
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineAsyncComponent", () => (parcelRequire("TusQn")).defineAsyncComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineAsyncComponent", () => (parcelRequire("TusQn")).defineAsyncComponent);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow(el);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow(el);
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $8POXm.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(?:^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $8POXm.isString)(prev) && prev ? prev[key] : void 0, value)) $a5d55dc64ccb07cf$var$setStyle(style, key, value);
            } else $a5d55dc64ccb07cf$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        if (!isCssString || prev !== next) el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) {
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty(name, val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $8POXm.isString)(next) && prev === next;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $a5d55dc64ccb07cf$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)) && !$a5d55dc64ccb07cf$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $8POXm.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $TusQn.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $TusQn.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue)))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $8POXm.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $8POXm.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $8POXm.camelize)(prop) === camelKey);
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) Comp = (0, $8POXm.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $8POXm.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            if (this._connected) this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$pendingGroups = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        let origins;
        let moves;
        const willMove = ()=>{
            if (moves === void 0) moves = prevChildren.length > 0 && $a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, $a5d55dc64ccb07cf$var$resolveMoveClass(props));
            return moves;
        };
        (0, $TusQn.onUpdated)(()=>{
            $a5d55dc64ccb07cf$var$pendingGroups.delete(instance);
            if (!willMove()) {
                prevChildren = [];
                origins = void 0;
                return;
            }
            const moveClass = $a5d55dc64ccb07cf$var$resolveMoveClass(props);
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            const shift = origins && $a5d55dc64ccb07cf$var$getOriginShift(origins, instance.vnode.el);
            origins = void 0;
            prevChildren.forEach((c)=>$a5d55dc64ccb07cf$var$recordPosition(c, shift));
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            moves = void 0;
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$a5d55dc64ccb07cf$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, $a5d55dc64ccb07cf$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren.length) {
                origins = $a5d55dc64ccb07cf$var$getOrigins(instance);
                $a5d55dc64ccb07cf$var$pendingGroups.set(instance, willMove);
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$resolveMoveClass(props) {
    return props.moveClass || `${props.name || "v"}-move`;
}
function $a5d55dc64ccb07cf$var$recordPosition(c, shift) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, $a5d55dc64ccb07cf$var$getPosition(c.el, shift));
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$getPosition(el, shift) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left - (shift ? shift.left : 0),
        top: rect.top - (shift ? shift.top : 0)
    };
}
function $a5d55dc64ccb07cf$var$getOrigins(instance) {
    let origins;
    for(let group = instance.parent; group; group = group.parent){
        const willMove = $a5d55dc64ccb07cf$var$pendingGroups.get(group);
        if (willMove) {
            const item = $a5d55dc64ccb07cf$var$findItem(group.vnode.el, instance.vnode.el);
            if (item) (origins || (origins = [])).push((0, $8POXm.extend)($a5d55dc64ccb07cf$var$getPosition(item), {
                item: item,
                willMove: willMove
            }));
        }
    }
    return origins;
}
function $a5d55dc64ccb07cf$var$findItem(root, node) {
    const container = root.nodeType === 1 ? root : root.parentNode;
    while(node && node.parentNode !== container)node = node.parentNode;
    if (node && node.nodeType === 1) return node;
}
function $a5d55dc64ccb07cf$var$getOriginShift(origins, root) {
    const origin = origins.find((o)=>o.willMove() && o.item.contains(root));
    return origin && $a5d55dc64ccb07cf$var$getPosition(origin.item, origin);
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $a5d55dc64ccb07cf$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $a5d55dc64ccb07cf$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $8POXm.looseToNumber)(value);
    return value;
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = $a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$a5d55dc64ccb07cf$var$initialValueKey];
        delete el[$a5d55dc64ccb07cf$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            const multiple = el.multiple;
            const assignedValue = multiple ? (0, $8POXm.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
            const pending = el._pendingValue = [
                multiple,
                multiple ? (0, $8POXm.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
            ];
            try {
                el[$a5d55dc64ccb07cf$var$assignKey](assignedValue);
            } finally{
                (0, $TusQn.nextTick)(()=>{
                    if (el._pendingValue === pending) el._pendingValue = void 0;
                });
            }
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        const pending = el._pendingValue;
        el._pendingValue = void 0;
        if (!pending || pending[0] !== el.multiple || !$a5d55dc64ccb07cf$var$isSameSelectValue(value, pending[1], pending[0])) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $8POXm.looseEqual)(value, assignedValue);
    if ((0, $8POXm.isArray)(value)) return (0, $8POXm.looseEqual)(value, assignedValue);
    if ((0, $8POXm.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue){
            if (!value.has(item)) return false;
        }
        return true;
    }
    return false;
}
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$export$cd4aa0842d13df8b
}, $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "defineAsyncComponent", () => $0a6cc4ba868319ae$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb[i]);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, minUid, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid || minUid !== void 0 && !(cb.id >= minUid)) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i = instance ? i - 1 : $0a6cc4ba868319ae$var$flushIndex;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen, skip, minUid = 0) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        let cbs = $0a6cc4ba868319ae$var$pendingPostFlushCbs;
        let kept = 0;
        if (skip) {
            cbs = [];
            for(let i = 0; i < $0a6cc4ba868319ae$var$pendingPostFlushCbs.length; i++){
                const cb = $0a6cc4ba868319ae$var$pendingPostFlushCbs[i];
                if (cb.i !== void 0 ? !cb.i || cb.i.uid < minUid : skip.has(cb)) $0a6cc4ba868319ae$var$pendingPostFlushCbs[kept++] = cb;
                else cbs.push(cb);
            }
        }
        const deduped = [
            ...new Set(cbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = kept;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$0a6cc4ba868319ae$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
let $0a6cc4ba868319ae$var$isFlushing = false;
function $0a6cc4ba868319ae$var$flushOnAppMount(fn, minUid) {
    if ($0a6cc4ba868319ae$var$isFlushing) {
        fn();
        return;
    }
    const queued = minUid === void 0 ? void 0 : new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs);
    fn();
    $0a6cc4ba868319ae$var$isFlushing = true;
    try {
        $0a6cc4ba868319ae$var$flushPreFlushCbs(void 0, minUid);
        $0a6cc4ba868319ae$var$flushPostFlushCbs(void 0, queued, minUid);
    } finally{
        $0a6cc4ba868319ae$var$isFlushing = false;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$setHmrUpdating = (v1)=>{
    try {
        return $0a6cc4ba868319ae$var$isHmrUpdating;
    } finally{
        $0a6cc4ba868319ae$var$isHmrUpdating = v1;
    }
};
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0a6cc4ba868319ae$var$isHmrUpdating = true;
                instance.parent.update();
                $0a6cc4ba868319ae$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if ($0a6cc4ba868319ae$var$currentInstance) {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        job.i = instance;
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0a6cc4ba868319ae$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $0a6cc4ba868319ae$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($0a6cc4ba868319ae$var$pendingMounts.get(vnode) !== mountJob) return;
                $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
                if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $0a6cc4ba868319ae$var$pendingMounts.set(vnode, mountJob);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $0a6cc4ba868319ae$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
        if (vnode.targetStart) insert(vnode.targetStart, container, parentAnchor);
        insert(vnode.targetAnchor, container, parentAnchor);
        parentAnchor = vnode.targetAnchor;
    }
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$0a6cc4ba868319ae$var$pendingMounts.has(vnode) && (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $0a6cc4ba868319ae$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $0a6cc4ba868319ae$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(oldInnerChild, innerChild) && $0a6cc4ba868319ae$var$getTransitionRoot(instance.subTree)) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode)) {
                let leavingCb = leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey];
                if (!leavingCb) {
                    const leavingRoot = $0a6cc4ba868319ae$var$getTransitionRoot(leavingVNode);
                    leavingCb = leavingRoot && leavingRoot.el[$0a6cc4ba868319ae$var$leaveCbKey];
                }
                if (leavingCb) leavingCb();
            }
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$0a6cc4ba868319ae$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            const done = el[$0a6cc4ba868319ae$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $0a6cc4ba868319ae$export$7770a22486565649($0a6cc4ba868319ae$var$isTeleport(subTree.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
        vnode.transition = hooks;
        if (vnode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && (0, $8POXm.isArray)(vnode.children)) {
            const child = $0a6cc4ba868319ae$var$filterSingleRoot(vnode.children, false);
            if (child) $0a6cc4ba868319ae$export$7770a22486565649(child, hooks);
        }
    }
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $0a6cc4ba868319ae$var$getTransitionRoot(vnode) {
    if (vnode.component) return $0a6cc4ba868319ae$var$getTransitionRoot(vnode.component.subTree);
    if (vnode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
        const child = (0, $8POXm.isArray)(vnode.children) && $0a6cc4ba868319ae$var$filterSingleRoot(vnode.children, false);
        return child ? $0a6cc4ba868319ae$var$getTransitionRoot(child) : void 0;
    }
    if (vnode.type !== $0a6cc4ba868319ae$export$4d299b491347818a) return vnode;
}
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0a6cc4ba868319ae$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? (0, $8POXm.NO) : (key)=>{
        if ($0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0a6cc4ba868319ae$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0a6cc4ba868319ae$var$pendingSetRefMap.set(rawRef, job);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0a6cc4ba868319ae$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if (($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) || vnode.component.asyncDep) && !vnode.component.subTree) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58(node.nodeType === 8 ? $0a6cc4ba868319ae$export$4d299b491347818a : "div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $8POXm.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $0a6cc4ba868319ae$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$0a6cc4ba868319ae$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $0a6cc4ba868319ae$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $0a6cc4ba868319ae$var$normalizeHiddenValue(clientValue);
        } else if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$normalizeHiddenValue(value) {
    if (!(0, $8POXm.isRenderableAttrValue)(value)) return false;
    if ((0, $8POXm.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $8POXm.includeBooleanAttr)(value) ? "" : false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8POXm.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    return $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), allowedType);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
function $0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode) {
    return $0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) || $0a6cc4ba868319ae$var$isMismatchAllowedByVNode(vnode);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(node.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$0a6cc4ba868319ae$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        const observe = (el)=>{
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            if (getComputedStyle(el).display === "contents") for(let i = 0; i < el.children.length; i++){
                if (observe(el.children[i]) === false) return false;
            }
            ob.observe(el);
        };
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            return observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) {
                $0a6cc4ba868319ae$var$resetShapeFlag(current);
                if (cached) $0a6cc4ba868319ae$var$resetShapeFlag(cached);
            }
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    const vnode = $0a6cc4ba868319ae$var$getInnerChild(instance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        if (!Number.isInteger(source) || source < 0) ret = [];
        else {
            ret = new Array(source);
            for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
        }
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $8POXm.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $0a6cc4ba868319ae$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $0a6cc4ba868319ae$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $0a6cc4ba868319ae$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>(0, i.vnode.el),
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $8POXm.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && key[0] !== "$" && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (0, $8POXm.hasOwn)(props, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const inSSRSetup = $0a6cc4ba868319ae$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    const restore = ()=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($0a6cc4ba868319ae$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    };
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, prevSetValue) && ((0, $8POXm.hasChanged)(value, emittedValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $8POXm.EMPTY_OBJ) && !(0, $8POXm.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0a6cc4ba868319ae$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $0a6cc4ba868319ae$var$isTeleport(root.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(root) || root : root;
        $0a6cc4ba868319ae$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (!(0, $8POXm.hasOwn)(prevProps, key) || $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $8POXm.isObject)(nextProp) && (0, $8POXm.isObject)(prevProp)) return !(0, $8POXm.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && $0a6cc4ba868319ae$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if ((0, $8POXm.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(measureName, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMeasures(measureName);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
            if (n2.dynamicChildren === (0, $8POXm.EMPTY_ARR)) n2.dynamicChildren = [];
            n2.dynamicChildren.hasOnce = true;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const oldEl = oldVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(oldVNode);
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldEl && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldEl) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized, namespace);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                n2.el = n1.el;
                n2.placeholder = n1.placeholder;
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            n2.placeholder = n1.placeholder;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$0a6cc4ba868319ae$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$0a6cc4ba868319ae$var$leaveCbKey];
                    if (el._isLeaving) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        const isFragment = type === $0a6cc4ba868319ae$export$ffb0004e005737fa;
        if (isFragment && !transition) {
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
            return;
        }
        const leavingNode = isFragment ? $0a6cc4ba868319ae$var$getTransitionRoot(vnode) : vnode;
        const performRemove = ()=>{
            if (isFragment) {
                if (hostParentNode(el)) removeFragment(el, anchor);
            } else hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (leavingNode && leavingNode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const leavingEl = leavingNode.el;
            const performLeave = ()=>leave(leavingEl, performRemove);
            if (delayLeave) delayLeave(leavingEl, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        } else if (instance.vnode.el && subTree) {
            subTree.transition = instance.vnode.transition;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    const render = (vnode, container, namespace)=>{
        const minUid = vnode && container._vnode ? void 0 : vnode && vnode.component ? vnode.component.uid : $0a6cc4ba868319ae$var$getNextUid();
        $0a6cc4ba868319ae$var$flushOnAppMount(()=>{
            if (vnode == null) {
                if (container._vnode) unmount(container._vnode, null, null, true);
            } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
            container._vnode = vnode;
        }, minUid);
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback && !parentSuspense.isHydrating) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(pendingBranch, newBranch)) {
            suspense.deps++;
            patch(pendingBranch, newBranch, // a hydrating pending branch is adopted SSR DOM, already in place
            isHydrating ? container : suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            suspense.deps--;
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspenseId = void 0;
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        // `namespace` intentionally shadows the boundary's own: the dep must be
        // mounted with the namespace of the position it was rendered at, which can
        // differ from the boundary's (e.g. a component nested inside an <svg>).
        registerDep (instance, setupRenderEffect, optimized2, namespace2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $0a6cc4ba868319ae$var$unsetCurrentInstance();
                if (!instance.scope.active) {
                    if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
                    return;
                }
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace2, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$var$hasContentChildren(children) {
    if ((0, $8POXm.isString)(children)) return children !== "";
    if ((0, $8POXm.isArray)(children)) return children.length > 0;
    return false;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce,
        cacheIndex: vnode.cacheIndex
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        if (shapeFlag & 65) {
            $0a6cc4ba868319ae$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $8POXm.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$getNextUid() {
    return $0a6cc4ba868319ae$var$uid;
}
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$setInSSRSetupState(true);
                try {
                    $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $0a6cc4ba868319ae$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])\w/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
                if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.44";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) {
                this.parent = $005d1fb7704e278c$var$activeEffectScope;
                this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($005d1fb7704e278c$var$activeEffectScope === this) $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            else {
                let current = $005d1fb7704e278c$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    if ($005d1fb7704e278c$export$7f3fe6025abfa26e(array)) return raw;
    if (!$005d1fb7704e278c$export$92d09b48637741e7(array)) return raw.map($005d1fb7704e278c$export$45c769cf449a508c);
    return $005d1fb7704e278c$export$352205f445242f02(array) ? raw.map((item)=>$005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item))) : raw.map($005d1fb7704e278c$export$4a78e7a2a4fb689f);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
function $005d1fb7704e278c$var$toWrapped(target, item) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return $005d1fb7704e278c$export$352205f445242f02(target) ? $005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item)) : $005d1fb7704e278c$export$4a78e7a2a4fb689f(item);
    return $005d1fb7704e278c$export$45c769cf449a508c(item);
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$005d1fb7704e278c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const methodFn = arr[method];
    const iter = methodFn.call(arr);
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        if (iter[Symbol.toStringTag] === "Array Iterator") {
            const wrapped = Object.create(Object.getPrototypeOf(iter));
            wrapped.next = ()=>$005d1fb7704e278c$var$wrapResult(iter.next(), wrapValue);
            if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) Object.defineProperties(wrapped, {
                return: {
                    get () {
                        const fn = iter.return;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                },
                throw: {
                    get () {
                        const fn = iter.throw;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                }
            });
            return wrapped;
        }
        iter._next = iter.next;
        iter.next = ()=>$005d1fb7704e278c$var$wrapResult(iter._next(), wrapValue);
    }
    return iter;
}
function $005d1fb7704e278c$var$wrapResult(result, wrapValue) {
    if (!result.done) result.value = wrapValue(result.value);
    return result;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $005d1fb7704e278c$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $005d1fb7704e278c$var$toWrapped(self, result) : result;
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return (0, $8POXm.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const rawValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $8POXm.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $8POXm.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $8POXm.isSymbol)(key) ? key : String(key);
        this._raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $8POXm.isArray)(_object) || (0, $8POXm.isSymbol)(this._key) || !(0, $8POXm.isIntegerKey)(this._key)) do shallow = !$005d1fb7704e278c$export$5f3ca29d057519b3(obj) || $005d1fb7704e278c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $005d1fb7704e278c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    return new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            try {
                return _cb(...args);
            } finally{
                watchHandle();
            }
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    if (cleanup) cleanup();
                    $005d1fb7704e278c$var$activeWatcher = effect;
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, (match)=>match.startsWith("/*") ? "" : match).split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,playsinline,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b, seen) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i], seen);
    return equal;
}
function $66ea9d0aaa418c4d$var$looseCompareCollections(a, b, seen) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $66ea9d0aaa418c4d$export$ae8015769846262c(item, candidates[i], seen)) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $66ea9d0aaa418c4d$var$looseCompareObjects(a, b, seen) {
    let aValidType = $66ea9d0aaa418c4d$export$5c90113a285f2241(a);
    let bValidType = $66ea9d0aaa418c4d$export$5c90113a285f2241(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareCollections(a, b, seen) : false;
    aValidType = $66ea9d0aaa418c4d$export$6750766a7c7ec627(a);
    bValidType = $66ea9d0aaa418c4d$export$6750766a7c7ec627(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareCollections(a, b, seen) : false;
    const aKeysCount = Object.keys(a).length;
    const bKeysCount = Object.keys(b).length;
    if (aKeysCount !== bKeysCount) return false;
    for(const key in a){
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key], seen)) return false;
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$var$looseCompareNested(a, b, seen, compare) {
    if (!seen) seen = [
        /* @__PURE__ */ new Map(),
        /* @__PURE__ */ new Map()
    ];
    const [seenA, seenB] = seen;
    if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
    seenA.set(a, b);
    seenB.set(b, a);
    const equal = compare(a, b, seen);
    seenA.delete(a);
    seenB.delete(b);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b, seen) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareNested(a, b, seen, $66ea9d0aaa418c4d$var$looseCompareArrays) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        return $66ea9d0aaa418c4d$var$looseCompareNested(a, b, seen, $66ea9d0aaa418c4d$var$looseCompareObjects);
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});





parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);
// Router-less page switch (see src/routes.js for the section registry). The
// active section is resolved once from the ?query at boot — switching sections
// is a full page load, which suits a static-hosted, code-split content site.
// TODO: a real history-API router would give clean /paths + no-reload section
// transitions, but the gains are mostly cosmetic here and it'd break 6 years of
// shareable ?query URLs (needs redirects). Parked — see routes.js. The pain it
// would solve (adding a page) is handled by the registry: one entry, no edits
// here or in SiteNav.
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $2332b = parcelRequire("2332b");

var $iScHE = parcelRequire("iScHE");

var $aGoGZ = parcelRequire("aGoGZ");

var $bXoWA = parcelRequire("bXoWA");

var $3lf9e = parcelRequire("3lf9e");
// Bracket (the default) stays statically imported in the entry bundle; every
// other section is code-split so its view + page-only JSON load on demand.
const $84d1df06ca739753$var$components = {
    SiteNav: $iScHE.default,
    Luxstadio: $2332b.default,
    DataStamp: $aGoGZ.default
};
for (const s of (0, $bXoWA.SECTIONS))if (s.loader) $84d1df06ca739753$var$components[s.key] = (0, $TusQn.defineAsyncComponent)(s.loader);
var $84d1df06ca739753$export$2e2bcd8739ae039 = {
    name: 'app',
    components: $84d1df06ca739753$var$components,
    data () {
        return {
            section: (0, $bXoWA.resolveSection)(),
            myUsername: ((0, $3lf9e.loadPrefs)().myUsername || '').trim()
        };
    },
    computed: {
        view () {
            return this.section.key === 'bracket' ? 'Luxstadio' : this.section.key;
        },
        showNav () {
            return this.section.key !== 'bracket';
        },
        activeKey () {
            return this.section.activeAs === undefined ? this.section.key : this.section.activeAs;
        },
        isChat () {
            return this.activeKey === 'chat';
        }
    }
};

});
parcelRegister("2332b", function(module, exports) {

$parcel$export(module.exports, "default", () => $17de3719e97ae2cd$export$2e2bcd8739ae039);
let $17de3719e97ae2cd$var$script;




let $17de3719e97ae2cd$var$initialize = ()=>{
    $17de3719e97ae2cd$var$script = (parcelRequire("5mnXu"));
    if ($17de3719e97ae2cd$var$script.__esModule) $17de3719e97ae2cd$var$script = $17de3719e97ae2cd$var$script.default;
    $17de3719e97ae2cd$var$script.render = (parcelRequire("eudrX")).render;
    $17de3719e97ae2cd$var$script.__cssModules = {};
    (parcelRequire("dyc38")).default($17de3719e97ae2cd$var$script);
    $17de3719e97ae2cd$var$script.__scopeId = 'data-v-c4c9db';
    $17de3719e97ae2cd$var$script.__file = "Luxstadio.vue";
};
$17de3719e97ae2cd$var$initialize();
var $17de3719e97ae2cd$export$2e2bcd8739ae039 = $17de3719e97ae2cd$var$script;

});
parcelRegister("5mnXu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3e7197824b10ac2e$export$2e2bcd8739ae039);

var $7iPtq = parcelRequire("7iPtq");

var $3bnHa = parcelRequire("3bnHa");

var $buZQz = parcelRequire("buZQz");

var $3Mxwx = parcelRequire("3Mxwx");

var $dt5j6 = parcelRequire("dt5j6");

var $6MNyJ = parcelRequire("6MNyJ");

var $4C5NX = parcelRequire("4C5NX");

var $e0SZd = parcelRequire("e0SZd");

var $5qmlL = parcelRequire("5qmlL");

var $cuELn = parcelRequire("cuELn");

var $iAuNh = parcelRequire("iAuNh");

var $iScHE = parcelRequire("iScHE");

var $5dltK = parcelRequire("5dltK");

var $9J7hU = parcelRequire("9J7hU");

var $cpXsb = parcelRequire("cpXsb");

var $kSAcq = parcelRequire("kSAcq");

var $8Bhv6 = parcelRequire("8Bhv6");

var $eiARH = parcelRequire("eiARH");

var $4VODn = parcelRequire("4VODn");

var $e1bFN = parcelRequire("e1bFN");

var $4zJ4j = parcelRequire("4zJ4j");

var $dr7Eb = parcelRequire("dr7Eb");

var $by2uy = parcelRequire("by2uy");

var $c8sRz = parcelRequire("c8sRz");

var $l1zL2 = parcelRequire("l1zL2");

var $ct3vs = parcelRequire("ct3vs");

var $2X6ab = parcelRequire("2X6ab");

var $8nxfB = parcelRequire("8nxfB");

var $3lf9e = parcelRequire("3lf9e");

var $pVEOf = parcelRequire("pVEOf");

var $htXGT = parcelRequire("htXGT");

var $jG4oQ = parcelRequire("jG4oQ");

var $koMQO = parcelRequire("koMQO");

var $adzaT = parcelRequire("adzaT");

var $aizvL = parcelRequire("aizvL");

var $5zojD = parcelRequire("5zojD");

var $8sRxE = parcelRequire("8sRxE");

var $5fnNF = parcelRequire("5fnNF");

var $64X3q = parcelRequire("64X3q");

var $fMXIO = parcelRequire("fMXIO");

var $ay2NQ = parcelRequire("ay2NQ");

var $hYk3h = parcelRequire("hYk3h");

var $kcejr = parcelRequire("kcejr");

var $4rZCr = parcelRequire("4rZCr");

var $56OCP = parcelRequire("56OCP");

var $4mfej = parcelRequire("4mfej");
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");
// Item/class normalization, safeDict, defaults, and the build helpers live in
// ./lib/apiData.js (imported above) so the offline tools build identical dicts.
const $3e7197824b10ac2e$var$safeNotables = (0, $8nxfB.buildNotables)((0, (/*@__PURE__*/$parcel$interopDefault($htXGT))));
const $3e7197824b10ac2e$var$bundledCharStats = (0, $8nxfB.buildCharStats)((0, (/*@__PURE__*/$parcel$interopDefault($5fnNF))).classes);
const $3e7197824b10ac2e$var$bundledItemsChanged = (0, $8nxfB.buildItemsChanged)((0, (/*@__PURE__*/$parcel$interopDefault($64X3q))).items);
const $3e7197824b10ac2e$var$bundledAbilitiesInfo = (0, $8nxfB.buildAbilitiesInfo)((0, (/*@__PURE__*/$parcel$interopDefault($fMXIO))).abilities);
var $3e7197824b10ac2e$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        HoverUnit: $7iPtq.default,
        InlineUnit: $3bnHa.default,
        BracketMatch: $buZQz.default,
        ChampStreakBadge: $4C5NX.default,
        TeamRatingTip: $e0SZd.default,
        MyModifiersModal: $5qmlL.default,
        SettingsModal: $3Mxwx.default,
        AnnouncementModal: $6MNyJ.default,
        HelpModal: $dt5j6.default,
        FightModal: $cuELn.default,
        UnitCardModal: $iAuNh.default,
        SiteNav: $iScHE.default,
        BotDownBanner: $5dltK.default,
        RecentTicker: $9J7hU.default,
        ColiseumPromo: $cpXsb.default,
        WhatsNewModal: $kSAcq.default,
        SpotlightModal: $8Bhv6.default,
        OnboardingTour: $eiARH.default,
        PredictPanel: $4VODn.default
    },
    data () {
        return {
            classRank: (0, (/*@__PURE__*/$parcel$interopDefault($jG4oQ))),
            // Per-browser user prefs (loaded from localStorage on mount). Shape
            // is defined in src/lib/userPrefs.js — currently:
            //   hideDefaultHighlights, hideBracket, customHighlights[]
            prefs: (0, $3lf9e.loadPrefs)(),
            showSettings: false,
            showHelp: false,
            // { unit, teamColor } when the full-screen unit card is open, else null.
            fullCard: null,
            showAnnouncement: false,
            // The floating "my skill modifiers" modal (viewer = prefs.myUsername).
            showMyMods: false,
            // The tournament's !buyrandom skill-drop token (e.g. "BraveBoost"), from
            // the API's SkillDrop field. Resolved to name/category/rarity via genTokens.
            skillDrop: null,
            // Whether the viewer (prefs.myUsername) already owns the drop token, from
            // their live userskills dump. null = unknown/not-checked (no handle set, or
            // the fetch is gated/failed — only works on the wiznaib.us origin).
            dropOwned: null,
            // The current champion's title-defense streak (global streak.txt), fetched
            // once per tournament. 0 = unknown/none.
            champStreak: 0,
            // How long since the current drop token last dropped, from the fftbg.com
            // tournaments list: { ago, lastMod } | { capped, window } | null.
            dropLastSeen: null,
            // Fight view: the two team names to compare, or null when closed.
            fightTeams: null,
            // When the live tournament last changed (the API's LastMod): the bot-down banner
            // uses it to tell whether wiznaibot is hearing the matches being played.
            tournamentLastMod: null,
            // "New tournament starting soon" heads-up banner + its poll timers.
            headsUp: false,
            pollTimer: null,
            goalTimer: null,
            headsUpTimer: null,
            // Last poll snapshot { matchIndex, winners } for match-sound detection.
            soundSnapshot: null,
            // Whether the URL is the live tournament (no ?tournament= override).
            // The start-of-tournament announcement only fires for live loads —
            // re-opening an archived tournament link shouldn't surprise the user
            // with a "X is in!" popup for events that already happened.
            isLiveTournament: !new URLSearchParams(window.location.search).get('tournament'),
            items: [],
            // The nine fixed FFTBG teams. Each entry holds its roster (the API's
            // Teams[name].Units), a `hidden` flag (toggled by the button row, the
            // bracket-click handlers, and the auto-hide-on-loss watcher), a `label`
            // (used as HoverUnit/InlineUnit's teamColor prop — capitalized
            // "Red"/"Blue"/.../"Champion") and a `cssShort` used by the existing
            // CSS classes `hidered`, `hideblue`, …, `hidechamp`. Order is the
            // bracket order (QF1 left/right, QF2 left/right, etc.).
            teams: [
                {
                    name: 'red',
                    cssShort: 'red',
                    label: 'Red',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'blue',
                    cssShort: 'blue',
                    label: 'Blue',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'green',
                    cssShort: 'green',
                    label: 'Green',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'yellow',
                    cssShort: 'yellow',
                    label: 'Yellow',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'white',
                    cssShort: 'white',
                    label: 'White',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'black',
                    cssShort: 'black',
                    label: 'Black',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'purple',
                    cssShort: 'purple',
                    label: 'Purple',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'brown',
                    cssShort: 'brown',
                    label: 'Brown',
                    hidden: false,
                    roster: [],
                    palettes: ''
                },
                {
                    name: 'champion',
                    cssShort: 'champ',
                    label: 'Champion',
                    hidden: false,
                    roster: [],
                    palettes: ''
                }
            ],
            entrants: [],
            // Game metadata, built from the bundled snapshots at module load (see
            // the imports above) — available synchronously, no network involved.
            charStats: $3e7197824b10ac2e$var$bundledCharStats,
            itemschanged: $3e7197824b10ac2e$var$bundledItemsChanged,
            // The bundled /api/tips snapshot (hover-card tooltip text) — same shape
            // the live endpoint served: {Zodiac, Class, UserSkill, Ability, Item,
            // MonsterSkills}. Refreshed by tools/fetchGameData.mjs.
            toolTips: (0, (/*@__PURE__*/$parcel$interopDefault($ay2NQ))),
            maps: [],
            current_tournament_id: "",
            previous_tournament_id: "",
            next_tournament_id: "",
            winners: [],
            // Predict-the-Bracket: whether pick mode is on + the persisted predictions
            // state (lifetime + per-tournament picks), loaded from localStorage.
            predictMode: false,
            predictState: (0, $e1bFN.loadPredictions)(),
            // Per-API load state: 'loading' | 'loaded' | 'failed'. The tournament
            // (the only required source) gates the main render via appState; the
            // optional recent-list loads in the background and degrades gracefully.
            // (Class/item/ability/tooltip data is all bundled — see charStats and
            // toolTips above — so none of it appears here.)
            sources: {
                tournament: 'loading',
                recent: 'loading'
            },
            sourceErrors: {
                tournament: '',
                recent: ''
            },
            // Display order + labels for the loading screen.
            sourceList: [
                {
                    key: 'tournament',
                    label: 'Tournament Data (fftbg)'
                },
                {
                    key: 'recent',
                    label: 'Previous Tournaments (fftbg)'
                }
            ],
            snubs: [],
            // Map of ability name -> `info` string, used by InlineUnit to
            // derive ability damage formulas (lib/abilityFormula.js).
            abilitiesInfo: $3e7197824b10ac2e$var$bundledAbilitiesInfo,
            IMG_URL: "https://luxor-fftbg-assets.s3.amazonaws.com/units/",
            IMG_URL_ITEMS: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/",
            IMG_URL_MAPS: "https://luxor-fftbg-assets.s3.amazonaws.com/maps/",
            notAbles: $3e7197824b10ac2e$var$safeNotables,
            // True when the page is loaded with ?test=1. Skips the tournament API
            // and synthesizes a fixture-tournament via testFixtures.js.
            testMode: false,
            // The actual gate for showing the main page. Set 150ms after appState
            // becomes 'ready' so the user sees the last source's dot flip green
            // before the v-if/v-else swap removes the loading screen.
            renderMain: false,
            showWhatsNew: false,
            showSpotlight: false,
            forceSpotlight: false,
            tourSteps: [
                {
                    target: '.tournament-bracket',
                    title: 'The bracket',
                    body: "Hover any unit for a quick card. On any matchup, \u2694 Fight View opens a damage matrix + battle sim, and the % button gives instant win odds."
                },
                {
                    target: '.teams',
                    title: 'Unit cards',
                    body: 'Click a unit to expand it in place; the "Full card" button opens its complete detail \u2014 stats, gear, abilities, and grades.'
                },
                {
                    target: '.snav-champions',
                    title: "\uD83C\uDFC6 Champions",
                    body: "The Tournament of Champions \u2014 a live leaderboard by title-defense streak, with a seeded bracket and sim odds."
                },
                {
                    target: '.snav-players',
                    title: "\uD83D\uDC65 Players",
                    body: '17k-player directory: quests, boards, achievements, career stats, and full championship histories. Player profiles with goal tracking.'
                },
                {
                    target: '.snav-maps',
                    title: "\uD83D\uDDFA\uFE0F Maps",
                    body: "All 138 battle maps \u2014 which classes the terrain favors, a 3D terrain viewer, and a height-calculator targeting tool."
                },
                {
                    target: '.snav-gear',
                    title: "\uD83D\uDD0D Gear Lab",
                    body: 'Search any item or pair: how often it rolls, its win rate, top classes, and what it pairs with.'
                },
                {
                    target: '.snav-stats',
                    title: "\uD83D\uDCCA Stats",
                    body: "Deep win-rate analytics \u2014 by class, skill, gear, Brave/Faith, and archetype, with trends over time."
                },
                {
                    target: '.settings-gear',
                    title: "\u2699 Settings",
                    body: "Set your username for a \uD83D\uDC64 profile button + goal tracker, highlight favorite players, toggle notification sounds, and replay this tour."
                },
                {
                    target: '.generator-button',
                    title: "\uD83C\uDFB2 Random generator",
                    body: "Jump to the Builder with a random FFTBG unit \u2014 force or ban classes, then edit anything."
                },
                {
                    target: '.help-button',
                    title: "\u2754 Guide",
                    body: "A searchable FFTBG reference \u2014 every chat command and the game mechanics behind the numbers."
                }
            ],
            TOURNAMENT_API_URL: "https://fftbg.com/api/tournament/latest",
            TOURNAMENT_API_PREFIX: "https://fftbg.com/api/tournament/"
        };
    },
    computed: {
        // Feature spotlight: updates the user hasn't seen yet.
        unseenUpdates () {
            const seen = new Set(this.prefs.seenUpdates || []);
            return (0, $l1zL2.SITE_UPDATES).filter((u)=>u.spotlight !== false && !seen.has(u.id));
        },
        // What to show in the spotlight modal: unseen updates, or all spotlightable if ?spotlight forced.
        spotlightUpdates () {
            const spotlightable = (0, $l1zL2.SITE_UPDATES).filter((u)=>u.spotlight !== false);
            return this.forceSpotlight && !this.unseenUpdates.length ? spotlightable : this.unseenUpdates;
        },
        // Goal tracker widget — reads from prefs (set on the player profile page).
        goalWidget () {
            const g = this.prefs.activeGoal, info = this.prefs.goalInfo;
            if (!g || !info || !this.prefs.myUsername || this.prefs.goalDismissed) return null;
            // Is the user rolling a remaining target right now? Gendered quests list "Lancer ♂",
            // the others the bare class, and the zodiac quest signs. Carried by Monsters counts
            // teammates' monsters, never your own, so your own unit can't be one it needs.
            let rolling = null;
            if (info.remaining && info.remaining.length && !(g.type === 'quest' && g.id === 'carried')) {
                const byLower = new Map(info.remaining.map((r)=>[
                        r.toLowerCase(),
                        r
                    ]));
                for (const { unit: unit } of this.findUnits(this.prefs.myUsername)){
                    const labels = g.type === 'quest' && g.id === 'zodiac' ? [
                        unit.Sign || ''
                    ] : [
                        unit.Class,
                        unit.Class + (unit.Gender === 'Male' ? " \u2642" : unit.Gender === 'Female' ? " \u2640" : '')
                    ];
                    rolling = labels.map((l)=>byLower.get(l.toLowerCase())).find(Boolean) || null;
                    if (rolling) break;
                }
            }
            return {
                name: info.name,
                status: info.status,
                remaining: info.remaining || [],
                rolling: rolling
            };
        },
        // Team grade (mean of unit grades) per team — shown on the team-grid headers.
        teamGrades () {
            const gd = {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles
            };
            const out = {};
            for (const t of this.teams)out[t.name] = (0, $8sRxE.teamGrade)(t.roster, (0, $koMQO.rosterStats), gd);
            return out;
        },
        // 'loading' until the tournament (the only required source) resolves;
        // 'failed' if it errors. Optional sources (tips, recent) don't block.
        // Class/item/ability data is bundled, so it can't fail or delay.
        appState () {
            if (this.sources.tournament === 'failed') return 'failed';
            if (this.sources.tournament === 'loaded') return 'ready';
            return 'loading';
        },
        // True when the URL pins a specific (?tournament=) archived tournament
        // rather than the live one — drives the archive-nav strip (Prev/Next/Live).
        isArchivedTournament () {
            return !this.isLiveTournament && !!this.current_tournament_id;
        },
        // Map a team's `name` to its team object — used everywhere we need to
        // look up roster/hidden/label by team name (e.g. allunits[colorName]
        // in HoverUnit, the bracket cells' won/lost class bindings).
        teamByName () {
            const map = {};
            for (const t of this.teams)map[t.name] = t;
            return map;
        },
        // The champion an entry made now would face, for My Mods' VIP helper: whoever wins this
        // tournament's champion match. Until that's played it's the champion, if they hold the belt.
        nextChampion () {
            const w = this.winners[7], won = w && w !== 'champion' && this.teamByName[w];
            if (won) return {
                units: won.roster,
                label: won.label,
                decided: true,
                isNew: true
            };
            const champ = this.teamByName.champion;
            return {
                units: champ ? champ.roster : [],
                label: 'Champion',
                decided: !!w,
                isNew: false
            };
        },
        // Derives every {teamName}BracketR1WIN / {position}BracketR{2,3,4}WIN flag
        // from the winners array (was previously a 130-line imperative watcher
        // setting each flag on this.). Keys match the previous data-field names
        // exactly so the bracket template's bindings only need to swap
        // `redBracketR1WIN` → `bracketState.redBracketR1WIN`.
        bracketState () {
            const w = this.winners;
            const qfPairs = [
                [
                    'red',
                    'blue'
                ],
                [
                    'green',
                    'yellow'
                ],
                [
                    'white',
                    'black'
                ],
                [
                    'purple',
                    'brown'
                ]
            ];
            const state = {};
            qfPairs.forEach((pair, i)=>{
                pair.forEach((name)=>{
                    state[name + 'BracketR1WIN'] = w[i] === name;
                });
            });
            state.topleftBracketR2WIN = w[4] === 'red' || w[4] === 'blue';
            state.toprightBracketR2WIN = w[4] === 'green' || w[4] === 'yellow';
            state.bottomleftBracketR2WIN = w[5] === 'white' || w[5] === 'black';
            state.bottomrightBracketR2WIN = w[5] === 'purple' || w[5] === 'brown';
            state.topleftBracketR3WIN = [
                'red',
                'blue',
                'green',
                'yellow'
            ].includes(w[6]);
            state.toprightBracketR3WIN = [
                'white',
                'black',
                'purple',
                'brown'
            ].includes(w[6]);
            state.topleftBracketR4WIN = [
                'red',
                'blue',
                'green',
                'yellow',
                'white',
                'black',
                'purple',
                'brown'
            ].includes(w[7]);
            state.toprightBracketR4WIN = w[7] === 'champion';
            return state;
        },
        // Teams still alive in the bracket (not yet eliminated) — for the champ cell's
        // "threat board". Empty once the Final resolves (the opponent is then known, so
        // the cell's own % odds takes over) or the champ match is decided.
        champChallengers () {
            const w = this.winners;
            if (w[6] || w[7]) return [];
            const qf = [
                [
                    'red',
                    'blue'
                ],
                [
                    'green',
                    'yellow'
                ],
                [
                    'white',
                    'black'
                ],
                [
                    'purple',
                    'brown'
                ]
            ];
            const out = new Set(); // eliminated
            qf.forEach((pair, i)=>{
                if (w[i]) out.add(pair[0] === w[i] ? pair[1] : pair[0]);
            });
            if (w[4]) out.add(w[0] === w[4] ? w[1] : w[0]);
            if (w[5]) out.add(w[2] === w[5] ? w[3] : w[2]);
            return [
                'red',
                'blue',
                'green',
                'yellow',
                'white',
                'black',
                'purple',
                'brown'
            ].filter((t)=>!out.has(t));
        },
        // Per-bracket-position labels (Capitalized "Red"/"Blue"/…), used as
        // HoverUnit's `enemyColor` prop in the SF / Finals / Champ cells.
        // Each derives from the corresponding winners[N] slot — replaces what
        // were imperative `this.semiOneLeft = "Red"` lines in the
        // winners watcher.
        semiOneLeft () {
            return this.teamByName[this.winners[0]]?.label || '';
        },
        semiOneRight () {
            return this.teamByName[this.winners[1]]?.label || '';
        },
        semiTwoLeft () {
            return this.teamByName[this.winners[2]]?.label || '';
        },
        semiTwoRight () {
            return this.teamByName[this.winners[3]]?.label || '';
        },
        finalLeft () {
            return this.teamByName[this.winners[4]]?.label || '';
        },
        finalRight () {
            return this.teamByName[this.winners[5]]?.label || '';
        },
        champLeft () {
            return this.teamByName[this.winners[6]]?.label || 'Champion';
        },
        // The tournament's skill drop resolved to { token, name, category, rarity }.
        // Falls back to a spaced token name + common rarity for any unmapped token.
        skillDropInfo () {
            if (!this.skillDrop) return null;
            const meta = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[this.skillDrop];
            const name = meta?.name || this.skillDrop.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            return {
                token: this.skillDrop,
                name: name,
                category: meta?.category || '',
                rarity: meta?.rarity || 'common'
            };
        },
        // "last dropped N tournaments ago" line for the chip. A long gap (or no prior
        // drop in the window) reads as a rare event — flagged via `.rare` styling.
        dropLastText () {
            const d = this.dropLastSeen;
            if (!d) return null;
            if (d.capped) return {
                text: `not dropped in ${d.window}+ tournaments`,
                rare: true,
                title: ''
            };
            return {
                text: `last dropped ${d.ago} tournament${d.ago === 1 ? '' : 's'} ago`,
                rare: d.ago >= 200,
                title: d.lastMod ? 'Previously dropped ' + new Date(d.lastMod).toLocaleDateString() : ''
            };
        },
        // The combined set of highlighted users — defaults (Luxor + friends, unless
        // toggled off) plus the user's customHighlights, deduped by lowercased name
        // (custom overrides default). Each is { name, color }; defaults carry the
        // default highlight color so they're visible out of the box.
        highlightedUsers () {
            return (0, $3lf9e.resolveHighlightedUsers)(this.prefs);
        },
        // Lowercase the entrants/snubs once so each highlight match is a cheap
        // Set lookup instead of repeatedly toLowercase'ing on every comparison.
        // The fftbg API returns usernames with the joining user's display-name
        // casing, which may not match what the modal-user typed — so we
        // compare in lowercase on both sides.
        entrantsLower () {
            return new Set(this.entrants.map((e)=>(e || '').toLowerCase().replace(/_/g, ' ')));
        },
        snubsLower () {
            return new Set(this.snubs.map((s)=>(s || '').toLowerCase().replace(/_/g, ' ')));
        },
        // Highlighted users who are entered in the current tournament, in the
        // same order as `highlightedUsers`. Drives the "X is in!" callouts.
        highlightedEntrants () {
            return this.highlightedUsers.filter((u)=>this.entrantsLower.has(u.name));
        },
        // Same idea for snubs.
        highlightedSnubs () {
            return this.highlightedUsers.filter((u)=>this.snubsLower.has(u.name));
        },
        // Combined entrant + snub matches for the start-of-tournament
        // announcement modal. Each entry carries a `status` field so the
        // modal can pick "is in!" vs "was Snubbed.".
        announcementMatches () {
            return [
                ...this.highlightedEntrants.map((u)=>({
                        ...u,
                        status: 'in',
                        units: this.findUnits(u.name)
                    })),
                ...this.highlightedSnubs.map((u)=>({
                        ...u,
                        status: 'snubbed'
                    }))
            ];
        },
        // Footer hint on the announcement modal pointing fresh visitors at the
        // ⚙ Settings — only while their highlight prefs are untouched (anyone
        // who's added a highlight or set their username has already found it).
        announceSettingsHint () {
            return !this.prefs.customHighlights.length && !this.prefs.myUsername;
        },
        // Map of lowercase-username → color for every highlighted user (defaults
        // included — they now carry the default highlight color), passed as a prop
        // to BracketMatch/InlineUnit/HoverUnit so they color the unit-name text
        // wherever it renders. Deduped via highlightedUsers.
        highlightColors () {
            const m = new Map();
            for (const u of this.highlightedUsers)if (u.color) m.set(u.name, u.color);
            return m;
        },
        // CSS-class object for the outer .teams div — toggles `hidered`,
        // `hideblue`, …, `hidechamp` based on each team's hidden flag. Matches
        // the existing CSS selectors (assets/css/main.scss).
        hideClasses () {
            const out = {};
            for (const t of this.teams)out['hide' + t.cssShort] = t.hidden;
            return out;
        },
        // Index (0-7) of the next undecided match — the one currently being
        // played — used to glow that bracket cell. -1 once every match is
        // decided (so completed/archived tournaments don't glow). Match order:
        // QF 0-3, SF 4-5, Final 6, Champ 7 (matches the maps/winners indices).
        currentMatchIndex () {
            for(let i = 0; i < 8; i++){
                if (!this.winners[i]) return i;
            }
            return -1;
        },
        // Which round the current match is in — drives the enlarged-column styling.
        activeRound () {
            const i = this.currentMatchIndex;
            if (i < 0) return null;
            if (i <= 3) return 'qf';
            if (i <= 5) return 'sf';
            if (i === 6) return 'final';
            return 'champ';
        },
        // ---- Predict-the-Bracket ----
        // Pick mode is offered on the live bracket + the ?test=1 fixture, not on
        // archived (?tournament=) views (predicting a decided tournament is moot).
        canPredict () {
            return this.isLiveTournament;
        },
        // This tournament's prediction record (read-only here; created on first pick).
        predictRec () {
            const id = this.current_tournament_id;
            return id && this.predictState.byTournament[id] || {
                picks: {},
                sim: {}
            };
        },
        // Per-cell predict state (match-index order) handed to each <BracketMatch>.
        predictCells () {
            const rec = this.predictRec, w = this.winners;
            return (0, $e1bFN.MATCH_DEFS).map((def)=>{
                const winner = w[def.i] || null;
                return {
                    i: def.i,
                    weight: def.weight,
                    roundLabel: (0, $e1bFN.ROUND_LABEL)[def.round],
                    candidates: (0, $e1bFN.matchCandidates)(def.i, w, rec.picks),
                    picked: rec.picks[def.i] || null,
                    simPick: winner ? rec.sim[def.i] || null : null,
                    winner: winner
                };
            });
        },
        // Running scorecard for the PredictPanel.
        predictScore () {
            return (0, $e1bFN.scorePredictions)(this.predictRec.picks, this.winners);
        },
        // You-vs-the-sim head-to-head (over decided matches where both have a pick).
        predictSimRecord () {
            return (0, $e1bFN.simRecord)(this.predictRec.picks, this.predictRec.sim, this.winners);
        },
        // Predict state for the matchup open in the Fight View (so it offers a pick
        // affordance there too), or null when not predicting / no match context.
        fightPredict () {
            if (!this.predictMode || !this.fightTeams || this.fightTeams.matchIndex == null) return null;
            return this.predictCells[this.fightTeams.matchIndex];
        },
        // Bundle of props every <BracketMatch> needs but doesn't vary per cell —
        // spread via v-bind so each call site is just the cell-specific bits.
        bracketSharedProps () {
            return {
                teamByName: this.teamByName,
                items: this.items,
                notAbles: this.notAbles,
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                abilitiesInfo: this.abilitiesInfo,
                toolTips: this.toolTips,
                imgUrlMaps: this.IMG_URL_MAPS,
                highlightColors: this.highlightColors,
                showWinRates: this.prefs.showWinRates,
                attackAnims: this.prefs.attackAnims,
                onBracketClick: this.bracketClick,
                onGoto: this.goto,
                onFight: this.openFight
            };
        },
        // Left-side candidates for the Champ match: any of the eight non-champion
        // teams that survived all three rounds. Inlined into the BracketMatch
        // call would be 8 lines of bracketState ANDs; pulled out as a computed
        // to keep the template readable.
        champLeftCandidates () {
            const b = this.bracketState;
            const enemy = this.teamByName.champion.label;
            return [
                {
                    name: 'red',
                    show: b.redBracketR1WIN && b.topleftBracketR2WIN && b.topleftBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'blue',
                    show: b.blueBracketR1WIN && b.topleftBracketR2WIN && b.topleftBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'green',
                    show: b.greenBracketR1WIN && b.toprightBracketR2WIN && b.topleftBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'yellow',
                    show: b.yellowBracketR1WIN && b.toprightBracketR2WIN && b.topleftBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'white',
                    show: b.whiteBracketR1WIN && b.bottomleftBracketR2WIN && b.toprightBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'black',
                    show: b.blackBracketR1WIN && b.bottomleftBracketR2WIN && b.toprightBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'purple',
                    show: b.purpleBracketR1WIN && b.bottomrightBracketR2WIN && b.toprightBracketR3WIN,
                    enemyColor: enemy
                },
                {
                    name: 'brown',
                    show: b.brownBracketR1WIN && b.bottomrightBracketR2WIN && b.toprightBracketR3WIN,
                    enemyColor: enemy
                }
            ];
        }
    },
    watch: {
        // Restore the player's predict-mode opt-in when the tournament id is set
        // (on load) or changes (a new tournament): predict mode reflects whether
        // they turned it on for THIS bracket. A new/unopted bracket starts off.
        current_tournament_id: function(id) {
            this.predictMode = this.canPredict && (0, $e1bFN.isActive)(this.predictState, id);
            if (this.predictMode) this.$nextTick(()=>this.ensureSimPicks());
        },
        // Slight pause between "everything required is loaded" and the
        // loading-screen → main-page swap so the user actually sees the
        // last source's dot flip green before the loading screen unmounts.
        appState: function(newVal) {
            if (newVal === 'ready') {
                // gameData is now loaded — compute any pending sim picks for a bracket
                // whose predict mode was restored before the data was ready.
                if (this.predictMode) this.ensureSimPicks();
                setTimeout(()=>{
                    this.renderMain = true;
                    const forced = (0, $ct3vs.introForced)();
                    if (forced) (0, $ct3vs.resetOnboarding)(); // ?intro replays everything, incl. the sub-page tours next visit
                    this.forceSpotlight = new URLSearchParams(window.location.search).has('spotlight');
                    if (forced || !(0, $ct3vs.onboardSeen)('intro')) this.showWhatsNew = true; // first visit (or ?intro) → welcome; mark all current updates as seen
                    else if (this.forceSpotlight || this.unseenUpdates.length) this.showSpotlight = true; // returning user with new features → spotlight
                    else this.maybeShowAnnouncement();
                }, 150);
            }
        },
        // Persist prefs to localStorage on any change — the settings modal
        // mutates a deep clone and emits whole-object updates, but the
        // announcement-dismiss flow mutates seenAnnouncements directly.
        // Watching deep covers both paths.
        prefs: {
            deep: true,
            handler (newVal) {
                (0, $3lf9e.savePrefs)(newVal);
            }
        },
        // Re-check drop ownership + how-long-since-last-dropped when the drop
        // changes (new tournament) or the viewer sets/changes their handle.
        // immediate so it fires on first load.
        skillDrop: {
            immediate: true,
            handler () {
                this.checkDropOwnership();
                this.loadDropHistory();
            }
        },
        'prefs.myUsername': function() {
            this.checkDropOwnership();
        },
        winners: function(newVal, oldVal) {
            // Auto-hide losing teams as winners come in. Bracket-WIN flags
            // themselves are derived in bracketState (computed), not here.
            // Live polling reassigns `winners` every 60s; without this guard a
            // team the user manually un-hid would be silently re-hidden each tick.
            if (oldVal && JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
            const w = this.winners;
            const hide = (name)=>{
                const t = this.teamByName[name];
                if (t) t.hidden = true;
            };
            const qfPairs = [
                [
                    'red',
                    'blue'
                ],
                [
                    'green',
                    'yellow'
                ],
                [
                    'white',
                    'black'
                ],
                [
                    'purple',
                    'brown'
                ]
            ];
            qfPairs.forEach((pair, i)=>{
                if (w[i] === pair[0]) hide(pair[1]);
                if (w[i] === pair[1]) hide(pair[0]);
            });
            if (w[4] === 'red' || w[4] === 'blue') {
                hide('green');
                hide('yellow');
            }
            if (w[4] === 'green' || w[4] === 'yellow') {
                hide('red');
                hide('blue');
            }
            if (w[5] === 'white' || w[5] === 'black') {
                hide('purple');
                hide('brown');
            }
            if (w[5] === 'purple' || w[5] === 'brown') {
                hide('white');
                hide('black');
            }
            if ([
                'red',
                'blue',
                'green',
                'yellow'
            ].includes(w[6])) [
                'white',
                'black',
                'purple',
                'brown'
            ].forEach(hide);
            if ([
                'white',
                'black',
                'purple',
                'brown'
            ].includes(w[6])) [
                'red',
                'blue',
                'green',
                'yellow'
            ].forEach(hide);
            // A match just resolved — fill in the sim's pick for it (if predicting).
            this.ensureSimPicks();
        }
    },
    async created () {
        // Quietly prefetch the top-50 champions (small, ~170KB) a few seconds after
        // load, so the 🏆 Champions page opens instantly from sessionStorage.
        setTimeout(()=>{
            try {
                if (sessionStorage.getItem('fftbgChampsTop50')) return;
                (0, $7we3r.default).get('https://fftbg.com/api/champions/?limit=50', {
                    timeout: 12000
                }).then((r)=>{
                    if (Array.isArray(r.data) && r.data.length) sessionStorage.setItem('fftbgChampsTop50', JSON.stringify(r.data));
                }).catch(()=>{});
            } catch (e) {}
        }, 2500);
        const urlParams = new URLSearchParams(window.location.search);
        // ?test=1 activates the synthetic-tournament fixture (testFixtures.js).
        // We still hit the classes + items APIs so the test units render with
        // real stats; we just skip tournament/tips/recent and synthesize the
        // tournament shape after items load.
        this.testMode = urlParams.get('test') === '1';
        if (this.testMode) {
            this.sources.tournament = 'loaded';
            this.sources.recent = 'loaded';
        } else {
            this.OLD_TOURNAMENT_ID = urlParams.get("tournament");
            if (this.OLD_TOURNAMENT_ID) this.TOURNAMENT_API_URL = this.TOURNAMENT_API_PREFIX + this.OLD_TOURNAMENT_ID;
            await this.loadTournament();
            try {
                // Derive the prev/next tournament ids from the recent-25 list (newest
                // first). findIndex returns -1 when the current tournament isn't in the
                // list, in which case there's no usable neighbor — leave the fields empty
                // so the prev button + archive strip controls hide. idx+1 is older
                // (previous), idx-1 is newer (next).
                const res = await (0, $7we3r.default).get(`https://fftbg.com/api/tournaments?limit=25`, {
                    timeout: 10000
                });
                const idList = res.data.map((t)=>t.ID);
                const idx = idList.findIndex((id)=>id == this.current_tournament_id);
                this.previous_tournament_id = idx >= 0 && idx + 1 < idList.length ? idList[idx + 1] : '';
                this.next_tournament_id = idx > 0 ? idList[idx - 1] : '';
                this.sources.recent = 'loaded';
            } catch (error) {
                this.sources.recent = 'failed';
                this.sourceErrors.recent = error.message || String(error);
            }
        } // end of: if (!this.testMode)
        // Test fixture: itemschanged is bundled, so it's always populated.
        if (this.testMode) {
            const fake = (0, $4mfej.buildTestTeams)(this.itemschanged);
            this.current_tournament_id = fake.ID;
            this.items = fake.Teams;
            this.maps = fake.Maps;
            for (const team of this.teams){
                team.roster = fake.Teams[team.name]?.Units || [];
                team.palettes = fake.Teams[team.name]?.Palettes || '';
            }
            this.winners = fake.Winners;
            this.entrants = fake.Entrants;
            this.snubs = fake.Snubs;
        }
        // Keep the goal widget current: rebuild the saved goal whenever a newer data
        // build is out, and re-check every 10 minutes for a tab left open across refreshes.
        if (!this.testMode) {
            this.refreshGoal();
            this.goalTimer = setInterval(()=>this.refreshGoal(), 600000);
        }
        // Live tournaments only: poll the bracket every minute so winners,
        // the current-match glow, and the team grid update without a refresh.
        if (!this.testMode && !this.OLD_TOURNAMENT_ID) {
            // Seed the match-sound snapshot from the initial load so the first poll
            // only reacts to changes since now (no sounds for already-decided matches).
            this.soundSnapshot = {
                matchIndex: this.currentMatchIndex,
                winners: [
                    ...this.winners
                ]
            };
            this.pollTimer = setInterval(()=>this.pollTournament(), 60000);
        }
    },
    beforeUnmount () {
        clearInterval(this.pollTimer);
        clearInterval(this.goalTimer);
        clearTimeout(this.headsUpTimer);
    },
    methods: {
        // Does the viewer already own the tournament's skill drop? Reads their live
        // userskills dump (prefs.myUsername) and checks for the drop token. Sets
        // dropOwned true/false, or leaves it null when there's no handle, no drop, or
        // the fetch is unavailable (the dump's CORS only allows the wiznaib.us origin,
        // so this is a no-op on staging/local). Guards against the drop changing
        // mid-fetch.
        async checkDropOwnership () {
            const me = (this.prefs.myUsername || '').trim();
            const drop = this.skillDrop;
            this.dropOwned = null;
            if (!me || !drop) return;
            const text = await (0, $aizvL.fetchDump)('userskills', me);
            if (text == null || this.skillDrop !== drop) return;
            this.dropOwned = (0, $aizvL.ownsToken)((0, $aizvL.parseSkills)(text), drop);
        },
        // The current champion's title-defense streak (global, prod-only). Left at 0
        // when the fetch is unavailable so the badge just doesn't show. Archived
        // (?tournament=) views skip it entirely — streak.txt is the LIVE champion's
        // count, which has nothing to do with whoever was champion back then.
        async loadChampStreak () {
            if (!this.isLiveTournament) return;
            const n = await (0, $aizvL.fetchChampStreak)();
            if (n != null) this.champStreak = n;
        },
        // How long since the current drop token last dropped. One call to the
        // fftbg.com tournaments list (our normal CORS-friendly API — works on every
        // origin), once per drop change. No prior occurrence in the window → "capped".
        async loadDropHistory () {
            const token = this.skillDrop;
            this.dropLastSeen = null;
            if (!token) return;
            const WINDOW = 300; // ~12 days; the avg drop gap is ~165, so most are still exact (~164KB vs 273KB at 500)
            try {
                const res = await (0, $7we3r.default).get(`https://fftbg.com/api/tournaments?limit=${WINDOW}`, {
                    timeout: 10000
                });
                if (this.skillDrop !== token) return; // a new tournament landed mid-fetch
                this.dropLastSeen = (0, $5zojD.lastDropAgo)(res.data, token) || {
                    capped: true,
                    window: WINDOW
                };
            } catch  {}
        },
        // The roster a given team is matched against RIGHT NOW, for the per-spell
        // damage hover on its unit cards. Follows the live bracket rather than the
        // fixed QF pairing: a team's current opponent is the other competitor in the
        // first undecided match it's in. Deeper-round slots resolve from `winners`
        // (SF = QF winners, Final = SF winners, Champ = Final winner vs Champion).
        // Returns [] when the opponent isn't decided yet (or the team is out), so the
        // preview never shows a stale round-1 enemy after the team has advanced.
        opponentRoster (teamName) {
            const w = this.winners || [];
            const matches = [
                [
                    'red',
                    'blue'
                ],
                [
                    'green',
                    'yellow'
                ],
                [
                    'white',
                    'black'
                ],
                [
                    'purple',
                    'brown'
                ],
                [
                    w[0],
                    w[1]
                ],
                [
                    w[2],
                    w[3]
                ],
                [
                    w[4],
                    w[5]
                ],
                [
                    w[6],
                    'champion'
                ]
            ];
            const roster = (name)=>name && this.teamByName[name] && this.teamByName[name].roster || [];
            for(let i = 0; i < matches.length; i++){
                if (w[i]) continue; // match already decided
                const [a, b] = matches[i];
                if (a === teamName) return roster(b);
                if (b === teamName) return roster(a);
            }
            return [];
        },
        // Fetch the tournament and (re)populate teams/maps/rosters/winners/etc.
        // Used on mount and by the live poll. Returns whether the tournament ID
        // changed (a brand-new tournament appeared).
        async loadTournament () {
            try {
                const res = await (0, $7we3r.default).get(this.TOURNAMENT_API_URL, {
                    timeout: 10000
                });
                const prevId = this.current_tournament_id;
                const changed = !!prevId && res.data.ID !== prevId;
                this.current_tournament_id = res.data.ID;
                if (changed) for (const t of this.teams)t.hidden = false;
                // Rosters/maps/entrants are immutable once the API exposes a tournament
                // (entries lock first), so only swap them on first load or a new ID.
                // Re-assigning fresh identities every poll wiped per-card tuning state
                // (InlineUnit's unit watcher resets on identity change) and re-rendered
                // the whole grid each minute on identical data.
                if (!prevId || changed) {
                    this.items = res.data.Teams;
                    this.maps = res.data.Maps;
                    for (const team of this.teams){
                        team.roster = this.items[team.name]?.Units || [];
                        team.palettes = this.items[team.name]?.Palettes || ''; // "Primary/Alt" team colors
                    }
                    this.entrants = res.data.Entrants;
                    this.snubs = res.data.Snubs;
                    this.loadChampStreak(); // global champ streak — once per tournament
                }
                // Winners + skill drop are the live parts — but keep the array identity
                // stable too, swapping only when a result actually landed.
                if (JSON.stringify(res.data.Winners) !== JSON.stringify(this.winners)) this.winners = res.data.Winners;
                this.skillDrop = res.data.SkillDrop || null;
                this.tournamentLastMod = res.data.LastMod || null;
                if (changed) {
                    // New tournament — the viewer's owned skills may have changed (skills
                    // turn over each tournament), so drop the cached read and re-grade the
                    // drop against a fresh fetch. (The skillDrop watcher covers the case
                    // where the drop token itself also changed; this covers a same-token
                    // drop across tournaments.)
                    (0, $aizvL.bustDump)('userskills', this.prefs.myUsername);
                    this.checkDropOwnership();
                }
                this.sources.tournament = 'loaded';
                return {
                    ok: true,
                    changed: changed
                };
            } catch (error) {
                this.sources.tournament = 'failed';
                this.sourceErrors.tournament = error.message || String(error);
                return {
                    ok: false
                };
            }
        },
        // One poll tick: refresh the bracket. On a brand-new tournament, re-fire
        // the "X is in!" announcement. When the current tournament just finished,
        // pop the "next one starting soon" heads-up.
        async pollTournament () {
            const wasComplete = this.currentMatchIndex === -1;
            const result = await this.loadTournament();
            if (!result.ok) return;
            this.checkMatchSounds(); // tracked-unit match-up / win / loss / champ
            if (result.changed) {
                this.maybeShowAnnouncement();
                return;
            }
            if (!wasComplete && this.currentMatchIndex === -1) this.announceNewTournamentSoon();
        },
        // Heads-up that the current tournament finished — the next join window is
        // opening. Banner always; sound only if the user enabled that event.
        announceNewTournamentSoon () {
            this.headsUp = true;
            clearTimeout(this.headsUpTimer);
            this.headsUpTimer = setTimeout(()=>{
                this.headsUp = false;
            }, 45000);
            (0, $2X6ab.playEventIfEnabled)(this.prefs, 'newTournament');
        },
        // Diff this poll's bracket state against the last one and play a sound for
        // each tracked-unit event (match becoming current, a result, a champ win).
        // Seeds the snapshot on the first call (no sound) so we only react to live
        // changes, not the initial load.
        checkMatchSounds () {
            const snap = {
                matchIndex: this.currentMatchIndex,
                winners: [
                    ...this.winners
                ]
            };
            const tracked = new Set(this.highlightedUsers.map((u)=>u.name));
            const myTeams = (0, $2X6ab.teamsWithTrackedUnits)(this.items, tracked);
            if (this.soundSnapshot && myTeams.size) for (const ev of (0, $2X6ab.matchEvents)(this.soundSnapshot, snap, myTeams))(0, $2X6ab.playEventIfEnabled)(this.prefs, ev);
            this.soundSnapshot = snap;
        },
        sourceStatus (key) {
            const s = this.sources[key];
            if (s === 'loaded') return "\u2713 loaded";
            if (s === 'failed') return `FAILED \u{2014} ${this.sourceErrors[key] || 'unknown error'}`;
            return "loading\u2026";
        },
        reload () {
            window.location.reload();
        },
        // Receives the modal's edited prefs and replaces ours. The deep
        // watcher on `prefs` persists the change to localStorage.
        onPrefsUpdate (newPrefs) {
            this.prefs = newPrefs;
        },
        dismissGoal () {
            this.prefs.goalDismissed = true;
            (0, $3lf9e.savePrefs)(this.prefs);
        },
        // Rebuild the goal widget's saved copy if newer data is out (see lib/goalRefresh.js).
        // The deep prefs watcher saves it.
        async refreshGoal () {
            if (this.prefs.goalDismissed) return;
            const info = await (0, $pVEOf.freshGoalInfo)(this.prefs).catch(()=>undefined);
            if (info !== undefined) this.prefs.goalInfo = info;
        },
        // Called after renderMain flips true. Shows the big "X is in!" /
        // "X was Snubbed!" modal iff: live tournament (not an archived URL,
        // not ?test=1), announcements aren't disabled, we have a current
        // tournament ID we haven't shown the modal for, and at least one
        // highlighted user is in entrants or snubs.
        maybeShowAnnouncement () {
            if (this.testMode) return;
            if (!this.isLiveTournament) return;
            if (this.prefs.disableAnnouncements) return;
            if (!this.current_tournament_id) return;
            if (this.prefs.seenAnnouncements.includes(this.current_tournament_id)) return;
            if (!this.announcementMatches.length) return;
            this.showAnnouncement = true;
        },
        // Find an entrant's unit (+ its team label) across the loaded teams, for the
        // announcement modal's "playing a Knight" line.
        // ALL units a player is fielding this tournament — usually one, but a player
        // who entered AND is the defending champion appears on two teams; the new team
        // is listed first, the Champion slot last. Drives the "X is in!" announcement.
        findUnits (name) {
            const lc = (name || '').toLowerCase();
            const gd = {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles
            };
            const out = [];
            for(const color in this.items)for (const u of this.items[color]?.Units || [])if ((u.Name || '').toLowerCase() === lc) out.push({
                unit: u,
                teamLabel: this.teamByName[color]?.label || '',
                grade: (0, $8sRxE.unitGrade)(u, (0, $koMQO.rosterStats), gd)
            });
            out.sort((a, b)=>(a.teamLabel === 'Champion' ? 1 : 0) - (b.teamLabel === 'Champion' ? 1 : 0));
            return out;
        },
        // User dismissed the announcement modal — record this tournament as
        // seen so it doesn't re-fire on refresh.
        dismissAnnouncement () {
            this.showAnnouncement = false;
            this.prefs.seenAnnouncements = (0, $3lf9e.markAnnouncementSeen)(this.prefs.seenAnnouncements, this.current_tournament_id);
        },
        // "⚙ Settings" link in the announcement footer — dismiss (marks the
        // tournament seen) and open the gear modal.
        openSettingsFromAnnouncement () {
            this.dismissAnnouncement();
            this.showSettings = true;
        },
        closeWhatsNew () {
            this.showWhatsNew = false;
            (0, $ct3vs.markOnboardSeen)('intro');
            // New visitors who see the Welcome don't need the spotlight — mark all current updates as seen
            this.markAllUpdatesSeen();
            this.maybeShowAnnouncement();
        },
        startMainTour () {
            this.showWhatsNew = false;
            (0, $ct3vs.markOnboardSeen)('intro');
            this.markAllUpdatesSeen();
            this.$nextTick(()=>{
                if (this.$refs.tour) this.$refs.tour.begin();
            });
        },
        closeSpotlight () {
            this.showSpotlight = false;
            this.markAllUpdatesSeen();
            this.maybeShowAnnouncement();
        },
        markAllUpdatesSeen () {
            const seen = new Set(this.prefs.seenUpdates || []);
            for (const u of (0, $l1zL2.SITE_UPDATES))seen.add(u.id);
            this.prefs.seenUpdates = [
                ...seen
            ];
            (0, $3lf9e.savePrefs)(this.prefs);
        },
        onTourDone () {
            (0, $ct3vs.markOnboardSeen)('tour.main');
        },
        // Open the fight view comparing two teams (by name), from a bracket cell.
        openFight (leftName, rightName, mapName, matchIndex) {
            this.fightTeams = {
                left: leftName,
                right: rightName,
                map: mapName || '',
                matchIndex: matchIndex == null ? null : matchIndex
            };
        },
        // ---- Predict-the-Bracket ----
        // Toggling persists the opt-in for THIS bracket so it restores on return
        // (see the current_tournament_id watcher), rather than silently re-surfacing
        // a saved bracket the player didn't knowingly turn on.
        togglePredict () {
            this.predictMode = !this.predictMode;
            const id = this.current_tournament_id;
            if (!id) return;
            const rec = (0, $e1bFN.tournamentRecord)(this.predictState, id);
            rec.active = this.predictMode;
            (0, $e1bFN.savePredictions)(this.predictState);
            if (this.predictMode) this.ensureSimPicks();
        },
        // Record (or toggle off) a pick for match `i`; prunes busted downstream picks
        // and persists. No-op once the match is decided (the pick has locked).
        onPick (i, team) {
            const id = this.current_tournament_id;
            if (!id || this.winners[i]) return;
            const rec = (0, $e1bFN.tournamentRecord)(this.predictState, id);
            (0, $e1bFN.setPick)(rec, i, rec.picks[i] === team ? null : team, this.winners);
            (0, $e1bFN.savePredictions)(this.predictState);
        },
        // The sim's favorite for a DECIDED match i — the actual two teams that fought.
        // Mirrors BracketMatch's per-cell % odds (flat Monte-Carlo, champ incumbency edge).
        computeSimFavorite (i) {
            const [left, right] = (0, $e1bFN.matchCandidates)(i, this.winners, {});
            const lt = this.teamByName[left], rt = this.teamByName[right];
            if (!lt || !rt) return null;
            try {
                const data = {
                    charStats: this.charStats,
                    itemschanged: this.itemschanged,
                    notAbles: this.notAbles,
                    abilitiesInfo: this.abilitiesInfo,
                    monsterSkills: (/*@__PURE__*/$parcel$interopDefault($hYk3h))
                };
                // Run on the match's real map geometry (same parse as FightModal / BracketMatch).
                const mt = ((this.maps || [])[i] || '').match(/^\s*(\d+)\)\s*(.*)$/);
                const terrain = mt && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName[mt[2].trim()] || (mt && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps ? (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps[mt[1]] : null) || null;
                const r = (0, $dr7Eb.runBattles)((0, $4zJ4j.prepTeam)(lt.roster, data), (0, $4zJ4j.prepTeam)(rt.roster, data), {
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                    terrain: terrain,
                    tiles: (0, $56OCP.tilesForMap)((this.maps || [])[i], (0, (/*@__PURE__*/$parcel$interopDefault($4rZCr))))
                });
                const champSide = lt.label === 'Champion' ? 'A' : rt.label === 'Champion' ? 'B' : null;
                const o = (0, $by2uy.calibratedOdds)(r, {
                    champSide: champSide
                });
                return o.a >= o.b ? left : right;
            } catch (e) {
                return null;
            }
        },
        // Fill in the sim's favorite for each decided match in the active bracket, one
        // per tick so a backlog (predicting a just-finished tournament) doesn't freeze
        // the page. Each match is attempted once per session; results persist.
        ensureSimPicks () {
            const id = this.current_tournament_id;
            if (!id || !this.predictMode || this._simRunning) return;
            if (this.appState !== 'ready') return; // tournament not loaded yet — retried on appState=ready
            const rec = (0, $e1bFN.tournamentRecord)(this.predictState, id);
            this._simAttempted = this._simAttempted || new Set();
            const step = ()=>{
                if (this.current_tournament_id !== id || !this.predictMode) {
                    this._simRunning = false;
                    return;
                }
                let i = -1;
                for(let k = 0; k < 8; k += 1)if (this.winners[k] && !rec.sim[k] && !this._simAttempted.has(id + ':' + k)) {
                    i = k;
                    break;
                }
                if (i < 0) {
                    this._simRunning = false;
                    this.maybeFinalize();
                    return;
                } // sim picks done → try to finalize
                this._simAttempted.add(id + ':' + i);
                const fav = this.computeSimFavorite(i);
                if (fav) {
                    rec.sim[i] = fav;
                    (0, $e1bFN.savePredictions)(this.predictState);
                }
                setTimeout(step, 0);
            };
            this._simRunning = true;
            setTimeout(step, 0);
        },
        // Once a predicted bracket is complete (and its sim picks are in), roll the
        // result into the lifetime record. Idempotent (the lib guards re-finalization).
        maybeFinalize () {
            const id = this.current_tournament_id;
            if (!id || this.currentMatchIndex !== -1) return; // not complete yet
            if ((0, $e1bFN.finalizeTournament)(this.predictState, id, this.winners)) (0, $e1bFN.savePredictions)(this.predictState);
        },
        // Clicking a bracket cell un-hides every team so the destination team is
        // visible before we scroll to it.
        bracketClick () {
            for (const team of this.teams)team.hidden = false;
        },
        // Scroll to a team's section in the team-grid. $nextTick gives the DOM a
        // beat to un-hide any teams toggled in bracketClick before we measure.
        goto (name) {
            this.$nextTick(()=>{
                const el = document.querySelector('.team.' + name);
                if (el) el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        },
        // Announcement-modal player-name click → find which team the player is on
        // and scroll to it. Dismisses the modal first so it doesn't cover the
        // scroll target.
        gotoPlayer (playerName) {
            const lower = (playerName || '').toLowerCase();
            const team = this.teams.find((t)=>(t.roster || []).some((u)=>(u.Name || '').toLowerCase() === lower));
            this.dismissAnnouncement();
            if (team) {
                for (const t of this.teams)t.hidden = false;
                this.goto(team.name);
            }
        }
    }
};

});
parcelRegister("7iPtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5512246b0e8a56dc$export$2e2bcd8739ae039);
let $5512246b0e8a56dc$var$script;




let $5512246b0e8a56dc$var$initialize = ()=>{
    $5512246b0e8a56dc$var$script = (parcelRequire("5w4w2"));
    if ($5512246b0e8a56dc$var$script.__esModule) $5512246b0e8a56dc$var$script = $5512246b0e8a56dc$var$script.default;
    $5512246b0e8a56dc$var$script.render = (parcelRequire("edXRW")).render;
    $5512246b0e8a56dc$var$script.__cssModules = {};
    (parcelRequire("8iNZr")).default($5512246b0e8a56dc$var$script);
    $5512246b0e8a56dc$var$script.__scopeId = 'data-v-9fbdd8';
    $5512246b0e8a56dc$var$script.__file = "hoverUnit.vue";
};
$5512246b0e8a56dc$var$initialize();
var $5512246b0e8a56dc$export$2e2bcd8739ae039 = $5512246b0e8a56dc$var$script;

});
parcelRegister("5w4w2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $404371a2529fd561$export$2e2bcd8739ae039);

var $eQqwh = parcelRequire("eQqwh");

var $5tAvx = parcelRequire("5tAvx");

var $79bVW = parcelRequire("79bVW");

var $ftvub = parcelRequire("ftvub");

var $7cZwo = parcelRequire("7cZwo");

var $8Q6Uh = parcelRequire("8Q6Uh");

var $ivz6X = parcelRequire("ivz6X");

var $k6EE8 = parcelRequire("k6EE8");

var $koMQO = parcelRequire("koMQO");

var $8sRxE = parcelRequire("8sRxE");

var $jW5bt = parcelRequire("jW5bt");

var $ht4ts = parcelRequire("ht4ts");
var $404371a2529fd561$export$2e2bcd8739ae039 = {
    props: {
        members: {},
        itemschanged: {},
        charStats: {},
        notAbles: {},
        teamColor: '',
        enemyColor: '',
        allunits: {},
        abilitiesInfo: {
            type: Object,
            default: ()=>({})
        },
        toolTips: {
            type: Object,
            default: ()=>({})
        },
        // Map<lowercase-username, color> for custom highlighted users.
        highlightColors: {
            type: Object,
            default: ()=>new Map()
        },
        showWinRates: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        grade () {
            return (0, $8sRxE.unitGrade)(this.members, (0, $koMQO.rosterStats), {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles
            });
        },
        classKey () {
            return (this.members.Class || '').replace(/\s+/g, '') + (this.members.Gender || '');
        },
        classBase () {
            return this.charStats[this.classKey];
        },
        equipped () {
            return {
                Mainhand: this.itemschanged[this.members.Mainhand],
                Offhand: this.itemschanged[this.members.Offhand],
                Head: this.itemschanged[this.members.Head],
                Armor: this.itemschanged[this.members.Armor],
                Accessory: this.itemschanged[this.members.Accessory]
            };
        },
        itemBonus () {
            const e = this.equipped;
            const sum = (k)=>e.Mainhand[k] + e.Offhand[k] + e.Head[k] + e.Armor[k] + e.Accessory[k];
            return {
                hp: sum('hp'),
                mp: sum('mp'),
                pa: sum('pa'),
                ma: sum('ma'),
                speed: sum('speed'),
                move: sum('move'),
                jump: sum('jump')
            };
        },
        itemBonusPAUnarmed () {
            const e = this.equipped;
            return e.Head.pa + e.Armor.pa + e.Accessory.pa;
        },
        moveSkillBonus () {
            return this.notAbles.movementSkills[this.members.MoveSkill];
        },
        // Only the unit's non-common action skills (own class + secondary set),
        // rarest first — the compact hover surfaces the highlights, not the full
        // skill list.
        notableSkills () {
            if (this.members.Gender === 'Monster') return [];
            const out = [];
            for (const a of this.members.ClassSkills || []){
                const r = (0, $ivz6X.skillRarity)(a, false, (0, (/*@__PURE__*/$parcel$interopDefault($k6EE8))));
                if (r) out.push({
                    name: a,
                    tier: r.tier,
                    roll: r.roll
                });
            }
            for (const a of this.members.ExtraSkills || []){
                const r = (0, $ivz6X.skillRarity)(a, true, (0, (/*@__PURE__*/$parcel$interopDefault($k6EE8))));
                if (r) out.push({
                    name: a,
                    tier: r.tier,
                    roll: r.roll
                });
            }
            return out.sort((x, y)=>x.roll - y.roll);
        },
        stats () {
            const c = this.classBase, b = this.itemBonus, m = this.moveSkillBonus;
            return {
                hp: c.hp + b.hp,
                mp: c.mp + b.mp,
                pa: c.pa + b.pa,
                ma: c.ma + b.ma,
                speed: c.speed + b.speed,
                move: c.move + b.move + m.move,
                jump: c.jump + b.jump + m.jump
            };
        },
        paUnarmed () {
            return this.classBase.pa + this.itemBonusPAUnarmed;
        },
        affinityText () {
            const p = (0, $79bVW.unitElementProfile)(this.equipped);
            const bits = [];
            if (p.strengthen.size) bits.push('Strengthen ' + [
                ...p.strengthen
            ].join('/'));
            if (p.absorb.size) bits.push('Absorb ' + [
                ...p.absorb
            ].join('/'));
            if (p.half.size) bits.push('Half ' + [
                ...p.half
            ].join('/'));
            if (p.weak.size) bits.push('Weak ' + [
                ...p.weak
            ].join('/'));
            return bits.join("  \xb7  ");
        },
        statusText () {
            const perm = [], init = [];
            for (const slot of Object.values(this.equipped)){
                for (const s of slot.permstatus || [])perm.push(s.name);
                for (const s of slot.initstatus || [])init.push(s.name);
            }
            const bits = [];
            if (perm.length) bits.push('Perm: ' + [
                ...new Set(perm)
            ].join(', '));
            if (init.length) bits.push('Init: ' + [
                ...new Set(init)
            ].join(', '));
            return bits.join("  \xb7  ");
        },
        teamCompat () {
            return this.compatFor(this.teamColor, true);
        },
        enemyCompat () {
            return this.compatFor(this.enemyColor, false);
        },
        // This unit's evade % by direction (chance to dodge an incoming attack).
        evasion () {
            const target = {
                equipped: this.equipped,
                cEv: this.classBase.cEvPercent,
                reaction: this.members.ReactionSkill
            };
            const ev = (type, dir)=>Math.round(100 - (0, $8Q6Uh.hitChance)(target, {
                    type: type,
                    direction: dir
                }));
            return {
                front: ev('physical', 'front'),
                side: ev('physical', 'side'),
                back: ev('physical', 'back'),
                magic: ev('magical', 'front')
            };
        },
        // Monsters have no gear — their "attacks" are their monster skills.
        monsterAttacks () {
            if (this.members.Gender !== 'Monster') return [];
            const skills = this.toolTips.MonsterSkills && this.toolTips.MonsterSkills[this.members.Class] || [];
            const ctx = {
                ma: this.stats.ma,
                pa: this.stats.pa,
                speed: this.stats.speed,
                brave: this.members.Brave,
                faith: this.members.Faith,
                targetFaith: 60,
                wp: 0,
                maxHp: this.stats.hp,
                paUnarmed: this.paUnarmed
            };
            return skills.map((raw)=>{
                const name = (raw || '').replace('*', '');
                const model = (0, $7cZwo.parseAbilityInfo)(this.abilitiesInfo[name]);
                let dmg = '';
                if (model && model.kind === 'number' && model.verb === 'Damage') {
                    const { final: final } = (0, $7cZwo.computeAbilityDamage)(model, ctx, {});
                    dmg = Array.isArray(final) ? `${final[0]} - ${final[1]}` : `${final}`;
                } else if (model && model.kind === 'percent') dmg = `${model.evalFn(ctx)}%`;
                return {
                    name: name,
                    dmg: dmg
                };
            });
        }
    },
    methods: {
        wr (dim, value) {
            return this.showWinRates ? {
                color: (0, $jW5bt.wrColor)(dim, value, this.members.Class, this.members.Gender)
            } : {};
        },
        wrTip (dim, value) {
            return this.showWinRates ? (0, $jW5bt.wrTitle)(dim, value, this.members.Class, this.members.Gender) : '';
        },
        wrS (dim, raw) {
            if (!this.showWinRates) return {};
            const isMonster = this.members.Gender === 'Monster';
            if (isMonster && dim.startsWith('Stat')) return {};
            if (isMonster && (dim === 'Brave' || dim === 'Faith')) return {
                color: (0, $jW5bt.wrMonsterBFColor)(this.members.Class, dim, raw, this.grade.typeWR)
            };
            const a = (0, $8sRxE.archetypeOf)(this.classBase, isMonster);
            const b = dim === 'Brave' || dim === 'Faith' ? (0, $8sRxE.bfBucket)(raw) : ((0, $8sRxE.sBucket)[dim.replace('Stat', '')] || (()=>String(raw)))(raw);
            const cg = isMonster ? null : this.members.Class && this.members.Gender ? this.members.Class + ' ' + this.members.Gender : null;
            return {
                color: (0, $jW5bt.wrStatColor)(dim, a, b, this.grade.typeWR, cg)
            };
        },
        nameStyle (name) {
            const c = this.highlightColors && this.highlightColors.get((name || '').toLowerCase());
            return c ? {
                color: c,
                fontWeight: 'bold'
            } : null;
        },
        itemIcon (name) {
            return (0, $ht4ts.ICONS_BASE) + (name || '').replace(/\s+/g, '') + '.gif';
        },
        // Note: NOT named teamColor — that's a prop, and a same-named method
        // shadows it (broke {{ teamColor }} and portrait lookups).
        teamHex (label) {
            return (0, $ftvub.teamBright)(label);
        },
        blockStyle (label) {
            const c = this.teamHex(label);
            return {
                border: '2px solid ' + c,
                background: c + '2e'
            };
        },
        portrait (unit, label) {
            if (unit.Gender === 'Monster') return (0, $ht4ts.UNITS_BASE) + unit.Class + '.gif';
            const g = (unit.Gender || 'Male')[0];
            if (label === 'Champion') return (0, $ht4ts.UNITS_BASE) + unit.Class + g + '.gif';
            return (0, $ht4ts.UNITS_BASE) + unit.Class + g + '_' + label + '.gif';
        },
        // Zodiac compatibility vs each unit on `label`'s team. `skipSelf` drops
        // this unit from its own team's list.
        compatFor (label, skipSelf) {
            if (!this.allunits || !label) return [];
            const team = this.allunits[label.toLowerCase()];
            if (!team || !team.Units) return [];
            return team.Units.filter((u)=>!(skipSelf && u.Name === this.members.Name)).map((u)=>({
                    unit: u,
                    compat: (0, $5tAvx.zodiacCompat)(this.members.Gender, this.members.Sign, u.Gender, u.Sign)
                }));
        },
        weaponDamage (slot) {
            return (0, $eQqwh.weaponDamage)({
                item: this.equipped[slot],
                pa: this.stats.pa,
                ma: this.stats.ma,
                speed: this.stats.speed,
                brave: this.members.Brave,
                faith: this.members.Faith,
                doublehand: this.members.SupportSkill === 'Doublehand',
                targetFaith: 60,
                // Reflect the unit's attacker supports (matches the inline card / fight view).
                attackUp: this.members.SupportSkill === 'Attack Up',
                magicAttackUp: this.members.SupportSkill === 'Magic Attack Up',
                strengthen: (0, $79bVW.unitElementProfile)(this.equipped).strengthen
            });
        },
        unarmedDamage () {
            return (0, $eQqwh.unarmedDamage)({
                paUnarmed: this.paUnarmed,
                brave: this.members.Brave,
                isMartialArts: this.members.SupportSkill === 'Martial Arts' || this.members.Class === 'Monk',
                attackUp: this.members.SupportSkill === 'Attack Up'
            });
        }
    }
};

});
parcelRegister("eQqwh", function(module, exports) {

$parcel$export(module.exports, "weaponDamage", () => $acea7e420adc18c2$export$f267f31a92c0ec92);
$parcel$export(module.exports, "unarmedDamage", () => $acea7e420adc18c2$export$ebbb758ac2564a7b);
$parcel$export(module.exports, "weaponAttackModel", () => $acea7e420adc18c2$export$58b37a837b6995e9);
$parcel$export(module.exports, "unarmedAttackModel", () => $acea7e420adc18c2$export$56f1cab73db4bb3);
$parcel$export(module.exports, "jumpAttackModel", () => $acea7e420adc18c2$export$c0cfccc8d08a604b);
// Combat damage formulas — pure functions, no Vue, no component `this`.
//
// This module is the single source of truth for damage math, extracted from
// the near-duplicate copies that lived in inlineUnit.vue and hoverUnit.vue.
//
// END-STATE ARCHITECTURE (being built incrementally — see the phased plan):
//   The public entry point will be
//       computeDamage(attacker, action, defender?, context?)
//   where:
//     - attacker: { pa, ma, speed, brave, faith, paUnarmed, isMartialArts,
//                   doublehand, strengthen:Set<element>, statuses:Set, ... }
//     - action:   { kind:'weapon'|'ability', formula, element, q/k, ... }
//     - defender: { absorb/half/weak:Set<element>, faith, zodiac, statuses:Set }
//     - context:  { attackerStatus:Set, targetStatus:Set, weather, ... }
//   The MOD 2 (physical) and MOD 5 (magic) modifier pipelines from the FFT
//   Battle Mechanics Guide will compose ON TOP of the raw formula functions
//   below. Those formula functions already take explicit inputs (not `this`),
//   so the pipeline wraps them without a rewrite — and status modifiers slot
//   in via `context` without changing this signature.
//
// For now this module exposes the raw weapon-attack formulas only; the
// ability-formula layer and the modifier pipeline land in later phases.
// Weapon ATTACK damage by weapon type (BMG §2.1). Returns:
//   - a number for fixed-damage weapons,
//   - a "min - max" string for random-range weapons (Axe/Bag/Flail),
//   - a "70% (..) - 20% (..) - 10% (..)" string for magical guns,
//   - null when the item type has no attack formula (empty slot, shield,
//     accessory, armor, etc.) so callers can fall back to unarmedDamage().
//
// opts:
//   item        - normalized item ({ type, wp, element }); from itemschanged
//   pa, ma, speed, brave, faith - the attacker's current stats
//   doublehand  - true if the unit has the Doublehand support (2x)
//   targetFaith - defender faith used for magical-gun damage (0-100). Until a
//                 real defender exists, callers pass a placeholder.
//   paBonus     - added to pa/ma/speed (and gun wp) before rolling; used by
//                 Charge+N to model "+N PA".
//   attackUp / magicAttackUp - the attacker's Attack Up / Magic Attack Up
//                 support (×4/3 on the XA term). attackUp scales physical
//                 weapons; magicAttackUp scales the magical (elemental) gun —
//                 the same physical/magical split weaponAttackModel uses, so
//                 the displayed basic-attack number matches the fight view/sim.
//   strengthen  - the attacker's Strengthen element Set (×5/4 on the XA when
//                 the weapon's element is in it).
//   The three attacker modifiers default to no-ops, so the sim/swing/Armory
//   callers (which model these elsewhere, or want a raw figure) are unchanged;
//   only the unit-card / hover display passes them. BMG order on the XA term:
//   Strengthen ×5/4, then Attack/Magic Attack Up ×4/3, each floored.
function $acea7e420adc18c2$export$f267f31a92c0ec92({ item: item, pa: pa, ma: ma, speed: speed, brave: brave, faith: faith, doublehand: doublehand = false, targetFaith: targetFaith = 100, paBonus: paBonus = 0, attackUp: attackUp = false, magicAttackUp: magicAttackUp = false, strengthen: strengthen = null }) {
    const wp = item.wp;
    const paX = pa + paBonus;
    const maX = ma + paBonus;
    const speedX = speed + paBonus;
    const mult = doublehand ? 2 : 1;
    const el = item.element;
    // Apply the attacker XA modifiers to a physical-attack XA term (in BMG order).
    const physXA = (xa)=>{
        if (el && strengthen && strengthen.has(el)) xa = Math.floor(xa * 5 / 4);
        if (attackUp) xa = Math.floor(xa * 4 / 3);
        return xa;
    };
    switch(item.type){
        case 'Rod':
        case 'Crossbow':
        case 'Spear':
        case 'Sword':
            return physXA(paX) * wp * mult;
        case 'Pole':
        case 'Staff':
            return physXA(maX) * wp * mult;
        case 'Knight Sword':
        case 'Katana':
            return parseInt(physXA(parseInt(paX * (brave / 100))) * wp) * mult;
        case 'Harp':
        case 'Book':
        case 'Fabric':
            return physXA(Math.floor((paX + maX) / 2)) * wp * mult;
        case 'Axe':
        case 'Bag':
        case 'Flail':
            return `${1 * wp * mult} - ${physXA(paX) * wp * mult}`;
        case 'Ninja Blade':
        case 'Knife':
        case 'Bow':
            return physXA(Math.floor((paX + speedX) / 2)) * wp * mult;
        case 'Gun':
            if (el) {
                const f = faith * targetFaith;
                // Magical gun: Strengthen then Magic Attack Up scale the WP XA term.
                let w = wp + paBonus;
                if (strengthen && strengthen.has(el)) w = Math.floor(w * 5 / 4);
                if (magicAttackUp) w = Math.floor(w * 4 / 3);
                return `70% (${Math.floor(f * 16 * w / 10000)}) - ` + `20% (${Math.floor(f * 20 * w / 10000)}) - ` + `10% (${Math.floor(f * 28 * w / 10000)})`;
            }
            return physXA(wp + paBonus) * wp;
        default:
            return null;
    }
}
function $acea7e420adc18c2$export$ebbb758ac2564a7b({ paUnarmed: paUnarmed, brave: brave, isMartialArts: isMartialArts = false, paBonus: paBonus = 0, attackUp: attackUp = false }) {
    const pa = paUnarmed + paBonus;
    let inner = parseInt(paUnarmed * brave / 100);
    if (attackUp) inner = Math.floor(inner * 4 / 3);
    return parseInt((isMartialArts ? 1.5 : 1) * pa * inner);
}
// ---- Attack as a "model" for the fight-view pipeline ----
// computeAbilityDamage (abilityFormula.js) takes a model with an
// evalFn(ctx, xa) that wraps the XA term in `xa`. These build such a model
// for a weapon ATTACK / unarmed ATTACK so the basic attack runs through the
// same MOD 2/MOD 5 modifier pipeline as abilities (zodiac, target absorb/
// half/weak, defense up, etc.). Weapon attacks are physical (magical:false)
// regardless of which stat they scale — except magical guns (MOD 5).
//
// ctx fields used: pa, ma, speed, wp, brave, faith, targetFaith, paUnarmed.
const $acea7e420adc18c2$var$_id = (x)=>x;
function $acea7e420adc18c2$export$58b37a837b6995e9(item, unit) {
    const mult = unit.SupportSkill === 'Doublehand' ? 2 : 1;
    const element = item.element || null;
    const wp = item.wp; // the weapon's own power (captured, not read from ctx)
    const phys = (stat, evalFn)=>({
            kind: 'number',
            verb: 'Damage',
            element: element,
            magical: false,
            stat: stat,
            evalFn: evalFn
        });
    switch(item.type){
        case 'Rod':
        case 'Crossbow':
        case 'Spear':
        case 'Sword':
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>xa(c.pa) * wp * mult);
        case 'Pole':
        case 'Staff':
            return phys('ma', (c, xa = $acea7e420adc18c2$var$_id)=>xa(c.ma) * wp * mult);
        case 'Knight Sword':
        case 'Katana':
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>xa(Math.floor(c.pa * c.brave / 100)) * wp * mult);
        case 'Harp':
        case 'Book':
        case 'Fabric':
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>xa(Math.floor((c.pa + c.ma) / 2)) * wp * mult);
        case 'Ninja Blade':
        case 'Knife':
        case 'Bow':
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>xa(Math.floor((c.pa + c.speed) / 2)) * wp * mult);
        case 'Axe':
        case 'Bag':
        case 'Flail':
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>[
                    1 * wp * mult,
                    xa(c.pa) * wp * mult
                ]);
        case 'Gun':
            if (element) // Magical gun (MOD 5). Uses the 70%/level-1 spell constant (Q=16) as
            // the representative number; magical so Magic Attack Up/Shell apply.
            return {
                kind: 'number',
                verb: 'Damage',
                element: element,
                magical: true,
                stat: 'wp',
                evalFn: (c, xa = $acea7e420adc18c2$var$_id)=>Math.floor(c.faith * c.targetFaith * xa(wp) * 16 / 10000)
            };
            return phys('pa', (c, xa = $acea7e420adc18c2$var$_id)=>xa(wp) * wp * mult); // physical gun: XA = WP
        default:
            return null; // shield / accessory / empty -> caller uses unarmedAttackModel
    }
}
function $acea7e420adc18c2$export$56f1cab73db4bb3(unit) {
    const maMult = unit.SupportSkill === 'Martial Arts' || unit.Class === 'Monk' ? 1.5 : 1;
    return {
        kind: 'number',
        verb: 'Damage',
        element: null,
        magical: false,
        stat: 'pa',
        // Martial Arts and the other modifiers scale the OUTER PA, not the [PA*Brave/100] bracket.
        // Checked in FFTBG's own build: a Monk (PA 14, Brave 50, Good zodiac) hit for 182 =
        // ((14 × 3/2 = 21) → 26) × 7, and a Mime (PA 15, Brave 47, Bad zodiac) for 84 = (15 → 12) × 7.
        evalFn: (c, xa = $acea7e420adc18c2$var$_id)=>xa(Math.floor(maMult * c.paUnarmed)) * Math.floor(c.paUnarmed * c.brave / 100)
    };
}
function $acea7e420adc18c2$export$c0cfccc8d08a604b(item, unit) {
    if (item && item.wp) {
        const wp = item.wp;
        const k = item.type === 'Spear' ? 1.5 : 1;
        return {
            kind: 'number',
            verb: 'Damage',
            element: null,
            magical: false,
            stat: 'pa',
            evalFn: (c, xa = $acea7e420adc18c2$var$_id)=>Math.floor(xa(c.pa) * wp * k)
        };
    }
    return {
        kind: 'number',
        verb: 'Damage',
        element: null,
        magical: false,
        stat: 'pa',
        evalFn: (c, xa = $acea7e420adc18c2$var$_id)=>c.paUnarmed * xa(Math.floor(c.paUnarmed * c.brave / 100))
    };
}

});

parcelRegister("5tAvx", function(module, exports) {

$parcel$export(module.exports, "ZODIAC", () => $3fcbfadf5cdd4e4c$export$cbb0962aba03bea4);
$parcel$export(module.exports, "SIGN_SYM", () => $3fcbfadf5cdd4e4c$export$a0f19358eaf3635f);
$parcel$export(module.exports, "COMPAT_TABLE", () => $3fcbfadf5cdd4e4c$export$97c430a4424b89b);
$parcel$export(module.exports, "zodiacCompat", () => $3fcbfadf5cdd4e4c$export$52b3da3b588b8f67);
// FFT zodiac compatibility. For each sign: which signs are "Good" or "Bad"
// matches, and its "opposite" sign. Opposite pairings resolve to "Best"
// (different gender), "Worst" (same gender), or "Bad" (either is a Monster).
// Serpentarius is "Neutral" with everything; anything unlisted is "Neutral".
//
// Extracted from hoverUnit.vue so the fight view can reuse it.
// The 12 western signs + FFT's bonus Serpentarius, as [name, glyph] pairs, plus a
// name→glyph lookup. Shared by the player pages so the symbol map lives in one place.
const $3fcbfadf5cdd4e4c$export$cbb0962aba03bea4 = [
    [
        'Aries',
        "\u2648"
    ],
    [
        'Taurus',
        "\u2649"
    ],
    [
        'Gemini',
        "\u264A"
    ],
    [
        'Cancer',
        "\u264B"
    ],
    [
        'Leo',
        "\u264C"
    ],
    [
        'Virgo',
        "\u264D"
    ],
    [
        'Libra',
        "\u264E"
    ],
    [
        'Scorpio',
        "\u264F"
    ],
    [
        'Sagittarius',
        "\u2650"
    ],
    [
        'Capricorn',
        "\u2651"
    ],
    [
        'Aquarius',
        "\u2652"
    ],
    [
        'Pisces',
        "\u2653"
    ],
    [
        'Serpentarius',
        "\u26CE"
    ]
];
const $3fcbfadf5cdd4e4c$export$a0f19358eaf3635f = Object.fromEntries($3fcbfadf5cdd4e4c$export$cbb0962aba03bea4);
const $3fcbfadf5cdd4e4c$export$97c430a4424b89b = {
    Aries: {
        good: [
            'Sagittarius',
            'Leo'
        ],
        bad: [
            'Cancer',
            'Capricorn'
        ],
        opposite: 'Libra'
    },
    Taurus: {
        good: [
            'Virgo',
            'Capricorn'
        ],
        bad: [
            'Leo',
            'Aquarius'
        ],
        opposite: 'Scorpio'
    },
    Gemini: {
        good: [
            'Libra',
            'Aquarius'
        ],
        bad: [
            'Pisces',
            'Virgo'
        ],
        opposite: 'Sagittarius'
    },
    Cancer: {
        good: [
            'Scorpio',
            'Pisces'
        ],
        bad: [
            'Libra',
            'Aries'
        ],
        opposite: 'Capricorn'
    },
    Leo: {
        good: [
            'Sagittarius',
            'Aries'
        ],
        bad: [
            'Scorpio',
            'Taurus'
        ],
        opposite: 'Aquarius'
    },
    Virgo: {
        good: [
            'Capricorn',
            'Taurus'
        ],
        bad: [
            'Sagittarius',
            'Gemini'
        ],
        opposite: 'Pisces'
    },
    Libra: {
        good: [
            'Aquarius',
            'Gemini'
        ],
        bad: [
            'Cancer',
            'Capricorn'
        ],
        opposite: 'Aries'
    },
    Scorpio: {
        good: [
            'Pisces',
            'Cancer'
        ],
        bad: [
            'Aquarius',
            'Leo'
        ],
        opposite: 'Taurus'
    },
    Sagittarius: {
        good: [
            'Aries',
            'Leo'
        ],
        bad: [
            'Pisces',
            'Virgo'
        ],
        opposite: 'Gemini'
    },
    Capricorn: {
        good: [
            'Taurus',
            'Virgo'
        ],
        bad: [
            'Libra',
            'Aries'
        ],
        opposite: 'Cancer'
    },
    Aquarius: {
        good: [
            'Gemini',
            'Libra'
        ],
        bad: [
            'Taurus',
            'Scorpio'
        ],
        opposite: 'Leo'
    },
    Pisces: {
        good: [
            'Cancer',
            'Scorpio'
        ],
        bad: [
            'Sagittarius',
            'Gemini'
        ],
        opposite: 'Virgo'
    }
};
function $3fcbfadf5cdd4e4c$export$52b3da3b588b8f67(myGender, mySign, theyGender, theySign) {
    if (mySign === 'Serpentarius' || theySign === 'Serpentarius') return 'Neutral';
    const entry = $3fcbfadf5cdd4e4c$export$97c430a4424b89b[mySign];
    if (!entry) return 'Neutral';
    if (entry.good.includes(theySign)) return 'Good';
    if (entry.bad.includes(theySign)) return 'Bad';
    if (entry.opposite === theySign) {
        if (myGender === 'Monster' || theyGender === 'Monster') return 'Bad';
        return myGender === theyGender ? 'Worst' : 'Best';
    }
    return 'Neutral';
}

});

parcelRegister("79bVW", function(module, exports) {

$parcel$export(module.exports, "parseItemElements", () => $5342a169e2590137$export$6e19116c952c0950);
$parcel$export(module.exports, "unitElementProfile", () => $5342a169e2590137$export$db4c93dd6bc9db8b);
$parcel$export(module.exports, "unitElementSources", () => $5342a169e2590137$export$1cca19cd4e07775c);
// Elemental affinities parsed from item `info` strings.
//
// The mustad.io items API only structures a *weapon's own* element
// (item.stats.element). Defensive/offensive elemental properties — Strengthen
// (attacker boost), Absorb / Half / Weak / Cancel (defender) — live only in
// the free-text `info`, in a consistent form, e.g.:
//   "... Effect: Absorb Fire; Half Ice."
//   "... Effect: Strengthen Fire, Lightning, Ice."
//   "... Effect: +1 MA; Absorb Dark."
//
// This module extracts those into structured sets so the damage pipeline
// (MOD 2 / MOD 5) can apply the ×5/4 strengthen, ×2 weak, ÷2 half, and
// absorb-negation steps.
const $5342a169e2590137$export$a6d18b072e3b7ccb = [
    'Fire',
    'Lightning',
    'Ice',
    'Wind',
    'Water',
    'Earth',
    'Holy',
    'Dark'
];
const $5342a169e2590137$var$ELEMENT_SET = new Set($5342a169e2590137$export$a6d18b072e3b7ccb);
const $5342a169e2590137$var$KEYWORDS = [
    'Strengthen',
    'Absorb',
    'Half',
    'Weak',
    'Cancel'
];
function $5342a169e2590137$export$6e19116c952c0950(info) {
    const out = {
        strengthen: [],
        absorb: [],
        half: [],
        weak: [],
        cancel: []
    };
    if (!info) return out;
    for (const kw of $5342a169e2590137$var$KEYWORDS){
        // "<Keyword> Elem[, Elem...]" — the char class stops at ';' or '.' so we
        // don't run past the clause; we also stop at the first non-element token.
        const re = new RegExp(`${kw}:?\\s+([A-Za-z, ]+)`, 'g');
        let m;
        while(m = re.exec(info)){
            const key = kw.toLowerCase();
            for (const tok of m[1].split(/,\s*/)){
                const e = tok.trim();
                if ($5342a169e2590137$var$ELEMENT_SET.has(e)) out[key].push(e);
                else break; // e.g. "Strengthen Fire; Chance to cast Fire" -> stop at "Chance"
            }
        }
    }
    return out;
}
function $5342a169e2590137$export$db4c93dd6bc9db8b(equipped) {
    const acc = {
        strengthen: new Set(),
        absorb: new Set(),
        half: new Set(),
        weak: new Set(),
        cancel: new Set()
    };
    for (const item of Object.values(equipped)){
        const p = $5342a169e2590137$export$6e19116c952c0950(item && item.info);
        for (const key of Object.keys(acc))for (const e of p[key])acc[key].add(e);
    }
    return acc;
}
function $5342a169e2590137$export$1cca19cd4e07775c(equipped) {
    const acc = {
        strengthen: {},
        absorb: {},
        half: {},
        weak: {},
        cancel: {}
    };
    for (const item of Object.values(equipped)){
        if (!item || !item.info) continue;
        const p = $5342a169e2590137$export$6e19116c952c0950(item.info);
        for (const key of Object.keys(acc))for (const e of p[key])(acc[key][e] || (acc[key][e] = [])).push(item.name || 'gear');
    }
    return acc;
}

});

parcelRegister("ftvub", function(module, exports) {

$parcel$export(module.exports, "teamBright", () => $b441fce0c4e8ada7$export$1084df70becb6872);
$parcel$export(module.exports, "teamDark", () => $b441fce0c4e8ada7$export$5051a5bd905a1811);
$parcel$export(module.exports, "COLOR_HEX", () => $b441fce0c4e8ada7$export$ca4f1152f19d6378);
// Team color palette, keyed by team label ('Red', 'Blue', …, 'Champion').
//   bright — vivid color for borders/chips/frames.
//   dark   — dark, white-text-readable variant for panel backgrounds.
const $b441fce0c4e8ada7$var$TEAM_BRIGHT = {
    Red: '#c0392b',
    Blue: '#2647c8',
    Green: '#2e9e2e',
    Yellow: '#b9960f',
    White: '#d9d9d9',
    Black: '#555',
    Purple: '#6a1b9a',
    Brown: '#6d4326',
    Champion: '#e07b1a'
};
const $b441fce0c4e8ada7$var$TEAM_DARK = {
    Red: '#4a1414',
    Blue: '#16263f',
    Green: '#143914',
    Yellow: '#322a08',
    White: '#383838',
    Black: '#161616',
    Purple: '#2a1240',
    Brown: '#2a1a0e',
    Champion: '#43290a'
};
function $b441fce0c4e8ada7$export$1084df70becb6872(label) {
    return $b441fce0c4e8ada7$var$TEAM_BRIGHT[label] || '#888';
}
function $b441fce0c4e8ada7$export$5051a5bd905a1811(label) {
    return $b441fce0c4e8ada7$var$TEAM_DARK[label] || 'rgba(12, 54, 80, 0.97)';
}
const $b441fce0c4e8ada7$export$ca4f1152f19d6378 = {
    red: '#c0392b',
    blue: '#2c6fbb',
    green: '#27913b',
    yellow: '#c9a227',
    white: '#aeb7c4',
    black: '#3b3f47',
    purple: '#8e44ad',
    brown: '#8a5a2b',
    champion: '#c79215'
};

});

parcelRegister("7cZwo", function(module, exports) {

$parcel$export(module.exports, "parseAbilityInfo", () => $53f9604a2aa2345b$export$4d84d9e86d20dce3);
$parcel$export(module.exports, "computeAbilityDamage", () => $53f9604a2aa2345b$export$e5ba94c82fd6698d);
$parcel$export(module.exports, "computeSuccess", () => $53f9604a2aa2345b$export$20dca43cbae166ff);
$parcel$export(module.exports, "abilityDisplay", () => $53f9604a2aa2345b$export$47a9e5e9046f8545);
$parcel$export(module.exports, "abilityVsTarget", () => $53f9604a2aa2345b$export$10a9b30493793f49);
$parcel$export(module.exports, "legacyAbilityFormula", () => $53f9604a2aa2345b$export$4e0c933de8bb875);
// Ability damage/heal/hit formulas, derived by parsing the mustad.io
// /api/abilities `info` strings instead of a hand-maintained switch.
//
// The API encodes each ability's formula in a regular grammar, e.g.
//   "... Element: Fire. Effect: Damage Faith(MA * 16)."        (faith magic)
//   "... Hit: Faith(MA + 175)%. Effect: Add Sleep."            (status %)
//   "... Effect: Damage (PA * WP)."                            (physical)
//   "... Effect: Damage (PA * Random(1,8)); ..."              (random range)
//   "... Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100)
//                          * ((100 - TargetFaith) / 100))."    (un-truth)
//
// Rather than a general arithmetic evaluator (the `/` operator means
// floor-now in stat terms but a deferred fraction in faith terms), we
// RECOGNIZE a fixed set of formula families and evaluate each with its own
// correct integer-flooring. Anything we don't recognize returns null, so the
// caller can fall back to the legacy switch.
//
// parseAbilityInfo(info) -> model | null
// renderAbility(model, ctx, mods?) -> display string
//   ctx:  { ma, pa, speed, brave, faith, targetFaith, wp, maxHp }
//   mods: { strengthen:Set<element>, attackUp:bool, magicAttackUp:bool,
//           martialArts:bool }
//         Attacker-only modifiers applied to DAMAGE results: Strengthen
//         (×5/4 when the attack's element is in the set), Attack UP /
//         Magic Attack UP (×4/3, physical vs magical), and Martial Arts
//         (×3/2, on PA-stat Punch Art ability formulas only — flagged
//         `maBoost`). They scale the XA term of the formula with the game's
//         per-step flooring — NOT the final number — and only one stat
//         instance, matching the BMG.
//
// `faith` is the caster's Faith, `targetFaith` the defender's (0-100). The
// Faith(X) macro means floor(faith * targetFaith * X / 10000).
const $53f9604a2aa2345b$var$idiv = (a, b)=>Math.floor(a / b);
const $53f9604a2aa2345b$var$identity = (x)=>x;
// Martial Arts (the support ability; the Monk's innate is identical) raises the
// modifiable PA term by ×3/2 (BMG MOD 2 step 4: "MartialArtsPA = [PA * 3/2]").
// Unlike the bare-hand basic ATTACK (barehanded-only — handled in damage.js),
// Punch Arts are non-weapon-elemental, so the bonus applies even with a weapon
// equipped. We only ever apply it to PA-stat *ability* models (flagged
// `maBoost` by parseAbilityInfo); the weapon/unarmed/Jump models from damage.js
// don't carry the flag, so the unarmed attack's own baked ×1.5 isn't doubled
// and Jump/weapon attacks (which the BMG exempts) stay untouched.
const $53f9604a2aa2345b$var$ma32 = (v)=>Math.floor(v * 3 / 2);
const $53f9604a2aa2345b$var$maEligible = (model, mods)=>!!(mods && mods.martialArts && model && model.maBoost);
const $53f9604a2aa2345b$var$PREFIX = {
    Damage: '',
    Heal: 'Heal: ',
    HealMP: 'HealMP: ',
    DamageMP: 'DamageMP: ',
    AbsorbHP: 'AbsorbHP: ',
    AbsorbMP: 'AbsorbMP: '
};
const $53f9604a2aa2345b$var$STAT_TOKEN = {
    MA: 'ma',
    PA: 'pa',
    Speed: 'speed',
    Brave: 'brave',
    WP: 'wp'
};
const $53f9604a2aa2345b$var$statKey = (tok)=>$53f9604a2aa2345b$var$STAT_TOKEN[tok];
// Each family's eval takes (ctx, xa) where `xa` scales the XA term (the part
// the attacker modifiers apply to). xa defaults to identity (no mods). `stat`
// is the primary attack stat, used to decide physical vs magical.
function $53f9604a2aa2345b$var$matchExpr(expr) {
    expr = expr.trim();
    let m;
    // Faith(MA * Q)  -> faith magic damage/heal
    if (m = expr.match(/^Faith\(\s*(MA|PA) \* (\d+)\s*\)$/)) {
        const s = $53f9604a2aa2345b$var$statKey(m[1]);
        const q = +m[2];
        return {
            stat: s,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>Math.floor(c.faith * c.targetFaith * xa(c[s]) * q / 10000)
        };
    }
    // (STAT * STAT2)   e.g. PA * WP, MA * MA
    if (m = expr.match(/^\(?\s*(MA|PA|Speed|Brave|WP) \* (MA|PA|Speed|Brave|WP)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const b = $53f9604a2aa2345b$var$statKey(m[2]);
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * c[b]
        };
    }
    // (STAT * N)
    if (m = expr.match(/^\(?\s*(MA|PA|Speed|Brave) \* (\d+)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const n = +m[2];
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * n
        };
    }
    // (A * ((B + C) / 2))  -> punch-art / elemental: A * floor((B+C)/2). Modifiers scale the
    // leading A, not the bracket: in FFTBG's build Wave Fist (PA 12, Martial Arts) did
    // (12 → 18) × 7 = 126, Will-O-Wisp (MA 13, PA 9) did (13 → 16 Good) × 5 = 80 and
    // (13 → 10 Bad) × 5 = 50.
    if (m = expr.match(/^\(?\s*(MA|PA) \* \(\((MA|PA) \+ (\d+)\) \/ 2\)\s*\)?$/)) {
        const outer = $53f9604a2aa2345b$var$statKey(m[1]);
        const inner = $53f9604a2aa2345b$var$statKey(m[2]);
        const cst = +m[3];
        return {
            stat: outer,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[outer]) * $53f9604a2aa2345b$var$idiv(c[inner] + cst, 2)
        };
    }
    // (A / 2) * B  -> floor(A/2) * B
    if (m = expr.match(/^\(?\s*\(?(MA|PA) \/ 2\)? \* (MA|PA)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const b = $53f9604a2aa2345b$var$statKey(m[2]);
        return {
            stat: b,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa($53f9604a2aa2345b$var$idiv(c[a], 2)) * c[b]
        };
    }
    // (A * (B / 2))  -> A * floor(B/2). Modifiers scale the leading A: in FFTBG's build Earth
    // Slash (PA 11, Martial Arts, charging target) did (11 → 16 → 20) × 5 = 100.
    if (m = expr.match(/^\(?\s*(MA|PA) \* \((MA|PA) \/ 2\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const b = $53f9604a2aa2345b$var$statKey(m[2]);
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * $53f9604a2aa2345b$var$idiv(c[b], 2)
        };
    }
    // (PA * (WP + N))  -> sword skills
    if (m = expr.match(/^\(?\s*(MA|PA) \* \(WP \+ (\d+)\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const n = +m[2];
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * (c.wp + n)
        };
    }
    // (PA * (WP + TargetMA [/ D]))  -> Unyielding Cut's no-equipment branch: WP plus the
    // TARGET's MA, halved since FFTBG's 2026-07-15 patch ("TargetMA / 2", floored like
    // every FFT division). This is the grammar's only DEFENDER-stat term; ctx.targetMa
    // (the raw MA) defaults to 0 when the target loadout is unknown (the equipped branch
    // is used in that case anyway — see the conditional in parseAbilityInfo).
    if (m = expr.match(/^\(?\s*(MA|PA) \* \(WP \+ TargetMA(?: \/ (\d+))?\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const d = m[2] ? +m[2] : 1;
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * (c.wp + $53f9604a2aa2345b$var$idiv(c.targetMa || 0, d))
        };
    }
    // (A * (B * Brave / 100))  -> monster brave attacks: A * floor(B*Brave/100). The modifiers
    // (zodiac, Defense Up, Protect, charging…) scale the OUTER stat, not the bracket: FFTBG's own
    // build did 72 for Iron Hawk's Scratch Up (PA 15, Brave 40) through Defense Up + Good zodiac,
    // i.e. (15 → 10 → 12) × 6, where scaling the bracket gives 15 × (6 → 4 → 5) = 75.
    if (m = expr.match(/^\(?\s*(MA|PA) \* \((MA|PA) \* Brave \/ 100\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const b = $53f9604a2aa2345b$var$statKey(m[2]);
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a]) * $53f9604a2aa2345b$var$idiv(c[b] * c.brave, 100)
        };
    }
    // (STAT * Random(a,b) * 3 / 2)  -> Pummel-style scaled range
    if (m = expr.match(/^\(?\s*(MA|PA) \* Random\((\d+),(\d+)\) \* 3 \/ 2\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const lo = +m[2];
        const hi = +m[3];
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>[
                    $53f9604a2aa2345b$var$idiv(xa(c[a]) * lo * 3, 2),
                    $53f9604a2aa2345b$var$idiv(xa(c[a]) * hi * 3, 2)
                ]
        };
    }
    // (STAT * Random(a,b))  -> range "min - max"
    if (m = expr.match(/^\(?\s*(MA|PA) \* Random\((\d+),(\d+)\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const lo = +m[2];
        const hi = +m[3];
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>[
                    xa(c[a]) * lo,
                    xa(c[a]) * hi
                ]
        };
    }
    // Un-truth: (MA * ((MA + C) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100))
    if (m = expr.match(/^\(?\s*MA \* \(\(MA \+ (\d+)\) \/ 2\) \* \(\(100 - Faith\) \/ 100\) \* \(\(100 - TargetFaith\) \/ 100\)\s*\)?$/)) {
        const cst = +m[1];
        return {
            stat: 'ma',
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>Math.floor(xa(c.ma) * $53f9604a2aa2345b$var$idiv(c.ma + cst, 2) * (100 - c.faith) * (100 - c.targetFaith) / 10000)
        };
    }
    // (MaxHP * a / b)  -> fraction of max HP (no stat -> no attacker mods)
    if (m = expr.match(/^\(?\s*MaxHP \* (\d+) \/ (\d+)\s*\)?$/)) {
        const a = +m[1];
        const b = +m[2];
        return {
            stat: null,
            eval: (c)=>$53f9604a2aa2345b$var$idiv(c.maxHp * a, b)
        };
    }
    // (A + (A * Brave / 100))  -> brave-scaled (Wiznaibus)
    if (m = expr.match(/^\(?\s*(MA|PA) \+ \(\1 \* Brave \/ 100\)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        return {
            stat: a,
            eval: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c[a] + $53f9604a2aa2345b$var$idiv(c[a] * c.brave, 100))
        };
    }
    // (STAT + N)  -> plain additive (Angel/Life Song)
    if (m = expr.match(/^\(?\s*(MA|PA|Speed) \+ (\d+)\s*\)?$/)) {
        const a = $53f9604a2aa2345b$var$statKey(m[1]);
        const n = +m[2];
        return {
            stat: a,
            eval: (c)=>c[a] + n
        };
    }
    // (N)  -> fixed literal (no stat -> no attacker mods)
    if (m = expr.match(/^\(?\s*(\d+)\s*\)?$/)) {
        const n = +m[1];
        return {
            stat: null,
            eval: ()=>n
        };
    }
    return null;
}
// Thrown-weapon power (Speed * ThrownWP). The API names the thrown item but its
// "thrown WP" is fixed per item and NOT in the item stats for shuriken/bombs
// (their equip WP is 0), so key a small table off the thrown item (BMG values,
// matching what legacyAbilityFormula showed). Element from the thrown weapon.
const $53f9604a2aa2345b$var$THROWN_WP = {
    'Giant Axe': 15,
    'Wizard Rod': 7,
    'Ivory Cane': 12,
    'Rune Blade': 14,
    'Gold Staff': 6,
    'Holy Lance': 13,
    'Morning Star': 16,
    'Air Knife': 10,
    'Spell Edge': 11,
    Shuriken: 9,
    'Burst Bomb': 8,
    'Papyrus Codex': 10
};
const $53f9604a2aa2345b$var$THROWN_ELEM = {
    'Ivory Cane': 'Earth',
    'Holy Lance': 'Holy',
    'Air Knife': 'Wind',
    'Papyrus Codex': 'Water'
};
function $53f9604a2aa2345b$export$4d84d9e86d20dce3(info) {
    if (!info) return null;
    // Jump is owned by jumpAttackModel (damage.js) — it needs the Spear ×3/2 and
    // unarmed-brave branches the info encodes as prose, which this grammar can't
    // express. Bail so the dedicated model handles it everywhere.
    if (/\(jumping\)/.test(info)) return null;
    // Throw (Ninja): "Throw <type> (<item>…); Damage (Speed * ThrownWP)" → speed*WP.
    if (/Damage \(Speed \* ThrownWP\)/.test(info)) {
        const item = (info.match(/Throw [\w ]+ \(([^),]+)/) || [])[1];
        const wp = item && $53f9604a2aa2345b$var$THROWN_WP[item.trim()];
        if (wp) return {
            kind: 'number',
            verb: 'Damage',
            element: item && $53f9604a2aa2345b$var$THROWN_ELEM[item.trim()] || null,
            stat: 'speed',
            magical: false,
            maBoost: false,
            evalFn: (c, xa = $53f9604a2aa2345b$var$identity)=>xa(c.speed) * wp
        };
    }
    const element = (info.match(/Element:\s*(\w+)/) || [])[1] || null;
    const effect = (info.match(/Effect:\s*(.+)$/) || [])[1] || '';
    // Two-branch equipment conditional (Unyielding Cut):
    //   "If target is equipped with any item except for a Shield, Damage (E1).
    //    If none is equipped, Damage (E2)."
    // E1 fires against an equipped target (the common case); E2 against a bare one
    // (monsters carry no gear, so they take E2, which folds in the target's MA). We
    // pick by ctx.targetEquipped — defaulting to the equipped branch when the
    // target's loadout is unknown (the generic single card and, for now, the sim).
    // Handled here, before the ';'-split loop, because the branches are joined by
    // '. ' and the leading "If …," strip below would otherwise garble them.
    {
        const cond = effect.match(/^If target is equipped[^,]*,\s*Damage\s+(.+?)\.\s+If none is equipped,\s*Damage\s+(.+?)\.?\s*$/);
        if (cond) {
            const e1 = $53f9604a2aa2345b$var$matchExpr(cond[1].trim());
            const e2 = $53f9604a2aa2345b$var$matchExpr(cond[2].trim());
            if (e1 && e2) return {
                kind: 'number',
                verb: 'Damage',
                element: element,
                stat: e1.stat,
                magical: e1.stat === 'ma',
                maBoost: e1.stat === 'pa',
                evalFn: (c, xa = $53f9604a2aa2345b$var$identity)=>c.targetEquipped === false ? e2.eval(c, xa) : e1.eval(c, xa)
            };
        }
    }
    for (const clause of effect.split(';')){
        // Strip a leading "If <cond>, " guard so the equip-break punch arts
        // ("Remove target's head equipment; If successful, Damage (PA * WP)") parse.
        // Death/Poison Nail's conditional damage is "(NN)%" and stays skipped below.
        const cm = clause.trim().replace(/^If [^,]+,\s*/, '').match(/^(Damage|Heal|HealMP|DamageMP|AbsorbHP|AbsorbMP)\s+(.+?)\.?\s*$/);
        if (!cm) continue;
        const verb = cm[1];
        const exprText = cm[2].trim();
        if (/^\(?\d+\)?%$/.test(exprText)) continue; // "(100)%" conditional — skip
        const matched = $53f9604a2aa2345b$var$matchExpr(exprText);
        if (matched) return {
            kind: 'number',
            verb: verb,
            element: element,
            stat: matched.stat,
            magical: matched.stat === 'ma',
            // PA-stat ability formulas (Punch Arts: Spin/Wave/Earth Slash damage,
            // Chakra heal) get the Martial Arts ×3/2 — see ma32/maEligible.
            maBoost: matched.stat === 'pa',
            evalFn: matched.eval
        };
    }
    // Status spell: success-rate from the Hit: clause. `faith` distinguishes
    // MOD 6 magic (CFa×TFa × (MA+Y)) from plain MOD 1/3/4 (stat + K, no faith).
    // evalFn is the faith-only quick calc used by the single card; the fight
    // view uses computeSuccess() for the full MOD 6 pipeline + breakdown.
    const hit = (info.match(/Hit:\s*([^.]+?)%/) || [])[1];
    if (hit) {
        const tail = hit.split(';').pop().trim();
        let fm;
        if (fm = tail.match(/^Faith\(\s*(MA|PA) \+ (\d+)\s*\)$/)) {
            const s = $53f9604a2aa2345b$var$statKey(fm[1]);
            const y = +fm[2];
            return {
                kind: 'percent',
                element: element,
                faith: true,
                stat: s,
                k: y,
                maBoost: s === 'pa',
                evalFn: (c)=>Math.floor(c.faith * c.targetFaith * (c[s] + y) / 10000)
            };
        }
        if (fm = tail.match(/^\(?\s*(MA|PA|Speed) \+ (\d+)\s*\)?$/)) {
            const s = $53f9604a2aa2345b$var$statKey(fm[1]);
            const k = +fm[2];
            return {
                kind: 'percent',
                element: element,
                faith: false,
                stat: s,
                k: k,
                maBoost: s === 'pa',
                evalFn: (c)=>c[s] + k
            };
        }
    }
    return null;
}
// Zodiac compatibility modifies the XA term additively (BMG).
function $53f9604a2aa2345b$var$zodiacStep(compat) {
    switch(compat){
        case 'Good':
            return (x)=>x + Math.floor(x / 4);
        case 'Bad':
            return (x)=>x - Math.floor(x / 4);
        case 'Best':
            return (x)=>x + Math.floor(x / 2);
        case 'Worst':
            return (x)=>x - Math.floor(x / 2);
        default:
            return $53f9604a2aa2345b$var$identity;
    }
}
// The ordered list of XA-term modifiers for a Damage attack, branching
// physical vs magical, in BMG order (each floored). `mods` carries both the
// attacker side (strengthen, attack/magic up, berserk) and the defender side
// (defense/magic-defend up, protect/shell, charging/sleeping/frog, zodiac).
// Absent fields are no-ops, so the single card (attacker-only mods) and the
// fight view (full mods) share one code path.
const $53f9604a2aa2345b$var$ZODIAC_FACTOR = {
    Good: "\xd75/4",
    Bad: "\xd73/4",
    Best: "\xd73/2",
    Worst: "\xd71/2"
};
function $53f9604a2aa2345b$var$xaSteps(model, mods) {
    const out = [];
    const mag = model.magical;
    const add = (cond, label, factor, apply)=>{
        if (cond) out.push({
            label: label,
            factor: factor,
            apply: apply
        });
    };
    const x = (n, d)=>(v)=>Math.floor(v * n / d);
    add(model.element && mods.strengthen && mods.strengthen.has(model.element), 'Strengthen', "\xd75/4", x(5, 4));
    add(mag ? mods.magicAttackUp : mods.attackUp, mag ? 'Magic Attack Up' : 'Attack Up', "\xd74/3", x(4, 3));
    add(model.maBoost && mods.martialArts, 'Martial Arts', "\xd73/2", x(3, 2));
    if (!mag) add(mods.berserk, 'Berserk', "\xd73/2", x(3, 2));
    add(mag ? mods.magicDefendUp : mods.defenseUp, mag ? 'Magic Defense Up' : 'Defense Up', "\xd72/3", x(2, 3));
    add(mag ? mods.shell : mods.protect, mag ? 'Shell' : 'Protect', "\xd72/3", x(2, 3));
    // FFTBG's status help (and its build): Charging +25% from physical attacks, Sleep +50%
    // physical, Frog/Chicken +50% from all attacks.
    if (!mag) {
        add(mods.charging, 'Charging', "\xd75/4", x(5, 4));
        add(mods.sleeping, 'Sleeping', "\xd73/2", x(3, 2));
    }
    add(mods.frogChicken, 'Frog/Chicken', "\xd73/2", x(3, 2));
    if (mods.zodiac && mods.zodiac !== 'Neutral') out.push({
        label: `Zodiac ${mods.zodiac}`,
        factor: $53f9604a2aa2345b$var$ZODIAC_FACTOR[mods.zodiac],
        apply: $53f9604a2aa2345b$var$zodiacStep(mods.zodiac)
    });
    // Weak doubles the stat term, last, so it lands before the formula's final floor: FFTBG's Bolt on a
    // Lightning-weak Ahriman did 101, ⌊2880 × (11·2) × 16 / 10000⌋, where doubling the finished 50 gives
    // 100. Half is NOT a stat step: it halves the result (Shiva on an Ice-half Porky did 59 = ⌊119 / 2⌋,
    // where halving the stat 13 → 6 gives 55).
    const el = model.element;
    add(el && mods.weak && mods.weak.has(el), 'Weak', "\xd72", x(2, 1));
    return out;
}
const $53f9604a2aa2345b$var$scaleResult = (r, fn)=>Array.isArray(r) ? [
        fn(r[0]),
        fn(r[1])
    ] : fn(r);
const $53f9604a2aa2345b$var$fmtNum = (r)=>Array.isArray(r) ? `${r[0]} - ${r[1]}` : `${r}`;
function $53f9604a2aa2345b$export$e5ba94c82fd6698d(model, ctx, mods = {}) {
    if (!model || model.kind !== 'number' || model.verb !== 'Damage' || !model.stat) // Non-damage numeric verbs (Heal/HealMP/Absorb…). Martial Arts still raises a
    // PA-scaling Punch Art (Chakra's heal) by ×3/2 on its stat term.
    return {
        final: model ? model.evalFn(ctx, $53f9604a2aa2345b$var$maEligible(model, mods) ? $53f9604a2aa2345b$var$ma32 : $53f9604a2aa2345b$var$identity) : 0,
        steps: []
    };
    const steps = [
        {
            label: 'Base',
            factor: '',
            value: $53f9604a2aa2345b$var$fmtNum(model.evalFn(ctx, $53f9604a2aa2345b$var$identity))
        }
    ];
    let composed = $53f9604a2aa2345b$var$identity;
    for (const s of $53f9604a2aa2345b$var$xaSteps(model, mods)){
        const prev = composed;
        composed = (v)=>s.apply(prev(v));
        steps.push({
            label: s.label,
            factor: s.factor,
            value: $53f9604a2aa2345b$var$fmtNum(model.evalFn(ctx, composed))
        });
    }
    let result = model.evalFn(ctx, composed);
    const el = model.element;
    if (el && mods.cancel && mods.cancel.has(el)) {
        result = $53f9604a2aa2345b$var$scaleResult(result, ()=>0);
        steps.push({
            label: 'Cancel',
            factor: "\xd70",
            value: $53f9604a2aa2345b$var$fmtNum(result)
        });
    }
    if (el && mods.half && mods.half.has(el)) {
        result = $53f9604a2aa2345b$var$scaleResult(result, (r)=>Math.floor(r / 2));
        steps.push({
            label: 'Half',
            factor: "\xf72",
            value: $53f9604a2aa2345b$var$fmtNum(result)
        });
    }
    if (el && mods.absorb && mods.absorb.has(el)) {
        result = $53f9604a2aa2345b$var$scaleResult(result, (r)=>-r);
        steps.push({
            label: 'Absorbed',
            factor: "\xd7\u22121",
            value: $53f9604a2aa2345b$var$fmtNum(result)
        });
    }
    return {
        final: result,
        steps: steps
    };
}
// Zodiac as the MOD 1/6 success ADDEND (uses both the stat and the constant).
function $53f9604a2aa2345b$var$zodiacAddend(compat, stat, y) {
    switch(compat){
        case 'Good':
            return Math.floor(stat / 4) + Math.floor(y / 4);
        case 'Bad':
            return -(Math.floor(stat / 4) + Math.floor(y / 4));
        case 'Best':
            return Math.floor(stat / 2) + Math.floor(y / 2);
        case 'Worst':
            return -(Math.floor(stat / 2) + Math.floor(y / 2));
        default:
            return 0;
    }
}
function $53f9604a2aa2345b$export$20dca43cbae166ff(model, ctx, mods = {}) {
    const steps = [];
    const Y = model.k;
    let s = ctx[model.stat];
    steps.push({
        label: model.stat.toUpperCase(),
        factor: '',
        value: `${s}`
    });
    // Martial Arts raises the PA term of a PA-based status Punch Art (Stigma Magic
    // / Revive / Purification) by ×3/2, like its damage counterpart.
    if ($53f9604a2aa2345b$var$maEligible(model, mods)) {
        s = $53f9604a2aa2345b$var$ma32(s);
        steps.push({
            label: 'Martial Arts',
            factor: "\xd73/2",
            value: `${s}`
        });
    }
    if (model.faith) {
        if (model.element && mods.strengthen && mods.strengthen.has(model.element)) {
            s = Math.floor(s * 5 / 4);
            steps.push({
                label: 'Strengthen',
                factor: "\xd75/4",
                value: `${s}`
            });
        }
        if (mods.magicAttackUp) {
            s = Math.floor(s * 4 / 3);
            steps.push({
                label: 'Magic Attack Up',
                factor: "\xd74/3",
                value: `${s}`
            });
        }
        if (mods.magicDefendUp) {
            s = Math.floor(s * 2 / 3);
            steps.push({
                label: 'Magic Defense Up',
                factor: "\xd72/3",
                value: `${s}`
            });
        }
        if (mods.shell) {
            s = Math.floor(s * 2 / 3);
            steps.push({
                label: 'Shell',
                factor: "\xd72/3",
                value: `${s}`
            });
        }
    }
    const z = $53f9604a2aa2345b$var$zodiacAddend(mods.zodiac, s, Y);
    let raw = s + Y + z;
    steps.push({
        label: `+ ${Y} (const)`,
        factor: '',
        value: `${s + Y}`
    });
    if (mods.zodiac && mods.zodiac !== 'Neutral') steps.push({
        label: `Zodiac ${mods.zodiac}`,
        factor: (z >= 0 ? '+' : '') + z,
        value: `${raw}`
    });
    let final;
    if (model.faith) {
        final = Math.floor(ctx.faith * ctx.targetFaith * raw / 10000);
        steps.push({
            label: 'Faith',
            factor: `\xd7${ctx.faith}% \xd7${ctx.targetFaith}%`,
            value: `${final}%`
        });
    } else {
        final = raw;
        steps[steps.length - 1].value = `${final}%`;
    }
    return {
        final: final,
        steps: steps
    };
}
function $53f9604a2aa2345b$export$269603d0c94ed434(model, ctx, mods) {
    if (!model) return '';
    if (model.kind === 'percent') {
        if (mods && (mods.zodiac && mods.zodiac !== 'Neutral' || $53f9604a2aa2345b$var$maEligible(model, mods))) return `${$53f9604a2aa2345b$export$20dca43cbae166ff(model, ctx, mods).final}%`;
        return `${model.evalFn(ctx, $53f9604a2aa2345b$var$identity)}%`;
    }
    if (model.verb !== 'Damage') return `${$53f9604a2aa2345b$var$PREFIX[model.verb] ?? ''}${model.evalFn(ctx, $53f9604a2aa2345b$var$maEligible(model, mods) ? $53f9604a2aa2345b$var$ma32 : $53f9604a2aa2345b$var$identity)}`;
    return $53f9604a2aa2345b$var$fmtNum($53f9604a2aa2345b$export$e5ba94c82fd6698d(model, ctx, mods).final);
}
function $53f9604a2aa2345b$export$47a9e5e9046f8545(info, ctx, mods) {
    const model = $53f9604a2aa2345b$export$4d84d9e86d20dce3(info);
    return model ? $53f9604a2aa2345b$export$269603d0c94ed434(model, ctx, mods) : '';
}
function $53f9604a2aa2345b$export$10a9b30493793f49(info, ctx, mods = {}) {
    const model = $53f9604a2aa2345b$export$4d84d9e86d20dce3(info);
    if (!model) return null;
    if (model.kind === 'percent') {
        if (mods && (mods.zodiac && mods.zodiac !== 'Neutral' || $53f9604a2aa2345b$var$maEligible(model, mods))) {
            const r = $53f9604a2aa2345b$export$20dca43cbae166ff(model, ctx, mods);
            return {
                kind: 'percent',
                faith: model.faith,
                display: `${r.final}%`,
                steps: r.steps
            };
        }
        return {
            kind: 'percent',
            faith: model.faith,
            display: `${model.evalFn(ctx, $53f9604a2aa2345b$var$identity)}%`,
            steps: []
        };
    }
    if (model.verb !== 'Damage') return {
        kind: 'other',
        verb: model.verb,
        magical: model.magical,
        display: `${$53f9604a2aa2345b$var$PREFIX[model.verb] ?? ''}${model.evalFn(ctx, $53f9604a2aa2345b$var$maEligible(model, mods) ? $53f9604a2aa2345b$var$ma32 : $53f9604a2aa2345b$var$identity)}`,
        steps: []
    };
    const { final: final, steps: steps } = $53f9604a2aa2345b$export$e5ba94c82fd6698d(model, ctx, mods);
    return {
        kind: 'damage',
        element: model.element,
        magical: model.magical,
        final: final,
        display: $53f9604a2aa2345b$var$fmtNum(final),
        steps: steps
    };
}
function $53f9604a2aa2345b$export$4e0c933de8bb875(name, ctx = {}) {
    const { pa: pa = 0, ma: ma = 0, brave: brave = 0, faith: faith = 0, targetFaith: targetFaith = 0, wp: wp = 0, weaponType: weaponType = '', paUnarmed: paUnarmed = 0 } = ctx;
    const dmg = (v)=>({
            kind: 'damage',
            value: v,
            display: String(v)
        });
    const pct = (v)=>({
            kind: 'percent',
            value: v,
            display: v + '%'
        });
    if (/^(Level|Vertical) Jump[1-8]$/.test(name)) {
        if (weaponType === 'Spear') return dmg(Math.floor(pa * wp * 1.5));
        if (wp) return dmg(Math.floor(pa * wp));
        return dmg(Math.floor(paUnarmed * Math.floor(paUnarmed * brave / 100)));
    }
    switch(name){
        case 'Elixir':
            return {
                kind: 'text',
                value: 0,
                display: 'Full Heal'
            };
        // Blastar Punch / Icewolf Bite / Shellbust Stab / Hellcry Crush now parse from
        // the API ("If successful, Damage (PA * WP)"); only Hellcry Punch is API-absent.
        case 'Hellcry Punch':
            return dmg(pa * wp);
        case 'Weapon Break':
            return pct(wp ? pa + wp + 32 : pa + 32);
        case 'Armor Break':
            return pct(wp ? pa + wp + 48 : pa + 48);
        case 'Head Break':
            return pct(wp ? pa + wp + 40 : pa + 40);
        case 'Shield Break':
            return pct(wp ? pa + wp + 56 : pa + 56);
        case 'Magic Break':
            return pct(pa + 50);
        // Throw (Axe/Wand/Stick/Sword/Staff/Spear/Hammer/Ninja Sword/Knife/Shuriken/
        // Bomb/Dictionary) now parses from the API info (Speed * ThrownWP) — see THROWN_WP.
        case 'Golem':
            return pct(Math.floor(faith / 100 * (ma + 225)));
        case 'Toxic Frog':
            return pct(Math.floor(faith * targetFaith / 10000 * (ma + 110)));
        case 'Bio Sanctus':
            return pct(Math.floor(faith * targetFaith / 10000 * (ma + 120)));
        case 'Blind Rage':
            return pct(Math.floor(faith * targetFaith / 10000 * (ma + 135)));
        case 'Confusion Song':
            return pct(Math.floor(faith * targetFaith / 10000 * (ma + 160)));
        case 'Silence Song':
            return pct(Math.floor(faith * targetFaith / 10000 * (ma + 180)));
        case 'Ice Soul':
            return dmg(ma * 3);
        default:
            return null;
    }
}

});

parcelRegister("8Q6Uh", function(module, exports) {

$parcel$export(module.exports, "evadeSources", () => $66f889949effdb4b$export$7e2608cd5899caad);
$parcel$export(module.exports, "hitChance", () => $66f889949effdb4b$export$af4af4d487ec1dd8);
// Chance (0-100) that an attack connects with a target, before the attack's
// own accuracy. FFT evasions are independent multiplicative checks — the
// attack lands only if it beats each applicable evade — so the hit chance is
// 100 × Π(1 − evadeᵢ/100). This mirrors the front/side/back logic that has
// long lived inline in inlineUnit.vue.
//
// Evade sources by physical direction:
//   front: class C-EV + shield + accessory (+ weapon, only with Parry)
//   side:  shield + accessory             (+ weapon, only with Parry)
//   back:  accessory only
// Magical evade (shield + accessory) applies from any direction.
// Guns and Jump can't be evaded — callers skip this for them.
//
// target: {
//   equipped: { Mainhand, Offhand, Head, Armor, Accessory },  // normalized items
//   cEv,        // class C-EV percent
//   reaction,   // ReactionSkill name (Parry enables weapon evade; Abandon
//               //   doubles every evade — it's always on, needs no trigger)
//   defending,  // optional: true while the unit has the 'Defending' status,
//               //   which doubles evade the same way Abandon does (stacks ×4)
// }
// Normalized items carry pevade (physical), mevade (magical), wevade (weapon).
// The evade percentages that apply, one per source (class, shield, accessory, weapon), before Abandon or
// Defending: the game rolls each separately (battleSim's evadeHit scales them per attack).
function $66f889949effdb4b$export$7e2608cd5899caad(target, { type: type = 'physical', direction: direction = 'front' } = {}) {
    const e = target.equipped;
    const evades = [];
    const mhShield = e.Mainhand.type === 'Shield';
    if (type === 'magical') {
        if (mhShield) evades.push(e.Mainhand.mevade);
        evades.push(e.Offhand.mevade, e.Accessory.mevade);
    } else if (direction === 'back') evades.push(e.Accessory.pevade);
    else {
        if (direction === 'front') evades.push(target.cEv);
        if (mhShield) evades.push(e.Mainhand.pevade);
        evades.push(e.Offhand.pevade, e.Accessory.pevade);
        if (target.reaction === 'Parry') evades.push(e.Mainhand.wevade, e.Offhand.wevade);
    }
    return evades.map((ev)=>ev || 0);
}
function $66f889949effdb4b$export$af4af4d487ec1dd8(target, opts = {}) {
    const evades = $66f889949effdb4b$export$7e2608cd5899caad(target, opts);
    // Abandon (always-on reaction) and the 'Defending' status each double every
    // evade percentage; both at once quadruple it (BMG §1.4). Each factor is
    // (1 − k·Ev), clamped at 0 — these are independent dodge checks, so once any
    // single doubled evade reaches 100% the attack can never connect.
    const k = (target.reaction === 'Abandon' ? 2 : 1) * (target.defending ? 2 : 1);
    let hit = 100;
    for (const ev of evades)hit *= Math.max(0, 100 - k * (ev || 0)) / 100;
    return hit;
}

});

parcelRegister("ivz6X", function(module, exports) {

$parcel$export(module.exports, "skillRarity", () => $d7965b942df11b79$export$57762466914ada97);
// Skill-roll rarity, from Fuelax's Class Formulas sheet
// (data in src/data/skillRarity.json: { [name]: { p, s? } }).
//
// p = chance a skill is rolled when it's the unit's OWN class (primary),
// s = chance when the class is taken as a secondary skillset. Lower = rarer.
//
// Tiers are keyed on the PRIMARY % (intrinsic rarity). s is ~5 below p across
// the board, and the secondary baseline sits at 35 — so tiering on the
// contextual % would light up nearly every secondary skill. We instead color
// by intrinsic tier and DISPLAY the context-correct % (p for own-class skills,
// s for the secondary set). Common skills (p >= 40) and skills absent from the
// sheet (monster skills, reaction/support/move) are unmarked.
// max is inclusive; first matching tier wins. >= 40 -> common (null).
//   color — bright, for use on dark backgrounds.
//   pill  — darker fill that stays legible with white text on light backgrounds.
const $d7965b942df11b79$export$6da3103054e9c839 = [
    {
        key: 'legendary',
        label: 'Legendary',
        max: 12,
        color: '#f0b429',
        pill: '#b07d0a'
    },
    {
        key: 'rare',
        label: 'Rare',
        max: 24,
        color: '#6aa3ff',
        pill: '#2f6fd0'
    },
    {
        key: 'uncommon',
        label: 'Uncommon',
        max: 39,
        color: '#35c39a',
        pill: '#1f8e6c'
    }
];
function $d7965b942df11b79$export$c79aaf9785d71556(p) {
    if (typeof p !== 'number') return null;
    for (const t of $d7965b942df11b79$export$6da3103054e9c839)if (p <= t.max) return t;
    return null;
}
function $d7965b942df11b79$export$57762466914ada97(name, isSecondary, rarityMap) {
    const rec = rarityMap && rarityMap[name];
    if (!rec) return null;
    const tier = $d7965b942df11b79$export$c79aaf9785d71556(rec.p);
    if (!tier) return null;
    const roll = isSecondary && typeof rec.s === 'number' ? rec.s : rec.p;
    return {
        tier: tier,
        roll: roll,
        p: rec.p,
        s: rec.s
    };
}

});

parcelRegister("k6EE8", function(module, exports) {
module.exports = JSON.parse("{\"Dash\":{\"p\":40,\"s\":35},\"Throw Stone\":{\"p\":40,\"s\":35},\"Accumulate\":{\"p\":50,\"s\":45},\"Heal\":{\"p\":72,\"s\":67},\"Tickle\":{\"p\":40,\"s\":35},\"Yell\":{\"p\":40,\"s\":35},\"Cheer Up\":{\"p\":35,\"s\":30},\"Fury\":{\"p\":35,\"s\":30},\"Wish\":{\"p\":40,\"s\":35},\"Scream\":{\"p\":25,\"s\":21},\"Ultima\":{\"p\":6,\"s\":5},\"Potion\":{\"p\":78,\"s\":73},\"Hi-Potion\":{\"p\":40,\"s\":34},\"X-Potion\":{\"p\":40,\"s\":34},\"Ether\":{\"p\":42,\"s\":37},\"Hi-Ether\":{\"p\":40,\"s\":35},\"Elixir\":{\"p\":4,\"s\":3},\"Antidote\":{\"p\":65,\"s\":60},\"Eye Drop\":{\"p\":65,\"s\":60},\"Echo Grass\":{\"p\":65,\"s\":59},\"Maiden's Kiss\":{\"p\":65,\"s\":58},\"Soft\":{\"p\":64,\"s\":57},\"Holy Water\":{\"p\":40,\"s\":35},\"Remedy\":{\"p\":40,\"s\":35},\"Phoenix Down\":{\"p\":85,\"s\":80},\"Head Rend\":{\"p\":40,\"s\":35},\"Armor Rend\":{\"p\":40,\"s\":35},\"Shield Rend\":{\"p\":40,\"s\":35},\"Weapon Rend\":{\"p\":40,\"s\":35},\"Magic Ruin\":{\"p\":40,\"s\":35},\"Speed Break\":{\"p\":40,\"s\":35},\"Power Break\":{\"p\":40,\"s\":35},\"Mind Break\":{\"p\":40,\"s\":35},\"Stasis Sword\":{\"p\":25,\"s\":21},\"Justice Sword\":{\"p\":32,\"s\":27},\"Dark Sword\":{\"p\":22,\"s\":19},\"Night Sword\":{\"p\":20,\"s\":17},\"Surging Sword\":{\"p\":15,\"s\":13},\"Explosion Sword\":{\"p\":7,\"s\":6},\"Charge+1\":{\"p\":55,\"s\":51},\"Charge+2\":{\"p\":40,\"s\":35},\"Charge+3\":{\"p\":40,\"s\":35},\"Charge+4\":{\"p\":40,\"s\":35},\"Charge+5\":{\"p\":40,\"s\":35},\"Charge+7\":{\"p\":40,\"s\":35},\"Charge+10\":{\"p\":30,\"s\":25},\"Charge+20\":{\"p\":21,\"s\":17},\"Spin Fist\":{\"p\":40,\"s\":35},\"Pummel\":{\"p\":40,\"s\":35},\"Wave Fist\":{\"p\":40,\"s\":35},\"Earth Slash\":{\"p\":40,\"s\":35},\"Secret Fist\":{\"p\":40,\"s\":35},\"Purification\":{\"p\":80,\"s\":75},\"Chakra\":{\"p\":45,\"s\":40},\"Revive\":{\"p\":71,\"s\":66},\"Seal Evil\":{\"p\":35,\"s\":30},\"Cure\":{\"p\":50,\"s\":45},\"Cure 2\":{\"p\":40,\"s\":35},\"Cure 3\":{\"p\":40,\"s\":35},\"Cure 4\":{\"p\":35,\"s\":30},\"Raise\":{\"p\":80,\"s\":75},\"Raise 2\":{\"p\":40,\"s\":35},\"Reraise\":{\"p\":40,\"s\":35},\"Regen\":{\"p\":40,\"s\":35},\"Protect\":{\"p\":40,\"s\":35},\"Protect 2\":{\"p\":40,\"s\":35},\"Shell\":{\"p\":40,\"s\":35},\"Shell 2\":{\"p\":40,\"s\":35},\"Wall\":{\"p\":40,\"s\":35},\"Esuna\":{\"p\":85,\"s\":80},\"Holy\":{\"p\":30,\"s\":25},\"Magic Barrier\":{\"p\":6,\"s\":5},\"Fire\":{\"p\":40,\"s\":35},\"Fire 2\":{\"p\":40,\"s\":35},\"Fire 3\":{\"p\":40,\"s\":35},\"Fire 4\":{\"p\":35,\"s\":30},\"Bolt\":{\"p\":40,\"s\":35},\"Bolt 2\":{\"p\":40,\"s\":35},\"Bolt 3\":{\"p\":40,\"s\":35},\"Bolt 4\":{\"p\":35,\"s\":30},\"Ice\":{\"p\":40,\"s\":35},\"Ice 2\":{\"p\":40,\"s\":35},\"Ice 3\":{\"p\":40,\"s\":35},\"Ice 4\":{\"p\":35,\"s\":30},\"Empower\":{\"p\":30,\"s\":25},\"Frog\":{\"p\":24,\"s\":20},\"Death\":{\"p\":25,\"s\":21},\"Flare\":{\"p\":28,\"s\":23},\"Haste\":{\"p\":59,\"s\":54},\"Haste 2\":{\"p\":40,\"s\":35},\"Slow\":{\"p\":40,\"s\":35},\"Slow 2\":{\"p\":40,\"s\":35},\"Stop\":{\"p\":40,\"s\":35},\"Immobilize\":{\"p\":40,\"s\":35},\"Float\":{\"p\":40,\"s\":35},\"Reflect\":{\"p\":43,\"s\":38},\"Quick\":{\"p\":40,\"s\":35},\"Demi\":{\"p\":40,\"s\":35},\"Demi 2\":{\"p\":40,\"s\":35},\"Mute\":{\"p\":40,\"s\":35},\"Old\":{\"p\":35,\"s\":30},\"Stabilize Time\":{\"p\":68,\"s\":63},\"Meteor\":{\"p\":25,\"s\":21},\"Galaxy Stop\":{\"p\":5,\"s\":5},\"Moogle\":{\"p\":75,\"s\":70},\"Shiva\":{\"p\":40,\"s\":35},\"Ramuh\":{\"p\":40,\"s\":35},\"Ifrit\":{\"p\":40,\"s\":35},\"Titan\":{\"p\":40,\"s\":35},\"Golem\":{\"p\":40,\"s\":35},\"Carbunkle\":{\"p\":60,\"s\":56},\"Bahamut\":{\"p\":19,\"s\":17},\"Odin\":{\"p\":25,\"s\":21},\"Leviathan\":{\"p\":40,\"s\":35},\"Salamander\":{\"p\":35,\"s\":30},\"Sylph\":{\"p\":40,\"s\":35},\"Fairy\":{\"p\":40,\"s\":35},\"Lich\":{\"p\":30,\"s\":25},\"Cyclops\":{\"p\":22,\"s\":19},\"Zodiac\":{\"p\":3,\"s\":3},\"Gil Taking\":{\"p\":39,\"s\":34},\"Steal Heart\":{\"p\":41,\"s\":36},\"Steal Helmet\":{\"p\":40,\"s\":35},\"Steal Armor\":{\"p\":40,\"s\":35},\"Steal Shield\":{\"p\":40,\"s\":35},\"Steal Weapon\":{\"p\":40,\"s\":35},\"Steal Accessory\":{\"p\":40,\"s\":35},\"Steal Status\":{\"p\":32,\"s\":27},\"Arm Aim\":{\"p\":35,\"s\":30},\"Leg Aim\":{\"p\":35,\"s\":30},\"Invitation\":{\"p\":40,\"s\":35},\"Persuade\":{\"p\":40,\"s\":35},\"Praise\":{\"p\":40,\"s\":35},\"Threaten\":{\"p\":40,\"s\":35},\"Preach\":{\"p\":40,\"s\":35},\"Solution\":{\"p\":40,\"s\":35},\"Death Sentence\":{\"p\":40,\"s\":35},\"Insult\":{\"p\":40,\"s\":35},\"Negotiate\":{\"p\":40,\"s\":35},\"Mimic Daravon\":{\"p\":40,\"s\":35},\"Refute\":{\"p\":70,\"s\":65},\"Rehabilitate\":{\"p\":40,\"s\":35},\"Blind\":{\"p\":40,\"s\":35},\"Poison\":{\"p\":40,\"s\":35},\"Life Drain\":{\"p\":40,\"s\":35},\"Spell Absorb\":{\"p\":40,\"s\":35},\"Pray Faith\":{\"p\":35,\"s\":30},\"Doubt Faith\":{\"p\":35,\"s\":30},\"Zombie\":{\"p\":40,\"s\":35},\"Silence\":{\"p\":40,\"s\":35},\"Enrage\":{\"p\":40,\"s\":35},\"Foxbird\":{\"p\":40,\"s\":35},\"Confuse\":{\"p\":40,\"s\":35},\"Paralyze\":{\"p\":40,\"s\":35},\"Sleep\":{\"p\":40,\"s\":35},\"Petrify\":{\"p\":25,\"s\":21},\"Dispel Magic\":{\"p\":70,\"s\":65},\"Dark Holy\":{\"p\":30,\"s\":25},\"Pitfall\":{\"p\":64,\"s\":64},\"Water Ball\":{\"p\":64,\"s\":64},\"Hell Ivy\":{\"p\":64,\"s\":64},\"Hallowed Ground\":{\"p\":64,\"s\":64},\"Local Quake\":{\"p\":64,\"s\":64},\"Static Shock\":{\"p\":64,\"s\":64},\"Will-O-Wisp\":{\"p\":64,\"s\":64},\"Quicksand\":{\"p\":64,\"s\":64},\"Sand Storm\":{\"p\":64,\"s\":64},\"Blizzard\":{\"p\":64,\"s\":64},\"Gusty Wind\":{\"p\":64,\"s\":64},\"Lava Ball\":{\"p\":64,\"s\":64},\"Level Jump7\":{\"p\":22,\"s\":21},\"Level Jump6\":{\"p\":19,\"s\":19},\"Level Jump5\":{\"p\":17,\"s\":17},\"Level Jump4\":{\"p\":15,\"s\":15},\"Level Jump3\":{\"p\":14,\"s\":14},\"Level Jump2\":{\"p\":13,\"s\":13},\"Vertical Jump7\":{\"p\":22,\"s\":21},\"Vertical Jump6\":{\"p\":19,\"s\":19},\"Vertical Jump5\":{\"p\":17,\"s\":17},\"Vertical Jump4\":{\"p\":15,\"s\":15},\"Vertical Jump3\":{\"p\":14,\"s\":14},\"Vertical Jump2\":{\"p\":13,\"s\":13},\"Asura\":{\"p\":53,\"s\":50},\"Koutetsu\":{\"p\":48,\"s\":43},\"Bizen Boat\":{\"p\":50,\"s\":45},\"Murasame\":{\"p\":41,\"s\":34},\"Heaven's Cloud\":{\"p\":40,\"s\":33},\"Kiyomori\":{\"p\":35,\"s\":32},\"Muramasa\":{\"p\":27,\"s\":18},\"Kikuichimonji\":{\"p\":32,\"s\":23},\"Masamune\":{\"p\":5,\"s\":4},\"Chirijiraden\":{\"p\":4,\"s\":3},\"Shuriken\":{\"p\":60,\"s\":55},\"Bomb\":{\"p\":45,\"s\":40},\"Knife\":{\"p\":16,\"s\":14},\"Sword\":{\"p\":6,\"s\":5},\"Hammer\":{\"p\":5,\"s\":4},\"Staff\":{\"p\":7,\"s\":7},\"Ninja Sword\":{\"p\":7,\"s\":7},\"Axe\":{\"p\":6,\"s\":5},\"Spear\":{\"p\":7,\"s\":6},\"Stick\":{\"p\":7,\"s\":7},\"Wand\":{\"p\":7,\"s\":7},\"Dictionary\":{\"p\":6,\"s\":6},\"Angel Song\":{\"p\":40,\"s\":35},\"Life Song\":{\"p\":40,\"s\":35},\"Cheer Song\":{\"p\":40,\"s\":35},\"Battle Song\":{\"p\":40,\"s\":35},\"Magic Song\":{\"p\":40,\"s\":35},\"Nameless Song\":{\"p\":30,\"s\":25},\"Last Song\":{\"p\":35,\"s\":30},\"Space Storage\":{\"p\":26,\"s\":22},\"Diamond Blade\":{\"p\":30,\"s\":25},\"Sky Demon\":{\"p\":30,\"s\":25},\"Hydra Pit\":{\"p\":30,\"s\":25},\"Witch Hunt\":{\"p\":40,\"s\":35},\"Wiznaibus\":{\"p\":40,\"s\":35},\"Slow Dance\":{\"p\":40,\"s\":35},\"Polka Polka\":{\"p\":40,\"s\":35},\"Disillusion\":{\"p\":40,\"s\":35},\"Nameless Dance\":{\"p\":30,\"s\":25},\"Last Dance\":{\"p\":35,\"s\":30},\"Void Storage\":{\"p\":26,\"s\":22},\"Obsidian Blade\":{\"p\":30,\"s\":25},\"Nether Demon\":{\"p\":30,\"s\":25},\"Dragon Pit\":{\"p\":30,\"s\":25}}");

});

parcelRegister("koMQO", function(module, exports) {

$parcel$export(module.exports, "rosterStats", () => $ed9bf14ec69fac45$export$86ed324fb8311e64);
$parcel$export(module.exports, "classIndex", () => $ed9bf14ec69fac45$export$ac217a0d29814d3c);
$parcel$export(module.exports, "classIndexGender", () => $ed9bf14ec69fac45$export$340a50d7c9524784);
$parcel$export(module.exports, "statsMonthly", () => $ed9bf14ec69fac45$export$ac005aa0989c2167);
$parcel$export(module.exports, "tournamentStats", () => $ed9bf14ec69fac45$export$7c58d4c74d6bcb75);
$parcel$export(module.exports, "teamRankings", () => $ed9bf14ec69fac45$export$faed7676b6b2aaf9);
$parcel$export(module.exports, "mapStats", () => $ed9bf14ec69fac45$export$c78dab378d9b2c52);
$parcel$export(module.exports, "seasonUnits", () => $ed9bf14ec69fac45$export$a52f93a569f55a5c);
$parcel$export(module.exports, "blueMagicSets", () => $ed9bf14ec69fac45$export$84a3df36f9d2ea2);
$parcel$export(module.exports, "chatVolume", () => $ed9bf14ec69fac45$export$a8b7507cdd4804a0);
$parcel$export(module.exports, "chatMeta", () => $ed9bf14ec69fac45$export$172f87cac15f3cd0);
$parcel$export(module.exports, "chatChatters", () => $ed9bf14ec69fac45$export$9f9f36e2005faf6f);
$parcel$export(module.exports, "chatLexicon", () => $ed9bf14ec69fac45$export$5f9da9eb74bcd458);
$parcel$export(module.exports, "chatSubmissions", () => $ed9bf14ec69fac45$export$e53a2954dcad47bd);
$parcel$export(module.exports, "copypasta", () => $ed9bf14ec69fac45$export$f83e6da0c67433f9);
$parcel$export(module.exports, "carpetBible", () => $ed9bf14ec69fac45$export$9a1d32aacc6196c3);
$parcel$export(module.exports, "CORE", () => $ed9bf14ec69fac45$export$db515c8cec1e6f79);
$parcel$export(module.exports, "preload", () => $ed9bf14ec69fac45$export$513ccb98c53b8039);
// src/lib/preload.js — the generated data that components read SYNCHRONOUSLY.
//
// Most data loads lazily: a page calls loadData() in a created() hook and shows a
// loading state (lib/dataStore.js). A few files can't work that way. rosterStats
// drives the grade on every unit card, the bracket's team grades, and the
// new-tournament notifier on every page, and they (and classIndex, statsMonthly, …)
// are read straight from computed properties. They used to be bundled JSON, there
// the instant a module loaded.
//
// Now they live on S3 like everything else, and main.js loads what the page needs
// (CORE for every page, plus that page's `data` list in src/routes.js) BEFORE the
// app mounts. These exports are live bindings: preload() fills them in, and
// components read them exactly as they read the bundled JSON, with no loading
// states anywhere.
//
// Reading one the current page didn't preload throws, rather than quietly rendering
// an empty table: add it to that page's `data` list in src/routes.js.

var $gKfUi = parcelRequire("gKfUi");
function $ed9bf14ec69fac45$var$unloaded(name) {
    return new Proxy({}, {
        get (_, key) {
            // Probes from await, Vue, devtools and the console aren't reads of the data.
            if (typeof key === 'symbol' || key === 'then' || key === 'toJSON' || String(key).startsWith('__v_')) return undefined;
            throw new Error(`${name}.json was read before it loaded; add it to this page's \`data\` in src/routes.js`);
        }
    });
}
let $ed9bf14ec69fac45$export$86ed324fb8311e64 = $ed9bf14ec69fac45$var$unloaded('rosterStats');
let $ed9bf14ec69fac45$export$ac217a0d29814d3c = $ed9bf14ec69fac45$var$unloaded('classIndex');
let $ed9bf14ec69fac45$export$340a50d7c9524784 = $ed9bf14ec69fac45$var$unloaded('classIndexGender');
let $ed9bf14ec69fac45$export$ac005aa0989c2167 = $ed9bf14ec69fac45$var$unloaded('statsMonthly');
let $ed9bf14ec69fac45$export$7c58d4c74d6bcb75 = $ed9bf14ec69fac45$var$unloaded('tournamentStats');
let $ed9bf14ec69fac45$export$faed7676b6b2aaf9 = $ed9bf14ec69fac45$var$unloaded('teamRankings');
let $ed9bf14ec69fac45$export$c78dab378d9b2c52 = $ed9bf14ec69fac45$var$unloaded('mapStats');
let $ed9bf14ec69fac45$export$a52f93a569f55a5c = $ed9bf14ec69fac45$var$unloaded('seasonUnits');
let $ed9bf14ec69fac45$export$84a3df36f9d2ea2 = $ed9bf14ec69fac45$var$unloaded('blueMagicSets');
let $ed9bf14ec69fac45$export$a8b7507cdd4804a0 = $ed9bf14ec69fac45$var$unloaded('chatVolume');
let $ed9bf14ec69fac45$export$172f87cac15f3cd0 = $ed9bf14ec69fac45$var$unloaded('chatMeta');
let $ed9bf14ec69fac45$export$9f9f36e2005faf6f = $ed9bf14ec69fac45$var$unloaded('chatChatters');
let $ed9bf14ec69fac45$export$5f9da9eb74bcd458 = $ed9bf14ec69fac45$var$unloaded('chatLexicon');
let $ed9bf14ec69fac45$export$e53a2954dcad47bd = $ed9bf14ec69fac45$var$unloaded('chatSubmissions');
let $ed9bf14ec69fac45$export$f83e6da0c67433f9 = $ed9bf14ec69fac45$var$unloaded('copypasta');
let $ed9bf14ec69fac45$export$9a1d32aacc6196c3 = $ed9bf14ec69fac45$var$unloaded('carpetBible');
// Reassigning an exported `let` updates it for every module that imported it.
const $ed9bf14ec69fac45$var$SET = {
    rosterStats: (d)=>{
        $ed9bf14ec69fac45$export$86ed324fb8311e64 = d;
    },
    classIndex: (d)=>{
        $ed9bf14ec69fac45$export$ac217a0d29814d3c = d;
    },
    classIndexGender: (d)=>{
        $ed9bf14ec69fac45$export$340a50d7c9524784 = d;
    },
    statsMonthly: (d)=>{
        $ed9bf14ec69fac45$export$ac005aa0989c2167 = d;
    },
    tournamentStats: (d)=>{
        $ed9bf14ec69fac45$export$7c58d4c74d6bcb75 = d;
    },
    teamRankings: (d)=>{
        $ed9bf14ec69fac45$export$faed7676b6b2aaf9 = d;
    },
    mapStats: (d)=>{
        $ed9bf14ec69fac45$export$c78dab378d9b2c52 = d;
    },
    seasonUnits: (d)=>{
        $ed9bf14ec69fac45$export$a52f93a569f55a5c = d;
    },
    blueMagicSets: (d)=>{
        $ed9bf14ec69fac45$export$84a3df36f9d2ea2 = d;
    },
    chatVolume: (d)=>{
        $ed9bf14ec69fac45$export$a8b7507cdd4804a0 = d;
    },
    chatMeta: (d)=>{
        $ed9bf14ec69fac45$export$172f87cac15f3cd0 = d;
    },
    chatChatters: (d)=>{
        $ed9bf14ec69fac45$export$9f9f36e2005faf6f = d;
    },
    chatLexicon: (d)=>{
        $ed9bf14ec69fac45$export$5f9da9eb74bcd458 = d;
    },
    chatSubmissions: (d)=>{
        $ed9bf14ec69fac45$export$e53a2954dcad47bd = d;
    },
    copypasta: (d)=>{
        $ed9bf14ec69fac45$export$f83e6da0c67433f9 = d;
    },
    carpetBible: (d)=>{
        $ed9bf14ec69fac45$export$9a1d32aacc6196c3 = d;
    }
};
const $ed9bf14ec69fac45$export$db515c8cec1e6f79 = [
    'rosterStats',
    'classIndex'
];
function $ed9bf14ec69fac45$export$513ccb98c53b8039(names) {
    return Promise.all([
        ...new Set(names)
    ].map((n)=>{
        if (!$ed9bf14ec69fac45$var$SET[n]) return Promise.reject(new Error(`preload: no such data file '${n}'`));
        return (0, $gKfUi.loadData)(`${n}.json`).then($ed9bf14ec69fac45$var$SET[n]);
    }));
}

});
parcelRegister("gKfUi", function(module, exports) {

$parcel$export(module.exports, "loadData", () => $c30d4809aea156f1$export$1686aec5678ceb1c);
$parcel$export(module.exports, "loadFile", () => $c30d4809aea156f1$export$3ae43cdaeb063d33);
$parcel$export(module.exports, "dataInfo", () => $c30d4809aea156f1$export$b80af9aaedbd9198);
$parcel$export(module.exports, "latestManifest", () => $c30d4809aea156f1$export$35eb0ccd2cfa14df);
$parcel$export(module.exports, "champDetailsFor", () => $c30d4809aea156f1$export$31eed8ea4454ef80);
// src/lib/dataStore.js — the site's generated data, loaded from S3.
//
// The precomputed JSON (playerIndex, champHistory, …) used to ride in the bundle as
// code-split import()s, so every data refresh was a git commit (~14 MB) and two
// Netlify builds. It now lives on the asset bucket, published by the refresh box
// (ops/publish.mjs): content-addressed gzipped files, plus one small manifest per
// channel naming the current build.
//
// A page reads its manifest ONCE and resolves every file through it, so files that
// must agree (champHistory and its index-aligned champReignMeta) always come from
// the same build, even when a refresh lands while the tab is open.
//
// Channel: production on wiznaib.us, staging everywhere else (the staging deploy,
// deploy previews, localhost), so a data-shape change can be tried on staging before
// production code has to understand it. Override with ?data=production|staging, or
// ?data=local to read freshly built files served by `node tools/serveData.mjs`.

var $ht4ts = parcelRequire("ht4ts");
const $c30d4809aea156f1$var$LOCAL_BASE = 'http://127.0.0.1:8090/';
function $c30d4809aea156f1$var$pickChannel() {
    let loc;
    try {
        loc = window.location;
    } catch (e) {
        return 'staging';
    }
    const q = new URLSearchParams(loc.search).get('data');
    if (q === 'production' || q === 'staging' || q === 'local') return q;
    return loc.hostname === 'wiznaib.us' || loc.hostname === 'www.wiznaib.us' ? 'production' : 'staging';
}
const $c30d4809aea156f1$export$75498c5a3399144e = $c30d4809aea156f1$var$pickChannel();
const $c30d4809aea156f1$var$BASE = $c30d4809aea156f1$export$75498c5a3399144e === 'local' ? $c30d4809aea156f1$var$LOCAL_BASE : (0, $ht4ts.DATA_BASE);
// One retry: a dropped connection shouldn't blank a page that would load on a second try.
async function $c30d4809aea156f1$var$getJson(url, init) {
    let lastErr;
    for(let attempt = 0; attempt < 2; attempt++)try {
        const r = await fetch(url, init);
        if (!r.ok) throw new Error(`HTTP ${r.status} for ${url}`);
        return await r.json();
    } catch (e) {
        lastErr = e;
    }
    throw lastErr;
}
let $c30d4809aea156f1$var$manifest = null;
function $c30d4809aea156f1$var$getManifest() {
    if (!$c30d4809aea156f1$var$manifest) {
        // no-cache = revalidate on every page load, so a refresh shows up without a redeploy.
        $c30d4809aea156f1$var$manifest = $c30d4809aea156f1$var$getJson(`${$c30d4809aea156f1$var$BASE}${$c30d4809aea156f1$export$75498c5a3399144e}.json`, {
            cache: 'no-cache'
        });
        $c30d4809aea156f1$var$manifest.catch(()=>{
            $c30d4809aea156f1$var$manifest = null;
        }); // a later call retries instead of inheriting the failure
    }
    return $c30d4809aea156f1$var$manifest;
}
const $c30d4809aea156f1$var$loaded = new Map();
function $c30d4809aea156f1$export$1686aec5678ceb1c(name) {
    if (!$c30d4809aea156f1$var$loaded.has(name)) {
        const p = $c30d4809aea156f1$var$getManifest().then((m)=>{
            const key = m.files[name];
            if (!key) throw new Error(`${name} is not in the ${$c30d4809aea156f1$export$75498c5a3399144e} data manifest`);
            return $c30d4809aea156f1$export$3ae43cdaeb063d33(key);
        });
        p.catch(()=>$c30d4809aea156f1$var$loaded.delete(name));
        $c30d4809aea156f1$var$loaded.set(name, p);
    }
    return $c30d4809aea156f1$var$loaded.get(name);
}
// A file by its manifest key. Keys are content hashes, so a key always means the same
// bytes, and loadData() and a reader of a newer manifest share one download.
const $c30d4809aea156f1$var$files = new Map();
function $c30d4809aea156f1$export$3ae43cdaeb063d33(key) {
    if (!$c30d4809aea156f1$var$files.has(key)) {
        const p = $c30d4809aea156f1$var$getJson($c30d4809aea156f1$var$BASE + key);
        p.catch(()=>$c30d4809aea156f1$var$files.delete(key));
        $c30d4809aea156f1$var$files.set(key, p);
    }
    return $c30d4809aea156f1$var$files.get(key);
}
function $c30d4809aea156f1$export$b80af9aaedbd9198() {
    return $c30d4809aea156f1$var$getManifest().then((m)=>({
            built: m.built || null,
            latestId: m.latestId || null
        }));
}
async function $c30d4809aea156f1$export$35eb0ccd2cfa14df() {
    try {
        return await $c30d4809aea156f1$var$getJson(`${$c30d4809aea156f1$var$BASE}${$c30d4809aea156f1$export$75498c5a3399144e}.json`, {
            cache: 'no-cache'
        });
    } catch  {
        return null;
    }
}
// A player's champion-loadout file (≥50-title players), or null for everyone else.
// Memoized like the import() it replaced: the history tab and the Onion Knight
// quest both ask for the same player's file on one profile.
const $c30d4809aea156f1$var$details = new Map();
function $c30d4809aea156f1$export$31eed8ea4454ef80(player) {
    if (!$c30d4809aea156f1$var$details.has(player)) {
        const p = $c30d4809aea156f1$export$1686aec5678ceb1c('champDetails/index.json').then((index)=>index[player] ? $c30d4809aea156f1$var$getJson($c30d4809aea156f1$var$BASE + index[player]) : null);
        p.catch(()=>$c30d4809aea156f1$var$details.delete(player));
        $c30d4809aea156f1$var$details.set(player, p);
    }
    return $c30d4809aea156f1$var$details.get(player);
}

});
parcelRegister("ht4ts", function(module, exports) {

$parcel$export(module.exports, "UNITS_BASE", () => $cb789d955d664c09$export$b06e3c6abeca5722);
$parcel$export(module.exports, "ICONS_BASE", () => $cb789d955d664c09$export$7125e62e44ba4c46);
$parcel$export(module.exports, "MAPS_BASE", () => $cb789d955d664c09$export$4ce56b7a8ceebc73);
$parcel$export(module.exports, "DATA_BASE", () => $cb789d955d664c09$export$993f2429d5ab1fb7);
// Base URLs for the FFTBG asset CDN. Centralized so the unit-portrait, item/skill-icon,
// and map-gif bases live in exactly one place (they were redefined ~19× across components
// under a half-dozen different names: UNIT_IMG / IMG_URL / CLASS_ICON_URL / PORTRAIT_BASE,
// ITEM_IMG / IMG_URL_ITEMS, MAP_IMG).
//
//   UNITS_BASE + '<Class><Gender>.gif'   → unit portrait  (e.g. 'KnightM.gif')
//   ICONS_BASE + '<ItemNameNoSpaces>.gif' → item / skill icon
//   MAPS_BASE  + '<n>.gif'                → battle-map gif
const $cb789d955d664c09$var$CDN = 'https://luxor-fftbg-assets.s3.amazonaws.com/';
const $cb789d955d664c09$export$b06e3c6abeca5722 = $cb789d955d664c09$var$CDN + 'units/';
const $cb789d955d664c09$export$7125e62e44ba4c46 = $cb789d955d664c09$var$CDN + 'icons/';
const $cb789d955d664c09$export$4ce56b7a8ceebc73 = $cb789d955d664c09$var$CDN + 'maps/';
const $cb789d955d664c09$export$993f2429d5ab1fb7 = $cb789d955d664c09$var$CDN + 'data/';

});



parcelRegister("8sRxE", function(module, exports) {

$parcel$export(module.exports, "sBucket", () => $629a788c435ae8d9$export$5ab2780a1670722b);
$parcel$export(module.exports, "bfBucket", () => $629a788c435ae8d9$export$5fc2ecf976025386);
$parcel$export(module.exports, "bfFit", () => $629a788c435ae8d9$export$225613c2d34ff);
$parcel$export(module.exports, "archetypeOf", () => $629a788c435ae8d9$export$30e95d823b49cf52);
$parcel$export(module.exports, "unitGrade", () => $629a788c435ae8d9$export$6beeeb6cf4d93b78);
$parcel$export(module.exports, "teamGrade", () => $629a788c435ae8d9$export$f99ae8ae029725dc);
$parcel$export(module.exports, "topParts", () => $629a788c435ae8d9$export$cf70aa8abe420919);
// Two-axis empirical unit grade, from the precomputed rosterStats.json:
//
//   COLOR  = type tier — how good this *kind* of unit is, absolutely (its class/
//            type overall win rate → gold / blue / green / grey). A Floating Eye
//            is grey no matter how it's rolled; a Holy Dragon is gold.
//   LETTER = specimen — how good *this one* is for its type, relative to an
//            average unit of the type:
//              · monsters: their Brave/Faith vs that monster's B/F win curves
//                (the only thing that varies on a monster);
//              · humans: their skills + (with gameData) their post-gear stats and
//                Brave/Faith, scored by archetype (high PA helps melee, high MA/
//                faith helps casters, etc.).
//
// So an 80-Brave Floating Eye reads "grey A" — a great specimen of a weak type.
// Correlational, not a win probability — label it that way in the UI.

var $9rruk = parcelRequire("9rruk");

var $gEKSn = parcelRequire("gEKSn");
const $629a788c435ae8d9$export$5ab2780a1670722b = {
    PA: (v)=>String(Math.round(v || 0)),
    MA: (v)=>String(Math.round(v || 0)),
    Speed: (v)=>String(Math.round(v || 0)),
    HP: (v)=>{
        const d = Math.floor((v || 0) / 25) * 25;
        return d < 100 ? '<100' : `${d}-${d + 24}`;
    }
};
const $629a788c435ae8d9$export$5fc2ecf976025386 = (v)=>{
    v = v || 0;
    if (v < 40) return '<40';
    if (v >= 85) return '85+';
    const lo = Math.floor(v / 5) * 5;
    return `${lo}-${lo + 4}`;
};
// Bucket → representative Brave/Faith value, for fitting a trend across a monster's
// bucketed B/F win curve.
const $629a788c435ae8d9$var$MID_BF = {
    '<40': 37,
    '40-44': 42,
    '45-49': 47,
    '50-54': 52,
    '55-59': 57,
    '60-64': 62,
    '65-69': 67,
    '70-74': 72,
    '75-79': 77,
    '80-84': 82,
    '85+': 88
};
function $629a788c435ae8d9$export$225613c2d34ff(curve) {
    if (!curve || !curve.length) return null;
    const pts = curve.map((b)=>({
            x: $629a788c435ae8d9$var$MID_BF[b.bucket],
            y: b.winRate,
            w: b.played || 1
        })).filter((p)=>p.x != null);
    if (!pts.length) return null;
    let sw = 0, sx = 0, sy = 0, sxx = 0, sxy = 0;
    for (const p of pts){
        sw += p.w;
        sx += p.w * p.x;
        sy += p.w * p.y;
        sxx += p.w * p.x * p.x;
        sxy += p.w * p.x * p.y;
    }
    const mx = sx / sw, my = sy / sw, denom = sxx - sw * mx * mx;
    const slope = denom > 1e-9 ? (sxy - sw * mx * my) / denom : 0; // one distinct bucket → flat
    const b0 = my - slope * mx;
    const xs = pts.map((p)=>p.x);
    const clamp = (w)=>Math.max(0, Math.min(100, w));
    return {
        predict: (v)=>clamp(b0 + slope * (v || 0)),
        lo: Math.min(...xs),
        hi: Math.max(...xs)
    };
}
function $629a788c435ae8d9$export$30e95d823b49cf52(classBase, isMonster) {
    if (isMonster) return 'monster';
    if (!classBase || !classBase.pa && !classBase.ma) return 'hybrid';
    if (classBase.ma > classBase.pa + 1) return 'caster';
    if (classBase.pa > classBase.ma + 1) return 'melee';
    return 'hybrid';
}
const $629a788c435ae8d9$var$TIERS = [
    [
        55,
        'gold'
    ],
    [
        51,
        'blue'
    ],
    [
        47,
        'green'
    ],
    [
        -1,
        'grey'
    ]
];
const $629a788c435ae8d9$var$colorFor = (wr)=>($629a788c435ae8d9$var$TIERS.find(([t])=>wr >= t) || [
        -1,
        'grey'
    ])[1];
const $629a788c435ae8d9$var$SKILL_W = 0.5, $629a788c435ae8d9$var$STAT_W = 0.5, $629a788c435ae8d9$var$BF_W = 0.3;
// Swing (basic-attack burst) weight. It OVERLAPS the StatPA/StatMA buckets +
// the weapon/Dual-Wield/Doublehand dims it's derived from, but the signal is
// marginal-to-PA (a +12–18pt separator at fixed PA), so it earns a full stat-
// tier weight rather than a token nudge. Tunable middle ground: raise it to lean
// harder into burst, drop toward 0 to mute it.
const $629a788c435ae8d9$var$SWING_W = 0.5;
// Compute the theoretical best and worst lift for a class+gender across the
// same dimensions the grade uses. Returns { min, max } — the floor/ceiling of
// what any unit of this type could score. Used to normalize the letter grade
// so each class's scale is relative to its own range, not a fixed threshold.
function $629a788c435ae8d9$var$liftRange(rs, cls, gender, typeWR, arch) {
    let minL = 0, maxL = 0;
    const isMonster = gender === 'Monster';
    const gKey = !isMonster && cls && gender ? cls + ' ' + gender : null;
    const RANGE_MIN_SAMPLE = 100; // ignore extreme outliers with tiny sample sizes
    // Skills: scan crossByClass for best/worst available WR per dim.
    if (!isMonster) {
        for (const dim of [
            'SupportSkill',
            'ReactionSkill',
            'ActionSkill'
        ]){
            const cb = rs && rs.crossByClass && rs.crossByClass[dim];
            if (!cb) continue;
            let best = typeWR, worst = typeWR;
            for(const skill in cb){
                let wr = null, n = 0;
                if (gKey) {
                    const h = cb[skill].find((x)=>x.value === gKey);
                    if (h) {
                        wr = h.winRate;
                        n = h.played;
                    }
                }
                if (wr == null) {
                    const h = cb[skill].find((x)=>x.value === cls);
                    if (h) {
                        wr = h.winRate;
                        n = h.played;
                    }
                }
                if (wr != null && n >= RANGE_MIN_SAMPLE) {
                    if (wr > best) best = wr;
                    if (wr < worst) worst = wr;
                }
            }
            maxL += (best - typeWR) * $629a788c435ae8d9$var$SKILL_W;
            minL += (worst - typeWR) * $629a788c435ae8d9$var$SKILL_W;
        }
        // Weapon: from flat dims (no cross-tab for weapons).
        const weapons = rs && rs.dims && rs.dims.Weapon;
        if (weapons && weapons.length) {
            const f = weapons.filter((w)=>w.played >= RANGE_MIN_SAMPLE);
            if (f.length) {
                maxL += (Math.max(...f.map((w)=>w.winRate)) - typeWR) * $629a788c435ae8d9$var$SKILL_W;
                minL += (Math.min(...f.map((w)=>w.winRate)) - typeWR) * $629a788c435ae8d9$var$SKILL_W;
            }
        }
        // Stats + Brave/Faith (conditional by class+gender, falling back to archetype).
        const cgKey = !isMonster && cls && gender ? cls + ' ' + gender : null;
        if (arch || cgKey) {
            for (const dim of [
                'StatPA',
                'StatMA',
                'StatSpeed',
                'StatHP'
            ]){
                const c = rs && rs.conditional && rs.conditional[dim];
                const a = cgKey && c && c[cgKey] || arch && c && c[arch];
                if (!a || !a.length) continue;
                const f = a.filter((x)=>x.played >= RANGE_MIN_SAMPLE);
                if (f.length) {
                    maxL += (Math.max(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$STAT_W;
                    minL += (Math.min(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$STAT_W;
                }
            }
            for (const dim of [
                'Brave',
                'Faith'
            ]){
                const c = rs && rs.conditional && rs.conditional[dim];
                const a = cgKey && c && c[cgKey] || arch && c && c[arch];
                if (!a || !a.length) continue;
                const f = a.filter((x)=>x.played >= RANGE_MIN_SAMPLE);
                if (f.length) {
                    maxL += (Math.max(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$BF_W;
                    minL += (Math.min(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$BF_W;
                }
            }
            // Swing damage — conditional like the stat buckets, its own weight.
            {
                const c = rs && rs.conditional && rs.conditional.StatSwing;
                const a = cgKey && c && c[cgKey] || arch && c && c[arch];
                if (a && a.length) {
                    const f = a.filter((x)=>x.played >= RANGE_MIN_SAMPLE);
                    if (f.length) {
                        maxL += (Math.max(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$SWING_W;
                        minL += (Math.min(...f.map((x)=>x.winRate)) - typeWR) * $629a788c435ae8d9$var$SWING_W;
                    }
                }
            }
        }
    } else {
        // Monsters: fitted Brave/Faith trends. The achievable lift extremes are the
        // fit evaluated at the ends of the observed B/F domain (the fit is linear, so
        // the extremes are the endpoints) — an ACHIEVABLE range (a unit really can roll
        // near those ends), matching the fitted lift the grade uses. A flat fit (B/F
        // doesn't move this monster) collapses the range → its specimens grade middling.
        const mb = rs && rs.monsterBF && rs.monsterBF[cls];
        if (mb) for (const curve of [
            mb.brave,
            mb.faith
        ]){
            const fit = $629a788c435ae8d9$export$225613c2d34ff(curve);
            if (!fit) continue;
            const ends = [
                fit.predict(fit.lo),
                fit.predict(fit.hi)
            ];
            const w = 0.5; // monsters split evenly across B/F
            maxL += (Math.max(...ends) - typeWR) * w;
            minL += (Math.min(...ends) - typeWR) * w;
        }
    }
    return {
        min: +minL.toFixed(1),
        max: +maxL.toFixed(1)
    };
}
// Map a lift to a letter grade based on where it falls in the class's range.
// Zero lift (= average unit) maps to 0.5; positive lifts scale into [0.5, 1.0]
// using max, negative into [0.0, 0.5] using min — so the scale is symmetric
// around "average" even when the range is lopsided.
const $629a788c435ae8d9$var$LETTER_PCTS = [
    [
        0.9,
        'A+'
    ],
    [
        0.75,
        'A'
    ],
    [
        0.6,
        'B'
    ],
    [
        0.45,
        'C+'
    ],
    [
        0.3,
        'C'
    ],
    [
        0.18,
        'D'
    ],
    [
        0.08,
        'E'
    ],
    [
        0,
        'F'
    ]
];
const $629a788c435ae8d9$var$letterFor = (lift, range)=>{
    if (!range || range.max <= 0 && range.min >= 0) return 'C';
    let pct;
    if (lift >= 0) pct = range.max > 0 ? 0.5 + 0.5 * (lift / range.max) : 1;
    else pct = range.min < 0 ? 0.5 - 0.5 * (lift / range.min) : 0;
    pct = Math.max(0, Math.min(1, pct));
    return ($629a788c435ae8d9$var$LETTER_PCTS.find(([t])=>pct >= t) || [
        0,
        'F'
    ])[1];
};
const $629a788c435ae8d9$export$320bc3b7c2fadd5e = [
    0,
    1,
    2,
    3,
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    97,
    98,
    99,
    100
];
const $629a788c435ae8d9$export$bf17dece9dc8a765 = [
    [
        0.98,
        'A+'
    ],
    [
        0.89,
        'A'
    ],
    [
        0.72,
        'B'
    ],
    [
        0.50,
        'C+'
    ],
    [
        0.28,
        'C'
    ],
    [
        0.11,
        'D'
    ],
    [
        0.02,
        'E'
    ],
    [
        0,
        'F'
    ]
];
const $629a788c435ae8d9$export$50ef99fb386df8fb = (p)=>($629a788c435ae8d9$export$bf17dece9dc8a765.find(([t])=>p >= t) || [
        0,
        'F'
    ])[1];
function $629a788c435ae8d9$export$35ed890b75c4f7b0(knots, lift) {
    if (!knots || !knots.length) return 0.5;
    if (lift <= knots[0]) return 0;
    if (lift >= knots[knots.length - 1]) return 1;
    let i = 1;
    while(i < knots.length && knots[i] < lift)i++;
    const lo = knots[i - 1], hi = knots[i];
    const frac = hi > lo ? (lift - lo) / (hi - lo) : 0;
    return ($629a788c435ae8d9$export$320bc3b7c2fadd5e[i - 1] + frac * ($629a788c435ae8d9$export$320bc3b7c2fadd5e[i] - $629a788c435ae8d9$export$320bc3b7c2fadd5e[i - 1])) / 100;
}
const $629a788c435ae8d9$var$dimWR = (rs, dim, value)=>{
    const a = rs && rs.dims && rs.dims[dim];
    if (!a || value == null || value === '') return null;
    const hit = a.find((x)=>x.value === value);
    return hit ? hit.winRate : null;
};
// Conditional stat lookup: tries class+gender first (e.g. "Wizard Female"),
// falls back to archetype (e.g. "caster").
const $629a788c435ae8d9$var$condWR = (rs, trait, arch, value, clsGender)=>{
    const c = rs && rs.conditional && rs.conditional[trait];
    if (!c || value == null) return null;
    if (clsGender) {
        const a = c[clsGender];
        if (a) {
            const hit = a.find((x)=>x.value === value);
            if (hit) return hit.winRate;
        }
    }
    const a = c[arch];
    if (!a) return null;
    const hit = a.find((x)=>x.value === value);
    return hit ? hit.winRate : null;
};
const $629a788c435ae8d9$var$curveWR = (curve, b)=>{
    const hit = curve && curve.find((x)=>x.bucket === b);
    return hit ? hit.winRate : null;
};
// Per-class win rate for a skill (crossByClass[dim][value] → find class+gender entry).
// Tries gender-specific ("Monk Male") first, falls back to gender-blind ("Monk"),
// then to the flat dimWR when per-class data is unavailable.
const $629a788c435ae8d9$var$crossWR = (rs, dim, value, cls, gender)=>{
    const cross = rs && rs.crossByClass && rs.crossByClass[dim] && rs.crossByClass[dim][value];
    if (cross) {
        if (cls && gender && gender !== 'Monster') {
            const hit = cross.find((x)=>x.value === cls + ' ' + gender);
            if (hit) return hit.winRate;
        }
        if (cls) {
            const hit = cross.find((x)=>x.value === cls);
            if (hit) return hit.winRate;
        }
    }
    return $629a788c435ae8d9$var$dimWR(rs, dim, value);
};
function $629a788c435ae8d9$export$6beeeb6cf4d93b78(unit, rosterStats, gameData) {
    const isMonster = (unit && unit.Gender) === 'Monster';
    // Gender-aware class win rate (Female Monk 47.9% vs Male Monk 53%) when
    // available; falls back to gender-blind Class rate for monsters / unknown.
    const genderedKey = !isMonster && unit && unit.Class && unit.Gender ? unit.Class + ' ' + unit.Gender : null;
    const typeWR = (genderedKey && $629a788c435ae8d9$var$dimWR(rosterStats, 'ClassGender', genderedKey)) ?? $629a788c435ae8d9$var$dimWR(rosterStats, 'Class', unit && unit.Class) ?? 50;
    const parts = [];
    let lift = 0;
    const add = (label, dim, winRate, weight)=>{
        const c = +((winRate - typeWR) * weight).toFixed(1);
        lift += c;
        parts.push({
            label: label,
            dim: dim,
            winRate: winRate,
            contribution: c
        });
    };
    if (isMonster) {
        // Monsters are identical but for Brave/Faith — score them on this type's own
        // Brave and Faith win curves (separately), relative to the type's average. The
        // score reads the sample-weighted FITTED trend at the unit's exact B/F (see
        // bfFit) rather than the raw 5-wide bucket, so the grade moves smoothly with B/F
        // instead of jumping at bucket boundaries or on a single thin extreme bin.
        const mb = rosterStats && rosterStats.monsterBF && rosterStats.monsterBF[unit.Class];
        if (mb) {
            const sigs = [
                [
                    'Brave',
                    unit.Brave || 0,
                    $629a788c435ae8d9$export$225613c2d34ff(mb.brave)
                ],
                [
                    'Faith',
                    unit.Faith || 0,
                    $629a788c435ae8d9$export$225613c2d34ff(mb.faith)
                ]
            ].filter((s)=>s[2]);
            const w = sigs.length ? 1 / sigs.length : 0;
            for (const [dim, val, fit] of sigs){
                const wr = +fit.predict(val).toFixed(1);
                const c = +((wr - typeWR) * w).toFixed(1);
                lift += c;
                parts.push({
                    label: `${dim} ${val}`,
                    dim: dim,
                    winRate: wr,
                    contribution: c
                });
            }
        }
    } else {
        // Skills + WEAPON. The weapon's identity matters beyond its raw stats
        // (type / range / element), so it counts; the other gear slots are
        // intentionally omitted — their effect is already in the post-gear
        // PA/MA/Speed/HP buckets below, so scoring them too would double-count.
        const cls = unit && unit.Class;
        for (const [dim, field] of [
            [
                'SupportSkill',
                'SupportSkill'
            ],
            [
                'ReactionSkill',
                'ReactionSkill'
            ],
            [
                'ActionSkill',
                'ActionSkill'
            ],
            [
                'Weapon',
                'Mainhand'
            ]
        ]){
            const v = unit && unit[field];
            const wr = $629a788c435ae8d9$var$crossWR(rosterStats, dim, v, cls, unit.Gender);
            if (wr != null) add(v, dim, wr, $629a788c435ae8d9$var$SKILL_W);
        }
        // Dual Wield's 2nd weapon (via the support OR innate, e.g. Ninja) was
        // previously ignored — the grade only read Mainhand. Score the offhand
        // under the Weapon dim too, at half weight (a secondary swing). A shield or
        // relic in the offhand returns null here (it never appears as a Mainhand, so
        // it's absent from the Weapon dim), so non-dual-wielders self-skip.
        if (unit && unit.Offhand) {
            const wr = $629a788c435ae8d9$var$crossWR(rosterStats, 'Weapon', unit.Offhand, cls, unit.Gender);
            if (wr != null) add(unit.Offhand, 'Weapon', wr, $629a788c435ae8d9$var$SKILL_W * 0.5);
        }
        const cs = gameData && gameData.charStats;
        if (cs) {
            const classBase2 = cs[(unit.Class || '').replace(/\s+/g, '') + (unit.Gender || '')];
            const arch2 = $629a788c435ae8d9$export$30e95d823b49cf52(classBase2, false);
            const cgKey = unit.Class && unit.Gender && unit.Gender !== 'Monster' ? unit.Class + ' ' + unit.Gender : null;
            const st = (0, $9rruk.unitCombatStats)(unit, cs, gameData.itemschanged, gameData.notAbles).stats;
            for (const [dim, val] of [
                [
                    'StatPA',
                    $629a788c435ae8d9$export$5ab2780a1670722b.PA(st.pa)
                ],
                [
                    'StatMA',
                    $629a788c435ae8d9$export$5ab2780a1670722b.MA(st.ma)
                ],
                [
                    'StatSpeed',
                    $629a788c435ae8d9$export$5ab2780a1670722b.Speed(st.speed)
                ],
                [
                    'StatHP',
                    $629a788c435ae8d9$export$5ab2780a1670722b.HP(st.hp)
                ]
            ]){
                const wr = $629a788c435ae8d9$var$condWR(rosterStats, dim, arch2, val, cgKey);
                if (wr != null) add(`${dim.slice(4)} ${val}`, dim, wr, $629a788c435ae8d9$var$STAT_W);
            }
            for (const [dim, val] of [
                [
                    'Brave',
                    $629a788c435ae8d9$export$5fc2ecf976025386(unit.Brave)
                ],
                [
                    'Faith',
                    $629a788c435ae8d9$export$5fc2ecf976025386(unit.Faith)
                ]
            ]){
                const wr = $629a788c435ae8d9$var$condWR(rosterStats, dim, arch2, val, cgKey);
                if (wr != null) add(`${dim} ${val}`, dim, wr, $629a788c435ae8d9$var$BF_W);
            }
            // Swing damage — the unit's basic-attack burst (mainhand, doubled for
            // Doublehand, + the Dual-Wield offhand). Bucketed win rate, conditional by
            // archetype/class. Captures the stat×weapon interaction the StatPA/StatMA
            // buckets and the per-weapon win rate each miss on their own.
            const sb = (0, $gEKSn.swingBucket)((0, $gEKSn.unitSwingDamage)(unit, cs, gameData.itemschanged, gameData.notAbles));
            if (sb) {
                const wr = $629a788c435ae8d9$var$condWR(rosterStats, 'StatSwing', arch2, sb, cgKey);
                if (wr != null) add(`Swing ${sb}`, 'StatSwing', wr, $629a788c435ae8d9$var$SWING_W);
            }
        }
    }
    // Compute the theoretical best/worst lift for this class+gender so the letter
    // grade is relative to the class's own range, not a fixed threshold.
    const cs = gameData && gameData.charStats;
    const classBase = !isMonster && cs ? cs[(unit.Class || '').replace(/\s+/g, '') + (unit.Gender || '')] : null;
    const arch = classBase ? $629a788c435ae8d9$export$30e95d823b49cf52(classBase, false) : null;
    const range = $629a788c435ae8d9$var$liftRange(rosterStats, unit && unit.Class, unit && unit.Gender, typeWR, arch);
    // Human letter: prefer the realized-lift percentile (see LIFT_KNOTS) when the
    // precomputed distribution for this class+gender is available AND the unit was
    // graded with gameData (so the lift is on the same scale). Otherwise the range
    // fallback. Monsters always use the (achievable) range — their letters already
    // spread fine on the fitted B/F trend.
    const cgKey = !isMonster && unit && unit.Class && unit.Gender ? unit.Class + ' ' + unit.Gender : null;
    const gq = rosterStats && rosterStats.gradeQuantiles && rosterStats.gradeQuantiles.keys;
    const knots = cs && cgKey && gq && gq[cgKey];
    const percentile = knots ? $629a788c435ae8d9$export$35ed890b75c4f7b0(knots, lift) : null;
    const grade = percentile != null ? $629a788c435ae8d9$export$50ef99fb386df8fb(percentile) : $629a788c435ae8d9$var$letterFor(lift, range);
    return {
        typeWR: +typeWR.toFixed(1),
        color: $629a788c435ae8d9$var$colorFor(typeWR),
        specimenLift: +lift.toFixed(1),
        grade: grade,
        score: +Math.max(0, Math.min(100, typeWR + lift)).toFixed(1),
        parts: parts,
        range: range,
        ...percentile != null ? {
            percentile: +percentile.toFixed(3)
        } : {}
    };
}
// Team grade = mean of the units' absolute (expected-win-rate) scores, with a
// letter on that mean (teams cluster ~48-53, so the bands are tight) and a
// color tier from the same mean.
const $629a788c435ae8d9$var$TEAM_LETTERS = [
    [
        54,
        'A+'
    ],
    [
        53,
        'A'
    ],
    [
        52,
        'B+'
    ],
    [
        51,
        'B'
    ],
    [
        50,
        'C+'
    ],
    [
        49,
        'C'
    ],
    [
        48,
        'D'
    ],
    [
        46,
        'E'
    ],
    [
        0,
        'F'
    ]
];
const $629a788c435ae8d9$var$teamLetterFor = (s)=>($629a788c435ae8d9$var$TEAM_LETTERS.find(([t])=>s >= t) || [
        0,
        'F'
    ])[1];
function $629a788c435ae8d9$export$f99ae8ae029725dc(units, rosterStats, gameData) {
    const unitGrades = (units || []).map((u)=>({
            name: u.Name,
            cls: u.Class,
            ...$629a788c435ae8d9$export$6beeeb6cf4d93b78(u, rosterStats, gameData)
        }));
    const score = unitGrades.length ? +(unitGrades.reduce((s, g)=>s + g.score, 0) / unitGrades.length).toFixed(1) : 50;
    return {
        score: score,
        color: $629a788c435ae8d9$var$colorFor(score),
        grade: $629a788c435ae8d9$var$teamLetterFor(score),
        units: unitGrades
    };
}
function $629a788c435ae8d9$export$cf70aa8abe420919(parts, n = 2) {
    const nz = [
        ...parts || []
    ].filter((p)=>p.contribution).sort((a, b)=>b.contribution - a.contribution);
    const up = nz.filter((p)=>p.contribution > 0).slice(0, n);
    const down = nz.filter((p)=>p.contribution < 0).slice(-n).reverse();
    return {
        up: up,
        down: down,
        more: nz.length - up.length - down.length
    };
}

});
parcelRegister("9rruk", function(module, exports) {

$parcel$export(module.exports, "unitCombatStats", () => $6dfbf543417e1b3a$export$4984048d0fd3f2b0);
// Compute a unit's combat stats from the shared API dictionaries — the same
// derivation InlineUnit/HoverUnit do via computeds, as a pure function so the
// fight view can compute stats for any unit.
//
// charStats, itemschanged, notAbles.movementSkills are the safeDict-wrapped
// lookups built in Luxstadio (missing keys return zero-filled defaults).
function $6dfbf543417e1b3a$export$4984048d0fd3f2b0(unit, charStats, itemschanged, notAbles) {
    const classKey = (unit.Class || '').replace(/\s+/g, '') + (unit.Gender || '');
    const classBase = charStats[classKey];
    const equipped = {
        Mainhand: itemschanged[unit.Mainhand],
        Offhand: itemschanged[unit.Offhand],
        Head: itemschanged[unit.Head],
        Armor: itemschanged[unit.Armor],
        Accessory: itemschanged[unit.Accessory]
    };
    const sum = (k)=>equipped.Mainhand[k] + equipped.Offhand[k] + equipped.Head[k] + equipped.Armor[k] + equipped.Accessory[k];
    const moveSkill = notAbles.movementSkills[unit.MoveSkill];
    const stats = {
        hp: classBase.hp + sum('hp'),
        mp: classBase.mp + sum('mp'),
        pa: classBase.pa + sum('pa'),
        ma: classBase.ma + sum('ma'),
        speed: classBase.speed + sum('speed'),
        move: classBase.move + sum('move') + moveSkill.move,
        jump: classBase.jump + sum('jump') + moveSkill.jump
    };
    const paUnarmed = classBase.pa + equipped.Head.pa + equipped.Armor.pa + equipped.Accessory.pa;
    return {
        classBase: classBase,
        equipped: equipped,
        stats: stats,
        paUnarmed: paUnarmed
    };
}

});

parcelRegister("gEKSn", function(module, exports) {

$parcel$export(module.exports, "unitSwingDamage", () => $c204be6024daa8a6$export$52e1d0b39f2319a3);
$parcel$export(module.exports, "swingBucket", () => $c204be6024daa8a6$export$cb4b48b53f6244fa);
// "Swing damage" — a unit's estimated basic-attack burst in a single turn.
//
// The grade scores damage potential only via the WP-blind StatPA/StatMA buckets
// and the stat-blind global weapon win rate, so the stat×weapon interaction
// (a high-MA Oracle swinging an MA×WP Pole, doubled across a Dual-Wield pair)
// falls through the cracks. This distills the actual swing into one number so an
// empirical win-rate-by-swing dimension can capture it. Pure + data-injected,
// shared by tools/buildRosterStats.mjs (the backfill) and lib/unitGrade.js so
// the bucketing is identical on both sides.
//
// Validated full-history (tools/swingDamageProbe.mjs): the win rate climbs
// monotonically with swing and stays a +12–18pt separator at FIXED PA, so it's
// real signal the StatPA bucket misses — not a restatement of PA.

var $9rruk = parcelRequire("9rruk");

var $eQqwh = parcelRequire("eQqwh");
function $c204be6024daa8a6$export$7e6d4b0387db4d7a(d) {
    if (d == null) return null;
    if (typeof d === 'number') return d;
    const s = String(d);
    const pct = [
        ...s.matchAll(/(\d+)%\s*\((\d+)\)/g)
    ];
    if (pct.length) return pct.reduce((a, [, p, v])=>a + +p / 100 * +v, 0); // magical gun: probability-weighted
    const rng = s.match(/^(\d+)\s*-\s*(\d+)$/);
    if (rng) return (+rng[1] + +rng[2]) / 2; // axe/bag/flail random range
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : null;
}
function $c204be6024daa8a6$export$52e1d0b39f2319a3(unit, charStats, itemschanged, notAbles, combat) {
    if (!unit || unit.Gender === 'Monster') return null;
    const c = combat || (0, $9rruk.unitCombatStats)(unit, charStats, itemschanged, notAbles);
    const { stats: stats, paUnarmed: paUnarmed, equipped: equipped, classBase: classBase } = c;
    const isMartialArts = unit.SupportSkill === 'Martial Arts' || unit.Class === 'Monk';
    const ctx = {
        pa: stats.pa,
        ma: stats.ma,
        speed: stats.speed,
        brave: unit.Brave || 0,
        faith: unit.Faith || 0
    };
    const punch = ()=>$c204be6024daa8a6$export$7e6d4b0387db4d7a((0, $eQqwh.unarmedDamage)({
            paUnarmed: paUnarmed,
            brave: ctx.brave,
            isMartialArts: isMartialArts
        }));
    const swingOf = (item, doublehand)=>{
        if (!item || !item.type) return null;
        return $c204be6024daa8a6$export$7e6d4b0387db4d7a((0, $eQqwh.weaponDamage)({
            item: item,
            ...ctx,
            doublehand: doublehand,
            targetFaith: 100
        }));
    };
    // Dual Wield — support OR innate (Ninja). The API spells out the rule on the
    // skill itself: "attacking once with each (or both fists if unarmed)". So an
    // UNARMED dual-wielder throws TWO punches (~2× a single fist); an armed one
    // adds the offhand weapon's swing (a lone weapon + empty hand stays single).
    const dualWield = unit.SupportSkill === 'Dual Wield' || (classBase && classBase.innates || []).some((i)=>i && i.name === 'Dual Wield');
    const mainWeapon = swingOf(equipped.Mainhand, unit.SupportSkill === 'Doublehand');
    let main, off;
    if (mainWeapon == null) {
        const p = punch();
        main = p;
        off = dualWield ? p : 0; // both fists for a dual-wielder
    } else {
        main = mainWeapon;
        off = swingOf(equipped.Offhand, false) || 0; // shield/relic/empty → no second swing
    }
    const total = (main || 0) + off;
    return total > 0 ? total : null;
}
function $c204be6024daa8a6$export$cb4b48b53f6244fa(v) {
    if (v == null) return null;
    if (v >= 350) return '350+';
    const lo = Math.floor(v / 50) * 50;
    return lo < 50 ? '<50' : `${lo}-${lo + 49}`;
}

});


parcelRegister("jW5bt", function(module, exports) {

$parcel$export(module.exports, "wrColor", () => $e83774899e10d716$export$705cb5ff49c1235b);
$parcel$export(module.exports, "wrTitle", () => $e83774899e10d716$export$3804f49ec1a20582);
$parcel$export(module.exports, "wrStatColor", () => $e83774899e10d716$export$16a4e0aa3788763f);
$parcel$export(module.exports, "wrMonsterBFColor", () => $e83774899e10d716$export$835b18a8debffcb1);
// Data-driven win-rate highlighting for skills and gear.
// Builds lookups from rosterStats on first use; components call
// wrColor(dim, value) to get a green/red text color (or null for neutral).

var $koMQO = parcelRequire("koMQO");

var $8sRxE = parcelRequire("8sRxE");
// Built on first use, not at import: rosterStats arrives from S3 after this module
// loads (lib/preload.js), though always before anything can render and call in.
let $e83774899e10d716$var$tabs = null;
function $e83774899e10d716$var$t() {
    if (!$e83774899e10d716$var$tabs) {
        const lookup = new Map();
        for (const [dim, entries] of Object.entries((0, $koMQO.rosterStats).dims || {})){
            const m = new Map();
            for (const e of entries)m.set(e.value, e.winRate);
            lookup.set(dim, m);
        }
        $e83774899e10d716$var$tabs = {
            lookup: lookup,
            cross: (0, $koMQO.rosterStats).crossByClass || {},
            cond: (0, $koMQO.rosterStats).conditional || {},
            monsterBF: (0, $koMQO.rosterStats).monsterBF || {}
        };
    }
    return $e83774899e10d716$var$tabs;
}
const $e83774899e10d716$var$DEAD_ZONE = 1.5;
function $e83774899e10d716$var$intensityColor(delta) {
    const abs = Math.abs(delta);
    if (abs < $e83774899e10d716$var$DEAD_ZONE) return null;
    const t = Math.min((abs - $e83774899e10d716$var$DEAD_ZONE) / 8, 1);
    const hue = delta > 0 ? 130 : 0;
    const sat = 40 + t * 50;
    const lit = 65 - t * 15;
    return `hsl(${hue}, ${sat}%, ${lit}%)`;
}
// Look up the class+gender baseline win rate (for class-relative comparisons).
function $e83774899e10d716$var$classBaseline(cls, gender) {
    if (!cls) return 50;
    const cg = gender && gender !== 'Monster' ? `${cls} ${gender}` : cls;
    const m = $e83774899e10d716$var$t().lookup.get('ClassGender');
    if (m) {
        const wr = m.get(cg);
        if (wr != null) return wr;
    }
    const mc = $e83774899e10d716$var$t().lookup.get('Class');
    if (mc) {
        const wr = mc.get(cls);
        if (wr != null) return wr;
    }
    return 50;
}
// Look up win rate: tries gendered cross-tab → plain class cross-tab → flat dims.
function $e83774899e10d716$var$resolveWR(dim, value, cls, gender) {
    const { cross: cross, lookup: lookup } = $e83774899e10d716$var$t();
    if (cls) {
        const cv = cross[dim] && cross[dim][value];
        if (cv) {
            if (gender && gender !== 'Monster') {
                const hit = cv.find((x)=>x.value === cls + ' ' + gender);
                if (hit) return hit.winRate;
            }
            const hit = cv.find((x)=>x.value === cls);
            if (hit) return hit.winRate;
        }
    }
    const m = lookup.get(dim);
    return m ? m.get(value) ?? null : null;
}
function $e83774899e10d716$export$705cb5ff49c1235b(dim, value, cls, gender) {
    if (!value) return null;
    const wr = $e83774899e10d716$var$resolveWR(dim, value, cls, gender);
    if (wr == null) return null;
    // Abilities are compared to the CLASS baseline, not 50% — otherwise every
    // ability on a good class glows green (a 54% ability on a 53% Wizard is
    // barely above average for that class, not a +4pp standout).
    const base = dim === 'Ability' ? $e83774899e10d716$var$classBaseline(cls, gender) : 50;
    return $e83774899e10d716$var$intensityColor(wr - base);
}
function $e83774899e10d716$export$3804f49ec1a20582(dim, value, cls, gender) {
    if (!value) return null;
    const wr = $e83774899e10d716$var$resolveWR(dim, value, cls, gender);
    if (wr == null) return null;
    if (dim === 'Ability') {
        const base = $e83774899e10d716$var$classBaseline(cls, gender);
        const delta = wr - base;
        return `${wr.toFixed(1)}% win rate (${delta >= 0 ? '+' : ''}${delta.toFixed(1)}pp vs ${cls} baseline)`;
    }
    return `${wr.toFixed(1)}% win rate`;
}
// Archetype-conditional stat lookup (StatPA, StatMA, StatSpeed, StatHP,
// Brave, Faith). Uses rosterStats.conditional[dim][arch] which is bucketed.
// Resolve the bucket win rate the SAME way unitGrade.js's condWR does: try the
// class+gender table first (e.g. "Oracle Female"), fall back to the archetype
// pool (e.g. "melee"). The stat-block color MUST use this — comparing an
// archetype-pooled win rate against the class+gender baseline (grade.typeWR)
// flips the sign for classes weaker than their archetype average, rendering a
// below-class stat green (the long-standing "low Brave shows green" bug).
function $e83774899e10d716$var$condStatWR(dim, arch, bucket, clsGender) {
    const c = $e83774899e10d716$var$t().cond[dim];
    if (!c) return null;
    if (clsGender && c[clsGender]) {
        const hit = c[clsGender].find((x)=>x.value === bucket);
        if (hit) return hit.winRate;
    }
    const a = c[arch];
    if (!a) return null;
    const hit = a.find((x)=>x.value === bucket);
    return hit ? hit.winRate : null;
}
function $e83774899e10d716$export$16a4e0aa3788763f(dim, arch, bucket, baseline, clsGender) {
    if (!bucket || !arch) return null;
    const wr = $e83774899e10d716$var$condStatWR(dim, arch, bucket, clsGender);
    if (wr == null) return null;
    return $e83774899e10d716$var$intensityColor(wr - (baseline ?? 50));
}
function $e83774899e10d716$export$16017eca0fa9c3ed(dim, arch, bucket, baseline, clsGender) {
    if (!bucket || !arch) return null;
    const wr = $e83774899e10d716$var$condStatWR(dim, arch, bucket, clsGender);
    if (wr == null) return null;
    return `${wr.toFixed(1)}% win rate (${clsGender || arch})`;
}
// MONSTER Brave/Faith color. Monsters must NOT use the conditional-stat path
// above: their only conditional bucket is the ALL-MONSTERS-POOLED archetype key,
// so comparing that pooled win rate against a strong monster's own high baseline
// (grade.typeWR) paints its Brave/Faith red even where its OWN B/F trend is
// positive — and it disagrees with the grade's +/- (which reads the per-monster
// FITTED trend). Color instead by that same fit (unitGrade.bfFit) at the shown
// B/F value, so the stat color and the grade contribution always agree in sign.
function $e83774899e10d716$var$monsterBFWR(cls, dim, value) {
    const mb = cls && $e83774899e10d716$var$t().monsterBF[cls];
    const fit = (0, $8sRxE.bfFit)(mb && mb[dim === 'Faith' ? 'faith' : 'brave']);
    return fit ? fit.predict(value) : null;
}
function $e83774899e10d716$export$835b18a8debffcb1(cls, dim, value, typeWR) {
    const wr = $e83774899e10d716$var$monsterBFWR(cls, dim, value);
    return wr == null ? null : $e83774899e10d716$var$intensityColor(wr - (typeWR ?? 50));
}
function $e83774899e10d716$export$aa28fcec86472092(cls, dim, value, typeWR) {
    const wr = $e83774899e10d716$var$monsterBFWR(cls, dim, value);
    if (wr == null) return null;
    const d = wr - (typeWR ?? 50);
    return `${wr.toFixed(1)}% win rate (${d >= 0 ? '+' : ''}${d.toFixed(1)}pp vs ${cls || 'type'})`;
}

});


parcelRegister("edXRW", function(module, exports) {

$parcel$export(module.exports, "render", () => $a5b0b856886cf462$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $a5b0b856886cf462$var$_hoisted_1 = {
    class: "hover-card"
};
const $a5b0b856886cf462$var$_hoisted_2 = {
    class: "hc-head"
};
const $a5b0b856886cf462$var$_hoisted_3 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_4 = {
    class: "hc-id"
};
const $a5b0b856886cf462$var$_hoisted_5 = {
    key: 0,
    class: "hc-boss"
};
const $a5b0b856886cf462$var$_hoisted_6 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_7 = {
    class: "hc-class"
};
const $a5b0b856886cf462$var$_hoisted_8 = {
    class: "hc-bf"
};
const $a5b0b856886cf462$var$_hoisted_9 = {
    key: 0,
    class: "hc-compat"
};
const $a5b0b856886cf462$var$_hoisted_10 = {
    class: "hc-compat-label"
};
const $a5b0b856886cf462$var$_hoisted_11 = {
    class: "hc-compat-row"
};
const $a5b0b856886cf462$var$_hoisted_12 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_13 = {
    class: "hc-compat-label"
};
const $a5b0b856886cf462$var$_hoisted_14 = {
    class: "hc-compat-row"
};
const $a5b0b856886cf462$var$_hoisted_15 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_16 = {
    class: "hc-stats"
};
const $a5b0b856886cf462$var$_hoisted_17 = {
    class: "hc-line hc-evade"
};
const $a5b0b856886cf462$var$_hoisted_18 = {
    class: "hc-gear"
};
const $a5b0b856886cf462$var$_hoisted_19 = {
    key: 0,
    class: "hc-dmg"
};
const $a5b0b856886cf462$var$_hoisted_20 = {
    class: "hc-line hc-skills"
};
const $a5b0b856886cf462$var$_hoisted_21 = {
    key: 0
};
const $a5b0b856886cf462$var$_hoisted_22 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_23 = {
    key: 1
};
const $a5b0b856886cf462$var$_hoisted_24 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_25 = {
    key: 2
};
const $a5b0b856886cf462$var$_hoisted_26 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_27 = {
    key: 3
};
const $a5b0b856886cf462$var$_hoisted_28 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_29 = {
    key: 0,
    class: "hc-line hc-notable"
};
const $a5b0b856886cf462$var$_hoisted_30 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_31 = {
    class: "hc-gear"
};
const $a5b0b856886cf462$var$_hoisted_32 = {
    class: "hc-gear-row"
};
const $a5b0b856886cf462$var$_hoisted_33 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_34 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_35 = {
    key: 0,
    class: "hc-dmg"
};
const $a5b0b856886cf462$var$_hoisted_36 = {
    key: 2,
    class: "hc-unarmed"
};
const $a5b0b856886cf462$var$_hoisted_37 = {
    class: "hc-dmg"
};
const $a5b0b856886cf462$var$_hoisted_38 = {
    key: 0,
    class: "hc-gear-row"
};
const $a5b0b856886cf462$var$_hoisted_39 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_40 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_41 = {
    key: 0,
    class: "hc-dmg"
};
const $a5b0b856886cf462$var$_hoisted_42 = {
    key: 1,
    class: "hc-gear-row"
};
const $a5b0b856886cf462$var$_hoisted_43 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_44 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_45 = {
    key: 2,
    class: "hc-gear-row"
};
const $a5b0b856886cf462$var$_hoisted_46 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_47 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_48 = {
    key: 3,
    class: "hc-gear-row"
};
const $a5b0b856886cf462$var$_hoisted_49 = [
    "src",
    "alt"
];
const $a5b0b856886cf462$var$_hoisted_50 = [
    "title"
];
const $a5b0b856886cf462$var$_hoisted_51 = {
    key: 3,
    class: "hc-line hc-affinity"
};
const $a5b0b856886cf462$var$_hoisted_52 = {
    key: 4,
    class: "hc-line hc-status"
};
function $a5b0b856886cf462$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("img", {
                class: "hc-portrait",
                src: $options.portrait($props.members, $props.teamColor),
                alt: $props.members.Class,
                onError: _cache[0] || (_cache[0] = ($event)=>$event.target.style.visibility = 'hidden')
            }, null, 40, $a5b0b856886cf462$var$_hoisted_3),
            (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("div", {
                    class: "hc-name",
                    style: (0, $8POXm.normalizeStyle)($options.nameStyle($props.members.Name))
                }, [
                    $props.members.RaidBoss ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_5, "\u2605 BOSS")) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.members.Name), 1),
                    (0, $TusQn.createElementVNode)("span", {
                        class: (0, $8POXm.normalizeClass)([
                            "grade-badge",
                            'tier-' + $options.grade.color
                        ]),
                        title: $options.grade.color + ' ' + $options.grade.grade + " \u2014 " + $props.members.Class + ' type wins ' + $options.grade.typeWR + '%, this one ' + ($options.grade.specimenLift >= 0 ? '+' : '') + $options.grade.specimenLift
                    }, (0, $8POXm.toDisplayString)($options.grade.grade), 11, $a5b0b856886cf462$var$_hoisted_6)
                ], 4),
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_7, (0, $8POXm.toDisplayString)($props.members.Class) + " \xb7 " + (0, $8POXm.toDisplayString)($props.members.Sign), 1),
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wrS('Brave', $props.members.Brave))
                    }, "Brave " + (0, $8POXm.toDisplayString)($props.members.Brave), 5),
                    _cache[8] || (_cache[8] = (0, $TusQn.createTextVNode)(" \xb7 ", -1)),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wrS('Faith', $props.members.Faith))
                    }, "Faith " + (0, $8POXm.toDisplayString)($props.members.Faith), 5)
                ])
            ])
        ]),
        $options.enemyCompat.length || $options.teamCompat.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_9, [
            $options.enemyCompat.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 0,
                class: "hc-compat-block",
                style: (0, $8POXm.normalizeStyle)($options.blockStyle($props.enemyColor))
            }, [
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_10, "vs " + (0, $8POXm.toDisplayString)($props.enemyColor), 1),
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_11, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.enemyCompat, (c, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 'e' + i,
                            class: "hc-compat-unit"
                        }, [
                            (0, $TusQn.createElementVNode)("img", {
                                src: $options.portrait(c.unit, $props.enemyColor),
                                alt: c.unit.Class,
                                onError: _cache[1] || (_cache[1] = ($event)=>$event.target.style.visibility = 'hidden')
                            }, null, 40, $a5b0b856886cf462$var$_hoisted_12),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)('z-' + c.compat.toLowerCase())
                            }, (0, $8POXm.toDisplayString)(c.compat), 3)
                        ]);
                    }), 128))
                ])
            ], 4)) : (0, $TusQn.createCommentVNode)("", true),
            $options.teamCompat.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 1,
                class: "hc-compat-block",
                style: (0, $8POXm.normalizeStyle)($options.blockStyle($props.teamColor))
            }, [
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_13, (0, $8POXm.toDisplayString)($props.teamColor) + " team", 1),
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_14, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.teamCompat, (c, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 't' + i,
                            class: "hc-compat-unit"
                        }, [
                            (0, $TusQn.createElementVNode)("img", {
                                src: $options.portrait(c.unit, $props.teamColor),
                                alt: c.unit.Class,
                                onError: _cache[2] || (_cache[2] = ($event)=>$event.target.style.visibility = 'hidden')
                            }, null, 40, $a5b0b856886cf462$var$_hoisted_15),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)('z-' + c.compat.toLowerCase())
                            }, (0, $8POXm.toDisplayString)(c.compat), 3)
                        ]);
                    }), 128))
                ])
            ], 4)) : (0, $TusQn.createCommentVNode)("", true)
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("span", {
                style: (0, $8POXm.normalizeStyle)($options.wrS('StatHP', $options.stats.hp))
            }, "HP " + (0, $8POXm.toDisplayString)($options.stats.hp), 5),
            (0, $TusQn.createElementVNode)("span", null, "MP " + (0, $8POXm.toDisplayString)($options.stats.mp), 1),
            (0, $TusQn.createElementVNode)("span", {
                style: (0, $8POXm.normalizeStyle)($options.wrS('StatPA', $options.stats.pa))
            }, "PA " + (0, $8POXm.toDisplayString)($options.stats.pa), 5),
            (0, $TusQn.createElementVNode)("span", {
                style: (0, $8POXm.normalizeStyle)($options.wrS('StatMA', $options.stats.ma))
            }, "MA " + (0, $8POXm.toDisplayString)($options.stats.ma), 5),
            (0, $TusQn.createElementVNode)("span", {
                style: (0, $8POXm.normalizeStyle)($options.wrS('StatSpeed', $options.stats.speed))
            }, "Sp " + (0, $8POXm.toDisplayString)($options.stats.speed), 5),
            (0, $TusQn.createElementVNode)("span", null, "Mv " + (0, $8POXm.toDisplayString)($options.stats.move), 1),
            (0, $TusQn.createElementVNode)("span", null, "Jp " + (0, $8POXm.toDisplayString)($options.stats.jump), 1)
        ]),
        (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_17, " Evade \u2014 F " + (0, $8POXm.toDisplayString)($options.evasion.front) + "% \xb7 S " + (0, $8POXm.toDisplayString)($options.evasion.side) + "% \xb7 B " + (0, $8POXm.toDisplayString)($options.evasion.back) + "% \xb7 Magic " + (0, $8POXm.toDisplayString)($options.evasion.magic) + "% ", 1),
        $props.members.Gender == 'Monster' && $options.monsterAttacks.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 1
        }, [
            _cache[9] || (_cache[9] = (0, $TusQn.createElementVNode)("div", {
                class: "hc-gearlabel"
            }, "Attacks", -1)),
            (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_18, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.monsterAttacks, (a, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: i,
                        class: "hc-gear-row"
                    }, [
                        (0, $TusQn.createElementVNode)("span", null, [
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(a.name), 1),
                            a.dmg ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_19, " (" + (0, $8POXm.toDisplayString)(a.dmg) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128))
            ])
        ], 64)) : (0, $TusQn.createCommentVNode)("", true),
        $props.members.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 2
        }, [
            (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_20, [
                $props.members.ActionSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_21, [
                    _cache[10] || (_cache[10] = (0, $TusQn.createElementVNode)("b", null, "Action:", -1)),
                    _cache[11] || (_cache[11] = (0, $TusQn.createTextVNode)()),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('ActionSkill', $props.members.ActionSkill)),
                        title: $options.wrTip('ActionSkill', $props.members.ActionSkill)
                    }, (0, $8POXm.toDisplayString)($props.members.ActionSkill), 13, $a5b0b856886cf462$var$_hoisted_22)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.ReactionSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_23, [
                    _cache[12] || (_cache[12] = (0, $TusQn.createElementVNode)("b", null, "React:", -1)),
                    _cache[13] || (_cache[13] = (0, $TusQn.createTextVNode)()),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('ReactionSkill', $props.members.ReactionSkill)),
                        title: $options.wrTip('ReactionSkill', $props.members.ReactionSkill)
                    }, (0, $8POXm.toDisplayString)($props.members.ReactionSkill), 13, $a5b0b856886cf462$var$_hoisted_24)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.SupportSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_25, [
                    _cache[14] || (_cache[14] = (0, $TusQn.createElementVNode)("b", null, "Support:", -1)),
                    _cache[15] || (_cache[15] = (0, $TusQn.createTextVNode)()),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('SupportSkill', $props.members.SupportSkill)),
                        title: $options.wrTip('SupportSkill', $props.members.SupportSkill)
                    }, (0, $8POXm.toDisplayString)($props.members.SupportSkill), 13, $a5b0b856886cf462$var$_hoisted_26)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.MoveSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_27, [
                    _cache[16] || (_cache[16] = (0, $TusQn.createElementVNode)("b", null, "Move:", -1)),
                    _cache[17] || (_cache[17] = (0, $TusQn.createTextVNode)()),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('MoveSkill', $props.members.MoveSkill)),
                        title: $options.wrTip('MoveSkill', $props.members.MoveSkill)
                    }, (0, $8POXm.toDisplayString)($props.members.MoveSkill), 13, $a5b0b856886cf462$var$_hoisted_28)
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            $options.notableSkills.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_29, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.notableSkills, (s, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                        key: i,
                        class: "hc-notable-skill"
                    }, [
                        (0, $TusQn.createElementVNode)("span", {
                            class: "hc-pill",
                            style: (0, $8POXm.normalizeStyle)({
                                background: s.tier.pill
                            })
                        }, (0, $8POXm.toDisplayString)(s.roll) + "%", 5),
                        (0, $TusQn.createElementVNode)("span", {
                            style: (0, $8POXm.normalizeStyle)($options.wr('Ability', s.name)),
                            title: $options.wrTip('Ability', s.name)
                        }, (0, $8POXm.toDisplayString)(s.name), 13, $a5b0b856886cf462$var$_hoisted_30)
                    ]);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_31, [
                (0, $TusQn.createElementVNode)("div", $a5b0b856886cf462$var$_hoisted_32, [
                    $props.members.Mainhand ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                        key: 0,
                        class: "hc-gear-icon",
                        src: $options.itemIcon($props.members.Mainhand),
                        alt: $props.members.Mainhand,
                        onError: _cache[3] || (_cache[3] = ($event)=>$event.target.style.visibility = 'hidden')
                    }, null, 40, $a5b0b856886cf462$var$_hoisted_33)) : (0, $TusQn.createCommentVNode)("", true),
                    $props.members.Mainhand ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                        key: 1,
                        style: (0, $8POXm.normalizeStyle)($options.wr('Weapon', $props.members.Mainhand)),
                        title: $options.wrTip('Weapon', $props.members.Mainhand)
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.members.Mainhand), 1),
                        $options.weaponDamage('Mainhand') !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_35, " (" + (0, $8POXm.toDisplayString)($options.weaponDamage('Mainhand')) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 12, $a5b0b856886cf462$var$_hoisted_34)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_36, [
                        _cache[18] || (_cache[18] = (0, $TusQn.createTextVNode)("Unarmed ", -1)),
                        (0, $TusQn.createElementVNode)("span", $a5b0b856886cf462$var$_hoisted_37, "(" + (0, $8POXm.toDisplayString)($options.unarmedDamage()) + ")", 1)
                    ]))
                ]),
                $props.members.Offhand ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_38, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "hc-gear-icon",
                        src: $options.itemIcon($props.members.Offhand),
                        alt: $props.members.Offhand,
                        onError: _cache[4] || (_cache[4] = ($event)=>$event.target.style.visibility = 'hidden')
                    }, null, 40, $a5b0b856886cf462$var$_hoisted_39),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('Weapon', $props.members.Offhand)),
                        title: $options.wrTip('Weapon', $props.members.Offhand)
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.members.Offhand), 1),
                        $options.weaponDamage('Offhand') !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a5b0b856886cf462$var$_hoisted_41, " (" + (0, $8POXm.toDisplayString)($options.weaponDamage('Offhand')) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 12, $a5b0b856886cf462$var$_hoisted_40)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.Head ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_42, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "hc-gear-icon",
                        src: $options.itemIcon($props.members.Head),
                        alt: $props.members.Head,
                        onError: _cache[5] || (_cache[5] = ($event)=>$event.target.style.visibility = 'hidden')
                    }, null, 40, $a5b0b856886cf462$var$_hoisted_43),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('Head', $props.members.Head)),
                        title: $options.wrTip('Head', $props.members.Head)
                    }, (0, $8POXm.toDisplayString)($props.members.Head), 13, $a5b0b856886cf462$var$_hoisted_44)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.Armor ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_45, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "hc-gear-icon",
                        src: $options.itemIcon($props.members.Armor),
                        alt: $props.members.Armor,
                        onError: _cache[6] || (_cache[6] = ($event)=>$event.target.style.visibility = 'hidden')
                    }, null, 40, $a5b0b856886cf462$var$_hoisted_46),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('Armor', $props.members.Armor)),
                        title: $options.wrTip('Armor', $props.members.Armor)
                    }, (0, $8POXm.toDisplayString)($props.members.Armor), 13, $a5b0b856886cf462$var$_hoisted_47)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.members.Accessory ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_48, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "hc-gear-icon",
                        src: $options.itemIcon($props.members.Accessory),
                        alt: $props.members.Accessory,
                        onError: _cache[7] || (_cache[7] = ($event)=>$event.target.style.visibility = 'hidden')
                    }, null, 40, $a5b0b856886cf462$var$_hoisted_49),
                    (0, $TusQn.createElementVNode)("span", {
                        style: (0, $8POXm.normalizeStyle)($options.wr('Accessory', $props.members.Accessory)),
                        title: $options.wrTip('Accessory', $props.members.Accessory)
                    }, (0, $8POXm.toDisplayString)($props.members.Accessory), 13, $a5b0b856886cf462$var$_hoisted_50)
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ], 64)) : (0, $TusQn.createCommentVNode)("", true),
        $options.affinityText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_51, (0, $8POXm.toDisplayString)($options.affinityText), 1)) : (0, $TusQn.createCommentVNode)("", true),
        $options.statusText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a5b0b856886cf462$var$_hoisted_52, (0, $8POXm.toDisplayString)($options.statusText), 1)) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("8iNZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b6c82222babea5$export$2e2bcd8739ae039);
let $60b6c82222babea5$var$NOOP = ()=>{};
var $60b6c82222babea5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3bnHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2514c78e3517e12d$export$2e2bcd8739ae039);
let $2514c78e3517e12d$var$script;



let $2514c78e3517e12d$var$initialize = ()=>{
    $2514c78e3517e12d$var$script = (parcelRequire("f1PEM"));
    if ($2514c78e3517e12d$var$script.__esModule) $2514c78e3517e12d$var$script = $2514c78e3517e12d$var$script.default;
    $2514c78e3517e12d$var$script.render = (parcelRequire("fn3JH")).render;
    (parcelRequire("grzPt")).default($2514c78e3517e12d$var$script);
    $2514c78e3517e12d$var$script.__scopeId = 'data-v-3bc81a';
    $2514c78e3517e12d$var$script.__file = "inlineUnit.vue";
};
$2514c78e3517e12d$var$initialize();
var $2514c78e3517e12d$export$2e2bcd8739ae039 = $2514c78e3517e12d$var$script;

});
parcelRegister("f1PEM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $af0f04f702a5d2bc$export$2e2bcd8739ae039);

var $eQqwh = parcelRequire("eQqwh");

var $7cZwo = parcelRequire("7cZwo");

var $79bVW = parcelRequire("79bVW");

var $ivz6X = parcelRequire("ivz6X");

var $k6EE8 = parcelRequire("k6EE8");

var $ftvub = parcelRequire("ftvub");

var $8Q6Uh = parcelRequire("8Q6Uh");

var $g603l = parcelRequire("g603l");

var $64X3q = parcelRequire("64X3q");

var $koMQO = parcelRequire("koMQO");

var $iNGLd = parcelRequire("iNGLd");

var $ituX7 = parcelRequire("ituX7");

var $8sRxE = parcelRequire("8sRxE");

var $5tAvx = parcelRequire("5tAvx");

var $iziJA = parcelRequire("iziJA");

var $jW5bt = parcelRequire("jW5bt");

var $bTyhe = parcelRequire("bTyhe");
// Item pool for the full-card gear editor (names grouped by equip type).
const $af0f04f702a5d2bc$var$ITEMS = Array.isArray((0, (/*@__PURE__*/$parcel$interopDefault($64X3q)))) ? (0, (/*@__PURE__*/$parcel$interopDefault($64X3q))) : Object.values((0, (/*@__PURE__*/$parcel$interopDefault($64X3q)))).find(Array.isArray);
const $af0f04f702a5d2bc$var$ITEM_BY_TYPE = {};
for (const it of $af0f04f702a5d2bc$var$ITEMS)($af0f04f702a5d2bc$var$ITEM_BY_TYPE[it.type] ||= []).push(it.name);
for (const t of Object.keys($af0f04f702a5d2bc$var$ITEM_BY_TYPE))$af0f04f702a5d2bc$var$ITEM_BY_TYPE[t].sort();
const $af0f04f702a5d2bc$var$ALL_WEAPON_TYPES = [
    ...new Set($af0f04f702a5d2bc$var$ITEMS.filter((i)=>i.slot === 'hand' && i.type !== 'Shield').map((i)=>i.type))
];
const $af0f04f702a5d2bc$var$EQUIP_SKILL_TYPE = {
    'Equip Knife': 'Knife',
    'Equip Sword': 'Sword',
    'Equip Axe': 'Axe',
    'Equip Polearm': 'Polearm',
    'Equip Bow': 'Bow',
    'Equip Gun': 'Gun'
};
// Pretty-print the base damage/heal/hit formula straight from an ability's API
// `info` string (e.g. "Effect: Damage (PA * (WP + 2))" → "PA × (WP + 2)";
// "Hit: Faith(MA + 175)%" → "Faith(MA + 175)%"). Textual only — the per-target
// numbers still run the real engine. Mirrors parseAbilityInfo's clause split so
// it reads the same clause the model does. Returns null if nothing recognizable.
function $af0f04f702a5d2bc$var$formulaText(info) {
    if (!info) return null;
    // Drop a single balanced wrapping paren pair ("(PA * WP)" → "PA * WP") but
    // keep inner grouping ("(PA * (WP + 2))" → "PA * (WP + 2)").
    const stripOuter = (e)=>{
        if (e[0] !== '(' || e[e.length - 1] !== ')') return e;
        let d = 0;
        for(let i = 0; i < e.length; i++){
            if (e[i] === '(') d++;
            else if (e[i] === ')' && --d === 0) return i === e.length - 1 ? e.slice(1, -1) : e;
        }
        return e;
    };
    const pretty = (e)=>stripOuter(e.trim()).replace(/\*/g, "\xd7").replace(/\s+/g, ' ').trim();
    const effect = (info.match(/Effect:\s*(.+)$/) || [])[1] || '';
    // Two-branch equipment conditional (Unyielding Cut): show the common (equipped)
    // branch — parseAbilityInfo also evaluates that branch by default. Handled before
    // the ';'-split so the "If …," strip below doesn't fold both branches together.
    const cond = effect.match(/^If target is equipped[^,]*,\s*Damage\s+(.+?)\.\s+If none is equipped,/);
    if (cond) return pretty(cond[1].trim());
    for (const clause of effect.split(';')){
        const cm = clause.trim().replace(/^If [^,]+,\s*/, '').match(/^(Damage|Heal|HealMP|DamageMP|AbsorbHP|AbsorbMP)\s+(.+?)\.?\s*$/);
        if (cm && !/^\(?\d+\)?%$/.test(cm[2].trim())) return pretty(cm[2].trim());
    }
    const hit = (info.match(/Hit:\s*([^.]+?)%/) || [])[1];
    if (hit) return pretty(hit.split(';').pop().trim()) + '%';
    return null;
}
// The by-type basic-attack formula for a weapon (mirrors damage.js weaponDamage);
// substituteFormula plugs in the unit's stats for the numeric line. Brackets are
// display sugar for the floor()s. Doublehand appends "× 2".
function $af0f04f702a5d2bc$var$weaponFormulaText(item, unit) {
    if (!item || !item.type) return null;
    const dbl = unit.SupportSkill === 'Doublehand' ? " \xd7 2" : '';
    switch(item.type){
        case 'Rod':
        case 'Crossbow':
        case 'Spear':
        case 'Sword':
            return `PA \xd7 WP${dbl}`;
        case 'Pole':
        case 'Staff':
            return `MA \xd7 WP${dbl}`;
        case 'Knight Sword':
        case 'Katana':
            return `[PA \xd7 Brave / 100] \xd7 WP${dbl}`;
        case 'Harp':
        case 'Book':
        case 'Fabric':
            return `[(PA + MA) / 2] \xd7 WP${dbl}`;
        case 'Ninja Blade':
        case 'Knife':
        case 'Bow':
            return `[(PA + Speed) / 2] \xd7 WP${dbl}`;
        case 'Axe':
        case 'Bag':
        case 'Flail':
            return `(1\u{2026}PA) \xd7 WP${dbl}`;
        case 'Gun':
            return item.element ? "Faith(WP \xd7 16)" : "WP \xd7 WP";
        default:
            return null;
    }
}
function $af0f04f702a5d2bc$var$unarmedFormulaText(unit) {
    const ma = unit.SupportSkill === 'Martial Arts' || unit.Class === 'Monk' ? "3/2 \xd7 " : '';
    return `${ma}PA \xd7 [PA \xd7 Brave / 100]`;
}
// A damage ability's status rider, if any ("…; Chance to add Death Sentence." →
// "Death Sentence"; "…Confusion, Death Sentence (Random)" → "Confusion, Death
// Sentence"). The "(Random)" tail and "Chance to knockback" are dropped. Null
// for pure-status spells (they use "Add X" as the effect itself, shown as hit%).
function $af0f04f702a5d2bc$var$riderStatuses(info) {
    if (!info) return null;
    const m = info.match(/Chance to add ([^.;(]+)/);
    return m ? m[1].trim() : null;
}
// Second "actual values" line for a formula: substitute the unit's own stats
// into the symbolic expression, expanding the Faith(X) macro into its % factors.
//   "MA × ((PA + 2) / 2)"  (MA 12, PA 10)          → "12 × ((10 + 2) / 2)"
//   "Faith(MA × 16)"       (Faith 70, tgt 60, MA 12) → "70% × 60% × 12 × 16"
function $af0f04f702a5d2bc$var$substituteFormula(formula, ctx) {
    if (!formula) return null;
    const sub = {
        MaxHP: ctx.maxHp,
        TargetFaith: ctx.targetFaith,
        Speed: ctx.speed,
        Brave: ctx.brave,
        Faith: ctx.faith,
        MA: ctx.ma,
        PA: ctx.pa,
        WP: ctx.wp
    };
    const expanded = formula.replace(/Faith\(([^)]*)\)/g, (_, inner)=>`${ctx.faith}% \xd7 ${ctx.targetFaith}% \xd7 ${inner}`);
    return expanded.replace(/\b(MaxHP|TargetFaith|Speed|Brave|Faith|MA|PA|WP)\b/g, (t)=>sub[t]);
}
// Click-to-pin dismissal: a pinned card tooltip (.hasToolTip.visible) stays open
// until you click OFF it or press Escape. Installed once for the whole app.
function $af0f04f702a5d2bc$var$closeAllPins() {
    document.querySelectorAll('.hasToolTip.visible').forEach((el)=>el.classList.remove('visible'));
}
let $af0f04f702a5d2bc$var$_pinCloserInstalled = false;
function $af0f04f702a5d2bc$var$installPinCloser() {
    if ($af0f04f702a5d2bc$var$_pinCloserInstalled || typeof document === 'undefined') return;
    $af0f04f702a5d2bc$var$_pinCloserInstalled = true;
    // A click that doesn't land on a .hasToolTip row dismisses every pinned tooltip.
    // (Clicks inside a pinned breakdown are @click.stop'd, so they never reach here.)
    document.addEventListener('click', (e)=>{
        if (!(e.target instanceof Element) || !e.target.closest('.hasToolTip')) $af0f04f702a5d2bc$var$closeAllPins();
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') $af0f04f702a5d2bc$var$closeAllPins();
    });
}
var $af0f04f702a5d2bc$export$2e2bcd8739ae039 = {
    components: {
        PlayerHover: $iNGLd.default,
        AbilityBreakdown: $ituX7.default
    },
    emits: [
        'full'
    ],
    props: {
        unit: {},
        itemschanged: {},
        charStats: {},
        notAbles: {},
        toolTips: {},
        teamColor: "",
        classRank: {},
        // Map of ability name -> API `info` string. Drives the parser-first
        // ability-damage formulas (lib/abilityFormula.js); falls back to the
        // legacy switch when an ability isn't recognized.
        abilitiesInfo: {
            type: Object,
            default: ()=>({})
        },
        // Map<lowercase-username, color> from the settings modal's custom
        // highlighted users — when this card's unit matches, the unit-name
        // line picks up that color.
        highlightColors: {
            type: Object,
            default: ()=>new Map()
        },
        // When rendered inside the full-card modal: always show full detail and
        // hide the compact/Full-card toolbar (the modal IS the full view).
        inModal: {
            type: Boolean,
            default: false
        },
        // Start expanded (detailed) rather than compact — fed from the user's
        // "expand cards by default" setting. Per-card toggle still works, and
        // flipping the setting updates already-mounted cards (watch below).
        defaultExpanded: {
            type: Boolean,
            default: false
        },
        showWinRates: {
            type: Boolean,
            default: false
        },
        // Optional opponent / own rosters (arrays of unit objects) — when present,
        // hovering a damaging spell shows per-enemy damage (zodiac-aware) and a
        // heal shows per-ally healing. Fed on the main page from the bracket matchup.
        enemyTeam: {
            type: Array,
            default: ()=>[]
        },
        ownTeam: {
            type: Array,
            default: ()=>[]
        }
    },
    computed: {
        // Empirical quality grade from rosterStats (lib/unitGrade.js) — correlational.
        grade () {
            return (0, $8sRxE.unitGrade)(this.unit, (0, $koMQO.rosterStats), {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles
            });
        },
        gradeTip () {
            return (0, $8sRxE.topParts)(this.grade.parts, 2);
        },
        // Intrinsic astrological profile of this unit's sign — the signs it's
        // Good/Bad against, plus its opposite (Best/Worst). From the FFT compat
        // table; null for Serpentarius / unknown signs (Neutral with everything).
        zodiacProfile () {
            const e = (0, $5tAvx.COMPAT_TABLE)[this.unit.Sign];
            if (!e) return null;
            return {
                good: e.good,
                bad: e.bad,
                opposite: e.opposite
            };
        },
        // Empirical "what to roll for this class" picks (win-rate-ranked Support /
        // Reaction / Move), for the 🎲 dice helper under the portrait. Humans only.
        rollAdvice () {
            if (this.unit.Gender === 'Monster' || !this.unit.Class) return null;
            const a = (0, $iziJA.classAdvice)((0, $koMQO.rosterStats), this.unit.Class, {
                gender: this.unit.Gender
            });
            return a.Support.length || a.Reaction.length || a.Move.length ? a : null;
        },
        // The unit's portrait gif (same logic as the image-holder), reused as the
        // centerpiece of the evasion direction grid.
        portraitSrc () {
            const u = this.unit;
            if (u.Gender === 'Monster') return this.IMG_URL + u.Class + '.gif';
            if (this.teamColor !== 'Champion') return this.IMG_URL + u.Class + u.Gender[0] + '_' + this.teamColor + '.gif';
            return this.IMG_URL + u.Class + u.Gender[0] + '.gif';
        },
        gradeFactors () {
            const parts = this.grade.parts || [];
            if (this.inModal) return [
                ...parts
            ].filter((p)=>p.contribution).sort((a, b)=>Math.abs(b.contribution) - Math.abs(a.contribution));
            const t = (0, $8sRxE.topParts)(parts, 3);
            return [
                ...t.up,
                ...t.down
            ];
        },
        // Full detail shows when the user expanded the card, or always in the modal.
        showDetail () {
            return this.inModal || this.expanded;
        },
        // Hover-card aesthetic: dark team-colored fill + bright team border.
        cardStyle () {
            return {
                background: (0, $ftvub.teamDark)(this.teamColor),
                borderColor: (0, $ftvub.teamBright)(this.teamColor)
            };
        },
        classKey () {
            return (this.unit.Class || '').replace(/\s+/g, '') + (this.unit.Gender || '');
        },
        classBase () {
            return this.charStats[this.classKey];
        },
        // Class Stats record (preferred-arms / legal equip types) for the gear editor.
        classStatsRec () {
            const c = (0, (/*@__PURE__*/$parcel$interopDefault($g603l)))[this.unit.Class];
            const g = (this.unit.Gender || 'Male')[0];
            return c && (c[g] || c.M || c.F) || {};
        },
        // Effective gear: the rolled slots, overridden by the full-card editor.
        // Everything (stats, damage, evasion, elements, status) derives from
        // `equipped`, which reads this — so edits recompute the whole card.
        gear () {
            const u = this.unit || {};
            const o = this.gearOverrides;
            const slot = (k)=>k in o ? o[k] : u[k];
            return {
                Mainhand: slot('Mainhand'),
                Offhand: slot('Offhand'),
                Head: slot('Head'),
                Armor: slot('Armor'),
                Accessory: slot('Accessory')
            };
        },
        gearEdited () {
            return Object.keys(this.gearOverrides).length > 0;
        },
        equipped () {
            // "treat weapon as removed" (disarmed) zeroes the mainhand for ALL derived
            // math — stats, damage, evasion, elements, ability formulas — while the
            // weapon name still shows (struck through) via `gear`. itemschanged[''] is
            // the safeDict zero default, the same path a genuinely weaponless unit hits.
            const mainhand = this.disarmed ? '' : this.gear.Mainhand;
            return {
                Mainhand: this.itemschanged[mainhand],
                Offhand: this.itemschanged[this.gear.Offhand],
                Head: this.itemschanged[this.gear.Head],
                Armor: this.itemschanged[this.gear.Armor],
                Accessory: this.itemschanged[this.gear.Accessory]
            };
        },
        itemBonus () {
            const e = this.equipped;
            const sum = (k)=>e.Mainhand[k] + e.Offhand[k] + e.Head[k] + e.Armor[k] + e.Accessory[k];
            return {
                hp: sum('hp'),
                mp: sum('mp'),
                pa: sum('pa'),
                ma: sum('ma'),
                speed: sum('speed'),
                move: sum('move'),
                jump: sum('jump')
            };
        },
        itemBonusPAUnarmed () {
            const e = this.equipped;
            return e.Head.pa + e.Armor.pa + e.Accessory.pa;
        },
        moveSkillBonus () {
            return this.notAbles.movementSkills[this.unit.MoveSkill];
        },
        // name -> rarity ({tier, roll, ...}) for own-class (primary) skills and
        // the secondary set. null entries (common / unlisted) are skipped.
        classSkillRarity () {
            const m = {};
            for (const a of this.unit.ClassSkills || [])m[a] = (0, $ivz6X.skillRarity)(a, false, (0, (/*@__PURE__*/$parcel$interopDefault($k6EE8))));
            return m;
        },
        extraSkillRarity () {
            const m = {};
            for (const a of this.unit.ExtraSkills || [])m[a] = (0, $ivz6X.skillRarity)(a, true, (0, (/*@__PURE__*/$parcel$interopDefault($k6EE8))));
            return m;
        },
        // The unit's non-common action skills, rarest first — drives the compact
        // summary's rarity pills.
        notableSkills () {
            const out = [];
            for (const a of this.unit.ClassSkills || []){
                const r = this.classSkillRarity[a];
                if (r) out.push({
                    name: a,
                    ...r
                });
            }
            for (const a of this.unit.ExtraSkills || []){
                const r = this.extraSkillRarity[a];
                if (r) out.push({
                    name: a,
                    ...r
                });
            }
            return out.sort((x, y)=>x.roll - y.roll);
        },
        // Evade % (chance to dodge) by direction, via lib/evasion.js.
        evade () {
            const t = {
                equipped: this.equipped,
                cEv: this.classBase && this.classBase.cEvPercent || 0,
                reaction: this.unit.ReactionSkill
            };
            const ev = (opts)=>Math.round(100 - (0, $8Q6Uh.hitChance)(t, opts));
            return {
                physFront: ev({
                    type: 'physical',
                    direction: 'front'
                }),
                physSide: ev({
                    type: 'physical',
                    direction: 'side'
                }),
                physBack: ev({
                    type: 'physical',
                    direction: 'back'
                }),
                magic: ev({
                    type: 'magical'
                })
            };
        },
        // Where the evasion comes from (full-card "from:" line).
        evadeSources () {
            const e = this.equipped, out = [];
            const c = this.classBase && this.classBase.cEvPercent || 0;
            if (c) out.push((this.unit.Class || 'Class') + ' ' + c + '%');
            if (e.Offhand.type === 'Shield' && (e.Offhand.pevade || e.Offhand.mevade)) out.push((e.Offhand.name || 'Shield') + ' ' + Math.max(e.Offhand.pevade, e.Offhand.mevade) + '%');
            if (e.Accessory.pevade || e.Accessory.mevade) out.push((e.Accessory.name || 'Accessory') + ' ' + Math.max(e.Accessory.pevade, e.Accessory.mevade) + '%');
            // Parry dodges with EACH weapon (hitChance counts both), so a dual-wielder lists both.
            const parry = [
                e.Mainhand.wevade,
                e.Offhand.wevade
            ].filter(Boolean);
            if (this.unit.ReactionSkill === 'Parry' && parry.length) out.push('Parry ' + parry.map((w)=>w + '%').join(' + '));
            return out;
        },
        // ability name -> element (from the API info string), for the unit's skills.
        abilityElements () {
            const m = {};
            for (const a of [
                ...this.unit.ClassSkills || [],
                ...this.unit.ExtraSkills || []
            ]){
                const info = this.abilitiesInfo[a];
                const match = info && info.match(/Element:\s*([A-Za-z]+)/);
                if (match) m[a] = match[1];
            }
            return m;
        },
        // Each Strengthen element + the unit's own spells it boosts.
        stats () {
            const c = this.classBase, b = this.itemBonus, m = this.moveSkillBonus;
            return {
                hp: c.hp + b.hp,
                mp: c.mp + b.mp,
                pa: c.pa + b.pa,
                ma: c.ma + b.ma,
                speed: c.speed + b.speed,
                move: c.move + b.move + m.move,
                jump: c.jump + b.jump + m.jump
            };
        },
        paUnarmed () {
            return this.classBase.pa + this.itemBonusPAUnarmed;
        },
        // A monster's INNATE elemental affinities — monsters have no gear, so this
        // is their only source. Read from the LIVE tips (toolTips.Class), whose
        // "Effect: Half X; Weak Y, Z" text is the same format as item info, so
        // parseItemElements handles it. (An old committed jobStats snapshot had this
        // data too but was stale — it claimed Tiamat weak Dark, Hydra half Fire.)
        // null for humans (they get affinities from gear only).
        monsterElements () {
            if (this.unit.Gender !== 'Monster') return null;
            const key = (this.unit.Class || '').replace(/\s+/g, '');
            return (0, $79bVW.parseItemElements)(this.toolTips.Class && this.toolTips.Class[key]);
        },
        // Aggregated elemental affinities: the unit's gear (lib/elements.js) plus, for
        // a monster, its innate affinities merged in.
        elementProfile () {
            const p = (0, $79bVW.unitElementProfile)(this.equipped);
            const mel = this.monsterElements;
            if (mel) for (const k of Object.keys(p))for (const e of mel[k])p[k].add(e);
            return p;
        },
        hasElementAffinity () {
            const p = this.elementProfile;
            return p.absorb.size || p.half.size || p.weak.size || p.strengthen.size || p.cancel.size;
        },
        elementSources () {
            const s = (0, $79bVW.unitElementSources)(this.equipped);
            const mel = this.monsterElements;
            if (mel) for (const k of Object.keys(s))for (const e of mel[k])(s[k][e] || (s[k][e] = [])).push('innate');
            return s;
        },
        // One readable row per elemental affinity: { kind, el, label, good, sources,
        // spells, tip }. Order: strengthen, absorb, cancel, half (good) → weak (bad).
        affinityRows () {
            const p = this.elementProfile, src = this.elementSources, rows = [];
            const from = (kind, el)=>src[kind] && src[kind][el] ? src[kind][el].join(', ') : '';
            const KINDS = [
                [
                    'strengthen',
                    'Strengthens',
                    true,
                    (el)=>`Your ${el} attacks deal \xd71.25 damage.`
                ],
                [
                    'absorb',
                    'Absorbs',
                    true,
                    (el)=>`${el} damage heals this unit instead.`
                ],
                [
                    'cancel',
                    'Cancels',
                    true,
                    (el)=>`${el} damage is nullified (0).`
                ],
                [
                    'half',
                    'Halves',
                    true,
                    (el)=>`${el} damage is halved.`
                ],
                [
                    'weak',
                    'Weak to',
                    false,
                    (el)=>`${el} damage is doubled against this unit.`
                ]
            ];
            for (const [kind, label, good, tipFn] of KINDS)for (const el of [
                ...p[kind]
            ]){
                const sources = from(kind, el);
                const spells = kind === 'strengthen' ? Object.entries(this.abilityElements).filter(([, e])=>e === el).map(([a])=>a) : [];
                rows.push({
                    kind: kind,
                    el: el,
                    label: label,
                    good: good,
                    sources: sources,
                    spells: spells,
                    tip: tipFn(el)
                });
            }
            return rows;
        },
        // Ability names this card renders (both human skill lists + the monster
        // kit), deduped — the key set for the two memoized maps below.
        abilityNames () {
            const u = this.unit || {};
            const monster = this.toolTips.MonsterSkills && this.toolTips.MonsterSkills[u.Class] || [];
            return [
                ...new Set([
                    ...u.ClassSkills || [],
                    ...u.ExtraSkills || [],
                    ...monster
                ])
            ];
        },
        // Memoized inline "(NNN)" value per ability. abilityFormula() was called
        // twice per row in the template and re-ran on every reactive render; funnel
        // it through a computed so it's one eval per ability, cached until a real
        // dep (stats / tuning sliders / gear) changes.
        abilityValues () {
            const m = {};
            for (const a of this.abilityNames)m[a] = this.abilityFormula(a);
            return m;
        },
        // Memoized per-target spell breakdown (the hover popup). targetBreakdown()
        // was called FOUR times per row (v-if, class, label, v-for) — this collapses
        // it to one eval per ability and caches across the slider-drag re-renders.
        abilityBreakdowns () {
            const m = {};
            for (const a of this.abilityNames)m[a] = this.targetBreakdown(a);
            return m;
        },
        // Basic-attack breakdown per weapon slot (the same both-teams treatment as
        // an ability, run over the weapon's attack model). Cached like the ability
        // maps so slider drags don't re-run it.
        weaponBreakdowns () {
            return {
                Mainhand: this.buildWeaponBreakdown('Mainhand'),
                Offhand: this.buildWeaponBreakdown('Offhand'),
                unarmed: this.buildWeaponBreakdown('unarmed')
            };
        }
    },
    mounted () {
        $af0f04f702a5d2bc$var$installPinCloser();
    },
    methods: {
        // Pin/unpin a card tooltip on click. Single-pin: opening one closes any other
        // that's open, so tapping around the card swaps the popup instead of stacking
        // them. Clicking off any tooltip (or Escape) dismisses it — see installPinCloser.
        togglePin (e) {
            const row = e.currentTarget.closest('.hasToolTip');
            if (!row) return;
            const wasOpen = row.classList.contains('visible');
            $af0f04f702a5d2bc$var$closeAllPins();
            if (!wasOpen) row.classList.add('visible');
        },
        // Copy this exact unit into the Character Builder (new tab, so the bracket stays open).
        openInBuilder () {
            if (!this.unit || !this.unit.Name) return; // BuilderView ignores a nameless payload — don't open a blank tab
            const url = window.location.origin + window.location.pathname + '?build&u=' + (0, $bTyhe.encodeBuild)(this.unit, this.unit.Name);
            window.open(url, '_blank', 'noopener');
        },
        wr (dim, value) {
            return this.showWinRates ? {
                color: (0, $jW5bt.wrColor)(dim, value, this.unit.Class, this.unit.Gender)
            } : {};
        },
        wrTip (dim, value) {
            return this.showWinRates ? (0, $jW5bt.wrTitle)(dim, value, this.unit.Class, this.unit.Gender) : '';
        },
        wrS (dim, raw) {
            if (!this.showWinRates) return {};
            const isMonster = this.unit.Gender === 'Monster';
            if (isMonster && dim.startsWith('Stat')) return {};
            if (isMonster && (dim === 'Brave' || dim === 'Faith')) return {
                color: (0, $jW5bt.wrMonsterBFColor)(this.unit.Class, dim, raw, this.grade.typeWR)
            };
            const a = (0, $8sRxE.archetypeOf)(this.classBase, isMonster);
            const b = dim === 'Brave' || dim === 'Faith' ? (0, $8sRxE.bfBucket)(raw) : ((0, $8sRxE.sBucket)[dim.replace('Stat', '')] || (()=>String(raw)))(raw);
            const cg = isMonster ? null : this.unit.Class && this.unit.Gender ? this.unit.Class + ' ' + this.unit.Gender : null;
            return {
                color: (0, $jW5bt.wrStatColor)(dim, a, b, this.grade.typeWR, cg)
            };
        },
        // Click anywhere on a compact card to expand it. No-op once detailed
        // (so inner controls/tooltips keep working) or inside the modal.
        onCardClick () {
            if (!this.showDetail) this.expanded = true;
        },
        signed (d) {
            return (d >= 0 ? '+' : "\u2212") + Math.abs(d).toFixed(1);
        },
        // Color tier for an evade % cell in the direction grid.
        evClass (pct) {
            return pct >= 40 ? 'ev-hi' : pct >= 15 ? 'ev-mid' : pct > 0 ? 'ev-lo' : 'ev-none';
        },
        zodiacToggleTip (z) {
            return ({
                Best: "Opposite sign, opposite gender \u2014 \xd71.5 damage",
                Good: "Compatible sign \u2014 \xd71.25",
                Neutral: 'No zodiac modifier',
                Bad: "Incompatible sign \u2014 \xd70.75",
                Worst: "Opposite sign, same gender \u2014 \xd70.5"
            })[z] || '';
        },
        // --- full-card gear editor ---
        slotLabel (slot) {
            return ({
                Mainhand: 'Weapon',
                Offhand: 'Offhand',
                Head: 'Head',
                Armor: 'Body',
                Accessory: 'Accessory'
            })[slot] || slot;
        },
        setGear (slot, value) {
            this.gearOverrides = {
                ...this.gearOverrides,
                [slot]: value
            };
        },
        resetGear () {
            this.gearOverrides = {};
        },
        // Legal class weapon types (from classStats), expanded by any Equip-X
        // support the unit has; the whole pool when "show all" is on.
        weaponTypes () {
            if (this.showAllItems) return $af0f04f702a5d2bc$var$ALL_WEAPON_TYPES;
            const cs = this.classStatsRec;
            let types = Object.keys(cs.weapons || {});
            const eq = $af0f04f702a5d2bc$var$EQUIP_SKILL_TYPE[this.unit.SupportSkill];
            if (eq && cs.equipArms && cs.equipArms[eq]) types = [
                ...new Set([
                    ...types,
                    ...Object.keys(cs.equipArms[eq])
                ])
            ];
            return types;
        },
        // Grouped item options for a slot: [{ label: type, items: [names] }].
        slotItems (slot) {
            const cs = this.classStatsRec;
            const all = this.showAllItems;
            const hasEquipShield = this.unit.SupportSkill === 'Equip Shield';
            const group = (types)=>types.map((t)=>({
                        label: t,
                        items: $af0f04f702a5d2bc$var$ITEM_BY_TYPE[t] || []
                    })).filter((g)=>g.items.length);
            if (slot === 'Mainhand') {
                const out = group(this.weaponTypes());
                if (hasEquipShield && !all && cs.noWeapons) out.push(...group([
                    'Shield'
                ]));
                return out;
            }
            if (slot === 'Head') return group(all ? [
                'Hat',
                'Helmet'
            ] : cs.heads && cs.heads.length ? cs.heads : [
                'Hat',
                'Helmet'
            ]);
            if (slot === 'Armor') return group(all ? [
                'Clothing',
                'Armor',
                'Robe'
            ] : cs.bodies && cs.bodies.length ? cs.bodies : [
                'Clothing',
                'Robe',
                'Armor'
            ]);
            if (slot === 'Accessory') return group([
                'Accessory'
            ]);
            if (slot === 'Offhand') {
                const out = [];
                if (all || cs.shield || hasEquipShield) out.push(...group([
                    'Shield'
                ]));
                if (all || this.unit.SupportSkill === 'Dual Wield') out.push(...group(this.weaponTypes()));
                return out;
            }
            return [];
        },
        // Style for the unit-name line — picks up the user's custom color
        // for this username (case-insensitively) from highlightColors,
        // returns null otherwise so the default styling applies.
        nameStyle (name) {
            const c = this.highlightColors && this.highlightColors.get((name || '').toLowerCase());
            return c ? {
                color: c,
                fontWeight: 'bold'
            } : null;
        },
        // Thin wrappers over the pure formulas in lib/damage.js. Signatures
        // (slot, paBonus) are preserved so abilityFormula's Charge+N calls work
        // unchanged. targetFaith comes from the on-card slider here.
        weaponDamage (slot, paBonus = 0) {
            return (0, $eQqwh.weaponDamage)({
                item: this.equipped[slot],
                pa: this.stats.pa,
                ma: this.stats.ma,
                speed: this.stats.speed,
                brave: this.braveAdj,
                faith: this.faithAdj,
                doublehand: this.unit.SupportSkill === 'Doublehand',
                targetFaith: this.targetFaith,
                paBonus: paBonus,
                // Apply the unit's attacker supports so the displayed basic-attack
                // number matches the fight view / sim (was raw — Attack Up / Magic
                // Attack Up / Strengthen silently never showed on the card).
                attackUp: this.unit.SupportSkill === 'Attack Up',
                magicAttackUp: this.unit.SupportSkill === 'Magic Attack Up',
                strengthen: this.elementProfile.strengthen
            });
        },
        unarmedDamage (paBonus = 0) {
            return (0, $eQqwh.unarmedDamage)({
                paUnarmed: this.paUnarmed,
                brave: this.braveAdj,
                isMartialArts: this.unit.SupportSkill === 'Martial Arts' || this.unit.Class === 'Monk',
                paBonus: paBonus,
                attackUp: this.unit.SupportSkill === 'Attack Up'
            });
        },
        // Shared assembly for the both-teams ability/weapon breakdown. Given a
        // per-target value function evalTarget(ctx, dMods) → display string, build
        // the { kind, primary, formula, rider, attackerMods, sides } object — BOTH
        // teams, the natural side first, the other side the hypothetical "if it hit
        // them". Abilities pass an abilityVsTarget closure; weapons pass a
        // computeAbilityDamage(model, …) one — same both-teams rows either way.
        assembleBreakdown ({ kind: kind, primary: primary, isDamage: isDamage, element: element, formula: formula, formulaNumbers: formulaNumbers, formulaValue: formulaValue, rider: rider, attackerMods: attackerMods, baseCtx: baseCtx, evalTarget: evalTarget }) {
            const ZFACTOR = {
                Good: "\xd75/4",
                Bad: "\xd73/4",
                Best: "\xd73/2",
                Worst: "\xd71/2"
            };
            const rowFor = (t)=>{
                const generic = !t; // no roster defined → a neutral 60-Faith stand-in
                const compat = generic ? 'Neutral' : (0, $5tAvx.zodiacCompat)(this.unit.Gender, this.unit.Sign, t.Gender, t.Sign);
                const dMods = {
                    zodiac: compat
                };
                let effect = null;
                if (isDamage && !generic) {
                    const prof = this.targetElementProfile(t);
                    dMods.absorb = prof.absorb;
                    dMods.half = prof.half;
                    dMods.weak = prof.weak;
                    dMods.cancel = prof.cancel;
                    if (element) {
                        if (prof.absorb.has(element)) effect = 'absorb';
                        else if (prof.cancel.has(element)) effect = 'cancel';
                        else if (prof.weak.has(element)) effect = 'weak';
                        else if (prof.half.has(element)) effect = 'half';
                    }
                }
                const value = evalTarget({
                    ...baseCtx,
                    targetFaith: generic ? 60 : t.Faith || 60
                }, dMods);
                return {
                    name: generic ? 'any target' : t.Name,
                    portrait: generic ? '' : this.unitPortrait(t),
                    zodiac: compat,
                    zfactor: ZFACTOR[compat] || null,
                    value: value,
                    effect: effect,
                    generic: generic
                };
            };
            const order = primary === 'allies' ? [
                [
                    'allies',
                    this.ownTeam
                ],
                [
                    'enemies',
                    this.enemyTeam
                ]
            ] : [
                [
                    'enemies',
                    this.enemyTeam
                ],
                [
                    'allies',
                    this.ownTeam
                ]
            ];
            const sides = [];
            for (const [key, list] of order){
                let rows = (list || []).filter(Boolean).map(rowFor);
                // No roster on the natural side (Builder / Champions / a team-less modal)
                // → one generic target (60 Faith, neutral) so the base number still shows.
                if (!rows.length && key === primary) rows = [
                    rowFor(null)
                ];
                if (!rows.length) continue;
                sides.push({
                    key: key,
                    label: key === 'enemies' ? "\u2694 enemies" : "\uD83D\uDEE1 your team",
                    hypothetical: key !== primary,
                    kind: kind,
                    rows: rows
                });
            }
            return {
                kind: kind,
                primary: primary,
                formula: formula,
                formulaNumbers: formulaNumbers,
                formulaValue: formulaValue,
                rider: rider,
                attackerMods: attackerMods,
                sides: sides
            };
        },
        // Per-target breakdown for the spell hover popup: for a damaging ability,
        // each enemy with its zodiac-aware damage; for a heal, each ally with the
        // heal amount. Null when the ability isn't a recognized damage/heal/status.
        // Reuses abilityVsTarget (the fight view's per-target entry) so the numbers
        // match the matrix; assembleBreakdown lays out both teams.
        targetBreakdown (abilityRaw) {
            const ability = abilityRaw.replace('*', '');
            const info = this.abilitiesInfo[ability];
            if (!info) return null;
            const baseCtx = {
                ma: this.stats.ma,
                pa: this.stats.pa,
                speed: this.stats.speed,
                brave: this.braveAdj,
                faith: this.faithAdj,
                wp: this.equipped.Mainhand.wp,
                maxHp: this.stats.hp
            };
            // Attacker-side modifiers — the same for every target, so they drive the
            // shared formula section. Applied to the probe too, so probe.steps carries
            // exactly the attacker multipliers that fire for this unit.
            const aMods = {
                strengthen: this.elementProfile.strengthen,
                attackUp: this.unit.SupportSkill === 'Attack Up',
                magicAttackUp: this.unit.SupportSkill === 'Magic Attack Up',
                martialArts: this.unit.SupportSkill === 'Martial Arts' || this.unit.Class === 'Monk'
            };
            const probe = (0, $7cZwo.abilityVsTarget)(info, {
                ...baseCtx,
                targetFaith: 60
            }, aMods);
            if (!probe) return null;
            // Classify the ability's kind + its NATURAL side. A drain (AbsorbHP/MP,
            // DamageMP) is aggressive like damage; Heal/HealMP heals allies; a percent
            // spell is a buff (ally) or an aggressive status (enemy). Since both teams
            // are always listed now, this only decides which side shows FIRST — a
            // misclassification just flips the ordering, never hides a side (the old
            // single-side guess sent ~15 ally cleanses/revives to the enemy list).
            const otherVerb = probe.kind === 'other' ? probe.verb : null;
            const isHeal = otherVerb === 'Heal' || otherVerb === 'HealMP';
            const isDrain = !!otherVerb && !isHeal; // AbsorbHP / AbsorbMP / DamageMP
            const isDamage = probe.kind === 'damage';
            const isPercent = probe.kind === 'percent';
            // A status (percent) ability leads with ALLIES if it ADDS a good status or
            // CANCELS/REMOVES a bad one — so cleanses/revives (Raise, Esuna, Stabilize
            // Time) and buffs default to your team, while dispels (Dispel Magic, Despair
            // — they Cancel GOOD statuses) and Add-bad debuffs stay enemy-first. Same
            // Cancel verb, opposite intent; the STATUS LIST disambiguates. Both teams
            // still show — this only picks which side leads. (Defending/Performing are
            // left out of "good": aggressive adds like Noxious Gas / Gil Taking include
            // them incidentally and must stay enemy-first.)
            const GOOD_STATUS = 'Protect|Shell|Haste|Regen|Reraise|Float|Reflect|Wall|Transparent|Faith';
            const BAD_STATUS = 'Death|Petrify|Darkness|Blind|Confusion|Silence|Poison|Sleep|Frog|Chicken|Stop|Charm|Berserk|Oil|Undead|Slow|Innocent|Blood';
            const isBeneficial = isPercent && (new RegExp(`\\bAdd\\b[^.;]*\\b(?:${GOOD_STATUS})\\b`, 'i').test(info) || new RegExp(`\\b(?:Cancel|Remove)\\b[^.;]*\\b(?:${BAD_STATUS})\\b`, 'i').test(info));
            const kind = isHeal ? 'heal' : isBeneficial ? 'buff' : isDamage || isDrain ? 'damage' : 'status';
            const primary = kind === 'heal' || kind === 'buff' ? 'allies' : 'enemies';
            // Only TRUE damage gets target-affinity effect coloring — the engine only
            // applies weak/half/absorb on the Damage verb (drains stay base).
            const element = isDamage ? probe.element : null;
            // Shared formula section: the base formula text (from the API info) + the
            // attacker multipliers that actually apply to THIS unit (the Damage-verb
            // step chain after "Base").
            const formula = $af0f04f702a5d2bc$var$formulaText(info);
            const formulaNumbers = $af0f04f702a5d2bc$var$substituteFormula(formula, {
                ...baseCtx,
                targetFaith: 60
            });
            // The base result (no attacker/target mods, generic 60 Faith) — the "= N"
            // that closes out the actual-values line.
            const baseRes = (0, $7cZwo.abilityVsTarget)(info, {
                ...baseCtx,
                targetFaith: 60
            }, {});
            const formulaValue = baseRes ? baseRes.display : null;
            const rider = $af0f04f702a5d2bc$var$riderStatuses(info); // "…Chance to add <status>" on a damage hit
            const attackerMods = isDamage ? (probe.steps || []).slice(1).map((s)=>({
                    label: s.label === 'Strengthen' && element ? `Strengthen ${element}` : s.label,
                    factor: s.factor
                })) : [];
            return this.assembleBreakdown({
                kind: kind,
                primary: primary,
                isDamage: isDamage,
                element: element,
                formula: formula,
                formulaNumbers: formulaNumbers,
                formulaValue: formulaValue,
                rider: rider,
                attackerMods: attackerMods,
                baseCtx: baseCtx,
                evalTarget: (ctx, dMods)=>{
                    const r = (0, $7cZwo.abilityVsTarget)(info, ctx, {
                        ...aMods,
                        ...dMods
                    });
                    return r ? r.display : "\u2014";
                }
            });
        },
        // Basic-attack breakdown for a weapon slot — the weapon's attack model run
        // through the SAME both-teams pipeline as an ability (computeAbilityDamage
        // per target). Mainhand with no weapon / disarmed falls back to unarmed; an
        // empty Offhand yields nothing. Monsters attack with their kit, not gear.
        buildWeaponBreakdown (slot) {
            if (this.unit.Gender === 'Monster') return null;
            const forceUnarmed = slot === 'unarmed'; // the standalone bare-hands row
            const item = forceUnarmed ? null : this.equipped[slot];
            let model = item && item.type ? (0, $eQqwh.weaponAttackModel)(item, this.unit) : null;
            let formula, rider, wp, isUnarmed = false;
            if (model) {
                formula = $af0f04f702a5d2bc$var$weaponFormulaText(item, this.unit);
                rider = $af0f04f702a5d2bc$var$riderStatuses(item.info);
                wp = item.wp;
            } else if (forceUnarmed || slot === 'Mainhand') {
                model = (0, $eQqwh.unarmedAttackModel)(this.unit); // no weapon / disarmed → bare hands
                formula = $af0f04f702a5d2bc$var$unarmedFormulaText(this.unit);
                rider = null;
                wp = 0;
                isUnarmed = true;
            } else return null;
            const baseCtx = {
                // Bare hands scale off paUnarmed (class base + non-weapon PA), so the
                // numeric line substitutes that for PA rather than the weapon-inclusive stat.
                ma: this.stats.ma,
                pa: isUnarmed ? this.paUnarmed : this.stats.pa,
                speed: this.stats.speed,
                brave: this.braveAdj,
                faith: this.faithAdj,
                wp: wp,
                maxHp: this.stats.hp,
                paUnarmed: this.paUnarmed
            };
            const aMods = {
                strengthen: this.elementProfile.strengthen,
                attackUp: this.unit.SupportSkill === 'Attack Up',
                magicAttackUp: this.unit.SupportSkill === 'Magic Attack Up',
                martialArts: this.unit.SupportSkill === 'Martial Arts' || this.unit.Class === 'Monk'
            };
            const element = model.element || null;
            const attackerMods = ((0, $7cZwo.computeAbilityDamage)(model, {
                ...baseCtx,
                targetFaith: 60
            }, aMods).steps || []).slice(1).map((s)=>({
                    label: s.label === 'Strengthen' && element ? `Strengthen ${element}` : s.label,
                    factor: s.factor
                }));
            const formulaNumbers = $af0f04f702a5d2bc$var$substituteFormula(formula, {
                ...baseCtx,
                targetFaith: 60
            });
            const fmt = (f)=>Array.isArray(f) ? `${f[0]} - ${f[1]}` : `${f}`;
            const formulaValue = fmt((0, $7cZwo.computeAbilityDamage)(model, {
                ...baseCtx,
                targetFaith: 60
            }, {}).final);
            return this.assembleBreakdown({
                kind: 'damage',
                primary: 'enemies',
                isDamage: true,
                element: element,
                formula: formula,
                formulaNumbers: formulaNumbers,
                formulaValue: formulaValue,
                rider: rider,
                attackerMods: attackerMods,
                baseCtx: baseCtx,
                evalTarget: (ctx, dMods)=>fmt((0, $7cZwo.computeAbilityDamage)(model, ctx, {
                        ...aMods,
                        ...dMods
                    }).final)
            });
        },
        // Elemental affinity (absorb/half/weak/strengthen/cancel sets) for an
        // arbitrary opposing unit, from its equipped gear. Monsters have no gear →
        // empty sets. Used to make the per-target spell breakdown element-aware.
        targetElementProfile (u) {
            const p = (0, $79bVW.unitElementProfile)({
                Mainhand: this.itemschanged[u.Mainhand],
                Offhand: this.itemschanged[u.Offhand],
                Head: this.itemschanged[u.Head],
                Armor: this.itemschanged[u.Armor],
                Accessory: this.itemschanged[u.Accessory]
            });
            // A monster target has no gear but does have innate affinities (Hydra is
            // weak to Ice/Wind) — merge them in, from the live tips (see monsterElements).
            if (u.Gender === 'Monster') {
                const key = (u.Class || '').replace(/\s+/g, '');
                const mel = (0, $79bVW.parseItemElements)(this.toolTips.Class && this.toolTips.Class[key]);
                for (const k of Object.keys(p))for (const e of mel[k])p[k].add(e);
            }
            return p;
        },
        // Portrait gif for an arbitrary unit (team-less; uses palette-less sprite).
        unitPortrait (u) {
            if (!u || !u.Class) return '';
            if (u.Gender === 'Monster') return this.IMG_URL + u.Class + '.gif';
            return this.IMG_URL + u.Class + (u.Gender ? u.Gender[0] : 'M') + '.gif';
        },
        abilityFormula (ability) {
            ability = ability.replace("*", "");
            // Charge+N: same weapon-by-type damage as a basic attack, but with
            // +N PA. Collapses what were eight near-identical 50-line switch cases.
            const charge = ability.match(/^Charge\+(\d+)$/);
            if (charge) {
                const n = +charge[1];
                return this.weaponDamage('Mainhand', n) ?? this.unarmedDamage(n);
            }
            // Parser-first: derive the formula from the abilities API `info`
            // (lib/abilityFormula.js). Returns '' for abilities it doesn't
            // recognize, in which case we fall through to the legacy switch below.
            const info = this.abilitiesInfo[ability];
            if (info) {
                const parsed = (0, $7cZwo.abilityDisplay)(info, {
                    ma: this.stats.ma,
                    pa: this.stats.pa,
                    speed: this.stats.speed,
                    brave: this.braveAdj,
                    faith: this.faithAdj,
                    targetFaith: this.targetFaith,
                    wp: this.equipped.Mainhand.wp,
                    maxHp: this.stats.hp
                }, {
                    // Attacker-only modifiers (correct regardless of target): the unit's
                    // elemental Strengthen, plus Attack UP / Magic Attack UP supports.
                    strengthen: this.elementProfile.strengthen,
                    attackUp: this.unit.SupportSkill === 'Attack Up',
                    magicAttackUp: this.unit.SupportSkill === 'Magic Attack Up',
                    // Martial Arts (support, or Monk innate) → ×3/2 on Punch Art skills.
                    martialArts: this.unit.SupportSkill === 'Martial Arts' || this.unit.Class === 'Monk',
                    // Hypothetical target zodiac compatibility (the tuning toggle).
                    zodiac: this.zodiacAdj
                });
                if (parsed) return parsed;
            }
            // Legacy fallback for forms the parser can't express yet — Jump, the
            // punch-art break skills, monster weapon skills, songs (lib/abilityFormula.js).
            // Reads `equipped`, so "treat weapon as removed" affects these too.
            const legacy = (0, $7cZwo.legacyAbilityFormula)(ability, {
                pa: this.stats.pa,
                ma: this.stats.ma,
                brave: this.braveAdj,
                faith: this.faithAdj,
                targetFaith: this.targetFaith,
                wp: this.equipped.Mainhand.wp,
                weaponType: this.equipped.Mainhand.type,
                paUnarmed: this.paUnarmed
            });
            return legacy ? legacy.display : '';
        }
    },
    data () {
        return {
            // Compact by default (short, screenshot-friendly); click to expand —
            // unless the "expand cards by default" setting seeds it open.
            expanded: this.defaultExpanded,
            // Damage-tuning panel (sliders + disarm), collapsed within the detail view.
            showTuning: false,
            // Treat the weapon as removed — reveals/uses the unarmed attack.
            disarmed: false,
            // Full-card gear editor: per-slot overrides ({} = use the rolled gear),
            // and the edit/sandbox toggles. Local + discarded when the modal closes.
            gearOverrides: {},
            editGear: false,
            showAllItems: false,
            // Local Brave/Faith used by the damage math, seeded from the unit so the
            // sliders let you see how B/F swings spell/ability numbers. (Avoid the
            // literal `unit.Brave/Faith` form here — it's threaded into the formulas.)
            braveAdj: (this.unit || {}).Brave || 70,
            faithAdj: (this.unit || {}).Faith || 70,
            // Local target-faith slider state. Initialized from the prop (if the
            // upstream API ever provides one) with a 60 fallback.
            targetFaith: this.unit && this.unit.targetFaith || 60,
            // Hypothetical zodiac compatibility vs the target, for the damage preview.
            // 'Neutral' by default; the tuning toggles set Best/Good/Bad/Worst.
            zodiacAdj: 'Neutral',
            IMG_URL: "https://luxor-fftbg-assets.s3.amazonaws.com/units/",
            IMG_URL_ITEMS: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/"
        };
    },
    watch: {
        // Flip already-mounted cards when the "expand by default" setting changes.
        defaultExpanded (v) {
            this.expanded = v;
        },
        // Re-seed the tuning sliders when the rendered unit changes (live poll
        // roster updates, or the generator re-rolling into the same component).
        unit () {
            this.braveAdj = (this.unit || {}).Brave || 70;
            this.faithAdj = (this.unit || {}).Faith || 70;
            this.disarmed = false;
            this.zodiacAdj = 'Neutral';
            this.gearOverrides = {};
            this.editGear = false;
        }
    }
};

});
parcelRegister("g603l", function(module, exports) {
module.exports = JSON.parse("{\"Squire\":{\"M\":{\"hp\":183,\"mp\":55,\"pa\":9,\"ma\":7,\"speed\":9,\"move\":4,\"jump\":3,\"cEv\":8,\"innate\":[\"Basic Skill\"],\"weapons\":{\"Sword\":40,\"Crossbow\":25,\"Axe\":18,\"Flail\":18},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\",\"Armor\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Katana\":37,\"Knight Sword\":35,\"Sword\":29},\"Axe\":{\"Staff\":46,\"Axe\":27,\"Flail\":27},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Gun\":47,\"Book\":39,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":171,\"mp\":59,\"pa\":7,\"ma\":9,\"speed\":9,\"move\":4,\"jump\":3,\"cEv\":8,\"innate\":[\"Basic Skill\"],\"weapons\":{\"Sword\":40,\"Crossbow\":25,\"Axe\":18,\"Flail\":18},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\",\"Armor\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Katana\":37,\"Knight Sword\":35,\"Sword\":29},\"Axe\":{\"Staff\":46,\"Axe\":27,\"Flail\":27},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Gun\":47,\"Book\":39,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Chemist\":{\"M\":{\"hp\":165,\"mp\":46,\"pa\":7,\"ma\":7,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":12,\"innate\":[\"Item\",\"Throw Item\"],\"weapons\":{\"Bag\":50,\"Knife\":25,\"Gun\":25,\"Sword\":1},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Rod\":36,\"Knife\":29},\"Sword\":{\"Katana\":38,\"Sword\":35,\"Knight Sword\":26},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Book\":43,\"Gun\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":154,\"mp\":49,\"pa\":6,\"ma\":8,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":12,\"innate\":[\"Item\",\"Throw Item\"],\"weapons\":{\"Bag\":50,\"Knife\":25,\"Gun\":25,\"Sword\":1},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Rod\":36,\"Knife\":29},\"Sword\":{\"Katana\":38,\"Sword\":35,\"Knight Sword\":26},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Book\":43,\"Gun\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Knight\":{\"M\":{\"hp\":202,\"mp\":42,\"pa\":12,\"ma\":6,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":14,\"innate\":[\"Battle Skill\",\"Equip Shield\"],\"weapons\":{\"Knight Sword\":38,\"Sword\":42,\"Axe\":20},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Katana\":44,\"Sword\":32,\"Knight Sword\":23},\"Axe\":{\"Flail\":43,\"Axe\":29,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"PreferredArms will force a Knight Sword if no equip skill is rolled.\",\"preferredArmsForce\":\"Knight Sword\"},\"F\":{\"hp\":189,\"mp\":45,\"pa\":10,\"ma\":7,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":14,\"innate\":[\"Battle Skill\",\"Equip Shield\"],\"weapons\":{\"Knight Sword\":38,\"Sword\":42,\"Axe\":20},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Katana\":44,\"Sword\":32,\"Knight Sword\":23},\"Axe\":{\"Flail\":43,\"Axe\":29,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"PreferredArms will force a Knight Sword if no equip skill is rolled.\",\"preferredArmsForce\":\"Knight Sword\"}},\"Archer\":{\"M\":{\"hp\":170,\"mp\":38,\"pa\":11,\"ma\":6,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":16,\"innate\":[\"Charge\"],\"weapons\":{\"Bow\":40,\"Crossbow\":40,\"Gun\":20},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":43,\"Crossbow\":43,\"Bag\":14},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"PreferredArms will force a Bow if no equip skill is rolled.\",\"preferredArmsForce\":\"Bow\"},\"F\":{\"hp\":159,\"mp\":41,\"pa\":9,\"ma\":8,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":16,\"innate\":[\"Charge\"],\"weapons\":{\"Bow\":40,\"Crossbow\":40,\"Gun\":20},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":43,\"Crossbow\":43,\"Bag\":14},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"PreferredArms will force a Bow if no equip skill is rolled.\",\"preferredArmsForce\":\"Bow\"}},\"Monk\":{\"M\":{\"hp\":206,\"mp\":52,\"pa\":12,\"ma\":7,\"speed\":8,\"move\":3,\"jump\":4,\"cEv\":24,\"innate\":[\"Punch Art\",\"Martial Arts\"],\"weapons\":{},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50},\"Gun\":{\"Book\":57,\"Gun\":29,\"Harp\":15}},\"notes\":\"MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.\"},\"F\":{\"hp\":193,\"mp\":56,\"pa\":10,\"ma\":9,\"speed\":8,\"move\":3,\"jump\":4,\"cEv\":24,\"innate\":[\"Punch Art\",\"Martial Arts\"],\"weapons\":{},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50},\"Gun\":{\"Book\":57,\"Gun\":29,\"Harp\":15}},\"notes\":\"MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.\"}},\"Priest\":{\"M\":{\"hp\":177,\"mp\":94,\"pa\":9,\"ma\":9,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":5,\"innate\":[\"White Magic\"],\"weapons\":{\"Staff\":67,\"Flail\":33},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":43,\"Flail\":29,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":166,\"mp\":101,\"pa\":7,\"ma\":11,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":5,\"innate\":[\"White Magic\"],\"weapons\":{\"Staff\":67,\"Flail\":33},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":43,\"Flail\":29,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Wizard\":{\"M\":{\"hp\":137,\"mp\":107,\"pa\":7,\"ma\":11,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":10,\"innate\":[\"Black Magic\"],\"weapons\":{\"Rod\":67,\"Knife\":33},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":43,\"Rod\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":43,\"Flail\":29,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":128,\"mp\":115,\"pa\":5,\"ma\":14,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":10,\"innate\":[\"Black Magic\"],\"weapons\":{\"Rod\":67,\"Knife\":33},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":43,\"Rod\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":43,\"Flail\":29,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Time Mage\":{\"M\":{\"hp\":141,\"mp\":103,\"pa\":8,\"ma\":10,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":17,\"innate\":[\"Time Magic\"],\"weapons\":{\"Staff\":60,\"Pole\":40},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":132,\"mp\":110,\"pa\":6,\"ma\":13,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":17,\"innate\":[\"Time Magic\"],\"weapons\":{\"Staff\":60,\"Pole\":40},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":43,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Summoner\":{\"M\":{\"hp\":125,\"mp\":112,\"pa\":5,\"ma\":9,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":7,\"innate\":[\"Summon Magic\"],\"weapons\":{\"Rod\":60,\"Staff\":25,\"Book\":15},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":117,\"mp\":119,\"pa\":4,\"ma\":12,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":7,\"innate\":[\"Summon Magic\"],\"weapons\":{\"Rod\":60,\"Staff\":25,\"Book\":15},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Thief\":{\"M\":{\"hp\":188,\"mp\":36,\"pa\":10,\"ma\":5,\"speed\":10,\"move\":4,\"jump\":3,\"cEv\":30,\"innate\":[\"Steal\"],\"weapons\":{\"Knife\":50,\"Ninja Blade\":25,\"Sword\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Katana\":38,\"Knight Sword\":33,\"Sword\":29},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":57,\"Book\":29,\"Harp\":15}},\"notes\":\"Equip Gun, forced. Guns (62%), Books (25%), Harps (14%).\"},\"F\":{\"hp\":176,\"mp\":39,\"pa\":8,\"ma\":7,\"speed\":10,\"move\":4,\"jump\":3,\"cEv\":30,\"innate\":[\"Steal\"],\"weapons\":{\"Knife\":50,\"Ninja Blade\":25,\"Sword\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":43,\"Ninja Blade\":29,\"Knife\":29},\"Sword\":{\"Katana\":38,\"Knight Sword\":33,\"Sword\":29},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Spear\":57,\"Pole\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":57,\"Book\":29,\"Harp\":15}},\"notes\":\"Equip Gun, forced. Guns (62%), Books (25%), Harps (14%).\"}},\"Mediator\":{\"M\":{\"hp\":160,\"mp\":48,\"pa\":8,\"ma\":8,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":9,\"innate\":[\"Talk Skill\",\"Monster Talk\"],\"weapons\":{\"Gun\":63,\"Book\":37},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Knife\":43,\"Ninja Blade\":29,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Crossbow\":64,\"Bow\":35,\"Bag\":1},\"Gun\":{\"Harp\":43,\"Book\":29,\"Gun\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":150,\"mp\":51,\"pa\":7,\"ma\":10,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":9,\"innate\":[\"Talk Skill\",\"Monster Talk\"],\"weapons\":{\"Gun\":63,\"Book\":37},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Knife\":43,\"Ninja Blade\":29,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Crossbow\":64,\"Bow\":35,\"Bag\":1},\"Gun\":{\"Harp\":43,\"Book\":29,\"Gun\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Oracle\":{\"M\":{\"hp\":149,\"mp\":86,\"pa\":6,\"ma\":10,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":22,\"innate\":[\"Yin Yang Magic\"],\"weapons\":{\"Pole\":75,\"Book\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Knife\":36,\"Rod\":36,\"Ninja Blade\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Staff\":43,\"Axe\":29,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":139,\"mp\":92,\"pa\":5,\"ma\":12,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":22,\"innate\":[\"Yin Yang Magic\"],\"weapons\":{\"Pole\":75,\"Book\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Knife\":36,\"Rod\":36,\"Ninja Blade\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Staff\":43,\"Axe\":29,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Geomancer\":{\"M\":{\"hp\":155,\"mp\":78,\"pa\":12,\"ma\":8,\"speed\":8,\"move\":4,\"jump\":3,\"cEv\":11,\"innate\":[\"Elemental\"],\"weapons\":{\"Axe\":50,\"Sword\":25,\"Katana\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Knight Sword\":36,\"Sword\":32,\"Katana\":32},\"Axe\":{\"Flail\":36,\"Staff\":36,\"Axe\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":47,\"Book\":39,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":145,\"mp\":83,\"pa\":9,\"ma\":10,\"speed\":8,\"move\":4,\"jump\":3,\"cEv\":11,\"innate\":[\"Elemental\"],\"weapons\":{\"Axe\":50,\"Sword\":25,\"Katana\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Knight Sword\":36,\"Sword\":32,\"Katana\":32},\"Axe\":{\"Flail\":36,\"Staff\":36,\"Axe\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":47,\"Book\":39,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Lancer\":{\"M\":{\"hp\":194,\"mp\":34,\"pa\":13,\"ma\":4,\"speed\":8,\"move\":3,\"jump\":4,\"cEv\":18,\"innate\":[\"Jump\"],\"weapons\":{\"Spear\":75,\"Pole\":25},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Fabric\":43,\"Pole\":29,\"Spear\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":181,\"mp\":37,\"pa\":10,\"ma\":5,\"speed\":8,\"move\":3,\"jump\":4,\"cEv\":18,\"innate\":[\"Jump\"],\"weapons\":{\"Spear\":75,\"Pole\":25},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Fabric\":43,\"Pole\":29,\"Spear\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Samurai\":{\"M\":{\"hp\":144,\"mp\":62,\"pa\":14,\"ma\":7,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":27,\"innate\":[\"Draw Out\"],\"weapons\":{\"Katana\":75,\"Spear\":25},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":43,\"Rod\":29,\"Knife\":29},\"Sword\":{\"Sword\":39,\"Knight Sword\":32,\"Katana\":28},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":43,\"Spear\":29,\"Fabric\":29},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"},\"F\":{\"hp\":135,\"mp\":66,\"pa\":11,\"ma\":9,\"speed\":8,\"move\":3,\"jump\":3,\"cEv\":27,\"innate\":[\"Draw Out\"],\"weapons\":{\"Katana\":75,\"Spear\":25},\"heads\":[\"Helmet\"],\"bodies\":[\"Armor\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":43,\"Rod\":29,\"Knife\":29},\"Sword\":{\"Sword\":39,\"Knight Sword\":32,\"Katana\":28},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":43,\"Spear\":29,\"Fabric\":29},\"Bow\":{\"Bow\":64,\"Crossbow\":35,\"Bag\":1},\"Gun\":{\"Gun\":45,\"Book\":41,\"Harp\":15}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Ninja\":{\"M\":{\"hp\":119,\"mp\":40,\"pa\":11,\"ma\":5,\"speed\":10,\"move\":4,\"jump\":4,\"cEv\":20,\"innate\":[\"Throw\",\"Dual Wield\"],\"weapons\":{\"Ninja Blade\":50,\"Flail\":25,\"Knife\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":46,\"Ninja Blade\":27,\"Knife\":27},\"Sword\":{\"Katana\":39,\"Sword\":37,\"Knight Sword\":24},\"Axe\":{\"Axe\":36,\"Staff\":36,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Book\":57,\"Gun\":29,\"Harp\":15}},\"notes\":\"Equip Gun, forced. Books (62%), Guns (25%), Harps (14%).\"},\"F\":{\"hp\":112,\"mp\":43,\"pa\":9,\"ma\":6,\"speed\":10,\"move\":4,\"jump\":4,\"cEv\":20,\"innate\":[\"Throw\",\"Dual Wield\"],\"weapons\":{\"Ninja Blade\":50,\"Flail\":25,\"Knife\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Rod\":46,\"Ninja Blade\":27,\"Knife\":27},\"Sword\":{\"Katana\":39,\"Sword\":37,\"Knight Sword\":24},\"Axe\":{\"Axe\":36,\"Staff\":36,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":43,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Book\":57,\"Gun\":29,\"Harp\":15}},\"notes\":\"Equip Gun, forced. Books (62%), Guns (25%), Harps (14%).\"}},\"Calculator\":{\"M\":{\"hp\":132,\"mp\":70,\"pa\":7,\"ma\":8,\"speed\":7,\"move\":3,\"jump\":3,\"cEv\":15,\"innate\":[\"Math Skill\"],\"weapons\":{\"Book\":50,\"Rod\":25,\"Pole\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Staff\":43,\"Axe\":29,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Preferred Blue Mage: Flails (35%), Books (30%), Rods (18%), Poles (18%).\"},\"F\":{\"hp\":123,\"mp\":75,\"pa\":5,\"ma\":10,\"speed\":7,\"move\":3,\"jump\":3,\"cEv\":15,\"innate\":[\"Math Skill\"],\"weapons\":{\"Book\":50,\"Rod\":25,\"Pole\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Staff\":43,\"Axe\":29,\"Flail\":29},\"Polearm\":{\"Spear\":43,\"Pole\":29,\"Fabric\":29},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":43,\"Book\":29,\"Harp\":29}},\"notes\":\"Preferred Blue Mage: Flails (35%), Books (30%), Rods (18%), Poles (18%).\"}},\"Bard\":{\"M\":{\"hp\":153,\"mp\":57,\"pa\":8,\"ma\":9,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":13,\"innate\":[\"Sing\"],\"weapons\":{\"Harp\":75,\"Bow\":25},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Armor\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Knife\":36,\"Rod\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Staff\":43,\"Axe\":29,\"Flail\":29},\"Polearm\":{\"Spear\":39,\"Pole\":39,\"Fabric\":21},\"Bow\":{\"Crossbow\":64,\"Bow\":35,\"Bag\":1},\"Gun\":{\"Gun\":44,\"Book\":42,\"Harp\":14}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Dancer\":{\"F\":{\"hp\":157,\"mp\":53,\"pa\":8,\"ma\":9,\"speed\":9,\"move\":3,\"jump\":3,\"cEv\":13,\"innate\":[\"Dance\"],\"weapons\":{\"Fabric\":75,\"Bag\":25,\"Knife\":2},\"heads\":[\"Hat\"],\"bodies\":[\"Clothing\",\"Robe\"],\"shield\":false,\"equipArms\":{\"Knife\":{\"Ninja Blade\":36,\"Rod\":36,\"Knife\":29},\"Sword\":{\"Sword\":38,\"Katana\":37,\"Knight Sword\":25},\"Axe\":{\"Axe\":36,\"Flail\":36,\"Staff\":29},\"Polearm\":{\"Pole\":57,\"Spear\":29,\"Fabric\":15},\"Bow\":{\"Bow\":50,\"Crossbow\":50,\"Bag\":1},\"Gun\":{\"Gun\":41,\"Book\":37,\"Harp\":21}},\"notes\":\"Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class.\"}},\"Mime\":{\"M\":{\"hp\":198,\"mp\":33,\"pa\":13,\"ma\":11,\"speed\":10,\"move\":3,\"jump\":4,\"cEv\":6,\"innate\":[\"Mimic\",\"Concentrate\",\"Beastmaster\",\"Throw Item\",\"No MP\"],\"weapons\":{},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\",\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{},\"notes\":\"MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.\",\"noWeapons\":true},\"F\":{\"hp\":185,\"mp\":35,\"pa\":11,\"ma\":13,\"speed\":10,\"move\":3,\"jump\":4,\"cEv\":6,\"innate\":[\"Mimic\",\"Concentrate\",\"Beastmaster\",\"Throw Item\",\"No MP\"],\"weapons\":{},\"heads\":[\"Hat\",\"Helmet\"],\"bodies\":[\"Clothing\",\"Armor\",\"Robe\"],\"shield\":true,\"equipArms\":{},\"notes\":\"MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.\",\"noWeapons\":true}}}");

});

parcelRegister("64X3q", function(module, exports) {
module.exports = JSON.parse("{\"items\":[{\"name\":\"Dagger\",\"info\":\"4 WP, 1 range, 5% evade, Knife. Effect: +2 Speed.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":5,\"speed\":2}},{\"name\":\"Mythril Knife\",\"info\":\"5 WP, 1 range, 9% evade, Knife. Effect: +1 Speed.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":1,\"evadePercent\":9,\"speed\":1}},{\"name\":\"Thief Knife\",\"info\":\"5 WP, 1 range, 18% evade, Knife. Effect: Chance to cast Steal Accessory.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":1,\"evadePercent\":18}},{\"name\":\"Mage Masher\",\"info\":\"6 WP, 1 range, 10% evade, Knife. Effect: Chance to add Silence.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":1,\"evadePercent\":10}},{\"name\":\"Cultist Dagger\",\"info\":\"9 WP, 1 range, 13% evade, Knife. Effect: Chance to add Undead.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":1,\"evadePercent\":13}},{\"name\":\"Main Gauche\",\"info\":\"7 WP, 1 range, 40% evade, Knife.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":1,\"evadePercent\":40}},{\"name\":\"Orichalcum\",\"info\":\"7 WP, 1 range, 7% evade, Knife. Effect: Initial Haste.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":1,\"evadePercent\":7,\"initialStatuses\":[{\"name\":\"Haste\",\"info\":\"Increases the unit's Speed by 50%. It has a duration of 28 clock ticks.\"}]}},{\"name\":\"Assassin Dagger\",\"info\":\"8 WP, 1 range, 15% evade, Knife. Effect: Chance to add Death Sentence.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":1,\"evadePercent\":15}},{\"name\":\"Air Knife\",\"info\":\"10 WP, 1 range, 3% evade, Knife. Element: Wind. Effect: +1 PA.\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":1,\"evadePercent\":3,\"element\":\"Wind\",\"pa\":1}},{\"name\":\"Zorlin Shape\",\"info\":\"12 WP, 1 range, 11% evade, Knife. Effect: Chance to add Death, Sleep (Random).\",\"type\":\"Knife\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":1,\"evadePercent\":11}},{\"name\":\"Blind Knife\",\"info\":\"8 WP, 1 range, 8% evade, Ninja Blade. Effect: Chance to add Darkness.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":1,\"evadePercent\":8}},{\"name\":\"Kunai\",\"info\":\"4 WP, 1 range, 9% evade, Ninja Blade. Effect: +1 Move.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":9,\"move\":1}},{\"name\":\"Short Blade\",\"info\":\"6 WP, 1 range, 6% evade, Ninja Blade. Effect: +1 Speed.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":1,\"evadePercent\":6,\"speed\":1}},{\"name\":\"Ninja Edge\",\"info\":\"10 WP, 1 range, 20% evade, Ninja Blade. Effect: Chance to cast Foxbird.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":1,\"evadePercent\":20}},{\"name\":\"Spell Edge\",\"info\":\"11 WP, 1 range, 4% evade, Ninja Blade. Effect: Chance to add Don't Act.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":1,\"evadePercent\":4}},{\"name\":\"Sasuke Knife\",\"info\":\"12 WP, 1 range, 15% evade, Ninja Blade.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":1,\"evadePercent\":15}},{\"name\":\"Iga Knife\",\"info\":\"13 WP, 1 range, 12% evade, Ninja Blade. Effect: Chance to cast Dash.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":1,\"evadePercent\":12}},{\"name\":\"Koga Knife\",\"info\":\"14 WP, 1 range, 5% evade, Ninja Blade. Effect: +1 Jump.\",\"type\":\"Ninja Blade\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":1,\"evadePercent\":5,\"jump\":1}},{\"name\":\"Iron Sword\",\"info\":\"5 WP, 1 range, 14% evade, Sword. Effect: +1 PA, +1 Jump.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":1,\"evadePercent\":14,\"jump\":1,\"pa\":1}},{\"name\":\"Mythril Sword\",\"info\":\"7 WP, 1 range, 8% evade, Sword. Effect: +1 Speed.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":1,\"evadePercent\":8,\"speed\":1}},{\"name\":\"Blood Sword\",\"info\":\"8 WP (absorbing), 1 range, 3% evade, Sword.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"absorbWp\":8,\"range\":1,\"evadePercent\":3}},{\"name\":\"Coral Sword\",\"info\":\"9 WP, 1 range, 10% evade, Sword. Element: Lightning. Effect: +1 Move.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":1,\"evadePercent\":10,\"element\":\"Lightning\",\"move\":1}},{\"name\":\"Ancient Sword\",\"info\":\"10 WP, 1 range, 5% evade, Sword. Effect: Chance to add Don't Move.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":1,\"evadePercent\":5}},{\"name\":\"Sleep Sword\",\"info\":\"8 WP, 1 range, 20% evade, Sword. Effect: Chance to add Sleep.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":1,\"evadePercent\":20}},{\"name\":\"Platinum Sword\",\"info\":\"13 WP, 1 range, 11% evade, Sword.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":1,\"evadePercent\":11}},{\"name\":\"Diamond Sword\",\"info\":\"11 WP, 1 range, 26% evade, Sword.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":1,\"evadePercent\":26}},{\"name\":\"Ice Brand\",\"info\":\"12 WP, 1 range, 6% evade, Sword. Element: Ice. Effect: Chance to cast Ice 2.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":1,\"evadePercent\":6,\"element\":\"Ice\"}},{\"name\":\"Rune Blade\",\"info\":\"14 WP, 1 range, 10% evade, Sword. Effect: +1 MA.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":1,\"evadePercent\":10,\"ma\":1}},{\"name\":\"Nagrarock\",\"info\":\"6 WP, 1 range, 50% evade, Sword. Effect: +2 MA; Permanent Evil; Initial Float; Chance to add Frog.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":1,\"evadePercent\":50,\"ma\":2,\"initialStatuses\":[{\"name\":\"Float\",\"info\":\"Unit hovers 1 height over the ground, allowing it to move (but not necessarily stand) on all terrain without penalty. Unit nullifies attacks of the Earth element.\"}],\"permStatuses\":[{\"name\":\"Evil\",\"info\":\"Unit is immune to Critical.\"}]}},{\"name\":\"Materia Blade\",\"info\":\"16 WP, 1 range, 7% evade, Sword. Effect: Strengthen Wind, Earth, Water.\",\"type\":\"Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":16,\"range\":1,\"evadePercent\":7}},{\"name\":\"Defender\",\"info\":\"17 WP, 1 range, 60% evade, Knight Sword.\",\"type\":\"Knight Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":17,\"range\":1,\"evadePercent\":60}},{\"name\":\"Save the Queen\",\"info\":\"19 WP, 1 range, 23% evade, Knight Sword. Effect: Permanent Protect.\",\"type\":\"Knight Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":19,\"range\":1,\"evadePercent\":23,\"permStatuses\":[{\"name\":\"Protect\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from physical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Excalibur\",\"info\":\"22 WP, 1 range, 35% evade, Knight Sword. Effect: Absorb Holy; Strengthen Holy; Initial Haste; Chance to cast Explosion Sword.\",\"type\":\"Knight Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":22,\"range\":1,\"evadePercent\":35,\"initialStatuses\":[{\"name\":\"Haste\",\"info\":\"Increases the unit's Speed by 50%. It has a duration of 28 clock ticks.\"}]}},{\"name\":\"Ragnarok\",\"info\":\"20 WP, 1 range, 27% evade, Knight Sword. Effect: Permanent Shell.\",\"type\":\"Knight Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":20,\"range\":1,\"evadePercent\":27,\"permStatuses\":[{\"name\":\"Shell\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from magical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Chaos Blade\",\"info\":\"25 WP, 1 range, 19% evade, Knight Sword. Effect: Absorb Dark; Strengthen Dark; Initial Regen; Chance to add Petrify.\",\"type\":\"Knight Sword\",\"slot\":\"hand\",\"stats\":{\"wp\":25,\"range\":1,\"evadePercent\":19,\"initialStatuses\":[{\"name\":\"Regen\",\"info\":\"Unit is healed by 12.5% at the end of each of its turns. It has a duration of 40 clock ticks.\"}]}},{\"name\":\"Asura Knife\",\"info\":\"11 WP, 1 range, 15% evade, Katana. Effect: +2 MA; Chance to add Berserk.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":1,\"evadePercent\":15,\"ma\":2}},{\"name\":\"Koutetsu Knife\",\"info\":\"12 WP, 1 range, 18% evade, Katana. Effect: +1 Move, +1 Jump.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":1,\"evadePercent\":18,\"move\":1,\"jump\":1}},{\"name\":\"Bizen Boat\",\"info\":\"13 WP, 1 range, 25% evade, Katana. Effect: +1 Speed.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":1,\"evadePercent\":25,\"speed\":1}},{\"name\":\"Murasame\",\"info\":\"14 WP, 1 range, 15% evade, Katana. Effect: Chance to cast Demi 2.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":1,\"evadePercent\":15}},{\"name\":\"Heaven's Cloud\",\"info\":\"15 WP, 1 range, 21% evade, Katana. Element: Holy.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":1,\"evadePercent\":21,\"element\":\"Holy\"}},{\"name\":\"Kiyomori\",\"info\":\"18 WP, 1 range, 29% evade, Katana. Effect: +1 MA.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":18,\"range\":1,\"evadePercent\":29,\"ma\":1}},{\"name\":\"Muramasa\",\"info\":\"16 WP, 1 range, 15% evade, Katana. Element: Dark.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":16,\"range\":1,\"evadePercent\":15,\"element\":\"Dark\"}},{\"name\":\"Kikuichimonji\",\"info\":\"19 WP, 1 range, 16% evade, Katana. Effect: +1 PA.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":19,\"range\":1,\"evadePercent\":16,\"pa\":1}},{\"name\":\"Masamune\",\"info\":\"21 WP, 1 range, 14% evade, Katana. Effect: +2 Speed.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":21,\"range\":1,\"evadePercent\":14,\"speed\":2}},{\"name\":\"Chirijiraden\",\"info\":\"24 WP, 1 range, 15% evade, Katana. Effect: Chance to cast Blade Beam.\",\"type\":\"Katana\",\"slot\":\"hand\",\"stats\":{\"wp\":24,\"range\":1,\"evadePercent\":15}},{\"name\":\"Battle Axe\",\"info\":\"10 WP, 1 range, 10% evade, Axe. Effect: +2 PA.\",\"type\":\"Axe\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":1,\"evadePercent\":10,\"pa\":2}},{\"name\":\"Rune Axe\",\"info\":\"13 WP, 1 range, 15% evade, Axe. Effect: Half Fire, Lightning, Ice; Chance to cast Manaburn.\",\"type\":\"Axe\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":1,\"evadePercent\":15}},{\"name\":\"Giant Axe\",\"info\":\"15 WP, 1 range, 6% evade, Axe. Effect: Chance to -2 PA.\",\"type\":\"Axe\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":1,\"evadePercent\":6}},{\"name\":\"Slasher\",\"info\":\"18 WP, 1 range, 4% evade, Axe. Effect: Chance to add Slow.\",\"type\":\"Axe\",\"slot\":\"hand\",\"stats\":{\"wp\":18,\"range\":1,\"evadePercent\":4}},{\"name\":\"Rod\",\"info\":\"4 WP, 1 range, 24% evade, Rod. Effect: Absorb Lightning.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":24}},{\"name\":\"Thunder Rod\",\"info\":\"3 WP, 1 range, 20% evade, Rod. Element: Lightning. Effect: Strengthen Lightning; Chance to cast Bolt.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":3,\"range\":1,\"evadePercent\":20,\"element\":\"Lightning\"}},{\"name\":\"Flame Rod\",\"info\":\"3 WP, 1 range, 20% evade, Rod. Element: Fire. Effect: Strengthen Fire; Chance to cast Fire.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":3,\"range\":1,\"evadePercent\":20,\"element\":\"Fire\"}},{\"name\":\"Ice Rod\",\"info\":\"3 WP, 1 range, 20% evade, Rod. Element: Ice. Effect: Strengthen Ice; Chance to cast Ice.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":3,\"range\":1,\"evadePercent\":20,\"element\":\"Ice\"}},{\"name\":\"Poison Rod\",\"info\":\"4 WP, 1 range, 17% evade, Rod. Effect: +2 PA; Chance to add Poison.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":17,\"pa\":2}},{\"name\":\"Wizard Rod\",\"info\":\"5 WP, 1 range, 20% evade, Rod. Effect: +2 MA.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":1,\"evadePercent\":20,\"ma\":2}},{\"name\":\"Dragon Rod\",\"info\":\"6 WP, 1 range, 12% evade, Rod. Effect: +1 PA; Initial Reraise; Immune Frog.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":1,\"evadePercent\":12,\"pa\":1,\"initialStatuses\":[{\"name\":\"Reraise\",\"info\":\"At the start of the unit's next turn with Death, it automatically resurrects with 10% HP.\"}]}},{\"name\":\"Faith Rod\",\"info\":\"8 WP, 1 range, 22% evade, Rod. Effect: Initial Faith; Immune Innocent; Chance to add Faith.\",\"type\":\"Rod\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":1,\"evadePercent\":22,\"initialStatuses\":[{\"name\":\"Faith\",\"info\":\"Unit's Faith is set to 100. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Oak Staff\",\"info\":\"4 WP, 1 range, 19% evade, Staff. Effect: Absorb Water.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":19}},{\"name\":\"White Staff\",\"info\":\"5 WP, 1 range, 16% evade, Staff. Effect: Chance to cast Steal Status.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":1,\"evadePercent\":16}},{\"name\":\"Healing Staff\",\"info\":\"8 WP (healing), 1 range, 14% evade, Staff.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"healWp\":8,\"range\":1,\"evadePercent\":14}},{\"name\":\"Rainbow Staff\",\"info\":\"6 WP, 1 range, 11% evade, Staff. Element: Earth. Effect: +1 Speed.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":1,\"evadePercent\":11,\"element\":\"Earth\",\"speed\":1}},{\"name\":\"Power Staff\",\"info\":\"4 WP, 1 range, 13% evade, Staff. Effect: +1 PA, +1 MA.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":4,\"range\":1,\"evadePercent\":13,\"pa\":1,\"ma\":1}},{\"name\":\"Gold Staff\",\"info\":\"7 WP, 1 range, 23% evade, Staff. Effect: Chance to cast Spell Absorb.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":1,\"evadePercent\":23}},{\"name\":\"Mace of Zeus\",\"info\":\"11 WP, 1 range, 21% evade, Staff. Effect: +2 PA; Chance to cast Lifebreak.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":1,\"evadePercent\":21,\"pa\":2}},{\"name\":\"Sage Staff\",\"info\":\"9 WP, 1 range, 17% evade, Staff. Effect: Permanent Protect.\",\"type\":\"Staff\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":1,\"evadePercent\":17,\"permStatuses\":[{\"name\":\"Protect\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from physical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Flail\",\"info\":\"11 WP, 1 range, 2% evade, Flail. Effect: Chance to cancel Charging, Defending, Performing.\",\"type\":\"Flail\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":1,\"evadePercent\":2}},{\"name\":\"Flame Whip\",\"info\":\"14 WP, 1 range, 3% evade, Flail. Element: Fire. Effect: Chance to cast Fire 2.\",\"type\":\"Flail\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":1,\"evadePercent\":3,\"element\":\"Fire\"}},{\"name\":\"Morning Star\",\"info\":\"16 WP, 1 range, 5% evade, Flail. Effect: Chance to add Oil.\",\"type\":\"Flail\",\"slot\":\"hand\",\"stats\":{\"wp\":16,\"range\":1,\"evadePercent\":5}},{\"name\":\"Scorpion Tail\",\"info\":\"23 WP, 1 range, 1% evade, Flail. Element: Earth. Effect: Chance to cast Nether Demon.\",\"type\":\"Flail\",\"slot\":\"hand\",\"stats\":{\"wp\":23,\"range\":1,\"evadePercent\":1,\"element\":\"Earth\"}},{\"name\":\"Romanda Gun\",\"info\":\"7 WP, 8 range, 6% evade, Gun.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":8,\"evadePercent\":6}},{\"name\":\"Mythril Gun\",\"info\":\"9 WP, 7 range, 4% evade, Gun. Effect: +1 Speed.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":7,\"evadePercent\":4,\"speed\":1}},{\"name\":\"Stone Gun\",\"info\":\"12 WP, 6 range, 8% evade, Gun. Effect: Initial Slow; Immune Petrify, Float.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":6,\"evadePercent\":8,\"initialStatuses\":[{\"name\":\"Slow\",\"info\":\"Halves the unit's Speed. It has a duration of 28 clock ticks.\"}]}},{\"name\":\"Blaze Gun\",\"info\":\"13 WP, 7 range, 5% evade, Gun. Element: Fire.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":7,\"evadePercent\":5,\"element\":\"Fire\"}},{\"name\":\"Glacier Gun\",\"info\":\"13 WP, 7 range, 5% evade, Gun. Element: Ice.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":7,\"evadePercent\":5,\"element\":\"Ice\"}},{\"name\":\"Blast Gun\",\"info\":\"13 WP, 7 range, 5% evade, Gun. Element: Lightning.\",\"type\":\"Gun\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":7,\"evadePercent\":5,\"element\":\"Lightning\"}},{\"name\":\"Bow Gun\",\"info\":\"5 WP, 4 range, 8% evade, Crossbow. Element: Fire. Effect: +2 PA.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":4,\"evadePercent\":8,\"element\":\"Fire\",\"pa\":2}},{\"name\":\"Night Killer\",\"info\":\"6 WP, 4 range, 13% evade, Crossbow. Effect: +1 MA; Chance to add Darkness.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":4,\"evadePercent\":13,\"ma\":1}},{\"name\":\"Arbalest\",\"info\":\"11 WP, 5 range, 10% evade, Crossbow.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":5,\"evadePercent\":10}},{\"name\":\"Venom Bow\",\"info\":\"9 WP, 4 range, 7% evade, Crossbow. Effect: Chance to add Poison.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":4,\"evadePercent\":7}},{\"name\":\"Hunting Bow\",\"info\":\"7 WP, 4 range, 11% evade, Crossbow. Effect: Chance to -1 Speed.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":4,\"evadePercent\":11}},{\"name\":\"Gastrophetes\",\"info\":\"14 WP, 4 range, 9% evade, Crossbow. Effect: Chance to cast Compress.\",\"type\":\"Crossbow\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":4,\"evadePercent\":9}},{\"name\":\"Long Bow\",\"info\":\"6 WP, 6 range, 3% evade, Bow.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":6,\"evadePercent\":3}},{\"name\":\"Silver Bow\",\"info\":\"7 WP, 5 range, 4% evade, Bow. Element: Ice. Effect: +2 MA.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":5,\"evadePercent\":4,\"element\":\"Ice\",\"ma\":2}},{\"name\":\"Lightning Bow\",\"info\":\"10 WP, 5 range, 2% evade, Bow. Element: Lightning. Effect: Chance to cast Bolt 2.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":5,\"evadePercent\":2,\"element\":\"Lightning\"}},{\"name\":\"Windslash Bow\",\"info\":\"9 WP, 5 range, 15% evade, Bow. Element: Wind. Effect: +1 Jump.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":5,\"evadePercent\":15,\"element\":\"Wind\",\"jump\":1}},{\"name\":\"Mythril Bow\",\"info\":\"8 WP, 5 range, 1% evade, Bow. Effect: +1 Speed.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":5,\"evadePercent\":1,\"speed\":1}},{\"name\":\"Ultimus Bow\",\"info\":\"12 WP, 5 range, 5% evade, Bow. Effect: Chance to cancel Undead, Innocent, Evil.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":5,\"evadePercent\":5}},{\"name\":\"Yoichi Bow\",\"info\":\"14 WP, 5 range, 2% evade, Bow. Effect: +1 Move.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":5,\"evadePercent\":2,\"move\":1}},{\"name\":\"Perseus Bow\",\"info\":\"15 WP, 5 range, 4% evade, Bow.\",\"type\":\"Bow\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":5,\"evadePercent\":4}},{\"name\":\"Lamia Harp\",\"info\":\"9 WP, 3 range, 12% evade, Harp. Effect: Chance to add Confusion.\",\"type\":\"Harp\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":3,\"evadePercent\":12}},{\"name\":\"Bloody Strings\",\"info\":\"11 WP (absorbing), 3 range, 7% evade, Harp.\",\"type\":\"Harp\",\"slot\":\"hand\",\"stats\":{\"absorbWp\":11,\"range\":3,\"evadePercent\":7}},{\"name\":\"Fairy Harp\",\"info\":\"14 WP, 3 range, 17% evade, Harp. Effect: Chance to add Charm.\",\"type\":\"Harp\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":3,\"evadePercent\":17}},{\"name\":\"Academic Tome\",\"info\":\"6 WP, 3 range, 30% evade, Book. Effect: Half Wind, Earth, Water; Chance to cast Persuade.\",\"type\":\"Book\",\"slot\":\"hand\",\"stats\":{\"wp\":6,\"range\":3,\"evadePercent\":30}},{\"name\":\"Battle Folio\",\"info\":\"7 WP, 3 range, 25% evade, Book. Effect: +1 PA.\",\"type\":\"Book\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":3,\"evadePercent\":25,\"pa\":1}},{\"name\":\"Bestiary\",\"info\":\"8 WP, 3 range, 19% evade, Book. Effect: +1 MA.\",\"type\":\"Book\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":3,\"evadePercent\":19,\"ma\":1}},{\"name\":\"Papyrus Codex\",\"info\":\"10 WP, 3 range, 6% evade, Book. Element: Water. Effect: Chance to add Faith, Innocent (Random).\",\"type\":\"Book\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":3,\"evadePercent\":6,\"element\":\"Water\"}},{\"name\":\"Madlemgen\",\"info\":\"13 WP, 3 range, 13% evade, Book. Element: Dark. Effect: Chance to cast Dark Holy.\",\"type\":\"Book\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":3,\"evadePercent\":13,\"element\":\"Dark\"}},{\"name\":\"Javelin\",\"info\":\"5 WP, 2 range, 7% evade, Spear. Effect: Chance to cast Spin Fist.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":5,\"range\":2,\"evadePercent\":7}},{\"name\":\"Spear\",\"info\":\"7 WP, 2 range, 12% evade, Spear. Effect: +1 Jump.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":2,\"evadePercent\":12,\"jump\":1}},{\"name\":\"Halberd\",\"info\":\"8 WP, 2 range, 10% evade, Spear. Effect: Half Holy, Dark.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":2,\"evadePercent\":10}},{\"name\":\"Mythril Spear\",\"info\":\"9 WP, 2 range, 5% evade, Spear. Effect: +1 Speed.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":2,\"evadePercent\":5,\"speed\":1}},{\"name\":\"Partisan\",\"info\":\"10 WP, 2 range, 16% evade, Spear.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":2,\"evadePercent\":16}},{\"name\":\"Obelisk\",\"info\":\"11 WP, 2 range, 9% evade, Spear. Element: Water. Effect: +1 MA.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":2,\"evadePercent\":9,\"element\":\"Water\",\"ma\":1}},{\"name\":\"Holy Lance\",\"info\":\"13 WP, 2 range, 10% evade, Spear. Element: Holy. Effect: Chance to cast Holy.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":13,\"range\":2,\"evadePercent\":10,\"element\":\"Holy\"}},{\"name\":\"Dragon Whisker\",\"info\":\"15 WP, 2 range, 8% evade, Spear. Effect: Permanent Shell.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":2,\"evadePercent\":8,\"permStatuses\":[{\"name\":\"Shell\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from magical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Gungnir\",\"info\":\"17 WP, 2 range, 10% evade, Spear. Element: Wind. Effect: Chance to cast Diamond Blade.\",\"type\":\"Spear\",\"slot\":\"hand\",\"stats\":{\"wp\":17,\"range\":2,\"evadePercent\":10,\"element\":\"Wind\"}},{\"name\":\"Cypress Pole\",\"info\":\"7 WP, 2 range, 21% evade, Pole. Effect: +1 MA, +1 Speed.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":7,\"range\":2,\"evadePercent\":21,\"speed\":1,\"ma\":1}},{\"name\":\"Battle Bamboo\",\"info\":\"8 WP, 2 range, 28% evade, Pole. Effect: +2 PA.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":8,\"range\":2,\"evadePercent\":28,\"pa\":2}},{\"name\":\"Musk Stick\",\"info\":\"9 WP, 2 range, 20% evade, Pole. Effect: Chance to -2 MA.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":2,\"evadePercent\":20}},{\"name\":\"Iron Fan\",\"info\":\"10 WP, 2 range, 24% evade, Pole. Effect: +1 Move.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":2,\"evadePercent\":24,\"move\":1}},{\"name\":\"Gokuu Pole\",\"info\":\"11 WP, 2 range, 22% evade, Pole. Effect: Chance to add Innocent.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":11,\"range\":2,\"evadePercent\":22}},{\"name\":\"Ivory Cane\",\"info\":\"12 WP, 2 range, 26% evade, Pole. Element: Earth.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":2,\"evadePercent\":26,\"element\":\"Earth\"}},{\"name\":\"Octagon Rod\",\"info\":\"14 WP, 2 range, 18% evade, Pole. Effect: Chance to cancel Float, Reraise, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":14,\"range\":2,\"evadePercent\":18}},{\"name\":\"Whale Whisker\",\"info\":\"16 WP, 2 range, 20% evade, Pole. Element: Water. Effect: Chance to cast Leviathan.\",\"type\":\"Pole\",\"slot\":\"hand\",\"stats\":{\"wp\":16,\"range\":2,\"evadePercent\":20,\"element\":\"Water\"}},{\"name\":\"Cute Bag\",\"info\":\"10 WP, 1 range, 1% evade, Bag. Effect: +1 MA; Strengthen Water; Initial Reflect.\",\"type\":\"Bag\",\"slot\":\"hand\",\"stats\":{\"wp\":10,\"range\":1,\"evadePercent\":1,\"ma\":1,\"initialStatuses\":[{\"name\":\"Reflect\",\"info\":\"Reflects most spells to another panel, mirrored from the caster. It has a duration of 32 clock ticks.\"}]}},{\"name\":\"Star Bag\",\"info\":\"20 WP, 1 range, 3% evade, Bag.\",\"type\":\"Bag\",\"slot\":\"hand\",\"stats\":{\"wp\":20,\"range\":1,\"evadePercent\":3}},{\"name\":\"Panther Bag\",\"info\":\"12 WP, 1 range, 4% evade, Bag. Effect: Strengthen Earth; Permanent Regen; Immune Death Sentence.\",\"type\":\"Bag\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":1,\"evadePercent\":4,\"permStatuses\":[{\"name\":\"Regen\",\"info\":\"Unit is healed by 12.5% at the end of each of its turns. It has a duration of 40 clock ticks.\"}]}},{\"name\":\"Hydra Bag\",\"info\":\"15 WP, 1 range, 2% evade, Bag. Effect: +1 Speed; Strengthen Wind; Immune Poison.\",\"type\":\"Bag\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":1,\"evadePercent\":2,\"speed\":1}},{\"name\":\"Persia\",\"info\":\"9 WP, 2 range, 55% evade, Fabric. Effect: +1 PA.\",\"type\":\"Fabric\",\"slot\":\"hand\",\"stats\":{\"wp\":9,\"range\":2,\"evadePercent\":55,\"pa\":1}},{\"name\":\"Cashmere\",\"info\":\"12 WP, 2 range, 65% evade, Fabric. Effect: Chance to cast Witch Hunt.\",\"type\":\"Fabric\",\"slot\":\"hand\",\"stats\":{\"wp\":12,\"range\":2,\"evadePercent\":65}},{\"name\":\"Ryozan Silk\",\"info\":\"15 WP, 2 range, 45% evade, Fabric. Effect: Chance to add Stop.\",\"type\":\"Fabric\",\"slot\":\"hand\",\"stats\":{\"wp\":15,\"range\":2,\"evadePercent\":45}},{\"name\":\"Escutcheon\",\"info\":\"8% physical evade, 9% magic evade, Shield. Effect: +1 Speed, +1 Jump.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":8,\"magicEvadePercent\":9,\"speed\":1,\"jump\":1}},{\"name\":\"Buckler\",\"info\":\"17% physical evade, 3% magic evade, Shield. Effect: +1 PA.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":17,\"magicEvadePercent\":3,\"pa\":1}},{\"name\":\"Bronze Shield\",\"info\":\"19% physical evade, 8% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":19,\"magicEvadePercent\":8}},{\"name\":\"Round Shield\",\"info\":\"12% physical evade, 17% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":12,\"magicEvadePercent\":17}},{\"name\":\"Mythril Shield\",\"info\":\"22% physical evade, 6% magic evade, Shield. Effect: +1 Speed.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":22,\"magicEvadePercent\":6,\"speed\":1}},{\"name\":\"Gold Shield\",\"info\":\"26% physical evade, 13% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":26,\"magicEvadePercent\":13}},{\"name\":\"Ice Shield\",\"info\":\"28% physical evade, 4% magic evade, Shield. Effect: Absorb Ice; Half Fire.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":28,\"magicEvadePercent\":4}},{\"name\":\"Flame Shield\",\"info\":\"31% physical evade, 2% magic evade, Shield. Effect: Absorb Fire; Half Ice.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":31,\"magicEvadePercent\":2}},{\"name\":\"Aegis Shield\",\"info\":\"5% physical evade, 33% magic evade, Shield. Effect: +1 MA.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":5,\"magicEvadePercent\":33,\"ma\":1}},{\"name\":\"Diamond Shield\",\"info\":\"33% physical evade, 11% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":33,\"magicEvadePercent\":11}},{\"name\":\"Platinum Shield\",\"info\":\"37% physical evade, 5% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":37,\"magicEvadePercent\":5}},{\"name\":\"Crystal Shield\",\"info\":\"40% physical evade, 7% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":40,\"magicEvadePercent\":7}},{\"name\":\"Genji Shield\",\"info\":\"50% physical evade, 1% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":50,\"magicEvadePercent\":1}},{\"name\":\"Kaiser Plate\",\"info\":\"42% physical evade, 23% magic evade, Shield. Effect: Strengthen Fire, Lightning, Ice.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":42,\"magicEvadePercent\":23}},{\"name\":\"Venetian Shield\",\"info\":\"46% physical evade, 19% magic evade, Shield. Effect: Half Fire, Lightning, Ice.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":46,\"magicEvadePercent\":19}},{\"name\":\"Hero Shield\",\"info\":\"54% physical evade, 28% magic evade, Shield.\",\"type\":\"Shield\",\"slot\":\"hand\",\"stats\":{\"physEvadePercent\":54,\"magicEvadePercent\":28}},{\"name\":\"Leather Helmet\",\"info\":\"+37 HP, +6 MP, Helmet. Effect: +1 Speed.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":37,\"mp\":6,\"speed\":1}},{\"name\":\"Bronze Helmet\",\"info\":\"+42 HP, +4 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":42,\"mp\":4}},{\"name\":\"Iron Helmet\",\"info\":\"+47 HP, +8 MP, Helmet. Effect: +1 PA.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":47,\"mp\":8,\"pa\":1}},{\"name\":\"Barbuta\",\"info\":\"+53 HP, +5 MP, Helmet. Effect: +1 Jump.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":53,\"mp\":5,\"jump\":1}},{\"name\":\"Mythril Helmet\",\"info\":\"+59 HP, +2 MP, Helmet. Effect: +1 Speed.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":59,\"mp\":2,\"speed\":1}},{\"name\":\"Gold Helmet\",\"info\":\"+65 HP, +9 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":65,\"mp\":9}},{\"name\":\"Cross Helmet\",\"info\":\"+73 HP, +0 MP, Helmet. Effect: +1 MA.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":73,\"ma\":1}},{\"name\":\"Diamond Helmet\",\"info\":\"+82 HP, +7 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":82,\"mp\":7}},{\"name\":\"Platinum Helmet\",\"info\":\"+91 HP, +0 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":91}},{\"name\":\"Circlet\",\"info\":\"+100 HP, +0 MP, Helmet. Effect: Half Holy, Dark.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":100}},{\"name\":\"Crystal Helmet\",\"info\":\"+110 HP, +3 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":110,\"mp\":3}},{\"name\":\"Genji Helmet\",\"info\":\"+130 HP, +1 MP, Helmet.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":130,\"mp\":1}},{\"name\":\"Grand Helmet\",\"info\":\"+150 HP, +0 MP, Helmet. Effect: Immune Darkness, Sleep.\",\"type\":\"Helmet\",\"slot\":\"head\",\"stats\":{\"hp\":150}},{\"name\":\"Leather Cap\",\"info\":\"+31 HP, +10 MP, Hat. Effect: +1 Speed.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":31,\"mp\":10,\"speed\":1}},{\"name\":\"Feather Hat\",\"info\":\"+38 HP, +7 MP, Hat. Effect: +1 Jump; Absorb Wind; Strengthen Wind.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":38,\"mp\":7,\"jump\":1}},{\"name\":\"Red Hood\",\"info\":\"+34 HP, +50 MP, Hat.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":34,\"mp\":50}},{\"name\":\"Headgear\",\"info\":\"+44 HP, +3 MP, Hat. Effect: +1 PA, +1 Jump.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":44,\"mp\":3,\"jump\":1,\"pa\":1}},{\"name\":\"Triangle Hat\",\"info\":\"+49 HP, +17 MP, Hat. Effect: +2 MA.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":49,\"mp\":17,\"ma\":2}},{\"name\":\"Green Beret\",\"info\":\"+54 HP, +1 MP, Hat. Effect: +1 Speed, +1 Move.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":54,\"mp\":1,\"speed\":1,\"move\":1}},{\"name\":\"Twist Headband\",\"info\":\"+60 HP, +13 MP, Hat. Effect: +2 PA.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":60,\"mp\":13,\"pa\":2}},{\"name\":\"Holy Miter\",\"info\":\"+72 HP, +21 MP, Hat. Effect: Strengthen Holy; Initial Regen.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":72,\"mp\":21,\"initialStatuses\":[{\"name\":\"Regen\",\"info\":\"Unit is healed by 12.5% at the end of each of its turns. It has a duration of 40 clock ticks.\"}]}},{\"name\":\"Black Hood\",\"info\":\"+103 HP, +2 MP, Hat.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":103,\"mp\":2}},{\"name\":\"Golden Hairpin\",\"info\":\"+79 HP, +35 MP, Hat. Effect: Immune Confusion, Silence.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":79,\"mp\":35}},{\"name\":\"Flash Hat\",\"info\":\"+88 HP, +5 MP, Hat. Effect: +1 MA, +1 Speed.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":88,\"mp\":5,\"speed\":1,\"ma\":1}},{\"name\":\"Thief Cap\",\"info\":\"+67 HP, +0 MP, Hat. Effect: +2 Speed.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":67,\"speed\":2}},{\"name\":\"Cachusha\",\"info\":\"+25 HP, +29 MP, Hat. Effect: +1 MA; Immune Death, Darkness, Silence, Oil, Frog, Poison, Stop, Charm, Don't Act.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":25,\"mp\":29,\"ma\":1}},{\"name\":\"Barette\",\"info\":\"+29 HP, +25 MP, Hat. Effect: +1 PA; Immune Undead, Petrify, Confusion, Blood Suck, Berserk, Slow, Sleep, Don't Move, Death Sentence.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":29,\"mp\":25,\"pa\":1}},{\"name\":\"Ribbon\",\"info\":\"+27 HP, +27 MP, Hat. Effect: Immune Death, Undead, Petrify, Darkness, Confusion, Silence, Blood Suck, Oil, Berserk, Frog, Poison, Slow, Stop, Charm, Sleep, Don't Move, Don't Act.\",\"type\":\"Hat\",\"slot\":\"head\",\"stats\":{\"hp\":27,\"mp\":27}},{\"name\":\"Leather Armor\",\"info\":\"+39 HP, +6 MP, Armor. Effect: +1 Speed.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":39,\"mp\":6,\"speed\":1}},{\"name\":\"Linen Cuirass\",\"info\":\"+46 HP, +11 MP, Armor. Effect: +1 Move.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":46,\"mp\":11,\"move\":1}},{\"name\":\"Bronze Armor\",\"info\":\"+52 HP, +4 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":52,\"mp\":4}},{\"name\":\"Chain Mail\",\"info\":\"+58 HP, +0 MP, Armor. Effect: +1 Jump; Immune Don't Act.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":58,\"jump\":1}},{\"name\":\"Mythril Armor\",\"info\":\"+64 HP, +2 MP, Armor. Effect: +1 Speed.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":64,\"mp\":2,\"speed\":1}},{\"name\":\"Plate Mail\",\"info\":\"+70 HP, +0 MP, Armor. Effect: +1 PA.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":70,\"pa\":1}},{\"name\":\"Gold Armor\",\"info\":\"+77 HP, +9 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":77,\"mp\":9}},{\"name\":\"Diamond Armor\",\"info\":\"+86 HP, +7 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":86,\"mp\":7}},{\"name\":\"Platinum Armor\",\"info\":\"+95 HP, +0 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":95}},{\"name\":\"Carabini Mail\",\"info\":\"+105 HP, +0 MP, Armor. Effect: Half Wind, Earth, Water.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":105}},{\"name\":\"Crystal Mail\",\"info\":\"+115 HP, +3 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":115,\"mp\":3}},{\"name\":\"Genji Armor\",\"info\":\"+140 HP, +1 MP, Armor.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":140,\"mp\":1}},{\"name\":\"Reflect Mail\",\"info\":\"+125 HP, +5 MP, Armor. Effect: Permanent Reflect.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":125,\"mp\":5,\"permStatuses\":[{\"name\":\"Reflect\",\"info\":\"Reflects most spells to another panel, mirrored from the caster. It has a duration of 32 clock ticks.\"}]}},{\"name\":\"Maximillian\",\"info\":\"+160 HP, +0 MP, Armor. Effect: +1 Move; Immune Oil.\",\"type\":\"Armor\",\"slot\":\"body\",\"stats\":{\"hp\":160,\"move\":1}},{\"name\":\"Clothes\",\"info\":\"+33 HP, +18 MP, Clothing. Effect: +1 Move.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":33,\"mp\":18,\"move\":1}},{\"name\":\"Leather Outfit\",\"info\":\"+36 HP, +12 MP, Clothing. Effect: +1 Speed.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":36,\"mp\":12,\"speed\":1}},{\"name\":\"Mystic Vest\",\"info\":\"+40 HP, +20 MP, Clothing. Effect: +1 MA.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":40,\"mp\":20,\"ma\":1}},{\"name\":\"Chain Shirt\",\"info\":\"+50 HP, +1 MP, Clothing. Effect: +1 Jump.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":50,\"mp\":1,\"jump\":1}},{\"name\":\"Mirage Vest\",\"info\":\"+56 HP, +8 MP, Clothing. Effect: +1 Speed.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":56,\"mp\":8,\"speed\":1}},{\"name\":\"Adamant Vest\",\"info\":\"+62 HP, +16 MP, Clothing. Effect: +1 PA.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":62,\"mp\":16,\"pa\":1}},{\"name\":\"Scholar Outfit\",\"info\":\"+68 HP, +10 MP, Clothing. Effect: +2 MA.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":68,\"mp\":10,\"ma\":2}},{\"name\":\"Brigandine\",\"info\":\"+74 HP, +22 MP, Clothing.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":74,\"mp\":22}},{\"name\":\"Judo Outfit\",\"info\":\"+80 HP, +6 MP, Clothing. Effect: +1 PA; Immune Death.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":80,\"mp\":6,\"pa\":1}},{\"name\":\"Power Sleeve\",\"info\":\"+87 HP, +0 MP, Clothing. Effect: +2 PA.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":87,\"pa\":2}},{\"name\":\"Earth Clothes\",\"info\":\"+93 HP, +14 MP, Clothing. Effect: Absorb Earth; Strengthen Earth.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":93,\"mp\":14}},{\"name\":\"Secret Clothes\",\"info\":\"+45 HP, +4 MP, Clothing. Effect: +2 Speed; Initial Transparent.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":45,\"mp\":4,\"speed\":2,\"initialStatuses\":[{\"name\":\"Transparent\",\"info\":\"Until the unit acts or is damaged, attacks used by it cannot be evaded.\"}]}},{\"name\":\"Black Costume\",\"info\":\"+101 HP, +2 MP, Clothing. Effect: Strengthen Dark; Immune Stop.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":101,\"mp\":2}},{\"name\":\"Rubber Costume\",\"info\":\"+120 HP, +30 MP, Clothing. Effect: Half Lightning; Immune Slow.\",\"type\":\"Clothing\",\"slot\":\"body\",\"stats\":{\"hp\":120,\"mp\":30}},{\"name\":\"Linen Robe\",\"info\":\"+35 HP, +15 MP, Robe. Effect: +1 MA, +1 Move.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":35,\"mp\":15,\"move\":1,\"ma\":1}},{\"name\":\"Silk Robe\",\"info\":\"+41 HP, +19 MP, Robe. Effect: +1 Speed.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":41,\"mp\":19,\"speed\":1}},{\"name\":\"Wizard Robe\",\"info\":\"+48 HP, +24 MP, Robe. Effect: +2 MA.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":48,\"mp\":24,\"ma\":2}},{\"name\":\"Chameleon Robe\",\"info\":\"+57 HP, +28 MP, Robe. Effect: Absorb Holy; Strengthen Water; Immune Don't Move.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":57,\"mp\":28}},{\"name\":\"White Robe\",\"info\":\"+75 HP, +33 MP, Robe. Effect: Half Fire, Lightning, Ice.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":75,\"mp\":33}},{\"name\":\"Black Robe\",\"info\":\"+66 HP, +39 MP, Robe. Effect: Strengthen Fire, Lightning, Ice.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":66,\"mp\":39}},{\"name\":\"Light Robe\",\"info\":\"+84 HP, +45 MP, Robe. Effect: +1 MA; Absorb Dark.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":84,\"mp\":45,\"ma\":1}},{\"name\":\"Robe of Lords\",\"info\":\"+98 HP, +60 MP, Robe. Effect: +1 PA; Initial Protect, Shell.\",\"type\":\"Robe\",\"slot\":\"body\",\"stats\":{\"hp\":98,\"mp\":60,\"pa\":1,\"initialStatuses\":[{\"name\":\"Protect\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from physical attacks by a third. It has a duration of 36 clock ticks.\"},{\"name\":\"Shell\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from magical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Battle Boots\",\"info\":\"Accessory. Effect: +1 Speed, +1 Move.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"speed\":1,\"move\":1}},{\"name\":\"Spike Shoes\",\"info\":\"Accessory. Effect: +1 Speed, +1 Jump.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"speed\":1,\"jump\":1}},{\"name\":\"Germinas Boots\",\"info\":\"Accessory. Effect: +1 Move, +1 Jump.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"move\":1,\"jump\":1}},{\"name\":\"Rubber Shoes\",\"info\":\"Accessory. Effect: Half Lightning; Strengthen Lightning; Initial Shell.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"initialStatuses\":[{\"name\":\"Shell\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from magical attacks by a third. It has a duration of 36 clock ticks.\"}]}},{\"name\":\"Feather Boots\",\"info\":\"Accessory. Effect: Strengthen Wind; Permanent Float.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"permStatuses\":[{\"name\":\"Float\",\"info\":\"Unit hovers 1 height over the ground, allowing it to move (but not necessarily stand) on all terrain without penalty. Unit nullifies attacks of the Earth element.\"}]}},{\"name\":\"Sprint Shoes\",\"info\":\"Accessory. Effect: +2 Speed.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"speed\":2}},{\"name\":\"Red Shoes\",\"info\":\"Accessory. Effect: +1 MA, +1 Move.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"move\":1,\"ma\":1}},{\"name\":\"Power Wrist\",\"info\":\"Accessory. Effect: +1 PA; Half Fire; Strengthen Fire.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":1}},{\"name\":\"Genji Gauntlet\",\"info\":\"Accessory. Effect: +2 PA, +2 MA.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":2,\"ma\":2}},{\"name\":\"Magic Gauntlet\",\"info\":\"Accessory. Effect: +3 MA.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"ma\":3}},{\"name\":\"Bracer\",\"info\":\"Accessory. Effect: +3 PA.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":3}},{\"name\":\"Reflect Ring\",\"info\":\"Accessory. Effect: Permanent Reflect; Initial Protect.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"initialStatuses\":[{\"name\":\"Protect\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from physical attacks by a third. It has a duration of 36 clock ticks.\"}],\"permStatuses\":[{\"name\":\"Reflect\",\"info\":\"Reflects most spells to another panel, mirrored from the caster. It has a duration of 32 clock ticks.\"}]}},{\"name\":\"Defense Ring\",\"info\":\"Accessory. Effect: Half Wind; Strengthen Water; Immune Death, Sleep.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{}},{\"name\":\"Magic Ring\",\"info\":\"Accessory. Effect: Half Ice; Strengthen Ice; Immune Silence, Berserk.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{}},{\"name\":\"Cursed Ring\",\"info\":\"Accessory. Effect: +1 PA, +1 MA, +1 Speed; Permanent Undead.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"speed\":1,\"pa\":1,\"ma\":1,\"permStatuses\":[{\"name\":\"Undead\",\"info\":\"Most abilities that would heal the unit's HP damage it instead, but abilities that would absorb the unit's HP are reversed (healing it instead). At the start of the unit's fourth turn with Death, it has a 62.5% chance to resurrect with random HP instead of Crystal being applied.\"}]}},{\"name\":\"Angel Ring\",\"info\":\"Accessory. Effect: Immune Undead, Darkness; Initial Reraise.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"initialStatuses\":[{\"name\":\"Reraise\",\"info\":\"At the start of the unit's next turn with Death, it automatically resurrects with 10% HP.\"}]}},{\"name\":\"Diamond Armlet\",\"info\":\"Accessory. Effect: +1 PA, +1 MA; Immune Oil, Slow.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":1,\"ma\":1}},{\"name\":\"Jade Armlet\",\"info\":\"Accessory. Effect: Half Water; Strengthen Earth; Immune Petrify, Stop.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{}},{\"name\":\"108 Gems\",\"info\":\"Accessory. Effect: Strengthen Fire, Lightning, Ice, Wind, Earth, Water, Holy, Dark; Immune Blood Suck, Frog, Poison.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{}},{\"name\":\"N-Kai Armlet\",\"info\":\"Accessory. Effect: Half Dark; Strengthen Holy; Immune Confusion, Charm.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{}},{\"name\":\"Iron Armlet\",\"info\":\"Accessory. Effect: +1 PA; Half Earth; Immune Don't Move, Don't Act.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":1}},{\"name\":\"Small Mantle\",\"info\":\"20% physical evade, 20% magic evade, Accessory. Effect: Half Holy.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":20,\"magicEvadePercent\":20}},{\"name\":\"Leather Mantle\",\"info\":\"10% physical evade, 10% magic evade, Accessory. Effect: +1 Speed.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":10,\"magicEvadePercent\":10,\"speed\":1}},{\"name\":\"Wizard Mantle\",\"info\":\"15% physical evade, 15% magic evade, Accessory. Effect: +1 MA.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":15,\"magicEvadePercent\":15,\"ma\":1}},{\"name\":\"Elf Mantle\",\"info\":\"30% physical evade, 15% magic evade, Accessory.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":30,\"magicEvadePercent\":15}},{\"name\":\"Dracula Mantle\",\"info\":\"15% physical evade, 30% magic evade, Accessory.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":15,\"magicEvadePercent\":30}},{\"name\":\"Feather Mantle\",\"info\":\"25% physical evade, 25% magic evade, Accessory.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":25,\"magicEvadePercent\":25}},{\"name\":\"Vanish Mantle\",\"info\":\"35% physical evade, 0% magic evade, Accessory. Effect: Strengthen Dark; Initial Transparent.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"physEvadePercent\":35,\"initialStatuses\":[{\"name\":\"Transparent\",\"info\":\"Until the unit acts or is damaged, attacks used by it cannot be evaded.\"}]}},{\"name\":\"Chantage\",\"info\":\"Accessory. Effect: Permanent Regen; Initial Reraise.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"initialStatuses\":[{\"name\":\"Reraise\",\"info\":\"At the start of the unit's next turn with Death, it automatically resurrects with 10% HP.\"}],\"permStatuses\":[{\"name\":\"Regen\",\"info\":\"Unit is healed by 12.5% at the end of each of its turns. It has a duration of 40 clock ticks.\"}]}},{\"name\":\"Cherche\",\"info\":\"Accessory. Effect: +1 PA, +1 MA; Permanent Float, Reflect.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"pa\":1,\"ma\":1,\"permStatuses\":[{\"name\":\"Float\",\"info\":\"Unit hovers 1 height over the ground, allowing it to move (but not necessarily stand) on all terrain without penalty. Unit nullifies attacks of the Earth element.\"},{\"name\":\"Reflect\",\"info\":\"Reflects most spells to another panel, mirrored from the caster. It has a duration of 32 clock ticks.\"}]}},{\"name\":\"Setiemson\",\"info\":\"Accessory. Effect: Permanent Haste.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"permStatuses\":[{\"name\":\"Haste\",\"info\":\"Increases the unit's Speed by 50%. It has a duration of 28 clock ticks.\"}]}},{\"name\":\"Salty Rage\",\"info\":\"Accessory. Effect: Permanent Protect, Shell.\",\"type\":\"Accessory\",\"slot\":\"accessory\",\"stats\":{\"permStatuses\":[{\"name\":\"Protect\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from physical attacks by a third. It has a duration of 36 clock ticks.\"},{\"name\":\"Shell\",\"info\":\"Decreases the damage (or hitrate) that the unit takes from magical attacks by a third. It has a duration of 36 clock ticks.\"}]}}]}");

});

parcelRegister("iNGLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dafdf8f3a500d0ce$export$2e2bcd8739ae039);
let $dafdf8f3a500d0ce$var$script;




let $dafdf8f3a500d0ce$var$initialize = ()=>{
    $dafdf8f3a500d0ce$var$script = (parcelRequire("dOihj"));
    if ($dafdf8f3a500d0ce$var$script.__esModule) $dafdf8f3a500d0ce$var$script = $dafdf8f3a500d0ce$var$script.default;
    $dafdf8f3a500d0ce$var$script.render = (parcelRequire("agujF")).render;
    $dafdf8f3a500d0ce$var$script.__cssModules = {};
    (parcelRequire("dPKc0")).default($dafdf8f3a500d0ce$var$script);
    $dafdf8f3a500d0ce$var$script.__scopeId = 'data-v-4eb3d0';
    $dafdf8f3a500d0ce$var$script.__file = "PlayerHover.vue";
};
$dafdf8f3a500d0ce$var$initialize();
var $dafdf8f3a500d0ce$export$2e2bcd8739ae039 = $dafdf8f3a500d0ce$var$script;

});
parcelRegister("dOihj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0de1f9174451af5$export$2e2bcd8739ae039);

var $1wkWE = parcelRequire("1wkWE");
var $a0de1f9174451af5$export$2e2bcd8739ae039 = {
    name: 'PlayerHover',
    props: {
        name: {
            type: String,
            required: true
        },
        nameStyle: {
            type: [
                Object,
                String
            ],
            default: ''
        }
    },
    data () {
        return {
            visible: false,
            record: undefined,
            _enterTimer: null,
            _leaveTimer: null,
            _onCard: false
        };
    },
    computed: {
        topClasses () {
            if (!this.record || !this.record.classes) return [];
            return Object.entries(this.record.classes).map(([cls, arr])=>[
                    cls,
                    arr[0]
                ]).sort((a, b)=>b[1] - a[1]).slice(0, 4).map(([cls])=>cls);
        }
    },
    methods: {
        onEnter () {
            clearTimeout(this._leaveTimer);
            this._enterTimer = setTimeout(()=>{
                this.visible = true;
                if (this.record === undefined) this.loadRecord();
            }, 150);
        },
        onLeave () {
            clearTimeout(this._enterTimer);
            this._leaveTimer = setTimeout(()=>{
                if (!this._onCard) this.visible = false;
            }, 120);
        },
        onCardEnter () {
            this._onCard = true;
            clearTimeout(this._leaveTimer);
        },
        onCardLeave () {
            this._onCard = false;
            this._leaveTimer = setTimeout(()=>{
                this.visible = false;
            }, 120);
        },
        async loadRecord () {
            const idx = await (0, $1wkWE.ensurePlayerIndex)();
            if (!idx) {
                this.record = null;
                return;
            }
            const key = Object.keys(idx).find((k)=>k.toLowerCase() === this.name.toLowerCase());
            this.record = key ? idx[key] : null;
        }
    }
};

});
parcelRegister("1wkWE", function(module, exports) {

$parcel$export(module.exports, "ensurePlayerIndex", () => $11b906d9e9d95f90$export$f516d7332a902325);

var $gKfUi = parcelRequire("gKfUi");
let $11b906d9e9d95f90$var$cached = null;
let $11b906d9e9d95f90$var$loading = null;
function $11b906d9e9d95f90$export$f516d7332a902325() {
    if ($11b906d9e9d95f90$var$cached) return Promise.resolve($11b906d9e9d95f90$var$cached);
    if ($11b906d9e9d95f90$var$loading) return $11b906d9e9d95f90$var$loading;
    $11b906d9e9d95f90$var$loading = (0, $gKfUi.loadData)('playerIndex.json').then((d)=>{
        $11b906d9e9d95f90$var$cached = d;
        return $11b906d9e9d95f90$var$cached;
    }).catch(()=>{
        $11b906d9e9d95f90$var$loading = null;
        return null;
    });
    return $11b906d9e9d95f90$var$loading;
}

});


parcelRegister("agujF", function(module, exports) {

$parcel$export(module.exports, "render", () => $7792ea32f30c13d2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7792ea32f30c13d2$var$_hoisted_1 = [
    "href"
];
const $7792ea32f30c13d2$var$_hoisted_2 = {
    class: "ph-line"
};
const $7792ea32f30c13d2$var$_hoisted_3 = {
    key: 0,
    class: "ph-line ph-champ"
};
const $7792ea32f30c13d2$var$_hoisted_4 = {
    key: 1,
    class: "ph-line ph-top"
};
const $7792ea32f30c13d2$var$_hoisted_5 = [
    "href"
];
const $7792ea32f30c13d2$var$_hoisted_6 = [
    "href"
];
const $7792ea32f30c13d2$var$_hoisted_7 = {
    key: 2,
    class: "ph-line ph-loading"
};
function $7792ea32f30c13d2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        class: "ph-wrap",
        onMouseenter: _cache[5] || (_cache[5] = (...args)=>$options.onEnter && $options.onEnter(...args)),
        onMouseleave: _cache[6] || (_cache[6] = (...args)=>$options.onLeave && $options.onLeave(...args))
    }, [
        (0, $TusQn.createElementVNode)("a", {
            href: '?player=' + encodeURIComponent($props.name),
            class: "ph-name",
            style: (0, $8POXm.normalizeStyle)($props.nameStyle),
            onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.name), 1)
                ])
        ], 12, $7792ea32f30c13d2$var$_hoisted_1),
        $data.visible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: "ph-card",
            onMouseenter: _cache[3] || (_cache[3] = (...args)=>$options.onCardEnter && $options.onCardEnter(...args)),
            onMouseleave: _cache[4] || (_cache[4] = (...args)=>$options.onCardLeave && $options.onCardLeave(...args))
        }, [
            $data.record ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("div", $7792ea32f30c13d2$var$_hoisted_2, [
                    (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($data.record.winRate) + "%", 1),
                    (0, $TusQn.createTextVNode)(" \xb7 " + (0, $8POXm.toDisplayString)($data.record.played.toLocaleString()) + " games", 1),
                    $data.record.tw ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createTextVNode)(" \xb7 " + (0, $8POXm.toDisplayString)($data.record.tw.toLocaleString()) + " bracket wins", 1)
                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                $data.record.champ ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7792ea32f30c13d2$var$_hoisted_3, [
                    (0, $TusQn.createTextVNode)("\uD83D\uDC51 " + (0, $8POXm.toDisplayString)($data.record.champ) + " title" + (0, $8POXm.toDisplayString)($data.record.champ === 1 ? '' : 's') + " \xb7 " + (0, $8POXm.toDisplayString)($data.record.champDef || 0) + " defense" + (0, $8POXm.toDisplayString)(($data.record.champDef || 0) === 1 ? '' : 's'), 1),
                    $data.record.champReign ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createTextVNode)(" \xb7 longest " + (0, $8POXm.toDisplayString)($data.record.champReign), 1)
                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $options.topClasses.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7792ea32f30c13d2$var$_hoisted_4, (0, $8POXm.toDisplayString)($options.topClasses.join(" \xb7 ")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("a", {
                    href: '?player=' + encodeURIComponent($props.name),
                    class: "ph-profile",
                    onClick: _cache[1] || (_cache[1] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "stop"
                    ]))
                }, "View profile \u2192", 8, $7792ea32f30c13d2$var$_hoisted_5)
            ], 64)) : $data.record === null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 1
            }, [
                _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("div", {
                    class: "ph-line ph-new"
                }, "New player", -1)),
                (0, $TusQn.createElementVNode)("a", {
                    href: '?player=' + encodeURIComponent($props.name),
                    class: "ph-profile",
                    onClick: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "stop"
                    ]))
                }, "View profile \u2192", 8, $7792ea32f30c13d2$var$_hoisted_6)
            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7792ea32f30c13d2$var$_hoisted_7, "Loading\u2026"))
        ], 32)) : (0, $TusQn.createCommentVNode)("", true)
    ], 32);
}

});

parcelRegister("dPKc0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a123deb2f15f3d36$export$2e2bcd8739ae039);
let $a123deb2f15f3d36$var$NOOP = ()=>{};
var $a123deb2f15f3d36$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ituX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d732f1f72848717f$export$2e2bcd8739ae039);
let $d732f1f72848717f$var$script;



let $d732f1f72848717f$var$initialize = ()=>{
    $d732f1f72848717f$var$script = (parcelRequire("ijVKt"));
    if ($d732f1f72848717f$var$script.__esModule) $d732f1f72848717f$var$script = $d732f1f72848717f$var$script.default;
    $d732f1f72848717f$var$script.render = (parcelRequire("arBwy")).render;
    (parcelRequire("an8tp")).default($d732f1f72848717f$var$script);
    $d732f1f72848717f$var$script.__scopeId = 'data-v-479ca3';
    $d732f1f72848717f$var$script.__file = "AbilityBreakdown.vue";
};
$d732f1f72848717f$var$initialize();
var $d732f1f72848717f$export$2e2bcd8739ae039 = $d732f1f72848717f$var$script;

});
parcelRegister("ijVKt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d566cc072f19f6dd$export$2e2bcd8739ae039);
// The ability hover tooltip on a unit card: the ability name + its API
// description, plus (when present) the precomputed per-target damage/heal
// breakdown. Presentational only — it renders whatever `breakdown` object the
// parent's cached `abilityBreakdowns` map hands it (the parent owns the compute,
// so this stays dumb and never touches the safeDict-proxied game data).
//
// Styling is GLOBAL (.toolTip in tooltips.scss, .tt-* in unit-card.scss) — the
// hover trigger is the parent's `.hasToolTip:hover .toolTip` rule, so this
// component's root must stay a `.toolTip` child of a `.hasToolTip` element.
//
// Shared by inlineUnit's ClassSkills / ExtraSkills / MonsterSkills lists. The
// full-formula section (Phase 4) will slot in between the description and the
// per-target rows.
var $d566cc072f19f6dd$export$2e2bcd8739ae039 = {
    name: 'AbilityBreakdown',
    props: {
        ability: {
            type: String,
            default: ''
        },
        // The ability's API description string (toolTips.Ability[name]).
        description: {
            type: String,
            default: ''
        },
        // { kind, primary, formula, formulaNumbers, formulaValue, rider, attackerMods:[{label,factor}],
        //   sides:[{ key:'enemies'|'allies', label, hypothetical, kind,
        //   rows:[{name,portrait,zodiac,zfactor,value,effect}] }] } — the base
        // formula + applied attacker mods, then both teams (natural side first).
        // null only when the ability isn't a recognized damage/heal/status; `sides`
        // is empty on team-less pages (the formula section still shows).
        breakdown: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            EFFECTS: {
                absorb: 'absorbs',
                cancel: 'immune',
                weak: "weak \xd72",
                half: "\xbd"
            }
        };
    }
};

});

parcelRegister("arBwy", function(module, exports) {

$parcel$export(module.exports, "render", () => $79a9888357f086c1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $79a9888357f086c1$var$_hoisted_1 = {
    key: 0,
    class: "tt-formula"
};
const $79a9888357f086c1$var$_hoisted_2 = {
    key: 0,
    class: "tt-fx"
};
const $79a9888357f086c1$var$_hoisted_3 = {
    key: 1,
    class: "tt-rider"
};
const $79a9888357f086c1$var$_hoisted_4 = {
    key: 2,
    class: "tt-fx tt-fx-num"
};
const $79a9888357f086c1$var$_hoisted_5 = {
    key: 0,
    class: "tt-hyp"
};
const $79a9888357f086c1$var$_hoisted_6 = [
    "src",
    "alt"
];
const $79a9888357f086c1$var$_hoisted_7 = {
    class: "tt-tname"
};
const $79a9888357f086c1$var$_hoisted_8 = {
    key: 1,
    class: "tt-note"
};
function $79a9888357f086c1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        class: "toolTip",
        onClick: _cache[1] || (_cache[1] = (0, $eeJ70.withModifiers)(()=>{}, [
            "stop"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.ability), 1),
        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.description), 1),
        $props.breakdown ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 0
        }, [
            $props.breakdown.formula || $props.breakdown.rider ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_1, [
                $props.breakdown.formula ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_2, (0, $8POXm.toDisplayString)($props.breakdown.formula), 1)) : (0, $TusQn.createCommentVNode)("", true),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.breakdown.attackerMods, (m)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                        key: m.label,
                        class: "tt-mod"
                    }, (0, $8POXm.toDisplayString)(m.label) + " " + (0, $8POXm.toDisplayString)(m.factor), 1);
                }), 128)),
                $props.breakdown.rider ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_3, "may add " + (0, $8POXm.toDisplayString)($props.breakdown.rider), 1)) : (0, $TusQn.createCommentVNode)("", true),
                $props.breakdown.formulaNumbers && $props.breakdown.formulaNumbers !== $props.breakdown.formula ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_4, [
                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.breakdown.formulaNumbers), 1),
                    $props.breakdown.formulaValue ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createTextVNode)(" = " + (0, $8POXm.toDisplayString)($props.breakdown.formulaValue), 1)
                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])) : (0, $TusQn.createCommentVNode)("", true),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.breakdown.sides, (side)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                    key: side.key,
                    class: (0, $8POXm.normalizeClass)([
                        "tt-targets",
                        [
                            'tt-' + side.kind,
                            'tt-side-' + side.key,
                            {
                                'tt-hypo': side.hypothetical
                            }
                        ]
                    ])
                }, [
                    (0, $TusQn.createElementVNode)("b", null, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(side.label), 1),
                        side.hypothetical ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_5, " \u2014 if it hit them")) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(side.rows, (tg)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: tg.name,
                            class: (0, $8POXm.normalizeClass)([
                                "tt-target",
                                {
                                    'tt-generic': tg.generic
                                }
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("img", {
                                class: "tt-portrait",
                                src: tg.portrait,
                                alt: tg.name,
                                onError: _cache[0] || (_cache[0] = ($event)=>$event.target.style.visibility = 'hidden')
                            }, null, 40, $79a9888357f086c1$var$_hoisted_6),
                            (0, $TusQn.createElementVNode)("span", $79a9888357f086c1$var$_hoisted_7, (0, $8POXm.toDisplayString)(tg.name), 1),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "tt-tval",
                                    'z-' + tg.zodiac.toLowerCase()
                                ])
                            }, (0, $8POXm.toDisplayString)(tg.value), 3),
                            tg.zfactor ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: 0,
                                class: (0, $8POXm.normalizeClass)([
                                    "tt-zf",
                                    'z-' + tg.zodiac.toLowerCase()
                                ])
                            }, (0, $8POXm.toDisplayString)(tg.zfactor), 3)) : (0, $TusQn.createCommentVNode)("", true),
                            tg.effect ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: 1,
                                class: (0, $8POXm.normalizeClass)([
                                    "tt-eff",
                                    'eff-' + tg.effect
                                ])
                            }, (0, $8POXm.toDisplayString)($data.EFFECTS[tg.effect]), 3)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 2);
                    }), 128))
                ], 2);
            }), 128)),
            $props.breakdown.kind === 'damage' && $props.breakdown.sides.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $79a9888357f086c1$var$_hoisted_8, "estimate \u2014 no target Protect / Shell / Defense Up")) : (0, $TusQn.createCommentVNode)("", true)
        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("an8tp", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d2a00277305c21$export$2e2bcd8739ae039);
let $78d2a00277305c21$var$NOOP = ()=>{};
var $78d2a00277305c21$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iziJA", function(module, exports) {

$parcel$export(module.exports, "classAdvice", () => $d84a07195ae98b50$export$556e4d5431ac67c5);
$parcel$export(module.exports, "avoidPicks", () => $d84a07195ae98b50$export$ea2338b2982099c6);
$parcel$export(module.exports, "classFullAdvice", () => $d84a07195ae98b50$export$529d3bc32ba70a7c);
$parcel$export(module.exports, "genderEdge", () => (parcelRequire("7qBNy")).genderEdge);
// App-facing class advice: binds the bundled genTokens.json forceable-token set
// to the pure functions in classAdvice.js. Import THIS from components; the pure
// module is for tests (same split as simCalibration / simCalibrationLive).

var $adzaT = parcelRequire("adzaT");

var $7qBNy = parcelRequire("7qBNy");
const $d84a07195ae98b50$var$FORCEABLE = (0, $7qBNy.makeForceable)((0, (/*@__PURE__*/$parcel$interopDefault($adzaT))));
const $d84a07195ae98b50$export$556e4d5431ac67c5 = (rosterStats, cls, opts = {})=>(0, $7qBNy.classAdvice)(rosterStats, cls, {
        forceable: $d84a07195ae98b50$var$FORCEABLE,
        ...opts
    });
const $d84a07195ae98b50$export$ea2338b2982099c6 = (rosterStats, cls, opts = {})=>(0, $7qBNy.avoidPicks)(rosterStats, cls, {
        forceable: $d84a07195ae98b50$var$FORCEABLE,
        ...opts
    });
const $d84a07195ae98b50$export$529d3bc32ba70a7c = (rosterStats, cls, opts = {})=>(0, $7qBNy.classFullAdvice)(rosterStats, cls, {
        forceable: $d84a07195ae98b50$var$FORCEABLE,
        ...opts
    });

});
parcelRegister("adzaT", function(module, exports) {
module.exports = JSON.parse("{\"byToken\":{\"Move+1\":{\"category\":\"movement\",\"name\":\"Move+1\",\"rarity\":\"common\"},\"Move+2\":{\"category\":\"movement\",\"name\":\"Move+2\",\"rarity\":\"common\"},\"Move+3\":{\"category\":\"movement\",\"name\":\"Move+3\",\"rarity\":\"uncommon\"},\"Jump+1\":{\"category\":\"movement\",\"name\":\"Jump+1\",\"rarity\":\"common\"},\"Jump+2\":{\"category\":\"movement\",\"name\":\"Jump+2\",\"rarity\":\"common\"},\"Jump+3\":{\"category\":\"movement\",\"name\":\"Jump+3\",\"rarity\":\"common\"},\"Lifefont\":{\"category\":\"movement\",\"name\":\"Lifefont\",\"rarity\":\"common\"},\"Teleport\":{\"category\":\"movement\",\"name\":\"Teleport\",\"rarity\":\"common\"},\"Levitate\":{\"category\":\"movement\",\"name\":\"Levitate\",\"rarity\":\"common\"},\"Pilgrimage\":{\"category\":\"movement\",\"name\":\"Pilgrimage\",\"rarity\":\"common\"},\"Manafont\":{\"category\":\"movement\",\"name\":\"Manafont\",\"rarity\":\"common\"},\"IgnoreTerrain\":{\"category\":\"movement\",\"name\":\"Ignore Terrain\",\"rarity\":\"common\"},\"LavaWalking\":{\"category\":\"movement\",\"name\":\"Lava Walking\",\"rarity\":\"common\"},\"IgnoreHeight\":{\"category\":\"movement\",\"name\":\"Ignore Height\",\"rarity\":\"common\"},\"Swim\":{\"category\":\"movement\",\"name\":\"Swim\",\"rarity\":\"common\"},\"Waterwalking\":{\"category\":\"movement\",\"name\":\"Waterwalking\",\"rarity\":\"common\"},\"Fly\":{\"category\":\"movement\",\"name\":\"Fly\",\"rarity\":\"common\"},\"Retreat\":{\"category\":\"movement\",\"name\":\"Retreat\",\"rarity\":\"common\"},\"SonicStep\":{\"category\":\"movement\",\"name\":\"Sonic Step\",\"rarity\":\"common\"},\"AttackUp\":{\"category\":\"support\",\"name\":\"Attack Up\",\"rarity\":\"common\"},\"DefenseUp\":{\"category\":\"support\",\"name\":\"Defense Up\",\"rarity\":\"common\"},\"MagicAttackUp\":{\"category\":\"support\",\"name\":\"Magic Attack Up\",\"rarity\":\"common\"},\"MagicDefenseUp\":{\"category\":\"support\",\"name\":\"Magic Defense Up\",\"rarity\":\"common\"},\"Concentrate\":{\"category\":\"support\",\"name\":\"Concentrate\",\"rarity\":\"common\"},\"MartialArts\":{\"category\":\"support\",\"name\":\"Martial Arts\",\"rarity\":\"common\"},\"Maintenance\":{\"category\":\"support\",\"name\":\"Maintenance\",\"rarity\":\"common\"},\"Doublehand\":{\"category\":\"support\",\"name\":\"Doublehand\",\"rarity\":\"rare\"},\"DualWield\":{\"category\":\"support\",\"name\":\"Dual Wield\",\"rarity\":\"rare\"},\"Defend\":{\"category\":\"support\",\"name\":\"Defend\",\"rarity\":\"common\"},\"ShortCharge\":{\"category\":\"support\",\"name\":\"Short Charge\",\"rarity\":\"rare\"},\"HalveMP\":{\"category\":\"support\",\"name\":\"Halve MP\",\"rarity\":\"common\"},\"Beastmaster\":{\"category\":\"support\",\"name\":\"Beastmaster\",\"rarity\":\"common\"},\"EquipArmor\":{\"category\":\"support\",\"name\":\"Equip Armor\",\"rarity\":\"common\"},\"EquipShield\":{\"category\":\"support\",\"name\":\"Equip Shield\",\"rarity\":\"common\"},\"EquipKnife\":{\"category\":\"support\",\"name\":\"Equip Knife\",\"rarity\":\"common\"},\"EquipBow\":{\"category\":\"support\",\"name\":\"Equip Bow\",\"rarity\":\"common\"},\"EquipSword\":{\"category\":\"support\",\"name\":\"Equip Sword\",\"rarity\":\"common\"},\"EquipGun\":{\"category\":\"support\",\"name\":\"Equip Gun\",\"rarity\":\"uncommon\"},\"EquipAxe\":{\"category\":\"support\",\"name\":\"Equip Axe\",\"rarity\":\"common\"},\"EquipPolearm\":{\"category\":\"support\",\"name\":\"Equip Polearm\",\"rarity\":\"common\"},\"SecretHunt\":{\"category\":\"support\",\"name\":\"Secret Hunt\",\"rarity\":\"common\"},\"Sicken\":{\"category\":\"support\",\"name\":\"Sicken\",\"rarity\":\"common\"},\"MonsterTalk\":{\"category\":\"support\",\"name\":\"Monster Talk\",\"rarity\":\"common\"},\"ThrowItem\":{\"category\":\"support\",\"name\":\"Throw Item\",\"rarity\":\"common\"},\"LongStatus\":{\"category\":\"support\",\"name\":\"Long Status\",\"rarity\":\"common\"},\"ShortStatus\":{\"category\":\"support\",\"name\":\"Short Status\",\"rarity\":\"common\"},\"CounterTackle\":{\"category\":\"reaction\",\"name\":\"Counter Tackle\",\"rarity\":\"common\"},\"AutoPotion\":{\"category\":\"reaction\",\"name\":\"Auto Potion\",\"rarity\":\"uncommon\"},\"Parry\":{\"category\":\"reaction\",\"name\":\"Parry\",\"rarity\":\"common\"},\"SpeedSave\":{\"category\":\"reaction\",\"name\":\"Speed Save\",\"rarity\":\"common\"},\"ArrowGuard\":{\"category\":\"reaction\",\"name\":\"Arrow Guard\",\"rarity\":\"common\"},\"HPRestore\":{\"category\":\"reaction\",\"name\":\"HP Restore\",\"rarity\":\"uncommon\"},\"Counter\":{\"category\":\"reaction\",\"name\":\"Counter\",\"rarity\":\"common\"},\"Hamedo\":{\"category\":\"reaction\",\"name\":\"Hamedo\",\"rarity\":\"rare\"},\"Regenerator\":{\"category\":\"reaction\",\"name\":\"Regenerator\",\"rarity\":\"common\"},\"CounterMagic\":{\"category\":\"reaction\",\"name\":\"Counter Magic\",\"rarity\":\"common\"},\"CriticalQuick\":{\"category\":\"reaction\",\"name\":\"Critical Quick\",\"rarity\":\"common\"},\"ManaShield\":{\"category\":\"reaction\",\"name\":\"Mana Shield\",\"rarity\":\"uncommon\"},\"MPRestore\":{\"category\":\"reaction\",\"name\":\"MP Restore\",\"rarity\":\"common\"},\"Caution\":{\"category\":\"reaction\",\"name\":\"Caution\",\"rarity\":\"common\"},\"Catch\":{\"category\":\"reaction\",\"name\":\"Catch\",\"rarity\":\"common\"},\"Earplug\":{\"category\":\"reaction\",\"name\":\"Earplug\",\"rarity\":\"common\"},\"AbsorbUsedMP\":{\"category\":\"reaction\",\"name\":\"Absorb Used MP\",\"rarity\":\"common\"},\"CounterFlood\":{\"category\":\"reaction\",\"name\":\"Counter Flood\",\"rarity\":\"common\"},\"DragonSpirit\":{\"category\":\"reaction\",\"name\":\"Dragon Spirit\",\"rarity\":\"common\"},\"MeatboneSlash\":{\"category\":\"reaction\",\"name\":\"Meatbone Slash\",\"rarity\":\"common\"},\"Abandon\":{\"category\":\"reaction\",\"name\":\"Abandon\",\"rarity\":\"common\"},\"Distribute\":{\"category\":\"reaction\",\"name\":\"Distribute\",\"rarity\":\"common\"},\"DamageSplit\":{\"category\":\"reaction\",\"name\":\"Damage Split\",\"rarity\":\"uncommon\"},\"PASave\":{\"category\":\"reaction\",\"name\":\"PA Save\",\"rarity\":\"common\"},\"MASave\":{\"category\":\"reaction\",\"name\":\"MA Save\",\"rarity\":\"common\"},\"BraveSave\":{\"category\":\"reaction\",\"name\":\"Brave Save\",\"rarity\":\"common\"},\"FaithSave\":{\"category\":\"reaction\",\"name\":\"Faith Save\",\"rarity\":\"common\"},\"SunkenState\":{\"category\":\"reaction\",\"name\":\"Sunken State\",\"rarity\":\"common\"},\"BasicSkill\":{\"category\":\"skillset\",\"name\":\"Basic Skill\",\"rarity\":\"common\"},\"Item\":{\"category\":\"skillset\",\"name\":\"Item\",\"rarity\":\"common\"},\"BattleSkill\":{\"category\":\"skillset\",\"name\":\"Battle Skill\",\"rarity\":\"common\"},\"Charge\":{\"category\":\"skillset\",\"name\":\"Charge\",\"rarity\":\"common\"},\"PunchArt\":{\"category\":\"skillset\",\"name\":\"Punch Art\",\"rarity\":\"common\"},\"WhiteMagic\":{\"category\":\"skillset\",\"name\":\"White Magic\",\"rarity\":\"common\"},\"BlackMagic\":{\"category\":\"skillset\",\"name\":\"Black Magic\",\"rarity\":\"common\"},\"TimeMagic\":{\"category\":\"skillset\",\"name\":\"Time Magic\",\"rarity\":\"common\"},\"SummonMagic\":{\"category\":\"skillset\",\"name\":\"Summon Magic\",\"rarity\":\"common\"},\"Steal\":{\"category\":\"skillset\",\"name\":\"Steal\",\"rarity\":\"common\"},\"TalkSkill\":{\"category\":\"skillset\",\"name\":\"Talk Skill\",\"rarity\":\"common\"},\"YinYangMagic\":{\"category\":\"skillset\",\"name\":\"Yin Yang Magic\",\"rarity\":\"common\"},\"Elemental\":{\"category\":\"skillset\",\"name\":\"Elemental\",\"rarity\":\"common\"},\"Jump\":{\"category\":\"skillset\",\"name\":\"Jump\",\"rarity\":\"common\"},\"DrawOut\":{\"category\":\"skillset\",\"name\":\"Draw Out\",\"rarity\":\"rare\"},\"Throw\":{\"category\":\"skillset\",\"name\":\"Throw\",\"rarity\":\"common\"},\"Dance\":{\"category\":\"skillset\",\"name\":\"Dance\",\"rarity\":\"common\"},\"Sing\":{\"category\":\"skillset\",\"name\":\"Sing\",\"rarity\":\"common\"},\"BlueMagic\":{\"category\":\"skillset\",\"name\":\"Blue Magic\",\"rarity\":\"common\"},\"Chocobo\":{\"category\":\"monster\",\"name\":\"Chocobo\",\"rarity\":\"common\"},\"BlackChocobo\":{\"category\":\"monster\",\"name\":\"Black Chocobo\",\"rarity\":\"common\"},\"RedChocobo\":{\"category\":\"monster\",\"name\":\"Red Chocobo\",\"rarity\":\"rare\"},\"Goblin\":{\"category\":\"monster\",\"name\":\"Goblin\",\"rarity\":\"common\"},\"BlackGoblin\":{\"category\":\"monster\",\"name\":\"Black Goblin\",\"rarity\":\"common\"},\"Gobbledeguck\":{\"category\":\"monster\",\"name\":\"Gobbledeguck\",\"rarity\":\"common\"},\"Bomb\":{\"category\":\"monster\",\"name\":\"Bomb\",\"rarity\":\"common\"},\"Grenade\":{\"category\":\"monster\",\"name\":\"Grenade\",\"rarity\":\"common\"},\"Explosive\":{\"category\":\"monster\",\"name\":\"Explosive\",\"rarity\":\"common\"},\"RedPanther\":{\"category\":\"monster\",\"name\":\"Red Panther\",\"rarity\":\"common\"},\"Coeurl\":{\"category\":\"monster\",\"name\":\"Coeurl\",\"rarity\":\"common\"},\"Vampire\":{\"category\":\"monster\",\"name\":\"Vampire\",\"rarity\":\"common\"},\"PiscoDemon\":{\"category\":\"monster\",\"name\":\"Pisco Demon\",\"rarity\":\"common\"},\"Squidraken\":{\"category\":\"monster\",\"name\":\"Squidraken\",\"rarity\":\"common\"},\"Mindflayer\":{\"category\":\"monster\",\"name\":\"Mindflayer\",\"rarity\":\"common\"},\"Skeleton\":{\"category\":\"monster\",\"name\":\"Skeleton\",\"rarity\":\"common\"},\"Draugr\":{\"category\":\"monster\",\"name\":\"Draugr\",\"rarity\":\"common\"},\"Reaper\":{\"category\":\"monster\",\"name\":\"Reaper\",\"rarity\":\"common\"},\"Ghoul\":{\"category\":\"monster\",\"name\":\"Ghoul\",\"rarity\":\"common\"},\"Ghost\":{\"category\":\"monster\",\"name\":\"Ghost\",\"rarity\":\"common\"},\"Revenant\":{\"category\":\"monster\",\"name\":\"Revenant\",\"rarity\":\"common\"},\"FloatingEye\":{\"category\":\"monster\",\"name\":\"Floating Eye\",\"rarity\":\"common\"},\"Ahriman\":{\"category\":\"monster\",\"name\":\"Ahriman\",\"rarity\":\"common\"},\"Plague\":{\"category\":\"monster\",\"name\":\"Plague\",\"rarity\":\"common\"},\"Juravis\":{\"category\":\"monster\",\"name\":\"Juravis\",\"rarity\":\"common\"},\"IronHawk\":{\"category\":\"monster\",\"name\":\"Iron Hawk\",\"rarity\":\"common\"},\"Cockatrice\":{\"category\":\"monster\",\"name\":\"Cockatrice\",\"rarity\":\"common\"},\"Swine\":{\"category\":\"monster\",\"name\":\"Swine\",\"rarity\":\"common\"},\"Porky\":{\"category\":\"monster\",\"name\":\"Porky\",\"rarity\":\"common\"},\"WildBoar\":{\"category\":\"monster\",\"name\":\"Wild Boar\",\"rarity\":\"common\"},\"Dryad\":{\"category\":\"monster\",\"name\":\"Dryad\",\"rarity\":\"common\"},\"Treant\":{\"category\":\"monster\",\"name\":\"Treant\",\"rarity\":\"common\"},\"Taiju\":{\"category\":\"monster\",\"name\":\"Taiju\",\"rarity\":\"common\"},\"BullDemon\":{\"category\":\"monster\",\"name\":\"Bull Demon\",\"rarity\":\"common\"},\"Minotaur\":{\"category\":\"monster\",\"name\":\"Minotaur\",\"rarity\":\"common\"},\"Sekhret\":{\"category\":\"monster\",\"name\":\"Sekhret\",\"rarity\":\"uncommon\"},\"Malboro\":{\"category\":\"monster\",\"name\":\"Malboro\",\"rarity\":\"common\"},\"Ochu\":{\"category\":\"monster\",\"name\":\"Ochu\",\"rarity\":\"common\"},\"GreatMalboro\":{\"category\":\"monster\",\"name\":\"Great Malboro\",\"rarity\":\"common\"},\"Behemoth\":{\"category\":\"monster\",\"name\":\"Behemoth\",\"rarity\":\"common\"},\"KingBehemoth\":{\"category\":\"monster\",\"name\":\"King Behemoth\",\"rarity\":\"uncommon\"},\"DarkBehemoth\":{\"category\":\"monster\",\"name\":\"Dark Behemoth\",\"rarity\":\"rare\"},\"Dragon\":{\"category\":\"monster\",\"name\":\"Dragon\",\"rarity\":\"uncommon\"},\"BlueDragon\":{\"category\":\"monster\",\"name\":\"Blue Dragon\",\"rarity\":\"uncommon\"},\"RedDragon\":{\"category\":\"monster\",\"name\":\"Red Dragon\",\"rarity\":\"uncommon\"},\"Wyvern\":{\"category\":\"monster\",\"name\":\"Wyvern\",\"rarity\":\"common\"},\"Hydra\":{\"category\":\"monster\",\"name\":\"Hydra\",\"rarity\":\"uncommon\"},\"Tiamat\":{\"category\":\"monster\",\"name\":\"Tiamat\",\"rarity\":\"rare\"},\"ArchaicDemon\":{\"category\":\"monster\",\"name\":\"Archaic Demon\",\"rarity\":\"uncommon\"},\"UltimaDemon\":{\"category\":\"monster\",\"name\":\"Ultima Demon\",\"rarity\":\"rare\"},\"Apanda\":{\"category\":\"monster\",\"name\":\"Apanda\",\"rarity\":\"uncommon\"},\"SteelGiant\":{\"category\":\"monster\",\"name\":\"Steel Giant\",\"rarity\":\"rare\"},\"Byblos\":{\"category\":\"monster\",\"name\":\"Byblos\",\"rarity\":\"rare\"},\"HolyDragon\":{\"category\":\"monster\",\"name\":\"Holy Dragon\",\"rarity\":\"rare\"},\"Serpentarius\":{\"category\":\"monster\",\"name\":\"Serpentarius\",\"rarity\":\"rare\"},\"BattleBoots\":{\"category\":\"accessory\",\"name\":\"Battle Boots\",\"rarity\":\"common\"},\"SpikeShoes\":{\"category\":\"accessory\",\"name\":\"Spike Shoes\",\"rarity\":\"common\"},\"GerminasBoots\":{\"category\":\"accessory\",\"name\":\"Germinas Boots\",\"rarity\":\"common\"},\"RubberShoes\":{\"category\":\"accessory\",\"name\":\"Rubber Shoes\",\"rarity\":\"common\"},\"FeatherBoots\":{\"category\":\"accessory\",\"name\":\"Feather Boots\",\"rarity\":\"common\"},\"SprintShoes\":{\"category\":\"accessory\",\"name\":\"Sprint Shoes\",\"rarity\":\"common\"},\"RedShoes\":{\"category\":\"accessory\",\"name\":\"Red Shoes\",\"rarity\":\"common\"},\"PowerWrist\":{\"category\":\"accessory\",\"name\":\"Power Wrist\",\"rarity\":\"common\"},\"MagicGauntlet\":{\"category\":\"accessory\",\"name\":\"Magic Gauntlet\",\"rarity\":\"common\"},\"Bracer\":{\"category\":\"accessory\",\"name\":\"Bracer\",\"rarity\":\"common\"},\"GenjiGauntlet\":{\"category\":\"accessory\",\"name\":\"Genji Gauntlet\",\"rarity\":\"rare\"},\"ReflectRing\":{\"category\":\"accessory\",\"name\":\"Reflect Ring\",\"rarity\":\"common\"},\"DefenseRing\":{\"category\":\"accessory\",\"name\":\"Defense Ring\",\"rarity\":\"common\"},\"MagicRing\":{\"category\":\"accessory\",\"name\":\"Magic Ring\",\"rarity\":\"common\"},\"CursedRing\":{\"category\":\"accessory\",\"name\":\"Cursed Ring\",\"rarity\":\"common\"},\"AngelRing\":{\"category\":\"accessory\",\"name\":\"Angel Ring\",\"rarity\":\"uncommon\"},\"DiamondArmlet\":{\"category\":\"accessory\",\"name\":\"Diamond Armlet\",\"rarity\":\"common\"},\"JadeArmlet\":{\"category\":\"accessory\",\"name\":\"Jade Armlet\",\"rarity\":\"common\"},\"108Gems\":{\"category\":\"accessory\",\"name\":\"108 Gems\",\"rarity\":\"common\"},\"N-KaiArmlet\":{\"category\":\"accessory\",\"name\":\"N-Kai Armlet\",\"rarity\":\"common\"},\"IronArmlet\":{\"category\":\"accessory\",\"name\":\"Iron Armlet\",\"rarity\":\"common\"},\"SmallMantle\":{\"category\":\"accessory\",\"name\":\"Small Mantle\",\"rarity\":\"common\"},\"LeatherMantle\":{\"category\":\"accessory\",\"name\":\"Leather Mantle\",\"rarity\":\"common\"},\"WizardMantle\":{\"category\":\"accessory\",\"name\":\"Wizard Mantle\",\"rarity\":\"common\"},\"ElfMantle\":{\"category\":\"accessory\",\"name\":\"Elf Mantle\",\"rarity\":\"common\"},\"DraculaMantle\":{\"category\":\"accessory\",\"name\":\"Dracula Mantle\",\"rarity\":\"common\"},\"FeatherMantle\":{\"category\":\"accessory\",\"name\":\"Feather Mantle\",\"rarity\":\"uncommon\"},\"VanishMantle\":{\"category\":\"accessory\",\"name\":\"Vanish Mantle\",\"rarity\":\"rare\"},\"BraveBoost\":{\"category\":\"meta\",\"name\":\"Brave Boost\",\"rarity\":\"common\"},\"FaithBoost\":{\"category\":\"meta\",\"name\":\"Faith Boost\",\"rarity\":\"common\"},\"EXPBoost\":{\"category\":\"meta\",\"name\":\"EXP Boost\",\"rarity\":\"common\"},\"NeutralZodiac\":{\"category\":\"meta\",\"name\":\"Neutral Zodiac\",\"rarity\":\"common\"},\"GearedUp\":{\"category\":\"meta\",\"name\":\"Geared Up\",\"rarity\":\"uncommon\"},\"HighlySkilled\":{\"category\":\"meta\",\"name\":\"Highly Skilled\",\"rarity\":\"uncommon\"},\"GilgameHeart\":{\"category\":\"meta\",\"name\":\"Gilgame Heart\",\"rarity\":\"common\"},\"FashionSense\":{\"category\":\"meta\",\"name\":\"Fashion Sense\",\"rarity\":\"common\"},\"RandomMonster\":{\"category\":\"meta\",\"name\":\"Random Monster\",\"rarity\":\"common\"},\"PreferredArms\":{\"category\":\"meta\",\"name\":\"Preferred Arms\",\"rarity\":\"uncommon\"},\"Teleport2\":{\"category\":\"movement\",\"name\":\"Teleport 2\",\"rarity\":\"rare\"},\"BladeGrasp\":{\"category\":\"reaction\",\"name\":\"Blade Grasp\",\"rarity\":\"rare\"},\"MathSkill\":{\"category\":\"skillset\",\"name\":\"Math Skill\",\"rarity\":\"rare\"},\"EquipPerfume\":{\"category\":\"support\",\"name\":\"Equip Perfume\",\"rarity\":\"rare\"},\"RaidBoss\":{\"category\":\"meta\",\"name\":\"Raid Boss\",\"rarity\":\"rare\"},\"Doppelganger\":{\"category\":\"meta\",\"name\":\"Doppelganger\",\"rarity\":\"rare\"}},\"categories\":{\"movement\":[{\"token\":\"Move+1\",\"name\":\"Move+1\",\"rarity\":\"common\"},{\"token\":\"Move+2\",\"name\":\"Move+2\",\"rarity\":\"common\"},{\"token\":\"Move+3\",\"name\":\"Move+3\",\"rarity\":\"uncommon\"},{\"token\":\"Jump+1\",\"name\":\"Jump+1\",\"rarity\":\"common\"},{\"token\":\"Jump+2\",\"name\":\"Jump+2\",\"rarity\":\"common\"},{\"token\":\"Jump+3\",\"name\":\"Jump+3\",\"rarity\":\"common\"},{\"token\":\"Lifefont\",\"name\":\"Lifefont\",\"rarity\":\"common\"},{\"token\":\"Teleport\",\"name\":\"Teleport\",\"rarity\":\"common\"},{\"token\":\"Levitate\",\"name\":\"Levitate\",\"rarity\":\"common\"},{\"token\":\"Pilgrimage\",\"name\":\"Pilgrimage\",\"rarity\":\"common\"},{\"token\":\"Manafont\",\"name\":\"Manafont\",\"rarity\":\"common\"},{\"token\":\"IgnoreTerrain\",\"name\":\"Ignore Terrain\",\"rarity\":\"common\"},{\"token\":\"LavaWalking\",\"name\":\"Lava Walking\",\"rarity\":\"common\"},{\"token\":\"IgnoreHeight\",\"name\":\"Ignore Height\",\"rarity\":\"common\"},{\"token\":\"Swim\",\"name\":\"Swim\",\"rarity\":\"common\"},{\"token\":\"Waterwalking\",\"name\":\"Waterwalking\",\"rarity\":\"common\"},{\"token\":\"Fly\",\"name\":\"Fly\",\"rarity\":\"common\"},{\"token\":\"Retreat\",\"name\":\"Retreat\",\"rarity\":\"common\"},{\"token\":\"SonicStep\",\"name\":\"Sonic Step\",\"rarity\":\"common\"},{\"token\":\"Teleport2\",\"name\":\"Teleport 2\",\"rarity\":\"rare\"}],\"support\":[{\"token\":\"AttackUp\",\"name\":\"Attack Up\",\"rarity\":\"common\"},{\"token\":\"DefenseUp\",\"name\":\"Defense Up\",\"rarity\":\"common\"},{\"token\":\"MagicAttackUp\",\"name\":\"Magic Attack Up\",\"rarity\":\"common\"},{\"token\":\"MagicDefenseUp\",\"name\":\"Magic Defense Up\",\"rarity\":\"common\"},{\"token\":\"Concentrate\",\"name\":\"Concentrate\",\"rarity\":\"common\"},{\"token\":\"MartialArts\",\"name\":\"Martial Arts\",\"rarity\":\"common\"},{\"token\":\"Maintenance\",\"name\":\"Maintenance\",\"rarity\":\"common\"},{\"token\":\"Doublehand\",\"name\":\"Doublehand\",\"rarity\":\"rare\"},{\"token\":\"DualWield\",\"name\":\"Dual Wield\",\"rarity\":\"rare\"},{\"token\":\"Defend\",\"name\":\"Defend\",\"rarity\":\"common\"},{\"token\":\"ShortCharge\",\"name\":\"Short Charge\",\"rarity\":\"rare\"},{\"token\":\"HalveMP\",\"name\":\"Halve MP\",\"rarity\":\"common\"},{\"token\":\"Beastmaster\",\"name\":\"Beastmaster\",\"rarity\":\"common\"},{\"token\":\"EquipArmor\",\"name\":\"Equip Armor\",\"rarity\":\"common\"},{\"token\":\"EquipShield\",\"name\":\"Equip Shield\",\"rarity\":\"common\"},{\"token\":\"EquipKnife\",\"name\":\"Equip Knife\",\"rarity\":\"common\"},{\"token\":\"EquipBow\",\"name\":\"Equip Bow\",\"rarity\":\"common\"},{\"token\":\"EquipSword\",\"name\":\"Equip Sword\",\"rarity\":\"common\"},{\"token\":\"EquipGun\",\"name\":\"Equip Gun\",\"rarity\":\"uncommon\"},{\"token\":\"EquipAxe\",\"name\":\"Equip Axe\",\"rarity\":\"common\"},{\"token\":\"EquipPolearm\",\"name\":\"Equip Polearm\",\"rarity\":\"common\"},{\"token\":\"SecretHunt\",\"name\":\"Secret Hunt\",\"rarity\":\"common\"},{\"token\":\"Sicken\",\"name\":\"Sicken\",\"rarity\":\"common\"},{\"token\":\"MonsterTalk\",\"name\":\"Monster Talk\",\"rarity\":\"common\"},{\"token\":\"ThrowItem\",\"name\":\"Throw Item\",\"rarity\":\"common\"},{\"token\":\"LongStatus\",\"name\":\"Long Status\",\"rarity\":\"common\"},{\"token\":\"ShortStatus\",\"name\":\"Short Status\",\"rarity\":\"common\"},{\"token\":\"EquipPerfume\",\"name\":\"Equip Perfume\",\"rarity\":\"rare\"}],\"reaction\":[{\"token\":\"CounterTackle\",\"name\":\"Counter Tackle\",\"rarity\":\"common\"},{\"token\":\"AutoPotion\",\"name\":\"Auto Potion\",\"rarity\":\"uncommon\"},{\"token\":\"Parry\",\"name\":\"Parry\",\"rarity\":\"common\"},{\"token\":\"SpeedSave\",\"name\":\"Speed Save\",\"rarity\":\"common\"},{\"token\":\"ArrowGuard\",\"name\":\"Arrow Guard\",\"rarity\":\"common\"},{\"token\":\"HPRestore\",\"name\":\"HP Restore\",\"rarity\":\"uncommon\"},{\"token\":\"Counter\",\"name\":\"Counter\",\"rarity\":\"common\"},{\"token\":\"Hamedo\",\"name\":\"Hamedo\",\"rarity\":\"rare\"},{\"token\":\"Regenerator\",\"name\":\"Regenerator\",\"rarity\":\"common\"},{\"token\":\"CounterMagic\",\"name\":\"Counter Magic\",\"rarity\":\"common\"},{\"token\":\"CriticalQuick\",\"name\":\"Critical Quick\",\"rarity\":\"common\"},{\"token\":\"ManaShield\",\"name\":\"Mana Shield\",\"rarity\":\"uncommon\"},{\"token\":\"MPRestore\",\"name\":\"MP Restore\",\"rarity\":\"common\"},{\"token\":\"Caution\",\"name\":\"Caution\",\"rarity\":\"common\"},{\"token\":\"Catch\",\"name\":\"Catch\",\"rarity\":\"common\"},{\"token\":\"Earplug\",\"name\":\"Earplug\",\"rarity\":\"common\"},{\"token\":\"AbsorbUsedMP\",\"name\":\"Absorb Used MP\",\"rarity\":\"common\"},{\"token\":\"CounterFlood\",\"name\":\"Counter Flood\",\"rarity\":\"common\"},{\"token\":\"DragonSpirit\",\"name\":\"Dragon Spirit\",\"rarity\":\"common\"},{\"token\":\"MeatboneSlash\",\"name\":\"Meatbone Slash\",\"rarity\":\"common\"},{\"token\":\"Abandon\",\"name\":\"Abandon\",\"rarity\":\"common\"},{\"token\":\"Distribute\",\"name\":\"Distribute\",\"rarity\":\"common\"},{\"token\":\"DamageSplit\",\"name\":\"Damage Split\",\"rarity\":\"uncommon\"},{\"token\":\"PASave\",\"name\":\"PA Save\",\"rarity\":\"common\"},{\"token\":\"MASave\",\"name\":\"MA Save\",\"rarity\":\"common\"},{\"token\":\"BraveSave\",\"name\":\"Brave Save\",\"rarity\":\"common\"},{\"token\":\"FaithSave\",\"name\":\"Faith Save\",\"rarity\":\"common\"},{\"token\":\"SunkenState\",\"name\":\"Sunken State\",\"rarity\":\"common\"},{\"token\":\"BladeGrasp\",\"name\":\"Blade Grasp\",\"rarity\":\"rare\"}],\"skillset\":[{\"token\":\"BasicSkill\",\"name\":\"Basic Skill\",\"rarity\":\"common\"},{\"token\":\"Item\",\"name\":\"Item\",\"rarity\":\"common\"},{\"token\":\"BattleSkill\",\"name\":\"Battle Skill\",\"rarity\":\"common\"},{\"token\":\"Charge\",\"name\":\"Charge\",\"rarity\":\"common\"},{\"token\":\"PunchArt\",\"name\":\"Punch Art\",\"rarity\":\"common\"},{\"token\":\"WhiteMagic\",\"name\":\"White Magic\",\"rarity\":\"common\"},{\"token\":\"BlackMagic\",\"name\":\"Black Magic\",\"rarity\":\"common\"},{\"token\":\"TimeMagic\",\"name\":\"Time Magic\",\"rarity\":\"common\"},{\"token\":\"SummonMagic\",\"name\":\"Summon Magic\",\"rarity\":\"common\"},{\"token\":\"Steal\",\"name\":\"Steal\",\"rarity\":\"common\"},{\"token\":\"TalkSkill\",\"name\":\"Talk Skill\",\"rarity\":\"common\"},{\"token\":\"YinYangMagic\",\"name\":\"Yin Yang Magic\",\"rarity\":\"common\"},{\"token\":\"Elemental\",\"name\":\"Elemental\",\"rarity\":\"common\"},{\"token\":\"Jump\",\"name\":\"Jump\",\"rarity\":\"common\"},{\"token\":\"DrawOut\",\"name\":\"Draw Out\",\"rarity\":\"rare\"},{\"token\":\"Throw\",\"name\":\"Throw\",\"rarity\":\"common\"},{\"token\":\"Dance\",\"name\":\"Dance\",\"rarity\":\"common\"},{\"token\":\"Sing\",\"name\":\"Sing\",\"rarity\":\"common\"},{\"token\":\"BlueMagic\",\"name\":\"Blue Magic\",\"rarity\":\"common\"},{\"token\":\"MathSkill\",\"name\":\"Math Skill\",\"rarity\":\"rare\"}],\"monster\":[{\"token\":\"Chocobo\",\"name\":\"Chocobo\",\"rarity\":\"common\"},{\"token\":\"BlackChocobo\",\"name\":\"Black Chocobo\",\"rarity\":\"common\"},{\"token\":\"RedChocobo\",\"name\":\"Red Chocobo\",\"rarity\":\"rare\"},{\"token\":\"Goblin\",\"name\":\"Goblin\",\"rarity\":\"common\"},{\"token\":\"BlackGoblin\",\"name\":\"Black Goblin\",\"rarity\":\"common\"},{\"token\":\"Gobbledeguck\",\"name\":\"Gobbledeguck\",\"rarity\":\"common\"},{\"token\":\"Bomb\",\"name\":\"Bomb\",\"rarity\":\"common\"},{\"token\":\"Grenade\",\"name\":\"Grenade\",\"rarity\":\"common\"},{\"token\":\"Explosive\",\"name\":\"Explosive\",\"rarity\":\"common\"},{\"token\":\"RedPanther\",\"name\":\"Red Panther\",\"rarity\":\"common\"},{\"token\":\"Coeurl\",\"name\":\"Coeurl\",\"rarity\":\"common\"},{\"token\":\"Vampire\",\"name\":\"Vampire\",\"rarity\":\"common\"},{\"token\":\"PiscoDemon\",\"name\":\"Pisco Demon\",\"rarity\":\"common\"},{\"token\":\"Squidraken\",\"name\":\"Squidraken\",\"rarity\":\"common\"},{\"token\":\"Mindflayer\",\"name\":\"Mindflayer\",\"rarity\":\"common\"},{\"token\":\"Skeleton\",\"name\":\"Skeleton\",\"rarity\":\"common\"},{\"token\":\"Draugr\",\"name\":\"Draugr\",\"rarity\":\"common\"},{\"token\":\"Reaper\",\"name\":\"Reaper\",\"rarity\":\"common\"},{\"token\":\"Ghoul\",\"name\":\"Ghoul\",\"rarity\":\"common\"},{\"token\":\"Ghost\",\"name\":\"Ghost\",\"rarity\":\"common\"},{\"token\":\"Revenant\",\"name\":\"Revenant\",\"rarity\":\"common\"},{\"token\":\"FloatingEye\",\"name\":\"Floating Eye\",\"rarity\":\"common\"},{\"token\":\"Ahriman\",\"name\":\"Ahriman\",\"rarity\":\"common\"},{\"token\":\"Plague\",\"name\":\"Plague\",\"rarity\":\"common\"},{\"token\":\"Juravis\",\"name\":\"Juravis\",\"rarity\":\"common\"},{\"token\":\"IronHawk\",\"name\":\"Iron Hawk\",\"rarity\":\"common\"},{\"token\":\"Cockatrice\",\"name\":\"Cockatrice\",\"rarity\":\"common\"},{\"token\":\"Swine\",\"name\":\"Swine\",\"rarity\":\"common\"},{\"token\":\"Porky\",\"name\":\"Porky\",\"rarity\":\"common\"},{\"token\":\"WildBoar\",\"name\":\"Wild Boar\",\"rarity\":\"common\"},{\"token\":\"Dryad\",\"name\":\"Dryad\",\"rarity\":\"common\"},{\"token\":\"Treant\",\"name\":\"Treant\",\"rarity\":\"common\"},{\"token\":\"Taiju\",\"name\":\"Taiju\",\"rarity\":\"common\"},{\"token\":\"BullDemon\",\"name\":\"Bull Demon\",\"rarity\":\"common\"},{\"token\":\"Minotaur\",\"name\":\"Minotaur\",\"rarity\":\"common\"},{\"token\":\"Sekhret\",\"name\":\"Sekhret\",\"rarity\":\"uncommon\"},{\"token\":\"Malboro\",\"name\":\"Malboro\",\"rarity\":\"common\"},{\"token\":\"Ochu\",\"name\":\"Ochu\",\"rarity\":\"common\"},{\"token\":\"GreatMalboro\",\"name\":\"Great Malboro\",\"rarity\":\"common\"},{\"token\":\"Behemoth\",\"name\":\"Behemoth\",\"rarity\":\"common\"},{\"token\":\"KingBehemoth\",\"name\":\"King Behemoth\",\"rarity\":\"uncommon\"},{\"token\":\"DarkBehemoth\",\"name\":\"Dark Behemoth\",\"rarity\":\"rare\"},{\"token\":\"Dragon\",\"name\":\"Dragon\",\"rarity\":\"uncommon\"},{\"token\":\"BlueDragon\",\"name\":\"Blue Dragon\",\"rarity\":\"uncommon\"},{\"token\":\"RedDragon\",\"name\":\"Red Dragon\",\"rarity\":\"uncommon\"},{\"token\":\"Wyvern\",\"name\":\"Wyvern\",\"rarity\":\"common\"},{\"token\":\"Hydra\",\"name\":\"Hydra\",\"rarity\":\"uncommon\"},{\"token\":\"Tiamat\",\"name\":\"Tiamat\",\"rarity\":\"rare\"},{\"token\":\"ArchaicDemon\",\"name\":\"Archaic Demon\",\"rarity\":\"uncommon\"},{\"token\":\"UltimaDemon\",\"name\":\"Ultima Demon\",\"rarity\":\"rare\"},{\"token\":\"Apanda\",\"name\":\"Apanda\",\"rarity\":\"uncommon\"},{\"token\":\"SteelGiant\",\"name\":\"Steel Giant\",\"rarity\":\"rare\"},{\"token\":\"Byblos\",\"name\":\"Byblos\",\"rarity\":\"rare\"},{\"token\":\"HolyDragon\",\"name\":\"Holy Dragon\",\"rarity\":\"rare\"},{\"token\":\"Serpentarius\",\"name\":\"Serpentarius\",\"rarity\":\"rare\"}],\"accessory\":[{\"token\":\"BattleBoots\",\"name\":\"Battle Boots\",\"rarity\":\"common\"},{\"token\":\"SpikeShoes\",\"name\":\"Spike Shoes\",\"rarity\":\"common\"},{\"token\":\"GerminasBoots\",\"name\":\"Germinas Boots\",\"rarity\":\"common\"},{\"token\":\"RubberShoes\",\"name\":\"Rubber Shoes\",\"rarity\":\"common\"},{\"token\":\"FeatherBoots\",\"name\":\"Feather Boots\",\"rarity\":\"common\"},{\"token\":\"SprintShoes\",\"name\":\"Sprint Shoes\",\"rarity\":\"common\"},{\"token\":\"RedShoes\",\"name\":\"Red Shoes\",\"rarity\":\"common\"},{\"token\":\"PowerWrist\",\"name\":\"Power Wrist\",\"rarity\":\"common\"},{\"token\":\"MagicGauntlet\",\"name\":\"Magic Gauntlet\",\"rarity\":\"common\"},{\"token\":\"Bracer\",\"name\":\"Bracer\",\"rarity\":\"common\"},{\"token\":\"GenjiGauntlet\",\"name\":\"Genji Gauntlet\",\"rarity\":\"rare\"},{\"token\":\"ReflectRing\",\"name\":\"Reflect Ring\",\"rarity\":\"common\"},{\"token\":\"DefenseRing\",\"name\":\"Defense Ring\",\"rarity\":\"common\"},{\"token\":\"MagicRing\",\"name\":\"Magic Ring\",\"rarity\":\"common\"},{\"token\":\"CursedRing\",\"name\":\"Cursed Ring\",\"rarity\":\"common\"},{\"token\":\"AngelRing\",\"name\":\"Angel Ring\",\"rarity\":\"uncommon\"},{\"token\":\"DiamondArmlet\",\"name\":\"Diamond Armlet\",\"rarity\":\"common\"},{\"token\":\"JadeArmlet\",\"name\":\"Jade Armlet\",\"rarity\":\"common\"},{\"token\":\"108Gems\",\"name\":\"108 Gems\",\"rarity\":\"common\"},{\"token\":\"N-KaiArmlet\",\"name\":\"N-Kai Armlet\",\"rarity\":\"common\"},{\"token\":\"IronArmlet\",\"name\":\"Iron Armlet\",\"rarity\":\"common\"},{\"token\":\"SmallMantle\",\"name\":\"Small Mantle\",\"rarity\":\"common\"},{\"token\":\"LeatherMantle\",\"name\":\"Leather Mantle\",\"rarity\":\"common\"},{\"token\":\"WizardMantle\",\"name\":\"Wizard Mantle\",\"rarity\":\"common\"},{\"token\":\"ElfMantle\",\"name\":\"Elf Mantle\",\"rarity\":\"common\"},{\"token\":\"DraculaMantle\",\"name\":\"Dracula Mantle\",\"rarity\":\"common\"},{\"token\":\"FeatherMantle\",\"name\":\"Feather Mantle\",\"rarity\":\"uncommon\"},{\"token\":\"VanishMantle\",\"name\":\"Vanish Mantle\",\"rarity\":\"rare\"}],\"meta\":[{\"token\":\"BraveBoost\",\"name\":\"Brave Boost\",\"rarity\":\"common\"},{\"token\":\"FaithBoost\",\"name\":\"Faith Boost\",\"rarity\":\"common\"},{\"token\":\"EXPBoost\",\"name\":\"EXP Boost\",\"rarity\":\"common\"},{\"token\":\"NeutralZodiac\",\"name\":\"Neutral Zodiac\",\"rarity\":\"common\"},{\"token\":\"GearedUp\",\"name\":\"Geared Up\",\"rarity\":\"uncommon\"},{\"token\":\"HighlySkilled\",\"name\":\"Highly Skilled\",\"rarity\":\"uncommon\"},{\"token\":\"GilgameHeart\",\"name\":\"Gilgame Heart\",\"rarity\":\"common\"},{\"token\":\"FashionSense\",\"name\":\"Fashion Sense\",\"rarity\":\"common\"},{\"token\":\"RandomMonster\",\"name\":\"Random Monster\",\"rarity\":\"common\"},{\"token\":\"PreferredArms\",\"name\":\"Preferred Arms\",\"rarity\":\"uncommon\"},{\"token\":\"RaidBoss\",\"name\":\"Raid Boss\",\"rarity\":\"rare\"},{\"token\":\"Doppelganger\",\"name\":\"Doppelganger\",\"rarity\":\"rare\"}]}}");

});

parcelRegister("7qBNy", function(module, exports) {

$parcel$export(module.exports, "makeForceable", () => $5688480e4f6d09c4$export$9ea72f6993956e0a);
$parcel$export(module.exports, "classAdvice", () => $5688480e4f6d09c4$export$556e4d5431ac67c5);
$parcel$export(module.exports, "avoidPicks", () => $5688480e4f6d09c4$export$ea2338b2982099c6);
$parcel$export(module.exports, "classFullAdvice", () => $5688480e4f6d09c4$export$529d3bc32ba70a7c);
$parcel$export(module.exports, "genderEdge", () => $5688480e4f6d09c4$export$3c0d494a7da94148);
// Per-class "what to roll" advice, derived from the empirical cross-tab win
// rates in rosterStats.crossByClass (win rate of each Support/Reaction/Move
// skill WHEN CARRIED BY a given class). Inverts that map to answer "for this
// class, which skills in each slot have historically won most?" — so the
// generator's dice helper and the strategy page give real, class-specific
// picks instead of generic folklore.
//
// Correlational, not causal (good players pick good skills), and it only
// reflects skills that actually appear on the class often enough to clear the
// sample floor — but it's grounded in years of real outcomes.
// Only ever suggest FORCEABLE picks — the stream tokens a player can actually force
// on a roll (Wizard Mantle yes, Chantage/Salty Rage no; Short Charge yes, the gated
// Math Skill / Doppelganger no). Matched case-insensitively by display name.
// The set is INJECTED (opts.forceable, built by makeForceable from genTokens.json)
// so this module stays pure and raw-Node-testable — a direct JSON import needs an
// import attribute on modern Node. Components import classAdviceLive.js, which
// binds the bundled JSON (same split as simCalibration/-Live). No set ⇒ no filter.
function $5688480e4f6d09c4$export$9ea72f6993956e0a(genTokens) {
    return new Set(Object.values(genTokens.byToken || {}).map((t)=>(t.name || '').toLowerCase()));
}
// Hidden skills (below) are forceable tokens too, since genTokens lists them so the What
// Chat Forces page recognizes them, so they're excluded here by name, not by absence.
const $5688480e4f6d09c4$var$forceable = (fset, skill)=>!$5688480e4f6d09c4$export$273e90ca5a6e6be1.has(skill) && (!fset || fset.has((skill || '').toLowerCase()));
const $5688480e4f6d09c4$var$SLOTS = [
    [
        'ActionSkill',
        'Secondary'
    ],
    [
        'SupportSkill',
        'Support'
    ],
    [
        'ReactionSkill',
        'Reaction'
    ],
    [
        'MoveSkill',
        'Move'
    ],
    [
        'Accessory',
        'Accessory'
    ]
];
const $5688480e4f6d09c4$export$273e90ca5a6e6be1 = new Set([
    'Math Skill',
    'Doppelganger',
    'Equip Perfume',
    'Blade Grasp',
    'Teleport 2',
    'Raid Boss'
]);
// Find a class entry in a cross-tab array. With a gender, only that gender's row counts.
// It used to fall back to the combined row, which gave a gender figures for skillsets it
// can never roll: the Classes page offered Sing as a ban for a female Time Mage, using
// the male Time Mage's 44.5%. Female units never roll Sing and males never roll Dance,
// so neither has a row for the other gender. Without a gender, Male+Female combine
// (weighted avg winRate, summed played).
function $5688480e4f6d09c4$var$findCross(arr, cls, gender) {
    if (!arr) return null;
    if (gender === 'Male' || gender === 'Female') return arr.find((x)=>x.value === cls + ' ' + gender) || null;
    const plain = arr.find((x)=>x.value === cls);
    if (plain) return plain;
    const m = arr.find((x)=>x.value === cls + ' Male');
    const f = arr.find((x)=>x.value === cls + ' Female');
    if (!m && !f) return null;
    if (!m) return f;
    if (!f) return m;
    const played = m.played + f.played;
    return {
        value: cls,
        winRate: Math.round((m.winRate * m.played + f.winRate * f.played) / played * 10) / 10,
        played: played
    };
}
// Top `n` skills for `cls` in dimension `dim`, ranked by win rate, with a
// sample floor so a 3-game fluke doesn't top the list.
function $5688480e4f6d09c4$var$topForSlot(rosterStats, cls, dim, n, minPlayed, gender, fset) {
    const cb = rosterStats.crossByClass && rosterStats.crossByClass[dim] || {};
    const out = [];
    for(const skill in cb){
        if (!$5688480e4f6d09c4$var$forceable(fset, skill)) continue; // only suggest forceable tokens
        const hit = $5688480e4f6d09c4$var$findCross(cb[skill], cls, gender);
        if (hit && hit.played >= minPlayed) out.push({
            skill: skill,
            winRate: hit.winRate,
            played: hit.played
        });
    }
    return out.sort((a, b)=>b.winRate - a.winRate).slice(0, n);
}
function $5688480e4f6d09c4$export$556e4d5431ac67c5(rosterStats, cls, opts = {}) {
    const n = opts.n || 3, minPlayed = opts.minPlayed || 150;
    const out = {};
    for (const [dim, label] of $5688480e4f6d09c4$var$SLOTS)out[label] = $5688480e4f6d09c4$var$topForSlot(rosterStats, cls, dim, n, minPlayed, opts.gender, opts.forceable);
    return out;
}
function $5688480e4f6d09c4$export$ea2338b2982099c6(rosterStats, cls, opts = {}) {
    const n = opts.n || 2, minPlayed = opts.minPlayed || 300, ceiling = opts.ceiling || 49;
    const all = [];
    for (const [dim] of $5688480e4f6d09c4$var$SLOTS){
        const cb = rosterStats.crossByClass && rosterStats.crossByClass[dim] || {};
        for(const skill in cb){
            if (!$5688480e4f6d09c4$var$forceable(opts.forceable, skill) || /^Equip /.test(skill)) continue;
            const hit = $5688480e4f6d09c4$var$findCross(cb[skill], cls, opts.gender);
            if (hit && hit.played >= minPlayed && hit.winRate < ceiling) all.push({
                skill: skill,
                winRate: hit.winRate
            });
        }
    }
    return all.sort((a, b)=>a.winRate - b.winRate).slice(0, n);
}
function $5688480e4f6d09c4$export$529d3bc32ba70a7c(rosterStats, cls, opts = {}) {
    const n = opts.n || 5, minPlayed = opts.minPlayed || 120;
    const out = {};
    for (const [dim, label] of $5688480e4f6d09c4$var$SLOTS){
        const cb = rosterStats.crossByClass && rosterStats.crossByClass[dim] || {};
        const rows = [];
        for(const skill in cb){
            if (!$5688480e4f6d09c4$var$forceable(opts.forceable, skill)) continue;
            const hit = $5688480e4f6d09c4$var$findCross(cb[skill], cls, opts.gender);
            if (hit && hit.played >= minPlayed) rows.push({
                skill: skill,
                winRate: hit.winRate,
                played: hit.played
            });
        }
        const best = [
            ...rows
        ].sort((a, b)=>b.winRate - a.winRate).slice(0, n);
        const worst = rows.filter((r)=>!/^Equip /.test(r.skill)).sort((a, b)=>a.winRate - b.winRate).slice(0, n);
        out[label] = {
            best: best,
            worst: worst,
            total: rows.length
        };
    }
    return out;
}
function $5688480e4f6d09c4$export$3c0d494a7da94148(rosterStats, cls, opts = {}) {
    const minDelta = opts.minDelta || 1.0, minPlayed = opts.minPlayed || 500;
    const cg = rosterStats.windows && rosterStats.windows.all && rosterStats.windows.all.ClassGender || [];
    const m = cg.find((x)=>x.value === cls + ' Male');
    const f = cg.find((x)=>x.value === cls + ' Female');
    if (!m || !f || m.played < minPlayed || f.played < minPlayed) return null;
    const delta = +Math.abs(m.winRate - f.winRate).toFixed(1);
    if (delta < minDelta) return null;
    return {
        gender: m.winRate >= f.winRate ? 'Male' : 'Female',
        delta: delta
    };
}

});


parcelRegister("bTyhe", function(module, exports) {

$parcel$export(module.exports, "exportUnit", () => $8a8f6b6c38fa4a2a$export$df24010bdeea6855);
$parcel$export(module.exports, "parseUnit", () => $8a8f6b6c38fa4a2a$export$96f9b964dfffecb5);
$parcel$export(module.exports, "encodeBuild", () => $8a8f6b6c38fa4a2a$export$fbeb63c721dead98);
$parcel$export(module.exports, "decodeBuild", () => $8a8f6b6c38fa4a2a$export$bb3662a325e1c488);
// Stream (Twitch) character format — serialize a unit to the fixed-position text
// block the FFTBG stream uses. Confirmed against real exports incl. a Mime: every
// unit is a rigid line frame (each slot a line, BLANK when empty — never omitted):
//
//   Name
//   Gender            ("Monster" for monsters)
//   Sign
//   Brave
//   Faith
//   Class             (monster name for monsters)
//   Secondary skillset
//   Reaction
//   Support
//   Move
//   <blank>
//   Mainhand
//   Offhand
//   Head
//   Armor
//   Accessory
//   <blank>
//   primary-class abilities, comma-separated
//   secondary-skillset abilities, comma-separated
//
// Monsters keep the frame with Gender="Monster", Class=monster name, and the
// skill/gear/ability lines blank. A single-character export optionally leads with
// "Player: !<name>" (the Team/Palettes header is deferred — teams come later).

var $6ZWSX = parcelRequire("6ZWSX");
var $8a8f6b6c38fa4a2a$require$Buffer = $6ZWSX.Buffer;
const $8a8f6b6c38fa4a2a$var$LF = '\n';
function $8a8f6b6c38fa4a2a$export$df24010bdeea6855(unit, playerName) {
    const u = unit || {};
    const isMon = (u.Gender || '') === 'Monster';
    const out = [];
    if (playerName) out.push('Player: !' + playerName, '');
    out.push(u.Name || '', isMon ? 'Monster' : u.Gender || '', u.Sign || '', u.Brave == null ? '' : String(u.Brave), u.Faith == null ? '' : String(u.Faith), u.Class || '', u.ActionSkill || '', u.ReactionSkill || '', u.SupportSkill || '', u.MoveSkill || '', '', u.Mainhand || '', u.Offhand || '', u.Head || '', u.Armor || '', u.Accessory || '', '', (u.ClassSkills || []).join(', '), (u.ExtraSkills || []).join(', '));
    return out.join($8a8f6b6c38fa4a2a$var$LF);
}
function $8a8f6b6c38fa4a2a$export$96f9b964dfffecb5(text) {
    const lines = String(text == null ? '' : text).replace(/\r/g, '').split('\n');
    let player = '';
    // strip a leading header (Player/Team/Palettes) + blank lines
    while(lines.length){
        const l = lines[0].trim();
        if (/^player\s*:/i.test(l)) {
            player = l.replace(/^player\s*:\s*!?/i, '').trim();
            lines.shift();
            continue;
        }
        if (/^(team|palettes)\s*:/i.test(l)) {
            lines.shift();
            continue;
        }
        if (l === '') {
            lines.shift();
            continue;
        }
        break;
    }
    const L = (i)=>lines[i] == null ? '' : lines[i].trim();
    const csv = (s)=>s ? s.split(',').map((x)=>x.trim()).filter(Boolean) : [];
    const num = (s)=>{
        const n = parseInt(s, 10);
        return Number.isFinite(n) ? n : null;
    };
    return {
        player: player,
        Name: L(0),
        Gender: L(1),
        Sign: L(2),
        Brave: num(L(3)),
        Faith: num(L(4)),
        Class: L(5),
        ActionSkill: L(6),
        ReactionSkill: L(7),
        SupportSkill: L(8),
        MoveSkill: L(9),
        // L(10) separator
        Mainhand: L(11),
        Offhand: L(12),
        Head: L(13),
        Armor: L(14),
        Accessory: L(15),
        // L(16) separator
        ClassSkills: csv(L(17)),
        ExtraSkills: csv(L(18))
    };
}
// --- shareable-link codec: base64url of the export text -----------------------
// Reuses the export/parse round-trip so a ?build&u=<...> link is the same data as
// a copy-pasted block. URL-safe base64 (no +, /, =), UTF-8 safe.
function $8a8f6b6c38fa4a2a$var$b64urlEncode(str) {
    const bin = unescape(encodeURIComponent(str));
    const b64 = typeof btoa === 'function' ? btoa(bin) : $8a8f6b6c38fa4a2a$require$Buffer.from(bin, 'binary').toString('base64');
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $8a8f6b6c38fa4a2a$var$b64urlDecode(s) {
    s = String(s).replace(/-/g, '+').replace(/_/g, '/');
    const pad = s.length % 4 ? '='.repeat(4 - s.length % 4) : '';
    const bin = typeof atob === 'function' ? atob(s + pad) : $8a8f6b6c38fa4a2a$require$Buffer.from(s + pad, 'base64').toString('binary');
    return decodeURIComponent(escape(bin));
}
function $8a8f6b6c38fa4a2a$export$fbeb63c721dead98(unit, playerName) {
    return $8a8f6b6c38fa4a2a$var$b64urlEncode($8a8f6b6c38fa4a2a$export$df24010bdeea6855(unit, playerName));
}
function $8a8f6b6c38fa4a2a$export$bb3662a325e1c488(param) {
    return $8a8f6b6c38fa4a2a$export$96f9b964dfffecb5($8a8f6b6c38fa4a2a$var$b64urlDecode(param));
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("fn3JH", function(module, exports) {

$parcel$export(module.exports, "render", () => $b30be6e99c8ec5f7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $b30be6e99c8ec5f7$var$_hoisted_1 = {
    class: "bg-and-holder"
};
const $b30be6e99c8ec5f7$var$_hoisted_2 = {
    key: 0,
    class: "detail-bar"
};
const $b30be6e99c8ec5f7$var$_hoisted_3 = {
    class: "card-col profile-col"
};
const $b30be6e99c8ec5f7$var$_hoisted_4 = {
    class: "image-stats"
};
const $b30be6e99c8ec5f7$var$_hoisted_5 = {
    class: "image-holder"
};
const $b30be6e99c8ec5f7$var$_hoisted_6 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_7 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_8 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_9 = {
    class: "class-label-row"
};
const $b30be6e99c8ec5f7$var$_hoisted_10 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_11 = {
    key: 1,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_12 = {
    class: "toolTip roll-tip"
};
const $b30be6e99c8ec5f7$var$_hoisted_13 = {
    key: 0,
    class: "roll-slot"
};
const $b30be6e99c8ec5f7$var$_hoisted_14 = {
    key: 2,
    class: "evade-grid hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_15 = {
    class: "eg-cells"
};
const $b30be6e99c8ec5f7$var$_hoisted_16 = {
    class: "eg-cell eg-mid"
};
const $b30be6e99c8ec5f7$var$_hoisted_17 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_18 = {
    key: 0,
    class: "evade-from"
};
const $b30be6e99c8ec5f7$var$_hoisted_19 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_20 = {
    class: "name-and-stats"
};
const $b30be6e99c8ec5f7$var$_hoisted_21 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_22 = {
    class: "zodiac-line"
};
const $b30be6e99c8ec5f7$var$_hoisted_23 = {
    class: "hasToolTip z-sign"
};
const $b30be6e99c8ec5f7$var$_hoisted_24 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_25 = {
    class: "z-compat z-good",
    title: "Deals/takes more damage with these signs"
};
const $b30be6e99c8ec5f7$var$_hoisted_26 = {
    class: "z-compat z-bad",
    title: "Deals/takes less damage with these signs"
};
const $b30be6e99c8ec5f7$var$_hoisted_27 = {
    key: 0,
    class: "z-compat z-opp",
    title: "Opposite sign \u2014 Best (opposite gender) / Worst (same gender)"
};
const $b30be6e99c8ec5f7$var$_hoisted_28 = {
    class: "stats"
};
const $b30be6e99c8ec5f7$var$_hoisted_29 = {
    class: "stat"
};
const $b30be6e99c8ec5f7$var$_hoisted_30 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_31 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_32 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_33 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_34 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_35 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_36 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_37 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_38 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_39 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_40 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_41 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_42 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_43 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_44 = {
    class: "stat"
};
const $b30be6e99c8ec5f7$var$_hoisted_45 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_46 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_47 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_48 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_49 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_50 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_51 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_52 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_53 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_54 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_55 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_56 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_57 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_58 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_59 = {
    key: 6
};
const $b30be6e99c8ec5f7$var$_hoisted_60 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_61 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_62 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_63 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_64 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_65 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_66 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_67 = {
    key: 6
};
const $b30be6e99c8ec5f7$var$_hoisted_68 = {
    class: "stat"
};
const $b30be6e99c8ec5f7$var$_hoisted_69 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_70 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_71 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_72 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_73 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_74 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_75 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_76 = {
    key: 0,
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_77 = {
    key: 0
};
const $b30be6e99c8ec5f7$var$_hoisted_78 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_79 = {
    key: 2
};
const $b30be6e99c8ec5f7$var$_hoisted_80 = {
    key: 3
};
const $b30be6e99c8ec5f7$var$_hoisted_81 = {
    key: 4
};
const $b30be6e99c8ec5f7$var$_hoisted_82 = {
    key: 5
};
const $b30be6e99c8ec5f7$var$_hoisted_83 = {
    class: "stat"
};
const $b30be6e99c8ec5f7$var$_hoisted_84 = {
    class: "gd-head"
};
const $b30be6e99c8ec5f7$var$_hoisted_85 = {
    class: "gd-type"
};
const $b30be6e99c8ec5f7$var$_hoisted_86 = {
    class: "gd-parts"
};
const $b30be6e99c8ec5f7$var$_hoisted_87 = {
    key: 0,
    class: "evasion stats"
};
const $b30be6e99c8ec5f7$var$_hoisted_88 = {
    class: "evade-line"
};
const $b30be6e99c8ec5f7$var$_hoisted_89 = {
    class: "ce-load"
};
const $b30be6e99c8ec5f7$var$_hoisted_90 = {
    key: 0,
    class: "ce-pills"
};
const $b30be6e99c8ec5f7$var$_hoisted_91 = {
    class: "unit-equipment"
};
const $b30be6e99c8ec5f7$var$_hoisted_92 = {
    key: 0,
    class: "gear-edit-bar"
};
const $b30be6e99c8ec5f7$var$_hoisted_93 = {
    class: "damage-number"
};
const $b30be6e99c8ec5f7$var$_hoisted_94 = {
    key: 0,
    class: "equipment mainhand hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_95 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_96 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_97 = {
    class: "damage-number"
};
const $b30be6e99c8ec5f7$var$_hoisted_98 = {
    key: 0,
    class: "aventail"
};
const $b30be6e99c8ec5f7$var$_hoisted_99 = {
    key: 1,
    class: "equipment offhand hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_100 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_101 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_102 = {
    class: "damage-number"
};
const $b30be6e99c8ec5f7$var$_hoisted_103 = {
    key: 0,
    class: "aventail"
};
const $b30be6e99c8ec5f7$var$_hoisted_104 = {
    key: 2,
    class: "equipment head hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_105 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_106 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_107 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_108 = {
    key: 3,
    class: "equipment armor hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_109 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_110 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_111 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_112 = {
    key: 4,
    class: "equipment accessory hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_113 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_114 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_115 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_116 = {
    key: 5,
    class: "status"
};
const $b30be6e99c8ec5f7$var$_hoisted_117 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_118 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_119 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_120 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_121 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_122 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_123 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_124 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_125 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_126 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_127 = {
    key: 6,
    class: "status"
};
const $b30be6e99c8ec5f7$var$_hoisted_128 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_129 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_130 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_131 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_132 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_133 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_134 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_135 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_136 = {
    class: "hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_137 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_138 = {
    key: 2,
    class: "gear-editor"
};
const $b30be6e99c8ec5f7$var$_hoisted_139 = [
    "value",
    "onChange"
];
const $b30be6e99c8ec5f7$var$_hoisted_140 = {
    value: ""
};
const $b30be6e99c8ec5f7$var$_hoisted_141 = [
    "label"
];
const $b30be6e99c8ec5f7$var$_hoisted_142 = [
    "value"
];
const $b30be6e99c8ec5f7$var$_hoisted_143 = {
    class: "ge-showall"
};
const $b30be6e99c8ec5f7$var$_hoisted_144 = {
    class: "card-col abilities-col"
};
const $b30be6e99c8ec5f7$var$_hoisted_145 = {
    key: 0,
    class: "status element-affinity"
};
const $b30be6e99c8ec5f7$var$_hoisted_146 = {
    class: "ea-rows"
};
const $b30be6e99c8ec5f7$var$_hoisted_147 = {
    class: "ea-bullet"
};
const $b30be6e99c8ec5f7$var$_hoisted_148 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_149 = {
    key: 1,
    class: "unit-innates"
};
const $b30be6e99c8ec5f7$var$_hoisted_150 = {
    class: "innate hasToolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_151 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_152 = [
    "src",
    "alt"
];
const $b30be6e99c8ec5f7$var$_hoisted_153 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_154 = [
    "src"
];
const $b30be6e99c8ec5f7$var$_hoisted_155 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_156 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_157 = [
    "src"
];
const $b30be6e99c8ec5f7$var$_hoisted_158 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_159 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_160 = [
    "src"
];
const $b30be6e99c8ec5f7$var$_hoisted_161 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_162 = {
    class: "toolTip"
};
const $b30be6e99c8ec5f7$var$_hoisted_163 = [
    "src"
];
const $b30be6e99c8ec5f7$var$_hoisted_164 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_165 = {
    class: "unit-skills damage-tuning"
};
const $b30be6e99c8ec5f7$var$_hoisted_166 = {
    key: 0,
    class: "tuning-body"
};
const $b30be6e99c8ec5f7$var$_hoisted_167 = {
    class: "tuning-row"
};
const $b30be6e99c8ec5f7$var$_hoisted_168 = {
    class: "tr-label"
};
const $b30be6e99c8ec5f7$var$_hoisted_169 = {
    class: "tuning-row"
};
const $b30be6e99c8ec5f7$var$_hoisted_170 = {
    class: "tr-label"
};
const $b30be6e99c8ec5f7$var$_hoisted_171 = {
    class: "tuning-row"
};
const $b30be6e99c8ec5f7$var$_hoisted_172 = {
    class: "tr-label"
};
const $b30be6e99c8ec5f7$var$_hoisted_173 = {
    class: "tuning-row tuning-zodiac"
};
const $b30be6e99c8ec5f7$var$_hoisted_174 = {
    class: "z-toggles"
};
const $b30be6e99c8ec5f7$var$_hoisted_175 = [
    "title",
    "onClick"
];
const $b30be6e99c8ec5f7$var$_hoisted_176 = {
    class: "tuning-check"
};
const $b30be6e99c8ec5f7$var$_hoisted_177 = {
    key: 2,
    class: "unit-skills"
};
const $b30be6e99c8ec5f7$var$_hoisted_178 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_179 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_180 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_181 = {
    key: 3,
    class: "unit-skills"
};
const $b30be6e99c8ec5f7$var$_hoisted_182 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_183 = [
    "title"
];
const $b30be6e99c8ec5f7$var$_hoisted_184 = {
    key: 1
};
const $b30be6e99c8ec5f7$var$_hoisted_185 = {
    key: 4,
    class: "unit-skills"
};
const $b30be6e99c8ec5f7$var$_hoisted_186 = {
    key: 0
};
function $b30be6e99c8ec5f7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PlayerHover = (0, $TusQn.resolveComponent)("PlayerHover");
    const _component_AbilityBreakdown = (0, $TusQn.resolveComponent)("AbilityBreakdown");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8POXm.normalizeClass)([
            "unit",
            {
                compact: !$options.showDetail
            }
        ]),
        style: (0, $8POXm.normalizeStyle)($options.cardStyle),
        onClick: _cache[42] || (_cache[42] = (...args)=>$options.onCardClick && $options.onCardClick(...args))
    }, [
        (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_1, [
            $options.showDetail && !$props.inModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "mini-btn",
                    onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('full', {
                            unit: $props.unit,
                            teamColor: $props.teamColor,
                            enemyTeam: $props.enemyTeam,
                            ownTeam: $props.ownTeam
                        }), [
                        "stop"
                    ]))
                }, "\u26F6 Full card"),
                (0, $TusQn.createElementVNode)("button", {
                    class: "mini-btn",
                    onClick: _cache[1] || (_cache[1] = (0, $eeJ70.withModifiers)((...args)=>$options.openInBuilder && $options.openInBuilder(...args), [
                        "stop"
                    ])),
                    "aria-label": "Open this unit in the Character Builder (new tab)",
                    title: "Open a copy of this unit in the Character Builder (new tab)"
                }, "\u270F\uFE0F Builder"),
                (0, $TusQn.createElementVNode)("button", {
                    class: "mini-btn",
                    onClick: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)(($event)=>$data.expanded = false, [
                        "stop"
                    ]))
                }, "\u25BE Less")
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_5, [
                        $props.unit.Gender == 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                            key: 0,
                            src: $data.IMG_URL + $props.unit.Class + '.gif',
                            alt: $props.unit.Class
                        }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_6)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            $props.teamColor != 'Champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                                key: 0,
                                src: $data.IMG_URL + $props.unit.Class + $props.unit.Gender[0] + '_' + $props.teamColor + '.gif',
                                alt: $props.unit.Class
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_7)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                                key: 1,
                                src: $data.IMG_URL + $props.unit.Class + $props.unit.Gender[0] + '.gif',
                                alt: $props.unit.Class
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_8))
                        ], 64)),
                        (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_9, [
                            (0, $TusQn.createElementVNode)("span", {
                                class: "class-label hasToolTip",
                                onClick: _cache[3] || (_cache[3] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, [
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.unit.Class) + " ", 1),
                                $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_10, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.Gender) + " " + (0, $8POXm.toDisplayString)($props.unit.Class), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Class[$props.unit.Class.replace(/\s+/g, '') + ' ' + $props.unit.Gender]), 1)
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_11, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.Class), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Class[$props.unit.Class.replace(/\s+/g, '')]), 1)
                                ]))
                            ]),
                            $options.showDetail && $options.rollAdvice ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: 0,
                                class: "roll-dice hasToolTip",
                                onClick: _cache[4] || (_cache[4] = (0, $eeJ70.withModifiers)((e)=>e.currentTarget.classList.toggle('active'), [
                                    "stop"
                                ])),
                                title: "Best rolls for this class"
                            }, [
                                _cache[45] || (_cache[45] = (0, $TusQn.createTextVNode)("\uD83C\uDFB2 ", -1)),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_12, [
                                    (0, $TusQn.createElementVNode)("p", null, [
                                        (0, $TusQn.createTextVNode)("\uD83C\uDFB2 Best " + (0, $8POXm.toDisplayString)($props.unit.Class) + " rolls ", 1),
                                        _cache[43] || (_cache[43] = (0, $TusQn.createElementVNode)("small", null, "(by historical win rate)", -1))
                                    ]),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.rollAdvice, (slot, label)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: label
                                        }, [
                                            slot.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_13, [
                                                (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)(label) + ":", 1),
                                                _cache[44] || (_cache[44] = (0, $TusQn.createTextVNode)()),
                                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(slot, (s, i)=>{
                                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                                        key: i,
                                                        class: "roll-pick"
                                                    }, [
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(s.skill) + " ", 1),
                                                        (0, $TusQn.createElementVNode)("small", null, (0, $8POXm.toDisplayString)(s.winRate) + "%", 1)
                                                    ]);
                                                }), 128))
                                            ])) : (0, $TusQn.createCommentVNode)("", true)
                                        ], 64);
                                    }), 128))
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                        $options.showDetail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_14, [
                            _cache[48] || (_cache[48] = (0, $TusQn.createElementVNode)("span", {
                                class: "eg-title"
                            }, "Evasion", -1)),
                            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_15, [
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "eg-cell eg-front",
                                        $options.evClass($options.evade.physFront)
                                    ])
                                }, (0, $8POXm.toDisplayString)($options.evade.physFront), 3),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "eg-cell eg-magic",
                                        $options.evClass($options.evade.magic)
                                    ]),
                                    title: "Magic evade (any direction)"
                                }, "\u2726" + (0, $8POXm.toDisplayString)($options.evade.magic), 3),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "eg-cell eg-sidel",
                                        $options.evClass($options.evade.physSide)
                                    ])
                                }, (0, $8POXm.toDisplayString)($options.evade.physSide), 3),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_16, [
                                    (0, $TusQn.createElementVNode)("img", {
                                        src: $options.portraitSrc,
                                        alt: $props.unit.Class,
                                        onError: _cache[5] || (_cache[5] = ($event)=>$event.target.style.visibility = 'hidden')
                                    }, null, 40, $b30be6e99c8ec5f7$var$_hoisted_17)
                                ]),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "eg-cell eg-sider",
                                        $options.evClass($options.evade.physSide)
                                    ])
                                }, (0, $8POXm.toDisplayString)($options.evade.physSide), 3),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "eg-cell eg-back",
                                        $options.evClass($options.evade.physBack)
                                    ])
                                }, (0, $8POXm.toDisplayString)($options.evade.physBack), 3)
                            ]),
                            $options.evadeSources.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_18, (0, $8POXm.toDisplayString)($options.evadeSources.join(" \xb7 ")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_19, [
                                _cache[47] || (_cache[47] = (0, $TusQn.createElementVNode)("p", null, "Evasion", -1)),
                                (0, $TusQn.createTextVNode)("Front " + (0, $8POXm.toDisplayString)($options.evade.physFront) + "% \xb7 Side " + (0, $8POXm.toDisplayString)($options.evade.physSide) + "% \xb7 Back " + (0, $8POXm.toDisplayString)($options.evade.physBack) + "% physical (facing matters \u2014 flank for fewer dodges). \u2726 Magic " + (0, $8POXm.toDisplayString)($options.evade.magic) + "% ignores facing.", 1),
                                $options.evadeSources.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    _cache[46] || (_cache[46] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                                    (0, $TusQn.createTextVNode)("From: " + (0, $8POXm.toDisplayString)($options.evadeSources.join(" \xb7 ")), 1)
                                ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_20, [
                        (0, $TusQn.createElementVNode)("div", {
                            style: (0, $8POXm.normalizeStyle)($options.nameStyle($props.unit.Name))
                        }, [
                            (0, $TusQn.createElementVNode)("b", null, [
                                $props.unit.RaidBoss ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createTextVNode)("[!] ")
                                ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                (0, $TusQn.createVNode)(_component_PlayerHover, {
                                    name: $props.unit.Name
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.unit.Name), 1)
                                        ]),
                                    _: 1
                                }, 8, [
                                    "name"
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "grade-badge hasToolTip",
                                    'tier-' + $options.grade.color
                                ])
                            }, [
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.grade.grade), 1),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($options.grade.color) + " " + (0, $8POXm.toDisplayString)($options.grade.grade) + " \u2014 " + (0, $8POXm.toDisplayString)($props.unit.Class), 1),
                                    (0, $TusQn.createTextVNode)("Type wins " + (0, $8POXm.toDisplayString)($options.grade.typeWR) + "% (" + (0, $8POXm.toDisplayString)($options.grade.color) + " tier); this one " + (0, $8POXm.toDisplayString)($options.grade.specimenLift >= 0 ? '+' : '') + (0, $8POXm.toDisplayString)($options.grade.specimenLift) + " \u2192 ~" + (0, $8POXm.toDisplayString)($options.grade.score) + "%.", 1),
                                    _cache[51] || (_cache[51] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.gradeTip.up, (p)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: p.dim
                                        }, [
                                            (0, $TusQn.createTextVNode)("\u25B2 " + (0, $8POXm.toDisplayString)(p.label) + " " + (0, $8POXm.toDisplayString)($options.signed(p.contribution)), 1),
                                            _cache[49] || (_cache[49] = (0, $TusQn.createElementVNode)("br", null, null, -1))
                                        ], 64);
                                    }), 128)),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.gradeTip.down, (p)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: p.dim
                                        }, [
                                            (0, $TusQn.createTextVNode)("\u25BC " + (0, $8POXm.toDisplayString)(p.label) + " " + (0, $8POXm.toDisplayString)($options.signed(p.contribution)), 1),
                                            _cache[50] || (_cache[50] = (0, $TusQn.createElementVNode)("br", null, null, -1))
                                        ], 64);
                                    }), 128)),
                                    $options.gradeTip.more ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, [
                                        (0, $TusQn.createTextVNode)("+" + (0, $8POXm.toDisplayString)($options.gradeTip.more) + " more \u2014 open the full card for all", 1)
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ], 2)
                        ], 4),
                        (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_22, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_23, [
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.unit.Sign), 1),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_24, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.Sign), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Zodiac[$props.unit.Sign]), 1)
                                ])
                            ]),
                            $options.showDetail && $options.zodiacProfile ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_25, "\u25B2 " + (0, $8POXm.toDisplayString)($options.zodiacProfile.good.join(', ')), 1),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_26, "\u25BC " + (0, $8POXm.toDisplayString)($options.zodiacProfile.bad.join(', ')), 1),
                                $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_27, "\u21C5 " + (0, $8POXm.toDisplayString)($options.zodiacProfile.opposite), 1)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                        (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_28, [
                            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_29, [
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.hp > 100,
                                        hasToolTip: $options.itemBonus.hp > 0
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('StatHP', $options.stats.hp))
                                }, [
                                    (0, $TusQn.createTextVNode)("HP: " + (0, $8POXm.toDisplayString)($options.stats.hp) + " ", 1),
                                    $options.itemBonus.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_30, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_31, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default HP (" + (0, $8POXm.toDisplayString)($options.classBase.hp) + ") ", 1),
                                            $options.equipped.Mainhand.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_32, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.hp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_33, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.hp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_34, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.hp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_35, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.hp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.hp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_36, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.hp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 6),
                                _cache[52] || (_cache[52] = (0, $TusQn.createElementVNode)("span", null, " - ", -1)),
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[7] || (_cache[7] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.mp > 40,
                                        hasToolTip: $options.itemBonus.mp > 0
                                    })
                                }, [
                                    (0, $TusQn.createTextVNode)("MP: " + (0, $8POXm.toDisplayString)($options.stats.mp) + " ", 1),
                                    $options.itemBonus.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_37, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_38, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default MP (" + (0, $8POXm.toDisplayString)($options.classBase.mp) + ") ", 1),
                                            $options.equipped.Mainhand.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_39, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.mp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_40, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.mp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_41, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.mp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_42, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.mp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.mp > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_43, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.mp) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 2)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_44, [
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[8] || (_cache[8] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.speed > 2,
                                        hasToolTip: $options.itemBonus.speed > 0
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('StatSpeed', $options.stats.speed))
                                }, [
                                    (0, $TusQn.createTextVNode)("Speed: " + (0, $8POXm.toDisplayString)($options.stats.speed) + " ", 1),
                                    $options.itemBonus.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_45, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_46, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default Speed (" + (0, $8POXm.toDisplayString)($options.classBase.speed) + ") ", 1),
                                            $options.equipped.Mainhand.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_47, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.speed) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_48, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.speed) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_49, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.speed) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_50, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.speed) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.speed > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_51, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.speed) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 6),
                                _cache[53] || (_cache[53] = (0, $TusQn.createElementVNode)("span", null, " - ", -1)),
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.move + $options.moveSkillBonus.move > 2,
                                        hasToolTip: $options.itemBonus.move + $options.moveSkillBonus.move > 0
                                    })
                                }, [
                                    (0, $TusQn.createTextVNode)(" Move: " + (0, $8POXm.toDisplayString)($options.stats.move) + " ", 1),
                                    $options.itemBonus.move + $options.moveSkillBonus.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_52, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_53, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default Move (" + (0, $8POXm.toDisplayString)($options.classBase.move) + ") ", 1),
                                            $options.equipped.Mainhand.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_54, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_55, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_56, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_57, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_58, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.moveSkillBonus.move > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_59, " + " + (0, $8POXm.toDisplayString)($props.unit.MoveSkill) + " (+" + (0, $8POXm.toDisplayString)($options.moveSkillBonus.move) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 2),
                                _cache[54] || (_cache[54] = (0, $TusQn.createElementVNode)("span", null, " - ", -1)),
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[10] || (_cache[10] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.jump + $options.moveSkillBonus.jump > 2,
                                        hasToolTip: $options.itemBonus.jump + $options.moveSkillBonus.jump > 0
                                    })
                                }, [
                                    (0, $TusQn.createTextVNode)("Jump: " + (0, $8POXm.toDisplayString)($options.stats.jump) + " ", 1),
                                    $options.itemBonus.jump + $options.moveSkillBonus.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_60, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_61, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default Jump (" + (0, $8POXm.toDisplayString)($options.classBase.jump) + ") ", 1),
                                            $options.equipped.Mainhand.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_62, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_63, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_64, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_65, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_66, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.moveSkillBonus.jump > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_67, " + " + (0, $8POXm.toDisplayString)($props.unit.MoveSkill) + " (+" + (0, $8POXm.toDisplayString)($options.moveSkillBonus.jump) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 2)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_68, [
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[11] || (_cache[11] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.pa > 2,
                                        hasToolTip: $options.itemBonus.pa > 0
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('StatPA', $options.stats.pa))
                                }, [
                                    (0, $TusQn.createTextVNode)("PA: " + (0, $8POXm.toDisplayString)($options.stats.pa) + " ", 1),
                                    $options.itemBonus.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_69, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_70, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default PA (" + (0, $8POXm.toDisplayString)($options.classBase.pa) + ") ", 1),
                                            $options.equipped.Mainhand.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_71, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.pa) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_72, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.pa) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_73, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.pa) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_74, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.pa) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.pa > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_75, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.pa) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 6),
                                _cache[55] || (_cache[55] = (0, $TusQn.createElementVNode)("span", null, " - ", -1)),
                                (0, $TusQn.createElementVNode)("span", {
                                    onClick: _cache[12] || (_cache[12] = (...args)=>$options.togglePin && $options.togglePin(...args)),
                                    class: (0, $8POXm.normalizeClass)({
                                        goodBonus: $options.itemBonus.ma > 2,
                                        hasToolTip: $options.itemBonus.ma > 0
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('StatMA', $options.stats.ma))
                                }, [
                                    (0, $TusQn.createTextVNode)("MA: " + (0, $8POXm.toDisplayString)($options.stats.ma) + " ", 1),
                                    $options.itemBonus.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_76, [
                                        (0, $TusQn.createElementVNode)("p", null, [
                                            $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_77, (0, $8POXm.toDisplayString)($props.unit.Gender), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.unit.Class) + " Default MA (" + (0, $8POXm.toDisplayString)($options.classBase.ma) + ") ", 1),
                                            $options.equipped.Mainhand.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_78, " + " + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Mainhand.ma) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Offhand.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_79, " + " + (0, $8POXm.toDisplayString)($options.equipped.Offhand.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Offhand.ma) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Head.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_80, " + " + (0, $8POXm.toDisplayString)($options.equipped.Head.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Head.ma) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Armor.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_81, " + " + (0, $8POXm.toDisplayString)($options.equipped.Armor.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Armor.ma) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $options.equipped.Accessory.ma > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_82, " + " + (0, $8POXm.toDisplayString)($options.equipped.Accessory.name) + " (+" + (0, $8POXm.toDisplayString)($options.equipped.Accessory.ma) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ], 6)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_83, [
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)({
                                        bold: $data.braveAdj > 70 || $data.braveAdj < 45
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('Brave', $data.braveAdj))
                                }, "Brave: " + (0, $8POXm.toDisplayString)($data.braveAdj), 7),
                                _cache[56] || (_cache[56] = (0, $TusQn.createTextVNode)(" - ", -1)),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)({
                                        bold: $data.faithAdj > 70 || $data.faithAdj < 45
                                    }),
                                    style: (0, $8POXm.normalizeStyle)($options.wrS('Faith', $data.faithAdj))
                                }, "Faith: " + (0, $8POXm.toDisplayString)($data.faithAdj), 7)
                            ])
                        ]),
                        $options.showDetail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 0,
                            class: (0, $8POXm.normalizeClass)([
                                "grade-detail",
                                'tier-' + $options.grade.color
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_84, (0, $8POXm.toDisplayString)($options.grade.color) + " " + (0, $8POXm.toDisplayString)($options.grade.grade), 1),
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_85, (0, $8POXm.toDisplayString)($props.unit.Class) + " type ~" + (0, $8POXm.toDisplayString)($options.grade.typeWR) + "% \xb7 this one " + (0, $8POXm.toDisplayString)($options.signed($options.grade.specimenLift)) + " \u2192 ~" + (0, $8POXm.toDisplayString)($options.grade.score) + "%", 1),
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_86, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.gradeFactors, (p)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                        key: p.dim,
                                        class: (0, $8POXm.normalizeClass)([
                                            "gd-part",
                                            p.contribution >= 0 ? 'gd-up' : 'gd-down'
                                        ])
                                    }, (0, $8POXm.toDisplayString)(p.label) + " " + (0, $8POXm.toDisplayString)($options.signed(p.contribution)), 3);
                                }), 128))
                            ])
                        ], 2)) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ]),
                !$options.showDetail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_87, [
                    (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_88, [
                        _cache[57] || (_cache[57] = (0, $TusQn.createTextVNode)(" Evade \u2014 Phys ", -1)),
                        _cache[58] || (_cache[58] = (0, $TusQn.createElementVNode)("b", null, "F", -1)),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($options.evade.physFront) + " \xb7 ", 1),
                        _cache[59] || (_cache[59] = (0, $TusQn.createElementVNode)("b", null, "S", -1)),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($options.evade.physSide) + " \xb7 ", 1),
                        _cache[60] || (_cache[60] = (0, $TusQn.createElementVNode)("b", null, "B", -1)),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($options.evade.physBack) + " \xa0\xb7\xa0 Magic " + (0, $8POXm.toDisplayString)($options.evade.magic), 1)
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true),
                !$options.showDetail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 1,
                    class: "compact-extra",
                    onClick: _cache[13] || (_cache[13] = ($event)=>$data.expanded = true)
                }, [
                    (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_89, [
                        $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 0
                        }, [
                            (0, $TusQn.createTextVNode)("\u2694 " + (0, $8POXm.toDisplayString)($options.gear.Mainhand || 'Unarmed'), 1),
                            $props.unit.ActionSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                (0, $TusQn.createTextVNode)(" \xb7 " + (0, $8POXm.toDisplayString)($props.unit.ActionSkill), 1)
                            ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    $options.notableSkills.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_90, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.notableSkills, (s, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: i,
                                class: "ce-skill"
                            }, [
                                (0, $TusQn.createElementVNode)("span", {
                                    class: "rarity-pill",
                                    style: (0, $8POXm.normalizeStyle)({
                                        background: s.tier.pill
                                    })
                                }, (0, $8POXm.toDisplayString)(s.roll) + "%", 5),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(s.name), 1)
                            ]);
                        }), 128))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    _cache[61] || (_cache[61] = (0, $TusQn.createElementVNode)("span", {
                        class: "expand-hint"
                    }, "\u25B8 details", -1))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_91, [
                    $props.inModal && $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_92, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "mini-btn",
                            onClick: _cache[14] || (_cache[14] = (0, $eeJ70.withModifiers)(($event)=>$data.editGear = !$data.editGear, [
                                "stop"
                            ]))
                        }, "\u270E " + (0, $8POXm.toDisplayString)($data.editGear ? 'Done' : 'Edit gear'), 1),
                        $data.editGear && $options.gearEdited ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 0,
                            class: "gear-reset",
                            onClick: _cache[15] || (_cache[15] = (0, $eeJ70.withModifiers)((...args)=>$options.resetGear && $options.resetGear(...args), [
                                "stop"
                            ]))
                        }, "reset")) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    !$data.editGear ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, [
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                "equipment unarmed hasToolTip",
                                {
                                    showUnarmed: $data.disarmed,
                                    monster: $props.unit.Gender == 'Monster',
                                    hasWeapon: $options.gear.Mainhand,
                                    hasShield: $props.itemschanged[$options.gear.Offhand].type == 'Shield'
                                }
                            ])
                        }, [
                            (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                ability: "Unarmed",
                                description: "Pow Pow! Right in the Noggin.",
                                breakdown: $options.weaponBreakdowns.unarmed
                            }, null, 8, [
                                "breakdown"
                            ]),
                            _cache[63] || (_cache[63] = (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/hand.png",
                                alt: "hand"
                            }, null, -1)),
                            _cache[64] || (_cache[64] = (0, $TusQn.createElementVNode)("img", {
                                class: "gear-icon flip",
                                src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/hand.png",
                                alt: "hand"
                            }, null, -1)),
                            (0, $TusQn.createElementVNode)("span", {
                                class: "equipment-text",
                                onClick: _cache[16] || (_cache[16] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, [
                                _cache[62] || (_cache[62] = (0, $TusQn.createTextVNode)("Unarmed ", -1)),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_93, "(" + (0, $8POXm.toDisplayString)($options.unarmedDamage()) + ")", 1)
                            ])
                        ], 2),
                        $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 0
                        }, [
                            $options.gear.Mainhand ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_94, [
                                (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                    ability: $options.gear.Mainhand,
                                    description: $props.itemschanged[$options.gear.Mainhand].info,
                                    breakdown: $options.weaponBreakdowns.Mainhand
                                }, null, 8, [
                                    "ability",
                                    "description",
                                    "breakdown"
                                ]),
                                (0, $TusQn.createElementVNode)("img", {
                                    onClick: _cache[17] || (_cache[17] = ($event)=>$data.disarmed = !$data.disarmed),
                                    class: "ability-icon cursor-pointer",
                                    src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/hand.png",
                                    alt: "hand"
                                }),
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "gear-icon",
                                    src: $data.IMG_URL_ITEMS + $options.gear.Mainhand.replace(/\s+/g, '') + '.gif',
                                    alt: $options.gear.Mainhand
                                }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_95),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "equipment-text",
                                        {
                                            bold: $props.notAbles.items.includes($options.gear.Mainhand),
                                            showUnarmed: $data.disarmed
                                        }
                                    ]),
                                    style: (0, $8POXm.normalizeStyle)($options.wr('Weapon', $options.gear.Mainhand)),
                                    title: $options.wrTip('Weapon', $options.gear.Mainhand),
                                    onClick: _cache[19] || (_cache[19] = (...args)=>$options.togglePin && $options.togglePin(...args))
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.gear.Mainhand) + " ", 1),
                                    (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_97, [
                                        $options.equipped.Mainhand.type === 'Gun' && $options.equipped.Mainhand.element ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_98, (0, $8POXm.toDisplayString)($options.weaponDamage('Mainhand')), 1)) : $options.weaponDamage('Mainhand') !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $TusQn.createTextVNode)("(" + (0, $8POXm.toDisplayString)($options.weaponDamage('Mainhand')) + ")", 1)
                                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", {
                                        class: "disarm-toggle",
                                        onClick: _cache[18] || (_cache[18] = (0, $eeJ70.withModifiers)(($event)=>$data.disarmed = !$data.disarmed, [
                                            "stop"
                                        ]))
                                    }, (0, $8POXm.toDisplayString)($data.disarmed ? 'armed?' : 'disarm?'), 1)
                                ], 14, $b30be6e99c8ec5f7$var$_hoisted_96)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $options.gear.Offhand ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_99, [
                                (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                    ability: $options.gear.Offhand,
                                    description: $props.itemschanged[$options.gear.Offhand].info,
                                    breakdown: $options.weaponBreakdowns.Offhand
                                }, null, 8, [
                                    "ability",
                                    "description",
                                    "breakdown"
                                ]),
                                _cache[65] || (_cache[65] = (0, $TusQn.createElementVNode)("img", {
                                    class: "ability-icon",
                                    src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/hand.png",
                                    alt: "hand"
                                }, null, -1)),
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "gear-icon",
                                    src: $data.IMG_URL_ITEMS + $options.gear.Offhand.replace(/\s+/g, '') + '.gif',
                                    alt: $options.gear.Offhand
                                }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_100),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "equipment-text",
                                        {
                                            bold: $props.notAbles.items.includes($options.gear.Offhand)
                                        }
                                    ]),
                                    style: (0, $8POXm.normalizeStyle)($options.wr('Weapon', $options.gear.Offhand)),
                                    title: $options.wrTip('Weapon', $options.gear.Offhand),
                                    onClick: _cache[20] || (_cache[20] = (...args)=>$options.togglePin && $options.togglePin(...args))
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.gear.Offhand) + " ", 1),
                                    (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_102, [
                                        $options.equipped.Offhand.type === 'Gun' && $options.equipped.Offhand.element ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_103, (0, $8POXm.toDisplayString)($options.weaponDamage('Offhand')), 1)) : $options.weaponDamage('Offhand') !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $TusQn.createTextVNode)("(" + (0, $8POXm.toDisplayString)($options.weaponDamage('Offhand')) + ")", 1)
                                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                    ])
                                ], 14, $b30be6e99c8ec5f7$var$_hoisted_101)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $options.gear.Head ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_104, [
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_105, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($options.gear.Head), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.itemschanged[$options.gear.Head].info), 1)
                                ]),
                                _cache[66] || (_cache[66] = (0, $TusQn.createElementVNode)("img", {
                                    class: "ability-icon",
                                    src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/head.png",
                                    alt: "head"
                                }, null, -1)),
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "gear-icon",
                                    src: $data.IMG_URL_ITEMS + $options.gear.Head.replace(/\s+/g, '') + '.gif',
                                    alt: $options.gear.Head
                                }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_106),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "equipment-text",
                                        {
                                            bold: $props.notAbles.items.includes($options.gear.Head)
                                        }
                                    ]),
                                    style: (0, $8POXm.normalizeStyle)($options.wr('Head', $options.gear.Head)),
                                    title: $options.wrTip('Head', $options.gear.Head),
                                    onClick: _cache[21] || (_cache[21] = (...args)=>$options.togglePin && $options.togglePin(...args))
                                }, (0, $8POXm.toDisplayString)($options.gear.Head), 15, $b30be6e99c8ec5f7$var$_hoisted_107)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $options.gear.Armor ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_108, [
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_109, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($options.gear.Armor), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.itemschanged[$options.gear.Armor].info), 1)
                                ]),
                                _cache[67] || (_cache[67] = (0, $TusQn.createElementVNode)("img", {
                                    class: "ability-icon",
                                    src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/body.png",
                                    alt: "body"
                                }, null, -1)),
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "gear-icon",
                                    src: $data.IMG_URL_ITEMS + $options.gear.Armor.replace(/\s+/g, '') + '.gif',
                                    alt: $options.gear.Armor
                                }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_110),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "equipment-text",
                                        {
                                            bold: $props.notAbles.items.includes($options.gear.Armor)
                                        }
                                    ]),
                                    style: (0, $8POXm.normalizeStyle)($options.wr('Armor', $options.gear.Armor)),
                                    title: $options.wrTip('Armor', $options.gear.Armor),
                                    onClick: _cache[22] || (_cache[22] = (...args)=>$options.togglePin && $options.togglePin(...args))
                                }, (0, $8POXm.toDisplayString)($options.gear.Armor), 15, $b30be6e99c8ec5f7$var$_hoisted_111)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $options.gear.Accessory ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_112, [
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_113, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($options.gear.Accessory), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.itemschanged[$options.gear.Accessory].info), 1)
                                ]),
                                _cache[68] || (_cache[68] = (0, $TusQn.createElementVNode)("img", {
                                    class: "ability-icon",
                                    src: "https://luxor-fftbg-assets.s3.amazonaws.com/icons/accessory.png",
                                    alt: "accessory"
                                }, null, -1)),
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "gear-icon",
                                    src: $data.IMG_URL_ITEMS + $options.gear.Accessory.replace(/\s+/g, '') + '.gif',
                                    alt: $options.gear.Accessory
                                }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_114),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "equipment-text",
                                        {
                                            bold: $props.notAbles.items.includes($options.gear.Accessory)
                                        }
                                    ]),
                                    style: (0, $8POXm.normalizeStyle)($options.wr('Accessory', $options.gear.Accessory)),
                                    title: $options.wrTip('Accessory', $options.gear.Accessory),
                                    onClick: _cache[23] || (_cache[23] = (...args)=>$options.togglePin && $options.togglePin(...args))
                                }, (0, $8POXm.toDisplayString)($options.gear.Accessory), 15, $b30be6e99c8ec5f7$var$_hoisted_115)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $props.itemschanged[$options.gear.Mainhand].permstatus || $props.itemschanged[$options.gear.Offhand].permstatus || $props.itemschanged[$options.gear.Head].permstatus || $props.itemschanged[$options.gear.Armor].permstatus || $props.itemschanged[$options.gear.Accessory].permstatus ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_116, [
                                _cache[69] || (_cache[69] = (0, $TusQn.createElementVNode)("h3", null, "Permanent Status", -1)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Mainhand].permstatus, (perm)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_117, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Mainhand) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_118, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(perm.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Offhand].permstatus, (perm)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_119, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Offhand) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_120, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(perm.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Head].permstatus, (perm)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_121, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Head) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_122, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(perm.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Armor].permstatus, (perm)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_123, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Armor) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_124, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(perm.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Accessory].permstatus, (perm)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_125, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Accessory) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_126, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(perm.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(perm.info), 1)
                                        ])
                                    ]);
                                }), 256))
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $props.itemschanged[$options.gear.Mainhand].initstatus || $props.itemschanged[$options.gear.Offhand].initstatus || $props.itemschanged[$options.gear.Head].initstatus || $props.itemschanged[$options.gear.Armor].initstatus || $props.itemschanged[$options.gear.Accessory].initstatus ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_127, [
                                _cache[70] || (_cache[70] = (0, $TusQn.createElementVNode)("h3", null, "Initial Status", -1)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Mainhand].initstatus, (init)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_128, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Mainhand) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_129, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(init.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Offhand].initstatus, (init)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_130, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Offhand) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_131, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(init.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Head].initstatus, (init)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_132, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Head) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_133, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(init.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Armor].initstatus, (init)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_134, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Armor) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_135, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(init.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.info), 1)
                                        ])
                                    ]);
                                }), 256)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.itemschanged[$options.gear.Accessory].initstatus, (init)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_136, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.name) + " (" + (0, $8POXm.toDisplayString)($options.gear.Accessory) + ") ", 1),
                                        (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_137, [
                                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(init.name), 1),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(init.info), 1)
                                        ])
                                    ]);
                                }), 256))
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_138, [
                        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)([
                            'Mainhand',
                            'Offhand',
                            'Head',
                            'Armor',
                            'Accessory'
                        ], (slot)=>{
                            return (0, $TusQn.createElementVNode)("div", {
                                class: "ge-row",
                                key: slot
                            }, [
                                (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)($options.slotLabel(slot)), 1),
                                (0, $TusQn.createElementVNode)("select", {
                                    value: $options.gear[slot] || '',
                                    onChange: ($event)=>$options.setGear(slot, $event.target.value)
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $b30be6e99c8ec5f7$var$_hoisted_140, (0, $8POXm.toDisplayString)(slot === 'Mainhand' ? 'Unarmed' : 'None'), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.slotItems(slot), (g)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("optgroup", {
                                            key: g.label,
                                            label: g.label
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(g.items, (n)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: n,
                                                    value: n
                                                }, (0, $8POXm.toDisplayString)(n), 9, $b30be6e99c8ec5f7$var$_hoisted_142);
                                            }), 128))
                                        ], 8, $b30be6e99c8ec5f7$var$_hoisted_141);
                                    }), 128))
                                ], 40, $b30be6e99c8ec5f7$var$_hoisted_139)
                            ]);
                        }), 64)),
                        (0, $TusQn.createElementVNode)("label", $b30be6e99c8ec5f7$var$_hoisted_143, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event)=>$data.showAllItems = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.showAllItems
                                ]
                            ]),
                            _cache[71] || (_cache[71] = (0, $TusQn.createTextVNode)(" show all items", -1))
                        ])
                    ]))
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_144, [
                $options.hasElementAffinity ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_145, [
                    _cache[74] || (_cache[74] = (0, $TusQn.createElementVNode)("h3", null, "Elemental", -1)),
                    (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_146, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.affinityRows, (r)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: r.kind + r.el,
                                class: (0, $8POXm.normalizeClass)([
                                    "ea-tag hasToolTip",
                                    r.good ? 'ea-good' : 'ea-bad'
                                ])
                            }, [
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_147, (0, $8POXm.toDisplayString)(r.good ? '+' : "\u2013"), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(r.label) + " " + (0, $8POXm.toDisplayString)(r.el), 1),
                                r.spells.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createTextVNode)(" (" + (0, $8POXm.toDisplayString)(r.spells.length) + ")", 1)
                                ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_148, [
                                    (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(r.label) + " " + (0, $8POXm.toDisplayString)(r.el), 1),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(r.tip), 1),
                                    r.spells.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, [
                                        _cache[72] || (_cache[72] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                                        (0, $TusQn.createTextVNode)("Boosts: " + (0, $8POXm.toDisplayString)(r.spells.join(', ')), 1)
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                    r.sources ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, [
                                        _cache[73] || (_cache[73] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                                        (0, $TusQn.createTextVNode)("From: " + (0, $8POXm.toDisplayString)(r.sources), 1)
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ], 2);
                        }), 128))
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.charStats[$props.unit.Class.replace(/\s+/g, '') + [
                    $props.unit.Gender
                ]].innates || $props.unit.Class == 'Lancer' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_149, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.charStats[$props.unit.Class.replace(/\s+/g, '') + [
                        $props.unit.Gender
                    ]].innates, (innate)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_150, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_151, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(innate.name), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(innate.info), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: $data.IMG_URL_ITEMS + innate.type + '.gif',
                                alt: innate.type
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_152),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "innate-text",
                                    {
                                        bold: $props.notAbles.abilities.includes(innate.name)
                                    }
                                ]),
                                onClick: _cache[25] || (_cache[25] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, (0, $8POXm.toDisplayString)(innate.name), 3)
                        ]);
                    }), 256)),
                    $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        $props.unit.Class != 'Mime' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 0,
                            class: "innate hasToolTip",
                            onClick: _cache[27] || (_cache[27] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_153, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.ActionSkill), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.UserSkill[$props.unit.ActionSkill.replace(/\s+/g, '')]), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: $data.IMG_URL_ITEMS + 'active.gif',
                                alt: "active"
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_154),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "innate-text",
                                    {
                                        bold: $props.notAbles.abilities.includes($props.unit.ActionSkill)
                                    }
                                ]),
                                style: (0, $8POXm.normalizeStyle)($options.wr('ActionSkill', $props.unit.ActionSkill)),
                                title: $options.wrTip('ActionSkill', $props.unit.ActionSkill),
                                onClick: _cache[26] || (_cache[26] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, (0, $8POXm.toDisplayString)($props.unit.ActionSkill), 15, $b30be6e99c8ec5f7$var$_hoisted_155)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                {
                                    bold: $props.notAbles.abilities.includes($props.unit.ReactionSkill)
                                },
                                "innate hasToolTip"
                            ]),
                            onClick: _cache[29] || (_cache[29] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_156, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.ReactionSkill), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Ability[$props.unit.ReactionSkill]), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: $data.IMG_URL_ITEMS + 'react.gif',
                                alt: "reaction"
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_157),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "innate-text",
                                    {
                                        bold: $props.notAbles.abilities.includes($props.unit.ReactionSkill)
                                    }
                                ]),
                                style: (0, $8POXm.normalizeStyle)($options.wr('ReactionSkill', $props.unit.ReactionSkill)),
                                title: $options.wrTip('ReactionSkill', $props.unit.ReactionSkill),
                                onClick: _cache[28] || (_cache[28] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, (0, $8POXm.toDisplayString)($props.unit.ReactionSkill), 15, $b30be6e99c8ec5f7$var$_hoisted_158)
                        ], 2),
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                {
                                    bold: $props.notAbles.abilities.includes($props.unit.SupportSkill)
                                },
                                "innate hasToolTip"
                            ]),
                            onClick: _cache[31] || (_cache[31] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_159, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.SupportSkill), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Ability[$props.unit.SupportSkill]), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: $data.IMG_URL_ITEMS + 'support.gif',
                                alt: "support"
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_160),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "innate-text",
                                    {
                                        bold: $props.notAbles.abilities.includes($props.unit.SupportSkill)
                                    }
                                ]),
                                style: (0, $8POXm.normalizeStyle)($options.wr('SupportSkill', $props.unit.SupportSkill)),
                                title: $options.wrTip('SupportSkill', $props.unit.SupportSkill),
                                onClick: _cache[30] || (_cache[30] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, (0, $8POXm.toDisplayString)($props.unit.SupportSkill), 15, $b30be6e99c8ec5f7$var$_hoisted_161)
                        ], 2),
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                {
                                    bold: $props.notAbles.abilities.includes($props.unit.MoveSkill)
                                },
                                "innate hasToolTip"
                            ]),
                            onClick: _cache[33] || (_cache[33] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_162, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.unit.MoveSkill), 1),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.toolTips.Ability[$props.unit.MoveSkill]), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("img", {
                                class: "ability-icon",
                                src: $data.IMG_URL_ITEMS + 'move.gif',
                                alt: "movement"
                            }, null, 8, $b30be6e99c8ec5f7$var$_hoisted_163),
                            (0, $TusQn.createElementVNode)("span", {
                                class: (0, $8POXm.normalizeClass)([
                                    "innate-text",
                                    {
                                        bold: $props.notAbles.abilities.includes($props.unit.MoveSkill)
                                    }
                                ]),
                                style: (0, $8POXm.normalizeStyle)($options.wr('MoveSkill', $props.unit.MoveSkill)),
                                title: $options.wrTip('MoveSkill', $props.unit.MoveSkill),
                                onClick: _cache[32] || (_cache[32] = (...args)=>$options.togglePin && $options.togglePin(...args))
                            }, (0, $8POXm.toDisplayString)($props.unit.MoveSkill), 15, $b30be6e99c8ec5f7$var$_hoisted_164)
                        ], 2)
                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_165, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "tuning-head",
                        onClick: _cache[34] || (_cache[34] = ($event)=>$data.showTuning = !$data.showTuning)
                    }, "\u2699 Damage tuning " + (0, $8POXm.toDisplayString)($data.showTuning ? "\u25BE" : "\u25B8"), 1),
                    $data.showTuning ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_166, [
                        (0, $TusQn.createElementVNode)("label", $b30be6e99c8ec5f7$var$_hoisted_167, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_168, [
                                _cache[75] || (_cache[75] = (0, $TusQn.createTextVNode)("Brave ", -1)),
                                (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($data.braveAdj), 1)
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "range",
                                min: "0",
                                max: "100",
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event)=>$data.braveAdj = $event),
                                class: "slider"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.braveAdj,
                                    void 0,
                                    {
                                        number: true
                                    }
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("label", $b30be6e99c8ec5f7$var$_hoisted_169, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_170, [
                                _cache[76] || (_cache[76] = (0, $TusQn.createTextVNode)("Faith ", -1)),
                                (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($data.faithAdj), 1)
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "range",
                                min: "0",
                                max: "100",
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event)=>$data.faithAdj = $event),
                                class: "slider"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.faithAdj,
                                    void 0,
                                    {
                                        number: true
                                    }
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("label", $b30be6e99c8ec5f7$var$_hoisted_171, [
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_172, [
                                _cache[77] || (_cache[77] = (0, $TusQn.createTextVNode)("Tgt Faith ", -1)),
                                (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($data.targetFaith), 1)
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "range",
                                min: "0",
                                max: "100",
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event)=>$data.targetFaith = $event),
                                class: "slider"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.targetFaith,
                                    void 0,
                                    {
                                        number: true
                                    }
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $b30be6e99c8ec5f7$var$_hoisted_173, [
                            _cache[78] || (_cache[78] = (0, $TusQn.createElementVNode)("span", {
                                class: "tr-label"
                            }, "Target sign", -1)),
                            (0, $TusQn.createElementVNode)("span", $b30be6e99c8ec5f7$var$_hoisted_174, [
                                ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)([
                                    'Worst',
                                    'Bad',
                                    'Neutral',
                                    'Good',
                                    'Best'
                                ], (z)=>{
                                    return (0, $TusQn.createElementVNode)("button", {
                                        key: z,
                                        type: "button",
                                        class: (0, $8POXm.normalizeClass)([
                                            "z-toggle",
                                            [
                                                'z-' + z.toLowerCase(),
                                                {
                                                    on: $data.zodiacAdj === z
                                                }
                                            ]
                                        ]),
                                        title: $options.zodiacToggleTip(z),
                                        onClick: ($event)=>$data.zodiacAdj = z
                                    }, (0, $8POXm.toDisplayString)(z), 11, $b30be6e99c8ec5f7$var$_hoisted_175);
                                }), 64))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("label", $b30be6e99c8ec5f7$var$_hoisted_176, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event)=>$data.disarmed = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.disarmed
                                ]
                            ]),
                            _cache[79] || (_cache[79] = (0, $TusQn.createTextVNode)(" treat weapon as removed", -1))
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                $props.unit.Gender != 'Monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_177, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.unit.ClassSkills, (ability)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            class: "hasToolTip",
                            onClick: _cache[39] || (_cache[39] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            $options.classSkillRarity[ability] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: 0,
                                class: "rarity-pill",
                                style: (0, $8POXm.normalizeStyle)({
                                    background: $options.classSkillRarity[ability].tier.pill
                                }),
                                title: $options.classSkillRarity[ability].tier.label + " \u2014 " + $options.classSkillRarity[ability].roll + '% roll'
                            }, (0, $8POXm.toDisplayString)($options.classSkillRarity[ability].roll) + "%", 13, $b30be6e99c8ec5f7$var$_hoisted_178)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("span", {
                                style: (0, $8POXm.normalizeStyle)($options.wr('Ability', ability)),
                                title: $options.wrTip('Ability', ability)
                            }, (0, $8POXm.toDisplayString)(ability), 13, $b30be6e99c8ec5f7$var$_hoisted_179),
                            (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                ability: ability,
                                description: $props.toolTips.Ability[ability],
                                breakdown: $options.abilityBreakdowns[ability]
                            }, null, 8, [
                                "ability",
                                "description",
                                "breakdown"
                            ]),
                            $options.abilityValues[ability] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_180, "\xa0(" + (0, $8POXm.toDisplayString)($options.abilityValues[ability]) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ]);
                    }), 256))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.unit.Gender != 'Monster' && $props.unit.Class != 'Mime' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_181, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.unit.ExtraSkills, (ability)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            class: "hasToolTip",
                            onClick: _cache[40] || (_cache[40] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            $options.extraSkillRarity[ability] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: 0,
                                class: "rarity-pill",
                                style: (0, $8POXm.normalizeStyle)({
                                    background: $options.extraSkillRarity[ability].tier.pill
                                }),
                                title: $options.extraSkillRarity[ability].tier.label + " \u2014 " + $options.extraSkillRarity[ability].roll + '% roll'
                            }, (0, $8POXm.toDisplayString)($options.extraSkillRarity[ability].roll) + "%", 13, $b30be6e99c8ec5f7$var$_hoisted_182)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("span", {
                                style: (0, $8POXm.normalizeStyle)($options.wr('Ability', ability)),
                                title: $options.wrTip('Ability', ability)
                            }, (0, $8POXm.toDisplayString)(ability), 13, $b30be6e99c8ec5f7$var$_hoisted_183),
                            (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                ability: ability,
                                description: $props.toolTips.Ability[ability],
                                breakdown: $options.abilityBreakdowns[ability]
                            }, null, 8, [
                                "ability",
                                "description",
                                "breakdown"
                            ]),
                            $options.abilityValues[ability] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_184, "\xa0(" + (0, $8POXm.toDisplayString)($options.abilityValues[ability]) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ]);
                    }), 256))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $props.toolTips.MonsterSkills[$props.unit.Class] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b30be6e99c8ec5f7$var$_hoisted_185, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.toolTips.MonsterSkills[$props.unit.Class], (ability)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                {
                                    bold: $props.notAbles.abilities.includes(ability)
                                },
                                "hasToolTip"
                            ]),
                            onClick: _cache[41] || (_cache[41] = (...args)=>$options.togglePin && $options.togglePin(...args))
                        }, [
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(ability) + " ", 1),
                            (0, $TusQn.createVNode)(_component_AbilityBreakdown, {
                                ability: ability,
                                description: $props.toolTips.Ability[ability.replace(/[^a-zA-Z1-9 ]/g, '')],
                                breakdown: $options.abilityBreakdowns[ability]
                            }, null, 8, [
                                "ability",
                                "description",
                                "breakdown"
                            ]),
                            $options.abilityValues[ability] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b30be6e99c8ec5f7$var$_hoisted_186, "\xa0(" + (0, $8POXm.toDisplayString)($options.abilityValues[ability]) + ")", 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 2);
                    }), 256))
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ])
    ], 6);
}

});

parcelRegister("grzPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8af5e32b7c521b$export$2e2bcd8739ae039);
let $bf8af5e32b7c521b$var$NOOP = ()=>{};
var $bf8af5e32b7c521b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("buZQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f278946f10abe1$export$2e2bcd8739ae039);
let $85f278946f10abe1$var$script;




let $85f278946f10abe1$var$initialize = ()=>{
    $85f278946f10abe1$var$script = (parcelRequire("19aYu"));
    if ($85f278946f10abe1$var$script.__esModule) $85f278946f10abe1$var$script = $85f278946f10abe1$var$script.default;
    $85f278946f10abe1$var$script.render = (parcelRequire("fg3Ll")).render;
    $85f278946f10abe1$var$script.__cssModules = {};
    (parcelRequire("lPxk8")).default($85f278946f10abe1$var$script);
    $85f278946f10abe1$var$script.__scopeId = 'data-v-72d6c4';
    $85f278946f10abe1$var$script.__file = "BracketMatch.vue";
};
$85f278946f10abe1$var$initialize();
var $85f278946f10abe1$export$2e2bcd8739ae039 = $85f278946f10abe1$var$script;

});
parcelRegister("19aYu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0d5f250e14aa4dfd$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $7iPtq = parcelRequire("7iPtq");

var $7xRwL = parcelRequire("7xRwL");

var $kcejr = parcelRequire("kcejr");

var $4rZCr = parcelRequire("4rZCr");

var $56OCP = parcelRequire("56OCP");

var $3DHjl = parcelRequire("3DHjl");

var $kmvQC = parcelRequire("kmvQC");

var $ftvub = parcelRequire("ftvub");

var $4zJ4j = parcelRequire("4zJ4j");

var $dr7Eb = parcelRequire("dr7Eb");

var $by2uy = parcelRequire("by2uy");

var $c8sRz = parcelRequire("c8sRz");

var $hYk3h = parcelRequire("hYk3h");

var $8sRxE = parcelRequire("8sRxE");

var $koMQO = parcelRequire("koMQO");

var $ht4ts = parcelRequire("ht4ts");

var $4C5NX = parcelRequire("4C5NX");

var $e0SZd = parcelRequire("e0SZd");

// Lazy — three.js (~600KB) + the viewer only load on the first map hover.
const $0d5f250e14aa4dfd$var$MapViewer3D = (0, $TusQn.defineAsyncComponent)(()=>(parcelRequire("7z4kn")));
// Solid team colors (match the .team-chip backgrounds below) for the champion
// "threat board" rows. Keyed by the lowercase team name.
const $0d5f250e14aa4dfd$var$CHIP_COLORS = {
    red: '#c0392b',
    blue: '#2647c8',
    green: '#2e9e2e',
    yellow: '#b9960f',
    white: '#d9d9d9',
    black: '#222',
    purple: '#6a1b9a',
    brown: '#6d4326',
    champion: '#e07b1a'
};
var $0d5f250e14aa4dfd$export$2e2bcd8739ae039 = {
    components: {
        HoverUnit: $7iPtq.default,
        ChampStreakBadge: $4C5NX.default,
        MapViewer3D: $0d5f250e14aa4dfd$var$MapViewer3D,
        UnitSprite: $7xRwL.default,
        TeamRatingTip: $e0SZd.default
    },
    data () {
        return {
            odds: null,
            oddsLoading: false,
            defenseOdds: null,
            defenseLoading: false,
            mapPopOpen: false,
            mapPopPos: {
                x: 0,
                y: 0
            }
        };
    },
    props: {
        // The map title for this round, from `maps[i]`.
        map: {
            type: String,
            default: ''
        },
        // Champ cell only: the reigning champion's title-defense streak (streak.txt),
        // shown as an escalating 🔥 badge next to the champion's crown.
        champStreak: {
            type: Number,
            default: 0
        },
        // Display string for the matchup heading. For QF cells this is hardcoded
        // ("Red vs. Blue"); for later rounds it's derived from the semi/final/
        // champ-label computeds in Luxstadio.
        vsTitle: {
            type: String,
            default: ''
        },
        // Optional class added to .bracket-match__content (e.g. "semi", "final",
        // "champ") so the existing bracket CSS targets the cell appropriately.
        matchClass: {
            type: String,
            default: ''
        },
        // [{ name, show, enemyColor }] — `show` decides whether that team's
        // roster is rendered (used by SF/Finals/Champ to gate by advancement),
        // `enemyColor` is the label passed to HoverUnit for the unit-card's
        // opposing-team color.
        leftTeams: {
            type: Array,
            required: true
        },
        rightTeams: {
            type: Array,
            required: true
        },
        // Whether the left/right side won this cell — drives the green
        // "won" / red "lost" classes on each team div.
        leftWon: {
            type: Boolean,
            default: false
        },
        rightWon: {
            type: Boolean,
            default: false
        },
        // Shared lookups + URL prefix passed through from Luxstadio.
        teamByName: {
            type: Object,
            required: true
        },
        items: {
            type: Object,
            required: true
        },
        notAbles: {
            type: Object,
            required: true
        },
        charStats: {
            type: Object,
            required: true
        },
        itemschanged: {
            type: Object,
            required: true
        },
        abilitiesInfo: {
            type: Object,
            default: ()=>({})
        },
        toolTips: {
            type: Object,
            default: ()=>({})
        },
        imgUrlMaps: {
            type: String,
            required: true
        },
        // Map<lowercase-username, color>. Forwarded to HoverUnit and also used
        // here to tint the bracket-cell roster lines.
        highlightColors: {
            type: Object,
            default: ()=>new Map()
        },
        // Click handlers — function props instead of emits because the parent
        // already has the methods (bracketClick/goto) and there's no useful
        // payload transformation in between.
        onBracketClick: {
            type: Function,
            required: true
        },
        onGoto: {
            type: Function,
            required: true
        },
        // Opens the fight view for this cell's two combatants. Optional so the
        // component still works if a caller doesn't wire it.
        onFight: {
            type: Function,
            default: null
        },
        // True for the next undecided match — glows the cell.
        isCurrent: {
            type: Boolean,
            default: false
        },
        // This cell's match index (0-7), forwarded to the Fight View so it can carry
        // the predict context for the matchup.
        matchIndex: {
            type: Number,
            default: null
        },
        // Champ cell only: the still-alive challenger team names. When non-empty,
        // the cell offers a "threat board" — the champion's odds vs each of them.
        challengers: {
            type: Array,
            default: ()=>[]
        },
        showWinRates: {
            type: Boolean,
            default: false
        },
        // When true (default), the live-match sprites occasionally play their attack
        // animation. Threaded from prefs.attackAnims via Luxstadio.bracketSharedProps.
        attackAnims: {
            type: Boolean,
            default: true
        },
        // Predict-the-Bracket state for this cell, or null when predict mode is off.
        // { candidates:[teamA,teamB], picked, simPick, winner, weight, roundLabel }
        predict: {
            type: Object,
            default: null
        }
    },
    emits: [
        'pick'
    ],
    computed: {
        // Team grade (mean unit grade) for each team shown in this cell.
        teamGrades () {
            const gd = {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles
            };
            const out = {};
            for (const t of [
                ...this.leftTeams,
                ...this.rightTeams
            ]){
                const tb = this.teamByName[t.name];
                if (tb) out[t.name] = (0, $8sRxE.teamGrade)(tb.roster, (0, $koMQO.rosterStats), gd);
            }
            return out;
        },
        // The teams actually shown in this cell (the resolved combatants).
        activeLeft () {
            return this.leftTeams.find((t)=>t.show);
        },
        activeRight () {
            return this.rightTeams.find((t)=>t.show);
        },
        // Animate the roster portraits as walking sprites ONLY in the current
        // (glowing) match — 8 canvases, the cell the eye is already on. Every other
        // cell keeps the cheap static headshots.
        useSprites () {
            return this.isCurrent && !!this.activeLeft && !!this.activeRight;
        },
        // The two combatants' resolved sprite colors (matchColors handles the
        // champion taking its alt color on a clash). Left team faces right.
        cellColors () {
            const L = this.activeLeft && this.teamByName[this.activeLeft.name] || null;
            const R = this.activeRight && this.teamByName[this.activeRight.name] || null;
            const [left, right] = (0, $kmvQC.matchColors)(L, R);
            return {
                left: left,
                right: right
            };
        },
        // Show cached odds only while they still match the current matchup, so a
        // new tournament / re-resolved cell drops stale numbers automatically.
        oddsShown () {
            return this.odds && this.activeLeft && this.activeRight && this.odds.left === this.activeLeft.name && this.odds.right === this.activeRight.name;
        },
        // Identity of the current challenger set — changes when a round resolves, so
        // a stale threat board (listing a now-eliminated team) gets dropped.
        challengerKey () {
            return this.challengers.join(',');
        },
        // Deep-link to this map's full page on the Maps view. The map prop is
        // "NN) Name"; strip the number prefix and slugify the name to match
        // MapsView's ?maps&map=<slug> deep-link (slugify is duplicated there).
        mapLink () {
            const name = (this.map || '').replace(/^\s*\d+\)\s*/, '').trim();
            if (!name) return null;
            const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            return '?maps&map=' + slug;
        },
        // Terrain for the hover popup — same lookup as FightModal: byName override
        // (reused map numbers) first, then the number key. null ⇒ gif fallback.
        popTiles () {
            return (0, $56OCP.tilesForMap)(this.map, (0, (/*@__PURE__*/$parcel$interopDefault($4rZCr))));
        },
        popTerrain () {
            const m = (this.map || '').match(/^\s*(\d+)\)\s*(.*)$/);
            const num = m ? +m[1] : null;
            const bare = (m ? m[2] : this.map || '').trim();
            return (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName[bare] || (num != null && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps ? (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps[num] : null) || null;
        },
        // The hover popup's start tiles, each tagged with the sprite of the unit that
        // actually stands there: Player 1 = the left combatant, Player 2 = the right
        // (the sim's convention), start.unit = that team's roster slot. Falls back to
        // a bare start (→ Knight) when a side/roster slot isn't resolved.
        popStarts () {
            const t = this.popTerrain;
            if (!t || !t.starts) return [];
            const teamObj = (tt)=>tt && this.teamByName[tt.name] || null;
            return (0, $kmvQC.startsWithSprites)(t.starts, teamObj(this.activeLeft), teamObj(this.activeRight));
        },
        popMeshUrl () {
            const m = (this.map || '').match(/^\s*(\d+)\)\s*(.*)$/);
            if (!m) return null;
            // A byName terrain override means this name was displaced off its number
            // (reused map numbers) — the number's GLB would be the WRONG map's mesh,
            // so fall back to the schematic built from the (correct) byName terrain.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName[m[2].trim()]) return null;
            return (0, $3DHjl.MESH_URLS)[+m[1]] || null;
        },
        mapPopStyle () {
            return {
                left: this.mapPopPos.x + 'px',
                top: this.mapPopPos.y + 'px'
            };
        }
    },
    watch: {
        challengerKey () {
            this.defenseOdds = null;
            this.defenseLoading = false;
            this._defRun = (this._defRun || 0) + 1;
        }
    },
    beforeUnmount () {
        this.mapHoverEnd();
    },
    methods: {
        // ----- 3D map hover popup -----
        // Hover-intent delay so an incidental mouse pass doesn't pull three.js +
        // a GLB; desktop/hover-capable only (mobile gets the map-title link).
        mapHoverStart () {
            if (!this.map) return;
            if (!window.matchMedia('(min-width: 1200px) and (hover: hover)').matches) return;
            this._mapHoverT = setTimeout(()=>{
                const span = this.$refs.mapSpan;
                if (!span) return;
                const r = span.getBoundingClientRect();
                const W = 420, H = 366, PAD = 8;
                let x = r.right + 14;
                if (x + W > window.innerWidth - PAD) x = r.left - W - 14; // flip left near the right edge
                x = Math.max(PAD, x);
                const y = Math.max(PAD, Math.min(r.top - 10, window.innerHeight - H - PAD));
                this.mapPopPos = {
                    x: x,
                    y: y
                };
                this.mapPopOpen = true;
                // The popup is position:fixed — close it if the page scrolls away.
                window.addEventListener('scroll', this._mapScrollClose = ()=>this.mapHoverEnd(), {
                    once: true,
                    passive: true
                });
            }, 250);
        },
        mapHoverEnd () {
            clearTimeout(this._mapHoverT);
            if (this._mapScrollClose) {
                window.removeEventListener('scroll', this._mapScrollClose);
                this._mapScrollClose = null;
            }
            this.mapPopOpen = false;
        },
        nameStyle (name) {
            const c = this.highlightColors && this.highlightColors.get((name || '').toLowerCase());
            return c ? {
                color: c,
                fontWeight: 'bold'
            } : null;
        },
        teamBright (label) {
            return (0, $ftvub.teamBright)(label);
        },
        teamDark (label) {
            return (0, $ftvub.teamDark)(label);
        },
        // Display label for a lowercase team name (for the predict bar).
        teamLabel (name) {
            return this.teamByName[name] ? this.teamByName[name].label : name;
        },
        // Per-team win% for this cell's chip, once odds are computed for the current
        // matchup (else null → the chip shows no number). Maps the team to a/b by name.
        teamOdds (name) {
            if (!this.oddsShown) return null;
            if (name === this.odds.left) return this.odds.a;
            if (name === this.odds.right) return this.odds.b;
            return null;
        },
        chipColor (name) {
            return $0d5f250e14aa4dfd$var$CHIP_COLORS[name] || '#555';
        },
        rowStyle (name) {
            return name === 'white' ? {
                background: $0d5f250e14aa4dfd$var$CHIP_COLORS.white,
                color: '#222',
                textShadow: 'none'
            } : {
                background: this.chipColor(name),
                color: '#fff'
            };
        },
        // Champion "threat board": sim the champion vs each still-alive challenger,
        // revealing each challenger's chance to WIN as it finishes (sorted, so the
        // biggest threat floats to the top). Chained via setTimeout so the UI stays
        // responsive and rows pop in instead of freezing for ~2s.
        computeDefenseOdds () {
            if (this.defenseLoading || !this.challengers.length) return;
            const champTb = this.teamByName.champion;
            if (!champTb) return;
            this.defenseLoading = true;
            this.defenseOdds = [];
            const myRun = this._defRun = (this._defRun || 0) + 1;
            const data = {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles,
                abilitiesInfo: this.abilitiesInfo,
                monsterSkills: (/*@__PURE__*/$parcel$interopDefault($hYk3h))
            };
            let champSpec;
            try {
                champSpec = (0, $4zJ4j.prepTeam)(champTb.roster, data);
            } catch (e) {
                this.defenseLoading = false;
                return;
            }
            const queue = this.challengers.slice();
            const runNext = ()=>{
                if (myRun !== this._defRun) return; // superseded by a reset / re-run
                const name = queue.shift();
                if (!name) {
                    this.defenseLoading = false;
                    return;
                }
                setTimeout(()=>{
                    if (myRun !== this._defRun) return;
                    try {
                        const tb = this.teamByName[name];
                        // Challenger = A, Champion = B → champion gets the incumbency edge (champSide:'B').
                        const r = (0, $dr7Eb.runBattles)((0, $4zJ4j.prepTeam)(tb.roster, data), champSpec, {
                            ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                            terrain: this.popTerrain,
                            tiles: this.popTiles
                        });
                        this.defenseOdds.push({
                            name: name,
                            label: tb.label,
                            pct: (0, $by2uy.calibratedOdds)(r, {
                                champSide: 'B'
                            }).a
                        });
                        this.defenseOdds.sort((a, b)=>b.pct - a.pct);
                    } catch (e) {}
                    runNext();
                }, 0);
            };
            runNext();
        },
        // Unit sprite URL — same scheme as HoverUnit: team-colored for normal
        // units, plain for the champion team and monsters.
        portrait (member, label) {
            if (member.Gender === 'Monster') return (0, $ht4ts.UNITS_BASE) + member.Class + '.gif';
            const g = (member.Gender || 'Male')[0];
            if (label === 'Champion') return (0, $ht4ts.UNITS_BASE) + member.Class + g + '.gif';
            return (0, $ht4ts.UNITS_BASE) + member.Class + g + '_' + label + '.gif';
        },
        // On-demand head-to-head win% for this cell's two combatants. Runs the
        // Monte-Carlo sim (blocking ~0.3s), deferred a tick so the button shows a
        // pending state first. Self-contained; reuses the same prep as FightModal.
        computeOdds () {
            if (!this.activeLeft || !this.activeRight || this.oddsLoading) return;
            const left = this.activeLeft.name, right = this.activeRight.name;
            this.oddsLoading = true;
            setTimeout(()=>{
                try {
                    const data = {
                        charStats: this.charStats,
                        itemschanged: this.itemschanged,
                        notAbles: this.notAbles,
                        abilitiesInfo: this.abilitiesInfo,
                        monsterSkills: (/*@__PURE__*/$parcel$interopDefault($hYk3h))
                    };
                    const A = (0, $4zJ4j.prepTeam)(this.teamByName[left].roster, data);
                    const B = (0, $4zJ4j.prepTeam)(this.teamByName[right].roster, data);
                    const r = (0, $dr7Eb.runBattles)(A, B, {
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                        terrain: this.popTerrain,
                        tiles: this.popTiles
                    });
                    const champSide = this.teamByName[left].label === 'Champion' ? 'A' : this.teamByName[right].label === 'Champion' ? 'B' : null;
                    const o = (0, $by2uy.calibratedOdds)(r, {
                        champSide: champSide
                    });
                    this.odds = {
                        a: o.a,
                        b: o.b,
                        left: left,
                        right: right
                    };
                } catch (e) {
                    this.odds = null;
                } finally{
                    this.oddsLoading = false;
                }
            }, 0);
        }
    }
};

});
parcelRegister("7xRwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e522e425d0ef40$export$2e2bcd8739ae039);
let $57e522e425d0ef40$var$script;




let $57e522e425d0ef40$var$initialize = ()=>{
    $57e522e425d0ef40$var$script = (parcelRequire("ipr7l"));
    if ($57e522e425d0ef40$var$script.__esModule) $57e522e425d0ef40$var$script = $57e522e425d0ef40$var$script.default;
    $57e522e425d0ef40$var$script.render = (parcelRequire("7DGKb")).render;
    $57e522e425d0ef40$var$script.__cssModules = {};
    (parcelRequire("9JQqT")).default($57e522e425d0ef40$var$script);
    $57e522e425d0ef40$var$script.__scopeId = 'data-v-f1b58d';
    $57e522e425d0ef40$var$script.__file = "UnitSprite.vue";
};
$57e522e425d0ef40$var$initialize();
var $57e522e425d0ef40$export$2e2bcd8739ae039 = $57e522e425d0ef40$var$script;

});
parcelRegister("ipr7l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d66f98c170ac7d9d$export$2e2bcd8739ae039);
// A walking-sprite portrait for a single unit. Resolves the unit's atlas
// key+palette (spriteForClass — tiny), then lazily pulls the heavy sprite
// renderer (manifest.json + canvas LUT) so this component is cheap to import
// into the entry bundle. See tools/fft-sprite/HANDOFF.md ("replacing the
// headshots").
//
// With `attackBursts` on (the live-match bracket cell), each sprite also
// occasionally plays a ONE-SHOT attack animation — the armed swing/poke/bow/gun
// pose with the unit's real Mainhand composited over it (lib/spriteArmed, the
// same path GalleryView uses), falling back to the unarmed `attack` pose for
// monsters, bare hands, or weapons we don't have ripped art for.

var $kmvQC = parcelRequire("kmvQC");
// key:pal:anim -> Promise<{front?,back?}|null>. The recolored canvases are shared
// across every cell showing the same class+color+anim (HANDOFF: "cache by key:pal").
const $d66f98c170ac7d9d$var$spriteCache = new Map();
let $d66f98c170ac7d9d$var$_render = null; // the heavy spriteRender module, imported once
let $d66f98c170ac7d9d$var$_armedLib = null; // the armed-weapon overlay lib, imported once

async function $d66f98c170ac7d9d$var$renderMod() {
    if (!$d66f98c170ac7d9d$var$_render) $d66f98c170ac7d9d$var$_render = await (parcelRequire("9JP80"));
    return $d66f98c170ac7d9d$var$_render;
}

async function $d66f98c170ac7d9d$var$armedMod() {
    if (!$d66f98c170ac7d9d$var$_armedLib) $d66f98c170ac7d9d$var$_armedLib = await (parcelRequire("lIPGL"));
    return $d66f98c170ac7d9d$var$_armedLib;
}
async function $d66f98c170ac7d9d$var$loadCached(key, pal, anim) {
    const k = key + ':' + pal + ':' + anim;
    let p = $d66f98c170ac7d9d$var$spriteCache.get(k);
    if (!p) {
        p = $d66f98c170ac7d9d$var$renderMod().then((m)=>m.loadSprite(key, pal, anim));
        $d66f98c170ac7d9d$var$spriteCache.set(k, p);
    }
    return p;
}
// ONE requestAnimationFrame for every animated UnitSprite on the page — a
// per-component rAF for dozens of canvases melts a phone (HANDOFF watch-out).
const $d66f98c170ac7d9d$var$live = new Set();
let $d66f98c170ac7d9d$var$raf = 0;
function $d66f98c170ac7d9d$var$frame(now) {
    for (const inst of $d66f98c170ac7d9d$var$live)inst._draw(now);
    $d66f98c170ac7d9d$var$raf = $d66f98c170ac7d9d$var$live.size ? requestAnimationFrame($d66f98c170ac7d9d$var$frame) : 0;
}
function $d66f98c170ac7d9d$var$startTicking(inst) {
    $d66f98c170ac7d9d$var$live.add(inst);
    if (!$d66f98c170ac7d9d$var$raf) $d66f98c170ac7d9d$var$raf = requestAnimationFrame($d66f98c170ac7d9d$var$frame);
}
function $d66f98c170ac7d9d$var$stopTicking(inst) {
    $d66f98c170ac7d9d$var$live.delete(inst);
    if (!$d66f98c170ac7d9d$var$live.size && $d66f98c170ac7d9d$var$raf) {
        cancelAnimationFrame($d66f98c170ac7d9d$var$raf);
        $d66f98c170ac7d9d$var$raf = 0;
    }
}
// Padding (sprite px) around the armed body so a raised weapon (a lifted blade
// reaches ~47px from the origin) doesn't clip; the body sits inset at (X, T).
const $d66f98c170ac7d9d$var$PAD = {
    X: 24,
    T: 34,
    B: 6
};
// Per-unit gap between attack bursts (ms). Randomized in this range and started
// from a random offset per instance, so the ~8 cell units never swing in unison.
const $d66f98c170ac7d9d$var$BURST_MIN = 6000, $d66f98c170ac7d9d$var$BURST_MAX = 15000;
function $d66f98c170ac7d9d$var$prefersReducedMotion() {
    return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
var $d66f98c170ac7d9d$export$2e2bcd8739ae039 = {
    name: 'UnitSprite',
    props: {
        // The unit (needs Class + Gender; Mainhand drives the armed weapon). Resolved via spriteForUnit.
        unit: {
            type: Object,
            required: true
        },
        // Team color NAME ('Red'/'Champion'/…); ignored for monsters (family palette).
        teamColor: {
            type: String,
            default: ''
        },
        // Portrait shown while loading / when the class has no walk sprite.
        fallbackSrc: {
            type: String,
            default: ''
        },
        // Animate on the shared ticker, or draw a static first frame. Default static
        // for perf when many are on screen; the active-fight cell passes true.
        animated: {
            type: Boolean,
            default: false
        },
        // Occasionally interrupt the walk loop with a one-shot armed attack. Only the
        // live-match bracket cell opts in; needs `animated` too. Honors reduced-motion.
        attackBursts: {
            type: Boolean,
            default: false
        },
        // Mirror horizontally (left team faces right, as the headshots did).
        flip: {
            type: Boolean,
            default: false
        },
        // Target display height in px.
        size: {
            type: Number,
            default: 48
        }
    },
    data () {
        return {
            ready: false,
            attacking: false
        };
    },
    computed: {
        alt () {
            return this.unit && this.unit.Class || '';
        }
    },
    watch: {
        'unit.Class': 'reload',
        'unit.Gender': 'reload',
        'unit.Mainhand': 'resetArmed',
        teamColor: 'reload',
        animated (v) {
            if (v) this.maybeStart();
            else {
                $d66f98c170ac7d9d$var$stopTicking(this);
                this.stopBursts();
                this.renderStatic();
            }
        },
        attackBursts (v) {
            if (v) this.scheduleBurst();
            else this.stopBursts();
        }
    },
    mounted () {
        this.reload();
    },
    beforeUnmount () {
        this._dead = true;
        $d66f98c170ac7d9d$var$stopTicking(this);
        this.clearBurstTimer();
    },
    methods: {
        async reload () {
            $d66f98c170ac7d9d$var$stopTicking(this);
            this.stopBursts();
            this.ready = false;
            this._pose = null;
            this._poseName = null;
            this.resetArmed();
            const u = this.unit;
            // Unknown class (e.g. a unique raid boss with no walk sprite) → keep the
            // real headshot rather than rendering a wrong stand-in.
            if (!u || !(0, $kmvQC.hasWalkSprite)(u.Class, u.Gender)) return;
            const { key: key, pal: pal } = (0, $kmvQC.spriteForUnit)(u.Class, u.Gender, this.teamColor);
            this._key = key;
            this._pal = pal;
            const token = this._token = (this._token || 0) + 1;
            const sprite = await $d66f98c170ac7d9d$var$loadCached(key, pal, 'walk');
            if (token !== this._token || this._dead) return; // unit/color changed mid-load
            const poseName = sprite && (sprite.front ? 'front' : sprite.back ? 'back' : null);
            if (!poseName) return; // stay on the fallback img
            this._pose = sprite[poseName];
            this._poseName = poseName;
            this._t0 = 0;
            this.ready = true;
            this.$nextTick(()=>{
                const cv = this.$refs.cv;
                if (!cv) return;
                cv.width = this._pose.fw;
                cv.height = this._pose.fh;
                this.renderStatic();
                this.maybeStart();
            });
        },
        maybeStart () {
            if (this.animated && this._pose) $d66f98c170ac7d9d$var$startTicking(this);
            this.scheduleBurst();
        },
        renderStatic () {
            if (this._pose) this.blit(0);
        },
        // ---- walk loop (in-flow canvas) ----
        blit (f) {
            const cv = this.$refs.cv, p = this._pose;
            if (!cv || !p) return;
            const cx = cv.getContext('2d');
            cx.imageSmoothingEnabled = false;
            cx.clearRect(0, 0, p.fw, p.fh);
            cx.drawImage(p.canvas, f * p.fw, 0, p.fw, p.fh, 0, 0, p.fw, p.fh);
        },
        _draw (now) {
            // Playing a one-shot attack? Render the armed overlay until the cycle ends.
            if (this.attacking && this._armed) {
                const p = this._armed.pose;
                const delays = p.delaysCs && p.delaysCs.length ? p.delaysCs : new Array(p.frames).fill(8);
                let total = 0;
                const cum = delays.map((d)=>total += d * 10); // cs → ms
                if (!this._atk) this._atk = now;
                const t = now - this._atk;
                if (t >= total) {
                    this.endBurst();
                    return;
                }
                let f = 0;
                while(f < cum.length - 1 && t >= cum[f])f++;
                this.drawArmed(f);
                return;
            }
            const p = this._pose;
            if (!p) return;
            const delays = p.delaysCs && p.delaysCs.length ? p.delaysCs : new Array(p.frames).fill(8);
            if (!this._t0) this._t0 = now;
            let total = 0;
            const cum = delays.map((d)=>total += d * 10); // cs → ms
            const t = (now - this._t0) % total;
            let f = 0;
            while(f < cum.length - 1 && t >= cum[f])f++;
            this.blit(f);
        },
        // ---- armed attack (overlay canvas) ----
        // Reset the memoized armed pose so the next burst re-resolves it (unit or
        // weapon changed). Safe to call before anything is loaded.
        resetArmed () {
            this._armedPromise = null;
            this._armed = null;
        },
        // Resolve + load this unit's attack pose: the armed swing/poke/bow/gun body
        // with its Mainhand composited, or the plain unarmed `attack` pose when there's
        // no ripped weapon art / it's a monster / bare-handed. Memoized per instance.
        loadArmed () {
            if (!this._armedPromise) this._armedPromise = this._resolveArmed();
            return this._armedPromise;
        },
        async _resolveArmed () {
            const key = this._key, pal = this._pal;
            if (!key) return null;
            const rmod = await $d66f98c170ac7d9d$var$renderMod();
            const meta = rmod.SPRITE_BY_KEY[key];
            let item = null, family = 'attack';
            // Only the human rigs (TYPE1/TYPE2) have armed timelines; monsters use `attack`.
            const mh = this.unit && this.unit.Mainhand;
            if (mh && meta && (meta.rig === 'TYPE1' || meta.rig === 'TYPE2')) {
                const lib = await $d66f98c170ac7d9d$var$armedMod();
                const wep = await lib.loadWeapons();
                const found = wep.meta.items.find((i)=>i.name === mh);
                if (found && meta.anims && meta.anims[found.family]) {
                    item = found;
                    family = found.family;
                    this._lib = lib;
                    this._wep = wep;
                }
            }
            const sprite = await $d66f98c170ac7d9d$var$loadCached(key, pal, family);
            if (this._dead) return null;
            const poseName = sprite && (this._poseName && sprite[this._poseName] && this._poseName || (sprite.front ? 'front' : sprite.back ? 'back' : null));
            if (!poseName) return null; // no attack pose → skip bursts
            let tl = null;
            if (item) {
                tl = this._lib.timelineFor(this._wep.meta, meta.rig, family, item.wt, poseName) || null;
                if (!tl) item = null; // no timeline → body-only swing
            }
            const armed = {
                pose: sprite[poseName],
                item: item,
                tl: tl
            };
            this._armed = armed;
            return armed;
        },
        sizeAtkCanvas () {
            const cv = this.$refs.atk, A = this._armed;
            if (!cv || !A) return;
            const p = A.pose;
            cv.width = p.fw + $d66f98c170ac7d9d$var$PAD.X * 2;
            cv.height = p.fh + $d66f98c170ac7d9d$var$PAD.T + $d66f98c170ac7d9d$var$PAD.B;
            // Display the body at the SAME scale as the walk sprite (size / walkFh) and
            // bottom-anchor it so the feet don't jump; the weapon padding overflows the
            // portrait box upward/sideways (no reflow — the canvas is absolute).
            const scale = this.size / (this._pose ? this._pose.fh : p.fh);
            cv.style.width = cv.width * scale + 'px';
            cv.style.height = cv.height * scale + 'px';
            cv.style.bottom = -$d66f98c170ac7d9d$var$PAD.B * scale + 'px';
        },
        drawArmed (f) {
            const cv = this.$refs.atk, A = this._armed;
            if (!cv || !A) return;
            const p = A.pose;
            const cx = cv.getContext('2d');
            cx.imageSmoothingEnabled = false;
            cx.clearRect(0, 0, cv.width, cv.height);
            const ox = p.ox + $d66f98c170ac7d9d$var$PAD.X, oy = p.oy + $d66f98c170ac7d9d$var$PAD.T;
            const st = A.tl && A.item ? A.tl[Math.min(f, A.tl.length - 1)] : null;
            if (st) this._lib.drawWeapon(cx, this._wep, st, A.item, ox, oy, 1); // behind body
            cx.drawImage(p.canvas, f * p.fw, 0, p.fw, p.fh, $d66f98c170ac7d9d$var$PAD.X, $d66f98c170ac7d9d$var$PAD.T, p.fw, p.fh);
            if (st) this._lib.drawWoosh(cx, this._wep, st, ox, oy, 1); // additive, front
        },
        // ---- burst scheduling ----
        clearBurstTimer () {
            if (this._burstTimer) {
                clearTimeout(this._burstTimer);
                this._burstTimer = 0;
            }
        },
        stopBursts () {
            this.clearBurstTimer();
            this.attacking = false;
            this._atk = 0;
        },
        scheduleBurst () {
            this.clearBurstTimer();
            if (this._dead || !this.animated || !this.attackBursts || $d66f98c170ac7d9d$var$prefersReducedMotion()) return;
            if (!this.unit || !(0, $kmvQC.hasWalkSprite)(this.unit.Class, this.unit.Gender)) return;
            const delay = $d66f98c170ac7d9d$var$BURST_MIN + Math.random() * ($d66f98c170ac7d9d$var$BURST_MAX - $d66f98c170ac7d9d$var$BURST_MIN);
            this._burstTimer = setTimeout(()=>this.fireBurst(), delay);
        },
        async fireBurst () {
            this._burstTimer = 0;
            if (this._dead || !this.animated || !this.attackBursts) return;
            const A = await this.loadArmed();
            if (this._dead || !this.animated || !this.attackBursts) return;
            if (!A) {
                this.scheduleBurst();
                return;
            } // no attack pose — try again later
            this.attacking = true;
            this._atk = 0;
            this.$nextTick(()=>{
                this.sizeAtkCanvas();
                this.drawArmed(0);
            });
            $d66f98c170ac7d9d$var$startTicking(this); // ensure the ticker is running
        },
        endBurst () {
            this.attacking = false;
            this._atk = 0;
            this.scheduleBurst(); // queue the next one
        }
    }
};

});
parcelRegister("kmvQC", function(module, exports) {

$parcel$export(module.exports, "hasWalkSprite", () => $ed2e90fcb9fec4df$export$39784e19c6759f44);
$parcel$export(module.exports, "spriteForUnit", () => $ed2e90fcb9fec4df$export$9b143bfdbb23bbc5);
$parcel$export(module.exports, "matchColors", () => $ed2e90fcb9fec4df$export$5fc70ff0f69b10e6);
$parcel$export(module.exports, "startsWithSprites", () => $ed2e90fcb9fec4df$export$baae23593194c662);
$parcel$export(module.exports, "randomSprite", () => $ed2e90fcb9fec4df$export$730512728d5911d7);
$parcel$export(module.exports, "mulberry32", () => $ed2e90fcb9fec4df$export$d22a027dada4117a);
// Map an FFTBG unit's Class (+ Gender) to a disc-derived sprite atlas key + a
// palette index — the data behind the walking billboards on the map
// (MapViewer3D, used by the bracket-hover popup and the Maps page).
//
// Sprite keys are the romaji disc filenames (KNIGHT_M, YUMI_M = Archer, KURO =
// Black Mage, SIRO = White Mage…); the authoritative slot→key table lives in
// tools/fft-sprite/gen_shapes.mjs. FFTBG class names are the PSX/WotL set
// (Wizard = Black Mage, Priest = White Mage, Lancer = Dragoon, Calculator,
// Mediator, Oracle…) and can arrive SPACED ("Time Mage", "Red Chocobo"), so we
// strip whitespace to match the unspaced canonical keys (the same convention as
// lib/unitStats.js's classKey).
//
// Palettes: each SPR carries 16 (manifest `pals`), the first 8 being the FFTBG
// team colors (confirmed from the dev's canonical sprites): index 0 Black ·
// 1 Blue · 2 Red · 3 Green · 4 White · 5 Purple · 6 Yellow · 7 Brown. HUMANS tint
// by their team color name via teamPalette(). For MONSTERS, color is a family
// tier (Wild Boar / Swine / Porky are all URI in different palettes) and is
// INDEPENDENT of team. The per-class tier is now pinned AUTHORITATIVELY from the
// disc: FFT's 48 monster jobs (0x5E–0x8D) are 16 families of 3 CONSECUTIVE jobs
// sharing one sprite, and the engine renders tier = palette = the job's rank in
// its family (0/1/2). So `pal` below = the class's position within its family,
// in the game's job order (= the FFTBG class-list order in classes.backup.json).
// Cross-checked: this reproduces the BOM family (Bomb 0 / Grenade 1 / Explosive 2)
// that NOTES.md had RE'd independently by eyeballing colors. (Unmapped classes
// still fall back to stablePal — see spriteForUnit.) RE script: tools/fft-sprite/
// reMonsterPalettes.mjs.
// human (space-stripped) class name → sprite base; the gender suffix (_M/_W) is
// added in spriteForUnit. Covers all 20 generic FFTBG jobs.
const $ed2e90fcb9fec4df$export$a53f49b902aacf80 = {
    Squire: 'MINA',
    Chemist: 'ITEM',
    Knight: 'KNIGHT',
    Archer: 'YUMI',
    Monk: 'MONK',
    Priest: 'SIRO',
    Wizard: 'KURO',
    TimeMage: 'TOKI',
    Summoner: 'SYOU',
    Thief: 'THIEF',
    Mediator: 'WAJU',
    Oracle: 'ONMYO',
    Geomancer: 'FUSUI',
    Lancer: 'RYU',
    Samurai: 'SAMU',
    Ninja: 'NINJA',
    Calculator: 'SAN',
    Bard: 'GIN',
    Dancer: 'ODORI',
    Mime: 'MONO'
};
// gender-locked jobs ship a single sheet, regardless of the unit's Gender field.
const $ed2e90fcb9fec4df$var$FORCE_GENDER = {
    GIN: 'M',
    ODORI: 'W'
}; // Bard ♂, Dancer ♀
const $ed2e90fcb9fec4df$export$1ea54820ca4fd292 = {
    // Chocobo family
    Chocobo: {
        key: 'CYOKO',
        pal: 0
    },
    BlackChocobo: {
        key: 'CYOKO',
        pal: 1
    },
    RedChocobo: {
        key: 'CYOKO',
        pal: 2
    },
    // Goblin family
    Goblin: {
        key: 'GOB',
        pal: 0
    },
    BlackGoblin: {
        key: 'GOB',
        pal: 1
    },
    Gobbledeguck: {
        key: 'GOB',
        pal: 2
    },
    // Bomb family
    Bomb: {
        key: 'BOM',
        pal: 0
    },
    Grenade: {
        key: 'BOM',
        pal: 1
    },
    Explosive: {
        key: 'BOM',
        pal: 2
    },
    // Panther / Coeurl family (HYOU)
    RedPanther: {
        key: 'HYOU',
        pal: 0
    },
    Coeurl: {
        key: 'HYOU',
        pal: 1
    },
    Vampire: {
        key: 'HYOU',
        pal: 2
    },
    // Pisco Demon / Squid family (IKA)
    PiscoDemon: {
        key: 'IKA',
        pal: 0
    },
    Squidraken: {
        key: 'IKA',
        pal: 1
    },
    Mindflayer: {
        key: 'IKA',
        pal: 2
    },
    // Skeleton family (SUKERU)
    Skeleton: {
        key: 'SUKERU',
        pal: 0
    },
    Draugr: {
        key: 'SUKERU',
        pal: 1
    },
    Reaper: {
        key: 'SUKERU',
        pal: 2
    },
    // Ghost family (YUREI)
    Ghoul: {
        key: 'YUREI',
        pal: 0
    },
    Ghost: {
        key: 'YUREI',
        pal: 1
    },
    Revenant: {
        key: 'YUREI',
        pal: 2
    },
    // Bird family (TORI, flying)
    Juravis: {
        key: 'TORI',
        pal: 0
    },
    IronHawk: {
        key: 'TORI',
        pal: 1
    },
    Cockatrice: {
        key: 'TORI',
        pal: 2
    },
    // Pig / Boar family (URI) — Swine / Porky / Wild Boar (game's job order)
    Swine: {
        key: 'URI',
        pal: 0
    },
    Porky: {
        key: 'URI',
        pal: 1
    },
    WildBoar: {
        key: 'URI',
        pal: 2
    },
    // Minotaur family (MINOTA)
    BullDemon: {
        key: 'MINOTA',
        pal: 0
    },
    Minotaur: {
        key: 'MINOTA',
        pal: 1
    },
    Sekhret: {
        key: 'MINOTA',
        pal: 2
    },
    // Malboro family (MOL)
    Malboro: {
        key: 'MOL',
        pal: 0
    },
    Ochu: {
        key: 'MOL',
        pal: 1
    },
    GreatMalboro: {
        key: 'MOL',
        pal: 2
    },
    // Behemoth family (BEHI)
    Behemoth: {
        key: 'BEHI',
        pal: 0
    },
    KingBehemoth: {
        key: 'BEHI',
        pal: 1
    },
    DarkBehemoth: {
        key: 'BEHI',
        pal: 2
    },
    // Dragon family (DORA1)
    Dragon: {
        key: 'DORA1',
        pal: 0
    },
    BlueDragon: {
        key: 'DORA1',
        pal: 1
    },
    RedDragon: {
        key: 'DORA1',
        pal: 2
    },
    // Hydra family (DORA2) — Wyvern / Hydra / Tiamat
    Wyvern: {
        key: 'DORA2',
        pal: 0
    },
    Hydra: {
        key: 'DORA2',
        pal: 1
    },
    Tiamat: {
        key: 'DORA2',
        pal: 2
    },
    // Demon family (DEMON) — only 2 tiers exist on this sprite; Apanda's true sprite
    // is BIBUROS (slot 0x96) so it has no DEMON tier → pal 0 stand-in.
    ArchaicDemon: {
        key: 'DEMON',
        pal: 0
    },
    UltimaDemon: {
        key: 'DEMON',
        pal: 1
    },
    Apanda: {
        key: 'DEMON',
        pal: 0
    },
    // Ahriman / floating-eye family (AHRIMAN) — extracted from the dev's BMP set
    FloatingEye: {
        key: 'AHRIMAN',
        pal: 0
    },
    Ahriman: {
        key: 'AHRIMAN',
        pal: 1
    },
    Plague: {
        key: 'AHRIMAN',
        pal: 2
    },
    // Treant / tree family (TREANT)
    Dryad: {
        key: 'TREANT',
        pal: 0
    },
    Treant: {
        key: 'TREANT',
        pal: 1
    },
    Taiju: {
        key: 'TREANT',
        pal: 2
    },
    // Serpentarius — the Elidibs serpent sprite (slot 0x97); rig MON/RUKA
    Serpentarius: {
        key: 'ELIDIBS',
        pal: 0
    },
    // uniques / closest model (no dedicated sheet for these) — base palette of their
    // own sprite (not a shared family tier).
    SteelGiant: {
        key: 'TETSU',
        pal: 0
    },
    Byblos: {
        key: 'BIBUROS',
        pal: 0
    },
    HolyDragon: {
        key: 'DORA1',
        pal: 0
    }
};
// when a class isn't in either table
const $ed2e90fcb9fec4df$var$FALLBACK_HUMAN = 'KNIGHT_M';
const $ed2e90fcb9fec4df$var$FALLBACK_MONSTER = 'GOB';
const $ed2e90fcb9fec4df$var$noSpace = (s)=>String(s == null ? '' : s).replace(/\s+/g, '');
// stable 0–2 from a string, so a given monster class is consistently one color
// (rather than flickering between hovers).
function $ed2e90fcb9fec4df$var$stablePal(name) {
    let h = 0;
    const s = String(name);
    for(let i = 0; i < s.length; i++)h = Math.imul(h, 31) + s.charCodeAt(i) >>> 0;
    return h % 3;
}
const $ed2e90fcb9fec4df$export$fa42fff0b264959e = {
    black: 0,
    blue: 1,
    red: 2,
    green: 3,
    white: 4,
    purple: 5,
    yellow: 6,
    brown: 7
};
const $ed2e90fcb9fec4df$export$66bc52401e1af6a1 = Object.keys($ed2e90fcb9fec4df$export$fa42fff0b264959e);
function $ed2e90fcb9fec4df$export$d5c9880b89c8eea3(teamColor) {
    return $ed2e90fcb9fec4df$export$fa42fff0b264959e[String(teamColor || '').toLowerCase()] ?? 0;
}
function $ed2e90fcb9fec4df$export$7652a93dd6861517(cls) {
    return Object.prototype.hasOwnProperty.call($ed2e90fcb9fec4df$export$1ea54820ca4fd292, $ed2e90fcb9fec4df$var$noSpace(cls));
}
function $ed2e90fcb9fec4df$export$39784e19c6759f44(cls) {
    const name = $ed2e90fcb9fec4df$var$noSpace(cls);
    return Object.prototype.hasOwnProperty.call($ed2e90fcb9fec4df$export$a53f49b902aacf80, name) || Object.prototype.hasOwnProperty.call($ed2e90fcb9fec4df$export$1ea54820ca4fd292, name);
}
function $ed2e90fcb9fec4df$export$9b143bfdbb23bbc5(cls, gender, teamColor) {
    const name = $ed2e90fcb9fec4df$var$noSpace(cls);
    const human = $ed2e90fcb9fec4df$export$a53f49b902aacf80[name];
    if (human) {
        const suffix = $ed2e90fcb9fec4df$var$FORCE_GENDER[human] || (gender === 'Female' ? 'W' : 'M');
        return {
            key: human + '_' + suffix,
            pal: $ed2e90fcb9fec4df$export$d5c9880b89c8eea3(teamColor)
        };
    }
    const mon = $ed2e90fcb9fec4df$export$1ea54820ca4fd292[name];
    if (mon) return {
        key: mon.key,
        pal: mon.pal == null ? $ed2e90fcb9fec4df$var$stablePal(name) : mon.pal
    };
    // unknown class — a Monster-gender unit gets a creature, everything else a knight
    if (gender === 'Monster') return {
        key: $ed2e90fcb9fec4df$var$FALLBACK_MONSTER,
        pal: $ed2e90fcb9fec4df$var$stablePal(name)
    };
    return {
        key: $ed2e90fcb9fec4df$var$FALLBACK_HUMAN,
        pal: $ed2e90fcb9fec4df$export$d5c9880b89c8eea3(teamColor)
    };
}
function $ed2e90fcb9fec4df$export$420d13627166c637(palettesStr) {
    return String(palettesStr || '').split('/').map((c)=>c.trim().toLowerCase()).filter(Boolean);
}
function $ed2e90fcb9fec4df$export$5fc70ff0f69b10e6(left, right) {
    const opts = (t)=>{
        const o = $ed2e90fcb9fec4df$export$420d13627166c637(t && t.palettes);
        if (o.length) return o;
        const n = t && t.name;
        return n && n !== 'champion' ? [
            String(n).toLowerCase()
        ] : [];
    };
    const lo = opts(left), ro = opts(right);
    let l = lo[0], r = ro[0];
    if (l && l === r) {
        if (left && left.name === 'champion' && lo[1]) l = lo[1];
        else if (ro[1]) r = ro[1];
        else if (lo[1]) l = lo[1];
    }
    l = l || 'black';
    return [
        l,
        r || (l !== 'blue' ? 'blue' : 'red')
    ];
}
function $ed2e90fcb9fec4df$export$baae23593194c662(starts, leftTeam, rightTeam) {
    if (!starts || !starts.length) return starts || [];
    const [lColor, rColor] = $ed2e90fcb9fec4df$export$5fc70ff0f69b10e6(leftTeam, rightTeam);
    const L = leftTeam && leftTeam.roster || [], R = rightTeam && rightTeam.roster || [];
    return starts.map((s)=>{
        const p1 = s.team === 'Player 1';
        const member = (p1 ? L : R)[s.unit];
        if (!member) return s;
        return {
            ...s,
            sprite: $ed2e90fcb9fec4df$export$9b143bfdbb23bbc5(member.Class, member.Gender, p1 ? lColor : rColor)
        };
    });
}
// ---- Maps page: a random unit per tile (no roster to read) ----
const $ed2e90fcb9fec4df$var$HUMAN_BASES = Object.values($ed2e90fcb9fec4df$export$a53f49b902aacf80);
const $ed2e90fcb9fec4df$var$MONSTER_KEYS = [
    ...new Set(Object.values($ed2e90fcb9fec4df$export$1ea54820ca4fd292).map((m)=>m.key))
];
function $ed2e90fcb9fec4df$export$730512728d5911d7(rng = Math.random, monsterChance = 0.18) {
    if (rng() < monsterChance) {
        const key = $ed2e90fcb9fec4df$var$MONSTER_KEYS[Math.floor(rng() * $ed2e90fcb9fec4df$var$MONSTER_KEYS.length)] || $ed2e90fcb9fec4df$var$FALLBACK_MONSTER;
        return {
            key: key,
            pal: Math.floor(rng() * 3)
        };
    }
    const base = $ed2e90fcb9fec4df$var$HUMAN_BASES[Math.floor(rng() * $ed2e90fcb9fec4df$var$HUMAN_BASES.length)] || 'KNIGHT';
    const suffix = $ed2e90fcb9fec4df$var$FORCE_GENDER[base] || (rng() < 0.5 ? 'M' : 'W');
    const color = $ed2e90fcb9fec4df$export$66bc52401e1af6a1[Math.floor(rng() * $ed2e90fcb9fec4df$export$66bc52401e1af6a1.length)]; // any team color, for variety
    return {
        key: base + '_' + suffix,
        pal: $ed2e90fcb9fec4df$export$d5c9880b89c8eea3(color)
    };
}
function $ed2e90fcb9fec4df$export$d22a027dada4117a(seed) {
    let a = seed >>> 0;
    return function() {
        a = a + 0x6D2B79F5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}

});

parcelRegister("9JP80", function(module, exports) {
module.exports = Promise.all([
    import("g3Uzr"),
    import("cR4KY"),
    import("1bQnR")
]).then(()=>parcelRequire('9qON5'));

});

parcelRegister("lIPGL", function(module, exports) {
module.exports = import("1J19D").then(()=>parcelRequire('siYDz'));

});


parcelRegister("7DGKb", function(module, exports) {

$parcel$export(module.exports, "render", () => $58fd54fbfcb8fcff$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $58fd54fbfcb8fcff$var$_hoisted_1 = {
    ref: "cv",
    class: "us-cv"
};
const $58fd54fbfcb8fcff$var$_hoisted_2 = {
    ref: "atk",
    class: "us-atk"
};
const $58fd54fbfcb8fcff$var$_hoisted_3 = [
    "src",
    "alt"
];
function $58fd54fbfcb8fcff$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        class: (0, $8POXm.normalizeClass)([
            "unit-sprite",
            {
                flipped: $props.flip
            }
        ]),
        style: (0, $8POXm.normalizeStyle)({
            height: $props.size + 'px'
        })
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("canvas", $58fd54fbfcb8fcff$var$_hoisted_1, null, 512), [
            [
                (0, $eeJ70.vShow),
                $data.ready && !$data.attacking
            ]
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("canvas", $58fd54fbfcb8fcff$var$_hoisted_2, null, 512), [
            [
                (0, $eeJ70.vShow),
                $data.attacking
            ]
        ]),
        !$data.ready ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
            key: 0,
            class: "us-fb",
            src: $props.fallbackSrc,
            alt: $options.alt,
            onError: _cache[0] || (_cache[0] = ($event)=>$event.target.style.visibility = 'hidden')
        }, null, 40, $58fd54fbfcb8fcff$var$_hoisted_3)) : (0, $TusQn.createCommentVNode)("", true)
    ], 6);
}

});

parcelRegister("9JQqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7170fd15770ec7d8$export$2e2bcd8739ae039);
let $7170fd15770ec7d8$var$NOOP = ()=>{};
var $7170fd15770ec7d8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("kcejr", function(module, exports) {
module.exports = JSON.parse("{\"generated\":{\"maps\":128},\"maps\":{\"0\":{\"num\":0,\"w\":13,\"h\":16,\"heights\":[[6.5,6.5,6.5,5.5,5.5,5.5,9,5.5,5.5,5.5,5.5,5.5,5.5],[6.5,6,6.5,5.5,5,5,9,5,5,5,5,5,5.5],[6.5,6,6,5.5,5,5,9,5,5,5,5,5,5.5],[7,7,7,5.5,5,5,9,5,5,5.5,4,4,4],[8.5,8.5,8.5,5,5,5,9,4.5,4.5,5.5,2,2,2],[9.5,9,9,9.5,5,5.5,4.5,4,4.5,5.5,1,1,1.5],[9.5,null,null,9.5,5,5,4.5,4.5,4.5,5.5,1,1,1.5],[null,null,null,null,5.5,5.5,5.5,5.5,5.5,5.5,1.5,1.5,1.5],[null,null,null,null,null,6.5,6.5,6.5,null,null,null,null,null],[null,null,null,null,null,7.5,7.5,7.5,null,null,null,null,null],[null,null,null,null,null,8.5,8.5,8.5,null,null,null,null,null],[12.5,11.5,11,11,12,9.5,9.5,9.5,12,11,11,11,12],[11,11,11,11,11,11,11,11,11,11,11,11,11],[12,11,11,11,12,11,11,11,12,11,11,11,12],[0,12,11,11,11,11,11,11,11,11,11,12,0],[0,0,null,null,null,12,12,12,null,null,null,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\"s\",\".\",\".\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\"s\",\"n\",\"n\",\"n\",\"s\",\"M\",\"M\",\"M\",\"s\",\"n\",\"n\",\"n\",\"s\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"s\",\"n\",\"n\",\"n\",\"s\",\"n\",\"n\",\"n\",\"s\",\"n\",\"n\",\"n\",\"s\"],[\"n\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"s\",\"n\"],[\"n\",\"n\",\".\",\".\",\".\",\"n\",\"n\",\"n\",\".\",\".\",\".\",\"n\",\"n\"]],\"starts\":[{\"x\":4,\"y\":4,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":15,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":15,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":15,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":14,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Sand area\":55,\"Stone wall\":43,\"Snow\":40,\"Machine\":12,\"Stone floor\":10,\"Natural Surface\":6},\"stats\":{\"walkable\":166,\"maxHeight\":12.5,\"minHeight\":0,\"spread\":12.5,\"avgHeight\":7.15,\"waterPct\":0}},\"1\":{\"num\":1,\"w\":10,\"h\":13,\"heights\":[[2,2,2,2,2,2,2,1,1.5,1.5],[2,2,2,2,2.5,2.5,2,0,1.5,2],[2,2,2,2,3.5,3.5,2,0,1.5,1.5],[1.5,1.5,0,0,4,4,0,0,0,1.5],[0,0,0,3,4,4,3,0,0,0],[0,0,0,3,4,4,3,0,0,1.5],[0,0,0,0,4,4,0,0,1,1.5],[4,4,2,0,4,4,0,1.5,4,4],[9,9,4,4,4,4,3.5,2.5,9,9],[8,9,4,4,4,4,3.5,2.5,9,8],[14,13,14,4,4,4,4,14,13,14],[14,12.5,14,13,null,null,13,14,12.5,14],[13,10,11.5,13,null,null,13,11.5,10,13]],\"surfaces\":[[\"g\",\"g\",\"g\",\"s\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"w\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"g\",\"s\",\"s\",\"w\",\"g\",\"g\"],[\"g\",\"g\",\"w\",\"w\",\"s\",\"s\",\"w\",\"w\",\"w\",\"g\"],[\"w\",\"w\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"w\",\"w\"],[\"w\",\"w\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"w\",\"g\"],[\"w\",\"w\",\"w\",\"w\",\"s\",\"s\",\"w\",\"w\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"w\",\"s\",\"s\",\"w\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\".\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\".\",\".\",\"s\",\"r\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":7,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":67,\"Grassland\":32,\"Waterway\":26,\"Roof\":1},\"stats\":{\"walkable\":126,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":4.37,\"waterPct\":20.6}},\"2\":{\"num\":2,\"w\":10,\"h\":11,\"heights\":[[1.5,2,2,1.5,1,1,1,0.5,0,0],[1.5,2,null,1.5,1,1,1,0.5,0.5,0.5],[1.5,1.5,1.5,1.5,1,1,1,1,1.5,2],[1,1,1,1,1,1,1.5,1.5,1.5,2],[1,0.5,0.5,0.5,0.5,0.5,1.5,2,2,2],[1.5,3,1,0,0,0.5,1.5,2,2,2],[2.5,4.5,7,7,7,7,7,6.5,5.5,2],[3,6,7,5,5,5,5,4,3,2],[3,null,null,5,5,5,5,null,null,2],[14,null,null,null,null,null,null,null,null,14],[5,5,5,5,5,5,5,5,5,5]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\"],[\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\"],[\"g\",\"g\",\"g\",\"g\",\"n\",\"n\",\"g\",\"n\",\"g\",\"g\"],[\"g\",\"g\",\"n\",\"n\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"n\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"g\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\"g\"],[\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":61,\"Stone floor\":23,\"Natural Surface\":13},\"stats\":{\"walkable\":97,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":2.83,\"waterPct\":0}},\"3\":{\"num\":3,\"w\":9,\"h\":13,\"heights\":[[null,null,null,1,1,1,null,null,null],[null,4,0,1,1,1,0,4,null],[null,4,0,1,1,1,0,4,null],[null,4,0,1,1,1,0,4,null],[null,4,0,1,1,1,0,4,null],[4,4,2,1.5,1.5,1.5,2,4,4],[4,1,2,2,2,2,2,1,4],[4,1,2,2,2,2,2,1,4],[4,1,2,2,2,2,2,1,4],[4,null,3,2,2,2,3,null,4],[4,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4],[null,null,null,4,4,4,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\".\",\"s\",\"w\",\"r\",\"r\",\"r\",\"w\",\"s\",\".\"],[\".\",\"s\",\"w\",\"r\",\"r\",\"r\",\"w\",\"s\",\".\"],[\".\",\"s\",\"w\",\"r\",\"r\",\"r\",\"w\",\"s\",\".\"],[\".\",\"s\",\"w\",\"r\",\"r\",\"r\",\"w\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"w\",\"s\",\"r\",\"r\",\"r\",\"s\",\"w\",\"s\"],[\"s\",\"w\",\"s\",\"r\",\"r\",\"r\",\"s\",\"w\",\"s\"],[\"s\",\"w\",\"s\",\"r\",\"r\",\"r\",\"s\",\"w\",\"s\"],[\"s\",\".\",\"s\",\"r\",\"r\",\"r\",\"s\",\".\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\"]],\"starts\":[{\"x\":1,\"y\":2,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":12,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":12,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":2,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":45,\"Rug\":36,\"Waterway\":14},\"stats\":{\"walkable\":95,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":2.48,\"waterPct\":14.7}},\"4\":{\"num\":4,\"w\":6,\"h\":12,\"heights\":[[0,null,0,0,0,0],[0,0,0,0,0,0],[0,0,1,1,0,0],[0,0,1,1,0,0],[0,0,1,1,0,0],[0,0,0,0,0,0],[0,0,0,0,0,0],[null,null,0,0,0,null],[null,null,1,1,null,null],[2,1,1,1,1,2],[2,1,1,1,1,2],[2,1,1,1,1,2]],\"surfaces\":[[\"s\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"f\",\"f\",\"r\",\"r\"],[\"r\",\"r\",\"f\",\"f\",\"r\",\"r\"],[\"r\",\"r\",\"f\",\"f\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\".\",\".\",\"r\",\"r\",\"s\",\".\"],[\".\",\".\",\"r\",\"r\",\".\",\".\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"f\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"o\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"f\"]],\"starts\":[{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":11,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":11,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":11,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":11,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Rug\":39,\"Stone floor\":16,\"Furniture\":8,\"Wooden floor\":1},\"stats\":{\"walkable\":64,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.5,\"waterPct\":0}},\"5\":{\"num\":5,\"w\":13,\"h\":11,\"heights\":[[0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,1.5,0.5,1.5],[2,1.5,5.5,6.5,7,6.5,7,6.5,7,6.5,7,6.5,7],[4,3,4.5,8,9,8,9,8,9,8,5,8,5],[2,5,5,10,10,10,10,12,10,10,3,10,3],[null,null,null,12,12,12,12,12,12,null,1,null,1],[null,null,null,13,13,null,13,14,null,null,1,null,1],[null,null,null,12,12,12,12,12,12,null,1,null,1],[6,5,5,10,10,10,10,12,10,10,3,10,3],[4,3,4.5,8,9,8,9,8,9,8,5,8,5],[2,1.5,5.5,6.5,7,6.5,7,6.5,7,6.5,7,6.5,7],[0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5,1.5,0.5,1.5]],\"surfaces\":[[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"r\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"c\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\".\",\".\",\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\"o\",\".\",\"o\"],[\".\",\".\",\".\",\"r\",\"r\",\".\",\"r\",\"c\",\".\",\".\",\"o\",\".\",\"o\"],[\".\",\".\",\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\"o\",\".\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"c\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"r\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"r\",\"s\"]],\"starts\":[{\"x\":10,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Roof\":101,\"Wooden floor\":18,\"Stone wall\":4,\"Chimney\":3},\"stats\":{\"walkable\":126,\"maxHeight\":14,\"minHeight\":0.5,\"spread\":13.5,\"avgHeight\":5.98,\"waterPct\":0}},\"6\":{\"num\":6,\"w\":12,\"h\":12,\"heights\":[[4,4,2,1,0,1.5,2,2,2,2,2.5,3],[4,4,0,0,0,0,0,1.5,2,2,2.5,3],[4,3,2,1.5,0,0,0,0,1.5,2,2.5,2.5],[11,10,9,2,1.5,0,0,0,2,2,2,2],[12,12,9,6,3,2.5,0,2,2,2,2,2],[11,12,9,8,7.5,0,0,0,1.5,2,2,2],[11,12,0,0,0,0,0,0,2,2,3,3],[11,11,9,8,7.5,6,4,0,2,2,4,4],[12,13,13.5,14,7,null,6,6,6,7,5,5],[13,13,13,5,5,5,5,5,5,5,5,5],[13,13,13,5,5,5,5,5,5,5,5,5],[13,13,13.5,14,7,null,6,6,6,7,5,5]],\"surfaces\":[[\"s\",\"s\",\"g\",\"g\",\"p\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\",\"g\"],[\"s\",\"s\",\"w\",\"p\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"n\",\"g\"],[\"s\",\"s\",\"s\",\"g\",\"p\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"n\"],[\"s\",\"s\",\"s\",\"g\",\"g\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"w\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"w\",\"w\",\"w\",\"n\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"g\",\"g\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"w\",\"g\",\"g\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"]],\"starts\":[{\"x\":1,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":76,\"Grassland\":35,\"Marsh\":12,\"Waterway\":12,\"Natural Surface\":7},\"stats\":{\"walkable\":142,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":4.75,\"waterPct\":16.9}},\"7\":{\"num\":7,\"w\":8,\"h\":12,\"heights\":[[3,3,3,3,3,3,3,3],[3,2,3,3,3,3,2,3],[3.5,0,3,3,3,3,0,3.5],[4,0,0,3.5,3.5,0,0,4],[3.5,0,4,4.5,4.5,4,0,3.5],[4,0,null,5,5,null,0,4],[5,2,4,6,6,4,2,5],[5,2,2,7,7,2,2,5],[5,2,2,8,8,2,2,5],[7,3,9,9,9,9,3,7],[10,9.5,9,9,9,9,9.5,10],[10,9.5,9,9,9,9,9.5,10]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"s\"],[\"s\",\"w\",\"w\",\"s\",\"s\",\"w\",\"w\",\"s\"],[\"g\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"g\"],[\"g\",\"w\",\".\",\"s\",\"s\",\".\",\"w\",\"g\"],[\"s\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"s\"],[\"s\",\"w\",\"w\",\"s\",\"s\",\"w\",\"w\",\"s\"],[\"s\",\"w\",\"w\",\"s\",\"s\",\"w\",\"w\",\"g\"],[\"s\",\"w\",\"s\",\"s\",\"s\",\"s\",\"w\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":65,\"Waterway\":22,\"Grassland\":7},\"stats\":{\"walkable\":94,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":4.55,\"waterPct\":23.4}},\"8\":{\"num\":8,\"w\":8,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[0,0,1,null,1,1,0,0],[0,0,1,1,1,1,0,0],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[4,4,4,1,1,4,4,4],[2,2,2,2,2,2,2,2],[2,2,2,2,2,2,2,2]],\"surfaces\":[[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"b\"],[\"b\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"b\"],[\"b\",\"r\",\"f\",\".\",\"f\",\"f\",\"r\",\"b\"],[\"b\",\"r\",\"f\",\"f\",\"f\",\"f\",\"r\",\"b\"],[\"b\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"b\"],[\"b\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"o\",\"o\",\"o\",\"S\",\"S\",\"o\",\"o\",\"o\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":44,\"Rug\":28,\"Furniture\":7,\"Wooden floor\":6,\"Stairs\":2},\"stats\":{\"walkable\":87,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":0.75,\"waterPct\":0}},\"9\":{\"num\":9,\"w\":8,\"h\":14,\"heights\":[[6,6,5,1,1,1,5,3],[3,5,5,1,1,1,5,4],[4,6,7,7,1,7,6,5],[5,5,6,1,1,1,5,4.5],[4,4.5,6,1,1,1,5,3],[2,2,null,1,1,1,null,2.5],[2,4,1,1,6,1,1,1],[2,4,1,1,1,1,1,1],[2,2,null,1,1,1,null,2.5],[5,4.5,7,3,3,3,7,2.5],[6,5,7,3,3,3,7,4.5],[10,5,7,3,3,3,7,6],[10,11,8,8,8,8,8,6.5],[10,11,10,8.5,8,8.5,8.5,9]],\"surfaces\":[[\"s\",\"s\",\"g\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"g\",\"g\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"B\",\"w\",\"B\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"w\",\"w\",\".\",\"w\",\"w\",\"w\",\".\",\"g\"],[\"w\",\"g\",\"w\",\"w\",\"s\",\"w\",\"w\",\"w\"],[\"w\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\"],[\"w\",\"w\",\".\",\"w\",\"w\",\"w\",\".\",\"g\"],[\"g\",\"g\",\"s\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"g\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\"]],\"starts\":[{\"x\":1,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":true},{\"x\":7,\"y\":13,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Waterway\":45,\"Grassland\":41,\"Stone floor\":20,\"Bridge\":2},\"stats\":{\"walkable\":108,\"maxHeight\":11,\"minHeight\":1,\"spread\":10,\"avgHeight\":4.23,\"waterPct\":41.7}},\"10\":{\"num\":10,\"w\":11,\"h\":10,\"heights\":[[10,10,2,2,2,2,2,3,3,3,4],[10,10,2,2,2,2,2,3,4,4,4],[10,10,2,2,2,2,2,5,5,5,6],[10,10,2,2,2,2,2,10,6,6,6],[10,10,2,2,10,9,8,8,7,7,8],[10,10,2,2,10,9,8,8,8,8,8],[2,2,2,2,2,2,2,10,8,8,8],[2,2,2,2,2,2,2,8,8,8,8],[1,1,1,1,3,2,2,8,8,8,8],[0,0,0,0,2.5,2,2,8,8,8,8]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":110},\"stats\":{\"walkable\":110,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":4.88,\"waterPct\":0}},\"11\":{\"num\":11,\"w\":7,\"h\":13,\"heights\":[[0,0,0,0,0,0,0],[1,0,0,0,0,0,1],[0,0,0,0,0,0,0],[null,0,0,null,0,0,null],[null,0,0,null,0,0,null],[0,0,0,0,0,0,0],[1,0,0,0,0,0,1],[0,0,0,0,0,0,0],[null,0,null,null,null,null,null],[null,0,0,0,0,0,null],[null,0,0,0,0,0,null],[null,null,0,0,0,null,null],[null,null,null,null,null,null,null]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"f\",\"s\",\"s\",\"s\",\"s\",\"s\",\"f\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\".\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\".\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"f\",\"s\",\"s\",\"s\",\"s\",\"s\",\"f\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\".\",\".\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":6,\"y\":5,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":60,\"Furniture\":4},\"stats\":{\"walkable\":64,\"maxHeight\":1,\"minHeight\":0,\"spread\":1,\"avgHeight\":0.06,\"waterPct\":0}},\"12\":{\"num\":12,\"w\":9,\"h\":15,\"heights\":[[0,0,0,0,4,4,4,4,0],[1.5,0,2,0,4,4,4,4,0],[2,0,0,0,4,4,4,4,2],[3.5,4,3.5,3.5,null,4,4,null,4],[3.5,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4],[4,4,15,4,4,4,4,4,4],[null,15,15,15,15,4,4,15,15],[15,15,15,15,15,4,4,15,15],[15,10.5,10,10,12.5,4,4,12.5,10],[13,10.5,9,7,4,4,4,4,4],[13,10,8,6,4,4,4,4,4],[14.5,14.5,10,5,4,4,4.5,4.5,4.5],[15,14.5,11.5,4,4,4,4.5,5,5]],\"surfaces\":[[\"p\",\"p\",\"p\",\"p\",\"s\",\"b\",\"b\",\"s\",\"p\"],[\"g\",\"p\",\"g\",\"p\",\"s\",\"b\",\"b\",\"s\",\"p\"],[\"g\",\"p\",\"p\",\"p\",\"s\",\"b\",\"b\",\"s\",\"g\"],[\"r\",\"r\",\"r\",\"r\",\".\",\"g\",\"g\",\".\",\"g\"],[\"r\",\"g\",\"g\",\"r\",\"s\",\"g\",\"g\",\"s\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\"],[\"r\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"r\"],[\"g\",\"g\",\"s\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":3,\"y\":14,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":14,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":14,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":14,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":60,\"Stone floor\":47,\"Marsh\":11,\"Rocky cliff\":8,\"Brick\":6},\"stats\":{\"walkable\":132,\"maxHeight\":15,\"minHeight\":0,\"spread\":15,\"avgHeight\":5.95,\"waterPct\":8.3}},\"13\":{\"num\":13,\"w\":8,\"h\":10,\"heights\":[[1,1,1,1,1,1,1,1],[0,0,0,1,1,0,0,0],[0,0,0,1,1,0,0,0],[0,0,0,1,1,0,0,0],[0,0,1,2,2,1,0,0],[5,null,null,4,4,null,null,5],[5,5,5,5,5,5,5,5],[5,6,7,8,8,7,6,5],[null,null,7,7,7,7,null,null],[null,null,null,null,null,null,null,null]],\"surfaces\":[[\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"S\",\"S\",\"s\",\"s\",\"s\"],[\"s\",\".\",\".\",\"S\",\"S\",\".\",\".\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"S\",\"s\",\"s\",\"s\",\"s\",\"S\",\"s\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":2,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":8,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":48,\"Rug\":10,\"Stairs\":6},\"stats\":{\"walkable\":64,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":2.47,\"waterPct\":0}},\"14\":{\"num\":14,\"w\":10,\"h\":9,\"heights\":[[null,null,null,null,null,null,null,null,null,null],[null,null,null,2,0,0,0,0,null,null],[null,null,2,0,0,0,0,0,0,null],[null,0,0,0,null,null,null,0,0,0],[null,0,0,0,null,null,null,0,0,0],[null,0,0,0,null,null,null,0,0,0],[null,null,2,0,0,0,0,0,0,null],[null,null,null,2,0,0,0,null,null,null],[null,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"b\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"r\",\"r\"],[\".\",\"s\",\"s\",\"f\",\".\",\".\",\".\",\"s\",\"r\",\"r\"],[\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"r\",\"r\"],[\".\",\".\",\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\".\",\".\",\"b\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":9,\"y\":5,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":30,\"Rug\":6,\"Box\":4,\"Furniture\":1},\"stats\":{\"walkable\":41,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.2,\"waterPct\":0}},\"15\":{\"num\":15,\"w\":10,\"h\":13,\"heights\":[[4,4,4,4,0,0,0,0,0,0],[4,4,4,4,0,0,0,0,0,0],[14,4,4,14,12,8,8,8,0,0],[14,4,4,14,12,10,9.5,8,8,7.5],[4,4,4,4,3.5,3.5,3,3.5,4,5.5],[4,4,4,4,3.5,3,3,3.5,3.5,3.5],[4,4,4,4,0,0,0,0,0,0],[4,4,4,4,0,0,0,0,0,0],[4,4,4,4,4,3.5,3.5,0,0,0],[4,4,4,4,4,4,3.5,3.5,3.5,3.5],[14,12,12,14,14,12,4,4,4,4],[14,12,12,14,14,12,5,6,6,7],[13.5,13,13,13.5,13.5,11,10,9,8,8]],\"surfaces\":[[\"n\",\"n\",\"n\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\"],[\"g\",\"s\",\"s\",\"s\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"w\",\"w\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"s\",\"g\",\"s\",\"s\"],[\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"s\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\"],[\"g\",\"s\",\"s\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\"],[\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\",\"w\",\"w\",\"w\"],[\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":11,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":11,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":64,\"Grassland\":34,\"Waterway\":29,\"Natural Surface\":3},\"stats\":{\"walkable\":130,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":5.2,\"waterPct\":22.3}},\"16\":{\"num\":16,\"w\":10,\"h\":13,\"heights\":[[4,4,0,0,0,0,0,0,4,4],[4,4,0,0,0,0,0,0,4,4],[4,4,0,0,0,0,0,0,4,4],[4,3.5,0,null,0,0,null,0,3.5,4],[4,3,1,0,0,0,0,1,3,4],[5,3,1,0.5,0.5,0.5,0.5,1,3,5],[6,2,1,1,1,1,1,1,2,6],[6,2,1,1,1,1,1,1,2,6],[6,6,1,1,1,1,1,1,6,6],[6,6,1,1,1,1,1,1,6,6],[6,6,4,1,1,1,1,4,6,6],[null,null,4,2,2,2,2,4,null,null],[null,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"r\",\"r\",\".\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"S\",\"S\",\"S\",\"S\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":4,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":11,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":11,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":88,\"Rug\":22,\"Stairs\":4},\"stats\":{\"walkable\":114,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":2.24,\"waterPct\":0}},\"17\":{\"num\":17,\"w\":6,\"h\":16,\"heights\":[[4,4,4,4,4,4],[4,4,4,4,8,4],[4,4,4,4,4,4],[4,8,4,4,7,4],[4,4,4,4,4,4],[null,4,4,4,4,null],[0,0,4,4,0,0],[0,0,4,4,0,0],[0,0,4,4,0,0],[2,0,4,4,0,0],[3,4,4,4,0,3],[5,5,4,5,5,5],[8,5,6,6,5,5],[6,6,6,6,6,6],[8,8,6,6,8,8],[6,6,6,6,6,6]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"t\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"t\",\"s\",\"s\",\"t\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\".\"],[\"w\",\"w\",\"B\",\"B\",\"w\",\"w\"],[\"w\",\"p\",\"B\",\"B\",\"p\",\"w\"],[\"w\",\"w\",\"B\",\"B\",\"w\",\"w\"],[\"s\",\"p\",\"B\",\"B\",\"p\",\"w\"],[\"s\",\"s\",\"s\",\"s\",\"w\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"c\",\"c\",\"s\",\"s\",\"c\",\"c\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":14,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":14,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":14,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":14,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":63,\"Waterway\":12,\"Bridge\":8,\"Marsh\":4,\"Coffin\":4,\"Tombstone\":3},\"stats\":{\"walkable\":94,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":4.03,\"waterPct\":17}},\"18\":{\"num\":18,\"w\":9,\"h\":10,\"heights\":[[null,null,null,null,0,null,null,null,null],[1,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,1],[1,0,0,0,1,0,0,0,1],[null,0,0,0,1,0,0,0,null],[1,0,0,0,1,0,0,0,1],[1,0,0,0,1,0,0,0,1],[1,0,0,0,0,0,0,0,1],[null,null,0,0,0,0,0,null,null],[null,null,null,3,3,3,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\"s\",\".\",\".\",\".\",\".\"],[\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\"],[\"r\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"r\"],[\"r\",\"s\",\"s\",\"r\",\"f\",\"r\",\"s\",\"s\",\"r\"],[\".\",\"s\",\"s\",\"r\",\"f\",\"r\",\"s\",\"s\",\".\"],[\"r\",\"s\",\"s\",\"r\",\"f\",\"r\",\"s\",\"s\",\"r\"],[\"r\",\"s\",\"s\",\"r\",\"f\",\"r\",\"s\",\"s\",\"r\"],[\"r\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"r\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\".\",\"f\",\"f\",\"f\",\".\",\".\",\".\"]],\"starts\":[{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":8,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":37,\"Rug\":26,\"Furniture\":7},\"stats\":{\"walkable\":70,\"maxHeight\":3,\"minHeight\":0,\"spread\":3,\"avgHeight\":0.36,\"waterPct\":0}},\"19\":{\"num\":19,\"w\":8,\"h\":14,\"heights\":[[1,0,0,0,0,0.5,1,0.5],[1.5,1,0,0,0,0,0,0],[3,5,0,0,0,0,0,0],[6,8,1,1,0,0,0,0.5],[10,10,1,1,1,3,10,10],[10,10.5,10,1,1,10,10.5,10],[3,3,2,1.5,1.5,2.5,3,3],[2.5,2.5,2,2,2,2.5,3,3],[2.5,2.5,2,2,2,2.5,3,3],[3,3,2.5,2,2,2.5,3,5],[3,3,2.5,2.5,2.5,2.5,3,7],[11,11,11,11,11,11,11,11],[13,13,13,11,11,13,13,13],[13,13,13,11,11,13,13,13]],\"surfaces\":[[\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"g\",\"n\",\"n\",\"n\",\"g\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"b\"],[\"g\",\"g\",\"g\",\"S\",\"S\",\"g\",\"g\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":53,\"Grassland\":49,\"Natural Surface\":6,\"Box\":2,\"Stairs\":2},\"stats\":{\"walkable\":112,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":4.77,\"waterPct\":0}},\"20\":{\"num\":20,\"w\":9,\"h\":10,\"heights\":[[null,null,0,0,0,7,0,1,1],[2,1,1,0,0,0,0,1,1],[3,2,3,0,0,7,9,2,3],[10,4,6,6,6,7,10,3,3.5],[7,5,5,5,5,5,5,4,4],[6,6,5,5,5,5,4,4,4],[6,6,5,5,5,5,4,4,4],[7,5,5,5,5,5,5,4,4],[10,5,5,5,5,5,10,3,3],[null,null,5,5,5,5,9,3,3]],\"surfaces\":[[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":5,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":86},\"stats\":{\"walkable\":86,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":4.23,\"waterPct\":0}},\"21\":{\"num\":21,\"w\":11,\"h\":8,\"heights\":[[null,null,4,2,1,1,0.5,1,1,2,null],[null,6,2,1,1,1,1,1,1,1,null],[3,3,2,1,1,1,1,1,1,1,1],[3,3,2,1,1,2,2,2,1,1,1],[3,3,2,1,1,2,2,2,1,1,1],[3,3,2,1,1,1,1,1,1,1,1],[null,6,2,1,1,1,1,1,1,1,null],[null,null,4,2,1,null,null,null,1,2,null]],\"surfaces\":[[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\".\"],[\"s\",\"s\",\"S\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"S\",\"s\",\"r\",\"f\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"S\",\"s\",\"r\",\"f\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"S\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"r\",\"f\",\"f\",\"f\",\"r\",\"s\",\".\"],[\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"s\",\".\"]],\"starts\":[{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":5,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":41,\"Rug\":21,\"Furniture\":9,\"Stairs\":4},\"stats\":{\"walkable\":75,\"maxHeight\":6,\"minHeight\":0.5,\"spread\":5.5,\"avgHeight\":1.63,\"waterPct\":0}},\"22\":{\"num\":22,\"w\":10,\"h\":15,\"heights\":[[2,2,null,2,0,0,0,0,2.5,3],[2,2,2,2,4,2,0,2,2.5,3],[0,0,2,8,7,2,0,2,2.5,2.5],[2,0,2,8,8,2,0,2,null,2],[2,0,0,7,7,2,2,2,2,0],[2,0,2,2,2,2,2,2,2,0],[2,0,8,7,2,0,0,2,4,5],[2,2,8,8,2,0,0,2,7,7],[0,2,7,7,2,0,2,2,8,8],[0,2,3,5,4,0,2,2,7,8],[0,0,0,0,2,0,2,2,2,1],[0,2,2,2,2,0,0,0,2,2],[7.5,8,7.5,2,2,2.5,2.5,2,2.5,2.5],[8.5,10,8.5,6,4,0,0,2,2.5,3],[8.5,9,8.5,7,4,0,0,0,2.5,3]],\"surfaces\":[[\"g\",\"g\",\".\",\"g\",\"w\",\"w\",\"w\",\"w\",\"g\",\"g\"],[\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"w\",\"g\",\"g\",\"g\"],[\"w\",\"w\",\"s\",\"o\",\"r\",\"o\",\"w\",\"s\",\"g\",\"g\"],[\"s\",\"w\",\"s\",\"r\",\"r\",\"s\",\"w\",\"s\",\".\",\"g\"],[\"s\",\"w\",\"w\",\"r\",\"r\",\"s\",\"B\",\"s\",\"s\",\"w\"],[\"s\",\"w\",\"s\",\"s\",\"s\",\"s\",\"B\",\"s\",\"s\",\"w\"],[\"s\",\"w\",\"c\",\"r\",\"o\",\"w\",\"w\",\"s\",\"b\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"w\",\"w\",\"s\",\"r\",\"r\"],[\"w\",\"o\",\"r\",\"r\",\"o\",\"w\",\"s\",\"s\",\"r\",\"r\"],[\"w\",\"s\",\"s\",\"o\",\"b\",\"w\",\"s\",\"s\",\"r\",\"c\"],[\"w\",\"w\",\"w\",\"w\",\"B\",\"w\",\"s\",\"s\",\"s\",\"s\"],[\"w\",\"s\",\"g\",\"g\",\"g\",\"w\",\"w\",\"w\",\"s\",\"g\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"B\",\"B\",\"s\",\"g\",\"g\"],[\"r\",\"c\",\"r\",\"b\",\"b\",\"w\",\"w\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"o\",\"b\",\"w\",\"w\",\"w\",\"g\",\"g\"]],\"starts\":[{\"x\":7,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":42,\"Waterway\":38,\"Grassland\":25,\"Roof\":23,\"Wooden floor\":7,\"Bridge\":5,\"Box\":5,\"Chimney\":3},\"stats\":{\"walkable\":148,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":2.78,\"waterPct\":25.7}},\"23\":{\"num\":23,\"w\":9,\"h\":12,\"heights\":[[2,0,3,3,3,3,3,2,2],[0,0,3,3,3,3,3,0,0],[0,0,3,null,3,null,3,0,0],[0,0,3,3,3,3,3,0,0],[0,5,5,4,4,4,5,5,0],[0,5,null,5,5,5,null,5,2],[1.5,5,5,5,5,5,5,5,2],[2,5,5,5,5,5,5,5,4],[2,null,null,17,5,17,null,null,4],[3,null,null,17,19,17,null,null,3],[17,17,17,17,19,17,17,17,17],[19,19,19,19,19,19,19,19,19]],\"surfaces\":[[\"s\",\"w\",\"g\",\"g\",\"s\",\"g\",\"g\",\"s\",\"s\"],[\"w\",\"w\",\"g\",\"g\",\"s\",\"g\",\"g\",\"w\",\"w\"],[\"w\",\"w\",\"g\",\".\",\"s\",\".\",\"g\",\"w\",\"w\"],[\"w\",\"w\",\"g\",\"g\",\"s\",\"g\",\"g\",\"w\",\"w\"],[\"w\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"w\"],[\"w\",\"g\",\".\",\"s\",\"s\",\"s\",\".\",\"g\",\"s\"],[\"s\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"s\"],[\"s\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"s\",\"s\"],[\"s\",\".\",\".\",\"r\",\"s\",\"r\",\".\",\".\",\"s\"],[\"s\",\".\",\".\",\"r\",\"r\",\"r\",\".\",\".\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"]],\"starts\":[{\"x\":2,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":7,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":7,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":30,\"Grassland\":27,\"Roof\":23,\"Waterway\":16},\"stats\":{\"walkable\":96,\"maxHeight\":19,\"minHeight\":0,\"spread\":19,\"avgHeight\":6.55,\"waterPct\":16.7}},\"24\":{\"num\":24,\"w\":8,\"h\":11,\"heights\":[[null,null,0,0,0,null,null,null],[null,0,0,0,0,0,null,null],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,8,0],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,8,0],[0,1,1,1,1,1,0,0],[0,2,null,null,null,2,0,0],[null,3,3,3,3,3,null,null],[null,null,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\"s\",\"r\",\"s\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"r\",\"s\",\"s\",\".\",\".\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"o\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"o\",\"s\"],[\"s\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\"],[\"s\",\"o\",\".\",\".\",\".\",\"o\",\"s\",\"s\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"o\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":45,\"Wooden floor\":14,\"Rug\":7},\"stats\":{\"walkable\":66,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":0.61,\"waterPct\":0}},\"25\":{\"num\":25,\"w\":10,\"h\":12,\"heights\":[[0.5,1,1,1,1,1,1,1.5,2,1.5],[0.5,1,1,1,1,1,1,1.5,null,1.5],[0.5,1,1,1,1,1,1,1.5,1.5,1.5],[1.5,1,1,1,1,1,1,1,1,null],[6,6,6,11,2,11,6,null,1,1],[3,3,3,3,3,3,6,6,null,1],[3,3,3,3,3,3,3,6,6,0.5],[3,3,3,3,3,3,3,3,6,0.5],[3,3,3,3,3,3,3,3,null,null],[3,3,3,9,8.5,3,3,3,7,11],[10,11,10,9,8.5,3,3,6,null,6],[10,11,10,9,9,3,7,8,6,6]],\"surfaces\":[[\"n\",\"n\",\"n\",\"g\",\"s\",\"s\",\"n\",\"n\",\"g\",\"g\"],[\"n\",\"n\",\"g\",\"s\",\"s\",\"s\",\"n\",\"n\",\".\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"n\",\"n\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"g\",\"n\",\"g\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"S\",\"s\",\"s\",\".\",\"g\",\"g\"],[\"n\",\"n\",\"g\",\"g\",\"s\",\"g\",\"s\",\"s\",\".\",\"g\"],[\"n\",\"s\",\"g\",\"g\",\"s\",\"g\",\"g\",\"s\",\"s\",\"g\"],[\"n\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"s\",\"g\"],[\"n\",\"g\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\".\",\".\"],[\"n\",\"n\",\"s\",\"r\",\"r\",\"s\",\"s\",\"n\",\"S\",\"o\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\".\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"c\",\"s\",\"o\",\"o\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":7,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":6,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":37,\"Stone floor\":24,\"Natural Surface\":20,\"Stone wall\":15,\"Roof\":11,\"Wooden floor\":3,\"Stairs\":2,\"Chimney\":1},\"stats\":{\"walkable\":113,\"maxHeight\":11,\"minHeight\":0.5,\"spread\":10.5,\"avgHeight\":3.62,\"waterPct\":0}},\"26\":{\"num\":26,\"w\":4,\"h\":18,\"heights\":[[7,7,0,2],[7,7,0,0],[9,7,0,0],[9.5,7,1,1],[10,7,2,3.5],[9.5,7,4,4],[9,7,4.5,3.5],[7,7,5,3],[7,7,6,3],[7.5,7.5,5,3],[8,10,4,4],[8,8,6,5],[8,8,4,5.5],[6,6,4,6.5],[6,8,5,7],[null,null,9,7.5],[11,10,9,8.5],[null,null,9,9]],\"surfaces\":[[\"s\",\"s\",\"s\",\"b\"],[\"s\",\"s\",\"s\",\"s\"],[\"M\",\"s\",\"s\",\"s\"],[\"M\",\"s\",\"s\",\"s\"],[\"M\",\"s\",\"s\",\"M\"],[\"M\",\"s\",\"s\",\"M\"],[\"M\",\"s\",\"s\",\"M\"],[\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\"],[\"s\",\"b\",\"s\",\"s\"],[\"s\",\"s\",\"b\",\"o\"],[\"s\",\"s\",\"s\",\"o\"],[\"s\",\"s\",\"s\",\"o\"],[\"s\",\"b\",\"s\",\"o\"],[\".\",\".\",\"s\",\"o\"],[\"s\",\"s\",\"s\",\"o\"],[\".\",\".\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":16,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":16,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":17,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":16,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":50,\"Machine\":8,\"Wooden floor\":6,\"Box\":4},\"stats\":{\"walkable\":68,\"maxHeight\":11,\"minHeight\":0,\"spread\":11,\"avgHeight\":5.93,\"waterPct\":0}},\"27\":{\"num\":27,\"w\":10,\"h\":10,\"heights\":[[0.5,1.5,2,1,1,1,1,1,2,1.5],[0.5,1.5,2,1,0,2.5,2.5,1,1,1],[2,6,7.5,7.5,7.5,5.5,5.5,2,0.5,0.5],[2,6,9,9,7.5,7,7,0,0,0],[1,1,16,16,13,13,7,6,0,0],[2,6,16,16,14,14,7,6,0,0],[2,6,12,12,16,13,7,1,0,0],[3,4,5,4,5,5.5,6,1,0,0],[2,2,4,4,3,3,2,1.5,0.5,0],[1,3,4,3,2,2,2,1.5,0.5,0]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"s\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"r\",\"r\",\"r\",\"r\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"r\",\"r\",\"r\",\"r\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"n\",\"r\",\"n\",\"n\"],[\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"r\",\"n\",\"n\"],[\"n\",\"r\",\"r\",\"r\",\"c\",\"r\",\"o\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":5,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Snow\":73,\"Roof\":23,\"Wooden floor\":2,\"Stone floor\":1,\"Chimney\":1},\"stats\":{\"walkable\":100,\"maxHeight\":16,\"minHeight\":0,\"spread\":16,\"avgHeight\":4.15,\"waterPct\":0}},\"28\":{\"num\":28,\"w\":13,\"h\":11,\"heights\":[[4.5,3,5,5,3,3,2,3,2,1,2,2,2],[5.5,6,6,6,6,4.5,3,4,2,1,1,1.5,2],[7,7,6,6,8,3,2,0,0,0,0.5,1,2],[9,9,6,6,6,4,2,0,0,0,0,2,2],[10,9,7,7,6,4,2,null,3.5,3.5,2.5,3,3],[12,12,8,7,6,4,3,null,5,5,5,4.5,3],[12,12,7,7,6,4.5,3,null,5,5,5,5,4],[12,12,7,6,6,7,7,10,12,5,5,5,4],[10,10,8.5,5.5,5.5,10,9,10,12,null,7,7,7],[10,10,9,11,11,12.5,12.5,11,13,11.5,9,9,8],[10,10,9,10,10,12.5,12.5,11,12,11,10,9,8]],\"surfaces\":[[\"n\",\"n\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\".\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\".\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\".\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\".\",\"n\",\"n\",\"s\"],[\"n\",\"n\",\"n\",\"s\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":12,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Snow\":134,\"Stone floor\":5},\"stats\":{\"walkable\":139,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":6.17,\"waterPct\":0}},\"29\":{\"num\":29,\"w\":12,\"h\":13,\"heights\":[[0,0,0,0,0,0,0,3,2,0,0,0],[0,0,2,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0],[2,1.5,1.5,1.5,1.5,0,1.5,1.5,1.5,1.5,0,1.5],[4,4,4,4,3,1.5,4,4,6.5,8,0,7.5],[6.5,8,8,8,3,3,4,5,6.5,8,0,8],[8,9,9,9,8,6,6,6,8,8,8,8],[9,13,13,13,8,8,8,8,8,8,8,8],[11,14,14,14,8,9.5,7.5,9,9,9,8,8],[12,14,17,17,13.5,11,6,9,10.5,10,9,9],[13,15,18,null,15.5,15,6,13.5,11.5,10,10,9],[16,18,18,18,17,16.5,17,17.5,18.5,10,18.5,18.5],[17,18.5,18.5,18.5,17.5,17,17,17.5,18.5,19,19,18.5]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\".\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":11,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Snow\":155},\"stats\":{\"walkable\":155,\"maxHeight\":19,\"minHeight\":0,\"spread\":19,\"avgHeight\":7.49,\"waterPct\":0}},\"30\":{\"num\":30,\"w\":11,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0,13,13.5,13.5],[0,0,2,0,0,0,0,0,0,13.5,14],[0,0,4,0,0,0,0,1.5,10,13.5,14],[0,0,6,0,0,0,0,3,9,13.5,14],[0,0,7,7,0,0,0,4.5,7.5,14.5,14.5],[0,0,0,0,0,0,0,6,7,14.5,15],[0,0,0,0,0,0,0,7,7,7,15],[1.5,1.5,7,7,0,0,0,7,7,14.5,15],[9,8,7,7,7,8.5,8.5,8.5,8.5,14.5,15],[10,14.5,14.5,7,14.5,14.5,12,12,12,14.5,15],[12,14.5,15,15,15,15,14.5,14.5,14.5,14.5,15]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"o\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"o\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"o\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":10,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Snow\":114,\"Natural Surface\":4,\"Wooden floor\":3},\"stats\":{\"walkable\":121,\"maxHeight\":15,\"minHeight\":0,\"spread\":15,\"avgHeight\":6.23,\"waterPct\":0}},\"31\":{\"num\":31,\"w\":9,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0,0],[9,7,7,0.5,0.5,0.5,0.5,0.5,0.5],[9,9,9,2,1.5,1.5,1.5,5,5],[7,7,7,2.5,2.5,2.5,2.5,5,null],[14,17,12.5,3.5,3.5,3.5,3.5,5,5],[14,14.5,12.5,5,4.5,4.5,5,5,5],[14,16,9,5.5,5.5,5.5,5.5,12,5],[14,14.5,9,6.5,6.5,6.5,6.5,12,5],[19,16,8,8,7.5,7.5,7.5,12,6],[16,16,12,8,8,8,8,13.5,13.5],[18,18,12,8,8,8,8,13.5,16]],\"surfaces\":[[\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"c\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"g\",\"s\",\"s\",\"s\",\"g\",\".\"],[\"r\",\"c\",\"r\",\"g\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"s\",\"s\",\"r\",\"s\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"s\",\"s\",\"r\",\"s\"],[\"c\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"s\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"r\",\"c\"]],\"starts\":[{\"x\":4,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":36,\"Roof\":32,\"Grassland\":26,\"Chimney\":4},\"stats\":{\"walkable\":98,\"maxHeight\":19,\"minHeight\":0,\"spread\":19,\"avgHeight\":7.2,\"waterPct\":0}},\"32\":{\"num\":32,\"w\":10,\"h\":16,\"heights\":[[0,0,0,0,0,0,0,0,0,0],[1.5,1.5,1.5,0,0,0,1.5,1.5,1.5,0],[1.5,2,2,2,0,1.5,1.5,2,2,2],[3,2,2,3.5,3.5,8,8,10,4,4],[3,2.5,2.5,10,9,9,8,8,7,6],[3,3,3,8,9,9,8,8,9,9],[3,3,3,8,9,9,9,10,8,8],[3,3,3,7,7,6,5,5,3,3],[3,3,3,3,3,3,3,3,3,3],[6,7,3,3,3,3,3,3,3,3],[6,5,3,3,3,3,5,8,8,10],[1,1,3,3,8,9,7,9,9,10],[0,1,2.5,2.5,11,9,9,14,15,16],[0,2,2,2,8,9,9,14,15,16],[1.5,2,2,2.5,8,9,9,13,14,17],[1.5,2,2.5,2.5,5,9,9,11,14,16]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"n\",\"n\",\"n\",\"r\",\"r\",\"r\",\"n\",\"n\",\"n\",\"r\"],[\"n\",\"n\",\"n\",\"n\",\"r\",\"n\",\"n\",\"g\",\"g\",\"s\"],[\"s\",\"n\",\"n\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"s\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"b\"],[\"s\",\"n\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"g\",\"g\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"n\",\"g\",\"n\",\"r\",\"r\",\"r\",\"b\",\"b\",\"n\",\"n\"],[\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"n\",\"n\",\"b\",\"r\",\"r\",\"r\"],[\"n\",\"n\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"p\",\"n\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"p\",\"g\",\"g\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"n\",\"g\",\"g\",\"n\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"n\",\"n\",\"n\",\"n\",\"b\",\"r\",\"r\",\"r\",\"r\",\"r\"]],\"starts\":[{\"x\":1,\"y\":13,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":13,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":14,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":14,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Roof\":62,\"Natural Surface\":57,\"Grassland\":14,\"Sea\":10,\"River\":5,\"Stone floor\":5,\"Box\":5,\"Marsh\":2},\"stats\":{\"walkable\":160,\"maxHeight\":17,\"minHeight\":0,\"spread\":17,\"avgHeight\":5.07,\"waterPct\":1.3}},\"33\":{\"num\":33,\"w\":9,\"h\":13,\"heights\":[[1,1,1,1,null,1,1,1,2],[1,1,2,1,1,1,1,1,0],[1,2,2,1,null,null,1,1,1],[1,1,null,2,null,null,1,1,1],[null,null,null,null,null,2,4,1,1],[1,3,3,null,null,8,2,1,1],[1,1,1,null,null,null,null,1,null],[2,1,1,1,null,null,1,1,1],[2,1,1,null,null,4,2.5,1,1],[2,1,1,1,null,4,null,2,1],[1,1,1,null,null,4,1,1,1],[1,1,1,1,1,1,1,1,1],[2,1,1,1,null,1,1,1,3]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"b\"],[\"s\",\"s\",\"f\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"f\",\"f\",\"s\",\".\",\".\",\"r\",\"r\",\"s\"],[\"s\",\"s\",\".\",\"f\",\".\",\".\",\"r\",\"r\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"f\",\"S\",\"r\",\"s\"],[\"s\",\"f\",\"f\",\".\",\".\",\"f\",\"f\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\"s\",\".\"],[\"o\",\"s\",\"r\",\"r\",\".\",\".\",\"s\",\"s\",\"s\"],[\"o\",\"s\",\"s\",\".\",\".\",\"f\",\"S\",\"r\",\"s\"],[\"o\",\"s\",\"r\",\"r\",\".\",\"f\",\".\",\"f\",\"s\"],[\"s\",\"s\",\"s\",\".\",\".\",\"f\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"b\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"k\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":11,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":11,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":59,\"Furniture\":13,\"Rug\":10,\"Wooden floor\":3,\"Box\":2,\"Stairs\":2,\"Book\":1},\"stats\":{\"walkable\":90,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":1.42,\"waterPct\":0}},\"34\":{\"num\":34,\"w\":11,\"h\":10,\"heights\":[[3,2.5,0,0,null,0,0,0,0,0,0],[2,0.5,0,0,0,0,0,0,0,0,0],[2,0.5,0,0,null,0,2,0,0,0,0],[1.5,0,0,0,5.5,null,null,0,0,0,0],[0.5,0,0,0,0,0,7,0,0,0,0],[0,0,0,0,null,0,6.5,null,0,null,6.5],[null,1,0.5,0,0,0,0,0,0,0,0],[3,2.5,1.5,0.5,0.5,0.5,0.5,0,0,0,0],[4.5,2.5,2.5,2.5,1.5,1.5,0.5,0,0.5,1.5,2],[5,null,4,3,2.5,2,2,3,4,4,3]],\"surfaces\":[[\"n\",\"g\",\"g\",\"g\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"s\",\"s\",\"s\",\"s\",\"s\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\".\",\"s\",\"b\",\"s\",\"s\",\"s\",\"s\"],[\"n\",\"n\",\"n\",\"n\",\"s\",\".\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"n\",\"g\",\"g\",\"n\",\"n\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"s\",\".\",\"s\",\".\",\"s\"],[\".\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"s\"],[\"g\",\"g\",\"n\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"n\",\"n\",\"n\"],[\"n\",\".\",\"g\",\"n\",\"n\",\"n\",\"g\",\"n\",\"n\",\"n\",\"g\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Natural Surface\":42,\"Grassland\":29,\"Stone floor\":25,\"Stone wall\":4,\"Box\":1},\"stats\":{\"walkable\":101,\"maxHeight\":7,\"minHeight\":0,\"spread\":7,\"avgHeight\":1.01,\"waterPct\":0}},\"35\":{\"num\":35,\"w\":10,\"h\":13,\"heights\":[[0,0,0,0,0.5,0.5,0.5,1.5,1.5,2.5],[0.5,0.5,0,0.5,0.5,1.5,1.5,1.5,2.5,2.5],[5,5,5,5,4.5,3.5,2.5,2.5,2.5,3],[12,5,12,5,4.5,3.5,3.5,2.5,2.5,7],[12,5,12,9,8,9,8,9,8,8],[8,5,4.5,4.5,4,4,4,4,4,7],[9,4.5,4.5,4,3.5,3.5,3.5,3.5,3.5,5],[7,4,3.5,3.5,3.5,3,3,3,8.5,10],[5,3.5,3.5,2.5,2.5,2.5,2.5,2.5,9.5,9.5],[3,2.5,2.5,2.5,2,2,2,2,10,10],[2.5,2.5,8,9,8,2.5,2.5,2.5,9,9],[2,4,8,9,8,3.5,3.5,8,8,8],[4,6,8,9,10,3.5,4.5,7,7,7]],\"surfaces\":[[\"g\",\"g\",\"n\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"g\",\"g\",\"n\",\"n\"],[\"s\",\"n\",\"s\",\"n\",\"n\",\"g\",\"g\",\"g\",\"n\",\"s\"],[\"s\",\"n\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"r\",\"c\"],[\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"g\",\"s\",\"s\",\"r\",\"r\"],[\"s\",\"b\",\"r\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"r\"],[\"b\",\"b\",\"r\",\"r\",\"c\",\"g\",\"g\",\"r\",\"r\",\"r\"]],\"starts\":[{\"x\":5,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":48,\"Grassland\":35,\"Roof\":21,\"Natural Surface\":18,\"Box\":6,\"Chimney\":2},\"stats\":{\"walkable\":130,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":4.7,\"waterPct\":0}},\"36\":{\"num\":36,\"w\":10,\"h\":10,\"heights\":[[8.5,10,8.5,2,1,1,1,1,1.5,1.5],[8.5,10,8.5,2,2,1,1,1,1.5,2],[8.5,10,8.5,2,2,1,1.5,1.5,1.5,2],[14.5,16,14.5,2,2,8.5,8.5,2,2,2],[14.5,16,14.5,2,2,9,9,7,2.5,2],[14.5,16,17,19,19,19,10,3,2.5,2.5],[14.5,16,17,null,null,null,11,3.5,3,3],[13.5,14,13,11,11,11,11,4,3.5,3.5],[8,8,9,10,4,4,4,4,4,3.5],[7,6,5,4,4,4,4,null,4,3.5]],\"surfaces\":[[\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"g\",\"g\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"r\",\"r\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"c\",\"o\",\"o\",\"o\",\"s\",\"s\",\"g\",\"g\"],[\"r\",\"r\",\"c\",\".\",\".\",\".\",\"s\",\"g\",\"s\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"s\",\"s\",\"o\",\"o\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"s\",\"s\",\"s\",\"g\",\"s\",\"g\",\"s\",\".\",\"g\",\"g\"]],\"starts\":[{\"x\":3,\"y\":2,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":37,\"Roof\":26,\"Grassland\":26,\"Wooden floor\":5,\"Chimney\":2},\"stats\":{\"walkable\":96,\"maxHeight\":19,\"minHeight\":1,\"spread\":18,\"avgHeight\":6.76,\"waterPct\":0}},\"37\":{\"num\":37,\"w\":9,\"h\":12,\"heights\":[[1,0.5,0,0,0,0,0.5,0.5,0.5],[1.5,0.5,0,0,0,0,0.5,null,0.5],[2,0,0,1,null,1,0.5,0.5,0.5],[1,0,0,0,0,0,0,0,0],[0,0,1,0,0,0,1,0.5,0],[null,9,3,null,0,null,3,null,null],[1,0.5,0.5,0,0,0,0,0.5,1],[2,1.5,1,0.5,0,0.5,1.5,1,0.5],[3.5,3,1.5,1,0.5,2.5,2,1.5,0.5],[null,3.5,1.5,1,2,3,1,0.5,1],[3.5,3.5,1.5,1,2,null,1,0.5,1],[3,1.5,1,1,1,2,0,0.5,0.5]],\"surfaces\":[[\"g\",\"g\",\"s\",\"b\",\"b\",\"s\",\"g\",\"g\",\"g\"],[\"b\",\"g\",\"s\",\"s\",\"s\",\"s\",\"g\",\".\",\"g\"],[\"b\",\"s\",\"b\",\"b\",\".\",\"b\",\"n\",\"g\",\"g\"],[\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\"],[\"b\",\"s\",\"b\",\"s\",\"s\",\"s\",\"b\",\"b\",\"b\"],[\".\",\"b\",\"b\",\".\",\"s\",\".\",\"b\",\".\",\".\"],[\"g\",\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"g\",\"g\"],[\"g\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"n\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\".\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"n\",\"g\",\"g\",\"n\",\"g\",\".\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"n\",\"g\",\"n\",\"g\",\"g\",\"n\"]],\"starts\":[{\"x\":6,\"y\":10,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":46,\"Stone floor\":19,\"Brick\":17,\"Natural Surface\":17},\"stats\":{\"walkable\":99,\"maxHeight\":9,\"minHeight\":0,\"spread\":9,\"avgHeight\":0.97,\"waterPct\":0}},\"38\":{\"num\":38,\"w\":8,\"h\":11,\"heights\":[[9,9,9,6,4.5,3.5,1,1],[9,11,9,7,4,2.5,2,1],[0,0,0,0,0,0,1,0.5],[0,0,0,7,0,0,0.5,0.5],[11,14,11,8,11,14,11,1.5],[11,13,11,8,11,13,11,3],[7,8,8,8,8,8,9,5.5],[7,8,13,8,13,7.5,7.5,6.5],[8,8,15,22,15,7,7,6.5],[8.5,12,14.5,14,14.5,12,8,6.5],[10,12,13,14,13,12,10,6]],\"surfaces\":[[\"r\",\"r\",\"r\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"c\",\"r\",\"B\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"B\",\"s\",\"s\",\"g\",\"n\"],[\"r\",\"M\",\"r\",\"s\",\"r\",\"M\",\"r\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"r\",\"r\",\"r\",\"g\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"g\"],[\"g\",\"s\",\"r\",\"s\",\"r\",\"r\",\"r\",\"g\"],[\"g\",\"s\",\"r\",\"M\",\"r\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"r\",\"s\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"r\",\"r\",\"s\",\"r\",\"r\",\"g\",\"g\"]],\"starts\":[{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Roof\":30,\"Grassland\":27,\"Stone floor\":24,\"Machine\":3,\"Bridge\":2,\"Chimney\":1,\"Natural Surface\":1},\"stats\":{\"walkable\":88,\"maxHeight\":22,\"minHeight\":0,\"spread\":22,\"avgHeight\":7.51,\"waterPct\":0}},\"39\":{\"num\":39,\"w\":6,\"h\":18,\"heights\":[[4,3,2,1,0,0],[4,4,0,0,0,0],[4.5,4,0,0,null,null],[5,4,0,0,null,null],[4.5,4,0,0,null,null],[4,4,4,0,0,0],[null,4,4,4,null,null],[null,null,4,4,3,null],[null,null,4,4,null,null],[null,null,4,4,null,null],[null,null,4,4,null,null],[null,4,4,4,4,3],[null,4,4,4,4,2],[4,4,4,0,0,1],[4,4,4,0,0,0],[4,4,0,0,0,0],[null,4,4,0,0,2],[null,4,4,2,2,2]],\"surfaces\":[[\"o\",\"o\",\"o\",\"o\",\"n\",\"n\"],[\"o\",\"o\",\"n\",\"n\",\"n\",\"n\"],[\"o\",\"o\",\"n\",\"n\",\".\",\".\"],[\"o\",\"s\",\"n\",\"n\",\".\",\".\"],[\"o\",\"o\",\"n\",\"n\",\".\",\".\"],[\"o\",\"o\",\"o\",\"n\",\"n\",\"n\"],[\".\",\"o\",\"o\",\"o\",\".\",\".\"],[\".\",\".\",\"o\",\"o\",\"r\",\".\"],[\".\",\".\",\"o\",\"o\",\".\",\".\"],[\".\",\".\",\"o\",\"o\",\".\",\".\"],[\".\",\".\",\"o\",\"o\",\".\",\".\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"o\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"o\"],[\"o\",\"o\",\"o\",\"n\",\"n\",\"o\"],[\"o\",\"o\",\"o\",\"n\",\"n\",\"n\"],[\"o\",\"o\",\"n\",\"n\",\"n\",\"n\"],[\".\",\"o\",\"o\",\"n\",\"n\",\"o\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"o\"]],\"starts\":[{\"x\":2,\"y\":17,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":17,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":17,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":17,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Wooden floor\":52,\"Natural Surface\":26,\"Stone floor\":1,\"Rocky cliff\":1},\"stats\":{\"walkable\":80,\"maxHeight\":5,\"minHeight\":0,\"spread\":5,\"avgHeight\":2.46,\"waterPct\":0}},\"40\":{\"num\":40,\"w\":11,\"h\":9,\"heights\":[[3.5,2.5,2.5,2,3,4,4,3.5,2,1.5,0.5],[6,5,4,3,3.5,4.5,4.5,4.5,1,1,0],[6.5,7.5,8,7.5,5,6.5,6.5,6.5,3,2.5,0],[7,8,8,9,6,7.5,7.5,7.5,5,3,0],[10.5,11,10.5,10,6,7.5,7.5,7.5,3,2.5,0.5],[11,11,12,9,5.5,6.5,7.5,6.5,2,1.5,1],[4.5,6,7.5,9,5,2,8,3.5,1,1,3],[3,3.5,4,3.5,3,0.5,0,0.5,1,1,1],[2,1.5,0,1.5,1.5,0.5,0,0.5,1,1,1]],\"surfaces\":[[\"g\",\"g\",\"g\",\"o\",\"g\",\"s\",\"g\",\"s\",\"g\",\"o\",\"o\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"r\",\"r\",\"g\",\"s\",\"s\",\"s\",\"r\",\"r\",\"g\"],[\"s\",\"r\",\"r\",\"s\",\"g\",\"s\",\"s\",\"s\",\"c\",\"r\",\"g\"],[\"r\",\"r\",\"r\",\"s\",\"g\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\"],[\"r\",\"r\",\"c\",\"s\",\"g\",\"r\",\"s\",\"r\",\"g\",\"g\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"o\",\"M\",\"o\",\"g\",\"g\",\"b\"],[\"s\",\"r\",\"r\",\"r\",\"s\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\"],[\"s\",\"s\",\"o\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\",\"s\"]],\"starts\":[{\"x\":7,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":33,\"Stone floor\":33,\"Roof\":23,\"Wooden floor\":6,\"Chimney\":2,\"Machine\":1,\"Box\":1},\"stats\":{\"walkable\":99,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":4.3,\"waterPct\":0}},\"41\":{\"num\":41,\"w\":8,\"h\":8,\"heights\":[[2,2,1,0,0,0,0,0],[4,2,1,0,0,0,0,0],[3,3,2,0,0,0,0,0],[5,4,0,0,0,0,0,0],[4,4,0,0,0,0,0,1],[4,4,0,0,0,0,0,3],[null,null,2,1,0,0,0,null],[null,null,null,null,null,null,null,null]],\"surfaces\":[[\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\"],[\"k\",\"o\",\"o\",\"o\",\"r\",\"r\",\"r\",\"o\"],[\"o\",\"o\",\"k\",\"o\",\"r\",\"r\",\"r\",\"o\"],[\"k\",\"o\",\"o\",\"o\",\"r\",\"r\",\"r\",\"o\"],[\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"k\"],[\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"k\"],[\".\",\".\",\"k\",\"k\",\"o\",\"o\",\"o\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":2,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":4,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Wooden floor\":37,\"Rug\":9,\"Book\":7},\"stats\":{\"walkable\":53,\"maxHeight\":5,\"minHeight\":0,\"spread\":5,\"avgHeight\":0.98,\"waterPct\":0}},\"42\":{\"num\":42,\"w\":10,\"h\":15,\"heights\":[[0,0,3,3,0,0,0,0,0,0],[0,0,3,3,0,0,0,0,0,0],[1,1,3,3,0,0,0,0,0,0],[6,5.5,3,3,2,2,0,0,0,0],[12.5,11,9,3,2,2,2,2.5,3,0],[13,13,9,8,7.5,7,6,5.5,4,0],[13,13,8,8,7.5,7,7,6,4,1.5],[14.5,14.5,8,8,9,11,11,6,4,2],[15,15,9,9,9,11,11,6,6.5,2],[16,14.5,10.5,9,9,12,12,7,7,2],[16,15,9,9,9,13,13,7,7,3],[15,15,9,9,9,13,12,8,3,3],[14,14,9,9,11,11,9,9,3,3],[14,14,10.5,9,11,11,8,8,5.5,3],[13,13,10.5,9,11,11,7,7,7,5]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"n\",\"n\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"n\",\"n\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"s\",\"b\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\"s\"],[\"r\",\"r\",\"b\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"s\"],[\"r\",\"r\",\"n\",\"n\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"s\",\"r\",\"r\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"n\",\"r\",\"r\",\"s\",\"r\",\"n\"],[\"c\",\"r\",\"b\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"n\"],[\"c\",\"r\",\"n\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"n\",\"c\",\"r\",\"r\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"n\",\"n\"],[\"r\",\"r\",\"b\",\"n\",\"r\",\"r\",\"r\",\"r\",\"b\",\"g\"],[\"b\",\"b\",\"b\",\"n\",\"r\",\"r\",\"r\",\"r\",\"b\",\"b\"]],\"starts\":[{\"x\":8,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Roof\":46,\"Natural Surface\":43,\"Sea\":28,\"Stone floor\":12,\"Box\":10,\"Grassland\":8,\"Chimney\":3},\"stats\":{\"walkable\":150,\"maxHeight\":16,\"minHeight\":0,\"spread\":16,\"avgHeight\":6.62,\"waterPct\":0}},\"43\":{\"num\":43,\"w\":9,\"h\":15,\"heights\":[[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,12.5,0,0,0,0],[0,0,0,null,11.5,null,0,6,6],[0,0,0,null,10.5,null,0,7,6],[6,6,null,10,10,10,null,6,6],[6,6,null,7,7,7,null,6,6],[6,6,6,6,6,6,6,6,6],[8,6,null,5,null,5,null,6,6],[11,11,null,5,5,5,null,6,6],[12.5,12.5,null,5,5,5,null,6,6],[12.5,12.5,null,5,5.5,5,null,6,6],[12.5,12.5,null,9,9,9,null,6,6],[10,11,null,null,9,null,null,6,6],[8,8,0,null,null,null,0,6,6]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"o\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"o\",\".\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"o\",\".\",\"s\",\"b\",\"s\"],[\"s\",\"s\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"s\",\"s\",\"B\",\"d\",\"d\",\"d\",\"B\",\"s\",\"s\"],[\"b\",\"o\",\".\",\"d\",\".\",\"d\",\".\",\"s\",\"s\"],[\"r\",\"r\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"r\",\"r\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"r\",\"r\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"r\",\"r\",\".\",\"d\",\"d\",\"d\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\".\",\"d\",\".\",\".\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":8,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Sea\":36,\"Stone floor\":33,\"Deck\":24,\"Roof\":8,\"Wooden floor\":4,\"Box\":2,\"Bridge\":2},\"stats\":{\"walkable\":109,\"maxHeight\":12.5,\"minHeight\":0,\"spread\":12.5,\"avgHeight\":4.92,\"waterPct\":0}},\"44\":{\"num\":44,\"w\":10,\"h\":14,\"heights\":[[1.5,0,0,0.5,1,0.5,0,0,0,0],[1.5,1.5,1.5,0.5,0.5,6,7,6,0,0],[9,8,1.5,0,0,6,7,7,1.5,1.5],[9,9,1,1.5,2,2,2,2,2,1.5],[8,8,1,1.5,2,2,2,2,2,2],[7,7,7,6,5,3,3,3.5,4,4],[7,11,11,11,11,12,13,12,6,4],[7,11,11,11,11,13,13,12,8,9],[9,11,11,12,13,13,13,13,9,9],[17,17,17,13,13,13,13,13,8,8],[17,17,17,16,15,14,13,13,9,5],[17,17,17,17,17,17,17,13,11,12],[17,17,17,17,17,17,17,13,13,12],[17,17,17,17,17,17,17,13,13,12]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"c\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"c\",\"n\",\"n\"],[\"r\",\"r\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"b\",\"g\"],[\"g\",\"s\",\"s\",\"s\",\"s\",\"c\",\"r\",\"r\",\"r\",\"c\"],[\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"n\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"s\"],[\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"r\",\"r\"],[\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"c\",\"r\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":2,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":59,\"Stone floor\":34,\"Roof\":23,\"Natural Surface\":16,\"Chimney\":5,\"Box\":3},\"stats\":{\"walkable\":140,\"maxHeight\":17,\"minHeight\":0,\"spread\":17,\"avgHeight\":8.82,\"waterPct\":0}},\"45\":{\"num\":45,\"w\":9,\"h\":16,\"heights\":[[1,2,2,0,0,0,1,1,1],[1,1,3,0.5,1,1,1.5,1,0],[1,1,3,1.5,2,2,2.5,1,3],[2.5,2.5,3,2.5,3,3,3,3,3],[2.5,6,7.5,15,3,3,15,null,null],[2.5,7,3,3,3,3,3,null,null],[4,8,3,3,3,3,3,3,7],[5.5,8,3,3,3,3,3,3,6.5],[5,5,3,3,3,3,3,3,6],[5,3,3,3,3,3,3,3,null],[3,3,3,3,4,4,7,6.5,6],[3,3,3,3,5,5,8,4,3.5],[3,3,3,3,5,5,9,3.5,3.5],[3,3,3.5,5,9,9,9,3,3],[2,2,2.5,2,2,2.5,3,3.5,3.5],[3,2,3,2.5,2,2,3,3.5,4]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"b\",\"b\",\"b\",\"g\",\"g\",\"b\",\".\",\".\"],[\"g\",\"b\",\"g\",\"g\",\"g\",\"g\",\"s\",\".\",\".\"],[\"g\",\"b\",\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"b\"],[\"b\",\"b\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"b\"],[\"b\",\"b\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"b\"],[\"b\",\"s\",\"g\",\"g\",\"s\",\"s\",\"s\",\"g\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"b\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"g\",\"g\"],[\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"b\",\"g\",\"g\"],[\"g\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":4,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":13,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":13,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":13,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":13,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":80,\"Stone floor\":35,\"Brick\":24},\"stats\":{\"walkable\":139,\"maxHeight\":15,\"minHeight\":0,\"spread\":15,\"avgHeight\":3.47,\"waterPct\":0}},\"46\":{\"num\":46,\"w\":9,\"h\":15,\"heights\":[[2,2.5,2.5,2.5,4,3.5,2.5,2.5,2.5],[3.5,3.5,3,3.5,4,3.5,2.5,2,2],[4,4,4,2,3.5,2.5,2,2.5,2.5],[2.5,2.5,2,2,3.5,2,2,3.5,3.5],[2,2,2,2.5,5,2.5,2,2,3],[2,null,2,3.5,5.5,3.5,2,2,2],[2,2,2,2,6,2,2,null,2],[2,2,3.5,4.5,5.5,4.5,3.5,2,2],[2,2,5,5.5,5.5,5.5,5,2,2],[2,2.5,5,7,6,7,5,2.5,2],[4,4,4.5,7.5,6.5,6,4.5,4,4],[3,3,4.5,8.5,9,8.5,4.5,3,3],[1,1,5.5,8.5,10,8.5,5.5,1,1],[1,1,6,9.5,15,9.5,6,1,1],[1,1,7.5,null,9,null,7.5,1,1]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\"],[\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"n\",\"g\",\"g\",\"g\",\"S\",\"g\",\"g\",\"g\",\"g\"],[\"n\",\"g\",\"g\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"t\",\"g\",\"g\",\"g\",\"g\"],[\"l\",\"l\",\"g\",\"g\",\"t\",\"g\",\"g\",\"l\",\"l\"],[\"l\",\"l\",\"g\",\"g\",\"t\",\"g\",\"g\",\"l\",\"l\"],[\"l\",\"l\",\"g\",\".\",\"g\",\".\",\"g\",\"l\",\"l\"]],\"starts\":[{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":106,\"Lake\":12,\"Natural Surface\":6,\"Stone floor\":3,\"Tombstone\":3,\"Stairs\":1},\"stats\":{\"walkable\":131,\"maxHeight\":15,\"minHeight\":1,\"spread\":14,\"avgHeight\":3.69,\"waterPct\":0}},\"47\":{\"num\":47,\"w\":10,\"h\":16,\"heights\":[[6,5,3,1,1,1,0.5,0.5,0.5,0],[8,8,8,1.5,1.5,1.5,1,1,0.5,0],[9,9,9,2,2,1.5,1.5,8,9,8],[9,8,8,2,2,2,2,9,9,9],[10,10,7,5,2.5,2.5,5,8,8,8],[10,10,10,5,3.5,3.5,5,6,6,6],[10,10,10,5,4.5,4.5,5,6,6,6],[11,11,11,5,5,5,5,6,10,8],[11,12,11,5,5,5,5,6,12,13],[3,3,4,5,5,5,5,6,13,13],[3,3,4,5,5,5,5,6,12,12],[11,11,11,4.5,4.5,4.5,4.5,12,12,12],[11,11,11,4,4,4,4,13,13,13],[11,11,11,3.5,3.5,3.5,4,12,13,12],[7,8,9,3,3,3,4,5,13,11],[7,6,4,3,3,3,3,7,9,9]],\"surfaces\":[[\"b\",\"b\",\"b\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"c\",\"r\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"s\",\"s\",\"S\",\"S\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"s\",\"S\",\"S\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"S\",\"S\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"b\"],[\"r\",\"c\",\"r\",\"w\",\"w\",\"w\",\"w\",\"s\",\"r\",\"c\"],[\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"s\",\"r\",\"r\"],[\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"s\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\"w\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\"s\",\"r\",\"r\",\"r\"],[\"s\",\"S\",\"s\",\"w\",\"w\",\"w\",\"s\",\"b\",\"b\",\"b\"],[\"s\",\"S\",\"S\",\"w\",\"w\",\"w\",\"w\",\"b\",\"m\",\"m\"]],\"starts\":[{\"x\":0,\"y\":15,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":15,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":15,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":15,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Roof\":53,\"Stone floor\":49,\"Wasteland\":35,\"Box\":9,\"Stairs\":9,\"Chimney\":3,\"Mud wall\":2},\"stats\":{\"walkable\":160,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":6.44,\"waterPct\":0}},\"48\":{\"num\":48,\"w\":11,\"h\":14,\"heights\":[[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,5.5,5.5],[0,2,2,2,2,2,2,3,3,6,6],[8,7.5,2,2,2,2,5,5,5,5,5],[8,7.5,3,3,3,3,5,5,8.5,9,9],[8,8,4,4,4,4,5,5,8.5,9,9],[7,5,5,5,5,5,5,5,5,5,5],[5,5,12,13,12,5,5,5,11.5,11.5,5],[11.5,11.5,12,13,12,5,5,5,11.5,11.5,10],[11.5,12,14,13,12,5,5,8.5,11.5,13,11],[11.5,11.5,10,8,5,5,5,8.5,10,9,10],[10,8,8,7.5,5,5,5,5,8,9,7],[5,7,8,7.5,5,5,4.5,4.5,8,9,5],[4,4,4.5,5,5,5,4.5,4,4,4,5]],\"surfaces\":[[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"o\",\"o\",\"r\",\"r\"],[\"r\",\"r\",\"g\",\"s\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"g\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"g\",\"s\",\"g\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\"],[\"b\",\"s\",\"g\",\"s\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"g\",\"s\",\"r\",\"r\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"c\",\"c\",\"r\",\"r\",\"s\",\"s\",\"r\",\"r\",\"c\",\"r\"],[\"r\",\"r\",\"b\",\"r\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\"],[\"b\",\"b\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\"],[\"b\",\"b\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\"],[\"s\",\"s\",\"s\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"s\"]],\"starts\":[{\"x\":4,\"y\":13,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":13,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":13,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":13,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":60,\"Roof\":51,\"River\":21,\"Grassland\":11,\"Box\":6,\"Chimney\":3,\"Wooden floor\":2},\"stats\":{\"walkable\":154,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":5.73,\"waterPct\":0}},\"49\":{\"num\":49,\"w\":9,\"h\":13,\"heights\":[[0,0,0.5,0.5,0,0,0,0,0],[0.5,0.5,7,1.5,1.5,2,2.5,0,0],[1,12,12,2.5,3,3.5,3.5,2.5,0],[0.5,13,12,7,5,4,4,2.5,0],[0,0,0.5,7,3.5,4,4,0.5,0],[0,0,0,0,0.5,1,1,0.5,0],[0.5,0.5,0,0,0.5,0.5,0.5,0.5,0],[0.5,5,0,0,0,4,0,0,0],[0.5,12,12,13,12,5,4,0.5,0],[0,13,13,13,12,8,4,1,0],[0,1,2,13,13,11,0.5,0,0],[0,1,1,0.5,0.5,0.5,0,0,0],[0,0,0,0,0,0,0,0,1]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"o\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"o\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":0,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Snow\":115,\"Wooden floor\":2},\"stats\":{\"walkable\":117,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":2.63,\"waterPct\":0}},\"50\":{\"num\":50,\"w\":8,\"h\":16,\"heights\":[[0,0.5,1,1,1,0.5,0,0],[0.5,0.5,1,1,1,0.5,0.5,0.5],[2,2,1,1,2,2,2,2],[2,2,1,1,2,2,2,2],[16,16,1,1,16,16,2,2],[16,16,12,12,16,16,2,2],[6,9,10,10,9,6,4,2],[7,9,10,10,9,7,4,1],[9,9,null,null,9,9,9,0],[9,9,null,null,9,9,9,0],[7,9,9,9,9,7,0,0],[null,7,6,6,7,null,0,0],[4,5,6,6,0,0,0,0],[2,0,6,6,0,0,0,1],[0.5,0.5,0,0,0,null,0.5,0.5],[1,0.5,0,0,0,0,0.5,null]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"g\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"g\"],[\"r\",\"r\",\".\",\".\",\"r\",\"r\",\"r\",\"g\"],[\"r\",\"r\",\".\",\".\",\"r\",\"r\",\"r\",\"g\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\".\",\"r\",\"s\",\"s\",\"r\",\".\",\"n\",\"g\"],[\"r\",\"r\",\"s\",\"s\",\"g\",\"g\",\"n\",\"g\"],[\"s\",\"g\",\"s\",\"s\",\"g\",\"g\",\"n\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\"]],\"starts\":[{\"x\":2,\"y\":4,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":15,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":15,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":15,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":15,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":61,\"Roof\":30,\"Stone floor\":26,\"Natural Surface\":3},\"stats\":{\"walkable\":120,\"maxHeight\":16,\"minHeight\":0,\"spread\":16,\"avgHeight\":4.32,\"waterPct\":0}},\"51\":{\"num\":51,\"w\":10,\"h\":11,\"heights\":[[null,0,0,0,0,0,0,0,0,null],[0,0,0,0,0,0,0,0,0,0],[0,0,1,0,0,0,0,1,0,0],[0,0,null,0,0,0,0,null,0,0],[0,0,1,0,0,0,0,1,0,0],[0,0,0,0,0,0,0,0,0,0],[0,0,0,null,0.5,0.5,null,0,0,0],[0,0,0,2,1.5,1.5,2,0,0,0],[0,0,0,2,2,2,2,0,0,0],[null,0,0,2,2,null,1,0,0,null],[null,null,null,4,3,3,4,null,null,null]],\"surfaces\":[[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"f\",\"r\",\"r\",\"r\",\"r\",\"f\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"r\",\"r\",\"r\",\"r\",\".\",\"s\",\"s\"],[\"s\",\"s\",\"f\",\"r\",\"r\",\"r\",\"r\",\"f\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"S\",\"S\",\".\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"S\",\"S\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\".\"],[\".\",\".\",\".\",\"s\",\"f\",\"f\",\"s\",\".\",\".\",\".\"]],\"starts\":[{\"x\":9,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":63,\"Rug\":22,\"Furniture\":6,\"Stairs\":4},\"stats\":{\"walkable\":95,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":0.41,\"waterPct\":0}},\"52\":{\"num\":52,\"w\":11,\"h\":12,\"heights\":[[null,null,null,null,0,0,0,null,null,null,null],[1,1,0,null,0.5,0,0.5,null,null,null,null],[1,1,0.5,0.5,1.5,1,1.5,0.5,0.5,0,null],[null,0,0.5,1,3,2,3,1,0.5,0,null],[null,1.5,2.5,null,4,4,4,null,2.5,1.5,null],[0,0,1,2,4,6,4,2,1,0,0],[0,0,1,2,4,6,4,2,1,0,0],[null,1.5,2.5,null,4,4,4,null,2.5,1.5,null],[null,0,0.5,1,3,2,3,1,0.5,0,null],[1,1,0.5,0.5,1.5,1,1.5,0.5,0.5,0,null],[1,1,0,null,0.5,0,0.5,null,null,null,null],[null,null,null,null,0,0,0,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\"],[\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\".\",\"r\",\"r\",\"r\",\".\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"c\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"c\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\".\",\"r\",\"r\",\"r\",\".\",\"s\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":6,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":80,\"Rug\":10,\"Coffin\":2},\"stats\":{\"walkable\":92,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":1.35,\"waterPct\":0}},\"53\":{\"num\":53,\"w\":9,\"h\":9,\"heights\":[[6,7,0,0,0,0,0,0,0],[4,0,0,0,0,0,0,0,0],[2,0,null,null,null,null,null,0,0],[0,0,null,8,8,8,null,0,0],[0,0,null,8,8,8,null,0,0],[0,0,null,8,8,8,null,0,0],[0,0,null,null,null,null,null,0,2],[0,0,0,0,0,0,0,0,4],[0,0,0,0,0,0,0,7,6]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"k\",\"k\",\"k\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"k\",\"M\",\"k\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"k\",\"k\",\"k\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":2,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":true},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":true},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":true},{\"x\":6,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":true},{\"x\":3,\"y\":8,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":true},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":true},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":true},{\"x\":5,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":true}],\"surfaces_hist\":{\"Stone floor\":56,\"Book\":8,\"Machine\":1},\"stats\":{\"walkable\":65,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":1.69,\"waterPct\":0}},\"54\":{\"num\":54,\"w\":10,\"h\":14,\"heights\":[[1,1,1.5,2,2,5,7,7.5,7,7],[0.5,1,2.5,3.5,3.5,5,6.5,7,7,7],[0.5,0.5,2.5,3.5,5.5,5.5,6.5,7,8.5,8.5],[0,0.5,1,1.5,4.5,6,6.5,6.5,9.5,9.5],[0,0,0,null,1.5,4.5,5,6.5,8.5,9],[0,0,null,null,null,null,null,6,8.5,8.5],[null,0,0,null,null,null,null,null,null,null],[null,0,0,null,null,null,6.5,6.5,null,null],[null,null,0,0,2,2.5,7,7,8.5,8.5],[0,0,0,0.5,2,4,6.5,7,10,10],[0,1,4.5,5,4,4.5,6,8.5,10.5,10.5],[1,null,4.5,5.5,6.5,8.5,9.5,9,10,10],[1.5,null,6.5,6.5,7,8.5,9.5,8,9.5,10],[1.5,4,5.5,7,7,7.5,7.5,8,9.5,10]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"o\",\"o\",\"o\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"o\",\"o\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\"],[\".\",\"o\",\"o\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\"o\",\"o\",\".\",\".\",\".\",\"r\",\"r\",\".\",\".\"],[\".\",\".\",\"o\",\"o\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"o\",\"o\",\"o\",\"s\",\"s\",\"r\",\"s\",\"s\",\"r\",\"r\"],[\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"s\",\".\",\"r\",\"r\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\".\",\"r\",\"r\",\"s\",\"r\",\"r\",\"s\",\"r\",\"r\"],[\"s\",\"b\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"]],\"starts\":[{\"x\":6,\"y\":13,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":13,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":13,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":13,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":68,\"Roof\":33,\"Wooden floor\":14,\"Box\":1},\"stats\":{\"walkable\":116,\"maxHeight\":10.5,\"minHeight\":0,\"spread\":10.5,\"avgHeight\":4.99,\"waterPct\":0}},\"55\":{\"num\":55,\"w\":17,\"h\":9,\"heights\":[[null,1.5,2,2,1.5,0.5,0,0,0.5,2.5,4.5,5.5,null,null,null,null,null],[0.5,1.5,2.5,2.5,2,0.5,0,0.5,0.5,2.5,4.5,5.5,6.5,null,null,null,null],[0.5,1.5,2.5,3.5,2.5,0.5,0.5,0.5,1,2.5,4.5,5.5,6.5,7.5,null,null,null],[0.5,1.5,2.5,3.5,null,1,1,1,1,2.5,4.5,5.5,6.5,7.5,8.5,null,null],[null,1.5,2.5,3.5,2.5,1,1,1,1,2.5,null,5.5,6.5,7.5,8.5,10,null],[0.5,1.5,2.5,3.5,2.5,1,1,1,1,2.5,4.5,5.5,6.5,7.5,8.5,null,null],[0.5,1.5,2.5,3.5,2.5,1,1,1,1,2.5,4.5,5.5,6.5,7.5,null,null,null],[0.5,1.5,2.5,3,2,1,0.5,0.5,0.5,2.5,4.5,5.5,6.5,null,null,null,null],[null,1.5,2.5,3,2,1,0.5,0,0.5,2.5,4.5,5.5,null,null,null,null,null]],\"surfaces\":[[\".\",\"i\",\"i\",\"i\",\"M\",\"M\",\"M\",\"M\",\"M\",\"d\",\"d\",\"d\",\".\",\".\",\".\",\".\",\".\"],[\"d\",\"i\",\"i\",\"i\",\"M\",\"M\",\"M\",\"M\",\"M\",\"d\",\"d\",\"d\",\"d\",\".\",\".\",\".\",\".\"],[\"d\",\"i\",\"i\",\"d\",\"d\",\"M\",\"M\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\".\",\".\",\".\"],[\"d\",\"i\",\"i\",\"d\",\".\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\".\",\".\"],[\".\",\"i\",\"i\",\"i\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\".\",\"d\",\"i\",\"i\",\"d\",\"d\",\".\"],[\"i\",\"i\",\"i\",\"i\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"i\",\"d\",\"i\",\"i\",\".\",\".\"],[\"i\",\"i\",\"i\",\"d\",\"d\",\"M\",\"M\",\"d\",\"d\",\"d\",\"d\",\"i\",\"d\",\"i\",\".\",\".\",\".\"],[\"i\",\"i\",\"i\",\"d\",\"d\",\"M\",\"M\",\"M\",\"M\",\"d\",\"i\",\"i\",\"i\",\".\",\".\",\".\",\".\"],[\".\",\"i\",\"i\",\"d\",\"d\",\"M\",\"M\",\"M\",\"M\",\"i\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":14,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":14,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Deck\":59,\"Ivy\":38,\"Machine\":22},\"stats\":{\"walkable\":119,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":2.82,\"waterPct\":0}},\"56\":{\"num\":56,\"w\":10,\"h\":14,\"heights\":[[0,0,0,5.5,6,7,8,9,9,9],[0,0,0,6,6,9,10,10,10,9],[0,6.5,7,7,7,11,11,10,10,8.5],[5,7,7,7,7.5,11,11,10,9.5,8],[7.5,7.5,7,7.5,8,11,11,9,8,7.5],[8.5,8.5,8.5,9,9,11,11,8.5,7,7],[8.5,9,9.5,10,10,11,11,7,7,7],[8,9.5,10,10,10,11,11,9,8,7],[7.5,9.5,9.5,10,11,11,11,11,9,8],[6.5,7.5,8,10,11,null,null,null,8,7.5],[0,5.5,5.5,8,null,null,null,null,null,5.5],[0,0,0,0,9,null,null,null,11,5.5],[0,0,0,0,7,null,13,null,11,0],[0,0,7,7,7,7,8,9,10,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"g\",\"o\",\"o\",\"o\",\"o\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"g\",\"o\",\"o\",\"o\",\"o\",\"o\",\"g\"],[\"s\",\"r\",\"g\",\"g\",\"g\",\"s\",\"s\",\"o\",\"o\",\"g\"],[\"r\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"o\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\".\",\".\",\"g\",\"g\"],[\"s\",\"g\",\"g\",\"g\",\".\",\".\",\".\",\".\",\".\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"g\",\".\",\".\",\".\",\"o\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"o\",\".\",\"g\",\".\",\"o\",\"s\"],[\"s\",\"s\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\"]],\"starts\":[{\"x\":9,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":70,\"Wooden floor\":22,\"Sea\":20,\"Stone floor\":13,\"Rocky cliff\":2},\"stats\":{\"walkable\":127,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":7.26,\"waterPct\":0}},\"57\":{\"num\":57,\"w\":9,\"h\":13,\"heights\":[[1,1,8,null,8,1,1,0,0],[1,1,8,8,8,1,1,null,null],[1,1,1,1,1,1,1,0,0],[1,2,8,null,8,2,1,0,0],[1,4,7,null,7,4,1,null,1.5],[1,5,6,null,6,5,1,1,1],[1,5,5,5,5,5,0,1,1],[1,5,6,null,6,5,1,1,1],[1,4,7,null,7,4,1,1.5,1.5],[1,2,8,null,8,2,1,0,0],[1,1,1,1,1,1,1,0,0],[1,1,8,8,8,1,1,1.5,1.5],[1,1,null,null,null,1,1,0,0]],\"surfaces\":[[\"b\",\"b\",\"o\",\".\",\"o\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"o\",\"o\",\"o\",\"b\",\"b\",\".\",\".\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"S\",\"o\",\".\",\"o\",\"S\",\"b\",\"b\",\"b\"],[\"b\",\"S\",\"b\",\".\",\"b\",\"S\",\"b\",\".\",\"f\"],[\"b\",\"b\",\"S\",\".\",\"S\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"S\",\".\",\"S\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"S\",\"b\",\".\",\"b\",\"S\",\"b\",\"f\",\"f\"],[\"b\",\"S\",\"o\",\".\",\"o\",\"S\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"o\",\"o\",\"o\",\"b\",\"b\",\"f\",\"f\"],[\"b\",\"b\",\".\",\".\",\".\",\"b\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":2,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":75,\"Wooden floor\":12,\"Stairs\":12,\"Furniture\":5},\"stats\":{\"walkable\":104,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":2.63,\"waterPct\":0}},\"58\":{\"num\":58,\"w\":10,\"h\":12,\"heights\":[[0,0,0,0,0,0,0,0,0,0],[2,1,6,6,6,6,6,6,1,2],[3,5,6,6,8,8,6,6,5,3],[6,6,6,6,6,6,6,6,6,6],[12,12,12,6,7,9,11,12,12,12],[12,12,12,12,12,12,12,12,12,12],[12,12,12,12,12,12,12,12,12,12],[12,12,null,null,12,12,null,null,12,12],[12,12,12,12,12,12,12,12,12,12],[12,12,12,12,12,12,12,12,12,12],[null,null,null,null,12,12,null,null,null,null],[null,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"S\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"S\",\"b\"],[\"S\",\"S\",\"b\",\"b\",\"f\",\"k\",\"b\",\"b\",\"S\",\"S\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"S\",\"S\",\"S\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\".\",\".\",\"b\",\"b\",\".\",\".\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\".\",\".\",\".\",\".\",\"b\",\"b\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":87,\"Stairs\":9,\"Furniture\":1,\"Book\":1},\"stats\":{\"walkable\":98,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":8.56,\"waterPct\":0}},\"59\":{\"num\":59,\"w\":12,\"h\":11,\"heights\":[[9,8,7,7,9,7,7,10.5,0,1,2,3],[9,11,7,7,11,7,7,11,11,11,11,4],[7,7,7,7,11,7,7,7,7,7,11.5,6],[7,7,7,7,11,7,7,7,7,7,11.5,7],[7,11,7,7,11,11.5,11.5,11,7,7,11,7],[7,11.5,7,7,11.5,7,7,7,7,7,7,7],[7,11.5,7,7,11.5,7,7,7,7,7,7,7],[7,11,11.5,11.5,11,11.5,11.5,11,11,11,9,8],[7,7,7,7,11,7,7,7,7,7,7,7],[7,7,7,7,11,7,7,7,7,7,9,8],[8,10,11.5,11.5,11,9,9,11,11.5,11.5,11,9]],\"surfaces\":[[\"k\",\"k\",\"k\",\"k\",\"s\",\"k\",\"k\",\"s\",\"k\",\"S\",\"k\",\"k\"],[\"k\",\"s\",\"k\",\"k\",\"s\",\"k\",\"k\",\"s\",\"s\",\"s\",\"s\",\"S\"],[\"k\",\"k\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"s\",\"S\"],[\"k\",\"k\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"s\",\"k\"],[\"k\",\"s\",\"k\",\"k\",\"s\",\"s\",\"s\",\"s\",\"k\",\"k\",\"s\",\"k\"],[\"k\",\"s\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"s\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"k\",\"s\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"s\",\"s\",\"s\",\"s\",\"k\",\"k\",\"s\",\"s\",\"s\",\"s\",\"k\"]],\"starts\":[{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":11,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":11,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Book\":88,\"Stone floor\":41,\"Stairs\":3},\"stats\":{\"walkable\":132,\"maxHeight\":11.5,\"minHeight\":0,\"spread\":11.5,\"avgHeight\":8.22,\"waterPct\":0}},\"60\":{\"num\":60,\"w\":16,\"h\":8,\"heights\":[[5,7,9,11,11,9,7,5,3,2.5,2.5,1,1,3.5,4,4],[3,3,3,3,3,3.5,4,4,3.5,3,2.5,1,1,0,0,6],[3,3,3,3,3,3.5,4,4,3.5,3.5,2.5,2.5,1,0,0,6],[3,3,3,3,3,3,4,9,8,7,6,5,4,10,8,8],[3,3,5,11,11,11,11,10.5,10,10,9.5,9,11,11,8,8],[2,3,5,11,11,11,11,6,7,7.5,8,8,11,11,10.5,9],[2,3,9,11,11,11,11,6,6,5,5,5,4,4,6.5,9],[1,1,8,11,11,11,11,6,6,5,4,4,4,4,6.5,7]],\"surfaces\":[[\"k\",\"k\",\"k\",\"b\",\"b\",\"k\",\"k\",\"k\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"b\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"k\",\"k\",\"k\"],[\"s\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"k\",\"f\",\"f\",\"k\",\"k\"],[\"s\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"f\",\"f\",\"k\",\"k\"],[\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"k\",\"k\",\"k\",\"s\",\"s\",\"s\",\"k\"],[\"s\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"k\",\"s\",\"s\",\"s\",\"s\",\"s\",\"k\"]],\"starts\":[{\"x\":0,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":14,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":14,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":61,\"Brick\":35,\"Book\":28,\"Furniture\":4},\"stats\":{\"walkable\":128,\"maxHeight\":11,\"minHeight\":0,\"spread\":11,\"avgHeight\":5.82,\"waterPct\":0}},\"61\":{\"num\":61,\"w\":12,\"h\":15,\"heights\":[[2.5,3,1.5,0,1,1.5,2,0,1,1.5,3,3],[2,1.5,0,0,0,1,1,0,0,0,2.5,1],[2.5,0,0,0,0,0,0,0,0,0,0,0],[1,0,null,null,null,null,0,null,0,null,null,0],[0,0,0,null,null,null,0,null,null,0,0,0],[0,0,0,0,0,null,null,0,0,null,null,null],[0,0,null,0,0,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,null,null,0,0],[0,null,null,0,0,null,null,null,null,null,0,0],[0,0,0,0,0,0,0,null,0,0,0,1.5],[2,1.5,0,0,0,0,0,0,0,0,1,2],[4.5,3,1.5,1,0,0,1,1.5,3,2.5,1,1],[5,3,3,3,3,4.5,5,4,3,4,3.5,2],[7,6.5,5,9,9,7.5,7,4.5,3,3,2,2],[7,8.5,9,9,9,9,7,5.5,4,4,3.5,2]],\"surfaces\":[[\"k\",\"k\",\"k\",\"b\",\"k\",\"k\",\"k\",\"b\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"k\",\"b\",\"b\",\"b\",\"k\",\"k\",\"b\",\"b\",\"b\",\"k\",\"k\"],[\"k\",\"b\",\"b\",\"o\",\"o\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"k\",\"b\",\".\",\".\",\".\",\".\",\"o\",\".\",\"o\",\".\",\".\",\"o\"],[\"b\",\"o\",\"o\",\".\",\".\",\".\",\"b\",\".\",\".\",\"o\",\"b\",\"b\"],[\"b\",\"o\",\"o\",\"o\",\"o\",\".\",\".\",\"o\",\"o\",\".\",\".\",\".\"],[\"o\",\"o\",\".\",\"o\",\"o\",\"b\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\"],[\".\",\".\",\".\",\".\",\".\",\"b\",\"o\",\"o\",\".\",\".\",\"b\",\"b\"],[\"o\",\".\",\".\",\"o\",\"o\",\".\",\".\",\".\",\".\",\".\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\".\",\"o\",\"o\",\"b\",\"k\"],[\"k\",\"k\",\"b\",\"b\",\"b\",\"b\",\"o\",\"o\",\"o\",\"b\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"k\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"b\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"],[\"k\",\"k\",\"k\",\"b\",\"b\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\",\"k\"]],\"starts\":[{\"x\":6,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Book\":62,\"Brick\":51,\"Wooden floor\":34},\"stats\":{\"walkable\":147,\"maxHeight\":9,\"minHeight\":0,\"spread\":9,\"avgHeight\":1.68,\"waterPct\":0}},\"62\":{\"num\":62,\"w\":14,\"h\":10,\"heights\":[[null,0,0,0,0,0,0,0,0,0,null,null,null,null],[null,1,1,1,1,1,1,1,0,0,0,null,null,null],[null,7,7,7,7,7,7,7,0,0,0,0,null,null],[null,7,7,7,7,7,7,7.5,8,0,0,1,null,null],[null,7,7,7,7,7,7,7.5,8,8,0,1,null,null],[null,7,7,7,7,7,7,7.5,8,0,0,1,null,null],[null,7,7,7,7,7,7,7,0,0,0,0,null,null],[null,1,1,1,1,1,1,1,0,0,0,null,null,null],[null,0,0,0,0,0,0,0,0,0,0,null,null,null],[null,null,null,null,null,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"S\",\"r\",\"s\",\"s\",\"o\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"S\",\"r\",\"r\",\"s\",\"o\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"S\",\"r\",\"s\",\"s\",\"o\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":8,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":7,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":66,\"Rug\":22,\"Stairs\":3,\"Wooden floor\":3},\"stats\":{\"walkable\":94,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":3.14,\"waterPct\":0}},\"63\":{\"num\":63,\"w\":11,\"h\":11,\"heights\":[[1,1,0,0,0,0,0,0,1,3,3],[2,2,0,0,0,1,0,0,0,2,3],[2,2,0,0,0,2,0,0,0,2,2],[1,2,0,0,0,2.5,0,0,0,1,1],[1,2,0,0,3,3,3,0,0,1,1],[1,2,0,0,3,4,3,0,0,1,1],[1,2,0,0,3,3,3,0,0,2,3],[4,3,0,0,0,0,0,0,0,2,4],[6,7,8,0,0,0,0,8,7.5,6.5,5.5],[10,10,9,9,0,0,9,9,10,10,10],[9,9,9,9,0,0,9,9,9,9,9]],\"surfaces\":[[\"b\",\"b\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"g\",\"g\",\"g\",\"o\",\"g\",\"g\",\"n\",\"b\",\"b\"],[\"b\",\"b\",\"g\",\"g\",\"g\",\"o\",\"g\",\"g\",\"g\",\"b\",\"b\"],[\"n\",\"b\",\"g\",\"g\",\"g\",\"o\",\"g\",\"g\",\"g\",\"b\",\"b\"],[\"g\",\"b\",\"g\",\"g\",\"o\",\"o\",\"o\",\"g\",\"g\",\"b\",\"b\"],[\"g\",\"b\",\"n\",\"n\",\"o\",\"o\",\"o\",\"g\",\"g\",\"b\",\"b\"],[\"n\",\"b\",\"g\",\"g\",\"o\",\"o\",\"o\",\"g\",\"g\",\"b\",\"o\"],[\"o\",\"b\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"b\",\"o\"],[\"o\",\"o\",\"o\",\"g\",\"g\",\"g\",\"g\",\"o\",\"o\",\"o\",\"o\"],[\"b\",\"b\",\"b\",\"b\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"s\",\"s\",\"b\",\"b\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":10,\"y\":4,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":45,\"Brick\":44,\"Wooden floor\":22,\"Natural Surface\":6,\"Stone floor\":4},\"stats\":{\"walkable\":121,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":2.57,\"waterPct\":0}},\"64\":{\"num\":64,\"w\":14,\"h\":10,\"heights\":[[1,1,2,3,4,5,10,11.5,12,10,9,4,0,0],[1,1,2,3,5.5,7,9,11.5,13,10,7,6,0,0],[1,1,null,3,3,2,1,null,11,null,4,6,0,0],[0,0,0,3,1,1,1,null,11,4,4,4,0,0],[0,0,null,3,null,1,1,null,11,null,4,4,0,0],[0,1,null,3,null,1,1,null,11,null,4,4,0,0],[0,0,0,3,1,1,1,null,11,4,4,6,0,0],[1,1,null,3,4,1,1,null,11.5,null,4,7,0,0],[1,1,2,3,8,9,11,12.5,13,11,9,7,0,0],[1,1,3,5,7,10.5,11,12.5,13,12,9,8.5,0,0]],\"surfaces\":[[\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"l\",\"n\",\"n\"],[\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"l\",\"l\",\"n\",\"n\"],[\"d\",\"d\",\".\",\"s\",\"o\",\"o\",\"d\",\".\",\"i\",\".\",\"l\",\"l\",\"n\",\"n\"],[\"r\",\"p\",\"p\",\"B\",\"p\",\"p\",\"d\",\".\",\"s\",\"l\",\"l\",\"l\",\"n\",\"n\"],[\"r\",\"p\",\".\",\"s\",\".\",\"p\",\"p\",\".\",\"s\",\".\",\"l\",\"l\",\"n\",\"n\"],[\"r\",\"d\",\".\",\"s\",\".\",\"d\",\"p\",\".\",\"s\",\".\",\"l\",\"l\",\"n\",\"n\"],[\"r\",\"p\",\"r\",\"B\",\"p\",\"p\",\"p\",\".\",\"s\",\"l\",\"l\",\"l\",\"n\",\"n\"],[\"d\",\"d\",\".\",\"s\",\"s\",\"d\",\"d\",\".\",\"i\",\".\",\"l\",\"l\",\"n\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\",\"l\",\"n\",\"n\"],[\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\"]],\"starts\":[{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":34,\"Natural Surface\":20,\"Stone floor\":19,\"Lake\":18,\"Marsh\":12,\"Sand area\":10,\"River\":5,\"Wooden floor\":2,\"Iron plate\":2,\"Bridge\":2},\"stats\":{\"walkable\":124,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":4.06,\"waterPct\":9.7}},\"65\":{\"num\":65,\"w\":6,\"h\":8,\"heights\":[[0,3,7,2.5,1.5,0.5],[1,2,6,3.5,0,0],[2,4,5,4,0,1],[3,6,8,0,0,2],[5,5,8,6,2,3],[14,14,15,14,5,4],[8,8,7,7,6,5],[9,6,6,14,10,10]],\"surfaces\":[[\"s\",\"b\",\"b\",\"o\",\"o\",\"o\"],[\"s\",\"b\",\"b\",\"o\",\"s\",\"s\"],[\"s\",\"b\",\"b\",\"o\",\"s\",\"s\"],[\"s\",\"b\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"b\",\"b\",\"b\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"b\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"b\",\"s\",\"s\",\"r\",\"f\",\"f\"]],\"starts\":[{\"x\":2,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":23,\"Box\":12,\"Wooden floor\":5,\"Roof\":5,\"Furniture\":2,\"Salt\":1},\"stats\":{\"walkable\":48,\"maxHeight\":15,\"minHeight\":0,\"spread\":15,\"avgHeight\":5.27,\"waterPct\":0}},\"66\":{\"num\":66,\"w\":9,\"h\":13,\"heights\":[[10,8,2,2,2,2,2,8,12],[10,8,2,2,2,2,2,8,11.5],[11,8,2,2,2,2,2,10,11],[12,8,5,5,4,4,5,8,11],[12,8,7,5,5,5,5,8,11.5],[12,8,5,5,5,5,5,8,12],[12,8,2,2,2,3,5,8,12],[12,6,2,2,2,2,2,7,12],[11.5,5,3,2,2,2,2,5,12],[11,7,8,8,8,6,5,5,12],[11,8,8,8,8,8,8,8,12],[11,10,8,8,8,8,8,10,12],[11,8,8,8,8,8,8,11,12]],\"surfaces\":[[\"b\",\"b\",\"w\",\"w\",\"w\",\"w\",\"w\",\"b\",\"b\"],[\"b\",\"b\",\"w\",\"w\",\"w\",\"w\",\"g\",\"b\",\"b\"],[\"b\",\"b\",\"w\",\"w\",\"g\",\"w\",\"w\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"g\",\"g\",\"g\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"g\",\"w\",\"w\",\"w\",\"g\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"g\",\"g\",\"g\",\"g\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":0,\"y\":10,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":87,\"Wasteland\":16,\"Grassland\":11,\"Box\":3},\"stats\":{\"walkable\":117,\"maxHeight\":12,\"minHeight\":2,\"spread\":10,\"avgHeight\":6.82,\"waterPct\":0}},\"67\":{\"num\":67,\"w\":13,\"h\":11,\"heights\":[[3,2.5,2.5,2,2,2,2,2,2,2,1.5,1,1],[3,3,2.5,2.5,2.5,2.5,2,2,2,2,2.5,2.5,2.5],[3,3.5,3.5,3.5,3.5,2.5,2.5,2.5,2.5,2.5,2.5,3,2.5],[3.5,3.5,4,6,3.5,3,2.5,2.5,3,2.5,2.5,3,2.5],[9,8,7,7,8,9,9,11,13,18,18,18,3],[2,2,4,6,2,2,4,6,15,16,16,18,18],[2,2,2,2,2,2,2,6,6,16,16,16,18],[2,2,2,2,2,2,2,6,6,16,16,16,18],[2,2,2,2,2,2,2,6,6,16,16,16,18],[2,2,6,4,2,2,4,6,15,16,16,18,18],[8,7.5,7,8,8,8.5,9,11,13,18,18,18,null]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"g\",\"w\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"w\",\"w\",\"w\"],[\"g\",\"g\",\"g\",\"b\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"g\"],[\"g\",\"g\",\"b\",\"b\",\"g\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"g\",\"g\",\"w\",\"w\",\"g\",\"w\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"g\",\"w\",\"w\",\"g\",\"w\",\"g\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"w\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"g\",\"g\",\"b\",\"b\",\"g\",\"g\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\".\"]],\"starts\":[{\"x\":8,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":60,\"Grassland\":57,\"Wasteland\":24,\"Box\":1},\"stats\":{\"walkable\":142,\"maxHeight\":18,\"minHeight\":1,\"spread\":17,\"avgHeight\":6.38,\"waterPct\":0}},\"68\":{\"num\":68,\"w\":8,\"h\":11,\"heights\":[[0,0,0,0,null,null,2,2],[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0],[0,0,0,1,1,0,0,0],[0,0,0,1,1,0,0,0],[0,0,0,1,1,0,0,0],[0,0,0,null,null,0,0,0],[0,0,0,0,null,0,0,0],[null,0,0,0,0,0,0,null],[null,2,null,0,0,0,2,null],[null,null,null,null,null,null,null,null]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\".\",\".\",\"f\",\"f\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\".\",\".\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"r\",\"r\",\".\",\"r\",\"s\",\"s\"],[\".\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\".\"],[\".\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":6,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":39,\"Rug\":23,\"Furniture\":8},\"stats\":{\"walkable\":70,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.2,\"waterPct\":0}},\"69\":{\"num\":69,\"w\":12,\"h\":12,\"heights\":[[null,null,4,0,0,0,0,0,0,null,null,null],[null,6,6,5,4,3,3,3,3,null,null,null],[null,null,3,3,3,3,3,3,3,3,null,null],[0,3,3,3,3,3,3,3,3,3,3,0],[0,3,3,3,4,3,3,3,3,2,1,0],[0,3,3,3,5,3,3,3,3,2,1,0],[0,3,3,null,6,null,3,3,3,2,1,0],[0,3,3,null,null,null,3,3,3,3,3,0],[0,3,3,null,null,null,3,3,3,3,null,0],[null,2,3,3,3,3,3,3,3,3,null,null],[0,2,2,3,3,3,3,4,null,6,8,null],[0,0,null,0,0,0,0,0,0,4,null,null]],\"surfaces\":[[\".\",\".\",\"s\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\".\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\".\",\".\"],[\"w\",\"s\",\"w\",\"w\",\"o\",\"w\",\"w\",\"w\",\"w\",\"w\",\"s\",\"w\"],[\"w\",\"s\",\"w\",\"w\",\"o\",\"s\",\"s\",\"o\",\"o\",\"w\",\"w\",\"w\"],[\"w\",\"s\",\"w\",\"w\",\"o\",\"s\",\"s\",\"s\",\"s\",\"w\",\"w\",\"w\"],[\"w\",\"s\",\"o\",\".\",\"n\",\".\",\"s\",\"w\",\"w\",\"s\",\"s\",\"w\"],[\"w\",\"s\",\"o\",\".\",\".\",\".\",\"w\",\"w\",\"w\",\"s\",\"s\",\"w\"],[\"w\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"w\",\"w\",\"w\",\".\",\"w\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"w\",\"s\",\"w\",\"s\",\"s\",\".\",\".\"],[\"w\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\".\"],[\"w\",\"w\",\".\",\"w\",\"w\",\"w\",\"w\",\"w\",\"w\",\"s\",\".\",\".\"]],\"starts\":[{\"x\":11,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Wasteland\":60,\"Stone floor\":46,\"Wooden floor\":7,\"Snow\":1},\"stats\":{\"walkable\":114,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":2.41,\"waterPct\":0}},\"70\":{\"num\":70,\"w\":8,\"h\":12,\"heights\":[[0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0.5,1],[0.5,7,0,0,0,7,1,1.5],[0.5,0,0,0,0,0,2,2],[0.5,0.5,0,0,0,2,2,4],[1,0.5,0,0,0,2,3,4.5],[7.5,8,8,0,8,8,7,6],[10,12,8,0,8,12,10,10],[10,12,9,0,9,12,10,9.5],[8.5,9,8,8,8,9,8,9],[4.5,4,7,6,6.5,7,6.5,6.5],[4,3,5,6,4,5,4.5,3.5]],\"surfaces\":[[\"g\",\"d\",\"g\",\"s\",\"g\",\"g\",\"d\",\"g\"],[\"d\",\"d\",\"d\",\"s\",\"g\",\"d\",\"g\",\"g\"],[\"g\",\"r\",\"d\",\"s\",\"g\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"d\",\"s\",\"d\",\"d\",\"g\",\"g\"],[\"g\",\"n\",\"d\",\"s\",\"s\",\"r\",\"g\",\"r\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"g\",\"g\",\"g\"],[\"S\",\"s\",\"s\",\"n\",\"s\",\"s\",\"S\",\"g\"],[\"r\",\"c\",\"s\",\"n\",\"s\",\"c\",\"r\",\"g\"],[\"g\",\"c\",\"s\",\"n\",\"s\",\"c\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":50,\"Stone floor\":19,\"Sand area\":11,\"Rocky cliff\":4,\"Coffin\":4,\"Snow\":3,\"Roof\":2,\"Stairs\":2,\"Natural Surface\":1},\"stats\":{\"walkable\":96,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":4.04,\"waterPct\":0}},\"71\":{\"num\":71,\"w\":14,\"h\":10,\"heights\":[[1,1.5,1.5,1,1.5,1.5,2,1.5,0,0,0,0,1,1.5],[0,1.5,1.5,0,1,1.5,1.5,1.5,0,null,0,1,1.5,1.5],[1,null,0,0,null,1.5,1.5,1,0,0,1.5,1.5,1.5,2],[1.5,1,0,0,2,2,1,0,0,0,1.5,1.5,1.5,1.5],[1.5,0,0,0,0,0,1,0,0,0,1,0,1.5,1.5],[1.5,0,0,0,0,0,1.5,1.5,1.5,1,0,0,0,1.5],[1.5,1.5,0,0,0,0,1.5,1.5,1.5,1.5,1.5,null,0,1.5],[1.5,1.5,1,null,0,1,1.5,1.5,0,1.5,1.5,1.5,1,1.5],[0,0,1,1.5,1.5,1.5,1.5,1.5,0,0,0,2,2,1],[1,0,0,1.5,2,1.5,1.5,1.5,0,0,0,1,1,1]],\"surfaces\":[[\"n\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"p\",\"p\",\"p\",\"p\",\"n\",\"g\"],[\"p\",\"g\",\"g\",\"p\",\"g\",\"g\",\"g\",\"g\",\"p\",\".\",\"p\",\"g\",\"g\",\"g\"],[\"g\",\".\",\"p\",\"p\",\".\",\"g\",\"g\",\"g\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"p\",\"p\",\"g\",\"n\",\"n\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"p\",\"p\",\"p\",\"p\",\"p\",\"g\",\"p\",\"p\",\"p\",\"n\",\"p\",\"g\",\"g\"],[\"n\",\"p\",\"p\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\",\"p\",\"p\",\"p\",\"g\"],[\"g\",\"g\",\"p\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"p\",\"n\"],[\"g\",\"g\",\"n\",\".\",\"p\",\"g\",\"g\",\"g\",\"p\",\"g\",\"g\",\"g\",\"n\",\"g\"],[\"p\",\"p\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\"],[\"g\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"p\",\"p\",\"n\",\"g\",\"g\"]],\"starts\":[{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":72,\"Marsh\":51,\"Natural Surface\":12},\"stats\":{\"walkable\":135,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.88,\"waterPct\":37.8}},\"72\":{\"num\":72,\"w\":9,\"h\":14,\"heights\":[[1,2,2,5,8,9,10.5,10.5,10],[1,2,4,6,8,10.5,11,10.5,10],[0,2,2,7,7,11,11,10.5,10.5],[0,1,2,6,7,null,11,11,11],[0,0,1,6,8,null,11,12,10.5],[1,0,0,5,10,11,11,10.5,10.5],[1,0,1,3,null,11,11,10.5,10],[0,0,1,3,11,11,12,10.5,10],[1,0,0,0,9,11,11,10.5,10],[1,1,2,3.5,9,11.5,11.5,10,10],[0,0,3.5,6.5,8,12,11.5,10.5,10],[0,1,2,7,7,12,12,10.5,10.5],[1,2,3,6,9,10,11,11,10.5],[1,2,4.5,5,8,10,10,11,10.5]],\"surfaces\":[[\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\"],[\"s\",\"r\",\"g\",\"g\",\"g\",\".\",\"r\",\"g\",\"g\"],[\"s\",\"s\",\"r\",\"g\",\"r\",\".\",\"r\",\"r\",\"g\"],[\"r\",\"s\",\"s\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"s\",\"r\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"r\",\"g\",\"r\",\"g\",\"r\",\"r\",\"r\"],[\"r\",\"s\",\"s\",\"s\",\"g\",\"g\",\"g\",\"r\",\"g\"],[\"r\",\"r\",\"g\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\"],[\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":1,\"y\":12,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":78,\"Rocky cliff\":30,\"Sea\":15},\"stats\":{\"walkable\":123,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":6.55,\"waterPct\":0}},\"73\":{\"num\":73,\"w\":8,\"h\":8,\"heights\":[[14,1,1,1,0,1,1,1],[14,1,0.5,0,0,0,1,0.5],[14,0,0,0,0,0,0,0],[14,2,0,null,null,0,0,0],[14,2,0,null,null,0,0,0],[14,1,0.5,0,0,0,0,1],[14,0,1,3,0,0,2,3],[14,7,6,4,3,2,3,4]],\"surfaces\":[[\"n\",\"o\",\"o\",\"o\",\"s\",\"o\",\"o\",\"o\"],[\"n\",\"o\",\"o\",\"s\",\"s\",\"s\",\"o\",\"o\"],[\"n\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"n\",\"b\",\"s\",\".\",\".\",\"s\",\"s\",\"s\"],[\"n\",\"b\",\"s\",\".\",\".\",\"s\",\"s\",\"s\"],[\"n\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"b\"],[\"n\",\"s\",\"s\",\"b\",\"s\",\"s\",\"b\",\"b\"],[\"n\",\"o\",\"s\",\"s\",\"s\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":1,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":7,\"y\":4,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":7,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":32,\"Wooden floor\":11,\"Box\":9,\"Natural Surface\":8},\"stats\":{\"walkable\":60,\"maxHeight\":14,\"minHeight\":0,\"spread\":14,\"avgHeight\":2.76,\"waterPct\":0}},\"74\":{\"num\":74,\"w\":11,\"h\":12,\"heights\":[[3.5,3,2.5,1.5,0,2,2,4,3,2.5,2.5],[3.5,null,2.5,2,2,null,2,2,3,3,3.5],[2.5,2.5,2.5,2,2,2,2,2.5,3,null,3.5],[2,2.5,2.5,2.5,2.5,1.5,0,2.5,3,3,3.5],[2,2.5,3,3,2.5,2,2,2,2.5,3,3],[2,2.5,3,3,3,0,0,0,2.5,2.5,0],[1.5,1.5,2.5,3,2.5,0,2,0,0,0,1.5],[0,0,0,0,0,0,0,0,0,3,2.5],[3,1.5,0,0,2,0,0,0,4.5,4.5,4.5],[4,3.5,null,0,0,0,1.5,1.5,4.5,5,5],[4.5,3.5,3,2,2,2,2,3,4.5,null,5],[4.5,4,2,1.5,0,1.5,3,3.5,4.5,5,5]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"p\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\".\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\"],[\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"p\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"n\",\"g\",\"g\",\"B\",\"B\",\"B\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"p\",\"p\",\"g\",\"g\",\"p\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"g\",\"p\",\"p\",\"p\",\"g\"],[\"p\",\"p\",\"p\",\"p\",\"p\",\"p\",\"p\",\"p\",\"p\",\"g\",\"g\"],[\"g\",\"g\",\"p\",\"p\",\"r\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\".\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"B\",\"B\",\"B\",\"B\",\"g\",\"g\",\".\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"p\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\"]],\"starts\":[{\"x\":0,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":10,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":3,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":86,\"Swamp\":28,\"Bridge\":7,\"Natural Surface\":5,\"Rocky cliff\":1},\"stats\":{\"walkable\":127,\"maxHeight\":5,\"minHeight\":0,\"spread\":5,\"avgHeight\":2.18,\"waterPct\":22}},\"75\":{\"num\":75,\"w\":10,\"h\":12,\"heights\":[[4,null,null,3.5,3,3,3,3,3,3],[4,null,null,3.5,3,3,3,3,5,3],[3,4,3,3,3,3,3,3,4,3],[3,4,3,3,3,3,3,3.5,4,3.5],[3,3,3,3,3,3,4,5,5,4],[3,3,3,3,3,3,3.5,3,6,5],[3,3,3,3,3,3,3,3,6,5.5],[3,3,3,3,3,3,3,3,10,7],[4,3,3,3,3,null,5,8,14.5,8],[5,null,3,3,4.5,6,5,13,18,9.5],[5,5,5,3,3,3,4,7,9,7],[4,3,0,0,0,0,0,0,3,4]],\"surfaces\":[[\"l\",\".\",\".\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\".\",\".\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\".\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\".\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\"]],\"starts\":[{\"x\":8,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":11,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":11,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Lava rocks\":70,\"Lava\":44},\"stats\":{\"walkable\":114,\"maxHeight\":18,\"minHeight\":0,\"spread\":18,\"avgHeight\":3.94,\"waterPct\":38.6}},\"76\":{\"num\":76,\"w\":10,\"h\":18,\"heights\":[[0.5,0.5,0,1,0.5,0.5,0,0,1,1],[1,0.5,0,0,1,0.5,null,0,0.5,1],[1,1,1.5,1.5,1.5,0,0,0.5,0.5,1],[1.5,1,1.5,2,1.5,1.5,1,1,1,1],[2,2,2,2.5,2.5,2,1.5,1.5,2,2],[3,2,2.5,2.5,3,3,2.5,2.5,2.5,0.5],[0,0,0,4,4,3,3,3,2.5,0.5],[0,0,0,0,0.5,0.5,0.5,0.5,0,0],[0.5,0.5,0,0.5,0.5,0,0,0,0.5,0.5],[2.5,3,4,4,0.5,0.5,0,4,4,3],[2.5,2.5,2.5,4,3,3,3,4,4,3],[2,2,2.5,2.5,3,3,3,3,2.5,2.5],[2,2,1,1,1.5,null,2,2.5,2.5,1],[0.5,1,1,1,1.5,1.5,1.5,1,1,1],[0.5,0.5,0,1,1,1,null,0.5,0.5,1],[0.5,0.5,0.5,0,null,0.5,0.5,0.5,0.5,0.5],[1,1,0.5,0.5,0.5,0,0,0.5,0.5,0],[1,1,1,1,0.5,0,0,0.5,1,1]],\"surfaces\":[[\"d\",\"d\",\"d\",\"r\",\"d\",\"d\",\"d\",\"d\",\"r\",\"r\"],[\"r\",\"d\",\"d\",\"d\",\"r\",\"d\",\".\",\"d\",\"d\",\"r\"],[\"r\",\"r\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"r\"],[\"d\",\"r\",\"d\",\"d\",\"d\",\"d\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"d\",\"d\",\"r\",\"d\",\"d\",\"r\",\"r\"],[\"r\",\"r\",\"d\",\"d\",\"r\",\"r\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"r\",\"r\",\"r\",\"r\",\"r\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"r\",\"r\",\"r\",\"r\",\"d\",\"d\",\"d\",\"r\",\"r\",\"r\"],[\"d\",\"d\",\"d\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"d\",\"d\",\"d\",\"r\",\"r\",\"d\",\"d\",\"d\"],[\"r\",\"r\",\"d\",\"r\",\"d\",\".\",\"r\",\"d\",\"d\",\"d\"],[\"d\",\"r\",\"r\",\"r\",\"d\",\"d\",\"d\",\"r\",\"r\",\"d\"],[\"d\",\"d\",\"d\",\"r\",\"r\",\"r\",\".\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\".\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"r\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"r\",\"r\",\"d\",\"r\",\"r\"]],\"starts\":[{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":17,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":17,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":17,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":17,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Sand area\":112,\"Rocky cliff\":64},\"stats\":{\"walkable\":176,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":1.31,\"waterPct\":0}},\"77\":{\"num\":77,\"w\":11,\"h\":11,\"heights\":[[1,1,1,2,2,3,1,1,1,1,1],[1,1,1,3,2,2,2,2,1,null,1],[1,1,2.5,4,2,2,2,1,1,1,1],[1,3,3.5,7,2,2.5,2.5,2.5,1,9,6],[1,3.5,3.5,8.5,2.5,2.5,3.5,6,7,8.5,6],[2.5,5,5,9,6.5,3.5,4,4,7,5.5,5.5],[4,6,5,7,5,4,4,5,7,6.5,5.5],[3,6.5,5,9,7,5,5,6.5,7.5,8,7.5],[3,7,4,8,6,6,6,7.5,10,10,10],[1,1,2.5,8.5,4.5,5,6.5,8.5,9.5,9,8.5],[1,1,2.5,9,4.5,4,6.5,8.5,9,9,7.5]],\"surfaces\":[[\"l\",\"l\",\"l\",\"r\",\"g\",\"g\",\"l\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"l\",\"l\",\"g\",\"g\",\"g\",\"r\",\"r\",\"l\",\".\",\"l\"],[\"l\",\"l\",\"g\",\"r\",\"g\",\"r\",\"r\",\"l\",\"l\",\"l\",\"l\"],[\"l\",\"g\",\"g\",\"r\",\"g\",\"g\",\"r\",\"g\",\"l\",\"r\",\"r\"],[\"l\",\"g\",\"g\",\"r\",\"g\",\"g\",\"n\",\"r\",\"g\",\"r\",\"g\"],[\"g\",\"r\",\"g\",\"r\",\"r\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"g\",\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"g\",\"r\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\"],[\"l\",\"l\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\"],[\"l\",\"l\",\"g\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"r\",\"g\"]],\"starts\":[{\"x\":0,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":61,\"Rocky cliff\":29,\"Lake\":26,\"Natural Surface\":4},\"stats\":{\"walkable\":120,\"maxHeight\":10,\"minHeight\":1,\"spread\":9,\"avgHeight\":4.44,\"waterPct\":0}},\"78\":{\"num\":78,\"w\":14,\"h\":12,\"heights\":[[3,3,4,3.5,3.5,1,1,2,2,2,1,3,null,null],[3,4,4,3.5,2,2,0,1,1,null,1,3,null,null],[3,4.5,3.5,3.5,1,2,2,2,0,null,0,3,null,null],[2.5,5,0,1,0,1,null,1,1,0,3,3,null,null],[1,4.5,1,null,2,0,null,2,2,1,3,4,null,null],[2,3.5,1,1,0,2,1,3,4.5,5,4.5,4,null,null],[1,1,0,2,1,0,2,0,1,2,3,3,null,null],[2.5,2.5,2.5,1,null,1,0,2,1,0,1,1,null,null],[2.5,3,2.5,1,null,2.5,2.5,1,null,1,2,2,null,null],[2.5,1,1,0,2.5,2.5,2.5,2,1,0,3.5,3.5,null,null],[2.5,null,null,1,2.5,3,2.5,0,1,2,3.5,3.5,null,null],[2.5,2.5,1,2,3,3,2,1,2,3,3.5,4,null,null]],\"surfaces\":[[\"g\",\"g\",\"g\",\"r\",\"w\",\"P\",\"P\",\"g\",\"g\",\"g\",\"P\",\"g\",\".\",\".\"],[\"g\",\"g\",\"g\",\"w\",\"g\",\"w\",\"P\",\"P\",\"P\",\".\",\"P\",\"g\",\".\",\".\"],[\"g\",\"t\",\"w\",\"w\",\"P\",\"w\",\"w\",\"g\",\"P\",\".\",\"P\",\"g\",\".\",\".\"],[\"g\",\"t\",\"P\",\"P\",\"P\",\"P\",\".\",\"P\",\"P\",\"P\",\"g\",\"g\",\".\",\".\"],[\"P\",\"t\",\"P\",\".\",\"g\",\"P\",\".\",\"g\",\"g\",\"P\",\"g\",\"g\",\".\",\".\"],[\"w\",\"t\",\"P\",\"P\",\"P\",\"w\",\"P\",\"t\",\"t\",\"t\",\"t\",\"g\",\".\",\".\"],[\"P\",\"P\",\"P\",\"w\",\"P\",\"P\",\"w\",\"P\",\"P\",\"n\",\"g\",\"g\",\".\",\".\"],[\"w\",\"g\",\"w\",\"P\",\".\",\"P\",\"P\",\"g\",\"P\",\"P\",\"P\",\"P\",\".\",\".\"],[\"g\",\"g\",\"w\",\"P\",\".\",\"g\",\"w\",\"P\",\".\",\"P\",\"g\",\"g\",\".\",\".\"],[\"w\",\"P\",\"P\",\"P\",\"g\",\"g\",\"g\",\"g\",\"P\",\"P\",\"g\",\"w\",\".\",\".\"],[\"w\",\".\",\".\",\"P\",\"g\",\"g\",\"g\",\"P\",\"P\",\"g\",\"g\",\"w\",\".\",\".\"],[\"w\",\"w\",\"P\",\"w\",\"g\",\"g\",\"g\",\"P\",\"w\",\"g\",\"g\",\"w\",\".\",\".\"]],\"starts\":[{\"x\":11,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":11,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Poisoned marsh\":52,\"Grassland\":48,\"Wasteland\":24,\"Tree\":8,\"Rocky cliff\":1,\"Natural Surface\":1},\"stats\":{\"walkable\":134,\"maxHeight\":5,\"minHeight\":0,\"spread\":5,\"avgHeight\":2.02,\"waterPct\":0}},\"79\":{\"num\":79,\"w\":12,\"h\":8,\"heights\":[[0,0,0.5,1,1,1,1,1,1,1.5,2,2],[0,0,0.5,1,1,5,4,1,1,1.5,2,2],[0,0,2,3.5,4,5.5,5.5,4.5,3,1.5,1.5,1.5],[0,0.5,2,3.5,5.5,null,null,5.5,3.5,1,1,1],[0,0.5,1.5,3.5,5.5,null,null,5.5,3.5,2,1,1],[0.5,0.5,1,3.5,4.5,5.5,5.5,4,3.5,3,3.5,3.5],[1,1,1,2.5,3,4,4,3.5,3.5,3.5,4,3.5],[1,1,1,2.5,2.5,3.5,3.5,3.5,3.5,3.5,3.5,3.5]],\"surfaces\":[[\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"g\",\"g\",\"s\",\"s\",\"s\",\"t\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"s\",\"s\",\"g\"],[\"g\",\"g\",\"r\",\"g\",\"t\",\".\",\".\",\"t\",\"t\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"t\",\".\",\".\",\"m\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"t\",\"t\",\"m\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":11,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":60,\"Stone floor\":19,\"Tree\":10,\"Moss\":2,\"Rocky cliff\":1},\"stats\":{\"walkable\":92,\"maxHeight\":5.5,\"minHeight\":0,\"spread\":5.5,\"avgHeight\":2.35,\"waterPct\":0}},\"80\":{\"num\":80,\"w\":12,\"h\":10,\"heights\":[[null,7,4.5,3.5,3,3,0,2.5,5,7,7,7],[7,7,3,3,3,3,2,2.5,5,5,7,null],[7,6,3,3,1,2.5,2,2,3.5,5,7,7],[5.5,5,2.5,2.5,2.5,2.5,0,2,3.5,4,4,4],[5,3,2,2,2,2,0,2,3,4,4,4],[6.5,2,2,0,2.5,2.5,2.5,2,0,4,4.5,4.5],[8,2,2,2,2.5,null,null,2,3,4.5,5,5],[null,5,2,2,2,null,2,2,3,5,6.5,6.5],[8,7,3,3,2,0.5,2,2,2,7,null,7],[6.5,4,3,2.5,2,1.5,2,2,3.5,7,7,7]],\"surfaces\":[[\".\",\"g\",\"t\",\"t\",\"t\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"g\"],[\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"t\"],[\"g\",\"g\",\"t\",\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"t\"],[\"g\",\"g\",\"g\",\"g\",\"t\",\".\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\".\",\"g\",\"g\",\"g\",\"g\",\".\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":11,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":98,\"Tree\":10,\"Natural Surface\":5},\"stats\":{\"walkable\":113,\"maxHeight\":8,\"minHeight\":0,\"spread\":8,\"avgHeight\":3.66,\"waterPct\":0}},\"81\":{\"num\":81,\"w\":11,\"h\":13,\"heights\":[[0,0,0,0,0,1,0,0,0,0,0],[0,0,0,0,0,1,0,0,0,0,0],[4,4,0,0,0,1,0,0,0,0,0],[3,4,4,4,0,1,1,4,4,4,4],[3,3,3,4,4,4,2,4,3,3,3],[7,3,3,3,3,4,3,3,3,3,3],[9,7,3,3,3,4,3,3,3,7,7],[8,7,7,3,3,4,3,7,7,7,6],[6,6,7,7,7,5,7,7,6,6,6],[6,6,6,6,7,6,6,6,6,6,6],[10,10,10,6,7,6,6,6,8,8.5,9],[9,9,10,7,10,6,9,8,8,8.5,8.5],[9,9,9,9,10,7,8.5,8.5,8,8.5,8.5]],\"surfaces\":[[\"t\",\"t\",\"g\",\"g\",\"n\",\"b\",\"n\",\"g\",\"t\",\"t\",\"t\"],[\"t\",\"t\",\"g\",\"g\",\"n\",\"b\",\"n\",\"g\",\"t\",\"t\",\"t\"],[\"g\",\"g\",\"n\",\"n\",\"n\",\"b\",\"n\",\"g\",\"t\",\"t\",\"t\"],[\"n\",\"r\",\"g\",\"g\",\"n\",\"b\",\"b\",\"r\",\"r\",\"r\",\"r\"],[\"n\",\"n\",\"n\",\"r\",\"r\",\"b\",\"S\",\"r\",\"g\",\"g\",\"g\"],[\"b\",\"g\",\"g\",\"g\",\"g\",\"b\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"b\",\"r\",\"g\",\"g\",\"n\",\"b\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"b\",\"r\",\"g\",\"g\",\"n\",\"b\",\"n\",\"g\",\"g\",\"g\",\"t\"],[\"g\",\"n\",\"g\",\"g\",\"b\",\"S\",\"g\",\"g\",\"t\",\"t\",\"t\"],[\"g\",\"g\",\"g\",\"g\",\"b\",\"s\",\"n\",\"n\",\"t\",\"t\",\"t\"],[\"g\",\"g\",\"g\",\"g\",\"b\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\"],[\"t\",\"t\",\"g\",\"s\",\"b\",\"n\",\"g\",\"r\",\"r\",\"g\",\"g\"],[\"t\",\"t\",\"g\",\"s\",\"b\",\"b\",\"g\",\"g\",\"r\",\"g\",\"g\"]],\"starts\":[{\"x\":10,\"y\":10,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":59,\"Thicket\":24,\"Natural Surface\":24,\"Brick\":15,\"Rocky cliff\":13,\"Box\":3,\"Stone floor\":3,\"Stairs\":2},\"stats\":{\"walkable\":143,\"maxHeight\":10,\"minHeight\":0,\"spread\":10,\"avgHeight\":4.5,\"waterPct\":0}},\"82\":{\"num\":82,\"w\":11,\"h\":12,\"heights\":[[1,1,2,3,1,1,1,1,1.5,2,2],[1,2,2.5,3,1,1,1,1,1.5,1.5,1.5],[1,1,2,1,1,2,1,1,1,1,2],[1,1,2,1,1,2,1,1,1,1,1],[1,2,2,2,2,2,1,1,1,4,5],[0.5,1,1,1,1,2.5,1,5,9.5,4,5],[0.5,1,1,1,6,5,6.5,8,9,4,5],[1,1,1,1,7,4,4,3,3,3,4],[4,3.5,2,6,8,7,4,3,3,3,4],[5,4,3,5,8,8,4,3.5,3,4,5],[1.5,4,3,5,7,7,7,6,5,5,9],[1.5,2.5,3,4,4,4,5,5,5,4,8]],\"surfaces\":[[\"d\",\"d\",\"o\",\"b\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"b\",\"b\",\"b\",\"b\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"b\",\"d\",\"d\",\"b\",\"d\",\"d\",\"d\",\"s\",\"s\"],[\"d\",\"d\",\"b\",\"d\",\"d\",\"b\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"b\",\"b\",\"b\",\"b\",\"b\",\"d\",\"d\",\"d\",\"s\",\"s\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"b\",\"d\",\"b\",\"b\",\"b\",\"s\"],[\"d\",\"d\",\"d\",\"d\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"s\"],[\"d\",\"d\",\"d\",\"d\",\"b\",\"b\",\"b\",\"d\",\"d\",\"d\",\"d\"],[\"b\",\"b\",\"S\",\"b\",\"o\",\"b\",\"b\",\"d\",\"d\",\"d\",\"d\"],[\"b\",\"o\",\"s\",\"b\",\"o\",\"b\",\"b\",\"d\",\"d\",\"b\",\"s\"],[\"d\",\"o\",\"s\",\"b\",\"o\",\"o\",\"o\",\"S\",\"o\",\"o\",\"o\"],[\"d\",\"d\",\"d\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"o\",\"o\"]],\"starts\":[{\"x\":1,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":10,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Sand area\":64,\"Brick\":44,\"Wooden floor\":13,\"Stone floor\":9,\"Stairs\":2},\"stats\":{\"walkable\":132,\"maxHeight\":9.5,\"minHeight\":0.5,\"spread\":9,\"avgHeight\":3.03,\"waterPct\":0}},\"83\":{\"num\":83,\"w\":11,\"h\":10,\"heights\":[[4,6.5,8,9.5,10.5,11.5,17,18.5,20.5,22,22],[3,5,8,9.5,10.5,10.5,13.5,16.5,19.5,22,22],[1,3.5,8,9.5,10,10,10.5,15,16.5,22,21.5],[2,1,1,1,0,5.5,9.5,13.5,16.5,null,20],[2,1,2,1,0,0,7.5,10.5,15.5,null,21],[1,1,1,1,0,0,4.5,8.5,13.5,null,20],[3.5,3.5,2.5,1,0,3.5,6.5,12.5,16.5,null,20],[4.5,4,9.5,10,10,9.5,9,14.5,19.5,22,21.5],[5.5,4.5,9.5,10,10,10.5,13.5,16.5,19.5,22,22],[7,8,9.5,10,10.5,10.5,17,19.5,21.5,22,22]],\"surfaces\":[[\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"r\"],[\"r\",\"r\",\"g\",\"r\",\"r\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"r\",\"r\",\"g\",\"g\",\"r\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\"w\",\".\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\".\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\".\",\"r\"],[\"g\",\"g\",\"r\",\"r\",\"r\",\"w\",\"w\",\"w\",\"w\",\".\",\"r\"],[\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\",\"g\"],[\"r\",\"g\",\"g\",\"r\",\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\"]],\"starts\":[{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Rocky cliff\":38,\"Grassland\":34,\"River\":20,\"Waterfall\":14},\"stats\":{\"walkable\":106,\"maxHeight\":22,\"minHeight\":0,\"spread\":22,\"avgHeight\":10.41,\"waterPct\":0}},\"84\":{\"num\":84,\"w\":14,\"h\":9,\"heights\":[[3.5,3.5,2,2,2,2,1.5,1,1,1,1,2.5,3,3],[4,3.5,3.5,3.5,2,2,1.5,1.5,1,1,2.5,2.5,3,3],[4,4,4,null,6,6.5,7,9.5,9.5,9.5,9.5,6.5,6.5,3],[4,4,6.5,6.5,8.5,9,9.5,9.5,10,10,11.5,11.5,11.5,9.5],[6.5,6.5,6.5,8.5,8.5,9,9.5,null,10,10,11.5,12,12,12],[6.5,7,7,8.5,8.5,9,9.5,9.5,9.5,10,11.5,12,12,12],[7,7,null,7,8.5,8.5,8.5,6,6,7.5,7.5,7.5,2,2],[6.5,6.5,5,4.5,3,3,2.5,2.5,1,1,1.5,1.5,2,2],[5,4.5,4.5,4.5,3,3,2.5,1,1,1,1,1.5,2,2]],\"surfaces\":[[\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"g\",\".\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\"],[\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\"],[\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\"],[\"g\",\"g\",\".\",\"g\",\"r\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"r\",\"g\",\"r\",\"r\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\"],[\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\"]],\"starts\":[{\"x\":9,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":11,\"y\":8,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":11,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":12,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":12,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":78,\"Rocky cliff\":45},\"stats\":{\"walkable\":123,\"maxHeight\":12,\"minHeight\":1,\"spread\":11,\"avgHeight\":5.61,\"waterPct\":0}},\"85\":{\"num\":85,\"w\":13,\"h\":13,\"heights\":[[1,1,1,null,1,1,1.5,3,1.5,1,1,1,null],[null,2,1,1,1,4,2,null,1.5,1,1,null,null],[1,1,1.5,1.5,1.5,null,2,4,1,null,1,1,null],[1,null,1.5,2,2,2,1.5,1,1,3,1,1,null],[1.5,1.5,2,2,2,2,1.5,1,1,1,1,null,null],[2,2,null,null,1.5,1.5,1,null,0.5,0.5,0.5,0.5,null],[2,2,null,1,1,1,1,null,0,0,0,0,null],[2,null,null,1,1,1,0,0,0,0,0,null,null],[3,1,1,1,null,0.5,0,0,0,0,null,1,null],[null,1,1,1,1,0.5,null,null,0,null,null,2,null],[1.5,1,1,1,1,0,0,0,0,1,2,2,null],[1,1,2,null,null,0,1,null,0,1,2,2,null],[1,1,1,null,0,0,0,0,0,1,2,2,null]],\"surfaces\":[[\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\",\".\"],[\".\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\".\",\"g\",\"g\",\"g\",\".\",\".\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"r\",\"g\",\".\",\"g\",\"g\",\".\"],[\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\".\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\".\"],[\"g\",\"r\",\".\",\".\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\".\"],[\"r\",\"r\",\".\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\".\"],[\"g\",\".\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\".\",\".\"],[\"r\",\"r\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\".\"],[\".\",\"g\",\"g\",\"g\",\"g\",\"r\",\".\",\".\",\"g\",\".\",\".\",\"g\",\".\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\".\"],[\"g\",\"g\",\"r\",\".\",\".\",\"g\",\"r\",\".\",\"g\",\"g\",\"r\",\"g\",\".\"],[\"r\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"g\",\".\"]],\"starts\":[{\"x\":0,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":12,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":11,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":12,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":109,\"Rocky cliff\":20},\"stats\":{\"walkable\":129,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":1.11,\"waterPct\":0}},\"86\":{\"num\":86,\"w\":10,\"h\":8,\"heights\":[[1,1,1,0.5,0,0.5,1,1,1.5,2],[1,1,3,4,0,0.5,1,6,4.5,3],[8,8,8,6,null,null,7,6.5,5,4],[7.5,8,8,7.5,7,7,7,6.5,5,7],[6,7,9,11,7,7,8.5,8,6,8],[null,9.5,10,11,null,null,12.5,12.5,7,7],[9.5,11,11,11,11.5,12,12.5,13,13,13],[10,11,13.5,13.5,12,12,12.5,13,13,13]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\"],[\"g\",\"g\",\"r\",\"r\",\".\",\".\",\"r\",\"r\",\"g\",\"r\"],[\"r\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\"],[\"g\",\"r\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"r\"],[\".\",\"r\",\"r\",\"g\",\".\",\".\",\"r\",\"r\",\"g\",\"g\"],[\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\"]],\"starts\":[{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":39,\"Rocky cliff\":36},\"stats\":{\"walkable\":75,\"maxHeight\":13.5,\"minHeight\":0,\"spread\":13.5,\"avgHeight\":7.26,\"waterPct\":0}},\"87\":{\"num\":87,\"w\":12,\"h\":12,\"heights\":[[8,7.5,7,6.5,5,8,11,7.5,4,5,10.5,11.5],[9,9,7,6.5,5,9.5,11,9,4,5,10,11.5],[null,10,9,4,5,9,10.5,6.5,5,7,10,10.5],[11,10.5,10,3,4,8.5,10,3,2,6.5,7.5,9],[11,10.5,8,3,4,3,8,3,2,6,7.5,8],[11.5,10.5,9,8,2,3,3,2,2,3,6,6.5],[9,9,8,8,8,3,3,2,3,3,6.5,7],[9,8.5,8,8,7.5,6.5,2,2,3,5.5,null,8],[9,9,9,9,8,6,3,6,3,6,7.5,8],[11,9.5,9,null,9.5,7,3,3,3,6.5,9,8.5],[11.5,14.5,13,11.5,10.5,6.5,2,2,6,7.5,9,null],[15.5,14.5,11,9.5,10,0,0,2,6,7.5,8.5,9]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\"],[\".\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\"],[\"s\",\"g\",\"s\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\"],[\"s\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\"],[\"s\",\"g\",\"g\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"n\",\"g\",\"g\",\"s\",\"s\",\"g\",\"r\",\"r\",\"r\",\"g\",\".\",\"g\"],[\"n\",\"g\",\"g\",\"g\",\"s\",\"g\",\"r\",\"s\",\"r\",\"g\",\"g\",\"g\"],[\"s\",\"g\",\"g\",\".\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"s\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\",\"s\",\".\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":0,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":5,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":82,\"River\":42,\"Stone floor\":14,\"Natural Surface\":2},\"stats\":{\"walkable\":140,\"maxHeight\":15.5,\"minHeight\":0,\"spread\":15.5,\"avgHeight\":7.05,\"waterPct\":0}},\"88\":{\"num\":88,\"w\":10,\"h\":17,\"heights\":[[2,2.5,2.5,2.5,0,2,2.5,1.5,1.5,0],[2,2.5,3,3,0,2,3,3,2.5,0],[2.5,2.5,null,3,2,3,3,1,1,2],[2.5,3,3,1,1,3.5,3,1,1,3],[3,3,3,1,3.5,3.5,1,2,3.5,3.5],[3.5,3.5,3,1,3.5,3.5,1,2,3.5,null],[4,null,3.5,1,3.5,3,1,3,3.5,3.5],[5.5,4.5,4.5,1,3,2,1,3,3,3.5],[6,5.5,4.5,1,2,1,1,3,3,3],[6,5.5,1,1,1,1,3.5,3.5,3,3],[7.5,6.5,1,1,6.5,1,3.5,3.5,3.5,3.5],[7.5,7,7,5,7,5,7,4.5,4,4],[7.5,7.5,7,4,6.5,4,6.5,6,6.5,4.5],[9.5,8,6.5,4,4,4,4,4,6.5,4.5],[10.5,8.5,8.5,7.5,4,4,4,4,6.5,6.5],[11,11,10.5,10,9.5,8,8,8,9.5,7],[11,10.5,10.5,10,10,7,10,7,10,7.5]],\"surfaces\":[[\"n\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\",\"r\"],[\"n\",\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"n\",\"g\",\"r\"],[\"n\",\"g\",\".\",\"g\",\"r\",\"n\",\"g\",\"r\",\"r\",\"r\"],[\"n\",\"n\",\"g\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\"],[\"n\",\"n\",\"g\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"g\",\"g\",\"r\",\"r\",\"g\",\".\"],[\"g\",\".\",\"g\",\"r\",\"g\",\"g\",\"r\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"g\",\"r\",\"r\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\",\"n\",\"n\"],[\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"n\"],[\"r\",\"g\",\"r\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"n\",\"r\",\"n\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"r\",\"r\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"r\",\"g\",\"r\",\"g\",\"g\"]],\"starts\":[{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":11,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":12,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":13,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":14,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":84,\"River\":52,\"Gravel\":15,\"Natural Surface\":14,\"Rocky cliff\":2},\"stats\":{\"walkable\":167,\"maxHeight\":11,\"minHeight\":0,\"spread\":11,\"avgHeight\":4.24,\"waterPct\":0}},\"89\":{\"num\":89,\"w\":12,\"h\":14,\"heights\":[[1.5,1.5,1.5,1.5,1.5,1.5,1,1,1,1,1,null],[2.5,2.5,2.5,2.5,2.5,2,1,1,2.5,2.5,1,null],[3,3.5,3.5,3.5,3.5,1.5,1,1,3,3,1,null],[1,4.5,4.5,4.5,4,1,1,1,3,3,3,null],[1,5,5,5,1,1,1,1,1,1,1,null],[1,1,1,1,1,1,1,3.5,3.5,3.5,1,null],[1,1,1,1,1,3.5,3.5,4,4,12,1,null],[1,1,1,1,3.5,4,4,4,4,4,1,null],[1,1,1,1,4,4,4,4,4,4,2.5,null],[2.5,1,1,2.5,4,5.5,13,10,11,11,3,null],[3.5,3.5,1,3,4,10,10,10,10,10,4.5,null],[4,4,1,6,7.5,10,12,10,11,10,5.5,null],[4,4,2.5,6,8,8,8,9,9,9,6,null],[4,3,3,4,8,8,8,8,8,9,8,null]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"r\",\"s\",\"s\",\"r\",\"r\",\".\"],[\"r\",\"r\",\"r\",\"s\",\"r\",\"r\",\"s\",\"r\",\"r\",\"r\",\"s\",\".\"],[\"s\",\"r\",\"r\",\"s\",\"r\",\"r\",\"o\",\"o\",\"r\",\"r\",\"r\",\".\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"o\",\"s\",\"s\",\"s\",\".\"],[\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"o\",\"o\",\"r\",\"r\",\"s\",\".\"],[\"r\",\"r\",\"r\",\"r\",\"s\",\"r\",\"o\",\"o\",\"s\",\"B\",\"r\",\".\"],[\"r\",\"r\",\"r\",\"s\",\"r\",\"r\",\"s\",\"s\",\"r\",\"r\",\"r\",\".\"],[\"r\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\"],[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"b\",\"b\",\"b\",\"B\",\"r\",\".\"],[\"s\",\"r\",\"s\",\"r\",\"r\",\"b\",\"b\",\"b\",\"b\",\"b\",\"r\",\".\"],[\"r\",\"r\",\"s\",\"r\",\"r\",\"b\",\"b\",\"b\",\"b\",\"b\",\"r\",\".\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"d\",\"d\",\"b\",\"b\",\"b\",\"r\",\".\"],[\"d\",\"d\",\"r\",\"d\",\"d\",\"d\",\"b\",\"b\",\"d\",\"b\",\"b\",\".\"]],\"starts\":[{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":13,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":13,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":13,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":13,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Rocky cliff\":72,\"Salt\":44,\"Brick\":20,\"Wooden floor\":8,\"Sand area\":8,\"Bridge\":2},\"stats\":{\"walkable\":154,\"maxHeight\":13,\"minHeight\":1,\"spread\":12,\"avgHeight\":3.81,\"waterPct\":0}},\"90\":{\"num\":90,\"w\":10,\"h\":12,\"heights\":[[2,3,4,5,6,7,6.5,0,0,0],[2,3,4,5,6,6.5,6.5,3,0,0],[7,7,4,5,6,6,6,6,1,1],[10,10,10,6,6,7,7,9,9,1],[10,9,8,7,12,12,8,8,9,5],[9,9,12,15,15,15,8,7,8.5,5],[9,9,12,15,15,15,6,6,8,null],[8,8,8,15,15,12,5,4,0.5,0],[4,4,4,3,4,5,5,4,0.5,0],[1,1,2,3,4,5,6,6,0,0],[0,1,2,4,5,6,6,0,0.5,0.5],[0,1,1,1,0.5,0,0,0,0.5,1]],\"surfaces\":[[\"g\",\"g\",\"o\",\"o\",\"o\",\"g\",\"g\",\"g\",\"n\",\"g\"],[\"g\",\"g\",\"n\",\"o\",\"o\",\"g\",\"g\",\"r\",\"g\",\"g\"],[\"r\",\"r\",\"g\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"o\",\"g\",\"g\",\"n\",\"r\",\"r\",\"g\"],[\"r\",\"o\",\"o\",\"o\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\"],[\"g\",\"o\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"r\",\"r\"],[\"g\",\"g\",\"r\",\"r\",\"r\",\"r\",\"g\",\"o\",\"r\",\".\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"o\",\"o\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"g\",\"o\",\"o\",\"o\",\"n\",\"n\",\"g\"],[\"g\",\"g\",\"g\",\"n\",\"n\",\"n\",\"r\",\"r\",\"g\",\"n\"],[\"g\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"g\",\"n\",\"n\"],[\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":11,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":11,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":46,\"Rocky cliff\":39,\"Natural Surface\":18,\"Wooden floor\":16},\"stats\":{\"walkable\":119,\"maxHeight\":15,\"minHeight\":0,\"spread\":15,\"avgHeight\":5.44,\"waterPct\":0}},\"91\":{\"num\":91,\"w\":10,\"h\":12,\"heights\":[[0,0,2,2,2,2,1,0,0,2],[0,0,2,2,2,2,0,0,0,1],[6,6,6,1,1,3,3,3,0,0],[6,6,6,2.5,2.5,5,5,5,2,0],[6,6,6,3.5,3.5,5,5,5,3.5,1],[6,6,7,4.5,4.5,5,5,5,3.5,0],[4,6,7,4.5,5.5,5.5,4,3,2,0],[3,6,13,3.5,6.5,6.5,4,2,0,0],[2,4.5,13,3,11,11,9,9,6,1],[1,2.5,11,3,3,3,9,8,6,1],[1,2,10,3,3,3,8,8,6,1],[1,1,1,1,1,1,1,1,1,1]],\"surfaces\":[[\"s\",\"s\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\",\"s\",\"o\"],[\"s\",\"s\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\"],[\"o\",\"o\",\"s\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\"],[\"g\",\"g\",\"g\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\"],[\"g\",\"g\",\"s\",\"o\",\"o\",\"o\",\"g\",\"g\",\"s\",\"s\"],[\"g\",\"g\",\"s\",\"o\",\"o\",\"o\",\"g\",\"s\",\"s\",\"s\"],[\"g\",\"g\",\"s\",\"o\",\"s\",\"s\",\"o\",\"s\",\"s\",\"s\"],[\"s\",\"g\",\"s\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\",\"s\"],[\"s\",\"g\",\"o\",\"o\",\"o\",\"o\",\"o\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Wooden floor\":45,\"Sea\":36,\"Stone floor\":25,\"Grassland\":14},\"stats\":{\"walkable\":120,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":3.65,\"waterPct\":0}},\"92\":{\"num\":92,\"w\":10,\"h\":8,\"heights\":[[null,null,2,2,2,2,null,3,3,3],[null,null,2,2,2,2,null,2,2,2],[2,2,2,2,2,2,null,2,2,2],[2,2,2,3,2,2,2,2,2,2],[2,2,2,3,2,2,null,2,2,2],[2,2,2,2,2,2,null,2,2,2],[null,null,2,2,2,2,null,1,1,1],[null,null,2,6,6,2,null,0,0,0]],\"surfaces\":[[\".\",\".\",\"r\",\"r\",\"r\",\"r\",\".\",\"r\",\"r\",\"r\"],[\".\",\".\",\"r\",\"r\",\"r\",\"r\",\".\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"f\",\"r\",\"r\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"f\",\"r\",\"r\",\".\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\"r\",\"r\",\"r\"],[\".\",\".\",\"r\",\"r\",\"r\",\"r\",\".\",\"S\",\"S\",\"S\"],[\".\",\".\",\"r\",\"f\",\"f\",\"r\",\".\",\"r\",\"r\",\"r\"]],\"starts\":[{\"x\":2,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Rug\":57,\"Furniture\":4,\"Stairs\":3,\"Stone floor\":1},\"stats\":{\"walkable\":65,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":2.06,\"waterPct\":0}},\"93\":{\"num\":93,\"w\":9,\"h\":9,\"heights\":[[5,5,5,5,5,5,6,null,null],[5,5,null,5,5,5,6,null,null],[4.5,4.5,null,5,5,5,6,null,null],[3.5,3.5,null,5,5,5,6,null,null],[2.5,2.5,null,5,5,5,6,null,null],[1.5,1.5,null,5,5,5,null,null,null],[0.5,0.5,null,5,5,5,6,null,null],[null,0,null,null,null,null,null,null,null],[null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\".\",\".\"],[\"o\",\"o\",\".\",\"r\",\"r\",\"r\",\"o\",\".\",\".\"],[\"S\",\"S\",\".\",\"r\",\"r\",\"r\",\"o\",\".\",\".\"],[\"S\",\"S\",\".\",\"r\",\"r\",\"r\",\"o\",\".\",\".\"],[\"S\",\"S\",\".\",\"r\",\"r\",\"r\",\"o\",\".\",\".\"],[\"S\",\"S\",\".\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\"S\",\"S\",\".\",\"o\",\"o\",\"o\",\"o\",\".\",\".\"],[\".\",\"o\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Wooden floor\":18,\"Rug\":15,\"Stairs\":10},\"stats\":{\"walkable\":43,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":4.44,\"waterPct\":0}},\"94\":{\"num\":94,\"w\":9,\"h\":5,\"heights\":[[2,2,0,0,0,0,0,0,2],[2,null,0,0,0,0,0,0,0],[2,1,0,0,0,0,0,0,0],[2,1,0,0,1,1,0,0,0],[2,1,0,0,0,0,0,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"r\",\"r\",\"r\",\"f\",\"f\",\"r\",\"s\",\"s\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"]],\"starts\":[{\"x\":8,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":8,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":26,\"Rug\":16,\"Furniture\":2},\"stats\":{\"walkable\":44,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.43,\"waterPct\":0}},\"95\":{\"num\":95,\"w\":9,\"h\":12,\"heights\":[[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[1,1,0,0,0,0,0,1,1],[0,0,0,0,0,0,0,0,0],[1,1,0,0,0,0,0,1,1],[0,0,0,0,0,0,0,0,0],[1,1,0,0,0,0,0,1,1],[0,0,0,0,0,0,0,0,0],[0,2,2,2,2,2,2,2,0],[1,2,2,4,null,4,2,2,1],[2,2,2,2,2,2,2,2,2],[2,2,2,2,4,2,2,2,2]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"f\",\"f\",\"s\",\"s\",\"r\",\"s\",\"s\",\"f\",\"f\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"f\",\"f\",\"s\",\"s\",\"r\",\"s\",\"s\",\"f\",\"f\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"f\",\"f\",\"s\",\"s\",\"r\",\"s\",\"s\",\"f\",\"f\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"f\",\".\",\"f\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"f\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":3,\"y\":10,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":10,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":11,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":11,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":84,\"Furniture\":15,\"Rug\":8},\"stats\":{\"walkable\":107,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":0.77,\"waterPct\":0}},\"96\":{\"num\":96,\"w\":9,\"h\":8,\"heights\":[[null,null,null,null,null,0,0,null,null],[2,1,3,0,0,0,0,3,1],[1,0,0,0,0,0,0,0,1],[null,2,null,0,1,1,1,0,1],[null,0,2,0,0,0,0,0,0],[null,0,2,0,0,0,0,0,0],[0,0,2,0,0,1,0,null,0],[null,null,null,4,0,1,0,0,0]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\"b\",\"b\",\".\",\".\"],[\"b\",\"b\",\"f\",\"b\",\"b\",\"b\",\"b\",\"f\",\"f\"],[\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\",\"f\"],[\".\",\"o\",\".\",\"b\",\"f\",\"f\",\"f\",\"b\",\"f\"],[\".\",\"n\",\"o\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\".\",\"n\",\"o\",\"b\",\"b\",\"b\",\"b\",\"b\",\"b\"],[\"n\",\"n\",\"o\",\"b\",\"b\",\"f\",\"b\",\".\",\"b\"],[\".\",\".\",\".\",\"f\",\"b\",\"f\",\"b\",\"b\",\"b\"]],\"starts\":[{\"x\":1,\"y\":4,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Brick\":35,\"Furniture\":11,\"Wooden floor\":4,\"Natural Surface\":4,\"Box\":3},\"stats\":{\"walkable\":57,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":0.53,\"waterPct\":0}},\"97\":{\"num\":97,\"w\":11,\"h\":13,\"heights\":[[9,7,0,0,0,0,0,0,0,0,0],[9,7,0,0,0,0,0,0,0,0,0],[9,7,5,0,0,0,0,0,0,0,0],[10,10,8,0,0,0,0,0,0,0,0],[10,10,8,0,0,0,0,0,0,0,0],[10,10,8,0,0,0,0,0,0,0,0],[null,null,0,0,0,0,0,0,0,0,0],[9,9,0,0,0,0,0,0,0,0,0],[null,17,null,0,0,0,0,null,17,null,0],[17,17,17,0,0,0,0,17,17,17,0],[null,17,null,0,0,0,0,null,17,null,null],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0]],\"surfaces\":[[\"r\",\"r\",\"n\",\"n\",\"g\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"n\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"r\",\"g\",\"g\",\"n\",\"n\",\"n\",\"n\",\"n\",\"g\"],[\"r\",\"r\",\"r\",\"g\",\"n\",\"n\",\"g\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"r\",\"g\",\"n\",\"n\",\"g\",\"n\",\"g\",\"g\",\"n\"],[\".\",\".\",\"g\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\",\"n\"],[\"s\",\"s\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\".\",\"s\",\".\",\"s\",\"s\",\"n\",\"n\",\".\",\"s\",\".\",\"g\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"n\",\"s\",\"s\",\"s\",\"g\"],[\".\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\".\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":2,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Natural Surface\":44,\"Stone floor\":43,\"Grassland\":29,\"Roof\":16},\"stats\":{\"walkable\":132,\"maxHeight\":17,\"minHeight\":0,\"spread\":17,\"avgHeight\":2.46,\"waterPct\":0}},\"98\":{\"num\":98,\"w\":12,\"h\":11,\"heights\":[[null,6,4,2,0.5,0,0.5,2,4,5.5,6,6],[null,23,null,2,0.5,0,0.5,2,4,5.5,6,6],[23,23,23,0.5,0.5,0,0.5,2,4,5.5,6,6],[null,23,null,6,6,6,6,6,6,6,6,6],[4,4,4,4,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,4,4],[null,23,null,6,6,6,6,6,6,6,6,6],[23,23,23,0.5,0,0,0.5,2,4,5.5,6,6],[null,23,null,0.5,0,0,0.5,2,4,5.5,6,6]],\"surfaces\":[[\".\",\"g\",\"g\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\".\",\"s\",\".\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"s\",\"s\",\"s\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\".\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\".\",\"s\",\".\",\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":11,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":11,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":76,\"Grassland\":38,\"Natural Surface\":9},\"stats\":{\"walkable\":123,\"maxHeight\":23,\"minHeight\":0,\"spread\":23,\"avgHeight\":5.42,\"waterPct\":0}},\"99\":{\"num\":99,\"w\":12,\"h\":16,\"heights\":[[null,null,0,0,0,0,0,0,0,0,0,0],[null,null,0,0,0,0,0,0,0,0,0,0],[4,3,2,1,0,0,0,0,0,0,0,0],[4,3,2,1,0,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,0,0,0,0],[0,0,null,null,null,0,0,0,0,0,0,0],[0,0,null,null,null,0,0,0,0,0,0,0],[null,null,null,null,0,0,0,0,0,0,0,0],[null,null,null,null,0,0,0,0,0,0,0,0],[null,null,null,null,null,0,0,0,0,0,0,0],[0,0,null,null,null,0,0,0,0,0,0,0],[0,0,null,null,null,0,0,0,0,0,0,0],[0,0,null,null,null,0,0,0,0,0,0,0]],\"surfaces\":[[\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"s\",\"s\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"s\",\"s\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\".\",\".\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"s\",\"s\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"s\",\"s\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"],[\"s\",\"s\",\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\"]],\"starts\":[{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":15,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":15,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":15,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":11,\"y\":15,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":2,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Road\":130,\"Stone floor\":10},\"stats\":{\"walkable\":140,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":0.14,\"waterPct\":0}},\"100\":{\"num\":100,\"w\":15,\"h\":15,\"heights\":[[0,0,0,1,3,0.5,0.5,1,1.5,2,2.5,3,3,3,3],[0,0,0,0,0,0.5,2,4,1.5,null,2.5,3,4,6,3],[0,0,1,2,0,0.5,1,1,1.5,1.5,2.5,2.5,2.5,3,3],[0,0,0,0,0.5,0.5,1,1,1,1.5,2,2,2.5,3,3],[0,0,0,0,0.5,1,1,1,1,1.5,2,2,2.5,3,3],[0,0,0,0,0.5,1,1,1,1,1.5,2.5,2.5,2.5,3,3],[0,0,0,0,0.5,1,1,3,null,1,2.5,3,3,3,3],[0,0,1,3,0.5,1,1,1,1,1,2.5,3,3,null,3],[0,0,0,0.5,0.5,1,1,1,1,2.5,2.5,3,3.5,3.5,3.5],[0,0,0,0.5,1,1,1,1,1,2.5,4,6,3.5,4,4],[0,1,3,0.5,1,1,1,1,2.5,2.5,3,3.5,3.5,4,4],[0,0,0,0.5,0.5,2,3,1,2.5,4,6,3.5,4,4,4],[0,0,0,0,0.5,1,1,1,2.5,3,3,3.5,4,5,6],[0,1,3,0,0.5,1,null,1,2.5,3,3,3.5,4,4,4],[0,0,0,0,0.5,1,1,1,2.5,3,3,3.5,4,4,4]],\"surfaces\":[[\"g\",\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"t\",\"g\",\".\",\"g\",\"g\",\"t\",\"t\",\"g\"],[\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\",\"g\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"g\"],[\"s\",\"s\",\"s\",\"g\",\"g\",\"s\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"s\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"s\",\"s\",\"c\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"g\"],[\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"t\",\"t\"],[\"g\",\"t\",\"t\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":6,\"y\":14,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":14,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":14,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":14,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":173,\"Stone floor\":25,\"Tombstone\":22,\"Coffin\":1},\"stats\":{\"walkable\":221,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":1.71,\"waterPct\":0}},\"101\":{\"num\":101,\"w\":11,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,1,1,1],[2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5],[3,3,3,3,3,3,3,3,3,3,3],[3,3,3,3,3,3,3,3,3,3,3],[3,3,3,3,3,3,3,3,3,3,3],[3,3,3,3,3,3,3,3,3,3,3],[3,3,3,3,3,3,3,3,3,3,3],[2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5,2.5],[1,1,1,1,1,1,1,1,1,1,1],[0,0,0,0,0,0,0,0,0,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":10,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":10,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":77,\"Sea\":44},\"stats\":{\"walkable\":121,\"maxHeight\":3,\"minHeight\":0,\"spread\":3,\"avgHeight\":2,\"waterPct\":0}},\"102\":{\"num\":102,\"w\":11,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,0,0,0,0],[1,1,1,1,1,1,1,0,0,0,0],[2,2,2,2,2,2,2,0,0,0,0],[3,3,3,3,3,3,3,0,0,0,0],[5,5,5,5,5,5,5,0,0,0,0],[7,7,7,7,7,7,7,0,0,0,0],[9,9,9,9,9,9,9,0,0,0,9],[9,9,9,9,9,9,9,0,0,0,9]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":7,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":0,\"y\":10,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":10,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":9,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":121},\"stats\":{\"walkable\":121,\"maxHeight\":9,\"minHeight\":0,\"spread\":9,\"avgHeight\":2.29,\"waterPct\":0}},\"103\":{\"num\":103,\"w\":8,\"h\":10,\"heights\":[[4,4,3.5,3,3,4,4,null],[4,4,3,3,null,null,null,null],[3.5,3,2.5,4,null,null,null,null],[3,2,2,5,null,null,null,null],[2.5,2,2,6,11.5,11.5,11.5,null],[2,2,3,7,7,7,7,7],[2,2,6,7,7,7,7,5],[1.5,1.5,5,6,7,7,5,5],[1,1,5,5,1,1,5,3],[1,1,0.5,0,0,0,0,0]],\"surfaces\":[[\"g\",\"g\",\"g\",\"n\",\"n\",\"g\",\"g\",\".\"],[\"g\",\"g\",\"g\",\"n\",\".\",\".\",\".\",\".\"],[\"g\",\"g\",\"n\",\"g\",\".\",\".\",\".\",\".\"],[\"g\",\"g\",\"n\",\"g\",\".\",\".\",\".\",\".\"],[\"n\",\"n\",\"n\",\"g\",\"r\",\"r\",\"r\",\".\"],[\"n\",\"n\",\"g\",\"g\",\"g\",\"s\",\"g\",\"g\"],[\"g\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"n\"],[\"g\",\"n\",\"g\",\"b\",\"b\",\"b\",\"g\",\"g\"],[\"g\",\"g\",\"g\",\"b\",\"s\",\"g\",\"r\",\"r\"],[\"g\",\"g\",\"g\",\"n\",\"g\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":3,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":4,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":38,\"Natural Surface\":17,\"Brick\":4,\"Roof\":3,\"Stone floor\":2,\"Rocky cliff\":2},\"stats\":{\"walkable\":66,\"maxHeight\":11.5,\"minHeight\":0,\"spread\":11.5,\"avgHeight\":3.92,\"waterPct\":0}},\"104\":{\"num\":104,\"w\":9,\"h\":8,\"heights\":[[null,null,0,0,0,0,null,null,null],[null,0,0,0,0,0,null,null,null],[null,0,0,0,0,0,null,null,null],[0,0,0,2,0,0,null,null,null],[0,0,0,2,0,0,null,null,null],[0,0,0,0,0,0,null,null,null],[null,0,0,0,0,0,null,null,null],[null,null,0,0,null,0,null,null,null]],\"surfaces\":[[\".\",\".\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\"r\",\"r\",\"r\",\"f\",\"r\",\"r\",\".\",\".\",\".\"],[\"r\",\"r\",\"r\",\"f\",\"r\",\"r\",\".\",\".\",\".\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\".\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\".\",\".\",\"r\",\"r\",\".\",\"r\",\".\",\".\",\".\"]],\"starts\":[{\"x\":4,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Rug\":35,\"Furniture\":2},\"stats\":{\"walkable\":40,\"maxHeight\":2,\"minHeight\":0,\"spread\":2,\"avgHeight\":0.11,\"waterPct\":0}},\"105\":{\"num\":105,\"w\":12,\"h\":9,\"heights\":[[2,2,1,2,2,3,4,6,6,7,9,12],[1,3,3,5,4,5,7,7,8,11,10,10],[1,1,2,3,4,6,7,6,10,11,10,11],[3,2,2,3,5,5,5,6,8,9,10,13],[0,2,3,3,5,6,5,9,8,10,12,13],[0,3,4,4,6,6,7,8,8,9,11,12],[2,3,3,7,6,6,7,7,7,9,9,12],[2,2,3,5,5,7,7,8,7,11,10,11],[1,1,3,5,4,4,5,5,6,8,8,9]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"m\",\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"m\",\"s\",\"s\",\"r\",\"r\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"m\",\"m\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"m\",\"s\",\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"m\",\"s\",\"s\",\"m\",\"m\",\"m\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":5,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":0,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":8,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":89,\"Moss\":12,\"Rocky cliff\":7},\"stats\":{\"walkable\":108,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":5.94,\"waterPct\":0}},\"106\":{\"num\":106,\"w\":16,\"h\":10,\"heights\":[[1,1,1,0,0,0,0,1,null,null,null,null,0,null,null,null],[2,1,0,0,0,1.5,2,0.5,null,0.5,null,null,0,1,0,null],[1.5,null,null,0,1,1,4,null,null,1,2,0,0,0,0,null],[0,null,null,null,1,null,null,null,null,null,3,0,0,0,0,0],[0,0,0,null,0,null,0,0,null,null,0,0,0,0,1,1],[0,0,0,null,null,null,null,0,0,1,0,null,1.5,2,1,1],[0,0,0,null,null,null,0,2.5,0,1,1,null,null,null,0,1],[null,null,null,null,0,0,4.5,6,0,0,null,null,null,0,0,null],[0.5,null,null,0,0,0,2,0,0,0,null,null,null,0,0,null],[1,0,0,0,0,null,null,0,0,0,null,null,0.5,1,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\".\",\".\",\".\",\".\",\"r\",\".\",\".\",\".\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\".\",\"s\",\".\",\".\",\"r\",\"s\",\"r\",\".\"],[\"s\",\".\",\".\",\"r\",\"s\",\"s\",\"s\",\".\",\".\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\".\"],[\"r\",\".\",\".\",\".\",\"s\",\".\",\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\".\",\"s\",\".\",\"r\",\"r\",\".\",\".\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"s\",\"r\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\".\",\".\",\".\",\"r\",\"s\",\"r\",\"s\",\"s\",\".\",\".\",\".\",\"r\",\"s\"],[\".\",\".\",\".\",\".\",\"r\",\"r\",\"s\",\"s\",\"r\",\"r\",\".\",\".\",\".\",\"r\",\"r\",\".\"],[\"s\",\".\",\".\",\"r\",\"r\",\"r\",\"s\",\"r\",\"r\",\"r\",\".\",\".\",\".\",\"r\",\"r\",\".\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\"r\",\"r\",\"r\",\".\",\".\",\"s\",\"s\",\"r\",\"r\"]],\"starts\":[{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":14,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":15,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":12,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Rocky cliff\":65,\"Stalactite\":38},\"stats\":{\"walkable\":103,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":0.55,\"waterPct\":0}},\"107\":{\"num\":107,\"w\":10,\"h\":10,\"heights\":[[0,0,1,1,1,1,1,3,3,2],[0,1,1,1,1,2,2,2,3,3],[0,1,7,7,7,6,6,5,4.5,3],[9,8.5,8,7,7,7,6,6,7,7],[9,10,10,11,13,13,15,16,16,17],[10,10,11.5,12,13,14,16,16,17,17],[20,20,18,18,16,14,16,16,18,17],[21.5,20,19.5,18,18,17,18,24,24,24],[22,24,24,24,24,24,24,24,24,24],[22,23,23,24,24,24,24,24,23,23]],\"surfaces\":[[\"m\",\"m\",\"s\",\"s\",\"m\",\"m\",\"m\",\"m\",\"m\",\"m\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"m\",\"m\",\"m\",\"m\",\"m\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"m\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"m\",\"m\"],[\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"m\",\"m\",\"s\",\"r\",\"r\",\"m\",\"m\"],[\"m\",\"s\",\"s\",\"m\",\"m\",\"m\",\"s\",\"m\",\"m\",\"m\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"m\",\"m\",\"s\",\"s\"]],\"starts\":[{\"x\":9,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":60,\"Moss\":29,\"Rocky cliff\":11},\"stats\":{\"walkable\":100,\"maxHeight\":24,\"minHeight\":0,\"spread\":24,\"avgHeight\":12.63,\"waterPct\":0}},\"108\":{\"num\":108,\"w\":13,\"h\":14,\"heights\":[[null,null,null,null,null,null,null,null,null,3,3,5,5],[null,null,null,null,null,null,null,null,3,3,4,5,6],[null,null,null,null,null,null,null,null,4,4,4,7,9],[null,null,null,null,null,null,null,null,4,4,null,10,10],[null,null,null,null,null,null,null,null,3,4,11,11,10],[null,null,null,null,null,null,null,3,3,4,11,11,10],[null,null,null,null,3,3,3,3,3,null,11,11,11],[null,null,3,3,3,3,3,null,11,11,11,11,11],[null,3,3,3,null,11,11,11,11,11,11,11,11],[null,3,3,null,11,11,11,11,11,11,11,11,9],[null,3,3,10,11,11,11,11,11,11,9,null,null],[3,3,null,11,11,11,11,8,null,null,null,null,null],[3,3,11,11,11,11,11,null,null,null,null,null,null],[3,3,11,11,11,11,8,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\".\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\"],[\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"r\",\"s\",\"s\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\".\",\"s\",\"s\",\"s\",\".\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\".\",\"s\",\"s\",\".\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\"],[\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"r\",\".\",\".\",\".\",\".\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":4,\"y\":13,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":12,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":12,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":13,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":11,\"y\":3,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":12,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":3,\"y\":13,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":71,\"Rocky cliff\":29},\"stats\":{\"walkable\":100,\"maxHeight\":11,\"minHeight\":3,\"spread\":8,\"avgHeight\":7.6,\"waterPct\":0}},\"109\":{\"num\":109,\"w\":15,\"h\":9,\"heights\":[[2,2,2,2,3,3,3,2,2,2,2,2,3,3,3],[2,2,2,4,4,3,3,2,2,2,3,4,4,3,3],[2,2,7,null,4,4,null,7,3,3,3,4,4,4,4],[2,2,7,9,5,5,7,7,6,3,null,12,12,10,10],[2,3,5,10,12,11,7,7,6,4,13,12,12,10,10],[0,3,3,10,13,13,11.5,7,7,12,13,12,9,9,10],[0,null,3,3,3,null,9,2,2,2,null,8,7,0,0],[0,0,3,3,3,2.5,2.5,2,2,1,1,0.5,0,0,0],[0,0,null,3,2.5,2.5,2,2,2,1,1,0.5,0.5,0,0]],\"surfaces\":[[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\"],[\"r\",\"s\",\"s\",\".\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\".\",\"r\",\"r\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"r\",\"s\",\"s\"],[\"r\",\"s\",\"s\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\"],[\"r\",\"r\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\"]],\"starts\":[{\"x\":13,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":14,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":14,\"y\":1,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":14,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":101,\"Rocky cliff\":27},\"stats\":{\"walkable\":128,\"maxHeight\":13,\"minHeight\":0,\"spread\":13,\"avgHeight\":4.38,\"waterPct\":0}},\"110\":{\"num\":110,\"w\":16,\"h\":11,\"heights\":[[null,null,null,null,null,4,4,3,null,null,null,null,null,8,9,9],[null,null,null,null,null,4,5,5,5,null,null,null,null,9,9,9],[null,null,null,null,4,4,5,5,5,null,null,null,null,9,9,9],[null,null,null,null,4,4,4,5,5,null,null,null,8,8,8,null],[1,1,null,null,4,null,null,5,5,5,null,null,8,8,null,null],[1,1,null,3,3,null,null,5,6,6,null,null,8,8,null,null],[1,1,null,3,3,null,null,6,6,6,null,null,8,8,null,null],[1,1,2,3,3,null,null,null,6,6,6,7,7,7,null,null],[1,2,2,3,3,null,null,null,6,6,7,7,7,null,null,null],[null,2,2,2,null,null,null,null,6,6,7,7,5,null,null,null],[null,null,null,null,null,null,null,null,null,4,4,5,5,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"r\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\",\"s\",\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\"],[\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\",\"s\",\"s\",\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\"],[\".\",\".\",\".\",\".\",\"s\",\"r\",\"r\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\"],[\"r\",\"m\",\".\",\".\",\"s\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\"r\",\"s\",\".\",\".\"],[\"m\",\"m\",\".\",\"s\",\"s\",\".\",\".\",\"s\",\"r\",\"r\",\".\",\".\",\"r\",\"s\",\".\",\".\"],[\"r\",\"r\",\".\",\"s\",\"s\",\".\",\".\",\"s\",\"r\",\"r\",\".\",\".\",\"s\",\"s\",\".\",\".\"],[\"r\",\"r\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\"],[\"r\",\"s\",\"s\",\"m\",\"s\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"s\",\"s\",\".\",\".\",\".\"]],\"starts\":[{\"x\":15,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":15,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":14,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":14,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":59,\"Rocky cliff\":25,\"Moss\":4},\"stats\":{\"walkable\":88,\"maxHeight\":9,\"minHeight\":1,\"spread\":8,\"avgHeight\":5.08,\"waterPct\":0}},\"111\":{\"num\":111,\"w\":7,\"h\":12,\"heights\":[[1,1,0,0,1,1,1],[0,0,0,0,0,1,1],[0,0,1,1,0,0,0],[2,2,2,1,1,0,0],[2,2,2,10,10,0,0],[2,5,17,16,13,13,13],[3,5,17,17,17,13,13],[6,6,17,18,18,12,12],[6,7,18,18,18,12,12],[7,7,10,10,11,11,11],[7,9,10,10,10,11,11],[7,9,9,10,10,11,11]],\"surfaces\":[[\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\"],[\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"s\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"s\",\"s\",\"r\"],[\"s\",\"s\",\"r\",\"r\",\"r\",\"r\",\"r\"],[\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"s\"]],\"starts\":[{\"x\":5,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":10,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":10,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":48,\"River\":36},\"stats\":{\"walkable\":84,\"maxHeight\":18,\"minHeight\":0,\"spread\":18,\"avgHeight\":7.01,\"waterPct\":0}},\"112\":{\"num\":112,\"w\":11,\"h\":10,\"heights\":[[0,0,0,1,1,null,4,4,4,5,5],[0,0,0,0,1,null,4,4,4,5,5],[0,0,0,0,1,null,4,4,5,5,5],[0,0,null,2,2,null,4,4,null,6,5],[0,1,null,2,2,null,4,4,null,6,6],[1,1,null,2,2,null,4,4,null,6,6],[1,1,null,2,2,null,4,4,null,6,5],[1,0,null,2,2,2,3,4,null,5,5],[0,0,null,2,2,3,3,4,null,5,5],[0,0,null,2,2,3,3,3,null,5,5]],\"surfaces\":[[\"r\",\"r\",\"r\",\"m\",\"m\",\".\",\"s\",\"r\",\"r\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"m\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"r\",\"m\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\".\",\"s\",\"s\",\".\",\"r\",\"r\",\".\",\"s\",\"s\"],[\"r\",\"s\",\".\",\"s\",\"s\",\".\",\"r\",\"s\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"s\",\"s\",\".\",\"r\",\"s\",\".\",\"s\",\"s\"],[\"s\",\"s\",\".\",\"s\",\"s\",\".\",\"s\",\"s\",\".\",\"s\",\"r\"],[\"s\",\"r\",\".\",\"s\",\"s\",\"s\",\"m\",\"s\",\".\",\"r\",\"r\"],[\"r\",\"r\",\".\",\"s\",\"s\",\"m\",\"m\",\"s\",\".\",\"r\",\"r\"],[\"r\",\"r\",\".\",\"s\",\"s\",\"r\",\"m\",\"m\",\".\",\"r\",\"r\"]],\"starts\":[{\"x\":1,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":8,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":9,\"y\":9,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":0,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":47,\"Rocky cliff\":33,\"Moss\":9},\"stats\":{\"walkable\":89,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":2.71,\"waterPct\":0}},\"113\":{\"num\":113,\"w\":12,\"h\":10,\"heights\":[[null,null,4,5,5,6,6,6,7,7,7,null],[null,null,4,5,5,5,6,6,7,7,7,7],[null,null,null,null,null,3,3,1,1,1,7,8],[2,2,null,null,null,3,3,null,1,1,7,8],[2,2,2,9,9,9,3,9,8,2,8,8],[1,2,2,9,9,9,3,9,2,2,8,8],[1,2,null,9,9,2,2,null,null,2,2,2],[1,1,null,9,9,2,2,1,1,2,2,1],[1,1,1,1,2,2,1,1,1,1,1,1],[null,null,1,1,1,1,1,1,null,null,null,null]],\"surfaces\":[[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\"],[\"s\",\"m\",\".\",\".\",\".\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"s\"],[\"m\",\"m\",\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"m\"],[\"m\",\"m\",\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"m\"],[\"m\",\"m\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\"m\",\"m\",\"m\"],[\"m\",\"m\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"m\",\"m\",\"m\",\"m\"],[\"m\",\"m\",\"m\",\"s\",\"s\",\"s\",\"s\",\"s\",\"m\",\"m\",\"m\",\"m\"],[\".\",\".\",\"m\",\"m\",\"m\",\"m\",\"m\",\"m\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":9,\"y\":3,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":60,\"Moss\":33,\"Rocky cliff\":3},\"stats\":{\"walkable\":96,\"maxHeight\":9,\"minHeight\":1,\"spread\":8,\"avgHeight\":3.96,\"waterPct\":0}},\"114\":{\"num\":114,\"w\":13,\"h\":13,\"heights\":[[null,null,null,null,null,6,6,6,null,null,null,null,null],[null,null,null,5,6,6,6,6,5,5,null,null,null],[null,null,8,8,7,7,6,5,5,5,5,null,null],[null,9,9,8,8,7,null,5,5,3,3,3,null],[null,9,9,9,null,null,null,null,null,3,3,3,null],[11,11,9,null,null,null,null,null,null,3,3,2,2],[11,11,9,null,null,null,null,null,null,null,2,2,2],[11,12,12,12,null,null,null,null,null,1,1,1,2],[null,12,12,12,null,null,null,null,null,1,1,1,null],[null,12,12,13,13,13,null,null,null,1,1,1,null],[null,null,13,13,13,15,15,15,null,null,null,null,null],[null,null,null,13,13,15,15,15,null,null,null,null,null],[null,null,null,null,null,15,15,15,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"r\",\"s\",\"s\",\"s\",\".\",\".\",\".\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"r\",\"s\",\"s\",\".\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"r\",\"s\",\"r\",\"r\",\"s\",\".\"],[\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"s\",\".\"],[\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"r\",\"s\"],[\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"r\"],[\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"r\",\"r\"],[\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\"r\",\"r\",\"r\",\".\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\"r\",\"r\",\"r\",\".\"],[\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":9,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":12,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":12,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":9,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":11,\"y\":9,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":5,\"y\":12,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":11,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":8,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stalactite\":59,\"Rocky cliff\":25},\"stats\":{\"walkable\":84,\"maxHeight\":15,\"minHeight\":1,\"spread\":14,\"avgHeight\":7.67,\"waterPct\":0}},\"115\":{\"num\":115,\"w\":8,\"h\":11,\"heights\":[[2,2,2,2,2,2,2,2],[7,null,null,null,null,2.5,2.5,2],[8.5,10.5,10.5,10,null,3.5,3.5,2],[9,10,9.5,10,null,5,5,2],[7.5,10,8,10,null,7,7,2],[6,10,10,10,9.5,8.5,8.5,2],[5,5,10,10,9.5,9,8.5,2],[4,3,2.5,2,2,2,2,2],[2,2,1,1.5,1.5,null,null,null],[1,0.5,0,0,0.5,0.5,0.5,1],[0.5,0.5,0,0,0,0,0.5,1]],\"surfaces\":[[\"g\",\"g\",\"g\",\"g\",\"g\",\"n\",\"n\",\"n\"],[\"r\",\".\",\".\",\".\",\".\",\"n\",\"r\",\"n\"],[\"r\",\"n\",\"n\",\"g\",\".\",\"n\",\"r\",\"n\"],[\"o\",\"g\",\"n\",\"n\",\".\",\"n\",\"r\",\"n\"],[\"o\",\"g\",\"n\",\"g\",\".\",\"n\",\"g\",\"n\"],[\"o\",\"r\",\"g\",\"n\",\"g\",\"n\",\"r\",\"n\"],[\"r\",\"r\",\"g\",\"r\",\"n\",\"n\",\"g\",\"n\"],[\"r\",\"r\",\"r\",\"g\",\"n\",\"n\",\"n\",\"n\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\".\",\".\",\".\"],[\"g\",\"g\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\"],[\"g\",\"g\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":9,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":9,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":6,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":7,\"y\":10,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Natural Surface\":31,\"Grassland\":26,\"Rocky cliff\":18,\"Wooden floor\":3},\"stats\":{\"walkable\":78,\"maxHeight\":10.5,\"minHeight\":0,\"spread\":10.5,\"avgHeight\":4.33,\"waterPct\":0}},\"116\":{\"num\":116,\"w\":11,\"h\":11,\"heights\":[[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":5,\"y\":9,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":8,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":8,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":8,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":9,\"y\":5,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":121},\"stats\":{\"walkable\":121,\"maxHeight\":0,\"minHeight\":0,\"spread\":0,\"avgHeight\":0,\"waterPct\":0}},\"117\":{\"num\":117,\"w\":8,\"h\":12,\"heights\":[[0,0,0,0,1,10,0.5,0],[0,0,0,0.5,1,10,1,0],[0,0,0,1,3,12,2,0],[0,0,0,2,3,12,3,0],[0,0.5,10,3,4,12,4.5,0],[0,0.5,10,3,5,10,6,0],[0,0.5,10,4.5,6,10,0,0],[0,0.5,10,6,7,10,2,0],[0,1,10,6,8,10,4,0],[0,1,10,6,8,10,0.5,1],[0,1,10,8,10,10,1,2],[0,1,10,10,10,11,1.5,3]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":5,\"y\":5,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":5,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":2,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":5,\"y\":7,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Natural Surface\":96},\"stats\":{\"walkable\":96,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":3.76,\"waterPct\":0}},\"118\":{\"num\":118,\"w\":14,\"h\":15,\"heights\":[[null,2,1,1,2,1,0,null,0,0,1,2,2,1],[1,2,2,1,1,1,1,1,1,1,2,2,2,1],[1,2,2,1,2,1,2,1,1,2,1,2,null,0],[0,1,1,1,3,3,3,1,1,1,1,1,0,0],[0,0,2,null,2.5,2.5,2.5,2.5,2,2,2,2,1,0],[0,1,1,3,2.5,2,1,1,2,2,2,2,2,1],[0,1,3.5,3,1,1,0,0,1,1,2,2,2,1],[1,4,3.5,3,2,3,1,1,null,1,2.5,null,2,1],[1,4,3.5,2.5,2,3,2.5,2.5,2.5,3,2.5,null,2,2],[1,1,3.5,2.5,2.5,3,2.5,2,2.5,3,1,2,2,1],[1,null,null,2.5,3,3,2.5,2.5,2.5,1,1,2,1,0],[0,null,null,2.5,3,1,1,3,3,1,1,1,1,1],[0,0,1,1,2,1,1,1,1,1,null,1,2.5,3],[0,0,0,1,1,1,1,2,2,1,2.5,2.5,2.5,3],[0,0,0,0,0,0,1,1,null,3,3,3,3,3]],\"surfaces\":[[\".\",\"g\",\"p\",\"p\",\"w\",\"p\",\"P\",\".\",\"p\",\"p\",\"p\",\"g\",\"g\",\"p\"],[\"p\",\"g\",\"g\",\"p\",\"p\",\"p\",\"p\",\"p\",\"P\",\"p\",\"w\",\"w\",\"g\",\"p\"],[\"p\",\"g\",\"g\",\"p\",\"w\",\"p\",\"w\",\"p\",\"p\",\"w\",\"p\",\"w\",\".\",\"p\"],[\"p\",\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"w\",\"p\",\"p\",\"p\",\"p\",\"p\",\"p\"],[\"P\",\"p\",\"w\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"P\"],[\"p\",\"p\",\"p\",\"g\",\"g\",\"g\",\"P\",\"P\",\"w\",\"g\",\"g\",\"g\",\"g\",\"p\"],[\"p\",\"p\",\"g\",\"g\",\"P\",\"P\",\"P\",\"P\",\"P\",\"P\",\"g\",\"g\",\"g\",\"p\"],[\"p\",\"g\",\"g\",\"g\",\"P\",\"w\",\"P\",\"P\",\".\",\"P\",\"g\",\".\",\"g\",\"p\"],[\"p\",\"g\",\"g\",\"g\",\"P\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"p\"],[\"p\",\"p\",\"g\",\"g\",\"g\",\"g\",\"g\",\"P\",\"g\",\"g\",\"p\",\"g\",\"g\",\"p\"],[\"p\",\".\",\".\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"p\",\"w\",\"w\",\"P\",\"p\"],[\"p\",\".\",\".\",\"w\",\"g\",\"p\",\"p\",\"g\",\"g\",\"p\",\"p\",\"p\",\"p\",\"p\"],[\"p\",\"p\",\"p\",\"P\",\"w\",\"p\",\"p\",\"p\",\"p\",\"p\",\".\",\"p\",\"w\",\"g\"],[\"p\",\"p\",\"p\",\"p\",\"p\",\"p\",\"P\",\"g\",\"g\",\"p\",\"w\",\"w\",\"g\",\"g\"],[\"p\",\"p\",\"p\",\"P\",\"p\",\"p\",\"p\",\"p\",\".\",\"w\",\"g\",\"g\",\"g\",\"g\"]],\"starts\":[{\"x\":7,\"y\":11,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":10,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":3,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":3,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":8,\"y\":10,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Marsh\":83,\"Grassland\":70,\"Poisoned marsh\":22,\"Wasteland\":19,\"Gravel\":3},\"stats\":{\"walkable\":197,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":1.57,\"waterPct\":42.1}},\"119\":{\"num\":119,\"w\":15,\"h\":10,\"heights\":[[7.5,7,6,0,0,0,0,0,0,0,0,3.5,4.5,5,5.5],[8,7,6,2,2,0,0,0,0,0,2,2.5,null,5.5,5.5],[8,8,4,3,2.5,0,0,0,0,0,2,2,null,5.5,6.5],[9,9,3,3,3,0,0,0,1.5,2.5,3,3,6.5,6.5,7],[9,3,1,0,0,0,0,0,0,0,3,3,7,7.5,7.5],[9,8.5,null,0,3,2,null,null,0,0,0,null,7.5,null,9],[9,8.5,8,0,0,0,8,8,0,0,0,8,8,8,8],[9,8.5,8,0,0,0,8,8,0,0,0,8,8,8,8],[8.5,9,null,0,0,0,null,null,1.5,0,0,null,null,null,7.5],[8,8.5,9,5.5,0,1,0,0,2,2,0,0,4,6,7]],\"surfaces\":[[\"d\",\"d\",\"d\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"l\",\"l\",\"l\",\"l\",\"l\",\"d\",\"d\",\".\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"l\",\"l\",\"l\",\"l\",\"l\",\"d\",\"d\",\".\",\"d\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"d\",\"l\",\"l\",\"l\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"w\",\"g\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"l\",\"d\",\"d\",\"d\",\"d\",\"d\"],[\"d\",\"d\",\".\",\"l\",\"w\",\"w\",\".\",\".\",\"l\",\"l\",\"l\",\".\",\"s\",\".\",\"d\"],[\"d\",\"d\",\"s\",\"l\",\"l\",\"l\",\"s\",\"s\",\"l\",\"l\",\"l\",\"s\",\"s\",\"s\",\"s\"],[\"d\",\"d\",\"s\",\"l\",\"l\",\"l\",\"s\",\"s\",\"l\",\"l\",\"l\",\"s\",\"s\",\"s\",\"s\"],[\"d\",\"d\",\".\",\"l\",\"l\",\"l\",\".\",\".\",\"w\",\"l\",\"l\",\".\",\".\",\".\",\"d\"],[\"d\",\"d\",\"d\",\"d\",\"l\",\"w\",\"l\",\"l\",\"w\",\"w\",\"l\",\"l\",\"d\",\"d\",\"d\"]],\"starts\":[{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":1,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":6,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":9,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Sand area\":60,\"Lava\":47,\"Stone floor\":15,\"Lava rocks\":7,\"Wasteland\":7,\"Gravel\":1},\"stats\":{\"walkable\":137,\"maxHeight\":9,\"minHeight\":0,\"spread\":9,\"avgHeight\":3.54,\"waterPct\":34.3}},\"120\":{\"num\":120,\"w\":15,\"h\":11,\"heights\":[[9,10,10,8.5,7,6.5,5.5,4,4,4,4,null,4,4,4],[9,11,10,8.5,7,6.5,5.5,4,4,4,4,4,4,4,4],[9,11,10,9.5,7,6.5,5,0,3.5,2.5,2.5,3.5,4,4,4],[9,10,10,11.5,6.5,7,0,0,0,0,0,0,4,0.5,0.5],[8,9,10,12,5,0,0,0,0,0.5,0.5,0.5,0.5,0.5,0.5],[null,null,0,0,0,0,0,0,0.5,0.5,1,1,1,1,1],[null,null,null,0,0,0,0,0,0,0.5,1,4,5,1,1],[null,null,0,0,0,0,0,0,0,0.5,1,4,5,1,1],[6.5,6.5,8.5,8.5,6,0,0.5,0.5,0.5,0.5,1,1,1,1,1],[6.5,6,6,4,3.5,0,0.5,1,1,2.5,2.5,2.5,3,3,2.5],[5,5,5,4,4,3.5,2.5,1,2,2.5,3,3,3.5,null,4]],\"surfaces\":[[\"n\",\"n\",\"n\",\"r\",\"n\",\"n\",\"r\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\",\"g\",\"g\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"d\",\"d\",\"g\"],[\"n\",\"n\",\"n\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"d\",\"d\",\"d\"],[\"r\",\"r\",\"r\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"d\",\"d\"],[\"n\",\"n\",\"r\",\"r\",\"r\",\"g\",\"g\",\"g\",\"g\",\"d\",\"d\",\"g\",\"g\",\"d\",\"d\"],[\".\",\".\",\"p\",\"g\",\"g\",\"g\",\"g\",\"d\",\"g\",\"d\",\"d\",\"g\",\"g\",\"g\",\"g\"],[\".\",\".\",\".\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"r\",\"o\",\"R\",\"R\"],[\".\",\".\",\"p\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"R\",\"r\",\"o\",\"R\",\"R\"],[\"r\",\"r\",\"r\",\"r\",\"s\",\"g\",\"d\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\"],[\"r\",\"r\",\"r\",\"n\",\"n\",\"n\",\"n\",\"g\",\"g\",\"g\",\"g\",\"g\",\"g\",\".\",\"g\"]],\"starts\":[{\"x\":11,\"y\":8,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":3,\"y\":2,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":1,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":8,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":7,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Grassland\":66,\"Rocky cliff\":26,\"Snow\":22,\"Road\":20,\"Sand area\":15,\"Marsh\":2,\"Rug\":2,\"Wooden floor\":2,\"Stone wall\":1},\"stats\":{\"walkable\":156,\"maxHeight\":12,\"minHeight\":0,\"spread\":12,\"avgHeight\":3.39,\"waterPct\":1.3}},\"121\":{\"num\":121,\"w\":8,\"h\":18,\"heights\":[[null,null,null,4,5,4,4,4],[null,null,null,4,5,4,4,4],[null,null,null,null,null,null,4,4],[null,9,9,8,7,5,4,4],[null,9,9,9,9,9,4,4],[null,null,null,9,9,9,4,4],[null,10,9,9,5,4,4,4],[null,10,9,9,5,4,4,4],[null,null,null,9,9,9,4,4],[null,10,9,9,5,4,4,4],[null,10,9,9,5,4,4,4],[null,null,null,9,9,9,4,4],[null,null,null,8,7,5,4,4],[null,null,null,null,null,5,5,4],[null,null,null,null,4,4,5,4],[null,null,null,null,null,5,5,4],[null,7,6.5,5.5,4.5,4,4,4],[null,7,6.5,5.5,4.5,4,4,4]],\"surfaces\":[[\".\",\".\",\".\",\"s\",\"f\",\"s\",\"r\",\"r\"],[\".\",\".\",\".\",\"s\",\"f\",\"s\",\"r\",\"r\"],[\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"f\",\"s\",\"r\",\"f\",\"s\",\"r\",\"s\"],[\".\",\"f\",\"s\",\"r\",\"f\",\"s\",\"r\",\"s\"],[\".\",\".\",\".\",\"s\",\"f\",\"s\",\"s\",\"s\"],[\".\",\"f\",\"s\",\"r\",\"f\",\"s\",\"s\",\"s\"],[\".\",\"f\",\"s\",\"r\",\"f\",\"s\",\"r\",\"s\"],[\".\",\".\",\".\",\"s\",\"f\",\"s\",\"r\",\"s\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"f\",\"f\",\"s\"],[\".\",\".\",\".\",\".\",\"s\",\"s\",\"f\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"f\",\"f\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"]],\"starts\":[{\"x\":3,\"y\":3,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":12,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":6,\"y\":12,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":3,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":12,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":12,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":3,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":69,\"Furniture\":17,\"Rug\":12},\"stats\":{\"walkable\":98,\"maxHeight\":10,\"minHeight\":4,\"spread\":6,\"avgHeight\":5.9,\"waterPct\":0},\"source\":\"fftbg-ram\"},\"122\":{\"num\":122,\"w\":13,\"h\":16,\"heights\":[[6.5,6.5,6.5,5.5,5.5,5.5,9,5.5,5.5,5.5,5.5,5.5,5.5],[6.5,6,6.5,5.5,5,5,9,5,5,5,5,5,5.5],[6.5,6,6,5.5,5,5,9,5,5,5,5,5,5.5],[7,7,7,5.5,5,5,9,5,5,5.5,4,4,4],[8.5,8.5,8.5,5,5,5,9,4.5,4.5,5.5,2,2,2],[9.5,9,9,9.5,5,5.5,4.5,4,4.5,5.5,1,1,1.5],[9.5,14,14,9.5,5,5,4.5,4.5,4.5,5.5,1,1,1.5],[15,9.5,9.5,15,5.5,5.5,5.5,5.5,5.5,5.5,1.5,1.5,1.5],[null,null,null,null,null,6.5,6.5,6.5,null,null,null,null,null],[null,null,null,null,null,7.5,7.5,7.5,null,null,null,null,null],[null,null,null,null,null,8.5,8.5,8.5,null,null,null,null,null],[12.5,11.5,11,11,12,9.5,9.5,9.5,12,11,11,11,12],[11,11,11,11,11,11,11,11,11,11,11,11,11],[12,11,11,11,12,11,11,11,12,11,11,11,12],[0,12,11,11,11,11,11,11,11,11,11,12,0],[0,0,21,20,21,12,12,12,21,20,21,0,0]],\"surfaces\":[[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\"s\",\"d\",\"d\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\"s\",\"r\",\"r\",\"s\",\"d\",\"d\",\"d\",\"d\",\"d\",\"s\",\"d\",\"d\",\"s\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\",\".\"],[\"s\",\"n\",\"n\",\"n\",\"s\",\"M\",\"M\",\"M\",\"s\",\"n\",\"n\",\"n\",\"s\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"s\",\"n\",\"n\",\"n\",\"s\",\"n\",\"n\",\"n\",\"s\",\"n\",\"n\",\"n\",\"s\"],[\"n\",\"s\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"s\",\"n\"],[\"n\",\"n\",\"n\",\"r\",\"n\",\"n\",\"n\",\"n\",\"n\",\"r\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":5,\"y\":15,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":2,\"y\":4,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":3,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":14,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":10,\"y\":14,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":7,\"y\":3,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":10,\"y\":4,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":15,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"South\",\"layer\":false}],\"surfaces_hist\":{\"Sand area\":55,\"Stone wall\":47,\"Snow\":44,\"Machine\":12,\"Stone floor\":10,\"Natural Surface\":6,\"Roof\":4},\"stats\":{\"walkable\":178,\"maxHeight\":21,\"minHeight\":0,\"spread\":21,\"avgHeight\":7.8,\"waterPct\":0},\"source\":\"fftbg-ram\"},\"123\":{\"num\":123,\"w\":14,\"h\":16,\"heights\":[[null,null,null,null,null,null,null,null,null,null,null,null,null,null],[null,null,null,null,7,7,7,7,7,7,null,null,null,null],[null,null,null,null,7,null,null,null,null,7,null,null,null,null],[6,6,6,null,7,null,null,null,null,7,null,6,6,6],[12,6,6,7,8,5,5,5,5,8,7,6,6,12],[6,6,6,5.5,5,5,5,5,5,5,5.5,6,6,6],[6,6,6,5.5,5,5,5,5,5,5,5.5,6,6,6],[12,6,6,6,6,5.5,5,5,5.5,6,6,6,6,12],[6,6,6,null,6,null,5,5,null,6,null,6,6,6],[null,null,null,null,9,9,5,5,9,9,null,null,null,null],[null,null,null,null,null,null,5,5,null,null,null,null,null,null],[null,null,null,null,null,null,5,5,null,null,null,null,null,null],[7,null,null,null,null,null,5,5,null,null,null,null,null,7],[null,null,null,null,null,null,5,5,null,null,null,null,null,null],[null,null,null,null,null,5,5,5,5,null,null,null,null,null],[null,null,null,null,null,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\"M\",\"M\",\"M\",\"M\",\"M\",\"M\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\"M\",\".\",\".\",\".\",\".\",\"M\",\".\",\".\",\".\",\".\"],[\"s\",\"s\",\"s\",\".\",\"M\",\".\",\".\",\".\",\".\",\"M\",\".\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\"i\",\"M\",\"i\",\"i\",\"i\",\"i\",\"M\",\"i\",\"s\",\"s\",\"s\"],[\"i\",\"i\",\"i\",\"S\",\"i\",\"i\",\"i\",\"i\",\"i\",\"i\",\"S\",\"i\",\"i\",\"i\"],[\"i\",\"i\",\"i\",\"S\",\"i\",\"i\",\"i\",\"i\",\"i\",\"i\",\"S\",\"i\",\"i\",\"i\"],[\"s\",\"s\",\"s\",\"M\",\"M\",\"M\",\"i\",\"i\",\"M\",\"M\",\"M\",\"s\",\"s\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"i\",\".\",\"i\",\"i\",\".\",\"i\",\".\",\"s\",\"s\",\"s\"],[\".\",\".\",\".\",\".\",\"M\",\"i\",\"i\",\"i\",\"i\",\"M\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\",\".\"],[\"M\",\".\",\".\",\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\",\"M\"],[\".\",\".\",\".\",\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":13,\"y\":5,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":5,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":13,\"y\":6,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":5,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":1,\"y\":5,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Iron plate\":48,\"Stone floor\":28,\"Machine\":22,\"Stairs\":4},\"stats\":{\"walkable\":102,\"maxHeight\":12,\"minHeight\":5,\"spread\":7,\"avgHeight\":6.17,\"waterPct\":0},\"source\":\"fftbg-ram\"},\"124\":{\"num\":124,\"w\":16,\"h\":11,\"heights\":[[null,null,null,null,null,null,null,null,null,7,6,6,7,0,0,0],[null,null,null,null,null,null,null,null,null,7,6,6,7,0,0,0],[null,null,null,null,null,null,null,null,null,11,6,6,11,0,0,0],[6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,0],[6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,0],[6,6,6,6,6,6,6,6,6,6,6,null,6,6,6,0],[null,null,null,null,6,6,null,null,null,null,null,null,6,6,null,null],[null,6,6,6,6,8,6,6,6,null,null,6,6,6,8,6],[6,6,11,11,11,11,11,11,6,6,6,6,11,11,11,11],[6,6,11,11,11,11,11,11,6,6,6,6,11,11,11,11],[null,6,6,6,6,8,6,6,6,null,null,6,6,6,8,6]],\"surfaces\":[[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"n\",\"n\",\"n\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"n\",\"n\",\"n\"],[\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"n\",\"n\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"n\"],[\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\"s\",\"s\",\"s\",\"n\"],[\".\",\".\",\".\",\".\",\"o\",\"o\",\".\",\".\",\".\",\".\",\".\",\".\",\"o\",\"o\",\".\",\".\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"b\",\"o\",\"o\",\"o\",\".\",\".\",\"o\",\"o\",\"o\",\"b\",\"o\"],[\"o\",\"o\",\"i\",\"i\",\"i\",\"i\",\"i\",\"i\",\"o\",\"o\",\"o\",\"o\",\"i\",\"i\",\"i\",\"i\"],[\"o\",\"o\",\"i\",\"i\",\"i\",\"i\",\"i\",\"i\",\"o\",\"o\",\"o\",\"o\",\"i\",\"i\",\"i\",\"i\"],[\".\",\"o\",\"o\",\"o\",\"o\",\"b\",\"o\",\"o\",\"o\",\".\",\".\",\"o\",\"o\",\"o\",\"b\",\"o\"]],\"starts\":[{\"x\":13,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":7,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":4,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":14,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":13,\"y\":10,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":10,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":5,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":56,\"Wooden floor\":38,\"Iron plate\":20,\"Natural Surface\":12,\"Box\":4},\"stats\":{\"walkable\":130,\"maxHeight\":11,\"minHeight\":0,\"spread\":11,\"avgHeight\":6.38,\"waterPct\":0},\"source\":\"fftbg-ram\"},\"125\":{\"num\":125,\"w\":16,\"h\":16,\"heights\":[[1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0],[2,2,2,2,2,2,2,2,0,0,0,0,0,0,0,0],[2,2,2,2,2,2,2,2,0,0,0,0,0,0,0,0],[2,2,2,2,2,2,2,2,0,0,0,0,0,0,0,0],[2,2,2,2,2,2,2,2,0,0,0,0,0,0,0,0],[3,3,3,3,3,3,3,3,0,0,0,0,0,0,0,0],[3,3,3,3,3,3,3,3,0,0,0,0,0,0,0,0],[3,3,3,3,3,3,3,3,0,0,0,0,0,0,0,0],[3,3,3,3,3,3,3,3,0,0,0,0,0,0,0,0],[4,4,4,4,4,4,4,4,0,0,0,0,0,0,0,0],[4,4,4,4,4,4,4,4,0,0,0,0,0,0,0,0],[4,4,4,4,4,4,4,4,0,0,0,0,0,0,0,0],[4,4,4,4,4,4,4,4,0,0,0,0,0,0,0,0]],\"surfaces\":[[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"],[\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\",\"n\"]],\"starts\":[{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"Natural Surface\":256},\"stats\":{\"walkable\":256,\"maxHeight\":4,\"minHeight\":0,\"spread\":4,\"avgHeight\":1.25,\"waterPct\":0}},\"126\":{\"num\":126,\"w\":18,\"h\":10,\"heights\":[[13,12.5,11,9,8,7.5,6,4,3,3,4,6,7.5,8,9,11,12.5,13],[13,12.5,11,9,8,7.5,6,4,3,3,4,6,7.5,8,9,11,12.5,13],[13,13,13,12,8,8,8,4,7,7,4,8,8,8,12,13,13,13],[13,13,13,9,8,8,8,8,8,8,8,8,8,8,9,13,13,13],[13,12.5,11,9,8,8,9,13,13,13,13,9,8,8,9,11,12.5,13],[13,12.5,11,9,8,8,12,13,13,13,13,12,8,8,9,11,12.5,13],[13,13,13,null,12,12,13,13,13,13,13,13,12,12,null,13,13,13],[13,13,13,13,null,null,13,13,13,13,13,13,null,null,13,13,13,13],[13,15,13,17,null,null,17,13,14,14,13,17,null,null,17,13,15,13],[13,15,13,17,null,null,14,13,null,null,13,14,null,null,17,13,15,13]],\"surfaces\":[[\"s\",\"S\",\"S\",\"S\",\"s\",\"S\",\"S\",\"S\",\"r\",\"r\",\"S\",\"S\",\"S\",\"s\",\"S\",\"S\",\"S\",\"s\"],[\"s\",\"S\",\"S\",\"S\",\"s\",\"S\",\"S\",\"S\",\"r\",\"r\",\"S\",\"S\",\"S\",\"s\",\"S\",\"S\",\"S\",\"s\"],[\"s\",\"s\",\"s\",\"f\",\"s\",\"s\",\"s\",\"f\",\"f\",\"f\",\"f\",\"s\",\"s\",\"s\",\"f\",\"s\",\"s\",\"s\"],[\"w\",\"s\",\"s\",\"f\",\"r\",\"r\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"r\",\"r\",\"f\",\"s\",\"s\",\"r\"],[\"w\",\"S\",\"S\",\"S\",\"r\",\"r\",\"f\",\"s\",\"s\",\"s\",\"s\",\"f\",\"r\",\"r\",\"S\",\"S\",\"S\",\"r\"],[\"s\",\"S\",\"S\",\"S\",\"r\",\"r\",\"f\",\"s\",\"s\",\"s\",\"s\",\"f\",\"r\",\"r\",\"S\",\"S\",\"S\",\"s\"],[\"s\",\"s\",\"s\",\".\",\"f\",\"f\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\"f\",\"f\",\".\",\"s\",\"s\",\"s\"],[\"r\",\"r\",\"r\",\"s\",\".\",\".\",\"s\",\"r\",\"r\",\"r\",\"r\",\"s\",\".\",\".\",\"s\",\"r\",\"r\",\"r\"],[\"r\",\"f\",\"r\",\"f\",\".\",\".\",\"f\",\"r\",\"f\",\"f\",\"r\",\"f\",\".\",\".\",\"f\",\"r\",\"f\",\"r\"],[\"r\",\"f\",\"r\",\"f\",\".\",\".\",\"f\",\"r\",\".\",\".\",\"r\",\"f\",\".\",\".\",\"f\",\"r\",\"f\",\"r\"]],\"starts\":[{\"x\":17,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":4,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":0,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":17,\"y\":4,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":17,\"y\":6,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"West\",\"layer\":false},{\"x\":17,\"y\":2,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"Stone floor\":52,\"Rug\":42,\"Stairs\":36,\"Furniture\":30,\"Type 47\":2,\"Roof\":2},\"stats\":{\"walkable\":164,\"maxHeight\":17,\"minHeight\":3,\"spread\":14,\"avgHeight\":10.95,\"waterPct\":0},\"source\":\"fftbg-ram\"},\"127\":{\"num\":127,\"w\":11,\"h\":15,\"heights\":[[null,null,null,7,7,null,null,7,7,null,null],[null,null,null,7,7,null,null,7,7,null,null],[null,null,null,7,7,null,null,7,7,null,null],[null,null,null,5,5,5,null,7,7,7,null],[null,null,null,5,5,5,6,7,7,9,null],[null,5,5,5,5,5,null,null,8,null,null],[null,5,5,6,7,7,null,9,9,null,null],[null,5,5,null,7,7,8,9,9,13,null],[null,5,5,5,5,5,7,9,9,null,null],[null,null,null,5,5,5,5,9,9,null,null],[null,null,null,6,6,null,null,9,9,null,null],[null,null,null,8,8,null,null,10,null,null,null],[null,null,null,9,9,null,11,11,11,11,11],[null,9,9,9,9,10,11,12.5,12.5,12.5,11],[null,9,9,9,9,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\"n\",\"n\",\".\",\".\",\"n\",\"n\",\".\",\".\"],[\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\"i\",\"i\",\".\",\".\"],[\".\",\".\",\".\",\"i\",\"i\",\".\",\".\",\"i\",\"i\",\".\",\".\"],[\".\",\".\",\".\",\"r\",\"r\",\"r\",\".\",\"i\",\"i\",\"i\",\".\"],[\".\",\".\",\".\",\"r\",\"r\",\"r\",\"S\",\"i\",\"i\",\"b\",\".\"],[\".\",\"i\",\"i\",\"r\",\"r\",\"r\",\".\",\".\",\"S\",\".\",\".\"],[\".\",\"i\",\"i\",\"S\",\"i\",\"i\",\".\",\"i\",\"i\",\".\",\".\"],[\".\",\"i\",\"i\",\".\",\"i\",\"i\",\"S\",\"i\",\"i\",\"p\",\".\"],[\".\",\"i\",\"i\",\"i\",\"i\",\"i\",\"b\",\"i\",\"i\",\".\",\".\"],[\".\",\".\",\".\",\"i\",\"i\",\"i\",\"i\",\"i\",\"i\",\".\",\".\"],[\".\",\".\",\".\",\"S\",\"S\",\".\",\".\",\"i\",\"i\",\".\",\".\"],[\".\",\".\",\".\",\"S\",\"S\",\".\",\".\",\"S\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"i\",\"i\",\".\",\"i\",\"i\",\"i\",\"i\",\"i\"],[\".\",\"i\",\"i\",\"i\",\"i\",\"S\",\"i\",\"M\",\"M\",\"M\",\"i\"],[\".\",\"i\",\"i\",\"i\",\"i\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":3,\"y\":14,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":14,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":4,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":7,\"y\":12,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":12,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":8,\"y\":0,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"Iron plate\":59,\"Stairs\":10,\"Rug\":9,\"Snow\":4,\"Machine\":3,\"Box\":2,\"Marsh\":1},\"stats\":{\"walkable\":88,\"maxHeight\":13,\"minHeight\":5,\"spread\":8,\"avgHeight\":7.57,\"waterPct\":1.1},\"source\":\"fftbg-ram\"}},\"byName\":{\"End of Time\":{\"num\":0,\"w\":17,\"h\":14,\"heights\":[[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null],[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null],[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null],[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null],[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null],[null,null,null,null,null,3,null,null,null,null,null,null,null,null,null,null,null],[null,null,null,null,null,3,null,null,null,null,null,null,null,null,null,null,null],[null,null,null,null,null,3,null,9,null,null,null,null,null,null,null,null,null],[null,null,null,null,null,3,null,null,null,9,null,null,5,5,5,5,5],[null,null,null,5,5,3,3,3,null,null,null,null,5,5,5,5,5],[5,5,5,3,3,3,3,3,3,3,3.5,4.5,5,5,5,5,5],[2,3,3,3,3,null,3,3,null,null,null,null,5,5,5,5,5],[5,5,5,3,3,3,3,5,null,null,null,null,5,5,5,5,5],[null,null,null,3,3,3,3,3,null,null,null,null,null,null,null,null,null]],\"surfaces\":[[\".\",\".\",\".\",\"c\",\"s\",\"r\",\"s\",\"i\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"l\",\"s\",\"s\",\"s\",\"w\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\"n\",\"s\",\"B\",\"s\",\"M\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\".\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"],[\".\",\".\",\".\",\".\",\".\",\"s\",\".\",\".\",\".\",\"s\",\".\",\".\",\"g\",\"s\",\"c\",\"s\",\"r\"],[\".\",\".\",\".\",\"p\",\"k\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"B\",\"B\",\"B\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"s\",\"S\",\"S\",\"n\",\"s\",\"M\",\"s\",\"r\"],[\"B\",\"B\",\"B\",\"s\",\"s\",\".\",\"s\",\"s\",\".\",\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\"],[\"B\",\"B\",\"B\",\"s\",\"s\",\"s\",\"s\",\"p\",\".\",\".\",\".\",\".\",\"R\",\"s\",\"p\",\"s\",\"M\"],[\".\",\".\",\".\",\"s\",\"s\",\"s\",\"s\",\"s\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\",\".\"]],\"starts\":[{\"x\":13,\"y\":10,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":5,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":2,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":14,\"y\":11,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":15,\"y\":10,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":5,\"y\":1,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":6,\"y\":2,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"North\",\"layer\":false},{\"x\":14,\"y\":9,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"East\",\"layer\":false}],\"surfaces_hist\":{\"s\":62,\"B\":10,\"r\":3,\"M\":3,\"p\":3,\"c\":2,\"n\":2,\"S\":2,\"i\":1,\"l\":1,\"w\":1,\"g\":1,\"k\":1,\"R\":1},\"stats\":{\"walkable\":93,\"maxHeight\":9,\"minHeight\":2,\"spread\":7,\"avgHeight\":3.87,\"waterPct\":5.4},\"source\":\"ffhacktics\"},\"Shop\":{\"num\":104,\"w\":6,\"h\":12,\"heights\":[[null,null,0,0,null,null],[2,0,0,0,0,0],[4,1.5,1,1,1,null],[6,0,0,0,0,0],[5,0,0,0,0,2],[4,1,0,0,0,2],[5,0,0,0,0,3],[null,null,0,0,null,null],[null,null,0,0,4,null],[null,1,0,0,2,null],[null,1,0,0,3,null],[null,1,1,0,4,null]],\"surfaces\":[[\".\",\".\",\"s\",\"s\",\".\",\".\"],[\"f\",\"s\",\"c\",\"c\",\"s\",\"s\"],[\"f\",\"M\",\"f\",\"f\",\"f\",\".\"],[\"k\",\"s\",\"c\",\"c\",\"s\",\"s\"],[\"k\",\"s\",\"c\",\"c\",\"s\",\"D\"],[\"f\",\"f\",\"c\",\"c\",\"s\",\"D\"],[\"k\",\"s\",\"s\",\"s\",\"s\",\"M\"],[\".\",\".\",\"s\",\"s\",\".\",\".\"],[\".\",\".\",\"s\",\"s\",\"f\",\".\"],[\".\",\"l\",\"s\",\"s\",\"f\",\".\"],[\".\",\"l\",\"s\",\"s\",\"k\",\".\"],[\".\",\"w\",\"M\",\"s\",\"k\",\".\"]],\"starts\":[{\"x\":4,\"y\":1,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"North\",\"layer\":false},{\"x\":4,\"y\":6,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":7,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"South\",\"layer\":false},{\"x\":3,\"y\":0,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":0,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"North\",\"layer\":false},{\"x\":2,\"y\":7,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":6,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"South\",\"layer\":false},{\"x\":1,\"y\":1,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"North\",\"layer\":false}],\"surfaces_hist\":{\"s\":24,\"f\":9,\"c\":8,\"k\":5,\"M\":3,\"D\":2,\"l\":2,\"w\":1},\"stats\":{\"walkable\":54,\"maxHeight\":6,\"minHeight\":0,\"spread\":6,\"avgHeight\":1.03,\"waterPct\":5.6},\"source\":\"ffhacktics\"},\"Chocobo Forest\":{\"num\":125,\"w\":13,\"h\":8,\"heights\":[[3.5,4,3.5,3,3,4,5.5,5.5,5,null,null,null,null],[4,4,3,2,2,3,6,6,5.5,5.5,6,6,6],[3.5,5.5,10,8.5,7,5.5,5.5,5.5,5,5.5,6.5,7.5,6],[3,6.5,11,8.5,7,5.5,5,5,null,null,0,9,6.5],[3.5,7,12.5,null,null,4.5,4.5,4.5,4.5,null,null,10.5,8],[4.5,7,12.5,null,null,4.5,4,4,4.5,5,null,11,10],[5,6.5,5,5,5,4.5,4,4,4.5,5,11.5,11.5,11.5],[5,5,5,5,5,4.5,4.5,4.5,4.5,5,12,12,12]],\"surfaces\":[[\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\".\",\".\",\".\",\".\"],[\"t\",\"p\",\"p\",\"p\",\"t\",\"t\",\"p\",\"p\",\"p\",\"t\",\"t\",\"t\",\"p\"],[\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\",\"t\"],[\"t\",\"t\",\"t\",\"p\",\"t\",\"t\",\"t\",\"t\",\".\",\".\",\"D\",\"t\",\"t\"],[\"t\",\"p\",\"p\",\".\",\".\",\"t\",\"o\",\"o\",\"o\",\".\",\".\",\"t\",\"t\"],[\"t\",\"p\",\"p\",\".\",\".\",\"o\",\"o\",\"o\",\"o\",\"o\",\".\",\"t\",\"t\"],[\"t\",\"p\",\"t\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"o\",\"t\",\"t\"],[\"t\",\"t\",\"t\",\"o\",\"o\",\"o\",\"D\",\"D\",\"o\",\"o\",\"o\",\"t\",\"t\"]],\"starts\":[{\"x\":0,\"y\":7,\"team\":\"Player 1\",\"unit\":0,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":3,\"team\":\"Player 2\",\"unit\":0,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":6,\"team\":\"Player 2\",\"unit\":1,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":2,\"team\":\"Player 1\",\"unit\":1,\"facing\":\"West\",\"layer\":false},{\"x\":0,\"y\":3,\"team\":\"Player 1\",\"unit\":2,\"facing\":\"West\",\"layer\":false},{\"x\":12,\"y\":2,\"team\":\"Player 2\",\"unit\":2,\"facing\":\"East\",\"layer\":false},{\"x\":12,\"y\":7,\"team\":\"Player 2\",\"unit\":3,\"facing\":\"East\",\"layer\":false},{\"x\":0,\"y\":6,\"team\":\"Player 1\",\"unit\":3,\"facing\":\"West\",\"layer\":false}],\"surfaces_hist\":{\"t\":53,\"o\":22,\"p\":13,\"D\":3},\"stats\":{\"walkable\":91,\"maxHeight\":12.5,\"minHeight\":0,\"spread\":12.5,\"avgHeight\":5.91,\"waterPct\":14.3},\"source\":\"ffhacktics\"}}}");

});

parcelRegister("4rZCr", function(module, exports) {
module.exports = JSON.parse("{\"generated\":\"2026-10-16\",\"format\":\"6 bytes per tile (surface, height, depth/slope, slope type, thickness, flags), row-major; upper layer only if it has panels\",\"maps\":{\"0\":{\"w\":17,\"h\":14,\"lower\":\"GQAAAAACGQAAAAACGQAAAAACHQMAAAAIFQMAAAAEIwMAAAAEFQMAAAAEBQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAEFQMAAAAAFQMAAAAAFQMAAAAAFQMAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACLwMAAAAEFQMAAAAAAgMAAAAAFQMAAAAALwMAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAEFQMAAAAAFQMAAAAAFQMAAAAAFQMAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACBQMAAAAIFQMAAAAEIwMAAAAEFQMAAAAEHQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAIGQAAAAACFgkAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQMAAAAIGQAAAAACGQAAAAACGQAAAAACFgkAAAAEGQAAAAACGQAAAAACAwUAAAAAFQUAAAAIHQUAAAAAFQUAAAAIBgUAAAAAGQAAAAACGQAAAAACGQAAAAACKwUAAAAIGwUAAAAEFQMAAAAEFQMAAAAEFQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQUAAAAIFQUAAAAIFQUAAAAIFQUAAAAIFQUAAAAIIwUAAAAMIwUAAAAIIwUAAAAIFQMAAAAEFQMAAAAAFQMAAAAAFQMAAAAAFQMAAAAEFQMAAAAIFQMAAAAIJQMBUgAIJQQBUgAIBQUAAAAAFQUAAAAIKQUAAAAAFQUAAAAIFgUAAAAAIwECUgAMIwMAAAAIIwMAAAAIFQMAAAAEFQMAAAAAKQwAAAACFQMAAAAAFQMAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQUAAAAIFQUAAAAIFQUAAAAIFQUAAAAIFQUAAAAIIwUAAAAMIwUAAAAIIwUAAAAIFQMAAAAEFQMAAAAAFQMAAAAAFQMAAAAAKwUAAAAEGQAAAAACGQAAAAACGQAAAAACGQAAAAACEwUAAAAAFQUAAAAICgUAAAAAFQUAAAAIKgUAAAAAGQAAAAACGQAAAAACGQAAAAACFQMAAAAIFQMAAAAEFQMAAAAEFQMAAAAEFQMAAAAIGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAAC\"},\"1\":{\"w\":10,\"h\":13,\"lower\":\"AwIAAAAgAwIAAAAgAwIAAAAgFQIAAAAQAwIAAAAQFQIAAAAQFQIAAAAQQwEAAAAgAwEBQQAgAwEBhQAgAwIAAAAgAwIAAAAgAwIAAAAgVQIAAAAQFQIBhQAQFQIBhQAQVQIAAAAQTgAgAABAAwEBUgAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgVQIAAAAQAwMBhQAQFQMBhQAQVQIAAAAQTgAgAABAAwEBEQAgAwEBZgAgAwEBJQAgAwEBJQAgTgAgAABETgAgAABAFQQAAAAQFQQAAAAQTgAgAABEDgAgAABADgAgAABAAwEBEQAgDgAgAABADgAgAABADgAgAABAVQMAAAAQFQQAAAAQFQQAAAAQVQMAAAAQDgAgAABADgAgAABADgAgAABADgAgAABADgAgAABADgAgAABAVQMAAAAQFQQAAAAQFQQAAAAQVQMAAAAQDgAgAABADgAgAABAAwEBQQAgDgAgAABADgAgAABADgAgAABADgAgAABAFQQAAAAQFQQAAAAQDgAgAABEDgAgAABAAwEAAAAgAwEBUgAgAwQAAAAgAwQAAAAgQwECRAAgDgAgAABAFQQAAAAQFQQAAAAQDgAgAABEAwEBQQAgAwQAAAAgAwQAAAAgFQkAAAAQFQkAAAAQAwQAAAAgFQQAAAAQFQQAAAAQFQQAAAAQFQMBWAAQFQIBWAAQFQkAAAAQFQkAAAAQVQgAAAAQFQkAAAAQAwQAAAAkFQQAAAAQFQQAAAAQFQQAAAAQFQMBWAAQFQIBWAAQFQkAAAAQVQgAAAAQFQ4AAAAQVQ0AAAAQFQ4AAAAQFQQAAAAUFQQAAAAQFQQAAAAQFQQAAAAQFQ4AAAAQVQ0AAAAQFQ4AAAAQFQ4AAAAQFQwBJQAUFQ4AAAAQVQ0AAAAQFQAAAAATFQAAAAATVQ0AAAAQFQ4AAAAQFQwBJQAUFQ4AAAAQFQwCJQAUFQoAAAAUVQsBUgAUFQ0AAAAQVQAAAAATFQAAAAATFQ0AAAAQFQsBWAAUFQoAAAAUFQwCJQAU\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQ0AAAMQFQ0AAAMQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVQwAAAIQVQwAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"2\":{\"w\":10,\"h\":11,\"lower\":\"AwEBUgAkAwIAAAAkAwIAAAAkAwEBWAAgAwEAAAAgAwEAAAAgAwEAAAAgAwABWAAgAAAAAAAgAAAAAAAgAwEBUgAkAwIAAAAkHgoAAAAmAwEBWAAkAwEAAAAgAwEAAAAkAwEAAAAgAwABmQAkQAABhQAgQAABhQAgAwEBEQAkAwEBJQAkAwEBJQAkAwEBFAAkAAEAAAAkAAEAAAAkAwEAAAAkAAEAAAAkAwEBUgAkAwIAAAAkAwEAAAAkAwEAAAAkAAEAAAAkAAEAAAAkAwEAAAAkAAEAAAAkAwEBQQAkAwEBhQAkAwEBlgAkAwIAAAAkAwEAAAAkAwABaQAkAwABJQAkAwABJQAkAwABJQAkAwABZgAkAwEBUgAkAwIAAAAkAwIAAAAkAwIAAAAkQAEBhQAkVQMAAAAUAwACWAAkAwAAAAAkAwAAAAAkAwABUgAkAwEBUgAkAwIAAAAkAwIAAAAkAwIAAAAkAwIBhQAkVQQBhQAUFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQYBWAAUFQUBWAAUAwIAAAAkAwMAAAAkVQYAAAAUFQcAAAAUFQUAAAAUFQUAAAAUFQUAAAAUFQUAAAAUVQQAAAAUFQMAAAAUAwIAAAAkAwMAAAAkFRAAAAASFRAAAAASFQUAAAAUFQUAAAAUFQUAAAAUFQUAAAAUFRAAAAASFRAAAAASAwIAAAAkVQ4AAAAQFRAAAAASFRAAAAASFRAAAAASFQUAAAAUFRAAAAASFRAAAAASFRAAAAASFRAAAAASVQ4AAAAQAwUAAAAgAwUAAAAgAwUAAAAgAwUAAAAgAAUAAAAgAAUAAAAgAwUAAAAgAwUAAAAgAwUAAAAgAwUAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFRAAAAcCAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"3\":{\"w\":9,\"h\":13,\"lower\":\"PwsAAAAaPwsAAAAaPwsAAAAaHQEAAAAgHQEAAAAgHQEAAAAgPwsAAAAaPwsAAAAaPwsAAAAaPwsAAAAaFQQAAAAQDgAgAABAHQEAAAAgHQEAAAAgHQEAAAAgDgAgAABAFQQAAAAQPwsAAAAaPwsAAAAaFQQAAAAQDgAgAABAHQEAAAAgHQEAAAAgHQEAAAAgDgAgAABAFQQAAAAQPwsAAAAaPwsAAAAaFQQAAAAQDgAgAABAHQEAAAAgHQEAAAAgHQEAAAAgDgAgAABAFQQAAAAQPwsAAAAaPwsAAAAaFQQAAAAQTgAgAABAHQEAAAAQHQEAAAAgHQEAAAAQTgAgAABAFQQAAAAQPwsAAAAaFQQAAAAQFQQAAAAQFQIAAAAQXQEBhQAQHQEBhQAgXQEBhQAQFQIAAAAQFQQAAAAQFQQAAAAQFQQAAAAQDgEgAABAFQIAAAAQHQIAAAAQHQIAAAAgHQIAAAAQFQIAAAAQDgEgAABAFQQAAAAQFQQAAAAQDgEgAABAFQIAAAAQHQIAAAAQHQIAAAAgHQIAAAAQFQIAAAAQDgEgAABAFQQAAAAQFQQAAAAQDgEgAABAVQIAAAAQHQIAAAAgHQIAAAAgHQIAAAAgVQIAAAAQDgEgAABAFQQAAAAQFQQAAAAQJgYAAAASVQMAAAAQXQIAAAAgHQIAAAAgXQIAAAAgVQMAAAAQJgYAAAASFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQHQQAAAAgHQQAAAAgHQQAAAAgFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQHQQAAAAgHQQAAAAgHQQAAAAgFQQAAAAQFQQAAAAQFQQAAAAQPwsAAAAaPwsAAAAaPwsAAAAaFQQAAAAQFQQAAAAQFQQAAAAQPwsAAAAaPwsAAAAaPwsAAAAa\"},\"4\":{\"w\":6,\"h\":12,\"lower\":\"VQAAAAAUJgMAAAAyVQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUHQAAAAAUXQAAAAAgXQAAAAAgXQAAAAAgHQAAAAAgHQAAAAAkHQAAAAAkXQAAAAAgZgEAAAAgZgEAAAAgXQAAAAAgHQAAAAAkHQAAAAAkXQAAAAAgJgEAAAAgJgEAAAAgXQAAAAAgHQAAAAAkHQAAAAAkXQAAAAAgZgEAAAAgZgEAAAAgXQAAAAAgHQAAAAAkHQAAAAAUHQAAAAAgXQAAAAAgXQAAAAAgHQAAAAAgHQAAAAAkFQAAAAAUXQAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkXQAAAAAkJgMAAAA2JgIAAAA2XQAAAAAkXQAAAAAkFQAAAAAUJgIAAAA2PwsAAAAaPwsAAAAaHQEAAAAkHQEAAAAkPwsAAAAaPwsAAAAaFQIAAAAUVQEAAAAUHQEAAAAkHQEAAAAkVQEAAAAUJgIAAAAkFQIAAAAUVQEAAAAQHQEAAAAgHQEAAAAgVQEAAAAQFAIAAAAkFQIAAAAUVQEAAAAQHQEAAAAgHQEAAAAgFQEAAAAQJgIAAAAk\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwsAAAIaPwsAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"5\":{\"w\":13,\"h\":11,\"lower\":\"VgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFgABhQAwFwADhQAQFgABhQA1FwADhQARFgIAAAAwFgEBhQAwVgUBJQAwVgYBhQAwFgcAAAAwVgYBhQAwFgcAhQAwVgYBhQAwFgcAhQAwVgYBhQAwFAcAAAAgFgYBhQA5FAcAAAAhFgQAAAAwVgIChQAwFgQBJQA0VgcChQAwFgkAAAAwVgcChQAwFgkAhQAwVgcChQAwFgkAhQAwVgcChQAwFAUAAAAkFgcChQAxFAUAAAAlFgIAAAA0FgQChQAwFgQChQA0FgkChQAwFgkChQAwFgkChQAwFgkChQAwIQwAhQAQFgkChQAwFgkChQAwFAMAhQAkFgkChQAxFAMAAAAlFhQCQQAyFhQChQAyFhQCRAAyFgsChQAwFgsChQAwFgsChQAwFgsChQAwVgsChQAwFgsChQAwFhAEhQAyFAEAhQAkFg8DhQAzFAEAAAAlFhQCUgAyFh4AAAAyFhQCWAAyFg0AAAAQVg0AAAAQFhUAAAAyVg0AAAAwYQ4AAAAQFhAAAAAyFhgAAAAyFAEAAAAkFhgAAAAzFAEAAAAlFhQCEQA2FhQCJQA2FhQCFAA2FgsCJQA4FgsCJQA4FgsCJQA4FgsCJQA4VgsCJQA4FgsCJQA4FhAEJQA6FAEAJQAkFg8DJQAzFAEAAAAlFgYAAAA0VgQCJQA0FgQCJQA0FgkCJQA4FgkCJQA4FgkCJQA4FgkCJQA0IQwAJQAYVgkCJQA0FgkCJQA4FAMAJQAkFgkCJQA1FAMAAAAlFgQAAAA0VgICJQA0FgQBhQA0VgcCJQA4FgkAAAA4VgcCJQA4FgkAJQA0VgcCJQA4FgkAAAA4VgcCJQA0FAUAAAAkFgcCJQAxFAUAAAAlFgIAAAA0FgEBJQA0VgUBhQA4VgYBJQA4FgcAAAA4VgYBJQA4FgcAJQA0VgYBJQA4FgcAJQA0VgYBJQA4FAcAAAAkFgYBJQA1FAcAAAAhVgABJQA0FgABJQA0FgABJQA0FgABJQA4FgABJQA4FgABJQA4FgABJQA4FgABJQA4FgABJQA4FgABJQA4FwADJQAYFgABJQA5FwADJQAZ\"},\"6\":{\"w\":12,\"h\":12,\"lower\":\"FQQAAAAQFQQAAAAQAwIAAAAgQwEAAAAgCgAgAABAAwEBUgAkAwIAAAAgAwIAAAAgAwIAAAAgAAIAAAAQAAIBUgAQAwMAAAAgFQQAAAAUFQQAAAAQTgAgAABACgAgAABACgAgAABASgAgAABASgAgAABAQwEBEQAgAwIAAAAgAwIAAAAgAAIBUgAQAwMAAAAQFQQAAAAUVQMAAAAUVQIAAAAgQwEBRAAgCgAgAABACgAgAABACgAgAABACgAgAABAQwEBUgAgAwIAAAAgAwIBEQAQAAIBJQAQVQsAAAAQVQoAAAAQVQkAAAAQAwIAAAAkQwEBRAAgSgAgAABACgAgAABASgAgAABAAwIAAAAgAwIAAAAgAwIAAAAgAAIAAAAQFQwAAAAQFQwAAAAQFQkAAAAQFQYAAAAQAwMAAAAkAwIBWAAgTgAgAABAAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAAIAAAAQVQsAAAAQFQwAAAAQFQkAAAAQVQgAAAAQFQcBWAAQTgAgAABEDgAgAABETgAgAABEQAEBUgAgAwIAAAAgQwIAAAAgQwIAAAAgVQsAAAAQFQwAAAAQDgAgAABEDgAgAABEDgAgAABEDgAgAABEDgAgAABETgAgAABEAwIAAAAkQwIAAAAkVQMAAAAQVQMAAAAQVQsAAAAQVQsAAAAUFQkAAAAUVQgAAAAQFQcBWAAQVQYAAAAQFQQAAAAUTgAgAABEAwIAAAAkAwIAAAAkVQQAAAAQVQQAAAAQVQwAAAAQFQ0AAAAQFQ0BUgAQFQ4AAAAQFQcAAAAQHAkAAAAiVQYAAAAQFQYAAAAQVQYAAAAQFQcAAAAQVQUAAAAQFQUAAAAQFQ0AAAAQFQ0AAAAQVQ0AAAAUFQUAAAARFQUAAAAQFQUAAAAQVQUAAAAQVQUAAAAQVQUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQ0AAAAQFQ0AAAAQVQ0AAAAUFQUAAAARFQUAAAAUFQUAAAAQVQUAAAAQVQUAAAAQVQUAAAAQFQUAAAAQFQUAAAAQAwUAAAAgFQ0AAAAQFQ0AAAAQFQ0BUgAQFQ4AAAAQFQcAAAAQHAkAAAAiVQYAAAAQFQYAAAAQVQYAAAAQFQcAAAAQFQUAAAAQAwUAAAAg\",\"upper\":\"AAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABFQ8AAAoQAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABFQ8AAAoQAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAABAAEAAAAB\"},\"7\":{\"w\":8,\"h\":12,\"lower\":\"FQMAAAAkFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUAwMAAAAkVQIAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUVQIAAAAUFQMAAAAkFQMBhQAkTgAgAABEFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUTgAgAABEFQMBhQAUFQQAAAAkDgAgAABEDgAgAABEFQMBhQAUFQMBhQAQDgAgAABEDgAgAABAFQQAAAAUAwMBJQAkDgAgAABEVQQAAAAQFQQBhQAUFQQBhQAQVQQAAAAQDgAgAABAAwMBJQAgAwMChQAkDgAgAABEHAcAAAAiVQUAAAAQVQUAAAAQHAcAAAAiDgAgAABAAwMChQAgFQUAAAAkDgIgAABEFQQAAAAQVQYAAAAQVQYAAAAQFQQAAAAUDgIgAABAFQUAAAAUFQUAAAAkDgIgAABEDgIgAABEVQcAAAAQVQcAAAAQDgIgAABEDgIgAABAFQUAAAAUFQUAAAAkDgIgAABEDgIgAABEVQgAAAAQVQgAAAAQDgIgAABEDgIgAABAAwUAAAAkFQcAAAAkDgMgAABEFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQDgMgAABAAwcAAAAgFQoAAAAUFQkBWAAUFQkAAAAUFQkAAAAQFQkAAAAQFQkAAAAQFQkBUgAQFQoAAAAQFQoAAAAUFQkBWAAUFQkAAAAUFQkAAAAQFQkAAAAQFQkAAAAQFQkBUgAQFQoAAAAQ\"},\"8\":{\"w\":8,\"h\":11,\"lower\":\"IAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgIAAAAAAQIAAAAAAQHQAAAAAgXQAAAAAgXQAAAAAgXQAAAAAgXQAAAAAgHQAAAAAgIAAAAAAQIAAAAAAQXQAAAAAgJgEAAAAgJgQAAAAyJgEAAAAgJgEAAAAgXQAAAAAgIAAAAAAQIAAAAAAQXQAAAAAgJgEAAAAgJgEAAAAgJgEAAAAgJgEAAAAgXQAAAAAgIAAAAAAQIAAAAAAQHQAAAAAgXQAAAAAgXQAAAAAgXQAAAAAgXQAAAAAgHQAAAAAgIAAAAAAQIAAAAAAQHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQFAQAAAAgFAQAAAAgFAQAAAAgZQAChQAQZQAChQAQFAQAAAAgFAQAAAAgFAQAAAAgIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQ\"},\"9\":{\"w\":8,\"h\":14,\"lower\":\"FQYAAAAQFQYAAAAQQwUAAAAgDgEgAABEDgEgAABADgEgAABAFQUAAAAQQwMAAAAgQwMAAAAgQwUAAAAgAwUAAAAgTgEgAABEDgEgAABATgEgAABAVQUAAAAQQwQAAAAgQwQAAAAgQwYAAAAgFQcAAAAQIwcAAAAQDgEgAABEIwcAAAAQVQYAAAAQQwUAAAAgAwUAAAAgQwUAAAAgVQYAAAAQTgEgAABEDgEgAABETgEgAABEVQUAAAAQQwQBFAAgQwQAAAAgQwQBJQAgFQYAAAAQDgEgAABEDgEgAABEDgEgAABEFQUAAAAQQwMAAAAkTgIgAABATgIgAABAXAUAAABCDgEgAABEDgEgAABEDgEgAABEXAQAAABCAwIBJQAkTgIgAABAAwQAAAAgDgEgAABADgEgAABEFQYAAAAgDgEgAABEDgEgAABADgEgAABATgIgAABAAwQAAAAgDgEgAABADgEgAABADgEgAABADgEgAABEDgEgAABADgEgAABADgIgAABATgIgAABAXAYAAABCDgEgAABADgEgAABADgEgAABAXAYAAABCAwIBQQAgQwUAAAAgQwQBhQAgFQcAAAAQDgMgAABADgMgAABADgMgAABAFQcAAAAQAwIBUgAgAwYAAAAgQwUAAAAgFQcAAAAQDgMgAABEDgMgAABADgMgAABAFQcAAAAQQwQBRAAgAwoAAAAgQwUAAAAgVQcAAAAQDgMgAABEDgMgAABADgMgAABAVQcAAAAQQwYAAAAgQwoAAAAgFQsAAAAQQwgAAAAkQwgAAAAgAwgAAAAgAwgAAAAgAwgAAAAgQwYBhQAgQwoAAAAgFQsAAAAQQwoAAAAgQwgBWAAgAwgAAAAgAwgBQQAgQwgBRAAgFQkAAAAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"10\":{\"w\":11,\"h\":10,\"lower\":\"FQoAAAAUFQoAAAAUFQIAAAAUFQIAAAAUFQIAAAAUFQIAAAAUVQIAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQQAAAAQFQoAAAAUFQoAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQVQIAAAAQVQMAAAAQVQQAAAAQVQQAAAAQFQQAAAAQFQoAAAAUFQoAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQUAAAAQVQUAAAAQVQUAAAAQFQYAAAAUFQoAAAAUFQoAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAUFQoAAAAQVQYAAAAQVQYAAAAQFQYAAAAUFQoAAAAUFQoAAAAQFQIAAAAQFQIAAAAQFQoAAAAQVQkAAAAQVQgAAAAQFQgAAAAQVQcAAAAQVQcAAAAQFQgAAAAUFQoAAAAUFQoAAAAQFQIAAAAQFQIAAAAUFQoAAAAQVQkAAAAQVQgAAAAQFQgAAAAQFQgAAAAQFQgAAAAQFQgAAAAQFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUFQIAAAAUFQIAAAAUFQoAAAAQFQgAAAAQFQgAAAAQFQgAAAAQFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUVQIAAAAUFQIAAAAUFQIAAAAQFQgAAAAQFQgAAAAQFQgAAAAQFQgAAAAQVQEAAAAUVQEAAAAQVQEAAAAUVQEAAAAUFQMAAAAUVQIAAAAUFQIAAAAUFQgAAAAQFQgAAAAQFQgAAAAQFQgAAAAQFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFQIBJQAUVQIAAAAUFQIAAAAUFQgAAAAQFQgAAAAQFQgAAAAQFQgAAAAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwoAAAEgIwoAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwoAAAEQIwoAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"11\":{\"w\":7,\"h\":13,\"lower\":\"VQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQAAAAAQJgEAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQJgEAAAAgVQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQAAAAAUJgYAAAAiFQAAAAAQFQAAAAAQVAEAAAAgFQAAAAAQFQAAAAAQJgYAAAAiJgYAAAAiFQAAAAAQFQAAAAAQVAEAAAAgFQAAAAAQFQAAAAAQJgYAAAAiFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQJgEAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQJgEAAAAkVQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQAAAAAUPwoAAAASFQAAAAAQPwoAAAASPwoAAAASPwoAAAASPwoAAAASPwoAAAASFwEAAAASFgAAAAAQFgAAAAAQFgAAAAAQFgAAAAAQFgAAAAAQFwEAAAASFwEAAAASFgAAAAAQFgAAAAAQFgAAAAAQFgAAAAAQFgAAAAAQFwEAAAASFwEAAAASFwEAAAASFgAAAAAQFgAAAAAQFgAAAAAQFwEAAAASFwEAAAASGAAAAAACFwEAAAASFwEAAAASFwEAAAASFwEAAAASFwEAAAASGAAAAAAC\"},\"12\":{\"w\":9,\"h\":15,\"lower\":\"CgAgAABACgAgAABASgAgAABACgAgAABAFQQAAAAQIAQAAAAgIAQAAAAgFQQAAAAQCgAgAABAAwEBhQAgSgAgAABAAwIAAAAgSgAgAABAFQQAAAAQIAQAAAAgIAQAAAAgFQQAAAAQCgAgAABEQwIAAAAgSgAgAABASgAgAABACgAgAABAFQQAAAAQIAQAAAAgIAQAAAAgFQQAAAAQAwIAAAAkBgMBUgAgBgQAAAAgBgMBmQAgBgMBhQAgHAcAAAAiAwQAAAAgAwQAAAAgHAcAAAAiAwQAAAAgBgMBlgAgAwQAAAAgAwQAAAAgBgQAAAAgFQQAAAAQAwQAAAAgAwQAAAAgFQQAAAAQAwQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgFQQAAAAQAwQAAAAgAwQAAAAgBgQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgFQQAAAAQFQQAAAAQAwQAAAAgBgQAAAAgAwQAAAAgAwQAAAAgVQ8AAAAQAwQAAAAgAwQAAAAgFQQAAAAQFQQAAAAQAwQAAAAgAwQAAAAgFw8AAAASFQ8AAAAQFQ8AAAAQVQ8AAAAQVQ8AAAAQAAQAAAAAAAQAAAAAVQ8AAAAQVQ8AAAAQFQ8AAAAQFQ8AAAAQFQ8AAAAQFQ8AAAAQFQ8AAAAQFQQAAAAUFQQAAAAUFQ8AAAAQFQ8AAAAQAw8AAAAgAwoBWAAkAwoAAAAkFQoAAAAUFQwBJQAUFQQAAAAUFQQAAAAUFQwBJQAUFQoAAAAUQw0AAAAgAwoBFAAkAwgCJQAkAwYCWAAkFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUQw0AhQAgAwoAhQAkQwgAAAAkAwYAJQAkAwQAAAAkFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUAw4BhQAgAw4BRAAgAwoAWAAgAwQCJQAkQwQAAAAkAwQAAAAkAwQBQQAgFQQBhQAUAwQBhQAkAw8AAAAgAw4BWAAgAwsBWAAkAwQAAAAkAwQAAAAkAwQAAAAgAwQBUgAgAwUAAAAgAwUAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHBEAAAIiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHBEAAAIiAAAAAAABHBEAAAIiHBEAAAUSHBEAAAISHBEAAAISHBEAAAUSHBEAAAIiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVQ8AAA8QVQ8AAA8QAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQ8AAAUQFQ8AAAUQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQwBJQIUFQwBJQIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"13\":{\"w\":8,\"h\":10,\"lower\":\"FQEAAAAUFQEAAAAUFQEAAAAUHQEAAAAkHQEAAAAkFQEAAAAUFQEAAAAUFQEAAAAUVQAAAAAYVQAAAAAYVQAAAAAUHQEAAAAgHQEAAAAgVQAAAAAQVQAAAAAQVQAAAAAUFQAAAAAYFQAAAAAYVQAAAAAUHQEAAAAgHQEAAAAgVQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAYFQAAAAAYVQAAAAAUHQEAAAAkHQEAAAAkVQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAYVQAAAAAYVQEAAAAYJQEChQAkJQEChQAkVQEAAAAYVQAAAAAYFQAAAAAYVQUAAAAQHAkAAAAyHAcAAAASZQMChQAkZQMChQAkHAcAAAASHAkAAAAyVQUAAAAQFQUAAAAQVQUAAAAQFQUAAAAQHQUAAAAkHQUAAAAkFQUAAAAUVQUAAAAUFQUAAAAQFQUAAAAQJQUCUgAUVQcAAAAUFQgAAAAUFQgAAAAUVQcAAAAUJQUCWAAUFQUAAAAQPwwAAAAaPwwAAAAaFQcAAAAUVQcAAAAUVQcAAAAUFQcAAAAUPwwAAAAaPwwAAAAaPw8AAAAaPw8AhQAaJgoAAAAyJgwAAAAWJgwAAAAWJgoAAAAyPw8AAAAaPw8AAAAa\"},\"14\":{\"w\":10,\"h\":9,\"lower\":\"PwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAATPwgAAAASPwgAAAASHwIAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQPwgAAAASPwgAAAAaPwgAAAAbPwgAAAAaHwIAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQPwgAAAAWPwgAAAAbFQAAAAAQFQAAAAAQFQAAAAAQJgIAAAAiJgIAAAAiJgIAAAAiFQAAAAAQHQAAAAAgHQAAAAAkPwgAAAATFQAAAAAQFQAAAAAQFQAAAAAQJgIAUgAiJgUAAAAyJgIAAAAiFQAAAAAQHQAAAAAgHQAAAAAkPwgAAAATFQAAAAAUFQAAAAAQFQAAAAAQJgIAEQAiJgIAAAAiJgIAAAAiFQAAAAAQHQAAAAAgHQAAAAAgPwgAAAAbPwgAAAAaHwIAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQPwgAAAAWPwgAAAAbPwgAAAAaPwgAAAAaHwIAAAAgFQAAAAAQFQAAAAAQFQAAAAAQJgQAAAAyPwgAAAAWPwgAAAAaPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAbPwgAAAAb\"},\"15\":{\"w\":10,\"h\":13,\"lower\":\"AAQAAAAgAAQAAAAQAAQAAAAQAwQAAAAgDgBAAABADgBAAABADgBAAABADgBAAABADgBAAABADgBAAABAAwQAAAAgFQQAAAAQFQQAAAAQFQQAAAAgDgBAAABADgBAAABADgBAAABADgBAAABADgBAAABADgBAAABAFQ4AAAAQFQQAAAARFQQAAAARFQ4AAAAQFQwAAAAQFQgAAAAQVQgAAAAQFQgAAAAQDgBAAABADgBAAABAFQ4AAAAQFQQAAAAQFQQAAAAUFQ4AAAAQFQwAAAAQFQoAAAAQFQkBWAAQVQgAAAAQFQgAAAAQFQcBWAAQAwQAAAAkFQQAAAAQFQQAAAAUAwQAAAAkAwMBaQAkAwMBFAAkFQMAWAAkAwMBUgAkVQQAAAAkFQUBJQAkAwQAAAAgFQQAAAAUFQQAAAAUAwQAAAAkAwMBWAAkAwMAFAAkFQMAAAAkAwMBEQAkAwMBJQAkAwMBJQAkAwQAAAAkFQQAAAAUFQQAAAAUAwQAAAAkTgBAWABETgBAAABETgBAAABETgBAEQBETgBAJQBATgBAJQBAAwQAAAAgFQQAAAAQFQQAAAAUAwQAAAAkDgBAAABETgBAAABETgBAAABEDgBAAABEDgBAAABEDgBAAABEAwQAAAAgFQQAAAAQFQQAAAAQAwQAAAAgAwQAAAAkAwMBmQAkAwMBRAAkTgBAAABETgBAAABETgBAAABEAwQAAAAgFQQAAAAQFQQAAAAQAwQAAAAgAwQAAAAgAwQAAAAgAwMBmQAgAwMBhQAgAwMBhQAgAwMBhQAgFQ4AAAAQFQwAAAAQFQwAAAAQFQ4AAAAQFQ4AAAAQFQwAAAAQFQQAAAAgAwQAAAAgAwQAAAAgAwQAAAAgFQ4AAAAQVQwAAAAQVQwAAAAQFQ4AAAAQFQ4AAAAgFQwAmQAQVQUARAAQFQYAAAAQVQYAAAAQVQcAAAAQFQ0BJQAQVQ0AAAAQVQ0AAAAQFQ0BJQAQFQ0BJQAQVQsAAAAUVQoAmQAUVQkAhQAQVQgAhQAQFQgAhQAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQwAAAEQFQwAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQwAAAEQFQwAAAEUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"16\":{\"w\":10,\"h\":13,\"lower\":\"FQQAAAAQFQQAAAAQFQAAAAAQFQAAAAAQHQAAAAAgHQAAAAAgFQAAAAAQFQAAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQAAAAAQFQAAAAAQHQAAAAAgHQAAAAAgFQAAAAAQFQAAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQAAAAAQFQAAAAAQHQAAAAAgHQAAAAAgFQAAAAAQFQAAAAAQFQQAAAAQFQQAAAAQFQQAAAAQVQMBJQAQFQAAAAAQHAQAAAAyHQAAAAAgHQAAAAAgHAQAAAAyFQAAAAAQVQMBJQAQFQQAAAAQFQQAAAAQFQMAAAAQFQEAAAAQFQAAAAAQHQAAAAAgHQAAAAAgFQAAAAAQFQEAAAAQFQMAAAAQFQQAAAAQFQQChQAQFQMAAAAQFQEAAAAQZQABhQAQJQABhQAgJQABhQAgZQABhQAQFQEAAAAQFQMAAAAQFQQChQAQFQYAAAAQFQIAAAAQFQEAAAAQFQEAAAAQHQEAAAAgHQEAAAAgFQEAAAAQFQEAAAAQFQIAAAAQFQYAAAAQFQYAAAAQFQIAAAAQFQEAAAAQFQEAAAAQHQEAAAAgHQEAAAAgFQEAAAAQFQEAAAAQFQIAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQEAAAAQFQEAAAAQHQEAAAAgHQEAAAAgFQEAAAAQFQEAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQEAAAAQFQEAAAAQHQEAAAAQHQEAAAAQFQEAAAAQFQEAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQQAAAAQFQEAAAAQHQEAAAAgHQEAAAAgFQEAAAAQFQQAAAAQFQYAAAAQFQYAAAAQPwwAAAASPwwAAAASFQQAAAAQVQIAAAAQHQIAAAAgHQIAAAAgVQIAAAAQFQQAAAAQPwwAAAASPwwAAAASPwwAAAASPwwAAAASPwwAAAASFwQAAAASFwQAAAASFwQAAAASFwQAAAASPwwAAAASPwwAAAASPwwAAAAS\"},\"17\":{\"w\":6,\"h\":16,\"lower\":\"FQQAEAAYFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAYFQQAAAAUFQQAAAAUFQQAAAAULAgAAAAUFQQAAAAYFQQAAAAYFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAYLAgAAAAUFQQAAAAUFQQAAAAULAcAAAAUFQQAAAAYFQQAAAAYFQQAAAAUFQQAAAAYFQQAAAAUFQQAAAAUFQQAAAAYPw0AAAAaFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUPw0AAAAaDgAgAABIDgAgAABIIwQAAAAUIwQAAAAUDgAgAABIDgAgAABIDgAgAABICgAgAABIIwQAAAAYIwQAAAAUCgAgAABIDgAgAABITgAgAABIDgAgAABIIwQAAAAUIwQAAAAYDgAgAABIDgAgAABIVQIAAAAUSgAgAABIIwQAAAAUIwQAAAAUCgAgAABIDgAgAABIVQMAAAAUVQQAAAAUFQQAAAAUVQQAAAAUDgAgAABIFQMAAAAUFQUAAAAUFQUAAAAUVQQAAAAUVQUAAAAUFQUAAAAUFQUAAAAUFQgAAAAUVQUAAAAUFQYAAAAUFQYAAAAUVQUAAAAUVQUAAAAUVQYAAAAYFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAULggAAAAULggAAAAUFQYAAAAUFQYAAAAULggAAAAULggAAAAUFQYAAAAYFQYAAAAUFQYAAAAUFQYAAAAYFQYAAAAYFQYAAAAU\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAEaAAAAAAABAAAAAAABPw0AAAEaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"18\":{\"w\":9,\"h\":10,\"lower\":\"PwkAAAASPwkAAAASVwEAAAASFwEAAAASVQAAAAAQFwEAAAASFwEAAAASPwkAAAASPwkAAAASHQEAAAAgVQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQAAAAAQHQEAAAAgHQEAAAAgVQAAAAAQFQAAAAAQHQAAAAAgXQAAAAAgHQAAAAAgFQAAAAAQVQAAAAAQHQEAAAAgXQEAAAAgVQAAAAAQFQAAAAAQXQAAAAAgJgEAAAAgXQAAAAAgFQAAAAAQVQAAAAAQXQEAAAAgPwkAAAASFQAAAAAQFQAAAAAQXQAAAAAgJgEAAAAgXQAAAAAgFQAAAAAQFQAAAAAQPwkAAAASXQEAAAAgVQAAAAAQFQAAAAAQXQAAAAAgJgEAAAAgXQAAAAAgFQAAAAAQVQAAAAAQXQEAAAAgHQEAAAAgVQAAAAAQFQAAAAAQXQAAAAAgJgEAAAAgXQAAAAAgFQAAAAAQVQAAAAAQHQEAAAAgHQEAAAAgVQAAAAAQFQAAAAAQHQAAAAAgXQAAAAAgHQAAAAAgFQAAAAAQVQAAAAAQHQEAAAAgPwkAAAASPwkAAAASFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQPwkAAAASPwkAAAACPwkAAAASPwkAAAASVwEAAAASJgMAAAAQJgMAAAAQJgMAAAAQVwEAAAASPwkAAAASPwkAAAAC\"},\"19\":{\"w\":8,\"h\":14,\"lower\":\"AwEAAAAgQwAAAAAgAwAAAAAgAAAAAAAgAwAAAAAgAwABUgAgAwEAAAAgAwABWAAgQwEBhQAgVQEAhQAQQwAAAAAgAAAAAAAgAwAAAAAgQwAAAAAgQwAAAAAgQwAAAAAgAwMAAAAgFQUAAAAQAwAAAAAgQAAAAAAgAAAAAAAgAAAAAAAgAwAAAAAgQAAAAAAgFQYAAAAQFQgAAAAQFQEAAAAUFQEAAAAQQwAAAAAgAwAAAAAgAwAAAAAgAwABUgAgFQoAAAAQFQoAAAAQAwEAAAAkFQEAAAAUFQEAAAAQFQMAAAAQFQoAAAAQFQoAAAAQVQoAAAAQFQoBhQAQVQoAAAAQFQEAAAAUFQEAhQAUVQoAAAAQFQoBhQAQVQoAAAAQAwMAAAAkAwMAAAAkQwIAAAAkVQEBhQAUFQEBhQAUAwIBUgAkAwMAAAAkAwMAAAAkAwIBJQAgAwIBJQAkQwIAAAAkFQIAAAAUFQIAAAAQAwIBUgAkAwMAAAAkAwMAAAAkAwIBhQAgAwIBhQAgQwIAAAAgFQIAAAAUFQIAAAAUAwIBUgAkAwMAAAAkAwMAAAAkAwMAAAAgAwMAAAAgQwIBRAAgFQIAAAAQFQIAAAAQAwIBUgAkAwMAAAAgHwUAAAAgAwMAAAAgAwMAAAAgAwIBmQAgJQIBhQAQJQIBhQAQAwIBlgAgAwMAAAAgHwcAAAAgFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQsAAAAQFQsAAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQsAAAAQFQsAAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVQkAAAEQVQkAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQsAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQsAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQsAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQsAAAEQAAAAAAABAAAAAAABFQsAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQsAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"20\":{\"w\":9,\"h\":10,\"lower\":\"Pw4AAAAaPw4AAAAaFQAAAAAYFQAAAAAYFQAAAAAYFQcAAAAUVQAAAAAYFQEAAAAYFQEAAAAYVQIAAAAUVQEAAAAUFQEAAAAYFQAAAAAYFQAAAAAYFQAAAAAYFQAAAAAYVQEAAAAYFQEAAAAYFQMAAAAUVQEChQAUFQMAAAAUFQAAAAAYFQAAAAAYVQcAAAAUVQkAAAAUVQIAAAAYFQMAAAAUFQoAAAAUVQMChQAUFQYAAAAUFQYAAAAUVQYAAAAUFQcAAAAUFQoAAAAUVQMAAAAYFQMBhQAUVQcAAAAUVQUAAAAUVQUAAAAUVQUAAAAUVQUAAAAUFQUAAAAUFQUAAAAUVQQAAAAUFQQAAAAUVQYAAAAUFQYAAAAUVQUAAAAUFQUAAAAQFQUAAAAUFQUAAAAUVQQAAAAUFQQAAAAUFQQAAAAUVQYAAAAUFQYAAAAUVQUAAAAUFQUAAAAQFQUAAAAQFQUAAAAUVQQAAAAUFQQAAAAUFQQAAAAUVQcAAAAUVQUAAAAUFQUAAAAUFQUAAAAQFQUAAAAQFQUAAAAUFQUAAAAUVQQAAAAUFQQAAAAUFQoAAAAUFQUAAAAUFQUAAAAUFQUAAAAQFQUAAAAQFQUAAAAUFQoAAAAUVQMAAAAYVQMAAAAYPw4AAAAaPw4AAAAaFQUAAAAUFQUAAAAQFQUAAAAQFQUAAAAUVQkAAAAUFQMAAAAYFQMAAAAY\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"21\":{\"w\":11,\"h\":8,\"lower\":\"PwsAAAAaPwsAAAAaFQQAAAAUFQIAAAAUVQEAAAAUFQEAAAAUVQABhQAUFQEAAAAUVQEAAAAUFQIAAAAUPwoAAAAaPw8AAAAaFQYAAAAUFQECWAAUVQEAAAAUHQEAAAAkHQEAAAAkHQEAAAAkHQEAAAAkHQEAAAAkVQEAAAAUPwoAAAAaFQMAAAAUFQMAAAAUJQECWAAUFQEAAAAUHQEAAAAkXQEAAAAkXQEAAAAkXQEAAAAkHQEAAAAkFQEAAAAUFQEAAAAUFQMAAAAQFQMAAAAQJQECWAAQFQEAAAAQXQEAAAAgJgIAAAAgJgIAAAAgJgIAAAAkXQEAAAAkFQEAAAAUFQEAAAAUFQMAAAAQFQMAAAAQJQECWAAQFQEAAAAQXQEAAAAgJgIAAAAgJgIAAAAgJgIAAAAkXQEAAAAkFQEAAAAUFQEAAAAUFQMAAAAUFQMAAAAUJQECWAAUFQEAAAAUHQEAAAAkXQEAAAAkXQEAAAAkXQEAAAAkHQEAAAAkFQEAAAAUFQEAAAAUPw8AAAAaVQYAAAAUFQECWAAUVQEAAAAUHQEAAAAkJgEAAAAkJgEAAAAkJgEAAAAkHQEAAAAkVQEAAAAUPwoAAAAaPwsAAAAaPwsAAAAaFQQAAAAUFQIAAAAUVQEAAAAUJgUEhQAmJgUEhQAmJgUEhQAmVQEAAAAYFQIAAAAUPwoAAAAa\"},\"22\":{\"w\":10,\"h\":15,\"lower\":\"AwIAAAAkAwIAAAAgHgUAAAAiAwIAAAAgTgAgAABATgAgAABADgAgAABATgAgAABEAwIBUgAgAwMAAAAgAwIAAAAkAwIAAAAgFQIAAAAQFQIAAAAQFQQAAAAQFQIAAAAQTgAgAABAAwIAAAAgAwIBUgAgAwMAAAAgTgAgAABETgAgAABEFQIAAAAQFAgAAAAgVgYChQAwFAIAAAAgTgAgAABAFQIAAAAQAwIBEQAgAwIBJQAgFQIAAAAQTgAgAABEFQIAAAAUFggAAAAwFggAAAAwFQIAAAAQTgAgAABAFQIAAAAQHgUAAAAiAwIAAAAgFQIAAAAQTgAgAABETgAgAABEFgYCJQAwFgYCJQAwFQIAAAAQIwIAAAAQFQIAAAAQFQIAAAAQTgAgAABAFQIAAAAQTgAgAABEFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAQIwIAAAAQFQIAAAAQFQIAAAAQTgAgAABAFQIAAAAQTgAgAABEIQgAAAAQVgYChQAwFAIAAAAgTgAgAABATgAgAABEFQIAAAAQXwQAAAAgFQUAAAAQFQIAAAAQFQIAAAAUFggAAAAwFggAAAAwFQIAAAAQTgAgAABATgAgAABEFQIAAAAUFgYChQAwFgYChQAwTgAgAABEFAIAAAAUFgYCJQAwFgYCJQAwFAIAAAAgTgAgAABAFQIAAAAQFQIAAAAUFggAAAAwFggAAAAwTgAgAABEVQIAAAAUVQMAAAAUFAUAAAAgXwQAAAAgTgAgAABAFQIAAAAUFQIAAAAUVgYCJQAwIQgAAAAQDgAgAABETgAgAABETgAgAABEDgAgAABEIwIAAAAQTgAgAABAFQIAAAAUFQIAAAAUFQIAAAAUVQEAAAAQTgAgAABEFQIAAAAUAwIAAAAQAwIAAAAgAwIAAAAgTgAgAABATgAgAABETgAgAABEFQIAAAAQAwIAAAAgVgcBUgA0FggAAAAwVgcBWAAwAwIAAAAgAwIAAAAgIwIBUgAQIwIBWAAQFQIAAAAQAwIBQQAgAwIBhQAgVggBUgA0IQoAAAAQVggBWAAwXwYAAAAgHwQAAAAgDgAgAABATgAgAABEFQIAAAAQAwIBUgAgAwMAAAAgFggBUgA0VgkAAAAwFggBWAAwFAcAAAAgHwQAAAAgDgAgAABADgAgAABATgAgAABEAwIBUgAgAwMAAAAg\"},\"23\":{\"w\":9,\"h\":12,\"lower\":\"FQIAAAAQTgAgAABAAwMAAAAgAwMAAAAgFQMAAAAQAwMAAAAgAwMAAAAgVQIAAAAQFQIAAAAQTgAgAABADgAgAABAAwMAAAAgAwMAAAAgFQMAAAAQAwMAAAAgAwMAAAAgTgAgAABETgAgAABADgAgAABADgAgAABAAwMAAAAgHg0AAAAiFQMAAAAQHg0AAAAiAwMAAAAgDgAgAABEDgAgAABADgAgAABADgAgAABAAwMAAAAgQwMAAAAgVQMAAAAUQwMAAAAgAwMAAAAkDgAgAABEDgAgAABADgAgAABAFQUAAAAQFQUAAAAQVQQAAAAQVQQAAAAQVQQAAAAUFQUAAAAQFQUAAAAkTgAgAABADgAgAABAAwUAAAAgHg8AAAAiFQUAAAAQFQUAAAAQFQUAAAAQHg8AAAAiAwUAAAAgFQIAAAAUFQEBhQAQAwUAAAAgAwUAAAAgAwUAAAAkFQUAAAAQAwUAAAAgAwUAAAAgAwUAAAAkFQIAAAAUFQIAAAAQQwUAAAAgAwUAAAAgAwUAAAAgFQUAAAAUAwUAAAAgAwUAAAAgFQUAAAAQVQQAAAAUVQIAAAAQFhgAAAAyFhgAAAAyVg8EUgAwFQUAAAAQVg8EWAA0FhgAAAAyFhgAAAAyFQQAAAAQFQMAAAAQFhgAAAAyFhgAAAAyFg8EUgA0FhMAAAAwFg8EWAA0FhgAAAAyFhgAAAAyVQMAAAAUVg8EmQAwVg8EhQAwFg8EhQA0Fg8ElgA0FhMAAAAwFg8EmQA0Fg8EhQAwVg8EhQA0Vg8ElgA0FhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAwFhMAAAAw\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFhMAAAgwAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"24\":{\"w\":8,\"h\":11,\"lower\":\"Fw4AAAAaFw4AAAAaFQAAAAAQHQAAAAAkFQAAAAAUFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFQAAAAAQFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUFw4AAAAaFw4AAAAaFQAAAAAQFQAAAAAUFQAAAAAQHQAAAAAgFQAAAAAUFQAAAAAUFQAAAAAYFQAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQHQAAAAAkFQAAAAAUFQAAAAAUVAgAAAAgVQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUVQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAQHQAAAAAkFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAUFQAAAAAQFQAAAAAUHQAAAAAkFQAAAAAUFQAAAAAUVAgAAAAgVQAAAAAUFQAAAAAQFAEAAAAkFAEAAAAkFAEAAAAkFAEAAAAkFAEAAAAkVQAAAAAUFQAAAAAQFQAAAAAQFAIAAAAkJgUAAAAmJgUAAAAiJgUAAAAmVAIAAAAkFQAAAAAUFQAAAAAQFw4AAAAaVAMAAAAoVAMAAAAkFAMAAAAgFAMAAAAgFAMAAAAkFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAa\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVAgAAAEgFAgAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVAgAAAEgFAgAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVAgAAAEgFAgAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVAgAAAEgFAgAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVAgAAAEgFAgAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"25\":{\"w\":10,\"h\":12,\"lower\":\"AAABUgAgAAEAAAAgAAEAAAAgAwEAAAAgFQEAAAAgFQEAAAAgAAEAAAAgAAEBUgAgAwIAAAAgAwEBWAAkAAABUgAgAAEAAAAgAwEAAAAgFQEAAAAgFQEAAAAgFQEAAAAgAAEAAAAgAAEBUgAgHgcAAAAiAwEBWAAkAwABlgAgAwEAAAAgAwEAAAAgAwEAAAAgFQEAAAAgFQEAAAAgAwEAAAAgAAEBEQAgAAEBJQAkAwEBFAAkAwEBRAAgAwEAAAAgAwEAAAAgFQEAAAAgFQEAAAAgFQEAAAAgAwEAAAAgAAEAAAAgAwEAAAAgHgYAAAAiFwYAAAAQFwYAAAAQVwYAAAAQFwsAAAAQZQEChQAUFwsAAAAQVwYAAAAQFwYAAAASAwEAAAAgAwEAAAAkAAMAAAAUAAMAAAAUAwMAAAAUAwMAAAAUFQMAAAAUAwMAAAAUFwYAAAAUFwYAAAAQFwYAAAASAwEAAAAkAAMAAAAQFQMAAAAQAwMAAAAQAwMAAAAQFQMAAAAUAwMAAAAUAwMAAAAUFwYAAAAUFwYAAAAQAwABJQAkAAMAAAAQAwMAAAAQAwMAAAAQAwMAAAAQFQMAAAAQAwMAAAAQAwMAAAAQAwMAAAAUFwYAAAAQAwABhQAkAAMAAAAQAwMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQAwMAAAAQAwMAAAAQHAwAAAAiVwYAAAASAAMAAAAQAAMAAAAQFQMAAAAQFgkAAAAwFggBWAAwFQMAAAAQFQMAAAAQAAMAAAAQZQMIUgAgVAsAAAAgFgkCUgAwFgsAAAAwFgkCWAAwFgkAAAAwVggBWAAwFQMAAAAUFQMAAAAQFwYAAAAQHAwAAAAiVwYAAAAUFgkCUgA0FgsAAAA0FgkCWAA0FgkAAAA0IQkAAAAUFQMAAAAUFAYCUgAkFAgAAAAkFwYAAAAUFwYAAAAU\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFwsAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"26\":{\"w\":4,\"h\":18,\"lower\":\"FQcAAAAUFQcAAAAUFQAAAAAUHwIAAAAkFQcAAAAUFQcAAAAUFQAAAAAYFQAAAAAUKQkAAAAkFQcAAAAUVQAAAAAYVQAAAAAUKQkBhQAkFQcAAAAUVQEAAAAYVQEAAAAUKQoAAAAkFQcAAAAUFQIAAAAUKQMBhQAkKQkBhQAkFQcAAAAUFQQAAAAUKQQAAAAkKQgCJQAkFQcAAAAUFQQBhQAUaQMBJQAkFQcAAAAUFQcAAAAUVQUAAAAUFQMAAAAUFQcAAAAUFQcAAAAUVQYAAAAUFQMAAAAUFQcBhQAUFQcBhQAUVQUAAAAUVQMAAAAUFQgAAAAUHwoAAAAkVQQAAAAUVQQAAAAUFQgAAAAUFQgAAAAUHwYAAAAkVAUAAAAkFQgAAAAUFQgAAAAUFQQAAAAYFAUBhQAkFQYAAAAYFQYAAAAUFQQAAAAUFAYBhQAkFQYAAAAUHwgAAAAkFQUAAAAUFAcAAAAkHAwAAAAmHAoCWAAmVQkAAAAUFAcBhQAkFQsAAAAUFQkCWAAUFQkAAAAUVAgBhQAkHAwAAAAmHAoCWAAmVQkAAAAUFQkAAAAU\"},\"27\":{\"w\":10,\"h\":10,\"lower\":\"BQABUgAgBQEBUgAgBQIAAAAgRQEAAAAgBQEAAAAgBQEAAAAgBQEAAAAgRQEAAAAgFQIAAAAgBQEBWAAgRQABUgAgBQEBUgAgBQIAAAAgRQEAAAAgRQAAAAAgBQEDhQAgBQEDhQAgRQEAAAAgRQEAAAAgRQEAAAAgBQIAAAAgFgUCUgAgFgcBhQAgFgcBhQAgFgcBRAAgRQQDhQAgBQQDhQAgBQIAAAAgBQABJQAgRQABFAAgBQIAAAAgFgUCEQAgFggChQAgFggChQAgFgcBWAAgBQcAAAAgBQcAAAAgBQAAAAAkBQAAAAAgBQAAAAAgRQEAAAAgBQEAAAAkVg8ChQAgVg8ChQAgVgwChQAgFgwChQAgBQcAAAAgFgUCWAAgBQAAAAAkBQAAAAAkBQIAAAAgFgUCUgAgVg8CJQAgVg8CJQAgFg4AAAAgFg4AAAAgFAcAAAAkFgUCWAAkBQAAAAAkBQAAAAAkRQIAAAAgFgUCUgAgFgsCEQAkVgsCJQAkIRAAAAAgVgwCJQAgFAcAAAAkBQEAAAAkRQAAAAAkBQAAAAAkRQMAAAAgRQQAAAAkBQUAAAAkRQQAAAAkBQUAAAAkBQUBUgAkRQYAAAAkRQEAAAAkRQAAAAAkBQAAAAAkRQIAAAAgRQIAAAAgRQQAAAAkBQQAAAAkRQMAAAAkBQMAAAAkBQIAAAAkBQEBWAAkBQABWAAkBQAAAAAkRQEAAAAgRQMAAAAgBQQAAAAgRQICJQAgRQIAAAAkRQIAAAAkBQIAAAAkBQEBWAAkBQABWAAkBQAAAAAk\"},\"28\":{\"w\":13,\"h\":11,\"lower\":\"BQQBhQAgRQMAWAAgFQQChQAQBQQChQAgBQMAAAAgBQMAUgAgRQECmQAgBQMAUgAgRQECRAAgRQEAAAAgBQIAhQAgBQIAAAAgBQIAUgAgRQUBhQAgBQYAlgAgBQYARAAgBQYARAAgBQYAWAAgBQMDWAAgRQMAAAAgBQQAAAAgBQECWAAgBQEAUgAgRQEAUgAgRQEBUgAgBQIAAAAgBQYChQAgBQYChQAgBQYAWAAgBQYAAAAgBQgAhQAgBQMAWAAkBQECWAAgBQAAUgAkBQAAAAAkRQAAAAAgRQABUgAgRQEAWAAgBQIAWAAgBQgChQAgBQgCRAAgBQYAAAAgBQYAUgAgBQYAAAAgBQMCWAAkBQECWAAgBQAAAAAgBQAAWAAgBQAAAAAgRQAAhQAgBQIAAAAgBQIAAAAgBQoAUgAgBQgCWAAgBQYChQAgBQYCRAAgBQYAUgAgBQMCWAAgBQECWAAgHAgAAAAiBQIDhQAgBQIDhQAgRQIBhQAgBQIChQAgBQICRAAgBQwAAAAgFQwAAAAQBQgAAAAgBQYCWAAgBQYAAAAgRQMCWAAgBQMAAAAgHAgAAAAiBQUAAAAgBQUAAAAgBQUAAAAgRQQBhQAgRQICWAAgBQwAAAAgBQwAAAAgRQYCJQAkBQYCFAAgBQYAAAAgBQMDWAAgBQMAAAAgHAkAAAAiBQUAAAAgBQUAAAAgBQUAAAAgBQUAAAAgRQQAAAAgBQwAAAAgBQwAAAAgBQcAAAAkBQYAAAAkBQYAAAAgBQYCQQAgRQYChQAgBQoAAAAgBQwAAAAgBQUAAAAgBQUAAAAgBQUAAAAgRQQAAAAgBQoAAAAgBQoAAAAkBQgBhQAkBQUBJQAkBQUBJQAgBQoAAAAgRQgChQAgBQoAAAAgRQwAAAAgBQoAAAAiBQYChQAgBQYChQAgFQYChQAQBQoAAAAgBQoAAAAgRQkAAAAgFQsAAAAgVQsAAAAgBQwBQQAgBQwBRAAgRQsAAAAgBQ0AAAAgBQoDWAAgBQgChQAgBQgCRAAgBQgAAAAgBQoAAAAgBQoAAAAgRQkAAAAgRQoAAAAgRQoAAAAgBQwBUgAgBQwBWAAgRQsAAAAgRQwAAAAgRQoCWAAgBQoAAAAgBQgCWAAgBQgAAAAg\"},\"29\":{\"w\":12,\"h\":13,\"lower\":\"BQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQMAAAAgRQIAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQIAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAkBQAAAAAkBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQEChQAgRQADhQAgBQADhQAgBQADhQAgBQADRAAgBQAAAAAgBQADQQAgBQADhQAgBQADhQAgBQADhQAgRQAAAAAgBQADhQAgBQQAAAAgBQMChQAgBQMChQAgBQMChQAgRQMAAAAgRQEBhQAgBQMCQQAgRQMChQAgBQYBUgAgBQgAAAAgBQAAAAAkBQcBmQAgRQYBhQAgBQcChQAgBQcChQAgBQcChQAgBQMAAAAkBQMAAAAgBQMCUgAgBQUAAAAgBQYBUgAgBQgAAAAgCgAAAAAkBQgAAAAgRQgAAAAgBQkAAAAgBQkAAAAgBQkAAAAgRQgAAAAgRQUChQAgBQUChQAgBQUChQAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQkAAAAgBQwChQAgBQwChQAgBQwChQAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQgAAAAgBQoChQAgBQ4AAAAgBQ4AAAAgBQ4AAAAgRQgAAAAkRQkBhQAgRQcBJQAgBQgCQQAgBQgChQAgBQgChQAgRQgAAAAgBQgAAAAgRQwAAAAgBQ4AAAAgBRAChQAgBRAChQAgBQ0BhQAgBQoCWAAgBQYAAAAkBQgCUgAgBQoBhQAgRQoAAAAgRQgChQAgBQgCRAAgBQ0AAAAgBQ4ChQAgBRIAAAAgHBMAAAAiBQ8BhQAgRQ8AAAAgBQYAAAAkBQ0BWAAgBQsBWAAgRQoAAAAgBQoAAAAgBQgCWAAgBQ8ChQAgBRIAAAAgBRIAAAAgBRIAAAAgRREAAAAgRRABUgAgBREAAAAgBREBUgAgBRIBQQAgBQoAAAAkBRIBhQAgBRIBRAAgRREAAAAgBRIBQQAgBRIBhQAgBRIBRAAgBREBWAAgBREAAAAgBREAAAAgBREBUgAgBRIBUgAgBRMAAAAgBRMAAAAgBRIBWAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQgAAAIgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQgAAAIgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQ4BWAIgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBRIBhQIgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"30\":{\"w\":11,\"h\":11,\"lower\":\"BQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQ0AAAAgBQ0BQQAgBQ0BhQAgBQAAAAAgBQAAAAAgFAEChQAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAkBQ0BUgAgBQ4AAAAgBQAAAAAgBQAAAAAgFAMChQAgBQAAAAAkBQAAAAAgBQAAAAAgBQAAAAAgBQEBhQAgRQoAAAAgBQ0BUgAgBQ4AAAAgBQAAAAAgBQAAAAAgFAUChQAgBQAAAAAkBQAAAAAgBQAAAAAgBQAAAAAgRQMAAAAgRQkAAAAgRQ0BUgAgBQ4AAAAgBQAAAAAgBQAAAAAgBQcAAAAgBQcAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQQBhQAgBQcBJQAgBQ4BQQAgBQ4BhQAgBQAAAAAgBQAAAAAgAAAAAAAgAAAAAAAkBQAAAAAkBQAAAAAgBQAAAAAgRQYAAAAgBQcAAAAgBQ4BUgAgBQ8AAAAgBQAAAAAgBQAAAAAgAAAAAAAgAAAAAAAgBQAAAAAkBQAAAAAkBQAAAAAgBQcAAAAgBQcAAAAgBQcAAAAkBQ8AAAAgBQADhQAgBQADhQAgBQcAAAAgBQcAAAAgBQAAAAAkBQAAAAAkBQAAAAAkBQcAAAAgBQcAAAAgBQ4BUgAgBQ8AAAAgBQkAAAAgBQcCWAAgBQcAAAAgBQcAAAAgRQcAAAAgBQcDhQAgBQcDhQAgBQcDhQAgBQcDhQAgBQ4BUgAgBQ8AAAAgBQkChQAgBQ4BQQAgBQ4BhQAgBQcAAAAkBQ4BhQAgBQ4BhQAgRQsChQAgBQsChQAgBQsChQAgBQ4BUgAgBQ8AAAAgBQwAAAAgBQ4BUgAgBQ8AAAAgBQ8AAAAgBQ8AAAAgBQ8AAAAgRQ4BhQAgBQ4BhQAgBQ4BhQAgBQ4BlgAgBQ8AAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQsBJQUgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQcAAAEgBQcAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQcAAAEgBQcAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQ4BUgEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQ4BhQEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"31\":{\"w\":9,\"h\":11,\"lower\":\"AwAAAAAgAwAAAAAgAwAAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQAwAAAAAgAwAAAAAgIQkAAAAQFgYChQAwFgYChQAwVQABhQAQFQABhQAQFQABhQAQFQABhQAQAwABhQAgAwABhQAgFgkAAAAwFgkAAAAwFgkAAAAwFQIAAAAUVQEBhQAQFQEBhQAQFQEBhQAQAwUAAAAgAwUAAAAgFgYCJQAwFgYCJQAwVgYCJQAwAwIBhQAkFQIBhQAUFQIBhQAQFQIBhQAQAwUAAAAgHg4AAAAiFgwEUgAwIREAAAAQFgwBWAAwQwMBhQAkFQMBhQAUFQMBhQAUVQMBhQAQAwUAAAAgAwUAAAAkFgwEUgAwVg0DWAAwFgwBWAAwFQUAAAAUVQQBhQAUVQQBhQAUFQUAAAAQFQUAAAAQFQUAAAAQFgwEUgAwFhAAAAAwFgkAAAA0AwUBhQAkAwUBhQAUFQUBhQAQFQUBhQAQFgwAAAAwFQUAAAAQVgwEUgAwVg0DWAAwFgkAAAA0QwYBhQAkAwYBhQAkFQYBhQAUFQYBhQAQFgwAAAAwVQUAAAAUIRMAAAAQFg4EWAAwVQgAAAAQFQgAAAAQVQcBhQAUFQcBhQAUFQcBhQAUFgwAAAAwFQYAAAAUVg4EUgAwVg4EWAAwFgwAAAAwAwgAAAAgAwgAAAAkAwgAAAAkAwgAAAAkVgwDhQAwFgwDhQAwFhIAAAAwFhIAAAAwFgwAAAA0AwgAAAAkAwgAAAAkAwgAAAAkAwgAAAAkVgwDJQAwIRAAAAAQ\"},\"32\":{\"w\":10,\"h\":16,\"lower\":\"EQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAAAEBQQAgAAEBhQAgQAEBRAAgTwAgAABADwAgAABADwAgAABAAAEBQQAgAAEBhQAgQAEBRAAgTwAgAABAQAEBlgAgAAIAAAAgAAIAAAAgQAIAAAAgTwAgAABAAAEBQQAgAAEBlgAgAwIAAAAgAwIAAAAgFQIAAAAQFQMAAAAQQAIAAAAgQAIAAAAgAwMBQQAgAwMBhQAgVggAAAAgFggAAAAgFgoAAAAgAwQAAAAgAwQAAAAgFQMAAAAQQAIBhQAgAAIBhQAgFgoAAAAgVgkAAAAgFgkAAAAgVggAAAAgFggAAAAgFgYCWAAkHwYAAAAgFQMAAAAQAAMAAAAgFQMAAAAgVgcCUgAgFgkAAAAgFgkAAAAgVggAAAAgVggAAAAgFgkAAAAgFgkAAAAgAwMAAAAgAwMAAAAgAAMAAAAgFgcCUgAgFgkAAAAgFgkAAAAgVgkAAAAgFgoAAAAgFgcCJQAgFgcCJQAgAAMAAAAgAwMAAAAgAAMAAAAgVgcAAAAgFgcAAAAgFgUCWAAkHwUAAAAkHwUAAAAkAAMAAAAkAAMAAAAkAwMAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAkAAMAAAAkAAMAAAAkAAMAAAAkAAMAAAAkAAMAAAAkVgYAAAAgFgcAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAgAAMAAAAkFgYAAAAgVgQCWAAgAAMAAAAkAAMAAAAgAAMAAAAgAAMAAAAgHwUAAAAgFgcChQAgFgcChQAgFgoAAAAgAAEAAAAgAAEAAAAkAAMAAAAgAAMAAAAgFgcCUgAgFgkAAAAgFgcAAAAgFgkAAAAgVgkAAAAgFgoAAAAgCgAgAABAQAEAAAAgAAIBJQAgAAIBJQAgFgsAAAAgFgkAAAAgFgkAAAAgFg0CUgAgVg8AAAAgFhAAAAAgSgAgAABAAwIAAAAgAwIAAAAgAAIAAAAgVgcCUgAgFgkAAAAgFgkAAAAgFg0CUgAgVg8AAAAgVhAAAAAgQAEBQQAgAwIAAAAgAwIAAAAgAAIBQQAgFgcCUgAgFgkAAAAgFgkAAAAgVg0AAAAgVg4AAAAgFhEAAAAgAAEBUgAgQAIAAAAgAAIBhQAgAAIBlgAgHwUAAAAgFgkAAAAgFgkAAAAgFgsAAAAgFg4AAAAgFg8CJQAg\"},\"33\":{\"w\":9,\"h\":13,\"lower\":\"FQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYPwwAAAAiFQEAAAAYFQEAAAAYFQEAAAAYHwIAAAAoFQEAAAAYFQEAAAAoJgIAAAAoFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYFQAAAAAYFQEAAAAYJgIAAAAkJgIAAAAkFQEAAAAUPwwAAAAiZgIAAAAqHQEAAAAoHQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAUHAQAAAAiJgIAAAAkPwwAAAAiZgIAAAAoHQEAAAAoHQEAAAAoFQEAAAAYPwwAAAAqPwwAAAAiPwwAAAAiPwwAAAAiPwwAAAAiJgIAAAAoJQEGWAAoHQEAAAAoFQEAAAAYFQEAAAAYJgMAAAAoJgMAAAAkJgMAAAAqPwwAAAAiJggAAAAYZgIAAAAoFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAUHAQAAAAyPwwAAAAiPwwAAAAiPwwAAAAiFQEAAAAYPwwAAAAiFAIAAAAoFQEAAAAYHQEAAAAkHQEAAAAkPwwAAAAiJgoAAAAaFQEAAAAYFQEAAAAYFQEAAAAYFAIAAAAoFQEAAAAYFQEAAAAUHAQAAAAyPwwAAAAiJgQAAAAkZQEDWAAkHQEAAAAUFQEAAAAYFAIAAAAoFQEAAAAYHQEAAAAkHQEAAAAkPwwAAAAiJgQAAAAkJgUAAAAiJgIAAAAkFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAUHAQAAAAyPwwAAAAiJgQAAAAkFQEAAAAUFQEAAAAUFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAUFQEAAAAUFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYFQEAAAAYHwIAAAA4FQEAAAAoFQEAAAAYFQEAAAAYPwwAAAAiFQEAAAAYFQEAAAAYFQEAAAAYGwMAAAAo\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwwAAAUiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABZgYAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABZgYAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABJgYAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwwAAAUiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABJgoAAAMmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwwAAAUiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"34\":{\"w\":11,\"h\":10,\"lower\":\"AAMAAAAgAwIBWAAgAwAAAAAgAwAAAAAgHAYAAAASFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQAAAAAAAgQAIAAAAgQAABWAAgAAAAAAAgAAAAAAAgAAAAAAAgFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQAAAAAAAgAAIAAAAgQAABFAAgAAAAAAAgAAAAAAAgHAcAAAASFQAAAAAUHwIAAAAkFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQAAEBJQAgQAAAAAAgAAAAAAAgAAAAAAAgFwUBUgAQHAYAAAASHAYAAAASFQAAAAAUFQAAAAAQFQAAAAAUFQAAAAAQAAABJQAgQwAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgAwAAAAAkFwcAAAAQFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUAwAAAAAgQwAAAAAkQwAAAAAgAwAAAAAgHgYAAAAiAwAAAAAgFwYBJQAQFggAAAAyVQAAAAAUFggAAAAyFwYBJQAQHggAAAAiQwEAAAAgQwABmQAgQwAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgFQAAAAAQQwMAAAAgQwIBRAAgQAEBWAAgQwABWAAgQwABQQAgAAABhQAgAAABRAAgAAAAAAAgQAAAAAAgQAAAAAAgAAAAAAAgAwQBhQAgAwIBmQAgQwIBhQAkQwIBRAAgQwEBmQAgAAEBhQAgQwABWAAgAwAAAAAgAAABUgAkAAEBUgAgQAIAAAAgAAUAAAAgHgoAAAAiQwQAAAAgQAMAAAAgAAIBWAAgAAIAAAAgAwIAAAAgAAICUgAgAAQAAAAgAAQAAAAgQwMAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFgkAAAMyAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"35\":{\"w\":10,\"h\":13,\"lower\":\"AwAAAAAgAwAAAAAgAAAAAAAgAwAAAAAgAAABQQAgAAABhQAgAwABlgAgAwEBQQAgAwEBlgAgAwIBQQAgAwABhQAgAwABRAAgAAAAAAAgAAABQQAgAwABlgAgAwEBQQAgQwEBhQAgAwEBlgAgAwIBQQAgAAIBlgAgAwUAAAAgAAUAAAAgAAUAAAAgAAUAAAAgAAQBWAAgAAMBWAAgAwIBmQAgAwIBRAAgAAIBUgAgAAMAAAAgFQwAAAAQAAUAAAAgFQwAAAAQAAUAAAAgAAQBWAAgAwMBmQAgAwMBRAAgAwIBWAAgAAIBEQAgFQYChQAQFQwAAAAQAAUAAAAkFQwAAAAQFQkAAAAUVQgAAAAQFQkAAAAQVQgAAAAQFQkAAAAQVQgAAAAQFQgAAAAQVQgAAAAUFQUAAAAkFQQBaQAkFQQBFAAkFQQAAAAkFQQAAAAkAwQAAAAkAwQAAAAkAwQAAAAkXwcAAAAkFQkAAAAQFQQBJQAkFQQBFAAkFQQAAAAkFQMBaQAkFQMBJQAkAwMBJQAkAwMBJQAkAwMBZgAkHwUAAAAgVQcAAAAUFQQAAAAkFQMBaQAkFQMBJQAkFQMBFAAkFQMAAAAkAwMAAAAkAwMAAAAkVggBhQAwIQoAAAAQHwUAAAAkVQMBJQAkFQMBFAAkFQIBaQAkFQIBJQAkFQIBJQAkFQIBJQAUFQIBJQAUFgkBhQAwVgkBhQAwAwMAAAAkAwIBaQAkFQIBJQAkFQIBFAAkFQIAAAAkFQIAAAAQFQIAAAAUFQIAAAAQFgoAAAAwFgoAAAAwFQIBJQAUFQIBFAAUFgcCUgAwFgkAAAAwFgcCWAAwAwIBhQAgFQIBhQAQFQIBRAAQFggCJQAwFggCJQA0FQIAAAAQHwQAAAAgFgcCUgAwFgkAAAAwVgcCWAAwAwMBQQAkAwMBhQAgFggAAAAwFggAAAA0FggAAAA0HwQAAAAgHwYAAAAgFgcCUgAwVgkAAAAwIQoAAAAQAwMBUgAkAwQBQQAgFgYCJQA0FgYCJQA0FgYCJQA0\",\"upper\":\"AAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARFQwAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQwAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"36\":{\"w\":10,\"h\":10,\"lower\":\"FgcDUgAwFgoAAAAwFgcDWAA0AwIAAAAQQwEAAAAgAwEAAAAgAwEAAAAgFQEAAAAQFQEBQQAQAwEBhQAgFgcDUgAwFgoARgAwFgcDWAA0FQIAAAAUFQIAAAAUQwEAAAAgAwEAAAAgFQEAhQAQAwEBUgAgAwIAAAAgFgcDUgAwFgoAAAAwFgcDWAA0FQIAAAAUAwIAAAAkQwEAhQAkAwEBQQAgFQEBhQAQAwEBlgAgAwIAAAAgFg0DUgAwFhAAAAAwFg0DWAA0FQIAAAAUFQIAAAAUFggBhQAwFggBhQAwFQIAAAAQFQIAAAAQFQIAhQAQFg0DUgAwFhAAAAAwFg0DWAA0FQIAAAAUFQIAAAAUFgkAAAAwVgkAAAAQFQcAAAAQAwIBRAAkAwIAhQAkFg0DUgAwVhAAAAAwIREAWAAQVBMAAAAgFBMAAAAgVBMAAAAgFQoAAAAQFQMAAAAUAwIBmQAUAwIBhQAkFg0DUgAwVhAAAAAwIREAWAAQFh4AAAAyFh8AAAAyFh4BAAAyFQsAAAAUAwMBhQAUFQMAAAAUAwMAAAAkVg0BUgAwFg4AAAA0Fg0AWAA0FQsAAAAUFQsAAAAUFQsAAAAUFQsAAAAUFQQAAAAUFQMBhQAUAwMBRAAkFQgAAAAUFQgAAAAUFAkAAAAkVAoAAAAkFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUAwMBWAAkVQcAAAAUVQYAAAAUFQUAAAAUAwQAAAAUFQQAAAAUAwQAAAAUFQQAAAAkHg0AAAAmAwQAAAAkAwMBWAAk\"},\"37\":{\"w\":9,\"h\":12,\"lower\":\"AwEAAAAkAwABWAAkFQAAAAAUIAAAAAAUIAAAAAAUFQAAAAAUAwABQQAkAwABhQAkAwABRAAgIAEBhQAUQwABFAAkFQAAAAAUVQAAAAAUVQAAAAAUVQAAAAAUAwABUgAkHgoAAAAmAwABWAAgIAIAAAAUFQAAAAAUYAAAAAAUYAEAAAAUIAEAAAAWIAEAAAAUQAABEQAkAwABJQAkAwABFAAgIAACJQAUVQAAAAAUVQAAAAAUVQAAAAAUVQAAAAAUVQAAAAAUVQAAAAAUVQAAAAAUIAAAAAAQIAAAAAAUFQAAAAAUIAEAAAAUVQAAAAAUFQAAAAAUVQAAAAAUIAEAAAAUIAABWAAUIAAAAAAUHAsAAAAWYAkAAAAQIAMAAAAUHAwAAAASFQAAAAAQHAsAAAASIAMAAAAUHAgAAAASXAYAAAASAwAChQAgAwABhQAgAAABhQAgQAAAAAAgAAAAAAAgAAAAAAAgQAAAAAAgAwABUgAgAwEAAAAgQwIAAAAgQwEBWAAgQAEAAAAgQAABWAAgQAAAAAAgQwABhQAgAwEBhQAgQwEAAAAgQwABJQAgAwMBhQAgQAMAAAAgAwEBWAAgAAEAAAAgQwABUgAkAwIBhQAgQwIAAAAgAwEBWAAgQwABhQAgHg0AAAAiAwMBWAAgAwEBWAAgAAEAAAAgAwECUgAkAwMAAAAgQwACWAAgQwABUgAkAwEAAAAgAAMBJQAgAwMBFAAgAwEBFAAgAAEAAAAgAwECUgAgHgwAAAAiAwACWAAgAwABUgAgAwEAAAAkAwMAAAAgQwEBWAAgAwEAAAAgAAEAAAAgQwEAAAAgQAIAAAAgQwAAAAAgAwABEQAgAAABJQAg\",\"upper\":\"AAAAAAAhAAAAAAAhAAAAAAARAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARAAAAAAAhAAAAAAARAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARAAAAAAARAAAAAAARAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARAAAAAAARAAAAAAARAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARAAAAAAARAAAAAAARAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAARAAAAAAARAAAAAAARAAAAAAABIAwAAAQQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAhAAAAAAAhAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"38\":{\"w\":8,\"h\":11,\"lower\":\"VggChQAwFggChQAwVggChQAwFQYAAAAQQwQBWAAgQwMBJQAgAwAChQAgAwACRAAgVggCJQAwIQsAAAAQVggCJQAwIwcAAAAQQwMCFAAkAwIBJQAgQwIAAAAgAwACWAAgFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUVQAAAAAUQwEAAAAgQwABWAAgFQAAAAAQFQAAAAAQFQAAAAAQIwcAAAAQFQAAAAAQFQAAAAAQQwABQQAgQAABhQAgVgoChQAwKQ4AAAAgVgoChQAwFQgAAAAQVgoChQAwKQ4AAAAgVgoChQAwAwEBhQAgVgoCJQA0FgwCJQAkVgoCJQA0FQgAAAAQVgoCJQA0FgwCJQAkVgoCJQA0AwIChQAgQwcAAAAkFQgAAAAUFQgAAAAUFQgAAAAQFQgAAAAUFQgAAAAUFgkAAAAkAwUBhQAgQwcAAAAgFQgAAAAQFgwChQAwFQgAAAAUFgwChQAwFgcBJQAwVgcBJQAwQwYBRAAgAwgAAAAgFQgAAAAQFg8AAAAgKRYAAAAwFg8AAAAgAwcAAAAgQwcAAAAgAwYBWAAgAwgBhQAgFgsCQQAwFg4BJQAgVQ4AAAAUFg4BJQAkFgsCRAAwAwgAAAAgAwYBFAAgAwoAAAAgFgsCUgAwVg0AAAAwFQ4AAAAQVg0AAAA0FgsCWAA0AwoAAAAkAwYAAAAk\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"39\":{\"w\":6,\"h\":18,\"lower\":\"FAQAAAAkVAMAAAAkVAIAAAAkVAEAAAAkQAAAAAAkAAAAAAAkFAQAAAAkFAQAAAAkAAAAAAAkQAAAAAAkAAAAAAAkAAAAAAAkFAQBhQAkVAQAAAAkAAAAAAAkAAAAAAAkBgADQQAWBgADhQASFAUAAAAkVQQAAAAUAAAAAAAoAAAAAAAoBgADUgAWBgIAAAASFAQBJQAkVAQAAAAkAAAAAAAoAAAAAAAoBgADEQAWBgADJQASFAQAAAAoFAQAAAAkFAQAAAAkAAAAAAAoAAAAAAAoAAAAAAAoPwsCUgASFAQAAAAkFAQAAAAkFAQAAAAkBgADhQAaBgADRAAaPwsCUgASPw0AAAASFAQAAAAkFAQAAAAkRgMAAAAUBgADWAAaPwsCUgASPw0AAAASFAQAAAAoFAQAAAAkPwwAAAASPwkCWAASPwsCUgASPw0AAAASFAQAAAAoFAQAAAAkfwsAAAASPwkCWAASPwsCUgASPw0AAAASFAQAAAAkFAQAAAAkFwQFJQAWFwQFJQAWPwsCUgASFAQAAAAkFAQAAAAkFAQAAAAkFAQAAAAkVAMAAAAkPwsCUgASFAQAAAAkFAQAAAAkFAQAAAAkFAQAAAAkFAIAAAAkFAQAAAAkFAQAAAAkFAQAAAAkAAAAAAAkAAAAAAAkVAEAAAAkFAQAAAAkFAQAAAAkFAQAAAAkAAAAAAAkAAAAAAAkAAAAAAAkFAQAAAAkFAQAAAAkAAAAAAAoAAAAAAAkAAAAAAAkAAAAAAAkPwsCUgASFAQAAAAkFAQAAAAkAAAAAAAoQAAAAAAkFAIAAAAkPwsCUgASFAQAAAAkFAQAAAAkFAIAAAAkFAIAAAAkFAIAAAAk\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPw0AAAESAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"40\":{\"w\":11,\"h\":9,\"lower\":\"AwMBhQAgQwIBhQAgQwIBRAAgVAIAhQAgQwMAAAAgFQQAAAAQAwQAAAAQVQMBhQAQQwIAAAAkFAEBWAAgFAABWAAgAwYAAAAgAwQCWAAgAwQAAAAgAwMAhQAgQwMBhQAgFQQBhQAQFQQBhQAQFQQBhQAQAwACJQAkQwACFAAkQwAAAAAgQwYBhQAgFgcBlgAgFggAAAAgFgcBmQAgAwUAAAAgFQYBhQAQFQYBhQAQFQYBhQAQFgMAAAAkFgIBmQAgAwAAAAAgVQcAAAAQFggAAAAgFggAAAAgVQkAAAAQQwYAAAAkFQcBhQAQFQcBhQAQFQcBhQAQIQUAAAAUFgMAAAAgAwAAAAAkFgoBlgAgFgsAAAAgVgoBmQAgVQoAAAAQAwYAAAAkFgcBJQAwFgcBJQAwFgcBJQAwFgMAAAAoFgIBaQAoFQABhQAQFgsAAAAkVgsAAAAkIQwAAAAQVQkAAAAUQwUBJQAkVgYBJQA0FQcBhQAQVgYBJQA0AwIAAAAYQwEBFAAoFQEAAAAQFQQBJQAUVQYAAAAUFQcBUgAUFQkAAAAUFQUAAAAUFAECJQAoKQgAAAAwFAMBJQAoQwEAAAAoAwEAAAAoHwMAAAAgVQMAAAAUFgMBZgAkFgQAAAAkVgMBaQAkVQICJQAUAwABWAAoAwAAAAAoAwABUgAoFQEAAAAUFQEAAAAUAwEAAAAkVQIAAAAUFQEBWAAUFAAAAAAkFQEBUgAUFQEBWAAUVQABFAAUAwAAAAAkAwABUgAkAwEAAAAkAwEAAAAkFQEAAAAU\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFggAAAEwAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"41\":{\"w\":8,\"h\":8,\"lower\":\"FAIAAAAoFAIAAAAkFAEAAAAkFAAAAAAkFAAAAAAkFAAAAAAkFAAAAAAkFAAAAAAkGwQAAAAoFAIAAAAoFAEAAAAkFAAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkFAAAAAAkFAMAAAAoFAMAAAAoGwIAAAAkFAAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkFAAAAAAkGwUAAAAoFAQAAAAoFAAAAAAkFAAAAAAgHQAAAAAkHQAAAAAkHQAAAAAkFAAAAAAkFAQAAAAoFAQAAAAoFAAAAAAkFAAAAAAgFAAAAAAgFAAAAAAgFAAAAAAgGwAChQAoFAQAAAAoFAQAAAAoFAAAAAAkFAAAAAAgFAAAAAAgFAAAAAAgFAAAAAAgGwIChQAoFw4AAAAaFw4AAAAaGwIAAAAkGwEAAAAgFAAAAAAgFAAAAAAgFAAAAAAkFw4AAAAaFw4AAAAaFw4AAAAaFw4AAAAGFw4AAAAGFw4AAAACFw4AAAACFw4AAAAGFw4AAAAa\"},\"42\":{\"w\":10,\"h\":15,\"lower\":\"EQAgAABAEQAgAABEFQMAAAAQFQMAAAAQEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABEFQMAAAAQFQMAAAAQEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAAAEAAAAkAAEAAAAkFQMAAAAQFQMAAAAQUQAgAABAUQAgAABAEQAgAABAEQAgAABAEQAgAABAEQAgAABAFgYAAAAkFgUBWAAkFQMAAAAUFQMAAAAQQAIAAAAgAAIAAAAgUQAgAABEEQAgAABEEQAgAABAEQAgAABAFgwBhQAQVQsAAAAQHwkAAAAgFQMAAAAUAAIAAAAkAAIAAAAkAAIAAAAkAAIBUgAkQAMAAAAgEQAgAABAFg0AAAAQFg0AAAAQHwkAAAAgQwgAAAAgAwcBWAAgAwcAAAAgQwYAAAAgQwUBWAAgQAQAAAAgEQAgAABAVg0AAAAQVg0AAAAQQAgAAAAgAAgAAAAkAwcBWAAkAwcAAAAkAAcAAAAgAAYAAAAgAAQAAAAgAAEBhQAgFg4BhQAwFg4BhQAwQAgAAAAgQAgAAAAkFQkAAAAUFgsAAAAQFgsAAAAQAAYAAAAgAAQAAAAgAAIAAAAgVg8AAAAwFg8AAAAwAAkAAAAgAAkAAAAkAAkAAAAkFgsAAAAQFgsAAAAQVQYAAAAQFgYBhQAQAAIAAAAgIRAAAAAQVg4BJQAwHwoBWAAgQAkAAAAkAAkAAAAkFgsChQAwFgsChQAwFgcAAAAQFgcAAAAQAAIAAAAgIRAAAAAQVg4ChQAwAAkAAAAgAAkAAAAkAAkAAAAkFg0AAAAwFg0AAAAwFgcAAAAQFgcAAAAQAAMAAAAgFg4CJQAwFg4CJQAwAAkAAAAgAAkAAAAkAAkAAAAkIQ0AAAAQVgsCJQAwFgcChQAQAAMAAAAgAAMAAAAgFg4AAAAQFg4AAAAQAAkAAAAgAAkAAAAkFgsAAAAQFgsAAAAQFgkAAAAQFgkAAAAQAAMAAAAgAAMAAAAgFg4AAAAQFg4AAAAQHwoBWAAgQAkAAAAkFgsAAAAQFgsAAAAQFgcCJQAQFgcCJQAQXwUBhQAgAwMAAAAgXw0AAAAgXw0AAAAgHwoBWAAgQAkAAAAkFgsAAAAQFgsAAAAQFgcAAAAQFgcAAAAQHwcAAAAgHwUAAAAg\"},\"43\":{\"w\":9,\"h\":15,\"lower\":\"EQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAFAwBJQMgEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAEQCAAABAHAsAAAAiFAsBJQQgHAsAAAAiEQCAAABAVQYAAAAQFQYAAAAQEQCAAABAEQCAAABAEQCAAABEHAsAJQEiVAoBJQEgHAsAJQEiEQCAAABAHwcAAAAgVQYAAAAQFQYAAAAQFQYAAAAUHAoAAAAiKAoAWAAgKAoAAAAgKAoAAAAgHAoAJQAiVQYAAAAQFQYAAAAQFQYAAAAQFQYAAAAQHAkBJQAiaAcAAAAgKAcAAAAgaAcAAAAkHAkBJQAiFQYAAAAQFQYAAAAQFQYAAAAQFQYAAAAQYwYAAAAgaAYAAAAgKAYAAAAgaAYAAAAgYwYAAAAgFQYAAAAQFQYAAAAQHwgAAAAkFAYAAAAUHAgAAAAiaAUAAAAkHB4AAAAiaAUAAAAkHAgAAAAiFQYAAAAQFQYAAAAQVgsAAAA0VgsAZgA0HAgAUgAiaAUAAAAkKAUAAAAkaAUAhQAkHAgAhQAiFQYAAAAQFQYAAAAQVgsDUgA0VgsDWAAwXAgAAAAiaAUAAAAgKAUAhQAkaAUAhQAkXAgAAAAiFQYAAAAQFQYAAAAQVgsDUgA0VgsDWAAwXAkAAAAiaAUAAAAgKAUBhQAoaAUAhQAkXAkAAAAiFQYAAAAQFQYAAAAQVgsDUgA0VgsDWAAwHAsAAAAiaAkAAAAgKAkAAAAgaAkAAAAgHAsAAAAiFQYAAAAQFQYAAAAQVQoAAAAUVQsAAAAQHAsAAAAiHAsAhQAiaAkAAAAgHAsAAAAiHAsAAAAiFQYAAAAQFQYAAAAQFQgAAAAUFQgAAAAQEQCAAABEHAsAUgAmHAwAAAAiHAsAWAAiEQCAAABAFQYAAAAQFQYAAAAQ\",\"upper\":\"AAQAAAABAAQAAAABAAQAAAABAAQAAAEBFA4BJQEgAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAEBFA0BJQEgAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAEBAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAEBAAAAAAEBAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAAAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAEAABAAQAAAABAAQAAAABAAQAAAABAAAAAAEBAAQAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABQAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAABAAAAAAABAAQAAAABAAQAAAABAAQAAAABAAQAAAAB\"},\"44\":{\"w\":10,\"h\":14,\"lower\":\"AwEBWAAgQwAAAAAgQwAAAAAgAwABUgAgAwEAAAAgAwABWAAgAwAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAwEBmQAgAwEBhQAgAwEBRAAgQwABEQAgAwABJQAgFgUCUgAwFgcAAAAwVgUCWAA0AwAAAAAgQwAAAAAgIQkAAAAQVgcChQAwAwEBFAAgQwAAAAAgAwAAAAAgFgUCUgAwFgcAAAAwIQcAAAAQAAEBhQAkAAEBRAAgFgkAAAAwFgkAAAAwFQEAAAAUAwEBUgAgAwIAAAAgQwIAAAAgAwIAAAAkAwIAAAAkAwIAAAAkAwEBmQAgFgcCJQAwFgcCJQAwAwEAAAAkAwEBUgAkAwIAAAAgQAIAAAAgQwIAAAAgAwIAAAAkAwIAAAAkAwIAAAAkAwcAAAAgAwcAAAAgFQcAAAAQFQYAAAAQFQUAAAAQFQMAAAAQFQMAAAAQAwMBUgAgAwQAAAAgAwQAAAAgAwcAAAAgFQsAAAAQFQsAAAAQFQsAAAAQFQsAAAAQVgsCUgAwFg0AAAAwFgsCWAA0HwYAAAAgAwQAAAAgAwcAAAAgFQsAAAAQFQsAAAAQVQsAAAAQFQsAAAAQIQ0AAAAQFg0AAAAwVgsCWAA0VgcChQA0IQkAAAAQHwkAAAAgFQsAAAAQFQsAAAAQVQwAAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFQ0AAAAQFgkAAAA0FgkAAAA0ABEAAAAgAxEAAAAgAxEAAAAgFQ0AAAAQFQ0AAAAQVQ0AAAAQFQ0AAAAQFQ0AAAAQFgcCJQA0FgcCJQAwAxEAAAAgAxEAAAAgAxEAAAAgVRAAAAAQVQ8AAAAQVQ4AAAAQFQ0AAAAQFQ0AAAAQHwkAAAAkFQUAAAAUABEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgFQ0AAAAQFgoCUgA0FgwAAAAwABEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgAxEAAAAgFQ0AAAAUIQ0AAAAQVgwAAAAwABEAAAABABEAAAABABEAAAABABEAAAABABEAAAABABEAAAABABEAAAABAA0AAAABAA0AAAABAAwAAAAB\"},\"45\":{\"w\":9,\"h\":16,\"lower\":\"QwEAAAAgAwIAAAAgQwIAAAAgAwAAAAAgFQAAAAAQFQAAAAAQAwEAAAAgAwEAAAAgFQEAAAAQAwEAAAAgQwEAAAAgAwMAAAAgAwABhQAgAwEAAAAgFQEAAAAQAwEBhQAgQwEAAAAgQwAAAAAgQwEAAAAgQwEAAAAgAwMAAAAgAwEBhQAgAwIAAAAgAwIAAAAgAwIBhQAgQwEAAAAgAwMAAAAgAwIBQQAgQwIBhQAgAwMAAAAgAwIBhQAgAwMAAAAgFQMAAAAQAwMAAAAgAwMAAAAgAwMAAAAgAwIBUgAkYAYAAAAQIAYDUgAQIA0EUgAQAwMAAAAgAwMAAAAgIA0EWAAQIA4AAQASIA4ARAASAwIBUgAkIAcAAAAQAwMAAAAkAwMAAAAkAwMAAAAgAwMAAAAkFQMAAAAUIA4AEQASIA4AFAASQwQAAAAkIAgAAAAQAwMAAAAkAwMAAAAkAwMAAAAkFQMAAAAUFQMAAAAUFQMAAAAUIAcAAAAQIAUBUgAUIAgAAAAQAwMAAAAkAwMAAAAkFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUIAYBJQAQYAUAAAAQIAUAAAAQAwMAAAAkAwMAAAAkFQMAAAAQFQMAAAAQAwMAAAAgAwMAAAAkIAYAAAAQIAUAAAAQFQMAAAAQAwMAAAAgAwMAAAAgFQMAAAAQFQMAAAAQFQMAAAAQAwMAAAAkIAcAAAASFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQQAAAAQFQQAAAAQIAcAAAAQIAYBWAAQYAYAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQUAAAAQFQUAAAAUIAgAAAAQAwQAAAAkAwMBWAAgAwMAAAAgAwMAAAAgVQMAAAAQFQMAAAAQFQUAAAAQFQUAAAAUIAkAAAAQAwMBJQAkAwMBFAAgAwMAAAAgAwMAAAAgIAMBUgAQYAUAAAAUIAkAAAAQIAkAAAAQIAkAAAAQAwMAAAAgAwMAAAAgQwIAAAAgQwIAAAAgQwIBhQAgQwIAAAAkAwIAAAAkAwIBUgAkAwMAAAAkAwMBQQAgAwMBhQAgAwMAAAAgQwIAAAAgAwMAAAAkAwIBWAAkAwIAAAAkQwIAAAAkAwMAAAAgAwMBUgAgAwQAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIBEAAAcQIBEAAAcQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"46\":{\"w\":9,\"h\":15,\"lower\":\"QwIAAAAgQwIBQQAgAwIBhQAgQwIBhQAgAwQAAAAgQwMBRAAgQwIBRAAgAwIBEQAgAwIBFAAgAwMBhQAgQwMBRAAgQwMAAAAgAwMBUgAgAwQAAAAgAwMBWAAgAwIBWAAgAwIAAAAgAAIAAAAgAwQAAAAgAwQAAAAgAwQAAAAgQwIAAAAgAwMBJQAgQwIBWAAgQwIAAAAgAwIBhQAgAAIBhQAgQwIBJQAgQwIBFAAgAwIAAAAgQwIAAAAgQwMBhQAgQwIAAAAgQwIAAAAgAwMBhQAgAwMBhQAgAAIAAAAgAwIAAAAgQwIAAAAgAwIBhQAgAwUAAAAgAwIBhQAgQwIAAAAgQwIAAAAgAwICJQAgAwIAAAAgHgwAAAAiAwIAAAAgAwMBQQAgAwUBhQAgAwMBRAAgQwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAkAwIAAAAgAwYAAAAgAwIAAAAkAwIAAAAgHgwAAAAiAwIAAAAgAAIAAAAgQwIAAAAgQwMBUgAgQwQBUgAkAwUBJQAgQwQBWAAgQwMBWAAgAwIAAAAgAwIAAAAkAAIAAAAgAwIAAAAgQwQCQQAgAwUBhQAgJQUBhQAQAwUBhQAgQwQCRAAgAwIAAAAgAwIAAAAgAAIAAAAgQwIBQQAgAwQCUgAgFQcAAAAQVQYAAAAQFQcAAAAQAwQCWAAgQwIBRAAgAwIAAAAgAwQAAAAgAwQAAAAgQwQBEQAgQwcBWAAgAwYBWAAgAwYAAAAgQwQBFAAgAwQAAAAgAwQAAAAgAwICJQAgAwICJQAgAwQBhQAgQwgBQQAgLAgChQAQQwgBRAAgAwQBhQAkAwICJQAkAwICJQAkEAEgAABAEAEgAABAAwUBhQAgQwgBUgAgbAoAAAAQQwgBWAAgQwUBRAAkEAEgAABEEAEgAABEEAEgAABAEAEgAABAQwYAAAAgAwkBUgAgLA8AAAAQAwkBWAAkQwYAAAAkEAEgAABEEAEgAABEEAEgAABAEAEgAABAQwcBUgAgHhMAAAAiAwkAAAAgHhMAAAAiQwcBWAAkEAEgAABEEAEgAABE\"},\"47\":{\"w\":10,\"h\":16,\"lower\":\"HwYAAAAkXwUAAAAkHwMAAAAkFQEAAAAQFQEAAAAUFQEAAAAUFQABmQAUFQABhQAUFQABRAAQFQAAAAAQFgcChQAUFgcChQAUFgcChQAUFQEBhQAQFQEBhQAUFQEBRAAUFQEAAAAUFQEAAAAUFQABWAAUFQAAAAAQFgkAAAAwFgkAAAAwFgkAAAAwFQIAAAAQFQIAAAAQFQEBmQAUFQEBhQAUVgcChQAwIQkAAAAQVgcChQAwVgkAAAAQVgcCJQAwFgcCJQAwFQIAAAAQFQIAAAAQFQIAAAAUFQIAAAAUFgkAAAAwFgkAAAAwFgkAAAAwFgoAAAAQFgoAAAAQFQcAAAAQFQUAAAAQJQIBhQAUJQIBhQAUFQUAAAAUFgcCJQAwFgcCJQAwFgcCJQAwFgoAAAAQFgoAAAAQFgoAAAAQFQUAAAAQJQMBhQAUZQMBhQAUVQUAAAAUFQYAAAAUFQYAAAAQFQYAAAAQFgoAAAAQFgoAAAAQFgoAAAAQFQUAAAAQZQQBhQAQZQQBhQAUVQUAAAAUFQYAAAAUFQYAAAAUFQYAAAAQFgoChQAwFgoChQAwFgoChQAwFQUAAAAQFQUAAAAQFQUAAAAUVQUAAAAUFQYAAAAUHwoAAAAkHwgAAAAgVgoCJQAwIQwAAAAQVgoCJQAwCAUAAAAgCAUAAAAgCAUAAAAkSAUAAAAkFQYAAAAUVgsChQAwIQ0AAAAQCAMAAAAoCAMAAAAkCAMCUgAgCAUAAAAgCAUAAAAgCAUAAAAkSAUAAAAkFQYAAAAUFg0AAAAwFg0AAAAwCAMAAAAkCAMAAAAkCAMCUgAgCAUAAAAgCAUAAAAgCAUAAAAkSAUAAAAkVQYAAAAUFgsCJQAwFgsCJQAwFgsAAAAQFgsAAAAQFgsAAAAQCAQBJQAgCAQBJQAgCAQBJQAkCAQBJQAkFgsChQAwFgsChQAwFgsChQAwFgsAAAAQFgsAAAAQFgsAAAAQCAQAAAAgCAQAAAAgCAQAAAAkFQQAAAAUFg0AAAAwFg0AAAAwFg0AAAAwFgsAAAAQFgsAAAAQFgsAAAAQCAMBJQAgCAMBJQAgSAMBJQAgFQQAAAAUVgsCJQAwFg0AAAAQVgsCJQAwFQcAAAAQJQcCUgAQFQkAAAAQCAMAAAAgCAMAAAAgSAMAAAAgFQQAAAAUHwUAAAAkHw0AAAAgHwsAAAAgFQcAAAAQJQUCWAAQZQMCWAAQCAMAAAAgCAMAAAAgCAMAAAAgCAMAAAAgHwcAAAAkIgkAAAAgIgkAAAAg\"},\"48\":{\"w\":11,\"h\":14,\"lower\":\"DwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABADwAgAABATwAgAABATwAgAABATwAgAABATwAgAABATwAgAABATwAgAABADwAgAABADwAgAABAFgUBhQAwFgUBhQAwTwAgAABAFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQFQIAAAAQVQIAAAAQFAMAAAAgFAMAAAAgFgYAAAAwFgYAAAAwFggAAAAwFgcBWAAwQwIAAAAQVQIAAAAQQwIAAAAQQwIAAAAQFQUAAAAQFQUAAAAQVQUAAAAQVQUAAAAQVQUAAAAQFggAAAAwVgcBWAAwFQMAAAAUVQMAAAAQQwMAAAAQVQMAAAAQFQUAAAAQVQUAAAAQFggBUgAwFgkAAAAwFgkAAAAwFggAAAAwFggAAAAwQwQAAAAUVQQAAAAQQwQAAAAQVQQAAAAQFQUAAAAQVQUAAAAQFggBUgAwFgkAAAAwFgkAAAAwXwcAAAAgFQUAAAAUAwUAAAAUFQUAAAAQAwUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQVQUAAAAQFQUAAAAUFQUAAAAUFQUAAAAQFQUAAAAUFgsCUgAwFg0AAAAwFgsCWAAwFQUAAAAQAwUAAAAQFQUAAAAQFgsBUgAwFgsBWAAwFQUAAAAUFgsBUgAwFgsBWAAwFgsCUgAwFg0AAAAwFgsCWAAwFQUAAAAUFQUAAAAQFQUAAAAQFgsBUgAwFgsBWAAwFgkChQAwFgsBUgAwIQwAAAAQIQ4AAAAQVg0AAAAwFgsCWAAwFQUAAAAUFQUAAAAUFggBUgAgFgsBUgAwIQ0AAAAQFgsAAAAwFgsBUgAwVgsBWAAwHwoAAAAkFggAAAA0FQUAAAAUFQUAAAAUFQUAAAAUVggBUgAgVgoAAAAwFgkAAAAkFgkCJQA0HwoAAAAgHwgAAAAkFggAAAA0VgcBWAA0FQUAAAAUFQUAAAAUFQUAAAAUFQUAAAAUFgcCUgAgFgkAAAAgFgcAAAA0HwUAAAAgXwcAAAAkFggAAAA0FgcBWAA0FQUAAAAUFQUAAAAUFQQBaQAUFQQBJQAUFgcCUgAgFgkAAAAgFQUAAAAUVQQAAAAQFQQAAAAQFQQBUgAUAwUAAAAUFQUAAAAUFQUAAAAUFQQBWAAUFQQAAAAUFQQAAAAUQwQAAAAUFQUAAAAU\"},\"49\":{\"w\":9,\"h\":13,\"lower\":\"BQAAAAAgBQAAAAAgBQABQQAgBQABhQAgRQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQABhQAgBQABRAAgBQcAAAAgBQEBhQAgRQEBlgAgRQIAAAAgBQIBhQAgBQAAAAAkBQAAAAAgBQEAAAAgRQwAAAAQBQwAAAAQBQIBUgAkRQMAAAAgBQMBhQAgBQMBhQAgRQIBWAAgBQAAAAAgBQABJQAgBQ0AAAAQRQwAAAAQFAcAAAAkRQUAAAAgRQQAAAAgBQQAAAAgRQIBFAAgBQAAAAAgBQAAAAAgBQAAAAAgBQABEQAkFAcAAAAkBQMBUgAkBQQAAAAgBQQAAAAgRQABWAAkBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAkBQAAAAAkRQABUgAkBQEAAAAkBQEAWAAkBQABWAAkBQAAAAAgBQABQQAgBQABRAAgBQAAAAAgBQAAAAAgRQABEQAkBQABJQAgBQABJQAgBQABFAAgBQAAAAAgBQABUgAgBQUAAAAgBQAAAAAgBQAAAAAgBQAAAAAkRQQAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQABEQAgRQwAAAAQRQwAAAAQBQ0AAAAQRQwAAAAQBQUAAAAkRQQAAAAgBQABhQAgRQAAAAAgBQAAAAAgBQ0AAAAQBQ0AAAAQBQ0AAAAQRQwAAAAQBQgAAAAkBQQAAAAkBQEAAAAkRQAAAAAgBQAAAAAgBQACUgAkBQIAAAAkBQ0AAAAQBQ0AAAAQRQsAAAAQBQABJQAkRQAAAAAkBQAAAAAgBQAAAAAgBQACEQAgBQACJQAkBQABJQAkBQABJQAkBQABFAAkBQAAAAAkBQAAAAAgRQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAgBQAAAAAkBQAAAAAkBQAAAAAkBQAAAAAkRQAAAAAgBQEAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwcAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"50\":{\"w\":8,\"h\":16,\"lower\":\"AwAAAAAkAwABUgAkAwEAAAAgAwEAAAAgAwEAAAAgAwABWAAgAwAAAAAgAwAAAAAgQwABQQAkQwABlgAkAwEAAAAkAwEAAAAkQwEAAAAgQwABmQAgQwABhQAgQwABRAAgAwIAAAAkAwIAAAAkVQEAAAAUQwEAAAAkAwIAAAAkAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAkAwIAAAAkVQEAAAAUVQEAAAAUAwIAAAAkAwIAAAAkAwIAAAAgAwIAAAAgFRAAAAAQFRAAAAAQFQEAAAAUFQEAAAAUFRAAAAAQFRAAAAAQAwIAAAAgAwIAAAAkFRAAAAAQFRAAAAAQFQwAAAAQFQwAAAAQFRAAAAAQFRAAAAAQAwIAAAAgAwIAAAAkVQYAAAAUFggCUgA0FgoAAAAwFgoAAAAwFggCWAAwVQYAAAAQFQQAAAAQAwIAAAAgFgYCUgA0FggCUgA0VgoAAAA0VgoAAAAwFggCWAAwFgYCWAAwFQQAAAAQAwACJQAgVggChQA0VggClgA0FgwEQQAyFgwERAAyVggCmQAwVggChQAwVggChQAwAwAAAAAgVggCJQAwVggCZgAwFgwEEQAyFgwEFAAyVggCaQAwVggCJQAwVggCJQAwAwAAAAAkVgYCUgA0FggCEQAwFggCJQAwFggCJQAwFggCFAA0VgYCWAAwAwAAAAAgAwAAAAAkFhAAAAAyVgYCJQAwVQYAAAAQVQYAAAAQVgYCJQAwFhAAAAAyAAAAAAAgAwAAAAAkFgQAAAAwFgQCUgAwFQYAAAAQFQYAAAAQAwAAAAAgAwAAAAAgAAAAAAAgQwAAAAAkFQIAAAAQAwAAAAAgFQYAAAAQFQYAAAAQAwAAAAAkAwAAAAAkQAAAAAAgAwEAAAAgQwABhQAgAwABRAAgAwAAAAAgAwAAAAAgAwAAAAAgHgYAAAACAwABQQAkQwABhQAgAwEAAAAgAwABWAAgAwAAAAAgAwAAAAAgAwAAAAAkAwAAAAAkAwABUgAgHgcAAAAC\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQ4AAAYQFQ4AAAYUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"51\":{\"w\":10,\"h\":11,\"lower\":\"PwsAAAAaFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQPwsAAAAaFQAAAAAUFQAAAAAQVQAAAAAQHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgVQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUVQAAAAAgJgEAAAAgXQAAAAAgHQAAAAAgHQAAAAAgXQAAAAAgJgEAAAAgVQAAZgAgFQAAAAAUFQAAAAAUVQAAAAAQJgMAAAAyXQAAAAAgHQAAAAAgHQAAAAAgXQAAAAAgJgMAAAAyVQAAAAAgFQAAAAAUFQAAAAAUVQAAAAAgJgEAAAAgXQAAAAAgHQAAAAAgHQAAAAAgXQAAAAAgJgEAAAAgVQAAAAAgFQAAAAAUFQAAAAAUFQAAAAAQVQAAAAAQHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgVQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAQHAUAAAASZQABhQAgZQABhQAgHAUAAAASFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAQFQIAAAAQZQEBhQAgZQEBhQAgFQIAAAAQFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAQFQIAAAAQHQIAAAAgHQIAAAAgFQIAAAAQFQAAAAAQFQAAAAAQFQAAAAAUPwsAAAAaFQAAAAAQFQAAAAAQFQIAAAAQFQIAAAAQJgQAAAAiVQEAAAAQVQAAAAAQFQAAAAAQPwsAAAAaPwsAAAAaPwsAAAAaPwsAAAAaFQQAAAAQZgMAAAAgZgMAAAAgFQQAAAAQPwsAAAAaPwsAAAAaPwsAAAAa\"},\"52\":{\"w\":11,\"h\":12,\"lower\":\"PwYAAAAaPwYAAAAaPwYAAAAafwgAAAAaFQAAAAAYFQAAAAAYFQAAAAAYfwgAAAAaPwYAAAAaPwYAAAAaPwYAAAAaFQEAAAAYFQEAAAAYFQAAAAAYfwgAAAAaFQABhQAUVQAAAAAUFQABhQAUfwgAAAAaPwYAAAAaPwYAAAAaPwYAAAAaFQEAAAAYFQEAAAAYVQABQQAUFQABhQAUVQEBhQAUVQEAAAAUVQEBhQAUFQABhQAUFQABRAAUFQAAAAAYPwYAAAAaPwYAAAAaFQAAAAAUFQABUgAUFQEAAAAQVQMAAAAQVQIAAAAQVQMAAAAQFQEAAAAQFQABWAAUFQAAAAAYPwYAAAAaPwoAAAAaFQEBUgAUFQIBUgAQHAUAAAAyHQQAAAAgXQQAAAAgHQQAAAAgHAUAAAAyFQIBWAAQFQEBWAAUPwoAAAAaFQAAAAAYVQAAAAAUVQEAAAAQVQIAAAAQXQQAAAAgLgYAAAAQXQQAAAAgVQIAAAAQVQEAAAAQVQAAAAAUFQAAAAAYFQAAAAAYVQAAAAAUVQEAAAAQVQIAAAAQXQQAAAAgLgYAAAAQXQQAAAAgVQIAAAAQVQEAAAAQVQAAAAAUFQAAAAAYPwoAAAAaFQEBUgAUFQIBUgAQHAUAAAAyHQQAAAAgXQQAAAAgHQQAAAAgHAUAAAAyFQIBWAAQFQEBWAAUPwoAAAAaPwYAAAAaFQAAAAAUFQABUgAUFQEAAAAQVQMAAAAQVQIAAAAQVQMAAAAQFQEAAAAQFQABWAAUFQAAAAAUPwYAAAAaFQEAAAAYFQEAAAAYVQABEQAYFQABJQAUVQEBJQAUVQEAAAAUVQEBJQAUFQABJQAUFQABFAAUFQAAAAAUPwYAAAAaFQEAAAAYFQEAAAAYFQAAAAAYfwgAAAAaFQABJQAUVQAAAAAUFQABJQAUfwgAAAAaPwYAAAAaPwYAAAAaPwYAAAAaPwYAAAAaPwYAAAAaPwYAAAAafwgAAAAaFQAAAAAYFQAAAAAYFQAAAAAYfwgAAAAaPwYAAAAaPwYAAAAaPwYAAAAa\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkBUgIaPwoAAAIaPwkBWAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkBUgIaPwoAAAIaPwkBWAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkAAAIaPwkAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkBUgIaPwoAAAIaPwkBWAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwkBUgIaPwoAAAIaPwkBWAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"53\":{\"w\":9,\"h\":9,\"lower\":\"FQYAAAAUFQYCUgAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQQAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQIAAAAUFQAAAAAUGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUGQAAAAACGwgAAAAUGwgAAAAUGwgAAAAUGQAAAAACFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUGQAAAAACGwgAAAAUKQgAAAAUGwgAAAAUGQAAAAACFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUGQAAAAACGwgAAAAUGwgAAAAUGwgAAAAUGQAAAAACFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUGQAAAAACGQAAAAACGQAAAAACGQAAAAACGQAAAAACFQAAAAAUFQIAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQQAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQYCWAAUFQYAAAAU\",\"upper\":\"AAAAAAABAAAAAAABFQgAAAIUFQgAAAIUFQgAAAIUFQgAAAIUFQgAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIUAAAAAAABFQgAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIUAAAAAAABFQgAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIUAAAAAAABFQgAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIUAAAAAAABFQgAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIUFQgAAAIUFQgAAAIUFQgAAAIUFQgAAAIUAAAAAAABAAAAAAAB\"},\"54\":{\"w\":10,\"h\":14,\"lower\":\"FQEAAAAUFQEAAAAUVQEBQQAUVQIAAAAUVQIAAAAUFQUAAAAUFgYCUgAkFgcBWAAkFQcAAAAUFQcAAAAUFQABZgAUFQEAAAAUFgEDUgAkFgMBWAAkVQMBQQAUVQUAAAAUVQYBUgAUVQcAAAAUFQcAAAAUFQcAAAAUFQABEQAUFQABZgAUFgEDUgAkFgMBWAAkFQUBhQAUVQUBhQAUFQYBUgAUVQcAAAAUFgcDhQAkFgcDhQAkFQAAAAAUVQABEQAUVQEAAAAUFQEBEQAUVgMDJQAkFQYAAAAUFQYBEQAUFQYBZgAUFgkBJQAkFgkBJQAkFAAAAAAkFAAAAAAkVAAAAAAkWQAAAAAGVQEBEQAYVQQBUgAUVQUAAAAUFQYBEQAUVQgBUgAUFQkAAAAUFAAAAAAkFAAAAAAkGQAAAAAGGQAAAAAGWQAAAAAGGQAAAAAGGQAAAAAGVQYAAAAUFQgBEQAUFQgBJQAUGQAAAAAGFAAAAAAkFAAAAAAkGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGFAAAAAAkFAAAAAAkGQAAAAAGWQAAAAAGGQAAAAAGFgYBhQAkFgYBhQAkGQAAAAAGGQAAAAAGGQAAAAAGGQAAAAAGFAAAAAAkFAAAAAAkFQIAAAAUVQIBQQAYFQcAAAAUVQcAAAAUVQgBQQAUFQgBhQAUFAAAAAAkVAAAAAAkFAAAAAAkFQABQQAUFQIAAAAUFgQAAAAoVQYBJQAUVQcAZgAUFgkChQAkFgkChQAkVQAAAAAUFQEAAAAUFgQBUgAUVgUAAAAUVQQAAAAUFQQBQQAUFQYAAAAUVQgBQQAUFgoBJQAkFgoBJQAkVQEAAAAUHAEGhQAmVgQBUgAkVgUBUgAkVQYBQQAUVgcDUgAkFgkBWAAkVQkAAAAUFQoAAAAUFQoAAAAUFQEBUgAYHAcAAAAWVgYBhQAUVgYBhQAUFQcAAAAUVgcDUgAkFgkBWAAkVQgAAAAUVgkBUgAkFgoAAAAkFQEBEQAYXwQAAAAoVgQDJQAoFQcAAAAUFQcAAAAUVQcBEQAUFQcBZgAUVQgAAAAUFgkBUgAkFgoAAAAk\"},\"55\":{\"w\":17,\"h\":9,\"lower\":\"KAABUgAGJwEBUgAgJwIAUgAgJwIAUgAgKQEBWAAQKQABWAAQKQAAAAAQKQAAAAAQKQABUgAQKAEDUgAgKAQBUgAgKAUBUgAgKAYBUgAGGQAAAAAGGQAAAAAGGQAAAAAGAAAAAAADKAABUgAkJwEBUgAkJwIBQQAkJwIBhQAkKQECWAAUKQABWAAUKQAAAAAUKQABQQAUKQABlgAUKAEDUgAkKAQBUgAkKAUBUgAkKAYBUgAgJwcBUgAGGQAAAAAGGQAAAAAGAAAAAAADKAABUgAkJwEBUgAkJwIBUgAkKAMBQQAkKAEDWAAkKQABmQAUKQABhQAUKAABlgAkKAEAAAAkKAEDUgAkKAQBUgAkKAUBUgAkKAYBUgAkKAcBUgAgKAgBUgAGWQAAAAAGAAAAAAADKAABUgAkJwEBUgAkJwIBUgAkKAMBUgAkHAQEUgAmKAEAAAAkKAEAAAAkKAEAAAAkKAEAAAAkKAEDUgAkKAQBUgAkKAUBUgAkKAYBUgAkKAcBUgAkKAgBUgAgGQAAAAAGAAAAAAADHAEFWAAmJwEBUgAkJwIBUgAkJwMBUgAkKAEDWAAkKAEAAAAkKAEAAAAkKAEAAAAkKAEAAAAkKAEDUgAkKAUKhQAmKAUBUgAkJwYBUgAkJwcBUgAkKAgBUgAkKAkCUgAkAAAAAAATJwABUgAkJwEBUgAkJwIBUgAkJwMBUgAkKAEDWAAkKAEAAAAkKAEAAAAkKAEAAAAkKAEAAAAkKAEDUgAkKAQBUgAkJwUBUgAkKAYBUgAkJwcBUgAkJwgBUgAkGQAAAAAGAAAAAAADJwABUgAkJwEBUgAkJwIBUgAkKAMBEQAkKAEDWAAkKQEAAAAUKQEAAAAUKAEAAAAkKAEAAAAkKAEDUgAkKAQBUgAkJwUBUgAkKAYBUgAkJwcBUgAkJwgBUgAGGQAAAAAGAAAAAAADJwABUgAkJwEBUgAkJwIBUgAkKAMAUgAkKAECWAAkKQEAAAAUKQABaQAUKQABJQAUKQABZgAUKAEDUgAkJwQBUgAkJwUBUgAkJwYBUgAkJwcBUgAGGQAAAAAGGQAAAAAGAAAAAAADKAABUgAGJwEBUgAkJwIBUgAkKAMAAAAkKAECWAAkKQEAAAAUKQABWAAUKQAAAAAUKQABUgAUJwEDUgAkJwQBUgAkJwUBUgAkKAYBUgAGGQAAAAAGGQAAAAAGGQAAAAAGAAAAAAAD\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHAgDUgMiHAsGUgMiHBABWAMiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHA8GhQUiAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"56\":{\"w\":10,\"h\":14,\"lower\":\"EQCAAABAEQCAAABAUQCAAABAQwUBUgAgVAYAAAAgVAcAAAAgVAgAAAAgVAkAAAAgQwkAAAAgAwkAAAAgEQCAAABAEQCAAABAEQCAhQBAQwYAAAAgVAYAAAAgVAkAAAAgVAoAQQAgFAoARAAgFAoAAAAgQwkAAAAgEQCAAABABgYBlgAgAwcAUgAgAwcAAAAgAwcAJQAgFQsAAAAQFQsAAAAQVAoAAAAgFAoAEQAgAwgBJQAgBgQChQAgAwcAAAAgAwcAAAAgQwcAAAAgAwcBhQAgFQsAAAAQFQsAAAAQVAoAAAAgQwkBWAAgAwgAAAAgAwcBhQAgQwcBRAAgQwcAAAAgQwcBUgAgQwgAAAAgFQsAAAAQFQsAAAAQQwkAAAAgQwgAAAAgAwcBaQAgAwgBhQAgAwgBhQAgQwgBhQAgQwkAAAAgQwkAAAAgFQsAAAAQFQsAAAAQAwgBJQAgQwcAAAAgQwcAAAAgQwgBJQAgQwkAAAAgQwkBhQAgAwoAAAAgQwoAAAAgFQsAAAAQFQsAAAAQAwcAAAAgQwcAAAAgAwcAAAAgQwgAAAAgAwkBUgAgAwoAAAAgAwoAAAAgQwoAAAAgFQsAAAAQFQsAAAAQAwkAAAAgQwcCWAAgQwcAAAAgQwcBJQAgAwkBEQAgQwkBJQAgQwoAAAAgAwsAAAAgFQsAAAAQAwsAAAAQQwsAAAAgAwkAAAAgQwgAAAAgQwYBJQAgQwcBUgAgQwgAAAAgQwoAAAAgAwsAAAAgFhsAQQAyVhsAAAAyFhsARAAyAwgAAAAkQwcBJQAkUQCAAABAAwUBJQAgQwUBJQAgAwcCUgAgFg8DUgAyVhsAAAAyFh8AAAAyVhsAhQAyFg8DWAAyAwUBWAAoEQCAAABAUQCAAABAUQCAAABAEQCAAABAAwkAAAAkFhsAEQAyVhsAAAAyFhsAFAAyFAsAAAAoAwUBFAAoEQCAAABAEQCAAABAEQCAAABAEQCAAABAFAcAAAAgFg8DJQAyAw0AAAAYFg8DJQAyFAsAAAAoUQCAAABIEQCAAABAEQCAAABAFAcAAAAgFAcAAAAgVAcAAAAgFAcAAAAkVAgAAAAoFAkAAAAoVAoAAAAoEQCAAABI\"},\"57\":{\"w\":9,\"h\":13,\"lower\":\"IAEAAAAYIAEAAAAYFAgAAAAoPxAAAAAaFAgAAAAoIAEAAAAYIAEAAAAYYAAAAAAYYAAAAAAUIAEAAAAYIAEAAAAYFAgAAAAoFAgAAAAoFAgAAAAoIAEAAAAYYAEAAAAYGwIBhQAiGwIBhQAiIAEAAAAUIAEAAAAYIAEAAAAYIAEAAAAYIAEAAAAYIAEAAAAUIAEAAAAUYAAAAAAUIAAAAAAQIAEAAAAUJQEChQAUFAgAAAAkPxAAAAAaFAgAAAAkZQEChQAUIAEAAAAUYAAAAAAUYAAAAAAQIAEAAAAUJQMChQAUYAcAAAAQPxAAAAAaYAcAAAAQJQMChQAUYAEAAAAUGwIBhQAiJgEBhQAgIAEAAAAUIAUAAAAUJQUCJQAQPxAAAAAaJQUCJQAQIAUAAAAQIAEAAAAQYAEAAAAQYAEAAAAQIAEAAAAUIAUAAAAUIAUAAAAQIAUAAAAUIAUAAAAQIAUAAAAQIAAAAAAQIAEAAAAQIAEAAAAQIAEAAAAUIAUAAAAQJQUChQAUPxAAAAAaJQUChQAUIAUAAAAQIAEAAAAUYAEAAAAUYAEAAAAQIAEAAAAUJQMCJQAQYAcAAAAUPxAAAAAaYAcAAAAUJQMCJQAQYAEAAAAQZgEBJQAgZgEBJQAgIAEAAAAUZQECJQAQFAgAAAAoPxAAAAAaFAgAAAAoZQECJQAQIAEAAAAQYAAAAAAQYAAAAAAQIAEAAAAUIAEAAAAUIAEAAAAYIAEAAAAYIAEAAAAUIAEAAAAUIAEAAAAUYAAAAAAQYAAAAAAQIAEAAAAUIAEAAAAUFAgAAAAkFAgAAAAoFAgAAAAkIAEAAAAUYAEAAAAUJgEBJQAgJgEBJQAgIAEAAAAUIAEAAAAUPxAAAAAaPxAAAAAaPxAAAAASIAEAAAAUIAEAAAAUYAAAAAAQYAAAAAAQ\",\"upper\":\"AAAAAAAJAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAFAAAAAAABAAAAAAABPxAAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEkPxAAAAkaFAgAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPxAAAAUaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEkPxAAAAkaFAgAAAEkAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPxAAAAIaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"58\":{\"w\":10,\"h\":12,\"lower\":\"IAAAAAAUIAAAWAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQIAAAAAAQYAIAAAAUJQACWAAUIAYAAAAQIAYAAAAQYAYAAAAQYAYAAAAQIAYAAAAQIAYAAAAQJQACUgAUYAIAAAAQJQICUgAUZQQCUgAUIAYAAAAQYAYAAAAQJggAAAAgGwgAAAAgYAYAAAAQIAYAAAAQZQQCWAAQJQICWAAQIAYAAAAUIAYAAAAUIAYAAAAQIAYAAAAQYAYAAAAQYAYAAAAQIAYAAAAQIAYAAAAQIAYAAAAQIAYAAAAQIAwAAAAUIAwAUgAQIAwAhQAQIAYAAAAQZQYCUgAQZQgCUgAUZQoCUgAUIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAUIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAhQAUIAwAAAAkIAwAAAAUIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAJQAQIAwAUgAgIAwAhQAQIAwAhQAUIAwAJQAUJhIAAAAiJhIAAAAiIAwAAAAQIAwAAAAQJhIAAAAiJhIAAAAiIAwAAAAQIAwAhQAQIAwAhQAUIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAhQAUIAwAAAAQIAwAhQAQIAwAAAAUIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQIAwAAAAQJhIAAAAmJhIAAAAmJhIAhQAiJhIAhQAiIAwAAAAQIAwAAAAUJhIAUgAiJhIAAAAiJhIAAAAiJhIAAAAiJhIAWAAmJhIAAAAmJhIAAAAiJhIAAAAiJhIAAAAiJhIAAAAiJhIAAAAiJhIAAAAiJhIAAAAiJhIAAAAi\"},\"59\":{\"w\":12,\"h\":11,\"lower\":\"GwkAAAAoWwgAAAAoWwcAAAAoGwcAAAAoFQkAAAAYGwcAAAAoGwcAAAAoFQoBhQAUGwAAAAAoJQACUgAoWwIAAAAoGwMAAAAoGwkAAAAoFQsAAAAUGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoFQsAAAAUFQsAAAAUFQsAAAAUFQsAAAAUZQMChQAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsBhQAUJQUChQAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsBJQAUGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoFQsAAAAUFQsBUgAUFQsBWAAUFQsAAAAUGwcAAAAoGwcAAAAoFQsAJQAUGwcAAAAoGwcAAAAoFQsBhQAUGwcAAAAoGwcAAAAoFQsBhQAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsBJQAUGwcAAAAoGwcAAAAoFQsBJQAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoWwcAAAAoGwcAAAAoFQsAAAAUFQsBUgAUFQsBWAAUFQsAAAAUFQsBUgAUFQsBWAAUFQsAAAAUFQsAAAAUFQsAAAAUGwkAAAAkWwgAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoWwcAAAAoWwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoFQsAAAAUGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwcAAAAoGwkAAAAkWwgAAAAoGwgAAAAoVQoAAAAUFQsBUgAUFQsBWAAUFQsAAAAUGwkAAAAkGwkAAAAkFQsAAAAUFQsBUgAUFQsBWAAUFQsAAAAUGwkAAAAo\"},\"60\":{\"w\":16,\"h\":8,\"lower\":\"GwUAAAAkGwcAAAAkGwkAAAAkIAsAAAAUIAsAAAAUGwkAAAAoGwcAAAAoGwUAAAAkVQMAAAAUFQIBmQAUFQIBRAAUVQEAAAAUFQEAAAAUIAMBUgAUIAQAAAAUIAQAAAAYFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAYFQMAAAAYFQMBUgAYFQQAAAAUVQQAAAAUFQMBWAAUFQMAAAAUFQIBWAAUVQEAAAAUFQEAAAAUVQAAAAAUFQAAAAAUIAYAAAAYFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAYFQMAAAAYFQMBUgAYFQQAAAAUFQQAAAAUFQMBmQAUFQMBRAAUFQIBmQAYFQIBhQAYVQEAAAAYVQAAAAAYFQAAAAAYIAYAAAAYFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAYFQMAAAAYFQMAAAAYFQQAAAAUYAkAAAAYYAgAAAAYYAcAAAAYYAYAAAAYYAUAAAAYIAQAAAAYWwoAAAAkGwgAAAAkGwgAAAAoFQMAAAAUFQMAAAAUFQQCUgAUIAsAAAAUIAsAAAAUIAsAAAAUIAsAAAAYGwoBWAAoGwoAAAAoGwoAAAAoGwkBWAAoGwkAAAAkJgsAAAAkJgsAAAAoGwgAAAAoWwgAAAAoVQECUgAUFQMAAAAUFQQCUgAUIAsAAAAUIAsAAAAUIAsAAAAUIAsAAAAYYAYAAAAYGwcAAAAkGwcBUgAkWwgAAAAkWwgAAAAkJgsAAAAkJgsAAAAoGwoBWAAoWwkAAAAoFQECUgAUFQMAAAAUIAkAAAAUIAsAAAAUIAsAAAAUIAsAAAAUIAsAAAAYIAYAAAAYYAYAAAAYWwUAAAAoGwUAAAAoGwUAAAAkVQQAAAAUFQQAAAAUFQYBUgAUGwkAAAAoVQEAAAAUFQEAAAAUVQcCJQAUIAsAAAAUIAsAAAAUIAsAAAAUIAsAAAAYIAYAAAAYIAYAAAAYWwUAAAAoVQQAAAAUVQQAAAAUFQQAAAAUFQQAAAAUFQYBUgAUGwcAAAAo\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwsBhQIUIwsBhQIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwwAAAIUIwwAAAIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwsBJQIUIwsBJQIUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"61\":{\"w\":12,\"h\":15,\"lower\":\"GwIBUgAoGwMAAAAoWwEBJQAoYAAAAAAYGwEAAAAoGwEBUgAoGwIAAAAoYAAAAAAYGwEAAAAoWwEBUgAoGwMAAAAoGwMAAAAoWwIAAAAkGwEBWAAoYAAAAAAUIAAAAAAUYAAAAAAUWwEAAAAoWwEAAAAoYAAAAAAUYAAAAAAUYAAAAAAUGwIBJQAoWwEAAAAoGwIBJQAoYAAAAAAUIAAAAAAUFAAAAAA0FAAAAAA0YAAAAAAUYAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUYAAAAAAUWwEAAAAkYAAAAAAYGQAAAAAKGQAAAAAGGQAAAAAGGQAAAAAKFAAAAAA4GQAAAAAKFAAAAAA0GQAAAAAKGQAAAAAKFAAAAAA4YAAAAAAUFAAAAAA0FAAAAAA0GQAAAAAGGQAAAAAGGQAAAAAKIAAAAAAUGQAAAAAKGQAAAAAKFAAAAAA4IAAAAAAYIAAAAAAUIAAAAAAkFAAAAAA4FAAAAAA0FAAAAAA0FAAAAAA0GQAAAAAKGQAAAAAKFAAAAAA0FAAAAAA0GQAAAAAKGQAAAAAKGQAAAAAKFAAAAAA0FAAAAAA4GQAAAAAKFAAAAAA0FAAAAAA0IAAAAAAUFAAAAAA0FAAAAAA0FAAAAAA0FAAAAAA0FAAAAAA4FAAAAAA0GQAAAAAGGQAAAAAKGQAAAAAKGQAAAAAKGQAAAAAGIAAAAAAUFAAAAAA0FAAAAAA4GQAAAAAKGQAAAAAKIAAAAAAYIAAAAAAUFAAAAAA0GQAAAAAKGQAAAAA6FAAAAAA0FAAAAAA0GQAAAAAKGQAAAAAKGQAAAAAKGQAAAAAKGQAAAAAKIAAAAAAYYAAAAAAUIAAAAAAUYAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUGQAAAAAKFAAAAAA4FAAAAAA0YAAAAAAYGwEBhQAoGwIAAAAkWwEBWAAkYAAAAAAYYAAAAAAUIAAAAAAUIAAAAAAUVAAAAAA0VAAAAAA0FAAAAAA0YAAAAAAUWwEAAAAoGwIAAAAoGwQBhQAoWwMAAAAkWwEBWAAoGwEAAAAoYAAAAAAUIAAAAAAUGwEAAAAoWwEBUgAoGwMAAAAoWwIBWAAoWwEAAAAoWwEAAAAoGwUAAAAoGwMAAAAkGwMAAAAoIAMAAAAYYAMAAAAYGwQBUgAoGwUAAAAoWwQAAAAoWwMAAAAoGwQAAAAoGwMBWAAoWwIAAAAoGwcAAAAoGwYBWAAkWwUAAAAoIAkAAAAYIAkAAAAYYAcBWAAYGwcAAAAoWwQBhQAoWwMAAAAoWwMAAAAoWwIAAAAoGwIAAAAoWwcAAAAoGwgBUgAkGwkAAAAoIAkAAAAYIAkAAAAYGwkAAAAoGwcAAAAoWwUBWAAoWwQAAAAoGwQAAAAoGwMBWAAoWwIAAAAo\"},\"62\":{\"w\":14,\"h\":10,\"lower\":\"FxMAAAASFQAAWAAYFQAAAAAUFQAAAAAUFQAAAAAUFQAAUgAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFQEAAAAYFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFxMAAAASFxMAAAASFxMAAAASFxMAAAASFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAUFQAAJQAQFQAAAAAQFQAAAAAQFQAAAAAUFxMAAAASFxMAAAASFxMAAAASHQcAAAAkHQcAAAAkHQcAAAAkHQcAAAAgHQcAAAAgHQcAAAAgJQcBUgAgHQgAAAAgFQAAAAAQFQAAAAAQFAEAAAAgFxMAAAASFxMAAAASFxMAAAASHQcAAAAkHQcAAAAkHQcAAAAkHQcAAAAgHQcAAAAgHQcAAAAgJQcBUgAgHQgAAAAgHQgAAAAQFQAAAAAQFAEAJQAkFxMAAAASFxMAAAASFxMAWAASHQcAJQAkHQcAAAAkHQcAAAAkHQcAAAAgHQcAAAAgHQcAAAAgJQcBUgAgHQgAAAAgFQAAAAAQFQAAAAAQFAEAAAAgFxMAAAASFxMAAAASFxMAAAASFQcAAAAUFQcAAAAUFQcAAAAUFQcAAAAQFQcAAAAQFQcAAAAQFQcAAAAQFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUFxMAAAASFxMAAAASFxMAAAASFQEAAAAUFQEAAAAYFQEAAAAYFQEAhQAYFQEAAAAYFQEAAAAUFQEAAAAUFQAAUgAUFQAAAAAUFQAAAAAUFxMAAAASFxMAAAASFxMAAAASFxMAAAASFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFxMAAAASFxMAAAASFxMAAAASFxMAWAASFxMAAAASFxMAUgASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAASFxMAAAAS\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFwAAAAACAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"63\":{\"w\":11,\"h\":11,\"lower\":\"YAEAAAAQYAEAAAAQQAAAAAAkAwAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgQwAAAAAgIAEAAAAQIAMAAAAQIAMAAAAQIAIAAAAQIAIAAAAQAwAAAAAkAwAAAAAgQwAAAAAgFAAChQAgQwAAAAAgAwAAAAAgQAAAAAAgYAIAAAAQIAMAAAAQIAIAAAAQIAIAAAAQAwAAAAAkAwAAAAAgAwAAAAAgFAIAAAAgAwAAAAAkAwAAAAAgAwAAAAAkIAIAAAAQYAIAAAAQQAEAAAAgIAIAAAAQAwAAAAAkAwAAAAAgAwAAAAAgFAIBhQAgAwAAAAAkAwAAAAAkAwAAAAAgYAEAAAAQYAEAAAAQQwEAAAAgIAIAAAAQAwAAAAAkAwAAAAAgFAMAAAAgVAMAAAAgFAMAAAAkAwAAAAAkQwAAAAAgIAEAAAAQIAEAAAAQQwEAAAAgIAIAAAAQAAAAAAAkAAAAAAAgVAMAAAAgFAQAAAAgVAMAAAAgAwAAAAAkQwAAAAAgYAEAAAAQIAEAAAAQQAEAAAAgYAIAAAAUAwAAAAAkAwAAAAAgFAMAAAAgVAMAAAAgFAMAAAAgAwAAAAAkAwAAAAAgYAIAAAAUFAIChQAgFAQAAAAkYAMAAAAUAwAAAAAkAwAAAAAkAwAAAAAkAwAAAAAkAwAAAAAkAwAAAAAkAwAAAAAkIAIAAAAUVAQAAAAkFAYAAAAkFAYCUgAkVAgAAAAgAwAAAAAkAwAAAAAkAwAAAAAkAwAAAAAkVAgAAAAgFAcBWAAkFAYBWAAkFAUBWAAkIAoAAAAQIAoAAAAQYAkAAAAQIAkAAAAQFQAAAAAUFQAAAAAUIAkAAAAQYAkAAAAQIAoAAAAQIAoAAAAQIAoAAAAQYAkAAAAQYAkAAAAQIAkAAAAQIAkAAAAQFQAAAAAUFQAAAAAQIAkAAAAQIAkAAAAQYAkAAAAQYAkAAAAQYAkAAAAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFA0AAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIAkAAAIQIAkAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIAkAAAIQIAkAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"64\":{\"w\":14,\"h\":10,\"lower\":\"AwEAAAAgQwEAAAAgVQIAAAAUVQMAAAAUQwQAAAAkAwUAAAAkQwoAAAAkAwsBUgAgQwwAAAAgAwoAAAAgQwkAAAAgUASAAABAAAAAAAABAAAAAAABAwEAAAAgQwEAAAAkVQIAAAAUFQMAAAAUQwUBUgAkQwcAUgAkQwkAAAAkQwsBUgAgAw0AAAAgQwoAJQAgUAcgJQBAEAZAAABAAAAAAAABAAAAAAABAQEAAAAgAQEAAAAkFQQAAAAWVQMAAAAQFAMAAAAgVAIAAAAgQQEAAAAkVQsAAAASKgsAAAAQFQsAAAASEASAAABAEAZAAABAAAAAAAABAAAAAAABDwAgAABACgAgAABESgAgAABIIwMAAAAQCgEAAABACgEAAABEAQEAAAAkAQEAAAAmFQsAAAAQUASAAABAEASAAABAEASAAABAAAAAAAABAAAAAAABDwAgAABACgAgAABEFQQAAAASVQMAAAAQFQQAAAASAQEAAAAkCgEAAABEFQsAAAASFQsAAAAQFQsAAAASEASAAABAEASAAABAAAAAAAABAAAAAAABDwAgAABACgEAAAAkFQQAAAASVQMAAAAQFQQAAAASAQEAAAAkCgEAAABEFQsAAAASFQsAAAAQFQsAAAASEASAAABAEASAAABAAAAAAAABAAAAAAABDwAgAABACgAgAABESgAgAABIIwMAAAAUCgEAAABECgEAAABECgEAAABIDwEAAABGFQsAAAAQUASAAABAEASAAABAEAZAAABAAAAAAAABAAAAAAABAQEAAAAgAQEAAAAkFQQAAAAWVQMAAAAUFQQAAAAUAQEAAAAoAQEAAAAoVQsAAAAaagsBhQAQVQsAhQASUASAAABAEAcgAABAAAAAAAABAAAAAAABFQEAAAAQVQEAAAAUVQIAAAAUFQMAAAAUQwgAAAAgQwkAAAAkVQsAAAAQAwwBUgAkAw0AAAAgQwsAAAAgAwkAAAAgUAcgAABAAAAAAAABAAAAAAABFQEAAAAQAwEAAAAkAwMAAAAkAwUAAAAkQwcAAAAkAwoBUgAkQwsAUgAgAwwBUgAkAw0AAAAkQwwAAAAgAwkAAAAgAwgBWABQAAAAAAABAAAAAAAB\"},\"65\":{\"w\":6,\"h\":8,\"lower\":\"VQAAAAAUHwMAAAAkHwcAAAAkFAIBhQAkFAEBWAAkFAABWAAkVQEAAAAUHwIAAAAkXwYAAAAkFAMBhQAkFQAAAAAUVQAAAAAUVQIAAAAUXwQAAAAkHwUAAAAkVAQAAAAkFQAAAAAUVQEAAAAUFQMAAAAUHwYAAAAkGggAAAAkFQAAAAAUFQAAAAAUVQIAAAAUFQUAAAAUXwUAAAAkHwgAAAAkHwYAAAAkFQIAAAAUVQMAAAAUFg4AAAAUVg4AAAAUFg8AAAAUVg4AAAAUHwUAAAAkVQQAAAAUVQgAAAAUFQgAAAAUFQcAAAAUFQcAAAAUVQYAAAAUVQUAAAAUHwkAAAAkFQYAAAAUVQYAAAAUFg4AAAAUJgoAAAAkJgoAAAAk\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFg4AAAEUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"66\":{\"w\":9,\"h\":13,\"lower\":\"IAoAAAAQIAgAAAAQCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAkIAgAAAAUIAwAAAAQIAoAAAAQIAgAAAAQCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgAwIAAAAkIAgAAAAUIAsBJQAQIAoChQAQIAgAAAAQCAIAAAAkCAIAAAAgAwIAAAAgCAIAAAAgCAIAAAAkXwoAAAAQIAsAAAAQIAwAAAAQIAgAAAAQIAUAAAAQIAUAAAAQYAQAAAAQYAQAAAAQIAUAAAAUIAgAAAAUIAsAAAAQIAwAAAAQIAgAAAAQXwcAAAAgIAUAAAAQIAUAAAAQIAUAAAAQIAUAAAAQIAgAAAAUIAsBhQAQIAwAAAAQIAgAAAAQIAUAAAAQIAUAAAAQIAUAAAAQIAUAAAAQIAUAAAAQIAgAAAAUIAwAAAAQIAwAAAAQIAgAAAAQAwIAAAAgAwIAAAAgQwIAAAAgIAMAAAAQIAUAAAAQIAgAAAAUIAwAAAAQIAwAAAAQIAYAAAAQAwIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgAwIAAAAkIAcAAAAUIAwAAAAQIAsBJQAQIAUAAAAUIAMAAAAUQwIAAAAkAwIAAAAkAwIAAAAkAwIAAAAkIAUAAAAUIAwAAAAQIAsAAAAQYAcAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAYAAAAQYAUAAAAUIAUAAAAUIAwAAAAQIAsAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAUIAwAAAAQIAsAAAAQXwoAAAAgIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQYAoAAAAQIAwAAAAQIAsAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQIAgAAAAQYAsAAAAQIAwAAAAQ\"},\"67\":{\"w\":13,\"h\":11,\"lower\":\"AwMAAAAgAwIBmQAgAwIBRAAgAwIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgAwIAAAAgQwEBWAAgQwEAAAAgQwEAAAAgAwMAAAAgAwMAAAAgAwIBmQAgCAIBhQAgCAIBhQAgCAIBRAAgCAIAAAAgCAIAAAAgCAIAAAAgCAIAAAAgCAIBQQAgAwIBhQAgCAIBRAAgAwMAAAAgAwMBQQAgAwMBhQAgAwMBhQAgAwMBRAAgAwIBmQAgAwIBRAAgAwIBQQAgAwIBhQAgAwIBRAAgCAIBUgAgCAMAAAAgCAIBWAAgAwMBhQAkAwMBlgAkAwQAAAAkXwYAAAAgAwMBWAAkAwMAAAAkAwIBmQAkAwIBlgAkAwMAAAAkAwIBmQAkAwIBlgAgAwMAAAAgAwIBmQAgIAkAAAAQIAcCWAAQIAcAAAAQIAcAAAAQIAcCUgAQIAkAAAAQIAkAAAAUIAsAAAAUIA0AAAAUIBIAAAAQIBIAAAAQIBIAAAAQAwMAAAAgAwIAAAAgAwIAAAAgIAQAAAAQYAYAAAAQAwIAAAAgAwIAAAAgIAQAAAAQIAYAAAAQYA8AAAAQYBAAAAAQIBAAAAAQIBIAAAAQIBIAAAAQAwIAAAAgAwIAAAAgCAIAAAAgCAIAAAAgAwIAAAAgCAIAAAAgAwIAAAAkIAYAAAAQIAYAAAAUIBAAAAAQIBAAAAAQIBAAAAAQIBIAAAAQAwIAAAAgCAIAAAAgCAIAAAAgAwIAAAAgCAIAAAAgAwIAAAAgAwIAAAAkIAYAAAAQIAYAAAAUIBAAAAAQIBAAAAAQIBAAAAAQIBIAAAAQCAIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAkIAYAAAAQIAYAAAAUIBAAAAAQIBAAAAAQIBAAAAAQIBIAAAAQAwIAAAAkAwIAAAAkYAYAAAAQIAQAAAAUAwIAAAAkAwIAAAAkIAQAAAAUIAYAAAAQYA8AAAAQYBAAAAAQIBAAAAAQIBIAAAAQIBIAAAAQIAgAAAAUIAcBWAAQYAcAAAAQIAgAAAAQIAgAAAAQIAgBUgAQIAkAAAAQYAsAAAAQIA0AAAAQIBIAAAAQIBIAAAAQIBIAAAAQAwICFAAi\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIBAAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIBAAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIBAAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"68\":{\"w\":8,\"h\":11,\"lower\":\"FQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUJgIAAAAmGwIAAAAmJgIAAAAkJgIAAAAgFQAAAAAQFQAAAAAUHQAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUHQAAAAAkXQAAAAAkXQAAAAAkHQAAAAAkFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUXQAAAAAkJgEAAAAkJgEAAAAkXQAAAAAkFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAUXQAAAAAkJgEAAAAkJgEAAAAkXQAAAAAkFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUXQAAAAAkJgEAAAAkJgEAAAAgXQAAAAAkFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUXQAAAAAkJgIAAAAiJgIAAAAiXQAAAAAgFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUHQAAAAAkXQAAAAAgJgQAAAAyHQAAAAAgFQAAAAAUFQAAAAAUPwoAAAAaFQAAAAAUHQAAAAAkHQAAAAAkHQAAAAAgHQAAAAAkFQAAAAAUPwoAAAAWPwoAAAAaFQIAAAAUJgQAAAA2FQAAAAAQFQAAAAAUFQAAAAAUFQIAAAAUPwoAAAAWPwoAAAAaPwoAAAAaPwoAAAAaPwoAAAAaPwoAAAAaPwoAAAAaPwoAAAAaPwoAAAAW\"},\"69\":{\"w\":12,\"h\":12,\"lower\":\"CAAAAAAmCAAAAAAmFQQAAAAUCAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkFQYAAAAWCAAAAAAmCAAAAAAmCAAAAAAmFQYAAAAUFQYAAAAUVQUAAAAUVQQAAAAUVQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUFQYAAAAWVQUAAAAWCAAAAAAmFQYAAAAWFQYAAAAWCAMAAAAkCAMAAAAkSAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkFQUAAAAWFQUAAAAWCAAAAAAkFQMAAAAUCAMAAAAkCAMAAAAkVAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkCAMAAAAkFQMAAAAUCAAAAAAkCAAAAAAkFQMAAAAUCAMAAAAkSAMAAAAkVAQAAAAkVQMAAAAUFQMAAAAUFAMAAAAkFAMAAAAkSAIAAAAkSAEAAAAkSAAAAAAkCAAAAAAkFQMAAAAUCAMAAAAkCAMAAAAkFAUAAAAkFQMAAAAUFQMAAAAUFQMAAAAUFQMAAAAUSAIAAAAkSAEAAAAkSAAAAAAkCAAAAAAkFQMAAAAUFAMAAAAkPwwAAAAWBQYAAAAkPwwAAAAWFQMAAAAkCAMAAAAkCAMAAAAkVQIAAAAUVQEAAAAUSAAAAAAkCAAAAAAkFQMAAAAUFAMAAAAkPwwAAAAWPwwAAAAWPwwAAAAWCAMAAAAkCAMAAAAkCAMAAAAkFQMAAAAUFQMAAAAUCAAAAAAkSAAAAAAkFQMAAAAUFQMAAAAUPwwAAAAWPwwAAAAWPwwAAAAWFQMAAAAUCAMAAAAkCAMAAAAkCAMAAAAkPwoAAAAWCAAAAAAkFQIAAAAWVQIAAAAUFQMAAAAUFQMAAAAUFQMAAAAUCAMAAAAkFQMAAAAUSAMAAAAkFQMAAAAUFQMAAAAUPwoAAAAWFwcDWAAWSAAAAAAkFQIAUgAUVQIAAAAUFQMAAAAUFQMAAAAUFQMAAAAUVQMAAAAUFQQAAAAUFQQAAAAWFQYAJQAUFQgAJQAUCAAAAAAmCAAAAAAkSAAAAAAkFQIAAAAWSAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkCAAAAAAkFQQAAAAUCAAAAAAmCAAAAAAm\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAwAAAEaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwoAAAEaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwoAAAEaAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"70\":{\"w\":8,\"h\":12,\"lower\":\"AwAAAAAgAQAAAAAgAwAAAAAgFQAAAAAQAwAAAAAgAwAAAAAgAQAAAAAgQwAAAAAkAQAAAAAgAQAAAAAgAQAAAAAgFQAAAAAQAwAAAAAQQQAAAAAgQwABhQAgAwEAAAAkQwABRAAgFgcAAAAQQQAAAAAgFQAAAAAQQwAAAAAQFgcAAAAQQwEAAAAgAwEBhQAkAwABWAAgQwAAAAAgAQAAAAAkFQAAAAAQAQAAAAAQQQAAAAAgAwIAAAAkAwIAAAAkAwABmQAgAAABRAAgAQAAAAAgFQAAAAAUFQAAAAAQBgIAAAAQAwIAAAAgBgQAAAAUAwEAAAAgAwABWAAgAwAAAAAgFQAAAAAQFQAAAAAgQwIAAAAgQwMAAAAgQwQBhQAkJQcBUgAQFQgAAAAQFQgAAAIQBQAAAAAQFQgAAAIQFQgAAAAQJQYCWAAQAwYAAAAgBgoAAAAQLgwAAAAQFQgAAAIQRQAAAAAUFQgAAAIQLgwAAAAQBgoAAAAQAwoAAAAgAwoAAAAgLgwAAAAQFQkAAAAUBQAAAAAYFQkAAAAULgwAAAAQAwoAAAAkQwkBJQAgQwgBZgAgAwkAAAAkQwgAAAAYFQgAAAAUQwgAAAAUAwkAAAAkQwgAAAAoAwkAAAAkAwQBJQAgQwQAAAAoQwcAAAAkVQYAAAAYQwYBUgAkAwcAAAAkQwYBJQAoAwYBFAAoAwQAAAAgQwMAAAAkQwUAAAAkFQYAAAAUQwQAAAAoAwUAAAAoAwQBWAAoQwMBJQAo\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQgAAAIQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABLgwAAAYQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABLgwAAAYQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"71\":{\"w\":14,\"h\":10,\"lower\":\"AAEAAAAgAwEBUgAgAwEBWAAgAAEAAAAgAwEBEQAgAwEBZgAgAwIAAAAgAwEBWAAgCgAgAABACgAgAABACgAgAABACgAgAABAAAEAAAAkAwEBQQAgCgAgAABEAwEBEQAgAwEBFAAgCgAgAABAAwEAAAAgAwEBUgAgAwEBaQAgAwEBFAAgCgAgAABAJAUAAAAiCgAgAABAAwEAAAAgAwEBQQAgAwEBlgAgAwEAAAAkJAQAAAAiCgAgAABACgAgAABAJAUAAAAiQwEBUgAgAwEBWAAgAwEAAAAgCgAgAABACgAgAABAAwEBQQAkAwEBRAAgAwEBUgAkAwIAAAAkAwEBRAAgAwEAAAAgCgAgAABESgAgAABAAwIAAAAgAAIAAAAkQAEAAAAkCgAgAABACgAgAABACgAgAABAAwEBEQAgAwEBFAAgAwEBUgAgAwEBaQAgAwEBWAAgCgAgAABACgAgAABACgAgAABASgAgAABASgAgAABAAwEAAAAgCgAgAABACgAgAABACgAgAABAAAEAAAAgCgAgAABAAwEBEQAgAwEBFAAgAAEBFAAgCgAgAABACgAgAABACgAgAABACgAgAABACgAgAABAAwEBQQAgAwEBhQAgAwEBRAAgAwEAAAAgCgAgAABACgAgAABACgAgAABAAwEBQQAgAwEBQQAgAwEBRAAgCgAgAABACgAgAABACgAgAABACgAgAABAAwEBEQAgAwEBJQAgAwEBFAAgAwEBQQAgAwEBRAAgJAQAAAAiCgAgAABAAAEBUgAgAwEBEQAgAwEBFAAgAAEAAAAUJAUAAAAiCgAgAABAAwEAAAAgAwEBQQAgAwEBRAAgCgAgAABAAwEBEQAgQwEBFAAgAwEBhQAgQAEAAAAkAwEBEQAgCgAgAABACgAgAABAAAEAAAAkAwEBQQAgAwEBhQAkAwEBRAAgAwEBUgAgAwEBWAAgCgAgAABACgAgAABASgAgAABAAwIAAAAgAwIAAAAgQwEAAAAgAwEAAAAgCgAgAABACgAgAABAAwEBUgAgAwIAAAAgAwEBWAAgAwEBEQAgAwEBFAAgCgAgAABACgAgAABACgAgAABAQAEAAAAgQwEAAAAgAwEAAAAg\"},\"72\":{\"w\":9,\"h\":14,\"lower\":\"RgEAAAAQAwIAAAAkAwIAAAAkQwUAAAAkQwgAAAAgQwkAAAAkAwoBhQAkAwoBRAAkAwoAAAAgRgEAAAAQAwIAAAAgAwQAAAAgQwYAAAAgAwgAAAAgQwoBhQAgAwsAAAAgAwoBWAAgAwoAAAAgUQAgAABAAwIAAAAgAwIAAAAgAwcAAAAgAwcAAAAgAwsAAAAgAwsAAAAgAwoBmQAgBgoBhQAQEQAgAABARgEAAABAAwIAAAAgQwYAAAAgAwcAAAAgBg0AAAASBgsAAAAQAwsAAAAgAwsAAAAgEQAgAABAEQAgAABABgEAAAAQAwYAAAAgBggAAAAUBg0AAAASBgsAAAAQBgwAAAAQAwoBaQAgBgEAAAAQEQAgAABAEQAgAABARgUAAAAQQwoAAAAgAwsAAAAgAwsAAAAgAwoBaQAgAwoBFAAgBgEAAAAQEQAgAABABgEAAAAQAwMAAAAgBgwAAAASAwsAAAAgAwsAAAAgAwoBWAAgAwoAAAAgEQAgAABAEQAgAABABgEAAAAQAwMAAAAgBgsAAAAQAwsAAAAgBgwAAAAQBgoBWAAQBgoAAAAQBgEAAAAQEQAgAABAUQAgAABAEQAgAABEAwkAAAAgAwsAAAAgAwsAAAAgRgoBFAAQAwoAAAAgBgEAAAAQRgEAAAAQQwIAAAAgBgMBhQAUAwkAAAAgBgsBhQAQAwsBRAAgQwoAAAAgAwoAAAAgEQAgAABAEQAgAABABgMBUgAQAwYBhQAgBggAAAAQAwwAAAAgAwsBmQAgQwoBRAAgAwoAAAAgEQAgAABARgEAAAAQAwIAAAAgAwcAAAAgAwcAAAAgBgwAAAAQAwwAAAAgQwoBmQAgAwoBRAAgRgEAAAAQQwIAAAAgQwMAAAAgQwYAAAAgQwkAAAAgQwoAAAAgQwsAAAAgAwsAAAAgAwoBWAAgRgEAAAAQAwIAAAAgAwQBUgAgQwUAAAAgQwgAAAAgAwoAAAAgQwoAAAAgAwsAAAAgAwoBWAAg\"},\"73\":{\"w\":8,\"h\":8,\"lower\":\"AA4AAAARFAEAAAAoFAEAAAAoFAEAAAAYVQAAAAAYFAEAAAAoFAEAAAAoFAEAAAAoAA4AAAARFAEAAAAkVAABWAAkVQAAAAAUFQAAAAAUVQAAAAAUFAEAAAAkVAABJQAkAA4AAAARVQAAAAAQVQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUVQAAAAAUFQAAAAAQAA4AAAARHwIAAAAgFQAAAAAUHAMAAAAiHAMAAAAmFQAAAAAQFQAAAAAQFQAAAAAQAA4AAAARHwIAAAAkFQAAAAAUHAMAAAAiHAMAAAAmFQAAAAAQFQAAAAAQVQAAAAAUAA4AAAARVQEAAAAQFQABhQAUVQAAAAAUFQAAAAAUFQAAAAAQVQAAAAAUHwEAAAAgAA4AAAARVQAAAAAQFQEAAAAUXwMAAAAkFQAAAAAUFQAAAAAQXwIAAAAgXwMAAAAgAA4AAAARVAcAAAAYVQYAAAAYFQQAAAAUVQMAAAAUXwIAAAAkXwMAAAAgHwQAAAAk\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEoFAgAAAEoFAgAAAEoAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAgAAAEoFAgAAAEoAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"74\":{\"w\":11,\"h\":12,\"lower\":\"AwMBWAAgAwMAAAAgAwIBWAAgQwEBWAAgSQAgAABAAAIAAAAgAwIAAAAkAwQAAAAgQwMAAAAkAwIBmQAgAwIBhQAgAwMBFAAkHhIAAAAiAwIBWAAgAwIAAAAgAwIAAAAgHhEAAAAiAwIAAAAkQwIAAAAkAwMAAAAgAwMAAAAgAwMBQQAgAwIBJQAkAwIBJQAkAwIBFAAkAwIAAAAgAwIAAAAkAwIAAAAgAwIAAAAkAwIBUgAgAwMAAAAgHhIAAAAiAwMBUgAgAwIAAAAgAAIBQQAgAAIBhQAgAwIBhQAkAwIBRAAgQwEBWAAkSQAgAABEAwIBUgAkAwMAAAAkAwMAAAAkAwMBEQAkAwIAAAAgAwIBUgAgAAMAAAAkAwMAAAAgQwIBWAAgIwIAAAAgIwIAAAAkYwIAAAAkQwIBUgAkAwMAAAAkAwMAAAAkAwIAAAAkAwIBUgAkAwMAAAAgAwMAAAAgAwMAAAAgSQAgAABESQAgAABASQAgAABEAwIBEQAkAwIBJQAkSQAgAABEAwEBJQAkQwEBUgAkQwIBUgAkAwMAAAAkAwIBaQAkSQAgAABEAwIAAAAgSQAgAABASQAgAABESQAgAABEAwEBhQAgCQAgAABESQAgAABESQAgAABECQAgAABESQAgAABECQAgAABESQAgAABECQAgAABACQAgAABAQwMAAAAgQwIBhQAgQwMAAAAgAwEBRAAgSQAgAABASQAgAABABgIAAAAgSQAgAABACQAgAABACQAgAABAAwQBQQAgAwQBhQAgAwQBhQAgAwQAAAAgQwMBRAAgHhEAAAAiSQAgAABASQAgAABASQAgAABAQwEBQQAgQwEBhQAkAwQBUgAkAwUAAAAgAwUAAAAgAwQBRAAgQwMBWAAgAwMAAAAgYwIAAAAkIwIAAAAgIwIAAAAgYwIAAAAgQwMAAAAgAwQBUgAkHhQAAAAiAwUAAAAgAwQBWAAkAwQAAAAkQwIAAAAkQwEBWAAkSQAgAABEQwEBUgAkAwMAAAAgAwMBUgAkAwQBUgAkAwUAAAAkAAUAAAAk\"},\"75\":{\"w\":10,\"h\":12,\"lower\":\"DAQAAAAUDAQGQQAWDAQGRAAWDAMBWAAUEgMAAAAUEgMAAAAkEgMAAAAkEgMAAAAkEgMAAAAkDAMAAAAYDAQAAAAUDAQGEQAWDAQGFAAWDAMBWAAUEgMAAAAUDAMAAAAUDAMAAAAUEgMAAAAkDAUAAAAUDAMAAAAYTAMAAAAQDAQAAAAUTAMAAAAkTAMAAAAUEgMAAAAkDAMAAAAkEgMAAAAkTAMAAAAkTAQAAAAUTAMAAAAYTAMAAAAQDAQAAAAQUgMAAAAkEgMAAAAkEgMAAAAkEgMAAAAkUgMAAAA0TAMBhQAUTAQAAAAUTAMBhQAYDAMAAAAUTAMAAAAkEgMAAAAkDAMAAAAkDAMAAAAkUgMAAAAkTAQAAAAUDAUAAAAUTAUAAAAUTAQAAAAYDAMAAAAUDAMAAAAkEgMAAAAkDAMAAAAkDAMAAAAUTAMAAAAkDAMBJQAUUgMAAAAkDAYAAAAUTAUAAAAYDAMAAAAUDAMAAAAUEgMAAAAUEgMAAAAkDAMAAAAUEgMAAAAkDAMAAAAUEgMAAAAkDAYAAAAUTAUBhQAYDAMAAAAUEgMAAAAUEgMAAAAUEgMAAAAkEgMAAAAkUgMAAAAkEgMAAAAkEgMAAAAkDAoAAAAUTAcAAAAYDAMChQAUDAMAAAAUDAMAAAAUEgMAAAAkTAMAAAAkDAUAAAASEgUAAAAgEggAAAAkDA4BhQAUDAgAAAAYDAUAAAAQDAgAAAASEgMAAAAkUgMAAAAkDAQBUgAQDAYAAAAQEgUAAAAgEg0AAAAgDBIAAAAUDAkBWAAYDAUAAAAQDAUAAAAQDAUAAAAUTAMAAAAgUgMAAAAQDAMAAAAQEgMCUgAgDAcAAAAQDAkAAAAQDAcAAAAUTAQAAAAQDAICWAAUEgAAAAAkEgAAAAAgEgAAAAAQEgAAAAAQEgAAAAAgEgAAAAAgDAICUgAQDAQAAAAU\"},\"76\":{\"w\":10,\"h\":18,\"lower\":\"AQABhQAAAQABRAAAQQAAAAAABgEAAAAAAQABmQAAAQABRAAAAQAAAAAAQQAAAAAABgEAAAAABgEAAAAABgEAAAAAAQABmQAAQQAAAAAAQQAAAAAABgEAAAAAQQABFAAAHgMAAAACAQAAAAAAQQABUgAABgEAAAAABgEAAAAABgEAAAAAAQEBQQAAAQEBhQAAAQEBRAAAQQAAAAAAQQAAAAAAQQABQQAAAQABlgAABgEAAAAAQQEBRAAARgEAAAAAQQEBUgAAAQIAAAAAAQEBmQAAQQEBRAAARgEAAAAABgEAAAAARgEAAAAARgEAAAAARgIAAAAABgIAAAAABgIAAAAAAQIBQQAAQQIBRAAARgIAAAAAAQEBmQAAQQEBhQAABgIAAAAABgIAAAAABgMAAAAABgIAAAAAAQIBQQAAQQIBlgAARgMAAAAABgMAAAAAQQIBhQAAAQIBhQAAAQIBRAAAQQABaQAAAQAAAAAAAQAAAAAAAQAAAAAABgQAAAAABgQAAAAARgMAAAAABgMAAAAABgMAAAAAAQIBWAAAAQABFAAAAQAAAAAAAQAAAAAAAQAAAAAAAQAAAAAAAQABEQAAAQABJQAAAQABJQAAAQABFAAAAQAAAAAAAQAAAAAAAQABhQAAAQABRAAAAQAAAAAAAQABQQAAAQABRAAAAQAAAAAAAQAAAAAAAQAAAAAAAQABQQAAAQABhQAABgIBUgAARgMAAAAABgQAAAAABgQAAAAAAQABmQAAAQABRAAAAQAAAAAABgQAAAAABgQAAAAARgMAAAAAAQIBEQAAAQIBJQAAQQIBZgAABgQAAAAARgMAAAAABgMAAAAARgMAAAAABgQAAAAABgQAAAAARgMAAAAABgIAAAAABgIAAAAAAQIBEQAAQQIBZgAAAQMAAAAABgMAAAAABgMAAAAAQQMAAAAAQQIBaQAAAQIBJQAABgIAAAAABgIAAAAAQQEAAAAARgEAAAAAQQEBUgAAHgUAAAACRgIAAAAAQQIBEQAAAQIBFAAAQQEAAAAAQQABZgAARgEAAAAABgEAAAAABgEAAAAAAQEBEQAAAQEBJQAAQQEBFAAARgEAAAAARgEAAAAAAQEAAAAAAQABEQAAQQABFAAAQQAAAAAABgEAAAAABgEAAAAABgEAAAAAHgQAAAACAQABaQAAAQABZgAAAQEAAAAAAQABhQAAAQABhQAAAQABRAAAQQAAAAAAHgMAAAACQQABEQAAAQABJQAAAQABFAAAAQABEQAAAQABJQAAAQEAAAAAAQEAAAAAAQABmQAAAQABhQAAAQABRAAAAQAAAAAABgAAAAAAAQABQQAAQQABRAAAQQAAAAAAAQEAAAAAAQEAAAAAAQEAAAAAAQEAAAAAAQABWAAABgAAAAAABgAAAAAAAQABUgAABgEAAAAABgEAAAAA\"},\"77\":{\"w\":11,\"h\":11,\"lower\":\"EAEgAABAEAEgAABAEAEgAABABgIAAAAgQwIAAAAgAwMAAAAgUAEgAABAEAEgAABAEAEgAABAEAEgAABAEAEgAABAEAEgAABAEAEgAABAUAEgAABAAwIChQAgQwIAAAAgQwIAAAAgBgIAAAAQBgIAAAAQEAEgAABABgQAAAASEAEgAABAEAEgAABAEAEgAABAQwIBQQAgBgQAAAAgAwIAAAAkBgIAAAAQBgIAAAAQEAEgAABAEAEgAABAUAEgAABAEAEgAABEUAEgAABAAwMAAAAgAwMBUgAgBgcAAAAQAwIAAAAkAwIBQQAgBgIBhQAQAwIBRAAgUAEgAABABgkAAAAQBgYAAAAQEAEgAABAAwMBhQAgAwMBlgAgBggBhQAQAwIBhQAkQwIBlgAgAAMBhQAgRgYAAAAQQwcAAAAgBggBJQAQAwYAAAAkAwIBhQAgBgQChQAQAwQCRAAgBgkAAAAQBgYBWAAUQAMBhQAkAAQAAAAgAwQAAAAgAwcAAAAgQwUBaQAkAwUBJQAkAwQAAAAgBgYAAAAQAwQCWAAgAwcAAAAgQwUAAAAkAwQAAAAkQAQAAAAgAwQChQAgQwcAAAAgQwYBRAAgQwUBhQAkQwICUgAgBgYBhQAQAwQCFAAkBgkAAAAQAwYCWAAkQwQChQAkQwQChQAgQwYBQQAgAwcBUgAgAwgAAAAgAwcBmQAgAwICUgAgBgcAAAAQAwQAAAAkRggAAAAQQwYAAAAkAwYAAAAgRgYAAAAQQwcBQQAgAwoAAAAgAwoAAAAgAwoAAAAgUAEgAABAEAEgAABEAwIBUgAkBggBhQAQAwQBWAAkQwQCJQAkAwYBUgAgRggBUgAQAwkBJQAgRgkAAAAUQwgBJQAkEAEgAABAEAEgAABAAwIBUgAgBgkAAAAQQwQBWAAkAwQAAAAkBgYBUgAQBggBUgAQAwkAAAAgBgkAAAAUQwcBaQAk\"},\"78\":{\"w\":14,\"h\":12,\"lower\":\"AwMAAAAgQwMAAAAgAwQAAAAgBgMBaQAQCAMBFAAgSwEgFABECwEgAABAAwIAAAAgAwIAAAAgAwIAAAAgCwEgAABAAwICQQAgAAAAAAADAAAAAAADAwMAZgAgAwQAAAAgAwQAAAAgCAMBWAAgQwIAAAAkCAIAAAAgCwBAAABACwEgAABACwEgAABAHgUAAAAiCwEgAABAAwICUgAgAAAAAAADAAAAAAADQwMAUgAgHgQBhQAgSAMBJQAgCAMBFAAgSwEgFABECAIAAABACAIAAAAgAwIAAAAgCwBAAABAHgUAAAAiCwBAAABEAwICUgAgAAAAAAADAAAAAAADAwIBJQAgHgUAJQAgSwBAAABESwEgAABECwBAAABACwEgAABAHgUAAAAiCwEgAABACwEgAABACwBAAABAAwICQQAgAwIClgAgAAAAAAADAAAAAAADCwEgAABAHgQBJQAgCwEgJQBEHgUAAAAiAwIAAAAgCwBAAABAHgUAAAAiQwIAAAAkAwIAAAAgCwEgAABAAwICUgAgAwQAUgAgAAAAAAADAAAAAAADSAIAAAAgHgMBJQAgSwEgJQBECwEgAABACwBAAABECAIAAAAgSwEgAABAHgICUgAgHgQBUgAgHgUAUgAgHgQBWAAgAwQAWAAgAAAAAAADAAAAAAADCwEgAABASwEgAABACwBAAABACAIAAAAgCwEgAABACwBAAABACAIAAAAgSwBAAAAgCwEgAABEAAIAAAAkAwICEQAkAwICJQAgAAAAEAADAAAAAAADCAIBQQAgAwIBhQAgCAIBRAAgCwEgRABAHgUAAAAiCwEgAABACwBAAABAAwIAAAAgCwEgAABACwBAAABACwEgAABECwEgAABEAAAAAAADAAAAAAADAwIBlgAgAwMAlgAgCAIBWAAgCwEgWABAHgUAAAAiAwIBQQAkCAIBRAAgCwEgRABAHgUAAAAiCwEgAABAQwIAAAAgQwIAAAAgAAAAAAADAAAAAAADCAIBaQAgSwEgaQBESwEgAABECwBAAABAAwIBQQAgAwIBlgAkAwIBWAAgAwIAWAAgCwEgAABASwBAAABEAwMBQQAgCAMBRAAgAAAAAAADAAAAAAADCAIBWAAgHgUAWAAiHgUAAAAiSwEgAABAAwIBlgAgAwMAlgAgQwIBFAAgCwBAFABECwEgAABAQwIAAAAgAwMBUgAgCAMBmQAgAAAAAAADAAAAAAADCAIBmQAgCAIBRAAgCwEgRABESAIAAAAgAwMAAAAgAwMAAAAgQwIAAAAgCwEgAABESAIAAAAgAwMAAAAgAwMBUgAgCAQAUgAgAAAAAAADAAAAAAAD\"},\"79\":{\"w\":12,\"h\":8,\"lower\":\"AwAAAAAoAwAAAAAoFQABUgAUFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAUFQEAAAAUFQEBUgAUFQIAAAAUAwIAAAAoAwAAAAAoAwAAAAAoVQABUgAQFQEAAAAQFQEAAAAQHgUAAAAkQwMCRAAkFQEAAAAUFQEAAAAUFQEBUgAUFQIAAAAUFQIAAAAYAwAAAAAoAwAAAAAoAwIAAAAgAwMBUgAgQwQAAAAgHgUBQQAgHgUBRAAkQwQBRAAkQwICWAAkVQEBEQAUFQEBJQAUAwEBJQAoAwAAAAAoQwABQQAkRgIAAAAQQwMBUgAgHgUBQQAgXg4AAAAiHg4AAAAiHgUBRAAkXgMBWAAkQwEAAAAkAwEAAAAoAwEAAAAoAwAAAAAoQwABUgAgQwEBJQAkQwMBUgAgHgUBEQAgHg8AAAAiHg4AAAAiKwUBFAAkQwMBWAAkQwECWAAkAwEAAAAoAwEAAAAoAwABhQAkAwABlgAkAwEAAAAkAwMBUgAgHgQBEQAgHgUBEQAkKwUBFAAkQwQAAAAkAwMBWAAkQwMAAAAkAwMBhQAkAwMBRAAoAwEAAAAoAwEAAAAoQwEAAAAoQwIBUgAkQwMAAAAkXgQAAAAkQwQAAAAkQwMBUgAkAwMBWAAoAwMBUgAoAwQAAAAoAwMBWAAoAwEAAAAoAwEAAAAoQwEAAAAoAwIBEQAkQwIBJQAoAwMBJQAoAwMBJQAkQwMBUgAoAwMBWAAoAwMBEQAoAwMBJQAoAwMBFAAo\"},\"80\":{\"w\":12,\"h\":10,\"lower\":\"PxEAAAAiAwcAAAAoHgQBWAAoHgMBWAAkHgMAAAAkAwMAAAAkAAAAAAAkAwIBUgAgAwUAAAAgAwcAAAAgAwcAAAAgAwcAAAAkAwcAAAAgAwcAAAAkAwMAAAAkQwMAAAAgAwMAAAAgAwMAAAAgQwIAAAAkAwIBUgAgAwUAAAAgAwUAAAAgAwcAAAAgPxEAAAAiAwcAAAAgQwYAAAAkAwMAAAAkAwMAAAAgAwEAAAAkQwIBWAAkAwIAAAAkQwIAAAAgQwMBUgAgAwUAAAAgAwcAAAAgAwcAAAAgAwUBJQAkQwUAAAAkAwIBJQAkAwIBJQAkAwIBJQAgAwIBFAAkAwAAAAAgQwIAAAAgAwMBUgAgQwQAAAAgHgQAAAAgAwQAAAAkQwUAAAAkAwMAAAAkXgIAAAAkHgIAAAAgAwIAAAAgAwIAAAAkAAAAAAAkQwIAAAAgQwMAAAAgAwQAAAAgAwQAAAAgHgQAAAAkAwYBhQAkAwIAAAAoHgIAAAAkAwAAAAAkAwIBQQAgAwIBhQAoAAIBRAAoAwIAAAAkAwAAAAAkQwQAAAAgQwQBQQAkHgQBhQAkAwgAAAAkAwIAAAAoAwIAAAAkAwIAAAAgHgIBEQAgPxEAAAAiAAAAAAAiQwIAAAAgQwMAAAAgQwQBUgAgQwUAAAAkQwUAAAAoPxEAAAAiAwUAAAAoAwIAAAAkQwIAAAAkAwIAAAAgAAAAAAAmAAIAAAAgQwIAAAAgAwMAAAAgQwUAAAAgAwYBhQAkAwYBhQAoAwgAAAAgQwcAAAAkAwMAAAAkAwMAAAAkQAIAAAAkAwABhQAgAwIAAAAgAwIAAAAgAwIAAAAgAwcAAAAgPxEAAAAiAwcAAAAoQwYBJQAgAwQAAAAgQwMAAAAkAwIBaQAgQwIAAAAkQwEBhQAgAwIAAAAgAwIAAAAgAwMBUgAgAwcAAAAgAwcAAAAgAwcAAAAk\"},\"81\":{\"w\":11,\"h\":13,\"lower\":\"RAAAAAAgRAAAAAAgAwAAAAAgAwAAAAAgQAAAAAAgIAEAAAAQQAAAAAAgAwAAAAAgRAAAAAAgRAAAAAAgRAAAAAAgRAAAAAAgRAAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgIAEAAAAQQAAAAAAgAwAAAAAgRAAAAAAgRAAAAAAgRAAAAAAgAwQAAAAgAwQAAAAgAAAAAAAgAAAAAAAgQAAAAAAgIAEAAAAQQAAAAAAgAwAAAAAgRAAAAAAgRAAAAAAgRAAAAAAgQAMAAAAgBgQAAAAQAwQAAAAgAwQAAAAgAAAAAAAgIAEAAAAQIAEAAAAUBgQAAAAQBgQAAAAQBgQAAAAQBgQAAAAQAAMAAAAgQAMAAAAgQAMAAAAgBgQAAAAQBgQAAAAQIAQAAAAQJQEChQAUBgQAAAAQQwMAAAAgQwMAAAAgQwMAAAAgHwcAAAAgAwMAAAAgAwMAAAAgQwMAAAAgQwMAAAAgIAQAAAAQQwMAAAAgQwMAAAAgAwMAAAAgAwMAAAAgAwMAAAAgHwkAAAAgBgcAAAAQAwMAAAAgAwMAAAAgQAMAAAAgIAQAAAAQQAMAAAAgAwMAAAAgAwMAAAAgAwcAAAAgAwcAAAAgXwgAAAAgBgcAAAAQAwcAAAAgAwMAAAAgAAMAAAAgIAQAAAAQAAMAAAAgAwcAAAAgAwcAAAAgAwcAAAAgRAYAAAAgAwYAAAAgQAYAAAAgAwcAAAAgAwcAAAAgIAcAAAAQZQQChQAQAwcAAAAgAwcAAAAgRAYAAAAgRAYAAAAgRAYAAAAgAwYAAAAgAwYAAAAgQwYAAAAgQwYAAAAgIAcAAAAQVQYAAAAQQAYAAAAgQAYAAAAgRAYAAAAgRAYAAAAgRAYAAAAgAwoAAAAgAwoAAAAgAwoAAAAgAwYAAAAgIAcAAAAQQAYAAAAgAAYAAAAgAAYAAAAgAwgAAAAgAwgBUgAgAwkAAAAgRAkAAAAgRAkAAAAgAwoAAAAgFQcAAAAUIAoAAAAQAAYAAAAkAwkAAAAgRggAAAAQBggAAAAQAwgBEQAgAwgBJQAgRAkAAAAgRAkAAAAgQwkAAAAgVQkAAAAQIAoAAAAQIAcAAAAUAwgBJQAgAwgBFAAgBggAAAAQAwgBQQAgAwgBhQAg\"},\"82\":{\"w\":11,\"h\":12,\"lower\":\"AQEAAAAgQQEAAAAgVAIAAAAgIAMAAAAQAQEAAAAgAQEAAAAgAQEAAAAgAQEAAAAgAQEBUgAgAQIAAAAgAQIAAAABYAEAAAAQIAIAAAAQIAIBUgAQIAMAAAAQAQEAAAAgQQEAAAAgAQEAAAAgAQEAAAAgAQEBEQAgAQEBJQAgAQEBJQABAQEAAAAgQQEAAAAgYAIAAAAQQQEAAAAgQQEAAAAgIAIAAAAQQQEAAAAgAQEAAAAgAQEAAAAgFQEAAAAQFQIAAAABAQEAAAAgQQEAAAAgIAIAAAAQQQEAAAAgQQEAAAAgIAIAAAAQQQEAAAAgAQEAAAAgAQEAAAAkAQEAAAAgAQEAAAABQQEAAAAgIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQIAIAAAAQQQEAAAAkAQEAAAAkQQEAAAAkFQQAAAAQFQUAAAABAQABZgAgQQEAAAAgQQEAAAAgQQEAAAAgQQEAAAAkIAIBhQAUAQEAAAAkIAUAAAAUIAkBUgAQIAQAAAAQFQUAAAABAQABlgAkAQEAAAAgAQEAAAAkAQEAAAAkYAYAAAAQYAUAAAAQIAYBUgAUIAcCUgAQYAkAAAAQIAQAAAAQFQUAAAABAQEAAAAkAQEAAAAkAQEAAAAkAQEAAAAkYAcAhQAQIAQAAAAQIAQAAAAQAQMAAAAgAQMAAAAgQQMAAAAgAQQAAAABYAQAAAAQYAMBWAAQZQEChQAUIAUCUgAUFAgAAAAgYAcAAAAQIAQAAAAQQQMAAAAgAQMAAAAgQQMAAAAgAQQAAAABIAUAAAAQVAQAAAAgVQMAAAAUIAUAAAAUFAgAAAAgIAgAAAAQIAQAAAAUAQMBRAAkQQMAAAAkYAQAAAAQFQUAAAAFAQEBQQAgFAQAAAAgVQMAAAAQIAUAAAAQVAcAAAAgVAcAAAAgFAcAAAAgJQUCWAAgFAUAAAAgFAUAAAAgFAkAAAABAQEBUgAgQQIBQQAgQQMAAAAgYAQAAAAQIAQAAAAQYAQAAAAQIAUAAAAUYAUAAAAQIAUAAAAQVAQAAAAgFAgAAAAB\"},\"83\":{\"w\":11,\"h\":10,\"lower\":\"AwQAAAAkAwYBUgAkBgcCUgAUBgkBUgAUBgoBUgAUAwsBEQAkAxACUgAgBhIBUgAUBhMDUgAQAxYAAAAgBhYAAAAQBgICJQAQBgQCJQAQAwcCUgAgBgkBUgAQBgoBEQAQAwoBJQAgRg0BZgAQBhABUgAQRhMBUgAQAxYAAAAgAxYAAAAgTwEgAABABgMBJQAQAwcCUgAgAwkBUgAgBgoAAAAQAwoAAAAgBgoBUgAQRg8AAAAQBhABZgAQBhYAAAAQQxUBJQAgBgIAAAAQTwEgAABADwEgAABADwEgAABADwBAAABALQUBUgBAbQkBEQBAbQ0BUgBALRABUgBAbRQBUgBCDxQgAABABgIAAAAQDwEgAABABgIAAAAQDwEgAABADwBAAABADwBAAABAbQcBEQBALQoBZgBAbQ8BEQBALRQBUgBCBhUAAAAQTwEgAABATwEgAABATwEgAABADwEgAABADwBAAABADwBAAABEbQQBUgBELQgBUgBELQ0BUgBELRQBUgBCDxQgAABAAwMBhQAkQwMBRAAkBgIBWAAUDwEgAABEDwBAAABELQMBQQBELQYBQQBEbQwBQQBEbRABUgBAbRQBUgBCTxQgAABEAwQBhQAkQwQAAAAkQwkBQQAkBgoAAAAQBgoAAAAQQwkBWAAkAwkAAAAkBg4BQQAUBhMBUgAQBhYAAAAQAxUBmQAgQwUBRAAkAwQBWAAkAwkBUgAgBgoAAAAQAwoAAAAgQwoBQQAgBg0BhQAUAxABUgAkRhMBUgAUAxYAAAAgAxYAAAAgBgcAAAAUAwcCUgAgAwkBUgAgBgoAAAAQAwoBQQAgAwoBlgAgBhACUgAQBhIDUgAQBhUBUgAQBhYAAAAQAxYAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwkBJQEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwkAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwkAAAEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwkBhQEgAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"84\":{\"w\":14,\"h\":9,\"lower\":\"BgMBhQAQAwMBRAAgRgIAAAAQQwIAAAAgAwIAAAAgAwIAAAAgBgEBWAAgAwEAAAAgAwEAAAAgAwEAAAAgRgEAAAAQAwIBUgAgAwMAAAAgAwMAAAAgBgQAAAAQBgMBmQAQAwMBhQAgAwMBRAAgQwIAAAAgAwIAAAAgBgEBmQAQBgEBRAAQAwEAAAAgAwEAAAAgAwIBQQAgAwIBlgAgAwMAAAAgAwMAAAAgAwQAAAAgBgQAAAAQAwQAAAAgHgwAAAAiAwYAAAAgBgYBUgAQRgcAAAAQBgkBQQAQAwkBhQAgAwkBhQAgAwkBRAAgAwYBhQAgAwYBRAAgAwMAAAAgAwQAAAAgBgQAAAAQBgYBQQAQRgYBhQAQAwgBUgAgAwkAAAAgAwkBQQAgBgkBlgAQBgoAAAAQQwoAAAAgAwsBQQAgAwsBhQAgRgsBRAAQRgkBhQAQBgYBQQAQAwYBhQAgQwYBlgAgBggBQQAQBggBlgAQAwkAAAAgAwkBUgAgHhAAAAAiAwoAAAAgQwoAAAAgAwsBUgAgAwwAAAAgAwwAAAAgBgwAAAAQBgYBlgAQAwcAAAAgQwcAAAAgBggBEQAQBggBZgAQAwkAAAAgAwkBEQAgBgkBJQAQAwkBZgAgQwoAAAAgAwsBUgAgBgwAAAAQBgwAAAAQBgwAAAAQAwcAAAAgAwcAAAAgHg0AAAAiQwcAAAAkBggBEQAQBggBJQAQQwgBFAAgBgYAAAAUQwYAAAAkAwcBEQAkAwcBJQAkBgcBFAAUAwIAAAAkAwIAAAAkAwYBJQAgQwYBFAAgQwUAAAAkAwQBWAAkBgMAAAAUAwMAAAAkBgIBaQAUBgIBFAAUQwEAAAAkAwEAAAAkBgEBEQAUAwEBZgAkBgIAAAAUAwIAAAAgQwUAAAAgQwQBaQAgBgQBJQAQBgQBFAAQQwMAAAAgAwMAAAAgBgIBWAAQQwEAAAAgBgEAAAAQAwEAAAAgAwEAAAAgAwEBUgAgBgIAAAAQBgIAAAAQ\"},\"85\":{\"w\":13,\"h\":13,\"lower\":\"AwEAAAAkQwEAAAAkAwEAAAAkBgUAAAASAwEAAAAgAwEAAAAoQwEBUgAoRgMAAAAUQwEBWAAkAwEAAAAgAwEAAAAgAwEAAAAgAAAAAAADBgMAAAASBgIAAAAQAwEAAAAgAwEAAAAgAwEAAAAgRgQAAAAQAwIAhQAoBgUAAAASAwEBFAAkAwEAAAAgQwEAAAAkBgQAhQASAAAAAAADAwEAAAAgQwEAAAAgAwEBQQAgAwEBhQAgAwEBhQAgBgYAAAASAwIAAAAgBgQAAAAQAwEAAAAgBgQAAAASAwEAAAAkQwEAAAAgAAAAAAADAwEAAAAgBgQAAAASQwEBlgAgAwIAAAAgAwIAAAAgAwIAAAAgAwEBaQAgQwEAAAAgBgEAAAAgBgICJQAQAwEAAAAgAwEAAAAgAAAAAAADAwEBhQAgAwEBlgAgAwIAAAAgAwIAAAAkAwIAAAAgAwIAAAAgQwEBFAAgQwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgBgUAAAASAAABJQADAwIAAAAgBgIAAAAgBgUBWAASBgIDWAAiAwEBJQAgAwEBJQAgQwEAAAAgBgMAaQASAwABJQAgAwABJQAgAwABJQAgAwABJQAgAAAAAAADBgIAAAAgRgIAAAAgBgMCJQASAwEAAAAgAwEAAAAgAwEAAAAgQwEAAAAgBgMAFAASAwAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAAAAAAADQwIAAAAgBgQAAAASBgQAAAASQwEAAAAgAwEAAAAgAwEAAAAgQwAAAAAgQwAAAAAgAwAAAAAgAwAAAAAgBgAAAAAgBgMAAAASAAAAAAADBgMAAAAQRgEAAAAkAwEAAAAgQwEAAAAgBgMAAAASAwABJQAgQwAAAAAkAwAAAAAkAwAAAAAgAwAAAAAgBgIChQASQwAChQAkAAAChQADBgQAAAASAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgRgABUgAQBgEBUgASBgIBWAASAwAAAAAgBgAEUgASBgQBUgASAwIAAAAgAAAAAAADQwEBFAAgAwEAAAAgAwEAAAAgAwEAAAAkAwEAAAAkQwAAAAAgAwAAAAAgAwAAAAAkAwAAAAAkQwACUgAgBgIAAAAgBgIAAAAgAAAAAAADAwEAAAAgAwEAAAAgBgIAAAAQBgMAAAASBgECWAASQwAAAAAgRgEAAAAQBgMAAAASAwAAAAAgAwACUgAgBgIAAAAgAwIAAAAgAAAAAAADBgEAAAAgAwEAAAAgQwEAAAAgBgMAAAASAwAAAAAgAwAAAAAgQwAAAAAgAwAAAAAgAwAAAAAgAwACUgAgBgIAAAAgAwIAAAAgAAAAAAAD\"},\"86\":{\"w\":10,\"h\":8,\"lower\":\"AwEAAAAgAwEAAAAkAwEAAAAkAwABWAAkAwAAAAAkAwABUgAgAwEAAAAgAwEAAAAgAwEBUgAkAwIAAAAkBgEAAAAUBgEAAAAURgICUgAUBgQAAAAUAwAAAAAkAwABUgAkAwEAAAAkBgYAAAAQRgQBhQAUBgIChQAUAwgAAAAgAwgAAAAgBggAAAAQRgYAAAAURgYAAAAWBgcAAAASBgcAAAAQBgYBWAAUQwUAAAAkRgQAAAAQBgcBZgAQAwgAAAAgBggAAAAQBgcBWAAUAwcAAAAkAwcAAAAgAwcAAAAgQwYBWAAkQwUAAAAkBgYChQAUQwYAAAAgRgcAAAAURggChQAQBgsAhQAQAwcAAAAkAwcAAAAkBggBQQAQRgcCWAAUAwYAAAAkBggAAAAQBgcChQASBgkBUgAQRgoAAAAQAwsAAAAgBgsBQQASRgwAAAAWBgwBQQAQBgwBhQAQAwcAAAAkAwcAAAAkRgkBlgAQBgsAAAAQAwsAAAAgAwsAAAAkQwsBUgAkAwwAAAAgAwwBUgAgAw0AAAAgAw0AAAAgBg0AAAAQRgoAAAAQBgsAAAAQBg0BUgAQBg0BWAAQRgwAAAAQAwwAAAAgAwwBUgAgAw0AAAAgBg0AAAAQBg0AAAAQ\"},\"87\":{\"w\":12,\"h\":12,\"lower\":\"AwgAAAAoQwcBhQAgQwcAAAAkAwYBWAAgDwUgAABEQwcCUgAkAwsAAAAgAwcBWAAgDwRAAABADwUgAABEAwoBUgAkAwsBUgAgAwgChQAkAwgChQAgAwcARAAgAwYBFAAgDwUgAABEAwgDUgAkAwsAAAAgAwcEWAAgDwRAAABATwUgAABEQwkCUgAkAwsBEQAgHhIAAAAiAwoAAAAgQwgCWAAgDwQgAABADwUgAABEQwgCUgAkAwoBJQAgAwYBFAAgTwUgAABAAwcAAAAkQwkCEQAkAwoBJQAgFQsAAAAUQwoBhQAgVQoAAAAQDwNAAABATwQgAABEQwcDEQAkAwoAAAAgDwMgAABEDwJAAABEQwYBUgAkQwcBUgAkQwkAAAAgFQsAAAAUQwoBWAAgQwYEWAAgTwNAAABADwQgAABEDwMgAABEAwYEJQAkDwMgAABATwJAAABAQwUCEQAkQwcBEQAkAwcCJQAgFQsBhQAUAwoBFAAgQwgCFAAgFQgAAAAQDwJAAABEDwMgAABEDwMgAABADwJAAABADwJAAABADwMgAABEQwYAAAAgAwYBJQAgAwkAAAAkQwkAAAAgQwgAAAAgFQgAAAAQFQgAAAAQDwMgAABADwMgAABADwJAAABADwMgAABADwMgAABEQwYBhQAgAwYChQAgAAkAAAAgQwgBWAAgQwgAAAAgVQgAAAAQVQcBWAAQAwYBJQAgDwJAAABADwJAAABATwMgAABAQwUBQQAkHgwAQQAiAwgAAAAkAAkAAAAgAwkAAAAgAwkAAAAgAwkAAAAgVQcCWAAQQwYAAAAgDwMgAABAFQYAAAAQDwMgAABEAwYAAAAkQwcBUgAkAwgAAAAkFQsAAAAkAwkBRAAgAwkAAAAgHhAAAAAiAwkBhQAgAwcAAAAgDwMgAABEDwMgAABADwMgAABEQwYBhQAkFQkAAAAUQwgBhQAkAwsBhQAkAw4BRAAgAwwCWAAgAwsBWAAgQwoBhQAgAwYBFAAgTwIgAABADwIgAABEAwUCUgAkQwcBUgAkFQkAAAAUHhEAAAAiAw8BWAAgAw4BWAAgAwgGWAAgQwgDEQAkQwkCFAAgDwBAAABATwBAAABADwIgAABEAwUCUgAkAwcBUgAkQwgBUgAkAwkAAAAg\"},\"88\":{\"w\":10,\"h\":17,\"lower\":\"AAIAAAAgAwIBQQAgAwIBhQAgAwIBhQAwTwBAAABARwIAAAAwAwIBhQAgQwEBaQAkQwEBFAAkDwAgAABEAAIAAAAgAwIBUgAgAwMAhQAgAwMAhQAgTwBAAABARwIAAAAwAwMAhQAgAAMAaQAgAwIBmQAgTwAgAABEAAIBQQAgAwIBlgAgHgkAAAAiBwMAAAAwDwIgAABAAAMAAAAwBwMAAAAwDwFAAABADwFAmQBADwIgAABAAAIBlgAgAAMAlgAgAwMAAAAgDwFAAABETwFAAABAAwMBRAAgBwMAAAAwDwFAAABADwFAAABABwMAAABAQAMAlgAgQAMAAAAgBwMAAAAwTwFAAABAAwMBlgAkAwMBWAAgDwFAAABADwIgAABABwMBQQAwAwMBhQAgAwMBlgAgAwMBmQAgRwMAAAAwTwFAAABAAwMBaQAgAwMBFAAgDwFAAABADwIgAABABwMBUgAwHgoAhQAiQwQAlgAgHgoAmQAiAwMBmQAwTwFAAABAAwMBFAAgBwMAFAAwDwFAAABABwMAAAAwAwMBEQAgAwMBZgAgAwUBhQAgQwQBhQAgAwQBRAAkTwFAAABABwMAFAAwDwIgAAAwDwFAAABABwMAAAAwAwMAEQAgAwMBEQAgAwYAhQAgQwUBRAAgAwQBWAAkTwFAAABEDwIgAABADwFAAABADwFAAABABwMAAAAwAAMAAAAgAAMAEQAgAwYAAAAgAwUBmQAgTwFAWABEDwFAAABATwFAAABETwFAAABAAwMBhQAgAwMBRAAgAwMAAAAgAAMAAAAgBgcBhQAgQwYBhQAgDwFAAABEDwFAAABAAwYBhQAgTwFAAABEAwMBZgAgAwMBmQAgAwMBhQAgAwMBhQAgAwcBaQAgQwcAhQAgAwcAAAAgTwUgAABAAwcAhQAgTwUgAABAAwcAZgAgAwQBRAAgAwQAhQAgAwQAhQAgAwcBmQAgAwcBhQAgQwcAAAAgTwRAAABAAAYBJQAgTwRAAABAAAYBJQAgRgYARAAgAwYBRAAgQwQBRAAgAwkBhQAgQwgAhQAgQwYBaQAgTwRAAABADwRAJQBADwRAAABADwRAJQBATwRAAABAAwYBWAAgAwQBmQAkAwoBhQAgAwgBlgAgAwgBWAAgAwcBmQAgTwRAAABADwRAAABADwRAAABATwRAAABAAwYBmQAgAwYBhQAgAwsAhQAgAwsAlgAgAwoBWAAgAwoAmQAgAwkBmQAgTwggAABATwggAABATwggAABAAwkBmQAgAwcAhQAgAwsAAAAgAwoBaQAgAwoBFAAgAwoAAAAgAwoAmQAgTwdAAABAAwoAAAAgTwdAAABAAwoAmQAgAwcBhQAk\"},\"89\":{\"w\":12,\"h\":14,\"lower\":\"GgEBhQAgGgEBhQAgGgEBhQAgGgEBhQAgGgEBhQAgGgEBhQAgWgEAAAAgGgEAAAAgWgEAAAAgWgEAAAAgGgEAAAAgAAAAAAADGgIBhQAgGgIBhQAgGgIBhQAgGgIBhQAgBgIBhQAQWgIAAAAgRgEAAAAQWgEAAAAgGgIBhQAgBgIBhQAQRgEAAAAQAAAAAAADRgMAAAAQBgMBhQAQBgMBhQAQGgMBhQAgBgMBhQAQRgEBaQAQGgEAAAAgBgEAAAAQBgMAAAAQBgMAAAAQGgEAAAAgAAAAAAADGgEAAAAgBgQBhQAQBgQBhQAQGgQBhQAgRgQAAAAQBgEAAAAQFAEAAAAgFAEAAAAQBgMAAAAQBgMAAAAQBgMAAAAQAAAAAAADGgEAAAAgBgUAAAAQBgUAAAAQBgUAAAAQBgEAAAAQBgEAAAAQFAEAAAAgFAEAAAAgGgEAAAAgGgEAAAAgGgEAAAAgAAAAAAADBgEAAAAQBgEAAAAQBgEAAAAQBgEAAAAQGgEAAAAgGgEAAAAgFAEAAAAgFAMBhQAgBgMBhQAQBgMBhQAQGgEAAAAgAAAAAAADBgEAAAAQBgEAAAAQBgEAAAAQBgEAAAAQGgEAAAAgBgMBhQAQVAMBhQAgFAQAAAAgGgQAAAAgIwwAAAAgBgEAAAAQAAAAAAADBgEAAAAQBgEAAAAQBgEAAAAQGgEAAAAgRgMBhQAQBgQAAAAQGgQAAAAgGgQAAAAgBgQAAAAQBgQAAAAURgEAAAAQAAAAAAADRgEAAAAQGgEAAAAgGgEAAAAgWgEAAAAgBgQAAAAQRgQAAAAQBgQAAAAQBgQAAAAQBgQAAAAQBgQAAAAQBgIBhQAUAAABhQADGgIBhQAgWgEAAAAgWgEAAAAgRgIBhQAQRgQAAAAQRgUBhQAQIA0AAAAQYAoAAAAQIAsAAAAQIwsAAAAgBgMAAAAUAAAAAAADGgMBhQAgBgMBhQAQGgEAAAAgRgMAAAAQBgQAAAAQIAoAAAAQIAoAAAAQIAoAAAAQYAoAAAAQYAoAAAAQBgQBhQAUAAABhQADBgQAAAAQBgQAAAAQGgEAAAAgBgYAAAAQBgcBhQAQYAoAAAAQIAwAAAAQYAoAAAAQIAsAAAAQYAoAAAAQBgUBhQAUAAABhQADBgQAAAAQBgQAAAAQBgIBhQAQBgYAAAAQBggAAAAQAQgAAAAgQQgAAAAgIAkAAAAQIAkAAAAQIAkAAAAQBgYAAAAUAAAAAAADAQQAAAAgQQMAAAAgRgMAAAAQAQQAAAAgAQgAAAAgAQgAAAAgIAgAAAAQYAgAAAAQQQgAAAAgIAkAAAAQYAgAAAAQAAAAAAAD\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwsAAAEAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwsAAAEAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"90\":{\"w\":10,\"h\":12,\"lower\":\"AwIAAAAgAwICUgAgFAQAAAAgFAQCUgAgVAYAAAAgAwcAAAAgAwYBWAAgAwAAAAAgAAAAAAAgAwAAAAAgAwIAAAAgAwICUgAgAAQAAAAgFAQCUgAgVAYAAAAgAwYBJQAgAwYBFAAgBgICRAAQAwAAAAAgAwAAAAAgBgcAAAAQBgcAAAAQAwQAAAAgAwQCUgAgAAYAAAAgAAYAAAAgAAYAAAAgAwYAAAAgAwAChQAkAwACRAAgBgoAAAAQBgoAAAAQBgoAAAAQVAYAAAAgAwYAAAAgAwYCQQAgQAYChQAgBgkAAAAQBgkAAAAQAwACmQAkBgoAAAAQVAkAAAAgVAcCWAAgFAcAAAAgBgwAAAAQBgwAAAAQQwgAAAAgQwgAAAAgBgkAAAAQBgUAAAAUQwkAAAAgFAkAAAAgBgwAAAAQBg8AAAAQBg8AAAAQBg8AAAAQAwgAAAAgQwcAAAAkBggBJQAQBgUAAAAUAwkAAAAgAwkAAAAgBgwAAAAQBg8AAAAQBg8AAAAgBg8AAAAQAwUCJQAkVAUCJQAkBggAAAAQRgQBJQAWBgcCJQAQBgcCJQAUBgcCZgAUBg8AAAAQBg8AAAAQBgwAAAAUFAUAAAAkFAMCWAAkAwABWAAkAwAAAAAkBgMCEQAUBgMCJQAUBgMCJQAUAwMAAAAkFAMCUgAkFAUAAAAkVAUAAAAkQAMCWAAkAAABFAAkAwAAAAAkAwEAAAAgAwEAAAAkAwECUgAkQAMAAAAgQAMCUgAkQAUAAAAkBgYAAAAQBgYAAAAUAwAAAAAkAAAAAAAkQwAAAAAgAAEAAAAgAAECUgAgBgQAAAAQBgQCUgAQBgYAAAAQBgYAAAAQAwAAAAAkAAABQQAkAAABhQAkQAAAAAAgAAEAAAAgQwEAAAAgAwEAAAAkAwABWAAkAwAAAAAkAwAAAAAkAwAAAAAkAwABUgAkAwEAAAAk\"},\"91\":{\"w\":10,\"h\":12,\"lower\":\"EQBAAABEEQBAAABAFAIAAAAgFAIAAAAgFAIAAAAgFAIAAAAgEQEgAABAEQBAAABAEQBAAABAFAIAAAAgEQBAAABEEQBAAABAFAIAAAAgFAIAAAAgFAIAAAAgVAIAAAAgUQBAAABAUQBAAABAEQBAAABAEQEgAABAFQYAAAAUFQYAAAAQFQYAAAAQEQEgAABAUQEgAABAFQMAAAAQFQMAAAAQFQMAAAAQUQBAAABAEQBAAABAFQYAAAAUFQYAAAAQFQYAAAAQFAIBhQAgFAIBhQAkFAUAAAAgFAUAAAAgFAUAAAAgVQIAAAAQEQBAAABAFAYAAAAkFAYAAAAgVQYAAAAQFAMBhQAgVAMBhQAkFAUAAAAgFAUAAAAgFAUAAAAgVAMBWAAgUQEgAABAAwYAAAAkQwYAAAAkAwcAAAAgFAQBhQAgVAQBhQAgFAUAAAAgFAUAAAAgFAUAAAAgVAMBWAAgUQBAAABAAwQAAAAkQwYAAAAkFQcAAAAQVAQBJQAgFAUBhQAgFAUBhQAgQwQAAAAgQwMAAAAgVQIAAAAQEQBAAABAQwMAAAAkAwYAAAAkFQ0AAAAQFAMBJQAkFAYBhQAgFAYBhQAgAwQAAAAgVQIAAAAQEQBAAABAEQBAAABAQwIAAAAkQwQBJQAkFQ0AAAAQFAMAAAAkVQsAAAAQFQsAAAAQVAkAAAAQFQkAAAAQFQYAAAAQEQEgAABAUQEgAABEAwIBJQAkFQsAAAAUFAMAAAAkFAMAAAAkFAMAAAAkFAkAAAAQVQgAAAAQFQYAAAAQEQEgAABAEQEgAABEAwIAAAAkVAoAAAAkFAMAAAAkFAMAAAAkFAMAAAAkVAgAAAAQFQgAAAAQFQYAAAAQEQEgAABAEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABEEQEgAABA\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABVQwAAAMQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"92\":{\"w\":10,\"h\":8,\"lower\":\"FwwAAAASFwwAAAASHQIAAAAkHQIAAAAkHQIAAAAkHQIAAAAkFwwAAAASHQMAAAAoHQMAAAAoHQMAAAAoFwwAAAASFwwAhQASHQIAAAAkHQIAAAAkHQIAAAAkHQIAAAAkFwwAAAASHQIAJQAkHQIAJQAkHQIAJQAkHQIAAAAgHQIAAAAgHQIAAAAkHQIAAAAkHQIAAAAkHQIAAAAkFwwAAAASHQIAAAAgHQIAAAAoHQIAAAAoHQIAAAAgHQIAAAAgHQIAAAAgJgMAAAAgHQIAAAAgHQIAAAAkFQIAAAAQHQIAAAAoHQIAAAAoHQIAAAAoHQIAAAAgHQIAAAAgHQIAAAAgJgMAAAAgHQIAAAAgHQIAAAAkFwwAAAASHQIAAAAoHQIAAAAoHQIAAAAoHQIAAAAgHQIAAAAgHQIAAAAkHQIAAAAkHQIAAAAkHQIAAAAkFwwAAAASHQIAAAAoHQIAAAAoHQIAAAAoFwwAAAASFwwAAAASHQIAAAAkHQIAAAAkHQIAAAAkHQIAAAAkFwwAAAASJQEAAAAoJQEAAAAoJQEAAAAoFwwAAAASFwwAAAASHQIAAAAkJgYAAAAUJgYAAAAUHQIAAAAkFwwAAAASHQAAAAAoHQAAAAAoHQAAAAAo\"},\"93\":{\"w\":9,\"h\":9,\"lower\":\"FAUAAAAEFAUAAAAEFAUAAAAEFAUAAAAEFAUAAAAEFAUAAAAEFAYAAAAEIBMAAAACIBMAAAACFAUAAAAEFAUAAAAEHAYAAAACHQUAAAAAHQUAAAAAHQUAAAAEFAYAAAAEIBMAAAACIBMAAAACJQQBJQAEJQQBJQAEHAYAAAACHQUAAAAAHQUAAAAAHQUAAAAAFAYAAAAAIAYCJQACFAYAAAACJQMBJQAEJQMBJQAEHAYAAAACHQUAAAAAHQUAAAAAHQUAAAAAFAYAAAAAIAYCQQACIAYChQACJQIBJQAEJQIBJQAEHAYAAAACHQUAAAAAHQUAAAAAHQUAAAAAFAYAAAAAIAYCUgACIAgCQQACJQEBJQAIJQEBJQAIHAYAAAACHQUAAAAAHQUAAAAAHQUAAAAAGgYAAAAAIBMAAAACIBMAAAACJQABJQAIJQABJQAIHAYAAAACFAUAAAAAFAUAAAAAFAUAAAAAFAYAAAAAIBMAAAACIBMAAAACIBMAAAACFAAAAAAMFBMAAAACFBMAAAACFBMAAAACFBMAAAACFBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAACIBMAAAAC\"},\"94\":{\"w\":9,\"h\":5,\"lower\":\"FQIAAAAYFQIAAAAYFQAAAAAYFQAAAAAYFQAAAAAYFQAAAAAYFQAAAAAYVQAAAAAYFQECUgAYFQIAAAAUPwsAAAASFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQIAAAAUHQEAAAAkHQAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkHQAAAAAkFQAAAAAUFQAAAAAQFQIAAAAQHQEAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgFQAAAAAQFQAAAAAQFQIAAAAUHQEAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgHQAAAAAgFQAAAAAQFQAAAAAQ\"},\"95\":{\"w\":9,\"h\":12,\"lower\":\"FQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUVQAAAAAUFQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUVQAAAAAUFQAAAAAUJgEAAAAgJgEAAAAkVQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUVQAAAAAUJgEAAAAgJgEAAAAgFQAAAAAQVQAAAAAUFQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUVQAAAAAQFQAAAAAQJgEAAAAgJgEAAAAkVQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUVQAAAAAUJgEAAAAgJgEAAAAgFQAAAAAQVQAAAAAUFQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUFQAAAAAUVQAAAAAQFQAAAAAQJgEAAAAgJgEAAAAkVQAAAAAUFQAAAAAUHQAAAAAgFQAAAAAUVQAAAAAUJgEAAAAgJgEAAAAgFQAAAAAQVQAAAAAUFQAAAAAUFQAAAAAUHQAAAAAkFQAAAAAUFQAAAAAUVQAAAAAUFQAAAAAQVQAAAAAUFQIAAAAUFQIAAAAUFQIAAAAUFQIAAAAgFQIAAAAUFQIAAAAUFQIAAAAUVQAAAAAQFQEAAAAUFQIAAAAQFQIAAAAUJgQAAAAgJgYAAAAyJgQAAAAgFQIAAAAUFQIAAAAQFQEAAAAUFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAUFQIAAAAUJgQAAAAkFQIAAAAUFQIAAAAUFQIAAAAQFQIAAAAU\"},\"96\":{\"w\":9,\"h\":8,\"lower\":\"PwsAAAAiPwsAAAAiPwsAAAAiPwsAAAAiPwsAAAAiIAAAAAAQIAAAAAAQPwsAAAAiPwsAAAAiHwIAAAAkHwEAAAAkJgMAAAAkIAAAAAAUIAAAAAAUIAAAAAAQIAAAAAAQJgMAAAAkJgEAAAAkHwEAAAAkIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUJgEAAAAkJgQAAAAmFAIAAAAkFAsAAAAmIAAAAAAUJgEAAAAkJgEAAAAkJgEAAAAkIAAAAAAUJgEAAAAkFAUAAAAmAAAAAAAkFAIAAAAkIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUFAUAAAAmAAAAAAAkFAIAAAAkIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUIAAAAAAUAAAAAAAkAAAAAAAkFAIAAAAkIAAAAAAUIAAAAAAUJgEAAAAkIAAAAAAUFAsAAAAmIAAAAAAYFAUAAAAmFAUAAAAmFAYAAAAmJgQAAAAkIAAAAAAUJgEAAAAkIAAAAAAUIAAAAAAYIAAAAAAY\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABPwsAAAQmPwsAAAQmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmFAoAAAEmAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABFAoAAAEmFAoAAAEmFAoAAAEmFAoAAAEmFAoAAAEmAAAAAAABFAoAAAEmAAAAAAABAAAAAAABFAoAAAEmAAAAAAABAAAAAAABAAAAAAABAAAAAAABFAoAAAEmAAAAAAAB\"},\"97\":{\"w\":11,\"h\":13,\"lower\":\"FggCWAAwFgYCWAAwAAAAAAAgAAAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgFggCWAAwFgYCWAAwAAAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAwAAAAAgAwAAAAAgFggCWAAwFgYCWAAwFgQCWAAwAwAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgFgkCUgAwFgkCWAAwFgcCWAAwAwAAAAAkAwAAAAAkAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAwAAAAAgFgkCUgAwFgkCWAAwFgcCWAAwAwAAAAAkAAAAAAAkAAAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgAAAAAAAgFgkCUgAwFgkCWAAwFgcCWAAwAwAAAAAkAAAAAAAkAAAAAAAgAwAAAAAgAAAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgFQsAAAASFQsAAAASAwAAAAAkAwAAAAAkAAAAAAAgAAAAAAAgAAAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgFQkAAAAQFQkAAAAQAwAAAAAkAAAAAAAkAAAAAAAgAAAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAwAAAAAgAAAAAAAgFRMAAAASFREAAAAQFRMAAAASFQAAAAAkFQAAAAAQAAAAAAAgAAAAAAAgFRMAAAASFREAAAAQFRMAAAASAwAAAAAgFREAAAAQFREAAAAQFREAAAAQFQAAAAAUFQAAAAAQFQAAAAAQAAAAAAAQFREAAAAQFREAAAAQFREAAAAQAwAAAAAgFRMAAAASFREAAAAQFRMAAAASFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAQFRMAAAASFREAAAAQFRMAAAASFQ8AAAASFQAAAAAQFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAU\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQ8AAAYWFQ4AAAQQFQ8AAAUSFQ4AAAUQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFQ8AAAYSFQ4AAAQQFQ8AAAUSFQ4AAAUQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"98\":{\"w\":12,\"h\":11,\"lower\":\"FRYAAAAWAwUCWAAkAwMCWAAkAwECWAAgAAABWAAkAAAAAAAkAAABUgAkAwECUgAkAwMCUgAkAwUBUgAkAwYAAAAgAwYAAAAgFRkAAAASFRcAAAAQFRkAAAASAwECFAAgAAABWAAkAAAAAAAkAwABUgAkAwECUgAkAwMCUgAkAwUBUgAkAwYAAAAgAwYAAAAgFRcAAAAQFRcAAAAQFRcAAAAQAwABJQAgAAABFAAkAAAAAAAkAwABUgAkAwECUgAkAwMCUgAkAwUBUgAkAwYAAAAgAwYAAAAgFRkAAAASFRcAAAAQFRkAAAASFQYAAAAQFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAQFQYAAAAQFQYAAAAQFQYAAAAQFQQAAAAQFQQAAAAQFQQAAAAUFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAUFQQAAAAQFQQAAAAQFQQAAAAQFRkAAAASFRcAAAAQFRkAAAASFQYAAAAUFQYAAAAQFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAUFQYAAAAQFQYAAAAQFQYAAAAQFRcAAAAQFRcAAAAQFRcAAAAQAwABWAAkAAAAAAAgAwAAAAAkAwABUgAkAwECUgAkAwMCUgAkAwUBUgAkAwYAAAAgAwYAAAAgFRkAAAASFRcAAAAQFRkAAAASAwABWAAkAAAAAAAgAwAAAAAkAwABUgAkAwECUgAkAwMCUgAkAwUBUgAkAwYAAAAgAwYAAAAg\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFRQAAAkQFRQAAAkQFRMAAAgQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFRUAAAoSFRUAAAoSFRMAAAgUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFRQAAAkQFRQAAAkUFRMAAAgUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFRUAAAoWFRUAAAoWFRMAAAgUAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"99\":{\"w\":12,\"h\":16,\"lower\":\"FgcCWAA0FgUCWAA0JAAAAAAQJAAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgcCWAA0FgUCWAA0JAAAAAAUJAAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQCQQAAAAUEwMAAAAUEwIAAAAUEwEAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQCQQAAAAQEwMAAAAQEwIAAAAQEwEAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgYEUgAyIQ0AAAASFgoDQQAyFgoDhQAwFgoDRAAyEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgYEUgAyIQ0AAAASFgoDUgAwFg4AAAAwFgoDWAA0EwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgYEUgAyFgYEWAA2FgoDEQAyFgoDJQA0FgoDFAA2EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgYEUgAyFgYEWAA2FgsAWAAwFgkCWAA0FgUCWAA0EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFQAAAAASFQAAAAASFgsAAAAwFgkCWAA0FgUCWAA0EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFQAAAAASFQAAAAASFgkCWAA0FgcCWAA0FgUCWAA2EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgkCWAA0FgcCWAA4FgkCWAA0FgcCWAA0EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgkCWAA0FgcCWAA4FgkCWAA0FgcCWAA0EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFgkCWAA0FgcCWAA4FgkCWAA0FgcCWAA0FgUCWAA0BwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFQAAAAASFQAAAAASFgoDQQAyFgoDhQAwFgoDRAAyBwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFQAAAAASFQAAAAASFgoDUgAwFg4AAAAwFgoDWAA0EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQFQAAAAASFQAAAAASFgoDEQAyFgoDJQA0FgoDFAA2EwAAAAAUEwAAAAAUEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQEwAAAAAQ\"},\"100\":{\"w\":15,\"h\":15,\"lower\":\"AwAAAAAgAwAAAAAgQwAAAAAgLAEAAAAQLAMAAAAQQwABQQAkQwABlgAkQwEAAAAgAwEBUgAkAwIAAAAgAwIBUgAkAwMAAAAkQwMAAAAkQwMAAAAkAwMAAAAkAwAAAAAgAwAAAAAgQwAAAAAgQwAAAAAgAwAAAAAgAwABUgAgLAIAAAAQLAQAAAAQQwEBUgAkHg4AAAAiAwIBUgAgQwMAAAAgLAQAAAAQLAYAAAAQAwMAAAAkAwAAAAAgQwAAAAAgLAEAAAAQLAIAAAAQAwAAAAAgAwABUgAgQwEAAAAgQwEAAAAgAwEBEQAgAwEBZgAgAwIBEQAgAwIBJQAgQwIBZgAgQwMAAAAgAwMAAAAkAwAAAAAgAwAAAAAgQwAAAAAgQwAAAAAgAwABQQAgAwABlgAgAwEAAAAgAwEAAAAgAwEAAAAgFQEBUgAQFQIAAAAQFQIAAAAQFQIBUgAQFQMAAAAQFQMAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQABUgAQFQEAAAAQAwEAAAAgAwEAAAAgFQEAAAAQFQEBUgAQFQIAAAAQFQIAAAAQFQIBUgAQFQMAAAAQAwMAAAAUFQAAAAAQFQAAAAAQFQAAAAAQAwAAAAAQAwABUgAQFQEAAAAQAwEAAAAgAwEAAAAgAwEAAAAgAwEBEQAkAwIBQQAgAwIBhQAgAwIBlgAgAwMAAAAgFQMAAAAkAwAAAAAgAwAAAAAgQwAAAAAgQwAAAAAgAwABUgAkFQEAAAAQFQEAAAAQLgMAAAAwLAYAAAASAwEAAAAkAwIBUgAgAwMAAAAgAwMAAAAgAwMAAAAgAwMAAAAkAwAAAAAgQwAAAAAgLAEAAAAQLAMAAAAQQwABUgAgAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgAwIBUgAgAwMAAAAgAwMAAAAgHg8AAAAiAwMAAAAkAwAAAAAkAwAAAAAgQwAAAAAgQwABQQAgAwABlgAgAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgAwIBQQAgQwIBlgAgQwMAAAAgAwMBQQAkAwMBhQAgAwMBhQAkAwAAAAAkQwAAAAAgQwAAAAAgAwABUgAkAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgAwEAAAAgQwIBUgAgLAQAAAAQLAYAAAAQQwMBUgAkAwQAAAAgAwQAAAAkQwAAAAAkLAEAAAAQLAMAAAAQQwABUgAgAwEAAAAgQwEAAAAgQwEAAAAgAwEAAAAgAwIBQQAgQwIBlgAgQwMAAAAgQwMBQQAkAwMBlgAgAwQAAAAgAwQAAAAkAwAAAAAkQwAAAAAgQwAAAAAgAwABEQAgQwABZgAgLAIAAAAQLAMAAAAQQwEAAAAgQwIBUgAkLAQAAAAQLAYAAAAQQwMBUgAkAwQAAAAgQwQAAAAgQwQAAAAkAwAAAAAkQwAAAAAgQwAAAAAgAwAAAAAkAwABUgAgQwEAAAAgQwEAAAAgAwEAAAAkAwIBUgAgQwMAAAAgQwMAAAAgAwMBUgAgQwQAAAAgLAUAAAAQLAYAAAAQQwAAAAAgLAEAAAAQLAMAAAAQAwAAAAAgAwABUgAgAwEAAAAgHg0AAAAiAwEAAAAgAwIBUgAgAwMAAAAgAwMAAAAgAwMBUgAkAwQAAAAgQwQAAAAgQwQAAAAgAwAAAAAgQwAAAAAgQwAAAAAgAwAAAAAgAwABUgAgAwEAAAAkAwEAAAAgAwEAAAAgAwIBUgAgAwMAAAAgAwMAAAAkAwMBUgAkAwQAAAAkAwQAAAAkAwQAAAAg\"},\"101\":{\"w\":11,\"h\":11,\"lower\":\"EQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQIBhQAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQFQIBJQAQEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQEgAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABAEQBAAABA\"},\"102\":{\"w\":11,\"h\":11,\"lower\":\"FQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQAAAAAQVQAAAAAQVQAAAAAQVQAAAAAQVQAAAAAQVQAAAAAQVQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQEAAAAQFQEAAAAQFQEAAAAQFQEAAAAQFQEAAAAQFQEAAAAQFQEAAAAQVQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQEAAAAQVQEAAAAQVQEAAAAQVQEAAAAQVQEAAAAQVQEAAAAQVQEAAAAQVQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQIAAAAQVQIAAAAQVQIAAAAQVQIAAAAQVQIAAAAQVQIAAAAQVQIAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQFQMAAAAQVQMAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQUAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQVQcAAAAQFQcAAAAQFQcAAAAQFQcAAAAQFQcAAAAQFQcAAAAQFQcAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQkAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQkAAAAQ\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwkAAAEQIwkAAAEQIwkAAAEQAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"103\":{\"w\":8,\"h\":10,\"lower\":\"AwQAAAAgAwQAAAAgAwMBWAAgAAMAAAAgQAMAAAAkAwQAAAAkAwQAAAAkBgQAAAAmAwQAAAAgAwQAAAAgQwMAAAAgAAMAAAAgFhQAhQAyFhQAAAAyFhQAAAAyBgQAAAAmAwMBJQAgQwMAAAAgQAIBJQAgAwQAAAAgFhQAAAAyFhQAAAAyFhQAAAAyBgQAAAAmAwMAAAAgQwIAAAAgAAIAAAAgAwUAAAAgFhQAAAAyFhQAhQAyFhQAAAAyBgQAZgAmAAIBJQAgQAIAAAAgAAIAAAAgQwYAAAAgFgsBJQAQFgsBJQAQFgsBJQAQBgcAWAAmAAIAAAAgQAIAAAAgAwMAAAAgAwcAAAAgAwcAAAAgFQcAAAAQAwcAAAAgAwcAAAAkAwIAAAAgAAIAAAAgQwYAAAAgAwcAAAAgAwcAAAAgAwcAAAAQAwcAAAAgAAUAAAAgAwEBJQAgAAEBJQAgQwUAAAAgYAUCUgAQIAcAAAAQIAcAAAAQAwUAAAAgAwUAAAAgAwEAAAAgAwEAAAAgAwUAAAAgYAUAAAAQFQEAAAAUAwEAAAAgBgUAJQAgRgEEJQAgAwEAAAAgAwEAAAAgAwABWAAgAAAAAAAgAwAAAAAgAAAAAAAgAAAAAAAgQAAAAAAg\"},\"104\":{\"w\":6,\"h\":12,\"lower\":\"PwgAAAACPwgAAAACFQAAAAAAFQAAAAAAPwgAAAACPwgAAAACJgAEWAAAFQAAAAAAHQAAAAAAHQAAAAAAFQAAAAAAFQAAAAAAJgQAAAAAKQEBJQAAJgEAAAAAJgEAAAAAJgEAAAAAFAEAAAACGwYAAAAAFQAAAAAAHQAAAAAAHQAAAAAAFQAAAAAAFQAAAAAAGwUAAAAAFQAAAAAAHQAAAAAAHQAAAAAAFQAAAAAAAAIAAAAAJgQAAAAAJgEAAAAAHQAAAAAAHQAAAAAAFQAAAAAAAAIAAAAAGwUAAAAAFQAAAAAAFQAAAAAAFQAAAAAAFQAAAAAAKgMAAAAAPxAAAAACPxAAAAACFQAAAAAAFQAAAAAAPxAAAAACPxAAAAACPwgAAAACKgcAAAACFQAAAAAAFQAAAAAAJgQAAAAAPwgAAAACIQQCWAACEgEAAAAAFQAAAAAAFQAAAAAAJgIAAAAAPwgAAAACIQQCWAACEgEAAAAAFQAAAAAAFQAAAAAAGwMAAAAAPwgAAAACPwgAAAACDgAgAAAAKgEAAAAAFQAAAAAAGwQAAAAAPwgAAAAC\"},\"105\":{\"w\":12,\"h\":9,\"lower\":\"AgIAAAAcQgIAAAAcQgEAAAAcAgIAAAAcQgIAAAAcQgMAAAAcAgQAAAAcQgYAAAAcQgYAAAAcAgcAAAAcQgkAAAAcAgwAAAAcawEAAAAsAgMAAAAcAgMAAAAcAgUAAAAcQgQAAAAcQgUAAAAcAgcAAAAcQgcAAAAcQggAAAAcAgsAAAAcQgoAAAAcQgoAAAAcKwEAAAAsawEAAAAsQgIAAAAcQgMAAAAcQgQAAAAcQgYAAAAcAgcAAAAcAgYAAAAcQgoAAAAcAgsAAAAcQgoAAAAcAgsAAAAcAgMAAAAcQgIAAAAcQgIAAAAcAgMAAAAcAgUAAAAcQgUAAAAcQgUAAAAcQgYAAAAcQggAAAAcQgkAAAAcAgoAAAAcAg0AAAAcAgAAAAAcQgIAAAAcQgMAAAAcQgMAAAAcQgUAAAAcAgYAAAAcAgUAAAAcAgkAAAAcRggAAAAcAgoAAAAcQgwAAAAcAg0AAAAcAgAAAAAcawMAAAAsAgQAAAAcQgQAAAAcBgYAAAAcRgYAAAAcQgcAAAAcRggAAAAcRggAAAAcQgkAAAAcQgsAAAAcQgwAAAAcQgIAAAAcKwMAAAAsawMAAAAsAgcAAAAcRgYAAAAcRgYAAAAcAgcAAAAcQgcAAAAcQgcAAAAcAgkAAAAcQgkAAAAcAgwAAAAcKwIAAAAsQgIAAAAcKwMAAAAsAgUAAAAcQgUAAAAcAgcAAAAcQgcAAAAcAggAAAAcQgcAAAAcAgsAAAAcQgoAAAAcQgsAAAAcQgEAAAAcQgEAAAAcKwMAAAAsAgUAAAAcQgQAAAAcawQAAAAsKwUAAAAsawUAAAAsQgYAAAAcQggAAAAcQggAAAAcAgkAAAAc\"},\"106\":{\"w\":16,\"h\":10,\"lower\":\"QgEAAAAcAgEAAAAcAgEAAAAcRgAAAAAcBgAAAAAcRgAAAAAcRgAAAAAcAgEAAAAcWQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgAAAAAcWQAAAAAOGQAAAAAOGQAAAAAOAgIAAAAcQgEAAAAcRgAAAAAcBgAAAAAcRgAAAAAcAgEBUgAcQgIAAAAcQgABJQAcWQAAAAAOAgABhQAcWQAAAAAOGQAAAAAORgAAAAAcAgEAAAAcRgAAAAAcGQAAAAAOAgEBJQAcWQAAAAAOGQAAAAAORgAAAAAcAgEAAAAcQgEAAAAcAgQAAAAcWQAAAAAOWQAAAAAOQgEAAAAcQgIAAAAcBgAAAAAcBgAAAAAcRgAAAAAcBgAAAAAcGQAAAAAORgAAAAAcGQAAAAAOGQAAAAAOWQAAAAAOAgEAAAAcWQAAAAAOWQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAOAgMAAAAcBgAAAAAcBgAAAAAcBgAAAAAcRgAAAAAcRgAAAAAcBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOQgAAAAAcGQAAAAAOBgAAAAAcBgAAAAAcGQAAAAAOWQAAAAAORgAAAAAcBgAAAAAcRgAAAAAcRgAAAAAcAgEAAAAcAgEAAAAcBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgAAAAAcRgAAAAAcAgEAAAAcRgAAAAAcWQAAAAAOAgEBUgAcAgIAAAAcQgEAAAAcAgEAAAAcBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOGQAAAAAOGQAAAAAOBgAAAAAcAgIBhQAcRgAAAAAcAgEAAAAcAgEAAAAcWQAAAAAOWQAAAAAOGQAAAAAORgAAAAAcAgEAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgAAAAAcBgAAAAAcQgQBUgAcAgYAAAAcBgAAAAAcRgAAAAAcWQAAAAAOGQAAAAAOGQAAAAAOBgAAAAAcBgAAAAAcWQAAAAAOAgABhQAcWQAAAAAOGQAAAAAOBgAAAAAcBgAAAAAcBgAAAAAcAgIAAAAcBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOGQAAAAAOWQAAAAAORgAAAAAcBgAAAAAcGQAAAAAOAgEAAAAcRgAAAAAcBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOGQAAAAAOBgAAAAAcBgAAAAAcBgAAAAAcGQAAAAAOGQAAAAAOAgABUgAcAgEAAAAcRgAAAAAcBgAAAAAc\"},\"107\":{\"w\":10,\"h\":10,\"lower\":\"KwAAAAAsawAAAAAsAgEAAAAcAgEAAAAcKwEAAAAsKwEAAAAsKwEAAAAsKwMAAAAsKwMAAAAsawIAAAAsQgAAAAAcAgEAAAAcAgEAAAAcAgEAAAAcQgEAAAAcKwIAAAAsKwIAAAAsawIAAAAsawMAAAAsKwMAAAAsQgAAAAAcAgEAAAAcQgcAAAAcAgcAAAAcAgcAAAAcQgYAAAAcBgYAAAAcRgUAAAAcBgQBWAAcawMAAAAsAgkAAAAcAggBWAAcAggAAAAcAgcAAAAcAgcAAAAcAgcAAAAcQgYAAAAcRgYAAAAcKwcAAAAsKwcAAAAsRgkAAAAcAgoAAAAcQgoAAAAcAgsAAAAcAg0AAAAcQg0AAAAcQg8AAAAcBhAAAAAcRhAAAAAcAhEAAAAcAgoAAAAcQgoAAAAcAgsBUgAcQgwAAAAcQg0AAAAcAg4AAAAcBhAAAAAcRhAAAAAcQhEAAAAcAhEAAAAcQhQAAAAcAhQAAAAcAhIAAAAcKxIAAAAsKxAAAAAsAg4AAAAcBhAAAAAcBhAAAAAcKxIAAAAsaxEAAAAsKxUBhQAsQhQAAAAcAhMBWAAcKxIAAAAsKxIAAAAsaxEAAAAsAhIAAAAcKxgAAAAsKxgAAAAsKxgAAAAsAhYAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcAhgAAAAcQhYAAAAcQhcAAAAcQhcAAAAcAhgAAAAcAhgAAAAcAhgAAAAcKxgAAAAsKxgAAAAsQhcAAAAcQhcAAAAc\"},\"108\":{\"w\":13,\"h\":14,\"lower\":\"GQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOQgIAAAAeAgMAAAAcQgMAAAAcAgUAAAAcQgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOQgMAAAAcQgMAAAAcQgQAAAAcQgUAAAAcAgYAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgQAAAAcAgQAAAAcAgQAAAAcAgcAAAAcQgkAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgQAAAAcAgQAAAAcQgoAAAAeQgoAAAAcAgoAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOWQADQQAOQgMAAAAcAgQAAAAcAgsAAAAcAgsAAAAcQgoAAAAcGQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAOGQAAAAAOGQAAAAAOQgIAAAAeAgMAAAAcQgMAAAAcAgQAAAAcBgsAAAAcBgsAAAAcQgoAAAAcGQAAAAAOGQAAAAAOWQAAAAAOAgMAAAAeAgMAAAAcAgMAAAAcAgMAAAAcAgMAAAAcAgMAAAAcBgkAAAAeBgsAAAAcAgsAAAAcAgsAAAAcGQAAAAAOQgEBQQAeAgMAAAAcAgMAAAAcAgMAAAAcAgMAAAAcAgMAAAAcRgkAAAAeBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcGQAAAAAOAgMAAAAcAgMAAAAcAgMAAAAcQgoAAAAeAgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcGQAAAAAOAgMAAAAcAgMAAAAcAggChQAeAgsAAAAcAgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgkAAAAcAgMAAAAeAgMAAAAcAgMAAAAcQgoAAAAcAgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgsAAAAcBgkAAAAcBgUCWAAeGQAAAAAOAgMAAAAcAgMAAAAcAgsAAAAeAgsAAAAcAgsAAAAcAgsAAAAcAgsAAAAcBggAAAAcRgcAAAAeGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgMAAAAcAgMAAAAcAgsAAAAcAgsAAAAcAgsAAAAcAgsAAAAcAgsAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgMAAAAcAgMAAAAcAgsAAAAcAgsAAAAcAgsAAAAcAgsAAAAcAggAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAO\"},\"109\":{\"w\":15,\"h\":9,\"lower\":\"BgIAAAAcBgIAAAAcBgIAAAAcQgIAAAAcQgMAAAAcAgMAAAAcAgMAAAAcRgIAAAAcBgIAAAAcAgIAAAAcQgIAAAAcQgIAAAAcQgMAAAAcBgMAAAAcBgMAAAAcBgIAAAAcBgIAAAAcBgIAAAAcBgQAAAAcAgQAAAAcQgMAAAAcAgMAAAAcAgIAAAAcQgIAAAAcQgIAAAAcQgMAAAAcAgQAAAAcAgQAAAAcRgMAAAAcRgMAAAAcBgIAAAAcAgIAAAAcAgcAAAAcQgYAAAAeQgQAAAAcQgQAAAAcAgcAAAAeAgcAAAAcAgMAAAAcAgMAAAAcQgMAAAAcAgQAAAAcAgQAAAAcAgQAAAAcAgQAAAAcBgIAAAAcAgIAAAAcAgcAAAAcQgkAAAAcQgUAAAAcAgUAAAAcAgcAAAAcAgcAAAAcQgYAAAAcAgMAAAAcQgwAAAAeAgwAAAAcAgwAAAAcQgoAAAAcAgoAAAAcQgIAAAAcAgMAAAAcQgUAAAAcAgoAAAAcQgwAAAAcQgsAAAAcQgcAAAAcAgcAAAAcQgYAAAAcAgQAAAAcAg0AAAAcQgwAAAAcAgwAAAAcAgoAAAAcAgoAAAAcAgAAAAAcAgMAAAAcAgMAAAAcBgoAAAAcAg0AAAAcAg0AAAAcQgsBWAAcAgcAAAAcAgcAAAAcAgsCUgAcAg0AAAAcQgwAAAAcAgkAAAAcQgkAAAAcAgoAAAAcBgAAAAAcQgIAAAAeBgMAAAAcBgMAAAAcAgMAAAAcQggAAAAeQgkAAAAcAgIAAAAcAgIAAAAcAgIAAAAcQgcAAAAeAggAAAAcRgcAAAAcAgAAAAAcAgAAAAAcBgAAAAAcAgAAAAAcAgMAAAAcBgMAAAAcBgMAAAAcAgIBaQAcAgIBFAAcAgIAAAAcAgIAAAAcQgEAAAAcAgEAAAAcAgABWAAcAgAAAAAcAgAAAAAcBgAAAAAcBgAAAAAcBgAAAAAcAgMAAAAeAgMAAAAcAgIBaQAcAgIBFAAcAgIAAAAcAgIAAAAcAgIAAAAcQgEAAAAcAgEAAAAcAgABmQAcAgABRAAcAgAAAAAcBgAAAAAc\"},\"110\":{\"w\":16,\"h\":11,\"lower\":\"GQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgQAAAAcQgQAAAAcQgMAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOQggAAAAcAgkAAAAcBgkAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgQAAAAeQgQAAAAcBgUAAAAcBgUAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgkAAAAcBgkAAAAcBgkAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgQAAAAcRgQAAAAcBgUAAAAcAgUAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOQggAAAAeAgkAAAAcBgkAAAAcBgkAAAAcWQAAAAAOWQAAAAAOGQAAAAAOQgMAAAAeAgQAAAAcBgQAAAAcRgQAAAAcAgUAAAAcAgUAAAAcAgUAAAAeGQAAAAAOGQAAAAAOAggAAAAcQggAAAAcQggAAAAcGQAAAAAOBgEAAAAcKwEAAAAsWQAAAAAOQgMAAAAeAgQAAAAcBgQAAAAeGQAAAAAOAgUAAAAcQgUAAAAcQgUAAAAcGQAAAAAOGQAAAAAOBggAAAAcAggAAAAcGQAAAAAOGQAAAAAOKwEAAAAsKwEAAAAsWQAAAAAOAgMAAAAcQgMAAAAcGQAAAAAOGQAAAAAOQgUAAAAcBgYAAAAcBgYAAAAcGQAAAAAOGQAAAAAOBggAAAAcAggAAAAcGQAAAAAOGQAAAAAOBgEAAAAcBgEAAAAcWQAAAAAOAgMAAAAcAgMAAAAcGQAAAAAOGQAAAAAOAgYAAAAcBgYAAAAcBgYAAAAcGQAAAAAOQgcAAAAeAggAAAAcAggAAAAcGQAAAAAOGQAAAAAOBgEAAAAcRgEAAAAcQgIAAAAcAgMAAAAcAgMAAAAcGQAAAAAOGQAAAAAOAgYAAAAeAgYAAAAcAgYAAAAcQgYAAAAcAgcAAAAcQgcAAAAcQgcAAAAcGQAAAAAOGQAAAAAORgEAAAAcAgIAAAAcQgIAAAAcKwMAAAAsAgMAAAAcGQAAAAAOGQAAAAAOGQAAAAAOAgYAAAAcQgYAAAAcAgcAAAAcAgcAAAAcAgcAAAAcAgcAAAAeGQAAAAAOGQAAAAAOWQAAAAAOAgIAAAAcAgIAAAAcQgIAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgYAAAAcQgYAAAAcAgcAAAAcAgcAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgQAAAAcRgQAAAAcAgUAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAO\"},\"111\":{\"w\":7,\"h\":12,\"lower\":\"AgEAAAAcAgEAAAAcQgAAAAAcTwAAAABMAgEAAAAcAgEAAAAcAgEAAAAcQgAAAAAcTwAAAABMTwAAAABMTwAAAABMTwAAAABMAgEAAAAcAgEAAAAcDwAAAABMTwAAAABMTwEAAABMAgEAAAAcTwAAAABMTwAAAABMTwAAAABMDwIAAABMAgIAAAAcDwIAAABMQgEAAAAcAgEAAAAcQgAAAAAcAgAAAAAcDwIAAABMDwIAAABMDwIAAABMAgoAAAAcAgoAAAAcAgAAAAAcAgAAAAAcTwIAAABMTwUAAABMAhEAAAAcQhAAAAAcQg0AAAAcAg0AAAAcAg0AAAAcDwMAAABMTwUAAABMAhEAAAAcQhEAAAAcQhEAAAAcAg0AAAAcAg0AAAAcDwYAAABMTwYAAABMQhEAAAAcAhIAAAAcAhIAAAAcQgwAAAAcQgwAAAAcTwYAAABMDwcAAABMAhIAAAAcAhIAAAAcAhIAAAAcAgwAAAAcAgwAAAAcDwcAAABMDwcAAABMTwoAAABMTwoAAABMAgsAAAAcQgsAAAAcTwsAAABMAgcAAAAcQgkAAAAcDwoAAABMDwoAAABMTwoAAABMDwsAAABMDwsAAABMAgcAAAAcAgkAAAAcQgkAAAAcAgoAAAAcTwoAAABMDwsAAABMAgsAAAAc\"},\"112\":{\"w\":11,\"h\":10,\"lower\":\"BgAAAAAcBgAAAAAcRgAAAAAcKwEAAAAsKwEAAAAsAgcAAAAeAgQAAAAcBgQAAAAcRgQAAAAcAgUAAAAcAgUAAAAcBgAAAAAcBgAAAAAcBgAAAAAcRgAAAAAcKwEAAAAsAgcDhQAeAgQAAAAcAgQAAAAcQgQAAAAcAgUAAAAcAgUAAAAcBgAAAAAcBgAAAAAcBgAAAAAcRgAAAAAcawEAAAAsAgsAAAAeAgQAAAAcQgQAAAAcQgUAAAAcQgUAAAAcAgUAAAAcBgAAAAAcRgAAAAAcAgcAAAAeAgIAAAAcAgIAAAAcAgcDJQAeBgQAAAAcBgQAAAAcAgkAAAAeAgYAAAAcQgUAAAAcRgAAAAAcAgEAAAAcAgYChQAeAgIAAAAcAgIAAAAcQgcBhQAeBgQAAAAcAgQAAAAcAgkAAAAeAgYAAAAcAgYAAAAcAgEAAAAcAgEAAAAcAggAAAAeAgIAAAAcAgIAAAAcAggAAAAeBgQAAAAcAgQAAAAcAgkBhQAeAgYAAAAcAgYAAAAcAgEAAAAcAgEAAAAcAgkAAAAeAgIAAAAcAgIAAAAcAgcAJQAeAgQAAAAcAgQAAAAcAgoAAAAeAgYAAAAcRgUAAAAcAgEAAAAcRgAAAAAcAgcAAAAeAgIAAAAcAgIAAAAcQgIAAAAcawMAAAAsAgQAAAAcAgkAAAAeBgUAAAAcBgUAAAAcRgAAAAAcBgAAAAAcQggAAAAeAgIAAAAcQgIAAAAcKwMAAAAsawMAAAAsAgQAAAAcAgkAAAAeBgUAAAAcBgUAAAAcBgAAAAAcBgAAAAAcAgcBJQAeAgIAAAAcQgIAAAAcBgMAAAAcKwMAAAAsawMAAAAsAgkAAAAeBgUAAAAcBgUAAAAc\"},\"113\":{\"w\":12,\"h\":10,\"lower\":\"GQAAAAAOGQAAAAAOQgQAAAAcAgUAAAAcQgUAAAAcAgYAAAAcAgYAAAAcQgYAAAAcAgcAAAAcAgcAAAAcAgcAAAAcGQAAAAAOGQAAAAAOGQAAAAAOQgQAAAAcAgUAAAAcAgUAAAAcQgUAAAAcAgYAAAAcQgYAAAAcAgcAAAAcAgcAAAAcAgcAAAAcQgcAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgMAAAAcAgMAAAAcAgEAAAAcAgEAAAAcAgEAAAAcQgcAAAAcBggAAAAcAgIAAAAcKwIAAAAsGQAAAAAOGQAAAAAOGQAAAAAOAgMAAAAcAgMAAAAcGQAAAAAOAgEAAAAcAgEAAAAcQgcAAAAcAggAAAAcKwIAAAAsKwIAAAAsawIAAAAsAgkAAAAcAgkAAAAcAgkAAAAcQgMAAAAcAgkAAAAcQggAAAAcAgIAAAAcAggAAAAcKwgAAAAsawEAAAAsKwIAAAAsKwIAAAAsAgkAAAAcAgkAAAAcAgkAAAAcAgMAAAAcAgkAAAAcAgIAAAAcBgIAAAAcBggAAAAcKwgAAAAsawEAAAAsKwIAAAAsGQAAAAAOAgkAAAAcAgkAAAAcAgIAAAAcAgIAAAAcWQAAAAAOWQAAAAAOKwIAAAAsKwIAAAAsKwIAAAAsKwEAAAAsawEAAAAsWQAAAAAOAgkAAAAcAgkAAAAcAgIAAAAcAgIAAAAcQgEAAAAcawEAAAAsKwIAAAAsKwIAAAAsawEAAAAsKwEAAAAsKwEAAAAsKwEAAAAsQgEAAAAcAgIAAAAcAgIAAAAcQgEAAAAcAgEAAAAcKwEAAAAsawEAAAAsawEAAAAsKwEAAAAsWQAAAAAOWQAAAAAOKwEAAAAsKwEAAAAsawEAAAAsawEAAAAsKwEAAAAsKwEAAAAsWQAAAAAOWQAAAAAOWQAAAAAOWQAAAAAO\"},\"114\":{\"w\":13,\"h\":13,\"lower\":\"GQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAgYAAAAeAgYAAAAcAgYAAAAcAgYAAAAcQgUAAAAeGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOQgUAAAAcQgYAAAAcQgYAAAAcBgYAAAAcAgYAAAAcQgUAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAggAAAAcAggAAAAcQgcAAAAcAgcAAAAcRgYAAAAcRgUAAAAcBgUAAAAcAgUAAAAcAgUAAAAcGQAAAAAOGQAAAAAOGQAAAAAOAgkAAAAcAgkAAAAcAggAAAAcAggAAAAcQgcAAAAcGQAAAAAOBgUAAAAcAgUAAAAcRgMAAAAcRgMAAAAcAgMAAAAcGQAAAAAOQgkAUgAeAgkAAAAcAgkAAAAcAgkAAAAcQggAWAAeGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgMAAAAcBgMAAAAcAgMAAAAcAgMAAAAeAgsAAAAcAgsAAAAcAgkAAAAcAgkAAAAeGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOBgMAAAAcBgMAAAAcRgIAAAAcAgIAAAAcAgsAAAAcQgsAAAAcAgkAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAORgIAAAAcBgIAAAAcBgIAAAAcQgsAAAAcAgwAAAAcAgwAAAAcAgwAAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAOBgEAAAAcRgEAAAAcRgEAAAAcBgIAAAAcQgsAAAAeAgwAAAAcAgwAAAAcQgwAAAAcQgwAAAAeGQAAAAAOGQAAAAAOGQAAAAAOWQAAAAAOBgEAAAAcBgEAAAAcBgEAAAAcWQAAAAAOGQAAAAAOAgwAAAAcQgwAAAAcAg0AAAAcAg0AAAAcAg0AAAAcGQAAAAAOGQAAAAAOWQAAAAAOBgEAAAAcBgEAAAAcBgEAAAAcWQAAAAAOGQAAAAAOGQAAAAAOAg0AAAAcAg0AAAAcAg0AAAAcAg8AAAAcAg8AAAAcAg8AAAAcGQAAAAAOWQAAAAAOWQAAAAAOWQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAg0AAAAcAg0AAAAcAg8AAAAcAg8AAAAcAg8AAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOAg8AAAAcAg8AAAAcAg8AAAAcGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAOGQAAAAAO\"},\"115\":{\"w\":8,\"h\":11,\"lower\":\"AwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAwIAAAAgAAIAAAAgAAIAAAAgAAIAAAAgBgYChQAgFwsBUgASFwwAAAASFwwAAAASFwwAAAASAAIBhQAgBgIBhQAgQAIAAAAgBggBhQAgQAoBEQAgQAoBFAAgAwoAAAAkFwwAAAASAAMBhQAgBgMBhQAgQAIAAAAkVAkAAAAgAwoAAAAgQAkBJQAgQAoAAAAgFwwAAAASAAQChQAgBgQChQAgAAIAAAAkVAcBJQAgAwoAAAAgAAgAAAAkQwoAAAAgFwwAAAASAAYChQAgAwYChQAgAAIAAAAkVAYAAAAgBgoAAAAgAwoAAAAgAAoAAAAgQwkBWAAkQAgBhQAgBggBRAAgAAIAAAAkRgUAAAAgBgUAAAAkAwoAAAAgBgoAAAAgAAkBWAAgAAkAAAAgAwgBWAAgQAIAAAAkRgQAAAAgRgMAAAAkBgIBWAAkAwIAAAAkAAIAAAAkQAIAAAAkQAIAAAAkAAIAAAAkBgECJQAkBgECJQAkRgEAAAAkBgEBJQAkRgEBJQAkFwQAAAAWFwQAAAAWFwQAAAAWAwEAAAAgAwABWAAkQAAAAAAkQAAAAAAkQwABEQAkAwABJQAkAwABZgAkAwEAAAAkAwABJQAgAwABFAAgAAAAAAAgAAAAAAAgAAAAAAAkAwAAAAAkAwABUgAkAwEAAAAk\"},\"116\":{\"w\":11,\"h\":11,\"lower\":\"AAAAAAAcAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAcAAAAAAAYFQAAAAAYFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAYAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAUFQAAAAAUFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAQFQAAAAAUFQAAAAAUAAAAAAAYAAAAAAAYFQAAAAAYFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAUFQAAAAAYAAAAAAAYAAAAAAAcAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAYAAAAAAAc\"},\"117\":{\"w\":8,\"h\":12,\"lower\":\"EwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAADQEAAAAAEwoAAAAADQABhQAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwABhQAADQEAAAAAEwoAAAAADQEAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwEAAAAADQMAAAAAEwwAAAAADQEChQAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwEChQAADQMAAAAAEwwAAAAADQMAAAAAEwAAAAAAEwAAAAAADQABRAAAEwoAAAAAEwMAAAAADQQAAAAAEwwAAAAADQMDhQAAEwAAAAAAEwAAAAAADQABmQAAEwoAAAAAEwMAAAAADQUAAAAAEwoAAAAAEwYAAAAAEwAAAAAAEwAAAAAADQABZgAAEwoAAAAAEwMDhQAADQYAAAAAEwoAAAAADQAAAAAAEwAAAAAAEwAAAAAADQABEQAAEwoAAAAAEwYAAAAADQcAAAAAEwoAAAAADQAEhQAAEwAAAAAAEwAAAAAADQACRAAAEwoAAAAAEwYAAAAAEwgAAAAAEwoAAAAAEwQAAAAAEwAAAAAAEwAAAAAADQACmQAAEwoAAAAAEwYAAAAAEwgAAAAAEwoAAAAADQABUgAAEwEAAAAAEwAAAAAADQACZgAAEwoAAAAAEwYEhQAAEwoAAAAAEwoAAAAADQACUgAAEwIAAAAAEwAAAAAADQACEQAAEwoAAAAAEwoAAAAAEwoAAAAAEwsAAAAADQADUgAAEwMAAAAA\"},\"118\":{\"w\":14,\"h\":15,\"lower\":\"JAUAAAACAwIAAAAACgEgAAAACgEgAAAACAIAAAAACgEgAAAACwBAAAAAJAQAAAACCgBAAAAACgBAAAAACgEgAAAAAwIAAAAAAwIAAAAACgEgAAAACgEgAAAAAwIAAAAAAwIAAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACwEgAAAACgEgAAAACAIAAAAACAIAAAAABwIAAAAACgEgAAAACgEgAAAAAwIAAAAAAwIAAAAACgEgAAAACAIAAAAACgEgAAAACAIAAAAACgEgAAAACgEgAAAACAIAAAAACgEgAAAACAIAAAAAJAQAAAACCgBAAAAACgBAAAAACgEgAAAACgEgAAAACgEgAAAAAwMAAAAAAwMAAAAAAwMAAAAACAEgAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACgBAAAAACgBAAAAACwBAAAAACgBAAAAACAIAAAAAJAQAAAACAwIBaQAAAwIBJQAAAwIBJQAAAwIBFAAAAwIAAAAAAwIAAAAAAwIAAAAAAwIAAAAACgEgAAAACwBAAAAACgBAAAAACgEgAAAACgEgAAAAAwMAAAAAAwIBWAAAAwIAAAAACwEgAAAACwEgAAAACAIAAAAAAwIAAAAAAwIAAAAAAwIAAAAAAwIAAAAACgEgAAAACgBAAAAACgEgAAAAAwMBRAAAAwMAAAAACwEgAAAACwEgAAAACwBAAAAACwBAAAAACwEgAAAACwEgAAAAAwIAAAAAAwIAAAAAAwIAAAAACgEgAAAACgEgAAAAAwQAAAAAAwMBWAAAAwMAAAAACwIAAAAACAMAAAAACwIAAAAACwEgAAAAJAUAAAACCwEgAAAAAwIBRAAAJAUAAAACAwIAAAAACgEgAAAACgEgAAAAAwQAAAAAAwMBWAAAAwIBWAAACwIAAAAAAwMAAAAAAwIBaQAAAwIBJQAAAwIBZgAAAwMAAAAAAwIBWAAAJAUAAAACAwIAAAAACgIAAAAACgEgAAAACgEgAAAAAwMBFAAAAwIBmQAAAwIBlgAAAwMAAAAAAwIBWAAACwIAAAAAAwIBUgAAAwMAAAAACgEgAAAAAwIAAAAAAwIAAAAACgEgAAAACgEgAAAAHg4gAAACHg4gAAACAwIBUgAAAwMAAAAAAwMAAAAAAwIBmQAAAwIBhQAAAwIBlgAACgEgAAAACAEgAAAACAIAAAAACwEgAAAACgBAAAAACgBAAAAAHg4gAAACHg4gAAACCAIBUgAAAwMAAAAACgEgAAAACgEgAAAAAwMAAAAAAwMAAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACgBAAAAACgBAAAAACgEgAAAACwEgAAAACAIAAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAACgEgAAAAJAQAAAACCgEgAAAACAIBUgAABgMAAAAACgBAAAAACgBAAAAACgBAAAAACgEgAAAACgEgAAAACgEgAAAACwEgAAAABwIAAAAABwIAAAAACgEgAAAACAIBhQAACAIBhQAAAwIBlgAAAwMAAAAACgBAAAAACgBAAAAACgBAAAAACwBAAAAACgBAAAAACgBAAAAACgEgAAAACgEgAAAAJAUAAAACCAMAAAAAAwMAAAAAAwMAAAAAAwMAAAAAAwMAAAAA\"},\"119\":{\"w\":15,\"h\":10,\"lower\":\"AQcBhQAAAQcAAAAAAQYAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAAQMBUgAAAQQBUgAAAQUAAAAAAQUBUgAAAQgAAAAAAQcAAAAAAQYAAAAAAQIAAAAAAQIAAAAADAAAAAAADAAAAAAADAAAAAAAEgAAAAAADAAAAAAAAQIAAAAAAQIBEQAAAQIDUgAAAQUBQQAAAQUBlgAAAQcCmQAAAQcChQAAAQQAAAAAAQMAAAAAAQIBhQAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAAQIAAAAAAQIAAAAAAQIDUgAAAQUBUgAAAQYBhQAAAQkAAAAAAQkAAAAAAQMAAAAAAQMAAAAAAQMAAAAAEgAAAAAAEgAAAAAAEgAAAAAAAQEBUgAAAQIBUgAAAQMAAAAAAQMAAAAAAQYBmQAAAQYBlgAAAQcAAAAAAQkAAAAACAMAAAAABwEAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAEgAAAAAAAQMAAAAAAQMAAAAAAQcAAAAAAQcBQQAAAQcBRAAAAQkAAAAAAQgBWAAAAAAAAAACEgAAAAAACAMAAAAACAIAAAAAAAAAAAACAAAAAAACEgAAAAAAEgAAAAAAEgAAAAAAAAkAAAACFQcBhQAABgkAAAACAQkAAAAAAQkAAAAAAQgBWAAAFQgAAAAAEgAAAAAAEgAAAAAADAAAAAAAFQgAAAAAFQgAAAAAEgAAAAAAEgAAAAAAEgAAAAAAFQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAAQkAAAAAAQgBWAAAFQgAAAAAEgAAAAAAEgAAAAAADAAAAAAAFQgAAAAAFQgAAAAAEgAAAAAAEgAAAAAAEgAAAAAAFQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAAQgBJQAAAQkAAAAAAQgBRAACEgAAAAAAEgAAAAAAEgAAAAAAHAkAAAACHAkAAAACCAEBhQAAEgAAAAAAEgAAAAAAHAkAAAACAAgAAAADAAgAAAADAQcBJQAAAQgAAAAAAQgBZgAAAQkAAAAAAQUBhQAADAAAAAAACAEAAAAAEgAAAAAAEgAAAAAACAIAAAAACAIAAAAAEgAAAAAAEgAAAAAAAQMCUgAAAQUCUgAAAQcAAAAA\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHAkAAAACAAAAAAABAAAAAAABHAkAAAACHAkAAAACHAkAAAACHAkAAAACHAkAAAACAAAAAAADFg0DhQAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwgAAAAAIwgAAAAAIwgAAAAAAAAAAAABAAAAAAABIwgAAAAAIwgAAAAAIwgAAAAAFg0DUgAAFhAAAAAAFg0DWAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABIwgAAAAAIwgAAAAAIwgAAAAAAAAAAAABAAAAAAABIwgAAAAAIwgAAAAAIwgAAAAAFg0DUgAAFhAAAAAAFg0DWAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABHAkAAAACHAkAAAACHAkAAAACHAAAAAABHAAAAAABHAkAAAACHAkAAAACHAkAAAACAAAAAAABFg0DJQAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"120\":{\"w\":15,\"h\":11,\"lower\":\"BQgCUgAABQoAAAAABQoAAAAABgcDWAAABQcAAAAABQYBWAAABgUBWAAAAwQAAAAAAwQAAAAAAwQAAAAAAwQAAAAAHhAAAAACAwQAAAAAAwQAAAAAAwQAAAAABQgCUgAABQoAAAAABQoAAAAABQcDWAAABQcAAAAABQYBWAAABgUBWAAAAwQAAAAAAwQAAAAAAwQAAAAAAwQAAAAAAwQAAAAAAQQAAAAAAQQAAAAAAwQAAAAABQgCUgAABQoAAAAABQoAAAAABgkBWAAABgcAAAAABgYBWAAABgQCWAAAAwAAAAAAAwMBWAAAAwIBWAAAAwIBUgAAAwMBUgAAAQQAAAAAAQQAAAAAAQQAAAAABggCUgAABgoAAAAABgoAAAAABgsBhQAABgYBZgAABgcAAAAAAwAAAAAAAwAAWAAAAwAAAAAAAwAAAAAAAwAAAAAAAwAAAAAAAwQAAAAAAQABJQAAAQABZgAABQgAAAAABQgCUgAABgoAAAAABgwAJQAABgQCJQAAAwAAAAAAAwAAAAAAAwAAAAAAAwAAAAAAAQABQQAAAQABhQAAAwABhQAAAwABhQAAAQABhQAAAQABlgAAEwAAAAACAwAAAAACCgAAAAAAAwAAAAAAAwAAAAAAAwAAAAAAAwAAAAAAAQAAAAAAAwABAAAAAQABUgAAAQEAAAAAAwEAAAAAAwEAAAAAAwEAAAAAAwEAAAAAEwAAAAACEwAAAAACEwAAAAACEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwABUgAAEwEAAAAAHQQAAAAAFAUAAAAAEwEAAAAAEwEAAAAAEwAAAAACEwAAAAACCgAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwAAAAAAEwABUgAAEwEAAAAAHQQAAAAAFAUAAAAAEwEAAAAAEwEAAAAABgYBJQAABgYBJQAABggBEQAABggBJQAAFwYAAAAAAwAAAAAAAQABQQAAAwABhQAAAwABhQAAAwABlgAAAwEAAAAAAwEAAAAAAwEAAAAAAwEAAAAAAwEAAAAABgYBWAAABgYAAAAABgYAAAAABQQAAAAABQMBmQAAAwAAAAAAAwABUgAAAwEAAAAAAwEAAAAAAwIBQQAAAwIBhQAAAwIBhQAAAwICQQAAAwIChQAAAwEDhQAABgQCJQAABgQCZgAABgQCWAAABQQAAAAABQQAAAAABQMBWAAABQIBWAAAAwEAAAAAAwIAAAAAAwIBUgAAAwMAAAAAAwMAAAAAAwMBUgAAHhAAAAACAwQAAAAA\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQcBJQAABQcBZgAABggCUgAABgoCJQAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBQcAAAAABQcBUgAABggCEQAABgkBJQAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABBgcAAAAABgcBUgAABggBUgAABgkAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAEAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"121\":{\"w\":8,\"h\":18,\"lower\":\"FQ4AAAADFQ4AAAADFQ4AAAADFQQAAAAAJgUAAAAAFQQAAAAAHQQAAAAAHQQAAAAAFQ4AAAADFQ4AAAADHQ4AAAADFQQAAAAAJgUAAAAAFQQAAAAAHQQAAAAAHQQAAAAAFQ4AAAADFQ4AAAADHQ4AAAADHgkAAAACHgkAAAACHgkAAAACFQQAAAAAFQQAAAAAFQ4AAAADFQkAAAAAFQkAAAAAFQgAAAAAFQYCWAAAFQQCWAAAFQQAAAAAFQQAAAAAFQ4AAAADFQkAAAAAFQkAAAAAFQkAAAAAFQkAAAAAFQkAAAAAFQQAAAAAFQQAAAAAFQ4AAAADHg4AAAACHg4AAAACFQkAAAAAFQkAAAAAFQkAAAAAFQQAAAAAFQQAAAAAFQ4AAAADJgoAAAAAFQkAAAAAHQkAAAAAJgUAAAAAFQQAAAAAHQQAAAAAFQQAAAAAFQ4AAAADJgoAAAAAFQkAAAAAHQkAAAAAJgUAAAAAFQQAAAAAHQQAAAAAFQQAAAAAJg4AAAADHg4AAAACHg4AAAACFQkAAAAAJgkAAAAAFQkAAAAAFQQAAAAAFQQAAAAAJg4AAAADJgoAAAAAFQkAAAAAHQkAAAAAJgUAAAAAFQQAAAAAFQQAAAAAFQQAAAAAAA4AAAADJgoAAAAAFQkAAAAAHQkAAAAAJgUAAAAAFQQAAAAAHQQAAAAAFQQAAAAAAA4AAAADHg4AAAADHg4AAAADFQkAAAAAJgkAAAAAFQkAAAAAHQQAAAAAFQQAAAAAAA4AAAADHg4AAAADHg4AUgADFQgAAAAAFQYCWAAAFQQCWAAAFQQAAAAAFQQAAAAAAA4AAAADHg4AAAADHg4AAAACHg4AAAACHgcAAAACJgUAAAAAJgUAAAAAFQQAAAAAAA4AAAADHg4AAAADHg4AAAACHg4AAAACFQQAAAAAFQQAAAAAJgUAAAAAFQQAAAAAAA4AAAADHg4AUgADHg4AAAACHg4AAAACHg4AAAACJgUAAAAAJgUAAAAAFQQAAAAAAA4AAAADFQcAAAAAFQYBWAAAFQUBWAAAFQQBWAAAFQQAAAAAFQQAAAAAFQQAAAAAAA4AAAADFQcAAAAAFQYBWAAAFQUBWAAAFQQBWAAAFQQAAAAAFQQAAAAAFQQAAAAA\",\"upper\":\"AAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABFQkAAAAAFQkAAAAAAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAABFQkAAAAAFQkAAAAAAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABFQAAAAADFQAAAAADAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABFQkAAAAAFQkAAAAAAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAABFQkAAAAAFQkAAAAAAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABFQAAAAADFQAAAAADAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAABFQAAAAADFQAAAAADAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABFQAAAAADFQAAAAADAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"122\":{\"w\":13,\"h\":16,\"lower\":\"FwYBaQAAFwYBJQAAFwYBJQAAFwUBaQAAFwUBJQAAFwUBJQAAFwkAAAAAFwUBJQAAFwUBJQAAFwUBJQAAFwUBJQAAFwUBJQAAFwUBZgAAFwYBWAAAAQYAAAAAAQYBAAAAAQUBWAAAAQUAAAAAAQUAAAAAFwkAAAAAAQUAAAAAAQUAAAAAAQUAAAAAAQUAAAAAAQUAAAAAFwUBUgAAFwYBWAAAAQYAAAAAAQYAAAAAAQUBWAAAAQUAAAAAAQUAAAAAFwkAAAAAAQUAAAAAAQUAAAAAAQUAAAAAAQUAAAAAAQUAAAAAFwUBUgAAFwYCmQAAAQYChQAAAQYChQAAAQUBFAAAAQUAAAAAAQUAAAAAFwkAAAAAAQUAAAAAAQUAAAAAAQUBQQAAAQMCJQAAAQMCJQAAFwMCZgAAFwgBmQAAAQgBhQAAAQgBhQAAAQUAAAAAAQUAAAAAAQUAAAAAFwkAAAAAAQQBJQAAAQQBZgAAFwUBUgAAAQECJQAAAQECJQAAFwECZgAAFwkBWAAAAQkAAAAAAQkAAAAAFwkBUgAAAQUAAAAAAQUBAAAAAQQBWAAAAQQAAAAAAQQBUgAAFwUBUgAAAQEAAAAAAQEAAAAAFwEBUgAAFwkBWAAAFg4AAAAAFg4AAAAAFwkBUgAAAQUAAAAAAQUAAAAAAQQBmQAAAQQBhQAAAQQBlgAAFwUBUgAAAQEAAAAAAQEAAAAAFwEBUgAAFw8AAAAAFwkBhQAAFwkBhQAAFw8AAAAAFwUBhQAAFwUBhQAAFwUBhQAAFwUBhQAAFwUBhQAAFwUBlgAAFwEBhQAAFwEBhQAAFwEBlgAAIAAAAAACIAAAAAACJQACAAACIAACAAACFAAAAAACKQYBhQAAKQYBhQAAKQYBhQAAAQABAAACAQAAAAACAAAAAAACAAAAAAACAAAAAAACIAAAAAACFAAAAAACFQAAAAACIAAAAAACFAAAAAACKQcBhQAAKQcBhQAAKQcBhQAAAQABAAACIAAAAAACAAAAAAACAAAAAAACAAAAAAACAQABAAACFAAAAAACFQAAAAACIAAAAAACFAAAAAACKQgBhQAAKQgBhQAAKQgBhQAAFAAAAAACFAAAAAACAAAAAAACAAAAAAACAAAAAAACFQwBAAAABQsBAAAABQsAAAAABQsAAAAAFQwAAAAAKQkBhQAAKQkBhQAAKQkBhQAAFQwAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAAAAAAAAABFQwAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAABQsAAAAAFQwAAAAAAAAAAAABAAAAAAABAAAAAAABBRUAAAAAFhQAAAAABRUAAAAABQwAAAAABQwAAAAABQwAAAAABRUAAAAAFhQAAAAABRUAAAAAAAAAAAABAAAAAAAB\"},\"123\":{\"w\":14,\"h\":16,\"lower\":\"AAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAKQcAAAAAKQcAAAAAKQcAAAAAKQcAAAAAKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAACKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAAAAAAAACFQYAAAAAFQYAAAAAFQYAAAAAFQwAAAAAFQYAAAAAFQYAAAAAKgYCUgAAKQgAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKQgAAAAAKgYCWAAAFQYAAAAAFQYAAAAAFQwAAAAAKgYAAAAEKgYAAAAAKgYAAAAAJQUBWAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAJQUBUgAAKgYAAAAAKgYAAAAAKgYAAAAEKgYAAAAEKgYAAAAAKgYAAAAAJQUBWAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAKgUAAAAAJQUBUgAAKgYAAAAAKgYAAAAAKgYAAAAEFQwAAAAAFQYAAAAAFQYAAAAAKQYAAAAAKQYAAAAAKQUBWAAAKgUAAAAAKgUAAAAAKQUBUgAAKQYAAAAAKQYAAAAAFQYAAAAAFQYAAAAAFQwAAAAAFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAACKgYAAAAAAAAAAAACKgUAAAAAKgUAAAAAAAAAAAACKgYAAAAAAAAAAAACFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQkAAAAAKgkAAAAAKgUAAAAAKgUAAAAAKgkAAAAAKQkAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKgUAAAAAKgUAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKgUAAAAAKgUAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKgUAAAAAKgUAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKQcAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACKgUAAAAAKgUAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACFQUAAAAAFQUAAAAAFQUAAAAAFQUAAAAAAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAACAAAAAAACAAAAAAACAAAAAAACAAAAAAAC\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADFQwAAAAAAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADFQwAAAAAFQwAAAAAAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADFQwAAAAAAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAADAAAAAAABAAAAAAADAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADKgkAAAAAKgkAAAAAAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAADAAAAAAADAAAAAAADAAAAAAADAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"124\":{\"w\":16,\"h\":11,\"lower\":\"AwMAAAACAwMAAAACAwMAAAACAwMAAAACAwMAAAACAwMAAAACDwMAAAACDwMAAAACAwMAAAACFQcAAAAAFQYAAAAAFQYAAAAAFQcAAAAAAAAAAAABAAAAAAABAAAAAAABAwMAAAACAwMAAAACAwMAAAACAwMAAAACAwMAAAACDwMAAAACDwMAAAACDwMAAAACDwMAAAACFQcAAAAAFQYAAAAAFQYAAAAAFQcAAAAAAAAAAAABAAAAAAABAAAAAAABAwMAAAACAwMAAAACAwMAAAACAwMAAAACAwMAAAACDwMAAAACFQMAAAACDwMAAAACFQMAAAACFQsAAAAAFQYAAAAAFQYAAAAAFQsAAAAAAAAAAAABAAAAAAABAAAAAAABFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAABFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAABFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAFQYAAAAAAwsAAAACFQYAAAAAFQYAAAAAFQYAAAAAAAAAAAABAwcAAAACAwcAAAACAwcAAAACFQcAAAACFAYAAAAAFAYAAAAAFQcAAAACAwcAAAACAwcAAAACAwcAAAACAwcAAAACAwcAAAACFAYAAAAAFAYAAAAAAAcAAAACAAcAAAACAAcAAAACFAYAAAAAFAYAAAAAFAYAAAAAFAYAAAAAHwgAAAAAFAYAAAAAFAYAAAAAFAYAAAAAAwcAAAACAwcAAAACFAYAAAAAFAYAAAAAFAYAAAAAHwgAAAAAFAYAAAAAFAYAAAAAFAYAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAFAYAAAAAFAYAAAAAFAYAAAAAFAYAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAFAYAAAAAFAYAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAFAYAAAAAFAYAAAAAFAYAAAAAFAYAAAAAKgsAAAAAKgsAAAAAKgsAAAAAKgsAAAAAAAcAAAACFAYAAAAAFAYAAAAAFAYAAAAAFAYAAAAAHwgAAAAAFAYAAAAAFAYAAAAAFAYAAAAAAAcAAAACAAcAAAACFAYAAAAAFAYAAAAAFAYAAAAAHwgAAAAAFAYAAAAA\",\"upper\":\"AAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAWAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAWAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABFgsAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAB\"},\"125\":{\"w\":13,\"h\":8,\"lower\":\"HgMBlgAAHgQAAAAAHgMBWAAAHgMAAAAAHgMAAAAAHgMCUgAAHgUBhQAAHgUBRAAAHgUAAAAAAAAAAAABAAAAAAABAAAAAAABAAAAAAABHgQAAAAACgQAAAAACgICWAAACgIAAAAAHgIAAAAAHgICUgAACgYAAAAACgYAAAAACgUBWAAAHgUBUgAAHgYAAAAAHgYAAAAACgYAAAAAHgMBJQAAHgUBhQAAHgoAAAAAHggBWAAAHgYCWAAAHgUBWAAAHgUBJQAAHgUBFAAAHgUAAAAAHgUBUgAAHgYBQQAAHgcBhQAAHgYAAAAAHgMAAAAAHgYBhQAAHgoChQAACggBWAAAHgYCWAAAHgUBWAAAHgUAAAAAHgUAAAAAAAAAAAACAAAAAAACAAAAAAACHggChQAAHgYBhQAAHgMBhQAACgcAAAAACgwBhQAAAAAAAAACAAAAAAACFAQBaQAAFAQBJQAAFAQBJQAAFAQBZgAAAAAAAAACAAAAAAABHgoBhQAAHgcChQAAHgQBhQAACgcAAAAACgwBJQAAAAAAAAACAAAAAAABFAQBWAAAFAQAAAAAFAQAAAAAFAQBUgAAFAUAAAAAAAAAAAABHgsAAAAAHgkChQAAHgUAAAAACgYBJQAAHgUAAAAAFAUAAAAAFAUAAAAAFAQBWAAAFAQAAAAAFAQAAAAAFAQBUgAAFAUAAAAAFAsBhQAAHgsBhQAAHgsBhQAAHgUAAAAAHgUAAAAAHgUAAAAAFAUAAAAAFAUAAAAAFAQBmQAAAAQBhQAAAAQBhQAAFAQBlgAAFAUAAAAAFAwAAAAAHgwAAAAAHgwAAAAA\",\"upper\":\"HgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgsBhQAAHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgwBhQAAHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABHgAAAAABAAAAAAABAAAAAAABAAAAAAABHgAAAAABHgAAAAABHgAAAAABHg0AAAAACgAAAAABAAAAAAABAAAAAAABHgAAAAABFAAAAAABFAAAAAABFAAAAAABAAAAAAABAAAAAAABHgAAAAABHgAAAAABHgAAAAABHgwBJQAACgAAAAABAAAAAAABAAAAAAABFAAAAAABFgwAAAAAFgwAAAAAFAAAAAABFAAAAAABAAAAAAABHgAAAAABHgAAAAABHgAAAAABHgwAAAAACgwAAAAAFAsBhQAAFAsBlgAAFAwAAAAAFAwAAAAAFAwAAAAAFAwAAAAAFAsBmQAAFAAAAAABHgAAAAABHgAAAAABHgAAAAABHgwAAAAAHgwAAAAAFAwAAAAAFAwAAAAAFAwAAAAAAAwAAAAAAAwAAAAAFAwAAAAAFAwAAAAAFAAAAAABHgAAAAABHgAAAAAB\"},\"126\":{\"w\":18,\"h\":10,\"lower\":\"FQ0AAAAAJQwBWAAAJQoCWAAAJQgCWAAAFQgAAAAAJQcBWAAAJQUCWAAAJQMCWAAAHQMAAAAAHQMAAAAAJQMCUgAAJQUCUgAAJQcBUgAAFQgAAAAAJQgCUgAAJQoCUgAAJQwBUgAAFQ0AAAAAFQ0AAAAAJQwBWAAAJQoCWAAAJQgCWAAAFQgAAAAAJQcBWAAAJQUCWAAAJQMCWAAAHQMAAAAAHQMAAAAAJQMCUgAAJQUCUgAAJQcBUgAAFQgAAAAAJQgCUgAAJQoCUgAAJQwBUgAAFQ0AAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAJgwAAAAAFQgAAAAAFQgAAAAAFQgAAAAAJgQAAAAAJgcAAAAAJgcAAAAAJgQAAAAAFQgAAAAAFQgAAAAAFQgAAAAAJgwAAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAALw0AAAAAFQ0AAAAAFQ0AAAAAJgkAAAAAHQgAAAAAHQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAFQgAAAAAHQgAAAAAHQgAAAAAJgkAAAAAFQ0AAAAAFQ0AAAAAFg0AAAAALw0AAAAAJQwBWAAAJQoCWAAAJQgCWAAAHQgAAAAAHQgAAAAAJgkAAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAJgkAAAAAHQgAAAAAHQgAAAAAJQgCUgAAJQoCUgAAJQwBUgAAFg0AAAAAFQ0AAAAAJQwBWAAAJQoCWAAAJQgCWAAAHQgAAAAAHQgAAAAAJgwAAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAJgwAAAAAHQgAAAAAHQgAAAAAJQgCUgAAJQoCUgAAJQwBUgAAFQ0AAAAAFQ0AAAAAFQ0AAAAAFQ0AAAAAAAsAAAACJgwAAAAAJgwAAAAAFQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAFQ0AAAAAJgwAAAAAJgwAAAAAAAsAAAACFQ0AAAAAFQ0AAAAAFQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAFQ0AAAAAPxYAAAACPxYAAAACFQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAFQ0AAAAAPxYAAAACPxYAAAACFQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAHQ0AAAAAJg8AAAAAHQ0AAAAAJhEAAAAAPxYAAAACPxYAAAACJhEAAAAAHQ0AAAAAJg4AAAAAJg4AAAAAHQ0AAAAAJhEAAAAAPxYAAAACPxYAAAACJhEAAAAAHQ0AAAAAJg8AAAAAHQ0AAAAAHQ0AAAAAJg8AAAAAHQ0AAAAAJhEAAAAAPxYAAAACPxYAAAACJg4AAAAAHQ0AAAAAGxEAAAACGxEAAAACHQ0AAAAAJg4AAAAAPxYAAAACPxYAAAACJhEAAAAAHQ0AAAAAJg8AAAAAHQ0AAAAA\"},\"127\":{\"w\":11,\"h\":15,\"lower\":\"AA0AAAAGAAAAAAAGAAAAAAAGBQcAAAAEBQcAAAAEPw0AAAAGPw0AAAAGBQcAAAAEBQcAAAAEAA0AAAAGAA0AAAAGAA0AAAAGAAAAAAAGAAAAAAAGKgcAAAAEKgcAAAAEPw0AAAAGPw0AAAAGKgcAAAAEKgcAAAAEAAAAAAAGAA0AAAAGAAAAAAAGAAAAAAAGAAAAAAAGKgcAAAAEKgcAAAAEAAAAAAAGAAUAAAAGKgcAAAAEKgcAAAAEAAAAAAAGAA0AAAAGAAAAAAAGAAAAAAAGAAAAAAAGHQUAAAAEHQUAAAAEHQUAAAAEAAUAAAAGKgcAAAAEKgcAAAAEKgcAAAAEAA0AAAAGAAAAAAAGAAAAAAAGAAAAAAAGHQUAAAAEHQUAAAAEHQUAAAAEJQUCUgAEKgcAAAAEKgcAAAAEHwkAAAAEAA0BhQAGAAAAAAAGKgUAAAAEKgUAAAAEHQUAAAAEHQUAAAAEHQUAAAAEAAUAAAAGAAAAAAAGJQcChQAEAAAAAAAGAA4BhQAGAA0AAAAGKgUAAAAEKgUAAAAEJQUCUgAEKgcAAAAEKgcAAAAEAAUAAAAGKgkAAAAEKgkAAAAEAAkAAAAGAA8AAAAGAA0AAAAGKgUAAAAEKgUAAAAEAAAAAAAGKgcAAAAEKgcAAAAEJQcCUgAEKgkAAAAEKgkAAAAECg0AAAAEAA8AAAAGAA0AAAAGKgUAAAAEKgUAAAAEKgUAAAAEKgUAAAAEKgUAAAAEHwcAAAAEKgkAAAAEKgkAAAAEAAkAAAAGAA8AAAAGAA0AAAAGAAIAAAAGAAAAAAAGKgUAAAAEKgUAAAAEKgUAAAAEKgUAAAAEKgkAAAAEKgkAAAAEAAAAAAAGAA8AAAAGAAAAAAAGAAIAAAAGAAIAAAAGJQUChQAEJQUChQAEAAIAAAAGAAYAAAAGKgkAAAAEKgkAAAAEAAYAAAAGAAYAAAAGAAAAAAAGAAIAAAAGAAIAAAAGJQcChQAEJQcChQAEAAIAAAAGAAYAAAAGJQkChQAEAAYAAAAGAAYAAAAGAAYAAAAGAAAAAAAGAAAAAAAGAAAAAAAGKgkAAAAEKgkAAAAEAAYAAAAGKgsAAAAEKgsAAAAEKgsAAAAEKgsAAAAEKgsAAAAEAAAAAAAGKgkAAAAEKgkAAAAEKgkAAAAEKgkAAAAEJQkCUgAEKgsAAAAEKQwBhQAEKQwBhQAEKQwBhQAEKgsAAAAEAAAAAAAGKgkAAAAEKgkAAAAEKgkAAAAEKgkAAAAEAAAAAAAGAAAAAAAGABAAAAAGABAAAAAGABAAAAAGAAAAAAAG\"}}}");

});

parcelRegister("56OCP", function(module, exports) {

$parcel$export(module.exports, "tilesForMap", () => $3b84c86f5d03437a$export$71c259b4c06697c);
$parcel$export(module.exports, "moveBits", () => $3b84c86f5d03437a$export$2983f3021ea56781);
$parcel$export(module.exports, "fftReach", () => $3b84c86f5d03437a$export$a139cb24e618feab);
$parcel$export(module.exports, "reachTargets", () => $3b84c86f5d03437a$export$80354c2c2236c14b);
// fftPath.js — FFT's movement range, ported from FFTBG's own pathfinder (BATTLE.BIN 0x80174B8C and the
// routines it calls), so the sim moves units exactly where the game would let them. Pure, data-injected.
// Validated against the game itself: tools/emu-battle/pathcheck.mjs replays every captured call of the
// real routine, and pathfuzz.mjs runs it on generated boards through a MIPS interpreter; both diff this
// file against the game panel by panel.
//
// Map: { w, h, tiles }, `tiles` = the game's raw tile table, 2 layers x 256 x 8 bytes (lower layer
// first, index = y * w + x), as FFTBG keeps it at 0x8018F8CC:
//   +0 & 0x3F surface    +2 height (whole steps)    +3 >> 5 water depth, & 0x1F slope height
//   +4 slope type: a 2-bit multiplier per side on the slope height (bits 0-1 +x, 2-3 -x, 4-5 -y, 6-7 +y)
//   +5 & 0x1F thickness (a floor's underside = its top minus 2 x this)
//   +6 & 1 no panel, & 2 no walking, & 0x80 not a place to stop
// Heights are compared in half steps at the EDGE a unit crosses: 2 x height + slope x code(side).
//
// Mover: { x, y, layer, move, jump, f93, f94, f95, st5a, st5c, u6 } — position, Move and Jump, and the
// game's own unit bytes: +0x93..0x95 movement-ability bits, +0x5A / +0x5C statuses (0x5A: 0x40 Float,
// 0x04 Chicken, 0x02 Frog, 0x01 Critical), +6. `others`: [{ x, y, layer, ally, base, top, job }] living
// units in the way (`mountable`: a chocobo ally it could ride); `bodies`: [{ x, y, layer }] dead or mid-Jump units, whose panels can't be stopped on.
// Output: per panel (layer * 256 + y * w + x) the remaining move + 1 (0 = unreachable), the largest
// single step on the best path (the game's 5-byte panel records, bytes 0 and 4) and `dest`, the panels
// the unit may end its move on (tile byte 5 bit 0x20). moveTargets() then gives the AI's reachable set.

var $6ZWSX = parcelRequire("6ZWSX");
var $3b84c86f5d03437a$require$Buffer = $6ZWSX.Buffer;
const $3b84c86f5d03437a$var$X = 255;
const $3b84c86f5d03437a$var$row = (s)=>[
        ...s
    ].map((c)=>c === 'X' ? $3b84c86f5d03437a$var$X : +c);
const $3b84c86f5d03437a$export$b8797f553a70fd05 = [
    $3b84c86f5d03437a$var$row('111111111000112222X111111X01X1111111011111111211111111111111111X'),
    $3b84c86f5d03437a$var$row('111111111111111111111111111111111111111111111111111111111111111X'),
    $3b84c86f5d03437a$var$row('111111111111111111111111111111111111111111111111111111111111111X'),
    $3b84c86f5d03437a$var$row('111111111111111111X111111X01X1111111111111111111111111111111111X'),
    $3b84c86f5d03437a$var$row('1111111111111111112111111X01X1111111111111111111111111111111111X'),
    $3b84c86f5d03437a$var$row('1111111110001122221111111X01X1111111011111111211111111111111111X')
];
const $3b84c86f5d03437a$var$SURF_LAVA = 18, $3b84c86f5d03437a$var$SURF_NOSTOP = 28, $3b84c86f5d03437a$var$SURF_NONE = 63;
// side order 0 +x, 1 +y, 2 -x, 3 -y: the slope-type shift of the side you LEAVE by and the side you
// ENTER by (the direction handlers at 0x801754D0..0x80175540)
const $3b84c86f5d03437a$var$DIRS = [
    {
        dx: 1,
        dy: 0,
        out: 0,
        in: 2
    },
    {
        dx: 0,
        dy: 1,
        out: 6,
        in: 4
    },
    {
        dx: -1,
        dy: 0,
        out: 2,
        in: 0
    },
    {
        dx: 0,
        dy: -1,
        out: 4,
        in: 6
    }
];
function $3b84c86f5d03437a$export$78b81afc429c6c98(m) {
    let f94 = m.f94 || 0, f95 = m.f95 || 0;
    const f93 = m.f93 || 0, st5a = m.st5a || 0, f95raw = f95;
    let height = 6;
    if (st5a & 0x06) {
        f94 &= -13;
        f95 &= -5;
        height = 4;
    } // Frog / Chicken: no Teleport/Fly, short
    const p20 = !(f95 & 0x88) && f94 & 0x10 ? 1 : 0;
    let p28 = f95;
    if (f95 & 0x08) {
        height += 2;
        p28 = f95 | 0x80;
    } // Levitate: floats 2 higher
    if (st5a & 0x40) f95 |= 0x08; // the Float status counts as floating
    let costRow, kind; // kind = the game's +14: 0 Fly, 1 Teleport, 2.. walking
    if (f95 & 0x04) {
        costRow = 1;
        kind = 0;
    } else if (f94 & 0x0c) {
        costRow = 1;
        kind = 1;
    } else if (f95 & 0x08) {
        costRow = 2;
        kind = 2;
    } else if (f95 & 0x20) {
        costRow = 5;
        kind = 3;
    } else if (f95 & 0x80) {
        costRow = 3;
        kind = 4;
    } else if (f95 & 0x40) {
        costRow = 3;
        kind = 5;
    } else if (f95 & 0x10) {
        costRow = 4;
        kind = 6;
    } else {
        costRow = 0;
        kind = 7;
    }
    const noLeap = kind <= 1; // Fly and Teleport don't search leaps
    const deep3Ok = !(p28 & 0xd0), deep4Ok = !(p28 & 0xc0); // may stop in depth-3 / depth-4+ water
    const p18 = deep3Ok ? 1 : 0, p19 = deep4Ok ? 1 : 0;
    const p17 = !(f95 & 0x8c) && f94 & 0x10 ? 1 : 0; // no water at all
    const lavaOk = f95raw & 0x28 ? 1 : 0; // Levitate / Lava Walking may stop on lava (+37)
    let jumpRaw = Math.min(m.jump, 7);
    const leap = jumpRaw >> 1;
    if (kind === 0 || f93 & 0x02) jumpRaw = 31; // Fly / Ignore Height
    const retreat = f95 & 0x02 && st5a & 0x01; // FFTBG's Retreat: +4 Move in Critical
    const move = Math.min(m.move + (retreat ? 4 : 0), 124);
    const stopOnAlly = m.u6 & 0xc0 && !(st5a & 0x06) && !((m.st5c || 0) & 0x20) ? 1 : 0; // the game's +22
    return {
        height: height,
        kind: kind,
        costRow: costRow,
        noLeap: noLeap,
        p17: p17,
        p18: p18,
        p19: p19,
        p20: p20,
        p28: p28,
        lavaOk: lavaOk,
        jumpRaw: jumpRaw,
        jumpLim: 2 * jumpRaw,
        leap: leap,
        move: move,
        stopOnAlly: stopOnAlly,
        waterOne: !!(f94 & 0x02),
        allOne: !!(f94 & 0x01),
        teleport: !!(f94 & 0x08)
    };
}
function $3b84c86f5d03437a$export$96e7aa1d986bb456(entry) {
    const tiles = new Uint8Array(4096);
    for(let i = 256; i < 512; i++)tiles[i * 8 + 6] = 1;
    const b64 = (s)=>typeof atob === 'function' ? Uint8Array.from(atob(s), (c)=>c.charCodeAt(0)) : new Uint8Array($3b84c86f5d03437a$require$Buffer.from(s, 'base64'));
    const put = (layer, s)=>{
        const b = b64(s);
        for(let i = 0; i < entry.w * entry.h; i++){
            const o = (layer * 256 + i) * 8, k = i * 6;
            tiles[o] = b[k];
            tiles[o + 2] = b[k + 1];
            tiles[o + 3] = b[k + 2];
            tiles[o + 4] = b[k + 3];
            tiles[o + 5] = b[k + 4];
            tiles[o + 6] = b[k + 5];
        }
    };
    put(0, entry.lower);
    if (entry.upper) put(1, entry.upper);
    return {
        w: entry.w,
        h: entry.h,
        tiles: tiles
    };
}
// The tile table for a map title as the API gives it ("29) Bariaus Valley"): the entry for its number in
// mapTiles.json's data (passed in, so callers load it their own way), unpacked once. null for no number or
// no entry. The sim checks the tiles against the terrain it's given, so a reused number falls back safely.
const $3b84c86f5d03437a$var$unpackedCache = new WeakMap();
function $3b84c86f5d03437a$export$71c259b4c06697c(title, mapTiles) {
    const m = /^\s*(\d+)\)/.exec(String(title || ''));
    const e = m && mapTiles && mapTiles.maps ? mapTiles.maps[+m[1]] : null;
    if (!e) return null;
    if (!$3b84c86f5d03437a$var$unpackedCache.has(e)) $3b84c86f5d03437a$var$unpackedCache.set(e, $3b84c86f5d03437a$export$96e7aa1d986bb456(e));
    return $3b84c86f5d03437a$var$unpackedCache.get(e);
}
const $3b84c86f5d03437a$export$4d527aa0e38d1f6a = [
    'Move+1',
    'Move+2',
    'Move+3',
    'Jump+1',
    'Jump+2',
    'Jump+3',
    'Ignore Height',
    'Lifefont',
    'Manafont',
    'Sonic Step',
    'Pilgrimage',
    'Landlocked',
    'Teleport',
    'Teleport 2',
    null,
    null,
    'Waterwalking',
    'Swim',
    'Lava Walking',
    'Ignore Terrain',
    'Levitate',
    'Fly',
    'Retreat',
    null
];
function $3b84c86f5d03437a$export$2983f3021ea56781(names = []) {
    const b = [
        0,
        0,
        0
    ];
    for (const n of names){
        const i = $3b84c86f5d03437a$export$4d527aa0e38d1f6a.indexOf(n);
        if (i >= 0) b[i >> 3] |= 0x80 >> (i & 7);
    }
    return {
        f93: b[0],
        f94: b[1],
        f95: b[2]
    };
}
function $3b84c86f5d03437a$export$a139cb24e618feab(map, mover, others = [], opts = {}) {
    const { w: w, h: h, tiles: tiles } = map;
    const N = 512;
    const P = $3b84c86f5d03437a$export$78b81afc429c6c98(mover);
    const H = P.height;
    const remain = new Uint8Array(N), maxStep = new Uint8Array(N).fill(255), attr = new Uint8Array(N);
    const topRemain = new Uint8Array(16), topMax = new Uint8Array(16).fill(255); // the unit-top nodes (records 512..527)
    const water = P.waterOne ? 1 : opts.waterCost ?? 1;
    const cost = $3b84c86f5d03437a$export$b8797f553a70fd05[P.costRow].map((c)=>c === 0 ? water : P.allOne && c !== $3b84c86f5d03437a$var$X ? 1 : c);
    const tile = (layer, x, y)=>(layer * 256 + y * w + x) * 8;
    const edge = (t, shift)=>2 * tiles[t + 2] + (tiles[t + 3] & 0x1f) * (tiles[t + 4] >> shift & 3);
    const inMap = (x, y)=>x >= 0 && y >= 0 && x < w && y < h;
    const REV = !!opts.reverse;
    const unitAt = new Map(others.slice(0, 16).map((o, index)=>[
            (o.layer || 0) * 256 + o.y * w + o.x,
            {
                ...o,
                index: index
            }
        ]));
    // Panel attributes ("0x80174E84"): 0x02 a slope rising along x on one side only; 0x40 too steep to
    // walk up (that kind at 3+, any other above the unit's Jump); 0x10 a panel the unit may stand on; 0x80
    // no panel; 0x04 a unit; 0x20 a rideable ally (it may stop there; other allies are only walked through).
    for(let p = 0; p < N; p++){
        if ((p & 255) >= w * h) continue;
        const t = p * 8, type = tiles[t + 4], sl = tiles[t + 3] & 0x1f, dep = tiles[t + 3] >> 5, b6 = tiles[t + 6];
        let a = 0;
        if ((type & 5) === 1 || (type & 5) === 4) {
            a |= 0x02;
            if (sl >= 3) a |= 0x40;
        } else if (sl > P.jumpRaw) a |= 0x40;
        if (!(b6 & 3) && !(dep && P.p17) && !(dep >= 4 && P.p19)) a |= 0x10;
        if (b6 & 1) a |= 0x80;
        else if (P.kind === 0 && b6 & 2 && (tiles[t] & 0x3f) !== $3b84c86f5d03437a$var$SURF_NONE) a |= 0x10; // a flier may land on no-walk tiles
        attr[p] = a;
    }
    for (const o of others){
        const p = (o.layer || 0) * 256 + o.y * w + o.x;
        let a = attr[p] | 0x04;
        if (o.job === 0x49) {
            a |= 0x80;
            a &= -17;
        }
        if (!o.ally) a = P.kind !== 0 ? a & 0xc7 : a & 0xcf | 0x08; // a foe: not standable; a flier may pass over its top
        else if (o.mountable) a |= 0x20; // an ally it could ride (a chocobo): may stop there
        else a &= -33; // any other ally: walk through, never stop
        attr[p] = a;
    }
    const steep = (p)=>(attr[p] & 0x40) !== 0;
    // Can a unit taking off at edge E jump over column (x, y)? ("0x8017622C") Each thing in it — a tile on
    // either layer, or a FOE standing there — spans [bottom, top] (a tile: lower edge minus twice its
    // thickness, higher edge plus twice its depth); none may cut into the jumper's body (E, E + H), and the
    // column must have something at or below E. Allies are jumped over.
    const gapClear = (x, y, d, E)=>{
        let lowest = 127;
        const span = (bottom, top)=>{
            if (bottom < lowest) lowest = bottom;
            if (E < bottom && bottom < E + H) return false;
            if (E < top && top < E + H) return false;
            if (bottom <= E && top >= E + H) return false;
            return true;
        };
        for(let layer = 0; layer < 2; layer++){
            const t = tile(layer, x, y);
            if (tiles[t + 6] & 1) continue;
            const a = edge(t, d.out), b = edge(t, d.in);
            if (!span(Math.min(a, b) - 2 * (tiles[t + 5] & 0x1f), Math.max(a, b) + 2 * (tiles[t + 3] >> 5))) return false;
            const u = unitAt.get(layer * 256 + y * w + x);
            if (u && !u.ally && u.base != null) {
                if (E < u.base + 3 && u.base + 3 < E + H) return false;
                if (!span(u.base, u.top)) return false;
            }
        }
        return lowest === 127 || !(E < lowest);
    };
    // Headroom ("0x80176164"): the lowest tile underside above height `lim` in column (x, y), either layer.
    const ceiling = (x, y, shift, lim)=>{
        let c = 127;
        for(let layer = 0; layer < 2; layer++){
            const t = tile(layer, x, y);
            if (tiles[t + 6] & 1) continue;
            const b = edge(t, shift) - 2 * (tiles[t + 5] & 0x1f);
            if (b > lim && b < c) c = b;
        }
        return c;
    };
    const start = (mover.layer || 0) * 256 + mover.y * w + mover.x;
    remain[start] = P.move + 1;
    maxStep[start] = 0;
    if (P.kind === 1) remain.fill(1); // Teleport: every panel (Teleport's Move limit is the AI's)
    else {
        // The search ("0x80174B8C"): Move rounds; each scans the panels in memory order (layer, row, column)
        // and expands every flagged one, clearing its flag first. A panel improved earlier in a scan is
        // expanded later in it, which settles ties between equally long paths.
        const flagged = new Uint8Array(N);
        flagged[start] = 1;
        for(let round = 0; round < P.move; round++){
            let any = false;
            for(let p = 0; p < N; p++){
                if (!flagged[p]) continue;
                flagged[p] = 0;
                any = true;
                if ((p & 255) >= w * h) continue;
                const layer = p >> 8, x = (p & 255) % w, y = Math.floor((p & 255) / w), ts = tile(layer, x, y);
                // One move onto column (nx, ny) from `src` (this panel, or the top of the unit standing on it), `gap`
                // tiles skipped (0 = a walk): "0x80175958". It tries the panel on each layer, then the top of a unit
                // standing on it (only where the panel is marked 0x08: a foe for a flier, an ally on the upper layer).
                const tryStep = (src, d, nx, ny, gap)=>{
                    const from = src.edge;
                    for(let a0 = 0; a0 < 4; a0++){
                        const nl = a0 & 1, onTop = a0 >> 1, q = nl * 256 + ny * w + nx, td = tile(nl, nx, ny);
                        let to, dstCeil, c, k = -1;
                        if (!onTop) {
                            if (!(attr[q] & 0x10)) continue; // not a panel it may enter
                            c = cost[tiles[td] & 0x3f];
                            if (c === $3b84c86f5d03437a$var$X) continue;
                            to = edge(td, d.in);
                            dstCeil = ceiling(nx, ny, d.in, to);
                        } else {
                            if (!(attr[q] & 0x08)) continue;
                            const u = unitAt.get(q);
                            if (!u || u.top == null) continue;
                            k = u.index;
                            c = 1;
                            to = u.top;
                            dstCeil = ceiling(nx, ny, d.in, to - 1);
                        }
                        if (dstCeil < from + H || src.ceil < to + H || dstCeil < to + H) continue; // no headroom
                        if (!onTop) {
                            if (edge(td, d.out) > to && steep(q)) continue; // walking up a too-steep slope
                            to += 2 * (tiles[td + 3] >> 5); // water depth raises the edge
                        }
                        if (gap && to > from) continue; // a leap never lands higher
                        const step = Math.abs(to - from);
                        if (step > P.jumpLim) continue;
                        const left = src.remain - gap - c;
                        if (left <= 0) continue;
                        const ms = P.kind === 0 ? 0 : Math.max(step, src.ms === 255 ? 0 : src.ms);
                        if (!onTop) {
                            if (left < remain[q] || left === remain[q] && ms >= maxStep[q]) continue;
                            remain[q] = left;
                            maxStep[q] = ms;
                        } else {
                            if (left < topRemain[k] || left === topRemain[k] && ms >= topMax[k]) continue;
                            topRemain[k] = left;
                            topMax[k] = ms;
                        }
                        if (left >= 2) flagged[q] = 1;
                    }
                };
                // REVERSE (the AI's distance-to-target flood, 0x80178CA4): the flood runs from the target outward, so a
                // flood step p -> q stands for the unit's real move q -> p. The real move's checks apply with the ends
                // swapped: q must be left that way (steep: downhill only), p entered (steep: not walking up it), the
                // cost is p's, and a leap may not land higher than it started.
                const tryRev = (d, nx, ny, gap)=>{
                    const q = ny * w + nx, td = tile(0, nx, ny);
                    if (!(attr[q] & 0x10) || attr[q] & 0x80) return;
                    const c = cost[tiles[ts] & 0x3f];
                    if (c === $3b84c86f5d03437a$var$X || cost[tiles[td] & 0x3f] === $3b84c86f5d03437a$var$X) return;
                    if (steep(q) && edge(td, d.in) >= edge(td, d.out)) return; // q is a steep slope it can't leave this way
                    let to = edge(ts, d.out);
                    if (steep(p) && edge(ts, d.in) > to) return; // walking up into p's steep slope
                    to += 2 * (tiles[ts + 3] >> 5);
                    let from = edge(td, d.in);
                    const dep = tiles[td + 3] >> 5;
                    if (dep && P.p28 & 0xc0) {
                        from += 2 * dep;
                        if (P.p28 & 0x40) from -= 2;
                    }
                    if (ceiling(nx, ny, d.in, edge(td, d.in)) < to + H || ceiling(x, y, d.out, to - 2 * (tiles[ts + 3] >> 5)) < from + H) return;
                    if (gap && to > from) return;
                    const step = Math.abs(to - from);
                    if (step > P.jumpLim) return;
                    const left = remain[p] - gap - c;
                    if (left <= 0) return;
                    const ms = P.kind === 0 ? 0 : Math.max(step, maxStep[p] === 255 ? 0 : maxStep[p]);
                    if (left < remain[q] || left === remain[q] && ms >= maxStep[q]) return;
                    remain[q] = left;
                    maxStep[q] = ms;
                    if (left >= 2) flagged[q] = 1;
                };
                if (REV) {
                    if (p >= 256) continue;
                    for (const d of $3b84c86f5d03437a$var$DIRS){
                        const nx = x + d.dx, ny = y + d.dy;
                        if (remain[p] >= 2 && inMap(nx, ny)) tryRev(d, nx, ny, 0);
                    }
                    if (P.noLeap) continue;
                    for (const d of $3b84c86f5d03437a$var$DIRS){
                        if (remain[p] < 2) continue;
                        for(let g = 1; g <= P.leap; g++){
                            if (remain[p] - g < 2) break;
                            const gx = x + g * d.dx, gy = y + g * d.dy, lx = x + (g + 1) * d.dx, ly = y + (g + 1) * d.dy;
                            if (!inMap(gx, gy) || !gapClear(gx, gy, d, edge(ts, d.out)) || !inMap(lx, ly)) break;
                            tryRev(d, lx, ly, g);
                        }
                    }
                    continue;
                }
                const canLeave = (d)=>!(steep(p) && edge(ts, d.out) >= edge(ts, d.in)); // a steep slope: downhill only
                // the edge it leaves from: a floater or water walker (+28 & 0xC0) is at the water's SURFACE
                const fromEdge = (d)=>{
                    let e = edge(ts, d.out);
                    const dep = tiles[ts + 3] >> 5;
                    if (dep && P.p28 & 0xc0) {
                        e += 2 * dep;
                        if (P.p28 & 0x40) e -= 2;
                    }
                    return e;
                };
                const fromPanel = (d)=>({
                        edge: fromEdge(d),
                        ceil: ceiling(x, y, d.out, edge(ts, d.out)),
                        remain: remain[p],
                        ms: maxStep[p]
                    });
                const here = unitAt.get(p);
                const fromTop = (d)=>({
                        edge: here.top,
                        ceil: ceiling(x, y, d.out, here.top - 1),
                        remain: topRemain[here.index],
                        ms: topMax[here.index]
                    });
                // directions 0-3 from the panel, then 4-7 from the top of the unit on it (if it's one it can stand on)
                for (const d of $3b84c86f5d03437a$var$DIRS){
                    const nx = x + d.dx, ny = y + d.dy;
                    if (remain[p] >= 2 && canLeave(d) && inMap(nx, ny)) tryStep(fromPanel(d), d, nx, ny, 0);
                }
                if (attr[p] & 0x08 && here && here.top != null) for (const d of $3b84c86f5d03437a$var$DIRS){
                    const nx = x + d.dx, ny = y + d.dy;
                    if (topRemain[here.index] >= 2 && inMap(nx, ny)) tryStep(fromTop(d), d, nx, ny, 0);
                }
                if (P.noLeap) continue;
                // Leaps ("0x801764D8"): over 1..Jump/2 gap tiles, landing on the next, while the move allows.
                for (const d of $3b84c86f5d03437a$var$DIRS){
                    if (!canLeave(d) || remain[p] < 2) continue;
                    const src = fromPanel(d);
                    for(let g = 1; g <= P.leap; g++){
                        if (remain[p] - g < 2) break;
                        const gx = x + g * d.dx, gy = y + g * d.dy, lx = x + (g + 1) * d.dx, ly = y + (g + 1) * d.dy;
                        if (!inMap(gx, gy) || !gapClear(gx, gy, d, src.edge) || !inMap(lx, ly)) break;
                        tryStep(src, d, lx, ly, g);
                    }
                }
            }
            if (!any) break;
        }
    }
    // Where it may stop ("0x80175288", after "0x80174DF8" takes standing off the bodies' panels): reached,
    // standable, not a slope of 4+ (or a one-sided x slope of 3+), not marked no-stop, not surface 28, no
    // lava without the lava/float bit, water only as deep as the unit may stand in, not on another unit
    // (unless +22 allows an ally's panel). Its own panel isn't in the set.
    for (const b of opts.bodies || [])attr[(b.layer || 0) * 256 + b.y * w + b.x] &= -17;
    const dest = new Uint8Array(N);
    for(let p = 0; p < N; p++){
        if (p === start || (p & 255) >= w * h) continue;
        const t = p * 8, sl = tiles[t + 3] & 0x1f, dep = tiles[t + 3] >> 5, surf = tiles[t] & 0x3f, b6 = tiles[t + 6], a = attr[p];
        if (P.kind === 1 && a & 0x20) {
            dest[p] = 1;
            continue;
        } // a teleporter may land on a rideable ally
        if (sl >= 3 && a & 0x02) continue;
        if (!remain[p] || sl >= 4 || b6 & 0x80 || surf === $3b84c86f5d03437a$var$SURF_NOSTOP) continue;
        if (dep && P.p20) continue;
        if (dep === 3 && P.p18) continue;
        if (dep >= 4 && P.p19) continue;
        if (surf === $3b84c86f5d03437a$var$SURF_LAVA && !P.lavaOk) continue;
        if (b6 & 2 || !(a & 0x10)) continue;
        if (a & 0x04 && (!(a & 0x20) || !P.stopOnAlly)) continue;
        dest[p] = 1;
    }
    return {
        remain: remain,
        maxStep: maxStep,
        dest: dest,
        params: P
    };
}
function $3b84c86f5d03437a$export$57111e524a3bb3a6(map, mover, others = [], opts = {}) {
    return $3b84c86f5d03437a$export$80354c2c2236c14b(map, mover, others, opts).targets;
}
function $3b84c86f5d03437a$export$80354c2c2236c14b(map, mover, others = [], opts = {}) {
    const r = $3b84c86f5d03437a$export$a139cb24e618feab(map, mover, others, opts), out = new Set();
    const { w: w, h: h } = map;
    for(let p = 0; p < 512; p++){
        if (!r.dest[p] || (p & 255) >= w * h) continue;
        if (r.params.teleport) {
            const x = (p & 255) % w, y = Math.floor((p & 255) / w);
            if (Math.abs(x - mover.x) + Math.abs(y - mover.y) > r.params.move) continue;
        }
        out.add(p);
    }
    for (const o of others)out.delete((o.layer || 0) * 256 + o.y * w + o.x);
    out.add((mover.layer || 0) * 256 + mover.y * w + mover.x);
    return {
        reach: r,
        targets: out
    };
}

});

parcelRegister("3DHjl", function(module, exports) {

$parcel$export(module.exports, "MESH_URLS", () => $2a669c438e438712$export$b88fdbe7802dfc48);
// Per-map-number URLs of the real-mesh .glb models (extracted from the game
// via tools/fft-map). Parcel resolves each new URL(…, import.meta.url) literal
// statically, so this table must stay literal — no loops. Shared by
// MapDetailView and the bracket's 3D map hover.

























































































































const $2a669c438e438712$export$b88fdbe7802dfc48 = {
    0: new URL((parcelRequire("2UM5p"))).href,
    1: new URL((parcelRequire("b7cfM"))).href,
    2: new URL((parcelRequire("l5OVz"))).href,
    3: new URL((parcelRequire("jvtts"))).href,
    4: new URL((parcelRequire("i6qXs"))).href,
    5: new URL((parcelRequire("6zShy"))).href,
    6: new URL((parcelRequire("iVkR1"))).href,
    7: new URL((parcelRequire("2MkHQ"))).href,
    8: new URL((parcelRequire("b9SqP"))).href,
    9: new URL((parcelRequire("2W2Am"))).href,
    10: new URL((parcelRequire("etNWE"))).href,
    11: new URL((parcelRequire("eaShH"))).href,
    12: new URL((parcelRequire("6Yg6M"))).href,
    13: new URL((parcelRequire("9t3Pp"))).href,
    14: new URL((parcelRequire("fVZ6v"))).href,
    15: new URL((parcelRequire("4v1v8"))).href,
    16: new URL((parcelRequire("eVYs2"))).href,
    17: new URL((parcelRequire("4wBQr"))).href,
    18: new URL((parcelRequire("hxzOH"))).href,
    19: new URL((parcelRequire("eVjuX"))).href,
    20: new URL((parcelRequire("1hpXX"))).href,
    21: new URL((parcelRequire("21Zqy"))).href,
    22: new URL((parcelRequire("cu8Q8"))).href,
    23: new URL((parcelRequire("i6MDd"))).href,
    24: new URL((parcelRequire("18jiG"))).href,
    25: new URL((parcelRequire("473ze"))).href,
    26: new URL((parcelRequire("l4Y9C"))).href,
    27: new URL((parcelRequire("e7JVk"))).href,
    28: new URL((parcelRequire("6pytA"))).href,
    29: new URL((parcelRequire("frWqA"))).href,
    30: new URL((parcelRequire("8BXoh"))).href,
    31: new URL((parcelRequire("6iYjh"))).href,
    32: new URL((parcelRequire("1R4s9"))).href,
    33: new URL((parcelRequire("fXdeX"))).href,
    34: new URL((parcelRequire("j6E6O"))).href,
    35: new URL((parcelRequire("eaAZe"))).href,
    36: new URL((parcelRequire("6Lz92"))).href,
    37: new URL((parcelRequire("6A5jP"))).href,
    38: new URL((parcelRequire("7ibK1"))).href,
    39: new URL((parcelRequire("6VYBV"))).href,
    40: new URL((parcelRequire("l0CAB"))).href,
    41: new URL((parcelRequire("5KFxD"))).href,
    42: new URL((parcelRequire("iJq0e"))).href,
    43: new URL((parcelRequire("bTppc"))).href,
    44: new URL((parcelRequire("eVngm"))).href,
    45: new URL((parcelRequire("9jmey"))).href,
    46: new URL((parcelRequire("2zXHd"))).href,
    47: new URL((parcelRequire("aWrDO"))).href,
    48: new URL((parcelRequire("bllsz"))).href,
    49: new URL((parcelRequire("ktcKD"))).href,
    50: new URL((parcelRequire("1VB4h"))).href,
    51: new URL((parcelRequire("aATq9"))).href,
    52: new URL((parcelRequire("QCI6l"))).href,
    53: new URL((parcelRequire("kRxHa"))).href,
    54: new URL((parcelRequire("8975A"))).href,
    55: new URL((parcelRequire("2JfOn"))).href,
    56: new URL((parcelRequire("4cr3X"))).href,
    57: new URL((parcelRequire("dsb3U"))).href,
    58: new URL((parcelRequire("foyrn"))).href,
    59: new URL((parcelRequire("i9o0l"))).href,
    60: new URL((parcelRequire("jwi0F"))).href,
    61: new URL((parcelRequire("aP9Zf"))).href,
    62: new URL((parcelRequire("6Ifu2"))).href,
    63: new URL((parcelRequire("aD5NQ"))).href,
    64: new URL((parcelRequire("3NXDO"))).href,
    65: new URL((parcelRequire("iH1BY"))).href,
    66: new URL((parcelRequire("9AZ9i"))).href,
    67: new URL((parcelRequire("iHbGC"))).href,
    68: new URL((parcelRequire("eIawK"))).href,
    69: new URL((parcelRequire("2kW9h"))).href,
    70: new URL((parcelRequire("hqpAT"))).href,
    71: new URL((parcelRequire("bP2Zc"))).href,
    72: new URL((parcelRequire("iXm8R"))).href,
    73: new URL((parcelRequire("k8hZr"))).href,
    74: new URL((parcelRequire("39B1H"))).href,
    75: new URL((parcelRequire("2lRk3"))).href,
    76: new URL((parcelRequire("kDpFB"))).href,
    77: new URL((parcelRequire("e7upz"))).href,
    78: new URL((parcelRequire("abb8J"))).href,
    79: new URL((parcelRequire("c6esc"))).href,
    80: new URL((parcelRequire("3PVrT"))).href,
    81: new URL((parcelRequire("8BIbI"))).href,
    82: new URL((parcelRequire("j4jMU"))).href,
    83: new URL((parcelRequire("4ZLTH"))).href,
    84: new URL((parcelRequire("jAznP"))).href,
    85: new URL((parcelRequire("78vtE"))).href,
    86: new URL((parcelRequire("lS0ni"))).href,
    87: new URL((parcelRequire("jwU4o"))).href,
    88: new URL((parcelRequire("cbQ7S"))).href,
    89: new URL((parcelRequire("kEpZG"))).href,
    90: new URL((parcelRequire("2Nv0f"))).href,
    91: new URL((parcelRequire("fqYJH"))).href,
    92: new URL((parcelRequire("k7E5t"))).href,
    93: new URL((parcelRequire("ekcvu"))).href,
    94: new URL((parcelRequire("6l64j"))).href,
    95: new URL((parcelRequire("c6idG"))).href,
    96: new URL((parcelRequire("kpu7n"))).href,
    97: new URL((parcelRequire("7txlq"))).href,
    98: new URL((parcelRequire("goWkQ"))).href,
    99: new URL((parcelRequire("dBzez"))).href,
    100: new URL((parcelRequire("63xvU"))).href,
    101: new URL((parcelRequire("jUpqZ"))).href,
    102: new URL((parcelRequire("fo9v9"))).href,
    103: new URL((parcelRequire("bsxav"))).href,
    104: new URL((parcelRequire("L15od"))).href,
    105: new URL((parcelRequire("3TXBu"))).href,
    106: new URL((parcelRequire("bQQQG"))).href,
    107: new URL((parcelRequire("20pml"))).href,
    108: new URL((parcelRequire("faDpW"))).href,
    109: new URL((parcelRequire("angDs"))).href,
    110: new URL((parcelRequire("4zBPQ"))).href,
    111: new URL((parcelRequire("bf6Hi"))).href,
    112: new URL((parcelRequire("d4GoW"))).href,
    113: new URL((parcelRequire("9PFTW"))).href,
    114: new URL((parcelRequire("6lN8O"))).href,
    115: new URL((parcelRequire("eQh4v"))).href,
    116: new URL((parcelRequire("jBkOA"))).href,
    117: new URL((parcelRequire("7ch73"))).href,
    118: new URL((parcelRequire("kN8uq"))).href,
    119: new URL((parcelRequire("lreXs"))).href,
    125: new URL((parcelRequire("zIbTP"))).href
};

});
parcelRegister("2UM5p", function(module, exports) {
module.exports = import.meta.resolve("cNR89");

});

parcelRegister("b7cfM", function(module, exports) {
module.exports = import.meta.resolve("aLW8G");

});

parcelRegister("l5OVz", function(module, exports) {
module.exports = import.meta.resolve("CmxvS");

});

parcelRegister("jvtts", function(module, exports) {
module.exports = import.meta.resolve("UcYWZ");

});

parcelRegister("i6qXs", function(module, exports) {
module.exports = import.meta.resolve("3O64S");

});

parcelRegister("6zShy", function(module, exports) {
module.exports = import.meta.resolve("l0wvG");

});

parcelRegister("iVkR1", function(module, exports) {
module.exports = import.meta.resolve("i6vlu");

});

parcelRegister("2MkHQ", function(module, exports) {
module.exports = import.meta.resolve("3dPar");

});

parcelRegister("b9SqP", function(module, exports) {
module.exports = import.meta.resolve("8y2qu");

});

parcelRegister("2W2Am", function(module, exports) {
module.exports = import.meta.resolve("1qo3G");

});

parcelRegister("etNWE", function(module, exports) {
module.exports = import.meta.resolve("l0Xrs");

});

parcelRegister("eaShH", function(module, exports) {
module.exports = import.meta.resolve("1vDfw");

});

parcelRegister("6Yg6M", function(module, exports) {
module.exports = import.meta.resolve("40KUg");

});

parcelRegister("9t3Pp", function(module, exports) {
module.exports = import.meta.resolve("6TOMh");

});

parcelRegister("fVZ6v", function(module, exports) {
module.exports = import.meta.resolve("f0Wd6");

});

parcelRegister("4v1v8", function(module, exports) {
module.exports = import.meta.resolve("iNbdL");

});

parcelRegister("eVYs2", function(module, exports) {
module.exports = import.meta.resolve("2A9aK");

});

parcelRegister("4wBQr", function(module, exports) {
module.exports = import.meta.resolve("99jPt");

});

parcelRegister("hxzOH", function(module, exports) {
module.exports = import.meta.resolve("gu8mG");

});

parcelRegister("eVjuX", function(module, exports) {
module.exports = import.meta.resolve("5CJVn");

});

parcelRegister("1hpXX", function(module, exports) {
module.exports = import.meta.resolve("ie6QJ");

});

parcelRegister("21Zqy", function(module, exports) {
module.exports = import.meta.resolve("eaPSw");

});

parcelRegister("cu8Q8", function(module, exports) {
module.exports = import.meta.resolve("7iFX0");

});

parcelRegister("i6MDd", function(module, exports) {
module.exports = import.meta.resolve("dqJPJ");

});

parcelRegister("18jiG", function(module, exports) {
module.exports = import.meta.resolve("hjkhw");

});

parcelRegister("473ze", function(module, exports) {
module.exports = import.meta.resolve("dX4Jf");

});

parcelRegister("l4Y9C", function(module, exports) {
module.exports = import.meta.resolve("hRmML");

});

parcelRegister("e7JVk", function(module, exports) {
module.exports = import.meta.resolve("TRpQN");

});

parcelRegister("6pytA", function(module, exports) {
module.exports = import.meta.resolve("5OxdR");

});

parcelRegister("frWqA", function(module, exports) {
module.exports = import.meta.resolve("kkkvI");

});

parcelRegister("8BXoh", function(module, exports) {
module.exports = import.meta.resolve("h88aT");

});

parcelRegister("6iYjh", function(module, exports) {
module.exports = import.meta.resolve("lMwAO");

});

parcelRegister("1R4s9", function(module, exports) {
module.exports = import.meta.resolve("90LA9");

});

parcelRegister("fXdeX", function(module, exports) {
module.exports = import.meta.resolve("ceSn5");

});

parcelRegister("j6E6O", function(module, exports) {
module.exports = import.meta.resolve("5sSZy");

});

parcelRegister("eaAZe", function(module, exports) {
module.exports = import.meta.resolve("jIxP7");

});

parcelRegister("6Lz92", function(module, exports) {
module.exports = import.meta.resolve("j3eLz");

});

parcelRegister("6A5jP", function(module, exports) {
module.exports = import.meta.resolve("4cUIq");

});

parcelRegister("7ibK1", function(module, exports) {
module.exports = import.meta.resolve("1OayE");

});

parcelRegister("6VYBV", function(module, exports) {
module.exports = import.meta.resolve("ftEW9");

});

parcelRegister("l0CAB", function(module, exports) {
module.exports = import.meta.resolve("bmy8X");

});

parcelRegister("5KFxD", function(module, exports) {
module.exports = import.meta.resolve("3WPD6");

});

parcelRegister("iJq0e", function(module, exports) {
module.exports = import.meta.resolve("7YAmB");

});

parcelRegister("bTppc", function(module, exports) {
module.exports = import.meta.resolve("4yJD3");

});

parcelRegister("eVngm", function(module, exports) {
module.exports = import.meta.resolve("7lRly");

});

parcelRegister("9jmey", function(module, exports) {
module.exports = import.meta.resolve("jqTPw");

});

parcelRegister("2zXHd", function(module, exports) {
module.exports = import.meta.resolve("boUvo");

});

parcelRegister("aWrDO", function(module, exports) {
module.exports = import.meta.resolve("9AzCF");

});

parcelRegister("bllsz", function(module, exports) {
module.exports = import.meta.resolve("5jvAp");

});

parcelRegister("ktcKD", function(module, exports) {
module.exports = import.meta.resolve("7r2Pb");

});

parcelRegister("1VB4h", function(module, exports) {
module.exports = import.meta.resolve("f2e5W");

});

parcelRegister("aATq9", function(module, exports) {
module.exports = import.meta.resolve("aC9E1");

});

parcelRegister("QCI6l", function(module, exports) {
module.exports = import.meta.resolve("fyUar");

});

parcelRegister("kRxHa", function(module, exports) {
module.exports = import.meta.resolve("5DouA");

});

parcelRegister("8975A", function(module, exports) {
module.exports = import.meta.resolve("4dPym");

});

parcelRegister("2JfOn", function(module, exports) {
module.exports = import.meta.resolve("l0fO8");

});

parcelRegister("4cr3X", function(module, exports) {
module.exports = import.meta.resolve("5iJEN");

});

parcelRegister("dsb3U", function(module, exports) {
module.exports = import.meta.resolve("gqx9r");

});

parcelRegister("foyrn", function(module, exports) {
module.exports = import.meta.resolve("4bSQO");

});

parcelRegister("i9o0l", function(module, exports) {
module.exports = import.meta.resolve("i5iv8");

});

parcelRegister("jwi0F", function(module, exports) {
module.exports = import.meta.resolve("bFkAl");

});

parcelRegister("aP9Zf", function(module, exports) {
module.exports = import.meta.resolve("3hzBe");

});

parcelRegister("6Ifu2", function(module, exports) {
module.exports = import.meta.resolve("hdCzo");

});

parcelRegister("aD5NQ", function(module, exports) {
module.exports = import.meta.resolve("3ScB3");

});

parcelRegister("3NXDO", function(module, exports) {
module.exports = import.meta.resolve("ejIAD");

});

parcelRegister("iH1BY", function(module, exports) {
module.exports = import.meta.resolve("fjVHU");

});

parcelRegister("9AZ9i", function(module, exports) {
module.exports = import.meta.resolve("b3uZb");

});

parcelRegister("iHbGC", function(module, exports) {
module.exports = import.meta.resolve("6fYZP");

});

parcelRegister("eIawK", function(module, exports) {
module.exports = import.meta.resolve("ka5Rz");

});

parcelRegister("2kW9h", function(module, exports) {
module.exports = import.meta.resolve("7fb8P");

});

parcelRegister("hqpAT", function(module, exports) {
module.exports = import.meta.resolve("3X4uL");

});

parcelRegister("bP2Zc", function(module, exports) {
module.exports = import.meta.resolve("kUadT");

});

parcelRegister("iXm8R", function(module, exports) {
module.exports = import.meta.resolve("3UYoj");

});

parcelRegister("k8hZr", function(module, exports) {
module.exports = import.meta.resolve("cunSL");

});

parcelRegister("39B1H", function(module, exports) {
module.exports = import.meta.resolve("3VAhz");

});

parcelRegister("2lRk3", function(module, exports) {
module.exports = import.meta.resolve("ipr09");

});

parcelRegister("kDpFB", function(module, exports) {
module.exports = import.meta.resolve("6Q3fv");

});

parcelRegister("e7upz", function(module, exports) {
module.exports = import.meta.resolve("eb8t4");

});

parcelRegister("abb8J", function(module, exports) {
module.exports = import.meta.resolve("f6a2c");

});

parcelRegister("c6esc", function(module, exports) {
module.exports = import.meta.resolve("kJ1VH");

});

parcelRegister("3PVrT", function(module, exports) {
module.exports = import.meta.resolve("hk0zM");

});

parcelRegister("8BIbI", function(module, exports) {
module.exports = import.meta.resolve("8YUt3");

});

parcelRegister("j4jMU", function(module, exports) {
module.exports = import.meta.resolve("2l1rk");

});

parcelRegister("4ZLTH", function(module, exports) {
module.exports = import.meta.resolve("ewhmZ");

});

parcelRegister("jAznP", function(module, exports) {
module.exports = import.meta.resolve("cbrva");

});

parcelRegister("78vtE", function(module, exports) {
module.exports = import.meta.resolve("dNd0k");

});

parcelRegister("lS0ni", function(module, exports) {
module.exports = import.meta.resolve("4Ziy1");

});

parcelRegister("jwU4o", function(module, exports) {
module.exports = import.meta.resolve("hxNRp");

});

parcelRegister("cbQ7S", function(module, exports) {
module.exports = import.meta.resolve("cBjLY");

});

parcelRegister("kEpZG", function(module, exports) {
module.exports = import.meta.resolve("ihOqs");

});

parcelRegister("2Nv0f", function(module, exports) {
module.exports = import.meta.resolve("5O9bh");

});

parcelRegister("fqYJH", function(module, exports) {
module.exports = import.meta.resolve("5dXxH");

});

parcelRegister("k7E5t", function(module, exports) {
module.exports = import.meta.resolve("8yHCC");

});

parcelRegister("ekcvu", function(module, exports) {
module.exports = import.meta.resolve("eZZO7");

});

parcelRegister("6l64j", function(module, exports) {
module.exports = import.meta.resolve("6U5vD");

});

parcelRegister("c6idG", function(module, exports) {
module.exports = import.meta.resolve("dOcRY");

});

parcelRegister("kpu7n", function(module, exports) {
module.exports = import.meta.resolve("hxUXn");

});

parcelRegister("7txlq", function(module, exports) {
module.exports = import.meta.resolve("lE4LS");

});

parcelRegister("goWkQ", function(module, exports) {
module.exports = import.meta.resolve("eePqV");

});

parcelRegister("dBzez", function(module, exports) {
module.exports = import.meta.resolve("3gxHS");

});

parcelRegister("63xvU", function(module, exports) {
module.exports = import.meta.resolve("2l0XC");

});

parcelRegister("jUpqZ", function(module, exports) {
module.exports = import.meta.resolve("5QuJq");

});

parcelRegister("fo9v9", function(module, exports) {
module.exports = import.meta.resolve("iWOP0");

});

parcelRegister("bsxav", function(module, exports) {
module.exports = import.meta.resolve("dMrZ2");

});

parcelRegister("L15od", function(module, exports) {
module.exports = import.meta.resolve("2yuud");

});

parcelRegister("3TXBu", function(module, exports) {
module.exports = import.meta.resolve("eSehD");

});

parcelRegister("bQQQG", function(module, exports) {
module.exports = import.meta.resolve("fYR5d");

});

parcelRegister("20pml", function(module, exports) {
module.exports = import.meta.resolve("1CI3Z");

});

parcelRegister("faDpW", function(module, exports) {
module.exports = import.meta.resolve("5d4ri");

});

parcelRegister("angDs", function(module, exports) {
module.exports = import.meta.resolve("5Kh2m");

});

parcelRegister("4zBPQ", function(module, exports) {
module.exports = import.meta.resolve("cSYp6");

});

parcelRegister("bf6Hi", function(module, exports) {
module.exports = import.meta.resolve("26FfJ");

});

parcelRegister("d4GoW", function(module, exports) {
module.exports = import.meta.resolve("5qKz4");

});

parcelRegister("9PFTW", function(module, exports) {
module.exports = import.meta.resolve("aPcCA");

});

parcelRegister("6lN8O", function(module, exports) {
module.exports = import.meta.resolve("4Lcti");

});

parcelRegister("eQh4v", function(module, exports) {
module.exports = import.meta.resolve("2Cuzm");

});

parcelRegister("jBkOA", function(module, exports) {
module.exports = import.meta.resolve("b3GDq");

});

parcelRegister("7ch73", function(module, exports) {
module.exports = import.meta.resolve("gfJNn");

});

parcelRegister("kN8uq", function(module, exports) {
module.exports = import.meta.resolve("gVa49");

});

parcelRegister("lreXs", function(module, exports) {
module.exports = import.meta.resolve("9psom");

});

parcelRegister("zIbTP", function(module, exports) {
module.exports = import.meta.resolve("2OmSC");

});


parcelRegister("4zJ4j", function(module, exports) {

$parcel$export(module.exports, "prepTeam", () => $354d63f64bda2a81$export$7341a8ca199b0636);
// Phase 5 bridge: convert a real FFTBG unit → a battleSim "combatant spec".
//
// Reuses the same combat libs the cards/fight view use (unitCombatStats,
// weapon/unarmed damage, evasion, and the abilityFormula models via
// abilityVsTarget) so the sim's numbers stay consistent with the rest of the
// app. APPROXIMATE: maps the clear damage/heal/revive/status/buff abilities and
// skips ones it can't classify. Monsters carry empty ClassSkills, so their kit is
// pulled from data.monsterSkills (the monster→intrinsic-skills snapshot) and their
// innate movement/undead traits read off classBase.innates.

var $9rruk = parcelRequire("9rruk");

var $eQqwh = parcelRequire("eQqwh");

var $8Q6Uh = parcelRequire("8Q6Uh");

var $7cZwo = parcelRequire("7cZwo");

var $79bVW = parcelRequire("79bVW");

var $jEtWa = parcelRequire("jEtWa");

var $56OCP = parcelRequire("56OCP");
// Reaction names the engine models (map the one that differs from API spelling).
// Reactions the engine resolves in dealAttack. Abandon & Parry are NOT here — their
// effect is the doubled / weapon evade, already baked into the precomputed `evade`
// via hitChance(unit.ReactionSkill). Counter Magic/Flood, Catch, Distribute, Absorb
// Used MP, Critical Quick, Sunken State, Earplug, Caution stay unmodeled (→ null).
const $354d63f64bda2a81$var$REACTIONS = new Set([
    'Counter',
    'Hamedo',
    'Blade Grasp',
    'Mana Shield',
    'Auto Potion',
    'Damage Split',
    'Counter Tackle',
    'Meatbone Slash',
    'Arrow Guard',
    'Dragon Spirit',
    'Regenerator',
    'HP Restore',
    'MP Restore',
    'Speed Save',
    'Brave Up',
    'Faith Up',
    'PA Save',
    'MA Save'
]);
const $354d63f64bda2a81$var$mapReaction = (r)=>r === 'Auto Potion' ? 'Auto-Potion' : $354d63f64bda2a81$var$REACTIONS.has(r) ? r : null;
// A weapon's reach. FFTBG's item `info` carries the authoritative PER-ITEM range
// ("9 WP, 5 range, 15% evade, Bow…"), which varies a lot — crossbows 4, Windslash Bow
// 5, Long Bow 6, spears 2, books 3 — so read it from there. RANGED[type] is only a
// fallback when an item's info lacks a range; 1 = plain melee. (A past bug hardcoded
// every bow to 4: a range-5 Windslash Bow then couldn't hit a foe 5 tiles away and,
// boxed in by void from closing the last tile, the archer never fired. It also
// under-ranged spears to 1 and books to 2.)
const $354d63f64bda2a81$var$RANGED = {
    Bow: 4,
    Crossbow: 4,
    Gun: 5,
    Harp: 3,
    Book: 2
};
const $354d63f64bda2a81$var$weaponRange = (item)=>{
    const m = item && item.info && item.info.match(/(\d+)\s*range/i);
    return m ? parseInt(m[1], 10) : $354d63f64bda2a81$var$RANGED[item && item.type] || 1;
};
// Undead monster classes. FFTBG's undead are the two classic sprite families —
// the skeleton family (SUKERU) and the ghost family (YUREI). The mustad.io API
// does NOT expose Auto-Undead as an innate (verified: no class mentions Undead
// anywhere), so the engine can't read it off classBase.innates — this explicit
// list stands in. Healing damages these, and they ~50%-revive instead of
// crystallizing (battleSim). The Zombie/Undead STATUS is also honored at runtime.
const $354d63f64bda2a81$var$UNDEAD_MONSTERS = new Set([
    'Skeleton',
    'Draugr',
    'Reaper',
    'Ghoul',
    'Ghost',
    'Revenant'
]);
// Innate movement traits that let a unit ignore terrain HEIGHT when pathing
// (birds/dragons/eyes fly; ghosts/bombs levitate) → a large effective Jump.
const $354d63f64bda2a81$var$HEIGHT_FREE_INNATES = new Set([
    'Fly',
    'Ignore Height',
    'Levitate'
]);
// Innates that also clear VOID/gap tiles, not just height: Fly (true flight) and
// Teleport (ghosts — move anywhere). These glide over chasms a ground unit (or a
// mere height-ignorer/levitator) is walled off by. → battleSim `canFly`.
const $354d63f64bda2a81$var$FLY_INNATES = new Set([
    'Fly',
    'Teleport'
]);
// Math Skill (Calculator) parameters. FFTBG ships only two ATTRIBUTES — CT and the
// standing Height — and four NUMBERS (×3/×4/×5 and Prime); there is NO Level/Exp
// targeting. A Calculator that knows ≥1 attribute and ≥1 number can cast a charged
// spell it knows on EVERY unit whose attribute satisfies the number — instantly, for
// free, board-wide, friendly fire. (`CALC_ATTR` maps the param name → the combatant
// field the engine reads: `ct` and `z` are both already tracked.)
const $354d63f64bda2a81$var$CALC_ATTR = {
    CT: 'ct',
    Height: 'z'
};
const $354d63f64bda2a81$var$CALC_NUM = {
    'Prime Number': 'prime',
    '3': '3',
    '4': '4',
    '5': '5'
};
const $354d63f64bda2a81$var$intIn = (info, re)=>{
    const m = info.match(re);
    return m ? parseInt(m[1], 10) : 0;
};
// abilityVsTarget returns a Random(lo,hi) damage as an array [lo,hi]; the engine wants
// a scalar power, and an array silently coerced to NaN (`[21,189] * mult` → NaN), so the
// AI's scorer scored those abilities NaN and never fired them — Pummel, Dash, Throw Stone,
// Cat Kick, Tail Swing were 5 permanently-dead skills. Collapse to the expected value.
const $354d63f64bda2a81$var$scalarPow = (p)=>Array.isArray(p) ? Math.round((p[0] + p[1]) / 2) : p;
const $354d63f64bda2a81$var$wItem = (it)=>it && it.type ? {
        type: it.type,
        wp: it.wp || 0,
        element: it.element || null
    } : null;
// The caster's side of a damage formula, as plain data (battle repros serialize actions).
const $354d63f64bda2a81$var$formulaCtx = (ctx)=>{
    const o = {};
    for (const k of [
        'pa',
        'ma',
        'speed',
        'brave',
        'faith',
        'wp',
        'maxHp',
        'weaponType',
        'paUnarmed',
        'martialArts',
        'strengthen',
        'attackUp',
        'magicAttackUp'
    ])if (ctx[k] != null && ctx[k] !== false) o[k] = ctx[k];
    return o;
};
// Enemy debuffs (status kind) and ally buffs (buff kind) an ability can inflict.
// Darkness → the engine's blind (halves physical accuracy); Frog/Berserk/Don't
// Move are modeled in battleSim. 'Death' = instant KO. Death Sentence is handled
// separately (a delayed-death countdown) before this matches.
const $354d63f64bda2a81$var$DISABLE = /Add\b[^.]*\b(Death|Stop|Sleep|Don't Act|Don't Move|Petrify|Charm|Frog|Berserk|Darkness|Silence|Confusion|Slow|Poison|Oil|Innocent|Undead)\b/;
const $354d63f64bda2a81$var$BUFF = /Add\b[^.]*\b(Haste|Protect|Shell|Regen|Reraise|Reflect|Float|Faith|Defending)\b/;
// Statuses a "Cancel …" clause can strip, split into the ones it's GOOD to remove from an
// ally (afflictions) vs. GOOD to strip from a foe (a Dispel of their buffs). Drives whether
// a cleanse targets allies (Esuna) or enemies (Dispel Magic).
const $354d63f64bda2a81$var$AFFLICTIONS = new Set([
    'Petrify',
    'Darkness',
    'Confusion',
    'Silence',
    'Berserk',
    'Frog',
    'Poison',
    'Sleep',
    'Stop',
    "Don't Move",
    "Don't Act",
    'Slow',
    'Death Sentence',
    'Oil',
    'Undead',
    'Blood Suck',
    'Charm',
    'Innocent'
]);
const $354d63f64bda2a81$var$GOODSTATUS = new Set([
    'Haste',
    'Protect',
    'Shell',
    'Regen',
    'Reraise',
    'Reflect',
    'Float',
    'Faith',
    'Defending',
    'Transparent',
    'Performing'
]);
// Stat modification (songs/dances ±N to a team; Mediator talk + Battle-Skill breaks ±N to
// one target; self-pumps like Accumulate). Reads the signed deltas out of the Effect clause.
const $354d63f64bda2a81$var$STAT_FIELD = {
    PA: 'pa',
    MA: 'ma',
    Speed: 'speed',
    Brave: 'brave',
    Faith: 'faith'
};
const $354d63f64bda2a81$var$parseStatMods = (info)=>{
    const eff = (info.match(/Effect:(.*)$/) || [
        ,
        ''
    ])[1]; // only the Effect clause (avoid "(PA + 81)" in a Hit% clause)
    const mods = [];
    const re = /([+-]\d+)\s*(PA|MA|Speed|Brave|Faith)\b/g;
    let m;
    while(m = re.exec(eff))mods.push({
        stat: $354d63f64bda2a81$var$STAT_FIELD[m[2]],
        delta: parseInt(m[1], 10)
    });
    return mods;
};
// Evaluate an additive "Hit: (PA + WP + 40)%" clause with the caster's stats → a % (for
// abilities abilityVsTarget doesn't score, e.g. the PA+WP Rends).
const $354d63f64bda2a81$var$hitPercent = (info, ctx)=>{
    const m = info.match(/Hit:[^.(]*\(([^)]*)\)%/);
    if (!m) return 100;
    let sum = 0;
    for (const tok of m[1].split('+').map((s)=>s.trim()))if (/^\d+$/.test(tok)) sum += +tok;
    else sum += ({
        PA: ctx.pa,
        WP: ctx.wp || 0,
        Speed: ctx.speed,
        MA: ctx.ma,
        Brave: ctx.brave,
        Faith: ctx.faith
    })[tok] || 0;
    return Math.max(0, Math.min(100, sum));
};
// The parts of a "Hit: [Human;] [Faith](MA + 34)%" clause, for the per-target rate battleSim computes
// (successOf): the stat part s (the caster's stats summed), the constant k, and whether Faith gates it.
const $354d63f64bda2a81$var$hitParts = (info, ctx)=>{
    const m = info.match(/Hit:\s*(?:[A-Za-z ]+;\s*)?(Faith)?\(([^)]*)\)%/);
    if (!m) return null;
    let st = 0, k = 0;
    for (const tok of m[2].split('+').map((x)=>x.trim()))if (/^\d+$/.test(tok)) k += +tok;
    else st += ({
        PA: ctx.pa,
        WP: ctx.wp || 0,
        Speed: ctx.speed,
        MA: ctx.ma,
        Brave: ctx.brave,
        Faith: ctx.faith
    })[tok] || 0;
    return {
        s: st,
        k: k,
        faith: !!m[1],
        ...ctx.magicAttackUp ? {
            mau: true
        } : {},
        ...ctx.attackUp ? {
            au: true
        } : {},
        ...ctx.martialArts && !ctx.wp ? {
            ma: true
        } : {}
    };
};
const $354d63f64bda2a81$var$STRIP_SLOT = {
    'head equipment': 'head',
    'body equipment': 'armor',
    shield: 'shield',
    weapon: 'weapon',
    accessory: 'accessory'
};
// Multi-status adds. "(Separate)" rolls EACH listed status independently, "(Random)" picks
// ONE, "(All)" applies them all on a single roll. Returns { statuses, mode } or null.
const $354d63f64bda2a81$var$STATUS_VOCAB = new Set([
    'Death',
    'Stop',
    'Sleep',
    "Don't Act",
    "Don't Move",
    'Petrify',
    'Charm',
    'Frog',
    'Berserk',
    'Darkness',
    'Silence',
    'Confusion',
    'Slow',
    'Poison',
    'Oil',
    'Innocent',
    'Undead',
    'Blood Suck',
    'Death Sentence',
    'Haste',
    'Protect',
    'Shell',
    'Regen',
    'Reraise',
    'Reflect',
    'Float',
    'Faith',
    'Defending',
    'Transparent'
]);
const $354d63f64bda2a81$var$multiStatus = (info)=>{
    const m = info.match(/Add ([^.]*?)\s*\((Separate|Random|All)\)/);
    if (!m) return null;
    const mode = {
        Separate: 'each',
        Random: 'one',
        All: 'all'
    }[m[2]];
    const statuses = m[1].split(/,|\band\b/).map((s)=>s.trim()).filter((s)=>$354d63f64bda2a81$var$STATUS_VOCAB.has(s));
    return statuses.length >= 2 ? {
        statuses: statuses,
        mode: mode
    } : null;
};
function $354d63f64bda2a81$export$9bd01db8ac5ab764(name, info, ctx) {
    if (!info) return null;
    // JUMP (Lancer): a charged, unevadable physical leap. The parser-first path
    // rejects its "If armed, Damage (PA * WP)" clauses (verb-anchored regex), so
    // model it directly. Power mirrors jumpAttackModel/legacyAbilityFormula: armed
    // PA*WP (×3/2 with a Spear), barehanded [PA*Br/100]*PA. Charge = ceil(50/Speed);
    // Jump ignores evasion (BMG) and is non-elemental. Level JumpN reaches N tiles
    // horizontally; Vertical JumpN reaches 1 tile but clears N of height.
    if (/\(jumping\)/.test(info)) {
        const wp = ctx.wp || 0;
        let power;
        if (wp) power = Math.floor(ctx.pa * wp * (ctx.weaponType === 'Spear' ? 1.5 : 1));
        else {
            const paU = ctx.paUnarmed || ctx.pa;
            power = Math.floor(paU * Math.floor(paU * ctx.brave / 100));
        }
        const vert = info.match(/(\d+) vertical range/);
        const range = vert ? ctx.weaponRange || 1 : $354d63f64bda2a81$var$intIn(info, /(\d+) range/) || ctx.weaponRange || 1;
        const charge = Math.max(1, Math.ceil(50 / Math.max(1, ctx.speed)));
        return {
            name: name,
            kind: 'damage',
            power: Math.max(1, power),
            magical: false,
            target: 'enemy',
            range: range,
            aoe: 0,
            homing: false,
            linear: false,
            multihit: null,
            element: null,
            mp: 0,
            charge: charge,
            ignoreEvade: true,
            noAttackUp: true,
            jump: true,
            ...vert ? {
                vRange: parseInt(vert[1], 10)
            } : {}
        };
    }
    // Revive items (Phoenix Down): a "Cancel Death" clause with NO Hit% gate is a
    // 100% item revive — on a fallen ally it raises them (at a low ~Random(1,20)
    // HP); on a LIVING undead it deals 100% MaxHP, i.e. an instant kill, flagged
    // `undeadKill`. (Raise/Raise 2 carry a Faith Hit% and take the percent path below.)
    if (/Cancel Death/.test(info) && !/Hit:/.test(info)) {
        const aoeM = info.match(/(\d+)\s*AoE/);
        return {
            name: name,
            kind: 'revive',
            target: 'ally',
            range: $354d63f64bda2a81$var$intIn(info, /(\d+) range/) || ctx.weaponRange || 1,
            aoe: aoeM ? Math.min(parseInt(aoeM[1], 10), 4) : 0,
            homing: false,
            linear: false,
            multihit: null,
            element: null,
            mp: $354d63f64bda2a81$var$intIn(info, /(\d+) MP/),
            charge: $354d63f64bda2a81$var$intIn(info, /(\d+) CT/),
            power: 10,
            success: 100,
            undeadKill: true
        };
    }
    // Martial Arts (Monk innate / support) → ×3/2 on PA-stat Punch Art abilities
    // (damage, Chakra heal, PA-based status success). ctx.martialArts is set in
    // prepCombatant; the lib only applies it to flagged ability models, so the
    // basic attack (already ×1.5 via unarmedDamage) isn't double-counted.
    // The attacker's own XA modifiers ride in ctx (prepCombatant sets them): Strengthen for the
    // elements its gear or class strengthens, Attack Up / Magic Attack Up. They scale the stat term
    // before the formula multiplies it out, each step floored, as the game does.
    const attMods = {
        martialArts: !!ctx.martialArts,
        ...ctx.strengthen && ctx.strengthen.length ? {
            strengthen: new Set(ctx.strengthen)
        } : {},
        ...ctx.attackUp ? {
            attackUp: true
        } : {},
        ...ctx.magicAttackUp ? {
            magicAttackUp: true
        } : {}
    };
    const avt = (0, $7cZwo.abilityVsTarget)(info, ctx, attMods);
    // "N range" — an explicit "0 range" means the effect is CENTERED ON THE CASTER
    // (Draw Out, Monk punches, monster self-blasts), not aimed at a foe. Don't let the
    // weapon-range fallback clobber a real 0 (a past bug parsed "0 range" then, since 0
    // is falsy, overwrote it with the weapon range — so Asura became a ranged AoE the AI
    // aimed AT an enemy, and its 2-AoE blast spread across the field and hit the caster).
    const rangeM = info.match(/(\d+) range/);
    let range = rangeM ? parseInt(rangeM[1], 10) : /move range/.test(info) ? ctx.move || 4 : ctx.weaponRange || 1;
    // AoE shape matters: the number is a DIAMOND radius for plain AoE, but
    // "(linear)" is a thin line (rarely catches the whole cluster here) and
    // "(homing)" keeps its radius (255 = team-wide songs/dances).
    const aoeM = info.match(/(\d+)\s*AoE(?:\s*\(([^)]+)\))?/);
    let aoe = 0, homing = false, linear = false;
    if (aoeM) {
        const n = parseInt(aoeM[1], 10);
        const shape = (aoeM[2] || '').toLowerCase();
        homing = /homing/.test(shape); // songs/dances/team abilities — seek a whole team, NO friendly fire
        linear = /linear/.test(shape); // a straight ray from the caster (Earth Slash etc.) — aoe carries its LENGTH
        // A line's length is its AoE number ("8 range, 8 AoE (linear)"); the breath/ink lines read
        // "N range, 0 AoE (linear)" and reach out to their range: FFTBG's Minotaur Blow Fires hit units
        // 1-3 tiles away in a straight line. Read as length 0 they hit nothing and were never used.
        aoe = linear ? n || range : homing ? n : Math.min(n, 4);
    }
    // A 0-range ability is self-centered: the effect radiates from the caster's own tile
    // rather than an aimed point. (Songs/dances are 0-range too but already team-scoped
    // via `homing`; linear rays fire from the caster via `linear` — neither needs this.)
    const centerSelf = !!rangeM && range === 0 && !homing && !linear;
    // "(multihit)" — N strikes, each landing on a RANDOM panel in the AoE area
    // (Obsidian Blade & co.). N is fixed ("Hit: 3 times") or a range ("Random(1,10)").
    let multihit = null;
    if (aoeM && /multihit/.test((aoeM[2] || '').toLowerCase())) {
        const rnd = info.match(/Hit:\s*Random\((\d+),\s*(\d+)\)/i);
        const fixed = info.match(/Hit:\s*(\d+)\s*times/i);
        multihit = rnd ? {
            lo: +rnd[1],
            hi: +rnd[2]
        } : fixed ? {
            lo: +fixed[1],
            hi: +fixed[1]
        } : null;
    }
    const element = (info.match(/Element:\s*([A-Za-z]+)/) || [])[1] || avt && avt.element || null; // for defender absorb/half/weak/cancel (Throw carries it on the model)
    // Reflect bounces an ability by the game's own per-ability flag (abilityFlags.js), not by whether
    // its formula uses MA: monster skills such as Mutilate and Life Drain don't bounce, and status
    // spells such as Frog and Petrify do. Silence likewise blocks only what the game flags. Both are
    // left out when the ability isn't in the table.
    const refl = (0, $jEtWa.reflectable)(name), sil = (0, $jEtWa.silenceable)(name);
    // Who its area can catch, by the game's flags (+4: 0x01 never the caster, 0x40 never allies, 0x80
    // never enemies): a Stasis Sword never cuts its own Knight, Spirit of Life heals the Treant's allies
    // but not the Treant.
    const spare = {
        ...(0, $jEtWa.sparesCaster)(name) != null ? {
            sparesCaster: (0, $jEtWa.sparesCaster)(name)
        } : {},
        ...(0, $jEtWa.sparesAllies)(name) ? {
            sparesAllies: true
        } : {},
        ...(0, $jEtWa.sparesEnemies)(name) ? {
            sparesEnemies: true
        } : {}
    };
    // "Chance to add X[, Y] [(Random)]" on a damaging skill: a status rider (one of the list when Random).
    // "(Separate)" lists and "Chance to cancel" aren't modelled yet.
    const rm = info.match(/Chance to add ([^.;(]+?)\s*(\((Random)\))?\s*(?:[.;]|$)/);
    const rider = rm && !/\(Separate\)/.test(rm[0]) ? {
        statuses: rm[1].split(/,\s*/).map((x)=>x.trim()).filter(Boolean),
        mode: rm[3] ? 'one' : 'all'
    } : null;
    // "DamageCaster (...)": HP the caster pays each use (Energize/Wish/Bequeath Bacon MaxHP/5, Destroy PA*5/2,
    // Compress PA*5, Dispose PA). Self Destruct's DamageCaster (CurrentHP) isn't modelled.
    const dc = info.match(/DamageCaster \((MaxHP|PA)(?:\s*\*\s*(\d+))?(?:\s*\/\s*(\d+))?\)/);
    const selfCost = dc ? Math.round((dc[1] === 'MaxHP' ? ctx.maxHp || 0 : ctx.pa || 0) * (dc[2] ? +dc[2] : 1) / (dc[3] ? +dc[3] : 1)) : 0;
    // Where the AI stands for it: every tile for short evadable strikes, else the safest one (standSearch).
    const stand = (0, $jEtWa.standSearch)(name, ctx.weaponRange || 1);
    // How far up or down it can be aimed and its area reaches, from the game's ability record (verticalOf).
    const vert = (0, $jEtWa.verticalOf)(name);
    // How the AI's trial of a CHARGED cast counts who it hits (battleSim trialTargets): whether it follows
    // the unit it's aimed at, and whether units that act before it lands still count.
    const follows = (0, $jEtWa.followsTarget)(name), keepsMovers = (0, $jEtWa.trialKeepsMovers)(name), noSelf = (0, $jEtWa.cantTargetSelf)(name), shareRoll = (0, $jEtWa.aiShareRoll)(name), coinFlip = (0, $jEtWa.aiCoinFlip)(name);
    // Which evasion can dodge it ('physical', 'magic' or 'none'), from the game's own formula code (evadeKind).
    const evade = (0, $jEtWa.evadeKind)(name);
    // Which modifiers its damage takes (zodiac / defense / criticals / elements), from the same formula code.
    const modMask = (0, $jEtWa.damageMods)(name);
    const hit = $354d63f64bda2a81$var$hitParts(info, ctx);
    // "Hit: Human;" (the talk skills) and "Hit: Undead;" (Seal Evil) say what the ability can affect at all.
    const only = (info.match(/Hit:\s*(Human|Undead);/) || [])[1];
    const base = {
        name: name,
        range: range,
        aoe: aoe,
        homing: homing,
        linear: linear,
        multihit: multihit,
        element: element,
        centerSelf: centerSelf,
        mp: $354d63f64bda2a81$var$intIn(info, /(\d+) MP/),
        charge: $354d63f64bda2a81$var$intIn(info, /(\d+) CT/),
        ...stand ? {
            standSearch: stand
        } : {},
        ...vert ? {
            vReach: vert.reach,
            vSpread: vert.spread
        } : {},
        ...refl != null ? {
            reflectable: refl
        } : {},
        ...sil != null ? {
            silenceable: sil
        } : {},
        ...rider ? {
            rider: rider
        } : {},
        ...selfCost ? {
            selfCost: selfCost
        } : {},
        ...follows ? {
            follows: follows
        } : {},
        ...keepsMovers ? {
            keepsMovers: keepsMovers
        } : {},
        ...noSelf ? {
            noSelf: noSelf
        } : {},
        ...hit ? {
            hit: hit
        } : {},
        ...only ? {
            only: only
        } : {},
        ...shareRoll ? {
            shareRoll: shareRoll
        } : {},
        ...coinFlip ? {
            coinFlip: coinFlip
        } : {},
        ...evade ? {
            evade: evade
        } : {},
        ...modMask != null ? {
            modMask: modMask
        } : {},
        ...spare
    };
    // "Heal (MaxHP * N / D)" heals a fraction of the CASTER's max HP (FFTBG's Energize healed 152 on units of any
    // size, its 380-HP Byblos paying 76): a fixed amount, not the target's share. It parsed as a 0 heal.
    const hm = info.match(/Effect:\s*Heal \(MaxHP \* (\d+) \/ (\d+)\)/);
    if (hm) return {
        ...base,
        kind: 'heal',
        power: Math.round((ctx.maxHp || 0) * +hm[1] / +hm[2]),
        target: 'ally',
        faith: false
    };
    // ===== Effects abilityVsTarget can't model (no stat/hit formula) — handled before the
    // avt gate. =====
    // Full-restore item (Elixir): Heal + HealMP, both as a % of MAX.
    if (/Heal \(\d+\)%/.test(info) && /HealMP \(\d+\)%/.test(info)) return {
        ...base,
        kind: 'heal',
        pct: $354d63f64bda2a81$var$intIn(info, /Heal \((\d+)\)%/),
        mpPct: $354d63f64bda2a81$var$intIn(info, /HealMP \((\d+)\)%/),
        target: 'ally'
    };
    // Self-referential HP damage (abilityVsTarget returns null for these). "Damage (MaxHP -
    // CurrentHP)" [× factor] = the CASTER's missing HP — "the more hurt I am, the harder I hit"
    // (Goblin Punch ×5/4, Vengeance, Lifebreak, Ulmaguest): ~0 at full HP, a finisher when low.
    // The Target-prefixed form is the TARGET's missing HP (Climhazzard). Computed from live HP at
    // resolution. (Self Destruct's suicide-AoE is excluded — it needs a self-KO + AI death cost.)
    if (!/DamageCaster/.test(info)) {
        const tm = /Damage \(TargetMaxHP - TargetCurrentHP\)/.test(info);
        const tmp = /Damage \(TargetCurrentMP\)/.test(info); // Manaburn: HP damage equal to the target's MP
        const cm = info.match(/Damage \(\(?MaxHP - CurrentHP\)?(?:\s*\*\s*(\d+)\s*\/\s*(\d+))?\)/);
        if (tm || tmp || cm) return {
            ...base,
            kind: 'damage',
            magical: false,
            target: 'enemy',
            noAttackUp: true,
            ...tm ? {
                targetMissingHp: true
            } : tmp ? {
                targetCurrentMp: true
            } : {
                casterMissingHp: cm[1] ? +cm[1] / +cm[2] : 1
            },
            .../Hit:/.test(info) ? {
                success: $354d63f64bda2a81$var$hitPercent(info, ctx)
            } : {}
        };
    }
    // Multi-status add (Bad Breath each-25% / Nameless Song one-of-5 @50% / Goo all-on-one-roll)
    // — handled here, before the avt gate, since the songs' flat "(50)%" Hit doesn't parse as a
    // formula (avt null). A self-cast (0-range/0-AoE, e.g. Fury) applies the WHOLE set to the
    // user — Fury's Berserk is an intentional downside (the +/- trade), NOT something to filter;
    // otherwise the side is decided by whether the set is all-beneficial.
    const ms = $354d63f64bda2a81$var$multiStatus(info);
    if (ms) {
        const selfCast = centerSelf && aoe === 0;
        const beneficial = !selfCast && ms.statuses.every((s)=>$354d63f64bda2a81$var$GOODSTATUS.has(s));
        const success = /Hit:/.test(info) ? $354d63f64bda2a81$var$hitPercent(info, ctx) : ms.mode === 'each' ? 25 : 100; // Separate w/ no Hit% (Bad Breath) = 25% each; Random/All no Hit% = 100%
        return {
            ...base,
            kind: selfCast || beneficial ? 'buff' : 'status',
            status: ms.statuses[0],
            statuses: ms.statuses,
            statusMode: ms.mode,
            duration: 6,
            success: success,
            faith: !!(avt && avt.faith),
            target: selfCast ? 'self' : beneficial ? 'ally' : 'enemy'
        };
    }
    // CT manipulation (Time Mage Quick → CT 100; bard Last Song → ally Quick; dancer Last Dance
    // → foe CT 0). Before the avt gate: the recurring songs' flat "(33)%" Hit gives no formula.
    const ctM = info.match(/Set CT to (\d+)/);
    if (ctM) {
        const ct = +ctM[1];
        return {
            ...base,
            kind: 'ctset',
            ct: ct,
            success: $354d63f64bda2a81$var$hitPercent(info, ctx),
            faith: !!(avt && avt.faith),
            target: ct >= 100 ? 'ally' : 'enemy'
        };
    }
    // Status CLEANSE (Esuna/Stabilize Time strip afflictions off an ally; Dispel Magic strips
    // buffs off a foe; the Chemist cure-items Antidote/Soft/Eye Drop/Maiden's Kiss/Echo Grass/
    // Remedy/Holy Water + Odd Soundwave). Before the avt gate — the items carry no Hit% formula,
    // so they used to fall through to NULL. Side is decided by WHICH statuses it removes. ("Cancel
    // Death" is a raise, handled in the percent branch below, so it's excluded here.)
    const canc = info.match(/Cancel\s+([^.;]+)/);
    if (canc && !/Cancel Death\b/.test(info)) {
        const statuses = canc[1].split(/,|\band\b/).map((s)=>s.trim()).filter(Boolean);
        const dispel = statuses.filter((s)=>$354d63f64bda2a81$var$GOODSTATUS.has(s)).length > statuses.filter((s)=>$354d63f64bda2a81$var$AFFLICTIONS.has(s)).length; // mostly-buffs → it's a Dispel
        return {
            ...base,
            kind: 'cleanse',
            statuses: statuses,
            success: $354d63f64bda2a81$var$hitPercent(info, ctx),
            faith: !!(avt && avt.faith),
            dispel: dispel,
            target: dispel ? 'enemy' : 'ally'
        };
    }
    // Guaranteed SINGLE status/buff with no Hit% gate (Guard "Add Defending"). A self-only
    // (0-range/0-AoE) buff targets the caster; a self-centered AoE buff its surrounding allies.
    if (!/Hit:/.test(info) && /Effect:[^.]*\bAdd\b/.test(info) && !/Damage|Heal|Absorb|Set CT|Cancel/.test(info)) {
        const buf = info.match($354d63f64bda2a81$var$BUFF);
        if (buf) return {
            ...base,
            kind: 'buff',
            status: buf[1],
            duration: 6,
            success: 100,
            target: centerSelf && aoe === 0 ? 'self' : 'ally'
        };
        const dis = info.match($354d63f64bda2a81$var$DISABLE);
        if (dis) return {
            ...base,
            kind: 'status',
            status: dis[1],
            duration: 6,
            success: 100,
            target: 'enemy'
        };
    }
    // Steal / Rend — remove an equipment slot (modeled via the recompute foundation: blank
    // the slot + re-derive stats). Steal is Speed-gated, Rend is PA+WP-gated; both target a foe.
    const strip = info.match(/Remove target's (head equipment|body equipment|shield|weapon|accessory)/);
    if (strip) return {
        ...base,
        kind: 'strip',
        slot: $354d63f64bda2a81$var$STRIP_SLOT[strip[1]],
        success: $354d63f64bda2a81$var$hitPercent(info, ctx),
        target: 'enemy'
    };
    // Stat modification (±N PA/MA/Speed/Brave/Faith). All-positive = a buff (own team / self);
    // any negative = a debuff (a foe). Songs/dances carry it team-wide via `homing`. PA/MA are
    // re-baked at resolution (the foundation); Speed/Brave/Faith are live.
    const statMods = $354d63f64bda2a81$var$parseStatMods(info);
    if (statMods.length) {
        const buff = statMods.every((m)=>m.delta > 0);
        const success = $354d63f64bda2a81$var$hitPercent(info, ctx); // honor a flat "Hit: (50)%" (Slow Dance/Polka/Cheer Song — avt is null for the recurring songs, so it used to default to 100%)
        return {
            ...base,
            kind: 'statmod',
            mods: statMods,
            buff: buff,
            success: success,
            faith: !!(avt && avt.faith),
            target: centerSelf && aoe === 0 ? 'self' : buff ? 'ally' : 'enemy'
        };
    }
    if (!avt) return null;
    // Throw (Ninja): a thrown weapon flies the unit's move range and is dodged by evade by facing (FFTBG's AI
    // listed a Shuriken at 76% from one panel and 100% from another; the old note said Throw can't be evaded).
    const isThrow = /Damage \(Speed \* ThrownWP\)/.test(info);
    // Summon Magic ignores Magic Evade entirely (BMG / FF Wiki) — an offensive summon never
    // "misses"; its only reliability lever is Faith (low/Innocent ⇒ ~0 damage, applied by
    // damageMult). In the data these are the positional `(homing)` damage spells (range > 0:
    // Shiva/Ramuh/Sylph/Bahamut/Flare 2…), as opposed to the 0-range homing dances. The
    // `Hit:`-gated summons (Moogle/Carbunkle/Lich) resolve via their success roll, not here.
    const summonUnevadable = base.homing && base.range > 0;
    // Faith-magic damage (`Damage Faith(MA*Q)`: Fire/Bolt/Meteor…) scales with the TARGET's
    // faith at resolution; flat MA damage (`Damage (MA*N)`: Draw Out, Choco Meteor, monster
    // breaths) does NOT — so flag it so damageMult only faith-scales the real faith spells.
    // `formula` keeps what the game's damage needs per target (battleSim formulaDamage): the info string
    // and the caster's numbers. `power` is the same formula against a Faith-50 neutral target, for the
    // places that only want a rough size. Attack Up is already in it, so it's marked noAttackUp.
    if (avt.kind === 'damage') return {
        ...base,
        kind: 'damage',
        power: $354d63f64bda2a81$var$scalarPow(avt.final),
        magical: avt.magical,
        faith: /Damage\s*Faith\(/.test(info),
        target: 'enemy',
        formula: {
            info: info,
            ctx: $354d63f64bda2a81$var$formulaCtx(ctx)
        },
        noAttackUp: true,
        ...summonUnevadable && !isThrow ? {
            ignoreEvade: true
        } : {},
        ...isThrow ? {
            thrown: true,
            evade: 'physical'
        } : {}
    };
    // HP/MP drain with a stat formula (Night Sword AbsorbHP, Dark Sword AbsorbMP):
    // damage that feeds the caster. avt.magical marks the MA-stat (faith) form.
    if (avt.kind === 'other' && (avt.verb === 'AbsorbHP' || avt.verb === 'AbsorbMP')) {
        const amt = parseInt(String(avt.display).replace(/[^\d]/g, ''), 10) || 0;
        // faith-based drains (Life Drain/Spell Absorb: AbsorbHP Faith(MA*Q)) scale with target
        // faith too; PA-based ones (Night/Dark Sword, Mutilate) stay flat.
        return {
            ...base,
            kind: 'damage',
            power: amt,
            magical: !!avt.magical,
            faith: /Faith\(/.test(info),
            drain: avt.verb === 'AbsorbHP' ? 'hp' : 'mp',
            target: 'enemy'
        };
    }
    // MP burn (Bizen Boat, Witch Hunt) and MP restore (Ether, Rehabilitate) with a stat
    // formula — drains/restores MP, never touching HP.
    if (avt.kind === 'other' && avt.verb === 'DamageMP') return {
        ...base,
        kind: 'mpDamage',
        power: parseInt(String(avt.display).replace(/[^\d]/g, ''), 10) || 0,
        magical: !!avt.magical,
        target: 'enemy'
    };
    if (avt.kind === 'other' && avt.verb === 'HealMP') return {
        ...base,
        kind: 'mpHeal',
        power: parseInt(String(avt.display).replace(/[^\d]/g, ''), 10) || 0,
        target: 'ally'
    };
    // %-of-MaxHP damage (Demi/Lich/Hurricane) or % drain (Drain Touch/Mutilate). The parser
    // skips the "(NN)%" damage clause, so read the percent + Hit: success from the raw info.
    const pm = info.match(/Effect:[^.]*?(Damage|AbsorbHP|AbsorbMP)\s*\((\d+)\)%/);
    if (pm) {
        const success = avt.kind === 'percent' ? parseInt(avt.display, 10) || 50 : 100;
        // AbsorbMP (NN)% (Siphon) drains a % of the target's MAX MP and feeds the caster.
        // Route it through mpDamage/pctMaxMp (like Mute's MP burn) with a drain flag — NOT
        // pctMaxHp, which would drain NN% of the target's MAX-HP-worth of MP (i.e. its
        // whole bar) and be mis-valued by the AI as a big HP nuke.
        if (pm[1] === 'AbsorbMP') return {
            ...base,
            kind: 'mpDamage',
            pctMaxMp: +pm[2],
            drain: 'mp',
            success: success,
            faith: !!(avt && avt.faith),
            target: 'enemy'
        };
        return {
            ...base,
            kind: 'damage',
            pctMaxHp: +pm[2],
            magical: true,
            success: success,
            faith: !!(avt && avt.faith),
            drain: pm[1] === 'AbsorbHP' ? 'hp' : null,
            target: 'enemy'
        };
    }
    if (avt.kind === 'other' && avt.verb === 'Heal') {
        const amt = parseInt(String(avt.display).replace(/[^\d]/g, ''), 10) || 0;
        // faith: a Cure-type heal (Faith(MA*Q)) scales with the TARGET's faith at
        // resolution; a neutral heal (Chakra / items) does not. avt.magical marks the
        // faith form (its stat is MA).
        return {
            ...base,
            kind: 'heal',
            power: amt,
            target: 'ally',
            faith: !!avt.magical
        };
    }
    if (avt.kind === 'percent') {
        const success = parseInt(avt.display, 10) || 50;
        // Raise / Raise 2 / Revive: success is the Hit formula (Faith-scaled when it reads Faith(...)), the
        // raised unit comes back at "Heal (N)%" of ITS max HP, and on a living undead unit the revive kills
        // it, as in FFT (the game's Monk casts Raise 2 on an undead Draugr). `success` above is the heal %
        // here, not the hit chance, so it isn't used.
        if (/Cancel Death/.test(info)) return {
            ...base,
            kind: 'revive',
            pct: $354d63f64bda2a81$var$intIn(info, /Heal \((\d+)\)%/) || 50,
            target: 'ally',
            success: $354d63f64bda2a81$var$hitPercent(info, ctx),
            faith: /Hit:\s*Faith\(/.test(info),
            undeadKill: true
        };
        // MP burn as a % of the target's MAX MP (Mute).
        const mpPm = info.match(/Effect:[^.]*?DamageMP\s*\((\d+)\)%/);
        if (mpPm) return {
            ...base,
            kind: 'mpDamage',
            pctMaxMp: +mpPm[1],
            success: success,
            faith: !!avt.faith,
            target: 'enemy'
        };
        // (CT manipulation "Set CT to N" and status CLEANSE "Cancel X" are handled before the avt
        // gate above — Quick/Last Song/Dance and Esuna/Antidote/Soft/Remedy/etc.)
        // Death Sentence is a delayed-death countdown (3 turns), NOT the instant-KO "Death".
        if (/Add\b[^.]*Death Sentence/.test(info)) return {
            ...base,
            kind: 'status',
            status: 'Death Sentence',
            duration: 3,
            success: success,
            target: 'enemy',
            faith: !!avt.faith
        };
        // A 0-range, 0-AoE status ability can only reach the CASTER — it's a self-buff, not
        // an enemy debuff. Fury ("Add Berserk, Haste (All)") trips the DISABLE regex on
        // "Berserk" and was mis-cast on a FOE; it's self-cast only, so apply the beneficial
        // status (Haste) to the caster. (Self-centered AoEs — aoe > 0, e.g. Bad Breath —
        // still ring-debuff foes via the normal path below.)
        if (centerSelf && aoe === 0) {
            const self = info.match($354d63f64bda2a81$var$BUFF);
            if (self) return {
                ...base,
                kind: 'buff',
                status: self[1],
                duration: 6,
                success: 100,
                target: 'self'
            };
        }
        const dis = info.match($354d63f64bda2a81$var$DISABLE);
        if (dis) return {
            ...base,
            kind: 'status',
            status: dis[1],
            duration: 6,
            success: success,
            target: 'enemy',
            faith: !!avt.faith
        };
        // A buff spell (Haste, Protect, Shell, Regen, Reraise, Float, Reflect, Pray Faith) is aimed at any ally in
        // range, its caster included. (These used to be marked self-only, so our White and Time Mages only ever
        // buffed themselves, and their allies only when standing in the area: FFTBG's Time Mage listed Haste on
        // the ally beside her at 74%, ours only on herself.)
        const buf = info.match($354d63f64bda2a81$var$BUFF);
        if (buf) return {
            ...base,
            kind: 'buff',
            status: buf[1],
            duration: 6,
            success: 100,
            target: 'ally'
        };
    }
    return null;
}
// Compute every gear/stat-derived ("baked") field of a combatant from the unit + a
// mutable `state` of runtime changes: { paBonus, maBonus, removed:Set }. With an EMPTY
// state this reproduces the original prep exactly — so the no-change path (every normal
// battle) is byte-identical and needs no recalibration. PA/MA have no live runtime
// representation in the sim, so a stat-mod touching them (Phase B) and a steal/rend that
// drops gear (Phase C) re-run this to refresh power / evade / range / elements / HP.
// (Brave/Faith/Speed ARE live fields, adjusted directly, so they aren't re-baked here.)
function $354d63f64bda2a81$var$computeBaked(unit, data, state = {}) {
    const { charStats: charStats, itemschanged: itemschanged, notAbles: notAbles, abilitiesInfo: abilitiesInfo } = data;
    const paBonus = state.paBonus || 0, maBonus = state.maBonus || 0;
    const rm = state.removed;
    // A stolen/rent slot is modeled by blanking that equip field and re-deriving stats
    // from scratch (the '' item is zero-stat, so the slot's bonuses vanish, e.g. armor HP).
    const eq = rm && rm.size ? {
        ...unit,
        Mainhand: rm.has('weapon') ? '' : unit.Mainhand,
        Offhand: rm.has('shield') ? '' : unit.Offhand,
        Head: rm.has('head') ? '' : unit.Head,
        Armor: rm.has('armor') ? '' : unit.Armor,
        Accessory: rm.has('accessory') ? '' : unit.Accessory
    } : unit;
    const { classBase: classBase, equipped: equipped, stats: stats, paUnarmed: paUnarmed } = (0, $9rruk.unitCombatStats)(eq, charStats, itemschanged, notAbles);
    const isMA = unit.SupportSkill === 'Martial Arts' || unit.Class === 'Monk';
    const pa = stats.pa + paBonus, ma = stats.ma + maBonus, paU = paUnarmed + paBonus; // unit-level PA/MA mods
    // Mainhand basic-attack power for a given Charge +stat bonus (cBonus). weaponDamage
    // returns a STRING for elemental guns ("70% (X) - …") and random-range weapons
    // ("lo - hi"); coerce those to a usable number so the sim never gets NaN damage.
    // cBonus drives Charge+N (it shifts the primary stat and the gun's effective WP).
    const mainBasic = (cBonus = 0)=>{
        let b = eq.Mainhand ? (0, $eQqwh.weaponDamage)({
            item: equipped.Mainhand,
            pa: pa,
            ma: ma,
            speed: stats.speed,
            brave: unit.Brave,
            faith: unit.Faith,
            doublehand: unit.SupportSkill === 'Doublehand',
            targetFaith: 50,
            paBonus: cBonus
        }) : null;
        if (typeof b === 'string') {
            if (equipped.Mainhand.type === 'Gun') b = Math.floor(unit.Faith * 50 * ((equipped.Mainhand.wp || 0) + cBonus) * 16 / 10000);
            else {
                const ns = b.match(/\d+/g);
                b = ns ? ns.map(Number).reduce((a, x)=>a + x, 0) / ns.length : null;
            }
        }
        if (b == null || !Number.isFinite(b)) b = (0, $eQqwh.unarmedDamage)({
            paUnarmed: paU,
            brave: unit.Brave,
            isMartialArts: isMA,
            paBonus: cBonus
        });
        return b;
    };
    let basic = mainBasic(0);
    // Dual Wield (the support OR the Ninja innate) → a second basic strike. With a real
    // off-hand weapon it's that weapon's own power + element; FULLY UNARMED it's a second
    // fist ("attacking once with each (or both fists if unarmed)" — the skill's own rule).
    // Shields (wp 0) and a lone weapon + empty hand stay single.
    const dualWield = unit.SupportSkill === 'Dual Wield' || (classBase && classBase.innates || []).some((i)=>i && i.name === 'Dual Wield');
    let basic2 = 0, element2 = null;
    if (dualWield && equipped.Offhand && equipped.Offhand.wp > 0) {
        let b2 = (0, $eQqwh.weaponDamage)({
            item: equipped.Offhand,
            pa: pa,
            ma: ma,
            speed: stats.speed,
            brave: unit.Brave,
            faith: unit.Faith,
            doublehand: false,
            targetFaith: 50
        });
        if (typeof b2 === 'string') {
            if (equipped.Offhand.type === 'Gun') b2 = Math.floor(unit.Faith * 50 * (equipped.Offhand.wp || 0) * 16 / 10000);
            else {
                const ns = b2.match(/\d+/g);
                b2 = ns ? ns.map(Number).reduce((a, b)=>a + b, 0) / ns.length : 0;
            }
        }
        basic2 = Number.isFinite(b2) ? Math.max(1, Math.round(b2)) : 0;
        element2 = equipped.Offhand.element || null;
    } else if (dualWield && !eq.Mainhand) basic2 = Number.isFinite(basic) ? Math.max(1, Math.round(basic)) : 0; // both fists
    const tgt = {
        equipped: equipped,
        cEv: classBase && classBase.cEvPercent || 0,
        reaction: unit.ReactionSkill
    };
    const ev = (o)=>Math.round(100 - (0, $8Q6Uh.hitChance)(tgt, o));
    const evade = {
        front: ev({
            type: 'physical',
            direction: 'front'
        }),
        side: ev({
            type: 'physical',
            direction: 'side'
        }),
        back: ev({
            type: 'physical',
            direction: 'back'
        }),
        magic: ev({
            type: 'magical'
        })
    };
    // the same, source by source (battleSim's evadeHit applies Defending, Darkness and the like per attack)
    const evs = (o)=>(0, $8Q6Uh.evadeSources)(tgt, o);
    const evadeSrc = {
        front: evs({
            type: 'physical',
            direction: 'front'
        }),
        side: evs({
            type: 'physical',
            direction: 'side'
        }),
        back: evs({
            type: 'physical',
            direction: 'back'
        }),
        magic: evs({
            type: 'magical'
        })
    };
    const wpRange = $354d63f64bda2a81$var$weaponRange(equipped.Mainhand);
    // Elements the unit's gear (or a monster's class) strengthens: ×5/4 on the stat term of its spells.
    const strengthen = [
        ...(0, $79bVW.unitElementProfile)(equipped).strengthen,
        ...classBase && classBase.effect && (0, $79bVW.parseItemElements)('Effect: ' + classBase.effect + '.').strengthen || []
    ];
    const ctx = {
        pa: pa,
        ma: ma,
        speed: stats.speed,
        brave: unit.Brave,
        faith: unit.Faith,
        wp: equipped.Mainhand.wp,
        maxHp: stats.hp,
        targetFaith: 50,
        weaponRange: wpRange,
        move: stats.move,
        weaponType: equipped.Mainhand.type,
        paUnarmed: paU,
        martialArts: isMA,
        strengthen: strengthen,
        attackUp: unit.SupportSkill === 'Attack Up',
        magicAttackUp: unit.SupportSkill === 'Magic Attack Up'
    };
    // Weapon element + magical-gun flag, shared by the basic attack and Charge+N.
    const wpElement = equipped.Mainhand && equipped.Mainhand.element ? equipped.Mainhand.element : null;
    const magicalGun = equipped.Mainhand.type === 'Gun' && !!equipped.Mainhand.element;
    const actions = [];
    if (unit.Gender !== 'Monster') for (const n of [
        ...unit.ClassSkills || [],
        ...unit.ExtraSkills || []
    ]){
        // CHARGE+N (Archer): a basic attack aimed for N CT, with +N on the primary
        // stat (the "Basic Attack with +N" info clause has no Damage formula, so the
        // parser can't model it). Recompute the mainhand basic at paBonus N, charge
        // for the info's "N CT". It hits like a basic (weapon element, evadable).
        const chg = n.match(/^Charge\+(\d+)$/);
        if (chg) {
            const bonus = +chg[1];
            const info = abilitiesInfo[n] || '';
            actions.push({
                name: n,
                kind: 'damage',
                target: 'enemy',
                range: wpRange,
                aoe: 0,
                mp: 0,
                charge: Math.max(1, $354d63f64bda2a81$var$intIn(info, /(\d+) CT/) || bonus + 2),
                power: Math.max(1, Math.round(mainBasic(bonus))),
                magical: magicalGun,
                element: wpElement,
                projectile: wpRange >= 4,
                homing: false,
                linear: false,
                multihit: null
            });
            continue;
        }
        const a = $354d63f64bda2a81$export$9bd01db8ac5ab764(n, abilitiesInfo[n], ctx);
        if (a) actions.push(a);
    }
    else // Monsters carry EMPTY ClassSkills/ExtraSkills in the tournament data — their
    // kit is class-intrinsic, looked up from the monster→skills snapshot
    // (data.monsterSkills, = the live toolTips.MonsterSkills). A trailing '*' marks
    // the Beastmaster-locked rare skill (the universal Wild Beast innate), usually
    // unavailable, so we drop it. The basic Attack is kept as a fallback (Wild Beast
    // technically suppresses it, but retaining it covers the monster skills the
    // formula parser can't yet model — see monsterSkillCoverage). Unparsed skills
    // are skipped.
    for (const raw of data.monsterSkills && data.monsterSkills[unit.Class] || []){
        if (typeof raw !== 'string' || raw.includes('*')) continue;
        const a = $354d63f64bda2a81$export$9bd01db8ac5ab764(raw, abilitiesInfo[raw], ctx);
        if (a) actions.push(a);
    }
    // Attack Up / Magic Attack Up: +1/3 outgoing physical / magical damage (baked in).
    const atkUp = unit.SupportSkill === 'Attack Up', mAtkUp = unit.SupportSkill === 'Magic Attack Up';
    if (atkUp) {
        basic = Number.isFinite(basic) ? basic * 4 / 3 : basic;
        basic2 = Math.round(basic2 * 4 / 3);
    }
    if (atkUp || mAtkUp) {
        for (const a of actions)if (a.kind === 'damage' && !a.noAttackUp) {
            if (a.magical && mAtkUp) a.power = Math.round(a.power * 4 / 3);
            else if (!a.magical && atkUp) a.power = Math.round(a.power * 4 / 3);
        }
    }
    // Math Skill (Calculator): turn the unit's charged spells into INSTANT, FREE,
    // board-wide math-casts — one action per (spell × known attribute × known number)
    // that hits every unit whose CT/Height satisfies the number, friendly fire and all.
    // Only CHARGED magic is math-castable (FFT requires a CTR), and we apply it
    // single-target per matching unit (no AoE splash — the simple, dominant form). The
    // normal casts are kept too, so the AI falls back when no math lines up.
    if (unit.Class === 'Calculator') {
        const known = new Set([
            ...unit.ClassSkills || [],
            ...unit.ExtraSkills || []
        ]);
        const attrs = Object.keys($354d63f64bda2a81$var$CALC_ATTR).filter((n)=>known.has(n)).map((n)=>$354d63f64bda2a81$var$CALC_ATTR[n]);
        const nums = Object.keys($354d63f64bda2a81$var$CALC_NUM).filter((n)=>known.has(n)).map((n)=>$354d63f64bda2a81$var$CALC_NUM[n]);
        if (attrs.length && nums.length) {
            const mathable = actions.filter((a)=>(a.kind === 'damage' || a.kind === 'status' || a.kind === 'heal') && (a.charge || 0) > 0 && !a.linear && !a.centerSelf && !a.multihit && !a.homing && !a.mathCast);
            for (const spell of mathable)for (const attr of attrs)for (const key of nums)actions.push({
                ...spell,
                mathCast: {
                    attr: attr,
                    key: key
                },
                baseName: spell.name,
                mp: 0,
                charge: 0,
                range: 99,
                aoe: 0,
                linear: false,
                multihit: null,
                homing: false,
                centerSelf: false,
                name: `${spell.name} [${attr === 'z' ? 'Height' : 'CT'}${key === 'prime' ? ':P' : "\xd7" + key}]`
            });
        }
    }
    // Innate monster traits (humans have no innates in this data). Fly / Ignore
    // Height / Levitate ignore terrain height when pathing → effectively unlimited
    // Jump; Levitate also grants permanent Float (Earth-immune, lava-safe). Undead
    // (skeleton/ghost families) is a combat trait read by battleSim.
    const innates = classBase && classBase.innates || [];
    const heightFree = innates.some((i)=>i && $354d63f64bda2a81$var$HEIGHT_FREE_INNATES.has(i.name));
    const canFly = innates.some((i)=>i && $354d63f64bda2a81$var$FLY_INNATES.has(i.name)); // glides over void gaps
    const floats = innates.some((i)=>i && i.name === 'Levitate'); // permanent Float
    const innateNames = new Set(innates.filter(Boolean).map((i)=>i.name));
    const hasSupport = (name)=>unit.SupportSkill === name || innateNames.has(name);
    const innateReaction = (innates.find((i)=>i && i.type === 'react') || {}).name || '';
    // "Wild Beast: … prevents it from using the basic Attack action" (FFTBG's ability help).
    const wildBeast = innateNames.has('Wild Beast');
    // A monster's innate elements ride on its class entry ("Absorb Earth; Null Water; Weak Fire",
    // from classhelp.txt via fetchGameData). "Null" is the item wording's "Cancel".
    const elementProfile = (0, $79bVW.unitElementProfile)(equipped);
    if (classBase && classBase.effect) {
        const innate = (0, $79bVW.parseItemElements)('Effect: ' + classBase.effect.replace(/\bNull\b/g, 'Cancel') + '.');
        for (const k of Object.keys(elementProfile))for (const el of innate[k] || [])elementProfile[k].add(el);
    }
    const undead = $354d63f64bda2a81$var$UNDEAD_MONSTERS.has(unit.Class);
    // Statuses from gear and class: "Permanent X" (always on), "Initial X" (starts the battle with it),
    // "Immune X" (can't be given it). Items list the first two as permStatuses/initialStatuses; all
    // three are in the help text, which is also where classes keep theirs ("Permanent Undead",
    // "Immune Float, Poison"). Ribbon-type immunities, Angel Ring's Initial Reraise, Reflect Mail's
    // Permanent Reflect: none of it reached the sim before.
    const traits = {
        perm: new Set(),
        init: new Set(),
        immune: new Set()
    };
    const clauses = (text)=>{
        for (const m of String(text || '').matchAll(/\b(Permanent|Initial|Immune) ([^;.]+)/g)){
            const set = m[1] === 'Permanent' ? traits.perm : m[1] === 'Initial' ? traits.init : traits.immune;
            for (const st of m[2].split(',').map((x)=>x.trim()).filter(Boolean))set.add(st);
        }
    };
    for (const it of Object.values(equipped || {}))if (it && it.info) clauses(String(it.info).split('Effect:')[1]);
    if (classBase) clauses(classBase.effect);
    if (floats) traits.perm.add('Float'); // Levitate
    return {
        name: unit.Name,
        cls: unit.Class,
        gender: unit.Gender,
        sign: unit.Sign,
        raidBoss: !!unit.RaidBoss,
        hp: stats.hp,
        mp: stats.mp,
        speed: stats.speed,
        move: stats.move,
        jump: heightFree || canFly ? 99 : stats.jump,
        jumpStat: stats.jump,
        moveBits: (0, $56OCP.moveBits)([
            unit.MoveSkill,
            ...innateNames
        ]),
        range: wpRange,
        power: Math.max(1, Math.round(Number.isFinite(basic) ? basic : 10)),
        // The basic Attack as plain data for the exact per-target damage (battleSim formulaDamage builds
        // damage.js's weapon model from it): main hand, the Dual Wield off hand (null = a second fist), and
        // the attacker's numbers. `power`/`power2` above stay as rough sizes.
        weapon: {
            main: $354d63f64bda2a81$var$wItem(eq.Mainhand ? equipped.Mainhand : null),
            off: $354d63f64bda2a81$var$wItem(dualWield && equipped.Offhand && equipped.Offhand.wp > 0 ? equipped.Offhand : null),
            support: unit.SupportSkill || '',
            cls: unit.Class,
            ctx: {
                pa: pa,
                ma: ma,
                speed: stats.speed,
                brave: unit.Brave,
                faith: unit.Faith,
                paUnarmed: paU,
                ...unit.SupportSkill === 'Attack Up' ? {
                    attackUp: true
                } : {},
                ...strengthen.length ? {
                    strengthen: strengthen
                } : {}
            }
        },
        ...canFly ? {
            canFly: true
        } : {},
        projectile: wpRange >= 4,
        // Supports and reactions count whether equipped or innate to the class: nearly every monster
        // has an innate Counter (it countered 11 times in 14 battles in FFTBG's build), and some have
        // Defense Up (Dryad/Treant/Taiju), Magic Defense Up (Floating Eye/Ahriman/Plague) or Short
        // Charge (Archaic/Ultima Demon, Apanda). Their reaction slot is empty in the tournament data.
        brave: unit.Brave,
        faith: unit.Faith,
        reaction: $354d63f64bda2a81$var$mapReaction(unit.ReactionSkill || innateReaction),
        concentrate: hasSupport('Concentrate'),
        defenseUp: hasSupport('Defense Up'),
        magicDefenseUp: hasSupport('Magic Defense Up'),
        shortCharge: hasSupport('Short Charge'),
        ...hasSupport('Sicken') ? {
            sicken: true,
            gunBasic: equipped.Mainhand.type === 'Gun'
        } : {},
        element: wpElement,
        power2: basic2,
        element2: element2,
        elements: elementProfile,
        ...wildBeast ? {
            noBasic: true
        } : {},
        ...undead ? {
            undead: true
        } : {},
        ...traits.perm.size ? {
            permStatus: [
                ...traits.perm
            ]
        } : {},
        ...traits.init.size ? {
            initStatus: [
                ...traits.init
            ]
        } : {},
        ...traits.immune.size ? {
            immune: [
                ...traits.immune
            ]
        } : {},
        evade: evade,
        evadeSrc: evadeSrc,
        ...unit.ReactionSkill === 'Abandon' ? {
            abandon: true
        } : {},
        actions: actions
    };
}
function $354d63f64bda2a81$export$70fe0fbb29cf246(unit, data) {
    const spec = $354d63f64bda2a81$var$computeBaked(unit, data, {});
    spec.paBonus = 0;
    spec.maBonus = 0;
    spec.removed = new Set();
    spec._rebake = (state)=>$354d63f64bda2a81$var$computeBaked(unit, data, state);
    return spec;
}
// The ability-formula context for a unit (PA/MA/etc.) — used to recompute a
// Mime's mirrored abilities with the MIME's own stats.
function $354d63f64bda2a81$var$unitCtx(unit, data) {
    const { equipped: equipped, stats: stats, paUnarmed: paUnarmed } = (0, $9rruk.unitCombatStats)(unit, data.charStats, data.itemschanged, data.notAbles);
    const wpRange = $354d63f64bda2a81$var$weaponRange(equipped.Mainhand);
    return {
        pa: stats.pa,
        ma: stats.ma,
        speed: stats.speed,
        brave: unit.Brave,
        faith: unit.Faith,
        wp: equipped.Mainhand.wp,
        maxHp: stats.hp,
        targetFaith: 50,
        weaponRange: wpRange,
        move: stats.move,
        weaponType: equipped.Mainhand.type,
        paUnarmed: paUnarmed
    };
}
function $354d63f64bda2a81$export$7341a8ca199b0636(roster, data) {
    const specs = roster.map((u)=>$354d63f64bda2a81$export$70fe0fbb29cf246(u, data));
    // A Mime has NO actions of its own — its turn is just move + basic attack. What
    // it carries is a `mimicTable`: every teammate ability recomputed with the
    // MIME's own stats, keyed by name. The engine fires the matching entry whenever a
    // non-mime teammate acts (the mime copies it from its own tile at the same
    // relative offset — it can whiff or friendly-fire, like the real Mimic reaction).
    const donors = [];
    const seen = new Set();
    for (const u of roster){
        if (u.Class === 'Mime' || u.Gender === 'Monster') continue;
        for (const n of [
            ...u.ClassSkills || [],
            ...u.ExtraSkills || []
        ])if (!seen.has(n) && data.abilitiesInfo[n]) {
            seen.add(n);
            donors.push(n);
        }
    }
    roster.forEach((u, i)=>{
        if (u.Class !== 'Mime') return;
        const ctx = $354d63f64bda2a81$var$unitCtx(u, data);
        const table = {};
        for (const n of donors){
            const a = $354d63f64bda2a81$export$9bd01db8ac5ab764(n, data.abilitiesInfo[n], ctx);
            if (a) table[n] = a;
        }
        specs[i] = {
            ...specs[i],
            actions: [],
            mimic: true,
            mimicTable: table
        };
    });
    return specs;
}
function $354d63f64bda2a81$export$e57fef307bd96ed1(data) {
    const ms = data.monsterSkills || {};
    const ctx = {
        pa: 14,
        ma: 20,
        speed: 8,
        brave: 70,
        faith: 60,
        wp: 0,
        maxHp: 400,
        targetFaith: 50,
        weaponRange: 1,
        move: 4,
        paUnarmed: 14
    };
    let total = 0, parsed = 0;
    const missed = [];
    for (const cls of Object.keys(ms))for (const raw of ms[cls] || []){
        if (typeof raw !== 'string' || raw.includes('*')) continue;
        total++;
        if ($354d63f64bda2a81$export$9bd01db8ac5ab764(raw, data.abilitiesInfo[raw], ctx)) parsed++;
        else missed.push(raw);
    }
    return {
        total: total,
        parsed: parsed,
        missed: [
            ...new Set(missed)
        ].sort()
    };
}

});
parcelRegister("jEtWa", function(module, exports) {

$parcel$export(module.exports, "ELEMENTAL_BY_SURFACE", () => $e4e8f9aa5d326948$export$fa1ca01d50a8fc95);
$parcel$export(module.exports, "AI_HEALERS", () => $e4e8f9aa5d326948$export$11593d11e79c3dca);
$parcel$export(module.exports, "reflectable", () => $e4e8f9aa5d326948$export$c6429a28e685ee70);
$parcel$export(module.exports, "silenceable", () => $e4e8f9aa5d326948$export$ee2b3e70d3c20100);
$parcel$export(module.exports, "aiShareRoll", () => $e4e8f9aa5d326948$export$68565f449b6d0b9f);
$parcel$export(module.exports, "aiCoinFlip", () => $e4e8f9aa5d326948$export$378f91c0e59ec6bd);
$parcel$export(module.exports, "evadeKind", () => $e4e8f9aa5d326948$export$f26343bab2d7bae8);
$parcel$export(module.exports, "damageMods", () => $e4e8f9aa5d326948$export$10ac2c641397d915);
$parcel$export(module.exports, "cantTargetSelf", () => $e4e8f9aa5d326948$export$3ed0198ba2b7f3ea);
$parcel$export(module.exports, "sparesCaster", () => $e4e8f9aa5d326948$export$b6bb43b10d012642);
$parcel$export(module.exports, "sparesAllies", () => $e4e8f9aa5d326948$export$eb49f89545284d65);
$parcel$export(module.exports, "sparesEnemies", () => $e4e8f9aa5d326948$export$742cc11a3efc35c1);
$parcel$export(module.exports, "verticalOf", () => $e4e8f9aa5d326948$export$abe4a8928f5d12e1);
$parcel$export(module.exports, "trialKeepsMovers", () => $e4e8f9aa5d326948$export$b76a36c9e595a78d);
$parcel$export(module.exports, "followsTarget", () => $e4e8f9aa5d326948$export$30a0fa6169f8ff18);
$parcel$export(module.exports, "standSearch", () => $e4e8f9aa5d326948$export$c604d7db624ffdef);
// GENERATED by tools/emu-battle/buildAbilityFlags.mjs from FFTBG's ability data — do not edit.
// Per action ability (the site's names): the flag bytes at +3..+6 of its record.
//   [0]: 0x08 vertical tolerance, 0x04 weapon strike, 0x02 auto/self-centred, 0x01 can't target self
//   [1]: 0x80 can't hit enemies, 0x40 can't hit allies, 0x10 follows its target, 0x08 random fire,
//        0x04 linear, 0x01 can't hit the caster
//   [2]: 0x80 reflectable, 0x40 Math Skill can cast it, 0x20 Silence blocks it, 0x10 can't be mimicked
//   [3]: 0x80 Counter Flood, 0x40 Counter Magic, 0x20 direct, 0x10 Blade Grasp can catch it, 0x02 evadable
//   [4]: byte 2 of the AI's own table (SCUS 0x4F3F4): 0xC0 / 0x3C steer the stand-panel search
//   [5], [6], [7]: range, area and vertical (byte +3 & 0x20 means the weapon's range and no area)
//   [8], [9]: bytes 0 and 1 of the AI's table: [8] 0x01 helps its targets; [9] 0x80 the whole side
//        (songs, dances), 0x10 aimed at a unit, which the AI's trial then follows
//   [10]: the evasion its formula rolls, 1 physical, 2 magic, 0 none (see evadeKind)
//   [11]: the modifiers its formula applies, a mask (see damageMods)
const $e4e8f9aa5d326948$export$ed0ccf5098dab683 = {
    "Accumulate": [
        0x02,
        0x10,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x09,
        0x80,
        0x00,
        0x00
    ],
    "All-Ultima": [
        0x00,
        0x01,
        0x20,
        0x00,
        0x02,
        0x05,
        0x03,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Angel Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x41,
        0x81,
        0x00,
        0x00
    ],
    "Aqua Soul": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x41,
        0x03,
        0x00,
        0x00,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Arm Aim": [
        0x20,
        0x10,
        0x00,
        0x10,
        0x01,
        0x00,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x93
    ],
    "Armor Rend": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x86,
        0x02,
        0x01,
        0x93
    ],
    "Asura": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x03,
        0xa2,
        0x00,
        0x00,
        0x129
    ],
    "Attack": [
        0x09,
        0x01,
        0x18,
        0x82,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x00,
        0x01,
        0x9f
    ],
    "Bad Breath": [
        0x03,
        0x11,
        0x30,
        0x01,
        0x00,
        0x00,
        0x02,
        0x02,
        0x12,
        0x01,
        0x00,
        0x00
    ],
    "Bahamut": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x03,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Battle Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x09,
        0x81,
        0x00,
        0x00
    ],
    "Beak": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x00,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Beam": [
        0x09,
        0x11,
        0x10,
        0x02,
        0x02,
        0x04,
        0x00,
        0x02,
        0x0a,
        0x02,
        0x02,
        0x121
    ],
    "Bequeath Bacon": [
        0x09,
        0x10,
        0x10,
        0x00,
        0x00,
        0x02,
        0x00,
        0x03,
        0x81,
        0x00,
        0x00,
        0x00
    ],
    "Bio Immortuos": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x02,
        0x05,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bio Insanis": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x02,
        0x05,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bio Lapis": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x03,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Bio Mortem": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x02,
        0x05,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bio Oleum": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x04,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bio Ranae": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x03,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Bio Silentium": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x04,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Bio Tardus": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x05,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Bio Tenebris": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x04,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bio Venenum": [
        0x00,
        0x01,
        0xa0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x04,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bite": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Bizen Boat": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x02,
        0x42,
        0x00,
        0x00,
        0x121
    ],
    "Black Ink": [
        0x19,
        0x15,
        0x11,
        0x22,
        0x51,
        0x02,
        0x02,
        0x04,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Blade Beam": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x03,
        0x00,
        0x00,
        0x82,
        0x00,
        0x00,
        0x00
    ],
    "Blastar Punch": [
        0x04,
        0x11,
        0x00,
        0x00,
        0x01,
        0x03,
        0x01,
        0x02,
        0x86,
        0x00,
        0x01,
        0x9f
    ],
    "Blaster": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x42,
        0x03,
        0x00,
        0x00,
        0x12,
        0x02,
        0x02,
        0x121
    ],
    "Blind": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Blizzard": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Blood Suck": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x00,
        0x01,
        0x00,
        0x00,
        0x12,
        0x02,
        0x00,
        0x00
    ],
    "Blow Fire": [
        0x19,
        0x15,
        0x31,
        0x20,
        0x52,
        0x03,
        0x03,
        0x02,
        0x82,
        0x01,
        0x02,
        0x129
    ],
    "Bolt": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bolt 2": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x02,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bolt 3": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x03,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Bolt 4": [
        0x00,
        0x01,
        0x20,
        0x02,
        0x02,
        0x05,
        0x02,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Braver": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x01,
        0x02,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Calm Spirit": [
        0x03,
        0x11,
        0x10,
        0x01,
        0x00,
        0x00,
        0x02,
        0x01,
        0x11,
        0x00,
        0x00,
        0x21
    ],
    "Carbunkle": [
        0x00,
        0x80,
        0x20,
        0x00,
        0x00,
        0x04,
        0x02,
        0x02,
        0x21,
        0x15,
        0x00,
        0x61
    ],
    "Cat Kick": [
        0x09,
        0x11,
        0x10,
        0x02,
        0x01,
        0x01,
        0x00,
        0x04,
        0x82,
        0x02,
        0x01,
        0x9b
    ],
    "Chakra": [
        0x02,
        0x10,
        0x00,
        0x01,
        0x00,
        0x00,
        0x01,
        0x00,
        0xc1,
        0x00,
        0x00,
        0x11
    ],
    "Cheer Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x09,
        0x81,
        0x00,
        0x00
    ],
    "Cheer Up": [
        0x09,
        0x10,
        0x20,
        0x00,
        0x00,
        0x03,
        0x00,
        0x04,
        0x11,
        0x01,
        0x00,
        0x21
    ],
    "Cherry Blossom": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x03,
        0x02,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Chicken": [
        0x00,
        0x01,
        0x20,
        0x02,
        0x02,
        0x05,
        0x01,
        0x01,
        0x0a,
        0x05,
        0x02,
        0x161
    ],
    "Chirijiraden": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x02,
        0x82,
        0x00,
        0x00,
        0x129
    ],
    "Choco Attack": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x02,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Choco Ball": [
        0x01,
        0x11,
        0x10,
        0x02,
        0x01,
        0x04,
        0x00,
        0x00,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Choco Cure": [
        0x02,
        0x10,
        0x10,
        0x00,
        0x00,
        0x00,
        0x01,
        0x02,
        0x81,
        0x20,
        0x00,
        0x21
    ],
    "Choco Esuna": [
        0x02,
        0x10,
        0x10,
        0x00,
        0x00,
        0x00,
        0x01,
        0x02,
        0x21,
        0x00,
        0x00,
        0x21
    ],
    "Choco Meteor": [
        0x00,
        0x10,
        0x10,
        0x00,
        0x02,
        0x05,
        0x00,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Climhazzard": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x04,
        0x00,
        0x00,
        0x82,
        0x00,
        0x00,
        0x00
    ],
    "Compress": [
        0x09,
        0x11,
        0x00,
        0x30,
        0x40,
        0x02,
        0x00,
        0x01,
        0x82,
        0x00,
        0x00,
        0x01
    ],
    "Confuse": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Cross-Slash": [
        0x15,
        0x13,
        0x00,
        0x01,
        0x04,
        0x03,
        0x03,
        0x01,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Cure": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x01,
        0x01,
        0x81,
        0x75,
        0x00,
        0x61
    ],
    "Cure 2": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x01,
        0x01,
        0x81,
        0x75,
        0x00,
        0x61
    ],
    "Cure 3": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x01,
        0x02,
        0x81,
        0x75,
        0x00,
        0x61
    ],
    "Cure 4": [
        0x00,
        0x00,
        0x20,
        0x00,
        0x00,
        0x05,
        0x01,
        0x03,
        0x81,
        0x35,
        0x00,
        0x61
    ],
    "Cyclops": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Dark Holy": [
        0x00,
        0x00,
        0x20,
        0x40,
        0x02,
        0x05,
        0x00,
        0x00,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Dark Sword": [
        0x0d,
        0x11,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x03,
        0x42,
        0x12,
        0x01,
        0x97
    ],
    "Dark Whisper": [
        0x01,
        0x19,
        0x11,
        0x00,
        0x02,
        0x04,
        0x01,
        0x03,
        0x82,
        0x08,
        0x02,
        0x129
    ],
    "Dash": [
        0x09,
        0x11,
        0x00,
        0x00,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x02,
        0x01,
        0x93
    ],
    "Death": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x00,
        0x00,
        0x12,
        0x75,
        0x02,
        0x161
    ],
    "Death Sentence": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x12,
        0x01,
        0x00,
        0x01
    ],
    "Demi": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x02,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Demi 2": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x04,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Demi 3": [
        0x00,
        0x01,
        0x20,
        0x00,
        0x02,
        0x05,
        0x01,
        0x03,
        0x82,
        0x1d,
        0x02,
        0x161
    ],
    "Despair": [
        0x00,
        0x00,
        0x20,
        0x42,
        0x02,
        0x06,
        0x00,
        0x00,
        0x22,
        0x15,
        0x02,
        0x161
    ],
    "Despair 2": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x02,
        0x22,
        0x15,
        0x02,
        0x161
    ],
    "Destroy": [
        0x09,
        0x11,
        0x20,
        0x80,
        0x00,
        0x04,
        0x00,
        0x03,
        0x82,
        0x01,
        0x00,
        0x01
    ],
    "Diamond Blade": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Disillusion": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x0a,
        0x80,
        0x00,
        0x00
    ],
    "Dispel Magic": [
        0x00,
        0x00,
        0x60,
        0x40,
        0x02,
        0x05,
        0x01,
        0x01,
        0x22,
        0x15,
        0x02,
        0x161
    ],
    "Dispose": [
        0x01,
        0x11,
        0x90,
        0x00,
        0x00,
        0x08,
        0x00,
        0x00,
        0x82,
        0x40,
        0x00,
        0x01
    ],
    "Doom": [
        0x01,
        0x11,
        0x30,
        0x00,
        0x02,
        0x03,
        0x00,
        0x00,
        0x12,
        0x01,
        0x02,
        0x121
    ],
    "Doubt Faith": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x02,
        0x05,
        0x00,
        0x00,
        0x10,
        0x55,
        0x02,
        0x161
    ],
    "Dragon Pit": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Drain Touch": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x02,
        0x82,
        0x22,
        0x01,
        0x93
    ],
    "Earth Slash": [
        0x11,
        0x15,
        0x00,
        0x82,
        0x21,
        0x08,
        0x08,
        0x02,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Empower": [
        0x01,
        0x01,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x09,
        0x11,
        0x00,
        0x61
    ],
    "Energize": [
        0x01,
        0x11,
        0x80,
        0x00,
        0x00,
        0x04,
        0x00,
        0x00,
        0x81,
        0x40,
        0x00,
        0x00
    ],
    "Enrage": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x00,
        0x00,
        0x10,
        0x55,
        0x02,
        0x161
    ],
    "Esuna": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x01,
        0x02,
        0x21,
        0x55,
        0x00,
        0x61
    ],
    "Explosion Sword": [
        0x15,
        0x15,
        0x00,
        0x03,
        0x21,
        0x04,
        0x04,
        0x04,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Eye Gouge": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x02,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Fairy": [
        0x00,
        0x80,
        0x20,
        0x00,
        0x00,
        0x04,
        0x02,
        0x02,
        0x81,
        0x35,
        0x00,
        0x61
    ],
    "Feather Bomb": [
        0x01,
        0x11,
        0x10,
        0x00,
        0x01,
        0x05,
        0x00,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Finish Touch": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x02,
        0x01,
        0x00,
        0x12,
        0x00,
        0x00,
        0x00
    ],
    "Fire": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Fire 2": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x02,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Fire 3": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x03,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Fire 4": [
        0x00,
        0x01,
        0x20,
        0x02,
        0x02,
        0x05,
        0x02,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Fire Breath": [
        0x19,
        0x15,
        0x11,
        0x22,
        0x52,
        0x02,
        0x02,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Flame Attack": [
        0x01,
        0x11,
        0x10,
        0x02,
        0x02,
        0x03,
        0x00,
        0x00,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Flare": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x06,
        0x00,
        0x00,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Flare 2": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x01,
        0x05,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Float": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x01,
        0x01,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Foxbird": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x06,
        0x00,
        0x00,
        0x1a,
        0x55,
        0x02,
        0x161
    ],
    "Frog": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x04,
        0x00,
        0x00,
        0x30,
        0x55,
        0x02,
        0x161
    ],
    "Frost Soul": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x41,
        0x03,
        0x00,
        0x00,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Frozen Cry": [
        0x09,
        0x11,
        0x30,
        0x12,
        0x01,
        0x01,
        0x00,
        0x00,
        0x82,
        0x03,
        0x01,
        0x9f
    ],
    "Fury": [
        0x02,
        0x10,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x81,
        0x20,
        0x00,
        0x11
    ],
    "Galaxy Stop": [
        0x02,
        0x50,
        0x20,
        0x01,
        0x02,
        0x00,
        0xff,
        0xff,
        0x12,
        0x81,
        0x00,
        0x121
    ],
    "Gather Power": [
        0x02,
        0x10,
        0x30,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x09,
        0x81,
        0x00,
        0x00
    ],
    "Giga Flare": [
        0x00,
        0x10,
        0x10,
        0x00,
        0x02,
        0x04,
        0x02,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Gil Taking": [
        0x09,
        0x11,
        0x00,
        0x12,
        0x01,
        0x02,
        0x00,
        0x02,
        0x12,
        0x02,
        0x00,
        0x93
    ],
    "Goblin Punch": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x93
    ],
    "Golem": [
        0x02,
        0x10,
        0x20,
        0x01,
        0x00,
        0x00,
        0x00,
        0x00,
        0x08,
        0x09,
        0x00,
        0x21
    ],
    "Goo": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x02,
        0x00,
        0x02,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Grand Cross": [
        0x00,
        0x41,
        0x00,
        0x01,
        0x00,
        0x04,
        0x02,
        0x04,
        0x12,
        0x10,
        0x00,
        0x00
    ],
    "Grease Touch": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x02,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Gusty Wind": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Hallowed Ground": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Haste": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x01,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Haste 2": [
        0x00,
        0x00,
        0x20,
        0x00,
        0x00,
        0x04,
        0x01,
        0x03,
        0x11,
        0x15,
        0x00,
        0x61
    ],
    "Head Rend": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x86,
        0x02,
        0x01,
        0x93
    ],
    "Heal": [
        0x08,
        0x10,
        0x00,
        0x00,
        0x00,
        0x01,
        0x00,
        0x02,
        0x21,
        0x00,
        0x00,
        0x00
    ],
    "Heaven's Cloud": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x02,
        0x82,
        0x00,
        0x00,
        0x129
    ],
    "Hell Ivy": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Hellcry Crush": [
        0x04,
        0x11,
        0x00,
        0x00,
        0x01,
        0x03,
        0x01,
        0x02,
        0x86,
        0x00,
        0x01,
        0x9f
    ],
    "Holy": [
        0x00,
        0x00,
        0xe0,
        0x40,
        0x02,
        0x05,
        0x00,
        0x00,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Holy Breath": [
        0x19,
        0x15,
        0x11,
        0x22,
        0x52,
        0x02,
        0x02,
        0x03,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Hurricane": [
        0x00,
        0x10,
        0x10,
        0x00,
        0x02,
        0x04,
        0x02,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Hydra Pit": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Ice": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Ice 2": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x02,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Ice 3": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x03,
        0x82,
        0x55,
        0x02,
        0x169
    ],
    "Ice 4": [
        0x00,
        0x01,
        0x20,
        0x02,
        0x02,
        0x05,
        0x02,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Ice Breath": [
        0x19,
        0x15,
        0x11,
        0x22,
        0x52,
        0x02,
        0x02,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Icewolf Bite": [
        0x04,
        0x11,
        0x00,
        0x00,
        0x01,
        0x03,
        0x01,
        0x03,
        0x86,
        0x00,
        0x01,
        0x9f
    ],
    "Ifrit": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Immobilize": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Insult": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x12,
        0x01,
        0x00,
        0x01
    ],
    "Invitation": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x12,
        0x01,
        0x00,
        0x01
    ],
    "Justice Sword": [
        0x0c,
        0x11,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x02,
        0x82,
        0x12,
        0x01,
        0x9f
    ],
    "Kikuichimonji": [
        0x11,
        0x15,
        0x00,
        0x80,
        0x22,
        0x06,
        0x06,
        0x03,
        0x82,
        0x00,
        0x00,
        0x129
    ],
    "Kiyomori": [
        0x02,
        0x00,
        0x00,
        0x01,
        0x00,
        0x00,
        0x02,
        0x03,
        0x11,
        0x00,
        0x00,
        0x00
    ],
    "Knife Hand": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Koutetsu": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x01,
        0x82,
        0x00,
        0x00,
        0x129
    ],
    "Last Dance": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x0a,
        0x80,
        0x00,
        0x00
    ],
    "Last Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x09,
        0x81,
        0x00,
        0x00
    ],
    "Lava Ball": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Leaf Dance": [
        0x03,
        0x11,
        0x10,
        0x81,
        0x02,
        0x00,
        0x01,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Leg Aim": [
        0x20,
        0x10,
        0x00,
        0x10,
        0x01,
        0x00,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x93
    ],
    "Level Blast": [
        0x01,
        0x11,
        0x10,
        0x00,
        0x02,
        0x03,
        0x00,
        0x00,
        0x09,
        0x00,
        0x00,
        0x00
    ],
    "Leviathan": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x03,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Lich": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Lick": [
        0x09,
        0x11,
        0x10,
        0x00,
        0x00,
        0x01,
        0x00,
        0x03,
        0x11,
        0x00,
        0x00,
        0x00
    ],
    "Life Drain": [
        0x01,
        0x01,
        0x20,
        0x40,
        0x02,
        0x05,
        0x00,
        0x00,
        0x82,
        0x35,
        0x02,
        0x161
    ],
    "Life Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x81,
        0x81,
        0x00,
        0x00
    ],
    "Lifebreak": [
        0x00,
        0x00,
        0x00,
        0x01,
        0x00,
        0x04,
        0x00,
        0x00,
        0x82,
        0x10,
        0x00,
        0x00
    ],
    "Local Quake": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Look of Devil": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x41,
        0x03,
        0x00,
        0x00,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Look of Fright": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x42,
        0x03,
        0x00,
        0x00,
        0x0a,
        0x02,
        0x02,
        0x121
    ],
    "Magic Barrier": [
        0x01,
        0x01,
        0x20,
        0x00,
        0x00,
        0x03,
        0x00,
        0x00,
        0x11,
        0x11,
        0x00,
        0x61
    ],
    "Magic Ruin": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x42,
        0x02,
        0x01,
        0x93
    ],
    "Magic Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x09,
        0x81,
        0x00,
        0x00
    ],
    "Magic Spirit": [
        0x03,
        0x11,
        0x10,
        0x01,
        0x00,
        0x00,
        0x02,
        0x01,
        0x41,
        0x00,
        0x00,
        0x21
    ],
    "Manaburn": [
        0x09,
        0x11,
        0x00,
        0x00,
        0x00,
        0x05,
        0x00,
        0x03,
        0x82,
        0x00,
        0x00,
        0x00
    ],
    "Masamune": [
        0x02,
        0x00,
        0x00,
        0x01,
        0x00,
        0x00,
        0x02,
        0x01,
        0x11,
        0x00,
        0x00,
        0x00
    ],
    "Melt": [
        0x00,
        0x00,
        0x20,
        0x40,
        0x02,
        0x04,
        0x03,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Meteor": [
        0x00,
        0x00,
        0x20,
        0x40,
        0x02,
        0x05,
        0x03,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Meteorain": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x03,
        0x02,
        0x01,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Midgar Swarm": [
        0x00,
        0x01,
        0x20,
        0x41,
        0x02,
        0x04,
        0x02,
        0x03,
        0x82,
        0x11,
        0x02,
        0x129
    ],
    "Mimic Daravon": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x03,
        0x01,
        0x04,
        0x12,
        0x01,
        0x00,
        0x01
    ],
    "Mimic Titan": [
        0x03,
        0x11,
        0x10,
        0x01,
        0x01,
        0x00,
        0x02,
        0x01,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Mind Blast": [
        0x00,
        0x11,
        0x10,
        0x00,
        0x02,
        0x03,
        0x01,
        0x01,
        0x12,
        0x00,
        0x02,
        0x121
    ],
    "Mind Break": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x0a,
        0x02,
        0x01,
        0x93
    ],
    "Moldball Virus": [
        0x19,
        0x15,
        0x10,
        0x22,
        0x50,
        0x03,
        0x03,
        0x03,
        0x0a,
        0x02,
        0x00,
        0x21
    ],
    "Moogle": [
        0x00,
        0x80,
        0x20,
        0x00,
        0x00,
        0x04,
        0x02,
        0x02,
        0x21,
        0x15,
        0x00,
        0x61
    ],
    "Muramasa": [
        0x02,
        0x01,
        0x00,
        0x81,
        0x02,
        0x00,
        0x02,
        0x01,
        0x82,
        0x00,
        0x00,
        0x129
    ],
    "Murasame": [
        0x02,
        0x00,
        0x00,
        0x01,
        0x00,
        0x00,
        0x02,
        0x02,
        0x81,
        0x20,
        0x00,
        0x01
    ],
    "Mute": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x03,
        0x42,
        0x55,
        0x02,
        0x161
    ],
    "Mutilate": [
        0x09,
        0x11,
        0x10,
        0x02,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x22,
        0x01,
        0x93
    ],
    "Nameless Dance": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x12,
        0x88,
        0x00,
        0x00
    ],
    "Nameless Song": [
        0x02,
        0x80,
        0x24,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x11,
        0x89,
        0x00,
        0x00
    ],
    "Nanoflare": [
        0x00,
        0x00,
        0x00,
        0x01,
        0x02,
        0x04,
        0x02,
        0x01,
        0x82,
        0x10,
        0x02,
        0x129
    ],
    "Negotiate": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x12,
        0x01,
        0x00,
        0x01
    ],
    "Nether Demon": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Night Sword": [
        0x0d,
        0x11,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x03,
        0x82,
        0x12,
        0x01,
        0x97
    ],
    "Noxious Gas": [
        0x00,
        0x00,
        0x90,
        0x00,
        0x02,
        0x03,
        0x01,
        0x04,
        0x12,
        0x54,
        0x02,
        0x161
    ],
    "Obsidian Blade": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Odd Soundwave": [
        0x02,
        0x10,
        0x30,
        0x01,
        0x02,
        0x00,
        0x02,
        0x03,
        0x22,
        0x01,
        0x00,
        0x00
    ],
    "Odin": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x03,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Oink": [
        0x09,
        0x11,
        0x31,
        0x00,
        0x00,
        0x02,
        0x00,
        0x02,
        0x21,
        0x21,
        0x00,
        0x11
    ],
    "Old": [
        0x00,
        0x00,
        0x60,
        0x42,
        0x02,
        0x06,
        0x00,
        0x00,
        0x0a,
        0x15,
        0x02,
        0x161
    ],
    "Omnislash": [
        0x05,
        0x11,
        0x00,
        0x00,
        0x00,
        0x03,
        0x01,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Paralyze": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Parasite": [
        0x01,
        0x11,
        0x00,
        0x00,
        0x00,
        0x04,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x00
    ],
    "Peck": [
        0x09,
        0x11,
        0x10,
        0x02,
        0x02,
        0x03,
        0x00,
        0x03,
        0x0a,
        0x02,
        0x02,
        0x121
    ],
    "Persuade": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x0a,
        0x01,
        0x00,
        0x01
    ],
    "Petrify": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x00,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Pitfall": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Poison": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x02,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Poison Nail": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x02,
        0x00,
        0x05,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Polka Polka": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x0a,
        0x80,
        0x00,
        0x00
    ],
    "Power Break": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x0a,
        0x02,
        0x01,
        0x93
    ],
    "Praise": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x09,
        0x01,
        0x00,
        0x01
    ],
    "Pray Faith": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x02,
        0x05,
        0x00,
        0x00,
        0x10,
        0x55,
        0x02,
        0x161
    ],
    "Preach": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x08,
        0x01,
        0x00,
        0x01
    ],
    "Protect": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x01,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Protect 2": [
        0x00,
        0x00,
        0x20,
        0x00,
        0x00,
        0x04,
        0x01,
        0x03,
        0x11,
        0x15,
        0x00,
        0x61
    ],
    "Protect Spirit": [
        0x03,
        0x11,
        0x10,
        0x01,
        0x00,
        0x00,
        0x02,
        0x01,
        0x11,
        0x00,
        0x00,
        0x21
    ],
    "Pummel": [
        0x09,
        0x11,
        0x00,
        0x80,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x02,
        0x01,
        0x97
    ],
    "Purification": [
        0x02,
        0x10,
        0x00,
        0x01,
        0x00,
        0x00,
        0x01,
        0x00,
        0x21,
        0x00,
        0x00,
        0x91
    ],
    "Quake": [
        0x00,
        0x00,
        0x20,
        0x40,
        0x02,
        0x04,
        0x03,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Quick": [
        0x00,
        0x00,
        0xa0,
        0x40,
        0x00,
        0x06,
        0x00,
        0x00,
        0x09,
        0x55,
        0x00,
        0x61
    ],
    "Quicksand": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Raise": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x00,
        0x00,
        0x21,
        0x75,
        0x00,
        0x61
    ],
    "Raise 2": [
        0x00,
        0x00,
        0xa0,
        0x00,
        0x00,
        0x05,
        0x00,
        0x00,
        0x21,
        0x75,
        0x00,
        0x61
    ],
    "Ramuh": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Reflect": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x05,
        0x00,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Refute": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x20,
        0x01,
        0x00,
        0x01
    ],
    "Regen": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x01,
        0x00,
        0x91,
        0x55,
        0x00,
        0x61
    ],
    "Rehabilitate": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x41,
        0x01,
        0x00,
        0x21
    ],
    "Repair": [
        0x02,
        0x10,
        0x10,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x81,
        0x20,
        0x00,
        0x11
    ],
    "Reraise": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x00,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Revive": [
        0x09,
        0x10,
        0x00,
        0x00,
        0x00,
        0x01,
        0x00,
        0x00,
        0x21,
        0x20,
        0x00,
        0x11
    ],
    "Salamander": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Sand Storm": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Scratch": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Scratch Up": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x04,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Scream": [
        0x02,
        0x10,
        0x20,
        0x01,
        0x00,
        0x00,
        0x00,
        0x00,
        0x09,
        0x01,
        0x00,
        0x00
    ],
    "Seal Evil": [
        0x20,
        0x10,
        0x00,
        0x10,
        0x01,
        0x00,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x93
    ],
    "Secret Fist": [
        0x09,
        0x11,
        0x00,
        0x80,
        0x01,
        0x01,
        0x00,
        0x00,
        0x12,
        0x00,
        0x01,
        0x93
    ],
    "Self Destruct": [
        0x02,
        0x10,
        0x10,
        0x01,
        0x00,
        0x00,
        0x02,
        0x04,
        0x82,
        0x00,
        0x00,
        0x00
    ],
    "Shake Off": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Shell": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x01,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Shell 2": [
        0x00,
        0x00,
        0x20,
        0x00,
        0x00,
        0x04,
        0x01,
        0x03,
        0x11,
        0x15,
        0x00,
        0x61
    ],
    "Shellbust Stab": [
        0x04,
        0x11,
        0x00,
        0x00,
        0x01,
        0x03,
        0x01,
        0x01,
        0x86,
        0x00,
        0x01,
        0x9f
    ],
    "Shield Rend": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x06,
        0x02,
        0x01,
        0x93
    ],
    "Shine Lover": [
        0x09,
        0x11,
        0x30,
        0x12,
        0x01,
        0x03,
        0x00,
        0x05,
        0x42,
        0x03,
        0x01,
        0x93
    ],
    "Shiva": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Silence": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Sky Demon": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Slam": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Sleep": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x01,
        0x01,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Sleep Touch": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x02,
        0x12,
        0x02,
        0x01,
        0x93
    ],
    "Slow": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Slow 2": [
        0x00,
        0x00,
        0x20,
        0x02,
        0x02,
        0x04,
        0x01,
        0x03,
        0x12,
        0x15,
        0x02,
        0x161
    ],
    "Slow Dance": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x0a,
        0x80,
        0x00,
        0x00
    ],
    "Small Bomb": [
        0x09,
        0x11,
        0x10,
        0x02,
        0x01,
        0x01,
        0x00,
        0x00,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Snake Carrier": [
        0x09,
        0x11,
        0x00,
        0x13,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x22,
        0x00,
        0x00
    ],
    "Snort": [
        0x09,
        0x51,
        0x31,
        0x02,
        0x02,
        0x02,
        0x00,
        0x01,
        0x12,
        0x03,
        0x02,
        0x121
    ],
    "Solution": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x08,
        0x01,
        0x00,
        0x01
    ],
    "Space Storage": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x02,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Spark": [
        0x02,
        0x10,
        0x10,
        0x01,
        0x02,
        0x00,
        0x02,
        0x01,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Speed Break": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x0a,
        0x02,
        0x01,
        0x93
    ],
    "Spell Absorb": [
        0x01,
        0x01,
        0x20,
        0x40,
        0x02,
        0x05,
        0x00,
        0x00,
        0x42,
        0x15,
        0x02,
        0x161
    ],
    "Spin Fist": [
        0x03,
        0x11,
        0x00,
        0x83,
        0x01,
        0x00,
        0x01,
        0x00,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Spirit of Life": [
        0x03,
        0x11,
        0x10,
        0x01,
        0x00,
        0x00,
        0x02,
        0x01,
        0x81,
        0x20,
        0x00,
        0x21
    ],
    "Stab Up": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x02,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Stabilize Time": [
        0x00,
        0x00,
        0x60,
        0x00,
        0x00,
        0x04,
        0x01,
        0x01,
        0x21,
        0x15,
        0x02,
        0x161
    ],
    "Stasis Sword": [
        0x04,
        0x11,
        0x00,
        0x02,
        0x01,
        0x01,
        0x01,
        0x00,
        0x82,
        0x12,
        0x01,
        0x9f
    ],
    "Static Shock": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Steal Accessory": [
        0x09,
        0x51,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x01,
        0x06,
        0x02,
        0x01,
        0x93
    ],
    "Steal Armor": [
        0x09,
        0x51,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x01,
        0x86,
        0x02,
        0x01,
        0x93
    ],
    "Steal Heart": [
        0x01,
        0x51,
        0x00,
        0x00,
        0x00,
        0x03,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x01
    ],
    "Steal Helmet": [
        0x09,
        0x51,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x01,
        0x86,
        0x02,
        0x01,
        0x93
    ],
    "Steal Shield": [
        0x09,
        0x51,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x01,
        0x06,
        0x02,
        0x01,
        0x93
    ],
    "Steal Status": [
        0x09,
        0x11,
        0x00,
        0x10,
        0x01,
        0x02,
        0x00,
        0x03,
        0x22,
        0x00,
        0x00,
        0x21
    ],
    "Steal Weapon": [
        0x09,
        0x51,
        0x00,
        0x02,
        0x01,
        0x02,
        0x00,
        0x01,
        0x06,
        0x02,
        0x01,
        0x93
    ],
    "Stop": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x04,
        0x01,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Storm Around": [
        0x03,
        0x11,
        0x10,
        0x11,
        0x01,
        0x00,
        0x01,
        0x01,
        0x82,
        0x00,
        0x01,
        0x9f
    ],
    "Straight Dash": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Suck Blood": [
        0x09,
        0x10,
        0x10,
        0x00,
        0x00,
        0x01,
        0x00,
        0x00,
        0x12,
        0x00,
        0x00,
        0x00
    ],
    "Surging Sword": [
        0x04,
        0x11,
        0x00,
        0x02,
        0x01,
        0x01,
        0x01,
        0x01,
        0x82,
        0x12,
        0x01,
        0x9f
    ],
    "Sylph": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Tackle": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x02,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Tail Swing": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x93
    ],
    "Tendrils": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x01,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Tentacle": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x02,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Threaten": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x04,
        0x00,
        0x04,
        0x0a,
        0x01,
        0x00,
        0x01
    ],
    "Throw Spirit": [
        0x01,
        0x11,
        0x10,
        0xa2,
        0x41,
        0x04,
        0x00,
        0x00,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Throw Stone": [
        0x01,
        0x11,
        0x00,
        0x22,
        0x41,
        0x04,
        0x00,
        0x00,
        0x82,
        0x02,
        0x01,
        0x93
    ],
    "Thunder Breath": [
        0x19,
        0x15,
        0x11,
        0x22,
        0x52,
        0x02,
        0x02,
        0x02,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Thunder Soul": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x41,
        0x03,
        0x00,
        0x00,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Tickle": [
        0x09,
        0x10,
        0x00,
        0x02,
        0x02,
        0x01,
        0x00,
        0x03,
        0x20,
        0x02,
        0x02,
        0x121
    ],
    "Titan": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x02,
        0x03,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Toot": [
        0x09,
        0x11,
        0x11,
        0x00,
        0x02,
        0x02,
        0x00,
        0x01,
        0x12,
        0x00,
        0x02,
        0x121
    ],
    "Tornado": [
        0x00,
        0x00,
        0x20,
        0x40,
        0x02,
        0x04,
        0x03,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Toxic Toad": [
        0x00,
        0x11,
        0x00,
        0x01,
        0x02,
        0x05,
        0x02,
        0x00,
        0x12,
        0x10,
        0x02,
        0x161
    ],
    "Triple Attack": [
        0x11,
        0x13,
        0x10,
        0x92,
        0x09,
        0x01,
        0x01,
        0x01,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Triple Breath": [
        0x19,
        0x13,
        0x11,
        0x02,
        0x06,
        0x02,
        0x02,
        0x02,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Triple Flame": [
        0x01,
        0x19,
        0x11,
        0x00,
        0x02,
        0x04,
        0x01,
        0x02,
        0x82,
        0x08,
        0x02,
        0x129
    ],
    "Triple Thunder": [
        0x01,
        0x19,
        0x11,
        0x00,
        0x02,
        0x04,
        0x01,
        0x01,
        0x82,
        0x08,
        0x02,
        0x129
    ],
    "Turn Punch": [
        0x03,
        0x11,
        0x30,
        0x01,
        0x01,
        0x00,
        0x01,
        0x01,
        0x82,
        0x01,
        0x01,
        0x9f
    ],
    "Ulmaguest": [
        0x00,
        0x10,
        0x30,
        0x00,
        0x00,
        0x04,
        0x02,
        0x01,
        0x82,
        0x01,
        0x00,
        0x00
    ],
    "Ultima": [
        0x00,
        0x01,
        0x20,
        0x00,
        0x02,
        0x05,
        0x01,
        0x01,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Vengeance": [
        0x09,
        0x11,
        0x00,
        0x00,
        0x00,
        0x05,
        0x00,
        0x02,
        0x82,
        0x00,
        0x00,
        0x00
    ],
    "Void Storage": [
        0x00,
        0x08,
        0x21,
        0x01,
        0x02,
        0x04,
        0x01,
        0x02,
        0x82,
        0x09,
        0x02,
        0x129
    ],
    "Wall": [
        0x00,
        0x00,
        0xe0,
        0x00,
        0x00,
        0x04,
        0x00,
        0x00,
        0x11,
        0x55,
        0x00,
        0x61
    ],
    "Water Ball": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Wave Fist": [
        0x09,
        0x11,
        0x00,
        0x82,
        0x01,
        0x03,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Weapon Rend": [
        0x20,
        0x10,
        0x00,
        0x12,
        0x01,
        0x00,
        0x00,
        0x00,
        0x06,
        0x02,
        0x01,
        0x93
    ],
    "Will-O-Wisp": [
        0x00,
        0x11,
        0x00,
        0x80,
        0x02,
        0x05,
        0x01,
        0x00,
        0x82,
        0x00,
        0x02,
        0x129
    ],
    "Wind Soul": [
        0x01,
        0x11,
        0x10,
        0x22,
        0x41,
        0x03,
        0x00,
        0x00,
        0x82,
        0x02,
        0x02,
        0x129
    ],
    "Wing Attack": [
        0x09,
        0x11,
        0x10,
        0x92,
        0x01,
        0x01,
        0x00,
        0x03,
        0x82,
        0x02,
        0x01,
        0x9f
    ],
    "Wish": [
        0x09,
        0x10,
        0x20,
        0x00,
        0x00,
        0x01,
        0x00,
        0x05,
        0x81,
        0x01,
        0x00,
        0x00
    ],
    "Witch Hunt": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x42,
        0x80,
        0x00,
        0x00
    ],
    "Wiznaibus": [
        0x02,
        0x40,
        0x04,
        0x01,
        0x00,
        0x00,
        0xff,
        0xff,
        0x82,
        0x80,
        0x00,
        0x00
    ],
    "Yell": [
        0x08,
        0x10,
        0x20,
        0x00,
        0x00,
        0x03,
        0x00,
        0x04,
        0x09,
        0x01,
        0x00,
        0x00
    ],
    "Zodiac": [
        0x00,
        0x40,
        0x20,
        0x00,
        0x02,
        0x04,
        0x03,
        0x02,
        0x82,
        0x15,
        0x02,
        0x169
    ],
    "Zombie": [
        0x00,
        0x00,
        0xe0,
        0x42,
        0x02,
        0x05,
        0x00,
        0x00,
        0x12,
        0x55,
        0x02,
        0x161
    ],
    "Zombie Touch": [
        0x09,
        0x11,
        0x10,
        0x12,
        0x01,
        0x01,
        0x00,
        0x02,
        0x12,
        0x02,
        0x01,
        0x93
    ]
};
const $e4e8f9aa5d326948$export$fa1ca01d50a8fc95 = [
    "Pitfall",
    "Sand Storm",
    "Sand Storm",
    "Hell Ivy",
    "Hell Ivy",
    "Blizzard",
    "Local Quake",
    "Hallowed Ground",
    "Pitfall",
    "Quicksand",
    "Quicksand",
    "Quicksand",
    "Local Quake",
    "Blizzard",
    "Water Ball",
    "Water Ball",
    "Water Ball",
    "Water Ball",
    "Lava Ball",
    "Pitfall",
    "Will-O-Wisp",
    "Hallowed Ground",
    "Gusty Wind",
    "Hallowed Ground",
    "Gusty Wind",
    "Static Shock",
    "Sand Storm",
    "Static Shock",
    "Will-O-Wisp",
    "Will-O-Wisp",
    "Static Shock",
    "Will-O-Wisp",
    "Static Shock",
    "Gusty Wind",
    "Hallowed Ground",
    "Static Shock",
    "Hell Ivy",
    "Will-O-Wisp",
    "Static Shock",
    "Hell Ivy",
    "Will-O-Wisp",
    "Lava Ball",
    "Static Shock",
    "Static Shock",
    "Hallowed Ground",
    "Water Ball",
    "Static Shock",
    "Water Ball",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock",
    "Static Shock"
];
const $e4e8f9aa5d326948$export$11593d11e79c3dca = new Set([
    "Bequeath Bacon",
    "Chakra",
    "Choco Cure",
    "Cure",
    "Cure 2",
    "Cure 3",
    "Cure 4",
    "Elixir",
    "Energize",
    "Fairy",
    "Fury",
    "Hi-Potion",
    "Life Song",
    "Murasame",
    "Potion",
    "Regen",
    "Repair",
    "Spirit of Life",
    "Wish",
    "X-Potion"
]);
// Each test is null when the ability isn't in the table (FFTBG additions, items).
const $e4e8f9aa5d326948$var$bit = (name, i, m)=>$e4e8f9aa5d326948$export$ed0ccf5098dab683[name] ? ($e4e8f9aa5d326948$export$ed0ccf5098dab683[name][i] & m) !== 0 : null;
const $e4e8f9aa5d326948$export$c6429a28e685ee70 = (name)=>$e4e8f9aa5d326948$var$bit(name, 2, 0x80);
const $e4e8f9aa5d326948$export$ee2b3e70d3c20100 = (name)=>$e4e8f9aa5d326948$var$bit(name, 2, 0x20);
const $e4e8f9aa5d326948$export$68565f449b6d0b9f = (name)=>$e4e8f9aa5d326948$export$ed0ccf5098dab683[name] ? !!($e4e8f9aa5d326948$export$ed0ccf5098dab683[name][9] & 0x08) : null;
const $e4e8f9aa5d326948$export$378f91c0e59ec6bd = (name)=>[
        'Yell',
        'Praise',
        'Accumulate'
    ].includes(name) && $e4e8f9aa5d326948$export$ed0ccf5098dab683[name] ? ($e4e8f9aa5d326948$export$ed0ccf5098dab683[name][8] & 0x0c) === 0x08 : null;
function $e4e8f9aa5d326948$export$f26343bab2d7bae8(name) {
    const f = $e4e8f9aa5d326948$export$ed0ccf5098dab683[name];
    if (!f || f[10] == null) return null;
    return f[3] & 0x02 && f[10] ? f[10] === 1 ? 'physical' : 'magic' : 'none';
}
const $e4e8f9aa5d326948$export$10ac2c641397d915 = (name)=>$e4e8f9aa5d326948$export$ed0ccf5098dab683[name] && $e4e8f9aa5d326948$export$ed0ccf5098dab683[name][11] != null ? $e4e8f9aa5d326948$export$ed0ccf5098dab683[name][11] : null;
const $e4e8f9aa5d326948$export$3ed0198ba2b7f3ea = (name)=>$e4e8f9aa5d326948$var$bit(name, 0, 0x01);
const $e4e8f9aa5d326948$export$b6bb43b10d012642 = (name)=>$e4e8f9aa5d326948$var$bit(name, 1, 0x01);
const $e4e8f9aa5d326948$export$eb49f89545284d65 = (name)=>$e4e8f9aa5d326948$var$bit(name, 1, 0x40);
const $e4e8f9aa5d326948$export$742cc11a3efc35c1 = (name)=>$e4e8f9aa5d326948$var$bit(name, 1, 0x80);
function $e4e8f9aa5d326948$export$abe4a8928f5d12e1(name) {
    const f = $e4e8f9aa5d326948$export$ed0ccf5098dab683[name];
    if (!f || f[0] & 0x20) return null;
    const v = f[7] ?? 0;
    return {
        reach: f[0] & 0x08 ? v : 99,
        spread: (f[6] || 0) > 0 && !(f[1] & 0x10) ? v : 99
    };
}
const $e4e8f9aa5d326948$export$b76a36c9e595a78d = (name)=>$e4e8f9aa5d326948$export$ed0ccf5098dab683[name] ? !!($e4e8f9aa5d326948$export$ed0ccf5098dab683[name][8] & 0x01 || $e4e8f9aa5d326948$export$ed0ccf5098dab683[name][9] & 0x80) : null;
const $e4e8f9aa5d326948$export$30a0fa6169f8ff18 = (name)=>$e4e8f9aa5d326948$export$ed0ccf5098dab683[name] ? !!($e4e8f9aa5d326948$export$ed0ccf5098dab683[name][9] & 0x10) : null;
function $e4e8f9aa5d326948$export$c604d7db624ffdef(name, weaponRange = 1) {
    const f = name === 'Attack' ? [
        0x20,
        0x00,
        0x00,
        0x02,
        0x01,
        0,
        0
    ] : $e4e8f9aa5d326948$export$ed0ccf5098dab683[name];
    if (!f) return null;
    const [b3, , , b6, ai2 = 0, range = 0, area = 0] = f;
    if (ai2 & 0xc0) return 'first';
    if (ai2 & 0x3c) return 'all';
    const r = b3 & 0x20 ? weaponRange : range, a = b3 & 0x20 ? 0 : area;
    return r + a < 3 && b6 & 0x02 ? 'all' : 'first';
}

});


parcelRegister("dr7Eb", function(module, exports) {

$parcel$export(module.exports, "simulateBattle", () => $9c83ba8af3a31ade$export$82efcf1bef55f708);
$parcel$export(module.exports, "runBattles", () => $9c83ba8af3a31ade$export$4ae5aadd2d8e14b6);
$parcel$export(module.exports, "serializeRepro", () => $9c83ba8af3a31ade$export$a8d656a67038330c);
// Flat-grid tactical Monte-Carlo battle sim.
//

var $56OCP = parcelRequire("56OCP");

var $jEtWa = parcelRequire("jEtWa");

var $5tAvx = parcelRequire("5tAvx");

var $7cZwo = parcelRequire("7cZwo");

var $eQqwh = parcelRequire("eQqwh");

var $6ZWSX = parcelRequire("6ZWSX");
var $9c83ba8af3a31ade$require$Buffer = $6ZWSX.Buffer;
//
// Two teams start on opposite rows of a flat grid facing each other; units take
// CT/Speed-ordered turns, move toward a target, and act (basic attack or an
// ability). Facing (front/side/back) drives the physical hit chance. Battles
// run to a wipe (or a turn cap → HP tiebreak); runBattles() repeats N times → win%.
//
// PHASE 1: grid + movement + facing + basic attack + death.
// PHASE 2 (this): abilities, MP, charge time, and a core status set, plus a
//   heuristic action chooser so abilities get used.
// NOT yet: a value-maximizing AI (P3), reactions (P4), positional AoE geometry,
//   height/terrain. The engine is pure + data-injected — it takes prepared
//   "combatant specs"; the app converts real units → specs elsewhere.
//
// Combatant spec (read-only; cloned into runtime units):
//   { name, hp, mp, speed, move, range, power, evade:{front,side,back,magic},
//     actions: [ {
//       name, kind:'damage'|'heal'|'revive'|'status'|'buff',
//       target:'enemy'|'ally'|'self', range, aoe, mp, charge,
//       power,        // damage / heal amount (revive = HP restored)
//       magical,      // true → uses magic evade + Shell mitigation
//       status,       // status name (kind status/buff); 'Death' = instant KO
//       duration,     // status turns
//       success,      // % to land a status (default 100)
//     } ] }
// Status groups. Stop/Sleep/Petrify fully incapacitate (no act, no move). Don't
// Act and Don't Move split the two halves; Charm acts for the enemy; Berserk
// forces an attack; Frog limits to a weak basic attack; Darkness halves physical
// accuracy; Reflect bounces single-target magic back toward the caster's side.
// AI tuning knobs read by the scorers, set from the battle config at the start of each battle
// (simulateBattle) or decision (decideTurn). statusWeight scales how much the AI values landing a
// status ailment against dealing damage.
const $9c83ba8af3a31ade$var$TUNE = {
    statusWeight: 1
};
const $9c83ba8af3a31ade$var$setTune = (config)=>{
    $9c83ba8af3a31ade$var$TUNE.statusWeight = config.statusWeight ?? 1;
};
const $9c83ba8af3a31ade$var$STOP_LIKE = [
    'Stop',
    'Sleep',
    'Petrify'
];
const $9c83ba8af3a31ade$var$NO_ACT = [
    'Stop',
    'Sleep',
    'Petrify',
    "Don't Act"
];
const $9c83ba8af3a31ade$var$NO_MOVE = [
    'Stop',
    'Sleep',
    'Petrify',
    "Don't Move"
];
// Stat-mod bounds (songs/dances/talk/breaks). PA/MA cap the accumulated BONUS (re-baked);
// Speed/Brave/Faith cap the live value. `appliedDelta` = how much a mod actually moves the
// stat after the cap — so the AI stops re-singing once the team is maxed. STAT_VALUE prices
// a single point (Speed buys turns, so it's worth most).
const $9c83ba8af3a31ade$var$STAT_CAP = {
    pa: [
        -6,
        6
    ],
    ma: [
        -6,
        6
    ],
    speed: [
        4,
        13
    ],
    brave: [
        5,
        95
    ],
    faith: [
        5,
        95
    ]
};
const $9c83ba8af3a31ade$var$STAT_VALUE = {
    pa: 9,
    ma: 9,
    speed: 14,
    brave: 4,
    faith: 4
};
// How much a stat-mod actually moves the stat, respecting the cap DIRECTIONALLY: a buff
// never reduces an already-high stat and a debuff never raises an already-low one (so the
// cap is a soft ceiling/floor, not a clamp that disturbs out-of-range base stats).
function $9c83ba8af3a31ade$var$appliedDelta(t, mod) {
    const cur = mod.stat === 'pa' || mod.stat === 'ma' ? (mod.stat === 'pa' ? t.paBonus : t.maBonus) || 0 : mod.stat === 'speed' ? t.speed : mod.stat === 'brave' ? t.brave ?? 50 : t.faith ?? 50;
    const [lo, hi] = $9c83ba8af3a31ade$var$STAT_CAP[mod.stat];
    return mod.delta > 0 ? Math.max(0, Math.min(mod.delta, hi - cur)) : Math.min(0, Math.max(mod.delta, lo - cur));
}
const $9c83ba8af3a31ade$var$DEAD_TURNS = 3; // a corpse lingers this many of its own ATs, then crystallizes
const $9c83ba8af3a31ade$var$crystalTicks = (d)=>d.dead == null || $9c83ba8af3a31ade$var$hasStatus(d, 'Reraise') ? Infinity : Math.ceil((100 * (d.dead + 1) - (d.ct || 0)) / Math.max(1, d.speed || 1));
const $9c83ba8af3a31ade$var$manh = (a, b)=>Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
const $9c83ba8af3a31ade$var$opp = (team)=>team === 'A' ? 'B' : 'A';
function $9c83ba8af3a31ade$export$bb945e451b3a4d79(ax, ay, target) {
    const relx = Math.sign(ax - target.x);
    const rely = Math.sign(ay - target.y);
    const dot = relx * target.facing.x + rely * target.facing.y;
    if (dot > 0) return 'front';
    if (dot < 0) return 'back';
    return 'side';
}
function $9c83ba8af3a31ade$var$faceToward(u, t) {
    const dx = t.x - u.x, dy = t.y - u.y;
    if (Math.abs(dx) >= Math.abs(dy)) u.facing = {
        x: Math.sign(dx) || 0,
        y: 0
    };
    else u.facing = {
        x: 0,
        y: Math.sign(dy)
    };
    if (!u.facing.x && !u.facing.y) u.facing = {
        x: 0,
        y: 1
    };
}
const $9c83ba8af3a31ade$var$hasStatus = (u, s)=>!!(u.status && u.status[s]);
const $9c83ba8af3a31ade$var$stopped = (u)=>$9c83ba8af3a31ade$var$STOP_LIKE.some((s)=>$9c83ba8af3a31ade$var$hasStatus(u, s)); // no act AND no move
const $9c83ba8af3a31ade$var$cantAct = (u)=>$9c83ba8af3a31ade$var$NO_ACT.some((s)=>$9c83ba8af3a31ade$var$hasStatus(u, s));
const $9c83ba8af3a31ade$var$cantMove = (u)=>$9c83ba8af3a31ade$var$NO_MOVE.some((s)=>$9c83ba8af3a31ade$var$hasStatus(u, s));
const $9c83ba8af3a31ade$var$cantReact = (u)=>$9c83ba8af3a31ade$var$stopped(u) || $9c83ba8af3a31ade$var$berserk(u) || $9c83ba8af3a31ade$var$hasStatus(u, 'Confusion') || $9c83ba8af3a31ade$var$hasStatus(u, "Don't Act"); // also blocked by Berserk / Confusion / Don't Act (BMG)
const $9c83ba8af3a31ade$var$charmed = (u)=>$9c83ba8af3a31ade$var$hasStatus(u, 'Charm');
const $9c83ba8af3a31ade$var$berserk = (u)=>$9c83ba8af3a31ade$var$hasStatus(u, 'Berserk');
const $9c83ba8af3a31ade$var$frogged = (u)=>$9c83ba8af3a31ade$var$hasStatus(u, 'Frog');
const $9c83ba8af3a31ade$var$blinded = (u)=>$9c83ba8af3a31ade$var$hasStatus(u, 'Darkness'); // halves physical accuracy
// AIRBORNE: a unit mid-Jump has LEFT the field — it can't be targeted, splashed, or
// math-hit by anyone until it lands (the jump action carries `jump:true`). This is the
// key Jump distinction: charging a SPELL keeps you standing there, exposed; a Jump
// removes you entirely, so the Lancer is untouchable while in the air (BMG / FFT).
const $9c83ba8af3a31ade$var$airborne = (u)=>!!(u.charging && u.charging.action && u.charging.action.jump);
// Which evasion can dodge `action`: the game's per-ability answer when simPrep has it (`evade`, from the
// formula code: Holy and the summons none, Fire and Slow magic, Mutilate and Beak physical), else magic evade
// for magic and evade by facing for the rest, none for Jump and Throw.
const $9c83ba8af3a31ade$var$evadeOf = (action)=>action.evade ?? (action.ignoreEvade ? 'none' : action.magical ? 'magic' : 'physical');
// A target that can't evade at all: asleep, stopped, Don't Act or confused (the game's evade setup, 0x801853F4).
// Charging doesn't stop it.
const $9c83ba8af3a31ade$var$EVADELESS = [
    'Sleep',
    'Stop',
    "Don't Act",
    'Confusion'
];
// The chance `t` doesn't dodge `action` from `u` standing at `from`, as FFTBG's evade check works it out. Each
// source (class, shield, accessory, weapon; simPrep's evadeSrc) passes ⌊(base − evade) × 100 / base⌋ percent,
// and the pass rate is ⌊the product / 10⁶⌋ (0x801858D0). The base starts at 100 and moves with the fight:
// halved (every evade doubled) for a Defending target, an Abandon one that can react, and, against physical
// attacks, an attacker with Darkness or Confusion; doubled (evade halved) for a target that's Performing a
// song or dance. Concentrate skips physical evade, a Transparent attacker skips both. (Darkness used to
// halve the hit instead, which cut even back attacks on targets with no evade at all.)
function $9c83ba8af3a31ade$var$evadeHit(u, action, t, from) {
    const kind = $9c83ba8af3a31ade$var$evadeOf(action);
    if (kind === 'none' || $9c83ba8af3a31ade$var$hasStatus(u, 'Transparent') || kind === 'physical' && u.concentrate || $9c83ba8af3a31ade$var$EVADELESS.some((s)=>$9c83ba8af3a31ade$var$hasStatus(t, s))) return 1;
    const dir = kind === 'magic' ? 'magic' : t.facing ? $9c83ba8af3a31ade$export$bb945e451b3a4d79(from.x, from.y, t) : 'front';
    const src = t.evadeSrc && t.evadeSrc[dir];
    if (!src) return Math.max(0, Math.floor(100 - (t.evade && t.evade[dir] || 0) + 1e-9) / 100 * (kind === 'physical' && $9c83ba8af3a31ade$var$blinded(u) ? 0.5 : 1));
    let base = 100;
    if (kind === 'physical' && ($9c83ba8af3a31ade$var$blinded(u) || $9c83ba8af3a31ade$var$hasStatus(u, 'Confusion'))) base = Math.floor(base / 2);
    if (t.abandon && !$9c83ba8af3a31ade$var$cantReact(t)) base = Math.floor(base / 2);
    if (t.charging && t.charging.action && $9c83ba8af3a31ade$var$fieldWide(t.charging.action)) base *= 2; // Performing
    if ($9c83ba8af3a31ade$var$hasStatus(t, 'Defending')) base = Math.floor(base / 2);
    let prod = 1, n = 0;
    for (const ev of src){
        if (!ev) continue;
        if (ev >= base) return 0;
        prod *= Math.floor((base - ev) * 100 / base);
        n++;
    }
    return n ? Math.floor(prod / 100 ** (n - 1)) / 100 : 1;
}
// Physical damage is ×3/2 against a unit that can't defend itself: mid-charge, asleep,
// a frog, or a chicken (the BMG MOD-2 defender-side damage bonuses).
// Damage-taken statuses, as FFTBG's own status help (infostatus.txt) states them and its build
// confirms: Charging +25% from physical attacks, Sleep +50% physical, Frog and Chicken +50% from
// ALL attacks. (Was a flat +50% physical for all four; the emulator showed a charging target
// taking ×5/4.) Performing only halves evasion: no damage bonus.
const $9c83ba8af3a31ade$var$vulnMult = (u, physical)=>{
    let m = 1;
    if (physical && !!u.charging && !$9c83ba8af3a31ade$var$airborne(u)) m *= 5 / 4;
    if (physical && $9c83ba8af3a31ade$var$hasStatus(u, 'Sleep')) m *= 1.5;
    if ($9c83ba8af3a31ade$var$frogged(u) || $9c83ba8af3a31ade$var$hasStatus(u, 'Chicken')) m *= 1.5;
    return m;
};
// Effective Faith of a target for faith-based magic: Innocent ⇒ 0 (near-immune),
// Faith ⇒ 100, else the unit's own Faith. simPrep bakes status-success/heal at a
// generic 50, so resolution rescales by effFaith/50 to use the REAL target faith.
const $9c83ba8af3a31ade$var$effFaith = (t)=>$9c83ba8af3a31ade$var$hasStatus(t, 'Innocent') ? 0 : $9c83ba8af3a31ade$var$hasStatus(t, 'Faith') ? 100 : t.faith ?? 50;
const $9c83ba8af3a31ade$var$critical = (u)=>u.alive && u.hp <= Math.max(1, u.maxHp * 0.2);
// The game's success rate for a "Hit:" clause against this target (FFT's MOD 1 / MOD 6, as abilityFormula's
// computeSuccess): the caster's stat part, for Faith-gated ones through Magic Attack Up, Magic Defense Up and
// Shell; plus the constant; plus the zodiac addend (⌊stat/4⌋ + ⌊constant/4⌋ for Good, halves for Best, the
// negatives for Bad/Worst); then for Faith ones ⌊caster Faith × target Faith × that / 10000⌋. FFTBG's Death
// Sentence, Hit (MA + 34)% from an MA-9 Squire, read 53 against a Good-compatibility target: 9 + 34 + 2 + 8.
// We used to take MA + K and scale it by the target's Faith / 50, so a Faith(MA + 195)% spell sat at 100%
// where the game has 86% (Faith 70 against 60, MA 10). Actions without the parts keep the old estimate.
const $9c83ba8af3a31ade$var$ZODIAC_ADD = {
    Good: 0.25,
    Best: 0.5,
    Bad: -0.25,
    Worst: -0.5
};
// Which of those steps a skill takes is its formula's (simPrep's `modMask`, see damageMods), in the game's order:
// Attack Up ×4/3 and Martial Arts ×3/2 (unarmed), Magic Attack Up ×4/3, the caster's Berserk ×3/2; then the
// target's Defense Up and Protect ×2/3, Sleep ×3/2 or else charging ×5/4 and Frog / Chicken ×3/2 (the physical
// ones: the Rends, Steals, Mutilate, Beak); Magic Defense Up and Shell ×2/3 and Frog / Chicken ×3/2 (Slow, Doom,
// Peck); zodiac; Faith. So Protect and Raise ignore the target's Shell, Doom feels it, a Rend feels Protect, and
// a song or dance takes nothing, not even zodiac. Without a mask, Faith clauses take the magic steps.
function $9c83ba8af3a31ade$var$successOf(u, action, t) {
    const h = action.hit;
    if (!h) return action.faith ? (action.success ?? 100) * $9c83ba8af3a31ade$var$effFaith(t) / 50 : action.success ?? 100;
    const m = action.modMask ?? (h.faith ? $9c83ba8af3a31ade$var$MOD_ZODIAC | $9c83ba8af3a31ade$var$MOD_MAU | $9c83ba8af3a31ade$var$MOD_MDEF | $9c83ba8af3a31ade$var$MOD_FAITH : $9c83ba8af3a31ade$var$MOD_ZODIAC);
    const step = (x, n, d)=>Math.floor(x * n / d);
    let st = h.s;
    if (m & $9c83ba8af3a31ade$var$MOD_AU) {
        if (h.au) st = step(st, 4, 3);
        if (h.ma) st = step(st, 3, 2);
    }
    if (m & $9c83ba8af3a31ade$var$MOD_MAU && h.mau) st = step(st, 4, 3);
    if (m & $9c83ba8af3a31ade$var$MOD_BERSERK && $9c83ba8af3a31ade$var$hasStatus(u, 'Berserk')) st = step(st, 3, 2);
    if (m & $9c83ba8af3a31ade$var$MOD_PDEF) {
        if (t.defenseUp) st = step(st, 2, 3);
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Protect')) st = step(st, 2, 3);
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Sleep')) st = step(st, 3, 2);
        else {
            if (t.charging && !$9c83ba8af3a31ade$var$airborne(t)) st = step(st, 5, 4);
            if ($9c83ba8af3a31ade$var$frogged(t) || $9c83ba8af3a31ade$var$hasStatus(t, 'Chicken')) st = step(st, 3, 2);
        }
    }
    if (m & $9c83ba8af3a31ade$var$MOD_MDEF) {
        if (t.magicDefenseUp) st = step(st, 2, 3);
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Shell')) st = step(st, 2, 3);
        if ($9c83ba8af3a31ade$var$frogged(t) || $9c83ba8af3a31ade$var$hasStatus(t, 'Chicken')) st = step(st, 3, 2);
    }
    const zc = m & $9c83ba8af3a31ade$var$MOD_ZODIAC && u.sign && t.sign ? (0, $5tAvx.zodiacCompat)(u.gender, u.sign, t.gender, t.sign) : 'Neutral', f = $9c83ba8af3a31ade$var$ZODIAC_ADD[zc] || 0;
    const z = f ? Math.sign(f) * (Math.floor(st * Math.abs(f)) + Math.floor(h.k * Math.abs(f))) : 0;
    const raw = st + h.k + z;
    return Math.max(0, Math.min(100, m & $9c83ba8af3a31ade$var$MOD_FAITH ? Math.floor($9c83ba8af3a31ade$var$effFaith(u) * $9c83ba8af3a31ade$var$effFaith(t) * raw / 10000) : raw));
}
const $9c83ba8af3a31ade$export$70293f6c7be5250c = (u)=>!!(u.undead || $9c83ba8af3a31ade$var$hasStatus(u, 'Undead'));
// The team a unit attacks / supports — swapped while Charmed (acts for the foe).
const $9c83ba8af3a31ade$var$foeTeamOf = (u)=>$9c83ba8af3a31ade$var$charmed(u) ? u.team : $9c83ba8af3a31ade$var$opp(u.team);
const $9c83ba8af3a31ade$var$friendTeamOf = (u)=>$9c83ba8af3a31ade$var$charmed(u) ? $9c83ba8af3a31ade$var$opp(u.team) : u.team;
// A Frog can only flail: a weak basic attack (FFT frog damage is tiny).
const $9c83ba8af3a31ade$var$frogBasic = (u)=>({
        ...$9c83ba8af3a31ade$var$BASIC(u),
        weapon: null,
        power: Math.max(1, Math.round((u.power || 1) * 0.25))
    });
const $9c83ba8af3a31ade$var$effSpeed = (u)=>Math.max(1, Math.round(u.speed * ($9c83ba8af3a31ade$var$hasStatus(u, 'Haste') ? 1.5 : 1) * ($9c83ba8af3a31ade$var$hasStatus(u, 'Slow') ? 0.5 : 1)));
// ---- Defender-side damage modifiers (applied at resolution, not baked in prep) ----
const $9c83ba8af3a31ade$var$ZODIAC_MULT = {
    Best: 1.5,
    Good: 1.25,
    Neutral: 1,
    Bad: 0.75,
    Worst: 0.5
};
const $9c83ba8af3a31ade$var$zodiacMult = (att, t)=>att.sign && t.sign ? $9c83ba8af3a31ade$var$ZODIAC_MULT[(0, $5tAvx.zodiacCompat)(att.gender, att.sign, t.gender, t.sign)] ?? 1 : 1;
// Element affinity from the target's gear: 0 = cancel/immune, -1 = absorb (heal),
// 0.5 = half, 2 = weak, 1 = none.
function $9c83ba8af3a31ade$var$elementMult(element, t) {
    const e = t.elements;
    if (!element || !e) return 1;
    if (e.cancel && e.cancel.has(element)) return 0;
    if (e.absorb && e.absorb.has(element)) return -1;
    if (e.half && e.half.has(element)) return 0.5;
    if (e.weak && e.weak.has(element)) return 2;
    return 1;
}
// Combined defender multiplier on raw damage. Magic also scales by the REAL target
// Faith (the prep baked in a generic 50; Innocent/faith-0 ⇒ ~immune). Negative ⇒
// the hit is absorbed (heals the target); 0 ⇒ cancelled.
// Does `action`'s damage take this modifier? simPrep's `modMask` is the game's own answer (MOD_* bits, from
// the formula code: Lifebreak takes none, Compress zodiac only); without one, every modifier applies.
const $9c83ba8af3a31ade$var$MOD_ZODIAC = 1, $9c83ba8af3a31ade$var$MOD_PDEF = 2, $9c83ba8af3a31ade$var$MOD_CRIT = 4, $9c83ba8af3a31ade$var$MOD_ELEMENT = 8, $9c83ba8af3a31ade$var$MOD_AU = 16, $9c83ba8af3a31ade$var$MOD_MAU = 32, $9c83ba8af3a31ade$var$MOD_FAITH = 64, $9c83ba8af3a31ade$var$MOD_BERSERK = 128, $9c83ba8af3a31ade$var$MOD_MDEF = 256;
const $9c83ba8af3a31ade$var$MOD_DEFENSE = $9c83ba8af3a31ade$var$MOD_PDEF | $9c83ba8af3a31ade$var$MOD_MDEF;
const $9c83ba8af3a31ade$var$takes = (action, bit)=>action.modMask == null || (action.modMask & bit) !== 0;
function $9c83ba8af3a31ade$export$691e2bddd84c34f0(att, action, t) {
    if (action.magical && action.faith && $9c83ba8af3a31ade$var$hasStatus(t, 'Innocent')) return 0; // Innocent → faith 0 → only FAITH magic null (flat MA spells still land)
    const elemental = $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_ELEMENT);
    let el = elemental ? $9c83ba8af3a31ade$var$elementMult(action.element, t) : 1;
    if (elemental && action.element === 'Earth' && $9c83ba8af3a31ade$var$hasStatus(t, 'Float')) el = 0; // Float negates Earth
    if (el === 0) return 0;
    let m = ($9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_ZODIAC) ? $9c83ba8af3a31ade$var$zodiacMult(att, t) : 1) * el;
    if (elemental && action.element === 'Fire' && $9c83ba8af3a31ade$var$hasStatus(t, 'Oil')) m *= 2; // Oil doubles Fire
    if (action.magical && action.faith) m *= (t.faith ?? 50) / 50; // only FAITH magic (Fire/Cure) scales with target faith; flat MA magic (Draw Out, Choco Meteor, breaths) does not
    return m;
}
// The game's own damage for a formula ability against this target (simPrep keeps the formula and the
// caster's numbers in action.formula): every modifier scales the stat term in turn, floored at each
// step, then ⌊CFa × TFa × Q × XA / 10000⌋ with both units' real Faith, then the target's element.
// The emulator's trials match it to the point (Shiva 59 where Faith-50-and-rescale said 59.28).
// Negative = absorbed, 0 = cancelled; null when the action has no formula. Cached per action, since
// the AI asks the same question many times a turn.
const $9c83ba8af3a31ade$var$formulaCache = new WeakMap(), $9c83ba8af3a31ade$var$elementIds = new WeakMap();
let $9c83ba8af3a31ade$var$elementSeq = 0;
// The basic Attack's model, damage.js's own (Dual Wield's second strike uses the off hand, or a fist).
const $9c83ba8af3a31ade$var$weaponModels = new WeakMap();
function $9c83ba8af3a31ade$var$weaponModel(w, strike) {
    let m = $9c83ba8af3a31ade$var$weaponModels.get(w);
    if (!m) $9c83ba8af3a31ade$var$weaponModels.set(w, m = {});
    if (!(strike in m)) {
        const item = strike === 2 ? w.off : w.main, who = {
            SupportSkill: strike === 2 ? '' : w.support,
            Class: w.cls
        };
        m[strike] = item && (0, $eQqwh.weaponAttackModel)(item, who) || (0, $eQqwh.unarmedAttackModel)(who);
    }
    return m[strike];
}
function $9c83ba8af3a31ade$var$formulaDamage(att, action, t) {
    const f = action.formula || (action.weapon ? {
        ctx: action.weapon.ctx
    } : null);
    if (!f) return null;
    const elemental = $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_ELEMENT), defended = $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_DEFENSE);
    if (elemental && action.element === 'Earth' && $9c83ba8af3a31ade$var$hasStatus(t, 'Float')) return 0;
    const zodiac = $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_ZODIAC) && att.sign && t.sign ? (0, $5tAvx.zodiacCompat)(att.gender, att.sign, t.gender, t.sign) : 'Neutral';
    const flags = [
        $9c83ba8af3a31ade$var$hasStatus(t, 'Shell'),
        $9c83ba8af3a31ade$var$hasStatus(t, 'Protect'),
        !!t.magicDefenseUp,
        !!t.defenseUp,
        !!t.charging && !$9c83ba8af3a31ade$var$airborne(t),
        $9c83ba8af3a31ade$var$hasStatus(t, 'Sleep'),
        $9c83ba8af3a31ade$var$frogged(t) || $9c83ba8af3a31ade$var$hasStatus(t, 'Chicken')
    ].map((x)=>defended && x).concat(elemental && action.element === 'Fire' && $9c83ba8af3a31ade$var$hasStatus(t, 'Oil'));
    const e = elemental ? t.elements : null;
    if (e && !$9c83ba8af3a31ade$var$elementIds.has(e)) $9c83ba8af3a31ade$var$elementIds.set(e, ++$9c83ba8af3a31ade$var$elementSeq);
    const strike = action.strike || 1, berserk = !!action.weapon && $9c83ba8af3a31ade$var$hasStatus(att, 'Berserk');
    const key = `${$9c83ba8af3a31ade$var$effFaith(att)}|${$9c83ba8af3a31ade$var$effFaith(t)}|${zodiac}|${flags.map(Number).join('')}|${e ? $9c83ba8af3a31ade$var$elementIds.get(e) : 0}|${strike}|${+berserk}`;
    let byKey = $9c83ba8af3a31ade$var$formulaCache.get(action);
    if (!byKey) $9c83ba8af3a31ade$var$formulaCache.set(action, byKey = new Map());
    if (byKey.has(key)) return byKey.get(key);
    const c = f.ctx;
    const mods = {
        martialArts: !!c.martialArts,
        attackUp: !!c.attackUp,
        magicAttackUp: !!c.magicAttackUp,
        zodiac: zodiac,
        ...c.strengthen && c.strengthen.length ? {
            strengthen: new Set(c.strengthen)
        } : {},
        shell: flags[0],
        protect: flags[1],
        magicDefendUp: flags[2],
        defenseUp: flags[3],
        charging: flags[4],
        sleeping: flags[5],
        frogChicken: flags[6],
        ...e ? {
            cancel: e.cancel,
            weak: e.weak,
            half: e.half,
            absorb: e.absorb
        } : {}
    };
    const cx = {
        ...c,
        faith: $9c83ba8af3a31ade$var$effFaith(att),
        targetFaith: $9c83ba8af3a31ade$var$effFaith(t)
    };
    let fin;
    if (action.weapon) {
        const model = $9c83ba8af3a31ade$var$weaponModel(action.weapon, strike);
        fin = (0, $7cZwo.computeAbilityDamage)(model, cx, {
            ...mods,
            martialArts: false,
            berserk: berserk
        }).final;
    } else {
        const r = (0, $7cZwo.abilityVsTarget)(f.info, cx, mods);
        fin = r && r.kind === 'damage' ? r.final : null;
    }
    let v = fin == null ? null : Array.isArray(fin) ? (fin[0] + fin[1]) / 2 : fin;
    if (v != null && flags[7]) v *= 2; // Oil doubles Fire
    byKey.set(key, v);
    return v;
}
// How long statuses last, as FFT counts them. The timed ones count down in CLOCKTICKS, whether or
// not the unit gets a turn; these are the starting values of the 16 status counters in FFTBG's unit
// records (+0x5D..+0x6C), read off its build in the emulator. At Speed 10 a turn is ~10 ticks, so
// Stop lasts ~2 turns and Poison ~4. Death Sentence counts the victim's own turns (3); Defending
// ends at the unit's next turn; everything else (Darkness, Silence, Oil, Frog, Petrify, Confusion,
// Berserk, Float, Reraise…) lasts until cured. (Every status used to last 6 of the victim's turns:
// Stop three times too long, Darkness and Oil wearing off. Status-heavy monsters, Wyvern and both
// Malboros, were the units the sim over-rated most against real results.)
const $9c83ba8af3a31ade$var$STATUS_TICKS = {
    Poison: 40,
    Regen: 40,
    Protect: 36,
    Shell: 36,
    Haste: 28,
    Slow: 28,
    Stop: 20,
    Wall: 24,
    Faith: 36,
    Innocent: 36,
    Charm: 28,
    Sleep: 48,
    "Don't Move": 24,
    "Don't Act": 24,
    Reflect: 32
};
const $9c83ba8af3a31ade$var$OWN_TURNS = {
    'Death Sentence': 3,
    Defending: 1
};
const $9c83ba8af3a31ade$var$PERMANENT = 999;
const $9c83ba8af3a31ade$var$immuneTo = (u, name)=>!!(u.immune && u.immune.includes(name));
const $9c83ba8af3a31ade$var$isPermanent = (u, name)=>!!(u.permStatus && u.permStatus.includes(name));
function $9c83ba8af3a31ade$var$addStatus(u, name, length) {
    if ($9c83ba8af3a31ade$var$immuneTo(u, name)) return;
    u.status = u.status || {};
    const n = length ?? $9c83ba8af3a31ade$var$STATUS_TICKS[name] ?? $9c83ba8af3a31ade$var$OWN_TURNS[name] ?? $9c83ba8af3a31ade$var$PERMANENT;
    u.status[name] = Math.max(u.status[name] || 0, n);
}
// One clocktick off every timed status.
function $9c83ba8af3a31ade$var$tickTimers(u) {
    if (!u.status) return;
    for (const k of Object.keys(u.status))if ($9c83ba8af3a31ade$var$STATUS_TICKS[k] != null && u.status[k] < $9c83ba8af3a31ade$var$PERMANENT && --u.status[k] <= 0) delete u.status[k];
}
const $9c83ba8af3a31ade$var$statusTick = (u)=>Math.floor(u.maxHp / 8);
// On the unit's own turn: count down Death Sentence/Defending, apply Regen/Poison.
function $9c83ba8af3a31ade$var$tickStatus(u, occupied, log) {
    if (!u.status) return;
    // Death Sentence is a 3-turn countdown to death, NOT an instant kill — when
    // its timer runs out on the unit's own turn, the unit finally dies.
    const dsLethal = u.status['Death Sentence'] != null && u.status['Death Sentence'] - 1 <= 0;
    for (const k of Object.keys(u.status))if ($9c83ba8af3a31ade$var$OWN_TURNS[k] != null && u.status[k] < $9c83ba8af3a31ade$var$PERMANENT && --u.status[k] <= 0) delete u.status[k];
    // FFTBG: 12.5% of max HP a turn, rounded down (Poison took 39 of 316 and 41 of 334 in our logged battles,
    // Regen gave 50 of 407). Poison is damage, so it can kill.
    if (u.status.Regen) u.hp = Math.min(u.maxHp, u.hp + $9c83ba8af3a31ade$var$statusTick(u));
    if (u.status.Poison) {
        u.hp -= $9c83ba8af3a31ade$var$statusTick(u);
        if (u.hp <= 0 && u.alive) {
            u.hp = 0;
            $9c83ba8af3a31ade$var$kill(u, occupied, log);
            if (log) log.push(`${u.name} succumbs to poison`);
            return;
        }
    }
    if (dsLethal && u.alive) {
        u.hp = 0;
        $9c83ba8af3a31ade$var$kill(u, occupied, log);
    }
}
// Snapshot of every unit's HP after an action — makes the log easy to follow.
function $9c83ba8af3a31ade$var$logState(units, log) {
    const side = (t)=>units.filter((u)=>u.team === t).map((u)=>u.alive ? `${u.name} ${u.hp}@${u.x},${u.y}` : `${u.name} KO`).join(', ');
    log.push(`    \xb7 A: ${side('A')} | B: ${side('B')}`);
}
function $9c83ba8af3a31ade$var$kill(t, occupied, log) {
    if ($9c83ba8af3a31ade$var$hasStatus(t, 'Reraise')) {
        delete t.status.Reraise;
        t.hp = Math.ceil(t.maxHp / 10); // BMG: Reraise revives at MaxHP/10
        if (log) log.push(`${t.name} reraises`);
        return;
    }
    t.alive = false;
    t.status = {}; // Dead cancels every status, except the ones gear or class make permanent (a Cursed Ring's Undead)
    for (const st of t.permStatus || [])t.status[st] = $9c83ba8af3a31ade$var$PERMANENT;
    t.charging = null;
    t.dead = $9c83ba8af3a31ade$var$DEAD_TURNS; // becomes a body that still blocks its tile (stays in `occupied`)
    if (log) log.push(`${t.name} falls`);
}
// A corpse's tile frees and leaves a walkable crystal; the body itself is gone.
function $9c83ba8af3a31ade$var$crystallize(t, occupied, crystals, log) {
    occupied.delete(`${t.x},${t.y}`);
    crystals.add(`${t.x},${t.y}`);
    t.dead = null;
    t.crystallized = true;
    if (log) log.push(`${t.name} crystallizes`);
}
// An undead corpse reanimates instead of crystallizing: back up at a random
// 1..MaxHP (BMG), keeping its tile (the body never left `occupied`).
function $9c83ba8af3a31ade$var$reviveUndead(u, rng, log) {
    u.alive = true;
    u.dead = null;
    u.charging = null;
    u.hp = 1 + Math.floor(rng() * u.maxHp);
    if (log) log.push(`${u.name} reanimates (${u.hp})`);
}
// A living unit ending its move on a crystal absorbs it → full HP + MP.
function $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log) {
    const k = `${u.x},${u.y}`;
    if (!crystals.has(k)) return false;
    crystals.delete(k);
    u.hp = u.maxHp;
    u.mp = u.maxMp ?? u.mp;
    if (log) log.push(`${u.name} absorbs the crystal \u{2192} full HP/MP`);
    return true;
}
const $9c83ba8af3a31ade$var$POTION_HEAL = 100;
// One attack from `att` onto `t`, including the target's reactions (Brave%-gated).
// isReaction=true for reaction-attacks so they don't recursively re-trigger.
function $9c83ba8af3a31ade$var$dealAttack(att, action, t, occupied, rng, log, isReaction) {
    if (!t.alive || $9c83ba8af3a31ade$var$hasStatus(t, 'Petrify')) return; // petrified units are stone — immune to all damage
    const physical = !action.magical;
    const brave = t.brave || 50;
    const canReact = !isReaction && !$9c83ba8af3a31ade$var$cantReact(t) && att !== t; // no reacting to your own friendly fire
    // Hamedo (First Strike) pre-empts a physical attack with a basic of its own — but ONLY
    // if the reactor can actually reach its attacker (BMG: "your monk can't Hamedo an
    // archer"). Gate on the reactor's own weapon range, same as Counter below: melee↔melee
    // procs, ranged→melee doesn't (out of reach), ranged→in-range-ranged does. A ranged
    // (Equip Gun) Hamedo unit's longer `range` lets it strike back, so it's covered too.
    // It is ALSO useless against a monster's attack: a monster's species attack (and every
    // monster skill) isn't an Attack directive, so Hamedo never reacts to it — UNLESS the
    // monster is Berserked, which forces the generic basic Attack (so ~the only ~3% case a
    // monster can be First-Struck).
    const monsterPoke = att.gender === 'Monster' && !$9c83ba8af3a31ade$var$hasStatus(att, 'Berserk');
    if (canReact && physical && !monsterPoke && t.reaction === 'Hamedo' && att.alive && $9c83ba8af3a31ade$var$manh(t, att) <= (t.range || 1) && rng() * 100 < brave) {
        if (log) log.push(`${t.name} Hamedo!`);
        $9c83ba8af3a31ade$var$dealAttack(t, $9c83ba8af3a31ade$var$BASIC(t), att, occupied, rng, log, true); // strikes first, original negated
        return;
    }
    if (canReact && physical && t.reaction === 'Blade Grasp' && rng() * 100 < brave) {
        if (log) log.push(`${t.name} Blade Grasp negates ${att.name}`);
        return;
    }
    if (canReact && physical && att.projectile && t.reaction === 'Arrow Guard' && rng() * 100 < brave) {
        if (log) log.push(`${t.name} Arrow Guard deflects ${att.name}`);
        return;
    }
    const dir = $9c83ba8af3a31ade$export$bb945e451b3a4d79(att.x, att.y, t);
    if (rng() >= $9c83ba8af3a31ade$var$evadeHit(att, action, t, att)) {
        if (log) log.push(`${att.name}'s ${action.name} misses ${t.name} (${dir})`);
        return;
    }
    // %-HP / drain attacks carry an inherent success% (faith-gated for Demi/Lich etc.).
    if (action.success != null) {
        const succ = $9c83ba8af3a31ade$var$successOf(att, action, t);
        if (rng() * 100 >= succ) {
            if (log) log.push(`${t.name} resists ${att.name}`);
            return;
        }
    }
    // Defender-side scaling: zodiac compatibility, real target Faith (magic), and
    // elemental affinity. mult 0 = cancelled (immune); mult < 0 = absorbed (heals).
    // %-of-MaxHP attacks (Demi/Lich/Hurricane) ignore zodiac/faith — only element applies.
    const exact = action.pctMaxHp ? null : $9c83ba8af3a31ade$var$formulaDamage(att, action, t);
    const mult = exact != null ? Math.sign(exact) : action.pctMaxHp ? $9c83ba8af3a31ade$var$elementMult(action.element, t) : $9c83ba8af3a31ade$export$691e2bddd84c34f0(att, action, t);
    if (mult === 0) {
        if (log) log.push(`${t.name} is immune to ${att.name}`);
        return;
    }
    // base damage: %-of-MaxHP, the CASTER's missing HP (Goblin Punch & co., ×factor), the
    // TARGET's missing HP (Climhazzard), or a flat power.
    const missing = action.casterMissingHp ? (att.maxHp - att.hp) * action.casterMissingHp : action.targetMissingHp ? t.maxHp - t.hp : action.targetCurrentMp ? t.mp || 0 : null;
    let dmg = exact != null ? Math.max(1, Math.round(Math.abs(exact))) : action.pctMaxHp ? Math.max(1, Math.ceil(t.maxHp * action.pctMaxHp / 100 * Math.abs(mult))) // rounded up: FFTBG's Demi took 230 → 172 and 274 → 205
     : missing != null ? Math.max(1, Math.round(missing * Math.abs(mult))) : Math.max(1, Math.round((action.power || 0) * Math.abs(mult)));
    if (action.drain === 'mp') {
        const d = Math.min(dmg, t.mp || 0);
        t.mp -= d;
        att.mp = Math.min(att.maxMp ?? att.mp, (att.mp || 0) + d);
        if (log) log.push(`${att.name}'s ${action.name} drains ${d} MP from ${t.name}`);
        return;
    }
    // Protect/Shell and the status multipliers scale a normal hit's damage, NOT a %-HP attack's (a
    // formula ability already has them, in the game's order).
    const defended = $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_DEFENSE); // Lifebreak, Compress and co. ignore all of these
    if (defended && exact == null && !action.pctMaxHp && action.magical && ($9c83ba8af3a31ade$var$hasStatus(t, 'Shell') || t.magicDefenseUp)) dmg = Math.floor(dmg * 2 / 3); // Shell / Magic Defense Up
    if (defended && exact == null && !action.pctMaxHp && !action.magical && ($9c83ba8af3a31ade$var$hasStatus(t, 'Protect') || t.defenseUp)) dmg = Math.floor(dmg * 2 / 3); // Protect / Defense Up
    if (defended && !action.pctMaxHp && $9c83ba8af3a31ade$var$hasStatus(t, 'Defending')) dmg = Math.floor(dmg * 3 / 4); // Defending (Guard) — a modest all-around guard
    if (defended && exact == null && !action.pctMaxHp) dmg = Math.floor(dmg * $9c83ba8af3a31ade$var$vulnMult(t, physical)); // charging +25% physical, asleep +50% physical, frog/chicken +50% all
    // ~6% (1/16) of physical hits crit: BMG randomizes the attack stat up to ~2x, so
    // damage ranges from normal to ~double. Adds real variance to every melee exchange. Only formulas that
    // call the game's critical routine can (the weapon-style ones: not Dash, Throw Stone, Goblin Punch).
    let crit = false;
    if (physical && !action.pctMaxHp && $9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_CRIT) && rng() < 0.0625) {
        crit = true;
        dmg = Math.max(dmg + 1, Math.floor(dmg * (1 + rng())));
    }
    if (mult > 0 && canReact && physical && t.reaction === 'Damage Split' && rng() * 100 < brave) {
        dmg = Math.max(1, Math.floor(dmg / 2));
        if (log) log.push(`${t.name} Damage Split`);
    }
    if (mult < 0) {
        const heal = Math.max(1, dmg);
        t.hp = Math.min(t.maxHp, t.hp + heal);
        if (log) log.push(`${t.name} absorbs ${att.name} \u{2192} +${heal} (${Math.max(0, t.hp)})`);
        return;
    }
    if (canReact && t.reaction === 'Mana Shield' && t.mp > 0 && rng() * 100 < brave) {
        // FFT: the HP damage is redirected to MP. If MP can't cover it, MP bottoms out at
        // 0 and the REMAINDER IS LOST — it is never dealt to HP. So a triggered Mana
        // Shield always spares HP entirely (even 1 MP blocks a lethal blow).
        const absorb = Math.min(dmg, t.mp);
        t.mp -= absorb;
        dmg = 0;
        if (log) log.push(`${t.name} Mana Shield (-${absorb} MP)`);
    }
    t.hp -= dmg;
    if (dmg > 0) {
        if (action.drain === 'hp' && att.alive) {
            att.hp = Math.min(att.maxHp, att.hp + dmg);
            if (log) log.push(`${att.name} drains ${dmg} HP`);
        } // Night Sword / Mutilate / Drain
        if (log) log.push(`${att.name}'s ${action.name} hits ${t.name} for ${dmg}${crit ? ' CRIT' : ''} (${dir}) \u{2192} ${Math.max(0, t.hp)}`);
        if (t.hp <= 0) {
            $9c83ba8af3a31ade$var$kill(t, occupied, log);
            return;
        }
        // Sicken (a Wyvern's innate, or equipped): its physical attacks add Poison, bar a gun's basic
        // Attack. FFTBG's Wyvern poisoned with both Triple Attacks that landed in our logged battles.
        if (att.sicken && physical && !(action.name === 'Attack' && att.gunBasic) && !$9c83ba8af3a31ade$var$hasStatus(t, 'Poison')) {
            $9c83ba8af3a31ade$var$addStatus(t, 'Poison');
            if (log && $9c83ba8af3a31ade$var$hasStatus(t, 'Poison')) log.push(`${t.name} is poisoned`);
        }
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Sleep')) {
            delete t.status.Sleep;
            if (log) log.push(`${t.name} wakes`);
        } // a hit cancels Sleep
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Charm')) {
            delete t.status.Charm;
            if (log) log.push(`${t.name} breaks free of Charm`);
        } // HP damage ends Charm
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Confusion')) {
            delete t.status.Confusion;
            if (log) log.push(`${t.name} snaps out of confusion`);
        } // HP damage ends Confusion
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Transparent')) {
            delete t.status.Transparent;
            if (log) log.push(`${t.name} is no longer transparent`);
        } // and Transparent
        // A "Chance to add X" rider (Knife Hand's Undead, Tackle's Don't Move/Don't Act, Stasis Sword's Stop...)
        // lands after the hit, so a Sleep or Confusion rider isn't cancelled by its own damage. The AI doesn't
        // count it when choosing (the game's look-ahead predicts the sure effects only: scoring the rider made
        // our decisions match FFTBG's worse, 1062 -> 1057 of 2194 turns).
        if (action.rider && t.alive && rng() < $9c83ba8af3a31ade$var$RIDER_CHANCE) {
            const pool = action.rider.statuses.filter((st)=>!$9c83ba8af3a31ade$var$hasStatus(t, st) && !$9c83ba8af3a31ade$var$immuneTo(t, st));
            const st = action.rider.mode === 'one' ? pool[Math.floor(rng() * pool.length)] : null;
            for (const x of action.rider.mode === 'one' ? st ? [
                st
            ] : [] : pool){
                if (x === 'Death') {
                    t.hp = 0;
                    $9c83ba8af3a31ade$var$kill(t, occupied, log);
                    if (log) log.push(`${t.name} is struck down by ${action.name}`);
                    return;
                }
                $9c83ba8af3a31ade$var$addStatus(t, x);
                if (log && $9c83ba8af3a31ade$var$hasStatus(t, x)) log.push(`${t.name} gains ${x} (${action.name})`);
            }
        }
    }
    // Damage-triggered reactions (a unit has one), Brave%-gated. The AI stays blind to
    // these (faithful — vanilla can't see reactions); they just play out in resolution.
    if (canReact && t.reaction && rng() * 100 < brave) {
        const r = t.reaction, inRange = att.alive && $9c83ba8af3a31ade$var$manh(t, att) <= (t.range || 1);
        if (r === 'Auto-Potion') {
            t.hp = Math.min(t.maxHp, t.hp + $9c83ba8af3a31ade$var$POTION_HEAL);
            if (log) log.push(`${t.name} Auto-Potion \u{2192} ${t.hp}`);
        } else if ((r === 'Counter' || r === 'Counter Tackle') && physical && inRange) {
            if (log) log.push(`${t.name} counters ${att.name}`);
            $9c83ba8af3a31ade$var$dealAttack(t, $9c83ba8af3a31ade$var$BASIC(t), att, occupied, rng, log, true);
        } else if (r === 'Meatbone Slash' && physical && inRange) {
            if (log) log.push(`${t.name} Meatbone Slash!`);
            $9c83ba8af3a31ade$var$dealAttack(t, {
                name: 'Meatbone Slash',
                power: t.maxHp,
                magical: false
            }, att, occupied, rng, log, true);
        } else if (r === 'Dragon Spirit') {
            if (!$9c83ba8af3a31ade$var$hasStatus(t, 'Reraise') && !$9c83ba8af3a31ade$var$hasStatus(t, 'Undead')) {
                $9c83ba8af3a31ade$var$addStatus(t, 'Reraise', 999);
                if (log) log.push(`${t.name} Dragon Spirit (Reraise)`);
            }
        } else if (r === 'Regenerator') {
            if (!$9c83ba8af3a31ade$var$hasStatus(t, 'Regen')) {
                $9c83ba8af3a31ade$var$addStatus(t, 'Regen');
                if (log) log.push(`${t.name} Regenerator`);
            }
        } else if (r === 'HP Restore') {
            if ($9c83ba8af3a31ade$var$critical(t)) {
                t.hp = t.maxHp;
                if (log) log.push(`${t.name} HP Restore \u{2192} full`);
            }
        } else if (r === 'MP Restore') {
            if ($9c83ba8af3a31ade$var$critical(t)) t.mp = t.maxMp ?? t.mp;
        } else if (r === 'Speed Save') t.speed = Math.min(50, (t.speed || 1) + 1);
        else if (r === 'Brave Up') t.brave = Math.min(100, (t.brave || 50) + 3);
        else if (r === 'Faith Up') t.faith = Math.min(100, (t.faith ?? 50) + 3);
        else if (r === 'PA Save' || r === 'MA Save') t.power = Math.round((t.power || 1) * 1.04);
         // power is the baked basic; ~+1 PA
    }
    // Dual Wield: the off-hand follows up with its own independent strike (its own
    // hit/evade roll + reactions). Not on reaction-attacks (a counter swings once).
    if (!isReaction && action.power2 > 0 && t.alive) $9c83ba8af3a31ade$var$dealAttack(att, {
        ...action,
        power: action.power2,
        element: action.element2 || null,
        power2: 0,
        strike: 2
    }, t, occupied, rng, log, false);
}
// ---- Battlefield: a flat NxN box, or a real map (size + walls/void + height). ----
const $9c83ba8af3a31ade$var$flatField = (n)=>({
        w: n,
        h: n,
        walkable: (x, y)=>x >= 0 && y >= 0 && x < n && y < n,
        height: ()=>0
    });
// Build a `field` from config.terrain (mapTerrain.maps[n]) — walkable iff the tile
// has a height (null = void) and isn't a wall surface; or fall back to a flat box.
// With `config.tiles` (the map's raw tile table, fftPath.unpackTiles of src/data/mapTiles.json), the
// field is the game's own: heights and walkability from its tiles, and movement by its pathfinder
// (see reachableTiles). Only the lower layer: the sim has no second layer yet.
// The tiles must be the terrain's map: a number FFTBG has reused for another map (the old #125
// Checkerboard Stairs) keeps the terrain's own geometry and the old walking. Checked once per pair.
const $9c83ba8af3a31ade$var$tilesFit = new WeakMap();
function $9c83ba8af3a31ade$var$tilesMatch(t, mt) {
    if (!t) return true;
    if (t.w !== mt.w || t.h !== mt.h || !t.heights) return false;
    let memo = $9c83ba8af3a31ade$var$tilesFit.get(t);
    if (!memo) $9c83ba8af3a31ade$var$tilesFit.set(t, memo = new WeakMap());
    if (!memo.has(mt)) {
        let a = 0, c = 0;
        for(let y = 0; y < t.h; y++)for(let x = 0; x < t.w; x++){
            const th = t.heights[y][x];
            if (th == null) continue;
            const o = (y * t.w + x) * 8;
            c++;
            if (mt.tiles[o + 2] + (mt.tiles[o + 3] & 0x1f) / 2 === th) a++;
        }
        memo.set(mt, c > 0 && a / c >= 0.9);
    }
    return memo.get(mt);
}
function $9c83ba8af3a31ade$export$7b8759f97dcc03d1(config) {
    const t = config.terrain, mt = config.tiles;
    if (mt && mt.tiles && $9c83ba8af3a31ade$var$tilesMatch(t, mt)) {
        const { w: w, h: h, tiles: tiles } = mt, inB = (x, y)=>x >= 0 && y >= 0 && x < w && y < h, at = (x, y)=>(y * w + x) * 8;
        return {
            w: w,
            h: h,
            tiles: mt,
            waterCost: mt.waterCost ?? 1,
            walkable: (x, y)=>inB(x, y) && !(tiles[at(x, y) + 6] & 3),
            height: (x, y)=>inB(x, y) ? tiles[at(x, y) + 2] + (tiles[at(x, y) + 3] & 0x1f) / 2 : 0,
            surface: (x, y)=>inB(x, y) ? tiles[at(x, y)] & 0x3f : null
        };
    }
    if (t && t.heights && t.w && t.h) {
        const { w: w, h: h, heights: heights, surfaces: surfaces } = t;
        const inB = (x, y)=>x >= 0 && y >= 0 && x < w && y < h;
        return {
            w: w,
            h: h,
            walkable: (x, y)=>inB(x, y) && heights[y][x] != null && !(surfaces && surfaces[y] && surfaces[y][x] === 'x'),
            height: (x, y)=>inB(x, y) && heights[y][x] != null ? heights[y][x] : 0
        };
    }
    return $9c83ba8af3a31ade$var$flatField(config.gridSize ?? 10);
}
// Movement helpers accept either a `field` object or a plain gridSize number (→ flat box).
const $9c83ba8af3a31ade$var$asField = (g)=>typeof g === 'number' ? $9c83ba8af3a31ade$var$flatField(g) : g;
// Terrain path-distance from (tx,ty): a BFS over the field (walls/void + the
// unit's Jump climb limit) that IGNORES units — a static routing field, so a
// mover heads the SHORT way *around* obstacles. Manhattan distance can't do this:
// escaping a walled pocket means first stepping away from the target (Manhattan
// goes up), so a greedy Manhattan picker deadlocks and the unit never moves.
// Returns a Map "x,y"→steps; tiles the unit can't route to are simply absent.
// On an open/flat field every tile's value equals its Manhattan distance, so
// movement is unchanged there.
function $9c83ba8af3a31ade$var$pathDistanceField(tx, ty, gridOrField, jump, fly) {
    const f = $9c83ba8af3a31ade$var$asField(gridOrField);
    const j = jump ?? 99;
    const inBounds = (x, y)=>x >= 0 && y >= 0 && x < f.w && y < f.h;
    const dist = new Map([
        [
            `${tx},${ty}`,
            0
        ]
    ]);
    let frontier = [
        [
            tx,
            ty
        ]
    ];
    let d = 0;
    while(frontier.length){
        d++;
        const next = [];
        for (const [cx, cy] of frontier){
            const ch = f.height(cx, cy);
            for (const [dx, dy] of [
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ]){
                const nx = cx + dx, ny = cy + dy, k = `${nx},${ny}`;
                if (dist.has(k)) continue;
                const walk = f.walkable(nx, ny);
                if (!walk && !(fly && inBounds(nx, ny))) continue; // a flier routes over in-bounds void
                if (walk && Math.abs(f.height(nx, ny) - ch) > j) continue;
                dist.set(k, d);
                next.push([
                    nx,
                    ny
                ]);
            }
        }
        frontier = next;
    }
    return dist;
}
// Move toward `target` as far as this turn allows: among the tiles the unit can
// stand on this turn, walk to the one that's nearest the target along the real
// terrain route (not as the crow flies), so it rounds walls/void instead of
// stalling against them. Manhattan distance is the tiebreak (and the fallback
// when terrain can't route to the target for this unit's Jump).
function $9c83ba8af3a31ade$var$moveToward(u, target, range, occupied, field, units = null) {
    const tiles = $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, field, units);
    const dist = $9c83ba8af3a31ade$var$pathDistanceField(target.x, target.y, field, u.jump ?? 99, !!u.canFly);
    const man = (n)=>Math.abs(n.x - target.x) + Math.abs(n.y - target.y);
    let bestKey = null, bestPath = Infinity, bestMan = Infinity;
    for (const node of tiles.values()){
        const k = `${node.x},${node.y}`;
        const pd = dist.has(k) ? dist.get(k) : Infinity;
        const m = man(node);
        if (pd < bestPath || pd === bestPath && m < bestMan) {
            bestPath = pd;
            bestMan = m;
            bestKey = k;
        }
    }
    // Terrain couldn't route to the target (disconnected for this Jump) → greedy
    // Manhattan so the unit at least edges closer rather than freezing.
    if (bestPath === Infinity) {
        bestMan = Infinity;
        for (const node of tiles.values()){
            const m = man(node);
            if (m < bestMan) {
                bestMan = m;
                bestKey = `${node.x},${node.y}`;
            }
        }
    }
    if (bestKey && bestKey !== `${u.x},${u.y}`) $9c83ba8af3a31ade$var$moveTo(u, bestKey, tiles, occupied);
}
function $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridOrField, units = null) {
    const f = $9c83ba8af3a31ade$var$asField(gridOrField);
    if (f.tiles && units) return $9c83ba8af3a31ade$var$gameReach(u, units, f);
    const allyAt = new Set(units ? units.filter((o)=>o !== u && o.alive && o.team === u.team).map((o)=>`${o.x},${o.y}`) : []);
    const jump = u.jump ?? 99; // flat field → no climb limit
    const fly = !!u.canFly;
    const inBounds = (x, y)=>x >= 0 && y >= 0 && x < f.w && y < f.h;
    const start = `${u.x},${u.y}`;
    const tiles = new Map([
        [
            start,
            {
                x: u.x,
                y: u.y,
                parent: null,
                z: f.height(u.x, u.y)
            }
        ]
    ]);
    const visited = new Set([
        start
    ]); // covers void tiles a flier passes through (never standable)
    // frontier entries: [x, y, wparent] — wparent = nearest WALKABLE ancestor key, so
    // a tile reached across a gap chains its move path back through real tiles only.
    let frontier = [
        [
            u.x,
            u.y,
            null
        ]
    ];
    for(let step = 0; step < (u.move || 0); step++){
        const next = [];
        for (const [cx, cy, wp] of frontier){
            const ch = f.height(cx, cy);
            const parentForChild = tiles.has(`${cx},${cy}`) ? `${cx},${cy}` : wp; // collapse void and allies' tiles out of the path
            for (const [dx, dy] of [
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ]){
                const nx = cx + dx, ny = cy + dy, k = `${nx},${ny}`;
                if (visited.has(k)) continue;
                const walk = f.walkable(nx, ny);
                const overVoid = fly && !walk && inBounds(nx, ny); // a flier glides over an in-bounds void tile
                if (!walk && !overVoid) continue; // wall / off-map / (non-flier) void blocks
                if (walk && Math.abs(f.height(nx, ny) - ch) > jump) continue; // can't scale past Jump
                const through = walk && occupied.has(k) && allyAt.has(k); // an ally: pass through, don't stop
                if (walk && occupied.has(k) && !through) continue; // anyone else (a foe, a body) blocks
                visited.add(k);
                next.push([
                    nx,
                    ny,
                    walk && !through ? k : parentForChild
                ]); // void tiles and allies' tiles forward their standable ancestor
                if (walk && !through) tiles.set(k, {
                    x: nx,
                    y: ny,
                    parent: parentForChild,
                    z: f.height(nx, ny)
                }); // only real, free tiles are standable; z = tile height for combat math
            }
        }
        frontier = next;
    }
    return tiles;
}
// On a real map with its tile table: the panels FFT's own pathfinder lets the unit end its move on
// (fftPath.js, exact against FFTBG's routine). Allies are walked through, foes block, bodies and
// mid-Jump units can be passed but not stopped on, crystals are free. The mover is described in the
// game's own terms: Move and the raw Jump stat (`jumpStat`; `jump` is 99 for fliers, for the BFS
// above), the movement-ability bits (`moveBits`, simPrep) and the statuses the pathfinder reads.
const $9c83ba8af3a31ade$var$statusByte = (o)=>($9c83ba8af3a31ade$var$hasStatus(o, 'Float') ? 0x40 : 0) | ($9c83ba8af3a31ade$var$hasStatus(o, 'Chicken') ? 0x04 : 0) | ($9c83ba8af3a31ade$var$frogged(o) ? 0x02 : 0) | ($9c83ba8af3a31ade$var$critical(o) ? 0x01 : 0);
// A turn asks this several times on the same board (planning, then moving), so answers are kept per
// battle, keyed on everything the pathfinder reads; nothing downstream changes the returned map.
function $9c83ba8af3a31ade$var$gameReach(u, units, f) {
    const mb = u.moveBits || {};
    let key = `${units.indexOf(u)}:${u.x},${u.y},${u.move},${u.jumpStat ?? u.jump},${$9c83ba8af3a31ade$var$statusByte(u)},${mb.f93 | 0},${mb.f94 | 0},${mb.f95 | 0}`;
    for (const o of units){
        if (o === u) continue;
        key += !o.alive ? o.dead != null ? `|b${o.x},${o.y}` : '|-' : $9c83ba8af3a31ade$var$airborne(o) ? `|b${o.x},${o.y}` : `|${o.team === u.team ? 'a' : 'f'}${o.x},${o.y},${$9c83ba8af3a31ade$var$statusByte(o) & 0x46}`;
    }
    const cache = f.reachCache || (f.reachCache = new Map());
    let hit = cache.get(key);
    if (!hit) {
        if (cache.size > 64) cache.clear();
        hit = $9c83ba8af3a31ade$var$gameReachRaw(u, units, f);
        cache.set(key, hit);
    }
    return hit;
}
function $9c83ba8af3a31ade$var$gameReachRaw(u, units, f) {
    const { w: w, h: h, tiles: tiles } = f.tiles;
    const others = [], bodies = [];
    for (const o of units){
        if (o === u) continue;
        if (!o.alive) {
            if (o.dead != null) bodies.push({
                x: o.x,
                y: o.y
            });
            continue;
        } // a crystal is no obstacle
        if ($9c83ba8af3a31ade$var$airborne(o)) {
            bodies.push({
                x: o.x,
                y: o.y
            });
            continue;
        }
        // the height of its feet and head, in half steps (the pathfinder's init, as tools/emu-battle/pathcase.mjs reads it)
        const t = (o.y * w + o.x) * 8, dep = tiles[t + 3] >> 5, float = $9c83ba8af3a31ade$var$hasStatus(o, 'Float'), f95 = o.moveBits && o.moveBits.f95 || 0;
        let base = 2 * tiles[t + 2] + (tiles[t + 3] & 0x1f);
        if (dep) base += float ? 2 * dep + 2 : f95 & 0x80 ? 2 * dep : f95 & 0x40 ? 2 * dep - 2 : 0;
        else if (float) base += 2;
        others.push({
            x: o.x,
            y: o.y,
            layer: 0,
            ally: o.team === u.team,
            base: base,
            top: base + ($9c83ba8af3a31ade$var$frogged(o) || $9c83ba8af3a31ade$var$hasStatus(o, 'Chicken') ? 4 : 6)
        });
    }
    const mover = {
        x: u.x,
        y: u.y,
        layer: 0,
        move: u.move || 0,
        jump: u.jumpStat ?? u.jump ?? 3,
        ...u.moveBits || {},
        st5a: $9c83ba8af3a31ade$var$statusByte(u)
    };
    const { reach: reach, targets: targets } = (0, $56OCP.reachTargets)(f.tiles, mover, others, {
        bodies: bodies,
        waterCost: f.waterCost
    });
    // A path for moveTo (facing and height on the way): from each panel step back to the neighbour with the
    // most move left (a leap's take-off when no neighbour has more), keeping only the panels it may stop on.
    const rem = reach.remain, leap = reach.params.leap, start = `${u.x},${u.y}`;
    const back = (x, y)=>{
        const r0 = rem[y * w + x];
        for(let d = 1; d <= 1 + leap; d++){
            let best = null, br = r0;
            for (const [dx, dy] of [
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ]){
                const nx = x + dx * d, ny = y + dy * d;
                if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
                if (rem[ny * w + nx] > br) {
                    br = rem[ny * w + nx];
                    best = [
                        nx,
                        ny
                    ];
                }
            }
            if (best) return best;
        }
        return null;
    };
    const tilesOut = new Map([
        [
            start,
            {
                x: u.x,
                y: u.y,
                parent: null,
                z: f.height(u.x, u.y)
            }
        ]
    ]);
    for (const p of targets){
        if (p >= 256) continue;
        const x = p % w, y = p / w | 0, k = `${x},${y}`;
        if (k === start) continue;
        let parent = start;
        for(let c = back(x, y); c && !(c[0] === u.x && c[1] === u.y); c = back(c[0], c[1]))if (targets.has(c[1] * w + c[0])) {
            parent = `${c[0]},${c[1]}`;
            break;
        }
        tilesOut.set(k, {
            x: x,
            y: y,
            parent: parent,
            z: f.height(x, y)
        });
    }
    return tilesOut;
}
// Walk the unit to a reachable destination (a key from reachableTiles), updating
// occupancy and facing along the reconstructed path.
function $9c83ba8af3a31ade$var$moveTo(u, destKey, tiles, occupied) {
    const path = [];
    for(let k = destKey; k && k !== `${u.x},${u.y}`; k = tiles.get(k).parent)path.push(tiles.get(k));
    for(let i = path.length - 1; i >= 0; i--){
        const node = path[i];
        occupied.delete(`${u.x},${u.y}`);
        u.facing = {
            x: Math.sign(node.x - u.x),
            y: Math.sign(node.y - u.y)
        };
        u.x = node.x;
        u.y = node.y;
        u.z = node.z ?? u.z; // keep height current for combat math
        occupied.add(`${u.x},${u.y}`);
    }
}
const $9c83ba8af3a31ade$var$BASIC = (u)=>({
        name: 'Attack',
        kind: 'damage',
        range: u.range,
        power: u.power,
        mp: 0,
        charge: 0,
        aoe: 0,
        magical: false,
        target: 'enemy',
        element: u.element || null,
        power2: u.power2 || 0,
        element2: u.element2 || null,
        projectile: u.projectile || false,
        ...u.weapon ? {
            weapon: u.weapon
        } : {}
    });
const $9c83ba8af3a31ade$var$nearest = (u, list)=>list.reduce((b, e)=>$9c83ba8af3a31ade$var$manh(u, e) < $9c83ba8af3a31ade$var$manh(u, b) ? e : b, list[0]);
// Rough "how dangerous is this unit" — best attack power scaled by frequency.
function $9c83ba8af3a31ade$var$threat(u) {
    const dmgs = (u.actions || []).filter((a)=>a.kind === 'damage').map((a)=>a.power || 0);
    return Math.max((u.power || 0) + (u.power2 || 0), ...dmgs, 0) * (Math.max(1, u.speed) / 8); // power2 = Dual Wield
}
// ---- Height in combat (FFT vertical mechanics). Each unit carries `z` = the
// height of the tile it stands on. An action reaches a target only within its
// vertical tolerance (`vRange`); projectiles (bows/guns) arc over height freely
// and gain horizontal range firing DOWNHILL. They do NOT lose horizontal range
// firing UPHILL — a bow arcs up and keeps its full reach (a past bug shrank the
// range so much firing up — −3 at a 6-height target — that an archer a couple
// tiles BELOW a foe on a structure thought it was out of range and, when a void
// blocked it from closing in, just paced the edge forever instead of shooting).
const $9c83ba8af3a31ade$var$zOf = (o)=>o.z || 0;
const $9c83ba8af3a31ade$var$VRANGE = 3; // physical-melee vertical tolerance (FFT ≈ 3 down / 2 up)
// What CLEARS a height gap: bows/guns (projectile) AND spells (magic/faith) are loosed
// or cast through the air, so they ignore vertical almost entirely — FFT mages bombard
// from clifftops and archers arc over terrain. Physical melee keeps the short ±VRANGE
// reach; Jump carries its own `vRange`. (A past bug lumped spells in with melee at 3,
// so a ridge caster on a tall map — Bariaus Valley spans 0–15 — couldn't hit valley
// foes only a few tiles away but several heights below, and just walked forward.)
const $9c83ba8af3a31ade$var$arcs = (a)=>a.projectile || a.magical || a.faith;
const $9c83ba8af3a31ade$var$vRangeOf = (a)=>a.vReach ?? ($9c83ba8af3a31ade$var$arcs(a) ? 99 : a.vRange ?? $9c83ba8af3a31ade$var$VRANGE);
const $9c83ba8af3a31ade$var$withinV = (az, tz, a)=>Math.abs(az - tz) <= $9c83ba8af3a31ade$var$vRangeOf(a); // can the height gap be cleared?
// The game's own height limits where the ability record has them (abilityFlags verticalOf, set by simPrep):
// `vReach` = how far up or down it can be aimed (only abilities flagged for it; spells and the rest have
// none), `vSpread` = how far up or down its area reaches from the centre (Fire 1, Fire 3 3, Demi 2 4).
// Without them (weapon strikes, hand-built specs) both fall back to the old rule above.
const $9c83ba8af3a31ade$var$vSpreadOf = (a)=>a.vSpread ?? ($9c83ba8af3a31ade$var$arcs(a) ? 99 : a.vRange ?? $9c83ba8af3a31ade$var$VRANGE);
const $9c83ba8af3a31ade$var$rangeBonus = (a, dz)=>a.projectile ? Math.max(0, Math.floor(dz / 2)) : 0; // dz = attacker − target height; downhill (+) extends reach; uphill keeps full range (the arc carries up)
const $9c83ba8af3a31ade$var$effRange = (a, az, tz)=>(a.range ?? 0) + $9c83ba8af3a31ade$var$rangeBonus(a, az - tz);
// ---- Math Skill (Calculator). A math-cast action carries `mathCast: {attr, key}`:
// it hits EVERY unit (both teams — friendly fire) whose CT (`ct`) or standing height
// (`z`) satisfies the number. Matching the Maps Calculator tool: only positive INTEGERS
// qualify (a sloped half-tile height or a 0 never does); `prime` → prime, else multiple.
const $9c83ba8af3a31ade$var$isPrime = (n)=>{
    if (!Number.isInteger(n) || n < 2) return false;
    for(let i = 2; i * i <= n; i++)if (n % i === 0) return false;
    return true;
};
const $9c83ba8af3a31ade$var$numberMatch = (v, key)=>Number.isInteger(v) && v > 0 && (key === 'prime' ? $9c83ba8af3a31ade$var$isPrime(v) : v % +key === 0);
// CT is CAPPED at 100 for the calculation: a unit acting is at CT ≥100 (e.g. 107) but
// counts as exactly 100, so CT×4 / CT×5 ALWAYS catch the caster while CT-Prime / CT×3
// never do. (The turn still costs the RAW value — 107−100 = 7 — which the main loop
// already subtracts; so a mime echoing the same cast a beat later re-reads the caster at
// CT 7, and a Prime cast that spared it on the original WILL clip it on the mimic.)
const $9c83ba8af3a31ade$var$mathAttrVal = (u, attr)=>attr === 'z' ? u.z || 0 : Math.min(u.ct || 0, 100);
const $9c83ba8af3a31ade$export$ba74ec6cb343363b = (action, units)=>units.filter((o)=>o.alive && !$9c83ba8af3a31ade$var$airborne(o) && !$9c83ba8af3a31ade$var$hasStatus(o, 'Petrify') && $9c83ba8af3a31ade$var$numberMatch($9c83ba8af3a31ade$var$mathAttrVal(o, action.mathCast.attr), action.mathCast.key));
function $9c83ba8af3a31ade$export$ac0600a78dcd19db(u) {
    if (!u._rebake) return;
    const f = u._rebake({
        paBonus: u.paBonus || 0,
        maBonus: u.maBonus || 0,
        removed: u.removed
    });
    u.power = f.power;
    u.power2 = f.power2;
    u.element = f.element;
    u.element2 = f.element2;
    u.weapon = f.weapon;
    u.elements = f.elements;
    u.evade = f.evade;
    if (f.evadeSrc) u.evadeSrc = f.evadeSrc;
    u.range = f.range;
    u.projectile = f.projectile;
    u.move = f.move;
    u.jump = f.jump;
    if (f.jumpStat != null) u.jumpStat = f.jumpStat;
    if (!u.mimic) u.actions = f.actions; // a mime keeps its empty action list (it acts only via mimicry)
    u.maxHp = f.hp;
    if (u.hp > u.maxHp) u.hp = u.maxHp; // lose armor → max HP drops, current clamps
    u.maxMp = f.mp;
    if ((u.mp || 0) > u.maxMp) u.mp = u.maxMp;
}
// "Field-wide": a homing ability that ALSO ignores range + height, sweeping its whole
// target team regardless of geometry. Only the 0-range performing songs/dances do this
// (Wiznaibus/Witch Hunt are 0-range 255-AoE and otherwise never fire). Summons are also
// tagged `homing` (= team-scoped, no friendly fire) but they are POSITIONAL — a real
// cast range (4) and a real height band — so they are NOT field-wide. The distinction is
// just range 0: every 255-AoE team sweeper is 0-range, every summon is range 4.
const $9c83ba8af3a31ade$var$fieldWide = (a)=>!!a.homing && (a.range || 0) === 0;
// Can the unit get an action within reach this turn (move + height-adjusted range,
// and within vertical tolerance)? (ignores obstacles — a coarse planning gate.)
const $9c83ba8af3a31ade$var$reachable = (u, target, action)=>{
    if ($9c83ba8af3a31ade$var$fieldWide(action)) return true; // 0-range songs/dances seek a whole team — no range/height limit
    const az = $9c83ba8af3a31ade$var$zOf(u), tz = $9c83ba8af3a31ade$var$zOf(target);
    if (!$9c83ba8af3a31ade$var$withinV(az, tz, action)) return false; // too far above/below to target
    return $9c83ba8af3a31ade$var$manh(u, target) - (u.move || 0) <= $9c83ba8af3a31ade$var$effRange(action, az, tz) + ($9c83ba8af3a31ade$var$splashAim(action) ? action.aoe : 0);
};
// Area spells aim at a PANEL, not a unit: FFT lets the caster centre a blast on any tile
// in range, so a unit just outside range is still caught by the splash of a tile nearer
// in (a range-4 radius-2 summon reaches 6 tiles out). The decision replay against the real
// game showed our Summoners/Wizards/Priests walking toward a foe 7-9 tiles away when the
// game cast at it from where it stood. Limited to spells/projectiles (which clear height
// anyway), so an off-unit centre never needs its own height.
const $9c83ba8af3a31ade$var$splashAim = (a)=>(a.aoe || 0) > 0 && !a.centerSelf && !a.linear && !a.mathCast && !$9c83ba8af3a31ade$var$fieldWide(a) && $9c83ba8af3a31ade$var$arcs(a);
// ---- FFT target priority (from the disassembled Target-Priority routine, 0019d6b4).
// The real AI does NOT pick the target it can damage most — it ranks foes by a
// priority value and guns for that one. The two signature drivers we can model:
//   • Caster Hate — (curMP% × #MP-using-abilities); the AI heavily prioritizes
//     mana-rich units with many spells ("it fucking hates mages").
//   • Lowest *current* HP, absolute — a 250/250 mage outranks a 300/450 knight
//     (250 < 450), so squishy low-max-HP units get focus-fired.
// Neutralized foes (can't act / charmed onto our side) are de-prioritized so the
// AI doesn't waste swings on a unit that's already out of the fight.
const $9c83ba8af3a31ade$var$mpAbilityCount = (u)=>(u.actions || []).filter((a)=>(a.mp || 0) > 0 && (a.mp || 0) <= u.mp).length;
function $9c83ba8af3a31ade$var$casterHate(t) {
    if (!t.maxMp || t.mp <= 0) return 0;
    const n = $9c83ba8af3a31ade$var$mpAbilityCount(t);
    return n ? t.mp / t.maxMp * n : 0; // ~0–N: a full-MP 3-spell mage ≈ 3
}
// Desirability of attacking foe `t` *beyond* the raw damage of the hit. Scaled as
// a nudge on the damage value (FFT's caster-hate peaks ~20 on a 0–128 HP scale,
// so ~16%), not a doubling — enough to focus-fire mages, not ignore everything else.
function $9c83ba8af3a31ade$var$targetBias(t) {
    let b = $9c83ba8af3a31ade$var$casterHate(t) * 7; // gun for casters
    b += Math.max(0, 150 - t.hp) * 0.08; // prefer low absolute current HP
    if ($9c83ba8af3a31ade$var$charmed(t)) b -= 80; // Charmed onto our side — don't attack it (it's effectively an ally now)
    return b; // NB: Stop/Sleep stay fair game — a helpless foe is an easy kill, not a wasted hit
}
function $9c83ba8af3a31ade$export$75a050ec0b549f3d(u, action, primary, units, center = primary) {
    // Self-centered blasts (Draw Out, Monk punches, monster self-AoE — `0 range`): the
    // effect radiates from the CASTER's own tile, not an aimed point, and is INDISCRIMINATE
    // — it hits everyone in the ring, friend AND foe (Draw Out distinguishes nothing, unlike
    // friend/foe-filtered Summon Magic). The caster's own tile is hit by the BENEFICIAL
    // auras (Murasame/Kiyomori/Masamune heal & buff the user too, like Chakra/Spirit of
    // Life); damaging/debuff self-blasts (Asura/Koutetsu) hit everyone in range EXCEPT the
    // caster.
    if (action.centerSelf) {
        const hitsCaster = action.sparesCaster != null ? !action.sparesCaster : action.kind === 'heal' || action.kind === 'buff' || action.kind === 'revive' || action.kind === 'mpHeal' || action.kind === 'cleanse' || action.kind === 'statmod' && action.buff;
        const out = hitsCaster ? [
            u
        ] : [];
        if (!(action.aoe > 0)) return out;
        for (const o of units){
            if (o === u || $9c83ba8af3a31ade$var$manh(o, u) > action.aoe || $9c83ba8af3a31ade$var$hasStatus(o, 'Petrify') || $9c83ba8af3a31ade$var$airborne(o) || $9c83ba8af3a31ade$var$spared(u, action, o)) continue;
            if (Math.abs($9c83ba8af3a31ade$var$zOf(o) - $9c83ba8af3a31ade$var$zOf(u)) > $9c83ba8af3a31ade$var$vSpreadOf(action)) continue;
            if (action.kind === 'revive') {
                if (!o.alive && o.team === $9c83ba8af3a31ade$var$friendTeamOf(u) || o.alive && action.undeadKill && $9c83ba8af3a31ade$export$70293f6c7be5250c(o)) out.push(o);
                continue;
            } // raises fallen allies, kills living undead
            if (o.alive) out.push(o); // positional friendly fire — both teams in the ring around the caster
        }
        return out;
    }
    // `center` is the panel the blast is aimed at: the primary unit itself, or (splashAim) a
    // tile near it, in which case only the units actually in the blast are hit.
    const onUnit = center === primary;
    const out = !onUnit || action.homing && !primary.alive ? [] : [
        primary
    ]; // a homing dance whose aim point died still sweeps the live team (don't hit the corpse)
    if (!(action.aoe > 0)) return out;
    for (const o of units){
        if (onUnit && o === primary || $9c83ba8af3a31ade$var$manh(o, center) > action.aoe || $9c83ba8af3a31ade$var$hasStatus(o, 'Petrify') || $9c83ba8af3a31ade$var$airborne(o)) continue; // friendly fire — even the caster; stone units aren't hit; airborne jumpers are off-field
        if ($9c83ba8af3a31ade$var$spared(u, action, o)) continue; // unless the game's flags say the area can't catch it (the caster, or one side)
        if (!$9c83ba8af3a31ade$var$fieldWide(action) && Math.abs($9c83ba8af3a31ade$var$zOf(o) - $9c83ba8af3a31ade$var$zOf(center)) > $9c83ba8af3a31ade$var$vSpreadOf(action)) continue; // vertical AoE band — a positional blast (incl. summons) spreads only within its height tolerance; only 0-range songs/dances are team-wide and ignore height
        if (action.kind === 'revive') {
            if (!o.alive && o.team === $9c83ba8af3a31ade$var$friendTeamOf(u) || o.alive && action.undeadKill && $9c83ba8af3a31ade$export$70293f6c7be5250c(o)) out.push(o);
            continue;
        } // raises fallen allies, kills living undead
        if (action.homing) {
            // team-scoped: a beneficial song seeks the caster's team, a hostile dance the foes
            const friendly = action.target === 'ally' || action.target === 'self';
            if (o.alive && o.team === (friendly ? $9c83ba8af3a31ade$var$friendTeamOf(u) : $9c83ba8af3a31ade$var$foeTeamOf(u))) out.push(o);
        } else if (o.alive) out.push(o); // positional AoE → friendly fire, everyone in the blast
    }
    return out;
}
// Is `t` on the side this action is "meant" to help (heal/buff a friend, hit a foe)?
const $9c83ba8af3a31ade$var$intendedTarget = (u, action, t)=>{
    const friendly = action.kind === 'heal' || action.kind === 'buff' || action.kind === 'revive';
    return t.team === (friendly ? $9c83ba8af3a31ade$var$friendTeamOf(u) : $9c83ba8af3a31ade$var$foeTeamOf(u));
};
// One strike of `action` on `t` from tile `from`, split into the damage it does when it lands
// (`dmg`, before HP clamping; negative ⇒ absorbed) and the chance it lands (`p`: hit% from
// evade + direction, times any success roll). `mp` is set instead for an MP-draining hit.
function $9c83ba8af3a31ade$var$strikeOf(u, action, t, from) {
    if ($9c83ba8af3a31ade$var$hasStatus(t, 'Petrify')) return {
        dmg: 0,
        p: 0
    }; // stone — immune; never worth aiming at
    const hit = $9c83ba8af3a31ade$var$evadeHit(u, action, t, from);
    if (action.pctMaxHp) {
        const succ = action.success != null ? $9c83ba8af3a31ade$var$successOf(u, action, t) / 100 : 1;
        const el = $9c83ba8af3a31ade$var$elementMult(action.element, t);
        return {
            dmg: Math.max(0, Math.sign(el) * Math.ceil(t.maxHp * action.pctMaxHp / 100 * Math.abs(el))),
            p: hit * Math.min(1, succ)
        };
    }
    if (action.drain === 'mp') return {
        dmg: 0,
        p: hit,
        mp: action.power || 0
    }; // MP drain (Dark Sword) — never HP
    if (action.casterMissingHp || action.targetMissingHp || action.targetCurrentMp) {
        const base = action.casterMissingHp ? (u.maxHp - u.hp) * action.casterMissingHp : action.targetCurrentMp ? t.mp || 0 : t.maxHp - t.hp;
        const succ = action.success != null ? $9c83ba8af3a31ade$var$successOf(u, action, t) / 100 : 1;
        return {
            dmg: Math.max(0, base * $9c83ba8af3a31ade$export$691e2bddd84c34f0(u, action, t)),
            p: hit * Math.min(1, succ)
        };
    }
    const exact = $9c83ba8af3a31ade$var$formulaDamage(u, action, t);
    if (exact != null) return {
        dmg: exact + (action.power2 > 0 && action.weapon ? $9c83ba8af3a31ade$var$formulaDamage(u, {
            ...action,
            strike: 2,
            element: action.element2
        }, t) || 0 : 0),
        p: hit
    };
    let dmg = action.power * $9c83ba8af3a31ade$export$691e2bddd84c34f0(u, action, t); // zodiac/faith/element (negative ⇒ absorbed)
    if (action.power2 > 0) dmg += action.power2 * $9c83ba8af3a31ade$export$691e2bddd84c34f0(u, {
        ...action,
        element: action.element2
    }, t); // Dual Wield 2nd strike
    if ($9c83ba8af3a31ade$var$takes(action, $9c83ba8af3a31ade$var$MOD_DEFENSE)) {
        if (action.magical && ($9c83ba8af3a31ade$var$hasStatus(t, 'Shell') || t.magicDefenseUp)) dmg *= 2 / 3;
        if (!action.magical && ($9c83ba8af3a31ade$var$hasStatus(t, 'Protect') || t.defenseUp)) dmg *= 2 / 3;
        dmg *= $9c83ba8af3a31ade$var$vulnMult(t, !action.magical); // charging +25% physical, asleep +50% physical, frog/chicken +50% all
    }
    return {
        dmg: dmg,
        p: hit
    };
}
// Expected HP damage of ONE strike (hit-weighted).
function $9c83ba8af3a31ade$var$expStrike(u, action, t, from) {
    const s = $9c83ba8af3a31ade$var$strikeOf(u, action, t, from);
    return s.mp ? s.mp * s.p * 0.2 : s.dmg * s.p;
}
// ---- FFT's own board evaluation, read from FFTBG's BATTLE.BIN (routine 0x8019D37C; FFTBG's is
// vanilla's). After trying an action the game scores the whole board: for each unit, 128 × HP/MaxHP,
// plus a weight for every status it carries (STATUS_W, the s16 table at 0x8019F308), plus an MP
// term for casters and 51 for each piece of gear still worn; the enemy's units count negative. An
// action is worth the CHANGE it makes. So a full bar of damage is worth 128, a kill adds Dead's
// 192, landing Stop 90, Protect on an ally 25, breaking a sword 51. Every scorer below values its
// effects on that one scale through effectValue. Notes: tools/emu-battle/refs/ai_board_evaluation.md.
const $9c83ba8af3a31ade$var$STATUS_W = {
    Crystal: -192,
    Dead: -192,
    Undead: -39,
    Petrify: -116,
    Invite: -231,
    Darkness: -64,
    Confusion: -64,
    Silence: -90,
    'Blood Suck': -116,
    Treasure: -192,
    Oil: -7,
    Float: 12,
    Reraise: 51,
    Transparent: 38,
    Berserk: -39,
    Chicken: -26,
    Frog: -52,
    Critical: -32,
    Poison: -26,
    Regen: 25,
    Protect: 25,
    Shell: 25,
    Haste: 19,
    Slow: -39,
    Stop: -90,
    Wall: 64,
    Faith: 6,
    Innocent: -7,
    Charm: -64,
    Sleep: -39,
    "Don't Move": -39,
    "Don't Act": -64,
    Reflect: 25,
    'Death Sentence': -103
};
const $9c83ba8af3a31ade$var$HP_BAR = 128, $9c83ba8af3a31ade$var$GEAR_W = 51;
// The chance a damaging skill's "Chance to add X" rider lands: FFT's 19% added-effect chance. In FFTBG's build
// 31 of 200 such hits that didn't kill added the status (15.5%), the rest of the gap being targets that
// already had it or were immune.
const $9c83ba8af3a31ade$var$RIDER_CHANCE = 0.19;
// HP a revive brings a unit back with: "Heal (N)%" of its own max HP (Raise 50, Raise 2 100, Revive 25), or
// a flat amount (Phoenix Down's Random(1,20), ~10).
const $9c83ba8af3a31ade$var$reviveHp = (action, t)=>Math.max(1, Math.min(t.maxHp, action.pct ? Math.ceil(t.maxHp * action.pct / 100) : action.power || Math.ceil(t.maxHp * 0.5)));
// Does Reflect bounce it? The game's per-ability flag when simPrep has it, else any magic.
const $9c83ba8af3a31ade$var$bounces = (action)=>action.reflectable ?? !!action.magical;
// Can an area of `action` cast by `u` catch `o`? The game's per-ability flags when simPrep has them.
const $9c83ba8af3a31ade$var$spared = (u, action, o)=>o === u && action.sparesCaster || o !== u && (action.sparesAllies && $9c83ba8af3a31ade$var$sideOf(u, o) > 0 || action.sparesEnemies && $9c83ba8af3a31ade$var$sideOf(u, o) < 0);
// Does Silence block it? The game's per-ability flag when simPrep has it, else any magic or faith skill
// (Silence doesn't stop a monster's MA-based skills, e.g. Mutilate, Eye Gouge).
const $9c83ba8af3a31ade$var$muted = (action)=>action.silenceable ?? !!(action.magical || action.faith);
const $9c83ba8af3a31ade$var$HELD = [
    'Slow',
    'Stop',
    'Sleep',
    "Don't Move",
    "Don't Act"
];
const $9c83ba8af3a31ade$var$TURNED = [
    'Confusion',
    'Blood Suck',
    'Charm'
];
// The game scales Silence by how much the unit relies on magic and Darkness by how much it relies
// on physical attacks, and the MP term by the former too: per-unit AI bytes that read 0–2 for
// casters and 0–1 for fighters in the battles we dumped. Approximated from the unit's kit.
const $9c83ba8af3a31ade$var$mpSpells = (t)=>(t.actions || []).filter((a)=>(a.mp || 0) > 0);
const $9c83ba8af3a31ade$var$magicReliance = (t)=>{
    const n = $9c83ba8af3a31ade$var$mpSpells(t).length;
    return n >= 3 ? 2 : n ? 1 : 0;
};
const $9c83ba8af3a31ade$var$physReliance = (t)=>$9c83ba8af3a31ade$var$mpSpells(t).length ? 0 : 1;
// Status part of a unit's board value, for the set of statuses S it carries.
function $9c83ba8af3a31ade$var$statusScore(t, S) {
    const turned = $9c83ba8af3a31ade$var$TURNED.some((s)=>S.has(s)), held = $9c83ba8af3a31ade$var$HELD.some((s)=>S.has(s));
    let v = 0;
    for (const s of S){
        let w = $9c83ba8af3a31ade$var$STATUS_W[s] || 0;
        if (!w || turned && w > 0) continue; // a Confused/Charmed unit's buffs don't count
        if (s === 'Darkness') w = w * $9c83ba8af3a31ade$var$physReliance(t) / 4;
        else if (s === 'Silence') w = w * $9c83ba8af3a31ade$var$magicReliance(t) / 4;
        else if ($9c83ba8af3a31ade$var$TURNED.includes(s) && held) w /= 2; // turned, but can't act on it anyway
        else if ($9c83ba8af3a31ade$var$HELD.includes(s) && turned) continue; // already neutralised by the Charm/Confusion
        v += w;
    }
    return v;
}
const $9c83ba8af3a31ade$var$isCrit = (t, hp)=>hp > 0 && hp <= Math.max(1, t.maxHp * 0.2);
const $9c83ba8af3a31ade$var$statusSetOf = (t)=>{
    const S = new Set(Object.keys(t.status || {}).filter((s)=>$9c83ba8af3a31ade$var$hasStatus(t, s)));
    if ($9c83ba8af3a31ade$var$isCrit(t, t.hp)) S.add('Critical');
    return S;
};
// Change in t's status value from adding `add` and dropping `drop` (TUNE.statusWeight scales it).
function $9c83ba8af3a31ade$var$statusDelta(t, add = [], drop = []) {
    const S = $9c83ba8af3a31ade$var$statusSetOf(t), before = $9c83ba8af3a31ade$var$statusScore(t, S);
    for (const s of drop)if (!$9c83ba8af3a31ade$var$isPermanent(t, s)) S.delete(s);
    for (const s of add)if (!$9c83ba8af3a31ade$var$immuneTo(t, s)) S.add(s);
    return ($9c83ba8af3a31ade$var$statusScore(t, S) - before) * $9c83ba8af3a31ade$var$TUNE.statusWeight;
}
// Change in t's value when its HP moves to newHp (still alive): the HP term plus Critical.
const $9c83ba8af3a31ade$var$hpDelta = (t, newHp)=>$9c83ba8af3a31ade$var$HP_BAR * (newHp - t.hp) / t.maxHp + (($9c83ba8af3a31ade$var$isCrit(t, newHp) ? 1 : 0) - ($9c83ba8af3a31ade$var$isCrit(t, t.hp) ? 1 : 0)) * $9c83ba8af3a31ade$var$STATUS_W.Critical;
// Killing t: its HP term and statuses go, Dead's weight comes in.
const $9c83ba8af3a31ade$var$killDelta = (t)=>$9c83ba8af3a31ade$var$STATUS_W.Dead - ($9c83ba8af3a31ade$var$HP_BAR * t.hp / t.maxHp + $9c83ba8af3a31ade$var$statusScore(t, $9c83ba8af3a31ade$var$statusSetOf(t)));
// Raising a dead unit to `hp`.
const $9c83ba8af3a31ade$var$reviveDelta = (t, hp)=>$9c83ba8af3a31ade$var$HP_BAR * hp / t.maxHp + ($9c83ba8af3a31ade$var$isCrit(t, hp) ? $9c83ba8af3a31ade$var$STATUS_W.Critical : 0) - $9c83ba8af3a31ade$var$STATUS_W.Dead;
// `dmg` landing on t (negative = absorbed, which heals). A hit that doesn't kill also ends the statuses
// damage ends (FFTBG's status help: Sleep, Charm, Confusion, Transparent), and the game's trial counts
// that: a Transparent Minotaur hit for 48 of 487 HP scored -51 = 12.6 for the HP + 38 for Transparent.
const $9c83ba8af3a31ade$var$ENDED_BY_DAMAGE = [
    'Sleep',
    'Charm',
    'Confusion',
    'Transparent'
];
const $9c83ba8af3a31ade$var$damageDelta = (t, dmg)=>dmg >= t.hp ? $9c83ba8af3a31ade$var$killDelta(t) : $9c83ba8af3a31ade$var$hpDelta(t, Math.min(t.maxHp, t.hp - dmg)) + (dmg > 0 ? $9c83ba8af3a31ade$var$statusDelta(t, [], $9c83ba8af3a31ade$var$ENDED_BY_DAMAGE.filter((st)=>$9c83ba8af3a31ade$var$hasStatus(t, st))) : 0);
// The MP term: 64 × MP/MaxMP, scaled by magic reliance and halved below a per-unit MP cost the
// game stores (6–34 in our dump; which spell it comes from is unknown, so we use the cheapest).
function $9c83ba8af3a31ade$var$mpTerm(t, mp) {
    if (!t.maxMp) return 0;
    const costs = $9c83ba8af3a31ade$var$mpSpells(t).map((a)=>a.mp);
    const low = costs.length && mp < Math.min(...costs) ? 0.5 : 1;
    return 64 * mp / t.maxMp * low * $9c83ba8af3a31ade$var$magicReliance(t) / 4;
}
const $9c83ba8af3a31ade$var$mpDelta = (t, d)=>$9c83ba8af3a31ade$var$mpTerm(t, Math.max(0, Math.min(t.maxMp ?? 0, (t.mp || 0) + d))) - $9c83ba8af3a31ade$var$mpTerm(t, t.mp || 0);
// +1 for a unit on the actor's side (itself included), −1 for the side it's fighting.
const $9c83ba8af3a31ade$var$sideOf = (u, t)=>t !== u && t.team === $9c83ba8af3a31ade$var$foeTeamOf(u) ? -1 : 1;
// Value of a stat change, priced in HP before the board scale existed (STAT_VALUE etc.):
// the game's board has no term for PA or Speed (and its CT term isn't decoded yet), so these keep
// their old prices, as a share of the bar.
const $9c83ba8af3a31ade$var$hpEquiv = (t, v)=>v * $9c83ba8af3a31ade$var$HP_BAR / Math.max(1, t.maxHp);
// Would the game's AI consider adding status `st` to `t`? Its "AI Ability Use Decisions" routine
// (0x8019E5D8) keeps only statuses the target lacks, then drops some by per-target flags that
// "Set type of target for all targets" (0x80194314) sets from HP at the start of each AI turn:
// Protect/Shell/Wall/Float/Faith/Reflect only on a unit at or under 80% HP, Regen/Reraise only
// under 50%. Silence only on a unit that relies on magic, Darkness only on one that relies on
// physical attacks at the game's level 2 (our 0/1 approximation never reaches it), Frog only on an
// enemy, Haste/Slow never on a Stopped or Sleeping unit. An ability is a candidate if any of its
// statuses survives; its value is still the board change of all of them (effectValue).
const $9c83ba8af3a31ade$var$AT_80_PCT = new Set([
    'Protect',
    'Shell',
    'Wall',
    'Float',
    'Faith',
    'Reflect'
]);
function $9c83ba8af3a31ade$var$aiWantsStatus(u, t, st) {
    if ($9c83ba8af3a31ade$var$hasStatus(t, st) || $9c83ba8af3a31ade$var$immuneTo(t, st)) return false;
    if ($9c83ba8af3a31ade$var$AT_80_PCT.has(st)) return 4 * t.maxHp >= 5 * t.hp;
    if (st === 'Regen' || st === 'Reraise') return t.hp < t.maxHp / 2;
    if (st === 'Silence') return $9c83ba8af3a31ade$var$magicReliance(t) > 0;
    if (st === 'Darkness') return $9c83ba8af3a31ade$var$physReliance(t) >= 2;
    if (st === 'Frog') return $9c83ba8af3a31ade$var$sideOf(u, t) < 0;
    if (st === 'Haste' || st === 'Slow') return !$9c83ba8af3a31ade$var$hasStatus(t, 'Stop') && !$9c83ba8af3a31ade$var$hasStatus(t, 'Sleep');
    return true;
}
// The statuses of `action` the AI would want on `t` (see aiWantsStatus).
const $9c83ba8af3a31ade$var$usefulStatuses = (u, t, action)=>(action.statuses || [
        action.status
    ]).filter((st)=>$9c83ba8af3a31ade$var$aiWantsStatus(u, t, st));
// What one target's share of `action` is worth to `u`, on the board scale. `from` = the tile the
// action is fired from (for hit direction).
function $9c83ba8af3a31ade$var$effectValue(u, action, t, from) {
    const side = $9c83ba8af3a31ade$var$sideOf(u, t);
    const succ = (action.success ?? 100) / 100;
    // (A "(Separate)" list counts at the quarter rate the AI gives it, as hitOf does, so value / hit is its
    // value if it lands, as the game ranks candidates.)
    const faithS = (action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) / 100 : action.faith ? succ * $9c83ba8af3a31ade$var$effFaith(t) / 50 : succ) / (action.statusMode === 'each' ? 4 : 1);
    switch(action.kind){
        case 'damage':
            {
                const { dmg: dmg, p: p, mp: mp } = $9c83ba8af3a31ade$var$strikeOf(u, action, t, from);
                if (!p) return 0;
                if (mp) {
                    const d = Math.min(mp, t.mp || 0);
                    return p * (side * $9c83ba8af3a31ade$var$mpDelta(t, -d) + $9c83ba8af3a31ade$var$mpDelta(u, d));
                }
                let v = side * p * $9c83ba8af3a31ade$var$damageDelta(t, dmg);
                if (u.sicken && !action.magical && dmg > 0 && dmg < t.hp) v += side * p * $9c83ba8af3a31ade$var$statusDelta(t, [
                    'Poison'
                ]); // Sicken: the hit poisons too
                if (action.drain === 'hp' && dmg > 0 && u.alive) v += p * $9c83ba8af3a31ade$var$hpDelta(u, Math.min(u.maxHp, u.hp + Math.min(dmg, t.hp))); // Night Sword feeds the caster
                return v;
            }
        case 'heal':
            {
                const heal = action.pct ? t.maxHp * action.pct / 100 : action.faith ? action.power * $9c83ba8af3a31ade$var$effFaith(t) / 50 : action.power;
                if ($9c83ba8af3a31ade$export$70293f6c7be5250c(t)) return side * $9c83ba8af3a31ade$var$damageDelta(t, heal); // a heal sears the undead
                let v = side * $9c83ba8af3a31ade$var$hpDelta(t, Math.min(t.maxHp, t.hp + heal));
                if (action.mpPct) v += side * $9c83ba8af3a31ade$var$mpDelta(t, (t.maxMp ?? 0) * action.mpPct / 100); // Elixir tops MP too
                return v;
            }
        case 'revive':
            if (t.alive) return action.undeadKill && $9c83ba8af3a31ade$export$70293f6c7be5250c(t) ? side * faithS * $9c83ba8af3a31ade$var$killDelta(t) : 0; // a revive destroys the undead
            return side * faithS * $9c83ba8af3a31ade$var$reviveDelta(t, $9c83ba8af3a31ade$var$reviveHp(action, t));
        case 'status':
        case 'buff':
            {
                // A buff is eligible if any of its statuses passes the AI's gate (usefulStatuses), and is then
                // worth ALL the statuses it would add, as the game's board evaluation scores the real effect:
                // Protect Spirit (Defending + Protect) on a full-HP ally passes on Defending and is worth its
                // Protect. (Valuing only the gated ones made it 0, and our Treants never cast it.)
                const list = action.kind === 'buff' ? $9c83ba8af3a31ade$var$usefulStatuses(u, t, action).length ? (action.statuses || [
                    action.status
                ]).filter((st)=>!$9c83ba8af3a31ade$var$hasStatus(t, st) && !$9c83ba8af3a31ade$var$immuneTo(t, st)) : [] : action.statuses && action.statusMode ? action.statuses : [
                    action.status
                ];
                const one = (st)=>st === 'Death' ? $9c83ba8af3a31ade$var$immuneTo(t, 'Death') ? 0 : $9c83ba8af3a31ade$var$killDelta(t) : $9c83ba8af3a31ade$var$statusDelta(t, [
                        st
                    ]);
                let d;
                // "(Random)" lands one status, but the game picks these as if the one worst for the target
                // lands: its Plague cast Look of Devil (Petrify, Darkness, Silence, Don't Move or Don't Act)
                // over Doom 6 times of 6, which an average of the five can't explain. Scored that way, the
                // decision replay matched 6 more of 662 turns. (For a buff that's its smallest useful gain.)
                // "(Separate)" rolls each at hit%/N, so about one lands, but the game's trial applies the whole
                // list: its Cheer Up candidates scored 132 = Float 12 + Reraise 51 + Transparent 38 + Regen 25 +
                // Faith 6 (Defending weighs nothing). We had the average, 22.
                if (action.statusMode === 'one' && list.length) d = Math.min(...list.map(one));
                else if (list.includes('Death') && !$9c83ba8af3a31ade$var$immuneTo(t, 'Death')) d = $9c83ba8af3a31ade$var$killDelta(t);
                else d = list.length ? $9c83ba8af3a31ade$var$statusDelta(t, list) : 0;
                return side * faithS * d;
            }
        case 'cleanse':
            {
                const present = (action.statuses || []).filter((st)=>$9c83ba8af3a31ade$var$hasStatus(t, st));
                return present.length ? side * faithS * $9c83ba8af3a31ade$var$statusDelta(t, [], present) : 0;
            }
        case 'mpHeal':
            {
                const amt = action.pct ? (t.maxMp ?? 0) * action.pct / 100 : action.power;
                return side * $9c83ba8af3a31ade$var$mpDelta(t, amt);
            }
        case 'mpDamage':
            {
                const amt = action.pctMaxMp ? (t.maxMp ?? 0) * action.pctMaxMp / 100 : action.power;
                return side * Math.min(1, faithS) * $9c83ba8af3a31ade$var$mpDelta(t, -amt);
            }
        case 'ctset':
            if (action.ct >= 100) return side * faithS * $9c83ba8af3a31ade$var$hpEquiv(t, 70); // Quick: hand an ally a near-instant turn
            return -side * faithS * $9c83ba8af3a31ade$var$hpEquiv(t, 30 + $9c83ba8af3a31ade$var$threat(t) * 0.3); // Set CT 0: stall a foe
        case 'statmod':
            {
                let mv = 0;
                for (const mod of action.mods || [])mv += Math.abs($9c83ba8af3a31ade$var$appliedDelta(t, mod)) * ($9c83ba8af3a31ade$var$STAT_VALUE[mod.stat] || 5) * Math.sign(mod.delta);
                return side * faithS * $9c83ba8af3a31ade$var$hpEquiv(t, mv);
            }
        case 'strip':
            if (side > 0 || t.removed && t.removed.has(action.slot)) return 0;
            if (t._rebake) {
                const a = t._rebake({
                    paBonus: t.paBonus || 0,
                    maBonus: t.maBonus || 0,
                    removed: new Set([
                        ...t.removed || [],
                        action.slot
                    ])
                });
                if (a.power === t.power && (a.power2 || 0) === (t.power2 || 0) && a.evade.front === t.evade.front && (a.evade.magic || 0) === (t.evade.magic || 0) && a.hp === t.maxHp && a.mp === t.maxMp) return 0;
            }
            return $9c83ba8af3a31ade$var$GEAR_W * ((action.success ?? 50) / 100);
        default:
            return 0;
    }
}
// Panels in a diamond of radius r (the multihit effect area).
const $9c83ba8af3a31ade$var$diamondPanels = (r)=>2 * r * r + 2 * r + 1;
// Value of a "(multihit)" attack: it strikes N times (N uniform in lo..hi), each on a RANDOM panel of
// the AoE diamond, so a unit in the area takes k strikes with k ~ Binomial(N, hit/panels). Scored as
// the expected board change over k, not the change of the expected damage: with Random(1,10) strikes
// on 5 panels a unit takes none ~39% of the time, and treating ~1.1 strikes' damage as a likely
// kill had our Dancer/Bard/Time Mage casting Dragon Pit, Sky Demon and Obsidian Blade ~25 times
// where FFTBG's build cast them 3 times.
function $9c83ba8af3a31ade$var$strikesDist(lo, hi, q) {
    const P = new Array(hi + 1).fill(0);
    for(let n = lo; n <= hi; n++){
        let c = 1; // C(n, k)
        for(let k = 0; k <= n; k++){
            P[k] += c * q ** k * (1 - q) ** (n - k) / (hi - lo + 1);
            c = c * (n - k) / (k + 1);
        }
    }
    return P;
}
function $9c83ba8af3a31ade$var$multihitScore(u, action, primary, units, from) {
    const panels = $9c83ba8af3a31ade$var$diamondPanels(action.aoe);
    let v = 0;
    for (const t of units){
        if (!t.alive || $9c83ba8af3a31ade$var$airborne(t) || $9c83ba8af3a31ade$var$manh(t, primary) > action.aoe || Math.abs($9c83ba8af3a31ade$var$zOf(primary) - $9c83ba8af3a31ade$var$zOf(t)) > $9c83ba8af3a31ade$var$vSpreadOf(action)) continue;
        const { dmg: dmg, p: p } = $9c83ba8af3a31ade$var$strikeOf(u, action, t, from);
        if (!p) continue;
        const P = $9c83ba8af3a31ade$var$strikesDist(action.multihit.lo, action.multihit.hi, p / panels);
        let ev = 0;
        for(let k = 1; k < P.length; k++)if (P[k]) ev += P[k] * $9c83ba8af3a31ade$var$damageDelta(t, k * dmg);
        v += $9c83ba8af3a31ade$var$sideOf(u, t) * ev;
        if (t === primary && $9c83ba8af3a31ade$var$sideOf(u, t) < 0) v += $9c83ba8af3a31ade$var$targetBias(t);
    }
    return v;
}
// Expected value of an action aimed at `primary` (used to pick the best move), on FFT's board
// scale (effectValue). `from` is the tile the action is evaluated from (defaults to where u
// stands); it only affects physical hit direction, so flanking can be scored per-tile.
// What a pending charge would do to the board, as `u`'s side counts it (the game's look-ahead lets every
// pending charge land after the trial action, so stopping one is worth the opposite). Traced in the MIPS
// interpreter: an Odin that killed a Geomancer mid-cast scored 1077, the kill (311) plus the four allies
// its pending spell would have Stopped and frozen (+193 each).
function $9c83ba8af3a31ade$var$chargeImpact(u, caster, units) {
    const ch = caster.charging;
    if (!ch || !ch.action) return 0;
    const a = ch.action;
    const at = ch.panel ? {
        x: ch.panel.x,
        y: ch.panel.y,
        z: ch.target ? $9c83ba8af3a31ade$var$zOf(ch.target) : 0
    } : ch.center ? ch.center : ch.target ? {
        x: ch.target.x,
        y: ch.target.y,
        z: $9c83ba8af3a31ade$var$zOf(ch.target)
    } : null;
    const hit = a.centerSelf ? $9c83ba8af3a31ade$export$75a050ec0b549f3d(caster, a, caster, units) : !((a.aoe || 0) > 0) ? ch.target && ch.target.alive && at && ch.target.x === at.x && ch.target.y === at.y ? [
        ch.target
    ] : [] : at ? $9c83ba8af3a31ade$export$75a050ec0b549f3d(caster, a, {}, units, at) : [];
    let v = 0;
    for (const o of hit)v += $9c83ba8af3a31ade$var$sideOf(u, o) * $9c83ba8af3a31ade$var$sideOf(caster, o) * $9c83ba8af3a31ade$var$effectValue(caster, a, o, caster);
    return v;
}
function $9c83ba8af3a31ade$var$scoreAction(u, action, primary, units, from = u, center = primary) {
    // Single-target magic that would just bounce off the target's Reflect is wasted.
    if ($9c83ba8af3a31ade$var$bounces(action) && (action.aoe || 0) === 0 && (action.kind === 'damage' || action.kind === 'status') && $9c83ba8af3a31ade$var$hasStatus(primary, 'Reflect')) return 0;
    if (!$9c83ba8af3a31ade$var$fieldWide(action) && !$9c83ba8af3a31ade$var$withinV($9c83ba8af3a31ade$var$zOf(from), $9c83ba8af3a31ade$var$zOf(center), action)) return 0; // can't clear the height gap from this tile to the aim point (team-wide songs/dances ignore height)
    if (!$9c83ba8af3a31ade$var$elementalOk(action, from)) return 0; // Geomancy: the caster's panel doesn't give this skill
    if (action.multihit) return $9c83ba8af3a31ade$var$multihitScore(u, action, center, units, from);
    let v = 0;
    for (const t of $9c83ba8af3a31ade$var$trialTargets(u, action, primary, units, center, from)){
        v += $9c83ba8af3a31ade$var$effectValue(u, action, t, from);
        if (action.kind === 'damage' && t !== u && t.charging && !action.multihit) {
            const s = $9c83ba8af3a31ade$var$strikeOf(u, action, t, from);
            if (s.p && s.dmg >= t.hp) v -= s.p * $9c83ba8af3a31ade$var$chargeImpact(u, t, units);
        }
        if (action.kind === 'damage' && t === primary && $9c83ba8af3a31ade$var$sideOf(u, t) < 0) v += $9c83ba8af3a31ade$var$targetBias(t); // the AI guns for casters/squishies
    }
    if (action.selfCost) v += $9c83ba8af3a31ade$var$damageDelta(u, action.selfCost); // the HP the caster pays (Energize, Destroy...)
    // ...and the MP: the game's trial spends it, so the caster's MP term drops (Haste: +19 for the ally, −2
    // for the Geomancer casting it, 17 in all, read off FFTBG's per-unit trial values).
    if (action.mp) v += $9c83ba8af3a31ade$var$mpDelta(u, -action.mp);
    return v;
}
// Elemental (Geomancy) is the skill the GEOMANCER's own panel gives (ELEMENTAL_BY_SURFACE, the game's
// table): standing on a wooden floor it's Will-O-Wisp, on grass Hell Ivy, whatever the target stands on.
// All 32 Elemental casts in our FFTBG battle logs match the caster's panel (13 the target's). So each
// stand tile allows one Elemental skill. The field of the turn being decided is kept here so the scorer
// can read surfaces; with no tile data (a flat or birb-terrain field) every one stays usable, as before.
const $9c83ba8af3a31ade$var$ELEMENTAL = new Set((0, $jEtWa.ELEMENTAL_BY_SURFACE).filter(Boolean));
let $9c83ba8af3a31ade$var$activeField = null;
const $9c83ba8af3a31ade$export$1b107e6458698125 = (f)=>{
    $9c83ba8af3a31ade$var$activeField = f && typeof f === 'object' ? f : null;
};
function $9c83ba8af3a31ade$var$elementalOk(action, from) {
    if (!$9c83ba8af3a31ade$var$ELEMENTAL.has(action.name) || !$9c83ba8af3a31ade$var$activeField || !$9c83ba8af3a31ade$var$activeField.surface || !from) return true;
    return (0, $jEtWa.ELEMENTAL_BY_SURFACE)[$9c83ba8af3a31ade$var$activeField.surface(from.x, from.y)] === action.name;
}
// Who the AI's trial of an action counts (0x8019DD8C, run on each candidate before scoring the board):
// everyone in its area, except that a CHARGED cast skips each unit that will get a turn, and can move,
// before it lands, since the AI expects it to walk out of the area (the flag the trial sets at +3608 on
// each such turn). Helpful spells and songs keep them (keepsMovers). A cast aimed at a unit
// (centre = primary, for abilities that follow their target) follows it: if that unit walks first it
// still counts, but alone, since the area moves with it. Read off FFTBG's trials: Shiva aimed at a
// Geomancer who would move hit him for 136 and spared the Knight beside him; aimed at the Knight, who
// wouldn't, it hit the Knight alone. Our scorer used to count both, every time.
// The game ALSO searches the same ability by panel (type 5), where the walker drops out and whoever
// stays counts, so a unit-aimed candidate is worth the better reading: trialSets gives both.
function $9c83ba8af3a31ade$var$trialSets(u, action, primary, units, center = primary) {
    const all = $9c83ba8af3a31ade$export$75a050ec0b549f3d(u, action, primary, units, center);
    if (!((action.charge || 0) > 0) || $9c83ba8af3a31ade$var$fieldWide(action) || action.jump) return [
        all
    ];
    const lands = (o)=>o === u || !o.alive || $9c83ba8af3a31ade$var$chargeLands(u, action, o);
    const stay = action.keepsMovers ? all : all.filter(lands);
    if (center === primary && action.follows && primary.alive && primary !== u && !lands(primary)) return [
        all.filter((o)=>o === primary),
        stay
    ];
    return [
        stay
    ];
}
const $9c83ba8af3a31ade$var$setValue = (u, action, set, from)=>set.reduce((v, t)=>v + $9c83ba8af3a31ade$var$effectValue(u, action, t, from), 0);
function $9c83ba8af3a31ade$var$trialTargets(u, action, primary, units, center = primary, from = u) {
    const sets = $9c83ba8af3a31ade$var$trialSets(u, action, primary, units, center);
    return sets.length === 1 ? sets[0] : sets.reduce((a, b)=>$9c83ba8af3a31ade$var$setValue(u, action, b, from) > $9c83ba8af3a31ade$var$setValue(u, action, a, from) ? b : a);
}
// Summed threat of living enemies that could strike (x,y) on their next turn —
// the positional "danger" a tile carries (Manhattan move+range, ignores blockers).
function $9c83ba8af3a31ade$var$dangerAt(x, y, enemies) {
    let d = 0;
    for (const e of enemies)if (Math.abs(e.x - x) + Math.abs(e.y - y) <= (e.move || 0) + Math.max(1, e.range || 1)) d += $9c83ba8af3a31ade$var$threat(e);
    return d;
}
// Would a charged single-target action land before its target gets a turn of its own? A charge hits a
// panel, and a target that acts first can walk off it. "See if ability should be used based on CT"
// (0x8019F0D8) says the target escapes when its ticks until a turn are at most the charge, unless it
// can't act or move then (0x8019F15C: Stop, Sleep, Don't Move, Petrify, Crystal). It does NOT exempt a
// target that is itself charging. Ticks until a turn = ceil((100 − CT) / Speed), as "Calculate
// Clockticks Until Unit Acts" (0x80199B98) does. chooseAction uses this as a preference, not a veto
// (see there). For area charges the game uses it to map where units will stand, which we don't model.
const $9c83ba8af3a31ade$var$effChargeOf = (u, action)=>Math.max(1, Math.ceil(action.charge * (u.shortCharge ? 0.5 : 1))); // what the AI believes
// How long a charge really takes. Short Charge halves it, except for Jump: the game's jump ignores
// Short Charge, but its AI still counts on it (effChargeOf), so a Short Charge Lancer jumps at
// targets it thinks it'll reach first and often lands on an empty panel.
const $9c83ba8af3a31ade$var$landChargeOf = (u, action)=>action.jump ? Math.max(1, Math.ceil(action.charge)) : $9c83ba8af3a31ade$var$effChargeOf(u, action);
function $9c83ba8af3a31ade$export$471751868d4cb744(u, action, target, units) {
    const charged = (action.charge || 0) > 0 && !(action.aoe > 0) && target !== u && target.alive;
    return {
        reachable: $9c83ba8af3a31ade$var$reachable(u, target, action),
        chargeOk: charged ? $9c83ba8af3a31ade$var$chargeLands(u, action, target) : true,
        ticks: charged ? {
            charge: $9c83ba8af3a31ade$var$effChargeOf(u, action),
            targetTurnIn: $9c83ba8af3a31ade$var$ticksUntilTurn(target),
            targetCt: target.ct
        } : null,
        value: $9c83ba8af3a31ade$var$scoreAction(u, action, target, units)
    };
}
function $9c83ba8af3a31ade$export$cbbe2ccc1a74176f(u, action, primary, units, from = u, center = primary) {
    if (!$9c83ba8af3a31ade$var$elementalOk(action, from)) return [];
    // a line attack fires a ray from the stand panel toward the aim point (lineUnits), not an area around it
    const dirTo = (c)=>Math.abs(c.x - from.x) >= Math.abs(c.y - from.y) ? {
            x: Math.sign(c.x - from.x),
            y: 0
        } : {
            x: 0,
            y: Math.sign(c.y - from.y)
        };
    const hit = action.linear ? $9c83ba8af3a31ade$export$a1711e4dcd674217(from.x, from.y, dirTo(center), action.aoe, units) : $9c83ba8af3a31ade$var$trialTargets(u, action, primary, units, center, from);
    const rows = hit.map((t)=>{
        const s = action.kind === 'damage' && !action.multihit ? $9c83ba8af3a31ade$var$strikeOf(u, action, t, from) : null;
        const cancel = s && t !== u && t.charging && s.dmg >= t.hp ? -s.p * $9c83ba8af3a31ade$var$chargeImpact(u, t, units) : 0;
        return {
            t: t,
            dmg: s ? s.dmg : null,
            p: s ? s.p : $9c83ba8af3a31ade$var$hitOf(u, action, t),
            value: $9c83ba8af3a31ade$var$effectValue(u, action, t, from) + cancel
        };
    });
    if (action.mp) rows.push({
        t: u,
        dmg: null,
        p: 1,
        value: $9c83ba8af3a31ade$var$mpDelta(u, -action.mp),
        mpCost: true
    }); // the caster's MP spent
    return rows;
}
const $9c83ba8af3a31ade$export$b582803c09aac0cd = (u)=>$9c83ba8af3a31ade$var$BASIC(u);
const $9c83ba8af3a31ade$export$52dcfda4f65381d2 = (u, action)=>({
        believed: $9c83ba8af3a31ade$var$effChargeOf(u, action),
        real: $9c83ba8af3a31ade$var$landChargeOf(u, action)
    });
const $9c83ba8af3a31ade$var$ticksUntilTurn = (t)=>t.ct >= 100 ? 0 : Math.ceil((100 - t.ct) / $9c83ba8af3a31ade$var$effSpeed(t));
const $9c83ba8af3a31ade$var$chargeLands = (u, action, t)=>$9c83ba8af3a31ade$var$cantMove(t) || $9c83ba8af3a31ade$var$effChargeOf(u, action) < $9c83ba8af3a31ade$var$ticksUntilTurn(t);
// ---- Linear (ray) attacks — Earth Slash & co. fire straight out from the caster.
const $9c83ba8af3a31ade$var$DIRS = [
    {
        x: 0,
        y: -1
    },
    {
        x: 0,
        y: 1
    },
    {
        x: 1,
        y: 0
    },
    {
        x: -1,
        y: 0
    }
];
function $9c83ba8af3a31ade$export$a1711e4dcd674217(fx, fy, d, length, units) {
    const out = [];
    for(let k = 1; k <= length; k++){
        const x = fx + d.x * k, y = fy + d.y * k;
        for (const o of units)if (o.alive && !$9c83ba8af3a31ade$var$airborne(o) && o.x === x && o.y === y) out.push(o);
    }
    return out;
}
// Signed value of a linear attack fired from (fx,fy) in direction d: every unit on the ray,
// friend or foe, on the board scale.
function $9c83ba8af3a31ade$var$lineScore(u, action, fx, fy, d, units) {
    let v = 0;
    for (const t of $9c83ba8af3a31ade$export$a1711e4dcd674217(fx, fy, d, action.aoe, units))v += $9c83ba8af3a31ade$var$effectValue(u, action, t, {
        x: fx,
        y: fy
    });
    return v;
}
// Best direction (and its value) for a linear attack fired from (fx,fy).
function $9c83ba8af3a31ade$var$bestLine(u, action, fx, fy, units) {
    let best = {
        d: $9c83ba8af3a31ade$var$DIRS[0],
        value: -Infinity
    };
    for (const d of $9c83ba8af3a31ade$var$DIRS){
        const value = $9c83ba8af3a31ade$var$lineScore(u, action, fx, fy, d, units);
        if (value > best.value) best = {
            d: d,
            value: value
        };
    }
    return best;
}
function $9c83ba8af3a31ade$export$e25e5e2e1cf311c5(u, units, occupied, gridSize, config, canMove) {
    const linears = (u.actions || []).filter((a)=>a.linear && (a.mp || 0) <= u.mp);
    if (!linears.length) return null;
    const tiles = canMove ? $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units) : new Map([
        [
            `${u.x},${u.y}`,
            {
                x: u.x,
                y: u.y,
                parent: null
            }
        ]
    ]);
    const enemies = units.filter((e)=>e.alive && !$9c83ba8af3a31ade$var$airborne(e) && e.team !== u.team);
    const dw = config.dangerWeight ?? 0.2;
    let best = null;
    for (const action of linears)for (const node of tiles.values()){
        const bl = $9c83ba8af3a31ade$var$bestLine(u, action, node.x, node.y, units);
        const net = bl.value - dw * $9c83ba8af3a31ade$var$hpEquiv(u, $9c83ba8af3a31ade$var$dangerAt(node.x, node.y, enemies));
        if (!best || net > best.net) best = {
            action: action,
            key: `${node.x},${node.y}`,
            dir: bl.d,
            value: bl.value,
            net: net
        };
    }
    return best;
}
// ---- Self-centered blasts (Draw Out, Monk punches, monster self-AoE) fire from the
// caster's OWN tile, so the AI picks the stand tile whose surrounding ring engulfs the
// most foes (and spares its own allies + itself), rather than aiming at one foe.
// Value of detonating self-centered `action` while standing at (cx,cy,cz): everyone in the
// ring, on the board scale. The caster counts only for beneficial auras (Chakra/Murasame/Kiyomori & co.).
function $9c83ba8af3a31ade$var$selfBlastValue(u, action, cx, cy, cz, units) {
    const from = {
        x: cx,
        y: cy
    };
    // A friendly blast includes the caster: heals, buffs and self pumps (Accumulate, Gather Power are
    // 0-range stat buffs on yourself, and scored 0 while the caster was skipped).
    const incCaster = action.sparesCaster != null ? !action.sparesCaster : action.kind === 'heal' || action.kind === 'buff' || action.kind === 'mpHeal' || action.kind === 'statmod' && action.buff || action.kind === 'cleanse' && !action.dispel;
    let v = 0;
    for (const t of units){
        if (!t.alive || $9c83ba8af3a31ade$var$airborne(t)) continue;
        if (t === u && !incCaster) continue; // caster spared by its own damage/debuff self-blast
        if (t !== u && $9c83ba8af3a31ade$var$spared(u, action, t)) continue;
        if ($9c83ba8af3a31ade$var$manh(from, t) > (action.aoe || 0)) continue;
        if (Math.abs(cz - $9c83ba8af3a31ade$var$zOf(t)) > $9c83ba8af3a31ade$var$vSpreadOf(action)) continue;
        if ($9c83ba8af3a31ade$var$hasStatus(t, 'Petrify')) continue;
        v += $9c83ba8af3a31ade$var$effectValue(u, action, t, from);
    }
    return v;
}
function $9c83ba8af3a31ade$export$2e5e9313ede7ee38(u, units, occupied, gridSize, config, canMove) {
    const silenced = $9c83ba8af3a31ade$var$hasStatus(u, 'Silence');
    const selfs = (u.actions || []).filter((a)=>a.centerSelf && a.kind !== 'statmod' && (a.mp || 0) <= u.mp && !(silenced && $9c83ba8af3a31ade$var$muted(a))); // stat pumps go through chooseAction (worth nothing, last resorts)
    if (!selfs.length) return null;
    const tiles = canMove ? $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units) : new Map([
        [
            `${u.x},${u.y}`,
            {
                x: u.x,
                y: u.y,
                parent: null,
                z: $9c83ba8af3a31ade$var$zOf(u)
            }
        ]
    ]);
    const enemies = units.filter((e)=>e.alive && !$9c83ba8af3a31ade$var$airborne(e) && e.team !== u.team);
    const dw = config.dangerWeight ?? 0.2;
    let best = null;
    // A heal is a candidate only when it reaches someone the AI would heal, as in chooseAction: an ally
    // under half HP (not undead) or an undead foe. Our Treants used to pulse Spirit of Life over scratches
    // (12 casts where FFTBG's cast it 4, and 4 Protect Spirits where FFTBG's cast 8).
    const healWanted = (action, x, y, z)=>units.some((o)=>o.alive && !(o === u && action.sparesCaster) && $9c83ba8af3a31ade$var$manh(o, {
                x: x,
                y: y
            }) <= (action.aoe || 0) && Math.abs($9c83ba8af3a31ade$var$zOf(o) - z) <= $9c83ba8af3a31ade$var$vSpreadOf(action) && ($9c83ba8af3a31ade$var$sideOf(u, o) > 0 ? o.hp < o.maxHp * 0.5 && !$9c83ba8af3a31ade$export$70293f6c7be5250c(o) : $9c83ba8af3a31ade$export$70293f6c7be5250c(o)));
    for (const action of selfs)for (const node of tiles.values()){
        if (action.kind === 'heal' && !healWanted(action, node.x, node.y, node.z || 0)) continue;
        const value = $9c83ba8af3a31ade$var$selfBlastValue(u, action, node.x, node.y, node.z || 0, units);
        if (value <= 0) continue;
        const net = value - dw * $9c83ba8af3a31ade$var$hpEquiv(u, $9c83ba8af3a31ade$var$dangerAt(node.x, node.y, enemies));
        if (!best || net > best.net) best = {
            action: action,
            key: `${node.x},${node.y}`,
            value: value,
            net: net
        };
    }
    return best;
}
// ---- Math Skill planning. A math-cast is free, instant and board-wide, so there's no
// tile/range to optimize — just value the units it would catch right now: foe hits +,
// friendly fire (allies AND the caster itself, if its own CT/height matches) −.
function $9c83ba8af3a31ade$var$mathScore(u, action, units) {
    // Math is a deliberate trade across BOTH teams: every unit whose CT/height matches is hit, the
    // caster's own side included, each valued on the board scale (400 to them for 200 to us is a win).
    let v = 0;
    for (const t of $9c83ba8af3a31ade$export$ba74ec6cb343363b(action, units))v += $9c83ba8af3a31ade$var$effectValue(u, action, t, u);
    return v;
}
function $9c83ba8af3a31ade$export$ae1b40343ef59d4(u, units) {
    const silenced = $9c83ba8af3a31ade$var$hasStatus(u, 'Silence');
    const casts = (u.actions || []).filter((a)=>a.mathCast && !(silenced && $9c83ba8af3a31ade$var$muted(a)));
    let best = null;
    for (const action of casts){
        const value = $9c83ba8af3a31ade$var$mathScore(u, action, units);
        if (value > 0 && (!best || value > best.value)) best = {
            action: action,
            value: value
        };
    }
    return best;
}
// Where to act from this turn, as {key, attack}. Among reachable tiles, take the
// in-range one maximizing (action value − dangerWeight·danger): this flanks to
// low-evade tiles AND, for ranged units, attacks from the safest spot that still
// hits (kiting). If even the best attack tile is worse than fleeing, hold the
// attack and retreat to the safest reachable tile. key === null → target out of
// reach this turn (the caller advances).
// FFT's danger map (AI +372, filled by "Check for good units to target", 0x8019971C): for a panel, the sum of
// 10 - distance over every enemy within 10 tiles (as the crow flies) that gets its turn no later than the
// mover's next one and can act then: not Chicken, Stop, Charm, Sleep, Don't Act (0x801998C8), or stone.
// Turn timing is "Calculate Clockticks Until Unit Acts" (0x80199B98), ceil((100 - CT) / Speed), with the
// mover counted from the CT it will have after this turn. Checked against the game's own table on 40 searches.
const $9c83ba8af3a31ade$var$DANGER_OFF = [
    'Chicken',
    'Stop',
    'Charm',
    'Sleep',
    "Don't Act",
    'Petrify'
];
function $9c83ba8af3a31ade$var$gameDangerFoes(u, units) {
    const ct = u.ct ?? 100, after = ct >= 100 ? ct - 100 : ct; // the sim takes its 100 off after the turn, the game before
    const limit = Math.ceil((100 - after) / $9c83ba8af3a31ade$var$effSpeed(u));
    return units.filter((e)=>e.alive && e.team !== u.team && !$9c83ba8af3a31ade$var$airborne(e) && !$9c83ba8af3a31ade$var$DANGER_OFF.some((st)=>$9c83ba8af3a31ade$var$hasStatus(e, st)) && $9c83ba8af3a31ade$var$ticksUntilTurn(e) <= limit);
}
const $9c83ba8af3a31ade$export$f89b7affc21d5b75 = (u, units, x, y)=>$9c83ba8af3a31ade$var$gameDanger(x, y, $9c83ba8af3a31ade$var$gameDangerFoes(u, units)); // for the decision replay's diagnostics
function $9c83ba8af3a31ade$var$gameDanger(x, y, foes) {
    let v = 0;
    for (const e of foes){
        const d = Math.abs(e.x - x) + Math.abs(e.y - y);
        if (d < 11) v += 10 - d;
    }
    return v;
}
// FFT's "value of standing there" (AI +1524, filled by "AI Target Priority Super Routine" 0x801999C8): the
// board after every pending charge lands, with the unit moved onto the panel. Traced in the MIPS
// interpreter: on each candidate panel the game resolves the charging units' spells (their Charging bit
// clears, their targets lose HP) and only the mover's own term changes with the panel, when a blast it
// would stand in catches it. Both the stand search and the move decision sort panels by this first, then
// by danger. Returns the unit's own change in value at (x, y), as its side sees it: 0 where no pending
// charge reaches, below 0 where one would catch it.
function $9c83ba8af3a31ade$var$chargeExposure(u, units, x, y, z) {
    let v = 0;
    for (const c of units){
        const ch = c.charging;
        if (c === u || !ch || !c.alive || !ch.action) continue;
        const a = ch.action;
        const at = ch.panel ? {
            x: ch.panel.x,
            y: ch.panel.y,
            z: ch.target ? $9c83ba8af3a31ade$var$zOf(ch.target) : 0
        } : ch.center ? ch.center : ch.target ? {
            x: ch.target.x,
            y: ch.target.y,
            z: $9c83ba8af3a31ade$var$zOf(ch.target)
        } : null;
        if (!at && !a.centerSelf) continue;
        const ox = u.x, oy = u.y, oz = u.z;
        u.x = x;
        u.y = y;
        u.z = z;
        let hit;
        if (a.centerSelf) hit = $9c83ba8af3a31ade$export$75a050ec0b549f3d(c, a, c, units).includes(u);
        else if (!((a.aoe || 0) > 0)) hit = x === at.x && y === at.y; // a single-target charge strikes its panel
        else hit = $9c83ba8af3a31ade$export$75a050ec0b549f3d(c, a, {}, units, at).includes(u); // an area: whoever stands in it
        if (hit) v += $9c83ba8af3a31ade$var$sideOf(c, u) * $9c83ba8af3a31ade$var$effectValue(c, a, u, c);
        u.x = ox;
        u.y = oy;
        u.z = oz;
    }
    return v;
}
const $9c83ba8af3a31ade$var$anyCharging = (u, units)=>units.some((c)=>c !== u && c.alive && c.charging && c.charging.action);
// ---- Moving without acting, and moving after acting: FFTBG's "Map movement decision" (0x8019638C) and
// "AI Post Action Movement" (0x8019693C), replayed in a MIPS interpreter on 100 captured decisions (exact,
// with the routine's own tables) before porting.
// The distance it works with is the walk from each panel to the target: "See if able to move to target"
// (0x801994F8) floods out from the target with Move 124 and the mover's own movement, the step rules run
// backwards (fftPath reverse) and no unit in the way; a Teleporter uses straight-line distance instead.
function $9c83ba8af3a31ade$var$distToTarget(u, target, units, f) {
    if (u.moveBits && u.moveBits.f94 & 0x0c) return (x, y)=>Math.abs(x - target.x) + Math.abs(y - target.y);
    if (f.tiles) {
        const mover = {
            x: target.x,
            y: target.y,
            layer: 0,
            move: 124,
            jump: u.jumpStat ?? u.jump ?? 3,
            ...u.moveBits || {},
            st5a: $9c83ba8af3a31ade$var$statusByte(u)
        };
        const r = (0, $56OCP.fftReach)(f.tiles, mover, [], {
            reverse: true,
            waterCost: f.waterCost
        });
        const top = r.remain[target.y * f.w + target.x];
        return (x, y)=>{
            const v = r.remain[y * f.w + x];
            return v ? top - v : 255;
        };
    }
    const bfs = $9c83ba8af3a31ade$var$pathDistanceField(target.x, target.y, f, u.jump ?? 99, !!u.canFly);
    return (x, y)=>bfs.get(`${x},${y}`) ?? 255;
}
// "Get Longest Range Ability or Move" (0x801962A0): Move plus the longest reach it has against enemies.
const $9c83ba8af3a31ade$var$longestReach = (u)=>(u.move || 0) + Math.max(u.range || 1, ...(u.actions || []).filter((a)=>a.target !== 'ally' && a.target !== 'self' && (a.kind === 'damage' || a.kind === 'status')).map((a)=>a.range || 0));
// Choose among `tiles`: mode 'safe' = lowest danger (ties: nearer the target, then the later tile in row
// order); mode 'near' = nearest the target (ties: lower danger, then later). `limit` caps the distance.
function $9c83ba8af3a31ade$var$pickMoveTile(cands, limit, mode) {
    let best = null;
    // the game's key: the value of standing there (pending charges, `exp`, higher first), then danger
    const key = (c)=>[
            -(c.exp || 0),
            c.danger
        ];
    const less = (a, b)=>{
        const ka = key(a), kb = key(b);
        return ka[0] !== kb[0] ? ka[0] < kb[0] : ka[1] < kb[1];
    };
    const same = (a, b)=>{
        const ka = key(a), kb = key(b);
        return ka[0] === kb[0] && ka[1] === kb[1];
    };
    for (const c of cands){
        if (c.dd > limit) continue;
        const later = !best || c.node.y > best.node.y || c.node.y === best.node.y && c.node.x >= best.node.x;
        if (!best) best = c;
        else if (mode === 'safe' ? less(c, best) || same(c, best) && (c.dd < best.dd || c.dd === best.dd && later) : c.dd < best.dd || c.dd === best.dd && (less(c, best) || same(c, best) && later)) best = c;
    }
    return best;
}
function $9c83ba8af3a31ade$export$ec423ff4c9d8995(u, target, units, f, tiles, rng = Math.random, after = false) {
    if (!target || !tiles.size) return null;
    const dist = $9c83ba8af3a31ade$var$distToTarget(u, target, units, f), foes = $9c83ba8af3a31ade$var$gameDangerFoes(u, units);
    const d = dist(u.x, u.y), R = $9c83ba8af3a31ade$var$longestReach(u);
    const charges = $9c83ba8af3a31ade$var$anyCharging(u, units);
    const all = [
        ...tiles.values()
    ].map((node)=>({
            node: node,
            dd: dist(node.x, node.y),
            danger: $9c83ba8af3a31ade$var$gameDanger(node.x, node.y, foes),
            exp: charges ? $9c83ba8af3a31ade$var$chargeExposure(u, units, node.x, node.y, node.z || 0) : 0
        }));
    let best;
    if (after) {
        if (R < d) return null;
        best = $9c83ba8af3a31ade$var$pickMoveTile(all, R - 1, 'safe') || $9c83ba8af3a31ade$var$pickMoveTile(all, Infinity, 'near');
    } else if (R >= d) {
        const c = all.filter((c)=>c.dd <= d + (u.move || 0));
        best = $9c83ba8af3a31ade$var$pickMoveTile(c.length ? c : all, Infinity, 'safe');
    } else {
        const nearer = all.filter((c)=>c.dd <= d - 1), c = nearer.length ? nearer : all;
        const r = rng() * 7 < 1 ? R >> 1 : R;
        best = $9c83ba8af3a31ade$var$pickMoveTile(c, r, 'safe') || $9c83ba8af3a31ade$var$pickMoveTile(c, Infinity, 'near');
    }
    return best ? `${best.node.x},${best.node.y}` : null;
}
// ---- The Critical AI ("AI Critical or Run Like Rabbit", 0x80198E60). A unit in Critical (or a Frog) whose
// side still has someone who isn't, two or more alive in all, decides differently ("Some targetability
// setting", 0x80194570; Death Sentence opts out). FFTBG runs it on ~11% of AI turns, in 14 of 15 battles.
// It runs to the safest panel it can reach and acts only if something beats standing there, trying itself
// first ("Find which units are active" in mode 3: only the actor is a target), then everyone else (mode 0),
// and otherwise just retreats. The retreat ("AI Cowardly Movement Routine", 0x8019905C) is the move
// decision's panel picker with no distance limit: the best value of standing there, then the lowest danger,
// ties to the panel nearer its main target, which is the nearest crystal or nearest ally who can heal
// (AI_HEALERS), itself included, else itself ("Calculate Physical Target", mode 5). Checked in a MIPS
// interpreter on FFTBG's own RAM: the rule picks the game's retreat on 26 of 26 captured turns.
const $9c83ba8af3a31ade$var$frogOrCritical = (o)=>$9c83ba8af3a31ade$var$critical(o) || $9c83ba8af3a31ade$var$frogged(o);
function $9c83ba8af3a31ade$export$ad1c6c97ef954fbb(u, units) {
    if (!$9c83ba8af3a31ade$var$frogOrCritical(u) || $9c83ba8af3a31ade$var$hasStatus(u, 'Death Sentence')) return false;
    const side = units.filter((o)=>o.alive && o.team === u.team && !$9c83ba8af3a31ade$var$hasStatus(o, 'Petrify') && !$9c83ba8af3a31ade$var$airborne(o));
    return side.length >= 2 && side.some((o)=>!$9c83ba8af3a31ade$var$frogOrCritical(o));
}
const $9c83ba8af3a31ade$var$canHeal = (o)=>(o.actions || []).some((a)=>(0, $jEtWa.AI_HEALERS).has(a.name) && (a.mp || 0) <= (o.mp || 0) && !($9c83ba8af3a31ade$var$hasStatus(o, 'Silence') && $9c83ba8af3a31ade$var$muted(a)));
function $9c83ba8af3a31ade$var$criticalMainTarget(u, units, crystals) {
    let best = null, bd = Infinity;
    const consider = (p, d)=>{
        if (d < bd) {
            bd = d;
            best = p;
        }
    };
    for (const k of crystals || []){
        const [x, y] = k.split(',').map(Number);
        consider({
            x: x,
            y: y,
            z: 0
        }, Math.abs(x - u.x) + Math.abs(y - u.y));
    }
    for (const o of units)if (o.alive && o.team === u.team && !$9c83ba8af3a31ade$var$hasStatus(o, 'Petrify') && !$9c83ba8af3a31ade$var$airborne(o) && $9c83ba8af3a31ade$var$canHeal(o)) consider(o, $9c83ba8af3a31ade$var$manh(o, u));
    return best || u;
}
function $9c83ba8af3a31ade$export$b4cc0b511682f74c(u, units, f, tiles, crystals) {
    if (!tiles.size) return null;
    const m = $9c83ba8af3a31ade$var$criticalMainTarget(u, units, crystals);
    const dist = $9c83ba8af3a31ade$var$distToTarget(u, m, units, f), foes = $9c83ba8af3a31ade$var$gameDangerFoes(u, units), charges = $9c83ba8af3a31ade$var$anyCharging(u, units);
    const all = [
        ...tiles.values()
    ].map((node)=>({
            node: node,
            dd: dist(node.x, node.y),
            danger: $9c83ba8af3a31ade$var$gameDanger(node.x, node.y, foes),
            exp: charges ? $9c83ba8af3a31ade$var$chargeExposure(u, units, node.x, node.y, node.z || 0) : 0
        }));
    const best = $9c83ba8af3a31ade$var$pickMoveTile(all, 255, 'safe');
    return best ? `${best.node.x},${best.node.y}` : null;
}
// Move there (walking the path), pick up a crystal, face the target.
function $9c83ba8af3a31ade$var$gameMove(u, target, units, occupied, crystals, f, rng, log, after = false) {
    const tiles = $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, f, units);
    const key = $9c83ba8af3a31ade$export$ec423ff4c9d8995(u, target, units, f, tiles, rng, after);
    if (key && key !== `${u.x},${u.y}`) {
        $9c83ba8af3a31ade$var$moveTo(u, key, tiles, occupied);
        $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        if (log) log.push(`${u.name} ${after ? 'falls back' : 'moves toward ' + target.name}`);
    }
    $9c83ba8af3a31ade$var$faceToward(u, target);
}
// Where to stand for `action` on `target`, as FFTBG's "Find Highest Target Priority in Ability Range"
// (0x8019BF2C) does it (read off BATTLE.BIN and replayed in a MIPS interpreter on 40 captured searches,
// which reproduce the game's chosen record byte for byte). The game pops reachable panels safest first
// (lowest danger; a tie goes to the later panel in row order) and scores each target panel once, from the
// FIRST popped panel that reaches it: the safest tile that can hit, not the best angle. A splash spell
// scores each centre that catches the target the same way and keeps the best; equal scores go to the safer
// stand panel, then to the first found. The game doesn't hold fire to back away here (no kiting): moving
// off after acting is its post-action routine. `enemies` / `dangerWeight` are unused, kept for callers.
// The reachable panels in the order the stand search pops them: out of pending blasts first, then safest,
// then the later panel in row order. The same for every ability a unit weighs in one turn.
function $9c83ba8af3a31ade$var$standOrderOf(u, units, tiles) {
    const foes = $9c83ba8af3a31ade$var$gameDangerFoes(u, units);
    const charges = $9c83ba8af3a31ade$var$anyCharging(u, units);
    return [
        ...tiles.values()
    ].map((node)=>({
            node: node,
            danger: $9c83ba8af3a31ade$var$gameDanger(node.x, node.y, foes),
            exp: charges ? $9c83ba8af3a31ade$var$chargeExposure(u, units, node.x, node.y, node.z || 0) : 0
        })).sort((a, b)=>b.exp - a.exp || a.danger - b.danger || b.node.y - a.node.y || b.node.x - a.node.x);
}
function $9c83ba8af3a31ade$var$pickStandTile(u, action, target, units, tiles, enemies, dangerWeight, field = null, order = null) {
    // On itself (a potion, Gather Power, Praise): the game aims at the panel the unit stands on now, and
    // while it weighs a stand panel it puts the unit there, so only its own panel still has it to hit.
    if (target === u && !action.centerSelf) return {
        key: `${u.x},${u.y}`,
        attack: true,
        center: target
    };
    const foes = $9c83ba8af3a31ade$var$gameDangerFoes(u, units);
    if (!order) order = $9c83ba8af3a31ade$var$standOrderOf(u, units, tiles);
    const splash = $9c83ba8af3a31ade$var$splashAim(action) ? action.aoe : 0;
    const onMap = (x, y)=>field && field.w ? x >= 0 && y >= 0 && x < field.w && y < field.h && field.walkable(x, y) : x >= 0 && y >= 0;
    const tz = $9c83ba8af3a31ade$var$zOf(target);
    const reaches = (node, c)=>{
        const az = node.z || 0;
        return $9c83ba8af3a31ade$var$elementalOk(action, node) && $9c83ba8af3a31ade$var$withinV(az, c.z ?? tz, action) && $9c83ba8af3a31ade$var$manh(node, c) <= $9c83ba8af3a31ade$var$effRange(action, az, c.z ?? tz);
    }; // (an Elemental skill only from a panel that gives it)
    // Short evadable strikes (the basic Attack with a melee weapon, Rends, Steals, monster bites...) search
    // every tile and keep the best result, so they take the angle with the best hit chance; equal results go
    // to the safer tile, then the first in row order. Everything else takes the safest tile that reaches.
    const mode = action.standSearch || (action.name === 'Attack' ? (0, $jEtWa.standSearch)('Attack', action.range || 1) : 'first');
    if (!splash && mode === 'all') {
        let best = null;
        for (const node of tiles.values()){
            if (!reaches(node, target)) continue;
            const net = $9c83ba8af3a31ade$var$scoreAction(u, action, target, units, node), danger = $9c83ba8af3a31ade$var$gameDanger(node.x, node.y, foes);
            if (!best || net > best.net || net === best.net && (danger < best.danger || danger === best.danger && (node.y < best.node.y || node.y === best.node.y && node.x < best.node.x))) best = {
                net: net,
                danger: danger,
                node: node
            };
        }
        return best ? {
            key: `${best.node.x},${best.node.y}`,
            attack: true,
            center: target
        } : {
            key: null,
            attack: false
        };
    }
    if (!splash) {
        const hit = order.find(({ node: node })=>reaches(node, target));
        return hit ? {
            key: `${hit.node.x},${hit.node.y}`,
            attack: true,
            center: target
        } : {
            key: null,
            attack: false
        };
    }
    // splash: every centre that catches the target, each scored from the first popped panel that reaches it
    let best = null;
    for(let dx = -splash; dx <= splash; dx++)for(let dy = -splash + Math.abs(dx); dy <= splash - Math.abs(dx); dy++){
        const cx = target.x + dx, cy = target.y + dy;
        if (!onMap(cx, cy)) continue;
        const c = dx || dy ? {
            x: cx,
            y: cy,
            z: tz
        } : target;
        const from = order.find(({ node: node })=>reaches(node, c));
        if (!from) continue;
        const net = $9c83ba8af3a31ade$var$scoreAction(u, action, target, units, from.node, c === target ? undefined : c);
        if (!best || net > best.net || net === best.net && from.danger < best.danger) best = {
            net: net,
            danger: from.danger,
            key: `${from.node.x},${from.node.y}`,
            center: c
        };
    }
    return best ? {
        key: best.key,
        attack: true,
        center: best.center
    } : {
        key: null,
        attack: false
    };
}
function $9c83ba8af3a31ade$export$7cf5cb98c3e7a5a9(u, action, target, units, occupied, gridSize, enemies = [], dangerWeight = 0) {
    return $9c83ba8af3a31ade$var$pickStandTile(u, action, target, units, $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), enemies, dangerWeight, $9c83ba8af3a31ade$var$asField(gridSize)).key;
}
function $9c83ba8af3a31ade$export$776134f4e8ad1ade(u, foes, occupied, gridOrField, units = null) {
    const tiles = $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridOrField, units);
    let bestKey = `${u.x},${u.y}`, bestDanger = Infinity, bestDist = -Infinity;
    for (const node of tiles.values()){
        const danger = $9c83ba8af3a31ade$var$dangerAt(node.x, node.y, foes);
        const dist = foes.length ? Math.min(...foes.map((e)=>$9c83ba8af3a31ade$var$manh(node, e))) : 0;
        if (danger < bestDanger || danger === bestDanger && dist > bestDist) {
            bestDanger = danger;
            bestDist = dist;
            bestKey = `${node.x},${node.y}`;
        }
    }
    return bestKey;
}
// How many of a buff's statuses would actually help `t` (usefulStatuses); a "pick one" buff
// (statusMode 'one'/'each') lands one of its list, so it's worth the useful fraction.
function $9c83ba8af3a31ade$var$usefulBuffs(u, t, action) {
    const n = $9c83ba8af3a31ade$var$usefulStatuses(u, t, action).length;
    return action.statuses && action.statusMode !== 'all' ? n / action.statuses.length : n;
}
// A candidate's chance to land as the game's AI records it (the +29 byte of its candidate record):
// an attack's hit chance after evasion, a status or buff's success (faith-scaled), 100% for a heal,
// and "always" (255) for a Jump.
function $9c83ba8af3a31ade$var$hitOf(u, action, t, from = u) {
    if (action.jump) return 1;
    if (action.kind === 'damage' && !action.multihit) return Math.min(1, $9c83ba8af3a31ade$var$strikeOf(u, action, t, from).p);
    if ([
        'heal',
        'revive',
        'mpHeal'
    ].includes(action.kind) && action.success == null) return 1;
    // A "(Separate)" list: the AI's hit byte is a quarter of the rate (FFTBG's Cheer Up, Hit (MA + 87)% from an
    // MA-9 Dancer, recorded 24), so the cascade takes it about one time in four.
    const base = action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) / 100 : action.faith ? (action.success ?? 100) / 100 * $9c83ba8af3a31ade$var$effFaith(t) / 50 : (action.success ?? 100) / 100;
    const ev = action.evade && action.evade !== 'none' ? $9c83ba8af3a31ade$var$evadeHit(u, action, t, from) : 1;
    // then the hit through it, rounded down: ⌊pass × hit / 100⌋ (the same routine, into the action's hit at +42)
    const hit = ev < 1 ? Math.floor(Math.round(base * 100) * Math.round(ev * 100) / 100) / 100 : base;
    return Math.max(0, Math.min(1, hit / (action.statusMode === 'each' ? 4 : 1)));
}
// Can `u` strike any of `enemies` this turn (move + its longest offensive reach)?
function $9c83ba8af3a31ade$var$canEngageOf(u, enemies) {
    const maxAtkReach = Math.max(u.range || 1, ...(u.actions || []).filter((a)=>a.kind === 'damage' || a.kind === 'status').map((a)=>a.range || 1));
    return enemies.some((e)=>$9c83ba8af3a31ade$var$manh(u, e) <= (u.move || 0) + maxAtkReach);
}
function $9c83ba8af3a31ade$export$4c3767320cfec6d5(u, units, rng, field = null, debug = null, only = null) {
    if (field) $9c83ba8af3a31ade$export$1b107e6458698125(field); // a field passed in (the harness) is the one to read surfaces from
    const foe = $9c83ba8af3a31ade$var$foeTeamOf(u), friend = $9c83ba8af3a31ade$var$friendTeamOf(u); // swapped while Charmed
    const enemies = units.filter((e)=>e.alive && !$9c83ba8af3a31ade$var$airborne(e) && e.team === foe && e !== u && !$9c83ba8af3a31ade$var$hasStatus(e, 'Petrify')); // (Charm makes own team the foe — never target self); petrified = out of the fight; airborne jumpers are untargetable
    const allies = units.filter((a)=>a.alive && a.team === friend && !$9c83ba8af3a31ade$var$hasStatus(a, 'Petrify'));
    const deadAllies = units.filter((a)=>!a.alive && a.dead != null && a.team === friend); // bodies only — a crystal can't be raised
    const basic = $9c83ba8af3a31ade$var$frogged(u) ? $9c83ba8af3a31ade$var$frogBasic(u) : $9c83ba8af3a31ade$var$BASIC(u);
    const silenced = $9c83ba8af3a31ade$var$hasStatus(u, 'Silence'); // can't cast magic / faith abilities
    // Wild Beast (nearly every monster, simPrep `noBasic`): no basic Attack action of its own. It
    // still swings when it counters, or when Berserk/Confusion take over (separate paths).
    const actions = $9c83ba8af3a31ade$var$frogged(u) ? [
        basic
    ] : [
        ...u.noBasic ? [] : [
            basic
        ],
        ...(u.actions || []).filter((a)=>(a.mp || 0) <= u.mp && !a.linear && !(a.centerSelf && a.kind !== 'statmod') && !a.mathCast && !(silenced && $9c83ba8af3a31ade$var$muted(a)))
    ]; // Frog: weak basic only; linear rays + self-centered blasts + math-casts are planned separately (self pumps such as Accumulate stay here, as last resorts)
    // The rolls the game makes before it weighs an ability (with an rng; deterministic calls skip them, which
    // is the game's roll of 0). A random multi-hit spell (Void Storage, Dragon Pit, Sky Demon...) is weighed
    // only with chance (⌊128 × such / usable⌋ + 1) / 128, its share of the unit's usable abilities, so a
    // Dancer with 2 such of 9 weighs each about one turn in four (FFTBG's lists mostly lacked them). Yell,
    // Praise and Accumulate take each target only on a coin flip.
    const usable = actions.length, shares = actions.filter((a)=>a.shareRoll).length;
    const shareOk = ()=>!rng || Math.floor(rng() * 128) <= Math.floor(128 * shares / Math.max(1, usable));
    const rolled = rng ? actions.filter((a)=>!a.shareRoll || shareOk()) : actions;
    const coinOk = (action)=>!rng || !action.coinFlip || rng() < 0.5;
    const cands = [];
    // Targets are gathered per action first (`pending`, before the reach test, like the game's
    // targetable set) so the charge-time preference below can look at all of them at once.
    let pending = [];
    const consider = (action, target)=>{
        if (target && coinOk(action) && $9c83ba8af3a31ade$var$canAffect(action, target) && !(action.noSelf && target === u) && !(only === 'self' && target !== u) && !(only === 'others' && target === u)) pending.push(target);
    }; // noSelf: the game won't aim it at its user (Cheer Up)
    const lastResort = []; // charges at targets that will walk off the panel: worth nothing (see below)
    // An Elemental skill is valued from the reachable panels that give it (see elementalOk): the best of
    // them that reaches the target, as the game's stand search tries every reachable panel.
    let geoTiles = null;
    const elementalFrom = (action, target)=>{
        if (!geoTiles) {
            geoTiles = [];
            if ($9c83ba8af3a31ade$var$activeField && $9c83ba8af3a31ade$var$activeField.surface && !$9c83ba8af3a31ade$var$cantMove(u)) {
                const occ = new Set(units.filter((o)=>o.alive && o !== u).map((o)=>`${o.x},${o.y}`));
                for (const n of $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occ, $9c83ba8af3a31ade$var$activeField, units).values())geoTiles.push({
                    x: n.x,
                    y: n.y,
                    z: $9c83ba8af3a31ade$var$activeField.height(n.x, n.y),
                    el: (0, $jEtWa.ELEMENTAL_BY_SURFACE)[$9c83ba8af3a31ade$var$activeField.surface(n.x, n.y)]
                });
            }
        }
        let best = 0;
        for (const t of geoTiles)if (t.el === action.name && $9c83ba8af3a31ade$var$manh(t, target) <= $9c83ba8af3a31ade$var$effRange(action, t.z, $9c83ba8af3a31ade$var$zOf(target))) best = Math.max(best, $9c83ba8af3a31ade$var$scoreAction(u, action, target, units, t));
        return best;
    };
    // Like the game, list only what can really be done this turn: some panel the unit can reach (or its own,
    // if it can't move) within the ability's range and height limits of the target, an area's splash
    // included. The coarse check above (Move + range as the crow flies) let our Squires rank a Death
    // Sentence on a foe behind a wall, where FFTBG's list held only Yell and Praise.
    let standTiles = null;
    const canReach = (action, target)=>{
        if (target === u || $9c83ba8af3a31ade$var$fieldWide(action)) return true;
        const f = field && typeof field === 'object' ? field : $9c83ba8af3a31ade$var$activeField;
        if (!f) return true;
        if (!standTiles) {
            const occ = new Set(units.filter((o)=>(o.alive || o.dead != null) && o !== u).map((o)=>`${o.x},${o.y}`));
            standTiles = $9c83ba8af3a31ade$var$cantMove(u) ? [
                {
                    x: u.x,
                    y: u.y,
                    z: $9c83ba8af3a31ade$var$zOf(u)
                }
            ] : [
                ...$9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occ, f, units).values()
            ].map((n)=>({
                    x: n.x,
                    y: n.y,
                    z: n.z ?? f.height(n.x, n.y)
                }));
        }
        const tz = $9c83ba8af3a31ade$var$zOf(target), splash = $9c83ba8af3a31ade$var$splashAim(action) ? action.aoe : 0;
        if (!splash) return standTiles.some((n)=>$9c83ba8af3a31ade$var$elementalOk(action, n) && $9c83ba8af3a31ade$var$withinV(n.z, tz, action) && $9c83ba8af3a31ade$var$manh(n, target) <= $9c83ba8af3a31ade$var$effRange(action, n.z, tz));
        // an area aimed at a panel beside the target: that centre must be within range of a reachable panel, and
        // the target within the area's height spread of it (FFTBG's Time Mage on low ground had no Demi 2 for a
        // foe on a cliff 8 panels up, two panels out of range: Demi 2's area spreads only 4 up or down)
        const centres = [];
        for(let dx = -splash; dx <= splash; dx++)for(let dy = -splash + Math.abs(dx); dy <= splash - Math.abs(dx); dy++){
            const cx = target.x + dx, cy = target.y + dy;
            if (f.w && (cx < 0 || cy < 0 || cx >= f.w || cy >= f.h)) continue;
            const cz = dx || dy ? f.height(cx, cy) : tz;
            if (Math.abs(tz - cz) <= $9c83ba8af3a31ade$var$vSpreadOf(action)) centres.push({
                x: cx,
                y: cy,
                z: cz
            });
        }
        return standTiles.some((n)=>$9c83ba8af3a31ade$var$elementalOk(action, n) && centres.some((c)=>$9c83ba8af3a31ade$var$withinV(n.z, c.z, action) && $9c83ba8af3a31ade$var$manh(n, c) <= $9c83ba8af3a31ade$var$effRange(action, n.z, c.z)));
    };
    // Where the hit chance is read from. Evade by facing depends on the side it comes from, and the game reads
    // the hit at the panel its stand search picks for that target, not from where the unit stands now (FFTBG's
    // Knight read Armor Rend at 82% from the target's back, where its current panel faced the shield side at
    // 37%). That's pickStandTile's panel, found here without scoring every panel: a short strike (mode 'all')
    // keeps the best result, which for a single target is the best angle, ties to the safer panel and then
    // the first in row order; anything else takes the safest panel that reaches.
    let standOrder = null;
    const angleFrom = (action, target)=>{
        if (target === u || $9c83ba8af3a31ade$var$evadeOf(action) !== 'physical') return u;
        const f = field && typeof field === 'object' ? field : $9c83ba8af3a31ade$var$activeField;
        if (!f) return u;
        if (!standOrder) {
            const occ = new Set(units.filter((o)=>(o.alive || o.dead != null) && o !== u).map((o)=>`${o.x},${o.y}`));
            const nodes = $9c83ba8af3a31ade$var$cantMove(u) ? [
                {
                    x: u.x,
                    y: u.y,
                    z: $9c83ba8af3a31ade$var$zOf(u)
                }
            ] : [
                ...$9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occ, f, units).values()
            ];
            const foes = $9c83ba8af3a31ade$var$gameDangerFoes(u, units), charges = $9c83ba8af3a31ade$var$anyCharging(u, units);
            standOrder = nodes.map((n)=>{
                const z = n.z ?? f.height(n.x, n.y);
                return {
                    node: {
                        x: n.x,
                        y: n.y,
                        z: z
                    },
                    danger: $9c83ba8af3a31ade$var$gameDanger(n.x, n.y, foes),
                    exp: charges ? $9c83ba8af3a31ade$var$chargeExposure(u, units, n.x, n.y, z) : 0
                };
            }).sort((p, q)=>q.exp - p.exp || p.danger - q.danger || q.node.y - p.node.y || q.node.x - p.node.x);
        }
        const tz = $9c83ba8af3a31ade$var$zOf(target);
        const reaches = (n)=>$9c83ba8af3a31ade$var$elementalOk(action, n) && $9c83ba8af3a31ade$var$withinV(n.z, tz, action) && $9c83ba8af3a31ade$var$manh(n, target) <= $9c83ba8af3a31ade$var$effRange(action, n.z, tz);
        const mode = action.standSearch || (action.name === 'Attack' ? (0, $jEtWa.standSearch)('Attack', action.range || 1) : 'first');
        let pick = null;
        if (mode === 'all' && !$9c83ba8af3a31ade$var$splashAim(action)) {
            let bh = -1;
            for (const o of standOrder){
                if (!reaches(o.node)) continue;
                const h = $9c83ba8af3a31ade$var$evadeHit(u, action, target, o.node);
                if (h > bh || h === bh && (o.danger < pick.danger || o.danger === pick.danger && (o.node.y < pick.node.y || o.node.y === pick.node.y && o.node.x < pick.node.x))) {
                    bh = h;
                    pick = o;
                }
            }
        } else pick = standOrder.find((o)=>reaches(o.node));
        return pick ? pick.node : u;
    };
    // The centre the stand search would aim an area at for `target` (pickStandTile), or null.
    const splashCentre = (action, target)=>{
        const f = field && typeof field === 'object' ? field : $9c83ba8af3a31ade$var$activeField;
        if (!f || target === u) return null;
        if (!standMap) {
            const occ = new Set(units.filter((o)=>(o.alive || o.dead != null) && o !== u).map((o)=>`${o.x},${o.y}`));
            standMap = $9c83ba8af3a31ade$var$cantMove(u) ? new Map([
                [
                    `${u.x},${u.y}`,
                    {
                        x: u.x,
                        y: u.y,
                        z: $9c83ba8af3a31ade$var$zOf(u)
                    }
                ]
            ]) : $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occ, f, units);
        }
        if (!splashOrder) splashOrder = $9c83ba8af3a31ade$var$standOrderOf(u, units, standMap);
        const pick = $9c83ba8af3a31ade$var$pickStandTile(u, action, target, units, standMap, [], 0, f, splashOrder);
        if (!pick.key) return null;
        const n = standMap.get(pick.key);
        return {
            center: pick.center,
            from: n ? {
                x: n.x,
                y: n.y,
                z: n.z ?? f.height(n.x, n.y)
            } : u
        };
    };
    let standMap = null, splashOrder = null;
    const evaluate = (action, target, escapes)=>{
        if (!$9c83ba8af3a31ade$var$reachable(u, target, action) || !canReach(action, target)) return;
        let v = $9c83ba8af3a31ade$var$ELEMENTAL.has(action.name) && !$9c83ba8af3a31ade$var$elementalOk(action, u) ? elementalFrom(action, target) : $9c83ba8af3a31ade$var$scoreAction(u, action, target, units);
        // A Jump is worth nothing to the game's AI too: its board evaluation leaves the jump out (read
        // off FFTBG's per-unit scores: after a Jump candidate no enemy has lost anything, the jumper's own
        // value is a few points up, the same as a turn spent doing nothing), so it jumps only when no
        // other option is worth anything, typically when no foe is in Attack reach but one is in jump range.
        let hit = $9c83ba8af3a31ade$var$hitOf(u, action, target, angleFrom(action, target));
        // An area aimed at an empty panel beside the target (the stand search keeps the centre that does the most,
        // pickStandTile) is valued there, and its hit is the average, rounded down, over everyone it catches;
        // aimed at the target's own panel, the hit is the target's (FFTBG's Bio between two foes at 80% and 100%
        // listed 90, its Haste between two allies at 74% and 64% listed 69, its Lich on a foe listed that foe's 74).
        // (Only worth searching when some other unit stands near enough to share an area with the target: alone, every
        // centre that catches it gives the same value and hit.)
        if ($9c83ba8af3a31ade$var$splashAim(action) && (action.aoe || 0) > 0 && units.some((o)=>o !== target && o.alive && $9c83ba8af3a31ade$var$manh(o, target) <= 2 * action.aoe)) {
            const sc = splashCentre(action, target), c = sc && sc.center;
            if (c && c !== target) {
                const caught = $9c83ba8af3a31ade$var$trialTargets(u, action, target, units, c, sc.from).filter((o)=>o.alive);
                if (caught.length) {
                    v = $9c83ba8af3a31ade$var$scoreAction(u, action, target, units, sc.from, c);
                    hit = Math.floor(caught.reduce((a, o)=>a + Math.round(100 * $9c83ba8af3a31ade$var$hitOf(u, action, o, sc.from)), 0) / caught.length) / 100;
                }
            }
        }
        // Stat changes are worth nothing to the game's board evaluation too (no PA/MA/Speed/Brave/Faith term):
        // in FFTBG's own candidate scores Praise and Yell tie exactly, and Accumulate, Yell and Praise tie
        // with each other, i.e. with doing nothing. So a song, dance, break, Chicken or Accumulate is a last
        // resort, cast when nothing else is worth anything (our old per-point prices had our Byblos casting
        // Chicken 15 times where FFTBG's cast it 4).
        // (A cast that follows its target is the exception: the trial follows the unit as it walks and counts
        // it, see trialTargets.)
        // Songs and dances that reach the whole side are worth nothing too: in FFTBG's candidate scores Wiznaibus
        // and Nameless Song tie exactly with an Attack that reaches no one, and Last Dance or Last Song sit a few
        // points above it. So a Dancer dances when nothing else is worth anything (FFTBG's never chose Nameless
        // Dance; ours did, valuing eight statuses on every foe).
        if (escapes && !(action.follows && !action.jump) || action.jump || action.kind === 'statmod' || $9c83ba8af3a31ade$var$fieldWide(action)) {
            if (v > 0) lastResort.push({
                action: action,
                target: target,
                v: 0,
                raw: v,
                hit: hit,
                score: 0
            });
            return;
        }
        if (v > 0) cands.push({
            action: action,
            target: target,
            v: v,
            hit: hit,
            score: hit > 0 ? v / hit : v
        });
    };
    for (const action of rolled){
        pending = [];
        gatherTargets(action);
        let targets = pending;
        // Charge-time preference ("AI ability use control routine", 0x8019B0F8, via 0x8019F01C): for a
        // single-target charge, drop the targets that will get a turn (and can move) before it lands.
        // If any target is left, choose among those, and skip the ability if none of them is in reach.
        // If every target would escape, the check is ignored and the ability stays a candidate, but the
        // board evaluation runs the clock forward to the landing and leaves out every unit that got a
        // turn first (0x8019DF0C), so it is worth nothing: the AI uses it only when it has no better
        // option, which is when FFTBG's Lancers jump at a unit that walks away (4 of 51 such turns).
        // Only enemies are screened (0x8019F01C checks a per-unit byte that is set on the actor's
        // foes), so an ally waiting on a charged heal or buff always stays a target.
        let escapes = false;
        if ((action.charge || 0) > 0 && !(action.aoe > 0)) {
            const landing = targets.filter((t)=>t === u || !t.alive || t.team !== foe || $9c83ba8af3a31ade$var$chargeLands(u, action, t));
            if (landing.length) targets = landing;
            else escapes = true;
        }
        for (const t of targets)evaluate(action, t, escapes);
    }
    function gatherTargets(action) {
        if (action.kind === 'damage') enemies.forEach((e)=>consider(action, e));
        else if (action.kind === 'status') enemies.forEach((e)=>{
            if ($9c83ba8af3a31ade$var$usefulStatuses(u, e, action).length) consider(action, e);
        });
        else if (action.kind === 'heal') {
            allies.forEach((a)=>{
                if (a.hp < a.maxHp * 0.5 && !$9c83ba8af3a31ade$export$70293f6c7be5250c(a)) consider(action, a);
            });
            enemies.forEach((e)=>{
                if ($9c83ba8af3a31ade$export$70293f6c7be5250c(e)) consider(action, e);
            });
        } else if (action.kind === 'buff') (action.target === 'self' ? [
            u
        ] : allies).forEach((a)=>{
            if ($9c83ba8af3a31ade$var$usefulBuffs(u, a, action) > 0) consider(action, a);
        });
        else if (action.kind === 'revive') {
            deadAllies.forEach((d)=>{
                if ($9c83ba8af3a31ade$var$hasStatus(d, 'Reraise') || (action.charge || 0) > 0 && $9c83ba8af3a31ade$var$crystalTicks(d) < $9c83ba8af3a31ade$var$effChargeOf(u, action)) return;
                consider(action, d);
            });
            if (action.undeadKill) enemies.forEach((e)=>{
                if ($9c83ba8af3a31ade$export$70293f6c7be5250c(e)) consider(action, e);
            });
        } else if (action.kind === 'mpDamage') enemies.forEach((e)=>{
            if ((e.mp || 0) > 0) consider(action, e);
        });
        else if (action.kind === 'mpHeal') allies.forEach((a)=>{
            if ((a.mp || 0) < (a.maxMp ?? 0) * 0.6 && $9c83ba8af3a31ade$var$mpAbilityCount(a)) consider(action, a);
        });
        else if (action.kind === 'cleanse') (action.dispel ? enemies : allies).forEach((o)=>{
            if ((action.statuses || []).some((s)=>$9c83ba8af3a31ade$var$hasStatus(o, s))) consider(action, o);
        });
        else if (action.kind === 'ctset') {
            if (action.ct >= 100) allies.forEach((a)=>{
                if (a !== u) consider(action, a);
            });
            else enemies.forEach((e)=>consider(action, e));
        } else if (action.kind === 'statmod') {
            if (action.buff) [
                u,
                ...allies
            ].forEach((a)=>consider(action, a));
            else enemies.forEach((e)=>consider(action, e));
        } else if (action.kind === 'strip') enemies.forEach((e)=>{
            if (!(e.removed && e.removed.has(action.slot))) consider(action, e);
        });
    }
    // How the game picks (FFTBG's BATTLE.BIN): "Set Highest Target Priority" keeps the 8 best
    // candidates ranked by their score IF THEY LAND, hit chance aside (only a tiebreak); then "Randomly
    // Transfer Data" (0x801970BC) walks that list in order and takes entry k when rand() % 100 is
    // under its hit % (the record's +29), falling back to the first. So an Attack at 68% is taken 68%
    // of the time and otherwise the roll falls through, often to a Jump (hit 255: always taken), which
    // is why FFTBG's Lancers jump about a third of the time they could attack. The worthless
    // candidates (jumps, charges at escaping targets) sit at the bottom of the list to catch those
    // fall-throughs. With no rng, the first entry (deterministic, for tests).
    cands.sort((a, b)=>Math.round(b.score) - Math.round(a.score) || b.hit - a.hit); // integer scores as the game's, then hit % (0x80196DB0)
    lastResort.sort((a, b)=>b.raw - a.raw);
    const ranked = [
        ...cands,
        ...lastResort
    ];
    if (debug) debug.push(...ranked);
    if (!ranked.length && only) return null; // the Critical AI's passes don't fall back to an advance
    if (!ranked.length) return enemies.length ? {
        action: basic,
        target: $9c83ba8af3a31ade$var$nearest(u, enemies),
        ...u.noBasic && !$9c83ba8af3a31ade$var$frogged(u) ? {
            advanceOnly: true
        } : {}
    } : null; // advance
    let pick = ranked[0];
    if (rng) {
        const top = ranked.slice(0, 8);
        pick = top.find((c)=>rng() * 100 < c.hit * 100) || ranked[0];
    }
    // Ninja Throw nerf (FFTBG): once throwing is chosen, the projectile is a COINFLIP — 50%
    // the best (highest-damage) throw, 50% the basic (lowest-power, i.e. shuriken/bomb) —
    // rather than always the optimum. (Throws all fly the same distance, so a perfect AI
    // would always pick the hardest hitter; the real bot doesn't.)
    if (rng && pick.action.thrown) {
        const throws = (u.actions || []).filter((a)=>a.thrown && (a.mp || 0) <= u.mp);
        if (throws.length > 1) {
            const best = throws.reduce((b, a)=>a.power > b.power ? a : b, throws[0]);
            const basicT = throws.reduce((b, a)=>a.power < b.power ? a : b, throws[0]);
            return {
                action: rng() < 0.5 ? basicT : best,
                target: pick.target
            };
        }
    }
    return {
        action: pick.action,
        target: pick.target
    };
}
const $9c83ba8af3a31ade$var$unitAt = (x, y, units)=>units.find((o)=>o.alive && o.x === x && o.y === y) || null;
// Apply one action's effect to a single target (shared by normal resolution and
// the mime reaction). Exported for tests.
// What an ability can affect at all. "Hit: Human;" (the talk skills) skips monsters, "Hit: Undead;" (Seal Evil)
// everything but the undead, and FFTBG's Sleep help: "Unit is unaffected by Talk Skill and recurring
// abilities" (FFTBG's Squire, a sleeping Monk in reach, listed only Yell and Praise; no Death Sentence).
const $9c83ba8af3a31ade$var$canAffect = (action, t)=>!(action.only === 'Human' && (t.gender === 'Monster' || $9c83ba8af3a31ade$var$hasStatus(t, 'Sleep')) || action.only === 'Undead' && !$9c83ba8af3a31ade$export$70293f6c7be5250c(t) || $9c83ba8af3a31ade$var$fieldWide(action) && $9c83ba8af3a31ade$var$hasStatus(t, 'Sleep'));
function $9c83ba8af3a31ade$export$59a7b217c53300d2(u, action, t, occupied, rng, log) {
    if (!$9c83ba8af3a31ade$var$canAffect(action, t)) {
        if (log) log.push(`${t.name} is unaffected by ${u.name}'s ${action.name}`);
        return;
    }
    // An evadable status or other effect (Slow and Stop by M-Ev, Beak and Goo by evade by facing) can be dodged
    // too; a damaging one rolls its own in dealAttack.
    if (action.kind !== 'damage' && action.evade && action.evade !== 'none') {
        const ev = $9c83ba8af3a31ade$var$evadeHit(u, action, t, u);
        if (ev < 1 && rng() >= ev) {
            if (log) log.push(`${t.name} evades ${u.name}'s ${action.name}`);
            return;
        }
    }
    if (action.kind === 'damage') $9c83ba8af3a31ade$var$dealAttack(u, action, t, occupied, rng, log, false);
    else if (action.kind === 'heal') {
        // `pct` heals a fraction of MAX HP (Elixir/items); else a flat (faith-scaled) amount.
        const amt = action.pct ? Math.max(1, Math.round(t.maxHp * action.pct / 100)) : action.faith ? Math.max(1, Math.round(action.power * $9c83ba8af3a31ade$var$effFaith(t) / 50)) : action.power; // Cure-type heals scale with target faith
        if ($9c83ba8af3a31ade$export$70293f6c7be5250c(t)) {
            t.hp -= amt;
            if (log) log.push(`${u.name}'s ${action.name} sears undead ${t.name} \u{2212}${amt} \u{2192} ${Math.max(0, t.hp)}`);
            if (t.hp <= 0) $9c83ba8af3a31ade$var$kill(t, occupied, log);
        } else {
            const before = t.hp;
            t.hp = Math.min(t.maxHp, t.hp + amt);
            if (log) log.push(`${u.name}'s ${action.name} heals ${t.name} +${t.hp - before} \u{2192} ${t.hp}`);
        }
        if (action.mpPct) t.mp = Math.min(t.maxMp ?? t.mp, (t.mp || 0) + Math.round((t.maxMp ?? 0) * action.mpPct / 100)); // Elixir also tops MP
    } else if (action.kind === 'mpHeal') {
        const amt = action.pct ? Math.round((t.maxMp ?? 0) * action.pct / 100) : action.power;
        const before = t.mp || 0;
        t.mp = Math.min(t.maxMp ?? t.mp, before + amt);
        if (log) log.push(`${u.name}'s ${action.name} restores ${t.mp - before} MP to ${t.name}`);
    } else if (action.kind === 'mpDamage') {
        const succ = action.success != null ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100;
        if (rng() * 100 < succ) {
            const amt = action.pctMaxMp ? Math.round((t.maxMp ?? 0) * action.pctMaxMp / 100) : action.power;
            const d = Math.min(amt, t.mp || 0);
            t.mp -= d;
            if (action.drain === 'mp' && u.alive) u.mp = Math.min(u.maxMp ?? u.mp, (u.mp || 0) + d); // Siphon (AbsorbMP) feeds the caster
            if (log) log.push(`${u.name}'s ${action.name} ${action.drain === 'mp' ? 'drains' : 'burns'} ${d} MP from ${t.name}`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    } else if (action.kind === 'cleanse') {
        const succ = action.success != null || action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100;
        if (rng() * 100 < succ) {
            const removed = (action.statuses || []).filter((s)=>$9c83ba8af3a31ade$var$hasStatus(t, s) && !$9c83ba8af3a31ade$var$isPermanent(t, s)); // gear/class statuses can't be stripped
            for (const s of removed)delete t.status[s];
            if (log && removed.length) log.push(`${u.name}'s ${action.name} cleanses ${t.name} (${removed.join(', ')})`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    } else if (action.kind === 'ctset') {
        const succ = action.success != null || action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100;
        if (rng() * 100 < succ) {
            t.ct = action.ct;
            if (log) log.push(`${u.name}'s ${action.name}: ${t.name} CT \u{2192} ${action.ct}`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    } else if (action.kind === 'statmod') {
        const succ = action.success != null || action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100;
        if (rng() * 100 < succ) {
            let reb = false;
            for (const mod of action.mods || []){
                const d = $9c83ba8af3a31ade$var$appliedDelta(t, mod);
                if (!d) continue;
                if (mod.stat === 'pa') {
                    t.paBonus = (t.paBonus || 0) + d;
                    reb = true;
                } else if (mod.stat === 'ma') {
                    t.maBonus = (t.maBonus || 0) + d;
                    reb = true;
                } else if (mod.stat === 'speed') t.speed += d;
                else if (mod.stat === 'brave') t.brave = (t.brave ?? 50) + d;
                else if (mod.stat === 'faith') t.faith = (t.faith ?? 50) + d;
            }
            if (reb) $9c83ba8af3a31ade$export$ac0600a78dcd19db(t); // PA/MA changed → refresh this unit's baked damage numbers
            if (log) log.push(`${u.name}'s ${action.name}: ${t.name} ${(action.mods || []).map((m)=>`${m.delta > 0 ? '+' : ''}${m.delta} ${m.stat.toUpperCase()}`).join(', ')}`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    } else if (action.kind === 'strip') {
        const succ = action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : action.success ?? 50;
        if (rng() * 100 < succ) {
            t.removed = t.removed || new Set();
            if (!t.removed.has(action.slot)) {
                t.removed.add(action.slot);
                $9c83ba8af3a31ade$export$ac0600a78dcd19db(t);
                if (log) log.push(`${u.name}'s ${action.name} strips ${t.name}'s ${action.slot}`);
            } else if (log) log.push(`${t.name} has no ${action.slot} to take`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    } else if (action.kind === 'revive') {
        const succ = action.success != null || action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100;
        if (!(rng() * 100 < succ)) {
            if (log) log.push(`${u.name}'s ${action.name} fails on ${t.name}`);
        } else if (action.undeadKill && t.alive && $9c83ba8af3a31ade$export$70293f6c7be5250c(t)) {
            t.hp = 0;
            $9c83ba8af3a31ade$var$kill(t, occupied, log);
            if (log) log.push(`${u.name}'s ${action.name} destroys undead ${t.name}`);
        } else if (!t.alive) {
            t.alive = true;
            t.dead = null;
            t.hp = $9c83ba8af3a31ade$var$reviveHp(action, t);
            occupied.add(`${t.x},${t.y}`);
            if (log) log.push(`${u.name}'s ${action.name} revives ${t.name} \u{2192} ${t.hp}`);
        }
    } else if (action.kind === 'status' || action.kind === 'buff') {
        const succ = action.success != null || action.hit ? $9c83ba8af3a31ade$var$successOf(u, action, t) : 100; // faith magic: real target faith gates it (Innocent ⇒ ~0)
        const put = (st)=>{
            if (st === 'Death') {
                if (!$9c83ba8af3a31ade$var$immuneTo(t, 'Death')) {
                    t.hp = 0;
                    $9c83ba8af3a31ade$var$kill(t, occupied, log);
                }
            } else $9c83ba8af3a31ade$var$addStatus(t, st);
        }; // each status's own FFT length (STATUS_TICKS / OWN_TURNS)
        if (action.statuses && action.statusMode) {
            const got = [];
            if (action.statusMode === 'one') {
                if (rng() * 100 < succ) {
                    const st = action.statuses[Math.floor(rng() * action.statuses.length)];
                    put(st);
                    got.push(st);
                }
            } else if (action.statusMode === 'all') {
                if (rng() * 100 < succ) for (const st of action.statuses){
                    if (!t.alive) break;
                    put(st);
                    got.push(st);
                }
            } else for (const st of action.statuses){
                if (!t.alive) break;
                if (rng() * 100 < succ / action.statuses.length) {
                    put(st);
                    got.push(st);
                }
            }
            if (log) log.push(got.length ? `${u.name}'s ${action.name}: ${t.name} \u{2192} ${got.join(', ')}` : `${t.name} resists ${u.name}'s ${action.name}`);
        } else if (rng() * 100 < succ) {
            put(action.status);
            if (log) log.push(`${u.name}'s ${action.name}: ${t.name} \u{2192} ${action.status}`);
        } else if (log) log.push(`${t.name} resists ${u.name}'s ${action.name}`);
    }
}
// A mime copies an ally's action from its OWN tile at the same relative offset.
// Single-target hits whoever stands on the offset tile (or whiffs into empty
// space); AoE blankets that tile (friendly fire). Un-clever, exactly the offset —
// the mime never re-aims. Uses the mime's own stats (its mimicTable entry).
function $9c83ba8af3a31ade$var$resolveMimic(m, action, cx, cy, units, occupied, rng, log) {
    // Self-centered echo (Draw Out & co.): the burst is centered on the MIME and spares it
    // exactly as it spared the original caster (Draw Out never hits the user). Reuse the
    // normal centerSelf collection so the caster-exclusion + vertical band are honored.
    if (action.centerSelf) {
        for (const t of $9c83ba8af3a31ade$export$75a050ec0b549f3d(m, action, m, units))$9c83ba8af3a31ade$export$59a7b217c53300d2(m, action, t, occupied, rng, log);
        return;
    }
    // Homing echo (songs/dances): stays TEAM-scoped from the mime's side (don't blanket
    // everyone at the offset) — a mimed song buffs the mime's team, a mimed dance hits foes.
    if (action.homing) {
        const friendly = action.target === 'ally' || action.target === 'self';
        for (const o of units)if (o.alive && o.team === (friendly ? $9c83ba8af3a31ade$var$friendTeamOf(m) : $9c83ba8af3a31ade$var$foeTeamOf(m))) $9c83ba8af3a31ade$export$59a7b217c53300d2(m, action, o, occupied, rng, log);
        return;
    }
    if (!(action.aoe > 0)) {
        const t = $9c83ba8af3a31ade$var$unitAt(cx, cy, units);
        if (t) $9c83ba8af3a31ade$export$59a7b217c53300d2(m, action, t, occupied, rng, log);
        else if (log) log.push(`${m.name}'s mimic hits nothing`);
        return;
    }
    const center = {
        x: cx,
        y: cy
    };
    for (const o of units){
        if ($9c83ba8af3a31ade$var$manh(o, center) > action.aoe) continue;
        if (action.kind === 'revive') {
            if (!o.alive && o.dead != null) $9c83ba8af3a31ade$export$59a7b217c53300d2(m, action, o, occupied, rng, log);
        } else if (o.alive) $9c83ba8af3a31ade$export$59a7b217c53300d2(m, action, o, occupied, rng, log);
    }
}
// A mime echoes a teammate's MATH-CAST: it re-runs the same calculation (attribute ×
// number) with the mime's OWN spell power, re-evaluated NOW — so it reads the current
// board, including the original caster's post-turn CT (107→7), which can catch units the
// original cast spared. (The mime has no calc params of its own; it copies the math.)
function $9c83ba8af3a31ade$var$triggerMathMimics(actor, action, units, occupied, rng, log) {
    for (const m of units){
        if (!m.mimic || !m.alive || m === actor || m.team !== actor.team || $9c83ba8af3a31ade$var$stopped(m)) continue;
        const base = m.mimicTable && m.mimicTable[action.baseName]; // the mime's own-stat copy of the spell
        if (!base) continue;
        const a = {
            ...base,
            mathCast: action.mathCast,
            mp: 0,
            charge: 0,
            range: 99,
            aoe: 0,
            name: action.name
        };
        if (log) log.push(`${m.name} mimics ${action.name}`);
        for (const t of $9c83ba8af3a31ade$export$ba74ec6cb343363b(a, units))$9c83ba8af3a31ade$export$59a7b217c53300d2(m, a, t, occupied, rng, log);
    }
}
// When a non-mime acts, each living mime teammate echoes the action from its own
// position at the same target offset (a reaction, not a chosen turn). It uses the
// mime's own-stat copy of that ability (mimicTable), or its own basic for 'Attack'.
function $9c83ba8af3a31ade$var$triggerMimics(actor, action, primary, units, occupied, rng, log) {
    const dx = primary.x - actor.x, dy = primary.y - actor.y;
    // Charge+N is a synthesized boosted basic (not a parser ability, so not in the mimic
    // table) — a mime echoes it as its OWN basic swing, like a plain Attack.
    const basicLike = action.name === 'Attack' || /^Charge\+\d+$/.test(action.name);
    for (const m of units){
        if (!m.mimic || !m.alive || m === actor || m.team !== actor.team || $9c83ba8af3a31ade$var$stopped(m)) continue;
        const a = basicLike ? {
            ...$9c83ba8af3a31ade$var$BASIC(m)
        } : m.mimicTable && m.mimicTable[action.name];
        if (!a) continue;
        const cx = m.x + dx, cy = m.y + dy;
        $9c83ba8af3a31ade$var$faceToward(m, {
            x: cx,
            y: cy
        });
        if (log) log.push(`${m.name} mimics ${action.name}`);
        $9c83ba8af3a31ade$var$resolveMimic(m, a, cx, cy, units, occupied, rng, log);
    }
}
// Resolve a linear attack: ray from the caster's tile in direction d, hitting every
// unit along it (friendly fire). Teammate mimes echo the same ray from their tile.
function $9c83ba8af3a31ade$var$resolveLinear(u, action, d, units, occupied, rng, log) {
    for (const t of $9c83ba8af3a31ade$export$a1711e4dcd674217(u.x, u.y, d, action.aoe, units))$9c83ba8af3a31ade$export$59a7b217c53300d2(u, action, t, occupied, rng, log);
    if (u.mimic) return;
    for (const m of units){
        if (!m.mimic || !m.alive || m === u || m.team !== u.team || $9c83ba8af3a31ade$var$stopped(m)) continue;
        const a = m.mimicTable && m.mimicTable[action.name];
        if (!a) continue;
        m.facing = {
            ...d
        };
        if (log) log.push(`${m.name} mimics ${action.name}`);
        for (const t of $9c83ba8af3a31ade$export$a1711e4dcd674217(m.x, m.y, d, a.aoe, units))$9c83ba8af3a31ade$export$59a7b217c53300d2(m, a, t, occupied, rng, log);
    }
}
// A "(multihit)" attack: strike Random(lo,hi) times, each landing on a RANDOM
// panel in the AoE diamond around the aim point — a strike on an empty/off-map
// panel is wasted; a panel with a unit (either team — friendly fire) gets hit.
function $9c83ba8af3a31ade$var$resolveMultihit(u, action, primary, units, occupied, rng, log) {
    const { lo: lo, hi: hi } = action.multihit;
    const n = lo + Math.floor(rng() * (hi - lo + 1));
    const panels = [];
    for(let dx = -action.aoe; dx <= action.aoe; dx++)for(let dy = -action.aoe; dy <= action.aoe; dy++)if (Math.abs(dx) + Math.abs(dy) <= action.aoe) panels.push([
        primary.x + dx,
        primary.y + dy
    ]);
    if (log) log.push(`${u.name}'s ${action.name} strikes ${n}\xd7 across the area`);
    for(let k = 0; k < n; k++){
        const [px, py] = panels[Math.floor(rng() * panels.length)];
        const t = units.find((o)=>o.alive && !$9c83ba8af3a31ade$var$airborne(o) && o.x === px && o.y === py);
        if (t && $9c83ba8af3a31ade$var$withinV($9c83ba8af3a31ade$var$zOf(u), $9c83ba8af3a31ade$var$zOf(t), action)) $9c83ba8af3a31ade$var$dealAttack(u, action, t, occupied, rng, log, false);
    }
}
// FFTBG's status help: "Transparent: Until the unit acts or is damaged, attacks used by it cannot be
// evaded." Acting ends it, once the action has gone off (its own attack still can't be dodged).
function $9c83ba8af3a31ade$var$resolveAction(u, action, primary, units, occupied, rng, log, center = primary) {
    try {
        $9c83ba8af3a31ade$var$resolveActionOn(u, action, primary, units, occupied, rng, log, center);
    } finally{
        if (u.status && u.status.Transparent && !$9c83ba8af3a31ade$var$isPermanent(u, 'Transparent')) delete u.status.Transparent;
    }
}
function $9c83ba8af3a31ade$var$resolveActionOn(u, action, primary, units, occupied, rng, log, center = primary) {
    // Math Skill: instant, board-wide, free. Apply the spell single-target to every unit
    // whose CT/height satisfies the number — both teams (friendly fire), no range/LOS.
    if (action.mathCast) {
        const targets = $9c83ba8af3a31ade$export$ba74ec6cb343363b(action, units);
        if (log) log.push(`${u.name} calculates ${action.name} (${targets.length} hit)`);
        for (const t of targets)$9c83ba8af3a31ade$export$59a7b217c53300d2(u, action, t, occupied, rng, log);
        if (!u.mimic) $9c83ba8af3a31ade$var$triggerMathMimics(u, action, units, occupied, rng, log); // teammates' mimes re-run the calculation
        return;
    }
    // Reflect: single-target magic bounces off the target toward the caster's side.
    if ($9c83ba8af3a31ade$var$bounces(action) && (action.aoe || 0) === 0 && (action.kind === 'damage' || action.kind === 'status') && $9c83ba8af3a31ade$var$hasStatus(primary, 'Reflect')) {
        if (log) log.push(`${primary.name} reflects ${action.name}`);
        const back = units.filter((o)=>o.alive && !$9c83ba8af3a31ade$var$airborne(o) && o.team === u.team).sort((a, b)=>$9c83ba8af3a31ade$var$manh(primary, a) - $9c83ba8af3a31ade$var$manh(primary, b))[0];
        if (!back) {
            $9c83ba8af3a31ade$var$faceToward(u, primary);
            return;
        }
        primary = back;
    }
    if (action.multihit) {
        $9c83ba8af3a31ade$var$resolveMultihit(u, action, center, units, occupied, rng, log);
        $9c83ba8af3a31ade$var$faceToward(u, center);
        if (!u.mimic) $9c83ba8af3a31ade$var$triggerMimics(u, action, center, units, occupied, rng, log);
        return;
    }
    const targets = $9c83ba8af3a31ade$export$75a050ec0b549f3d(u, action, primary, units, center);
    for (const t of targets)$9c83ba8af3a31ade$export$59a7b217c53300d2(u, action, t, occupied, rng, log);
    if (action.selfCost && u.alive) {
        u.hp -= action.selfCost;
        if (log) log.push(`${u.name} pays ${action.selfCost} HP \u{2192} ${Math.max(0, u.hp)}`);
        if (u.hp <= 0) $9c83ba8af3a31ade$var$kill(u, occupied, log);
    }
    if (primary !== u) $9c83ba8af3a31ade$var$faceToward(u, center); // a self-centered cast keeps the facing the caller set (toward the foes)
    if (!u.mimic) $9c83ba8af3a31ade$var$triggerMimics(u, action, center, units, occupied, rng, log); // teammates' mimes echo it (same offset as the blast)
}
function $9c83ba8af3a31ade$var$takeTurn(u, units, occupied, crystals, gridSize, rng, log, config) {
    $9c83ba8af3a31ade$export$1b107e6458698125(gridSize);
    $9c83ba8af3a31ade$var$tickStatus(u, occupied, log);
    if (!u.alive) return;
    if ($9c83ba8af3a31ade$var$stopped(u)) return; // Stop / Sleep / Petrify — no act, no move
    const canMove = !$9c83ba8af3a31ade$var$cantMove(u);
    const realFoes = ()=>units.filter((e)=>e.alive && !$9c83ba8af3a31ade$var$airborne(e) && e.team !== u.team);
    // Berserk: uncontrollable — charge the nearest enemy and basic-attack (×1.5).
    if ($9c83ba8af3a31ade$var$berserk(u)) {
        const foes = realFoes();
        if (!foes.length) return;
        const target = $9c83ba8af3a31ade$var$nearest(u, foes);
        if (canMove) {
            $9c83ba8af3a31ade$var$moveToward(u, target, u.range, occupied, gridSize, units);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        }
        $9c83ba8af3a31ade$var$faceToward(u, target);
        if ($9c83ba8af3a31ade$var$manh(u, target) <= u.range) $9c83ba8af3a31ade$var$resolveAction(u, {
            ...$9c83ba8af3a31ade$var$BASIC(u),
            power: Math.round((u.power || 1) * 1.5)
        }, target, units, occupied, rng, log);
        else if (log) log.push(`${u.name} rushes ${target.name} (berserk)`);
        return;
    }
    // Confusion: uncontrollable — basic-attack the NEAREST unit, friend or foe (can
    // hurt its own team; a hit snaps it out, which is why allies sometimes whack it).
    if ($9c83ba8af3a31ade$var$hasStatus(u, 'Confusion')) {
        const all = units.filter((o)=>o.alive && !$9c83ba8af3a31ade$var$airborne(o) && o !== u && !$9c83ba8af3a31ade$var$hasStatus(o, 'Petrify'));
        if (!all.length) return;
        const target = $9c83ba8af3a31ade$var$nearest(u, all);
        if (canMove) {
            $9c83ba8af3a31ade$var$moveToward(u, target, u.range, occupied, gridSize, units);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        }
        $9c83ba8af3a31ade$var$faceToward(u, target);
        if ($9c83ba8af3a31ade$var$manh(u, target) <= u.range) $9c83ba8af3a31ade$var$resolveAction(u, $9c83ba8af3a31ade$var$BASIC(u), target, units, occupied, rng, log);
        else if (log) log.push(`${u.name} stumbles about (confused)`);
        return;
    }
    // Don't Act (but can still move): FLEE. A disabled unit can't retaliate, so loitering
    // in melee just hands the enemy free hits — the real AI runs from danger. Move to the
    // safest reachable tile (fewest foes can reach it / farthest from the nearest), facing
    // the nearest threat. (Was: advance toward the enemy, which made Don't Act far too weak
    // a debuff in the sim.)
    if ($9c83ba8af3a31ade$var$cantAct(u)) {
        if (canMove) {
            const foes = realFoes();
            if (foes.length) {
                const key = $9c83ba8af3a31ade$export$776134f4e8ad1ade(u, foes, occupied, gridSize, units);
                if (key !== `${u.x},${u.y}`) {
                    $9c83ba8af3a31ade$var$moveTo(u, key, $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), occupied);
                    $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
                }
                $9c83ba8af3a31ade$var$faceToward(u, $9c83ba8af3a31ade$var$nearest(u, foes));
            }
        }
        if (log) log.push(`${u.name} can't act`);
        return;
    }
    const enemies = realFoes();
    // The Critical AI (criticalMode): its move, before or after acting, is the retreat, and it never walks
    // toward a target it can't reach. (This replaced a guess: below 30% HP, beeline for the nearest crystal.)
    const crit = $9c83ba8af3a31ade$export$ad1c6c97ef954fbb(u, units);
    const retreat = crit && canMove ? $9c83ba8af3a31ade$export$b4cc0b511682f74c(u, units, $9c83ba8af3a31ade$var$asField(gridSize), $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), crystals) : null;
    const retreatMove = ()=>{
        if (retreat && retreat !== `${u.x},${u.y}`) {
            $9c83ba8af3a31ade$var$moveTo(u, retreat, $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), occupied);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
            if (log) log.push(`${u.name} retreats`);
        }
        if (enemies.length) $9c83ba8af3a31ade$var$faceToward(u, $9c83ba8af3a31ade$var$nearest(u, enemies));
    };
    // The move after acting in place (see planAfter below): plan 1 of the game's move decision.
    const planAfterFor = (me, tgt)=>{
        if (crit) return retreat;
        const foesNow = realFoes();
        const main = tgt && tgt.team !== me.team ? tgt : foesNow.length ? $9c83ba8af3a31ade$var$nearest(me, foesNow) : null;
        return main ? $9c83ba8af3a31ade$export$ec423ff4c9d8995(me, main, units, $9c83ba8af3a31ade$var$asField(gridSize), $9c83ba8af3a31ade$export$5f4f5be423bd6abd(me, occupied, gridSize, units), rng) : null;
    };
    const moveAfterTo = (plan)=>{
        if (!plan || plan === `${u.x},${u.y}` || !u.alive || $9c83ba8af3a31ade$var$cantMove(u) || $9c83ba8af3a31ade$var$airborne(u)) return;
        const now = $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, $9c83ba8af3a31ade$var$asField(gridSize), units);
        if (now.has(plan)) {
            $9c83ba8af3a31ade$var$moveTo(u, plan, now, occupied);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
            if (log) log.push(`${u.name} moves after acting`);
        }
    };
    // Special plans that don't aim at a single foe: linear rays (Earth Slash & co.) fire
    // a straight ray from the caster; self-centered blasts (Draw Out & co.) detonate
    // around the caster. Each picks its own best stand tile; take whichever beats the
    // best ordinary action. (Frog can only flail a weak basic — no casting.)
    const cands = []; // every scored candidate, best first (for the reach fallback below)
    const selfChoice = crit ? $9c83ba8af3a31ade$export$4c3767320cfec6d5(u, units, rng, 0, cands, 'self') : null; // the Critical AI tries itself first, and takes it
    const noPlans = $9c83ba8af3a31ade$var$frogged(u) || !!selfChoice;
    const linearPlan = noPlans ? null : $9c83ba8af3a31ade$export$e25e5e2e1cf311c5(u, units, occupied, gridSize, config, canMove);
    const selfPlan = noPlans ? null : $9c83ba8af3a31ade$export$2e5e9313ede7ee38(u, units, occupied, gridSize, config, canMove);
    const mathPlan = noPlans ? null : $9c83ba8af3a31ade$export$ae1b40343ef59d4(u, units);
    const choice = selfChoice || $9c83ba8af3a31ade$export$4c3767320cfec6d5(u, units, rng, 0, cands, crit ? 'others' : null);
    const normalVal = choice && choice.target && !choice.advanceOnly ? $9c83ba8af3a31ade$var$scoreAction(u, choice.action, choice.target, units) : 0;
    const linearVal = linearPlan && linearPlan.value > 0 ? linearPlan.value : -Infinity;
    const selfVal = selfPlan && selfPlan.value > 0 ? selfPlan.value : -Infinity;
    const mathVal = mathPlan && mathPlan.value > 0 ? mathPlan.value : -Infinity;
    // Math Skill (Calculator): a free, instant, board-wide cast — no positioning or range
    // to optimize, so if it's the best option this turn, just fire it in place. Wins over
    // every other plan when its value leads.
    if (mathVal > -Infinity && mathVal >= normalVal && mathVal >= linearVal && mathVal >= selfVal) {
        $9c83ba8af3a31ade$var$resolveAction(u, mathPlan.action, u, units, occupied, rng, log); // primary unused on the mathCast path
        return;
    }
    // Self-centered blast (Draw Out & co.): center on the caster, never the caster's own
    // tile damaging itself — that's handled in collectTargets. Wins if it beats both the
    // best ordinary action and the best linear ray.
    if (selfVal > -Infinity && selfVal >= normalVal && selfVal >= linearVal) {
        const inPlace = selfPlan.key === `${u.x},${u.y}`;
        const plan = inPlace && canMove ? planAfterFor(u, null) : null; // cast where it stands, then take the move (planAfter)
        if (canMove && !inPlace) {
            $9c83ba8af3a31ade$var$moveTo(u, selfPlan.key, $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), occupied);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        }
        const en = realFoes();
        if (en.length) $9c83ba8af3a31ade$var$faceToward(u, $9c83ba8af3a31ade$var$nearest(u, en));
        u.mp -= selfPlan.action.mp || 0;
        if (selfPlan.action.charge > 0) {
            const ctr = Math.max(1, Math.ceil(selfPlan.action.charge * (u.shortCharge ? 0.5 : 1)));
            u.charging = {
                action: selfPlan.action,
                target: u,
                ctr: ctr
            }; // target self → always "alive" when the charge lands
            if (log) log.push(`${u.name} begins ${selfPlan.action.name}`);
        } else {
            if (log) log.push(`${u.name} unleashes ${selfPlan.action.name}`);
            $9c83ba8af3a31ade$var$resolveAction(u, selfPlan.action, u, units, occupied, rng, log); // primary = self ⇒ centered on the caster
        }
        moveAfterTo(plan);
        return;
    }
    if (linearPlan && linearPlan.value > 0 && linearPlan.value >= normalVal) {
        if (canMove && linearPlan.key !== `${u.x},${u.y}`) {
            $9c83ba8af3a31ade$var$moveTo(u, linearPlan.key, $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units), occupied);
            $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        }
        u.facing = {
            ...linearPlan.dir
        };
        u.mp -= linearPlan.action.mp || 0;
        if (log) log.push(`${u.name} unleashes ${linearPlan.action.name}`);
        $9c83ba8af3a31ade$var$resolveLinear(u, linearPlan.action, linearPlan.dir, units, occupied, rng, log);
        return;
    }
    if (!choice || !choice.target) {
        if (crit) retreatMove();
        return;
    }
    // Nothing it may use is in reach and it can't basic-attack (Wild Beast): just close in.
    if (choice.advanceOnly) {
        if (crit) {
            retreatMove();
            return;
        }
        if (canMove) $9c83ba8af3a31ade$var$gameMove(u, choice.target, units, occupied, crystals, $9c83ba8af3a31ade$var$asField(gridSize), rng, log);
        return;
    }
    let { action: action, target: target } = choice;
    // chooseAction's reach check is coarse (move + range as the crow flies), so its pick can have no
    // tile to act from once walls, height and blocked paths count. FFT scores options from the tiles a
    // unit can really stand on, so then take the best candidate that IS usable from here this turn
    // rather than walking toward the first. (FFTBG's Ochu Goo'd the Hydra beside it where ours walked
    // toward a Ninja it couldn't reach; our Dancer walked where the game danced.) Kept although the
    // backtest dipped when it was first tried: the goal is the game's actions, not a better score.
    const dw = config.dangerWeight ?? 0.2;
    const tiles = canMove ? $9c83ba8af3a31ade$export$5f4f5be423bd6abd(u, occupied, gridSize, units) : new Map([
        [
            `${u.x},${u.y}`,
            {
                x: u.x,
                y: u.y,
                z: $9c83ba8af3a31ade$var$zOf(u)
            }
        ]
    ]);
    let picked = $9c83ba8af3a31ade$var$fieldWide(action) ? null : $9c83ba8af3a31ade$var$pickStandTile(u, action, target, units, tiles, enemies, canMove ? dw : 0, gridSize);
    if (picked && picked.key == null) for (const c of cands){
        if (c.action === action && c.target === target) continue;
        if ($9c83ba8af3a31ade$var$fieldWide(c.action)) {
            action = c.action;
            target = c.target;
            picked = null;
            break;
        }
        const p = $9c83ba8af3a31ade$var$pickStandTile(u, c.action, c.target, units, tiles, enemies, canMove ? dw : 0, gridSize);
        if (p.key != null && p.attack) {
            action = c.action;
            target = c.target;
            picked = p;
            break;
        }
    }
    // Acting from where it stands leaves the move for after. The game marks this case itself: when the
    // panel its stand search pops is the unit's own (0x8019C20C sets AI +20), it evaluates the action from
    // there and swaps in the move plan of the active slot, plan 1: what its move decision chose before any
    // action was weighed (0x8019638C, toward the main target). So the tile is decided before acting, and
    // walked to after. A Jump leaves the field and doesn't walk.
    const planAfter = ()=>canMove ? planAfterFor(u, target) : null;
    const moveAfter = moveAfterTo;
    // 0-range songs/dances reach a whole team regardless of position — perform in place
    // (no approach, no range/height gate), then keep performing on later turns. Summons are
    // homing too but POSITIONAL (real range), so they fall through to the normal cast path
    // below and approach into range first.
    if ($9c83ba8af3a31ade$var$fieldWide(action)) {
        const en = realFoes();
        if (en.length) $9c83ba8af3a31ade$var$faceToward(u, $9c83ba8af3a31ade$var$nearest(u, en));
        const plan = planAfter();
        u.mp -= action.mp || 0;
        if (action.charge > 0) {
            const ctr = $9c83ba8af3a31ade$var$landChargeOf(u, action);
            u.charging = {
                action: action,
                target: target,
                ctr: ctr
            };
            if (log) log.push(`${u.name} begins ${action.name}`);
        } else {
            if (log) log.push(`${u.name} performs ${action.name}`);
            $9c83ba8af3a31ade$var$resolveAction(u, action, target, units, occupied, rng, log);
        }
        moveAfter(plan);
        return;
    }
    let center = target; // the panel the action is aimed at (a nearby tile for an off-unit splash)
    const act = ()=>{
        if (!$9c83ba8af3a31ade$var$withinV($9c83ba8af3a31ade$var$zOf(u), $9c83ba8af3a31ade$var$zOf(center), action) || $9c83ba8af3a31ade$var$manh(u, center) > $9c83ba8af3a31ade$var$effRange(action, $9c83ba8af3a31ade$var$zOf(u), $9c83ba8af3a31ade$var$zOf(center))) return; // height-adjusted reach + vertical tolerance
        u.mp -= action.mp || 0;
        if (action.charge > 0) {
            // CTR is in clockticks (one sim tick = one CT increment for all units), and
            // counts down independent of the caster's Speed — Haste grants more turns but
            // does NOT shorten a charge. Short Charge halves the CTR (BMG 4.2), except a Jump's.
            // A Jump lands on the PANEL its target stood on (`panel`), whoever is there by then.
            const ctr = $9c83ba8af3a31ade$var$landChargeOf(u, action);
            u.charging = center === target ? {
                action: action,
                target: target,
                ctr: ctr
            } : {
                action: action,
                target: target,
                ctr: ctr,
                center: center
            };
            if (action.jump) u.charging.panel = {
                x: target.x,
                y: target.y
            };
            if (log) log.push(`${u.name} begins ${action.name}`);
        } else $9c83ba8af3a31ade$var$resolveAction(u, action, target, units, occupied, rng, log, center);
    };
    // Don't Move: act only from the current tile (no repositioning).
    if (!canMove) {
        if (picked.center) center = picked.center;
        $9c83ba8af3a31ade$var$faceToward(u, center);
        act();
        return;
    }
    // Where to act from is the game's stand search (pickStandTile): nothing in reach → its move decision;
    // the unit's own tile → act, then move; any other tile → move there, then act.
    const { key: key, attack: attack } = picked;
    if (picked.center) center = picked.center;
    if (key == null) {
        if (crit) {
            retreatMove();
            return;
        } // the Critical AI doesn't close in
        $9c83ba8af3a31ade$var$gameMove(u, target, units, occupied, crystals, $9c83ba8af3a31ade$var$asField(gridSize), rng, log); // out of reach: FFT's move decision
        return;
    } else if (!attack) {
        $9c83ba8af3a31ade$var$moveTo(u, key, tiles, occupied); // kite: reposition to safety, hold the attack
        $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log);
        if (enemies.length) $9c83ba8af3a31ade$var$faceToward(u, $9c83ba8af3a31ade$var$nearest(u, enemies));
        if (log) log.push(`${u.name} repositions`);
        return;
    } else if (key !== `${u.x},${u.y}`) $9c83ba8af3a31ade$var$moveTo(u, key, tiles, occupied);
    else {
        const plan = planAfter(); // acting from where it stands: act, then take the move (see planAfter)
        act();
        moveAfter(plan);
        return;
    }
    $9c83ba8af3a31ade$var$absorbCrystal(u, crystals, log); // stepped onto a crystal en route
    act();
}
const $9c83ba8af3a31ade$export$d22a027dada4117a = (seed)=>{
    let a = seed >>> 0;
    return ()=>{
        a = a + 0x6D2B79F5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
};
function $9c83ba8af3a31ade$export$82efcf1bef55f708(teamA, teamB, config = {}, rng = Math.random) {
    try {
        return $9c83ba8af3a31ade$var$simulateBattleOn(teamA, teamB, config, rng);
    } finally{
        $9c83ba8af3a31ade$export$1b107e6458698125(null);
    }
}
function $9c83ba8af3a31ade$var$simulateBattleOn(teamA, teamB, config, rng) {
    $9c83ba8af3a31ade$var$setTune(config);
    if (config.seed != null) rng = $9c83ba8af3a31ade$export$d22a027dada4117a(config.seed); // reproducible run
    const field = $9c83ba8af3a31ade$export$7b8759f97dcc03d1(config);
    const maxTurns = config.maxTurns ?? 200;
    const undeadReviveChance = config.undeadReviveChance ?? 0.625; // undead reanimate (vs crystallize) at this rate: FFTBG's Undead help says 62.5%, at the start of the 4th turn with Death
    const log = config.log || config.frames ? [] : null;
    const units = [];
    const mkUnit = (s, team, x, y, facing)=>({
            ...s,
            status: {
                ...s.status || {}
            },
            charging: null,
            speed: Math.max(1, s.speed || 1),
            mp: s.mp || 0,
            maxMp: s.mp || 0,
            brave: s.brave ?? 50,
            reaction: s.reaction ?? null,
            team: team,
            maxHp: s.hp,
            hp: s.hp,
            removed: new Set(s.removed),
            x: x,
            y: y,
            z: field.height(x, y),
            facing: {
                ...facing
            },
            ct: Math.floor(rng() * (s.speed || 1)),
            alive: true
        });
    // Gear/class statuses (simPrep): permanent ones never run out, initial ones start their usual timer.
    const withTraits = (u)=>{
        for (const st of u.permStatus || [])u.status[st] = $9c83ba8af3a31ade$var$PERMANENT;
        for (const st of u.initStatus || [])$9c83ba8af3a31ade$var$addStatus(u, st);
        return u;
    };
    // Place on the map's authoritative ENTD start tiles (team A = Player 1, B = P2),
    // or — with no terrain — on opposite rows of the flat box.
    const FACE = {
        North: {
            x: 0,
            y: -1
        },
        South: {
            x: 0,
            y: 1
        },
        East: {
            x: 1,
            y: 0
        },
        West: {
            x: -1,
            y: 0
        }
    };
    const starts = config.terrain && Array.isArray(config.terrain.starts) ? config.terrain.starts : null;
    if (starts && starts.some((s)=>s.team === 'Player 1') && starts.some((s)=>s.team === 'Player 2')) {
        const slots = (label)=>starts.filter((s)=>s.team === label).sort((a, b)=>(a.unit || 0) - (b.unit || 0));
        const placeOn = (specs, team, sl)=>specs.forEach((s, i)=>{
                const t = sl[i] || sl[sl.length - 1] || {
                    x: 0,
                    y: 0
                };
                units.push(withTraits(mkUnit(s, team, t.x, t.y, FACE[t.facing] || {
                    x: 0,
                    y: 1
                })));
            });
        // Left/first team (A) is ALWAYS Player 1, right team (B) Player 2 — a fixed,
        // deterministic placement (roster slot i → start tile i). Randomizing the side
        // shuffled positions, which shifts who-reaches-whom and turn order on speed ties.
        placeOn(teamA, 'A', slots('Player 1'));
        placeOn(teamB, 'B', slots('Player 2'));
    } else {
        const place = (specs, team, row, facing)=>{
            const startCol = Math.max(0, Math.floor((field.w - specs.length) / 2));
            specs.forEach((s, i)=>units.push(withTraits(mkUnit(s, team, startCol + i, row, facing))));
        };
        place(teamA, 'A', 0, {
            x: 0,
            y: 1
        });
        place(teamB, 'B', field.h - 1, {
            x: 0,
            y: -1
        });
    }
    const occupied = new Set(units.map((u)=>`${u.x},${u.y}`));
    const crystals = new Set(); // tile keys holding a crystal (walkable; full HP/MP on step)
    const aliveTeam = (t)=>units.some((u)=>u.team === t && u.alive && !$9c83ba8af3a31ade$var$hasStatus(u, 'Petrify')); // an all-petrified team is out (stone = unable to fight)
    // Snapshot the board to the log, but only when something actually changed
    // (skips the duplicate lines from move-only / wasted turns).
    // Structured per-action frames for the visual replay (FightModal's BattleViewer).
    // One frame per board change (same trigger as the log snapshot); the viewer
    // derives who-got-hit from HP deltas between frames, so we only carry the actor.
    const frames = config.frames ? [] : null;
    const boardSnapshot = ()=>units.filter((u)=>!u.crystallized).map((u)=>({
                name: u.name,
                team: u.team,
                x: u.x,
                y: u.y,
                hp: Math.max(0, u.hp),
                maxHp: u.maxHp,
                alive: u.alive,
                dead: u.dead ?? null,
                dir: {
                    ...u.facing
                },
                status: u.status ? {
                    ...u.status
                } : {},
                cls: u.cls,
                gender: u.gender,
                raidBoss: u.raidBoss
            }));
    let lastSig = null, frameMark = 0;
    const pushState = (actor)=>{
        if (!log) return;
        const sig = units.map((u)=>`${u.crystallized ? 'z' : u.alive ? u.hp : 'd' + u.dead}@${u.x},${u.y}`).join('|') + '#' + [
            ...crystals
        ].sort().join(',');
        if (sig === lastSig) return;
        lastSig = sig;
        $9c83ba8af3a31ade$var$logState(units, log);
        if (frames) {
            const caption = log.slice(frameMark, log.length - 1).filter((l)=>!l.startsWith("    \xb7")).join(" \xb7 ");
            frames.push({
                turn: turns,
                actor: actor || null,
                caption: caption,
                board: boardSnapshot(),
                crystals: [
                    ...crystals
                ]
            });
            frameMark = log.length;
        }
    };
    let turns = 0;
    if (frames) frames.push({
        turn: 0,
        actor: null,
        caption: 'Battle begins.',
        board: boardSnapshot(),
        crystals: []
    });
    while(turns < maxTurns && aliveTeam('A') && aliveTeam('B')){
        for (const u of units){
            if (!u.alive && u.dead == null) continue; // crystallized / fully gone — no CT
            if (u.alive) $9c83ba8af3a31ade$var$tickTimers(u);
            if (u.charging) {
                u.charging.ctr -= 1; // count down the charge by one clocktick (Speed-independent)
                if (u.charging.ctr <= 0) {
                    const c = u.charging;
                    u.charging = null;
                    // A charge aims at a PANEL: a single-target attack whiffs if its mark walked out
                    // of reach before it lands (FFT — you dodge a charge by moving away). AoE / linear /
                    // homing / self-centered casts still detonate on their area, so they're unaffected.
                    const singleAimed = (c.action.aoe || 0) === 0 && !c.action.homing && !c.action.centerSelf && !c.action.linear && !c.action.mathCast;
                    if (c.panel) {
                        const on = $9c83ba8af3a31ade$var$unitAt(c.panel.x, c.panel.y, units);
                        if (on && on !== c.target) c.target = on;
                    }
                    const dodged = singleAimed && c.target.alive && (c.panel ? c.target.x !== c.panel.x || c.target.y !== c.panel.y : $9c83ba8af3a31ade$var$manh(u, c.target) > $9c83ba8af3a31ade$var$effRange(c.action, $9c83ba8af3a31ade$var$zOf(u), $9c83ba8af3a31ade$var$zOf(c.target)));
                    if (dodged) {
                        if (log) log.push(`${c.target.name} steps out of ${u.name}'s ${c.action.name}`);
                    } else if (c.center || c.target.alive || c.action.homing) {
                        $9c83ba8af3a31ade$var$resolveAction(u, c.action, c.target, units, occupied, rng, log, c.center || c.target);
                        pushState(u.name);
                    } else if (log) log.push(`${u.name}'s ${c.action.name} fizzles`);
                    u.ct = 0;
                }
            } else u.ct += $9c83ba8af3a31ade$var$effSpeed(u);
        }
        const ready = units.filter((u)=>(u.alive || u.dead != null) && !u.charging && u.ct >= 100).sort((a, b)=>b.ct - a.ct || rng() - 0.5);
        for (const u of ready){
            if (turns >= maxTurns || !aliveTeam('A') || !aliveTeam('B')) break;
            if (u.crystallized) continue;
            if (!u.alive && u.dead != null) {
                if (--u.dead < 0) {
                    if ($9c83ba8af3a31ade$export$70293f6c7be5250c(u) && rng() < undeadReviveChance) $9c83ba8af3a31ade$var$reviveUndead(u, rng, log);
                    else $9c83ba8af3a31ade$var$crystallize(u, occupied, crystals, log);
                }
                u.ct -= 100;
                pushState(u.name);
                continue;
            }
            if (!u.alive || u.charging) continue;
            $9c83ba8af3a31ade$var$takeTurn(u, units, occupied, crystals, field, rng, log, config);
            pushState(u.name);
            u.ct -= 100;
            turns++;
        }
    }
    let winner;
    if (!aliveTeam('A') && !aliveTeam('B')) winner = 'draw';
    else if (!aliveTeam('B')) winner = 'A';
    else if (!aliveTeam('A')) winner = 'B';
    else {
        // Turn-cap tiebreak: more living units wins (a tactics match is decided by
        // bodies, not HP bars); summed HP only breaks a body-count tie.
        const living = (t)=>units.filter((u)=>u.team === t && u.alive && !$9c83ba8af3a31ade$var$hasStatus(u, 'Petrify'));
        const la = living('A'), lb = living('B');
        if (la.length !== lb.length) winner = la.length > lb.length ? 'A' : 'B';
        else {
            const sum = (us)=>us.reduce((s, u)=>s + u.hp, 0);
            const ha = sum(la), hb = sum(lb);
            winner = ha > hb ? 'A' : hb > ha ? 'B' : 'draw';
        }
    }
    return {
        winner: winner,
        turns: turns,
        log: log,
        frames: frames,
        units: units.map((u)=>({
                name: u.name,
                team: u.team,
                alive: u.alive
            }))
    };
}
function $9c83ba8af3a31ade$export$7475123d066047c9(u, units, config = {}, rng = ()=>0) {
    $9c83ba8af3a31ade$var$setTune(config);
    const field = $9c83ba8af3a31ade$export$7b8759f97dcc03d1(config);
    const occupied = new Set(units.filter((o)=>o.alive).map((o)=>`${o.x},${o.y}`));
    const log = [];
    try {
        $9c83ba8af3a31ade$var$takeTurn(u, units, occupied, new Set(), field, rng, log, config);
    } finally{
        $9c83ba8af3a31ade$export$1b107e6458698125(null);
    }
    return {
        x: u.x,
        y: u.y,
        log: log,
        charging: u.charging ? {
            action: u.charging.action.name,
            target: u.charging.target && u.charging.target.name
        } : null
    };
}
function $9c83ba8af3a31ade$export$4ae5aadd2d8e14b6(teamA, teamB, opts = {}, rng = Math.random) {
    const n = opts.n ?? opts.runs ?? 150;
    let a = 0, b = 0, d = 0;
    const survival = new Map(); // team+name -> { name, team, survived }
    for(let i = 0; i < n; i++){
        const res = $9c83ba8af3a31ade$export$82efcf1bef55f708(teamA, teamB, opts, rng);
        if (res.winner === 'A') a++;
        else if (res.winner === 'B') b++;
        else d++;
        for (const u of res.units){
            const k = u.team + ' ' + u.name;
            const rec = survival.get(k) || {
                name: u.name,
                team: u.team,
                survived: 0
            };
            if (u.alive) rec.survived++;
            survival.set(k, rec);
        }
    }
    const unitStats = [
        ...survival.values()
    ].map((r)=>({
            name: r.name,
            team: r.team,
            survivalPct: r.survived / n
        }));
    return {
        n: n,
        aWins: a,
        bWins: b,
        draws: d,
        aWinPct: a / n,
        bWinPct: b / n,
        unitStats: unitStats
    };
}
// ---- Reproducible-battle blob. The combatant specs + config + seed are everything
// simulateBattle needs to replay a fight bit-for-bit, so a `repro` is a self-contained
// debug capsule: paste it into replayRepro() and get the identical fight back (log +
// frames). Sets (a spec's `removed`, its `elements` affinity sets, the field's tile
// sets) don't survive plain JSON, so we tag/restore them. Terrain is embedded whole so
// the capsule needs nothing external. `seed` defaults to a fresh random one if absent.
// Sets, and the map's tile table (a Uint8Array, as base64), survive the round trip.
const $9c83ba8af3a31ade$var$toB64 = (u8)=>typeof btoa === 'function' ? btoa(String.fromCharCode(...u8)) : $9c83ba8af3a31ade$require$Buffer.from(u8).toString('base64');
const $9c83ba8af3a31ade$var$fromB64 = (s)=>typeof atob === 'function' ? Uint8Array.from(atob(s), (c)=>c.charCodeAt(0)) : new Uint8Array($9c83ba8af3a31ade$require$Buffer.from(s, 'base64'));
const $9c83ba8af3a31ade$var$setReplacer = (k, v)=>v instanceof Set ? {
        __set: [
            ...v
        ]
    } : v instanceof Uint8Array ? {
        __u8: $9c83ba8af3a31ade$var$toB64(v)
    } : v;
const $9c83ba8af3a31ade$var$setReviver = (k, v)=>v && typeof v === 'object' && Array.isArray(v.__set) ? new Set(v.__set) : v && typeof v === 'object' && typeof v.__u8 === 'string' ? $9c83ba8af3a31ade$var$fromB64(v.__u8) : v;
function $9c83ba8af3a31ade$export$a8d656a67038330c(teamA, teamB, config = {}, seed) {
    const { log: log, frames: frames, ...knobs } = config; // drop output toggles; keep terrain + the tuning knobs
    const s = seed != null ? seed : Math.floor(Math.random() * 0x7fffffff);
    return JSON.stringify({
        v: 1,
        seed: s,
        config: knobs,
        teamA: teamA,
        teamB: teamB
    }, $9c83ba8af3a31ade$var$setReplacer, 2);
}
function $9c83ba8af3a31ade$export$16706dfe16037aba(json, overrides = {}) {
    const blob = typeof json === 'string' ? JSON.parse(json, $9c83ba8af3a31ade$var$setReviver) : json;
    return $9c83ba8af3a31ade$export$82efcf1bef55f708(blob.teamA, blob.teamB, {
        ...blob.config,
        seed: blob.seed,
        log: true,
        frames: true,
        ...overrides
    });
}

});

parcelRegister("by2uy", function(module, exports) {

$parcel$export(module.exports, "calibratedOdds", () => $8684cd807f10e0f0$export$89e069b6331b45ee);
// App-facing sim odds. Since 2026-10-16 the site shows the sim's RAW win rate: no Platt
// shrink toward 50% and no champion-incumbency edge. We're chasing the sim's actual behaviour
// against FFTBG's own build (tools/emu-battle), so the numbers on the page should be what the
// sim really produced: a team that won all 600 runs reads 100%, not ~75%.
// The fitted calibration (src/data/simCalibration.json: honest `a`, display `uiA`, `champEdge`)
// is unchanged and still used where honesty matters: the betting bot (it calls the pure
// calibrate() with those params) and tools/backtest.mjs --fit. To bring a calibrated display
// back, pass `params` (or `{ ...params, a: params.uiA }`) here instead of RAW.

var $ekpMB = parcelRequire("ekpMB");
const $8684cd807f10e0f0$var$RAW = {
    a: 1,
    b: 0,
    champEdge: 0
};
const $8684cd807f10e0f0$export$764e6ef9a0abbb2c = (rawP, opts = {})=>(0, $ekpMB.calibrate)($8684cd807f10e0f0$var$RAW, rawP, opts);
const $8684cd807f10e0f0$export$89e069b6331b45ee = (res, opts = {})=>(0, $ekpMB.calibratedOdds)($8684cd807f10e0f0$var$RAW, res, opts);

});
parcelRegister("ekpMB", function(module, exports) {

$parcel$export(module.exports, "calibrate", () => $a6e6eee465297cd2$export$764e6ef9a0abbb2c);
$parcel$export(module.exports, "calibratedOdds", () => $a6e6eee465297cd2$export$89e069b6331b45ee);
// Probability calibration for the battle sim (pure — params injected).
//
// The raw Monte-Carlo win% is badly over-confident (when the sim says 95% the
// real rate is ~62%) and weakly discriminative. We fit a Platt scaling
// p_cal = sigmoid(a·logit(p) + b) on historical outcomes (tools/backtest.mjs
// --fit → src/data/simCalibration.json) that shrinks the probabilities toward
// their true rate — a big Brier-score win without touching the engine. A small
// `champEdge` adds the reigning champion's incumbency advantage in the Champ
// match (champions defend ~58%).
//
// This does NOT change which side is favored in the non-champ case (the argmax
// is preserved) — only how confident the number is. Engine realism is the lever
// for favorite-pick accuracy.
//
// The bundled params live in src/data/simCalibration.json; simCalibrationLive.js
// binds them for the app. Keeping this file params-injected (no JSON import) lets
// it run under plain Node for the tests.
const $a6e6eee465297cd2$var$EPS = 1e-6;
const $a6e6eee465297cd2$var$clamp01 = (p)=>Math.min(1 - $a6e6eee465297cd2$var$EPS, Math.max($a6e6eee465297cd2$var$EPS, p));
const $a6e6eee465297cd2$var$logit = (p)=>Math.log($a6e6eee465297cd2$var$clamp01(p) / (1 - $a6e6eee465297cd2$var$clamp01(p)));
const $a6e6eee465297cd2$var$sigmoid = (z)=>1 / (1 + Math.exp(-z));
function $a6e6eee465297cd2$export$764e6ef9a0abbb2c(params, rawP, opts = {}) {
    const a = params && Number.isFinite(params.a) ? params.a : 1;
    const b = params && Number.isFinite(params.b) ? params.b : 0;
    const E = params && Number.isFinite(params.champEdge) ? params.champEdge : 0;
    let z = a * $a6e6eee465297cd2$var$logit(rawP) + b;
    if (opts.champSide === 'A') z += E;
    else if (opts.champSide === 'B') z -= E;
    return $a6e6eee465297cd2$var$sigmoid(z);
}
function $a6e6eee465297cd2$export$89e069b6331b45ee(params, res, opts = {}) {
    const a = Math.round($a6e6eee465297cd2$export$764e6ef9a0abbb2c(params, res.aWinPct, opts) * 100);
    return {
        a: a,
        b: 100 - a
    };
}

});


parcelRegister("c8sRz", function(module, exports) {
module.exports = JSON.parse("{\"gridSize\":10,\"maxTurns\":200,\"runs\":600,\"dangerWeight\":0.1,\"undeadReviveChance\":0.625,\"statusWeight\":1}");

});

parcelRegister("hYk3h", function(module, exports) {
module.exports = JSON.parse("{\"Ahriman\":[\"Wing Attack\",\"Look of Devil\",\"Look of Fright\",\"Doom*\"],\"Apanda\":[\"Bio Tenebris\",\"Bio Venenum\",\"Bio Oleum\",\"Bio Ranae\",\"Bio Tardus\",\"Bio Silentium\",\"Bio Lapis\",\"Bio Immortuos\",\"Bio Mortem\",\"Bio Insanis\"],\"Archaic Demon\":[\"Lifebreak\",\"Dark Holy\",\"Giga Flare\",\"Empower\",\"Despair\",\"Despair 2\"],\"Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Giga Flare*\"],\"Black Chocobo\":[\"Choco Attack\",\"Choco Ball\",\"Choco Esuna\",\"Choco Meteor*\"],\"Black Goblin\":[\"Tackle\",\"Turn Punch\",\"Goblin Punch\",\"Mutilate*\"],\"Blue Dragon\":[\"Slam\",\"Ice Breath\",\"Tail Swing\",\"Fire Breath*\"],\"Bomb\":[\"Bite\",\"Self Destruct\",\"Flame Attack\",\"Spark*\"],\"Bull Demon\":[\"Shake Off\",\"Storm Around\",\"Blow Fire*\"],\"Byblos\":[\"Energize\",\"Parasite\",\"Vengeance\",\"Manaburn\",\"Chicken\"],\"Chocobo\":[\"Choco Attack\",\"Choco Cure\",\"Choco Esuna\",\"Choco Ball*\"],\"Cockatrice\":[\"Scratch Up\",\"Beak\",\"Feather Bomb\",\"Peck*\"],\"Coeurl\":[\"Scratch\",\"Cat Kick\",\"Blaster\",\"Poison Nail*\"],\"Dark Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Ulmaguest*\"],\"Dragon\":[\"Slam\",\"Thunder Breath\",\"Tail Swing\",\"Ice Breath*\"],\"Draugr\":[\"Knife Hand\",\"Aqua Soul\",\"Frost Soul\",\"Wind Soul*\"],\"Dryad\":[\"Leaf Dance\",\"Calm Spirit\",\"Protect Spirit\",\"Spirit of Life*\"],\"Explosive\":[\"Bite\",\"Self Destruct\",\"Spark\",\"Small Bomb*\"],\"Floating Eye\":[\"Wing Attack\",\"Look of Fright\",\"Beam\",\"Look of Devil*\"],\"Ghost\":[\"Throw Spirit\",\"Grease Touch\",\"Drain Touch\",\"Zombie Touch*\"],\"Ghoul\":[\"Throw Spirit\",\"Sleep Touch\",\"Knife Hand\",\"Grease Touch*\"],\"Gobbledeguck\":[\"Tackle\",\"Eye Gouge\",\"Mutilate\",\"Goblin Punch*\"],\"Goblin\":[\"Tackle\",\"Eye Gouge\",\"Goblin Punch\",\"Turn Punch*\"],\"Great Malboro\":[\"Tendrils\",\"Bad Breath\",\"Moldball Virus\",\"Goo*\"],\"Grenade\":[\"Bite\",\"Small Bomb\",\"Self Destruct\",\"Flame Attack*\"],\"Holy Dragon\":[\"Holy Breath\",\"Fire Breath\",\"Ice Breath\",\"Thunder Breath\"],\"Hydra\":[\"Triple Attack\",\"Triple Flame\",\"Triple Thunder*\"],\"Iron Hawk\":[\"Scratch Up\",\"Peck\",\"Shine Lover\",\"Feather Bomb*\"],\"Juravis\":[\"Scratch Up\",\"Feather Bomb\",\"Shine Lover\",\"Fury*\"],\"King Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Hurricane*\"],\"Malboro\":[\"Tendrils\",\"Lick\",\"Noxious Gas\",\"Bad Breath*\"],\"Mindflayer\":[\"Tentacle\",\"Mind Blast\",\"Odd Soundwave\",\"Level Blast*\"],\"Minotaur\":[\"Shake Off\",\"Blow Fire\",\"Gather Power*\"],\"Ochu\":[\"Tendrils\",\"Goo\",\"Lick\",\"Noxious Gas*\"],\"Pisco Demon\":[\"Tentacle\",\"Black Ink\",\"Level Blast\",\"Odd Soundwave*\"],\"Plague\":[\"Wing Attack\",\"Doom\",\"Look of Devil\",\"Beam*\"],\"Porky\":[\"Straight Dash\",\"Toot\",\"Bequeath Bacon\",\"Snort*\"],\"Reaper\":[\"Knife Hand\",\"Wind Soul\",\"Thunder Soul\",\"Frost Soul*\"],\"Red Chocobo\":[\"Choco Attack\",\"Choco Meteor\",\"Choco Ball\",\"Choco Cure*\"],\"Red Dragon\":[\"Slam\",\"Fire Breath\",\"Tail Swing\",\"Thunder Breath*\"],\"Red Panther\":[\"Scratch\",\"Poison Nail\",\"Cat Kick\",\"Accumulate*\"],\"Revenant\":[\"Throw Spirit\",\"Drain Touch\",\"Zombie Touch\",\"Sleep Touch*\"],\"Sekhret\":[\"Shake Off\",\"Mimic Titan\",\"Gather Power\",\"Storm Around*\"],\"Serpentarius\":[\"Snake Carrier\",\"Toxic Toad\",\"Midgar Swarm\",\"Scream\"],\"Skeleton\":[\"Knife Hand\",\"Thunder Soul\",\"Frost Soul\",\"Aqua Soul*\"],\"Squidraken\":[\"Tentacle\",\"Black Ink\",\"Odd Soundwave\",\"Mind Blast*\"],\"Steel Giant\":[\"Destroy\",\"Compress\",\"Dispose\",\"Repair\"],\"Swine\":[\"Straight Dash\",\"Oink\",\"Bequeath Bacon\",\"Toot*\"],\"Taiju\":[\"Leaf Dance\",\"Magic Spirit\",\"Spirit of Life\",\"Magic Barrier*\"],\"Tiamat\":[\"Triple Attack\",\"Triple Thunder\",\"Triple Breath\",\"Dark Whisper*\"],\"Treant\":[\"Leaf Dance\",\"Spirit of Life\",\"Protect Spirit\",\"Calm Spirit*\"],\"Ultima Demon\":[\"Nanoflare\",\"Dark Holy\",\"Ultima\",\"Hurricane\",\"Ulmaguest\",\"Empower\"],\"Vampire\":[\"Scratch\",\"Blaster\",\"Blood Suck\",\"Cat Kick*\"],\"Wild Boar\":[\"Straight Dash\",\"Snort\",\"Bequeath Bacon\",\"Oink*\"],\"Wyvern\":[\"Triple Attack\",\"Noxious Gas\",\"Triple Breath*\"]}");

});

parcelRegister("4C5NX", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bf36c017da625d$export$2e2bcd8739ae039);
let $35bf36c017da625d$var$script;




let $35bf36c017da625d$var$initialize = ()=>{
    $35bf36c017da625d$var$script = (parcelRequire("jthll"));
    if ($35bf36c017da625d$var$script.__esModule) $35bf36c017da625d$var$script = $35bf36c017da625d$var$script.default;
    $35bf36c017da625d$var$script.render = (parcelRequire("hWNKk")).render;
    $35bf36c017da625d$var$script.__cssModules = {};
    (parcelRequire("63XTR")).default($35bf36c017da625d$var$script);
    $35bf36c017da625d$var$script.__scopeId = 'data-v-98e680';
    $35bf36c017da625d$var$script.__file = "ChampStreakBadge.vue";
};
$35bf36c017da625d$var$initialize();
var $35bf36c017da625d$export$2e2bcd8739ae039 = $35bf36c017da625d$var$script;

});
parcelRegister("jthll", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e2ce2dca5857d4a1$export$2e2bcd8739ae039);

var $kI4Ko = parcelRequire("kI4Ko");
var $e2ce2dca5857d4a1$export$2e2bcd8739ae039 = {
    name: 'ChampStreakBadge',
    props: {
        streak: {
            type: Number,
            default: 0
        }
    },
    computed: {
        d () {
            return (0, $kI4Ko.streakDisplay)(this.streak);
        }
    }
};

});
parcelRegister("kI4Ko", function(module, exports) {

$parcel$export(module.exports, "streakDisplay", () => $f13b99686dd28c20$export$be6331a8d5ae80ae);
// Escalating display for the reigning champion's title-defense streak (from the
// global streak.txt). The visual ramps with `level` (1–5) — emoji + a flavor word
// here, with the size/glow/animation done in CSS (ChampStreakBadge.vue). Returns
// null below 1 so the badge just doesn't render.
const $f13b99686dd28c20$var$TIERS = [
    {
        min: 12,
        level: 5,
        emoji: "\uD83D\uDC51\uD83D\uDD25\uD83D\uDD25\uD83D\uDD25\uD83D\uDC51",
        word: 'LEGENDARY'
    },
    {
        min: 8,
        level: 4,
        emoji: "\uD83D\uDD25\uD83D\uDD25\uD83D\uDD25",
        word: 'UNSTOPPABLE'
    },
    {
        min: 5,
        level: 3,
        emoji: "\uD83D\uDD25\uD83D\uDD25\uD83D\uDD25",
        word: 'dominating'
    },
    {
        min: 3,
        level: 2,
        emoji: "\uD83D\uDD25\uD83D\uDD25",
        word: 'on a tear'
    },
    {
        min: 1,
        level: 1,
        emoji: "\uD83D\uDD25",
        word: ''
    }
];
function $f13b99686dd28c20$export$be6331a8d5ae80ae(streak) {
    const n = Math.max(0, Math.floor(Number(streak) || 0));
    if (n < 1) return null;
    const t = $f13b99686dd28c20$var$TIERS.find((x)=>n >= x.min);
    return {
        n: n,
        level: t.level,
        emoji: t.emoji,
        word: t.word
    };
}

});


parcelRegister("hWNKk", function(module, exports) {

$parcel$export(module.exports, "render", () => $d10e70fd0f7277f2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $d10e70fd0f7277f2$var$_hoisted_1 = [
    "title"
];
const $d10e70fd0f7277f2$var$_hoisted_2 = {
    class: "csb-fire"
};
const $d10e70fd0f7277f2$var$_hoisted_3 = {
    class: "csb-n"
};
const $d10e70fd0f7277f2$var$_hoisted_4 = {
    key: 0,
    class: "csb-word"
};
function $d10e70fd0f7277f2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $options.d ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        key: 0,
        class: (0, $8POXm.normalizeClass)([
            "csb",
            'csb-' + $options.d.level
        ]),
        title: 'Reigning champion has defended the title ' + $options.d.n + ' time' + ($options.d.n === 1 ? '' : 's') + ' in a row'
    }, [
        (0, $TusQn.createElementVNode)("span", $d10e70fd0f7277f2$var$_hoisted_2, (0, $8POXm.toDisplayString)($options.d.emoji), 1),
        (0, $TusQn.createElementVNode)("b", $d10e70fd0f7277f2$var$_hoisted_3, (0, $8POXm.toDisplayString)($options.d.n), 1),
        _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("span", {
            class: "csb-lbl"
        }, "streak", -1)),
        $options.d.word ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $d10e70fd0f7277f2$var$_hoisted_4, (0, $8POXm.toDisplayString)($options.d.word), 1)) : (0, $TusQn.createCommentVNode)("", true)
    ], 10, $d10e70fd0f7277f2$var$_hoisted_1)) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("63XTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a17cc0a6c47de5$export$2e2bcd8739ae039);
let $46a17cc0a6c47de5$var$NOOP = ()=>{};
var $46a17cc0a6c47de5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("e0SZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33bb7eb964d62db$export$2e2bcd8739ae039);
let $a33bb7eb964d62db$var$script;




let $a33bb7eb964d62db$var$initialize = ()=>{
    $a33bb7eb964d62db$var$script = (parcelRequire("fLZ9f"));
    if ($a33bb7eb964d62db$var$script.__esModule) $a33bb7eb964d62db$var$script = $a33bb7eb964d62db$var$script.default;
    $a33bb7eb964d62db$var$script.render = (parcelRequire("ehNse")).render;
    $a33bb7eb964d62db$var$script.__cssModules = {};
    (parcelRequire("inKIK")).default($a33bb7eb964d62db$var$script);
    $a33bb7eb964d62db$var$script.__scopeId = 'data-v-3d5b6c';
    $a33bb7eb964d62db$var$script.__file = "TeamRatingTip.vue";
};
$a33bb7eb964d62db$var$initialize();
var $a33bb7eb964d62db$export$2e2bcd8739ae039 = $a33bb7eb964d62db$var$script;

});
parcelRegister("fLZ9f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b7baad8e0f8508e8$export$2e2bcd8739ae039);

var $8sRxE = parcelRequire("8sRxE");
var // Compact team-rating hover content: per-unit class, a diverging win-rate bar
// (centred on the 50% average), and the unit's biggest grade drivers. Shared by
// the bracket cell badges (BracketMatch) and the team-grid header (Luxstadio).
$b7baad8e0f8508e8$export$2e2bcd8739ae039 = {
    name: 'TeamRatingTip',
    props: {
        grade: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: ''
        }
    },
    methods: {
        signed (d) {
            return (d >= 0 ? '+' : "\u2212") + Math.abs(d).toFixed(1);
        },
        // Up to 1 best + 1 worst grade driver (the row is tight; 2 chips reads well).
        drivers (u) {
            const t = (0, $8sRxE.topParts)(u.parts, 1);
            return [
                ...t.up,
                ...t.down
            ];
        },
        // Diverging bar: scores cluster ~40–60, so map that span across the track and
        // grow the fill out from the 50% centre — right/green above average, left/red below.
        barStyle (score) {
            const pos = Math.max(0, Math.min(1, (score - 40) / 20)) * 100;
            return score >= 50 ? {
                left: '50%',
                width: pos - 50 + '%'
            } : {
                left: pos + '%',
                width: 50 - pos + '%'
            };
        }
    }
};

});

parcelRegister("ehNse", function(module, exports) {

$parcel$export(module.exports, "render", () => $a66903d94a7d0da5$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $a66903d94a7d0da5$var$_hoisted_1 = {
    class: "tr"
};
const $a66903d94a7d0da5$var$_hoisted_2 = {
    class: "tr-head"
};
const $a66903d94a7d0da5$var$_hoisted_3 = {
    class: "tr-team"
};
const $a66903d94a7d0da5$var$_hoisted_4 = {
    class: "tr-avg"
};
const $a66903d94a7d0da5$var$_hoisted_5 = {
    class: "tr-line"
};
const $a66903d94a7d0da5$var$_hoisted_6 = {
    class: "tr-name"
};
const $a66903d94a7d0da5$var$_hoisted_7 = {
    class: "tr-cls"
};
const $a66903d94a7d0da5$var$_hoisted_8 = {
    class: "tr-bar"
};
const $a66903d94a7d0da5$var$_hoisted_9 = {
    key: 0,
    class: "tr-chips"
};
function $a66903d94a7d0da5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a66903d94a7d0da5$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $a66903d94a7d0da5$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("span", $a66903d94a7d0da5$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.label) + " Team", 1),
            (0, $TusQn.createElementVNode)("span", {
                class: (0, $8POXm.normalizeClass)([
                    "tr-grade",
                    'g-' + $props.grade.color
                ])
            }, (0, $8POXm.toDisplayString)($props.grade.grade), 3),
            (0, $TusQn.createElementVNode)("span", $a66903d94a7d0da5$var$_hoisted_4, "avg unit ~" + (0, $8POXm.toDisplayString)($props.grade.score) + "%", 1)
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.grade.units, (u)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: u.name,
                class: "tr-row"
            }, [
                (0, $TusQn.createElementVNode)("div", $a66903d94a7d0da5$var$_hoisted_5, [
                    (0, $TusQn.createElementVNode)("span", $a66903d94a7d0da5$var$_hoisted_6, (0, $8POXm.toDisplayString)(u.name), 1),
                    (0, $TusQn.createElementVNode)("span", $a66903d94a7d0da5$var$_hoisted_7, (0, $8POXm.toDisplayString)(u.cls), 1),
                    _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("span", {
                        class: "tr-spacer"
                    }, null, -1)),
                    (0, $TusQn.createElementVNode)("span", {
                        class: (0, $8POXm.normalizeClass)([
                            "tr-g",
                            'g-' + u.color
                        ])
                    }, (0, $8POXm.toDisplayString)(u.grade), 3),
                    (0, $TusQn.createElementVNode)("span", {
                        class: (0, $8POXm.normalizeClass)([
                            "tr-wr",
                            u.score >= 50 ? 'up' : 'down'
                        ])
                    }, "~" + (0, $8POXm.toDisplayString)(u.score) + "%", 3)
                ]),
                (0, $TusQn.createElementVNode)("div", $a66903d94a7d0da5$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: (0, $8POXm.normalizeClass)(u.score >= 50 ? 'up' : 'down'),
                        style: (0, $8POXm.normalizeStyle)($options.barStyle(u.score))
                    }, null, 6)
                ]),
                $options.drivers(u).length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a66903d94a7d0da5$var$_hoisted_9, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.drivers(u), (p)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: p.dim,
                            class: (0, $8POXm.normalizeClass)([
                                "tr-chip",
                                p.contribution >= 0 ? 'up' : 'down'
                            ])
                        }, (0, $8POXm.toDisplayString)(p.label) + " " + (0, $8POXm.toDisplayString)($options.signed(p.contribution)), 3);
                    }), 128))
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]);
        }), 128))
    ]);
}

});

parcelRegister("inKIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61e9dba4fe7fbf7$export$2e2bcd8739ae039);
let $d61e9dba4fe7fbf7$var$NOOP = ()=>{};
var $d61e9dba4fe7fbf7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7z4kn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("8WjVk")),
    import("g3Uzr"),
    import("cR4KY"),
    import("1bQnR"),
    import("kun3Y")
]).then(()=>parcelRequire('3fH5t'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("fg3Ll", function(module, exports) {

$parcel$export(module.exports, "render", () => $b1bb44d6d3681136$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $b1bb44d6d3681136$var$_hoisted_1 = {
    class: "tournament-bracket__item"
};
const $b1bb44d6d3681136$var$_hoisted_2 = {
    class: "bm-header"
};
const $b1bb44d6d3681136$var$_hoisted_3 = {
    class: "bm-vs"
};
const $b1bb44d6d3681136$var$_hoisted_4 = [
    "href"
];
const $b1bb44d6d3681136$var$_hoisted_5 = [
    "disabled"
];
const $b1bb44d6d3681136$var$_hoisted_6 = [
    "disabled"
];
const $b1bb44d6d3681136$var$_hoisted_7 = [
    "onClick"
];
const $b1bb44d6d3681136$var$_hoisted_8 = {
    key: 0,
    class: "bmp-dot"
};
const $b1bb44d6d3681136$var$_hoisted_9 = {
    key: 0,
    class: "bmp-wait"
};
const $b1bb44d6d3681136$var$_hoisted_10 = [
    "onMouseup"
];
const $b1bb44d6d3681136$var$_hoisted_11 = {
    class: "team-chip"
};
const $b1bb44d6d3681136$var$_hoisted_12 = {
    key: 0,
    class: "win-mark",
    title: "Won"
};
const $b1bb44d6d3681136$var$_hoisted_13 = {
    key: 2,
    class: "crown"
};
const $b1bb44d6d3681136$var$_hoisted_14 = {
    class: "unit-grid"
};
const $b1bb44d6d3681136$var$_hoisted_15 = [
    "src",
    "alt"
];
const $b1bb44d6d3681136$var$_hoisted_16 = {
    key: 0,
    class: "boss-badge"
};
const $b1bb44d6d3681136$var$_hoisted_17 = [
    "onMouseup"
];
const $b1bb44d6d3681136$var$_hoisted_18 = {
    class: "team-chip"
};
const $b1bb44d6d3681136$var$_hoisted_19 = {
    key: 0,
    class: "win-mark",
    title: "Won"
};
const $b1bb44d6d3681136$var$_hoisted_20 = {
    key: 2,
    class: "crown"
};
const $b1bb44d6d3681136$var$_hoisted_21 = {
    class: "unit-grid"
};
const $b1bb44d6d3681136$var$_hoisted_22 = [
    "src",
    "alt"
];
const $b1bb44d6d3681136$var$_hoisted_23 = {
    key: 0,
    class: "boss-badge"
};
const $b1bb44d6d3681136$var$_hoisted_24 = {
    key: 1,
    class: "def-box"
};
const $b1bb44d6d3681136$var$_hoisted_25 = {
    class: "def-rows"
};
const $b1bb44d6d3681136$var$_hoisted_26 = {
    class: "def-name"
};
const $b1bb44d6d3681136$var$_hoisted_27 = {
    class: "def-pct"
};
const $b1bb44d6d3681136$var$_hoisted_28 = {
    key: 0,
    class: "def-running"
};
const $b1bb44d6d3681136$var$_hoisted_29 = {
    class: "map3d-title"
};
const $b1bb44d6d3681136$var$_hoisted_30 = {
    key: 1,
    class: "map-holder"
};
const $b1bb44d6d3681136$var$_hoisted_31 = [
    "src"
];
function $b1bb44d6d3681136$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TeamRatingTip = (0, $TusQn.resolveComponent)("TeamRatingTip");
    const _component_ChampStreakBadge = (0, $TusQn.resolveComponent)("ChampStreakBadge");
    const _component_UnitSprite = (0, $TusQn.resolveComponent)("UnitSprite");
    const _component_HoverUnit = (0, $TusQn.resolveComponent)("HoverUnit");
    const _component_MapViewer3D = (0, $TusQn.resolveComponent)("MapViewer3D");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $b1bb44d6d3681136$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)([
                "tournament-bracket__match",
                {
                    'is-current': $props.isCurrent
                }
            ]),
            tabindex: "0"
        }, [
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)([
                    'bracket-match__content',
                    $props.matchClass
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_2, [
                    (0, $TusQn.createElementVNode)("span", $b1bb44d6d3681136$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.vsTitle), 1),
                    (0, $TusQn.createElementVNode)("span", {
                        ref: "mapSpan",
                        class: "bm-map",
                        onMouseenter: _cache[0] || (_cache[0] = (...args)=>$options.mapHoverStart && $options.mapHoverStart(...args)),
                        onMouseleave: _cache[1] || (_cache[1] = (...args)=>$options.mapHoverEnd && $options.mapHoverEnd(...args))
                    }, [
                        (0, $TusQn.createElementVNode)("a", {
                            href: $options.mapLink,
                            class: "bm-map-link",
                            title: "See this map's stats"
                        }, "\uD83D\uDDFA " + (0, $8POXm.toDisplayString)($props.map), 9, $b1bb44d6d3681136$var$_hoisted_4)
                    ], 544),
                    $props.onFight && $options.activeLeft && $options.activeRight ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 0,
                        class: "fight-btn",
                        onClick: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)(($event)=>$props.onFight($options.activeLeft.name, $options.activeRight.name, $props.map, $props.matchIndex), [
                            "stop"
                        ]))
                    }, "\u2694 Fight")) : (0, $TusQn.createCommentVNode)("", true),
                    $options.activeLeft && $options.activeRight ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "odds-btn",
                        disabled: $data.oddsLoading,
                        onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)((...args)=>$options.computeOdds && $options.computeOdds(...args), [
                            "stop"
                        ])),
                        title: "Run the battle sim for this matchup"
                    }, (0, $8POXm.toDisplayString)($data.oddsLoading ? "\u2026" : $options.oddsShown ? "\u21BB odds" : '% odds'), 9, $b1bb44d6d3681136$var$_hoisted_5)) : (0, $TusQn.createCommentVNode)("", true),
                    $props.challengers.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 2,
                        class: "odds-btn def-btn",
                        disabled: $data.defenseLoading,
                        onClick: _cache[4] || (_cache[4] = (0, $eeJ70.withModifiers)((...args)=>$options.computeDefenseOdds && $options.computeDefenseOdds(...args), [
                            "stop"
                        ])),
                        title: "Sim the champion vs every team still alive in the bracket"
                    }, (0, $8POXm.toDisplayString)($data.defenseLoading ? "\u2026" : $data.defenseOdds ? "\u21BB threats" : "\uD83D\uDEE1 threats"), 9, $b1bb44d6d3681136$var$_hoisted_6)) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                $props.predict ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 0,
                    class: (0, $8POXm.normalizeClass)([
                        "bm-predict",
                        $props.predict.winner ? 'graded' : 'open'
                    ])
                }, [
                    !$props.predict.winner ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        _cache[11] || (_cache[11] = (0, $TusQn.createElementVNode)("span", {
                            class: "bmp-q"
                        }, "\uD83D\uDD2E Pick:", -1)),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.predict.candidates, (t, idx)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: idx
                            }, [
                                t ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                    key: 0,
                                    class: (0, $8POXm.normalizeClass)([
                                        "bmp-btn",
                                        [
                                            t + '-team',
                                            {
                                                picked: $props.predict.picked === t
                                            }
                                        ]
                                    ]),
                                    onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('pick', t), [
                                        "stop"
                                    ])
                                }, [
                                    $props.predict.picked === t ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_8, "\uD83D\uDD2E")) : (0, $TusQn.createCommentVNode)("", true),
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.teamLabel(t)), 1)
                                ], 10, $b1bb44d6d3681136$var$_hoisted_7)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 64);
                        }), 128)),
                        !$props.predict.candidates[0] || !$props.predict.candidates[1] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_9, "\u2014 pick the earlier round first")) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, [
                        (0, $TusQn.createElementVNode)("span", {
                            class: (0, $8POXm.normalizeClass)([
                                "bmp-res",
                                !$props.predict.picked ? 'none' : $props.predict.picked === $props.predict.winner ? 'hit' : 'miss'
                            ])
                        }, [
                            !$props.predict.picked ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                (0, $TusQn.createTextVNode)("\u2014 no pick")
                            ], 64)) : $props.predict.picked === $props.predict.winner ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, [
                                (0, $TusQn.createTextVNode)("\u2713 " + (0, $8POXm.toDisplayString)($options.teamLabel($props.predict.picked)) + " +" + (0, $8POXm.toDisplayString)($props.predict.weight), 1)
                            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 2
                            }, [
                                (0, $TusQn.createTextVNode)("\u2717 you said " + (0, $8POXm.toDisplayString)($options.teamLabel($props.predict.picked)), 1)
                            ], 64))
                        ], 2),
                        $props.predict.simPick ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 0,
                            class: (0, $8POXm.normalizeClass)([
                                "bmp-sim",
                                $props.predict.simPick === $props.predict.winner ? 'hit' : 'miss'
                            ]),
                            title: "The battle sim's pick"
                        }, "\uD83E\uDD16 " + (0, $8POXm.toDisplayString)($options.teamLabel($props.predict.simPick)) + " " + (0, $8POXm.toDisplayString)($props.predict.simPick === $props.predict.winner ? "\u2713" : "\u2717"), 3)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64))
                ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.leftTeams, (team)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 'L-' + team.name
                    }, [
                        team.show ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 0,
                            onMousedown: _cache[7] || (_cache[7] = (...args)=>$props.onBracketClick && $props.onBracketClick(...args)),
                            onMouseup: ($event)=>$props.onGoto(team.name),
                            class: (0, $8POXm.normalizeClass)([
                                'left-team',
                                team.name + '-team',
                                {
                                    won: $props.leftWon,
                                    lost: $props.rightWon
                                }
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_11, [
                                $props.leftWon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_12, "\u2713 ")) : (0, $TusQn.createCommentVNode)("", true),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.teamByName[team.name].label), 1),
                                $options.teamGrades[team.name] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 1,
                                    class: (0, $8POXm.normalizeClass)([
                                        "grade-badge hasToolTip",
                                        'tier-' + $options.teamGrades[team.name].color
                                    ])
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.teamGrades[team.name].grade), 1),
                                    (0, $TusQn.createElementVNode)("span", {
                                        class: "toolTipSide tr-host",
                                        onClick: _cache[5] || (_cache[5] = (0, $eeJ70.withModifiers)(()=>{}, [
                                            "stop"
                                        ]))
                                    }, [
                                        (0, $TusQn.createVNode)(_component_TeamRatingTip, {
                                            grade: $options.teamGrades[team.name],
                                            label: $props.teamByName[team.name].label
                                        }, null, 8, [
                                            "grade",
                                            "label"
                                        ])
                                    ])
                                ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                                $props.teamByName[team.name].label === 'Champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_13, "\uD83D\uDC51")) : (0, $TusQn.createCommentVNode)("", true),
                                $props.teamByName[team.name].label === 'Champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ChampStreakBadge, {
                                    key: 3,
                                    streak: $props.champStreak
                                }, null, 8, [
                                    "streak"
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.teamOdds(team.name) != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 4,
                                    class: (0, $8POXm.normalizeClass)([
                                        "chip-odds",
                                        {
                                            fav: $options.teamOdds(team.name) >= 50
                                        }
                                    ]),
                                    title: "Estimated win chance (battle sim)"
                                }, (0, $8POXm.toDisplayString)($options.teamOdds(team.name)) + "%", 3)) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_14, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.teamByName[team.name].roster, (member, idx)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "unit-cell hasToolTip",
                                            {
                                                'is-boss': member.RaidBoss
                                            }
                                        ]),
                                        key: idx
                                    }, [
                                        $options.useSprites ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_UnitSprite, {
                                            key: 0,
                                            unit: member,
                                            "team-color": team.name === $options.activeLeft.name ? $options.cellColors.left : $options.cellColors.right,
                                            "fallback-src": $options.portrait(member, $props.teamByName[team.name].label),
                                            animated: true,
                                            "attack-bursts": $props.attackAnims,
                                            flip: team.name === $options.activeLeft.name,
                                            size: 52
                                        }, null, 8, [
                                            "unit",
                                            "team-color",
                                            "fallback-src",
                                            "attack-bursts",
                                            "flip"
                                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                                            key: 1,
                                            class: "unit-icon",
                                            src: $options.portrait(member, $props.teamByName[team.name].label),
                                            alt: member.Class,
                                            onError: _cache[6] || (_cache[6] = ($event)=>$event.target.style.visibility = 'hidden')
                                        }, null, 40, $b1bb44d6d3681136$var$_hoisted_15)),
                                        (0, $TusQn.createElementVNode)("span", {
                                            class: "unit-name",
                                            style: (0, $8POXm.normalizeStyle)($options.nameStyle(member.Name))
                                        }, [
                                            member.RaidBoss ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_16, "\u2605")) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(member.Name), 1)
                                        ], 4),
                                        (0, $TusQn.createElementVNode)("div", {
                                            class: "toolTipSide",
                                            style: (0, $8POXm.normalizeStyle)({
                                                background: $options.teamDark($props.teamByName[team.name].label),
                                                borderColor: $options.teamBright($props.teamByName[team.name].label)
                                            })
                                        }, [
                                            (0, $TusQn.createVNode)(_component_HoverUnit, {
                                                allunits: $props.items,
                                                enemyColor: team.enemyColor,
                                                teamColor: $props.teamByName[team.name].label,
                                                notAbles: $props.notAbles,
                                                charStats: $props.charStats,
                                                members: member,
                                                itemschanged: $props.itemschanged,
                                                abilitiesInfo: $props.abilitiesInfo,
                                                toolTips: $props.toolTips,
                                                highlightColors: $props.highlightColors,
                                                "show-win-rates": $props.showWinRates
                                            }, null, 8, [
                                                "allunits",
                                                "enemyColor",
                                                "teamColor",
                                                "notAbles",
                                                "charStats",
                                                "members",
                                                "itemschanged",
                                                "abilitiesInfo",
                                                "toolTips",
                                                "highlightColors",
                                                "show-win-rates"
                                            ])
                                        ], 4)
                                    ], 2);
                                }), 128))
                            ])
                        ], 42, $b1bb44d6d3681136$var$_hoisted_10)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64);
                }), 128)),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.rightTeams, (team)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 'R-' + team.name
                    }, [
                        team.show ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 0,
                            onMousedown: _cache[10] || (_cache[10] = (...args)=>$props.onBracketClick && $props.onBracketClick(...args)),
                            onMouseup: ($event)=>$props.onGoto(team.name),
                            class: (0, $8POXm.normalizeClass)([
                                'right-team',
                                team.name + '-team',
                                {
                                    won: $props.rightWon,
                                    lost: $props.leftWon
                                }
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_18, [
                                $props.rightWon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_19, "\u2713 ")) : (0, $TusQn.createCommentVNode)("", true),
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.teamByName[team.name].label), 1),
                                $options.teamGrades[team.name] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 1,
                                    class: (0, $8POXm.normalizeClass)([
                                        "grade-badge hasToolTip",
                                        'tier-' + $options.teamGrades[team.name].color
                                    ])
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.teamGrades[team.name].grade), 1),
                                    (0, $TusQn.createElementVNode)("span", {
                                        class: "toolTipSide tr-host",
                                        onClick: _cache[8] || (_cache[8] = (0, $eeJ70.withModifiers)(()=>{}, [
                                            "stop"
                                        ]))
                                    }, [
                                        (0, $TusQn.createVNode)(_component_TeamRatingTip, {
                                            grade: $options.teamGrades[team.name],
                                            label: $props.teamByName[team.name].label
                                        }, null, 8, [
                                            "grade",
                                            "label"
                                        ])
                                    ])
                                ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                                $props.teamByName[team.name].label === 'Champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_20, "\uD83D\uDC51")) : (0, $TusQn.createCommentVNode)("", true),
                                $props.teamByName[team.name].label === 'Champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ChampStreakBadge, {
                                    key: 3,
                                    streak: $props.champStreak
                                }, null, 8, [
                                    "streak"
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.teamOdds(team.name) != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 4,
                                    class: (0, $8POXm.normalizeClass)([
                                        "chip-odds",
                                        {
                                            fav: $options.teamOdds(team.name) >= 50
                                        }
                                    ]),
                                    title: "Estimated win chance (battle sim)"
                                }, (0, $8POXm.toDisplayString)($options.teamOdds(team.name)) + "%", 3)) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_21, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.teamByName[team.name].roster, (member, idx)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "unit-cell hasToolTip",
                                            {
                                                'is-boss': member.RaidBoss
                                            }
                                        ]),
                                        key: idx
                                    }, [
                                        $options.useSprites ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_UnitSprite, {
                                            key: 0,
                                            unit: member,
                                            "team-color": team.name === $options.activeLeft.name ? $options.cellColors.left : $options.cellColors.right,
                                            "fallback-src": $options.portrait(member, $props.teamByName[team.name].label),
                                            animated: true,
                                            "attack-bursts": $props.attackAnims,
                                            flip: team.name === $options.activeLeft.name,
                                            size: 52
                                        }, null, 8, [
                                            "unit",
                                            "team-color",
                                            "fallback-src",
                                            "attack-bursts",
                                            "flip"
                                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                                            key: 1,
                                            class: "unit-icon",
                                            src: $options.portrait(member, $props.teamByName[team.name].label),
                                            alt: member.Class,
                                            onError: _cache[9] || (_cache[9] = ($event)=>$event.target.style.visibility = 'hidden')
                                        }, null, 40, $b1bb44d6d3681136$var$_hoisted_22)),
                                        (0, $TusQn.createElementVNode)("span", {
                                            class: "unit-name",
                                            style: (0, $8POXm.normalizeStyle)($options.nameStyle(member.Name))
                                        }, [
                                            member.RaidBoss ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b1bb44d6d3681136$var$_hoisted_23, "\u2605")) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(member.Name), 1)
                                        ], 4),
                                        (0, $TusQn.createElementVNode)("div", {
                                            class: "toolTipSide",
                                            style: (0, $8POXm.normalizeStyle)({
                                                background: $options.teamDark($props.teamByName[team.name].label),
                                                borderColor: $options.teamBright($props.teamByName[team.name].label)
                                            })
                                        }, [
                                            (0, $TusQn.createVNode)(_component_HoverUnit, {
                                                allunits: $props.items,
                                                enemyColor: team.enemyColor,
                                                teamColor: $props.teamByName[team.name].label,
                                                notAbles: $props.notAbles,
                                                charStats: $props.charStats,
                                                members: member,
                                                itemschanged: $props.itemschanged,
                                                abilitiesInfo: $props.abilitiesInfo,
                                                toolTips: $props.toolTips,
                                                highlightColors: $props.highlightColors,
                                                "show-win-rates": $props.showWinRates
                                            }, null, 8, [
                                                "allunits",
                                                "enemyColor",
                                                "teamColor",
                                                "notAbles",
                                                "charStats",
                                                "members",
                                                "itemschanged",
                                                "abilitiesInfo",
                                                "toolTips",
                                                "highlightColors",
                                                "show-win-rates"
                                            ])
                                        ], 4)
                                    ], 2);
                                }), 128))
                            ])
                        ], 42, $b1bb44d6d3681136$var$_hoisted_17)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64);
                }), 128)),
                $data.defenseOdds ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b1bb44d6d3681136$var$_hoisted_24, [
                    _cache[12] || (_cache[12] = (0, $TusQn.createElementVNode)("div", {
                        class: "def-box-title"
                    }, "Chance to beat champ", -1)),
                    (0, $TusQn.createElementVNode)("div", $b1bb44d6d3681136$var$_hoisted_25, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.defenseOdds, (row)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: row.name,
                                class: "def-row",
                                style: (0, $8POXm.normalizeStyle)($options.rowStyle(row.name))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $b1bb44d6d3681136$var$_hoisted_26, (0, $8POXm.toDisplayString)(row.label), 1),
                                (0, $TusQn.createElementVNode)("span", $b1bb44d6d3681136$var$_hoisted_27, (0, $8POXm.toDisplayString)(row.pct) + "%", 1)
                            ], 4);
                        }), 128))
                    ]),
                    $data.defenseLoading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b1bb44d6d3681136$var$_hoisted_28, "running\u2026 " + (0, $8POXm.toDisplayString)($data.defenseOdds.length) + "/" + (0, $8POXm.toDisplayString)($props.challengers.length), 1)) : (0, $TusQn.createCommentVNode)("", true)
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ], 2)
        ], 2),
        ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.Teleport), {
            to: "body"
        }, [
            $data.mapPopOpen ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 0,
                class: "map3d-pop",
                style: (0, $8POXm.normalizeStyle)($options.mapPopStyle)
            }, [
                (0, $TusQn.createElementVNode)("h3", $b1bb44d6d3681136$var$_hoisted_29, (0, $8POXm.toDisplayString)($props.map), 1),
                $options.popTerrain ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_MapViewer3D, {
                    key: $props.map,
                    terrain: $options.popTerrain,
                    starts: $options.popStarts,
                    "mesh-url": $options.popMeshUrl,
                    "auto-rotate": true,
                    chrome: false,
                    style: {
                        "height": "300px"
                    }
                }, null, 8, [
                    "terrain",
                    "starts",
                    "mesh-url"
                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b1bb44d6d3681136$var$_hoisted_30, [
                    ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(4, (n)=>{
                        return (0, $TusQn.createElementVNode)("img", {
                            key: n,
                            src: $props.imgUrlMaps + ($props.map || '').split(')')[0] + '_' + n + '.gif'
                        }, null, 8, $b1bb44d6d3681136$var$_hoisted_31);
                    }), 64))
                ])),
                _cache[13] || (_cache[13] = (0, $TusQn.createElementVNode)("span", {
                    class: "map3d-hint"
                }, "click the map name for full stats", -1))
            ], 4)) : (0, $TusQn.createCommentVNode)("", true)
        ]))
    ]);
}

});

parcelRegister("lPxk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4835d10d9f9533$export$2e2bcd8739ae039);
let $fe4835d10d9f9533$var$NOOP = ()=>{};
var $fe4835d10d9f9533$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3Mxwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0fdbeb728994e3$export$2e2bcd8739ae039);
let $2c0fdbeb728994e3$var$script;




let $2c0fdbeb728994e3$var$initialize = ()=>{
    $2c0fdbeb728994e3$var$script = (parcelRequire("04K5F"));
    if ($2c0fdbeb728994e3$var$script.__esModule) $2c0fdbeb728994e3$var$script = $2c0fdbeb728994e3$var$script.default;
    $2c0fdbeb728994e3$var$script.render = (parcelRequire("aaivV")).render;
    $2c0fdbeb728994e3$var$script.__cssModules = {};
    (parcelRequire("lJ1Q3")).default($2c0fdbeb728994e3$var$script);
    $2c0fdbeb728994e3$var$script.__scopeId = 'data-v-cd1730';
    $2c0fdbeb728994e3$var$script.__file = "SettingsModal.vue";
};
$2c0fdbeb728994e3$var$initialize();
var $2c0fdbeb728994e3$export$2e2bcd8739ae039 = $2c0fdbeb728994e3$var$script;

});
parcelRegister("04K5F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $00e4206b831f5946$export$2e2bcd8739ae039);

var $8Iy0x = parcelRequire("8Iy0x");

var $2X6ab = parcelRequire("2X6ab");
const $00e4206b831f5946$var$SOUND_EVENT_LIST = [
    {
        key: 'newTournament',
        label: 'New tournament starting (so you can enter)'
    },
    {
        key: 'matchUp',
        label: "A highlighted user's match is coming up"
    },
    {
        key: 'win',
        label: 'A highlighted user won their match'
    },
    {
        key: 'loss',
        label: 'A highlighted user lost their match'
    },
    {
        key: 'champ',
        label: "A highlighted user won the championship \uD83C\uDFC6"
    }
];
var $00e4206b831f5946$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $8Iy0x.default)
    ],
    props: {
        // Current prefs object — we mutate a local copy and emit on changes.
        prefs: {
            type: Object,
            required: true
        }
    },
    emits: [
        'update:prefs',
        'close'
    ],
    data () {
        // Defensive clone so the parent's prefs object isn't mutated directly —
        // we emit on every change via the deep watcher below.
        return {
            local: {
                ...this.prefs,
                customHighlights: this.prefs.customHighlights.map((u)=>({
                        ...u
                    })),
                soundEvents: {
                    ...this.prefs.soundEvents || {}
                }
            },
            soundSets: (0, $2X6ab.SOUND_SETS),
            soundEventList: $00e4206b831f5946$var$SOUND_EVENT_LIST
        };
    },
    computed: {
        // Inverse of hideDefaultHighlights — the checkbox in the UI is phrased
        // positively ("Show default …") which reads better than a "Hide" toggle.
        showDefaults: {
            get () {
                return !this.local.hideDefaultHighlights;
            },
            set (v) {
                this.local.hideDefaultHighlights = !v;
            }
        },
        // Same shape, inverse of disableAnnouncements.
        showAnnouncements: {
            get () {
                return !this.local.disableAnnouncements;
            },
            set (v) {
                this.local.disableAnnouncements = !v;
            }
        },
        // Volume slider works in percent (0–200); the pref is a 0–2 multiplier.
        volumePct: {
            get () {
                return Math.round((this.local.soundVolume ?? 1) * 100);
            },
            set (v) {
                this.local.soundVolume = Math.max(0, Math.min(2, (Number(v) || 0) / 100));
            }
        }
    },
    watch: {
        local: {
            deep: true,
            handler (newVal) {
                this.$emit('update:prefs', JSON.parse(JSON.stringify(newVal)));
            }
        }
    },
    methods: {
        addUser () {
            this.local.customHighlights.push({
                name: '',
                color: '#ffd700'
            });
        },
        removeUser (i) {
            this.local.customHighlights.splice(i, 1);
        },
        // Preview a sound from the currently-selected set (plays even if the event's
        // toggle is off, so you can audition before enabling).
        testSound (ev) {
            (0, $2X6ab.playEvent)(this.local.soundSet || (0, $2X6ab.DEFAULT_SOUND_SET), ev, this.local.soundVolume);
        },
        reset () {
            if (!window.confirm('Reset all settings to defaults? (Also clears the "tournaments already announced" history.)')) return;
            this.local = {
                hideDefaultHighlights: false,
                hideBracket: false,
                customHighlights: [],
                disableAnnouncements: false,
                soundSet: (0, $2X6ab.DEFAULT_SOUND_SET),
                soundEvents: {
                    newTournament: false,
                    matchUp: false,
                    win: false,
                    loss: false,
                    champ: false
                },
                soundVolume: 1,
                expandedCards: false,
                showWinRates: false,
                attackAnims: true,
                showTicker: true,
                myUsername: '',
                myColor: '#ffd700',
                seenAnnouncements: []
            };
        }
    }
};

});
parcelRegister("8Iy0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $658ccffd5736f0a9$export$2e2bcd8739ae039);
// Shared overlay accessibility for the modals: Escape-to-close, a focus trap
// (Tab/Shift+Tab cycle within the dialog), and focus restore on close.
//
// To use: add `mixins: [modalA11y]` to a modal component, and put
// `role="dialog" aria-modal="true"` (+ an aria-label) on its dialog element.
// The mixin emits the component's close event on Escape — `close` by default;
// set a top-level `closeEvent: 'dismiss'` option to override (AnnouncementModal).
// An element inside the dialog that uses Escape itself (a picker's search box closing
// its own list) opts out with a `data-own-escape` attribute on it or an ancestor.
//
// Assumes the modal is mounted/unmounted with v-if (so the lifecycle hooks map
// to open/close), which is how Luxstadio renders them.
// Open modals, oldest first. Only the topmost handles keys, so a picker opened from
// inside a modal (My Mods' class picker) closes alone on Escape and keeps Tab to itself.
const $658ccffd5736f0a9$var$open = [];
const $658ccffd5736f0a9$var$FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
var $658ccffd5736f0a9$export$2e2bcd8739ae039 = {
    mounted () {
        this._prevFocus = typeof document !== 'undefined' && document.activeElement;
        $658ccffd5736f0a9$var$open.push(this);
        document.addEventListener('keydown', this._onModalKeydown, true);
        this.$nextTick(()=>{
            const f = this._modalFocusables();
            (f[0] || this.$el)?.focus?.();
        });
    },
    beforeUnmount () {
        document.removeEventListener('keydown', this._onModalKeydown, true);
        const i = $658ccffd5736f0a9$var$open.indexOf(this);
        if (i >= 0) $658ccffd5736f0a9$var$open.splice(i, 1);
        if (this._prevFocus && this._prevFocus.focus) this._prevFocus.focus();
    },
    methods: {
        _modalFocusables () {
            if (!this.$el || !this.$el.querySelectorAll) return [];
            return [
                ...this.$el.querySelectorAll($658ccffd5736f0a9$var$FOCUSABLE)
            ].filter((el)=>el.getClientRects().length > 0);
        },
        _onModalKeydown (e) {
            if ($658ccffd5736f0a9$var$open[$658ccffd5736f0a9$var$open.length - 1] !== this) return;
            if (e.key === 'Escape') {
                if (e.target && e.target.closest && e.target.closest('[data-own-escape]')) return;
                e.stopPropagation();
                this.$emit(this.$options.closeEvent || 'close');
                return;
            }
            if (e.key !== 'Tab') return;
            const f = this._modalFocusables();
            if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }
};

});

parcelRegister("2X6ab", function(module, exports) {

$parcel$export(module.exports, "SOUND_SETS", () => $2265df5a4d706d6a$export$c2f631c85bcd62fa);
$parcel$export(module.exports, "DEFAULT_SOUND_SET", () => $2265df5a4d706d6a$export$fa47b05ce4c8c6e0);
$parcel$export(module.exports, "playEvent", () => $2265df5a4d706d6a$export$f9702c88d617efa2);
$parcel$export(module.exports, "playEventIfEnabled", () => $2265df5a4d706d6a$export$7811bc77cfe3674d);
$parcel$export(module.exports, "teamsWithTrackedUnits", () => $2265df5a4d706d6a$export$96b1e47a889883cc);
$parcel$export(module.exports, "matchEvents", () => $2265df5a4d706d6a$export$2bbbcbdad7f1355f);
// Web-Audio notification sounds for the live tournament tracker. No audio
// assets — every built-in "set" is synthesized from oscillator tones, so it
// works offline and adds zero bytes. A set can instead declare sample URLs
// (kind:'sample') for ripped audio dropped in later; playEvent handles both.
//
// EVENTS:
//   newTournament — the current tournament finished; a new join window opens.
//   matchUp       — a tracked unit's match just became the current bracket match.
//   win / loss    — a tracked unit's match resolved.
//   champ         — a tracked unit's team won the championship match.
// One shared AudioContext, created lazily on first play (browsers require a
// user gesture first; by the time anything fires here the user has interacted).
let $2265df5a4d706d6a$var$audioCtx = null;
function $2265df5a4d706d6a$var$ctx() {
    try {
        if (!$2265df5a4d706d6a$var$audioCtx) {
            const C = window.AudioContext || window.webkitAudioContext;
            if (!C) return null;
            $2265df5a4d706d6a$var$audioCtx = new C();
        }
        if ($2265df5a4d706d6a$var$audioCtx.state === 'suspended') $2265df5a4d706d6a$var$audioCtx.resume().catch(()=>{});
        return $2265df5a4d706d6a$var$audioCtx;
    } catch  {
        return null;
    }
}
// Note sequences per event — [freq Hz, start s, dur s] triples. Shared across
// the tone-based sets; each set re-timbres them via its wave + gain. The
// sequences are designed to be recognizable: rising = good, falling = bad,
// champ = a little da-da-da-DAA fanfare.
const $2265df5a4d706d6a$var$SEQ = {
    newTournament: [
        [
            880,
            0,
            0.18
        ],
        [
            1320,
            0.13,
            0.4
        ]
    ],
    matchUp: [
        [
            659,
            0,
            0.1
        ],
        [
            880,
            0.09,
            0.1
        ],
        [
            1175,
            0.18,
            0.32
        ]
    ],
    win: [
        [
            523,
            0,
            0.12
        ],
        [
            659,
            0.1,
            0.12
        ],
        [
            784,
            0.2,
            0.12
        ],
        [
            1046,
            0.32,
            0.4
        ]
    ],
    loss: [
        [
            523,
            0,
            0.16
        ],
        [
            415,
            0.15,
            0.16
        ],
        [
            311,
            0.32,
            0.5
        ]
    ],
    champ: [
        [
            523,
            0,
            0.13
        ],
        [
            523,
            0.13,
            0.13
        ],
        [
            523,
            0.26,
            0.13
        ],
        [
            659,
            0.42,
            0.16
        ],
        [
            784,
            0.62,
            0.18
        ],
        [
            1046,
            0.82,
            0.6
        ]
    ]
};
const $2265df5a4d706d6a$export$c2f631c85bcd62fa = {
    chime: {
        label: 'Chime (soft)',
        wave: 'sine',
        gain: 0.16
    },
    retro: {
        label: 'Retro (8-bit)',
        wave: 'square',
        gain: 0.08
    },
    bell: {
        label: 'Bell (bright)',
        wave: 'triangle',
        gain: 0.15
    }
};
const $2265df5a4d706d6a$export$fa47b05ce4c8c6e0 = 'chime';
const $2265df5a4d706d6a$export$dcf51d598ef0f84f = (v)=>{
    v = Number(v);
    return Number.isFinite(v) ? Math.max(0, Math.min(2, v)) : 1;
};
function $2265df5a4d706d6a$var$playTones(set, seq, volume) {
    const c = $2265df5a4d706d6a$var$ctx();
    if (!c || !seq) return;
    const peak = set.gain * volume;
    if (peak <= 0.0001) return; // muted (also keeps the exponential ramp target positive)
    const t0 = c.currentTime;
    for (const [freq, start, dur] of seq){
        const o = c.createOscillator();
        const g = c.createGain();
        o.connect(g);
        g.connect(c.destination);
        o.type = set.wave;
        o.frequency.setValueAtTime(freq, t0 + start);
        g.gain.setValueAtTime(0.0001, t0 + start);
        g.gain.exponentialRampToValueAtTime(peak, t0 + start + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + start + dur);
        o.start(t0 + start);
        o.stop(t0 + start + dur + 0.03);
        o.onended = ()=>{
            try {
                o.disconnect();
                g.disconnect();
            } catch  {}
        };
    }
}
function $2265df5a4d706d6a$var$playSample(set, event, volume) {
    const url = set.urls && set.urls[event];
    if (!url) return;
    const vol = Math.max(0, Math.min(1, (set.volume ?? 0.6) * volume)); // HTMLAudio caps at 1.0
    if (vol <= 0) return;
    try {
        const a = new Audio(url);
        a.volume = vol;
        a.play().catch(()=>{});
    } catch  {}
}
function $2265df5a4d706d6a$export$f9702c88d617efa2(setId, event, volume = 1) {
    const set = $2265df5a4d706d6a$export$c2f631c85bcd62fa[setId] || $2265df5a4d706d6a$export$c2f631c85bcd62fa[$2265df5a4d706d6a$export$fa47b05ce4c8c6e0];
    if (!set) return;
    const v = $2265df5a4d706d6a$export$dcf51d598ef0f84f(volume);
    if (set.kind === 'sample') $2265df5a4d706d6a$var$playSample(set, event, v);
    else $2265df5a4d706d6a$var$playTones(set, $2265df5a4d706d6a$var$SEQ[event], v);
}
function $2265df5a4d706d6a$export$7811bc77cfe3674d(prefs, event) {
    if (prefs && prefs.soundEvents && prefs.soundEvents[event]) $2265df5a4d706d6a$export$f9702c88d617efa2(prefs.soundSet || $2265df5a4d706d6a$export$fa47b05ce4c8c6e0, event, prefs.soundVolume);
}
// The QF team pairs, in bracket-match order. winners[0..3] are these, [4]/[5]
// the semis, [6] the final, [7] the champ match (final winner vs. the standing
// champion team). Mirrors the bracket layout in Luxstadio.
const $2265df5a4d706d6a$var$QF_PAIRS = [
    [
        'red',
        'blue'
    ],
    [
        'green',
        'yellow'
    ],
    [
        'white',
        'black'
    ],
    [
        'purple',
        'brown'
    ]
];
function $2265df5a4d706d6a$export$19b5e2861cf558ff(i, winners) {
    const w = winners || [];
    if (i < 4) return $2265df5a4d706d6a$var$QF_PAIRS[i];
    if (i === 4) return w[0] && w[1] ? [
        w[0],
        w[1]
    ] : null;
    if (i === 5) return w[2] && w[3] ? [
        w[2],
        w[3]
    ] : null;
    if (i === 6) return w[4] && w[5] ? [
        w[4],
        w[5]
    ] : null;
    if (i === 7) return w[6] ? [
        w[6],
        'champion'
    ] : null;
    return null;
}
function $2265df5a4d706d6a$export$96b1e47a889883cc(teams, trackedLower) {
    const out = new Set();
    if (!teams || !trackedLower || !trackedLower.size) return out;
    for(const color in teams){
        const units = teams[color] && (teams[color].Units || teams[color].units);
        if (!units) continue;
        for (const u of units)if (trackedLower.has((u.Name || '').toLowerCase())) {
            out.add(color);
            break;
        }
    }
    return out;
}
function $2265df5a4d706d6a$export$2bbbcbdad7f1355f(prev, cur, myTeams) {
    const events = [];
    if (!prev || !myTeams || !myTeams.size) return events;
    const pw = prev.winners || [], cw = cur.winners || [];
    // matchUp: the current match changed to one featuring a tracked team.
    if (cur.matchIndex >= 0 && cur.matchIndex !== prev.matchIndex) {
        const pair = $2265df5a4d706d6a$export$19b5e2861cf558ff(cur.matchIndex, cw);
        if (pair && pair.some((t)=>myTeams.has(t))) events.push('matchUp');
    }
    // win/loss/champ: any slot that newly resolved this poll.
    for(let i = 0; i < 8; i++)if (cw[i] && !pw[i]) {
        const pair = $2265df5a4d706d6a$export$19b5e2861cf558ff(i, cw);
        if (!pair) continue;
        const mine = pair.find((t)=>myTeams.has(t));
        if (!mine) continue;
        if (cw[i] === mine) events.push(i === 7 ? 'champ' : 'win');
        else events.push('loss');
    }
    return events;
}

});


parcelRegister("aaivV", function(module, exports) {

$parcel$export(module.exports, "render", () => $7669330d3c1e123a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7669330d3c1e123a$var$_hoisted_1 = {
    class: "settings-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Settings"
};
const $7669330d3c1e123a$var$_hoisted_2 = {
    class: "who-row"
};
const $7669330d3c1e123a$var$_hoisted_3 = [
    "title"
];
const $7669330d3c1e123a$var$_hoisted_4 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_5 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_6 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_7 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_8 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_9 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_10 = {
    class: "sound-set-row"
};
const $7669330d3c1e123a$var$_hoisted_11 = [
    "value"
];
const $7669330d3c1e123a$var$_hoisted_12 = {
    class: "sound-volume-row"
};
const $7669330d3c1e123a$var$_hoisted_13 = {
    class: "sv-value"
};
const $7669330d3c1e123a$var$_hoisted_14 = [
    "onUpdate:modelValue"
];
const $7669330d3c1e123a$var$_hoisted_15 = {
    class: "sound-desc"
};
const $7669330d3c1e123a$var$_hoisted_16 = [
    "onClick"
];
const $7669330d3c1e123a$var$_hoisted_17 = {
    class: "checkbox-row"
};
const $7669330d3c1e123a$var$_hoisted_18 = {
    class: "custom-users"
};
const $7669330d3c1e123a$var$_hoisted_19 = [
    "onUpdate:modelValue"
];
const $7669330d3c1e123a$var$_hoisted_20 = [
    "onUpdate:modelValue",
    "title"
];
const $7669330d3c1e123a$var$_hoisted_21 = [
    "onClick"
];
const $7669330d3c1e123a$var$_hoisted_22 = {
    class: "footer"
};
function $7669330d3c1e123a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay top settings-backdrop",
        onClick: _cache[15] || (_cache[15] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $7669330d3c1e123a$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "close-btn",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\xd7"),
            _cache[34] || (_cache[34] = (0, $TusQn.createElementVNode)("h1", null, "Luxor's Wiznaib.us", -1)),
            _cache[35] || (_cache[35] = (0, $TusQn.createElementVNode)("p", {
                class: "blurb"
            }, [
                (0, $TusQn.createTextVNode)(" A unit-stats viewer for "),
                (0, $TusQn.createElementVNode)("a", {
                    href: "https://twitch.tv/fftbattleground",
                    target: "_blank",
                    rel: "noopener"
                }, "FFTBG"),
                (0, $TusQn.createTextVNode)(" \u2014 the Final Fantasy Tactics tournament bot on Twitch. Thanks to thekillernacho for running it. ")
            ], -1)),
            (0, $TusQn.createElementVNode)("section", null, [
                _cache[16] || (_cache[16] = (0, $TusQn.createElementVNode)("h3", null, "Who are you?", -1)),
                _cache[17] || (_cache[17] = (0, $TusQn.createElementVNode)("p", {
                    class: "hint"
                }, " Your Twitch username \u2014 adds a \uD83D\uDC64 button to the top bar for quick access to your player profile, and highlights your name on the bracket. ", -1)),
                (0, $TusQn.createElementVNode)("div", $7669330d3c1e123a$var$_hoisted_2, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.local.myUsername = $event),
                        placeholder: "username",
                        maxlength: "30",
                        class: "my-username-input"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.local.myUsername
                        ]
                    ]),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "color",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.local.myColor = $event),
                        title: 'Highlight color for ' + ($data.local.myUsername || 'you')
                    }, null, 8, $7669330d3c1e123a$var$_hoisted_3), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.local.myColor
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("section", null, [
                _cache[24] || (_cache[24] = (0, $TusQn.createElementVNode)("h3", null, "Display", -1)),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_4, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.local.hideBracket = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.local.hideBracket
                        ]
                    ]),
                    _cache[18] || (_cache[18] = (0, $TusQn.createTextVNode)(" Hide bracket section ", -1))
                ]),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_5, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.local.showTicker = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.local.showTicker
                        ]
                    ]),
                    _cache[19] || (_cache[19] = (0, $TusQn.createTextVNode)(' Show the \uD83C\uDF89 "Just happened" strip (recent titles, quests and long reigns) ', -1))
                ]),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_6, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$options.showAnnouncements = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $options.showAnnouncements
                        ]
                    ]),
                    _cache[20] || (_cache[20] = (0, $TusQn.createTextVNode)(" Show big \"X is in! / X was Snubbed!\" callout at start of each tournament ", -1))
                ]),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_7, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.local.expandedCards = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.local.expandedCards
                        ]
                    ]),
                    _cache[21] || (_cache[21] = (0, $TusQn.createTextVNode)(" Expand unit cards by default (show full detail without clicking) ", -1))
                ]),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_8, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.local.showWinRates = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.local.showWinRates
                        ]
                    ]),
                    _cache[22] || (_cache[22] = (0, $TusQn.createTextVNode)(" Color skills & gear by win rate (green = above average, red = below) ", -1))
                ]),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_9, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$data.local.attackAnims = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.local.attackAnims
                        ]
                    ]),
                    _cache[23] || (_cache[23] = (0, $TusQn.createTextVNode)(" Live-match fighters occasionally play their attack animation ", -1))
                ])
            ]),
            (0, $TusQn.createElementVNode)("section", null, [
                _cache[27] || (_cache[27] = (0, $TusQn.createElementVNode)("h3", null, "Sounds", -1)),
                _cache[28] || (_cache[28] = (0, $TusQn.createElementVNode)("p", {
                    class: "hint"
                }, [
                    (0, $TusQn.createTextVNode)(" Optional notification sounds for your "),
                    (0, $TusQn.createElementVNode)("b", null, "highlighted users"),
                    (0, $TusQn.createTextVNode)(" (above) \u2014 a chime when their match comes up, when it's won or lost, and a fanfare if they champ. ")
                ], -1)),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_10, [
                    _cache[25] || (_cache[25] = (0, $TusQn.createTextVNode)(" Sound set ", -1)),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$data.local.soundSet = $event)
                    }, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.soundSets, (s, id)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                key: id,
                                value: id
                            }, (0, $8POXm.toDisplayString)(s.label), 9, $7669330d3c1e123a$var$_hoisted_11);
                        }), 128))
                    ], 512), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.local.soundSet
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $7669330d3c1e123a$var$_hoisted_12, [
                    _cache[26] || (_cache[26] = (0, $TusQn.createElementVNode)("span", {
                        class: "sv-label"
                    }, "Volume", -1)),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "200",
                        step: "5",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$options.volumePct = $event),
                        "aria-label": "Notification volume"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $options.volumePct,
                            void 0,
                            {
                                number: true
                            }
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("span", $7669330d3c1e123a$var$_hoisted_13, (0, $8POXm.toDisplayString)($options.volumePct) + "%", 1),
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "sound-test",
                        onClick: _cache[11] || (_cache[11] = (0, $eeJ70.withModifiers)(($event)=>$options.testSound('newTournament'), [
                            "prevent"
                        ])),
                        title: "Preview at this volume"
                    }, "\u25B6")
                ]),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.soundEventList, (ev)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", {
                        key: ev.key,
                        class: "checkbox-row sound-row"
                    }, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event)=>$data.local.soundEvents[ev.key] = $event
                        }, null, 8, $7669330d3c1e123a$var$_hoisted_14), [
                            [
                                (0, $eeJ70.vModelCheckbox),
                                $data.local.soundEvents[ev.key]
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", $7669330d3c1e123a$var$_hoisted_15, (0, $8POXm.toDisplayString)(ev.label), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "sound-test",
                            onClick: (0, $eeJ70.withModifiers)(($event)=>$options.testSound(ev.key), [
                                "prevent"
                            ]),
                            title: "Preview"
                        }, "\u25B6", 8, $7669330d3c1e123a$var$_hoisted_16)
                    ]);
                }), 128))
            ]),
            (0, $TusQn.createElementVNode)("section", null, [
                _cache[30] || (_cache[30] = (0, $TusQn.createElementVNode)("h3", null, "Highlighted users", -1)),
                _cache[31] || (_cache[31] = (0, $TusQn.createElementVNode)("p", {
                    class: "hint"
                }, " Names listed here get a callout (\"X is in!\" / \"X was Snubbed!\") when they enter or get snubbed from a tournament. ", -1)),
                (0, $TusQn.createElementVNode)("label", $7669330d3c1e123a$var$_hoisted_17, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$options.showDefaults = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $options.showDefaults
                        ]
                    ]),
                    _cache[29] || (_cache[29] = (0, $TusQn.createTextVNode)(" Show default highlighted players (luxordoesntframe, yoimbear, firstodie) ", -1))
                ]),
                (0, $TusQn.createElementVNode)("div", $7669330d3c1e123a$var$_hoisted_18, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.local.customHighlights, (user, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: i,
                            class: "custom-row"
                        }, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event)=>user.name = $event,
                                placeholder: "username",
                                maxlength: "30"
                            }, null, 8, $7669330d3c1e123a$var$_hoisted_19), [
                                [
                                    (0, $eeJ70.vModelText),
                                    user.name
                                ]
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "color",
                                "onUpdate:modelValue": ($event)=>user.color = $event,
                                title: 'Color for ' + (user.name || 'this user')
                            }, null, 8, $7669330d3c1e123a$var$_hoisted_20), [
                                [
                                    (0, $eeJ70.vModelText),
                                    user.color
                                ]
                            ]),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "remove-btn",
                                onClick: ($event)=>$options.removeUser(i),
                                "aria-label": "Remove"
                            }, "\xd7", 8, $7669330d3c1e123a$var$_hoisted_21)
                        ]);
                    }), 128)),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "add-btn",
                        onClick: _cache[13] || (_cache[13] = (...args)=>$options.addUser && $options.addUser(...args))
                    }, "+ Add user")
                ])
            ]),
            (0, $TusQn.createElementVNode)("section", $7669330d3c1e123a$var$_hoisted_22, [
                _cache[32] || (_cache[32] = (0, $TusQn.createElementVNode)("a", {
                    href: "?intro",
                    class: "nav-btn"
                }, "\uD83C\uDF93 Replay intro tour", -1)),
                _cache[33] || (_cache[33] = (0, $TusQn.createElementVNode)("a", {
                    href: "?changelog",
                    class: "nav-btn"
                }, "\uD83D\uDCDC What's new", -1)),
                (0, $TusQn.createElementVNode)("button", {
                    class: "reset-btn",
                    onClick: _cache[14] || (_cache[14] = (...args)=>$options.reset && $options.reset(...args))
                }, "Reset all settings")
            ])
        ])
    ]);
}

});

parcelRegister("lJ1Q3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd0f3a0e73988698$export$2e2bcd8739ae039);
let $fd0f3a0e73988698$var$NOOP = ()=>{};
var $fd0f3a0e73988698$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("dt5j6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce219afc7406a06$export$2e2bcd8739ae039);
let $9ce219afc7406a06$var$script;




let $9ce219afc7406a06$var$initialize = ()=>{
    $9ce219afc7406a06$var$script = (parcelRequire("2I4Nn"));
    if ($9ce219afc7406a06$var$script.__esModule) $9ce219afc7406a06$var$script = $9ce219afc7406a06$var$script.default;
    $9ce219afc7406a06$var$script.render = (parcelRequire("eYTsC")).render;
    $9ce219afc7406a06$var$script.__cssModules = {};
    (parcelRequire("R6gXg")).default($9ce219afc7406a06$var$script);
    $9ce219afc7406a06$var$script.__scopeId = 'data-v-7a3ec4';
    $9ce219afc7406a06$var$script.__file = "HelpModal.vue";
};
$9ce219afc7406a06$var$initialize();
var $9ce219afc7406a06$export$2e2bcd8739ae039 = $9ce219afc7406a06$var$script;

});
parcelRegister("2I4Nn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1f93691554b584a0$export$2e2bcd8739ae039);

var $6qlKJ = parcelRequire("6qlKJ");

var $8Iy0x = parcelRequire("8Iy0x");
var $1f93691554b584a0$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $8Iy0x.default)
    ],
    emits: [
        'close'
    ],
    data () {
        return {
            sections: (0, $6qlKJ.HELP_SECTIONS),
            capturedDate: (0, $6qlKJ.HELP_CAPTURED_DATE),
            sourceUrl: (0, $6qlKJ.HELP_SOURCE_URL),
            activeId: (0, $6qlKJ.HELP_SECTIONS)[0].id,
            // Command-table state (only relevant on the Commands section).
            cmdQuery: '',
            cmdCategory: 'all'
        };
    },
    computed: {
        activeSection () {
            return this.sections.find((s)=>s.id === this.activeId) || this.sections[0];
        }
    },
    watch: {
        // Scroll the content pane back to the top when switching sections, and
        // reset the command filters so they don't leak between visits.
        activeId () {
            this.cmdQuery = '';
            this.cmdCategory = 'all';
            this.$nextTick(()=>{
                if (this.$refs.content) this.$refs.content.scrollTop = 0;
            });
        }
    },
    methods: {
        // Flatten the chosen category's commands (or all), then filter by the
        // search box against command name + description.
        filteredCommands (block) {
            const cats = this.cmdCategory === 'all' ? block.categories : block.categories.filter((c)=>c.name === this.cmdCategory);
            const all = cats.flatMap((c)=>c.cmds);
            const q = this.cmdQuery.trim().toLowerCase();
            if (!q) return all;
            return all.filter((c)=>(c.name + ' ' + (c.params || '') + ' ' + c.desc).toLowerCase().includes(q));
        }
    }
};

});
parcelRegister("6qlKJ", function(module, exports) {

$parcel$export(module.exports, "HELP_CAPTURED_DATE", () => $4ad60b6722ad1e73$export$3bbfbfd251fcb0ba);
$parcel$export(module.exports, "HELP_SOURCE_URL", () => $4ad60b6722ad1e73$export$f897aaa5f7f97412);
$parcel$export(module.exports, "HELP_SECTIONS", () => $4ad60b6722ad1e73$export$9306f1594bbcdd2d);
// FFTBG help content — sourced from TheKillerNacho's Twitch description.
// Captured 2026-05-27. If the canonical text changes, this is the file to edit.
//
// Section shape: { id, title, blocks: [...] }
// Block types: 'p', 'h', 'callout', 'list', 'cmd', 'link', 'resources', 'commands'
//   p:         { type: 'p', text }
//   h:         { type: 'h', text }        sub-heading inside a section
//   callout:   { type: 'callout', text }  emphasized box (for "beware!" notes)
//   list:      { type: 'list', items }    bulleted list of strings
//   cmd:       { type: 'cmd', name, desc } single command line
//   link:      { type: 'link', url, label }
//   resources: { type: 'resources', items: [{ label, url?, by?, desc? }] }
//                                  — url is optional; without it the label is
//                                    rendered as plain text (no fabricated URL)
//   commands:  { type: 'commands', categories: [{ name, cmds: [{name, params, desc}] }] }
//                                  — the filterable command table
const $4ad60b6722ad1e73$export$3bbfbfd251fcb0ba = '2026-05-27';
const $4ad60b6722ad1e73$export$f897aaa5f7f97412 = 'https://www.twitch.tv/fftbattleground/about';
const $4ad60b6722ad1e73$export$9306f1594bbcdd2d = [
    {
        id: 'welcome',
        title: 'Welcome',
        blocks: [
            {
                type: 'p',
                text: 'FFTBattleground is an automated stream of continual Final Fantasy Tactics battles, pitting squads of four AI-controlled units against each other in single-elimination tournaments featuring eight teams: Red, Blue, Green, Yellow, White, Black, Purple and Brown. The winner of each tournament earns the right to challenge the current Champion team to seize that position for themselves.'
            },
            {
                type: 'p',
                text: 'While this stream attempts to preserve the spirit of the vanilla game, it does use a custom mod containing a handful of additions and balancing changes. Most of these modifications were made with the goal of making the battles as interesting and engaging as possible.'
            },
            {
                type: 'p',
                text: 'The FFTBG Discord and historical VoDs on YouTube are linked under Helpful Links, along with the community tools that power sites like this one.'
            }
        ]
    },
    {
        id: 'site',
        title: 'About This Site',
        blocks: [
            {
                type: 'p',
                text: "Wiznaib.us is a community-built viewer for FFTBG tournaments. It shows live brackets, full unit cards with estimated combat damage, and a battle simulator that predicts match outcomes. Everything runs client-side from public data \u2014 no accounts, no backend."
            },
            {
                type: 'h',
                text: 'The grade system'
            },
            {
                type: 'p',
                text: 'Every unit gets a two-part grade based on historical win rates across tens of thousands of tournaments:'
            },
            {
                type: 'list',
                items: [
                    "The COLOR (gold / blue / green / grey) is the type tier \u2014 how good this kind of unit is overall. A gold-tier class like Holy Dragon wins more often than a grey-tier one regardless of how it's rolled. Gender matters: Female Monk and Male Monk have different baselines because their stat distributions differ.",
                    "The LETTER (A+ through F) is the specimen grade \u2014 how good this specific unit is for its type, relative to an average unit of the same class and gender. It looks at support, reaction, and secondary skills (using per-class win rates, not overall), plus post-gear stats and Brave/Faith scored by archetype (high PA matters for melee, high MA for casters)."
                ]
            },
            {
                type: 'p',
                text: 'So a "grey A+" is a great specimen of a weak type \u2014 the best possible Squire, but still a Squire. A "gold D" is a poorly-rolled powerhouse that\'s coasting on class strength. The grades are correlational (what tends to win), not a simulation \u2014 the battle sim handles the actual matchup odds.'
            },
            {
                type: 'h',
                text: 'Win-rate highlighting'
            },
            {
                type: 'p',
                text: 'When enabled in Settings, skill and gear names shift green (above average) or red (below average) based on their empirical win rate. The intensity scales with how far the rate deviates from 50%. A faint tint means it barely matters; a vivid color means it\'s a real outlier. Hover any colored name to see the exact win rate.'
            },
            {
                type: 'h',
                text: 'The battle simulator'
            },
            {
                type: 'p',
                text: 'The "Simulate" button in the fight view (and the "% odds" on bracket cells) runs a Monte Carlo battle sim \u2014 hundreds of randomized fights on the real map geometry with the actual unit stats, abilities, reactions, and statuses. The displayed odds are calibrated against historical outcomes so the percentages are honest, not over-confident.'
            },
            {
                type: 'h',
                text: 'Other pages'
            },
            {
                type: 'list',
                items: [
                    "Champions \u2014 the live Tournament of Champions leaderboard with sim odds and season history.",
                    "Players \u2014 full career stats, per-class win rates, championship history, and Monster Quest progress for every player.",
                    "Maps \u2014 all 138 battle maps with empirical class win rates, terrain grids, 3D models, and Calculator height targeting.",
                    "Gear Lab \u2014 item combo lookup: has this gear pair ever rolled, how often, and who won with it?",
                    "Builder \u2014 create a unit from scratch and see its full card, then export it in stream-ready format.",
                    "Stats \u2014 the data engine: windowed win rates for every class, skill, item, and stat, with archetype breakdowns and monthly trends.",
                    "Mechanics \u2014 how the battle engine works: damage, evasion, zodiac, Faith and turn order, with live calculators built on the same math the cards use."
                ]
            }
        ]
    },
    {
        id: 'betting',
        title: 'Betting',
        blocks: [
            {
                type: 'p',
                text: "The primary objective for viewers is to accumulate Gil, the stream's currency. Your account starts with a balance of 1,000G, and it cannot fall below your Gil Floor (100G by default)."
            },
            {
                type: 'p',
                text: 'The main way to earn Gil is to bet on the outcome of matches. Betting takes place during a 60-second window preceding each match.'
            },
            {
                type: 'cmd',
                name: '!balance',
                desc: 'View your current balance at any time.'
            },
            {
                type: 'cmd',
                name: '!bet {wager} {team}',
                desc: 'Submit a wager during the betting window. Team name can be its color, or simply "left" or "right".'
            },
            {
                type: 'p',
                text: 'You may change your bet at any point before the deadline, or cancel it completely with !bet cancel.'
            },
            {
                type: 'callout',
                text: 'Beware! Reducing your bet or cancelling it (including changing it to the other team) causes the bank to keep a 10% cancellation fee.'
            },
            {
                type: 'cmd',
                name: '!bet',
                desc: 'Check your bet for the current match and how much you stand to win.'
            },
            {
                type: 'h',
                text: 'Quick wagers'
            },
            {
                type: 'cmd',
                name: '!allin {team}',
                desc: 'Wager your entire balance.'
            },
            {
                type: 'cmd',
                name: '!halfin {team}',
                desc: 'Wager half your current balance.'
            },
            {
                type: 'cmd',
                name: '!betf {team}',
                desc: 'Wager an amount equal to your Gil Floor.'
            },
            {
                type: 'h',
                text: 'Odds'
            },
            {
                type: 'p',
                text: 'Payout odds are determined by the ratio of total Gil wagered on each side. The stream matches bets on one side up to 500G when viewer population is low.'
            },
            {
                type: 'cmd',
                name: '!pot',
                desc: 'Get the current pot totals and odds from the bot.'
            }
        ]
    },
    {
        id: 'team-gen',
        title: 'Team Generation',
        blocks: [
            {
                type: 'p',
                text: 'At the beginning of each tournament, eight teams are generated, each consisting of four randomized units. During this period, you can attempt to enter the fray yourself.'
            },
            {
                type: 'cmd',
                name: '!fight',
                desc: 'Enter for a chance to have a unit generated. If selected, the unit bears your name and earns you EXP with each victory.'
            },
            {
                type: 'p',
                text: 'Optionally, you can spend Gil to enhance your unit with up to four parameters:'
            },
            {
                type: 'cmd',
                name: '!fight [class] [sex] [skill] -[exclude]',
                desc: 'Each parameter costs 100G, deducted only when chosen. Class is required when using two or more parameters. Using a skill guarantees the corresponding ability/effect; excluding a skill prevents it from being randomly received.'
            },
            {
                type: 'p',
                text: 'All human classes and sexes are available by default, but skills and monster classes must be acquired before use (see Skills). Monsters are incompatible with other parameters and have a unique price by species: 200G normal, 500G strong, 800G elite.'
            },
            {
                type: 'cmd',
                name: '!skills',
                desc: 'See the skills available to you.'
            },
            {
                type: 'cmd',
                name: '!classes',
                desc: 'See the classes available to you.'
            },
            {
                type: 'h',
                text: 'Unit display order'
            },
            {
                type: 'p',
                text: 'During generation, each unit is shown in detail in this order:'
            },
            {
                type: 'list',
                items: [
                    'Name',
                    'Gender',
                    'Zodiac Sign',
                    'Brave',
                    'Faith',
                    'Job',
                    'Secondary',
                    'Reaction',
                    'Support',
                    'Movement',
                    'Hand / Offhand / Head / Body Equipment, Accessory',
                    'Primary Abilities',
                    'Secondary Abilities'
                ]
            },
            {
                type: 'p',
                text: 'Certain abilities and items are rarer than others, with the most powerful being a rare (but still possible) sight.'
            }
        ]
    },
    {
        id: 'skills',
        title: 'Skills',
        blocks: [
            {
                type: 'p',
                text: 'Collecting and using skills lets you customize your generated units. There are three types:'
            },
            {
                type: 'list',
                items: [
                    'Ability Skills represent an in-game secondary skillset, reaction, support, movement ability, or accessory item. Applied to a human unit they force the corresponding ability/item; excluded, they prevent it from being randomly rolled.',
                    "Meta Skills provide a special effect when applied \u2014 some manipulate the randomization process to favor good rolls, others alter victory rewards. Excluding them applies a unique (usually inverse) effect.",
                    "Monster Skills unlock the associated monster class. They aren't compatible with other skills or exclusions."
                ]
            },
            {
                type: 'h',
                text: 'Getting skills'
            },
            {
                type: 'p',
                text: 'At the start of each tournament a Skill Drop is announced. Users who submit an entry are entered in a raffle to win it free; others can purchase it.'
            },
            {
                type: 'cmd',
                name: '!buy',
                desc: 'Purchase the current Skill Drop for 1,000G (anytime after the raffle, before the tournament ends).'
            },
            {
                type: 'p',
                text: 'You also receive a free random skill when reaching Level 1 and every three Level Ups thereafter, until Level 100. After that, you can purchase random skills for 25,000G (discounted 100G per Level Up beyond 100, minimum 5,000G).'
            },
            {
                type: 'cmd',
                name: '!buyrandom',
                desc: 'Purchase a randomly selected unowned skill (Level 100+).'
            },
            {
                type: 'cmd',
                name: '!gift',
                desc: 'Gift a Skill Drop you own to a random raffle entrant for 2,000G (recipient is random).'
            },
            {
                type: 'h',
                text: 'Cooldowns'
            },
            {
                type: 'p',
                text: "Each time you use a skill it enters a cooldown: you can't use it on your next five admitted entries, and it carries a priority and EXP penalty on the four after that \u2014 nine generated units total before it's penalty-free again."
            },
            {
                type: 'cmd',
                name: '!cooldown',
                desc: 'List which of your skills are currently unusable or penalized.'
            },
            {
                type: 'p',
                text: "A community skill checklist (by kevv2, revised by DustbirdEX) is linked under Helpful Links."
            }
        ]
    },
    {
        id: 'exp',
        title: 'Experience & Leveling',
        blocks: [
            {
                type: 'p',
                text: 'You earn EXP when various conditions are met. Each time you reach 100 EXP you Level Up, raising your Gil Floor by 5G and granting a free random skill on the first level and every three after.'
            },
            {
                type: 'cmd',
                name: '!exp',
                desc: 'Get your Level, progress to the next, and when you earn your next free skill.'
            },
            {
                type: 'h',
                text: 'Three ways to earn EXP'
            },
            {
                type: 'list',
                items: [
                    "Betting \u2014 1 EXP for each bonus that applies: winning the wager; wagering at least half your balance; placing a wager (\u2265100G) in the first 30 seconds without changing it; being among the top 25% of all wagers.",
                    "Your unit winning \u2014 5 EXP by default when a unit you generated wins a match (modified by the bonuses/penalties below).",
                    "Allegiance \u2014 if your entry isn't admitted, you earn EXP (1 by default, 3 for subs) each time your allied team wins."
                ]
            },
            {
                type: 'h',
                text: 'Bonuses & penalties'
            },
            {
                type: 'list',
                items: [
                    'Up to -4 for using a skill you used recently.',
                    'Up to +7 for entering as a human class that extends your class streak (consecutive classes used without repeating). The bonus grows as the streak continues.',
                    '+1 for entering without parameters (stacks with the Class Bonus).',
                    '+2 for using your current Skill Bonus (which changes to a random owned skill each time you are admitted).',
                    'Double EXP (betting and winning) during the championship match.',
                    'Half your normal reward as a consolation prize if you lose in the first round.'
                ]
            },
            {
                type: 'cmd',
                name: '!allegiance {team}',
                desc: 'Set which team you earn allegiance EXP with (takes effect the following tournament).'
            },
            {
                type: 'cmd',
                name: '!bonus',
                desc: 'List your Class Bonus options and your current Skill Bonus.'
            },
            {
                type: 'p',
                text: "There's no Level cap, but the Gil Floor increase and free skills stop at Level 100 \u2014 by which point your Gil Floor has risen 500G total and you've learned 34 free skills. Leveling past 100 instead reduces the !buyrandom cost."
            }
        ]
    },
    {
        id: 'priority',
        title: 'Entry Priority',
        blocks: [
            {
                type: 'p',
                text: "Priority adjusts the odds of being admitted to a tournament. The bot doesn't strictly take higher entries first \u2014 it picks a random entry from the queue, then rolls a Priority% check to decide whether to admit it, repeating until one succeeds."
            },
            {
                type: 'h',
                text: 'Your priority'
            },
            {
                type: 'list',
                items: [
                    'Base: 30',
                    "+40 if you weren't admitted into the previous tournament despite entering",
                    '+20 if subscribed',
                    '+10 while entering without parameters',
                    '+5 while using your current Skill Bonus',
                    '+5 while excluding the GilgameHeart skill',
                    '-3 to -10 while using a skill or monster you used recently',
                    '-10 while using an uncommon skill or strong monster',
                    '-15 while using a rare skill or elite monster',
                    "-25% to -50% if you've gotten in at least once in the last three tournaments (-50% for the first two, -25% on the third)",
                    "-1 when rolling on a team that doesn't match your allegiance (-2 if that team is opposed to your color)"
                ]
            },
            {
                type: 'h',
                text: 'Rarity tiers'
            },
            {
                type: 'p',
                text: 'Rare (-15) skills: any elite monster, DrawOut, Doublehand, DualWield, ShortCharge, Hamedo, GenjiGauntlet, VanishMantle, and all hidden skills.'
            },
            {
                type: 'p',
                text: 'Uncommon (-10) skills: any strong monster, EquipGun, ThrowItem, AutoPotion, DamageSplit, HPRestore, ManaShield, Move+3, AngelRing, FeatherMantle, GearedUp, HighlySkilled, and PreferredArms.'
            },
            {
                type: 'h',
                text: 'Snub protection'
            },
            {
                type: 'p',
                text: "Up to three slots (depending on the number of entries) are reserved for entrants with the longest snub streaks \u2014 entries attempted since last being admitted. Ties are broken by priority."
            },
            {
                type: 'callout',
                text: "There's a hard cap of 32 slots each tournament. Higher priority improves your chances a fair amount, but it's no guarantee when there are a lot of entrants."
            }
        ]
    },
    {
        id: 'prestige',
        title: 'Prestige & Hidden Skills',
        blocks: [
            {
                type: 'p',
                text: 'Users who have reached Level 100 and obtained every skill can ascend to a new level of prestige \u2014 essentially a "New Game Plus." Ascending completely resets your account (all Gil, EXP, and skills). In exchange, your base Gil Floor increases by 50G and you learn one hidden skill exclusive to prestige.'
            },
            {
                type: 'cmd',
                name: '!prestige',
                desc: "Check how many times you've ascended and the hidden skills you've obtained."
            },
            {
                type: 'p',
                text: "Hidden skills are unstable by nature \u2014 created with the most powerful effects conceivable. They count as rare skills for priority, share a cooldown with each other, and are forgotten upon use (only temporarily). A forgotten hidden skill has a chance to be remembered with each Level Up."
            },
            {
                type: 'callout',
                text: "Consider carefully before ascending \u2014 the cost is heavy."
            },
            {
                type: 'cmd',
                name: '!prestige ascend',
                desc: 'Reset your account to advance a level of prestige (only if you meet the requirements).'
            },
            {
                type: 'cmd',
                name: '!hidden',
                desc: 'List the hidden skills you currently remember and their shared penalty.'
            }
        ]
    },
    {
        id: 'subs',
        title: 'Subscriber Benefits',
        blocks: [
            {
                type: 'p',
                text: 'If you choose to subscribe to support the channel, it is highly appreciated! Subscribing grants:'
            },
            {
                type: 'list',
                items: [
                    'Base Gil Floor increases from 100G to 200G.',
                    'Eligibility for the bonus Skill Drop raffle at the start of each tournament.',
                    '+20 priority to be admitted into each tournament.',
                    '+2 EXP whenever your allegiance team wins.',
                    'Change your portrait to monsters and special characters (like Ramza).',
                    'A small chance to spawn as a powerful Raid Boss when entering without parameters (see Raid Bosses).',
                    'No ad breaks at the end of each tournament or when first tuning in.',
                    'Access to FFT-themed emotes for use anywhere on Twitch.'
                ]
            },
            {
                type: 'p',
                text: 'There may be more perks in the future, but nothing that would provide a competitive advantage.'
            }
        ]
    },
    {
        id: 'raids',
        title: 'Raid Bosses',
        blocks: [
            {
                type: 'p',
                text: 'Rarely, subscribers entering without parameters can spawn as a powerful Raid Boss! A special sound effect plays, and Raid Bosses are identified by a [!] marker next to their name.'
            },
            {
                type: 'p',
                text: "The default chance a unit spawns as a Raid Boss is just 0.25%. Subscribers can boost their allied team\u2019s chance by donating bits, subscribing, or gifting a sub: the team\u2019s chance becomes X%, where X = bits donated \xf7 50 (each subscription adds 100 bits to the total). The bonus resets when a Raid Boss is successfully summoned."
            },
            {
                type: 'p',
                text: 'Raid Bosses generate as if they used all four of the BraveBoost, FaithBoost, HighlySkilled, and GearedUp skills.'
            },
            {
                type: 'cmd',
                name: '!raid',
                desc: "Get each team's current chance to spawn a Raid Boss."
            },
            {
                type: 'cmd',
                name: '!raids',
                desc: 'List the Raid Bosses that spawned into the current tournament.'
            },
            {
                type: 'h',
                text: 'Rewards'
            },
            {
                type: 'p',
                text: 'If a Raid Boss reaches the championship match, it earns an extra 25 EXP and 2,500G. Teammates (including allegiance-EXP earners) get 10 EXP and 1,000G. If the Raid Boss then defeats the Champion team, these gains are doubled.'
            },
            {
                type: 'p',
                text: "If the Raid Boss falls before that point, everyone who entered the tournament at the start \u2014 except those allied with the Raid Boss, a team it defeated, or a team defeated by a team it defeated \u2014 earns 5 EXP and 500G. Those allied with the team that actually defeated the Raid Boss earn double."
            }
        ]
    },
    {
        id: 'onscreen',
        title: 'Onscreen Messages',
        blocks: [
            {
                type: 'p',
                text: 'When you are in the fray and currently fighting, your chat input is displayed on stream via text boxes (disabled while the emulator is receiving input).'
            },
            {
                type: 'p',
                text: 'Even when just spectating, you can display an onscreen message by highlighting it with channel points or cheering with at least 10 bits. Cheer messages play a sound effect and last longer depending on the bit amount. To avoid showing the Cheer emote, use FFTBGcheer or the default Cheer emote.'
            },
            {
                type: 'p',
                text: 'Onscreen messages display an avatar with a portrait of your choosing. Every human class portrait (followed by sex) is available to everyone; subscribers can additionally pick monster and unique-character portraits (like Ramza and Delita).'
            },
            {
                type: 'cmd',
                name: '!portrait {portrait}',
                desc: 'Change your displayed portrait at any time.'
            },
            {
                type: 'p',
                text: "Chuckolator's portrait list is linked under Helpful Links."
            }
        ]
    },
    {
        id: 'rules',
        title: 'Rules',
        blocks: [
            {
                type: 'h',
                text: 'Tiebreakers & Time Overs'
            },
            {
                type: 'p',
                text: 'If a match ends in a tie (both teams eliminated simultaneously), it results in a Team 2 default victory \u2014 this situation causes a Game Over in the vanilla game. To compensate, Team 1 gets a default victory on a "Time Over," which triggers if a match exceeds roughly 20 minutes. Most matches finish far sooner; this exists to prevent an infinite match.'
            },
            {
                type: 'callout',
                text: "The Champion team always plays as Team 2 but wins both ties and Time Overs \u2014 challengers must earn a decisive victory to usurp the throne."
            },
            {
                type: 'h',
                text: 'Cheating'
            },
            {
                type: 'p',
                text: "Cheating via automated botting, multi-accounting (playing more than one account at once), or any other method is strictly forbidden. Detection code is in place; violators have their accounts flagged, locking EXP at Level 0 and disabling tournament entry. Macros (like hotkeys) while actually present are permitted, at the user\u2019s own risk."
            },
            {
                type: 'p',
                text: "Dedicated betting bots are allowed if flagged as such \u2014 developers should provide the bot's account name before activation and are encouraged to use the Discord's #development channel."
            },
            {
                type: 'p',
                text: 'Appeals for first-time violations are considered after a month. Whether an appeal is granted depends on the nature of the infraction and the sincerity of the offender.'
            }
        ]
    },
    {
        id: 'commands',
        title: 'Bot Commands',
        blocks: [
            {
                type: 'p',
                text: 'The full list of tournament-related bot commands. Required parameters are listed in {}, optional ones in []. Use the search box to filter, or pick a category.'
            },
            {
                type: 'commands',
                categories: [
                    {
                        name: 'Action',
                        cmds: [
                            {
                                name: '!bet',
                                params: '{wager} {team}',
                                desc: 'Place a wager on the specified team. Accepted only during the betting phase before each match; can be modified until the bet closes.'
                            },
                            {
                                name: '!bet cancel',
                                params: '',
                                desc: 'Cancel your current bet entirely. Reducing or cancelling (including switching teams) keeps a 10% fee.'
                            },
                            {
                                name: '!allin',
                                params: '{team}',
                                desc: 'Wager equal to your current balance.'
                            },
                            {
                                name: '!halfin',
                                params: '{team}',
                                desc: 'Wager equal to half your current balance.'
                            },
                            {
                                name: '!betf',
                                params: '{team}',
                                desc: 'Wager equal to your Gil Floor.'
                            },
                            {
                                name: '!fight',
                                params: '[class] [sex] [skill] -[exclude]',
                                desc: 'Enter for a chance at a generated unit. A random unit is free; each optional parameter costs 100G. Skills/monsters must be obtained first; monsters are incompatible with other parameters. Accepted only during team generation.'
                            },
                            {
                                name: '!dontfight',
                                params: '',
                                desc: 'Skip the fray but still get a chance at the Skill Drop raffle and allegiance EXP. Accepted only during team generation.'
                            },
                            {
                                name: '!buy',
                                params: '',
                                desc: 'Purchase the Skill Drop for 1,000G, anytime after the raffle and before the tournament ends.'
                            },
                            {
                                name: '!buyrandom',
                                params: '',
                                desc: 'Purchase a random unowned skill for 25,000G. Requires Level 100+; discounted 100G per level beyond (minimum 5,000G).'
                            },
                            {
                                name: '!gift',
                                params: '',
                                desc: 'Gift a Skill Drop you own to a random raffle player for 2,000G (recipient is random).'
                            },
                            {
                                name: '!allegiance',
                                params: '[team]',
                                desc: "Get or set your team allegiance. If your entry isn't admitted, you earn EXP each time your allied team wins. Use \"none\" to clear it. Takes effect the following tournament."
                            },
                            {
                                name: '!portrait',
                                params: '[portrait]',
                                desc: 'Get or set your onscreen portrait. Any human class (followed by sex); subs can also use monsters and unique characters.'
                            }
                        ]
                    },
                    {
                        name: 'Stream Info',
                        cmds: [
                            {
                                name: '!unit',
                                params: '{team} {unit}',
                                desc: 'Get the unit of the specified team and unit number.'
                            },
                            {
                                name: '!team',
                                params: '{team}',
                                desc: 'List the units on the specified team.'
                            },
                            {
                                name: '!match',
                                params: '',
                                desc: 'Current match data, including the map and time remaining before a Time Over.'
                            },
                            {
                                name: '!pot',
                                params: '',
                                desc: 'Wagers and Gil placed on each team for the current match, and their odds (payout multiplier).'
                            },
                            {
                                name: '!tournament',
                                params: '',
                                desc: 'List the teams still alive and competing in the tournament.'
                            },
                            {
                                name: '!skill',
                                params: '{skill}',
                                desc: 'Brief summary of what a skill does when applied to a unit entry.'
                            },
                            {
                                name: '!maplist',
                                params: '',
                                desc: 'The map list, in order of appearance, for the current tournament.'
                            },
                            {
                                name: '!streak',
                                params: '',
                                desc: "Current Champion team's streak."
                            },
                            {
                                name: '!drop',
                                params: '',
                                desc: "The tournament's Skill Drop, won via raffle or purchased."
                            },
                            {
                                name: '!drops',
                                params: '',
                                desc: 'The current Skill Drop plus the previous five.'
                            },
                            {
                                name: '!raffle',
                                params: '',
                                desc: "How many users entered the tournament, and how many don't own the current Skill Drop yet."
                            },
                            {
                                name: '!value',
                                params: '',
                                desc: 'Total Gil spent to create each team during character generation.'
                            },
                            {
                                name: '!music',
                                params: '',
                                desc: "The current music track and how much longer it's set to play."
                            },
                            {
                                name: '!raid',
                                params: '',
                                desc: "Each team's chance to spawn a Raid Boss until one is successfully summoned."
                            },
                            {
                                name: '!raids',
                                params: '',
                                desc: 'The Raid Bosses that spawned into the current tournament, if any.'
                            },
                            {
                                name: '!season',
                                params: '',
                                desc: 'The current season number and the date it began.'
                            },
                            {
                                name: '!toc',
                                params: '',
                                desc: 'The date and time of the next Tournament of Champions, if scheduled.'
                            }
                        ]
                    },
                    {
                        name: 'User Info',
                        cmds: [
                            {
                                name: '!balance',
                                params: '[difference]',
                                desc: 'Your current Gil balance. The difference parameter instead gets how much Gil you gained or lost this tournament.'
                            },
                            {
                                name: '!exp',
                                params: '',
                                desc: 'Your Level, EXP toward the next, when you earn your next free skill, and how many skills you can still receive from leveling.'
                            },
                            {
                                name: '!floor',
                                params: '',
                                desc: "Your Gil Floor \u2014 the minimum your balance can fall to."
                            },
                            {
                                name: '!bet',
                                params: '',
                                desc: 'Your bet for the current match and how much you stand to earn if you win.'
                            },
                            {
                                name: '!snub',
                                params: '',
                                desc: "Your snub streak \u2014 consecutive entries submitted without being admitted."
                            },
                            {
                                name: '!priority',
                                params: '',
                                desc: 'Your priority modifiers for the upcoming tournament. After entering, instead gets your entry priority (or unit number if already admitted).'
                            },
                            {
                                name: '!classes',
                                params: '[page]',
                                desc: 'Your eligible classes. Over 25 requires the page parameter.'
                            },
                            {
                                name: '!skills',
                                params: '[page/skill]',
                                desc: 'The skills you own. Over 25 requires the page parameter. A skill name (or category) instead gets whether you own it and its current modifier.'
                            },
                            {
                                name: '!unowned',
                                params: '',
                                desc: "How many skills you don't own yet, listing them once you have 25 or fewer remaining."
                            },
                            {
                                name: '!bonus',
                                params: '',
                                desc: 'Bonus EXP for entering with a class that extends your streak (or without parameters), the eligible classes, and your current Skill Bonus.'
                            },
                            {
                                name: '!cooldown',
                                params: '',
                                desc: 'Skills you currently have a modifier on and the penalties/bonuses, including your nine most recently used skills and your Skill Bonus.'
                            },
                            {
                                name: '!active',
                                params: '[user]',
                                desc: 'When you (or another user) last participated. Users within the previous 30 days are considered active.'
                            },
                            {
                                name: '!rank',
                                params: '[active]',
                                desc: 'Your leaderboard rank. The active parameter ranks among active users only.'
                            },
                            {
                                name: '!exprank',
                                params: '[active]',
                                desc: 'Your expboard rank. The active parameter ranks among active users only.'
                            },
                            {
                                name: '!riserrank',
                                params: '',
                                desc: "Your riserboard rank \u2014 how close you are to Highest Riser or Deepest Faller."
                            },
                            {
                                name: '!unit last',
                                params: '',
                                desc: 'Your last unit rolled in any standard tournament.'
                            },
                            {
                                name: '!prestige',
                                params: '[ascend/newrun]',
                                desc: "How many times you've ascended and the hidden skills obtained. \"ascend\" advances prestige; \"newrun\" resets with no benefit."
                            },
                            {
                                name: '!hidden',
                                params: '',
                                desc: 'The hidden skills you currently remember and their shared penalty.'
                            }
                        ]
                    },
                    {
                        name: 'Game Info',
                        cmds: [
                            {
                                name: '!class',
                                params: '(class) [sex]',
                                desc: "A class's base stats \u2014 HP, MP, Move, Jump, Speed, PA, MA, C-EV, innate abilities, eligible equipment, and affinities. The first weapon type listed is preferred."
                            },
                            {
                                name: '!ability',
                                params: '{ability}',
                                desc: 'Detailed description of an in-game ability. Actions show range, AoE, CT, MP cost, hitrate, effects; non-actions show type and effects.'
                            },
                            {
                                name: '!item',
                                params: '{item}',
                                desc: 'Detailed description of an item or item type (e.g. "Swords"). Items show type, weapon power, range, evasion, element, effects; item types show shared effects and damage formula.'
                            },
                            {
                                name: '!status',
                                params: '{status}',
                                desc: "A status condition\u2019s effects and duration in clock ticks (if applicable)."
                            },
                            {
                                name: '!zodiac',
                                params: '{sign}',
                                desc: 'The compatibility list for a zodiac sign. Best/Worst is best for humans of the opposite sex, worst for the same sex, bad if either unit is a monster. Unlisted signs are neutral.'
                            },
                            {
                                name: '!map',
                                params: '[map]',
                                desc: "A link to the current or desired map's layout. The parameter can be a map ID number or name."
                            },
                            {
                                name: '!define',
                                params: '{keyword}',
                                desc: 'The definition of a keyword used on the stream (stats, elements, terrain types).'
                            }
                        ]
                    },
                    {
                        name: 'Stats',
                        cmds: [
                            {
                                name: '!leaderboard',
                                params: '[active]',
                                desc: 'Top 15 richest players. A top 10 is shown at the start of each round. The active parameter limits to active users.'
                            },
                            {
                                name: '!expboard',
                                params: '[active]',
                                desc: 'Top 10 most experienced players. The active parameter limits to active users.'
                            },
                            {
                                name: '!riserboard',
                                params: '',
                                desc: 'The 15 players with the highest Gil differences this tournament. First at the end is the Highest Riser, earning a random reward.'
                            },
                            {
                                name: '!fallerboard',
                                params: '',
                                desc: 'The 15 players with the lowest Gil differences this tournament. First is the Deepest Faller.'
                            },
                            {
                                name: '!snubs',
                                params: '[active]',
                                desc: 'The 10 players with the longest snub streaks. The active parameter limits to active users.'
                            },
                            {
                                name: '!vip',
                                params: '',
                                desc: 'Each season, whoever becomes Champion with the most distinct classes earns a channel VIP. Links the seasonal leaderboard.'
                            },
                            {
                                name: '!standard',
                                params: '[unit]',
                                desc: 'Streak, team color, and unit list of the reigning Champion team. The unit parameter gets a specific unit.'
                            },
                            {
                                name: '!meme',
                                params: '[unit]',
                                desc: 'Same, for the reigning Meme Champion.'
                            },
                            {
                                name: '!coc',
                                params: '[unit]',
                                desc: 'Same, for the reigning Champion of Champions.'
                            },
                            {
                                name: '!past',
                                params: '(id) [unit]',
                                desc: 'Streak, color, fall date, and units of a previous Champion team. "last" gets the most recently defeated Champion.'
                            },
                            {
                                name: '!search',
                                params: '{string}',
                                desc: 'IDs of previous Champion teams matching the string (name, class, color, date, abilities, etc.). Separate terms with "|". Prefixes: start:, end:, x[count]:, e[count]:, not:, streak:, season:'
                            },
                            {
                                name: '!greatest',
                                params: '[season] [team]',
                                desc: 'The 8 highest-streaking Champion teams of the current/desired season. "all" lists all-time. The team parameter limits to a color.'
                            },
                            {
                                name: '!latest',
                                params: '[team]',
                                desc: 'The 5 most recently fallen Champion teams. The team parameter limits to a color.'
                            },
                            {
                                name: '!stats',
                                params: '[all] {class}',
                                desc: 'Historical stats of a class for the current season, including Champion-team appearances. "all" gets all-time stats.'
                            },
                            {
                                name: '!teamstats',
                                params: '[all] {team}',
                                desc: 'Historical stats of a team for the current season. "all" gets all-time stats.'
                            },
                            {
                                name: '!usercount',
                                params: '[active]',
                                desc: 'Total number of users. The active parameter limits to active users.'
                            },
                            {
                                name: '!allegiances',
                                params: '[active]',
                                desc: 'Number of users aligned with each team. The active parameter limits to active users.'
                            },
                            {
                                name: '!gilcount',
                                params: '[active]',
                                desc: 'Total Gil in the economy. The active parameter limits to active users.'
                            },
                            {
                                name: '!expcount',
                                params: '[active]',
                                desc: 'Total EXP earned among all users. The active parameter limits to active users.'
                            },
                            {
                                name: '!snubscount',
                                params: '[active]',
                                desc: 'Total snubs among all users. The active parameter limits to active users.'
                            },
                            {
                                name: '!gildifference',
                                params: '',
                                desc: 'Total Gil created or destroyed during the current tournament.'
                            }
                        ]
                    },
                    {
                        name: 'Other',
                        cmds: [
                            {
                                name: '!coin',
                                params: '',
                                desc: 'The result of a coin flip the bot performs.'
                            },
                            {
                                name: '!dice',
                                params: '[sides]',
                                desc: 'The result of a dice roll. Default 6-sided; the sides parameter sets a custom amount (max 100).'
                            },
                            {
                                name: '!name',
                                params: '[sex]',
                                desc: 'A random name from the NPC name list. The sex parameter limits to male or female names.'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'links',
        title: 'Helpful Links',
        blocks: [
            {
                type: 'p',
                text: "Thanks to FFTBG's community, several third-party tools and resources exist. The best are listed below."
            },
            {
                type: 'resources',
                items: [
                    {
                        label: 'FFTBattleground on Twitch',
                        url: 'https://www.twitch.tv/fftbattleground',
                        desc: 'the stream itself.'
                    },
                    {
                        label: 'FFTBG.com',
                        url: 'https://fftbg.com',
                        by: 'tikotikotiko',
                        desc: 'complete tournament and unit data archive, with an API for developers.'
                    },
                    {
                        label: 'Mustad.io',
                        url: 'https://www.mustad.io',
                        by: 'SirBraneDamuj',
                        desc: 'breaks teams down by match with easy-to-read zodiac compatibility.'
                    },
                    {
                        label: 'Wiznaib.us',
                        url: 'https://wiznaib.us',
                        by: 'LuxorDoesntFrame',
                        desc: "this site \u2014 unique unit calculations like overall evasion and estimated attack damage."
                    },
                    {
                        label: 'FFTBG Stats',
                        url: 'https://fftbg.bryanching.net/',
                        by: 'bryan792',
                        desc: 'win-rate statistics of just about everything.'
                    },
                    {
                        label: 'FFTB Viewer',
                        url: 'https://twitch-chat-reader-otherbrand.replit.app/music',
                        by: 'OtherBrand',
                        desc: 'live info including the stream music playlist and playback history.'
                    },
                    {
                        label: 'Meatb.one',
                        url: 'https://meatb.one',
                        by: 'q99m',
                        desc: 'class-related leaderboards (originally a "Monster Quest" progress tracker).'
                    },
                    {
                        label: 'BirbBrainsBot',
                        url: 'https://birb-brains-bot.app/#!/home',
                        by: 'MagicBottle',
                        desc: "the bet bot's hub with predicted odds and starting map spawns."
                    },
                    {
                        label: 'FFTBG Skill Seeker',
                        url: 'https://thekillernacho.github.io/fftbg-skill-seeker/',
                        by: 'RughSontos',
                        desc: 'find out when a skill last dropped.'
                    },
                    {
                        label: 'FFTBG Wiki',
                        url: 'https://wiki.birb-brains-bot.app/start',
                        by: 'ProphetPeter and others',
                        desc: 'a ton of useful knowledge in one place.'
                    },
                    {
                        label: 'FFTBG Monster Manual',
                        url: 'https://drive.google.com/file/d/1El5cVeeXHlT9BZwOjAPsZGzyS_4W_JnV/view',
                        by: 'TheKillerNacho',
                        desc: "flavor for each of FFTBG's fifty-five monster species."
                    },
                    {
                        label: 'FFTBG Discord',
                        url: 'https://discord.gg/R76xaNd',
                        by: 'the FFTBG community',
                        desc: 'the community Discord server.'
                    },
                    {
                        label: 'FFTBG YouTube',
                        url: 'https://www.youtube.com/@fftbattleground/playlists',
                        desc: 'historical VoDs.'
                    },
                    {
                        label: 'FFTBG Skill Checklist',
                        url: 'https://docs.google.com/spreadsheets/d/1yC1W2OeJJVjpR4sw9JGoV_1LXYv3O7mJoljGdn3L090/edit#gid=1040375262',
                        by: 'kevv2, revised by DustbirdEX',
                        desc: 'a handy skill checklist.'
                    },
                    {
                        label: 'FFTBG Portrait List',
                        url: 'https://pastebin.com/EdG0dQj4',
                        by: 'Chuckolator',
                        desc: 'the list of available onscreen portraits.'
                    }
                ]
            }
        ]
    },
    {
        id: 'contact',
        title: 'Contact',
        blocks: [
            {
                type: 'p',
                text: "Commentated videos and re-streams of this channel's content are permitted without needing to ask for explicit permission. The only request is that a link be provided to viewers who may be interested in participating themselves."
            },
            {
                type: 'p',
                text: "To contact FFTBG's owner for any other reason, message TheKillerNacho on Discord."
            },
            {
                type: 'link',
                url: 'mailto:timothyjsharpe@yahoo.com',
                label: 'Email TheKillerNacho'
            }
        ]
    }
];

});


parcelRegister("eYTsC", function(module, exports) {

$parcel$export(module.exports, "render", () => $ae81b09eb3c72f4d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $ae81b09eb3c72f4d$var$_hoisted_1 = {
    class: "help-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "FFTBG help"
};
const $ae81b09eb3c72f4d$var$_hoisted_2 = [
    "value"
];
const $ae81b09eb3c72f4d$var$_hoisted_3 = {
    class: "help-body"
};
const $ae81b09eb3c72f4d$var$_hoisted_4 = {
    class: "help-nav"
};
const $ae81b09eb3c72f4d$var$_hoisted_5 = [
    "onClick"
];
const $ae81b09eb3c72f4d$var$_hoisted_6 = {
    class: "help-content",
    ref: "content"
};
const $ae81b09eb3c72f4d$var$_hoisted_7 = {
    key: 0,
    class: "b-p"
};
const $ae81b09eb3c72f4d$var$_hoisted_8 = {
    key: 1,
    class: "b-h"
};
const $ae81b09eb3c72f4d$var$_hoisted_9 = {
    key: 2,
    class: "b-callout"
};
const $ae81b09eb3c72f4d$var$_hoisted_10 = {
    key: 3,
    class: "b-list"
};
const $ae81b09eb3c72f4d$var$_hoisted_11 = {
    key: 4,
    class: "b-cmd"
};
const $ae81b09eb3c72f4d$var$_hoisted_12 = {
    key: 0,
    class: "b-cmd-desc"
};
const $ae81b09eb3c72f4d$var$_hoisted_13 = [
    "href"
];
const $ae81b09eb3c72f4d$var$_hoisted_14 = {
    key: 6,
    class: "b-resources"
};
const $ae81b09eb3c72f4d$var$_hoisted_15 = [
    "href"
];
const $ae81b09eb3c72f4d$var$_hoisted_16 = {
    key: 1
};
const $ae81b09eb3c72f4d$var$_hoisted_17 = {
    key: 2,
    class: "res-by"
};
const $ae81b09eb3c72f4d$var$_hoisted_18 = {
    key: 7,
    class: "b-commands"
};
const $ae81b09eb3c72f4d$var$_hoisted_19 = {
    class: "cmd-chips"
};
const $ae81b09eb3c72f4d$var$_hoisted_20 = [
    "onClick"
];
const $ae81b09eb3c72f4d$var$_hoisted_21 = {
    key: 0,
    class: "cmd-empty"
};
const $ae81b09eb3c72f4d$var$_hoisted_22 = {
    key: 1,
    class: "cmd-table"
};
const $ae81b09eb3c72f4d$var$_hoisted_23 = {
    class: "cmd-name"
};
const $ae81b09eb3c72f4d$var$_hoisted_24 = {
    class: "cmd-params"
};
const $ae81b09eb3c72f4d$var$_hoisted_25 = {
    class: "cmd-desc"
};
const $ae81b09eb3c72f4d$var$_hoisted_26 = {
    class: "help-footer"
};
const $ae81b09eb3c72f4d$var$_hoisted_27 = [
    "href"
];
function $ae81b09eb3c72f4d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay top help-backdrop",
        onClick: _cache[4] || (_cache[4] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $ae81b09eb3c72f4d$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "close-btn",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\xd7"),
            _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("h1", null, "FFTBG Guide", -1)),
            _cache[8] || (_cache[8] = (0, $TusQn.createElementVNode)("a", {
                class: "help-faq-banner",
                href: "?faq"
            }, [
                (0, $TusQn.createTextVNode)("\u2753 Got a question? The community "),
                (0, $TusQn.createElementVNode)("strong", null, "FAQ"),
                (0, $TusQn.createTextVNode)(" answers what chat asks most \u2014 auto-mined from six years of stream chat \u2192")
            ], -1)),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                class: "section-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.activeId = $event)
            }, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.sections, (s)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                        key: s.id,
                        value: s.id
                    }, (0, $8POXm.toDisplayString)(s.title), 9, $ae81b09eb3c72f4d$var$_hoisted_2);
                }), 128))
            ], 512), [
                [
                    (0, $eeJ70.vModelSelect),
                    $data.activeId
                ]
            ]),
            (0, $TusQn.createElementVNode)("div", $ae81b09eb3c72f4d$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("nav", $ae81b09eb3c72f4d$var$_hoisted_4, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.sections, (s)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: s.id,
                            class: (0, $8POXm.normalizeClass)([
                                'nav-item',
                                {
                                    active: s.id === $data.activeId
                                }
                            ]),
                            onClick: ($event)=>$data.activeId = s.id
                        }, (0, $8POXm.toDisplayString)(s.title), 11, $ae81b09eb3c72f4d$var$_hoisted_5);
                    }), 128))
                ]),
                (0, $TusQn.createElementVNode)("div", $ae81b09eb3c72f4d$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)($options.activeSection.title), 1),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.activeSection.blocks, (block, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: i
                        }, [
                            block.type === 'p' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $ae81b09eb3c72f4d$var$_hoisted_7, (0, $8POXm.toDisplayString)(block.text), 1)) : block.type === 'h' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h3", $ae81b09eb3c72f4d$var$_hoisted_8, (0, $8POXm.toDisplayString)(block.text), 1)) : block.type === 'callout' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ae81b09eb3c72f4d$var$_hoisted_9, (0, $8POXm.toDisplayString)(block.text), 1)) : block.type === 'list' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $ae81b09eb3c72f4d$var$_hoisted_10, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(block.items, (item, j)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        key: j
                                    }, (0, $8POXm.toDisplayString)(item), 1);
                                }), 128))
                            ])) : block.type === 'cmd' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ae81b09eb3c72f4d$var$_hoisted_11, [
                                (0, $TusQn.createElementVNode)("code", null, (0, $8POXm.toDisplayString)(block.name), 1),
                                block.desc ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $ae81b09eb3c72f4d$var$_hoisted_12, (0, $8POXm.toDisplayString)(block.desc), 1)) : (0, $TusQn.createCommentVNode)("", true)
                            ])) : block.type === 'link' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                key: 5,
                                class: "b-link",
                                href: block.url,
                                target: "_blank",
                                rel: "noopener"
                            }, (0, $8POXm.toDisplayString)(block.label), 9, $ae81b09eb3c72f4d$var$_hoisted_13)) : block.type === 'resources' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $ae81b09eb3c72f4d$var$_hoisted_14, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(block.items, (r, j)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        key: j
                                    }, [
                                        r.url ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                            key: 0,
                                            class: "b-link",
                                            href: r.url,
                                            target: "_blank",
                                            rel: "noopener"
                                        }, (0, $8POXm.toDisplayString)(r.label), 9, $ae81b09eb3c72f4d$var$_hoisted_15)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("strong", $ae81b09eb3c72f4d$var$_hoisted_16, (0, $8POXm.toDisplayString)(r.label), 1)),
                                        r.by ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $ae81b09eb3c72f4d$var$_hoisted_17, " \u2014 " + (0, $8POXm.toDisplayString)(r.by), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                        r.desc ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: 3
                                        }, [
                                            (0, $TusQn.createTextVNode)(": " + (0, $8POXm.toDisplayString)(r.desc), 1)
                                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                    ]);
                                }), 128))
                            ])) : block.type === 'commands' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ae81b09eb3c72f4d$var$_hoisted_18, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    type: "text",
                                    class: "cmd-search",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.cmdQuery = $event),
                                    placeholder: "Search commands\u2026"
                                }, null, 512), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $data.cmdQuery
                                    ]
                                ]),
                                (0, $TusQn.createElementVNode)("div", $ae81b09eb3c72f4d$var$_hoisted_19, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            'chip',
                                            {
                                                active: $data.cmdCategory === 'all'
                                            }
                                        ]),
                                        onClick: _cache[3] || (_cache[3] = ($event)=>$data.cmdCategory = 'all')
                                    }, "All", 2),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(block.categories, (cat)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                            key: cat.name,
                                            class: (0, $8POXm.normalizeClass)([
                                                'chip',
                                                {
                                                    active: $data.cmdCategory === cat.name
                                                }
                                            ]),
                                            onClick: ($event)=>$data.cmdCategory = cat.name
                                        }, (0, $8POXm.toDisplayString)(cat.name), 11, $ae81b09eb3c72f4d$var$_hoisted_20);
                                    }), 128))
                                ]),
                                !$options.filteredCommands(block).length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $ae81b09eb3c72f4d$var$_hoisted_21, "No commands match.")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $ae81b09eb3c72f4d$var$_hoisted_22, [
                                    (0, $TusQn.createElementVNode)("tbody", null, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredCommands(block), (c, k)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: k
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", $ae81b09eb3c72f4d$var$_hoisted_23, [
                                                    (0, $TusQn.createElementVNode)("code", null, (0, $8POXm.toDisplayString)(c.name), 1),
                                                    _cache[5] || (_cache[5] = (0, $TusQn.createTextVNode)()),
                                                    (0, $TusQn.createElementVNode)("span", $ae81b09eb3c72f4d$var$_hoisted_24, (0, $8POXm.toDisplayString)(c.params), 1)
                                                ]),
                                                (0, $TusQn.createElementVNode)("td", $ae81b09eb3c72f4d$var$_hoisted_25, (0, $8POXm.toDisplayString)(c.desc), 1)
                                            ]);
                                        }), 128))
                                    ])
                                ]))
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ], 64);
                    }), 128))
                ], 512)
            ]),
            (0, $TusQn.createElementVNode)("p", $ae81b09eb3c72f4d$var$_hoisted_26, [
                _cache[6] || (_cache[6] = (0, $TusQn.createTextVNode)(" Source: ", -1)),
                (0, $TusQn.createElementVNode)("a", {
                    href: $data.sourceUrl,
                    target: "_blank",
                    rel: "noopener"
                }, "FFTBG Twitch description", 8, $ae81b09eb3c72f4d$var$_hoisted_27),
                (0, $TusQn.createTextVNode)(", captured " + (0, $8POXm.toDisplayString)($data.capturedDate) + ". ", 1)
            ])
        ])
    ]);
}

});

parcelRegister("R6gXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f9d0eebffce5e1$export$2e2bcd8739ae039);
let $09f9d0eebffce5e1$var$NOOP = ()=>{};
var $09f9d0eebffce5e1$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6MNyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0dab2c9076cb81$export$2e2bcd8739ae039);
let $4f0dab2c9076cb81$var$script;




let $4f0dab2c9076cb81$var$initialize = ()=>{
    $4f0dab2c9076cb81$var$script = (parcelRequire("501Y1"));
    if ($4f0dab2c9076cb81$var$script.__esModule) $4f0dab2c9076cb81$var$script = $4f0dab2c9076cb81$var$script.default;
    $4f0dab2c9076cb81$var$script.render = (parcelRequire("eJZGU")).render;
    $4f0dab2c9076cb81$var$script.__cssModules = {};
    (parcelRequire("aWgDy")).default($4f0dab2c9076cb81$var$script);
    $4f0dab2c9076cb81$var$script.__scopeId = 'data-v-d45744';
    $4f0dab2c9076cb81$var$script.__file = "AnnouncementModal.vue";
};
$4f0dab2c9076cb81$var$initialize();
var $4f0dab2c9076cb81$export$2e2bcd8739ae039 = $4f0dab2c9076cb81$var$script;

});
parcelRegister("501Y1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a3e7a76496cac17$export$2e2bcd8739ae039);

var $ht4ts = parcelRequire("ht4ts");

var $8Iy0x = parcelRequire("8Iy0x");
const $3a3e7a76496cac17$var$CONFETTI_COLORS = [
    '#ff3b3b',
    '#ffd700',
    '#00e676',
    '#1e90ff',
    '#ff69b4',
    '#ffffff',
    '#ff8c00'
];
var $3a3e7a76496cac17$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $8Iy0x.default)
    ],
    closeEvent: 'dismiss',
    props: {
        // [{ name, color, status: 'in'|'snubbed', units? }] — pre-built by parent.
        // 'in' entries carry a `units` array (a player can field a new team AND be the
        // defending champion → both are shown). Legacy single `unit`/`teamLabel`/`grade`
        // is still accepted via unitsFor().
        matches: {
            type: Array,
            required: true
        },
        // { token, name, category, rarity } for the tournament's !buyrandom drop, or null.
        skillDrop: {
            type: Object,
            default: null
        },
        // Show the "these are the default highlights — see ⚙ Settings" footer
        // (parents pass true only for fresh visitors with untouched prefs).
        settingsHint: {
            type: Boolean,
            default: false
        },
        // Whether "⚙ Settings" is clickable (emits open-settings). True on the
        // bracket page, false on sub-pages where the gear modal doesn't exist.
        settingsLink: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'dismiss',
        'scroll-to-player',
        'open-settings'
    ],
    data () {
        // Pre-compute particle positions in JS so each piece gets a unique
        // CSS-variable-driven trajectory. ~60 feels celebratory without lagging.
        const confetti = Array.from({
            length: 60
        }, (_, i)=>{
            // Angle weighted upward so the burst goes up-and-out, then gravity pulls down.
            const angle = Math.PI + Math.random() * Math.PI;
            const distance = 120 + Math.random() * 260;
            return {
                id: i,
                color: $3a3e7a76496cac17$var$CONFETTI_COLORS[i % $3a3e7a76496cac17$var$CONFETTI_COLORS.length],
                size: 6 + Math.random() * 8,
                dx: Math.cos(angle) * distance,
                dy: Math.sin(angle) * distance + 320,
                rot: Math.random() * 1440 - 720,
                delay: Math.random() * 250
            };
        });
        return {
            confetti: confetti
        };
    },
    computed: {
        hasIn () {
            return this.matches.some((m)=>m.status === 'in');
        }
    },
    methods: {
        // The unit(s) to show for a match — a `units` array if present, else the legacy
        // single unit. A player who entered AND is the defending champion has two.
        unitsFor (m) {
            if (Array.isArray(m.units)) return m.units.filter((x)=>x && x.unit);
            return m.unit ? [
                {
                    unit: m.unit,
                    teamLabel: m.teamLabel,
                    grade: m.grade
                }
            ] : [];
        },
        // Team-coloured portrait (same scheme as the bracket); monsters/champion plain.
        portrait (u, label) {
            if (u.Gender === 'Monster') return (0, $ht4ts.UNITS_BASE) + u.Class + '.gif';
            const g = (u.Gender || 'Male')[0];
            if (label === 'Champion') return (0, $ht4ts.UNITS_BASE) + u.Class + g + '.gif';
            return (0, $ht4ts.UNITS_BASE) + u.Class + g + '_' + label + '.gif';
        },
        unitSkills (u) {
            return [
                u.ActionSkill,
                u.ReactionSkill,
                u.SupportSkill,
                u.MoveSkill
            ].filter(Boolean).join(" \xb7 ");
        },
        unitGear (u) {
            return [
                u.Mainhand,
                u.Offhand,
                u.Head,
                u.Armor,
                u.Accessory
            ].filter(Boolean).join(', ');
        }
    }
};

});

parcelRegister("eJZGU", function(module, exports) {

$parcel$export(module.exports, "render", () => $abb51f37e0cbf47f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $abb51f37e0cbf47f$var$_hoisted_1 = {
    key: 0,
    class: "confetti-layer",
    "aria-hidden": "true"
};
const $abb51f37e0cbf47f$var$_hoisted_2 = {
    class: "announcement-panel",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Tournament announcement"
};
const $abb51f37e0cbf47f$var$_hoisted_3 = {
    class: "ad-name"
};
const $abb51f37e0cbf47f$var$_hoisted_4 = {
    class: "ad-rarity"
};
const $abb51f37e0cbf47f$var$_hoisted_5 = [
    "onClick"
];
const $abb51f37e0cbf47f$var$_hoisted_6 = {
    key: 0,
    class: "announcement-units"
};
const $abb51f37e0cbf47f$var$_hoisted_7 = [
    "src",
    "alt"
];
const $abb51f37e0cbf47f$var$_hoisted_8 = {
    class: "au-info"
};
const $abb51f37e0cbf47f$var$_hoisted_9 = {
    class: "au-class"
};
const $abb51f37e0cbf47f$var$_hoisted_10 = {
    key: 0,
    class: "au-team"
};
const $abb51f37e0cbf47f$var$_hoisted_11 = {
    key: 0,
    class: "au-grade"
};
const $abb51f37e0cbf47f$var$_hoisted_12 = {
    class: "au-grade-score"
};
const $abb51f37e0cbf47f$var$_hoisted_13 = {
    key: 1,
    class: "au-line"
};
const $abb51f37e0cbf47f$var$_hoisted_14 = {
    key: 2,
    class: "au-line au-gear"
};
const $abb51f37e0cbf47f$var$_hoisted_15 = {
    key: 1,
    class: "settings-hint"
};
function $abb51f37e0cbf47f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay z900 announcement-backdrop",
        onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('dismiss'))
    }, [
        $options.hasIn ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $abb51f37e0cbf47f$var$_hoisted_1, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.confetti, (p)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                    key: p.id,
                    class: "confetti-piece",
                    style: (0, $8POXm.normalizeStyle)({
                        background: p.color,
                        width: p.size + 'px',
                        height: p.size * 0.4 + 'px',
                        animationDelay: p.delay + 'ms',
                        '--dx': p.dx + 'px',
                        '--dy': p.dy + 'px',
                        '--rot': p.rot + 'deg'
                    })
                }, null, 4);
            }), 128))
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $abb51f37e0cbf47f$var$_hoisted_2, [
            $props.skillDrop ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 0,
                class: (0, $8POXm.normalizeClass)([
                    "announcement-drop",
                    'rarity-' + $props.skillDrop.rarity
                ])
            }, [
                _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("span", {
                    class: "ad-label"
                }, "\uD83C\uDF81 Skill Drop", -1)),
                (0, $TusQn.createElementVNode)("span", $abb51f37e0cbf47f$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.skillDrop.name), 1),
                (0, $TusQn.createElementVNode)("span", $abb51f37e0cbf47f$var$_hoisted_4, (0, $8POXm.toDisplayString)($props.skillDrop.rarity), 1)
            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.matches, (m, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: i,
                    class: "announcement-item"
                }, [
                    (0, $TusQn.createElementVNode)("p", {
                        class: "announcement-line",
                        style: (0, $8POXm.normalizeStyle)(m.color ? {
                            color: m.color
                        } : null)
                    }, [
                        m.status === 'in' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                            key: 0,
                            href: "#",
                            class: "player-link",
                            style: (0, $8POXm.normalizeStyle)(m.color ? {
                                color: m.color
                            } : null),
                            onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('scroll-to-player', m.name), [
                                "stop",
                                "prevent"
                            ])
                        }, (0, $8POXm.toDisplayString)(m.name), 13, $abb51f37e0cbf47f$var$_hoisted_5)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(m.name), 1)
                        ], 64)),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(m.status === 'in' ? 'is in!' : 'was Snubbed.'), 1)
                    ], 4),
                    m.status === 'in' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $abb51f37e0cbf47f$var$_hoisted_6, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.unitsFor(m), (uu, j)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: j,
                                class: "announcement-unit"
                            }, [
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "au-portrait",
                                    src: $options.portrait(uu.unit, uu.teamLabel),
                                    alt: uu.unit.Class,
                                    onError: _cache[0] || (_cache[0] = ($event)=>$event.target.style.visibility = 'hidden')
                                }, null, 40, $abb51f37e0cbf47f$var$_hoisted_7),
                                (0, $TusQn.createElementVNode)("div", $abb51f37e0cbf47f$var$_hoisted_8, [
                                    (0, $TusQn.createElementVNode)("div", $abb51f37e0cbf47f$var$_hoisted_9, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(uu.unit.Class), 1),
                                        uu.teamLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $abb51f37e0cbf47f$var$_hoisted_10, " \xb7 " + (0, $8POXm.toDisplayString)(uu.teamLabel === 'Champion' ? 'Champion (defending)' : uu.teamLabel + ' team'), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                    ]),
                                    uu.grade ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $abb51f37e0cbf47f$var$_hoisted_11, [
                                        (0, $TusQn.createElementVNode)("span", {
                                            class: (0, $8POXm.normalizeClass)([
                                                "grade-badge",
                                                'tier-' + uu.grade.color
                                            ]),
                                            title: "Color = class tier \xb7 letter = this unit within its class"
                                        }, (0, $8POXm.toDisplayString)(uu.grade.grade), 3),
                                        (0, $TusQn.createElementVNode)("span", $abb51f37e0cbf47f$var$_hoisted_12, "~" + (0, $8POXm.toDisplayString)(uu.grade.score) + "% expected win rate", 1)
                                    ])) : (0, $TusQn.createCommentVNode)("", true),
                                    $options.unitSkills(uu.unit) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $abb51f37e0cbf47f$var$_hoisted_13, (0, $8POXm.toDisplayString)($options.unitSkills(uu.unit)), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                    $options.unitGear(uu.unit) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $abb51f37e0cbf47f$var$_hoisted_14, (0, $8POXm.toDisplayString)($options.unitGear(uu.unit)), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ]);
                        }), 128))
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ]);
            }), 128)),
            $props.settingsHint ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $abb51f37e0cbf47f$var$_hoisted_15, [
                _cache[4] || (_cache[4] = (0, $TusQn.createTextVNode)(" \uD83D\uDCA1 Luxor & friends are highlighted by default \u2014 that's why you're seeing this. ", -1)),
                $props.settingsLink ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                    key: 0,
                    href: "#",
                    class: "settings-link",
                    onClick: _cache[1] || (_cache[1] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('open-settings'), [
                        "stop",
                        "prevent"
                    ]))
                }, "\u2699 Settings")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    (0, $TusQn.createTextVNode)("The \u2699 Settings on the bracket page")
                ], 64)),
                _cache[5] || (_cache[5] = (0, $TusQn.createTextVNode)(" lets you highlight your own players instead \u2014 or turn these popups off. ", -1))
            ])) : (0, $TusQn.createCommentVNode)("", true),
            _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("p", {
                class: "dismiss-hint"
            }, "click anywhere to dismiss", -1))
        ])
    ]);
}

});

parcelRegister("aWgDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f6c39e6c974fc14$export$2e2bcd8739ae039);
let $7f6c39e6c974fc14$var$NOOP = ()=>{};
var $7f6c39e6c974fc14$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5qmlL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f30b7b504fed939$export$2e2bcd8739ae039);
let $3f30b7b504fed939$var$script;




let $3f30b7b504fed939$var$initialize = ()=>{
    $3f30b7b504fed939$var$script = (parcelRequire("97MBw"));
    if ($3f30b7b504fed939$var$script.__esModule) $3f30b7b504fed939$var$script = $3f30b7b504fed939$var$script.default;
    $3f30b7b504fed939$var$script.render = (parcelRequire("knZDq")).render;
    $3f30b7b504fed939$var$script.__cssModules = {};
    (parcelRequire("cB3jn")).default($3f30b7b504fed939$var$script);
    $3f30b7b504fed939$var$script.__scopeId = 'data-v-0e0b7b';
    $3f30b7b504fed939$var$script.__file = "MyModifiersModal.vue";
};
$3f30b7b504fed939$var$initialize();
var $3f30b7b504fed939$export$2e2bcd8739ae039 = $3f30b7b504fed939$var$script;

});
parcelRegister("97MBw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6a4a784425705adb$export$2e2bcd8739ae039);

var $8Iy0x = parcelRequire("8Iy0x");

var $k0cFV = parcelRequire("k0cFV");

var $ht4ts = parcelRequire("ht4ts");

var $78F4Z = parcelRequire("78F4Z");

var $aizvL = parcelRequire("aizvL");

var $j4wl1 = parcelRequire("j4wl1");

var $gNwy4 = parcelRequire("gNwy4");

var $3lf9e = parcelRequire("3lf9e");

var $gKfUi = parcelRequire("gKfUi");

var $4ErgZ = parcelRequire("4ErgZ");

var $1dDjn = parcelRequire("1dDjn");

var $53jI0 = parcelRequire("53jI0");

var $764dZ = parcelRequire("764dZ");

var $adzaT = parcelRequire("adzaT");

var $koMQO = parcelRequire("koMQO");

var $iziJA = parcelRequire("iziJA");
var $7qBNy = parcelRequire("7qBNy");
const $6a4a784425705adb$var$nameOf = (tok)=>(0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok] && (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok].name || tok.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
const $6a4a784425705adb$var$isMonster = (tok)=>(0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok] && (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok].category === 'monster';
const $6a4a784425705adb$var$rarityOf = (tok)=>(0, $aizvL.isHiddenSkill)(tok) ? 'rare' : (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok] && (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok].rarity || 'common';
const $6a4a784425705adb$var$classDisplay = (tok)=>String(tok).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
// token → combat win rate (human classes only), for ranking entry classes by power.
// Built on first use: classIndex arrives from S3 after this module loads (lib/preload.js).
let $6a4a784425705adb$var$CLASS_WR = null;
const $6a4a784425705adb$var$classWR = (tok)=>{
    if (!$6a4a784425705adb$var$CLASS_WR) {
        $6a4a784425705adb$var$CLASS_WR = {};
        for (const r of (0, $koMQO.classIndex))if (!r.monster) $6a4a784425705adb$var$CLASS_WR[(0, $gNwy4.cmdToken)(r.cls)] = r.winRate;
    }
    return $6a4a784425705adb$var$CLASS_WR[(0, $gNwy4.cmdToken)(tok)];
};
const $6a4a784425705adb$var$FORCEABLE = [
    'skillset',
    'support',
    'reaction',
    'movement',
    'accessory'
];
const $6a4a784425705adb$var$RARITY_RANK = {
    rare: 2,
    uncommon: 1,
    common: 0
};
// genTokens category → the crossByClass dim that holds its per-class win rates.
const $6a4a784425705adb$var$CAT_DIM = {
    skillset: 'ActionSkill',
    support: 'SupportSkill',
    reaction: 'ReactionSkill',
    movement: 'MoveSkill',
    accessory: 'Accessory'
};
// The inverse: a worstBan crossByClass dim → its genTokens category (for slot dedup).
const $6a4a784425705adb$var$DIM_CAT = {
    ActionSkill: 'skillset',
    SupportSkill: 'support',
    ReactionSkill: 'reaction',
    MoveSkill: 'movement',
    Accessory: 'accessory'
};
// Skill display-name → genTokens category, so a ban (which carries only a name)
// can be matched against the forced slot. Names are unique across categories.
const $6a4a784425705adb$var$NAME_CAT = {};
for(const k in (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken)$6a4a784425705adb$var$NAME_CAT[(0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[k].name] = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[k].category;
const $6a4a784425705adb$var$tokenCategory = (tok)=>(0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok] && (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[tok].category || '';
const $6a4a784425705adb$var$GGH_PREF = 'wiznaibus.mods.excludeGgh';
// "Save my hidden skills": no suggestion forces a hidden (prestige) skill. For the hoarders.
const $6a4a784425705adb$var$HIDDEN_PREF = 'wiznaibus.mods.saveHidden';
// "A, B or C", for the names in a sentence.
const $6a4a784425705adb$var$orList = (xs)=>xs.length < 2 ? xs.join('') : xs.slice(0, -1).join(', ') + ' or ' + xs[xs.length - 1];
// A class's base win rate, for one gender when given, so a gendered skill rate is
// compared like for like (female Monks win 48.0% overall against 51.8% for both).
const $6a4a784425705adb$var$classBaseWR = (cls, gender)=>{
    const g = gender && ((0, $koMQO.rosterStats).windows.all.ClassGender || []).find((x)=>x.value === cls + ' ' + gender);
    return g ? g.winRate : ((0, $koMQO.rosterStats).windows.all.Class.find((x)=>x.value === cls) || {}).winRate || 50;
};
// A skill's empirical win rate FOR a class, or null on thin/absent data. This is
// the "same checker" — so e.g. Short Charge reads +6.8% on Wizard but ~0% on melee,
// instead of being force-picked by rarity. Pass a gender ('Male'/'Female') to score
// for that gender only; omit it to combine both (the Go-big default).
function $6a4a784425705adb$var$skillClassWR(token, cls, gender) {
    const meta = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[token];
    const dim = meta && $6a4a784425705adb$var$CAT_DIM[meta.category];
    const rows = dim && ((0, $koMQO.rosterStats).crossByClass[dim] || {})[meta.name];
    if (!rows) return null;
    const rel = gender ? rows.filter((r)=>r.value === cls + ' ' + gender) : rows.filter((r)=>r.value === cls + ' Male' || r.value === cls + ' Female');
    const tot = rel.reduce((s, r)=>s + r.played, 0);
    const floor = gender ? 150 : 300; // a single-gender slice is half the sample
    return tot >= floor ? rel.reduce((s, r)=>s + r.winRate * r.played, 0) / tot : null;
}
// Gender-locked classes — the off-gender pill is disabled (matches the generator).
const $6a4a784425705adb$var$GENDER_LOCK = {
    Bard: 'Male',
    Dancer: 'Female'
};
// owned monster → !fight tier (rare species = elite, uncommon = strong, else normal)
const $6a4a784425705adb$var$tierOf = (tok)=>{
    const r = $6a4a784425705adb$var$rarityOf(tok);
    return r === 'rare' ? 'elite' : r === 'uncommon' ? 'strong' : 'normal';
};
// The same, '' for anything that isn't a monster (RandomMonster is a meta token, not a species).
const $6a4a784425705adb$var$monsterTier = (tok)=>$6a4a784425705adb$var$isMonster(tok) ? $6a4a784425705adb$var$tierOf(tok) : '';
const $6a4a784425705adb$var$TIER_PRIO = {
    elite: "\u221215 priority",
    strong: "\u221210 priority",
    normal: 'no priority cost'
};
// 🐉 "Respect Monster Quest": only suggest monsters you still need for the next set.
const $6a4a784425705adb$var$MQ_PREF = 'wiznaibus.mods.monsterQuest';
// ── ⭐ My entry (Taobakaa's suggestion): a remembered class + rules → one command ──
const $6a4a784425705adb$var$CLASS_PREF = 'wiznaibus.mods.class'; // the remembered "Suggest for" class
// The remembered gender (null = the class's stronger one, '' = any), set by the picker's ♂/♀
// or My entry's pills. It's kept in the My entry rules too; this copy works without them.
const $6a4a784425705adb$var$GENDER_PREF = 'wiznaibus.mods.gender';
const $6a4a784425705adb$var$AUTO_VAL = '__auto__'; // the picker's ⚙ Auto tile ('' can't be a tile value)
const $6a4a784425705adb$var$portraitOf = (cls, gender)=>(0, $ht4ts.UNITS_BASE) + (0, $78F4Z.classPortrait)(cls, gender);
const $6a4a784425705adb$var$ENTRY_PREF = 'wiznaibus.mods.entry'; // the My entry rules; present = set up
// gender: null = the class's stronger gender (if there is one), '' = any, or a gender.
const $6a4a784425705adb$var$ENTRY_DEFAULTS = {
    forceBest: true,
    pool: 'usable',
    banWorst: false,
    respectQuest: false,
    vip: false,
    gender: null
};
// 🎖️ VIP Quest helper. Strong and elite monsters share a cooldown, so the ones you still
// need go first (the VIP_MONSTERS tiers, from the token rarity a !fight monster is priced by).
const $6a4a784425705adb$var$VIP_MONSTER_SET = new Set((0, $1dDjn.VIP_MONSTERS));
const $6a4a784425705adb$var$MONSTER_TIER = {};
for(const k in (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken){
    const t = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[k];
    if (t.category === 'monster' && (t.rarity === 'rare' || t.rarity === 'uncommon')) $6a4a784425705adb$var$MONSTER_TIER[t.name] = t.rarity === 'rare' ? 'elite' : 'strong';
}
const $6a4a784425705adb$var$VIP_SHOWN = 5; // candidates listed under the pick
const $6a4a784425705adb$var$POOL_LABEL = {
    usable: 'Any usable',
    offcd: 'Off cooldown',
    nopenalty: 'No penalty'
};
// Quests an entry can move: their targets are classes (gendered or not) and monsters.
const $6a4a784425705adb$var$QUEST_ENTERABLE = new Set([
    'monster',
    'human',
    'everything',
    'gendered',
    'bagel'
]);
const $6a4a784425705adb$var$QUEST_WHY_NOT = {
    zodiac: "a sign can't be forced",
    carried: "it counts teammates' monsters, not yours"
};
const $6a4a784425705adb$var$HUMAN_BY_NAME = Object.fromEntries((0, $j4wl1.STANDARD_CLASSES).map((t)=>[
        $6a4a784425705adb$var$classDisplay(t).toLowerCase(),
        t
    ]));
const $6a4a784425705adb$var$MONSTER_BY_NAME = {};
for(const k in (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken)if ((0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[k].category === 'monster') $6a4a784425705adb$var$MONSTER_BY_NAME[(0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[k].name.toLowerCase()] = k;
// A monster's combat win rate by name, to rank quest monsters (built on first use,
// like CLASS_WR: classIndex arrives from S3 after this module loads).
let $6a4a784425705adb$var$MON_WR = null;
const $6a4a784425705adb$var$monsterWR = (name)=>{
    if (!$6a4a784425705adb$var$MON_WR) {
        $6a4a784425705adb$var$MON_WR = {};
        for (const r of (0, $koMQO.classIndex))if (r.monster) $6a4a784425705adb$var$MON_WR[r.cls.toLowerCase()] = r.winRate;
    }
    return $6a4a784425705adb$var$MON_WR[String(name).toLowerCase()];
};
const $6a4a784425705adb$var$readJson = (k)=>{
    try {
        return JSON.parse(localStorage.getItem(k));
    } catch  {
        return null;
    }
};
const $6a4a784425705adb$var$writeJson = (k, v)=>{
    try {
        localStorage.setItem(k, JSON.stringify(v));
    } catch  {}
};

var $6a4a784425705adb$export$2e2bcd8739ae039 = {
    name: 'MyModifiersModal',
    components: {
        ClassPickerModal: $k0cFV.default
    },
    mixins: [
        (0, $8Iy0x.default)
    ],
    props: {
        handle: {
            type: String,
            required: true
        },
        // The champion an entry made now would face, from the bracket page:
        // { units, label, decided, isNew } (see Luxstadio's nextChampion).
        champion: {
            type: Object,
            default: null
        }
    },
    emits: [
        'close'
    ],
    data () {
        return {
            skills: null,
            skillBonus: '',
            mark: 0,
            classbonus: null,
            gil: 0,
            copied: '',
            loaded: false,
            chosenClass: '',
            entriesExpanded: false,
            excludeGgh: true,
            saveHidden: false,
            // ⭐ My entry: the rules (remembered), whether it's been set up, the "adjust picks"
            // panel, and this session's manual picks (null = follow the rule).
            rules: {
                ...$6a4a784425705adb$var$ENTRY_DEFAULTS
            },
            entrySetUp: false,
            fineTune: false,
            customGender: '',
            forceOverride: null,
            banOverride: null,
            goal: null,
            goalInfo: null,
            // 🎖️ VIP Quest: the champion history (frozen, loaded when the switch is on), this
            // session's pick of another candidate, and the on-demand sim's results by class.
            vipHist: null,
            vipMeta: null,
            vipError: '',
            vipOverride: null,
            vipSim: {},
            vipSimBusy: false,
            monsterQuest: false,
            classPickerOpen: false,
            AUTO_VAL: $6a4a784425705adb$var$AUTO_VAL,
            // The 🐉 tile's portrait, just for fun: one of your monsters at random, once they load.
            monsterFace: (0, $1dDjn.VIP_MONSTERS)[Math.floor(Math.random() * (0, $1dDjn.VIP_MONSTERS).length)],
            seasonCount: (0, $4ErgZ.SEASON_COUNT),
            vipTotal: (0, $1dDjn.VIP_CLASSES).length
        };
    },
    async created () {
        // Restore the GilgameHeart-exclude preference (default on — the historical behavior).
        try {
            const v = localStorage.getItem($6a4a784425705adb$var$GGH_PREF);
            if (v != null) this.excludeGgh = v === '1';
        } catch  {}
        try {
            this.saveHidden = localStorage.getItem($6a4a784425705adb$var$HIDDEN_PREF) === '1';
        } catch  {}
        // The remembered class and My entry rules.
        const cls = $6a4a784425705adb$var$readJson($6a4a784425705adb$var$CLASS_PREF);
        if (cls === '' || cls === 'MONSTER' || (0, $j4wl1.STANDARD_CLASSES).includes(cls)) this.chosenClass = cls;
        const rules = $6a4a784425705adb$var$readJson($6a4a784425705adb$var$ENTRY_PREF);
        if (rules && typeof rules === 'object') {
            this.rules = {
                ...$6a4a784425705adb$var$ENTRY_DEFAULTS,
                ...rules
            };
            this.entrySetUp = true;
        }
        try {
            const g = localStorage.getItem($6a4a784425705adb$var$GENDER_PREF);
            if (g != null) {
                const v = JSON.parse(g);
                if (v === null || v === '' || v === 'Male' || v === 'Female') this.rules.gender = v;
            }
        } catch  {}
        try {
            this.monsterQuest = localStorage.getItem($6a4a784425705adb$var$MQ_PREF) === '1';
        } catch  {}
        if (this.rules.vip || this.monsterQuest && this.chosenClass === 'MONSTER') this.ensureVipHistory();
        // The pinned goal, which the bracket page keeps current (lib/goalRefresh.js).
        const prefs = (0, $3lf9e.loadPrefs)();
        this.goal = prefs.activeGoal || null;
        this.goalInfo = prefs.goalInfo || null;
        this.resetCustom();
        // userskills is likely already cached (the drop chip fetched it); the rest are
        // tiny. All prod-only (the dump CORS), so they resolve to null off-prod.
        const [sk, bonus, mk, cb, gil] = await Promise.all([
            (0, $aizvL.fetchDump)('userskills', this.handle),
            (0, $aizvL.fetchDump)('skillbonus', this.handle),
            (0, $aizvL.fetchDump)('prestige/mark', this.handle),
            (0, $aizvL.fetchDump)('classbonus', this.handle),
            (0, $aizvL.fetchDump)('gil', this.handle)
        ]);
        this.skills = sk == null ? [] : (0, $aizvL.parseSkills)(sk);
        this.skillBonus = (0, $aizvL.parseLines)(bonus)[0] || '';
        this.mark = (0, $aizvL.parseNumber)(mk) || 0;
        this.classbonus = cb == null ? null : (0, $aizvL.parseLines)(cb); // null = fetch failed (off-prod)
        this.gil = (0, $aizvL.parseNumber)(gil) || 0;
        const mons = this.skills.filter((s)=>$6a4a784425705adb$var$isMonster(s.token));
        if (mons.length) this.monsterFace = $6a4a784425705adb$var$nameOf(mons[Math.floor(Math.random() * mons.length)].token);
        this.loaded = true;
    },
    computed: {
        mods () {
            return (0, $j4wl1.activeModifiers)(this.skills, this.skillBonus, this.mark, $6a4a784425705adb$var$nameOf, $6a4a784425705adb$var$monsterTier);
        },
        cb () {
            return this.classbonus == null ? null : (0, $j4wl1.classBonus)(this.classbonus, this.skillBonus, $6a4a784425705adb$var$isMonster);
        },
        skillBonusName () {
            return this.skillBonus ? $6a4a784425705adb$var$nameOf(this.skillBonus) : '';
        },
        hasData () {
            return this.mods.length > 0 || this.cb != null;
        },
        // Best class to enter as: the strongest (by combat win rate) of your bonus
        // classes, falling back to the strongest class overall.
        bestClassToken () {
            const rank = (tok)=>$6a4a784425705adb$var$classWR(tok) ?? 0;
            const bonus = (0, $gNwy4.bonusClassTokens)(this.classbonus || []);
            return (0, $gNwy4.pickClass)(bonus.length ? bonus : (0, $j4wl1.STANDARD_CLASSES), rank);
        },
        // The class the suggestions use — your quest's target when "respect my quest" is
        // on, the VIP pick when the VIP helper is, else the picker's (remembered) choice,
        // else the auto-best.
        activeClass () {
            if (this.questActive && this.questTarget.kind === 'class') return this.questTarget.cls;
            if (this.vipActive && this.vipPick.kind === 'class') return $6a4a784425705adb$var$HUMAN_BY_NAME[this.vipPick.cls.toLowerCase()] || this.vipPick.cls;
            return this.chosenClass && this.chosenClass !== 'MONSTER' ? this.chosenClass : this.bestClassToken;
        },
        // The stronger gender for the active class, if there's a significant gap (≥2%).
        // null for monsters / gender-locked / negligible. Forcing it costs 100G, no
        // priority hit — a pure win, so we fold it into the value/go-big commands.
        genderEdgeInfo () {
            if (this.chosenClass === 'MONSTER' || !this.activeClass) return null;
            return (0, $7qBNy.genderEdge)((0, $koMQO.rosterStats), $6a4a784425705adb$var$classDisplay(this.activeClass), {
                minDelta: 2
            });
        },
        // The class's worst forceable skill to ban (e.g. Sing on a Wizard, -8.4%) —
        // surfaced as an OPTIONAL swap for the -gilgameheart ban. We keep GilgameHeart
        // as the default (its +5 priority usually beats the small avoid-the-worst-roll
        // gain); this just shows the alternative. Only returns clearly-bad ones (≤-3%).
        worstBan () {
            if (this.chosenClass === 'MONSTER' || !this.activeClass) return null;
            const cls = $6a4a784425705adb$var$classDisplay(this.activeClass);
            const cbc = (0, $koMQO.rosterStats).crossByClass || {};
            const base = ((0, $koMQO.rosterStats).windows.all.Class.find((x)=>x.value === cls) || {}).winRate || 50;
            const DIMS = {
                ActionSkill: 'secondary',
                SupportSkill: 'support',
                ReactionSkill: 'reaction',
                MoveSkill: 'move',
                Accessory: 'accessory'
            };
            // Don't recommend banning a slot the suggestions already FORCE (skill bonus /
            // best owned skill) — banning a sibling there is wasted gil (same dedup as the
            // custom builder). Skip those slots' dims entirely.
            const forcedCats = new Set();
            for (const tok of [
                this.skillBonus,
                this.goBigSkill
            ])for (const c of (0, $gNwy4.forcedSlots)(tok, $6a4a784425705adb$var$tokenCategory(tok)))forcedCats.add(c);
            let worst = null;
            for(const dim in DIMS){
                if (forcedCats.has($6a4a784425705adb$var$DIM_CAT[dim])) continue;
                for(const skill in cbc[dim] || {}){
                    if (/^Equip /.test(skill)) continue; // off-class weapon noise
                    // both genders — the well-known "this class + this skill is bad" headline
                    const rows = cbc[dim][skill].filter((r)=>r.value === cls + ' Male' || r.value === cls + ' Female');
                    const tot = rows.reduce((s, r)=>s + r.played, 0);
                    if (tot < 500) continue;
                    const wr = rows.reduce((s, r)=>s + r.winRate * r.played, 0) / tot;
                    if (!worst || wr < worst.wr) worst = {
                        skill: skill,
                        slot: DIMS[dim],
                        wr: wr
                    };
                }
            }
            if (!worst) return null;
            const delta = +(worst.wr - base).toFixed(1);
            return delta <= -3 ? {
                skill: worst.skill,
                slot: worst.slot,
                delta: delta,
                ban: (0, $gNwy4.cmdToken)(worst.skill)
            } : null;
        },
        // Class tokens (lowercased) that earn the class bonus — to mark them in the picker.
        bonusSet () {
            return new Set((0, $gNwy4.bonusClassTokens)(this.classbonus || []).map((0, $gNwy4.cmdToken)));
        },
        // The gender you picked (♂/♀ in the picker or My entry's pills): 'Male' / 'Female',
        // '' = any, null = the class's stronger gender. A gender-locked class ignores it.
        pickedGender () {
            return this.rules.gender;
        },
        // Your skill bonus, when it's a monster you own: entering as it earns the bonus.
        monsterBonus () {
            const sb = this.skillBonus;
            return !!sb && $6a4a784425705adb$var$isMonster(sb) && (this.skills || []).some((s)=>(0, $gNwy4.cmdToken)(s.token) === (0, $gNwy4.cmdToken)(sb));
        },
        // The picker's tiles: ⚙ Auto, the 20 classes (✦ = earns your class bonus; ♂/♀ pick a
        // gender right there), then 🐉 Monster.
        pickerTiles () {
            const g = (tok)=>$6a4a784425705adb$var$classDisplay(tok) === $6a4a784425705adb$var$classDisplay(this.activeClass) && this.customGender === 'Female' ? 'F' : 'M';
            const best = $6a4a784425705adb$var$classDisplay(this.bestClassToken);
            return [
                {
                    val: $6a4a784425705adb$var$AUTO_VAL,
                    name: 'Auto: ' + best,
                    emoji: "\u2699",
                    special: true,
                    title: `Your strongest ${this.bonusSet.size ? 'bonus ' : ''}class, ${best}`
                },
                ...(0, $j4wl1.STANDARD_CLASSES).map((tok)=>{
                    const name = $6a4a784425705adb$var$classDisplay(tok), bonus = this.bonusSet.has((0, $gNwy4.cmdToken)(tok));
                    return {
                        val: tok,
                        name: name,
                        icon: $6a4a784425705adb$var$portraitOf(name, g(tok)),
                        badge: bonus ? "\u2726" : '',
                        badgeTitle: 'Earns your class bonus',
                        genders: $6a4a784425705adb$var$GENDER_LOCK[name] ? [] : [
                            'Male',
                            'Female'
                        ],
                        title: name + (bonus ? " \u2726 earns your class bonus" : '') + ($6a4a784425705adb$var$GENDER_LOCK[name] ? '' : " \xb7 click for the stronger gender, or pick \u2642/\u2640")
                    };
                }),
                {
                    val: 'MONSTER',
                    name: 'Monster',
                    icon: $6a4a784425705adb$var$portraitOf(this.monsterFace, 'Monster'),
                    special: true,
                    badge: this.monsterBonus ? "\u2726" : '',
                    badgeTitle: 'Your skill bonus is a monster you own',
                    title: 'The best monster you own that you can roll right now'
                }
            ];
        },
        // What the "Suggest for" button shows.
        pickerCurrent () {
            if (this.chosenClass === 'MONSTER') return {
                icon: $6a4a784425705adb$var$portraitOf(this.monsterFace, 'Monster'),
                label: 'Monster',
                bonus: this.monsterBonus
            };
            if (!this.chosenClass) return {
                emoji: "\u2699",
                label: 'Auto: ' + $6a4a784425705adb$var$classDisplay(this.bestClassToken),
                bonus: this.bonusSet.has((0, $gNwy4.cmdToken)(this.bestClassToken))
            };
            const name = $6a4a784425705adb$var$classDisplay(this.chosenClass);
            const g = this.genderLock ? '' : this.customGender === 'Female' ? " \u2640" : this.customGender === 'Male' ? " \u2642" : '';
            return {
                icon: $6a4a784425705adb$var$portraitOf(name, this.customGender === 'Female' ? 'F' : 'M'),
                label: name + g,
                bonus: this.bonusSet.has((0, $gNwy4.cmdToken)(this.chosenClass))
            };
        },
        // Your single best owned forceable skill FOR THE ACTIVE CLASS, by empirical win
        // rate (must beat the class baseline to be worth forcing). Picking by class fit
        // instead of rarity stops it always suggesting Short Charge on melee, etc.
        goBigSkill () {
            const cls = $6a4a784425705adb$var$classDisplay(this.activeClass);
            const bonusKey = String(this.skillBonus || '').toLowerCase();
            let best = '', bestWR = $6a4a784425705adb$var$classBaseWR(cls);
            for (const s of this.skills || []){
                const meta = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[s.token];
                if (!meta || !$6a4a784425705adb$var$FORCEABLE.includes(meta.category)) continue;
                // Skip "cannot use" (buyrandom step≥5) skills — they can't be forced.
                const mod = (0, $aizvL.skillModifier)(s.step, s.token.toLowerCase() === bonusKey);
                if (mod && mod.cannotUse) continue;
                if (this.saveHidden && (0, $aizvL.isHiddenSkill)(s.token)) continue;
                const wr = $6a4a784425705adb$var$skillClassWR(s.token, cls);
                if (wr != null && wr > bestWR) {
                    bestWR = wr;
                    best = s.token;
                }
            }
            return best;
        },
        // The suggested !fight entries (only with the prod-only data loaded). Always a
        // "Get me in" baseline, then class-specific rows (or owned-monster rows).
        entries () {
            if (this.classbonus == null) return null;
            const aff = (cost)=>cost <= this.gil;
            const getIn = {
                key: 'in',
                icon: "\uD83C\uDFAF",
                label: 'Get me in',
                note: "Best odds \u2014 a random unit, but it still banks your class-bonus EXP.",
                ...(0, $gNwy4.buildEntry)({}),
                affordable: true
            };
            if (this.chosenClass === 'MONSTER') return [
                ...this.monsterEntries,
                getIn
            ];
            const classTok = this.activeClass;
            const classDisp = $6a4a784425705adb$var$classDisplay(classTok);
            const sb = this.skillBonus;
            const sbMonster = !!sb && ((0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[sb] || {}).category === 'monster';
            const sbSaved = !!sb && this.saveHidden && (0, $aizvL.isHiddenSkill)(sb);
            const forceSb = !!sb && !sbMonster && !sbSaved; // a monster skill bonus can't be forced on a human
            const gx = this.genderEdgeInfo; // { gender, delta } | null
            // Your picked gender ('' = any), else the stronger one when the gap is real.
            const gender = this.genderLock ? '' : this.pickedGender != null ? this.pickedGender : gx ? gx.gender : '';
            // Excluding GilgameHeart buys +5 priority but costs +500G (the bribe). Fold it
            // in only when the forced skill isn't GilgameHeart AND you can afford it —
            // otherwise drop it (poor players shouldn't be told to pay a bribe they can't).
            const buildAdaptive = (forcedSkills, usesSkillBonus)=>{
                const b = {
                    className: classTok,
                    gender: gender,
                    forcedSkills: forcedSkills,
                    usesSkillBonus: usesSkillBonus,
                    rarityOf: $6a4a784425705adb$var$rarityOf
                };
                // Opt-out (persisted) or already forcing GilgameHeart → no bribe.
                if (!this.excludeGgh || forcedSkills.some((s)=>(0, $gNwy4.cmdToken)(s) === 'gilgameheart')) return {
                    e: (0, $gNwy4.buildEntry)(b),
                    bribe: false,
                    poor: false
                };
                const withBribe = (0, $gNwy4.buildEntry)({
                    ...b,
                    excludes: [
                        'GilgameHeart'
                    ]
                });
                if (withBribe.cost <= this.gil) return {
                    e: withBribe,
                    bribe: true,
                    poor: false
                };
                return {
                    e: (0, $gNwy4.buildEntry)(b),
                    bribe: false,
                    poor: true
                };
            };
            const v = buildAdaptive(forceSb ? [
                sb
            ] : [], forceSb);
            const rows = [
                getIn,
                {
                    key: 'value',
                    icon: "\u2696\uFE0F",
                    label: 'Smart value',
                    note: `Force ${classDisp}${forceSb ? ' + your skill bonus (' + this.skillBonusName + ')' : ''}` + (v.bribe ? ", exclude GilgameHeart \u2014 same odds as a blind entry, but you control it." : v.poor ? " \u2014 you control it (skipped the GilgameHeart bribe; you're short on gil for the +5)." : " \u2014 you control it.") + (sbMonster ? ` Your skill bonus, ${this.skillBonusName}, is a monster \u{2014} enter as it via \u{1F409} Monster to claim its +5.` : '') + (sbSaved ? ` Your skill bonus, ${this.skillBonusName}, is a hidden skill you're saving, so it's left out.` : ''),
                    ...v.e,
                    affordable: aff(v.e.cost)
                }
            ];
            const big = this.goBigSkill;
            if (big && (0, $gNwy4.cmdToken)(big) !== (0, $gNwy4.cmdToken)(sb)) {
                const b = buildAdaptive([
                    big
                ], false);
                const r = $6a4a784425705adb$var$rarityOf(big);
                const tail = r === 'common' ? 'no odds cost.' : `but it's ${r}, so it drops your odds.`;
                rows.push({
                    key: 'big',
                    icon: "\uD83D\uDCAA",
                    label: 'Go big',
                    note: `Force ${classDisp} + ${$6a4a784425705adb$var$nameOf(big)} \u{2014} your best owned skill for ${classDisp} \u{2014} ${tail}` + (b.poor ? " (GilgameHeart bribe skipped \u2014 low on gil.)" : ''),
                    ...b.e,
                    affordable: aff(b.e.cost)
                });
            }
            return rows;
        },
        // The one entry shown when the section is collapsed — the recommended Smart
        // value (controlled + good odds), falling back to the first available.
        headlineEntry () {
            const e = this.entries;
            return e ? e.find((x)=>x.key === 'value' || x.mon) || e[0] : null;
        },
        // Your owned monsters as solo entries, ranked: what you can enter as right now (off
        // cooldown, affordable) by win rate, then the rest. Strong and elite monsters share a
        // cooldown per tier, read off the userskills tildes (entryAdvisor rankMonsters).
        rankedMonsters () {
            return (0, $gNwy4.rankMonsters)(this.skills, {
                tierOf: $6a4a784425705adb$var$monsterTier,
                winRate: (t)=>$6a4a784425705adb$var$monsterWR($6a4a784425705adb$var$nameOf(t)),
                modifier: (0, $aizvL.skillModifier),
                format: (0, $aizvL.formatModifier),
                gil: this.gil,
                skillBonus: this.skillBonus
            });
        },
        // 🐉 Monster Quest progress, all time: how many of the 55 you've champed, how many full
        // sets, and the monsters the next set still needs (all at your lowest count). null until
        // the champion history loads.
        mqProgress () {
            if (!this.vipHist) return null;
            const row = (0, $1dDjn.vipRowFor)((0, $1dDjn.vipStandings)(this.vipHist, 0, (0, $4ErgZ.seasonOf), this.vipMeta), this.handle);
            const count = (m)=>row && row.cls[m] ? row.cls[m].titles : 0;
            const sets = Math.min(...(0, $1dDjn.VIP_MONSTERS).map(count));
            return {
                sets: sets,
                have: (0, $1dDjn.VIP_MONSTERS).filter((m)=>count(m) > sets).length,
                need: new Set((0, $1dDjn.VIP_MONSTERS).filter((m)=>count(m) === sets))
            };
        },
        // The monsters you own and can enter as right now, by name (cooldown-aware): what the
        // VIP helper and "Respect my quest" may suggest. Affordability is left to the entry.
        rollableMonsters () {
            return new Set(this.rankedMonsters.filter((r)=>r.usable).map((r)=>$6a4a784425705adb$var$nameOf(r.token)));
        },
        // The monsters the suggestions draw from: all you own, or just what your quest needs.
        monsterPool () {
            const mq = this.monsterQuest && this.mqProgress;
            return mq ? this.rankedMonsters.filter((r)=>mq.need.has($6a4a784425705adb$var$nameOf(r.token))) : this.rankedMonsters;
        },
        // The ones you can enter as, as entry rows (an unaffordable one stays, marked).
        monsterEntries () {
            const rows = this.monsterPool.filter((r)=>r.usable);
            return rows.map((r, i)=>{
                const name = $6a4a784425705adb$var$nameOf(r.token);
                const wr = r.winRate != null ? r.winRate.toFixed(1) + '% win rate' : 'no win-rate data';
                const best = i === 0 && r.affordable && r.winRate != null ? this.monsterQuest ? ', your best that the quest still needs' : ', the best you can roll right now' : '';
                const tierBit = `${r.tier} monster (${$6a4a784425705adb$var$TIER_PRIO[r.tier]})`;
                const cd = r.modText && !r.isBonus ? r.tier === 'normal' ? ` \xb7 rerolled: ${r.modText}` : ` \xb7 ${r.tier} cooldown winding down: ${r.modText}` : '';
                return {
                    key: 'mon-' + r.token,
                    mon: true,
                    icon: "\uD83D\uDC09",
                    label: name + (r.winRate != null ? " \xb7 " + r.winRate.toFixed(1) + '%' : '') + (r.isBonus ? " \u2726" : ''),
                    note: wr + best + " \xb7 " + tierBit + cd + (r.isBonus ? " \xb7 your skill bonus (+5 priority, +2 EXP)" : '') + '. A monster entry takes no other parameters.',
                    ...r
                };
            });
        },
        // Owned monsters you can't enter as right now, in a line per cooldown: strong and
        // elite ones by tier (they share it), normal ones together (each has its own).
        monsterBlocked () {
            const out = [], blocked = this.monsterPool.filter((r)=>!r.usable);
            for (const tier of [
                'elite',
                'strong',
                'normal'
            ]){
                const rows = blocked.filter((r)=>r.tier === tier);
                if (!rows.length) continue;
                const names = rows.map((r)=>$6a4a784425705adb$var$nameOf(r.token));
                const list = names.slice(0, 5).join(', ') + (names.length > 5 ? ` and ${names.length - 5} more` : '');
                if (tier === 'normal') out.push({
                    key: tier,
                    text: `On their own cooldown: ${list}.`
                });
                else {
                    const n = rows[0].freesIn;
                    out.push({
                        key: tier,
                        text: `Your ${tier} monsters share a cooldown, and it's still running: about ${n} more tournament${n === 1 ? '' : 's'} you're in before any of them can roll (${list}).`
                    });
                }
            }
            return out;
        },
        mqHint () {
            const mq = this.mqProgress;
            if (this.vipError) return "Couldn't load your titles, so this shows every monster you own.";
            if (!mq) return "Reading your titles\u2026";
            const n = (0, $1dDjn.VIP_MONSTERS).length;
            return mq.sets ? `${mq.sets} full set${mq.sets === 1 ? '' : 's'} \xb7 ${mq.have}/${n} toward the next` : `${mq.have}/${n} champed`;
        },
        // Why the quest switch left nothing to suggest, if it did.
        mqEmptyMsg () {
            if (!this.monsterQuest || !this.mqProgress || this.monsterEntries.length) return '';
            if (!this.monsterPool.length) return "You don't own any of the monsters your Monster Quest still needs.";
            return 'The monsters you own that your quest still needs are all on cooldown right now.';
        },
        // ── ⭐ My entry ───────────────────────────────────────────────────────────
        showMyEntry () {
            return this.entrySetUp && this.chosenClass !== 'MONSTER';
        },
        // The pinned quest, if an entry can advance it.
        questGoal () {
            const g = this.goal, info = this.goalInfo;
            if (!g || g.type !== 'quest' || !info || !$6a4a784425705adb$var$QUEST_ENTERABLE.has(g.id)) return null;
            return {
                id: g.id,
                name: info.name,
                remaining: info.remaining || []
            };
        },
        // Your quest's best target you can enter as (a class, with gender on gendered
        // quests, or a monster you own), or null.
        questTarget () {
            const q = this.questGoal;
            if (!q) return null;
            const owned = new Set((this.skills || []).filter((s)=>$6a4a784425705adb$var$isMonster(s.token)).map((s)=>s.token));
            const targets = (0, $gNwy4.questTargets)(q.remaining, {
                humanClass: (n)=>$6a4a784425705adb$var$HUMAN_BY_NAME[n.toLowerCase()] || '',
                monsterToken: (n)=>{
                    const t = $6a4a784425705adb$var$MONSTER_BY_NAME[n.toLowerCase()];
                    return t && owned.has(t) && this.rollableMonsters.has($6a4a784425705adb$var$nameOf(t)) ? t : '';
                }
            });
            return (0, $gNwy4.pickQuestTarget)(targets, {
                isBonus: (cls)=>this.bonusSet.has((0, $gNwy4.cmdToken)(cls)),
                rank: (t)=>(t.kind === 'class' ? $6a4a784425705adb$var$classWR(t.cls) : $6a4a784425705adb$var$monsterWR(t.label)) ?? 0
            });
        },
        questActive () {
            return this.rules.respectQuest && !!this.questTarget;
        },
        // Why "respect my quest" can't apply ('' when it can), for its tooltip and note.
        questWhyNot () {
            const g = this.goal;
            if (!g) return 'Pin a quest on your profile first.';
            if (g.type !== 'quest') return "Your goal is an achievement, which an entry can't target.";
            if ($6a4a784425705adb$var$QUEST_WHY_NOT[g.id]) return `Your quest can't be targeted: ${$6a4a784425705adb$var$QUEST_WHY_NOT[g.id]}.`;
            if (!this.questGoal) return "Your goal can't be targeted by an entry.";
            if (!this.questTarget) return `Nothing left on your ${this.questGoal.name} list is something you can enter as.`;
            return '';
        },
        // The locked gender for the active class (Bard/Dancer), or '' if free.
        genderLock () {
            return $6a4a784425705adb$var$GENDER_LOCK[$6a4a784425705adb$var$classDisplay(this.activeClass)] || '';
        },
        // The gender a quest target needs ('' if none, or when the class is locked anyway).
        questGender () {
            return this.questActive && this.questTarget.kind === 'class' && !this.genderLock ? this.questTarget.gender : '';
        },
        // The gender the entry names ('' = leave it to the roll). A locked class never needs one.
        genderParam () {
            return this.genderLock ? '' : this.customGender;
        },
        // The slots the forced skill fills (its own, plus the secondary for Throw Item /
        // Monster Talk) — drives the same-slot ban dedup.
        forceSlots () {
            return (0, $gNwy4.forcedSlots)(this.forcePick, $6a4a784425705adb$var$tokenCategory(this.forcePick));
        },
        // Your hidden (prestige) skills that an entry could force, by name. "Save my hidden
        // skills" only shows when there's one to save.
        ownedHidden () {
            return (this.skills || []).filter((s)=>(0, $aizvL.isHiddenSkill)(s.token) && $6a4a784425705adb$var$FORCEABLE.includes($6a4a784425705adb$var$tokenCategory(s.token))).map((s)=>$6a4a784425705adb$var$nameOf(s.token));
        },
        // Your owned forceable skills, ranked by empirical win rate for the active class
        // (and gender, when one is set). "Cannot use" (5+ tildes) skills are left out.
        // Hidden skills are in it; forceRanked drops them while you're saving them.
        forceRankedAll () {
            const cls = $6a4a784425705adb$var$classDisplay(this.activeClass);
            const base = $6a4a784425705adb$var$classBaseWR(cls, this.customGender);
            const bonusKey = String(this.skillBonus || '').toLowerCase();
            const out = [];
            for (const s of this.skills || []){
                const meta = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[s.token];
                if (!meta || !$6a4a784425705adb$var$FORCEABLE.includes(meta.category)) continue;
                const isBonus = s.token.toLowerCase() === bonusKey;
                const mod = (0, $aizvL.skillModifier)(s.step, isBonus);
                if (mod && mod.cannotUse) continue;
                const wr = $6a4a784425705adb$var$skillClassWR(s.token, cls, this.customGender);
                if (wr == null) continue;
                const r = $6a4a784425705adb$var$rarityOf(s.token);
                out.push({
                    token: s.token,
                    name: $6a4a784425705adb$var$nameOf(s.token),
                    step: s.step,
                    isBonus: isBonus,
                    delta: +(wr - base).toFixed(1),
                    rarity: r,
                    prio: r === 'rare' ? -15 : r === 'uncommon' ? -10 : 0,
                    // The owned-skill step modifier (rerolled penalty, or the +2/+5 bonus).
                    stepText: mod && !mod.cannotUse ? (0, $aizvL.formatModifier)(mod) : '',
                    stepNeg: !!mod && !mod.cannotUse && mod.exp < 0
                });
            }
            return out.sort((a, b)=>b.delta - a.delta);
        },
        // The ranking every pick uses: My entry's rule, the Force list, the notes.
        forceRanked () {
            return this.saveHidden ? this.forceRankedAll.filter((s)=>!(0, $aizvL.isHiddenSkill)(s.token)) : this.forceRankedAll;
        },
        // The Force list: the top 10, plus the current pick if it ranks lower.
        customForceList () {
            const top = this.forceRanked.slice(0, 10);
            const pick = this.forcePick && this.forceRanked.find((s)=>s.token === this.forcePick);
            return pick && !top.includes(pick) ? [
                ...top,
                pick
            ] : top;
        },
        // The Ban list: the class's worst rolls (for the gender, when one is set), without
        // the slot you're already forcing (a same-slot ban just burns 100G). GilgameHeart
        // has its own checkbox.
        customBanList () {
            const cls = $6a4a784425705adb$var$classDisplay(this.activeClass);
            const base = $6a4a784425705adb$var$classBaseWR(cls, this.customGender);
            const worst = (0, $iziJA.avoidPicks)((0, $koMQO.rosterStats), cls, {
                gender: this.customGender,
                n: 8
            }).map((w)=>({
                    token: w.skill,
                    name: w.skill,
                    delta: +(w.winRate - base).toFixed(1)
                }));
            return (0, $gNwy4.pruneSameSlotBans)(worst, this.forceSlots, (b)=>$6a4a784425705adb$var$NAME_CAT[b.name] || '');
        },
        // What the rules pick, and what's in effect (a manual pick this session wins). The VIP
        // helper's matchup skill, when it found one, comes before the best-skill rule.
        ruleForce () {
            if (this.vipSkill) return this.vipSkill.token;
            return this.rules.forceBest ? (0, $gNwy4.pickRuleSkill)(this.forceRanked, this.rules.pool) : '';
        },
        ruleBan () {
            return this.rules.banWorst && this.customBanList.length ? this.customBanList[0].token : '';
        },
        forcePick () {
            return this.forceOverride !== null ? this.forceOverride : this.ruleForce;
        },
        banPick () {
            return this.banOverride !== null ? this.banOverride : this.ruleBan;
        },
        // The assembled entry: fitted to the four-parameter limit, with the GilgameHeart
        // bribe dropped when you can't afford it. A quest target that's a monster you own
        // is a solo monster entry instead.
        customEntry () {
            const t = this.questActive ? this.questTarget : this.vipActive && this.vipPick.kind === 'monster' ? {
                kind: 'monster',
                token: $6a4a784425705adb$var$MONSTER_BY_NAME[this.vipPick.cls.toLowerCase()]
            } : null;
            if (t && t.kind === 'monster') {
                const tier = $6a4a784425705adb$var$tierOf(t.token), e = (0, $gNwy4.buildMonsterEntry)(t.token, tier);
                if ((0, $gNwy4.cmdToken)(t.token) === (0, $gNwy4.cmdToken)(this.skillBonus)) e.priority += 5;
                return {
                    ...e,
                    kind: 'monster',
                    via: this.questActive ? 'quest' : 'vip',
                    monster: t.token,
                    tier: tier,
                    affordable: e.cost <= this.gil,
                    dropped: [],
                    bribeSkipped: false,
                    gender: '',
                    forced: '',
                    ban: '',
                    ggh: false,
                    usesSkillBonus: false,
                    stepText: ''
                };
            }
            const isGgh = (x)=>(0, $gNwy4.cmdToken)(x) === 'gilgameheart';
            const force = this.forcePick;
            const excludes = [];
            if (this.banPick) excludes.push(this.banPick);
            if (this.excludeGgh && !isGgh(force)) excludes.push('GilgameHeart');
            const fit = (0, $gNwy4.fitToLimit)({
                className: this.activeClass,
                gender: this.genderParam,
                genderRequired: !!this.questGender,
                forcedSkills: force ? [
                    force
                ] : [],
                excludes: excludes
            });
            const forced = fit.forcedSkills[0] || '';
            const usesSkillBonus = !!forced && !$6a4a784425705adb$var$isMonster(forced) && (0, $gNwy4.cmdToken)(forced) === (0, $gNwy4.cmdToken)(this.skillBonus);
            const make = (ex)=>(0, $gNwy4.buildEntry)({
                    className: this.activeClass,
                    gender: fit.gender,
                    forcedSkills: fit.forcedSkills,
                    excludes: ex,
                    usesSkillBonus: usesSkillBonus,
                    rarityOf: $6a4a784425705adb$var$rarityOf
                });
            let ex = fit.excludes, e = make(ex), bribeSkipped = false;
            if (ex.some(isGgh) && e.cost > this.gil) {
                ex = ex.filter((x)=>!isGgh(x));
                e = make(ex);
                bribeSkipped = true;
            }
            // buildEntry is blind to buyrandom-step penalties — fold in the forced skill's
            // own step modifier. (The skill-bonus +5 is already in e.priority via
            // usesSkillBonus, so only adjust for a non-bonus rerolled skill.)
            let stepText = '';
            let priority = e.priority;
            if (forced && !usesSkillBonus) {
                const s = (this.skills || []).find((x)=>x.token === forced);
                const m = s ? (0, $aizvL.skillModifier)(s.step, false) : null;
                if (m && !m.cannotUse && m.priority) {
                    priority += m.priority;
                    stepText = (0, $aizvL.formatModifier)(m);
                }
            }
            return {
                ...e,
                kind: 'class',
                priority: priority,
                usesSkillBonus: usesSkillBonus,
                stepText: stepText,
                affordable: e.cost <= this.gil,
                dropped: fit.dropped,
                bribeSkipped: bribeSkipped,
                gender: fit.gender,
                forced: forced,
                ban: ex.find((x)=>!isGgh(x)) || '',
                ggh: ex.some(isGgh)
            };
        },
        // What the any usable / off cooldown / no penalty choice changed here, so it never
        // looks inert: the better skills it passed over (and their costs), then what each
        // stricter choice would force instead.
        poolNote () {
            if (!this.rules.forceBest || this.forceOverride !== null || this.customEntry.kind === 'monster' || this.vipSkill) return '';
            const cur = this.ruleForce, at = Math.max(0, (0, $gNwy4.RULE_POOLS).indexOf(this.rules.pool));
            const picks = (0, $gNwy4.RULE_POOLS).map((p)=>(0, $gNwy4.pickRuleSkill)(this.forceRanked, p));
            if (picks.every((t)=>t === cur)) return cur ? `All three choices pick ${$6a4a784425705adb$var$nameOf(cur)} here.` : '';
            const info = (tok)=>this.forceRanked.find((x)=>x.token === tok);
            // Only the costs this choice turns down: tildes, plus rarity under "no penalty".
            const costs = (o)=>[
                    o.step > 0 && !o.isBonus ? `${o.step} reroll tilde${o.step === 1 ? '' : 's'}` : '',
                    this.rules.pool === 'nopenalty' && o.rarity && o.rarity !== 'common' ? `${o.rarity}, ${o.prio} priority` : ''
                ].filter(Boolean).join('; ');
            const out = [];
            const skipped = [
                ...new Set(picks.slice(0, at))
            ].filter((t)=>t && t !== cur).map(info).filter(Boolean);
            if (skipped.length) out.push('Skipped ' + skipped.map((o)=>`${o.name} (+${o.delta}%: ${costs(o)})`).join(' and ') + '.');
            for(let i = at + 1; i < (0, $gNwy4.RULE_POOLS).length; i++){
                const t = picks[i];
                if (t === cur || t === picks[i - 1] && i > at + 1) continue; // same as this choice, or as the one just listed
                const o = info(t), label = $6a4a784425705adb$var$POOL_LABEL[(0, $gNwy4.RULE_POOLS)[i]], strict = (0, $gNwy4.RULE_POOLS)[i] === 'nopenalty';
                out.push(o ? `"${label}" would force ${o.name} instead (+${o.delta}%, no tildes${strict ? ' or priority cost' : ''}).` : `"${label}" would force nothing: none of your skills that beat the baseline ${strict ? 'are penalty-free' : 'are off cooldown'}.`);
            }
            return out.join(' ');
        },
        // The hidden skill "Save my hidden skills" kept My entry from forcing, if any.
        hiddenNote () {
            if (!this.saveHidden || !this.rules.forceBest || this.forceOverride !== null || this.customEntry.kind === 'monster' || this.vipSkill) return '';
            const tok = (0, $gNwy4.pickRuleSkill)(this.forceRankedAll, this.rules.pool);
            const o = tok && (0, $aizvL.isHiddenSkill)(tok) && this.forceRankedAll.find((s)=>s.token === tok);
            return o ? `Skipped ${o.name} (+${o.delta}%: a hidden skill you're saving).` : '';
        },
        // ── 🎖️ VIP Quest ──────────────────────────────────────────────────────────
        // Your row on this season's VIP board: null until the champion history loads, or when
        // you haven't champed anything this season yet.
        vipRow () {
            return this.vipHist ? (0, $1dDjn.vipRowFor)((0, $1dDjn.vipStandings)(this.vipHist, (0, $4ErgZ.SEASON_COUNT), (0, $4ErgZ.seasonOf), this.vipMeta), this.handle) : null;
        },
        vipNeeded () {
            return (0, $1dDjn.vipMissing)(this.vipRow);
        },
        vipHave () {
            return this.vipTotal - this.vipNeeded.length;
        },
        // The champion's units, read for what they take double from and what they shrug off.
        vipDefenders () {
            return (this.champion && this.champion.units || []).map((0, $764dZ.defensesOf));
        },
        // Every class you still need that you can enter as, best first: owned strong and elite
        // monsters ahead of everything (they share a cooldown), then by win rate plus the edge
        // on the champion. A human may bring an owned skillset that hits a weakness.
        vipRanked () {
            if (!this.rules.vip || !this.vipHist) return [];
            const owned = this.rollableMonsters;
            const bonusKey = (0, $gNwy4.cmdToken)(this.skillBonus);
            const skillsets = [];
            for (const s of this.skills || []){
                if ($6a4a784425705adb$var$tokenCategory(s.token) !== 'skillset' || this.saveHidden && (0, $aizvL.isHiddenSkill)(s.token)) continue;
                const mod = (0, $aizvL.skillModifier)(s.step, (0, $gNwy4.cmdToken)(s.token) === bonusKey);
                if (mod && mod.cannotUse) continue;
                const k = (0, $764dZ.skillsetKit)(s.token);
                if (k) skillsets.push({
                    token: s.token,
                    name: k.name,
                    kit: k.kit,
                    rank: (cls)=>$6a4a784425705adb$var$skillClassWR(s.token, cls) ?? 0
                });
            }
            return (0, $53jI0.vipCandidates)({
                needed: this.vipNeeded,
                owned: owned,
                skillsets: skillsets,
                ownSkillset: $764dZ.ownSkillset,
                kitOf: (0, $764dZ.classKit),
                defenders: this.vipDefenders,
                isMonster: (c)=>$6a4a784425705adb$var$VIP_MONSTER_SET.has(c),
                gated: (c)=>!!$6a4a784425705adb$var$MONSTER_TIER[c],
                strength: (c)=>$6a4a784425705adb$var$VIP_MONSTER_SET.has(c) ? $6a4a784425705adb$var$monsterWR(c) : $6a4a784425705adb$var$classWR(c)
            });
        },
        // The pick: your choice from the list this session, else the top candidate.
        vipPick () {
            const r = this.vipRanked;
            return this.vipOverride && r.find((x)=>x.cls === this.vipOverride) || r[0] || null;
        },
        vipActive () {
            return this.rules.vip && !!this.vipPick;
        },
        vipSkill () {
            return this.vipActive && this.vipPick.kind === 'class' ? this.vipPick.skill : null;
        },
        // The list under the pick: the top few, plus the pick when it ranks lower.
        vipList () {
            const top = this.vipRanked.slice(0, $6a4a784425705adb$var$VIP_SHOWN);
            return this.vipPick && !top.includes(this.vipPick) ? [
                ...top,
                this.vipPick
            ] : top;
        },
        // The needed strong/elite monsters: the ones you own lead the list; the rest you'd
        // have to get first.
        vipGated () {
            const need = this.vipNeeded.filter((c)=>$6a4a784425705adb$var$MONSTER_TIER[c]);
            const owned = new Set(this.vipRanked.filter((r)=>r.gated).map((r)=>r.cls));
            const all = new Set(this.rankedMonsters.map((r)=>$6a4a784425705adb$var$nameOf(r.token)));
            return {
                need: need,
                owned: need.filter((c)=>owned.has(c)),
                cooling: need.filter((c)=>!owned.has(c) && all.has(c)),
                missing: need.filter((c)=>!all.has(c))
            };
        },
        vipChampText () {
            const c = this.champion;
            if (!c || !c.units || !c.units.length) return '';
            const who = c.units.map((u)=>u.Class).join(', ');
            if (c.isNew) return `the new champion, ${c.label}'s team: ${who}`;
            return `the champion${c.decided ? '' : ', if they hold the belt'}: ${who}`;
        },
        // Why the active pick, for the breakdown's VIP line, and why its forced skillset.
        vipPickWhy () {
            return this.vipPick ? this.vipWhy(this.vipPick) : '';
        },
        vipSkillWhy () {
            const hits = this.vipSkill ? this.vipPick.edge.hits.map((h)=>`${h.element} for their ${h.cls}`) : [];
            return 'the VIP matchup' + (hits.length ? ': ' + hits.join(', ') : '');
        },
        // The short "for" label on the My entry card: "Lancer ♂", with 🎯 when it's your quest's pick.
        myEntryFor () {
            const e = this.customEntry;
            if (e.kind === 'monster') return $6a4a784425705adb$var$nameOf(e.monster) + (e.via === 'vip' ? " \uD83C\uDF96\uFE0F" : " \uD83C\uDFAF");
            const g = e.gender === 'Male' ? " \u2642" : e.gender === 'Female' ? " \u2640" : '';
            return $6a4a784425705adb$var$classDisplay(this.activeClass) + g + (this.questActive ? " \uD83C\uDFAF" : this.vipActive ? " \uD83C\uDF96\uFE0F" : '');
        },
        // What the four-parameter limit left out, in words.
        droppedText () {
            const words = {
                ban: (v)=>'the ' + v + ' ban',
                gender: (v)=>'the ' + (v === 'Female' ? "\u2640" : "\u2642") + ' pick',
                bribe: ()=>'the GilgameHeart bribe',
                skill: (v)=>$6a4a784425705adb$var$nameOf(v)
            };
            return this.customEntry.dropped.map((d)=>words[d.kind](d.value)).join(', ');
        },
        // Display helpers for the entry breakdown.
        classBaseWRDisp () {
            return $6a4a784425705adb$var$classBaseWR($6a4a784425705adb$var$classDisplay(this.activeClass), this.customGender).toFixed(1);
        },
        forcePickDisp () {
            const hit = this.forceRanked.find((s)=>s.token === this.customEntry.forced);
            if (!hit) return '';
            const sign = hit.delta >= 0 ? '+' : '';
            const tail = hit.rarity === 'common' ? 'common (no priority cost)' : `${hit.rarity} (${hit.prio} priority)`;
            const who = $6a4a784425705adb$var$classDisplay(this.activeClass) + (this.customGender === 'Female' ? " \u2640" : this.customGender === 'Male' ? " \u2642" : '');
            return `${sign}${hit.delta}% for ${who} \xb7 ${tail}`;
        },
        banPickDisp () {
            const hit = this.customBanList.find((b)=>b.token === this.customEntry.ban);
            return hit ? `${hit.delta}%` : '';
        }
    },
    watch: {
        // Switching class re-applies the rules and re-defaults the gender.
        activeClass: 'resetCustom',
        // A new champion makes the VIP sim's numbers stale.
        champion () {
            this.vipSim = {};
        },
        // Flipping gender re-ranks both lists, so fall back to the rules' picks.
        customGender () {
            this.forceOverride = null;
            this.banOverride = null;
        },
        // Remember the picked class. 🐉 Monster has no My entry, so close its picks panel.
        chosenClass (v) {
            $6a4a784425705adb$var$writeJson($6a4a784425705adb$var$CLASS_PREF, v);
            if (v === 'MONSTER') {
                this.fineTune = false;
                if (this.monsterQuest) this.ensureVipHistory();
            }
        },
        rules: {
            deep: true,
            handler (v) {
                if (this.entrySetUp) $6a4a784425705adb$var$writeJson($6a4a784425705adb$var$ENTRY_PREF, v);
            }
        },
        // Forcing a slot makes a same-slot manual ban pointless, so fall back to the rule.
        forcePick () {
            if (!this.forceSlots.length || !this.banOverride) return;
            const banCat = $6a4a784425705adb$var$NAME_CAT[this.banOverride] || $6a4a784425705adb$var$tokenCategory(this.banOverride);
            if (this.forceSlots.includes(banCat)) this.banOverride = null;
        }
    },
    methods: {
        classDisplay: $6a4a784425705adb$var$classDisplay,
        cmdToken: $gNwy4.cmdToken,
        // Re-apply the rules (dropping this session's manual picks) and re-default the
        // gender: a locked class's, a quest target's, your remembered pick, else the class's
        // stronger gender when the gap is real, else leave it to the roll.
        resetCustom () {
            this.forceOverride = null;
            this.banOverride = null;
            const g = this.rules.gender;
            const edge = (0, $7qBNy.genderEdge)((0, $koMQO.rosterStats), $6a4a784425705adb$var$classDisplay(this.activeClass), {
                minDelta: 2
            });
            this.customGender = this.genderLock || this.questGender || (g != null ? g : edge ? edge.gender : '');
        },
        selectForce (token) {
            this.forceOverride = this.forcePick === token ? '' : token;
        },
        selectBan (token) {
            this.banOverride = this.banPick === token ? '' : token;
        },
        // A gender picked on the pills is remembered for next time ('' = any).
        setGender (g) {
            this.customGender = g;
            this.rules.gender = g;
            $6a4a784425705adb$var$writeJson($6a4a784425705adb$var$GENDER_PREF, g);
        },
        // A picker tile: the class (or Auto / Monster), with a gender when ♂/♀ was clicked.
        // Clicking the tile itself hands the gender back to the class's stronger one.
        onPickClass (val, gender) {
            this.classPickerOpen = false;
            this.chosenClass = val === $6a4a784425705adb$var$AUTO_VAL ? '' : val;
            if (val === 'MONSTER' || val === $6a4a784425705adb$var$AUTO_VAL) return;
            this.rules.gender = gender || null;
            $6a4a784425705adb$var$writeJson($6a4a784425705adb$var$GENDER_PREF, this.rules.gender);
            this.resetCustom();
        },
        setUpMyEntry () {
            this.entrySetUp = true;
            $6a4a784425705adb$var$writeJson($6a4a784425705adb$var$ENTRY_PREF, this.rules);
        },
        toggleRule (key) {
            this.rules[key] = !this.rules[key];
            // "Respect my quest" and the VIP helper both choose the class, so one turns the other off.
            if (this.rules[key] && key === 'vip') {
                this.rules.respectQuest = false;
                this.ensureVipHistory();
            }
            if (this.rules[key] && key === 'respectQuest') this.rules.vip = false;
            if (key === 'vip') this.vipOverride = null;
            this.resetCustom();
        },
        // ── 🎖️ VIP Quest ──
        async ensureVipHistory () {
            if (this.vipHist || this._vipLoading) return;
            this._vipLoading = true;
            try {
                // The reign side-file says when each reign was dethroned, which decides its season.
                const [hist, meta] = await Promise.all([
                    (0, $gKfUi.loadData)('champHistory.json'),
                    (0, $gKfUi.loadData)('champReignMeta.json').catch(()=>null)
                ]);
                this.vipMeta = meta && Object.freeze(meta);
                this.vipHist = Object.freeze(hist);
            } catch (e) {
                this.vipError = "Couldn't load the champion history, so the VIP helper can't tell what you still need.";
            } finally{
                this._vipLoading = false;
            }
        },
        vipTier (cls) {
            return $6a4a784425705adb$var$MONSTER_TIER[cls] || '';
        },
        // Persisted "Respect Monster Quest" switch; it reads the same champion history as VIP.
        toggleMonsterQuest () {
            this.monsterQuest = !this.monsterQuest;
            if (this.monsterQuest) this.ensureVipHistory();
            try {
                localStorage.setItem($6a4a784425705adb$var$MQ_PREF, this.monsterQuest ? '1' : '0');
            } catch  {}
        },
        // Choose another candidate for this session (the top one clears the choice).
        pickVip (cls) {
            this.vipOverride = this.vipRanked[0] && this.vipRanked[0].cls === cls ? null : cls;
            this.forceOverride = null;
        },
        // Why a candidate, in words: the weaknesses it hits, what blocks it, its win rate.
        vipWhy (c) {
            const parts = [], byEl = {};
            for (const h of c.edge.hits)(byEl[h.element] || (byEl[h.element] = [])).push(h.cls);
            for (const [el, cls] of Object.entries(byEl))parts.push(`${el} hits their ${cls.join(' and ')}`);
            for (const b of c.edge.blocks)parts.push(b.why === 'innocent' ? `their ${b.cls} shrugs off magic` : `their ${b.cls} ${b.why === 'absorb' ? 'absorbs' : 'nulls'} ${b.element}`);
            parts.push(`${c.base.toFixed(1)}% win rate`);
            return parts.join(" \xb7 ");
        },
        // The on-demand reality check: the battle sim for each listed candidate vs the champion.
        async runVipSim () {
            const units = this.champion && this.champion.units;
            if (this.vipSimBusy || !units || !units.length) return;
            this.vipSimBusy = true;
            this.vipSim = {};
            try {
                const { simVipCandidates: simVipCandidates } = await (parcelRequire("eovON"));
                await simVipCandidates(this.vipList.map((c)=>({
                        cls: c.cls,
                        skill: c.skill
                    })), units, (cls, pct)=>{
                    this.vipSim = {
                        ...this.vipSim,
                        [cls]: pct
                    };
                });
            } catch (e) {
                console.warn('VIP sim failed', e);
            } finally{
                this.vipSimBusy = false;
            }
        },
        setPool (pool) {
            this.rules.pool = pool;
            this.forceOverride = null;
        },
        // Persisted "Save my hidden skills" switch. Turning it on drops a manual hidden pick.
        toggleHidden () {
            this.saveHidden = !this.saveHidden;
            if (this.saveHidden && (0, $aizvL.isHiddenSkill)(this.forceOverride)) this.forceOverride = null;
            try {
                localStorage.setItem($6a4a784425705adb$var$HIDDEN_PREF, this.saveHidden ? '1' : '0');
            } catch  {}
        },
        orList: $6a4a784425705adb$var$orList,
        // Persisted GilgameHeart-exclude toggle for the suggestions.
        toggleGgh () {
            this.excludeGgh = !this.excludeGgh;
            try {
                localStorage.setItem($6a4a784425705adb$var$GGH_PREF, this.excludeGgh ? '1' : '0');
            } catch  {}
        },
        nameOfToken: $6a4a784425705adb$var$nameOf,
        copy (text) {
            try {
                navigator.clipboard.writeText(text);
                this.copied = text;
                setTimeout(()=>{
                    if (this.copied === text) this.copied = '';
                }, 1500);
            } catch  {}
        }
    }
};

});
parcelRegister("k0cFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8fda3c51c38cf99$export$2e2bcd8739ae039);
let $e8fda3c51c38cf99$var$script;




let $e8fda3c51c38cf99$var$initialize = ()=>{
    $e8fda3c51c38cf99$var$script = (parcelRequire("2pE0G"));
    if ($e8fda3c51c38cf99$var$script.__esModule) $e8fda3c51c38cf99$var$script = $e8fda3c51c38cf99$var$script.default;
    $e8fda3c51c38cf99$var$script.render = (parcelRequire("5Z3ee")).render;
    $e8fda3c51c38cf99$var$script.__cssModules = {};
    (parcelRequire("4Hdp2")).default($e8fda3c51c38cf99$var$script);
    $e8fda3c51c38cf99$var$script.__scopeId = 'data-v-e528f7';
    $e8fda3c51c38cf99$var$script.__file = "ClassPickerModal.vue";
};
$e8fda3c51c38cf99$var$initialize();
var $e8fda3c51c38cf99$export$2e2bcd8739ae039 = $e8fda3c51c38cf99$var$script;

});
parcelRegister("2pE0G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1c1cf3bb7732d188$export$2e2bcd8739ae039);

var $8Iy0x = parcelRequire("8Iy0x");
var $1c1cf3bb7732d188$export$2e2bcd8739ae039 = {
    name: 'ClassPickerModal',
    mixins: [
        (0, $8Iy0x.default)
    ],
    props: {
        // [{ name, n?, titles?, isMonster?, icon?, val?, emoji?, special?, title?, badge?, badgeTitle?, genders? }],
        // pre-sorted. val overrides the emitted pick value, emoji is a sprite-less fallback,
        // badge is a corner mark (e.g. ✦ for a bonus class). genders (['Male', 'Female']) adds
        // ♂/♀ buttons that emit pick(value, gender); the tile itself emits pick(value).
        classes: {
            type: Array,
            default: ()=>[]
        },
        current: {
            type: String,
            default: ''
        },
        currentGender: {
            type: String,
            default: ''
        },
        heading: {
            type: String,
            default: "\uD83C\uDFC6 Champions by class"
        }
    },
    data () {
        return {
            q: ''
        };
    },
    computed: {
        filtered () {
            const q = this.q.trim().toLowerCase();
            return q ? this.classes.filter((c)=>c.name.toLowerCase().includes(q)) : this.classes;
        }
    },
    mounted () {
        this.$nextTick(()=>{
            if (this.$refs.search) this.$refs.search.focus();
        });
    }
};

});

parcelRegister("5Z3ee", function(module, exports) {

$parcel$export(module.exports, "render", () => $45b527667fa29daf$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $45b527667fa29daf$var$_hoisted_1 = {
    class: "cp",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Pick a class"
};
const $45b527667fa29daf$var$_hoisted_2 = {
    class: "cp-title"
};
const $45b527667fa29daf$var$_hoisted_3 = {
    class: "cp-grid"
};
const $45b527667fa29daf$var$_hoisted_4 = [
    "onClick",
    "title"
];
const $45b527667fa29daf$var$_hoisted_5 = [
    "title"
];
const $45b527667fa29daf$var$_hoisted_6 = [
    "src",
    "alt"
];
const $45b527667fa29daf$var$_hoisted_7 = {
    key: 2,
    class: "cp-tile-emoji"
};
const $45b527667fa29daf$var$_hoisted_8 = {
    class: "cp-tile-name"
};
const $45b527667fa29daf$var$_hoisted_9 = {
    key: 3,
    class: "cp-tile-n"
};
const $45b527667fa29daf$var$_hoisted_10 = {
    key: 4,
    class: "cp-tile-g"
};
const $45b527667fa29daf$var$_hoisted_11 = [
    "title",
    "onClick",
    "onKeydown"
];
const $45b527667fa29daf$var$_hoisted_12 = {
    key: 0,
    class: "cp-empty"
};
function $45b527667fa29daf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay cp-overlay",
        onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $45b527667fa29daf$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "modal-close",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\u2715"),
            (0, $TusQn.createElementVNode)("div", $45b527667fa29daf$var$_hoisted_2, [
                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.heading) + " ", 1),
                _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("span", {
                    class: "cp-sub"
                }, "\u2014 click to pick", -1))
            ]),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                ref: "search",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.q = $event),
                class: "cp-search",
                type: "text",
                placeholder: "Filter\u2026"
            }, null, 512), [
                [
                    (0, $eeJ70.vModelText),
                    $data.q
                ]
            ]),
            (0, $TusQn.createElementVNode)("div", $45b527667fa29daf$var$_hoisted_3, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filtered, (c)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: c.val || c.name,
                        class: (0, $8POXm.normalizeClass)([
                            "cp-tile",
                            {
                                on: (c.val || c.name) === $props.current,
                                mon: c.isMonster,
                                special: c.special
                            }
                        ]),
                        onClick: ($event)=>_ctx.$emit('pick', c.val || c.name),
                        title: c.title || c.name
                    }, [
                        c.badge ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 0,
                            class: "cp-tile-badge",
                            title: c.badgeTitle || ''
                        }, (0, $8POXm.toDisplayString)(c.badge), 9, $45b527667fa29daf$var$_hoisted_5)) : (0, $TusQn.createCommentVNode)("", true),
                        c.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                            key: 1,
                            class: "cp-tile-img",
                            src: c.icon,
                            alt: c.name,
                            onError: _cache[2] || (_cache[2] = ($event)=>$event.target.style.visibility = 'hidden')
                        }, null, 40, $45b527667fa29daf$var$_hoisted_6)) : c.emoji ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $45b527667fa29daf$var$_hoisted_7, (0, $8POXm.toDisplayString)(c.emoji), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("span", $45b527667fa29daf$var$_hoisted_8, (0, $8POXm.toDisplayString)(c.name), 1),
                        c.n != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $45b527667fa29daf$var$_hoisted_9, "\uD83C\uDFC6 " + (0, $8POXm.toDisplayString)(c.n), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        c.genders && c.genders.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $45b527667fa29daf$var$_hoisted_10, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(c.genders, (g)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: g,
                                    role: "button",
                                    tabindex: "0",
                                    class: (0, $8POXm.normalizeClass)([
                                        "cp-g",
                                        {
                                            on: (c.val || c.name) === $props.current && g === $props.currentGender
                                        }
                                    ]),
                                    title: c.name + ' ' + (g === 'Male' ? "\u2642 male" : "\u2640 female"),
                                    onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('pick', c.val || c.name, g), [
                                        "stop"
                                    ]),
                                    onKeydown: (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('pick', c.val || c.name, g), [
                                        "stop",
                                        "prevent"
                                    ]), [
                                        "enter"
                                    ])
                                }, (0, $8POXm.toDisplayString)(g === 'Male' ? "\u2642" : "\u2640"), 43, $45b527667fa29daf$var$_hoisted_11);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ], 10, $45b527667fa29daf$var$_hoisted_4);
                }), 128))
            ]),
            !$options.filtered.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $45b527667fa29daf$var$_hoisted_12, "No classes match \"" + (0, $8POXm.toDisplayString)($data.q) + "\".", 1)) : (0, $TusQn.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("4Hdp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b59317eec8b003$export$2e2bcd8739ae039);
let $36b59317eec8b003$var$NOOP = ()=>{};
var $36b59317eec8b003$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("78F4Z", function(module, exports) {

$parcel$export(module.exports, "fmtDate", () => $532925459c5b97fc$export$d570a62256bab7b8);
$parcel$export(module.exports, "fmtGil", () => $532925459c5b97fc$export$fa62c7f58153bda5);
$parcel$export(module.exports, "classList", () => $532925459c5b97fc$export$11c615ce16f87241);
$parcel$export(module.exports, "champClassList", () => $532925459c5b97fc$export$a762ba70778bf0dd);
$parcel$export(module.exports, "bestWorst", () => $532925459c5b97fc$export$2547827205c0b067);
$parcel$export(module.exports, "classIcon", () => $532925459c5b97fc$export$212a904772d1d31d);
$parcel$export(module.exports, "buildClassAgg", () => $532925459c5b97fc$export$a05840d8251c95b);
$parcel$export(module.exports, "monsterClasses", () => $532925459c5b97fc$export$b87b020bd0a8e032);
$parcel$export(module.exports, "humanClasses", () => $532925459c5b97fc$export$68b683ca35a59522);
$parcel$export(module.exports, "playerFromRecord", () => $532925459c5b97fc$export$b73bf0ca6044aa5d);
$parcel$export(module.exports, "bettingFor", () => $532925459c5b97fc$export$79c1dc4467c8ddc1);
$parcel$export(module.exports, "spanDetailed", () => $532925459c5b97fc$export$e858adc450c1124d);
$parcel$export(module.exports, "GENDER_LOCK", () => $532925459c5b97fc$export$1db2073fb92140e7);
$parcel$export(module.exports, "ordinal", () => $532925459c5b97fc$export$7bb39f879164e4ac);
$parcel$export(module.exports, "classPortrait", () => $532925459c5b97fc$export$664e93535edd9b82);
/**
 * Shared helpers for player data display — used by both PlayerView and
 * PlayerProfileView to avoid duplicating formatting and class-list logic.
 */ const $532925459c5b97fc$export$660310bf9a8597d5 = 'https://luxor-fftbg-assets.s3.amazonaws.com/units/';
function $532925459c5b97fc$export$d570a62256bab7b8(ms) {
    return new Date(ms).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
function $532925459c5b97fc$export$fa62c7f58153bda5(n) {
    const a = Math.abs(n);
    if (a >= 1e6) return +(n / 1e6).toFixed(1) + 'M';
    if (a >= 1e3) return Math.round(n / 1e3) + 'k';
    return '' + Math.round(n);
}
function $532925459c5b97fc$export$11c615ce16f87241(p) {
    const ents = Object.entries(p.classes).sort((a, b)=>b[1][0] - a[1][0]);
    const max = ents.length ? ents[0][1][0] : 1;
    return ents.map(([name, [pl, wo]])=>({
            name: name,
            played: pl,
            won: wo,
            wr: Math.round(wo / pl * 100),
            pct: Math.round(pl / max * 100)
        }));
}
function $532925459c5b97fc$export$a762ba70778bf0dd(p) {
    return Object.entries(p.champClasses || {}).map(([name, a])=>({
            name: name,
            n: a[0]
        })).sort((x, y)=>y.n - x.n);
}
function $532925459c5b97fc$export$2547827205c0b067(p) {
    const cls = $532925459c5b97fc$export$11c615ce16f87241(p).filter((c)=>c.played >= 20);
    if (cls.length < 2) return null;
    const byWr = [
        ...cls
    ].sort((a, b)=>b.wr - a.wr);
    return {
        best: byWr[0],
        worst: byWr[byWr.length - 1]
    };
}
function $532925459c5b97fc$export$212a904772d1d31d(cls, classAgg) {
    const ag = classAgg && classAgg[cls] || [
        0,
        0
    ];
    return $532925459c5b97fc$export$660310bf9a8597d5 + cls + (ag[0] === 0 && ag[1] === 0 ? '' : ag[0] > 0 ? 'M' : 'F') + '.gif';
}
function $532925459c5b97fc$export$a05840d8251c95b(players) {
    const agg = {};
    for (const p of players){
        if (!p.champClasses) continue;
        for(const cls in p.champClasses){
            const a = p.champClasses[cls];
            agg[cls] = agg[cls] || [
                0,
                0
            ];
            agg[cls][0] += a[1]; // male
            agg[cls][1] += a[2]; // female
        }
    }
    return agg;
}
function $532925459c5b97fc$export$b87b020bd0a8e032(classAgg) {
    return Object.keys(classAgg).filter((c)=>classAgg[c][0] === 0 && classAgg[c][1] === 0).sort();
}
function $532925459c5b97fc$export$68b683ca35a59522(classAgg) {
    return Object.keys(classAgg).filter((c)=>classAgg[c][0] > 0 || classAgg[c][1] > 0).sort();
}
function $532925459c5b97fc$export$b73bf0ca6044aa5d(name, record) {
    return {
        name: name,
        played: record.played,
        won: record.won,
        winRate: record.winRate,
        classes: record.classes || {},
        champ: record.champ || 0,
        champDef: record.champDef || 0,
        champReign: record.champReign || 0,
        firstChamp: record.firstChamp || null,
        lastChamp: record.lastChamp || null,
        champClasses: record.champClasses || null,
        champSigns: record.champSigns || null,
        champColors: record.champColors || null,
        champYears: record.champYears || null,
        mqDates: record.mqDates || null,
        tw: record.tw || 0
    };
}
function $532925459c5b97fc$export$79c1dc4467c8ddc1(bettingStats, name) {
    const norm = (s)=>s.toLowerCase().replace(/[\s_]+/g, ' ').trim();
    return bettingStats[name] || bettingStats[Object.keys(bettingStats).find((k)=>norm(k) === norm(name))] || null;
}
function $532925459c5b97fc$export$e858adc450c1124d(p) {
    const a = new Date(p.firstChamp), b = new Date(p.lastChamp);
    let y = b.getFullYear() - a.getFullYear(), m = b.getMonth() - a.getMonth(), d = b.getDate() - a.getDate();
    if (d < 0) {
        m -= 1;
        d += new Date(b.getFullYear(), b.getMonth(), 0).getDate();
    }
    if (m < 0) {
        y -= 1;
        m += 12;
    }
    const parts = [];
    if (y) parts.push(y + 'y');
    if (m) parts.push(m + 'mo');
    if (d || !parts.length) parts.push(d + 'd');
    return parts.join(' ');
}
function $532925459c5b97fc$export$e473b1e54f52a381(wr) {
    return {
        width: Math.max(2, Math.min(100, (wr - 35) * (100 / 30))) + '%'
    };
}
const $532925459c5b97fc$export$1db2073fb92140e7 = {
    Dancer: 'F',
    Bard: 'M'
};
function $532925459c5b97fc$export$7bb39f879164e4ac(n) {
    const s = [
        'th',
        'st',
        'nd',
        'rd'
    ], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
function $532925459c5b97fc$export$664e93535edd9b82(name, gender) {
    if (gender === 'Monster') return name + '.gif';
    if ($532925459c5b97fc$export$1db2073fb92140e7[name]) return name + $532925459c5b97fc$export$1db2073fb92140e7[name] + '.gif';
    return name + (gender || 'M') + '.gif';
}

});

parcelRegister("aizvL", function(module, exports) {

$parcel$export(module.exports, "fetchDump", () => $77f7219dea53b4fb$export$a13938813a034e08);
$parcel$export(module.exports, "fetchChampStreak", () => $77f7219dea53b4fb$export$e483f1bd807e1164);
$parcel$export(module.exports, "parseNumber", () => $77f7219dea53b4fb$export$6bf0e8cf8e1d780d);
$parcel$export(module.exports, "bustDump", () => $77f7219dea53b4fb$export$c47c8cb78885f769);
$parcel$export(module.exports, "parseLines", () => $77f7219dea53b4fb$export$a50caf788bd43399);
$parcel$export(module.exports, "parseSkills", () => $77f7219dea53b4fb$export$ee7d69e88ed7aaee);
$parcel$export(module.exports, "parseLastUnit", () => $77f7219dea53b4fb$export$aaad12b7e3cae177);
$parcel$export(module.exports, "ownsToken", () => $77f7219dea53b4fb$export$a0c7cd6361e455cf);
$parcel$export(module.exports, "HIDDEN_SKILLS", () => $77f7219dea53b4fb$export$273e90ca5a6e6be1);
$parcel$export(module.exports, "isHiddenSkill", () => $77f7219dea53b4fb$export$443d8678be6e6a9);
$parcel$export(module.exports, "skillModifier", () => $77f7219dea53b4fb$export$6dffcde0437cd214);
$parcel$export(module.exports, "formatModifier", () => $77f7219dea53b4fb$export$1d57e301c779ecc7);
// Live per-player data from the FFTBG file dumps on fftbattleground.com.
//
// These are public plain-text files, one per user, holding the player's CURRENT
// state (owned skills, last unit fielded, gil, snub streak, bonuses, allegiance)
// — the live layer our static career snapshots (playerIndex etc.) don't have.
//
// We read them through our OWN Netlify Function (`/.netlify/functions/fftbg-proxy`),
// which fetches the origin over plain HTTP server-side and hands it back same-origin
// over HTTPS. Two reasons: the browser hard-blocks an http:// fetch from our HTTPS
// page (mixed content), and the origin's HTTPS intermittently 521s (Cloudflare can't
// reach the origin's flapping :443; its :80 stays up) while plain HTTP works — the
// server-side HTTP hop routes around both.
// Same-origin also drops our dependence on the host's /fftbg/ CORS whitelist.
// (Prod-only: the Function doesn't run under the local Parcel dev server, exactly as
// the old direct fetch was prod-only — the CORS whitelist was wiznaib.us, not
// localhost. Callers already treat the resulting null as "no data".)
//
// Convention (like the rest of src/lib): the parsers are PURE and data-injected
// (the genTokens map is passed in, never imported here) so they're node-testable
// without network or JSON-import. Only `fetchDump` touches the network. The one
// data import, twitchHandles, is a generated .js module (not JSON) precisely so
// the node tests still run import-attribute-free; dumpHandle takes it as an
// overridable default param.

var $bTyhe = parcelRequire("bTyhe");

var $giVeM = parcelRequire("giVeM");
const $77f7219dea53b4fb$var$PROXY = '/.netlify/functions/fftbg-proxy';
const $77f7219dea53b4fb$export$46152e92461d98ca = Object.freeze([
    'userskills',
    'lastchar',
    'gil',
    'snubstreak',
    'skillbonus',
    'classbonus',
    'allegiance',
    'prestige',
    'prestige/mark'
]);
// In-flight + resolved cache, keyed `category:lowercased-name`. The files are
// case-insensitive on the host, and we canonicalize to lowercase everywhere, so
// the lowercased key dedupes "Luxor" / "luxor" to one fetch.
const $77f7219dea53b4fb$var$cache = new Map();
function $77f7219dea53b4fb$export$5e641c14b31a5dcc(name, overrides = (0, $giVeM.default)) {
    const s = String(name || '').trim();
    const key = s.toLowerCase().replace(/[\s_]+/g, '_').replace(/^_+|_+$/g, '');
    return overrides[key] || s.replace(/ /g, '_');
}
function $77f7219dea53b4fb$export$a13938813a034e08(category, name) {
    const handle = $77f7219dea53b4fb$export$5e641c14b31a5dcc(name);
    if (!handle) return Promise.resolve(null);
    const key = category + ':' + handle.toLowerCase();
    if ($77f7219dea53b4fb$var$cache.has(key)) return $77f7219dea53b4fb$var$cache.get(key);
    const p = (async ()=>{
        try {
            // no-cache: always revalidate so bustDump() actually re-reads. (The proxy
            // sets Cache-Control: no-cache too; the old direct fetch needed this to beat
            // the browser's heuristic caching off the upstream's bare Last-Modified.)
            const res = await fetch(`${$77f7219dea53b4fb$var$PROXY}?category=${encodeURIComponent(category)}&handle=${encodeURIComponent(handle)}`, {
                cache: 'no-cache'
            });
            if (!res.ok) return null;
            const text = await res.text();
            // Guard against a 200 that isn't a real dump. Under the local Parcel dev
            // server the proxy path has no Function, so it falls through to the SPA's
            // index.html (HTTP 200) — and a proxy/CDN error page could do the same in
            // prod. Dumps are plain text and never start with '<', so leading markup
            // means "no data" (parse it as a unit and the card renders raw HTML).
            if (/^\s*</.test(text)) return null;
            return text;
        } catch  {
            return null;
        }
    })();
    $77f7219dea53b4fb$var$cache.set(key, p);
    return p;
}
async function $77f7219dea53b4fb$export$e483f1bd807e1164() {
    try {
        // no-cache for the same reason as fetchDump: always revalidate, so a long
        // reign's stale streak doesn't linger into the next tournament's badge.
        const res = await fetch(`${$77f7219dea53b4fb$var$PROXY}?file=streak`, {
            cache: 'no-cache'
        });
        if (!res.ok) return null;
        return $77f7219dea53b4fb$export$6bf0e8cf8e1d780d(await res.text());
    } catch  {
        return null;
    }
}
function $77f7219dea53b4fb$export$c47c8cb78885f769(category, name) {
    const handle = $77f7219dea53b4fb$export$5e641c14b31a5dcc(name);
    if (handle) $77f7219dea53b4fb$var$cache.delete(category + ':' + handle.toLowerCase());
}
function $77f7219dea53b4fb$export$a50caf788bd43399(text) {
    return String(text == null ? '' : text).replace(/\r/g, '').split('\n').map((l)=>l.trim()).filter(Boolean);
}
function $77f7219dea53b4fb$export$6bf0e8cf8e1d780d(text) {
    const n = parseInt(String(text == null ? '' : text).trim(), 10);
    return Number.isFinite(n) ? n : null;
}
function $77f7219dea53b4fb$export$ee7d69e88ed7aaee(text) {
    return $77f7219dea53b4fb$export$a50caf788bd43399(text).map((line)=>{
        const m = line.match(/^(.*?)(~*)$/);
        return {
            token: m[1],
            step: m[2].length
        };
    });
}
function $77f7219dea53b4fb$export$c929005dfa6dc8b0(skills, tokenMap) {
    const map = tokenMap || {};
    return skills.map((s)=>{
        const meta = map[s.token];
        return {
            ...s,
            name: meta && meta.name || s.token.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
            category: meta && meta.category || '',
            rarity: meta && meta.rarity || 'common'
        };
    });
}
function $77f7219dea53b4fb$export$aaad12b7e3cae177(text) {
    if (!$77f7219dea53b4fb$export$a50caf788bd43399(text).length) return null;
    return (0, $bTyhe.parseUnit)(text);
}
function $77f7219dea53b4fb$export$a0c7cd6361e455cf(skills, token) {
    const want = String(token || '').toLowerCase();
    return (skills || []).some((s)=>s.token.toLowerCase() === want);
}
// --- buyrandom skill-modifier ladder ----------------------------------------
// The penalty a skill applies to your character generation, keyed by its
// `userskills` tilde step. VALIDATED against the bot's own `!skills` output
// (IdioSyncr4zy "full house": step 1→-1/-3 … 4→-4/-10, ≥5→cannot use; the
// designated skillbonus skill → +2/+5). EXP penalty = -step; the priority
// penalties are a fixed 4-rung table (NOT linear: -3,-5,-7,-10).
const $77f7219dea53b4fb$var$PRIORITY_BY_STEP = {
    1: -3,
    2: -5,
    3: -7,
    4: -10
};
const $77f7219dea53b4fb$export$273e90ca5a6e6be1 = Object.freeze([
    'RaidBoss',
    'MathSkill',
    'EquipPerfume',
    'Doppelganger',
    'Teleport2',
    'BladeGrasp'
]);
const $77f7219dea53b4fb$var$HIDDEN_SET = new Set($77f7219dea53b4fb$export$273e90ca5a6e6be1.map((s)=>s.toLowerCase()));
function $77f7219dea53b4fb$export$443d8678be6e6a9(token) {
    return $77f7219dea53b4fb$var$HIDDEN_SET.has(String(token || '').toLowerCase());
}
function $77f7219dea53b4fb$export$6dffcde0437cd214(step, isSkillBonus = false) {
    if (isSkillBonus) return {
        exp: 2,
        priority: 5
    };
    if (!step) return null;
    if (step >= 5) return {
        cannotUse: true
    };
    return {
        exp: -step,
        priority: $77f7219dea53b4fb$var$PRIORITY_BY_STEP[step]
    };
}
function $77f7219dea53b4fb$export$1d57e301c779ecc7(mod) {
    if (!mod) return '';
    if (mod.cannotUse) return 'cannot use';
    const sign = (n)=>(n > 0 ? '+' : '') + n;
    return `${sign(mod.exp)} EXP, ${sign(mod.priority)} priority`;
}

});
parcelRegister("giVeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdeab9f1f4705265$export$2e2bcd8739ae039);
// GENERATED by tools/buildBettingStats.mjs — do not edit. Canon player key → real
// Twitch login, only where the in-game (space-mangled) name can't recover it.
var $bdeab9f1f4705265$export$2e2bcd8739ae039 = {
    "1ply": "1ply_",
    "5head": "5head___",
    "aarrgh": "aarrgh_",
    "adam_dane": "adam_dane_",
    "aelmarkin": "aelmarkin_",
    "afriken": "Afriken_",
    "agrias": "agrias__",
    "agrias_oaks": "agrias_oaks_",
    "aigis": "Aigis____",
    "alagara": "Alagara_",
    "ally_mcbeal": "Ally_McBeal_",
    "almost_sane": "almost__sane",
    "aloevera": "aloevera_____",
    "alstruction": "Alstruction_",
    "alyony": "Alyony_",
    "alys": "alys______",
    "ancelot": "ancelot__",
    "ancelote": "ancelote_",
    "anomandaris": "Anomandaris__",
    "aquios": "Aquios_",
    "aranea": "aranea_____",
    "aranea_highwind": "aranea_highwind__",
    "arc_x": "arc_x_",
    "arispejal": "arispejal_",
    "artea": "Artea_",
    "average_gamer_dad": "Average_Gamer_Dad_",
    "ayleth": "ayleth___",
    "b0dge": "b0dge__",
    "b2b3s": "b2b3s_",
    "b_u_r_z_u_m": "b_u_r_z_u_m_",
    "bad_kenny": "Bad_Kenny_",
    "baikentv": "BaikenTV_",
    "bald_potato": "bald_potato_",
    "bambados": "bambados_",
    "bannana_slug": "bannana_slug_",
    "basch_fon_ronsenburg": "Basch_fon__Ronsenburg",
    "based_x": "based__x",
    "bbgj": "bbgj_",
    "bearrier": "bearrier_",
    "billybones1": "billybones1_",
    "blinkbaby": "Blinkbaby_",
    "blorpy": "blorpy_",
    "bo_vice": "bo_vice_",
    "botocorderola": "BotoCorDeRola_",
    "bp_9": "BP___9",
    "brother": "brother_______",
    "buttersheep": "Buttersheep_",
    "cactus_tony": "cactus_tony_",
    "call_me_sean": "Call__me__Sean",
    "camboy": "Camboy__",
    "candy_hansel": "candy_hansel_",
    "canton": "CANTON__",
    "captain_boomer": "Captain_Boomer__",
    "carlgamer": "CarlGamer_",
    "cementdrinker": "cementdrinker_",
    "chemical_x": "chemical___x",
    "cherryonion": "cherryonion_",
    "chinese_takeout": "Chinese_Takeout_",
    "chiyome_mochizuki": "chiyome_mochizuki_",
    "churromancer": "churromancer_",
    "clarkkent": "ClarkKent_",
    "cloudzin": "cloudzin_",
    "clover_days": "Clover__Days",
    "clyde_arrowny": "clyde_arrowny_",
    "codydotexe": "codydotexe_",
    "coledot": "coledot_",
    "cool_beans": "cool____beans",
    "cora_dora": "cora__dora",
    "corrin": "corrin__",
    "courtesy_f1ush": "Courtesy_F1ush_",
    "cranka": "Cranka_",
    "crckt": "crckt_",
    "cropolite": "cropolite__",
    "cross_x": "Cross_X_",
    "cyclone_joker": "Cyclone__Joker",
    "dadnificent": "dadnificent_",
    "daitenshi": "Daitenshi__",
    "dancingdrone": "dancingdrone_",
    "dandydragon": "dandydragon_",
    "dankswiss": "dankswiss_",
    "dantalian": "Dantalian_",
    "dark_h3art": "Dark_H3art_",
    "daucus": "DAUCUS_",
    "daveb": "daveb_",
    "david_hustle": "david__hustle",
    "deathzlicer": "DeathzLiceR_",
    "defal7": "Defal7_",
    "demi_fiend": "demi_fiend_",
    "dentata": "Dentata_",
    "dishonestjackson": "dishonestjackson_",
    "docrad": "Docrad_",
    "doctor_zyd": "doctor_zyd_",
    "draco_ch": "draco__ch",
    "ebonroc": "ebonroc_",
    "eccen_tric": "eccen_tric_",
    "elboyboy": "elboyboy_",
    "elicsgo": "elicsgo_",
    "elionfaith": "elionfaith_",
    "elusiveone": "ElusiveOne_",
    "exvi": "Exvi_",
    "eyepoor": "Eyepoor_",
    "falchii": "Falchii_",
    "farseli": "Farseli_",
    "fart_breath": "Fart__Breath",
    "fasc": "fasc_",
    "feel_the_heat": "feel_the_heat__",
    "fieress": "Fieress_",
    "fire": "fire_________________",
    "fire_rat": "fire__rat",
    "fish_warrior": "Fish_Warrior_",
    "fncardascia": "FNCardascia_",
    "formalhault": "formalhault_",
    "fosst": "Fosst_",
    "frances": "frances_____",
    "frank_80": "frank__80",
    "ftk": "ftk___",
    "g33k": "g33k__",
    "g_31": "G__31",
    "gabillis": "Gabillis_",
    "garouz": "GarouZ_",
    "geonn": "geonn_",
    "geordil": "geordil_",
    "ginchiyo_tachibana": "ginchiyo_tachibana___",
    "gingerjesus": "GingerJesus_",
    "glaciate": "Glaciate_",
    "goboshi": "goboshi_",
    "gomes_89": "Gomes_89_",
    "gouda_nuff": "Gouda_Nuff_",
    "gourry": "Gourry_",
    "graveyardsmash": "graveyardsmash_",
    "gtzc": "gtzc_",
    "guntz": "Guntz__",
    "hamsterdd": "hamsterdd_",
    "hashtagrob": "HashtagRob_",
    "havluv": "havluv_",
    "hazard_zone": "Hazard_Zone_",
    "hellishmist": "HellishMist_",
    "herlock_sholmes": "herlock_sholmes___",
    "hermione_granger": "hermione_granger____",
    "hewf": "Hewf_",
    "hogwarts_student": "hogwarts_student_",
    "honestmistake": "honestmistake_",
    "hyena_x": "Hyena_x_",
    "hyvi": "hyvi_",
    "iceflambe": "iceflambe_",
    "id_stim": "id__stim",
    "imanemogirl": "imanemogirl_",
    "imbajoe": "Imbajoe_",
    "ini": "ini_",
    "irha": "irha_",
    "isvar": "Isvar_",
    "its_practice": "Its_Practice_",
    "izlude": "izlude_",
    "j_bone": "j_bone__",
    "jack_smith_usa": "Jack_Smith_USA_",
    "jack_the_ripper": "jack__the__ripper",
    "jackaree": "jackaree_",
    "jaik": "jaik__",
    "jaisyn": "jaisyn_",
    "jaldun": "jaldun_",
    "jam": "Jam__",
    "jaosen": "Jaosen_",
    "jeanne_d_arc": "jeanne_d__arc",
    "jeffgoldblum": "JeffGoldblum_",
    "jehanne": "Jehanne____",
    "jel_ly": "jel_ly_",
    "jjohn": "jjohn__",
    "joeynumbers": "JoeyNumbers_",
    "johnny_oh": "johnny_oh_",
    "jumanjiraya": "jumanjiraya_",
    "jurrasicore": "jurrasicore_",
    "justitia": "justitia____",
    "k8nmitosis": "K8nMitosis_",
    "kaillith": "Kaillith_",
    "kazuhira_miller_msf": "Kazuhira_Miller__MSF",
    "kc_danger": "kc__danger",
    "kebit": "kebit_",
    "keezu": "KeeZu__",
    "keh": "keh___",
    "khelor": "khelor_",
    "kikuson": "kikuson_",
    "killer_bijuu": "killer____bijuu",
    "killerducky": "KillerDucky_",
    "king_sephiroth": "king__sephiroth",
    "klausdieelfe": "KlausDieElfe_",
    "kookem": "Kookem_",
    "kre4t0r": "kre4t0r_",
    "kuhja": "Kuhja_",
    "kuma_tora": "Kuma_tora_",
    "kyle_lewis_sison": "kyle__lewis_sison",
    "kyver": "Kyver_",
    "lagzuzu": "Lagzuzu_",
    "lars": "lars___________________",
    "laughing_mad": "laughing__mad",
    "lavian": "Lavian___",
    "layerp": "layerP_",
    "lazymoosehead": "Lazymoosehead_",
    "le_dawg": "Le__Dawg",
    "leoschneider": "leoschneider_",
    "lezales": "lezales_",
    "lif2": "LIF2_",
    "lilithtaiyoo": "lilithtaiyoo_",
    "llight": "LLight__",
    "lootacris": "Lootacris_",
    "lostintheivy": "lostintheivy_",
    "lucas_cs": "lucas__cs",
    "luckyiam": "luckyiam_",
    "luckyshot21": "Luckyshot21_",
    "maakur": "maakur_",
    "maestro_gear": "Maestro__Gear",
    "manc0": "manc0_",
    "march": "march_",
    "maria_rita": "maria_rita___",
    "math_skill": "math__skill",
    "matt_on_twitch": "matt_on_twitch_",
    "mattrick": "Mattrick_",
    "mavin": "Mavin___",
    "megazorde": "megazorde__",
    "meowyster": "Meowyster_",
    "merlin_the_wizard": "merlin_the_wizard__",
    "miisaee": "Miisaee_",
    "mindleaker": "MindLeaker__",
    "mistersteak": "mistersteak_",
    "monakw": "monakW_",
    "monsterjesus": "MonsterJesus_",
    "moussx": "moussx_",
    "mpzyy": "mpzyy_",
    "mr_cata": "mr_cata_",
    "mrgooey": "mrgooey_",
    "mrmaniac": "mrmaniac_",
    "mrmorewood": "Mrmorewood_",
    "mrsmilez": "MrSmileZ_",
    "mushufasa": "Mushufasa_",
    "mythical3": "MythicaL3_",
    "n1ch": "n1ch__",
    "nanaki_xiii": "nanaki__XIII",
    "neoxianwu": "NeoXianWu_",
    "nieblv": "Nieblv_",
    "nmn": "nMn_",
    "nok": "nok____",
    "noobiestream": "noobiestream_",
    "norgath": "norgath_",
    "nova_buster": "NOVA_BUSTER_",
    "noxah": "Noxah__",
    "od1um": "od1um__",
    "officialfaceless": "officialfaceless_",
    "ogyeezus": "ogyeezus_",
    "ohickey": "ohickey_",
    "ohmalleycat": "OhMalleyCat_",
    "old_overholt": "old_overholt_",
    "omally": "Omally_",
    "onyxceptable": "onyxceptable_",
    "overscan": "overscan_",
    "oxenford": "Oxenford_",
    "parallelcrusader": "ParallelCrusader_",
    "paumir": "paumir_",
    "pelerin": "pelerin_",
    "pendarr": "Pendarr_",
    "pepos": "pepos_",
    "phalanx": "Phalanx______",
    "phalanx_formation": "Phalanx_Formation_",
    "pineapplez13": "PIneaPplez13_",
    "pldn": "PLDN__",
    "pocketsizedbug": "PocketsizedBug_",
    "pogchampion_lol": "pogchampion_lol_",
    "pokrew": "pokrew_",
    "pomelux": "pomelux_",
    "poppyj": "poppyj_",
    "portugal": "Portugal_",
    "potato_pete": "potato_pete__",
    "prince_rogers_nelson": "prince_rogers_nelson_",
    "proper_noun": "proper__noun__",
    "protog1": "ProtoG1_",
    "puraisu": "puraisu_",
    "qpan": "Qpan_",
    "quiet_lion": "Quiet__Lion",
    "quintassential": "quintassential_",
    "rad": "rad_______",
    "ralph_dragon": "Ralph__Dragon",
    "ramza": "Ramza_____",
    "rasend": "Rasend_",
    "raybz": "RayBz_",
    "razzeo": "Razzeo_",
    "rdelucas": "rdelucas_",
    "reaversfall": "Reaversfall_",
    "red_lancer": "red__lancer",
    "reddwind": "Reddwind_",
    "reltz": "Reltz_",
    "rename": "rename_",
    "rengald": "Rengald_",
    "rethera": "Rethera_",
    "revvy": "revvy_",
    "rg0n": "rg0n_",
    "ricard_highwind": "ricard_highwind_",
    "rileydrinksbeer": "rileydrinksbeer_",
    "roachfacekillah": "roachfacekillah_",
    "roomless": "roomless_",
    "roseblood": "roseblood__",
    "ruminative": "ruminative_",
    "ryu_tempest": "Ryu_Tempest_",
    "sagata": "Sagata_",
    "scarlet_winter": "Scarlet_Winter_",
    "scr4ppy": "scr4ppy__",
    "semiconductor": "semiconductor__",
    "senaahh": "Senaahh_",
    "sephirya": "Sephirya_",
    "shaveandahaircut": "ShaveAndAHaircut_",
    "sherlock_holmes": "sherlock_holmes_____",
    "shingenuchiha": "shingenuchiha_",
    "shinra": "shinra____",
    "shivo": "Shivo_",
    "shs": "shs_",
    "shurikk3n": "Shurikk3n_",
    "silver64": "silver64_",
    "silver_core": "Silver__Core",
    "sir_whitey": "Sir_Whitey_",
    "sirbates": "SirBates_",
    "sirphobos": "sirphobos_",
    "skoompa": "skoompa_",
    "slestrange": "SLeStrange_",
    "smaps": "Smaps_",
    "smiler": "smiler____",
    "soasm": "soasm_",
    "solja": "solja__",
    "spicycherrysoda": "SpicyCherrySoda_",
    "spleen_eater": "spleen_eater_",
    "spray_k": "spray_k_",
    "squideater": "squideater_",
    "sqwejly": "sqwejly_",
    "stankzappa": "stankzappa_",
    "star0cean": "Star0cean_",
    "starocean": "StarOcean__",
    "steelpaladin": "SteelPaladin_",
    "steve_dave": "steve__dave",
    "stoneforge": "stoneforge_",
    "stonesoul": "Stonesoul_",
    "stormblade": "stormblade___",
    "summoner": "summoner__",
    "supa_ttv": "SUPA__TTV",
    "survivel_samuel": "survivel_samuel_",
    "sweaty_toast": "Sweaty_Toast_",
    "swetik": "Swetik_",
    "swillin": "swillin_",
    "sylver_fox": "Sylver_foX_",
    "synthrave": "synthrave_",
    "sytra": "Sytra_",
    "tacmoss": "TacMoss_",
    "taskan_skylander": "taskan___skylander",
    "tda23": "tda23_",
    "teamarket": "TeaMarket_",
    "tech_priest": "tech_priest_",
    "tekn1k": "TeKn1k_",
    "tenkei": "Tenkei_",
    "terminally_chill": "Terminally____Chill",
    "the_engi": "the_engi_",
    "the_gambler": "The_Gambler_",
    "the_king_ant": "The_King_Ant_",
    "the_voice": "The_Voice_",
    "thereck24": "thereck24_",
    "thranduil": "Thranduil_",
    "time_mage": "time__mage",
    "toby_guile": "toby__guile",
    "trajer": "Trajer_",
    "trez": "trez_",
    "trippy_haze": "trippy_haze_",
    "tripsin": "TripSin_",
    "tsyber": "Tsyber_",
    "ttk": "ttk___",
    "uberpikachu": "UberPikachu_",
    "ulster": "Ulster_",
    "ultimecia": "ultimecia__",
    "unphocus": "UnPhocus_",
    "utengar": "Utengar_",
    "vaihne": "Vaihne_",
    "valdemarr": "Valdemarr_",
    "valyro": "Valyro_",
    "vamp_daddy": "vamp__daddy",
    "vinnyboi": "vinnyboi__",
    "vsilence": "VSilence_",
    "w_de_wrande": "w_de_wrande_",
    "wasabi_ger": "wasabi__GER",
    "wawawasi": "wawawasi_",
    "withoutreason": "WithoutReason_",
    "wolfdd": "wolfdd_",
    "woodstock_hobbs": "Woodstock_hobbs_",
    "wottle": "wottle_",
    "wrin": "Wrin_",
    "wwwdotcom": "wwwdotcom_",
    "x_applesauce": "x__Applesauce__",
    "xenon1te": "Xenon1te_",
    "yoshimoto": "Yoshimoto_",
    "yukiko_amagi": "Yukiko_Amagi_",
    "z_tk": "z__TK",
    "zenaga": "zenaga_",
    "zenova": "Zenova_",
    "zephyrbear": "ZephyrBear_",
    "ziegfriedz": "ziegfriedz_",
    "zukute": "Zukute_",
    "zwirrfinst": "Zwirrfinst_"
};

});


parcelRegister("j4wl1", function(module, exports) {

$parcel$export(module.exports, "activeModifiers", () => $de2779b934c7bbd2$export$58b6cc66cb100704);
$parcel$export(module.exports, "STANDARD_CLASSES", () => $de2779b934c7bbd2$export$94bec5bbca5aefcb);
$parcel$export(module.exports, "classBonus", () => $de2779b934c7bbd2$export$4a9a86325dd76d6);
// The "active modifiers" a player's owned skills apply to their character roll —
// the computable slice of the bot's !skills line. Mirrors the breakdown we
// reverse-engineered: each owned skill at buyrandom step ≥1 carries a penalty
// (or "cannot use" at ≥5), the designated skillbonus skill gives +2/+5, and the
// masked "Hidden Skill" carries the step from the prestige/mark dump. The
// monster-tier / snub / recency adjustments aren't here — those are bot-internal.

var $aizvL = parcelRequire("aizvL");
function $de2779b934c7bbd2$export$58b6cc66cb100704(skills, skillBonus, mark, nameOf, monsterTierOf) {
    const name = (tok)=>nameOf ? nameOf(tok) : tok;
    const bonusKey = String(skillBonus || '').toLowerCase();
    const out = [], tierStep = {};
    for (const s of skills || []){
        const isBonus = s.token.toLowerCase() === bonusKey;
        const tier = monsterTierOf && monsterTierOf(s.token);
        if (!isBonus && (tier === 'elite' || tier === 'strong')) {
            tierStep[tier] = Math.max(tierStep[tier] || 0, s.step || 0);
            continue;
        }
        const mod = (0, $aizvL.skillModifier)(s.step, isBonus);
        if (mod) out.push({
            token: s.token,
            name: name(s.token),
            step: s.step,
            mod: mod,
            modText: (0, $aizvL.formatModifier)(mod),
            isBonus: isBonus,
            hidden: false
        });
    }
    for (const tier of [
        'elite',
        'strong'
    ]){
        const mod = (0, $aizvL.skillModifier)(tierStep[tier] || 0);
        if (mod) out.push({
            token: '_' + tier,
            name: tier === 'elite' ? 'Elite Monster' : 'Strong Monster',
            step: tierStep[tier],
            mod: mod,
            modText: (0, $aizvL.formatModifier)(mod),
            isBonus: false,
            hidden: false
        });
    }
    const k = Math.max(0, Math.floor(Number(mark) || 0));
    if (k >= 1) {
        const mod = (0, $aizvL.skillModifier)(k);
        out.push({
            token: '_hidden',
            name: 'Hidden Skill',
            step: k,
            mod: mod,
            modText: (0, $aizvL.formatModifier)(mod),
            isBonus: false,
            hidden: true
        });
    }
    out.sort((a, b)=>b.step - a.step);
    return out;
}
const $de2779b934c7bbd2$export$94bec5bbca5aefcb = [
    'Squire',
    'Chemist',
    'Knight',
    'Archer',
    'Monk',
    'Priest',
    'Wizard',
    'TimeMage',
    'Summoner',
    'Thief',
    'Mediator',
    'Oracle',
    'Geomancer',
    'Lancer',
    'Samurai',
    'Ninja',
    'Calculator',
    'Bard',
    'Dancer',
    'Mime'
];
const $de2779b934c7bbd2$var$spaced = (s)=>String(s).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
function $de2779b934c7bbd2$export$4a9a86325dd76d6(classbonusLines, skillBonusToken, isMonster) {
    const excluded = new Set((classbonusLines || []).map((c)=>String(c).toLowerCase().replace(/[^a-z0-9]/g, '')));
    const classes = $de2779b934c7bbd2$export$94bec5bbca5aefcb.filter((c)=>!excluded.has(c.toLowerCase())).map($de2779b934c7bbd2$var$spaced);
    if (skillBonusToken && isMonster && isMonster(skillBonusToken)) classes.push($de2779b934c7bbd2$var$spaced(skillBonusToken));
    const amount = 2 * Math.floor((classbonusLines || []).length / 5) + 1;
    return {
        amount: amount,
        classes: classes
    };
}

});

parcelRegister("gNwy4", function(module, exports) {

$parcel$export(module.exports, "cmdToken", () => $c3aa78620907eebf$export$c53d7d0b7153b272);
$parcel$export(module.exports, "bonusClassTokens", () => $c3aa78620907eebf$export$91142442959776b6);
$parcel$export(module.exports, "pickClass", () => $c3aa78620907eebf$export$cabda979f666926f);
$parcel$export(module.exports, "buildEntry", () => $c3aa78620907eebf$export$ac255afc4064ba51);
$parcel$export(module.exports, "forcedSlots", () => $c3aa78620907eebf$export$e7525e50c64f8476);
$parcel$export(module.exports, "pruneSameSlotBans", () => $c3aa78620907eebf$export$f314addc5f047323);
$parcel$export(module.exports, "buildMonsterEntry", () => $c3aa78620907eebf$export$ab4c469b17283fa4);
$parcel$export(module.exports, "RULE_POOLS", () => $c3aa78620907eebf$export$f4bfd584d8a50b12);
$parcel$export(module.exports, "pickRuleSkill", () => $c3aa78620907eebf$export$223f26c9cf74ba8b);
$parcel$export(module.exports, "fitToLimit", () => $c3aa78620907eebf$export$4a014c261188cbf8);
$parcel$export(module.exports, "questTargets", () => $c3aa78620907eebf$export$3cb472c25b2c97fd);
$parcel$export(module.exports, "pickQuestTarget", () => $c3aa78620907eebf$export$233e3cf129722fc1);
$parcel$export(module.exports, "rankMonsters", () => $c3aa78620907eebf$export$c11648e746fb3ce6);
// FFTBG !fight entry advisor — assemble affordable, priority-aware entry commands.
//
// Costs: 100G per human parameter (class / sex / skill / -exclude), max 4 params,
// and class is required once you use 2+. Monsters are a SOLO entry priced by tier
// (200 normal / 500 strong / 800 elite) and take no other params.
//
// Admission priority (from the rules doc): base 30, +10 entering with no params,
// +5 using your current skill bonus, +5 excluding GilgameHeart, −10 per UNCOMMON
// forced skill (or strong monster), −15 per RARE forced skill (or elite monster /
// hidden skill). The +40 snub / +20 sub / recency / recent-admission factors are
// per-user state we can't see, so callers surface those as caveats.

var $j4wl1 = parcelRequire("j4wl1");
const $c3aa78620907eebf$var$RARE_HIT = -15;
const $c3aa78620907eebf$var$UNCOMMON_HIT = -10;
const $c3aa78620907eebf$var$MONSTER_COST = {
    elite: 800,
    strong: 500,
    normal: 200
};
function $c3aa78620907eebf$export$c53d7d0b7153b272(s) {
    return String(s == null ? '' : s).replace(/\s+/g, '').toLowerCase();
}
function $c3aa78620907eebf$export$91142442959776b6(classbonusLines) {
    const excluded = new Set((classbonusLines || []).map($c3aa78620907eebf$export$c53d7d0b7153b272));
    return (0, $j4wl1.STANDARD_CLASSES).filter((c)=>!excluded.has($c3aa78620907eebf$export$c53d7d0b7153b272(c)));
}
function $c3aa78620907eebf$export$cabda979f666926f(classTokens, rank) {
    let best = '', bestScore = -Infinity;
    for (const c of classTokens || []){
        const s = rank ? rank(c) ?? -Infinity : 0;
        if (s > bestScore) {
            bestScore = s;
            best = c;
        }
    }
    return best;
}
function $c3aa78620907eebf$export$ac255afc4064ba51({ className: className = '', gender: gender = '', forcedSkills: forcedSkills = [], excludes: excludes = [], usesSkillBonus: usesSkillBonus = false, rarityOf: rarityOf = ()=>'common' } = {}) {
    const params = [];
    if (className) params.push($c3aa78620907eebf$export$c53d7d0b7153b272(className));
    if (gender) params.push($c3aa78620907eebf$export$c53d7d0b7153b272(gender)); // 'male'/'female' — costs 100G, no priority effect
    for (const s of forcedSkills)params.push($c3aa78620907eebf$export$c53d7d0b7153b272(s));
    for (const e of excludes)params.push('-' + $c3aa78620907eebf$export$c53d7d0b7153b272(e));
    let priority = 30;
    if (!params.length) priority += 10;
    if (usesSkillBonus) priority += 5;
    if (excludes.some((e)=>$c3aa78620907eebf$export$c53d7d0b7153b272(e) === 'gilgameheart')) priority += 5;
    for (const s of forcedSkills){
        const r = rarityOf(s);
        if (r === 'rare') priority += $c3aa78620907eebf$var$RARE_HIT;
        else if (r === 'uncommon') priority += $c3aa78620907eebf$var$UNCOMMON_HIT;
    }
    // 100G per parameter, PLUS the GilgameHeart-exclude bribe: excluding it costs an
    // extra 500G (600G total with the param) to buy the +5 priority.
    const cost = params.length * 100 + (excludes.some((e)=>$c3aa78620907eebf$export$c53d7d0b7153b272(e) === 'gilgameheart') ? 500 : 0);
    return {
        command: '!fight' + (params.length ? ' ' + params.join(' ') : ''),
        cost: cost,
        priority: priority,
        paramCount: params.length
    };
}
const $c3aa78620907eebf$export$918e30a4bcf4e8d9 = new Set([
    'skillset',
    'support',
    'reaction',
    'movement',
    'accessory'
]);
const $c3aa78620907eebf$export$499a91ee0ae5eec0 = {
    throwitem: 'Item',
    monstertalk: 'Talk Skill'
};
function $c3aa78620907eebf$export$e7525e50c64f8476(token, category) {
    const slots = $c3aa78620907eebf$export$918e30a4bcf4e8d9.has(category) ? [
        category
    ] : [];
    if (token && $c3aa78620907eebf$export$499a91ee0ae5eec0[$c3aa78620907eebf$export$c53d7d0b7153b272(token)] && !slots.includes('skillset')) slots.push('skillset');
    return slots;
}
function $c3aa78620907eebf$export$f314addc5f047323(bans, forced, categoryOf) {
    const filled = (Array.isArray(forced) ? forced : [
        forced
    ]).filter((c)=>$c3aa78620907eebf$export$918e30a4bcf4e8d9.has(c));
    if (!filled.length) return bans || [];
    return (bans || []).filter((b)=>!filled.includes(categoryOf(b)));
}
function $c3aa78620907eebf$export$ab4c469b17283fa4(monsterToken, tier) {
    return {
        command: '!fight ' + $c3aa78620907eebf$export$c53d7d0b7153b272(monsterToken),
        cost: $c3aa78620907eebf$var$MONSTER_COST[tier] || $c3aa78620907eebf$var$MONSTER_COST.normal,
        priority: 30 + (tier === 'elite' ? $c3aa78620907eebf$var$RARE_HIT : tier === 'strong' ? $c3aa78620907eebf$var$UNCOMMON_HIT : 0),
        paramCount: 1
    };
}
const $c3aa78620907eebf$export$a3b802940f0852f4 = 4;
const $c3aa78620907eebf$export$f4bfd584d8a50b12 = [
    'usable',
    'offcd',
    'nopenalty'
];
function $c3aa78620907eebf$export$223f26c9cf74ba8b(candidates, pool = 'usable') {
    for (const c of candidates || []){
        if (!(c.delta > 0)) continue;
        const tilded = c.step > 0 && !c.isBonus;
        if (pool === 'nopenalty') {
            if (tilded || c.rarity && c.rarity !== 'common') continue;
        } else if (pool === 'offcd') {
            if (tilded) continue;
        } else if (c.step >= 5 && !c.isBonus) continue;
        return c.token;
    }
    return '';
}
function $c3aa78620907eebf$export$4a014c261188cbf8({ className: className = '', gender: gender = '', genderRequired: genderRequired = false, forcedSkills: forcedSkills = [], excludes: excludes = [] } = {}) {
    let g = gender;
    const forced = [
        ...forcedSkills
    ], ex = [
        ...excludes
    ], dropped = [];
    const isGgh = (e)=>$c3aa78620907eebf$export$c53d7d0b7153b272(e) === 'gilgameheart';
    const count = ()=>(className ? 1 : 0) + (g ? 1 : 0) + forced.length + ex.length;
    while(count() > $c3aa78620907eebf$export$a3b802940f0852f4){
        const ban = ex.findIndex((e)=>!isGgh(e));
        if (ban >= 0) {
            dropped.push({
                kind: 'ban',
                value: ex.splice(ban, 1)[0]
            });
            continue;
        }
        if (g && !genderRequired) {
            dropped.push({
                kind: 'gender',
                value: g
            });
            g = '';
            continue;
        }
        const ggh = ex.findIndex(isGgh);
        if (ggh >= 0) {
            dropped.push({
                kind: 'bribe',
                value: ex.splice(ggh, 1)[0]
            });
            continue;
        }
        if (forced.length) {
            dropped.push({
                kind: 'skill',
                value: forced.pop()
            });
            continue;
        }
        break;
    }
    return {
        gender: g,
        forcedSkills: forced,
        excludes: ex,
        dropped: dropped
    };
}
function $c3aa78620907eebf$export$3cb472c25b2c97fd(remaining, { humanClass: humanClass, monsterToken: monsterToken }) {
    const out = [];
    for (const label of remaining || []){
        const [, name, sym] = String(label).match(/^(.*?)\s*([♂♀])?$/);
        const gender = sym === "\u2642" ? 'Male' : sym === "\u2640" ? 'Female' : '';
        const cls = humanClass(name);
        if (cls) {
            out.push({
                kind: 'class',
                cls: cls,
                gender: gender,
                label: label
            });
            continue;
        }
        const tok = gender ? '' : monsterToken(name);
        if (tok) out.push({
            kind: 'monster',
            token: tok,
            label: label
        });
    }
    return out;
}
function $c3aa78620907eebf$export$233e3cf129722fc1(targets, { isBonus: isBonus = ()=>false, rank: rank = ()=>0 } = {}) {
    const humans = (targets || []).filter((t)=>t.kind === 'class');
    const pool = humans.length ? humans : targets || [];
    let best = null, bestKey = null;
    for (const t of pool){
        const key = [
            t.kind === 'class' && isBonus(t.cls) ? 1 : 0,
            rank(t) ?? -Infinity
        ];
        if (!best || key[0] > bestKey[0] || key[0] === bestKey[0] && key[1] > bestKey[1]) {
            best = t;
            bestKey = key;
        }
    }
    return best;
}
function $c3aa78620907eebf$export$625f99c88a839233(skills, tierOf) {
    const out = {
        elite: 0,
        strong: 0
    };
    for (const s of skills || []){
        const t = tierOf(s.token);
        if (t === 'elite' || t === 'strong') out[t] = Math.max(out[t], s.step || 0);
    }
    return out;
}
function $c3aa78620907eebf$export$c11648e746fb3ce6(skills, { tierOf: tierOf, winRate: winRate, modifier: modifier, format: format = ()=>'', gil: gil = Infinity, skillBonus: skillBonus = '' } = {}) {
    const cd = $c3aa78620907eebf$export$625f99c88a839233(skills, tierOf);
    const bonusKey = $c3aa78620907eebf$export$c53d7d0b7153b272(skillBonus);
    const rows = [];
    for (const s of skills || []){
        const tier = tierOf(s.token);
        if (!tier) continue;
        const isBonus = !!bonusKey && $c3aa78620907eebf$export$c53d7d0b7153b272(s.token) === bonusKey;
        const step = tier === 'normal' ? isBonus ? 0 : s.step || 0 : cd[tier];
        const mod = modifier(step, false);
        const usable = !(mod && mod.cannotUse);
        const e = $c3aa78620907eebf$export$ab4c469b17283fa4(s.token, tier);
        if (isBonus) e.priority += 5;
        if (usable && mod && mod.priority) e.priority += mod.priority;
        const wr = winRate(s.token);
        rows.push({
            ...e,
            token: s.token,
            tier: tier,
            winRate: wr == null ? null : wr,
            step: step,
            usable: usable,
            affordable: e.cost <= gil,
            isBonus: isBonus,
            freesIn: usable ? 0 : step - 4,
            modText: mod ? format(mod) : ''
        });
    }
    const ok = (r)=>r.usable && r.affordable;
    return rows.sort((a, b)=>ok(b) - ok(a) || (b.winRate ?? -1) - (a.winRate ?? -1));
}

});

parcelRegister("3lf9e", function(module, exports) {

$parcel$export(module.exports, "resolveHighlightedUsers", () => $26ef154bb7d3b887$export$eb5027da8eb58fe5);
$parcel$export(module.exports, "loadPrefs", () => $26ef154bb7d3b887$export$ac1159ec55100cbb);
$parcel$export(module.exports, "savePrefs", () => $26ef154bb7d3b887$export$e5abf71cde65ac0d);
$parcel$export(module.exports, "markAnnouncementSeen", () => $26ef154bb7d3b887$export$bb3968ac2995dc5a);
// Per-browser settings persisted to localStorage. Loaded once on app mount,
// written back whenever the settings modal mutates them.
//
// Versioned key so the shape can evolve — bump the version and add a
// migration here if/when the schema changes.
const $26ef154bb7d3b887$var$STORAGE_KEY = 'wiznaibus.prefs.v1';
const $26ef154bb7d3b887$export$263939444ea3beea = Object.freeze({
    // When true, the three baked-in highlighted users (Luxor + friends) are
    // not shown in the entrants/snubs callouts — and also don't fire the
    // start-of-tournament announcement modal.
    hideDefaultHighlights: false,
    // When true, the bracket section is hidden — the team grid renders
    // immediately at the top of the page.
    hideBracket: false,
    // User-added names to highlight in the entrants/snubs callouts. Each
    // entry is { name: string, color: string } — color is a CSS color
    // string (the `<input type="color">` produces hex like "#ff0000").
    customHighlights: [],
    // When true, the big start-of-tournament announcement modal is
    // suppressed even when there would be matches to announce.
    disableAnnouncements: false,
    // Notification sounds (lib/sounds.js). `soundSet` picks the synth palette;
    // `soundEvents` is a per-event on/off map. All default OFF (opt-in). Migrated
    // from the old `newTournamentSound` boolean on load (see loadPrefs).
    soundSet: 'chime',
    soundEvents: {
        newTournament: false,
        matchUp: false,
        win: false,
        loss: false,
        champ: false
    },
    // Notification volume multiplier: 1 = 100% (each set's tuned level), 0 = muted,
    // up to 2 = 200% (louder). Applied in lib/sounds.js.
    soundVolume: 1,
    // When true, unit cards in the team grid render expanded (detailed) by
    // default instead of compact. The per-card click toggle still works.
    expandedCards: false,
    showWinRates: false,
    // When true (default), the live-match bracket sprites occasionally play their
    // armed attack animation. Always suppressed under prefers-reduced-motion.
    attackAnims: true,
    // When true (default), the bracket page shows the 🎉 "just happened" strip of
    // recent titles, quest completions and long reigns (RecentTicker.vue).
    showTicker: true,
    // Twitch username for the "My Profile" quick-access button (👤 in the top
    // bar). When set, also auto-highlights on the bracket in gold.
    myUsername: '',
    myColor: '#ffd700',
    // Tournament IDs whose start-of-tournament announcement has already
    // been dismissed in this browser. Capped at the most recent 50 to
    // keep localStorage bounded.
    seenAnnouncements: [],
    // Feature spotlight IDs the user has already seen (one-time "what's new" popups).
    seenUpdates: [],
    // Active quest/achievement goal for the player profile tracker.
    // Shape: { type: 'quest'|'achievement', id: string } or null.
    activeGoal: null,
    // Saved goal progress for the bracket widget: written by the profile page, and rebuilt
    // by the bracket page whenever newer data is out (lib/goalRefresh.js); src = the data
    // build it came from. Shape: { name, remaining: string[], status, src? } or null.
    goalInfo: null,
    // When true, the bracket page goal widget is hidden. Cleared when the
    // user sets a new goal on the profile page.
    goalDismissed: false
});
const $26ef154bb7d3b887$var$SEEN_CAP = 50;
const $26ef154bb7d3b887$export$5664e25ba5dcdba7 = [
    'luxordoesntframe',
    'yoimbear',
    'firstodie'
];
const $26ef154bb7d3b887$export$4b15acc9c405c4bd = '#ffd700';
function $26ef154bb7d3b887$export$eb5027da8eb58fe5(prefs) {
    const byName = new Map();
    const norm = (s)=>s.trim().toLowerCase().replace(/_/g, ' ');
    // "Who are you" username — auto-highlighted in gold (lowest priority, so a
    // custom entry or a matching default overrides its color).
    if (prefs && prefs.myUsername) {
        const me = norm(prefs.myUsername);
        if (me) byName.set(me, {
            name: me,
            color: prefs.myColor || $26ef154bb7d3b887$export$4b15acc9c405c4bd
        });
    }
    if (prefs && !prefs.hideDefaultHighlights) for (const n of $26ef154bb7d3b887$export$5664e25ba5dcdba7)byName.set(n, {
        name: n,
        color: $26ef154bb7d3b887$export$4b15acc9c405c4bd
    });
    for (const u of prefs && prefs.customHighlights || []){
        const n = norm(u.name || '');
        if (n) byName.set(n, {
            name: n,
            color: u.color || ''
        });
    }
    return [
        ...byName.values()
    ];
}
function $26ef154bb7d3b887$export$ac1159ec55100cbb() {
    try {
        const raw = localStorage.getItem($26ef154bb7d3b887$var$STORAGE_KEY);
        if (!raw) return {
            ...$26ef154bb7d3b887$export$263939444ea3beea
        };
        const parsed = JSON.parse(raw);
        // Migrate the old single newTournamentSound boolean → soundEvents map.
        const soundEvents = {
            ...$26ef154bb7d3b887$export$263939444ea3beea.soundEvents,
            ...parsed.soundEvents || {},
            ...parsed.newTournamentSound != null && parsed.soundEvents == null ? {
                newTournament: !!parsed.newTournamentSound
            } : {}
        };
        // Coerce/clamp the volume multiplier so a bad stored value can't override the
        // sane default (the spread above would otherwise let e.g. 5 or "loud" through).
        const sv = Number(parsed.soundVolume);
        return {
            ...$26ef154bb7d3b887$export$263939444ea3beea,
            ...parsed,
            soundSet: parsed.soundSet || $26ef154bb7d3b887$export$263939444ea3beea.soundSet,
            soundEvents: soundEvents,
            soundVolume: Number.isFinite(sv) ? Math.max(0, Math.min(2, sv)) : 1,
            customHighlights: Array.isArray(parsed.customHighlights) ? parsed.customHighlights.map((u)=>({
                    name: u.name || '',
                    color: u.color || '#ffd700'
                })) : [],
            seenAnnouncements: Array.isArray(parsed.seenAnnouncements) ? parsed.seenAnnouncements.slice(-$26ef154bb7d3b887$var$SEEN_CAP) : []
        };
    } catch  {
        return {
            ...$26ef154bb7d3b887$export$263939444ea3beea
        };
    }
}
function $26ef154bb7d3b887$export$e5abf71cde65ac0d(prefs) {
    try {
        localStorage.setItem($26ef154bb7d3b887$var$STORAGE_KEY, JSON.stringify(prefs));
    } catch  {
    // localStorage can be unavailable (private browsing, quota, etc.) —
    // we silently no-op rather than crash the page.
    }
}
function $26ef154bb7d3b887$export$bb3968ac2995dc5a(seen, tournamentId) {
    if (!tournamentId) return seen || [];
    if ((seen || []).includes(tournamentId)) return seen;
    const next = [
        ...seen || [],
        tournamentId
    ];
    return next.length > $26ef154bb7d3b887$var$SEEN_CAP ? next.slice(-$26ef154bb7d3b887$var$SEEN_CAP) : next;
}

});

parcelRegister("4ErgZ", function(module, exports) {

$parcel$export(module.exports, "SEASON_BOUNDARIES", () => $36300db6ec554065$export$369e42392258fbe6);
$parcel$export(module.exports, "SEASON_COUNT", () => $36300db6ec554065$export$dd81bbc189f1f480);
$parcel$export(module.exports, "seasonOf", () => $36300db6ec554065$export$38cb79ba6ba16066);
$parcel$export(module.exports, "seasonRange", () => $36300db6ec554065$export$cf9a778ca6ac806d);
// ToC season boundaries + bucketing.
//
// FFTBG groups tournaments into "seasons", each ending in a Tournament of
// Champions. seasons.txt (on fftbattleground.com — a different origin, no CORS,
// so the browser can't read it) lists the tournament ID that STARTS each season,
// one per line. A tournament ID is a ms timestamp, so season N spans
// [SEASON_BOUNDARIES[N-1], SEASON_BOUNDARIES[N]). These line up 1:1 with the live
// API's `Season` field (verified to the ms against the founding champion's
// timestamp: API champion #1's defeat ~= SEASON_BOUNDARIES[0]).
//
// Small + append-only (a new number a few times a year), so it lives inline here
// as the single source of truth — imported by both the app and the backfill
// tools. Refresh after each new ToC opens a season:
//   node tools/fetchSeasons.mjs        (rewrites the array between the @seasons markers)
const $36300db6ec554065$export$369e42392258fbe6 = [
    // @seasons:start (generated by tools/fetchSeasons.mjs)
    1577633138990,
    1582396517081,
    1587230639860,
    1592673680707,
    1598721195449,
    1604772879703,
    1610216767654,
    1615659717512,
    1621706876023,
    1627755319614,
    1634408366432,
    1642880107661,
    1650738965219,
    1657996516400,
    1665859729710,
    1674328189525,
    1683397584477,
    1692469840654,
    1699729987022,
    1707593496317,
    1716057602089,
    1725129293438,
    1734205714347,
    1742063175423,
    1750530467294,
    1758997553148,
    1766950119136,
    1775932369711,
    1786299769004
];
const $36300db6ec554065$export$dd81bbc189f1f480 = $36300db6ec554065$export$369e42392258fbe6.length;
function $36300db6ec554065$export$38cb79ba6ba16066(id) {
    for(let n = $36300db6ec554065$export$369e42392258fbe6.length; n >= 1; n--){
        if (id >= $36300db6ec554065$export$369e42392258fbe6[n - 1]) return n;
    }
    return 1;
}
function $36300db6ec554065$export$cf9a778ca6ac806d(n) {
    return [
        $36300db6ec554065$export$369e42392258fbe6[n - 1],
        $36300db6ec554065$export$369e42392258fbe6[n] ?? Infinity
    ];
}
function $36300db6ec554065$export$9f3243785c0e87f2(n) {
    return $36300db6ec554065$export$369e42392258fbe6[n - 1];
}

});

parcelRegister("1dDjn", function(module, exports) {

$parcel$export(module.exports, "VIP_HUMANS", () => $0e357fd057a67cb7$export$2a44535ae5e6bf9d);
$parcel$export(module.exports, "VIP_MONSTERS", () => $0e357fd057a67cb7$export$8cb758d0e7ded733);
$parcel$export(module.exports, "VIP_CLASSES", () => $0e357fd057a67cb7$export$ab4c4ffc611a552e);
$parcel$export(module.exports, "ONE_GENDER", () => $0e357fd057a67cb7$export$e2ff12119314a459);
$parcel$export(module.exports, "VIP_GENDERED_TOTAL", () => $0e357fd057a67cb7$export$f916ef9352fd41dc);
$parcel$export(module.exports, "vipStandings", () => $0e357fd057a67cb7$export$65c0a52c42fbd9f5);
$parcel$export(module.exports, "rankBy", () => $0e357fd057a67cb7$export$fc6934a143d103e5);
$parcel$export(module.exports, "vipRowFor", () => $0e357fd057a67cb7$export$c63e154bb3c185d7);
$parcel$export(module.exports, "vipMissing", () => $0e357fd057a67cb7$export$f17ebd1fa1587060);
// The VIP Quest: FFTBG's season-long race to champion the most DIFFERENT classes. Gender
// doesn't matter and monsters count, so there are 75 to collect. Everything here reads the
// champion history the site already ships (champHistory.json: r = reigns
// [startMs, color, len, [[name, class, g, sign]×4]], p = player → reign indices), so the
// standings need no build step. The community's tracker is meatb.one/fftbg/leaderboard.html;
// on 2026-10-01 these counts matched its Season 29 board everywhere except the reigning
// champion, whom it adds only once they're dethroned. A reign counts for the season it was
// dethroned in, as FFTBG files it (see reignEnds).
const $0e357fd057a67cb7$export$2a44535ae5e6bf9d = [
    'Squire',
    'Chemist',
    'Knight',
    'Archer',
    'Monk',
    'Priest',
    'Wizard',
    'Time Mage',
    'Summoner',
    'Thief',
    'Mediator',
    'Oracle',
    'Geomancer',
    'Lancer',
    'Samurai',
    'Ninja',
    'Calculator',
    'Dancer',
    'Bard',
    'Mime'
];
const $0e357fd057a67cb7$export$8cb758d0e7ded733 = [
    'Chocobo',
    'Black Chocobo',
    'Red Chocobo',
    'Goblin',
    'Black Goblin',
    'Gobbledeguck',
    'Bomb',
    'Grenade',
    'Explosive',
    'Red Panther',
    'Coeurl',
    'Vampire',
    'Pisco Demon',
    'Squidraken',
    'Mindflayer',
    'Skeleton',
    'Draugr',
    'Reaper',
    'Ghoul',
    'Ghost',
    'Revenant',
    'Floating Eye',
    'Ahriman',
    'Plague',
    'Juravis',
    'Iron Hawk',
    'Cockatrice',
    'Swine',
    'Porky',
    'Wild Boar',
    'Dryad',
    'Treant',
    'Taiju',
    'Bull Demon',
    'Minotaur',
    'Sekhret',
    'Malboro',
    'Ochu',
    'Great Malboro',
    'Behemoth',
    'King Behemoth',
    'Dark Behemoth',
    'Dragon',
    'Blue Dragon',
    'Red Dragon',
    'Holy Dragon',
    'Wyvern',
    'Hydra',
    'Tiamat',
    'Archaic Demon',
    'Ultima Demon',
    'Apanda',
    'Byblos',
    'Steel Giant',
    'Serpentarius'
];
const $0e357fd057a67cb7$export$ab4c4ffc611a552e = [
    ...$0e357fd057a67cb7$export$2a44535ae5e6bf9d,
    ...$0e357fd057a67cb7$export$8cb758d0e7ded733
];
const $0e357fd057a67cb7$var$HUMAN = new Set($0e357fd057a67cb7$export$2a44535ae5e6bf9d), $0e357fd057a67cb7$var$KNOWN = new Set($0e357fd057a67cb7$export$ab4c4ffc611a552e);
const $0e357fd057a67cb7$export$e2ff12119314a459 = {
    Bard: 'M',
    Dancer: 'F'
};
const $0e357fd057a67cb7$export$f916ef9352fd41dc = $0e357fd057a67cb7$export$2a44535ae5e6bf9d.reduce((n, c)=>n + ($0e357fd057a67cb7$export$e2ff12119314a459[c] ? 1 : 2), 0); // 38
const $0e357fd057a67cb7$var$norm = (s)=>String(s).toLowerCase().replace(/[\s_]+/g, ' ').trim();
function $0e357fd057a67cb7$export$4dd8549fdc2ca02c(units, players) {
    const out = new Map(), freeUnits = units.map((_, i)=>i), freePlayers = [];
    for (const p of players){
        const k = freeUnits.findIndex((i)=>$0e357fd057a67cb7$var$norm(units[i][0]) === $0e357fd057a67cb7$var$norm(p));
        if (k < 0) freePlayers.push(p);
        else {
            out.set(p, units[freeUnits[k]]);
            freeUnits.splice(k, 1);
        }
    }
    if (freePlayers.length === 1 && freeUnits.length === 1) out.set(freePlayers[0], units[freeUnits[0]]);
    return out;
}
function $0e357fd057a67cb7$export$c946d7cd4182641f(champHistory, reignMeta) {
    const r = champHistory.r, wd = reignMeta && reignMeta.wd || [];
    return r.map((_, i)=>i === 0 ? Infinity : r[i - 1][0] - (wd[i - 1] || 0));
}
function $0e357fd057a67cb7$export$84b70e6fa89d2da1(reignMeta) {
    const cn = reignMeta && reignMeta.cn || [];
    const newest = cn.findIndex((x)=>x > 0), out = new Set();
    if (newest >= 0) {
        for(let i = newest + 1; i < cn.length; i++)if (!cn[i]) out.add(i);
    }
    return out;
}
function $0e357fd057a67cb7$export$65c0a52c42fbd9f5(champHistory, season, seasonOf, reignMeta) {
    const { r: reigns, p: players } = champHistory;
    const ends = season ? $0e357fd057a67cb7$export$c946d7cd4182641f(champHistory, reignMeta) : null;
    const blips = $0e357fd057a67cb7$export$84b70e6fa89d2da1(reignMeta);
    const owners = new Map(); // reign index → the players credited with it
    for(const name in players)for (const i of players[name]){
        if (blips.has(i) || season && seasonOf(ends[i]) !== season) continue;
        const a = owners.get(i);
        if (a) a.push(name);
        else owners.set(i, [
            name
        ]);
    }
    const rows = new Map();
    for (const [i, names] of owners){
        const [start, , len, units] = reigns[i];
        for (const [name, u] of $0e357fd057a67cb7$export$4dd8549fdc2ca02c(units, names)){
            if (!$0e357fd057a67cb7$var$KNOWN.has(u[1])) continue;
            let row = rows.get(name);
            if (!row) rows.set(name, row = {
                name: name,
                cls: {}
            });
            const c = row.cls[u[1]] || (row.cls[u[1]] = {
                titles: 0,
                first: start,
                best: 0,
                g: new Set()
            });
            c.titles++;
            if (start < c.first) c.first = start;
            if (len > c.best) c.best = len;
            c.g.add(u[2]);
        }
    }
    for (const row of rows.values()){
        let humans = 0, monsters = 0, gendered = 0, titles = 0, reachedAt = 0;
        for(const cls in row.cls){
            const c = row.cls[cls];
            titles += c.titles;
            if (c.first > reachedAt) reachedAt = c.first;
            if (!$0e357fd057a67cb7$var$HUMAN.has(cls)) {
                monsters++;
                continue;
            }
            humans++;
            gendered += $0e357fd057a67cb7$export$e2ff12119314a459[cls] ? 1 : (c.g.has('M') ? 1 : 0) + (c.g.has('F') ? 1 : 0);
        }
        Object.assign(row, {
            count: humans + monsters,
            humans: humans,
            monsters: monsters,
            gendered: gendered,
            titles: titles,
            reachedAt: reachedAt
        });
    }
    return [
        ...rows.values()
    ].sort($0e357fd057a67cb7$export$fc6934a143d103e5('count'));
}
const $0e357fd057a67cb7$export$fc6934a143d103e5 = (key)=>(a, b)=>b[key] - a[key] || a.reachedAt - b.reachedAt || a.name.localeCompare(b.name);
function $0e357fd057a67cb7$export$c63e154bb3c185d7(standings, name) {
    const k = $0e357fd057a67cb7$var$norm(name || '');
    return k && standings.find((r)=>$0e357fd057a67cb7$var$norm(r.name) === k) || null;
}
function $0e357fd057a67cb7$export$f17ebd1fa1587060(row) {
    return $0e357fd057a67cb7$export$ab4c4ffc611a552e.filter((c)=>!(row && row.cls[c]));
}

});

parcelRegister("53jI0", function(module, exports) {

$parcel$export(module.exports, "kitProfile", () => $3adc855665833911$export$9d400f033c84cf7);
$parcel$export(module.exports, "unitDefenses", () => $3adc855665833911$export$809b0781260f0abc);
$parcel$export(module.exports, "vipCandidates", () => $3adc855665833911$export$48e5683ffa470d60);
// The VIP helper behind My Mods: of the classes you still need this season, which has an edge
// on the champion you'd face? The edge is elemental, read from the data the unit cards use.
// A kit's side comes from what it deals: a human class's own skillset (each ability weighted
// by its roll chance) or a monster's intrinsic skills, each ability's "Element:", and whether
// its damage is Faith magic. A champion unit's side comes from what it takes double from or
// shrugs off: gear "Absorb / Half / Weak / Cancel" clauses, and the class's own "Effect:"
// line in its tip (Treant "Weak Fire", Steel Giant "Null Holy, Dark … Permanent Innocent").
// It's a heuristic and says why; the battle sim, on demand in the modal, is the reality check.
// Pure and data-injected, so it runs in node tests.

var $79bVW = parcelRequire("79bVW");
const $3adc855665833911$export$9c5f1319a811382e = 0.5;
const $3adc855665833911$export$4effacddd8cda406 = 0.5;
const $3adc855665833911$export$95fbbb0911343a7b = 3;
function $3adc855665833911$export$a6a5d4cdbd5147dc(info) {
    const s = String(info || '');
    const effect = (s.match(/Effect:\s*(.*)$/) || [])[1] || '';
    return {
        element: (s.match(/Element:\s*([A-Za-z]+)/) || [])[1] || '',
        damage: /\bDamage\b/.test(effect),
        faith: /Faith\(/.test(effect),
        terrain: /\bTerrain:/.test(s)
    };
}
function $3adc855665833911$export$9d400f033c84cf7(abilities, abilityInfo) {
    const acc = {};
    let dmg = 0, faithDmg = 0;
    for (const { name: name, chance: chance } of abilities){
        const t = $3adc855665833911$export$a6a5d4cdbd5147dc(abilityInfo[name]);
        if (!t.damage) continue;
        const c = Math.max(0, Math.min(1, chance)) * (t.terrain ? $3adc855665833911$export$4effacddd8cda406 : 1);
        dmg += c;
        if (t.faith) faithDmg += c;
        if (!t.element) continue;
        const e = acc[t.element] || (acc[t.element] = {
            miss: 1,
            faith: true,
            names: [],
            w: 0
        });
        e.miss *= 1 - c;
        e.faith = e.faith && t.faith;
        e.w += c;
        e.names.push(name);
    }
    return $3adc855665833911$var$finishKit(acc, dmg, faithDmg);
}
function $3adc855665833911$var$finishKit(acc, dmg, faithDmg) {
    const elements = {};
    let main = '', mainW = 0;
    for (const [el, e] of Object.entries(acc)){
        elements[el] = {
            p: 1 - e.miss,
            faith: e.faith,
            names: e.names,
            w: e.w,
            miss: e.miss
        };
        if (e.w > mainW) {
            main = el;
            mainW = e.w;
        }
    }
    return {
        elements: elements,
        dmg: dmg,
        faithDmg: faithDmg,
        main: dmg > 0 && mainW >= dmg / 2 ? main : ''
    };
}
function $3adc855665833911$export$aa13e117c84c123a(a, b) {
    const acc = {};
    for (const k of [
        a,
        b
    ])for (const [el, e] of Object.entries(k.elements)){
        const m = acc[el] || (acc[el] = {
            miss: 1,
            faith: true,
            names: [],
            w: 0
        });
        m.miss *= e.miss;
        m.faith = m.faith && e.faith;
        m.w += e.w;
        m.names.push(...e.names);
    }
    return $3adc855665833911$var$finishKit(acc, a.dmg + b.dmg, a.faithDmg + b.faithDmg);
}
function $3adc855665833911$export$809b0781260f0abc(unit, itemInfo, tip) {
    const sets = {
        weak: new Set(),
        half: new Set(),
        absorb: new Set(),
        cancel: new Set()
    };
    const statuses = new Set();
    const take = (text)=>{
        const effect = (String(text || '').match(/Effect:\s*(.*)$/) || [])[1];
        if (!effect) return;
        const p = (0, $79bVW.parseItemElements)('Effect: ' + effect.replace(/\bNull\b/g, 'Cancel'));
        for (const k of Object.keys(sets))for (const e of p[k])sets[k].add(e);
        for (const clause of effect.split(';')){
            const m = clause.trim().match(/^(?:Permanent|Initial)\s+(.*)$/);
            if (m) for (const s of m[1].split(/,\s*/))statuses.add(s.trim().replace(/\.$/, ''));
        }
    };
    for (const slot of [
        'Mainhand',
        'Offhand',
        'Head',
        'Armor',
        'Accessory'
    ])take(itemInfo[unit[slot]]);
    take(tip);
    const innates = (String(tip || '').match(/Innate:\s*([^.]*)\./) || [])[1] || '';
    return {
        name: unit.Name,
        cls: unit.Class,
        ...sets,
        innocent: statuses.has('Innocent'),
        float: statuses.has('Float') || /\bLevitate\b/.test(innates)
    };
}
function $3adc855665833911$export$354df6c61864f0c5(kit, defenders) {
    const hits = [], blocks = [];
    for (const d of defenders){
        let hit = null;
        for (const [el, k] of Object.entries(kit.elements)){
            if (k.p < $3adc855665833911$export$9c5f1319a811382e || !d.weak.has(el) || d.half.has(el) || d.absorb.has(el) || d.cancel.has(el)) continue;
            if (k.faith && d.innocent || el === 'Earth' && d.float) continue;
            if (!hit || k.p > hit.p) hit = {
                unit: d.name,
                cls: d.cls,
                element: el,
                p: k.p
            };
        }
        if (hit) {
            hits.push(hit);
            continue;
        }
        if (kit.main && (d.absorb.has(kit.main) || d.cancel.has(kit.main))) blocks.push({
            unit: d.name,
            cls: d.cls,
            why: d.absorb.has(kit.main) ? 'absorb' : 'null',
            element: kit.main
        });
        else if (d.innocent && kit.dmg > 0 && kit.faithDmg / kit.dmg >= 0.6) blocks.push({
            unit: d.name,
            cls: d.cls,
            why: 'innocent'
        });
    }
    return {
        hits: hits,
        blocks: blocks,
        score: hits.length - blocks.length
    };
}
function $3adc855665833911$export$48e5683ffa470d60({ needed: needed, isMonster: isMonster, gated: gated = ()=>false, owned: owned, kitOf: kitOf, strength: strength, defenders: defenders, skillsets: skillsets = [], ownSkillset: ownSkillset = ()=>'', edgeWeight: edgeWeight = $3adc855665833911$export$95fbbb0911343a7b }) {
    const rows = [];
    for (const cls of needed){
        const monster = isMonster(cls);
        if (monster && !owned.has(cls)) continue;
        const kit = kitOf(cls);
        let edge = $3adc855665833911$export$354df6c61864f0c5(kit, defenders), skill = null;
        if (!monster) {
            // The owned skillset that adds the most edge; ties go to the one that does best on the class.
            let best = null;
            for (const s of skillsets){
                if (s.name === ownSkillset(cls)) continue;
                const e = $3adc855665833911$export$354df6c61864f0c5($3adc855665833911$export$aa13e117c84c123a(kit, s.kit), defenders);
                const gain = e.score - edge.score;
                if (gain <= 0) continue;
                const rank = s.rank(cls);
                if (!best || gain > best.gain || gain === best.gain && rank > best.rank) best = {
                    token: s.token,
                    name: s.name,
                    gain: gain,
                    rank: rank,
                    edge: e
                };
            }
            if (best) {
                edge = best.edge;
                skill = {
                    token: best.token,
                    name: best.name,
                    gain: best.gain
                };
            }
        }
        const base = strength(cls) ?? 50;
        rows.push({
            cls: cls,
            kind: monster ? 'monster' : 'class',
            gated: monster && gated(cls),
            base: base,
            edge: edge,
            skill: skill,
            score: base + edgeWeight * edge.score
        });
    }
    return rows.sort((a, b)=>b.gated - a.gated || b.score - a.score || b.base - a.base || a.cls.localeCompare(b.cls));
}

});

parcelRegister("764dZ", function(module, exports) {

$parcel$export(module.exports, "classKit", () => $52ac5ee390ad58d1$export$c3f67333561b7dc4);
$parcel$export(module.exports, "ownSkillset", () => $52ac5ee390ad58d1$export$f72a38f3194a1e57);
$parcel$export(module.exports, "skillsetKit", () => $52ac5ee390ad58d1$export$99645f636e6d87e9);
$parcel$export(module.exports, "defensesOf", () => $52ac5ee390ad58d1$export$5c4e4a79f82587f7);
// vipAdvisor bound to the bundled game data: each class's kit (a human's skillset with its
// roll chances, a monster's intrinsic skills), each forceable skillset's kit as a secondary,
// and the champion units' defenses from their gear and class tips. The pure logic and its
// tests are in vipAdvisor.js.

var $5Pzz7 = parcelRequire("5Pzz7");

var $1BkfY = parcelRequire("1BkfY");

var $hYk3h = parcelRequire("hYk3h");

var $fMXIO = parcelRequire("fMXIO");

var $64X3q = parcelRequire("64X3q");

var $ay2NQ = parcelRequire("ay2NQ");

var $adzaT = parcelRequire("adzaT");

var $53jI0 = parcelRequire("53jI0");
let $52ac5ee390ad58d1$var$ABILITY = null, $52ac5ee390ad58d1$var$ITEM = null;
const $52ac5ee390ad58d1$var$abilityInfo = ()=>$52ac5ee390ad58d1$var$ABILITY || ($52ac5ee390ad58d1$var$ABILITY = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($fMXIO))).abilities.map((a)=>[
            a.name,
            a.info
        ])));
const $52ac5ee390ad58d1$var$itemInfo = ()=>$52ac5ee390ad58d1$var$ITEM || ($52ac5ee390ad58d1$var$ITEM = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($64X3q))).items.map((i)=>[
            i.name,
            i.info
        ])));
// An ability's roll chance (the mined mode), or an even chance when the logs never saw it.
const $52ac5ee390ad58d1$var$chanceOf = (rates, name)=>{
    const r = rates && rates[name];
    return r ? r.mode / 100 : 0.5;
};
const $52ac5ee390ad58d1$var$skillsetKitOf = (cls, which)=>(0, $53jI0.kitProfile)((0, (/*@__PURE__*/$parcel$interopDefault($5Pzz7))).skillsets[cls].abilities.map((name)=>({
            name: name,
            chance: $52ac5ee390ad58d1$var$chanceOf(((0, (/*@__PURE__*/$parcel$interopDefault($1BkfY)))[cls] || {})[which], name)
        })), $52ac5ee390ad58d1$var$abilityInfo());
// A class's own kit: a human's skillset as its primary, or a monster's intrinsic skills (a
// starred one is locked behind Beastmaster, so it's left out, as the battle sim does).
const $52ac5ee390ad58d1$var$KITS = new Map();
function $52ac5ee390ad58d1$export$c3f67333561b7dc4(cls) {
    if (!$52ac5ee390ad58d1$var$KITS.has(cls)) {
        const set = (0, (/*@__PURE__*/$parcel$interopDefault($5Pzz7))).skillsets[cls];
        $52ac5ee390ad58d1$var$KITS.set(cls, set && set.skillset ? $52ac5ee390ad58d1$var$skillsetKitOf(cls, 'primary') : (0, $53jI0.kitProfile)(((0, (/*@__PURE__*/$parcel$interopDefault($hYk3h)))[cls] || []).filter((s)=>!s.endsWith('*')).map((name)=>({
                name: name,
                chance: 1
            })), $52ac5ee390ad58d1$var$abilityInfo()));
    }
    return $52ac5ee390ad58d1$var$KITS.get(cls);
}
const $52ac5ee390ad58d1$export$f72a38f3194a1e57 = (cls)=>(0, (/*@__PURE__*/$parcel$interopDefault($5Pzz7))).skillsets[cls] && (0, (/*@__PURE__*/$parcel$interopDefault($5Pzz7))).skillsets[cls].skillset || '';
// A forceable skillset token's kit when forced as a secondary, or null if it isn't one
// (Blue Magic has no class of its own to read it from).
const $52ac5ee390ad58d1$var$SKILLSET_CLASS = {};
for (const [cls, s] of Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($5Pzz7))).skillsets))if (s && s.skillset) $52ac5ee390ad58d1$var$SKILLSET_CLASS[s.skillset] = cls;
const $52ac5ee390ad58d1$var$SKILLSET_KITS = new Map();
function $52ac5ee390ad58d1$export$99645f636e6d87e9(token) {
    const meta = (0, (/*@__PURE__*/$parcel$interopDefault($adzaT))).byToken[token];
    const cls = meta && meta.category === 'skillset' ? $52ac5ee390ad58d1$var$SKILLSET_CLASS[meta.name] : '';
    if (!cls) return null;
    if (!$52ac5ee390ad58d1$var$SKILLSET_KITS.has(token)) $52ac5ee390ad58d1$var$SKILLSET_KITS.set(token, {
        name: meta.name,
        kit: $52ac5ee390ad58d1$var$skillsetKitOf(cls, 'secondary')
    });
    return $52ac5ee390ad58d1$var$SKILLSET_KITS.get(token);
}
function $52ac5ee390ad58d1$export$825249213ad38a80(unit) {
    const key = String(unit.Class || '').replace(/ /g, '');
    const tips = (0, (/*@__PURE__*/$parcel$interopDefault($ay2NQ))).Class || {};
    return tips[key + ' ' + (unit.Gender === 'Female' ? 'Female' : 'Male')] || tips[key] || '';
}
const $52ac5ee390ad58d1$export$5c4e4a79f82587f7 = (unit)=>(0, $53jI0.unitDefenses)(unit, $52ac5ee390ad58d1$var$itemInfo(), $52ac5ee390ad58d1$export$825249213ad38a80(unit));

});
parcelRegister("5Pzz7", function(module, exports) {
module.exports = JSON.parse("{\"classes\":[\"Archer\",\"Bard\",\"Calculator\",\"Chemist\",\"Dancer\",\"Geomancer\",\"Knight\",\"Lancer\",\"Mediator\",\"Mime\",\"Monk\",\"Ninja\",\"Oracle\",\"Priest\",\"Samurai\",\"Squire\",\"Summoner\",\"Thief\",\"Time Mage\",\"Wizard\"],\"classIndex\":{\"Archer\":3,\"Bard\":17,\"Calculator\":16,\"Chemist\":1,\"Dancer\":17,\"Geomancer\":12,\"Knight\":2,\"Lancer\":13,\"Mediator\":10,\"Mime\":18,\"Monk\":4,\"Ninja\":15,\"Oracle\":11,\"Priest\":5,\"Samurai\":14,\"Squire\":0,\"Summoner\":8,\"Thief\":9,\"Time Mage\":7,\"Wizard\":6},\"monsters\":[\"Ahriman\",\"Apanda\",\"Archaic Demon\",\"Behemoth\",\"Black Chocobo\",\"Black Goblin\",\"Blue Dragon\",\"Bomb\",\"Bull Demon\",\"Byblos\",\"Chocobo\",\"Cockatrice\",\"Coeurl\",\"Dark Behemoth\",\"Dragon\",\"Draugr\",\"Dryad\",\"Explosive\",\"Floating Eye\",\"Ghost\",\"Ghoul\",\"Gobbledeguck\",\"Goblin\",\"Great Malboro\",\"Grenade\",\"Holy Dragon\",\"Hydra\",\"Iron Hawk\",\"Juravis\",\"King Behemoth\",\"Malboro\",\"Mindflayer\",\"Minotaur\",\"Ochu\",\"Pisco Demon\",\"Plague\",\"Porky\",\"Reaper\",\"Red Chocobo\",\"Red Dragon\",\"Red Panther\",\"Revenant\",\"Sekhret\",\"Serpentarius\",\"Skeleton\",\"Squidraken\",\"Steel Giant\",\"Swine\",\"Taiju\",\"Tiamat\",\"Treant\",\"Ultima Demon\",\"Vampire\",\"Wild Boar\",\"Wyvern\"],\"monsterSkills\":{\"Ahriman\":[\"Wing Attack\",\"Look of Devil\",\"Look of Fright\",\"Doom*\"],\"Apanda\":[\"Bio Tenebris\",\"Bio Venenum\",\"Bio Oleum\",\"Bio Ranae\",\"Bio Tardus\",\"Bio Silentium\",\"Bio Lapis\",\"Bio Immortuos\",\"Bio Mortem\",\"Bio Insanis\"],\"Archaic Demon\":[\"Lifebreak\",\"Dark Holy\",\"Giga Flare\",\"Empower\",\"Despair\",\"Despair 2\"],\"Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Giga Flare*\"],\"Black Chocobo\":[\"Choco Attack\",\"Choco Ball\",\"Choco Esuna\",\"Choco Meteor*\"],\"Black Goblin\":[\"Tackle\",\"Turn Punch\",\"Goblin Punch\",\"Mutilate*\"],\"Blue Dragon\":[\"Slam\",\"Ice Breath\",\"Tail Swing\",\"Fire Breath*\"],\"Bomb\":[\"Bite\",\"Self Destruct\",\"Flame Attack\",\"Spark*\"],\"Bull Demon\":[\"Shake Off\",\"Storm Around\",\"Blow Fire*\"],\"Byblos\":[\"Energize\",\"Parasite\",\"Vengeance\",\"Manaburn\",\"Chicken\"],\"Chocobo\":[\"Choco Attack\",\"Choco Cure\",\"Choco Esuna\",\"Choco Ball*\"],\"Cockatrice\":[\"Scratch Up\",\"Beak\",\"Feather Bomb\",\"Peck*\"],\"Coeurl\":[\"Scratch\",\"Cat Kick\",\"Blaster\",\"Poison Nail*\"],\"Dark Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Ulmaguest*\"],\"Dragon\":[\"Slam\",\"Thunder Breath\",\"Tail Swing\",\"Ice Breath*\"],\"Draugr\":[\"Knife Hand\",\"Aqua Soul\",\"Frost Soul\",\"Wind Soul*\"],\"Dryad\":[\"Leaf Dance\",\"Calm Spirit\",\"Protect Spirit\",\"Spirit of Life*\"],\"Explosive\":[\"Bite\",\"Self Destruct\",\"Spark\",\"Small Bomb*\"],\"Floating Eye\":[\"Wing Attack\",\"Look of Fright\",\"Beam\",\"Look of Devil*\"],\"Ghost\":[\"Throw Spirit\",\"Grease Touch\",\"Drain Touch\",\"Zombie Touch*\"],\"Ghoul\":[\"Throw Spirit\",\"Sleep Touch\",\"Knife Hand\",\"Grease Touch*\"],\"Gobbledeguck\":[\"Tackle\",\"Eye Gouge\",\"Mutilate\",\"Goblin Punch*\"],\"Goblin\":[\"Tackle\",\"Eye Gouge\",\"Goblin Punch\",\"Turn Punch*\"],\"Great Malboro\":[\"Tendrils\",\"Bad Breath\",\"Moldball Virus\",\"Goo*\"],\"Grenade\":[\"Bite\",\"Small Bomb\",\"Self Destruct\",\"Flame Attack*\"],\"Holy Dragon\":[\"Holy Breath\",\"Fire Breath\",\"Ice Breath\",\"Thunder Breath\"],\"Hydra\":[\"Triple Attack\",\"Triple Flame\",\"Triple Thunder*\"],\"Iron Hawk\":[\"Scratch Up\",\"Peck\",\"Shine Lover\",\"Feather Bomb*\"],\"Juravis\":[\"Scratch Up\",\"Feather Bomb\",\"Shine Lover\",\"Fury*\"],\"King Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Hurricane*\"],\"Malboro\":[\"Tendrils\",\"Lick\",\"Noxious Gas\",\"Bad Breath*\"],\"Mindflayer\":[\"Tentacle\",\"Mind Blast\",\"Odd Soundwave\",\"Level Blast*\"],\"Minotaur\":[\"Shake Off\",\"Blow Fire\",\"Gather Power*\"],\"Ochu\":[\"Tendrils\",\"Goo\",\"Lick\",\"Noxious Gas*\"],\"Pisco Demon\":[\"Tentacle\",\"Black Ink\",\"Level Blast\",\"Odd Soundwave*\"],\"Plague\":[\"Wing Attack\",\"Doom\",\"Look of Devil\",\"Beam*\"],\"Porky\":[\"Straight Dash\",\"Toot\",\"Bequeath Bacon\",\"Snort*\"],\"Reaper\":[\"Knife Hand\",\"Wind Soul\",\"Thunder Soul\",\"Frost Soul*\"],\"Red Chocobo\":[\"Choco Attack\",\"Choco Meteor\",\"Choco Ball\",\"Choco Cure*\"],\"Red Dragon\":[\"Slam\",\"Fire Breath\",\"Tail Swing\",\"Thunder Breath*\"],\"Red Panther\":[\"Scratch\",\"Poison Nail\",\"Cat Kick\",\"Accumulate*\"],\"Revenant\":[\"Throw Spirit\",\"Drain Touch\",\"Zombie Touch\",\"Sleep Touch*\"],\"Sekhret\":[\"Shake Off\",\"Mimic Titan\",\"Gather Power\",\"Storm Around*\"],\"Serpentarius\":[\"Snake Carrier\",\"Toxic Toad\",\"Midgar Swarm\",\"Scream\"],\"Skeleton\":[\"Knife Hand\",\"Thunder Soul\",\"Frost Soul\",\"Aqua Soul*\"],\"Squidraken\":[\"Tentacle\",\"Black Ink\",\"Odd Soundwave\",\"Mind Blast*\"],\"Steel Giant\":[\"Destroy\",\"Compress\",\"Dispose\",\"Repair\"],\"Swine\":[\"Straight Dash\",\"Oink\",\"Bequeath Bacon\",\"Toot*\"],\"Taiju\":[\"Leaf Dance\",\"Magic Spirit\",\"Spirit of Life\",\"Magic Barrier*\"],\"Tiamat\":[\"Triple Attack\",\"Triple Thunder\",\"Triple Breath\",\"Dark Whisper*\"],\"Treant\":[\"Leaf Dance\",\"Spirit of Life\",\"Protect Spirit\",\"Calm Spirit*\"],\"Ultima Demon\":[\"Nanoflare\",\"Dark Holy\",\"Ultima\",\"Hurricane\",\"Ulmaguest\",\"Empower\"],\"Vampire\":[\"Scratch\",\"Blaster\",\"Blood Suck\",\"Cat Kick*\"],\"Wild Boar\":[\"Straight Dash\",\"Snort\",\"Bequeath Bacon\",\"Oink*\"],\"Wyvern\":[\"Triple Attack\",\"Noxious Gas\",\"Triple Breath*\"]},\"reactions\":[\"Abandon\",\"Absorb Used MP\",\"Arrow Guard\",\"Auto Potion\",\"Blade Grasp\",\"Brave Save\",\"Catch\",\"Caution\",\"Counter\",\"Counter Flood\",\"Counter Magic\",\"Counter Tackle\",\"Critical Quick\",\"Damage Split\",\"Distribute\",\"Dragon Spirit\",\"Earplug\",\"Faith Save\",\"HP Restore\",\"Hamedo\",\"MA Save\",\"MP Restore\",\"Mana Shield\",\"Meatbone Slash\",\"PA Save\",\"Parry\",\"Regenerator\",\"Speed Save\",\"Sunken State\"],\"supports\":[\"Attack Up\",\"Beastmaster\",\"Concentrate\",\"Defend\",\"Defense Up\",\"Doublehand\",\"Dual Wield\",\"Equip Armor\",\"Equip Axe\",\"Equip Bow\",\"Equip Gun\",\"Equip Knife\",\"Equip Polearm\",\"Equip Shield\",\"Equip Sword\",\"Halve MP\",\"Long Status\",\"Magic Attack Up\",\"Magic Defense Up\",\"Maintenance\",\"Martial Arts\",\"Monster Talk\",\"Secret Hunt\",\"Short Charge\",\"Short Status\",\"Sicken\",\"Throw Item\"],\"movements\":[\"Fly\",\"Ignore Height\",\"Ignore Terrain\",\"Jump+1\",\"Jump+2\",\"Jump+3\",\"Lava Walking\",\"Levitate\",\"Lifefont\",\"Manafont\",\"Move+1\",\"Move+2\",\"Move+3\",\"Pilgrimage\",\"Retreat\",\"Sonic Step\",\"Swim\",\"Teleport\",\"Teleport 2\",\"Waterwalking\"],\"zodiacs\":[\"Aquarius\",\"Aries\",\"Cancer\",\"Capricorn\",\"Gemini\",\"Leo\",\"Libra\",\"Pisces\",\"Sagittarius\",\"Scorpio\",\"Serpentarius\",\"Taurus\",\"Virgo\"],\"skillsets\":{\"Archer\":{\"skillset\":\"Charge\",\"primaryBaseChance\":40,\"abilities\":[\"Charge+1\",\"Charge+10\",\"Charge+2\",\"Charge+20\",\"Charge+3\",\"Charge+4\",\"Charge+5\",\"Charge+7\"]},\"Bard\":{\"skillset\":\"Sing\",\"primaryBaseChance\":40,\"abilities\":[\"Angel Song\",\"Battle Song\",\"Cheer Song\",\"Diamond Blade\",\"Hydra Pit\",\"Last Song\",\"Life Song\",\"Magic Song\",\"Nameless Song\",\"Sky Demon\",\"Space Storage\"]},\"Calculator\":{\"skillset\":\"Math Skill\",\"primaryBaseChance\":48,\"abilities\":[\"3\",\"4\",\"5\",\"CT\",\"Height\",\"Prime Number\"]},\"Chemist\":{\"skillset\":\"Item\",\"primaryBaseChance\":40,\"abilities\":[\"Antidote\",\"Echo Grass\",\"Elixir\",\"Ether\",\"Eye Drop\",\"Hi-Ether\",\"Hi-Potion\",\"Holy Water\",\"Maiden's Kiss\",\"Phoenix Down\",\"Potion\",\"Remedy\",\"Soft\",\"X-Potion\"]},\"Dancer\":{\"skillset\":\"Dance\",\"primaryBaseChance\":40,\"abilities\":[\"Disillusion\",\"Dragon Pit\",\"Last Dance\",\"Nameless Dance\",\"Nether Demon\",\"Obsidian Blade\",\"Polka Polka\",\"Slow Dance\",\"Void Storage\",\"Witch Hunt\",\"Wiznaibus\"]},\"Geomancer\":{\"skillset\":\"Elemental\",\"primaryBaseChance\":62,\"abilities\":[\"Blizzard\",\"Gusty Wind\",\"Hallowed Ground\",\"Hell Ivy\",\"Lava Ball\",\"Local Quake\",\"Pitfall\",\"Quicksand\",\"Sand Storm\",\"Static Shock\",\"Water Ball\",\"Will-O-Wisp\"]},\"Knight\":{\"skillset\":\"Battle Skill\",\"primaryBaseChance\":40,\"abilities\":[\"Armor Rend\",\"Dark Sword\",\"Explosion Sword\",\"Head Rend\",\"Justice Sword\",\"Magic Ruin\",\"Mind Break\",\"Night Sword\",\"Power Break\",\"Shield Rend\",\"Speed Break\",\"Stasis Sword\",\"Surging Sword\",\"Weapon Rend\"]},\"Lancer\":{\"skillset\":\"Jump\",\"primaryBaseChance\":40,\"abilities\":[\"Level Jump2\",\"Level Jump3\",\"Level Jump4\",\"Level Jump5\",\"Level Jump6\",\"Level Jump7\",\"Vertical Jump2\",\"Vertical Jump3\",\"Vertical Jump4\",\"Vertical Jump5\",\"Vertical Jump6\",\"Vertical Jump7\"]},\"Mediator\":{\"skillset\":\"Talk Skill\",\"primaryBaseChance\":40,\"abilities\":[\"Death Sentence\",\"Insult\",\"Invitation\",\"Mimic Daravon\",\"Negotiate\",\"Persuade\",\"Praise\",\"Preach\",\"Refute\",\"Rehabilitate\",\"Solution\",\"Threaten\"]},\"Mime\":{\"skillset\":null,\"primaryBaseChance\":40,\"abilities\":[\"Mimic\"]},\"Monk\":{\"skillset\":\"Punch Art\",\"primaryBaseChance\":40,\"abilities\":[\"Chakra\",\"Earth Slash\",\"Pummel\",\"Purification\",\"Revive\",\"Seal Evil\",\"Secret Fist\",\"Spin Fist\",\"Wave Fist\"]},\"Ninja\":{\"skillset\":\"Throw\",\"primaryBaseChance\":40,\"abilities\":[\"Axe\",\"Bomb\",\"Dictionary\",\"Hammer\",\"Knife\",\"Ninja Sword\",\"Shuriken\",\"Spear\",\"Staff\",\"Stick\",\"Sword\",\"Wand\"]},\"Oracle\":{\"skillset\":\"Yin Yang Magic\",\"primaryBaseChance\":40,\"abilities\":[\"Blind\",\"Confuse\",\"Dark Holy\",\"Dispel Magic\",\"Doubt Faith\",\"Enrage\",\"Foxbird\",\"Life Drain\",\"Paralyze\",\"Petrify\",\"Poison\",\"Pray Faith\",\"Silence\",\"Sleep\",\"Spell Absorb\",\"Zombie\"]},\"Priest\":{\"skillset\":\"White Magic\",\"primaryBaseChance\":40,\"abilities\":[\"Cure\",\"Cure 2\",\"Cure 3\",\"Cure 4\",\"Esuna\",\"Holy\",\"Magic Barrier\",\"Protect\",\"Protect 2\",\"Raise\",\"Raise 2\",\"Regen\",\"Reraise\",\"Shell\",\"Shell 2\",\"Wall\"]},\"Samurai\":{\"skillset\":\"Draw Out\",\"primaryBaseChance\":40,\"abilities\":[\"Asura\",\"Bizen Boat\",\"Chirijiraden\",\"Heaven's Cloud\",\"Kikuichimonji\",\"Kiyomori\",\"Koutetsu\",\"Masamune\",\"Muramasa\",\"Murasame\"]},\"Squire\":{\"skillset\":\"Basic Skill\",\"primaryBaseChance\":40,\"abilities\":[\"Accumulate\",\"Cheer Up\",\"Dash\",\"Fury\",\"Heal\",\"Scream\",\"Throw Stone\",\"Tickle\",\"Ultima\",\"Wish\",\"Yell\"]},\"Summoner\":{\"skillset\":\"Summon Magic\",\"primaryBaseChance\":40,\"abilities\":[\"Bahamut\",\"Carbunkle\",\"Cyclops\",\"Fairy\",\"Golem\",\"Ifrit\",\"Leviathan\",\"Lich\",\"Moogle\",\"Odin\",\"Ramuh\",\"Salamander\",\"Shiva\",\"Sylph\",\"Titan\",\"Zodiac\"]},\"Thief\":{\"skillset\":\"Steal\",\"primaryBaseChance\":40,\"abilities\":[\"Arm Aim\",\"Gil Taking\",\"Leg Aim\",\"Steal Accessory\",\"Steal Armor\",\"Steal Heart\",\"Steal Helmet\",\"Steal Shield\",\"Steal Status\",\"Steal Weapon\"]},\"Time Mage\":{\"skillset\":\"Time Magic\",\"primaryBaseChance\":40,\"abilities\":[\"Demi\",\"Demi 2\",\"Float\",\"Galaxy Stop\",\"Haste\",\"Haste 2\",\"Immobilize\",\"Meteor\",\"Mute\",\"Old\",\"Quick\",\"Reflect\",\"Slow\",\"Slow 2\",\"Stabilize Time\",\"Stop\"]},\"Wizard\":{\"skillset\":\"Black Magic\",\"primaryBaseChance\":40,\"abilities\":[\"Bolt\",\"Bolt 2\",\"Bolt 3\",\"Bolt 4\",\"Death\",\"Empower\",\"Fire\",\"Fire 2\",\"Fire 3\",\"Fire 4\",\"Flare\",\"Frog\",\"Ice\",\"Ice 2\",\"Ice 3\",\"Ice 4\"]}}}");

});

parcelRegister("1BkfY", function(module, exports) {
module.exports = JSON.parse("{\"Archer\":{\"primary\":{\"Charge+1\":{\"mode\":55,\"min\":50,\"max\":60},\"Charge+10\":{\"mode\":30,\"min\":22,\"max\":45},\"Charge+2\":{\"mode\":40,\"min\":35,\"max\":50},\"Charge+20\":{\"mode\":21,\"min\":15,\"max\":31},\"Charge+3\":{\"mode\":40,\"min\":35,\"max\":50},\"Charge+4\":{\"mode\":40,\"min\":35,\"max\":50},\"Charge+5\":{\"mode\":40,\"min\":35,\"max\":50},\"Charge+7\":{\"mode\":40,\"min\":35,\"max\":50}},\"secondary\":{\"Charge+1\":{\"mode\":51,\"min\":51,\"max\":56},\"Charge+10\":{\"mode\":25,\"min\":25,\"max\":37},\"Charge+2\":{\"mode\":35,\"min\":35,\"max\":45},\"Charge+20\":{\"mode\":18,\"min\":17,\"max\":27},\"Charge+3\":{\"mode\":35,\"min\":35,\"max\":45},\"Charge+4\":{\"mode\":35,\"min\":35,\"max\":45},\"Charge+5\":{\"mode\":35,\"min\":35,\"max\":45},\"Charge+7\":{\"mode\":35,\"min\":35,\"max\":45}}},\"Bard\":{\"primary\":{\"Angel Song\":{\"mode\":40,\"min\":35,\"max\":50},\"Battle Song\":{\"mode\":40,\"min\":35,\"max\":50},\"Cheer Song\":{\"mode\":40,\"min\":35,\"max\":50},\"Diamond Blade\":{\"mode\":30,\"min\":22,\"max\":46},\"Hydra Pit\":{\"mode\":30,\"min\":22,\"max\":45},\"Last Song\":{\"mode\":35,\"min\":26,\"max\":49},\"Life Song\":{\"mode\":40,\"min\":35,\"max\":50},\"Magic Song\":{\"mode\":40,\"min\":35,\"max\":50},\"Nameless Song\":{\"mode\":30,\"min\":22,\"max\":45},\"Sky Demon\":{\"mode\":30,\"min\":21,\"max\":44},\"Space Storage\":{\"mode\":26,\"min\":18,\"max\":40}},\"secondary\":{\"Angel Song\":{\"mode\":35,\"min\":35,\"max\":45},\"Battle Song\":{\"mode\":35,\"min\":35,\"max\":45},\"Cheer Song\":{\"mode\":35,\"min\":35,\"max\":45},\"Diamond Blade\":{\"mode\":25,\"min\":24,\"max\":38},\"Hydra Pit\":{\"mode\":25,\"min\":24,\"max\":37},\"Last Song\":{\"mode\":30,\"min\":30,\"max\":44},\"Life Song\":{\"mode\":35,\"min\":35,\"max\":45},\"Magic Song\":{\"mode\":35,\"min\":35,\"max\":45},\"Nameless Song\":{\"mode\":25,\"min\":25,\"max\":37},\"Sky Demon\":{\"mode\":25,\"min\":24,\"max\":37},\"Space Storage\":{\"mode\":22,\"min\":21,\"max\":34}}},\"Calculator\":{\"primary\":{\"3\":{\"mode\":49,\"min\":48,\"max\":100},\"4\":{\"mode\":100,\"min\":48,\"max\":100},\"5\":{\"mode\":51,\"min\":48,\"max\":100},\"CT\":{\"mode\":100,\"min\":48,\"max\":100},\"Height\":{\"mode\":48,\"min\":48,\"max\":100},\"Prime Number\":{\"mode\":48,\"min\":48,\"max\":100}},\"secondary\":{\"3\":{\"mode\":100,\"min\":39,\"max\":100},\"4\":{\"mode\":100,\"min\":39,\"max\":100},\"5\":{\"mode\":41,\"min\":41,\"max\":100},\"CT\":{\"mode\":40,\"min\":39,\"max\":100},\"Height\":{\"mode\":100,\"min\":39,\"max\":100},\"Prime Number\":{\"mode\":40,\"min\":39,\"max\":43}}},\"Chemist\":{\"primary\":{\"Antidote\":{\"mode\":65,\"min\":65,\"max\":68},\"Echo Grass\":{\"mode\":65,\"min\":64,\"max\":67},\"Elixir\":{\"mode\":4,\"min\":4,\"max\":9},\"Ether\":{\"mode\":43,\"min\":42,\"max\":51},\"Eye Drop\":{\"mode\":65,\"min\":65,\"max\":68},\"Hi-Ether\":{\"mode\":40,\"min\":40,\"max\":50},\"Hi-Potion\":{\"mode\":45,\"min\":44,\"max\":52},\"Holy Water\":{\"mode\":40,\"min\":40,\"max\":50},\"Maiden's Kiss\":{\"mode\":64,\"min\":64,\"max\":67},\"Phoenix Down\":{\"mode\":85,\"min\":85,\"max\":86},\"Potion\":{\"mode\":78,\"min\":77,\"max\":80},\"Remedy\":{\"mode\":40,\"min\":40,\"max\":50},\"Soft\":{\"mode\":64,\"min\":64,\"max\":67},\"X-Potion\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Antidote\":{\"mode\":60,\"min\":56,\"max\":63},\"Echo Grass\":{\"mode\":59,\"min\":55,\"max\":62},\"Elixir\":{\"mode\":3,\"min\":1,\"max\":9},\"Ether\":{\"mode\":38,\"min\":33,\"max\":46},\"Eye Drop\":{\"mode\":60,\"min\":56,\"max\":64},\"Hi-Ether\":{\"mode\":35,\"min\":31,\"max\":45},\"Hi-Potion\":{\"mode\":35,\"min\":31,\"max\":45},\"Holy Water\":{\"mode\":35,\"min\":31,\"max\":45},\"Maiden's Kiss\":{\"mode\":58,\"min\":54,\"max\":61},\"Phoenix Down\":{\"mode\":80,\"min\":76,\"max\":81},\"Potion\":{\"mode\":73,\"min\":68,\"max\":76},\"Remedy\":{\"mode\":35,\"min\":31,\"max\":45},\"Soft\":{\"mode\":58,\"min\":53,\"max\":60},\"X-Potion\":{\"mode\":34,\"min\":29,\"max\":45}}},\"Dancer\":{\"primary\":{\"Disillusion\":{\"mode\":40,\"min\":40,\"max\":50},\"Dragon Pit\":{\"mode\":30,\"min\":29,\"max\":46},\"Last Dance\":{\"mode\":35,\"min\":35,\"max\":49},\"Nameless Dance\":{\"mode\":30,\"min\":30,\"max\":45},\"Nether Demon\":{\"mode\":30,\"min\":29,\"max\":46},\"Obsidian Blade\":{\"mode\":30,\"min\":29,\"max\":46},\"Polka Polka\":{\"mode\":40,\"min\":40,\"max\":50},\"Slow Dance\":{\"mode\":40,\"min\":40,\"max\":50},\"Void Storage\":{\"mode\":26,\"min\":25,\"max\":40},\"Witch Hunt\":{\"mode\":40,\"min\":40,\"max\":50},\"Wiznaibus\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Disillusion\":{\"mode\":35,\"min\":35,\"max\":35},\"Dragon Pit\":{\"mode\":25,\"min\":24,\"max\":26},\"Last Dance\":{\"mode\":30,\"min\":30,\"max\":30},\"Nameless Dance\":{\"mode\":25,\"min\":25,\"max\":25},\"Nether Demon\":{\"mode\":25,\"min\":24,\"max\":26},\"Obsidian Blade\":{\"mode\":25,\"min\":24,\"max\":26},\"Polka Polka\":{\"mode\":35,\"min\":35,\"max\":35},\"Slow Dance\":{\"mode\":35,\"min\":35,\"max\":35},\"Void Storage\":{\"mode\":22,\"min\":21,\"max\":23},\"Witch Hunt\":{\"mode\":35,\"min\":35,\"max\":35},\"Wiznaibus\":{\"mode\":35,\"min\":35,\"max\":35}}},\"Geomancer\":{\"primary\":{\"Blizzard\":{\"mode\":63,\"min\":62,\"max\":75},\"Gusty Wind\":{\"mode\":65,\"min\":62,\"max\":75},\"Hallowed Ground\":{\"mode\":65,\"min\":62,\"max\":74},\"Hell Ivy\":{\"mode\":63,\"min\":62,\"max\":75},\"Lava Ball\":{\"mode\":64,\"min\":62,\"max\":73},\"Local Quake\":{\"mode\":63,\"min\":62,\"max\":75},\"Pitfall\":{\"mode\":63,\"min\":62,\"max\":72},\"Quicksand\":{\"mode\":63,\"min\":62,\"max\":72},\"Sand Storm\":{\"mode\":65,\"min\":62,\"max\":74},\"Static Shock\":{\"mode\":63,\"min\":62,\"max\":72},\"Water Ball\":{\"mode\":63,\"min\":62,\"max\":74},\"Will-O-Wisp\":{\"mode\":63,\"min\":62,\"max\":72}},\"secondary\":{\"Blizzard\":{\"mode\":60,\"min\":55,\"max\":70},\"Gusty Wind\":{\"mode\":60,\"min\":55,\"max\":70},\"Hallowed Ground\":{\"mode\":60,\"min\":55,\"max\":70},\"Hell Ivy\":{\"mode\":60,\"min\":55,\"max\":70},\"Lava Ball\":{\"mode\":60,\"min\":55,\"max\":70},\"Local Quake\":{\"mode\":60,\"min\":55,\"max\":70},\"Pitfall\":{\"mode\":60,\"min\":55,\"max\":70},\"Quicksand\":{\"mode\":60,\"min\":55,\"max\":70},\"Sand Storm\":{\"mode\":60,\"min\":55,\"max\":70},\"Static Shock\":{\"mode\":60,\"min\":55,\"max\":70},\"Water Ball\":{\"mode\":60,\"min\":55,\"max\":70},\"Will-O-Wisp\":{\"mode\":60,\"min\":55,\"max\":70}}},\"Knight\":{\"primary\":{\"Armor Rend\":{\"mode\":40,\"min\":40,\"max\":50},\"Dark Sword\":{\"mode\":22,\"min\":22,\"max\":34},\"Explosion Sword\":{\"mode\":7,\"min\":7,\"max\":13},\"Head Rend\":{\"mode\":40,\"min\":40,\"max\":50},\"Justice Sword\":{\"mode\":33,\"min\":32,\"max\":49},\"Magic Ruin\":{\"mode\":40,\"min\":40,\"max\":50},\"Mind Break\":{\"mode\":40,\"min\":40,\"max\":50},\"Night Sword\":{\"mode\":20,\"min\":20,\"max\":30},\"Power Break\":{\"mode\":40,\"min\":40,\"max\":50},\"Shield Rend\":{\"mode\":40,\"min\":40,\"max\":50},\"Speed Break\":{\"mode\":40,\"min\":40,\"max\":50},\"Stasis Sword\":{\"mode\":25,\"min\":25,\"max\":37},\"Surging Sword\":{\"mode\":15,\"min\":15,\"max\":22},\"Weapon Rend\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Armor Rend\":{\"mode\":35,\"min\":30,\"max\":35},\"Dark Sword\":{\"mode\":19,\"min\":14,\"max\":19},\"Explosion Sword\":{\"mode\":6,\"min\":4,\"max\":6},\"Head Rend\":{\"mode\":35,\"min\":30,\"max\":35},\"Justice Sword\":{\"mode\":28,\"min\":20,\"max\":28},\"Magic Ruin\":{\"mode\":35,\"min\":30,\"max\":35},\"Mind Break\":{\"mode\":35,\"min\":30,\"max\":35},\"Night Sword\":{\"mode\":17,\"min\":12,\"max\":17},\"Power Break\":{\"mode\":35,\"min\":30,\"max\":35},\"Shield Rend\":{\"mode\":35,\"min\":30,\"max\":35},\"Speed Break\":{\"mode\":35,\"min\":30,\"max\":35},\"Stasis Sword\":{\"mode\":21,\"min\":15,\"max\":21},\"Surging Sword\":{\"mode\":13,\"min\":9,\"max\":13},\"Weapon Rend\":{\"mode\":35,\"min\":30,\"max\":35}}},\"Lancer\":{\"primary\":{\"Level Jump2\":{\"mode\":0,\"min\":0,\"max\":100},\"Level Jump2.5\":{\"mode\":0,\"min\":0,\"max\":36},\"Level Jump3\":{\"mode\":0,\"min\":0,\"max\":36},\"Level Jump3.5\":{\"mode\":0,\"min\":0,\"max\":36},\"Level Jump4\":{\"mode\":0,\"min\":0,\"max\":35},\"Level Jump5\":{\"mode\":0,\"min\":0,\"max\":34},\"Level Jump6\":{\"mode\":25,\"min\":0,\"max\":29},\"Level Jump7\":{\"mode\":22,\"min\":22,\"max\":25},\"Vertical Jump2\":{\"mode\":0,\"min\":0,\"max\":100},\"Vertical Jump2.5\":{\"mode\":0,\"min\":0,\"max\":31},\"Vertical Jump3\":{\"mode\":0,\"min\":0,\"max\":36},\"Vertical Jump3.5\":{\"mode\":0,\"min\":0,\"max\":36},\"Vertical Jump4\":{\"mode\":0,\"min\":0,\"max\":35},\"Vertical Jump5\":{\"mode\":0,\"min\":0,\"max\":34},\"Vertical Jump6\":{\"mode\":25,\"min\":0,\"max\":29},\"Vertical Jump7\":{\"mode\":22,\"min\":22,\"max\":25}},\"secondary\":{\"Level Jump2\":{\"mode\":0,\"min\":0,\"max\":100},\"Level Jump2.5\":{\"mode\":0,\"min\":0,\"max\":30},\"Level Jump3\":{\"mode\":0,\"min\":0,\"max\":30},\"Level Jump3.5\":{\"mode\":0,\"min\":0,\"max\":30},\"Level Jump4\":{\"mode\":0,\"min\":0,\"max\":30},\"Level Jump5\":{\"mode\":0,\"min\":0,\"max\":29},\"Level Jump6\":{\"mode\":24,\"min\":0,\"max\":28},\"Level Jump7\":{\"mode\":21,\"min\":21,\"max\":24},\"Vertical Jump2\":{\"mode\":0,\"min\":0,\"max\":100},\"Vertical Jump2.5\":{\"mode\":0,\"min\":0,\"max\":30},\"Vertical Jump3\":{\"mode\":0,\"min\":0,\"max\":30},\"Vertical Jump3.5\":{\"mode\":0,\"min\":0,\"max\":35},\"Vertical Jump4\":{\"mode\":0,\"min\":0,\"max\":34},\"Vertical Jump5\":{\"mode\":0,\"min\":0,\"max\":33},\"Vertical Jump6\":{\"mode\":24,\"min\":0,\"max\":28},\"Vertical Jump7\":{\"mode\":21,\"min\":21,\"max\":24}}},\"Mediator\":{\"primary\":{\"Death Sentence\":{\"mode\":40,\"min\":40,\"max\":50},\"Insult\":{\"mode\":40,\"min\":40,\"max\":50},\"Invitation\":{\"mode\":40,\"min\":40,\"max\":50},\"Mimic Daravon\":{\"mode\":40,\"min\":40,\"max\":50},\"Negotiate\":{\"mode\":40,\"min\":40,\"max\":50},\"Persuade\":{\"mode\":40,\"min\":40,\"max\":50},\"Praise\":{\"mode\":40,\"min\":40,\"max\":50},\"Preach\":{\"mode\":40,\"min\":40,\"max\":50},\"Refute\":{\"mode\":70,\"min\":70,\"max\":73},\"Rehabilitate\":{\"mode\":40,\"min\":40,\"max\":50},\"Solution\":{\"mode\":40,\"min\":40,\"max\":50},\"Threaten\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Death Sentence\":{\"mode\":35,\"min\":30,\"max\":45},\"Insult\":{\"mode\":35,\"min\":30,\"max\":45},\"Invitation\":{\"mode\":35,\"min\":30,\"max\":45},\"Mimic Daravon\":{\"mode\":35,\"min\":30,\"max\":45},\"Negotiate\":{\"mode\":35,\"min\":30,\"max\":45},\"Persuade\":{\"mode\":35,\"min\":30,\"max\":45},\"Praise\":{\"mode\":35,\"min\":30,\"max\":45},\"Preach\":{\"mode\":35,\"min\":30,\"max\":45},\"Refute\":{\"mode\":65,\"min\":60,\"max\":68},\"Rehabilitate\":{\"mode\":35,\"min\":30,\"max\":45},\"Solution\":{\"mode\":35,\"min\":30,\"max\":45},\"Threaten\":{\"mode\":35,\"min\":30,\"max\":45}}},\"Mime\":{\"primary\":{\"Mimic\":{\"mode\":100,\"min\":100,\"max\":100}}},\"Monk\":{\"primary\":{\"Chakra\":{\"mode\":45,\"min\":45,\"max\":52},\"Earth Slash\":{\"mode\":40,\"min\":40,\"max\":50},\"Pummel\":{\"mode\":40,\"min\":40,\"max\":50},\"Purification\":{\"mode\":80,\"min\":80,\"max\":82},\"Revive\":{\"mode\":71,\"min\":70,\"max\":74},\"Seal Evil\":{\"mode\":35,\"min\":35,\"max\":49},\"Secret Fist\":{\"mode\":40,\"min\":40,\"max\":50},\"Spin Fist\":{\"mode\":40,\"min\":40,\"max\":50},\"Wave Fist\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Chakra\":{\"mode\":40,\"min\":35,\"max\":47},\"Earth Slash\":{\"mode\":35,\"min\":30,\"max\":45},\"Pummel\":{\"mode\":35,\"min\":30,\"max\":45},\"Purification\":{\"mode\":75,\"min\":70,\"max\":77},\"Revive\":{\"mode\":66,\"min\":61,\"max\":69},\"Seal Evil\":{\"mode\":30,\"min\":22,\"max\":44},\"Secret Fist\":{\"mode\":35,\"min\":30,\"max\":45},\"Spin Fist\":{\"mode\":35,\"min\":30,\"max\":45},\"Wave Fist\":{\"mode\":35,\"min\":30,\"max\":45}}},\"Ninja\":{\"primary\":{\"Axe\":{\"mode\":6,\"min\":4,\"max\":6},\"Bomb\":{\"mode\":45,\"min\":40,\"max\":45},\"Dictionary\":{\"mode\":13,\"min\":9,\"max\":14},\"Hammer\":{\"mode\":5,\"min\":3,\"max\":5},\"Knife\":{\"mode\":25,\"min\":18,\"max\":25},\"Ninja Sword\":{\"mode\":10,\"min\":8,\"max\":11},\"Shuriken\":{\"mode\":60,\"min\":55,\"max\":60},\"Spear\":{\"mode\":8,\"min\":6,\"max\":8},\"Staff\":{\"mode\":16,\"min\":12,\"max\":17},\"Stick\":{\"mode\":9,\"min\":6,\"max\":9},\"Sword\":{\"mode\":7,\"min\":5,\"max\":7},\"Wand\":{\"mode\":20,\"min\":15,\"max\":20}},\"secondary\":{\"Axe\":{\"mode\":5,\"min\":4,\"max\":11},\"Bomb\":{\"mode\":40,\"min\":35,\"max\":47},\"Dictionary\":{\"mode\":11,\"min\":8,\"max\":16},\"Hammer\":{\"mode\":4,\"min\":3,\"max\":10},\"Knife\":{\"mode\":21,\"min\":15,\"max\":31},\"Ninja Sword\":{\"mode\":9,\"min\":7,\"max\":16},\"Shuriken\":{\"mode\":55,\"min\":50,\"max\":58},\"Spear\":{\"mode\":7,\"min\":5,\"max\":13},\"Staff\":{\"mode\":15,\"min\":11,\"max\":22},\"Stick\":{\"mode\":8,\"min\":6,\"max\":15},\"Sword\":{\"mode\":6,\"min\":4,\"max\":12},\"Wand\":{\"mode\":17,\"min\":12,\"max\":25}}},\"Oracle\":{\"primary\":{\"Blind\":{\"mode\":40,\"min\":40,\"max\":50},\"Confuse\":{\"mode\":40,\"min\":40,\"max\":50},\"Dark Holy\":{\"mode\":30,\"min\":30,\"max\":45},\"Dispel Magic\":{\"mode\":70,\"min\":70,\"max\":73},\"Doubt Faith\":{\"mode\":35,\"min\":35,\"max\":49},\"Enrage\":{\"mode\":40,\"min\":40,\"max\":50},\"Foxbird\":{\"mode\":40,\"min\":40,\"max\":50},\"Life Drain\":{\"mode\":40,\"min\":40,\"max\":50},\"Paralyze\":{\"mode\":40,\"min\":40,\"max\":50},\"Petrify\":{\"mode\":25,\"min\":24,\"max\":37},\"Poison\":{\"mode\":40,\"min\":40,\"max\":50},\"Pray Faith\":{\"mode\":35,\"min\":35,\"max\":49},\"Silence\":{\"mode\":40,\"min\":40,\"max\":50},\"Sleep\":{\"mode\":40,\"min\":40,\"max\":50},\"Spell Absorb\":{\"mode\":40,\"min\":40,\"max\":50},\"Zombie\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Blind\":{\"mode\":35,\"min\":35,\"max\":46},\"Confuse\":{\"mode\":35,\"min\":35,\"max\":46},\"Dark Holy\":{\"mode\":25,\"min\":25,\"max\":37},\"Dispel Magic\":{\"mode\":65,\"min\":65,\"max\":69},\"Doubt Faith\":{\"mode\":30,\"min\":30,\"max\":45},\"Enrage\":{\"mode\":35,\"min\":35,\"max\":46},\"Foxbird\":{\"mode\":35,\"min\":35,\"max\":45},\"Life Drain\":{\"mode\":35,\"min\":35,\"max\":45},\"Paralyze\":{\"mode\":35,\"min\":35,\"max\":47},\"Petrify\":{\"mode\":21,\"min\":21,\"max\":32},\"Poison\":{\"mode\":35,\"min\":35,\"max\":46},\"Pray Faith\":{\"mode\":30,\"min\":30,\"max\":45},\"Silence\":{\"mode\":35,\"min\":35,\"max\":46},\"Sleep\":{\"mode\":35,\"min\":35,\"max\":46},\"Spell Absorb\":{\"mode\":35,\"min\":35,\"max\":45},\"Zombie\":{\"mode\":35,\"min\":35,\"max\":46}}},\"Priest\":{\"primary\":{\"Cure\":{\"mode\":50,\"min\":50,\"max\":55},\"Cure 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Cure 3\":{\"mode\":40,\"min\":40,\"max\":50},\"Cure 4\":{\"mode\":35,\"min\":35,\"max\":49},\"Esuna\":{\"mode\":85,\"min\":84,\"max\":86},\"Holy\":{\"mode\":30,\"min\":28,\"max\":45},\"Magic Barrier\":{\"mode\":6,\"min\":5,\"max\":11},\"Protect\":{\"mode\":40,\"min\":40,\"max\":50},\"Protect 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Raise\":{\"mode\":80,\"min\":80,\"max\":82},\"Raise 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Regen\":{\"mode\":40,\"min\":40,\"max\":50},\"Reraise\":{\"mode\":40,\"min\":40,\"max\":50},\"Shell\":{\"mode\":40,\"min\":40,\"max\":50},\"Shell 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Wall\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Cure\":{\"mode\":45,\"min\":45,\"max\":51},\"Cure 2\":{\"mode\":35,\"min\":35,\"max\":47},\"Cure 3\":{\"mode\":35,\"min\":35,\"max\":47},\"Cure 4\":{\"mode\":30,\"min\":30,\"max\":44},\"Esuna\":{\"mode\":80,\"min\":80,\"max\":82},\"Holy\":{\"mode\":25,\"min\":25,\"max\":39},\"Magic Barrier\":{\"mode\":5,\"min\":5,\"max\":10},\"Protect\":{\"mode\":35,\"min\":35,\"max\":46},\"Protect 2\":{\"mode\":35,\"min\":35,\"max\":45},\"Raise\":{\"mode\":75,\"min\":75,\"max\":79},\"Raise 2\":{\"mode\":35,\"min\":35,\"max\":45},\"Regen\":{\"mode\":35,\"min\":35,\"max\":46},\"Reraise\":{\"mode\":35,\"min\":35,\"max\":46},\"Shell\":{\"mode\":35,\"min\":35,\"max\":46},\"Shell 2\":{\"mode\":35,\"min\":35,\"max\":45},\"Wall\":{\"mode\":35,\"min\":35,\"max\":46}}},\"Samurai\":{\"primary\":{\"Asura\":{\"mode\":53,\"min\":52,\"max\":58},\"Bizen Boat\":{\"mode\":50,\"min\":50,\"max\":55},\"Chirijiraden\":{\"mode\":4,\"min\":3,\"max\":8},\"Heaven's Cloud\":{\"mode\":40,\"min\":40,\"max\":50},\"Kikuichimonji\":{\"mode\":32,\"min\":31,\"max\":48},\"Kiyomori\":{\"mode\":35,\"min\":35,\"max\":49},\"Koutetsu\":{\"mode\":48,\"min\":47,\"max\":55},\"Masamune\":{\"mode\":5,\"min\":4,\"max\":10},\"Muramasa\":{\"mode\":27,\"min\":27,\"max\":42},\"Murasame\":{\"mode\":41,\"min\":40,\"max\":51}},\"secondary\":{\"Asura\":{\"mode\":50,\"min\":45,\"max\":55},\"Bizen Boat\":{\"mode\":45,\"min\":40,\"max\":50},\"Chirijiraden\":{\"mode\":3,\"min\":2,\"max\":7},\"Heaven's Cloud\":{\"mode\":32,\"min\":28,\"max\":43},\"Kikuichimonji\":{\"mode\":23,\"min\":16,\"max\":35},\"Kiyomori\":{\"mode\":32,\"min\":24,\"max\":43},\"Koutetsu\":{\"mode\":42,\"min\":38,\"max\":48},\"Masamune\":{\"mode\":4,\"min\":2,\"max\":9},\"Muramasa\":{\"mode\":18,\"min\":13,\"max\":27},\"Murasame\":{\"mode\":34,\"min\":29,\"max\":44}}},\"Squire\":{\"primary\":{\"Accumulate\":{\"mode\":50,\"min\":50,\"max\":56},\"Cheer Up\":{\"mode\":35,\"min\":35,\"max\":49},\"Dash\":{\"mode\":40,\"min\":40,\"max\":50},\"Fury\":{\"mode\":35,\"min\":35,\"max\":49},\"Heal\":{\"mode\":73,\"min\":72,\"max\":75},\"Scream\":{\"mode\":25,\"min\":25,\"max\":37},\"Throw Stone\":{\"mode\":40,\"min\":40,\"max\":50},\"Tickle\":{\"mode\":40,\"min\":40,\"max\":50},\"Ultima\":{\"mode\":6,\"min\":5,\"max\":12},\"Wish\":{\"mode\":40,\"min\":40,\"max\":50},\"Yell\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Accumulate\":{\"mode\":45,\"min\":45,\"max\":51},\"Cheer Up\":{\"mode\":30,\"min\":30,\"max\":44},\"Dash\":{\"mode\":35,\"min\":35,\"max\":45},\"Fury\":{\"mode\":30,\"min\":30,\"max\":44},\"Heal\":{\"mode\":67,\"min\":67,\"max\":70},\"Scream\":{\"mode\":21,\"min\":21,\"max\":31},\"Throw Stone\":{\"mode\":35,\"min\":35,\"max\":45},\"Tickle\":{\"mode\":35,\"min\":35,\"max\":45},\"Ultima\":{\"mode\":5,\"min\":5,\"max\":10},\"Wish\":{\"mode\":35,\"min\":35,\"max\":45},\"Yell\":{\"mode\":35,\"min\":35,\"max\":45}}},\"Summoner\":{\"primary\":{\"Bahamut\":{\"mode\":18,\"min\":17,\"max\":28},\"Carbunkle\":{\"mode\":60,\"min\":60,\"max\":64},\"Cyclops\":{\"mode\":22,\"min\":21,\"max\":34},\"Fairy\":{\"mode\":40,\"min\":40,\"max\":50},\"Golem\":{\"mode\":40,\"min\":40,\"max\":50},\"Ifrit\":{\"mode\":40,\"min\":40,\"max\":50},\"Leviathan\":{\"mode\":40,\"min\":39,\"max\":50},\"Lich\":{\"mode\":30,\"min\":30,\"max\":45},\"Moogle\":{\"mode\":75,\"min\":75,\"max\":77},\"Odin\":{\"mode\":25,\"min\":24,\"max\":37},\"Ramuh\":{\"mode\":40,\"min\":40,\"max\":50},\"Salamander\":{\"mode\":35,\"min\":34,\"max\":49},\"Shiva\":{\"mode\":40,\"min\":40,\"max\":50},\"Sylph\":{\"mode\":40,\"min\":39,\"max\":50},\"Titan\":{\"mode\":40,\"min\":39,\"max\":50},\"Zodiac\":{\"mode\":3,\"min\":2,\"max\":8}},\"secondary\":{\"Bahamut\":{\"mode\":17,\"min\":16,\"max\":24},\"Carbunkle\":{\"mode\":56,\"min\":56,\"max\":59},\"Cyclops\":{\"mode\":19,\"min\":18,\"max\":27},\"Fairy\":{\"mode\":35,\"min\":35,\"max\":45},\"Golem\":{\"mode\":35,\"min\":35,\"max\":45},\"Ifrit\":{\"mode\":35,\"min\":35,\"max\":45},\"Leviathan\":{\"mode\":35,\"min\":35,\"max\":45},\"Lich\":{\"mode\":25,\"min\":25,\"max\":37},\"Moogle\":{\"mode\":70,\"min\":70,\"max\":72},\"Odin\":{\"mode\":21,\"min\":21,\"max\":31},\"Ramuh\":{\"mode\":35,\"min\":35,\"max\":45},\"Salamander\":{\"mode\":30,\"min\":30,\"max\":44},\"Shiva\":{\"mode\":35,\"min\":35,\"max\":45},\"Sylph\":{\"mode\":35,\"min\":35,\"max\":45},\"Titan\":{\"mode\":35,\"min\":35,\"max\":45},\"Zodiac\":{\"mode\":3,\"min\":3,\"max\":7}}},\"Thief\":{\"primary\":{\"Arm Aim\":{\"mode\":35,\"min\":35,\"max\":49},\"Gil Taking\":{\"mode\":38,\"min\":38,\"max\":50},\"Leg Aim\":{\"mode\":35,\"min\":35,\"max\":49},\"Steal Accessory\":{\"mode\":40,\"min\":40,\"max\":50},\"Steal Armor\":{\"mode\":40,\"min\":40,\"max\":50},\"Steal Heart\":{\"mode\":41,\"min\":41,\"max\":51},\"Steal Helmet\":{\"mode\":40,\"min\":40,\"max\":50},\"Steal Shield\":{\"mode\":40,\"min\":40,\"max\":50},\"Steal Status\":{\"mode\":33,\"min\":32,\"max\":49},\"Steal Weapon\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Arm Aim\":{\"mode\":30,\"min\":22,\"max\":44},\"Gil Taking\":{\"mode\":33,\"min\":25,\"max\":45},\"Leg Aim\":{\"mode\":30,\"min\":22,\"max\":44},\"Steal Accessory\":{\"mode\":35,\"min\":30,\"max\":45},\"Steal Armor\":{\"mode\":35,\"min\":30,\"max\":45},\"Steal Heart\":{\"mode\":36,\"min\":31,\"max\":46},\"Steal Helmet\":{\"mode\":35,\"min\":30,\"max\":45},\"Steal Shield\":{\"mode\":35,\"min\":30,\"max\":45},\"Steal Status\":{\"mode\":28,\"min\":20,\"max\":42},\"Steal Weapon\":{\"mode\":35,\"min\":30,\"max\":45}}},\"Time Mage\":{\"primary\":{\"Demi\":{\"mode\":40,\"min\":40,\"max\":50},\"Demi 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Float\":{\"mode\":40,\"min\":40,\"max\":50},\"Galaxy Stop\":{\"mode\":5,\"min\":5,\"max\":10},\"Haste\":{\"mode\":58,\"min\":58,\"max\":61},\"Haste 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Immobilize\":{\"mode\":40,\"min\":40,\"max\":50},\"Meteor\":{\"mode\":25,\"min\":25,\"max\":37},\"Mute\":{\"mode\":40,\"min\":40,\"max\":50},\"Old\":{\"mode\":35,\"min\":35,\"max\":49},\"Quick\":{\"mode\":40,\"min\":40,\"max\":50},\"Reflect\":{\"mode\":43,\"min\":42,\"max\":51},\"Slow\":{\"mode\":40,\"min\":40,\"max\":50},\"Slow 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Stabilize Time\":{\"mode\":68,\"min\":67,\"max\":71},\"Stop\":{\"mode\":40,\"min\":40,\"max\":50}},\"secondary\":{\"Demi\":{\"mode\":35,\"min\":35,\"max\":47},\"Demi 2\":{\"mode\":35,\"min\":35,\"max\":46},\"Float\":{\"mode\":35,\"min\":35,\"max\":47},\"Galaxy Stop\":{\"mode\":5,\"min\":4,\"max\":10},\"Haste\":{\"mode\":54,\"min\":53,\"max\":58},\"Haste 2\":{\"mode\":35,\"min\":35,\"max\":45},\"Immobilize\":{\"mode\":35,\"min\":35,\"max\":47},\"Meteor\":{\"mode\":21,\"min\":21,\"max\":31},\"Mute\":{\"mode\":35,\"min\":35,\"max\":46},\"Old\":{\"mode\":30,\"min\":30,\"max\":45},\"Quick\":{\"mode\":35,\"min\":35,\"max\":45},\"Reflect\":{\"mode\":38,\"min\":37,\"max\":48},\"Slow\":{\"mode\":35,\"min\":35,\"max\":46},\"Slow 2\":{\"mode\":35,\"min\":35,\"max\":45},\"Stabilize Time\":{\"mode\":62,\"min\":62,\"max\":67},\"Stop\":{\"mode\":35,\"min\":35,\"max\":47}}},\"Wizard\":{\"primary\":{\"Bolt\":{\"mode\":40,\"min\":40,\"max\":50},\"Bolt 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Bolt 3\":{\"mode\":40,\"min\":39,\"max\":50},\"Bolt 4\":{\"mode\":35,\"min\":34,\"max\":49},\"Death\":{\"mode\":25,\"min\":23,\"max\":37},\"Empower\":{\"mode\":30,\"min\":29,\"max\":45},\"Fire\":{\"mode\":40,\"min\":40,\"max\":50},\"Fire 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Fire 3\":{\"mode\":40,\"min\":39,\"max\":50},\"Fire 4\":{\"mode\":35,\"min\":34,\"max\":49},\"Flare\":{\"mode\":28,\"min\":25,\"max\":42},\"Frog\":{\"mode\":24,\"min\":22,\"max\":36},\"Ice\":{\"mode\":40,\"min\":40,\"max\":50},\"Ice 2\":{\"mode\":40,\"min\":40,\"max\":50},\"Ice 3\":{\"mode\":40,\"min\":39,\"max\":50},\"Ice 4\":{\"mode\":35,\"min\":34,\"max\":49}},\"secondary\":{\"Bolt\":{\"mode\":35,\"min\":35,\"max\":46},\"Bolt 2\":{\"mode\":35,\"min\":35,\"max\":46},\"Bolt 3\":{\"mode\":35,\"min\":35,\"max\":47},\"Bolt 4\":{\"mode\":30,\"min\":30,\"max\":44},\"Death\":{\"mode\":21,\"min\":21,\"max\":32},\"Empower\":{\"mode\":25,\"min\":25,\"max\":37},\"Fire\":{\"mode\":35,\"min\":35,\"max\":46},\"Fire 2\":{\"mode\":35,\"min\":35,\"max\":46},\"Fire 3\":{\"mode\":35,\"min\":35,\"max\":46},\"Fire 4\":{\"mode\":30,\"min\":30,\"max\":44},\"Flare\":{\"mode\":23,\"min\":23,\"max\":35},\"Frog\":{\"mode\":20,\"min\":20,\"max\":31},\"Ice\":{\"mode\":35,\"min\":35,\"max\":46},\"Ice 2\":{\"mode\":35,\"min\":35,\"max\":47},\"Ice 3\":{\"mode\":35,\"min\":35,\"max\":47},\"Ice 4\":{\"mode\":30,\"min\":30,\"max\":44}}}}");

});

parcelRegister("fMXIO", function(module, exports) {
module.exports = JSON.parse("{\"abilities\":[{\"name\":\"Cure\",\"info\":\"5 range, 1 AoE, 3 CT, 5 MP. Effect: Heal Faith(MA * 15).\",\"type\":\"active\"},{\"name\":\"Cure 2\",\"info\":\"5 range, 1 AoE, 4 CT, 10 MP. Effect: Heal Faith(MA * 20).\",\"type\":\"active\"},{\"name\":\"Cure 3\",\"info\":\"5 range, 1 AoE, 6 CT, 16 MP. Effect: Heal Faith(MA * 30).\",\"type\":\"active\"},{\"name\":\"Cure 4\",\"info\":\"5 range, 1 AoE, 8 CT, 24 MP. Effect: Heal Faith(MA * 40).\",\"type\":\"active\"},{\"name\":\"Raise\",\"info\":\"5 range, 0 AoE, 4 CT, 10 MP. Hit: Faith(MA + 190)%. Effect: Cancel Death; If successful, Heal (50)%.\",\"type\":\"active\"},{\"name\":\"Raise 2\",\"info\":\"5 range, 0 AoE, 9 CT, 20 MP. Hit: Faith(MA + 165)%. Effect: Cancel Death; If successful, Heal (100)%.\",\"type\":\"active\"},{\"name\":\"Reraise\",\"info\":\"4 range, 0 AoE, 7 CT, 14 MP. Hit: Faith(MA + 155)%. Effect: Add Reraise.\",\"type\":\"active\"},{\"name\":\"Regen\",\"info\":\"4 range, 1 AoE, 3 CT, 8 MP. Hit: Faith(MA + 175)%. Effect: Add Regen.\",\"type\":\"active\"},{\"name\":\"Protect\",\"info\":\"4 range, 1 AoE, 2 CT, 6 MP. Hit: Faith(MA + 200)%. Effect: Add Protect.\",\"type\":\"active\"},{\"name\":\"Protect 2\",\"info\":\"4 range, 1 AoE, 5 CT, 18 MP. Hit: Faith(MA + 245)%. Effect: Add Protect.\",\"type\":\"active\"},{\"name\":\"Shell\",\"info\":\"4 range, 1 AoE, 2 CT, 6 MP. Hit: Faith(MA + 200)%. Effect: Add Shell.\",\"type\":\"active\"},{\"name\":\"Shell 2\",\"info\":\"4 range, 1 AoE, 5 CT, 18 MP. Hit: Faith(MA + 245)%. Effect: Add Shell.\",\"type\":\"active\"},{\"name\":\"Wall\",\"info\":\"4 range, 0 AoE, 4 CT, 22 MP. Hit: Faith(MA + 145)%. Effect: Add Protect, Shell (All).\",\"type\":\"active\"},{\"name\":\"Esuna\",\"info\":\"5 range, 1 AoE, 2 CT, 17 MP. Hit: Faith(MA + 205)%. Effect: Cancel Petrify, Darkness, Confusion, Silence, Blood Suck, Berserk, Frog, Poison, Sleep, Don't Move, Don't Act.\",\"type\":\"active\"},{\"name\":\"Holy\",\"info\":\"5 range, 0 AoE, 6 CT, 53 MP. Element: Holy. Effect: Damage Faith(MA * 46).\",\"type\":\"active\"},{\"name\":\"Fire\",\"info\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Fire. Effect: Damage Faith(MA * 16).\",\"type\":\"active\"},{\"name\":\"Fire 2\",\"info\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Fire. Effect: Damage Faith(MA * 20).\",\"type\":\"active\"},{\"name\":\"Fire 3\",\"info\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Fire. Effect: Damage Faith(MA * 28).\",\"type\":\"active\"},{\"name\":\"Fire 4\",\"info\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Fire. Effect: Damage Faith(MA * 35).\",\"type\":\"active\"},{\"name\":\"Bolt\",\"info\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Lightning. Effect: Damage Faith(MA * 16).\",\"type\":\"active\"},{\"name\":\"Bolt 2\",\"info\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Lightning. Effect: Damage Faith(MA * 20).\",\"type\":\"active\"},{\"name\":\"Bolt 3\",\"info\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Lightning. Effect: Damage Faith(MA * 28).\",\"type\":\"active\"},{\"name\":\"Bolt 4\",\"info\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Lightning. Effect: Damage Faith(MA * 35).\",\"type\":\"active\"},{\"name\":\"Ice\",\"info\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Ice. Effect: Damage Faith(MA * 16).\",\"type\":\"active\"},{\"name\":\"Ice 2\",\"info\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Ice. Effect: Damage Faith(MA * 20).\",\"type\":\"active\"},{\"name\":\"Ice 3\",\"info\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Ice. Effect: Damage Faith(MA * 28).\",\"type\":\"active\"},{\"name\":\"Ice 4\",\"info\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Ice. Effect: Damage Faith(MA * 35).\",\"type\":\"active\"},{\"name\":\"Poison\",\"info\":\"5 range, 1 AoE, 3 CT, 4 MP. Hit: Faith(MA + 195)%. Effect: Add Poison.\",\"type\":\"active\"},{\"name\":\"Frog\",\"info\":\"4 range, 0 AoE, 5 CT, 11 MP. Hit: Faith(MA + 125)%. Effect: Add Frog.\",\"type\":\"active\"},{\"name\":\"Death\",\"info\":\"5 range, 0 AoE, 10 CT, 28 MP. Hit: Faith(MA + 113)%. Effect: Add Death; If successful, Damage (100)%; If Undead, Heal (100)% instead.\",\"type\":\"active\"},{\"name\":\"Flare\",\"info\":\"6 range, 0 AoE, 7 CT, 60 MP. Effect: Damage Faith(MA * 48).\",\"type\":\"active\"},{\"name\":\"Haste\",\"info\":\"4 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 185)%. Effect: Add Haste.\",\"type\":\"active\"},{\"name\":\"Haste 2\",\"info\":\"4 range, 1 AoE, 5 CT, 20 MP. Hit: Faith(MA + 240)%. Effect: Add Haste.\",\"type\":\"active\"},{\"name\":\"Slow\",\"info\":\"4 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 185)%. Effect: Add Slow.\",\"type\":\"active\"},{\"name\":\"Slow 2\",\"info\":\"4 range, 1 AoE, 5 CT, 20 MP. Hit: Faith(MA + 240)%. Effect: Add Slow.\",\"type\":\"active\"},{\"name\":\"Stop\",\"info\":\"4 range, 1 AoE, 7 CT, 16 MP. Hit: Faith(MA + 140)%. Effect: Add Stop.\",\"type\":\"active\"},{\"name\":\"Immobilize\",\"info\":\"5 range, 1 AoE, 4 CT, 10 MP. Hit: Faith(MA + 190)%. Effect: Add Don't Move.\",\"type\":\"active\"},{\"name\":\"Float\",\"info\":\"5 range, 1 AoE, 2 CT, 3 MP. Hit: Faith(MA + 170)%. Effect: Add Float.\",\"type\":\"active\"},{\"name\":\"Reflect\",\"info\":\"5 range, 0 AoE, 2 CT, 12 MP. Hit: Faith(MA + 180)%. Effect: Add Reflect.\",\"type\":\"active\"},{\"name\":\"Quick\",\"info\":\"6 range, 0 AoE, 3 CT, 24 MP. Hit: Faith(MA + 160)%. Effect: Set CT to 100 (Quick).\",\"type\":\"active\"},{\"name\":\"Demi\",\"info\":\"5 range, 1 AoE, 3 CT, 18 MP. Hit: Faith(MA + 208)%. Effect: Damage (25)%.\",\"type\":\"active\"},{\"name\":\"Demi 2\",\"info\":\"5 range, 1 AoE, 6 CT, 40 MP. Hit: Faith(MA + 165)%. Effect: Damage (50)%.\",\"type\":\"active\"},{\"name\":\"Meteor\",\"info\":\"5 range, 3 AoE, 12 CT, 70 MP. Effect: Damage Faith(MA * 60).\",\"type\":\"active\"},{\"name\":\"Blind\",\"info\":\"5 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 200)%. Effect: Add Darkness.\",\"type\":\"active\"},{\"name\":\"Spell Absorb\",\"info\":\"5 range, 0 AoE, 2 CT, 2 MP. Hit: Faith(MA + 192)%. Effect: AbsorbMP (33)%.\",\"type\":\"active\"},{\"name\":\"Life Drain\",\"info\":\"5 range, 0 AoE, 2 CT, 16 MP. Hit: Faith(MA + 188)%. Effect: AbsorbHP (25)%.\",\"type\":\"active\"},{\"name\":\"Pray Faith\",\"info\":\"5 range, 0 AoE, 4 CT, 7 MP. Hit: Faith(MA + 155)%. Effect: Add Faith.\",\"type\":\"active\"},{\"name\":\"Doubt Faith\",\"info\":\"5 range, 0 AoE, 4 CT, 7 MP. Hit: Faith(MA + 155)%. Effect: Add Innocent.\",\"type\":\"active\"},{\"name\":\"Zombie\",\"info\":\"5 range, 0 AoE, 4 CT, 19 MP. Hit: Faith(MA + 150)%. Effect: Add Undead.\",\"type\":\"active\"},{\"name\":\"Silence\",\"info\":\"5 range, 1 AoE, 3 CT, 15 MP. Hit: Faith(MA + 180)%. Effect: Add Silence.\",\"type\":\"active\"},{\"name\":\"Enrage\",\"info\":\"5 range, 0 AoE, 5 CT, 18 MP. Hit: Faith(MA + 135)%. Effect: Add Berserk.\",\"type\":\"active\"},{\"name\":\"Foxbird\",\"info\":\"6 range, 0 AoE, 4 CT, 11 MP. Hit: Faith(MA + 170)%. Effect: -30 Brave.\",\"type\":\"active\"},{\"name\":\"Confuse\",\"info\":\"5 range, 1 AoE, 4 CT, 20 MP. Hit: Faith(MA + 160)%. Effect: Add Confusion.\",\"type\":\"active\"},{\"name\":\"Dispel Magic\",\"info\":\"5 range, 1 AoE, 3 CT, 32 MP. Hit: Faith(MA + 205)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"active\"},{\"name\":\"Paralyze\",\"info\":\"5 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 185)%. Effect: Add Don't Act.\",\"type\":\"active\"},{\"name\":\"Sleep\",\"info\":\"5 range, 1 AoE, 6 CT, 22 MP. Hit: Faith(MA + 175)%. Effect: Add Sleep.\",\"type\":\"active\"},{\"name\":\"Petrify\",\"info\":\"5 range, 0 AoE, 8 CT, 17 MP. Hit: Faith(MA + 130)%. Effect: Add Petrify.\",\"type\":\"active\"},{\"name\":\"Moogle\",\"info\":\"4 range, 2 AoE (homing), 3 CT, 20 MP. Hit: Faith(MA + 150)%. Effect: Cancel Darkness, Confusion, Silence, Blood Suck, Oil, Berserk, Frog, Poison, Don't Move, Don't Act; If successful, Heal (10)%.\",\"type\":\"active\"},{\"name\":\"Shiva\",\"info\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Ice. Effect: Damage Faith(MA * 23).\",\"type\":\"active\"},{\"name\":\"Ramuh\",\"info\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Lightning. Effect: Damage Faith(MA * 23).\",\"type\":\"active\"},{\"name\":\"Ifrit\",\"info\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Fire. Effect: Damage Faith(MA * 23).\",\"type\":\"active\"},{\"name\":\"Titan\",\"info\":\"4 range, 2 AoE (homing), 5 CT, 34 MP. Element: Earth. Effect: Damage Faith(MA * 27).\",\"type\":\"active\"},{\"name\":\"Golem\",\"info\":\"0 range, 0 AoE (global), 4 CT, 38 MP. Hit: ((MA + 225) * (Faith / 100))%. Effect: Set target team's Golem to MaxHP; Until depleted, any damage from a basic Attack or Throw ability is dealt to the Golem instead.\",\"type\":\"active\"},{\"name\":\"Carbunkle\",\"info\":\"4 range, 2 AoE (homing), 8 CT, 36 MP. Hit: Faith(MA + 140)%. Effect: Cancel Death, Undead, Petrify, Charm, Sleep, Death Sentence; If successful, Heal (20)%.\",\"type\":\"active\"},{\"name\":\"Bahamut\",\"info\":\"4 range, 3 AoE (homing), 11 CT, 62 MP. Element: Dark. Effect: Damage Faith(MA * 44).\",\"type\":\"active\"},{\"name\":\"Odin\",\"info\":\"4 range, 3 AoE (homing), 10 CT, 56 MP. Element: Holy. Effect: Damage Faith(MA * 39).\",\"type\":\"active\"},{\"name\":\"Leviathan\",\"info\":\"4 range, 3 AoE (homing), 9 CT, 50 MP. Element: Water. Effect: Damage Faith(MA * 36).\",\"type\":\"active\"},{\"name\":\"Salamander\",\"info\":\"4 range, 2 AoE (homing), 8 CT, 46 MP. Element: Fire. Effect: Damage Faith(MA * 32); Chance to add Oil.\",\"type\":\"active\"},{\"name\":\"Sylph\",\"info\":\"4 range, 2 AoE (homing), 7 CT, 42 MP. Element: Wind. Effect: Damage Faith(MA * 30); Chance to add Silence.\",\"type\":\"active\"},{\"name\":\"Fairy\",\"info\":\"4 range, 2 AoE (homing), 6 CT, 30 MP. Effect: Heal Faith(MA * 24).\",\"type\":\"active\"},{\"name\":\"Lich\",\"info\":\"4 range, 2 AoE (homing), 9 CT, 44 MP. Element: Dark. Hit: Faith(MA + 160)%. Effect: Damage (60)%.\",\"type\":\"active\"},{\"name\":\"Cyclops\",\"info\":\"4 range, 2 AoE (homing), 11 CT, 66 MP. Effect: Damage Faith(MA * 50).\",\"type\":\"active\"},{\"name\":\"Zodiac\",\"info\":\"4 range, 3 AoE (homing), 13 CT, 99 MP. Effect: Damage Faith(MA * 90).\",\"type\":\"active\"},{\"name\":\"Asura\",\"info\":\"0 range, 2 AoE. Effect: Damage (MA * 8); Chance to cancel Defending, Float, Berserk, Regen, Protect, Shell, Haste, Slow.\",\"type\":\"active\"},{\"name\":\"Koutetsu\",\"info\":\"0 range, 2 AoE. Effect: Damage (MA * 10); Chance to add Oil, Darkness (Random).\",\"type\":\"active\"},{\"name\":\"Bizen Boat\",\"info\":\"0 range, 2 AoE. Effect: DamageMP (MA * 5).\",\"type\":\"active\"},{\"name\":\"Murasame\",\"info\":\"0 range, 2 AoE. Effect: Heal (MA * 9).\",\"type\":\"active\"},{\"name\":\"Heaven's Cloud\",\"info\":\"0 range, 2 AoE. Effect: Damage (MA * 11); Chance to add Slow.\",\"type\":\"active\"},{\"name\":\"Kiyomori\",\"info\":\"0 range, 2 AoE. Effect: Add Protect, Shell (Random).\",\"type\":\"active\"},{\"name\":\"Muramasa\",\"info\":\"0 range, 2 AoE. Effect: Damage (MA * 14); Chance to add Confusion, Death Sentence (Random).\",\"type\":\"active\"},{\"name\":\"Kikuichimonji\",\"info\":\"6 range, 6 AoE (linear). Effect: Damage (MA * 12).\",\"type\":\"active\"},{\"name\":\"Masamune\",\"info\":\"0 range, 2 AoE. Effect: Add Regen, Haste (Random).\",\"type\":\"active\"},{\"name\":\"Chirijiraden\",\"info\":\"0 range, 2 AoE. Effect: Damage (MA * 17).\",\"type\":\"active\"},{\"name\":\"Angel Song\",\"info\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: HealMP (MA + 20).\",\"type\":\"active\"},{\"name\":\"Life Song\",\"info\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: Heal (MA + 20).\",\"type\":\"active\"},{\"name\":\"Cheer Song\",\"info\":\"0 range, 255 AoE (homing), 6 CT (recurring). Hit: (50)%. Effect: +1 Speed.\",\"type\":\"active\"},{\"name\":\"Battle Song\",\"info\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: +1 PA.\",\"type\":\"active\"},{\"name\":\"Magic Song\",\"info\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: +1 MA.\",\"type\":\"active\"},{\"name\":\"Nameless Song\",\"info\":\"0 range, 255 AoE (homing), 9 CT (recurring), 5 MP. Hit: (50)%. Effect: Add Reraise, Regen, Protect, Shell, Haste (Random).\",\"type\":\"active\"},{\"name\":\"Last Song\",\"info\":\"0 range, 255 AoE (homing), 8 CT (recurring). Hit: (33)%. Effect: Set CT to 100 (Quick).\",\"type\":\"active\"},{\"name\":\"Witch Hunt\",\"info\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: DamageMP (PA + (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Wiznaibus\",\"info\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: Damage (PA + (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Slow Dance\",\"info\":\"0 range, 255 AoE (homing), 6 CT (recurring). Hit: (50)%. Effect: -1 Speed.\",\"type\":\"active\"},{\"name\":\"Polka Polka\",\"info\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: -1 PA.\",\"type\":\"active\"},{\"name\":\"Disillusion\",\"info\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: -1 MA.\",\"type\":\"active\"},{\"name\":\"Nameless Dance\",\"info\":\"0 range, 255 AoE (homing), 10 CT (recurring), 5 MP. Hit: (50)%. Effect: Add Darkness, Confusion, Silence, Frog, Poison, Slow, Stop, Sleep (Random).\",\"type\":\"active\"},{\"name\":\"Last Dance\",\"info\":\"0 range, 255 AoE (homing), 8 CT (recurring). Hit: (33)%. Effect: Set CT to 0 (0 CT).\",\"type\":\"active\"},{\"name\":\"Spin Fist\",\"info\":\"0 range, 1 AoE. Effect: Damage (PA * ((PA + 1) / 2)).\",\"type\":\"active\"},{\"name\":\"Pummel\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,9) * 3 / 2).\",\"type\":\"active\"},{\"name\":\"Wave Fist\",\"info\":\"3 range, 0 AoE. Element: Wind. Effect: Damage (PA * ((PA + 2) / 2)).\",\"type\":\"active\"},{\"name\":\"Earth Slash\",\"info\":\"8 range, 8 AoE (linear). Element: Earth. Effect: Damage (PA * (PA / 2)).\",\"type\":\"active\"},{\"name\":\"Secret Fist\",\"info\":\"1 range, 0 AoE. Hit: (MA + 50)%. Effect: Add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Purification\",\"info\":\"0 range, 1 AoE. Hit: (PA + 77)%. Effect: Cancel Petrify, Darkness, Confusion, Silence, Blood Suck, Berserk, Frog, Poison, Sleep, Don't Move, Don't Act.\",\"type\":\"active\"},{\"name\":\"Chakra\",\"info\":\"0 range, 1 AoE. Effect: Heal (PA * 5); HealMP (PA * 5 / 2).\",\"type\":\"active\"},{\"name\":\"Revive\",\"info\":\"1 range, 0 AoE. Hit: (PA + 69)%. Effect: Cancel Death; If successful, Heal (25)%.\",\"type\":\"active\"},{\"name\":\"Gil Taking\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 63)%. Effect: Add Defending, Berserk (Random).\",\"type\":\"active\"},{\"name\":\"Steal Heart\",\"info\":\"3 range, 0 AoE. Hit: Different Sex; (MA + 45)%. Effect: Add Charm.\",\"type\":\"active\"},{\"name\":\"Steal Helmet\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 60)%. Effect: Remove target's head equipment.\",\"type\":\"active\"},{\"name\":\"Steal Armor\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 55)%. Effect: Remove target's body equipment.\",\"type\":\"active\"},{\"name\":\"Steal Shield\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 50)%. Effect: Remove target's shield.\",\"type\":\"active\"},{\"name\":\"Steal Weapon\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 65)%. Effect: Remove target's weapon.\",\"type\":\"active\"},{\"name\":\"Steal Accessory\",\"info\":\"2 range, 0 AoE. Hit: (Speed + 70)%. Effect: Remove target's accessory.\",\"type\":\"active\"},{\"name\":\"Rehabilitate\",\"info\":\"4 range, 0 AoE. Effect: HealMP (MA * 3).\",\"type\":\"active\"},{\"name\":\"Invitation\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 37)%. Effect: Add Confusion, Charm (Random).\",\"type\":\"active\"},{\"name\":\"Persuade\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 59)%. Effect: Set CT to 0 (0 CT).\",\"type\":\"active\"},{\"name\":\"Praise\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 81)%. Effect: +5 Brave.\",\"type\":\"active\"},{\"name\":\"Threaten\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 89)%. Effect: -20 Brave.\",\"type\":\"active\"},{\"name\":\"Preach\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 81)%. Effect: +5 Faith.\",\"type\":\"active\"},{\"name\":\"Solution\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 89)%. Effect: -20 Faith.\",\"type\":\"active\"},{\"name\":\"Death Sentence\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 34)%. Effect: Add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Steal Status\",\"info\":\"2 range, 0 AoE. Hit: Faith(MA + 173)%. Effect: Cancel statuses on target and add them to caster.\",\"type\":\"active\"},{\"name\":\"Insult\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 39)%. Effect: Add Berserk.\",\"type\":\"active\"},{\"name\":\"Mimic Daravon\",\"info\":\"3 range, 1 AoE. Hit: Human; (MA + 43)%. Effect: Add Sleep.\",\"type\":\"active\"},{\"name\":\"Pitfall\",\"info\":\"5 range, 1 AoE. Terrain: Dirt, Wasteland, Road, Pit. Element: Dark. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Don't Move.\",\"type\":\"active\"},{\"name\":\"Water Ball\",\"info\":\"5 range, 1 AoE. Terrain: Canal, River, Lake, Ocean, Waterfall, Pool. Element: Water. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Frog.\",\"type\":\"active\"},{\"name\":\"Hell Ivy\",\"info\":\"5 range, 1 AoE. Terrain: Grassland, Thicket, Ivy, Plant. Element: Earth. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Stop.\",\"type\":\"active\"},{\"name\":\"Hallowed Ground\",\"info\":\"5 range, 1 AoE. Terrain: Gravel, Marble, Wall, Mud, Tomb. Element: Holy. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Petrify, Oil (Random).\",\"type\":\"active\"},{\"name\":\"Local Quake\",\"info\":\"5 range, 1 AoE. Terrain: Stone, Basalt. Element: Earth. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Confusion.\",\"type\":\"active\"},{\"name\":\"Static Shock\",\"info\":\"5 range, 1 AoE. Terrain: Book, Tree, Brick, Bridge, Furniture, Iron, Moss, Coffin, Barrier. Element: Lightning. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Don't Act.\",\"type\":\"active\"},{\"name\":\"Will-O-Wisp\",\"info\":\"5 range, 1 AoE. Terrain: Wood, Carpet, Box, Stairs, Deck, Obstacle. Element: Fire. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Sleep.\",\"type\":\"active\"},{\"name\":\"Quicksand\",\"info\":\"5 range, 1 AoE. Terrain: Marsh, Swamp, Sludge. Element: Water. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Sand Storm\",\"info\":\"5 range, 1 AoE. Terrain: Sand, Stalactite, Salt. Element: Wind. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Darkness.\",\"type\":\"active\"},{\"name\":\"Blizzard\",\"info\":\"5 range, 1 AoE. Terrain: Snow, Glacier. Element: Ice. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Silence.\",\"type\":\"active\"},{\"name\":\"Gusty Wind\",\"info\":\"5 range, 1 AoE. Terrain: Roof, Chimney, Sky. Element: Wind. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Slow.\",\"type\":\"active\"},{\"name\":\"Lava Ball\",\"info\":\"5 range, 1 AoE. Terrain: Lava, Machine. Element: Fire. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Death.\",\"type\":\"active\"},{\"name\":\"Head Rend\",\"info\":\"weapon range, 0 AoE. Hit: (PA + WP + 40)%. Effect: Remove target's head equipment; If none is equipped, basic Attack instead.\",\"type\":\"active\"},{\"name\":\"Armor Rend\",\"info\":\"weapon range, 0 AoE. Hit: (PA + WP + 48)%. Effect: Remove target's body equipment; If none is equipped, basic Attack instead.\",\"type\":\"active\"},{\"name\":\"Shield Rend\",\"info\":\"weapon range, 0 AoE. Hit: (PA + WP + 56)%. Effect: Remove target's shield; If none is equipped, basic Attack instead.\",\"type\":\"active\"},{\"name\":\"Weapon Rend\",\"info\":\"weapon range, 0 AoE. Hit: (PA + WP + 32)%. Effect: Remove target's weapon; If none is equipped, basic Attack instead.\",\"type\":\"active\"},{\"name\":\"Magic Ruin\",\"info\":\"weapon range, 0 AoE. Hit: (PA + 50)%. Effect: DamageMP (50)%.\",\"type\":\"active\"},{\"name\":\"Speed Break\",\"info\":\"weapon range, 0 AoE. Hit: (PA + 54)%. Effect: -2 Speed.\",\"type\":\"active\"},{\"name\":\"Power Break\",\"info\":\"weapon range, 0 AoE. Hit: (PA + 52)%. Effect: -3 PA.\",\"type\":\"active\"},{\"name\":\"Mind Break\",\"info\":\"weapon range, 0 AoE. Hit: (PA + 52)%. Effect: -3 MA.\",\"type\":\"active\"},{\"name\":\"Accumulate\",\"info\":\"0 range, 0 AoE. Effect: +1 PA, +1 MA.\",\"type\":\"active\"},{\"name\":\"Dash\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,4)); Chance to knockback.\",\"type\":\"active\"},{\"name\":\"Throw Stone\",\"info\":\"4 range, 0 AoE. Effect: Damage (PA * Random(1,2)); Chance to knockback.\",\"type\":\"active\"},{\"name\":\"Heal\",\"info\":\"1 range, 0 AoE. Effect: Cancel Darkness, Silence, Oil, Poison, Don't Act.\",\"type\":\"active\"},{\"name\":\"Yell\",\"info\":\"3 range, 0 AoE. Effect: +1 Speed.\",\"type\":\"active\"},{\"name\":\"Cheer Up\",\"info\":\"3 range, 0 AoE. Hit: (MA + 87)%. Effect: Add Defending, Float, Reraise, Transparent, Regen, Faith (Separate).\",\"type\":\"active\"},{\"name\":\"Wish\",\"info\":\"1 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"type\":\"active\"},{\"name\":\"Scream\",\"info\":\"0 range, 0 AoE, 2 CT. Effect: +3 Brave, +1 PA, +1 MA, +1 Speed.\",\"type\":\"active\"},{\"name\":\"Ultima\",\"info\":\"5 range, 1 AoE, 5 CT, 9 MP. Element: Holy. Effect: Damage Faith(MA * 25).\",\"type\":\"active\"},{\"name\":\"Stasis Sword\",\"info\":\"1 range, 1 AoE, 3 CT, 19 MP. Effect: Damage (PA * (WP + 1)); Chance to add Stop.\",\"type\":\"active\"},{\"name\":\"Justice Sword\",\"info\":\"2 range, 0 AoE, 2 CT, 21 MP. Effect: Damage (PA * (WP + 2)); Chance to add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Surging Sword\",\"info\":\"1 range, 1 AoE, 4 CT, 25 MP. Effect: Damage (PA * (WP + 2)); Chance to add Silence.\",\"type\":\"active\"},{\"name\":\"Explosion Sword\",\"info\":\"4 range, 4 AoE (linear), 2 CT, 27 MP. Effect: Damage (PA * (WP + 3)); Chance to add Confusion.\",\"type\":\"active\"},{\"name\":\"Shellbust Stab\",\"info\":\"3 range, 1 AoE, 15 MP. Effect: Remove target's body equipment; If successful, Damage (PA * (WP + 5)).\",\"type\":\"active\"},{\"name\":\"Blastar Punch\",\"info\":\"3 range, 1 AoE, 9 MP. Effect: Remove target's head equipment; If successful, Damage (PA * (WP + 2)).\",\"type\":\"active\"},{\"name\":\"Hellcry Crush\",\"info\":\"3 range, 1 AoE, 13 MP. Effect: Remove target's weapon; If successful, Damage (PA * (WP + 4)).\",\"type\":\"active\"},{\"name\":\"Icewolf Bite\",\"info\":\"3 range, 1 AoE, 11 MP. Effect: Remove target's accessory; If successful, Damage (PA * (WP + 3)).\",\"type\":\"active\"},{\"name\":\"Unyielding Cut\",\"info\":\"2 range, 0 AoE, 19 MP, 4 CT. Effect: If target is equipped with any item except for a Shield, Damage (PA * (WP + 1)). If none is equipped, Damage (PA * (WP + TargetMA / 2)).\",\"type\":\"active\"},{\"name\":\"Siphon\",\"info\":\"1 range, 0 AoE. Hit: (MA + 70)%. Effect: AbsorbMP (25)%.\",\"type\":\"active\"},{\"name\":\"Dark Sword\",\"info\":\"2 range, 0 AoE, 3 CT, 17 MP. Effect: AbsorbMP (PA * WP).\",\"type\":\"active\"},{\"name\":\"Night Sword\",\"info\":\"2 range, 0 AoE, 3 CT, 23 MP. Effect: AbsorbHP (PA * WP).\",\"type\":\"active\"},{\"name\":\"Dark Holy\",\"info\":\"5 range, 0 AoE, 7 CT, 41 MP. Element: Dark. Effect: Damage Faith(MA * 41).\",\"type\":\"active\"},{\"name\":\"Galaxy Stop\",\"info\":\"0 range, 255 AoE (homing), 14 CT, 64 MP. Hit: Different Zodiac; (MA + 47)%. Effect: Add Stop, Don't Move, Don't Act (All).\",\"type\":\"active\"},{\"name\":\"Diamond Blade\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Wind. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"type\":\"active\"},{\"name\":\"Hydra Pit\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Water. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"type\":\"active\"},{\"name\":\"Space Storage\",\"info\":\"4 range, 1 AoE (multihit), 4 CT, 13 MP. Element: Holy. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 15) / 2)); Chance to add Darkness, Confusion, Silence, Frog, Poison, Slow, Sleep (Random).\",\"type\":\"active\"},{\"name\":\"Sky Demon\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Earth. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"type\":\"active\"},{\"name\":\"Obsidian Blade\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Wind. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"type\":\"active\"},{\"name\":\"Dragon Pit\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Water. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"type\":\"active\"},{\"name\":\"Void Storage\",\"info\":\"4 range, 1 AoE (multihit), 4 CT, 13 MP. Element: Dark. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 111) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)); Chance to add Darkness, Confusion, Silence, Frog, Poison, Slow, Sleep (Random).\",\"type\":\"active\"},{\"name\":\"Nether Demon\",\"info\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Earth. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"type\":\"active\"},{\"name\":\"Tickle\",\"info\":\"1 range, 0 AoE. Hit: (MA + 67)%. Effect: Cancel Charging, Defending, Performing, Confusion, Charm, Sleep.\",\"type\":\"active\"},{\"name\":\"Vengeance\",\"info\":\"5 range, 0 AoE. Effect: Damage (MaxHP - CurrentHP).\",\"type\":\"active\"},{\"name\":\"Manaburn\",\"info\":\"5 range, 0 AoE. Effect: Damage (TargetCurrentMP).\",\"type\":\"active\"},{\"name\":\"Stabilize Time\",\"info\":\"4 range, 1 AoE, 1 CT, 14 MP. Hit: Faith(MA + 195)%. Effect: Cancel Slow, Stop, Don't Move, Death Sentence.\",\"type\":\"active\"},{\"name\":\"Bio Tenebris\",\"info\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Wind. Effect: Damage Faith(MA * 13); Chance to add Darkness.\",\"type\":\"active\"},{\"name\":\"Bio Venenum\",\"info\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Water. Effect: Damage Faith(MA * 13); Chance to add Poison.\",\"type\":\"active\"},{\"name\":\"Bio Oleum\",\"info\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Earth. Effect: Damage Faith(MA * 13); Chance to add Oil.\",\"type\":\"active\"},{\"name\":\"Bio Ranae\",\"info\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 117)%. Effect: Add Frog.\",\"type\":\"active\"},{\"name\":\"Bio Tardus\",\"info\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 120)%. Effect: Add Slow.\",\"type\":\"active\"},{\"name\":\"Bio Silentium\",\"info\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 123)%. Effect: Add Silence.\",\"type\":\"active\"},{\"name\":\"Bio Lapis\",\"info\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 115)%. Effect: Add Petrify.\",\"type\":\"active\"},{\"name\":\"Bio Immortuos\",\"info\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Water. Effect: Damage Faith(MA * 26); Chance to add Undead.\",\"type\":\"active\"},{\"name\":\"Bio Mortem\",\"info\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Earth. Effect: Damage Faith(MA * 26); Chance to add Death.\",\"type\":\"active\"},{\"name\":\"Bio Insanis\",\"info\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Wind. Effect: Damage Faith(MA * 26); Chance to add Confusion.\",\"type\":\"active\"},{\"name\":\"Magic Barrier\",\"info\":\"3 range, 0 AoE, 9 CT, 35 MP. Hit: Faith(MA + 202)%. Effect: Add Reraise, Regen, Protect, Shell, Haste (All).\",\"type\":\"active\"},{\"name\":\"Fury\",\"info\":\"0 range, 0 AoE. Hit: (PA + 85)%. Effect: Add Berserk, Haste (All); If successful, Heal (35)%.\",\"type\":\"active\"},{\"name\":\"Leg Aim\",\"info\":\"weapon range, 0 AoE. Hit: (Speed + 46)%. Effect: Add Don't Move.\",\"type\":\"active\"},{\"name\":\"Arm Aim\",\"info\":\"weapon range, 0 AoE. Hit: (Speed + 42)%. Effect: Add Don't Act.\",\"type\":\"active\"},{\"name\":\"Seal Evil\",\"info\":\"weapon range, 0 AoE. Hit: Undead; (Speed + 58)%. Effect: Add Petrify.\",\"type\":\"active\"},{\"name\":\"Mute\",\"info\":\"5 range, 1 AoE, 3 CT, 9 MP. Hit: Faith(MA + 210)%. Effect: DamageMP (35)%.\",\"type\":\"active\"},{\"name\":\"Old\",\"info\":\"6 range, 0 AoE, 4 CT, 5 MP. Hit: Faith(MA + 222)%. Effect: -2 PA, -2 MA, -1 Speed.\",\"type\":\"active\"},{\"name\":\"Despair 2\",\"info\":\"4 range, 2 AoE (homing), 5 CT, 22 MP. Hit: Faith(MA + 196)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"active\"},{\"name\":\"Chicken\",\"info\":\"5 range, 1 AoE, 5 CT, 19 MP. Hit: Faith(MA + 199)%. Effect: -40 Brave.\",\"type\":\"active\"},{\"name\":\"Despair\",\"info\":\"6 range, 0 AoE, 2 CT, 9 MP. Hit: Faith(MA + 214)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"active\"},{\"name\":\"Refute\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 75)%. Effect: Cancel Undead, Confusion, Blood Suck, Reraise, Berserk, Faith, Innocent, Charm, Death Sentence.\",\"type\":\"active\"},{\"name\":\"Empower\",\"info\":\"4 range, 0 AoE, 9 CT, 13 MP. Hit: Faith(MA + 236)%. Effect: +2 PA, +2 MA, +2 Speed.\",\"type\":\"active\"},{\"name\":\"Negotiate\",\"info\":\"4 range, 0 AoE. Hit: Human; (MA + 41)%. Effect: Add Slow, Stop (Random).\",\"type\":\"active\"},{\"name\":\"Noxious Gas\",\"info\":\"3 range, 1 AoE. Hit: Faith(MA + 231)%. Effect: Add Defending, Darkness, Oil, Poison, Slow, Don't Move, Death Sentence (Separate).\",\"type\":\"active\"},{\"name\":\"Holy Breath\",\"info\":\"2 range, 0 AoE (linear). Element: Holy. Effect: Damage (MA * 5).\",\"type\":\"active\"},{\"name\":\"Braver\",\"info\":\"2 range, 1 AoE, 3 CT. Effect: Damage (MA * 16).\",\"type\":\"active\"},{\"name\":\"Cross-Slash\",\"info\":\"3 range, 3 AoE (trilinear), 4 CT. Effect: Damage (MA * 22).\",\"type\":\"active\"},{\"name\":\"Blade Beam\",\"info\":\"3 range, 0 AoE, 5 CT. Effect: Damage ((125 - Brave) * TargetBrave / 16).\",\"type\":\"active\"},{\"name\":\"Climhazzard\",\"info\":\"4 range, 0 AoE, 6 CT. Effect: Damage (TargetMaxHP - TargetCurrentHP).\",\"type\":\"active\"},{\"name\":\"Meteorain\",\"info\":\"3 range, 2 AoE, 9 CT. Effect: Damage (MA * 26).\",\"type\":\"active\"},{\"name\":\"Finish Touch\",\"info\":\"2 range, 1 AoE, 7 CT, 28 MP. Effect: Add Death, Petrify, Stop (Random).\",\"type\":\"active\"},{\"name\":\"Omnislash\",\"info\":\"3 range, 1 AoE, 11 CT. Effect: Damage (MA * 40).\",\"type\":\"active\"},{\"name\":\"Cherry Blossom\",\"info\":\"3 range, 2 AoE, 15 CT. Effect: Damage (MA * 58).\",\"type\":\"active\"},{\"name\":\"Choco Attack\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Charging, Performing.\",\"type\":\"active\"},{\"name\":\"Choco Ball\",\"info\":\"4 range, 0 AoE. Element: Water. Effect: Damage (PA * ((PA + 1) / 2)).\",\"type\":\"active\"},{\"name\":\"Choco Meteor\",\"info\":\"5 range, 0 AoE. Effect: Damage (MA * 4).\",\"type\":\"active\"},{\"name\":\"Choco Esuna\",\"info\":\"0 range, 1 AoE. Hit: (MA + 64)%. Effect: Cancel Undead, Petrify, Darkness, Silence, Poison, Stop, Innocent, Don't Move, Don't Act.\",\"type\":\"active\"},{\"name\":\"Choco Cure\",\"info\":\"0 range, 1 AoE. Effect: Heal (MA * 3).\",\"type\":\"active\"},{\"name\":\"Tackle\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Don't Move, Don't Act (Random).\",\"type\":\"active\"},{\"name\":\"Goblin Punch\",\"info\":\"1 range, 0 AoE. Hit: (MA + 46)%. Effect: Damage ((MaxHP - CurrentHP) * 5 / 4).\",\"type\":\"active\"},{\"name\":\"Turn Punch\",\"info\":\"0 range, 1 AoE. Effect: Damage (PA * ((PA + 3) / 2)).\",\"type\":\"active\"},{\"name\":\"Eye Gouge\",\"info\":\"1 range, 0 AoE. Hit: (MA + 54)%. Effect: Add Darkness, Confusion (All).\",\"type\":\"active\"},{\"name\":\"Mutilate\",\"info\":\"1 range, 0 AoE. Hit: (MA + 35)%. Effect: AbsorbHP (66)%.\",\"type\":\"active\"},{\"name\":\"Bite\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Oil.\",\"type\":\"active\"},{\"name\":\"Small Bomb\",\"info\":\"4 range, 0 AoE. Element: Dark. Effect: Damage Faith(MA * 9); Chance to add Oil.\",\"type\":\"active\"},{\"name\":\"Self Destruct\",\"info\":\"0 range, 2 AoE. Effect: Damage (MaxHP - CurrentHP); DamageCaster (CurrentHP); Add Oil.\",\"type\":\"active\"},{\"name\":\"Flame Attack\",\"info\":\"3 range, 0 AoE. Element: Fire. Effect: Damage (MA * 4).\",\"type\":\"active\"},{\"name\":\"Spark\",\"info\":\"0 range, 2 AoE. Element: Fire. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Scratch\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Cat Kick\",\"info\":\"1 range, 0 AoE. Element: Earth. Effect: Damage (PA * Random(1,8)); Chance to knockback.\",\"type\":\"active\"},{\"name\":\"Blaster\",\"info\":\"3 range, 0 AoE. Hit: (MA + 38)%. Effect: Add Petrify, Stop, Sleep (Random).\",\"type\":\"active\"},{\"name\":\"Poison Nail\",\"info\":\"2 range, 0 AoE. Hit: (MA + 58)%. Effect: Add Poison; If successful, Damage (15)%.\",\"type\":\"active\"},{\"name\":\"Blood Suck\",\"info\":\"1 range, 0 AoE. Effect: AbsorbHP (25)%; Chance to add Blood Suck.\",\"type\":\"active\"},{\"name\":\"Suck Blood\",\"info\":\"1 range, 0 AoE. Effect: AbsorbHP (25)%; Add Blood Suck.\",\"type\":\"active\"},{\"name\":\"Tentacle\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Stop.\",\"type\":\"active\"},{\"name\":\"Black Ink\",\"info\":\"2 range, 0 AoE (linear). Hit: (MA + 55)%. Effect: Add Darkness, Oil (All).\",\"type\":\"active\"},{\"name\":\"Odd Soundwave\",\"info\":\"0 range, 2 AoE. Effect: Cancel Charging, Performing, Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"active\"},{\"name\":\"Mind Blast\",\"info\":\"3 range, 1 AoE. Hit: (MA + 49)%. Effect: Add Confusion, Berserk (Random).\",\"type\":\"active\"},{\"name\":\"Level Blast\",\"info\":\"3 range, 0 AoE. Effect: +1 Brave, +1 PA, +1 MA, +1 Speed.\",\"type\":\"active\"},{\"name\":\"Knife Hand\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Undead.\",\"type\":\"active\"},{\"name\":\"Thunder Soul\",\"info\":\"3 range, 0 AoE. Element: Lightning. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Aqua Soul\",\"info\":\"3 range, 0 AoE. Element: Water. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Frost Soul\",\"info\":\"3 range, 0 AoE. Element: Ice. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Wind Soul\",\"info\":\"3 range, 0 AoE. Element: Wind. Effect: Damage (MA * 4).\",\"type\":\"active\"},{\"name\":\"Throw Spirit\",\"info\":\"4 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Zombie Touch\",\"info\":\"1 range, 0 AoE. Hit: (MA + 47)%. Effect: Add Undead.\",\"type\":\"active\"},{\"name\":\"Sleep Touch\",\"info\":\"1 range, 0 AoE. Hit: (MA + 44)%. Effect: Add Sleep.\",\"type\":\"active\"},{\"name\":\"Drain Touch\",\"info\":\"1 range, 0 AoE. Hit: (MA + 62)%. Effect: AbsorbHP (34)%.\",\"type\":\"active\"},{\"name\":\"Grease Touch\",\"info\":\"1 range, 0 AoE. Hit: (MA + 52)%. Effect: Add Oil, Slow (All).\",\"type\":\"active\"},{\"name\":\"Wing Attack\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Float, Reraise, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"type\":\"active\"},{\"name\":\"Look of Devil\",\"info\":\"3 range, 0 AoE. Hit: (MA + 42)%. Effect: Add Petrify, Darkness, Silence, Don't Move, Don't Act (Random).\",\"type\":\"active\"},{\"name\":\"Look of Fright\",\"info\":\"3 range, 0 AoE. Hit: (MA + 57)%. Effect: -25 Brave.\",\"type\":\"active\"},{\"name\":\"Beam\",\"info\":\"4 range, 0 AoE. Hit: (MA + 51)%. Effect: -2 MA.\",\"type\":\"active\"},{\"name\":\"Doom\",\"info\":\"3 range, 0 AoE. Hit: (MA + 45)%. Effect: Add Death Sentence.\",\"type\":\"active\"},{\"name\":\"Scratch Up\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Beak\",\"info\":\"1 range, 0 AoE. Hit: (MA + 36)%. Effect: Add Petrify.\",\"type\":\"active\"},{\"name\":\"Shine Lover\",\"info\":\"3 range, 0 AoE. Hit: (PA + 66)%. Effect: DamageMP (66)%.\",\"type\":\"active\"},{\"name\":\"Feather Bomb\",\"info\":\"5 range, 0 AoE. Element: Wind. Effect: Damage (MA * 2).\",\"type\":\"active\"},{\"name\":\"Peck\",\"info\":\"3 range, 0 AoE. Hit: (MA + 53)%. Effect: -2 PA.\",\"type\":\"active\"},{\"name\":\"Straight Dash\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Silence, Berserk (Random).\",\"type\":\"active\"},{\"name\":\"Snort\",\"info\":\"2 range, 0 AoE. Hit: (MA + 40)%. Effect: Add Charm.\",\"type\":\"active\"},{\"name\":\"Oink\",\"info\":\"2 range, 0 AoE. Hit: (PA + 72)%. Effect: Cancel Death; If successful, Heal (75)%.\",\"type\":\"active\"},{\"name\":\"Toot\",\"info\":\"2 range, 0 AoE. Hit: (MA + 48)%. Effect: Add Confusion, Sleep (Random).\",\"type\":\"active\"},{\"name\":\"Bequeath Bacon\",\"info\":\"2 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"type\":\"active\"},{\"name\":\"Leaf Dance\",\"info\":\"0 range, 1 AoE. Effect: Damage (MA * 5).\",\"type\":\"active\"},{\"name\":\"Protect Spirit\",\"info\":\"0 range, 2 AoE. Hit: (MA + 60)%. Effect: Add Defending, Protect (All).\",\"type\":\"active\"},{\"name\":\"Calm Spirit\",\"info\":\"0 range, 2 AoE. Hit: (MA + 60)%. Effect: Add Defending, Shell (All).\",\"type\":\"active\"},{\"name\":\"Spirit of Life\",\"info\":\"0 range, 2 AoE. Effect: Heal (MA * 4).\",\"type\":\"active\"},{\"name\":\"Magic Spirit\",\"info\":\"0 range, 2 AoE. Effect: HealMP (MA * 2).\",\"type\":\"active\"},{\"name\":\"Shake Off\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Defending.\",\"type\":\"active\"},{\"name\":\"Storm Around\",\"info\":\"0 range, 1 AoE. Element: Lightning. Effect: Damage (PA * (PA / 2)).\",\"type\":\"active\"},{\"name\":\"Mimic Titan\",\"info\":\"0 range, 2 AoE. Element: Earth. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Gather Power\",\"info\":\"0 range, 0 AoE. Effect: +2 PA.\",\"type\":\"active\"},{\"name\":\"Blow Fire\",\"info\":\"3 range, 0 AoE (linear). Element: Fire. Effect: Damage (MA * 3).\",\"type\":\"active\"},{\"name\":\"Tendrils\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Slow.\",\"type\":\"active\"},{\"name\":\"Lick\",\"info\":\"1 range, 0 AoE. Effect: Add Reflect.\",\"type\":\"active\"},{\"name\":\"Goo\",\"info\":\"2 range, 0 AoE. Hit: (MA + 65)%. Effect: Add Stop, Don't Move, Don't Act (All).\",\"type\":\"active\"},{\"name\":\"Bad Breath\",\"info\":\"0 range, 2 AoE. Effect: Add Petrify, Darkness, Confusion, Silence, Oil, Frog, Poison, Sleep, Don't Act (Separate).\",\"type\":\"active\"},{\"name\":\"Moldball Virus\",\"info\":\"3 range, 0 AoE (linear). Hit: (MA + 18)%. Effect: Transform target into a Malboro.\",\"type\":\"active\"},{\"name\":\"Stab Up\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Frozen Cry\",\"info\":\"1 range, 0 AoE. Element: Ice. Effect: Damage (PA * ((PA + 2) / 2)); Chance to add Death.\",\"type\":\"active\"},{\"name\":\"Hurricane\",\"info\":\"4 range, 2 AoE. Element: Wind. Hit: (MA + 56)%. Effect: Damage (35)%.\",\"type\":\"active\"},{\"name\":\"Ulmaguest\",\"info\":\"4 range, 2 AoE. Effect: Damage (MaxHP - CurrentHP).\",\"type\":\"active\"},{\"name\":\"Giga Flare\",\"info\":\"4 range, 2 AoE. Effect: Damage (MA * 7).\",\"type\":\"active\"},{\"name\":\"Slam\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Tail Swing\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,15)); Chance to knockback.\",\"type\":\"active\"},{\"name\":\"Ice Breath\",\"info\":\"2 range, 2 AoE (linear). Element: Ice. Effect: Damage (MA * 5).\",\"type\":\"active\"},{\"name\":\"Fire Breath\",\"info\":\"2 range, 2 AoE (linear). Element: Fire. Effect: Damage (MA * 5).\",\"type\":\"active\"},{\"name\":\"Thunder Breath\",\"info\":\"2 range, 2 AoE (linear). Element: Lightning. Effect: Damage (MA * 5).\",\"type\":\"active\"},{\"name\":\"Triple Attack\",\"info\":\"1 range, 1 AoE (trilinear). Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Triple Breath\",\"info\":\"2 range, 2 AoE (trilinear). Hit: (MA + 84)%. Effect: Damage (45)%.\",\"type\":\"active\"},{\"name\":\"Triple Thunder\",\"info\":\"4 range, 1 AoE (multihit). Element: Lightning. Hit: 3 times. Effect: Damage (MA * ((MA + 12) / 2)).\",\"type\":\"active\"},{\"name\":\"Triple Flame\",\"info\":\"4 range, 1 AoE (multihit). Element: Fire. Hit: 3 times. Effect: Damage (MA * ((MA + 20) / 2)).\",\"type\":\"active\"},{\"name\":\"Dark Whisper\",\"info\":\"4 range, 1 AoE (multihit). Element: Dark. Hit: 6 times. Effect: Damage (MA * ((MA + 4) / 2)); Chance to add Death, Sleep, Evil (Separate).\",\"type\":\"active\"},{\"name\":\"Snake Carrier\",\"info\":\"1 range, 0 AoE, 1 MP. Effect: AbsorbHP (29)%; Add Undead, Darkness, Confusion, Blood Suck, Oil, Frog, Poison, Charm, Sleep, Death Sentence (Random).\",\"type\":\"active\"},{\"name\":\"Toxic Toad\",\"info\":\"5 range, 2 AoE, 6 CT. Hit: Faith(MA + 109)%. Effect: Add Frog, Poison (All).\",\"type\":\"active\"},{\"name\":\"Midgar Swarm\",\"info\":\"4 range, 2 AoE, 4 CT, 37 MP. Element: Water. Effect: Damage (MA * 18).\",\"type\":\"active\"},{\"name\":\"Lifebreak\",\"info\":\"4 range, 0 AoE, 3 CT. Effect: Damage (MaxHP - CurrentHP).\",\"type\":\"active\"},{\"name\":\"Nanoflare\",\"info\":\"4 range, 2 AoE, 7 CT. Effect: Damage (MA * ((MA + 8) / 2)).\",\"type\":\"active\"},{\"name\":\"Destroy\",\"info\":\"4 range, 0 AoE. Effect: Damage (PA * 10); DamageCaster (PA * 5 / 2).\",\"type\":\"active\"},{\"name\":\"Compress\",\"info\":\"2 range, 0 AoE. Effect: Damage (PA * 15); DamageCaster (PA * 5).\",\"type\":\"active\"},{\"name\":\"Dispose\",\"info\":\"8 range, 0 AoE. Effect: Damage (PA * 5); DamageCaster (PA).\",\"type\":\"active\"},{\"name\":\"Repair\",\"info\":\"0 range, 0 AoE. Hit: (PA + 80)%. Effect: Add Oil; If successful, Heal (30)%.\",\"type\":\"active\"},{\"name\":\"Energize\",\"info\":\"4 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"type\":\"active\"},{\"name\":\"Parasite\",\"info\":\"4 range, 0 AoE. Effect: Add Petrify, Darkness, Confusion, Silence, Oil, Frog, Poison, Sleep, Innocent (Separate).\",\"type\":\"active\"},{\"name\":\"Melt\",\"info\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Fire. Effect: Damage Faith(MA * 38).\",\"type\":\"active\"},{\"name\":\"Tornado\",\"info\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Wind. Effect: Damage Faith(MA * 38).\",\"type\":\"active\"},{\"name\":\"Quake\",\"info\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Earth. Effect: Damage Faith(MA * 38).\",\"type\":\"active\"},{\"name\":\"Flare 2\",\"info\":\"4 range, 1 AoE (homing), 4 CT, 23 MP. Effect: Damage Faith(MA * 42).\",\"type\":\"active\"},{\"name\":\"Demi 3\",\"info\":\"5 range, 1 AoE, 4 CT, 29 MP. Hit: Faith(MA + 182)%. Effect: Damage (TargetCurrentHP - 1).\",\"type\":\"active\"},{\"name\":\"All-Ultima\",\"info\":\"5 range, 3 AoE, 8 CT, 33 MP. Element: Holy. Effect: Damage Faith(MA * 55).\",\"type\":\"active\"},{\"name\":\"Grand Cross\",\"info\":\"4 range, 2 AoE (homing), 6 CT, 31 MP. Effect: Add Petrify, Darkness, Confusion, Silence, Berserk, Frog, Poison, Slow, Sleep (Separate).\",\"type\":\"active\"},{\"name\":\"Potion\",\"info\":\"1 range, 0 AoE. Effect: Heal (100).\",\"type\":\"active\"},{\"name\":\"Hi-Potion\",\"info\":\"1 range, 0 AoE. Effect: Heal (120).\",\"type\":\"active\"},{\"name\":\"X-Potion\",\"info\":\"1 range, 0 AoE. Effect: Heal (150).\",\"type\":\"active\"},{\"name\":\"Ether\",\"info\":\"1 range, 0 AoE. Effect: HealMP (20).\",\"type\":\"active\"},{\"name\":\"Hi-Ether\",\"info\":\"1 range, 0 AoE. Effect: HealMP (50).\",\"type\":\"active\"},{\"name\":\"Elixir\",\"info\":\"1 range, 0 AoE. Effect: Heal (100)%; HealMP (100)%.\",\"type\":\"active\"},{\"name\":\"Antidote\",\"info\":\"1 range, 0 AoE. Effect: Cancel Poison.\",\"type\":\"active\"},{\"name\":\"Eye Drop\",\"info\":\"1 range, 0 AoE. Effect: Cancel Darkness.\",\"type\":\"active\"},{\"name\":\"Echo Grass\",\"info\":\"1 range, 0 AoE. Effect: Cancel Silence.\",\"type\":\"active\"},{\"name\":\"Maiden's Kiss\",\"info\":\"1 range, 0 AoE. Effect: Cancel Frog.\",\"type\":\"active\"},{\"name\":\"Soft\",\"info\":\"1 range, 0 AoE. Effect: Cancel Petrify.\",\"type\":\"active\"},{\"name\":\"Holy Water\",\"info\":\"1 range, 0 AoE. Effect: Cancel Undead, Blood Suck.\",\"type\":\"active\"},{\"name\":\"Remedy\",\"info\":\"1 range, 0 AoE. Effect: Cancel Confusion, Oil, Sleep.\",\"type\":\"active\"},{\"name\":\"Phoenix Down\",\"info\":\"1 range, 0 AoE. Cancel Death; If successful, Heal Random(1,20); If Undead, Damage (100)% instead.\",\"type\":\"active\"},{\"name\":\"Shuriken\",\"info\":\"move range, 0 AoE. Effect: Throw Shuriken (Shuriken, Magic Shuriken, Yagyu Shuriken); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Knife\",\"info\":\"move range, 0 AoE. Effect: Throw Knife (Air Knife); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Sword\",\"info\":\"move range, 0 AoE. Effect: Throw Sword (Rune Blade); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Hammer\",\"info\":\"move range, 0 AoE. Effect: Throw Flail (Morning Star); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Staff\",\"info\":\"move range, 0 AoE. Effect: Throw Staff (Gold Staff); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Ninja Sword\",\"info\":\"move range, 0 AoE. Effect: Throw Ninja Blade (Spell Edge); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Axe\",\"info\":\"move range, 0 AoE. Effect: Throw Axe (Giant Axe); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Spear\",\"info\":\"move range, 0 AoE. Effect: Throw Spear (Holy Lance); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Stick\",\"info\":\"move range, 0 AoE. Effect: Throw Pole (Ivory Cane); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Wand\",\"info\":\"move range, 0 AoE. Effect: Throw Rod (Wizard Rod); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Dictionary\",\"info\":\"move range, 0 AoE. Effect: Throw Book (Papyrus Codex); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Bomb\",\"info\":\"move range, 0 AoE. Effect: Throw Bomb (Burst Bomb, Torrent Bomb, Spark Bomb); Damage (Speed * ThrownWP).\",\"type\":\"active\"},{\"name\":\"Level Jump2\",\"info\":\"2 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Level Jump3\",\"info\":\"3 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Level Jump4\",\"info\":\"4 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Level Jump5\",\"info\":\"5 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Level Jump6\",\"info\":\"6 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Level Jump7\",\"info\":\"7 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump2\",\"info\":\"2 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump3\",\"info\":\"3 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump4\",\"info\":\"4 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump5\",\"info\":\"5 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump6\",\"info\":\"6 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Vertical Jump7\",\"info\":\"7 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Charge+1\",\"info\":\"weapon range, 0 AoE, 3 CT (aiming). Effect: Basic Attack with +1 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+2\",\"info\":\"weapon range, 0 AoE, 4 CT (aiming). Effect: Basic Attack with +2 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+3\",\"info\":\"weapon range, 0 AoE, 5 CT (aiming). Effect: Basic Attack with +3 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+4\",\"info\":\"weapon range, 0 AoE, 6 CT (aiming). Effect: Basic Attack with +4 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+5\",\"info\":\"weapon range, 0 AoE, 7 CT (aiming). Effect: Basic Attack with +5 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+7\",\"info\":\"weapon range, 0 AoE, 9 CT (aiming). Effect: Basic Attack with +7 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+10\",\"info\":\"weapon range, 0 AoE, 12 CT (aiming). Effect: Basic Attack with +10 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"Charge+20\",\"info\":\"weapon range, 0 AoE, 16 CT (aiming). Effect: Basic Attack with +20 added to the primary stat.\",\"type\":\"active\"},{\"name\":\"CT\",\"info\":\"Algorithm for targeting units based on their CT.\",\"type\":\"active\"},{\"name\":\"Blue Magic\",\"info\":\"Enables the unit to equip special secondary skillsets that feature both monster and exclusive abilities.\",\"type\":\"active\"},{\"name\":\"Height\",\"info\":\"Algorithm for targeting units based on the height of the tile they are standing on.\",\"type\":\"active\"},{\"name\":\"Prime Number\",\"info\":\"Expression for targeting units whose algorithmic attribute is a prime number (a number divisible by only 1 and itself).\",\"type\":\"active\"},{\"name\":\"5\",\"info\":\"Expression for targeting units whose algorithmic attribute is a multiple of 5.\",\"type\":\"active\"},{\"name\":\"4\",\"info\":\"Expression for targeting units whose algorithmic attribute is a multiple of 4.\",\"type\":\"active\"},{\"name\":\"3\",\"info\":\"Expression for targeting units whose algorithmic attribute is a multiple of 3.\",\"type\":\"active\"},{\"name\":\"Attack\",\"info\":\"weapon range, 0 AoE. Effect: If armed, weapon type's formula; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"Guard\",\"info\":\"0 range, 0 AoE. Effect: Add Defending.\",\"type\":\"active\"},{\"name\":\"Frog Attack\",\"info\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"type\":\"active\"},{\"name\":\"PA Save\",\"info\":\"Reaction. After the unit was damaged by an attack, it gains +1 PA.\",\"type\":\"react\"},{\"name\":\"MA Save\",\"info\":\"Reaction. After the unit was damaged by an attack, it gains +1 MA.\",\"type\":\"react\"},{\"name\":\"Speed Save\",\"info\":\"Reaction. After the unit was damaged by an attack, it gains +1 Speed.\",\"type\":\"react\"},{\"name\":\"Sunken State\",\"info\":\"Reaction. After the unit was targeted by a counterable attack, add Transparent.\",\"type\":\"react\"},{\"name\":\"Caution\",\"info\":\"Reaction. After the unit was targeted by a counterable attack, add Defending.\",\"type\":\"react\"},{\"name\":\"Dragon Spirit\",\"info\":\"Reaction. After the unit was targeted by a counterable attack, add Reraise.\",\"type\":\"react\"},{\"name\":\"Regenerator\",\"info\":\"Reaction. After the unit was damaged by an attack, add Regen.\",\"type\":\"react\"},{\"name\":\"Brave Save\",\"info\":\"Reaction. After the unit was targeted by a counterable attack, it gains +3 Brave.\",\"type\":\"react\"},{\"name\":\"Faith Save\",\"info\":\"Reaction. After the unit was targeted by an ability using MP, it gains +3 Faith.\",\"type\":\"react\"},{\"name\":\"HP Restore\",\"info\":\"Reaction. After the unit was damaged to Critical by an attack, its HP is set to its MaxHP.\",\"type\":\"react\"},{\"name\":\"MP Restore\",\"info\":\"Reaction. After the unit was damaged to Critical by an attack, its MP is set to its MaxMP.\",\"type\":\"react\"},{\"name\":\"Critical Quick\",\"info\":\"Reaction. After the unit was damaged to Critical by an attack, its CT is set to 100 (Quick).\",\"type\":\"react\"},{\"name\":\"Meatbone Slash\",\"info\":\"Reaction. After the unit was damaged to Critical by an attack from a unit within weapon range, it retaliates with an attack that deals damage equal to its MaxHP.\",\"type\":\"react\"},{\"name\":\"Counter Magic\",\"info\":\"Reaction. After the unit was targeted by certain offensive magic while having enough MP to cast that same spell, it retaliates with a cast of that spell.\",\"type\":\"react\"},{\"name\":\"Counter Tackle\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from an adjacent unit, it retaliates with Dash.\",\"type\":\"react\"},{\"name\":\"Counter Flood\",\"info\":\"Reaction. After the unit was targeted by certain attacks, it retaliates with Elemental.\",\"type\":\"react\"},{\"name\":\"Absorb Used MP\",\"info\":\"Reaction. After the unit was targeted by an ability using MP, it heals its MP by the amount spent.\",\"type\":\"react\"},{\"name\":\"Auto Potion\",\"info\":\"Reaction. After the unit was damaged by an attack, it uses a Potion (healing 100 HP).\",\"type\":\"react\"},{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Distribute\",\"info\":\"Reaction. After the unit was healed by more HP than necessary to reach MaxHP, it heals allied damaged units equal to the excess (divided evenly).\",\"type\":\"react\"},{\"name\":\"Mana Shield\",\"info\":\"Reaction. When the unit is damaged while MP is greater than 0, damage is dealt to the unit's MP instead.\",\"type\":\"react\"},{\"name\":\"Damage Split\",\"info\":\"Reaction. After the unit was damaged by an attack, it heals half of that damage and retaliates with damage equal to the amount healed.\",\"type\":\"react\"},{\"name\":\"Parry\",\"info\":\"Reaction. Enables the evasion of the unit's equipped weapons.\",\"type\":\"react\"},{\"name\":\"Earplug\",\"info\":\"Reaction. When the unit is targeted by a Talk Skill ability, it negates that ability.\",\"type\":\"react\"},{\"name\":\"Abandon\",\"info\":\"Reaction. Doubles the unit's evasion.\",\"type\":\"react\"},{\"name\":\"Catch\",\"info\":\"Reaction. When the unit is targeted by a Throw ability, it negates that ability.\",\"type\":\"react\"},{\"name\":\"Blade Grasp\",\"info\":\"Reaction. When the unit is targeted by a counterable attack, it negates that attack.\",\"type\":\"react\"},{\"name\":\"Arrow Guard\",\"info\":\"Reaction. When the unit is targeted by an attack from a weapon with 4 range or greater, it negates that attack.\",\"type\":\"react\"},{\"name\":\"Hamedo\",\"info\":\"Reaction. When the unit is targeted by an ability with variable range from a unit within weapon range, it negates that attack and retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Equip Armor\",\"info\":\"Support. Allows the unit to equip Hats, Helmets, Clothing, Armor, and Robes.\",\"type\":\"support\"},{\"name\":\"Equip Shield\",\"info\":\"Support. Allows the unit to equip Shields (even if a Knight Sword or Bow is equipped).\",\"type\":\"support\"},{\"name\":\"Equip Sword\",\"info\":\"Support. Allows the unit to equip Swords, Knight Swords, and Katanas.\",\"type\":\"support\"},{\"name\":\"Equip Knife\",\"info\":\"Support. Allows the unit to equip Knives, Ninja Blades, and Rods.\",\"type\":\"support\"},{\"name\":\"Equip Bow\",\"info\":\"Support. Allows the unit to equip Bows, Crossbows, and rarely Bags.\",\"type\":\"support\"},{\"name\":\"Equip Polearm\",\"info\":\"Support. Allows the unit to equip Spears, Poles, and Fabrics.\",\"type\":\"support\"},{\"name\":\"Equip Axe\",\"info\":\"Support. Allows the unit to equip Axes, Flails, and Staves.\",\"type\":\"support\"},{\"name\":\"Equip Gun\",\"info\":\"Support. Allows the unit to equip Guns, Books, and Harps.\",\"type\":\"support\"},{\"name\":\"Halve MP\",\"info\":\"Support. Halves the MP cost of abilities used by the unit.\",\"type\":\"support\"},{\"name\":\"No MP\",\"info\":\"Support. Eliminates the MP cost of abilities used by the unit.\",\"type\":\"support\"},{\"name\":\"Attack Up\",\"info\":\"Support. Increases the damage (or hitrate) of the unit's physical attacks by a third (except jumping and Throw abilities).\",\"type\":\"support\"},{\"name\":\"Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from physical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Magic Attack Up\",\"info\":\"Support. Increases the damage (or hitrate) of the unit's magical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Magic Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from magical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Concentrate\",\"info\":\"Support. Prevents physical attacks used by the unit from being evaded.\",\"type\":\"support\"},{\"name\":\"Sicken\",\"info\":\"Support. Allows physical attacks used by the unit to add Poison (except a basic Attack with a Gun).\",\"type\":\"support\"},{\"name\":\"Secret Hunt\",\"info\":\"Support. After killing or resurrecting a unit, the unit gains +1 PA and +1 MA.\",\"type\":\"support\"},{\"name\":\"Martial Arts\",\"info\":\"Support. Increases the damage (or hitrate) of the unit's unarmed attacks, Punch Art abilities, and certain other physical abilities by 50%.\",\"type\":\"support\"},{\"name\":\"Monster Talk\",\"info\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"type\":\"support\"},{\"name\":\"Throw Item\",\"info\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"type\":\"support\"},{\"name\":\"Maintenance\",\"info\":\"Support. Prevents the unit's equipment from being removed.\",\"type\":\"support\"},{\"name\":\"Doublehand\",\"info\":\"Support. Doubles the damage of the unit's basic Attack unless unarmed or equipped with a Gun, but prevents it from equipping items in the offhand.\",\"type\":\"support\"},{\"name\":\"Dual Wield\",\"info\":\"Support. Allows the unit to equip an additional weapon in the offhand unless equipped with a Bow, attacking once with each (or both fists if unarmed).\",\"type\":\"support\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"},{\"name\":\"Defend\",\"info\":\"Support. Allows the unit to use the Guard ability (to add Defending).\",\"type\":\"support\"},{\"name\":\"Short Charge\",\"info\":\"Support. Halves the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"Non-Charge\",\"info\":\"Support. Eliminates the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"Short Status\",\"info\":\"Support. Halves the duration of status effects (both positive and negative) applied to the unit.\",\"type\":\"support\"},{\"name\":\"Long Status\",\"info\":\"Support. Increases the duration of status effects (both positive and negative) applied to the unit by 50%.\",\"type\":\"support\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Move+1\",\"info\":\"Movement. Increases the unit's Move by 1.\",\"type\":\"move\"},{\"name\":\"Move+2\",\"info\":\"Movement. Increases the unit's Move by 2.\",\"type\":\"move\"},{\"name\":\"Move+3\",\"info\":\"Movement. Increases the unit's Move by 3.\",\"type\":\"move\"},{\"name\":\"Jump+1\",\"info\":\"Movement. Increases the unit's Jump by 1.\",\"type\":\"move\"},{\"name\":\"Jump+2\",\"info\":\"Movement. Increases the unit's Jump by 2.\",\"type\":\"move\"},{\"name\":\"Jump+3\",\"info\":\"Movement. Increases the unit's Jump by 3.\",\"type\":\"move\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"},{\"name\":\"Lifefont\",\"info\":\"Movement. After moving, the unit heals its HP by 10%.\",\"type\":\"move\"},{\"name\":\"Manafont\",\"info\":\"Movement. After moving, the unit heals its MP by 10%.\",\"type\":\"move\"},{\"name\":\"Teleport\",\"info\":\"Movement. Allows the unit to teleport directly to a tile within its move range.\",\"type\":\"move\"},{\"name\":\"Teleport 2\",\"info\":\"Movement. Allows the unit to teleport directly to any tile.\",\"type\":\"move\"},{\"name\":\"Pilgrimage\",\"info\":\"Movement. After moving, the unit gains +1 Brave and +1 Faith.\",\"type\":\"move\"},{\"name\":\"Waterwalking\",\"info\":\"Movement. Allows the unit to move and stand on the surface of water.\",\"type\":\"move\"},{\"name\":\"Swim\",\"info\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"type\":\"move\"},{\"name\":\"Lava Walking\",\"info\":\"Movement. Allows the unit to move and stand on lava.\",\"type\":\"move\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Retreat\",\"info\":\"Movement. While in Critical, increases the unit's Move by 4.\",\"type\":\"move\"},{\"name\":\"Sonic Step\",\"info\":\"Movement. After moving, the unit gains +5 CT.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"},{\"name\":\"Mimic\",\"info\":\"Skillset. Allows the unit to automatically copy the actions of allies without Mimic except abilities associated with a Wild Beast family, but prevents it from equipping weapons. Mimicked abilities are instant (requiring no CT) and their targeting copies the distance and direction of the original action.\",\"type\":\"active\"},{\"name\":\"Basic Skill\",\"info\":\"Skillset. Squire job abilities.\",\"type\":\"active\"},{\"name\":\"Item\",\"info\":\"Skillset (inventory). Chemist job abilities.\",\"type\":\"active\"},{\"name\":\"Battle Skill\",\"info\":\"Skillset. Knight job abilities.\",\"type\":\"active\"},{\"name\":\"Charge\",\"info\":\"Skillset (snipe). Archer job abilities.\",\"type\":\"active\"},{\"name\":\"Punch Art\",\"info\":\"Skillset. Monk job abilities.\",\"type\":\"active\"},{\"name\":\"White Magic\",\"info\":\"Skillset. Priest job abilities.\",\"type\":\"active\"},{\"name\":\"Black Magic\",\"info\":\"Skillset. Wizard job abilities.\",\"type\":\"active\"},{\"name\":\"Time Magic\",\"info\":\"Skillset. Time Mage job abilities.\",\"type\":\"active\"},{\"name\":\"Summon Magic\",\"info\":\"Skillset. Summoner job abilities.\",\"type\":\"active\"},{\"name\":\"Steal\",\"info\":\"Skillset. Thief job abilities.\",\"type\":\"active\"},{\"name\":\"Talk Skill\",\"info\":\"Skillset (oral). Mediator job abilities.\",\"type\":\"active\"},{\"name\":\"Yin Yang Magic\",\"info\":\"Skillset. Oracle job abilities.\",\"type\":\"active\"},{\"name\":\"Elemental\",\"info\":\"Skillset (geomancy). Geomancer job abilities.\",\"type\":\"active\"},{\"name\":\"Jump\",\"info\":\"Skillset (aerial). Lancer job abilities.\",\"type\":\"active\"},{\"name\":\"Draw Out\",\"info\":\"Skillset (inventory). Samurai job abilities.\",\"type\":\"active\"},{\"name\":\"Throw\",\"info\":\"Skillset (inventory). Ninja job abilities.\",\"type\":\"active\"},{\"name\":\"Dance\",\"info\":\"Skillset. Dancer job abilities.\",\"type\":\"active\"},{\"name\":\"Sing\",\"info\":\"Skillset. Bard job abilities.\",\"type\":\"active\"},{\"name\":\"Math Skill\",\"info\":\"Skillset (arithmetic). Calculator job abilities.\",\"type\":\"active\"},{\"name\":\"Bio\",\"info\":\"Blue Skillset. Apanda abilities.\",\"type\":\"active\"},{\"name\":\"Robosnake Skill\",\"info\":\"Blue Skillset. Steel Giant and Serpentarius abilities.\",\"type\":\"active\"},{\"name\":\"Byblos\",\"info\":\"Blue Skillset. Byblos abilities.\",\"type\":\"active\"},{\"name\":\"Demon Skill\",\"info\":\"Blue Skillset. Demon family abilities.\",\"type\":\"active\"},{\"name\":\"Limit\",\"info\":\"Blue Skillset. Cloud's job abilities.\",\"type\":\"active\"},{\"name\":\"Lucavi Skill\",\"info\":\"Blue Skillset. Lucavi family abilities.\",\"type\":\"active\"},{\"name\":\"Mighty Sword\",\"info\":\"Blue Skillset. Meliadoul's job abilities.\",\"type\":\"active\"},{\"name\":\"Bird Skill\",\"info\":\"Blue Skillset. Chocobo family and Aevis family abilities.\",\"type\":\"active\"},{\"name\":\"Imp Skill\",\"info\":\"Blue Skillset. Goblin family and Eye family abilities.\",\"type\":\"active\"},{\"name\":\"Wildfire Skill\",\"info\":\"Blue Skillset. Bomb family and Tree family abilities.\",\"type\":\"active\"},{\"name\":\"Animal Skill\",\"info\":\"Blue Skillset. Cat family and Pig family abilities.\",\"type\":\"active\"},{\"name\":\"Tentacle Skill\",\"info\":\"Blue Skillset. Squid family and Malboro family abilities.\",\"type\":\"active\"},{\"name\":\"Undeath Skill\",\"info\":\"Blue Skillset. Skeleton family and Ghost family abilities.\",\"type\":\"active\"},{\"name\":\"Beast Skill\",\"info\":\"Blue Skillset. Minotaur family and Behemoth family abilities.\",\"type\":\"active\"},{\"name\":\"Dinosaur Skill\",\"info\":\"Blue Skillset. Dragon family and Hydra family abilities.\",\"type\":\"active\"},{\"name\":\"Foul Skill\",\"info\":\"Blue Skillset. Pig family and Malboro family abilities.\",\"type\":\"active\"},{\"name\":\"Griffin Skill\",\"info\":\"Blue Skillset. Aevis family and Cat family abilities.\",\"type\":\"active\"},{\"name\":\"Spirit Skill\",\"info\":\"Blue Skillset. Ghost family and Bomb family abilities.\",\"type\":\"active\"},{\"name\":\"Ranch Skill\",\"info\":\"Blue Skillset. Minotaur family and Chocobo family abilities.\",\"type\":\"active\"},{\"name\":\"Dungeon Skill\",\"info\":\"Blue Skillset. Goblin family and Dragon family abilities.\",\"type\":\"active\"},{\"name\":\"Marsh Skill\",\"info\":\"Blue Skillset. Tree family and Squid family abilities.\",\"type\":\"active\"},{\"name\":\"Medusa Skill\",\"info\":\"Blue Skillset. Eye family and Hydra family abilities.\",\"type\":\"active\"},{\"name\":\"Nightmare Skill\",\"info\":\"Blue Skillset. Behemoth family and Skeleton family abilities.\",\"type\":\"active\"},{\"name\":\"Farm Skill\",\"info\":\"Blue Skillset. Chocobo family and Pig family abilities.\",\"type\":\"active\"},{\"name\":\"Giant Skill\",\"info\":\"Blue Skillset. Hydra family and Behemoth family abilities.\",\"type\":\"active\"},{\"name\":\"Forest Skill\",\"info\":\"Blue Skillset. Tree family and Aevis family abilities.\",\"type\":\"active\"},{\"name\":\"Curse Skill\",\"info\":\"Blue Skillset. Eye family and Ghost family abilities.\",\"type\":\"active\"},{\"name\":\"Havoc Skill\",\"info\":\"Blue Skillset. Bomb family and Goblin family abilities.\",\"type\":\"active\"},{\"name\":\"Disease Skill\",\"info\":\"Blue Skillset. Malboro family and Skeleton family abilities.\",\"type\":\"active\"},{\"name\":\"Labyrinth Skill\",\"info\":\"Blue Skillset. Dragon family and Minotaur family abilities.\",\"type\":\"active\"},{\"name\":\"Catfish Skill\",\"info\":\"Blue Skillset. Squid family and Cat family abilities.\",\"type\":\"active\"},{\"name\":\"Troll Skill\",\"info\":\"Blue Skillset. Pig family and Goblin family abilities.\",\"type\":\"active\"},{\"name\":\"Hex Skill\",\"info\":\"Blue Skillset. Cat family and Eye family abilities.\",\"type\":\"active\"},{\"name\":\"Abyss Skill\",\"info\":\"Blue Skillset. Skeleton family and Squid family abilities.\",\"type\":\"active\"},{\"name\":\"Cerberus Skill\",\"info\":\"Blue Skillset. Hydra family and Minotaur family abilities.\",\"type\":\"active\"},{\"name\":\"Vine Skill\",\"info\":\"Blue Skillset. Malboro family and Tree family abilities.\",\"type\":\"active\"},{\"name\":\"Missile Skill\",\"info\":\"Blue Skillset. Aevis family and Bomb family abilities.\",\"type\":\"active\"},{\"name\":\"Roc Skill\",\"info\":\"Blue Skillset. Behemoth family and Chocobo family abilities.\",\"type\":\"active\"},{\"name\":\"Phantom Skill\",\"info\":\"Blue Skillset. Ghost family and Dragon family abilities.\",\"type\":\"active\"},{\"name\":\"Night Magic\",\"info\":\"Monster Skillset. Ultima Demon abilities.\",\"type\":\"active\"},{\"name\":\"Dark Magic\",\"info\":\"Monster Skillset. Archaic Demon abilities.\",\"type\":\"active\"},{\"name\":\"Dark Cloud\",\"info\":\"Monster Skillset. Serpentarius abilities.\",\"type\":\"active\"},{\"name\":\"Work\",\"info\":\"Monster Skillset. Steel Giant abilities.\",\"type\":\"active\"},{\"name\":\"Breath\",\"info\":\"Monster Skillset. Holy Dragon abilities.\",\"type\":\"active\"}]}");

});

parcelRegister("ay2NQ", function(module, exports) {
module.exports = JSON.parse("{\"Item\":{\"108 Gems\":\"Accessory. Effect: Strengthen Fire, Lightning, Ice, Wind, Earth, Water, Holy, Dark; Immune Blood Suck, Frog, Poison.\",\"Academic Tome\":\"6 WP, 3 range, 30% evade, Book. Effect: Half Wind, Earth, Water; Chance to cast Persuade.\",\"Accessories\":\"Extra Equipment Type. Grants unique effects that all classes can equip.\",\"Adamant Vest\":\"+62 HP, +16 MP, Clothing. Effect: +1 PA.\",\"Aegis Shield\":\"5% physical evade, 33% magic evade, Shield. Effect: +1 MA.\",\"Air Knife\":\"10 WP, 1 range, 3% evade, Knife. Element: Wind. Effect: +1 PA.\",\"Ancient Sword\":\"10 WP, 1 range, 5% evade, Sword. Effect: Chance to add Don't Move.\",\"Angel Ring\":\"Accessory. Effect: Immune Undead, Darkness; Initial Reraise.\",\"Antidote\":\"Consumable. Effect: Cancel Poison.\",\"Arbalest\":\"11 WP, 5 range, 10% evade, Crossbow.\",\"Armor\":\"Body Equipment Type. Increases HP and MP. Typically offers superior HP compared to other body equipment.\",\"Assassin Dagger\":\"8 WP, 1 range, 15% evade, Knife. Effect: Chance to add Death Sentence.\",\"Asura Knife\":\"11 WP, 1 range, 15% evade, Katana. Effect: +2 MA; Chance to add Berserk.\",\"Axes\":\"Weapon Subtype (striking). Formula: Damage (Random(1,PA) * WP).\",\"Bags\":\"Weapon Subtype (striking). Formula: Damage (Random(1,PA) * WP). Effect: Chance to be equipped rarely by units of any class.\",\"Barbuta\":\"+53 HP, +5 MP, Helmet. Effect: +1 Jump.\",\"Barette\":\"+29 HP, +25 MP, Hat. Effect: +1 PA; Immune Undead, Petrify, Confusion, Blood Suck, Berserk, Slow, Sleep, Don't Move, Death Sentence.\",\"Battle Axe\":\"10 WP, 1 range, 10% evade, Axe. Effect: +2 PA.\",\"Battle Bamboo\":\"8 WP, 2 range, 28% evade, Pole. Effect: +2 PA.\",\"Battle Boots\":\"Accessory. Effect: +1 Speed, +1 Move.\",\"Battle Folio\":\"7 WP, 3 range, 25% evade, Book. Effect: +1 PA.\",\"Bestiary\":\"8 WP, 3 range, 19% evade, Book. Effect: +1 MA.\",\"Bizen Boat\":\"13 WP, 1 range, 25% evade, Katana. Effect: +1 Speed.\",\"Black Costume\":\"+101 HP, +2 MP, Clothing. Effect: Strengthen Dark; Immune Stop.\",\"Black Hood\":\"+103 HP, +2 MP, Hat.\",\"Black Robe\":\"+66 HP, +39 MP, Robe. Effect: Strengthen Fire, Lightning, Ice.\",\"Blast Gun\":\"13 WP, 7 range, 5% evade, Gun. Element: Lightning.\",\"Blaze Gun\":\"13 WP, 7 range, 5% evade, Gun. Element: Fire.\",\"Blind Knife\":\"8 WP, 1 range, 8% evade, Ninja Blade. Effect: Chance to add Darkness.\",\"Blood Sword\":\"8 WP (absorbing), 1 range, 3% evade, Sword.\",\"Bloody Strings\":\"11 WP (absorbing), 3 range, 7% evade, Harp.\",\"Bombs\":\"Weapon Subtype (throwing). Formula: N/A.\",\"Books\":\"Weapon Subtype (direct). Formula: Damage ((PA + MA) / 2 * WP).\",\"Bow Gun\":\"5 WP, 4 range, 8% evade, Crossbow. Element: Fire. Effect: +2 PA.\",\"Bows\":\"Weapon Subtype (arcing). Formula: Damage ((PA + Speed) / 2 * WP). Effect: Prevents the unit from equipping a Shield (unless it has Equip Shield) or another weapon in the offhand with Dual Wield.\",\"Bracer\":\"Accessory. Effect: +3 PA.\",\"Brigandine\":\"+74 HP, +22 MP, Clothing.\",\"Bronze Armor\":\"+52 HP, +4 MP, Armor.\",\"Bronze Helmet\":\"+42 HP, +4 MP, Helmet.\",\"Bronze Shield\":\"19% physical evade, 8% magic evade, Shield.\",\"Buckler\":\"17% physical evade, 3% magic evade, Shield. Effect: +1 PA.\",\"Burst Bomb\":\"8 WP, Bomb. Element: Fire.\",\"Cachusha\":\"+25 HP, +29 MP, Hat. Effect: +1 MA; Immune Death, Darkness, Silence, Oil, Frog, Poison, Stop, Charm, Don't Act.\",\"Carabini Mail\":\"+105 HP, +0 MP, Armor. Effect: Half Wind, Earth, Water.\",\"Cashmere\":\"12 WP, 2 range, 65% evade, Fabric. Effect: Chance to cast Witch Hunt.\",\"Chain Mail\":\"+58 HP, +0 MP, Armor. Effect: +1 Jump; Immune Don't Act.\",\"Chain Shirt\":\"+50 HP, +1 MP, Clothing. Effect: +1 Jump.\",\"Chameleon Robe\":\"+57 HP, +28 MP, Robe. Effect: Absorb Holy; Strengthen Water; Immune Don't Move.\",\"Chantage\":\"Accessory. Effect: Permanent Regen; Initial Reraise.\",\"Chaos Blade\":\"25 WP, 1 range, 19% evade, Knight Sword. Effect: Absorb Dark; Strengthen Dark; Initial Regen; Chance to add Petrify.\",\"Cherche\":\"Accessory. Effect: +1 PA, +1 MA; Permanent Float, Reflect.\",\"Chirijiraden\":\"24 WP, 1 range, 15% evade, Katana. Effect: Chance to cast Blade Beam.\",\"Circlet\":\"+100 HP, +0 MP, Helmet. Effect: Half Holy, Dark.\",\"Clothes\":\"+33 HP, +18 MP, Clothing. Effect: +1 Move.\",\"Clothing\":\"Body Equipment Type. Increases HP and MP. Typically offers more effects compared to other body equipment.\",\"Consumables\":\"Item Type. Enables a single use of the corresponding Item ability while in the team's inventory.\",\"Coral Sword\":\"9 WP, 1 range, 10% evade, Sword. Element: Lightning. Effect: +1 Move.\",\"Cross Helmet\":\"+73 HP, +0 MP, Helmet. Effect: +1 MA.\",\"Crossbows\":\"Weapon Subtype (direct). Formula: Damage (PA * WP).\",\"Crystal Helmet\":\"+110 HP, +3 MP, Helmet.\",\"Crystal Mail\":\"+115 HP, +3 MP, Armor.\",\"Crystal Shield\":\"40% physical evade, 7% magic evade, Shield.\",\"Cultist Dagger\":\"9 WP, 1 range, 13% evade, Knife. Effect: Chance to add Undead.\",\"Cursed Ring\":\"Accessory. Effect: +1 PA, +1 MA, +1 Speed; Permanent Undead.\",\"Cute Bag\":\"10 WP, 1 range, 1% evade, Bag. Effect: +1 MA; Strengthen Water; Initial Reflect.\",\"Cypress Pole\":\"7 WP, 2 range, 21% evade, Pole. Effect: +1 MA, +1 Speed.\",\"Dagger\":\"4 WP, 1 range, 5% evade, Knife. Effect: +2 Speed.\",\"Defender\":\"17 WP, 1 range, 60% evade, Knight Sword.\",\"Defense Ring\":\"Accessory. Effect: Half Wind; Strengthen Water; Immune Death, Sleep.\",\"Diamond Armlet\":\"Accessory. Effect: +1 PA, +1 MA; Immune Oil, Slow.\",\"Diamond Armor\":\"+86 HP, +7 MP, Armor.\",\"Diamond Helmet\":\"+82 HP, +7 MP, Helmet.\",\"Diamond Shield\":\"33% physical evade, 11% magic evade, Shield.\",\"Diamond Sword\":\"11 WP, 1 range, 26% evade, Sword.\",\"Dracula Mantle\":\"15% physical evade, 30% magic evade, Accessory.\",\"Dragon Rod\":\"6 WP, 1 range, 12% evade, Rod. Effect: +1 PA; Initial Reraise; Immune Frog.\",\"Dragon Whisker\":\"15 WP, 2 range, 8% evade, Spear. Effect: Permanent Shell.\",\"Earth Clothes\":\"+93 HP, +14 MP, Clothing. Effect: Absorb Earth; Strengthen Earth.\",\"Echo Grass\":\"Consumable. Effect: Cancel Silence.\",\"Elf Mantle\":\"30% physical evade, 15% magic evade, Accessory.\",\"Elixir\":\"Consumable. Effect: Heal (100)%; HealMP (100)%.\",\"Escutcheon\":\"8% physical evade, 9% magic evade, Shield. Effect: +1 Speed, +1 Jump.\",\"Ether\":\"Consumable. Effect: HealMP (20).\",\"Excalibur\":\"22 WP, 1 range, 35% evade, Knight Sword. Effect: Absorb Holy; Strengthen Holy; Initial Haste; Chance to cast Explosion Sword.\",\"Eye Drop\":\"Consumable. Effect: Cancel Darkness.\",\"Fabrics\":\"Weapon Subtype (lunging). Formula: Damage ((PA + MA) / 2 * WP).\",\"Fairy Harp\":\"14 WP, 3 range, 17% evade, Harp. Effect: Chance to add Charm.\",\"Faith Rod\":\"8 WP, 1 range, 22% evade, Rod. Effect: Initial Faith; Immune Innocent; Chance to add Faith.\",\"Feather Boots\":\"Accessory. Effect: Strengthen Wind; Permanent Float.\",\"Feather Hat\":\"+38 HP, +7 MP, Hat. Effect: +1 Jump; Absorb Wind; Strengthen Wind.\",\"Feather Mantle\":\"25% physical evade, 25% magic evade, Accessory.\",\"Flail\":\"11 WP, 1 range, 2% evade, Flail. Effect: Chance to cancel Charging, Defending, Performing.\",\"Flails\":\"Weapon Subtype (striking). Formula: Damage (Random(1,PA) * WP).\",\"Flame Rod\":\"3 WP, 1 range, 20% evade, Rod. Element: Fire. Effect: Strengthen Fire; Chance to cast Fire.\",\"Flame Shield\":\"31% physical evade, 2% magic evade, Shield. Effect: Absorb Fire; Half Ice.\",\"Flame Whip\":\"14 WP, 1 range, 3% evade, Flail. Element: Fire. Effect: Chance to cast Fire 2.\",\"Flash Hat\":\"+88 HP, +5 MP, Hat. Effect: +1 MA, +1 Speed.\",\"Gastrophetes\":\"14 WP, 4 range, 9% evade, Crossbow. Effect: Chance to cast Compress.\",\"Genji Armor\":\"+140 HP, +1 MP, Armor.\",\"Genji Gauntlet\":\"Accessory. Effect: +2 PA, +2 MA.\",\"Genji Helmet\":\"+130 HP, +1 MP, Helmet.\",\"Genji Shield\":\"50% physical evade, 1% magic evade, Shield.\",\"Germinas Boots\":\"Accessory. Effect: +1 Move, +1 Jump.\",\"Giant Axe\":\"15 WP, 1 range, 6% evade, Axe. Effect: Chance to -2 PA.\",\"Glacier Gun\":\"13 WP, 7 range, 5% evade, Gun. Element: Ice.\",\"Gokuu Pole\":\"11 WP, 2 range, 22% evade, Pole. Effect: Chance to add Innocent.\",\"Gold Armor\":\"+77 HP, +9 MP, Armor.\",\"Gold Helmet\":\"+65 HP, +9 MP, Helmet.\",\"Gold Shield\":\"26% physical evade, 13% magic evade, Shield.\",\"Gold Staff\":\"7 WP, 1 range, 23% evade, Staff. Effect: Chance to cast Spell Absorb.\",\"Golden Hairpin\":\"+79 HP, +35 MP, Hat. Effect: Immune Confusion, Silence.\",\"Grand Helmet\":\"+150 HP, +0 MP, Helmet. Effect: Immune Darkness, Sleep.\",\"Green Beret\":\"+54 HP, +1 MP, Hat. Effect: +1 Speed, +1 Move.\",\"Gungnir\":\"17 WP, 2 range, 10% evade, Spear. Element: Wind. Effect: Chance to cast Diamond Blade.\",\"Guns\":\"Weapon Subtype (direct). Formula: If physical gun, Damage (WP * WP); If magic gun, Damage Faith(WP * SpellPower). Effect: The unit's basic Attack cannot be evaded but are unaffected by Doublehand.\",\"Hair Adornments\":\"Hat Subtype. Grants status immunities. Contains: Cachusha, Barette, Ribbon.\",\"Halberd\":\"8 WP, 2 range, 10% evade, Spear. Effect: Half Holy, Dark.\",\"Harps\":\"Weapon Subtype (direct). Formula: Damage ((PA + MA) / 2 * WP).\",\"Hats\":\"Head Equipment Type. Increases HP and MP. Typically offers superior MP and more effects compared to other head equipment.\",\"Headgear\":\"+44 HP, +3 MP, Hat. Effect: +1 PA, +1 Jump.\",\"Healing Staff\":\"8 WP (healing), 1 range, 14% evade, Staff.\",\"Heaven's Cloud\":\"15 WP, 1 range, 21% evade, Katana. Element: Holy.\",\"Helmets\":\"Head Equipment Type. Increases HP and MP. Typically offers superior HP compared to other head equipment.\",\"Hero Shield\":\"54% physical evade, 28% magic evade, Shield.\",\"Hi-Ether\":\"Consumable. Effect: HealMP (50).\",\"Hi-Potion\":\"Consumable. Effect: Heal (120).\",\"Holy Lance\":\"13 WP, 2 range, 10% evade, Spear. Element: Holy. Effect: Chance to cast Holy.\",\"Holy Miter\":\"+72 HP, +21 MP, Hat. Effect: Strengthen Holy; Initial Regen.\",\"Holy Water\":\"Consumable. Effect: Cancel Undead, Blood Suck.\",\"Hunting Bow\":\"7 WP, 4 range, 11% evade, Crossbow. Effect: Chance to -1 Speed.\",\"Hydra Bag\":\"15 WP, 1 range, 2% evade, Bag. Effect: +1 Speed; Strengthen Wind; Immune Poison.\",\"Ice Brand\":\"12 WP, 1 range, 6% evade, Sword. Element: Ice. Effect: Chance to cast Ice 2.\",\"Ice Rod\":\"3 WP, 1 range, 20% evade, Rod. Element: Ice. Effect: Strengthen Ice; Chance to cast Ice.\",\"Ice Shield\":\"28% physical evade, 4% magic evade, Shield. Effect: Absorb Ice; Half Fire.\",\"Iga Knife\":\"13 WP, 1 range, 12% evade, Ninja Blade. Effect: Chance to cast Dash.\",\"Iron Armlet\":\"Accessory. Effect: +1 PA; Half Earth; Immune Don't Move, Don't Act.\",\"Iron Fan\":\"10 WP, 2 range, 24% evade, Pole. Effect: +1 Move.\",\"Iron Helmet\":\"+47 HP, +8 MP, Helmet. Effect: +1 PA.\",\"Iron Sword\":\"5 WP, 1 range, 14% evade, Sword. Effect: +1 PA, +1 Jump.\",\"Ivory Cane\":\"12 WP, 2 range, 26% evade, Pole. Element: Earth.\",\"Jade Armlet\":\"Accessory. Effect: Half Water; Strengthen Earth; Immune Petrify, Stop.\",\"Javelin\":\"5 WP, 2 range, 7% evade, Spear. Effect: Chance to cast Spin Fist.\",\"Judo Outfit\":\"+80 HP, +6 MP, Clothing. Effect: +1 PA; Immune Death.\",\"Kaiser Plate\":\"42% physical evade, 23% magic evade, Shield. Effect: Strengthen Fire, Lightning, Ice.\",\"Katanas\":\"Weapon Subtype (striking). Formula: Damage ((PA * Brave / 100) * WP).\",\"Kikuichimonji\":\"19 WP, 1 range, 16% evade, Katana. Effect: +1 PA.\",\"Kiyomori\":\"18 WP, 1 range, 29% evade, Katana. Effect: +1 MA.\",\"Knight Swords\":\"Weapon Subtype (striking). Formula: Damage ((PA * Brave / 100) * WP). Effect: Prevents the unit from equipping a Shield (unless it has Equip Shield) and have a reduced chance of being equipped in the offhand with Dual Wield.\",\"Knives\":\"Weapon Subtype (striking). Formula: Damage ((PA + Speed) / 2 * WP).\",\"Koga Knife\":\"14 WP, 1 range, 5% evade, Ninja Blade. Effect: +1 Jump.\",\"Koutetsu Knife\":\"12 WP, 1 range, 18% evade, Katana. Effect: +1 Move, +1 Jump.\",\"Kunai\":\"4 WP, 1 range, 9% evade, Ninja Blade. Effect: +1 Move.\",\"Lamia Harp\":\"9 WP, 3 range, 12% evade, Harp. Effect: Chance to add Confusion.\",\"Leather Armor\":\"+39 HP, +6 MP, Armor. Effect: +1 Speed.\",\"Leather Cap\":\"+31 HP, +10 MP, Hat. Effect: +1 Speed.\",\"Leather Helmet\":\"+37 HP, +6 MP, Helmet. Effect: +1 Speed.\",\"Leather Mantle\":\"10% physical evade, 10% magic evade, Accessory. Effect: +1 Speed.\",\"Leather Outfit\":\"+36 HP, +12 MP, Clothing. Effect: +1 Speed.\",\"Light Robe\":\"+84 HP, +45 MP, Robe. Effect: +1 MA; Absorb Dark.\",\"Lightning Bow\":\"10 WP, 5 range, 2% evade, Bow. Element: Lightning. Effect: Chance to cast Bolt 2.\",\"Linen Cuirass\":\"+46 HP, +11 MP, Armor. Effect: +1 Move.\",\"Linen Robe\":\"+35 HP, +15 MP, Robe. Effect: +1 MA, +1 Move.\",\"Long Bow\":\"6 WP, 6 range, 3% evade, Bow.\",\"Mace of Zeus\":\"11 WP, 1 range, 21% evade, Staff. Effect: +2 PA; Chance to cast Lifebreak.\",\"Madlemgen\":\"13 WP, 3 range, 13% evade, Book. Element: Dark. Effect: Chance to cast Dark Holy.\",\"Mage Masher\":\"6 WP, 1 range, 10% evade, Knife. Effect: Chance to add Silence.\",\"Magic Gauntlet\":\"Accessory. Effect: +3 MA.\",\"Magic Guns\":\"Gun Subtype. Guns with an element that cast a Black Magic spell of that element with a SpellPower of 16 (60%), 20 (30%) or 28 (10%). Formula: Damage Faith(WP * SpellPower). Contains: Blaze Gun, Glacier Gun, Blast Gun.\",\"Magic Ring\":\"Accessory. Effect: Half Ice; Strengthen Ice; Immune Silence, Berserk.\",\"Magic Shuriken\":\"6 WP, Shuriken. Element: Ice.\",\"Maiden's Kiss\":\"Consumable. Effect: Cancel Frog.\",\"Main Gauche\":\"7 WP, 1 range, 40% evade, Knife.\",\"Mantles\":\"Accessory Subtype. Grants physical and magical evasion. Contains: Leather Mantle, Small Mantle, Wizard Mantle, Elf Mantle, Dracula Mantle, Feather Mantle, Vanish Mantle.\",\"Masamune\":\"21 WP, 1 range, 14% evade, Katana. Effect: +2 Speed.\",\"Materia Blade\":\"16 WP, 1 range, 7% evade, Sword. Effect: Strengthen Wind, Earth, Water.\",\"Maximillian\":\"+160 HP, +0 MP, Armor. Effect: +1 Move; Immune Oil.\",\"Mirage Vest\":\"+56 HP, +8 MP, Clothing. Effect: +1 Speed.\",\"Morning Star\":\"16 WP, 1 range, 5% evade, Flail. Effect: Chance to add Oil.\",\"Muramasa\":\"16 WP, 1 range, 15% evade, Katana. Element: Dark.\",\"Murasame\":\"14 WP, 1 range, 15% evade, Katana. Effect: Chance to cast Demi 2.\",\"Musk Stick\":\"9 WP, 2 range, 20% evade, Pole. Effect: Chance to -2 MA.\",\"Mystic Vest\":\"+40 HP, +20 MP, Clothing. Effect: +1 MA.\",\"Mythril Armor\":\"+64 HP, +2 MP, Armor. Effect: +1 Speed.\",\"Mythril Bow\":\"8 WP, 5 range, 1% evade, Bow. Effect: +1 Speed.\",\"Mythril Gun\":\"9 WP, 7 range, 4% evade, Gun. Effect: +1 Speed.\",\"Mythril Helmet\":\"+59 HP, +2 MP, Helmet. Effect: +1 Speed.\",\"Mythril Knife\":\"5 WP, 1 range, 9% evade, Knife. Effect: +1 Speed.\",\"Mythril Shield\":\"22% physical evade, 6% magic evade, Shield. Effect: +1 Speed.\",\"Mythril Spear\":\"9 WP, 2 range, 5% evade, Spear. Effect: +1 Speed.\",\"Mythril Sword\":\"7 WP, 1 range, 8% evade, Sword. Effect: +1 Speed.\",\"N-Kai Armlet\":\"Accessory. Effect: Half Dark; Strengthen Holy; Immune Confusion, Charm.\",\"Nagrarock\":\"6 WP, 1 range, 50% evade, Sword. Effect: +2 MA; Permanent Evil; Initial Float; Chance to add Frog.\",\"Night Killer\":\"6 WP, 4 range, 13% evade, Crossbow. Effect: +1 MA; Chance to add Darkness.\",\"Ninja Blades\":\"Weapon Subtype (striking). Formula: Damage ((PA + Speed) / 2 * WP).\",\"Ninja Edge\":\"10 WP, 1 range, 20% evade, Ninja Blade. Effect: Chance to cast Foxbird.\",\"Oak Staff\":\"4 WP, 1 range, 19% evade, Staff. Effect: Absorb Water.\",\"Obelisk\":\"11 WP, 2 range, 9% evade, Spear. Element: Water. Effect: +1 MA.\",\"Octagon Rod\":\"14 WP, 2 range, 18% evade, Pole. Effect: Chance to cancel Float, Reraise, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Orichalcum\":\"7 WP, 1 range, 7% evade, Knife. Effect: Initial Haste.\",\"Panther Bag\":\"12 WP, 1 range, 4% evade, Bag. Effect: Strengthen Earth; Permanent Regen; Immune Death Sentence.\",\"Papyrus Codex\":\"10 WP, 3 range, 6% evade, Book. Element: Water. Effect: Chance to add Faith, Innocent (Random).\",\"Partisan\":\"10 WP, 2 range, 16% evade, Spear.\",\"Perfumes\":\"Accessory Subtype. Grants positive statuses. Contains: Cherche, Salty Rage, Chantage, Setiemson.\",\"Perseus Bow\":\"15 WP, 5 range, 4% evade, Bow.\",\"Persia\":\"9 WP, 2 range, 55% evade, Fabric. Effect: +1 PA.\",\"Phoenix Down\":\"Consumable. Effect: Cancel Death; If successful, Heal Random(1,20); If Undead, Damage (100)% instead.\",\"Physical Guns\":\"Gun Subtype. Guns without an element that only factor WP in their damage formula. Formula: Damage (WP * WP). Contains: Romanda Gun, Mythril Gun, Stone Gun.\",\"Plate Mail\":\"+70 HP, +0 MP, Armor. Effect: +1 PA.\",\"Platinum Armor\":\"+95 HP, +0 MP, Armor.\",\"Platinum Helmet\":\"+91 HP, +0 MP, Helmet.\",\"Platinum Shield\":\"37% physical evade, 5% magic evade, Shield.\",\"Platinum Sword\":\"13 WP, 1 range, 11% evade, Sword.\",\"Poison Rod\":\"4 WP, 1 range, 17% evade, Rod. Effect: +2 PA; Chance to add Poison.\",\"Poles\":\"Weapon Subtype (lunging). Formula: Damage (MA * WP).\",\"Potion\":\"Consumable. Effect: Heal (100).\",\"Power Sleeve\":\"+87 HP, +0 MP, Clothing. Effect: +2 PA.\",\"Power Staff\":\"4 WP, 1 range, 13% evade, Staff. Effect: +1 PA, +1 MA.\",\"Power Wrist\":\"Accessory. Effect: +1 PA; Half Fire; Strengthen Fire.\",\"Ragnarok\":\"20 WP, 1 range, 27% evade, Knight Sword. Effect: Permanent Shell.\",\"Rainbow Staff\":\"6 WP, 1 range, 11% evade, Staff. Element: Earth. Effect: +1 Speed.\",\"Red Hood\":\"+34 HP, +50 MP, Hat.\",\"Red Shoes\":\"Accessory. Effect: +1 MA, +1 Move.\",\"Reflect Mail\":\"+125 HP, +5 MP, Armor. Effect: Permanent Reflect.\",\"Reflect Ring\":\"Accessory. Effect: Permanent Reflect; Initial Protect.\",\"Remedy\":\"Consumable. Effect: Cancel Confusion, Oil, Sleep.\",\"Ribbon\":\"+27 HP, +27 MP, Hat. Effect: Immune Death, Undead, Petrify, Darkness, Confusion, Silence, Blood Suck, Oil, Berserk, Frog, Poison, Slow, Stop, Charm, Sleep, Don't Move, Don't Act.\",\"Robe of Lords\":\"+98 HP, +60 MP, Robe. Effect: +1 PA; Initial Protect, Shell.\",\"Robes\":\"Body Equipment Type. Increases HP and MP. Typically offers superior MP compared to other body equipment.\",\"Rod\":\"4 WP, 1 range, 24% evade, Rod. Effect: Absorb Lightning.\",\"Rods\":\"Weapon Subtype (striking). Formula: Damage (PA * WP).\",\"Romanda Gun\":\"7 WP, 8 range, 6% evade, Gun.\",\"Round Shield\":\"12% physical evade, 17% magic evade, Shield.\",\"Rubber Costume\":\"+120 HP, +30 MP, Clothing. Effect: Half Lightning; Immune Slow.\",\"Rubber Shoes\":\"Accessory. Effect: Half Lightning; Strengthen Lightning; Initial Shell.\",\"Rune Axe\":\"13 WP, 1 range, 15% evade, Axe. Effect: Half Fire, Lightning, Ice; Chance to cast Manaburn.\",\"Rune Blade\":\"14 WP, 1 range, 10% evade, Sword. Effect: +1 MA.\",\"Ryozan Silk\":\"15 WP, 2 range, 45% evade, Fabric. Effect: Chance to add Stop.\",\"Sage Staff\":\"9 WP, 1 range, 17% evade, Staff. Effect: Permanent Protect.\",\"Salty Rage\":\"Accessory. Effect: Permanent Protect, Shell.\",\"Sasuke Knife\":\"12 WP, 1 range, 15% evade, Ninja Blade.\",\"Save the Queen\":\"19 WP, 1 range, 23% evade, Knight Sword. Effect: Permanent Protect.\",\"Scholar Outfit\":\"+68 HP, +10 MP, Clothing. Effect: +2 MA.\",\"Scorpion Tail\":\"23 WP, 1 range, 1% evade, Flail. Element: Earth. Effect: Chance to cast Nether Demon.\",\"Secret Clothes\":\"+45 HP, +4 MP, Clothing. Effect: +2 Speed; Initial Transparent.\",\"Setiemson\":\"Accessory. Effect: Permanent Haste.\",\"Shields\":\"Offhand Equipment Type. Grants physical and magical evasion.\",\"Short Blade\":\"6 WP, 1 range, 6% evade, Ninja Blade. Effect: +1 Speed.\",\"Shuriken\":\"4 WP, Shuriken.\",\"Shurikens\":\"Weapon Subtype (throwing). Formula: N/A.\",\"Silk Robe\":\"+41 HP, +19 MP, Robe. Effect: +1 Speed.\",\"Silver Bow\":\"7 WP, 5 range, 4% evade, Bow. Element: Ice. Effect: +2 MA.\",\"Slasher\":\"18 WP, 1 range, 4% evade, Axe. Effect: Chance to add Slow.\",\"Sleep Sword\":\"8 WP, 1 range, 20% evade, Sword. Effect: Chance to add Sleep.\",\"Small Mantle\":\"20% physical evade, 20% magic evade, Accessory. Effect: Half Holy.\",\"Soft\":\"Consumable. Effect: Cancel Petrify.\",\"Spark Bomb\":\"8 WP, Bomb. Element: Lightning.\",\"Spear\":\"7 WP, 2 range, 12% evade, Spear. Effect: +1 Jump.\",\"Spears\":\"Weapon Subtype (lunging). Formula: Damage (PA * WP).\",\"Spell Edge\":\"11 WP, 1 range, 4% evade, Ninja Blade. Effect: Chance to add Don't Act.\",\"Spike Shoes\":\"Accessory. Effect: +1 Speed, +1 Jump.\",\"Sprint Shoes\":\"Accessory. Effect: +2 Speed.\",\"Star Bag\":\"20 WP, 1 range, 3% evade, Bag.\",\"Staves\":\"Weapon Subtype (striking). Formula: Damage (MA * WP).\",\"Stone Gun\":\"12 WP, 6 range, 8% evade, Gun. Effect: Initial Slow; Immune Petrify, Float.\",\"Swords\":\"Weapon Subtype (striking). Formula: Damage (PA * WP).\",\"Thief Cap\":\"+67 HP, +0 MP, Hat. Effect: +2 Speed.\",\"Thief Knife\":\"5 WP, 1 range, 18% evade, Knife. Effect: Chance to cast Steal Accessory.\",\"Thunder Rod\":\"3 WP, 1 range, 20% evade, Rod. Element: Lightning. Effect: Strengthen Lightning; Chance to cast Bolt.\",\"Torrent Bomb\":\"8 WP, Bomb. Element: Water.\",\"Triangle Hat\":\"+49 HP, +17 MP, Hat. Effect: +2 MA.\",\"Twist Headband\":\"+60 HP, +13 MP, Hat. Effect: +2 PA.\",\"Ultimus Bow\":\"12 WP, 5 range, 5% evade, Bow. Effect: Chance to cancel Undead, Innocent, Evil.\",\"Unarmed\":\"Weapon Subtype (striking). Formula: Damage (PA * (PA * Brave / 100)). Effect: The unit's basic Attack are not prevented from using a hand equipped with a Shield but are unaffected by Doublehand.\",\"Vanish Mantle\":\"35% physical evade, 0% magic evade, Accessory. Effect: Strengthen Dark; Initial Transparent.\",\"Venetian Shield\":\"46% physical evade, 19% magic evade, Shield. Effect: Half Fire, Lightning, Ice.\",\"Venom Bow\":\"9 WP, 4 range, 7% evade, Crossbow. Effect: Chance to add Poison.\",\"Weapons\":\"Mainhand Equipment Type. Determines what weapon formula a basic Attack uses, at what WP and range, how that range operates, and evasion to grant to units with Parry.\",\"Whale Whisker\":\"16 WP, 2 range, 20% evade, Pole. Element: Water. Effect: Chance to cast Leviathan.\",\"White Robe\":\"+75 HP, +33 MP, Robe. Effect: Half Fire, Lightning, Ice.\",\"White Staff\":\"5 WP, 1 range, 16% evade, Staff. Effect: Chance to cast Steal Status.\",\"Windslash Bow\":\"9 WP, 5 range, 15% evade, Bow. Element: Wind. Effect: +1 Jump.\",\"Wizard Mantle\":\"15% physical evade, 15% magic evade, Accessory. Effect: +1 MA.\",\"Wizard Robe\":\"+48 HP, +24 MP, Robe. Effect: +2 MA.\",\"Wizard Rod\":\"5 WP, 1 range, 20% evade, Rod. Effect: +2 MA.\",\"X-Potion\":\"Consumable. Effect: Heal (150).\",\"Yagyu Shuriken\":\"9 WP, Shuriken. Element: Dark.\",\"Yoichi Bow\":\"14 WP, 5 range, 2% evade, Bow. Effect: +1 Move.\",\"Zorlin Shape\":\"12 WP, 1 range, 11% evade, Knife. Effect: Chance to add Death, Sleep (Random).\"},\"Ability\":{\"3\":\"Expression for targeting units whose algorithmic attribute is a multiple of 3.\",\"4\":\"Expression for targeting units whose algorithmic attribute is a multiple of 4.\",\"5\":\"Expression for targeting units whose algorithmic attribute is a multiple of 5.\",\"Abandon\":\"Reaction. Doubles the unit's evasion.\",\"Absorb Used MP\":\"Reaction. After the unit was targeted by an ability using MP, it heals its MP by the amount spent.\",\"Abyss Skill\":\"Blue Skillset. Skeleton family and Squid family abilities.\",\"Accumulate\":\"0 range, 0 AoE. Effect: +1 PA, +1 MA.\",\"All-Ultima\":\"5 range, 3 AoE, 8 CT, 33 MP. Element: Holy. Effect: Damage Faith(MA * 55).\",\"Angel Song\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: HealMP (MA + 20).\",\"Animal Skill\":\"Blue Skillset. Cat family and Pig family abilities.\",\"Antidote\":\"1 range, 0 AoE. Effect: Cancel Poison.\",\"Aqua Soul\":\"3 range, 0 AoE. Element: Water. Effect: Damage (MA * 3).\",\"Arm Aim\":\"weapon range, 0 AoE. Hit: (Speed + 42)%. Effect: Add Don't Act.\",\"Armor Rend\":\"weapon range, 0 AoE. Hit: (PA + WP + 48)%. Effect: Remove target's body equipment; If none is equipped, basic Attack instead.\",\"Arrow Guard\":\"Reaction. When the unit is targeted by an attack from a weapon with 4 range or greater, it negates that attack.\",\"Asura\":\"0 range, 2 AoE. Effect: Damage (MA * 8); Chance to cancel Defending, Float, Berserk, Regen, Protect, Shell, Haste, Slow.\",\"Attack\":\"weapon range, 0 AoE. Effect: If armed, weapon type's formula; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Attack Up\":\"Support. Increases the damage (or hitrate) of the unit's physical attacks by a third (except jumping and Throw abilities).\",\"Auto Potion\":\"Reaction. After the unit was damaged by an attack, it uses a Potion (healing 100 HP).\",\"Axe\":\"move range, 0 AoE. Effect: Throw Axe (Giant Axe); Damage (Speed * ThrownWP).\",\"Bad Breath\":\"0 range, 2 AoE. Effect: Add Petrify, Darkness, Confusion, Silence, Oil, Frog, Poison, Sleep, Don't Act (Separate).\",\"Bahamut\":\"4 range, 3 AoE (homing), 11 CT, 62 MP. Element: Dark. Effect: Damage Faith(MA * 44).\",\"Basic Skill\":\"Skillset. Squire job abilities.\",\"Battle Skill\":\"Skillset. Knight job abilities.\",\"Battle Song\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: +1 PA.\",\"Beak\":\"1 range, 0 AoE. Hit: (MA + 36)%. Effect: Add Petrify.\",\"Beam\":\"4 range, 0 AoE. Hit: (MA + 51)%. Effect: -2 MA.\",\"Beast Skill\":\"Blue Skillset. Minotaur family and Behemoth family abilities.\",\"Beastmaster\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"Bequeath Bacon\":\"2 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"Bio\":\"Blue Skillset. Apanda abilities.\",\"Bio Immortuos\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Water. Effect: Damage Faith(MA * 26); Chance to add Undead.\",\"Bio Insanis\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Wind. Effect: Damage Faith(MA * 26); Chance to add Confusion.\",\"Bio Lapis\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 115)%. Effect: Add Petrify.\",\"Bio Mortem\":\"4 range, 2 AoE, 6 CT, 21 MP. Element: Earth. Effect: Damage Faith(MA * 26); Chance to add Death.\",\"Bio Oleum\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Earth. Effect: Damage Faith(MA * 13); Chance to add Oil.\",\"Bio Ranae\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 117)%. Effect: Add Frog.\",\"Bio Silentium\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 123)%. Effect: Add Silence.\",\"Bio Tardus\":\"4 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 120)%. Effect: Add Slow.\",\"Bio Tenebris\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Wind. Effect: Damage Faith(MA * 13); Chance to add Darkness.\",\"Bio Venenum\":\"4 range, 1 AoE, 3 CT, 7 MP. Element: Water. Effect: Damage Faith(MA * 13); Chance to add Poison.\",\"Bird Skill\":\"Blue Skillset. Chocobo family and Aevis family abilities.\",\"Bite\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Oil.\",\"Bizen Boat\":\"0 range, 2 AoE. Effect: DamageMP (MA * 5).\",\"Black Ink\":\"2 range, 0 AoE (linear). Hit: (MA + 55)%. Effect: Add Darkness, Oil (All).\",\"Black Magic\":\"Skillset. Wizard job abilities.\",\"Blade Beam\":\"3 range, 0 AoE, 5 CT. Effect: Damage ((125 - Brave) * TargetBrave / 16).\",\"Blade Grasp\":\"Reaction. When the unit is targeted by a counterable attack, it negates that attack.\",\"Blastar Punch\":\"3 range, 1 AoE, 9 MP. Effect: Remove target's head equipment; If successful, Damage (PA * (WP + 2)).\",\"Blaster\":\"3 range, 0 AoE. Hit: (MA + 38)%. Effect: Add Petrify, Stop, Sleep (Random).\",\"Blind\":\"5 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 200)%. Effect: Add Darkness.\",\"Blizzard\":\"5 range, 1 AoE. Terrain: Snow, Glacier. Element: Ice. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Silence.\",\"Blood Suck\":\"1 range, 0 AoE. Effect: AbsorbHP (25)%; Chance to add Blood Suck.\",\"Blow Fire\":\"3 range, 0 AoE (linear). Element: Fire. Effect: Damage (MA * 3).\",\"Blue Magic\":\"Enables the unit to equip special secondary skillsets that feature both monster and exclusive abilities.\",\"Bolt\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Lightning. Effect: Damage Faith(MA * 16).\",\"Bolt 2\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Lightning. Effect: Damage Faith(MA * 20).\",\"Bolt 3\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Lightning. Effect: Damage Faith(MA * 28).\",\"Bolt 4\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Lightning. Effect: Damage Faith(MA * 35).\",\"Bomb\":\"move range, 0 AoE. Effect: Throw Bomb (Burst Bomb, Torrent Bomb, Spark Bomb); Damage (Speed * ThrownWP).\",\"Brave Save\":\"Reaction. After the unit was targeted by a counterable attack, it gains +3 Brave.\",\"Braver\":\"2 range, 1 AoE, 3 CT. Effect: Damage (MA * 16).\",\"Breath\":\"Monster Skillset. Holy Dragon abilities.\",\"Byblos\":\"Blue Skillset. Byblos abilities.\",\"CT\":\"Algorithm for targeting units based on their CT.\",\"Calm Spirit\":\"0 range, 2 AoE. Hit: (MA + 60)%. Effect: Add Defending, Shell (All).\",\"Carbunkle\":\"4 range, 2 AoE (homing), 8 CT, 36 MP. Hit: Faith(MA + 140)%. Effect: Cancel Death, Undead, Petrify, Charm, Sleep, Death Sentence; If successful, Heal (20)%.\",\"Cat Kick\":\"1 range, 0 AoE. Element: Earth. Effect: Damage (PA * Random(1,8)); Chance to knockback.\",\"Catch\":\"Reaction. When the unit is targeted by a Throw ability, it negates that ability.\",\"Catfish Skill\":\"Blue Skillset. Squid family and Cat family abilities.\",\"Caution\":\"Reaction. After the unit was targeted by a counterable attack, add Defending.\",\"Cerberus Skill\":\"Blue Skillset. Hydra family and Minotaur family abilities.\",\"Chakra\":\"0 range, 1 AoE. Effect: Heal (PA * 5); HealMP (PA * 5 / 2).\",\"Charge\":\"Skillset (snipe). Archer job abilities.\",\"Charge+1\":\"weapon range, 0 AoE, 3 CT (aiming). Effect: Basic Attack with +1 added to the primary stat.\",\"Charge+10\":\"weapon range, 0 AoE, 12 CT (aiming). Effect: Basic Attack with +10 added to the primary stat.\",\"Charge+2\":\"weapon range, 0 AoE, 4 CT (aiming). Effect: Basic Attack with +2 added to the primary stat.\",\"Charge+20\":\"weapon range, 0 AoE, 16 CT (aiming). Effect: Basic Attack with +20 added to the primary stat.\",\"Charge+3\":\"weapon range, 0 AoE, 5 CT (aiming). Effect: Basic Attack with +3 added to the primary stat.\",\"Charge+4\":\"weapon range, 0 AoE, 6 CT (aiming). Effect: Basic Attack with +4 added to the primary stat.\",\"Charge+5\":\"weapon range, 0 AoE, 7 CT (aiming). Effect: Basic Attack with +5 added to the primary stat.\",\"Charge+7\":\"weapon range, 0 AoE, 9 CT (aiming). Effect: Basic Attack with +7 added to the primary stat.\",\"Cheer Song\":\"0 range, 255 AoE (homing), 6 CT (recurring). Hit: (50)%. Effect: +1 Speed.\",\"Cheer Up\":\"3 range, 0 AoE. Hit: (MA + 87)%. Effect: Add Defending, Float, Reraise, Transparent, Regen, Faith (Separate).\",\"Cherry Blossom\":\"3 range, 2 AoE, 15 CT. Effect: Damage (MA * 58).\",\"Chicken\":\"5 range, 1 AoE, 5 CT, 19 MP. Hit: Faith(MA + 199)%. Effect: -40 Brave.\",\"Chirijiraden\":\"0 range, 2 AoE. Effect: Damage (MA * 17).\",\"Choco Attack\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Charging, Performing.\",\"Choco Ball\":\"4 range, 0 AoE. Element: Water. Effect: Damage (PA * ((PA + 1) / 2)).\",\"Choco Cure\":\"0 range, 1 AoE. Effect: Heal (MA * 3).\",\"Choco Esuna\":\"0 range, 1 AoE. Hit: (MA + 64)%. Effect: Cancel Undead, Petrify, Darkness, Silence, Poison, Stop, Innocent, Don't Move, Don't Act.\",\"Choco Meteor\":\"5 range, 0 AoE. Effect: Damage (MA * 4).\",\"Climhazzard\":\"4 range, 0 AoE, 6 CT. Effect: Damage (TargetMaxHP - TargetCurrentHP).\",\"Compress\":\"2 range, 0 AoE. Effect: Damage (PA * 15); DamageCaster (PA * 5).\",\"Concentrate\":\"Support. Prevents physical attacks used by the unit from being evaded.\",\"Confuse\":\"5 range, 1 AoE, 4 CT, 20 MP. Hit: Faith(MA + 160)%. Effect: Add Confusion.\",\"Counter\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"Counter Flood\":\"Reaction. After the unit was targeted by certain attacks, it retaliates with Elemental.\",\"Counter Magic\":\"Reaction. After the unit was targeted by certain offensive magic while having enough MP to cast that same spell, it retaliates with a cast of that spell.\",\"Counter Tackle\":\"Reaction. After the unit was targeted by a counterable attack from an adjacent unit, it retaliates with Dash.\",\"Critical Quick\":\"Reaction. After the unit was damaged to Critical by an attack, its CT is set to 100 (Quick).\",\"Cross-Slash\":\"3 range, 3 AoE (trilinear), 4 CT. Effect: Damage (MA * 22).\",\"Cure\":\"5 range, 1 AoE, 3 CT, 5 MP. Effect: Heal Faith(MA * 15).\",\"Cure 2\":\"5 range, 1 AoE, 4 CT, 10 MP. Effect: Heal Faith(MA * 20).\",\"Cure 3\":\"5 range, 1 AoE, 6 CT, 16 MP. Effect: Heal Faith(MA * 30).\",\"Cure 4\":\"5 range, 1 AoE, 8 CT, 24 MP. Effect: Heal Faith(MA * 40).\",\"Curse Skill\":\"Blue Skillset. Eye family and Ghost family abilities.\",\"Cyclops\":\"4 range, 2 AoE (homing), 11 CT, 66 MP. Effect: Damage Faith(MA * 50).\",\"Damage Split\":\"Reaction. After the unit was damaged by an attack, it heals half of that damage and retaliates with damage equal to the amount healed.\",\"Dance\":\"Skillset. Dancer job abilities.\",\"Dark Cloud\":\"Monster Skillset. Serpentarius abilities.\",\"Dark Holy\":\"5 range, 0 AoE, 7 CT, 41 MP. Element: Dark. Effect: Damage Faith(MA * 41).\",\"Dark Magic\":\"Monster Skillset. Archaic Demon abilities.\",\"Dark Sword\":\"2 range, 0 AoE, 3 CT, 17 MP. Effect: AbsorbMP (PA * WP).\",\"Dark Whisper\":\"4 range, 1 AoE (multihit). Element: Dark. Hit: 6 times. Effect: Damage (MA * ((MA + 4) / 2)); Chance to add Death, Sleep, Evil (Separate).\",\"Dash\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,4)); Chance to knockback.\",\"Death\":\"5 range, 0 AoE, 10 CT, 28 MP. Hit: Faith(MA + 113)%. Effect: Add Death; If successful, Damage (100)%; If Undead, Heal (100)% instead.\",\"Death Sentence\":\"4 range, 0 AoE. Hit: Human; (MA + 34)%. Effect: Add Death Sentence.\",\"Defend\":\"Support. Allows the unit to use the Guard ability (to add Defending).\",\"Defense Up\":\"Support. Decreases the damage (or hitrate) that the unit takes from physical attacks by a third.\",\"Demi\":\"5 range, 1 AoE, 3 CT, 18 MP. Hit: Faith(MA + 208)%. Effect: Damage (25)%.\",\"Demi 2\":\"5 range, 1 AoE, 6 CT, 40 MP. Hit: Faith(MA + 165)%. Effect: Damage (50)%.\",\"Demi 3\":\"5 range, 1 AoE, 4 CT, 29 MP. Hit: Faith(MA + 182)%. Effect: Damage (TargetCurrentHP - 1).\",\"Demon Skill\":\"Blue Skillset. Demon family abilities.\",\"Despair\":\"6 range, 0 AoE, 2 CT, 9 MP. Hit: Faith(MA + 214)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Despair 2\":\"4 range, 2 AoE (homing), 5 CT, 22 MP. Hit: Faith(MA + 196)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Destroy\":\"4 range, 0 AoE. Effect: Damage (PA * 10); DamageCaster (PA * 5 / 2).\",\"Diamond Blade\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Wind. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"Dictionary\":\"move range, 0 AoE. Effect: Throw Book (Papyrus Codex); Damage (Speed * ThrownWP).\",\"Dinosaur Skill\":\"Blue Skillset. Dragon family and Hydra family abilities.\",\"Disease Skill\":\"Blue Skillset. Malboro family and Skeleton family abilities.\",\"Disillusion\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: -1 MA.\",\"Dispel Magic\":\"5 range, 1 AoE, 3 CT, 32 MP. Hit: Faith(MA + 205)%. Effect: Cancel Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Dispose\":\"8 range, 0 AoE. Effect: Damage (PA * 5); DamageCaster (PA).\",\"Distribute\":\"Reaction. After the unit was healed by more HP than necessary to reach MaxHP, it heals allied damaged units equal to the excess (divided evenly).\",\"Doom\":\"3 range, 0 AoE. Hit: (MA + 45)%. Effect: Add Death Sentence.\",\"Doublehand\":\"Support. Doubles the damage of the unit's basic Attack unless unarmed or equipped with a Gun, but prevents it from equipping items in the offhand.\",\"Doubt Faith\":\"5 range, 0 AoE, 4 CT, 7 MP. Hit: Faith(MA + 155)%. Effect: Add Innocent.\",\"Dragon Pit\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Water. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"Dragon Spirit\":\"Reaction. After the unit was targeted by a counterable attack, add Reraise.\",\"Drain Touch\":\"1 range, 0 AoE. Hit: (MA + 62)%. Effect: AbsorbHP (34)%.\",\"Draw Out\":\"Skillset (inventory). Samurai job abilities.\",\"Dual Wield\":\"Support. Allows the unit to equip an additional weapon in the offhand unless equipped with a Bow, attacking once with each (or both fists if unarmed).\",\"Dungeon Skill\":\"Blue Skillset. Goblin family and Dragon family abilities.\",\"Earplug\":\"Reaction. When the unit is targeted by a Talk Skill ability, it negates that ability.\",\"Earth Slash\":\"8 range, 8 AoE (linear). Element: Earth. Effect: Damage (PA * (PA / 2)).\",\"Echo Grass\":\"1 range, 0 AoE. Effect: Cancel Silence.\",\"Elemental\":\"Skillset (geomancy). Geomancer job abilities.\",\"Elixir\":\"1 range, 0 AoE. Effect: Heal (100)%; HealMP (100)%.\",\"Empower\":\"4 range, 0 AoE, 9 CT, 13 MP. Hit: Faith(MA + 236)%. Effect: +2 PA, +2 MA, +2 Speed.\",\"Energize\":\"4 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"Enrage\":\"5 range, 0 AoE, 5 CT, 18 MP. Hit: Faith(MA + 135)%. Effect: Add Berserk.\",\"Equip Armor\":\"Support. Allows the unit to equip Hats, Helmets, Clothing, Armor, and Robes.\",\"Equip Axe\":\"Support. Allows the unit to equip Axes, Flails, and Staves.\",\"Equip Bow\":\"Support. Allows the unit to equip Bows, Crossbows, and rarely Bags.\",\"Equip Gun\":\"Support. Allows the unit to equip Guns, Books, and Harps.\",\"Equip Knife\":\"Support. Allows the unit to equip Knives, Ninja Blades, and Rods.\",\"Equip Polearm\":\"Support. Allows the unit to equip Spears, Poles, and Fabrics.\",\"Equip Shield\":\"Support. Allows the unit to equip Shields (even if a Knight Sword or Bow is equipped).\",\"Equip Sword\":\"Support. Allows the unit to equip Swords, Knight Swords, and Katanas.\",\"Esuna\":\"5 range, 1 AoE, 2 CT, 17 MP. Hit: Faith(MA + 205)%. Effect: Cancel Petrify, Darkness, Confusion, Silence, Blood Suck, Berserk, Frog, Poison, Sleep, Don't Move, Don't Act.\",\"Ether\":\"1 range, 0 AoE. Effect: HealMP (20).\",\"Explosion Sword\":\"4 range, 4 AoE (linear), 2 CT, 27 MP. Effect: Damage (PA * (WP + 3)); Chance to add Confusion.\",\"Eye Drop\":\"1 range, 0 AoE. Effect: Cancel Darkness.\",\"Eye Gouge\":\"1 range, 0 AoE. Hit: (MA + 54)%. Effect: Add Darkness, Confusion (All).\",\"Fairy\":\"4 range, 2 AoE (homing), 6 CT, 30 MP. Effect: Heal Faith(MA * 24).\",\"Faith Save\":\"Reaction. After the unit was targeted by an ability using MP, it gains +3 Faith.\",\"Farm Skill\":\"Blue Skillset. Chocobo family and Pig family abilities.\",\"Feather Bomb\":\"5 range, 0 AoE. Element: Wind. Effect: Damage (MA * 2).\",\"Finish Touch\":\"2 range, 1 AoE, 7 CT, 28 MP. Effect: Add Death, Petrify, Stop (Random).\",\"Fire\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Fire. Effect: Damage Faith(MA * 16).\",\"Fire 2\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Fire. Effect: Damage Faith(MA * 20).\",\"Fire 3\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Fire. Effect: Damage Faith(MA * 28).\",\"Fire 4\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Fire. Effect: Damage Faith(MA * 35).\",\"Fire Breath\":\"2 range, 2 AoE (linear). Element: Fire. Effect: Damage (MA * 5).\",\"Flame Attack\":\"3 range, 0 AoE. Element: Fire. Effect: Damage (MA * 4).\",\"Flare\":\"6 range, 0 AoE, 7 CT, 60 MP. Effect: Damage Faith(MA * 48).\",\"Flare 2\":\"4 range, 1 AoE (homing), 4 CT, 23 MP. Effect: Damage Faith(MA * 42).\",\"Float\":\"5 range, 1 AoE, 2 CT, 3 MP. Hit: Faith(MA + 170)%. Effect: Add Float.\",\"Fly\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"Forest Skill\":\"Blue Skillset. Tree family and Aevis family abilities.\",\"Foul Skill\":\"Blue Skillset. Pig family and Malboro family abilities.\",\"Foxbird\":\"6 range, 0 AoE, 4 CT, 11 MP. Hit: Faith(MA + 170)%. Effect: -30 Brave.\",\"Frog\":\"4 range, 0 AoE, 5 CT, 11 MP. Hit: Faith(MA + 125)%. Effect: Add Frog.\",\"Frog Attack\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"Frost Soul\":\"3 range, 0 AoE. Element: Ice. Effect: Damage (MA * 3).\",\"Frozen Cry\":\"1 range, 0 AoE. Element: Ice. Effect: Damage (PA * ((PA + 2) / 2)); Chance to add Death.\",\"Fury\":\"0 range, 0 AoE. Hit: (PA + 85)%. Effect: Add Berserk, Haste (All); If successful, Heal (35)%.\",\"Galaxy Stop\":\"0 range, 255 AoE (homing), 14 CT, 64 MP. Hit: Different Zodiac; (MA + 47)%. Effect: Add Stop, Don't Move, Don't Act (All).\",\"Gather Power\":\"0 range, 0 AoE. Effect: +2 PA.\",\"Giant Skill\":\"Blue Skillset. Hydra family and Behemoth family abilities.\",\"Giga Flare\":\"4 range, 2 AoE. Effect: Damage (MA * 7).\",\"Gil Taking\":\"2 range, 0 AoE. Hit: (Speed + 63)%. Effect: Add Defending, Berserk (Random).\",\"Goblin Punch\":\"1 range, 0 AoE. Hit: (MA + 46)%. Effect: Damage ((MaxHP - CurrentHP) * 5 / 4).\",\"Golem\":\"0 range, 0 AoE (global), 4 CT, 38 MP. Hit: ((MA + 225) * (Faith / 100))%. Effect: Set target team's Golem to MaxHP; Until depleted, any damage from a basic Attack or Throw ability is dealt to the Golem instead.\",\"Goo\":\"2 range, 0 AoE. Hit: (MA + 65)%. Effect: Add Stop, Don't Move, Don't Act (All).\",\"Grand Cross\":\"4 range, 2 AoE (homing), 6 CT, 31 MP. Effect: Add Petrify, Darkness, Confusion, Silence, Berserk, Frog, Poison, Slow, Sleep (Separate).\",\"Grease Touch\":\"1 range, 0 AoE. Hit: (MA + 52)%. Effect: Add Oil, Slow (All).\",\"Griffin Skill\":\"Blue Skillset. Aevis family and Cat family abilities.\",\"Guard\":\"0 range, 0 AoE. Effect: Add Defending.\",\"Gusty Wind\":\"5 range, 1 AoE. Terrain: Roof, Chimney, Sky. Element: Wind. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Slow.\",\"HP Restore\":\"Reaction. After the unit was damaged to Critical by an attack, its HP is set to its MaxHP.\",\"Hallowed Ground\":\"5 range, 1 AoE. Terrain: Gravel, Marble, Wall, Mud, Tomb. Element: Holy. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Petrify, Oil (Random).\",\"Halve MP\":\"Support. Halves the MP cost of abilities used by the unit.\",\"Hamedo\":\"Reaction. When the unit is targeted by an ability with variable range from a unit within weapon range, it negates that attack and retaliates with a basic Attack.\",\"Hammer\":\"move range, 0 AoE. Effect: Throw Flail (Morning Star); Damage (Speed * ThrownWP).\",\"Haste\":\"4 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 185)%. Effect: Add Haste.\",\"Haste 2\":\"4 range, 1 AoE, 5 CT, 20 MP. Hit: Faith(MA + 240)%. Effect: Add Haste.\",\"Havoc Skill\":\"Blue Skillset. Bomb family and Goblin family abilities.\",\"Head Rend\":\"weapon range, 0 AoE. Hit: (PA + WP + 40)%. Effect: Remove target's head equipment; If none is equipped, basic Attack instead.\",\"Heal\":\"1 range, 0 AoE. Effect: Cancel Darkness, Silence, Oil, Poison, Don't Act.\",\"Heaven's Cloud\":\"0 range, 2 AoE. Effect: Damage (MA * 11); Chance to add Slow.\",\"Height\":\"Algorithm for targeting units based on the height of the tile they are standing on.\",\"Hell Ivy\":\"5 range, 1 AoE. Terrain: Grassland, Thicket, Ivy, Plant. Element: Earth. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Stop.\",\"Hellcry Crush\":\"3 range, 1 AoE, 13 MP. Effect: Remove target's weapon; If successful, Damage (PA * (WP + 4)).\",\"Hex Skill\":\"Blue Skillset. Cat family and Eye family abilities.\",\"Hi-Ether\":\"1 range, 0 AoE. Effect: HealMP (50).\",\"Hi-Potion\":\"1 range, 0 AoE. Effect: Heal (120).\",\"Holy\":\"5 range, 0 AoE, 6 CT, 53 MP. Element: Holy. Effect: Damage Faith(MA * 46).\",\"Holy Breath\":\"2 range, 0 AoE (linear). Element: Holy. Effect: Damage (MA * 5).\",\"Holy Water\":\"1 range, 0 AoE. Effect: Cancel Undead, Blood Suck.\",\"Hurricane\":\"4 range, 2 AoE. Element: Wind. Hit: (MA + 56)%. Effect: Damage (35)%.\",\"Hydra Pit\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Water. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"Ice\":\"5 range, 1 AoE, 3 CT, 6 MP. Element: Ice. Effect: Damage Faith(MA * 16).\",\"Ice 2\":\"5 range, 1 AoE, 4 CT, 12 MP. Element: Ice. Effect: Damage Faith(MA * 20).\",\"Ice 3\":\"5 range, 1 AoE, 6 CT, 24 MP. Element: Ice. Effect: Damage Faith(MA * 28).\",\"Ice 4\":\"5 range, 2 AoE, 8 CT, 48 MP. Element: Ice. Effect: Damage Faith(MA * 35).\",\"Ice Breath\":\"2 range, 2 AoE (linear). Element: Ice. Effect: Damage (MA * 5).\",\"Icewolf Bite\":\"3 range, 1 AoE, 11 MP. Effect: Remove target's accessory; If successful, Damage (PA * (WP + 3)).\",\"Ifrit\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Fire. Effect: Damage Faith(MA * 23).\",\"Ignore Height\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"Ignore Terrain\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"Immobilize\":\"5 range, 1 AoE, 4 CT, 10 MP. Hit: Faith(MA + 190)%. Effect: Add Don't Move.\",\"Imp Skill\":\"Blue Skillset. Goblin family and Eye family abilities.\",\"Insult\":\"4 range, 0 AoE. Hit: Human; (MA + 39)%. Effect: Add Berserk.\",\"Invitation\":\"4 range, 0 AoE. Hit: Human; (MA + 37)%. Effect: Add Confusion, Charm (Random).\",\"Item\":\"Skillset (inventory). Chemist job abilities.\",\"Jump\":\"Skillset (aerial). Lancer job abilities.\",\"Jump+1\":\"Movement. Increases the unit's Jump by 1.\",\"Jump+2\":\"Movement. Increases the unit's Jump by 2.\",\"Jump+3\":\"Movement. Increases the unit's Jump by 3.\",\"Justice Sword\":\"2 range, 0 AoE, 2 CT, 21 MP. Effect: Damage (PA * (WP + 2)); Chance to add Death Sentence.\",\"Kikuichimonji\":\"6 range, 6 AoE (linear). Effect: Damage (MA * 12).\",\"Kiyomori\":\"0 range, 2 AoE. Effect: Add Protect, Shell (Random).\",\"Knife\":\"move range, 0 AoE. Effect: Throw Knife (Air Knife); Damage (Speed * ThrownWP).\",\"Knife Hand\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Undead.\",\"Koutetsu\":\"0 range, 2 AoE. Effect: Damage (MA * 10); Chance to add Oil, Darkness (Random).\",\"Labyrinth Skill\":\"Blue Skillset. Dragon family and Minotaur family abilities.\",\"Landlocked\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"Last Dance\":\"0 range, 255 AoE (homing), 8 CT (recurring). Hit: (33)%. Effect: Set CT to 0 (0 CT).\",\"Last Song\":\"0 range, 255 AoE (homing), 8 CT (recurring). Hit: (33)%. Effect: Set CT to 100 (Quick).\",\"Lava Ball\":\"5 range, 1 AoE. Terrain: Lava, Machine. Element: Fire. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Death.\",\"Lava Walking\":\"Movement. Allows the unit to move and stand on lava.\",\"Leaf Dance\":\"0 range, 1 AoE. Effect: Damage (MA * 5).\",\"Leg Aim\":\"weapon range, 0 AoE. Hit: (Speed + 46)%. Effect: Add Don't Move.\",\"Level Blast\":\"3 range, 0 AoE. Effect: +1 Brave, +1 PA, +1 MA, +1 Speed.\",\"Level Jump2\":\"2 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Level Jump3\":\"3 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Level Jump4\":\"4 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Level Jump5\":\"5 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Level Jump6\":\"6 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Level Jump7\":\"7 range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Leviathan\":\"4 range, 3 AoE (homing), 9 CT, 50 MP. Element: Water. Effect: Damage Faith(MA * 36).\",\"Levitate\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"Lich\":\"4 range, 2 AoE (homing), 9 CT, 44 MP. Element: Dark. Hit: Faith(MA + 160)%. Effect: Damage (60)%.\",\"Lick\":\"1 range, 0 AoE. Effect: Add Reflect.\",\"Life Drain\":\"5 range, 0 AoE, 2 CT, 16 MP. Hit: Faith(MA + 188)%. Effect: AbsorbHP (25)%.\",\"Life Song\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: Heal (MA + 20).\",\"Lifebreak\":\"4 range, 0 AoE, 3 CT. Effect: Damage (MaxHP - CurrentHP).\",\"Lifefont\":\"Movement. After moving, the unit heals its HP by 10%.\",\"Limit\":\"Blue Skillset. Cloud's job abilities.\",\"Local Quake\":\"5 range, 1 AoE. Terrain: Stone, Basalt. Element: Earth. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Confusion.\",\"Long Status\":\"Support. Increases the duration of status effects (both positive and negative) applied to the unit by 50%.\",\"Look of Devil\":\"3 range, 0 AoE. Hit: (MA + 42)%. Effect: Add Petrify, Darkness, Silence, Don't Move, Don't Act (Random).\",\"Look of Fright\":\"3 range, 0 AoE. Hit: (MA + 57)%. Effect: -25 Brave.\",\"Lucavi Skill\":\"Blue Skillset. Lucavi family abilities.\",\"MA Save\":\"Reaction. After the unit was damaged by an attack, it gains +1 MA.\",\"MP Restore\":\"Reaction. After the unit was damaged to Critical by an attack, its MP is set to its MaxMP.\",\"Magic Attack Up\":\"Support. Increases the damage (or hitrate) of the unit's magical attacks by a third.\",\"Magic Barrier\":\"3 range, 0 AoE, 9 CT, 35 MP. Hit: Faith(MA + 202)%. Effect: Add Reraise, Regen, Protect, Shell, Haste (All).\",\"Magic Defense Up\":\"Support. Decreases the damage (or hitrate) that the unit takes from magical attacks by a third.\",\"Magic Ruin\":\"weapon range, 0 AoE. Hit: (PA + 50)%. Effect: DamageMP (50)%.\",\"Magic Song\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: +1 MA.\",\"Magic Spirit\":\"0 range, 2 AoE. Effect: HealMP (MA * 2).\",\"Maiden's Kiss\":\"1 range, 0 AoE. Effect: Cancel Frog.\",\"Maintenance\":\"Support. Prevents the unit's equipment from being removed.\",\"Mana Shield\":\"Reaction. When the unit is damaged while MP is greater than 0, damage is dealt to the unit's MP instead.\",\"Manaburn\":\"5 range, 0 AoE. Effect: Damage (TargetCurrentMP).\",\"Manafont\":\"Movement. After moving, the unit heals its MP by 10%.\",\"Marsh Skill\":\"Blue Skillset. Tree family and Squid family abilities.\",\"Martial Arts\":\"Support. Increases the damage (or hitrate) of the unit's unarmed attacks, Punch Art abilities, and certain other physical abilities by 50%.\",\"Masamune\":\"0 range, 2 AoE. Effect: Add Regen, Haste (Random).\",\"Math Skill\":\"Skillset (arithmetic). Calculator job abilities.\",\"Meatbone Slash\":\"Reaction. After the unit was damaged to Critical by an attack from a unit within weapon range, it retaliates with an attack that deals damage equal to its MaxHP.\",\"Medusa Skill\":\"Blue Skillset. Eye family and Hydra family abilities.\",\"Melt\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Fire. Effect: Damage Faith(MA * 38).\",\"Meteor\":\"5 range, 3 AoE, 12 CT, 70 MP. Effect: Damage Faith(MA * 60).\",\"Meteorain\":\"3 range, 2 AoE, 9 CT. Effect: Damage (MA * 26).\",\"Midgar Swarm\":\"4 range, 2 AoE, 4 CT, 37 MP. Element: Water. Effect: Damage (MA * 18).\",\"Mighty Sword\":\"Blue Skillset. Meliadoul's job abilities.\",\"Mimic\":\"Skillset. Allows the unit to automatically copy the actions of allies without Mimic except abilities associated with a Wild Beast family, but prevents it from equipping weapons. Mimicked abilities are instant (requiring no CT) and their targeting copies the distance and direction of the original action.\",\"Mimic Daravon\":\"3 range, 1 AoE. Hit: Human; (MA + 43)%. Effect: Add Sleep.\",\"Mimic Titan\":\"0 range, 2 AoE. Element: Earth. Effect: Damage (MA * 3).\",\"Mind Blast\":\"3 range, 1 AoE. Hit: (MA + 49)%. Effect: Add Confusion, Berserk (Random).\",\"Mind Break\":\"weapon range, 0 AoE. Hit: (PA + 52)%. Effect: -3 MA.\",\"Missile Skill\":\"Blue Skillset. Aevis family and Bomb family abilities.\",\"Moldball Virus\":\"3 range, 0 AoE (linear). Hit: (MA + 18)%. Effect: Transform target into a Malboro.\",\"Monster Talk\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"Moogle\":\"4 range, 2 AoE (homing), 3 CT, 20 MP. Hit: Faith(MA + 150)%. Effect: Cancel Darkness, Confusion, Silence, Blood Suck, Oil, Berserk, Frog, Poison, Don't Move, Don't Act; If successful, Heal (10)%.\",\"Move+1\":\"Movement. Increases the unit's Move by 1.\",\"Move+2\":\"Movement. Increases the unit's Move by 2.\",\"Move+3\":\"Movement. Increases the unit's Move by 3.\",\"Muramasa\":\"0 range, 2 AoE. Effect: Damage (MA * 14); Chance to add Confusion, Death Sentence (Random).\",\"Murasame\":\"0 range, 2 AoE. Effect: Heal (MA * 9).\",\"Mute\":\"5 range, 1 AoE, 3 CT, 9 MP. Hit: Faith(MA + 210)%. Effect: DamageMP (35)%.\",\"Mutilate\":\"1 range, 0 AoE. Hit: (MA + 35)%. Effect: AbsorbHP (66)%.\",\"Nameless Dance\":\"0 range, 255 AoE (homing), 10 CT (recurring), 5 MP. Hit: (50)%. Effect: Add Darkness, Confusion, Silence, Frog, Poison, Slow, Stop, Sleep (Random).\",\"Nameless Song\":\"0 range, 255 AoE (homing), 9 CT (recurring), 5 MP. Hit: (50)%. Effect: Add Reraise, Regen, Protect, Shell, Haste (Random).\",\"Nanoflare\":\"4 range, 2 AoE, 7 CT. Effect: Damage (MA * ((MA + 8) / 2)).\",\"Negotiate\":\"4 range, 0 AoE. Hit: Human; (MA + 41)%. Effect: Add Slow, Stop (Random).\",\"Nether Demon\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Earth. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"Night Magic\":\"Monster Skillset. Ultima Demon abilities.\",\"Night Sword\":\"2 range, 0 AoE, 3 CT, 23 MP. Effect: AbsorbHP (PA * WP).\",\"Nightmare Skill\":\"Blue Skillset. Behemoth family and Skeleton family abilities.\",\"Ninja Sword\":\"move range, 0 AoE. Effect: Throw Ninja Blade (Spell Edge); Damage (Speed * ThrownWP).\",\"No MP\":\"Support. Eliminates the MP cost of abilities used by the unit.\",\"Non-Charge\":\"Support. Eliminates the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"Noxious Gas\":\"3 range, 1 AoE. Hit: Faith(MA + 231)%. Effect: Add Defending, Darkness, Oil, Poison, Slow, Don't Move, Death Sentence (Separate).\",\"Obsidian Blade\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Wind. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 121) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)).\",\"Odd Soundwave\":\"0 range, 2 AoE. Effect: Cancel Charging, Performing, Float, Reraise, Transparent, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Odin\":\"4 range, 3 AoE (homing), 10 CT, 56 MP. Element: Holy. Effect: Damage Faith(MA * 39).\",\"Oink\":\"2 range, 0 AoE. Hit: (PA + 72)%. Effect: Cancel Death; If successful, Heal (75)%.\",\"Old\":\"6 range, 0 AoE, 4 CT, 5 MP. Hit: Faith(MA + 222)%. Effect: -2 PA, -2 MA, -1 Speed.\",\"Omnislash\":\"3 range, 1 AoE, 11 CT. Effect: Damage (MA * 40).\",\"PA Save\":\"Reaction. After the unit was damaged by an attack, it gains +1 PA.\",\"Paralyze\":\"5 range, 1 AoE, 5 CT, 14 MP. Hit: Faith(MA + 185)%. Effect: Add Don't Act.\",\"Parasite\":\"4 range, 0 AoE. Effect: Add Petrify, Darkness, Confusion, Silence, Oil, Frog, Poison, Sleep, Innocent (Separate).\",\"Parry\":\"Reaction. Enables the evasion of the unit's equipped weapons.\",\"Peck\":\"3 range, 0 AoE. Hit: (MA + 53)%. Effect: -2 PA.\",\"Persuade\":\"4 range, 0 AoE. Hit: Human; (MA + 59)%. Effect: Set CT to 0 (0 CT).\",\"Petrify\":\"5 range, 0 AoE, 8 CT, 17 MP. Hit: Faith(MA + 130)%. Effect: Add Petrify.\",\"Phantom Skill\":\"Blue Skillset. Ghost family and Dragon family abilities.\",\"Phoenix Down\":\"1 range, 0 AoE. Cancel Death; If successful, Heal Random(1,20); If Undead, Damage (100)% instead.\",\"Pilgrimage\":\"Movement. After moving, the unit gains +1 Brave and +1 Faith.\",\"Pitfall\":\"5 range, 1 AoE. Terrain: Dirt, Wasteland, Road, Pit. Element: Dark. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Don't Move.\",\"Poison\":\"5 range, 1 AoE, 3 CT, 4 MP. Hit: Faith(MA + 195)%. Effect: Add Poison.\",\"Poison Nail\":\"2 range, 0 AoE. Hit: (MA + 58)%. Effect: Add Poison; If successful, Damage (15)%.\",\"Polka Polka\":\"0 range, 255 AoE (homing), 7 CT (recurring). Hit: (50)%. Effect: -1 PA.\",\"Potion\":\"1 range, 0 AoE. Effect: Heal (100).\",\"Power Break\":\"weapon range, 0 AoE. Hit: (PA + 52)%. Effect: -3 PA.\",\"Praise\":\"4 range, 0 AoE. Hit: Human; (MA + 81)%. Effect: +5 Brave.\",\"Pray Faith\":\"5 range, 0 AoE, 4 CT, 7 MP. Hit: Faith(MA + 155)%. Effect: Add Faith.\",\"Preach\":\"4 range, 0 AoE. Hit: Human; (MA + 81)%. Effect: +5 Faith.\",\"Prime Number\":\"Expression for targeting units whose algorithmic attribute is a prime number (a number divisible by only 1 and itself).\",\"Protect\":\"4 range, 1 AoE, 2 CT, 6 MP. Hit: Faith(MA + 200)%. Effect: Add Protect.\",\"Protect 2\":\"4 range, 1 AoE, 5 CT, 18 MP. Hit: Faith(MA + 245)%. Effect: Add Protect.\",\"Protect Spirit\":\"0 range, 2 AoE. Hit: (MA + 60)%. Effect: Add Defending, Protect (All).\",\"Pummel\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,9) * 3 / 2).\",\"Punch Art\":\"Skillset. Monk job abilities.\",\"Purification\":\"0 range, 1 AoE. Hit: (PA + 77)%. Effect: Cancel Petrify, Darkness, Confusion, Silence, Blood Suck, Berserk, Frog, Poison, Sleep, Don't Move, Don't Act.\",\"Quake\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Earth. Effect: Damage Faith(MA * 38).\",\"Quick\":\"6 range, 0 AoE, 3 CT, 24 MP. Hit: Faith(MA + 160)%. Effect: Set CT to 100 (Quick).\",\"Quicksand\":\"5 range, 1 AoE. Terrain: Marsh, Swamp, Sludge. Element: Water. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Death Sentence.\",\"Raise\":\"5 range, 0 AoE, 4 CT, 10 MP. Hit: Faith(MA + 190)%. Effect: Cancel Death; If successful, Heal (50)%.\",\"Raise 2\":\"5 range, 0 AoE, 9 CT, 20 MP. Hit: Faith(MA + 165)%. Effect: Cancel Death; If successful, Heal (100)%.\",\"Ramuh\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Lightning. Effect: Damage Faith(MA * 23).\",\"Ranch Skill\":\"Blue Skillset. Minotaur family and Chocobo family abilities.\",\"Reflect\":\"5 range, 0 AoE, 2 CT, 12 MP. Hit: Faith(MA + 180)%. Effect: Add Reflect.\",\"Refute\":\"4 range, 0 AoE. Hit: Human; (MA + 75)%. Effect: Cancel Undead, Confusion, Blood Suck, Reraise, Berserk, Faith, Innocent, Charm, Death Sentence.\",\"Regen\":\"4 range, 1 AoE, 3 CT, 8 MP. Hit: Faith(MA + 175)%. Effect: Add Regen.\",\"Regenerator\":\"Reaction. After the unit was damaged by an attack, add Regen.\",\"Rehabilitate\":\"4 range, 0 AoE. Effect: HealMP (MA * 3).\",\"Remedy\":\"1 range, 0 AoE. Effect: Cancel Confusion, Oil, Sleep.\",\"Repair\":\"0 range, 0 AoE. Hit: (PA + 80)%. Effect: Add Oil; If successful, Heal (30)%.\",\"Reraise\":\"4 range, 0 AoE, 7 CT, 14 MP. Hit: Faith(MA + 155)%. Effect: Add Reraise.\",\"Retreat\":\"Movement. While in Critical, increases the unit's Move by 4.\",\"Revive\":\"1 range, 0 AoE. Hit: (PA + 69)%. Effect: Cancel Death; If successful, Heal (25)%.\",\"Robosnake Skill\":\"Blue Skillset. Steel Giant and Serpentarius abilities.\",\"Roc Skill\":\"Blue Skillset. Behemoth family and Chocobo family abilities.\",\"Salamander\":\"4 range, 2 AoE (homing), 8 CT, 46 MP. Element: Fire. Effect: Damage Faith(MA * 32); Chance to add Oil.\",\"Sand Storm\":\"5 range, 1 AoE. Terrain: Sand, Stalactite, Salt. Element: Wind. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Darkness.\",\"Scratch\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"Scratch Up\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"Scream\":\"0 range, 0 AoE, 2 CT. Effect: +3 Brave, +1 PA, +1 MA, +1 Speed.\",\"Seal Evil\":\"weapon range, 0 AoE. Hit: Undead; (Speed + 58)%. Effect: Add Petrify.\",\"Secret Fist\":\"1 range, 0 AoE. Hit: (MA + 50)%. Effect: Add Death Sentence.\",\"Secret Hunt\":\"Support. After killing or resurrecting a unit, the unit gains +1 PA and +1 MA.\",\"Self Destruct\":\"0 range, 2 AoE. Effect: Damage (MaxHP - CurrentHP); DamageCaster (CurrentHP); Add Oil.\",\"Shake Off\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Defending.\",\"Shell\":\"4 range, 1 AoE, 2 CT, 6 MP. Hit: Faith(MA + 200)%. Effect: Add Shell.\",\"Shell 2\":\"4 range, 1 AoE, 5 CT, 18 MP. Hit: Faith(MA + 245)%. Effect: Add Shell.\",\"Shellbust Stab\":\"3 range, 1 AoE, 15 MP. Effect: Remove target's body equipment; If successful, Damage (PA * (WP + 5)).\",\"Shield Rend\":\"weapon range, 0 AoE. Hit: (PA + WP + 56)%. Effect: Remove target's shield; If none is equipped, basic Attack instead.\",\"Shine Lover\":\"3 range, 0 AoE. Hit: (PA + 66)%. Effect: DamageMP (66)%.\",\"Shiva\":\"4 range, 2 AoE (homing), 4 CT, 26 MP. Element: Ice. Effect: Damage Faith(MA * 23).\",\"Short Charge\":\"Support. Halves the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"Short Status\":\"Support. Halves the duration of status effects (both positive and negative) applied to the unit.\",\"Shuriken\":\"move range, 0 AoE. Effect: Throw Shuriken (Shuriken, Magic Shuriken, Yagyu Shuriken); Damage (Speed * ThrownWP).\",\"Sicken\":\"Support. Allows physical attacks used by the unit to add Poison (except a basic Attack with a Gun).\",\"Silence\":\"5 range, 1 AoE, 3 CT, 15 MP. Hit: Faith(MA + 180)%. Effect: Add Silence.\",\"Sing\":\"Skillset. Bard job abilities.\",\"Siphon\":\"1 range, 0 AoE. Hit: (MA + 70)%. Effect: AbsorbMP (25)%.\",\"Sky Demon\":\"4 range, 1 AoE (multihit), 3 CT, 10 MP. Element: Earth. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 17) / 2)).\",\"Slam\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"Sleep\":\"5 range, 1 AoE, 6 CT, 22 MP. Hit: Faith(MA + 175)%. Effect: Add Sleep.\",\"Sleep Touch\":\"1 range, 0 AoE. Hit: (MA + 44)%. Effect: Add Sleep.\",\"Slow\":\"4 range, 1 AoE, 2 CT, 8 MP. Hit: Faith(MA + 185)%. Effect: Add Slow.\",\"Slow 2\":\"4 range, 1 AoE, 5 CT, 20 MP. Hit: Faith(MA + 240)%. Effect: Add Slow.\",\"Slow Dance\":\"0 range, 255 AoE (homing), 6 CT (recurring). Hit: (50)%. Effect: -1 Speed.\",\"Small Bomb\":\"4 range, 0 AoE. Element: Dark. Effect: Damage Faith(MA * 9); Chance to add Oil.\",\"Snake Carrier\":\"1 range, 0 AoE, 1 MP. Effect: AbsorbHP (29)%; Add Undead, Darkness, Confusion, Blood Suck, Oil, Frog, Poison, Charm, Sleep, Death Sentence (Random).\",\"Snort\":\"2 range, 0 AoE. Hit: (MA + 40)%. Effect: Add Charm.\",\"Soft\":\"1 range, 0 AoE. Effect: Cancel Petrify.\",\"Solution\":\"4 range, 0 AoE. Hit: Human; (MA + 89)%. Effect: -20 Faith.\",\"Sonic Step\":\"Movement. After moving, the unit gains +5 CT.\",\"Space Storage\":\"4 range, 1 AoE (multihit), 4 CT, 13 MP. Element: Holy. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 15) / 2)); Chance to add Darkness, Confusion, Silence, Frog, Poison, Slow, Sleep (Random).\",\"Spark\":\"0 range, 2 AoE. Element: Fire. Effect: Damage (MA * 3).\",\"Spear\":\"move range, 0 AoE. Effect: Throw Spear (Holy Lance); Damage (Speed * ThrownWP).\",\"Speed Break\":\"weapon range, 0 AoE. Hit: (PA + 54)%. Effect: -2 Speed.\",\"Speed Save\":\"Reaction. After the unit was damaged by an attack, it gains +1 Speed.\",\"Spell Absorb\":\"5 range, 0 AoE, 2 CT, 2 MP. Hit: Faith(MA + 192)%. Effect: AbsorbMP (33)%.\",\"Spin Fist\":\"0 range, 1 AoE. Effect: Damage (PA * ((PA + 1) / 2)).\",\"Spirit Skill\":\"Blue Skillset. Ghost family and Bomb family abilities.\",\"Spirit of Life\":\"0 range, 2 AoE. Effect: Heal (MA * 4).\",\"Stab Up\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)).\",\"Stabilize Time\":\"4 range, 1 AoE, 1 CT, 14 MP. Hit: Faith(MA + 195)%. Effect: Cancel Slow, Stop, Don't Move, Death Sentence.\",\"Staff\":\"move range, 0 AoE. Effect: Throw Staff (Gold Staff); Damage (Speed * ThrownWP).\",\"Stasis Sword\":\"1 range, 1 AoE, 3 CT, 19 MP. Effect: Damage (PA * (WP + 1)); Chance to add Stop.\",\"Static Shock\":\"5 range, 1 AoE. Terrain: Book, Tree, Brick, Bridge, Furniture, Iron, Moss, Coffin, Barrier. Element: Lightning. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Don't Act.\",\"Steal\":\"Skillset. Thief job abilities.\",\"Steal Accessory\":\"2 range, 0 AoE. Hit: (Speed + 70)%. Effect: Remove target's accessory.\",\"Steal Armor\":\"2 range, 0 AoE. Hit: (Speed + 55)%. Effect: Remove target's body equipment.\",\"Steal Heart\":\"3 range, 0 AoE. Hit: Different Sex; (MA + 45)%. Effect: Add Charm.\",\"Steal Helmet\":\"2 range, 0 AoE. Hit: (Speed + 60)%. Effect: Remove target's head equipment.\",\"Steal Shield\":\"2 range, 0 AoE. Hit: (Speed + 50)%. Effect: Remove target's shield.\",\"Steal Status\":\"2 range, 0 AoE. Hit: Faith(MA + 173)%. Effect: Cancel statuses on target and add them to caster.\",\"Steal Weapon\":\"2 range, 0 AoE. Hit: (Speed + 65)%. Effect: Remove target's weapon.\",\"Stepping Stone\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"Stick\":\"move range, 0 AoE. Effect: Throw Pole (Ivory Cane); Damage (Speed * ThrownWP).\",\"Stop\":\"4 range, 1 AoE, 7 CT, 16 MP. Hit: Faith(MA + 140)%. Effect: Add Stop.\",\"Storm Around\":\"0 range, 1 AoE. Element: Lightning. Effect: Damage (PA * (PA / 2)).\",\"Straight Dash\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Silence, Berserk (Random).\",\"Suck Blood\":\"1 range, 0 AoE. Effect: AbsorbHP (25)%; Add Blood Suck.\",\"Summon Magic\":\"Skillset. Summoner job abilities.\",\"Sunken State\":\"Reaction. After the unit was targeted by a counterable attack, add Transparent.\",\"Surging Sword\":\"1 range, 1 AoE, 4 CT, 25 MP. Effect: Damage (PA * (WP + 2)); Chance to add Silence.\",\"Swim\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"Sword\":\"move range, 0 AoE. Effect: Throw Sword (Rune Blade); Damage (Speed * ThrownWP).\",\"Sylph\":\"4 range, 2 AoE (homing), 7 CT, 42 MP. Element: Wind. Effect: Damage Faith(MA * 30); Chance to add Silence.\",\"Tackle\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Don't Move, Don't Act (Random).\",\"Tail Swing\":\"1 range, 0 AoE. Effect: Damage (PA * Random(1,15)); Chance to knockback.\",\"Talk Skill\":\"Skillset (oral). Mediator job abilities.\",\"Teleport\":\"Movement. Allows the unit to teleport directly to a tile within its move range.\",\"Teleport 2\":\"Movement. Allows the unit to teleport directly to any tile.\",\"Tendrils\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Slow.\",\"Tentacle\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Stop.\",\"Tentacle Skill\":\"Blue Skillset. Squid family and Malboro family abilities.\",\"Threaten\":\"4 range, 0 AoE. Hit: Human; (MA + 89)%. Effect: -20 Brave.\",\"Throw\":\"Skillset (inventory). Ninja job abilities.\",\"Throw Item\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"Throw Spirit\":\"4 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to add Death Sentence.\",\"Throw Stone\":\"4 range, 0 AoE. Effect: Damage (PA * Random(1,2)); Chance to knockback.\",\"Thunder Breath\":\"2 range, 2 AoE (linear). Element: Lightning. Effect: Damage (MA * 5).\",\"Thunder Soul\":\"3 range, 0 AoE. Element: Lightning. Effect: Damage (MA * 3).\",\"Tickle\":\"1 range, 0 AoE. Hit: (MA + 67)%. Effect: Cancel Charging, Defending, Performing, Confusion, Charm, Sleep.\",\"Time Magic\":\"Skillset. Time Mage job abilities.\",\"Titan\":\"4 range, 2 AoE (homing), 5 CT, 34 MP. Element: Earth. Effect: Damage Faith(MA * 27).\",\"Toot\":\"2 range, 0 AoE. Hit: (MA + 48)%. Effect: Add Confusion, Sleep (Random).\",\"Tornado\":\"4 range, 3 AoE, 5 CT, 16 MP. Element: Wind. Effect: Damage Faith(MA * 38).\",\"Toxic Toad\":\"5 range, 2 AoE, 6 CT. Hit: Faith(MA + 109)%. Effect: Add Frog, Poison (All).\",\"Triple Attack\":\"1 range, 1 AoE (trilinear). Effect: Damage (PA * (PA * Brave / 100)).\",\"Triple Breath\":\"2 range, 2 AoE (trilinear). Hit: (MA + 84)%. Effect: Damage (45)%.\",\"Triple Flame\":\"4 range, 1 AoE (multihit). Element: Fire. Hit: 3 times. Effect: Damage (MA * ((MA + 20) / 2)).\",\"Triple Thunder\":\"4 range, 1 AoE (multihit). Element: Lightning. Hit: 3 times. Effect: Damage (MA * ((MA + 12) / 2)).\",\"Troll Skill\":\"Blue Skillset. Pig family and Goblin family abilities.\",\"Turn Punch\":\"0 range, 1 AoE. Effect: Damage (PA * ((PA + 3) / 2)).\",\"Ulmaguest\":\"4 range, 2 AoE. Effect: Damage (MaxHP - CurrentHP).\",\"Ultima\":\"5 range, 1 AoE, 5 CT, 9 MP. Element: Holy. Effect: Damage Faith(MA * 25).\",\"Undeath Skill\":\"Blue Skillset. Skeleton family and Ghost family abilities.\",\"Unyielding Cut\":\"2 range, 0 AoE, 19 MP, 4 CT. Effect: If target is equipped with any item except for a Shield, Damage (PA * (WP + 1)). If none is equipped, Damage (PA * (WP + TargetMA / 2)).\",\"Vengeance\":\"5 range, 0 AoE. Effect: Damage (MaxHP - CurrentHP).\",\"Vertical Jump2\":\"2 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vertical Jump3\":\"3 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vertical Jump4\":\"4 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vertical Jump5\":\"5 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vertical Jump6\":\"6 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vertical Jump7\":\"7 vertical range, 0 AoE, (50 / Speed) CT (jumping). Effect: If armed, Damage (PA * WP); If Spear is equipped, increase damage by 50%; If unarmed, Damage (PA * (PA * Brave / 100)).\",\"Vine Skill\":\"Blue Skillset. Malboro family and Tree family abilities.\",\"Void Storage\":\"4 range, 1 AoE (multihit), 4 CT, 13 MP. Element: Dark. Hit: Random(1,10) times. Effect: Damage (MA * ((MA + 111) / 2) * ((100 - Faith) / 100) * ((100 - TargetFaith) / 100)); Chance to add Darkness, Confusion, Silence, Frog, Poison, Slow, Sleep (Random).\",\"Wall\":\"4 range, 0 AoE, 4 CT, 22 MP. Hit: Faith(MA + 145)%. Effect: Add Protect, Shell (All).\",\"Wand\":\"move range, 0 AoE. Effect: Throw Rod (Wizard Rod); Damage (Speed * ThrownWP).\",\"Water Ball\":\"5 range, 1 AoE. Terrain: Canal, River, Lake, Ocean, Waterfall, Pool. Element: Water. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Frog.\",\"Waterwalking\":\"Movement. Allows the unit to move and stand on the surface of water.\",\"Wave Fist\":\"3 range, 0 AoE. Element: Wind. Effect: Damage (PA * ((PA + 2) / 2)).\",\"Weapon Rend\":\"weapon range, 0 AoE. Hit: (PA + WP + 32)%. Effect: Remove target's weapon; If none is equipped, basic Attack instead.\",\"White Magic\":\"Skillset. Priest job abilities.\",\"Wild Beast\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"Wildfire Skill\":\"Blue Skillset. Bomb family and Tree family abilities.\",\"Will-O-Wisp\":\"5 range, 1 AoE. Terrain: Wood, Carpet, Box, Stairs, Deck, Obstacle. Element: Fire. Effect: Damage (MA * ((PA + 2) / 2)); Chance to add Sleep.\",\"Wind Soul\":\"3 range, 0 AoE. Element: Wind. Effect: Damage (MA * 4).\",\"Wing Attack\":\"1 range, 0 AoE. Effect: Damage (PA * (PA * Brave / 100)); Chance to cancel Float, Reraise, Regen, Protect, Shell, Haste, Faith, Reflect.\",\"Wish\":\"1 range, 0 AoE. Effect: Heal (MaxHP * 2 / 5); DamageCaster (MaxHP / 5).\",\"Witch Hunt\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: DamageMP (PA + (PA * Brave / 100)).\",\"Wiznaibus\":\"0 range, 255 AoE (homing), 5 CT (recurring). Effect: Damage (PA + (PA * Brave / 100)).\",\"Work\":\"Monster Skillset. Steel Giant abilities.\",\"X-Potion\":\"1 range, 0 AoE. Effect: Heal (150).\",\"Yell\":\"3 range, 0 AoE. Effect: +1 Speed.\",\"Yin Yang Magic\":\"Skillset. Oracle job abilities.\",\"Zodiac\":\"4 range, 3 AoE (homing), 13 CT, 99 MP. Effect: Damage Faith(MA * 90).\",\"Zombie\":\"5 range, 0 AoE, 4 CT, 19 MP. Hit: Faith(MA + 150)%. Effect: Add Undead.\",\"Zombie Touch\":\"1 range, 0 AoE. Hit: (MA + 47)%. Effect: Add Undead.\"},\"UserSkill\":{\"108Gems\":\"You wear 108 Gems, granting immunity to Blood Suck, Frog, and Poison. Also strengthens abilities of all elements used by you.\",\"Abandon\":\"Doubles your evasion.\",\"AbsorbUsedMP\":\"When hit by a spell, gain MP equal to what the caster spent.\",\"Ahriman\":\"Allows you to use the monster: Ahriman.\",\"AngelRing\":\"You wear Angel Ring, granting initial Reraise status and immunity to Undead and Darkness.\",\"Apanda\":\"Allows you to use the monster: Apanda.\",\"ArchaicDemon\":\"Allows you to use the monster: ArchaicDemon.\",\"ArrowGuard\":\"When targeted by a projectile fired from a ranged weapon, dodge it to negate the attack.\",\"AttackUp\":\"Increases the damage of your physical abilities by a third.\",\"AutoPotion\":\"When damaged, use a Potion. Forcing this skill reduces the odds of rolling higher Brave values.\",\"BasicSkill\":\"Squire abilities: Dash, Throw Stone, Accumulate, Heal, Tickle, Yell, Cheer Up, Fury, Wish, Scream, Ultima.\",\"BattleBoots\":\"You wear Battle Boots, increasing your Speed and Move by 1.\",\"BattleSkill\":\"Knight abilities: Head Rend, Armor Rend, Shield Rend, Weapon Rend, Magic Ruin, Speed Break, Power Break, Mind Break, Stasis Sword, Justice Sword, Dark Sword, Night Sword, Surging Sword, Explosion Sword.\",\"Beastmaster\":\"Allied monsters can use their locked ability while adjacent to you.\",\"Behemoth\":\"Allows you to use the monster: Behemoth.\",\"BlackChocobo\":\"Allows you to use the monster: BlackChocobo.\",\"BlackGoblin\":\"Allows you to use the monster: BlackGoblin.\",\"BlackMagic\":\"Wizard abilities: Fire, Fire 2, Fire 3, Fire 4, Bolt, Bolt 2, Bolt 3, Bolt 4, Ice, Ice 2, Ice 3, Ice 4, Empower, Frog, Death, Flare.\",\"BlueDragon\":\"Allows you to use the monster: BlueDragon.\",\"BlueMagic\":\"Use only with Calculator. Transform into a Blue Mage, replacing Math Skill with abilities from a monster class. Excluding this skill prevents your Calculator from randomly becoming a Blue Mage.\",\"Bomb\":\"Allows you to use the monster: Bomb.\",\"Bracer\":\"You wear Bracer, increasing your PA by 3.\",\"BraveBoost\":\"Increases your chance to roll high Brave. Excluding this skill lowers your Brave.\",\"BraveSave\":\"When physically attacked, gain 3 Brave.\",\"BullDemon\":\"Allows you to use the monster: BullDemon.\",\"Byblos\":\"Allows you to use the monster: Byblos.\",\"Catch\":\"When targeted by a thrown weapon, catch it to negate the attack.\",\"Caution\":\"When physically attacked, gain Defending to double your evasion until the next turn.\",\"Charge\":\"Archer abilities: Charge+1, Charge+2, Charge+3, Charge+4, Charge+5, Charge+7, Charge+10, Charge+20.\",\"Chocobo\":\"Allows you to use the monster: Chocobo.\",\"Cockatrice\":\"Allows you to use the monster: Cockatrice.\",\"Coeurl\":\"Allows you to use the monster: Coeurl.\",\"Concentrate\":\"Your physical attacks bypass your target's evasion.\",\"Counter\":\"When attacked by a unit within your weapon's range, attack them back.\",\"CounterFlood\":\"When attacked, attack back with Elemental.\",\"CounterMagic\":\"When hit by an offensive spell, cast it back on the attacker (unless you lack the MP to do so).\",\"CounterTackle\":\"When attacked by an adjacent unit, push them back with Dash.\",\"CriticalQuick\":\"When hit to critical, you gain your next turn immediately.\",\"CursedRing\":\"You wear Cursed Ring, granting permanent Undead status and increasing your PA, MA, and Speed by 1.\",\"DamageSplit\":\"When damaged, transfer half of that damage to the attacker. Forcing this skill reduces the odds of rolling higher Brave values.\",\"Dance\":\"Dancer abilities: Witch Hunt, Wiznaibus, Slow Dance, Polka Polka, Disillusion, Nameless Dance, Last Dance, Void Storage, Obsidian Blade, Nether Demon, Dragon Pit. Only compatible with females.\",\"DarkBehemoth\":\"Allows you to use the monster: DarkBehemoth.\",\"Defend\":\"Allows use of the Guard action, which doubles your evasion until the next turn.\",\"DefenseRing\":\"You wear Defense Ring, granting immunity to Death and Sleep. Also allows you to resist Wind and strengthens Water abilities used by you.\",\"DefenseUp\":\"Decreases the damage from physical abilities by a third.\",\"DiamondArmlet\":\"You wear Diamond Armlet, granting immunity to Oil and Slow and increasing your PA and MA by 1.\",\"Distribute\":\"When healed beyond your maximum HP, give the excess healing to all allies.\",\"Doublehand\":\"Use both hands to hold your weapon, doubling the damage. Doesn't work with Guns (or if unarmed).\",\"DraculaMantle\":\"You wear Dracula Mantle, granting 15% physical evasion and 30% magical evasion.\",\"Dragon\":\"Allows you to use the monster: Dragon.\",\"DragonSpirit\":\"When physically attacked, gain Reraise.\",\"Draugr\":\"Allows you to use the monster: Draugr.\",\"DrawOut\":\"Samurai abilities: Asura, Koutetsu, Bizen Boat, Murasame, Heaven's Cloud, Kiyomori, Muramasa, Kikuichimonji, Masamune, Chirijiraden.\",\"Dryad\":\"Allows you to use the monster: Dryad.\",\"DualWield\":\"Equip a weapon in each hand, attacking with both. Doesn't work with Bows.\",\"EXPBoost\":\"Your unit earns double the EXP it normally would. Excluding this skill causes you to earn no EXP.\",\"Earplug\":\"When targeted by a Talk Skill, ignore it to negate the ability.\",\"Elemental\":\"Geomancer abilities: Pitfall, Water Ball, Hell Ivy, Hallowed Ground, Local Quake, Static Shock, Will-O-Wisp, Quicksand, Sand Storm, Blizzard, Gusty Wind, Lava Ball.\",\"ElfMantle\":\"You wear Elf Mantle, granting 30% physical evasion and 15% magical evasion.\",\"EquipArmor\":\"Allows you to equip Hats, Helmets, Clothing, Armor, and Robes. You will get at least one that your class couldn't equip normally.\",\"EquipAxe\":\"Allows you to equip Axes, Flails, and Staves.\",\"EquipBow\":\"Allows you to equip Bows and Crossbows. Very rarely, you may tie a pretty bow on a Bag instead.\",\"EquipGun\":\"Allows you to equip Guns, Books, and Harps.\",\"EquipKnife\":\"Allows you to equip Knives, Ninja Blades, and Rods.\",\"EquipPolearm\":\"Allows you to equip Spears, Poles, and Fabrics.\",\"EquipShield\":\"Allows you to equip Shields, and removes the restriction of being unable to use them with Knight Swords and Bows.\",\"EquipSword\":\"Allows you to equip Swords, Knight Swords, and Katanas.\",\"Explosive\":\"Allows you to use the monster: Explosive.\",\"FaithBoost\":\"Increases your chance to roll high Faith. Excluding this skill lowers your Faith.\",\"FaithSave\":\"When targeted by a spell, gain 3 Faith.\",\"FashionSense\":\"You have an increased chance to equip Bags, Hair Adornments, and Perfumes. Excluding this skill will prevent you from equipping these items (Bags can still be equipped by classes that get them normally, though).\",\"FeatherBoots\":\"You wear Feather Boots, granting Float (which itself grants Earth immunity). Also strengthens Wind abilities used by you.\",\"FeatherMantle\":\"You wear Feather Mantle, granting 25% physical and magical evasion.\",\"FloatingEye\":\"Allows you to use the monster: FloatingEye.\",\"Fly\":\"Fly instead of walking, ignoring height. Also grants immunity to fall damage.\",\"GearedUp\":\"Makes all equipment normal rarity to you, increasing your odds of rolling rare and uncommon gear. Excluding this skill greatly decreases the odds of rare and uncommon gear.\",\"GenjiGauntlet\":\"You wear Genji Gauntlet, increasing your PA and MA by 2.\",\"GerminasBoots\":\"You wear Germinas Boots, increasing Move and Jump by 1.\",\"Ghost\":\"Allows you to use the monster: Ghost.\",\"Ghoul\":\"Allows you to use the monster: Ghoul.\",\"GilgameHeart\":\"Your unit earns no EXP, but awards you with 500G (+/-100G for each EXP bonus/penalty you have) for each win instead. Excluding this skill increases your entry fee by 500G (for a total of 600G including the parameter cost), bribing the bot to give you +5 priority.\",\"Gobbledeguck\":\"Allows you to use the monster: Gobbledeguck.\",\"Goblin\":\"Allows you to use the monster: Goblin.\",\"GreatMalboro\":\"Allows you to use the monster: GreatMalboro.\",\"Grenade\":\"Allows you to use the monster: Grenade.\",\"HPRestore\":\"When hit to critical, restore all HP.\",\"HalveMP\":\"Halves MP from all abilities and spells.\",\"Hamedo\":\"When targeted by a normal attack from a unit within your weapon's range, negate it and attack them instead. Forcing this skill reduces the odds of rolling higher Brave values.\",\"HighlySkilled\":\"Increases your odds of rolling a greater number of abilities (especially rare abilities). Excluding this skill reduces your odds of rolling a greater number of abilities (especially rare abilities).\",\"HolyDragon\":\"Allows you to use the monster: HolyDragon.\",\"Hydra\":\"Allows you to use the monster: Hydra.\",\"IgnoreHeight\":\"Jump vertically any distance.\",\"IgnoreTerrain\":\"Move through water without a penalty and walk on lava with a penalty.\",\"IronArmlet\":\"You wear Iron Armlet, granting immunity to Don't Move and Don't Act and increasing your PA by 1. Also allows you to resist Earth.\",\"IronHawk\":\"Allows you to use the monster: IronHawk.\",\"Item\":\"Chemist abilities: Potion, Hi-Potion, X-Potion, Ether, Hi-Ether, Elixir, Antidote, Eye Drop, Echo Grass, Maiden's Kiss, Soft, Holy Water, Remedy, Phoenix Down.\",\"JadeArmlet\":\"You wear Jade Armlet, granting immunity to Petrify and Stop. Also allows you to resist Water and strengthens Earth abilities used by you.\",\"Jump\":\"Lancer abilities: Level Jump7, Level Jump6, Level Jump5, Level Jump4, Level Jump3, Level Jump2, Vertical Jump7, Vertical Jump6, Vertical Jump5, Vertical Jump4, Vertical Jump3, Vertical Jump2.\",\"Jump+1\":\"Increases your Jump by 1.\",\"Jump+2\":\"Increases your Jump by 2.\",\"Jump+3\":\"Increases your Jump by 3.\",\"Juravis\":\"Allows you to use the monster: Juravis.\",\"KingBehemoth\":\"Allows you to use the monster: KingBehemoth.\",\"LavaWalking\":\"Walk and stand on lava.\",\"LeatherMantle\":\"You wear Leather Mantle, granting 10% physical and magical evasion and increasing your Speed by 1.\",\"Levitate\":\"Float over the battlefield, allowing you to ignore hazards and nullify Earth.\",\"Lifefont\":\"Restore 10% of your HP after moving.\",\"LongStatus\":\"Increases the duration of status effects (both buffs and debuffs) applied to you by 50%.\",\"MASave\":\"When damaged, gain 1 MA.\",\"MPRestore\":\"When hit to critical, restore all MP.\",\"MagicAttackUp\":\"Increases the damage of your magic abilities by a third.\",\"MagicDefenseUp\":\"Decreases the damage from magic abilities by a third.\",\"MagicGauntlet\":\"You wear Magic Gauntlet, increasing your MA by 3.\",\"MagicRing\":\"You wear Magic Ring, granting immunity to Silence and Berserk. Also allows you to resist Ice and strengthens Ice abilities used by you.\",\"Maintenance\":\"Your equipment can't be broken or stolen.\",\"Malboro\":\"Allows you to use the monster: Malboro.\",\"ManaShield\":\"When you would be damaged, deal that damage to your MP instead of your HP (unless your MP is depleted).\",\"Manafont\":\"Restore 10% of your MP after moving.\",\"MartialArts\":\"Increases the damage of your unarmed attacks and Punch Art abilities by 50%. Forcing this skill guarantees you will not have a weapon equipped.\",\"MeatboneSlash\":\"When hit to critical by a unit in your weapon's range, damage them back equal to your Max HP.\",\"Mindflayer\":\"Allows you to use the monster: Mindflayer.\",\"Minotaur\":\"Allows you to use the monster: Minotaur.\",\"MonsterTalk\":\"Allows you to use Talk Skill abilities on monsters. Forcing this skill guarantees Talk Skill as a secondary, but reduces the odds of having each ability.\",\"Move+1\":\"Increases your Move by 1.\",\"Move+2\":\"Increases your Move by 2.\",\"Move+3\":\"Increases your Move by 3.\",\"N-KaiArmlet\":\"You wear N-Kai Armlet, granting immunity to Confusion and Charm. Also allows you to resist Dark and strengthens Holy abilities used by you.\",\"NeutralZodiac\":\"You will have the Serpentarius zodiac sign, which has neutral compatibility with all units. Excluding this skill prevents you from getting the Serpentarius zodiac sign.\",\"Ochu\":\"Allows you to use the monster: Ochu.\",\"PASave\":\"When damaged, gain 1 PA.\",\"Parry\":\"Grants you extra physical evasion equal to your weapon's evade stat.\",\"Pilgrimage\":\"Gain +1 Brave and +1 Faith after moving.\",\"PiscoDemon\":\"Allows you to use the monster: PiscoDemon.\",\"Plague\":\"Allows you to use the monster: Plague.\",\"Porky\":\"Allows you to use the monster: Porky.\",\"PowerWrist\":\"You wear Power Wrist, increasing your PA by 1. Also allows you to resist Fire and strengthens Fire abilities used by you.\",\"PreferredArms\":\"You have the preferred weapon type of your class equipped (or its preference within a rolled Equip Weapon support). Excluding this skill equalizes the weapon preferences of your class, increasing the odds of a non-preferred weapon type.\",\"PunchArt\":\"Monk abilities: Spin Fist, Pummel, Wave Fist, Earth Slash, Secret Fist, Purification, Chakra, Revive, Seal Evil.\",\"RandomMonster\":\"You will be a completely random monster class.\",\"Reaper\":\"Allows you to use the monster: Reaper.\",\"RedChocobo\":\"Allows you to use the monster: RedChocobo.\",\"RedDragon\":\"Allows you to use the monster: RedDragon.\",\"RedPanther\":\"Allows you to use the monster: RedPanther.\",\"RedShoes\":\"You wear Red Shoes, increasing your MA and Move by 1.\",\"ReflectRing\":\"You wear Reflect Ring, granting permanent Reflect status and initial Protect status.\",\"Regenerator\":\"When damaged, gain Regen.\",\"Retreat\":\"While in critical, increases your Move by 4.\",\"Revenant\":\"Allows you to use the monster: Revenant.\",\"RubberShoes\":\"You wear Rubber Shoes, granting initial Shell status. Also allows you to resist Lightning and strengthens Lightning abilities used by you.\",\"SecretHunt\":\"When you kill or resurrect another unit, gain +1 PA and +1 MA.\",\"Sekhret\":\"Allows you to use the monster: Sekhret.\",\"Serpentarius\":\"Allows you to use the monster: Serpentarius.\",\"ShortCharge\":\"Halves the charge time of spells.\",\"ShortStatus\":\"Halves the duration of status effects (both buffs and debuffs) applied to you.\",\"Sicken\":\"Your physical attacks always inflict Poison.\",\"Sing\":\"Bard abilities: Angel Song, Life Song, Cheer Song, Battle Song, Magic Song, Nameless Song, Last Song, Space Storage, Diamond Blade, Sky Demon, Hydra Pit. Only compatible with males.\",\"Skeleton\":\"Allows you to use the monster: Skeleton.\",\"SmallMantle\":\"You wear Small Mantle, granting 20% physical and magic evasion. Also allows you to resist Holy.\",\"SonicStep\":\"Gain +5 CT towards your next turn after moving.\",\"SpeedSave\":\"When damaged, gain +1 Speed.\",\"SpikeShoes\":\"You wear Spike Shoes, increasing your Speed and Jump by 1.\",\"SprintShoes\":\"You wear Sprint Shoes, increasing your Speed by 2.\",\"Squidraken\":\"Allows you to use the monster: Squidraken.\",\"Steal\":\"Thief abilities: Gil Taking, Steal Heart, Steal Helmet, Steal Armor, Steal Shield, Steal Weapon, Steal Accessory, Steal Status, Arm Aim, Leg Aim.\",\"SteelGiant\":\"Allows you to use the monster: SteelGiant.\",\"SummonMagic\":\"Summoner abilities: Moogle, Shiva, Ramuh, Ifrit, Titan, Golem, Carbunkle, Bahamut, Odin, Leviathan, Salamander, Sylph, Fairy, Lich, Cyclops, Zodiac.\",\"SunkenState\":\"When physically attacked, gain Transparent to bypass evasion with your next attack.\",\"Swim\":\"Avoid becoming submerged in water and move through it without a penalty.\",\"Swine\":\"Allows you to use the monster: Swine.\",\"Taiju\":\"Allows you to use the monster: Taiju.\",\"TalkSkill\":\"Mediator abilities: Invitation, Persuade, Praise, Threaten, Preach, Solution, Death Sentence, Insult, Negotiate, Mimic Daravon, Refute, Rehabilitate.\",\"Teleport\":\"Teleport directly instead of walking.\",\"Throw\":\"Ninja abilities: Shuriken, Bomb, Knife, Sword, Hammer, Staff, Ninja Sword, Axe, Spear, Stick, Wand, Dictionary.\",\"ThrowItem\":\"Increases the range of your Item abilities to 4. Forcing this skill guarantees Item as a secondary, but reduces the odds of having each ability.\",\"Tiamat\":\"Allows you to use the monster: Tiamat.\",\"TimeMagic\":\"Time Mage abilities: Haste, Haste 2, Slow, Slow 2, Stop, Immobilize, Float, Reflect, Quick, Demi, Demi 2, Mute, Old, Stabilize Time, Meteor, Galaxy Stop.\",\"Treant\":\"Allows you to use the monster: Treant.\",\"UltimaDemon\":\"Allows you to use the monster: UltimaDemon.\",\"Vampire\":\"Allows you to use the monster: Vampire.\",\"VanishMantle\":\"You wear Vanish Mantle, granting 35% physical evasion and initial Transparent status. Also strengthens Dark abilities used by you.\",\"Waterwalking\":\"Walk and stand on water.\",\"WhiteMagic\":\"Priest abilities: Cure, Cure 2, Cure 3, Cure 4, Raise, Raise 2, Reraise, Regen, Protect, Protect 2, Shell, Shell 2, Wall, Esuna, Holy, Magic Barrier.\",\"WildBoar\":\"Allows you to use the monster: WildBoar.\",\"WizardMantle\":\"You wear Wizard Mantle, granting 15% physical and magical evasion and increasing your MA by 1.\",\"Wyvern\":\"Allows you to use the monster: Wyvern.\",\"YinYangMagic\":\"Oracle abilities: Blind, Poison, Life Drain, Spell Absorb, Pray Faith, Doubt Faith, Zombie, Silence, Enrage, Foxbird, Confuse, Paralyze, Sleep, Petrify, Dispel Magic, Dark Holy.\"},\"Zodiac\":{\"Aquarius\":\"Best/Worst - Leo; Good - Gemini, Libra; Bad - Taurus, Scorpio.\",\"Aries\":\"Best/Worst - Libra; Good - Sagittarius, Leo; Bad - Cancer, Capricorn.\",\"Cancer\":\"Best/Worst - Capricorn; Good - Scorpio, Pisces; Bad - Libra, Aries.\",\"Capricorn\":\"Best/Worst - Cancer; Good - Taurus, Virgo; Bad - Libra, Aries.\",\"Gemini\":\"Best/Worst - Sagittarius; Good - Libra, Aquarius; Bad - Virgo, Pisces.\",\"Leo\":\"Best/Worst - Aquarius; Good - Sagittarius, Aries; Bad - Scorpio, Taurus.\",\"Libra\":\"Best/Worst - Aries; Good - Aquarius, Gemini; Bad - Capricorn, Cancer.\",\"Pisces\":\"Best/Worst - Virgo; Good - Cancer, Scorpio; Bad - Sagittarius, Gemini.\",\"Sagittarius\":\"Best/Worst - Gemini; Good - Aries, Leo; Bad - Pisces, Virgo.\",\"Scorpio\":\"Best/Worst - Taurus; Good - Pisces, Cancer; Bad - Aquarius, Leo.\",\"Serpentarius\":\"Neutral to all.\",\"Taurus\":\"Best/Worst - Scorpio; Good - Virgo, Capricorn; Bad - Leo, Aquarius.\",\"Virgo\":\"Best/Worst - Pisces; Good - Capricorn, Taurus; Bad - Sagittarius, Gemini.\"},\"Class\":{\"Ahriman\":\"281 HP, 50 MP, 5 Move, 6 Jump, 8 Speed, 16 PA, 39 MA, 23% C-EV. Innate: Counter, Wild Beast, Magic Defense Up, Fly, Landlocked. Effect: Half Earth, Water, Holy, Dark; Weak Lightning.\",\"Apanda\":\"415 HP, 91 MP, 4 Move, 6 Jump, 8 Speed, 14 PA, 14 MA, 11% C-EV. Innate: Counter, Short Charge, Pilgrimage, Landlocked. Effect: Half Wind, Earth, Water; Weak Fire, Dark; Immune Float.\",\"ArchaicDemon\":\"320 HP, 109 MP, 4 Move, 3 Jump, 8 Speed, 13 PA, 15 MA, 6% C-EV. Innate: Counter, Short Charge, Landlocked. Effect: Null Holy; Half Dark; Weak Lightning.\",\"Archer Female\":\"159 HP, 41 MP, 3 Move, 3 Jump, 9 Speed, 9 PA, 8 MA, 16% C-EV. Innate: Charge. Equipment: Crossbows, Bows, Guns, Shields, Hats, Helmets, Clothing.\",\"Archer Male\":\"170 HP, 38 MP, 3 Move, 3 Jump, 9 Speed, 11 PA, 6 MA, 16% C-EV. Innate: Charge. Equipment: Crossbows, Bows, Guns, Shields, Hats, Helmets, Clothing.\",\"Bard Male\":\"153 HP, 57 MP, 3 Move, 3 Jump, 9 Speed, 8 PA, 9 MA, 13% C-EV. Innate: Sing. Equipment: Harps, Bows, Hats, Clothing, Armor.\",\"Behemoth\":\"476 HP, 26 MP, 4 Move, 5 Jump, 9 Speed, 17 PA, 41 MA, 12% C-EV. Innate: Counter, Wild Beast, Secret Hunt, Stepping Stone, Landlocked. Effect: Half Wind, Earth; Weak Dark; Immune Float.\",\"BlackChocobo\":\"250 HP, 25 MP, 6 Move, 5 Jump, 8 Speed, 18 PA, 42 MA, 28% C-EV. Innate: Counter, Wild Beast, Swim, Fly. Effect: Half Earth, Dark; Weak Wind.\",\"BlackGoblin\":\"271 HP, 10 MP, 5 Move, 3 Jump, 8 Speed, 15 PA, 36 MA, 24% C-EV. Innate: Counter, Wild Beast, Beastmaster. Effect: Half Lightning, Dark; Weak Ice; Immune Darkness.\",\"BlueDragon\":\"480 HP, 24 MP, 5 Move, 3 Jump, 8 Speed, 18 PA, 40 MA, 8% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Ignore Terrain, Landlocked. Effect: Absorb Ice; Weak Lightning; Immune Float.\",\"Bomb\":\"246 HP, 3 MP, 4 Move, 4 Jump, 10 Speed, 12 PA, 38 MA, 19% C-EV. Innate: Counter, Wild Beast, Levitate. Effect: Absorb Fire; Half Ice, Earth; Weak Water; Immune Oil.\",\"BullDemon\":\"428 HP, 8 MP, 5 Move, 3 Jump, 8 Speed, 18 PA, 37 MA, 14% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Wind; Weak Water; Immune Float.\",\"Byblos\":\"382 HP, 63 MP, 3 Move, 6 Jump, 9 Speed, 12 PA, 20 MA, 33% C-EV. Innate: Counter, Ignore Height, Lifefont, Landlocked. Effect: Half Earth, Holy; Weak Fire.\",\"Calculator Female\":\"123 HP, 75 MP, 3 Move, 3 Jump, 7 Speed, 5 PA, 10 MA, 15% C-EV. Innate: Math Skill, Monster Talk. Equipment: Books, Rods, Poles, Hats, Clothing, Robes, if Blue Mage [Flails, Helmets, Armor, uncommonly Shields].\",\"Calculator Male\":\"132 HP, 70 MP, 3 Move, 3 Jump, 7 Speed, 7 PA, 8 MA, 15% C-EV. Innate: Math Skill, Monster Talk. Equipment: Books, Rods, Poles, Hats, Clothing, Robes, if Blue Mage [Flails, Helmets, Armor, uncommonly Shields].\",\"Chemist Female\":\"154 HP, 49 MP, 3 Move, 3 Jump, 8 Speed, 6 PA, 8 MA, 12% C-EV. Innate: Item, Throw Item. Equipment: Bags, Knives, Guns, Hats, Clothing, rarely Swords.\",\"Chemist Male\":\"165 HP, 46 MP, 3 Move, 3 Jump, 8 Speed, 7 PA, 7 MA, 12% C-EV. Innate: Item, Throw Item. Equipment: Bags, Knives, Guns, Hats, Clothing, rarely Swords.\",\"Chocobo\":\"285 HP, 33 MP, 6 Move, 5 Jump, 9 Speed, 16 PA, 38 MA, 21% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Swim. Effect: Half Lightning; Weak Wind.\",\"Cockatrice\":\"264 HP, 13 MP, 6 Move, 5 Jump, 10 Speed, 18 PA, 39 MA, 34% C-EV. Innate: Counter, Wild Beast, Fly, Landlocked. Effect: Absorb Wind; Weak Earth.\",\"Coeurl\":\"274 HP, 16 MP, 4 Move, 5 Jump, 11 Speed, 13 PA, 41 MA, 27% C-EV. Innate: Counter, Wild Beast, Ignore Height, Retreat, Landlocked. Effect: Half Ice; Weak Earth.\",\"Dancer Female\":\"157 HP, 53 MP, 3 Move, 3 Jump, 9 Speed, 8 PA, 9 MA, 13% C-EV. Innate: Dance. Equipment: Fabrics, Bags, Hats, Clothing, Robes, rarely Knives.\",\"DarkBehemoth\":\"491 HP, 36 MP, 4 Move, 3 Jump, 9 Speed, 23 PA, 40 MA, 18% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Landlocked. Effect: Half Wind, Dark; Weak Holy; Immune Float.\",\"Dragon\":\"455 HP, 27 MP, 5 Move, 3 Jump, 9 Speed, 17 PA, 38 MA, 10% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Sonic Step, Landlocked. Effect: Absorb Lightning; Weak Fire; Immune Float.\",\"Draugr\":\"393 HP, 47 MP, 3 Move, 4 Jump, 9 Speed, 17 PA, 45 MA, 15% C-EV. Innate: Counter, Wild Beast. Effect: Absorb Dark; Null Ice; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence.\",\"Dryad\":\"465 HP, 35 MP, 3 Move, 3 Jump, 7 Speed, 11 PA, 41 MA, 4% C-EV. Innate: Counter, Wild Beast, Defense Up, Landlocked. Effect: Absorb Earth; Half Water; Weak Fire; Immune Float.\",\"Explosive\":\"325 HP, 9 MP, 4 Move, 4 Jump, 9 Speed, 14 PA, 40 MA, 16% C-EV. Innate: Counter, Wild Beast, Levitate. Effect: Absorb Fire; Half Fire, Ice; Weak Water; Immune Oil.\",\"FloatingEye\":\"310 HP, 18 MP, 5 Move, 5 Jump, 8 Speed, 13 PA, 37 MA, 31% C-EV. Innate: Counter, Wild Beast, Magic Defense Up, Fly, Landlocked. Effect: Half Ice, Wind, Earth, Dark; Weak Lightning.\",\"Geomancer Female\":\"145 HP, 83 MP, 4 Move, 3 Jump, 8 Speed, 9 PA, 10 MA, 11% C-EV. Innate: Elemental. Equipment: Axes, Swords, Katanas, Shields, Hats, Clothing, Robes.\",\"Geomancer Male\":\"155 HP, 78 MP, 4 Move, 3 Jump, 8 Speed, 12 PA, 8 MA, 11% C-EV. Innate: Elemental. Equipment: Axes, Swords, Katanas, Shields, Hats, Clothing, Robes.\",\"Ghost\":\"239 HP, 14 MP, 5 Move, 5 Jump, 10 Speed, 14 PA, 41 MA, 40% C-EV. Innate: Counter, Wild Beast, Levitate, Teleport. Effect: Absorb Dark; Null Earth; Weak Wind, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence.\",\"Ghoul\":\"254 HP, 23 MP, 6 Move, 4 Jump, 10 Speed, 13 PA, 42 MA, 35% C-EV. Innate: Counter, Wild Beast, Levitate, Teleport. Effect: Absorb Dark; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence.\",\"Gobbledeguck\":\"304 HP, 4 MP, 4 Move, 3 Jump, 10 Speed, 14 PA, 37 MA, 26% C-EV. Innate: Counter, Wild Beast. Effect: Half Lightning; Weak Ice.\",\"Goblin\":\"316 HP, 7 MP, 4 Move, 4 Jump, 8 Speed, 13 PA, 35 MA, 22% C-EV. Innate: Counter, Wild Beast, Beastmaster. Effect: Half Lightning, Holy; Weak Ice.\",\"GreatMalboro\":\"461 HP, 8 MP, 4 Move, 5 Jump, 7 Speed, 12 PA, 18 MA, 7% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Waterwalking. Effect: Null Wind; Half Water; Weak Ice; Immune Float.\",\"Grenade\":\"257 HP, 6 MP, 4 Move, 4 Jump, 11 Speed, 11 PA, 42 MA, 13% C-EV. Innate: Counter, Wild Beast, Levitate. Effect: Absorb Fire; Half Holy; Weak Water; Immune Oil.\",\"HolyDragon\":\"435 HP, 40 MP, 4 Move, 3 Jump, 10 Speed, 15 PA, 43 MA, 7% C-EV. Innate: Counter, Beastmaster, Stepping Stone, Landlocked. Effect: Absorb Holy; Weak Dark; Immune Evil.\",\"Hydra\":\"496 HP, 10 MP, 4 Move, 4 Jump, 9 Speed, 18 PA, 12 MA, 6% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Fly, Landlocked. Effect: Half Water; Weak Ice, Wind; Immune Float.\",\"IronHawk\":\"388 HP, 7 MP, 6 Move, 4 Jump, 9 Speed, 15 PA, 34 MA, 37% C-EV. Innate: Counter, Wild Beast, Fly, Landlocked. Effect: Absorb Wind; Null Lightning; Weak Earth.\",\"Juravis\":\"242 HP, 9 MP, 6 Move, 6 Jump, 10 Speed, 12 PA, 45 MA, 39% C-EV. Innate: Counter, Wild Beast, Fly, Landlocked. Effect: Absorb Wind; Weak Earth.\",\"KingBehemoth\":\"505 HP, 30 MP, 4 Move, 4 Jump, 9 Speed, 20 PA, 39 MA, 15% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Landlocked. Effect: Half Wind, Holy; Weak Dark; Immune Float.\",\"Knight Female\":\"189 HP, 45 MP, 3 Move, 3 Jump, 8 Speed, 10 PA, 7 MA, 14% C-EV. Innate: Battle Skill, Equip Shield. Equipment: Knight Swords, Swords, Axes, Shields, Helmets, Armor, Robes.\",\"Knight Male\":\"202 HP, 42 MP, 3 Move, 3 Jump, 8 Speed, 12 PA, 6 MA, 14% C-EV. Innate: Battle Skill, Equip Shield. Equipment: Knight Swords, Swords, Axes, Shields, Helmets, Armor, Robes.\",\"Lancer Female\":\"181 HP, 37 MP, 3 Move, 4 Jump, 8 Speed, 10 PA, 5 MA, 18% C-EV. Innate: Jump. Equipment: Spears, Poles, Shields, Helmets, Armor, Robes.\",\"Lancer Male\":\"194 HP, 34 MP, 3 Move, 4 Jump, 8 Speed, 13 PA, 4 MA, 18% C-EV. Innate: Jump. Equipment: Spears, Poles, Shields, Helmets, Armor, Robes.\",\"Malboro\":\"443 HP, 2 MP, 3 Move, 5 Jump, 7 Speed, 14 PA, 16 MA, 5% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Waterwalking. Effect: Half Wind, Water; Weak Ice; Immune Float.\",\"Mediator Female\":\"150 HP, 51 MP, 3 Move, 3 Jump, 9 Speed, 7 PA, 10 MA, 9% C-EV. Innate: Talk Skill, Monster Talk. Equipment: Guns, Books, Hats, Clothing, Robes.\",\"Mediator Male\":\"160 HP, 48 MP, 3 Move, 3 Jump, 9 Speed, 8 PA, 8 MA, 9% C-EV. Innate: Talk Skill, Monster Talk. Equipment: Guns, Books, Hats, Clothing, Robes.\",\"Mime Female\":\"185 HP, 35 MP, 3 Move, 4 Jump, 10 Speed, 11 PA, 13 MA, 6% C-EV. Innate: Mimic, Concentrate, Beastmaster, Throw Item, No MP. Equipment: Hats, Clothing, uncommonly [Shields, Helmets, Armor, Robes].\",\"Mime Male\":\"198 HP, 33 MP, 3 Move, 4 Jump, 10 Speed, 13 PA, 11 MA, 6% C-EV. Innate: Mimic, Concentrate, Beastmaster, Throw Item, No MP. Equipment: Hats, Clothing, uncommonly [Shields, Helmets, Armor, Robes].\",\"Mindflayer\":\"299 HP, 54 MP, 4 Move, 3 Jump, 8 Speed, 17 PA, 36 MA, 5% C-EV. Innate: Counter, Wild Beast, Ignore Terrain. Effect: Absorb Water; Half Fire; Weak Lightning.\",\"Minotaur\":\"487 HP, 4 MP, 4 Move, 4 Jump, 9 Speed, 15 PA, 41 MA, 10% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Fire; Weak Water; Immune Float.\",\"Monk Female\":\"193 HP, 56 MP, 3 Move, 4 Jump, 8 Speed, 10 PA, 9 MA, 24% C-EV. Innate: Punch Art, Martial Arts. Equipment: Hats, Clothing.\",\"Monk Male\":\"206 HP, 52 MP, 3 Move, 4 Jump, 8 Speed, 12 PA, 7 MA, 24% C-EV. Innate: Punch Art, Martial Arts. Equipment: Hats, Clothing.\",\"Ninja Female\":\"112 HP, 43 MP, 4 Move, 4 Jump, 10 Speed, 9 PA, 6 MA, 20% C-EV. Innate: Throw, Dual Wield. Equipment: Ninja Blades, Knives, Flails, Hats, Clothing.\",\"Ninja Male\":\"119 HP, 40 MP, 4 Move, 4 Jump, 10 Speed, 11 PA, 5 MA, 20% C-EV. Innate: Throw, Dual Wield. Equipment: Ninja Blades, Knives, Flails, Hats, Clothing.\",\"Ochu\":\"375 HP, 5 MP, 4 Move, 4 Jump, 8 Speed, 13 PA, 19 MA, 8% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Waterwalking. Effect: Half Lightning, Water; Weak Ice; Immune Float.\",\"Oracle Female\":\"139 HP, 92 MP, 3 Move, 3 Jump, 9 Speed, 5 PA, 12 MA, 22% C-EV. Innate: Yin Yang Magic. Equipment: Poles, Books, Hats, Clothing, Robes.\",\"Oracle Male\":\"149 HP, 86 MP, 3 Move, 3 Jump, 9 Speed, 6 PA, 10 MA, 22% C-EV. Innate: Yin Yang Magic. Equipment: Poles, Books, Hats, Clothing, Robes.\",\"PiscoDemon\":\"340 HP, 31 MP, 3 Move, 3 Jump, 9 Speed, 11 PA, 40 MA, 11% C-EV. Innate: Counter, Wild Beast, Ignore Terrain. Effect: Absorb Water; Half Fire, Earth; Weak Lightning.\",\"Plague\":\"292 HP, 34 MP, 5 Move, 4 Jump, 8 Speed, 15 PA, 46 MA, 17% C-EV. Innate: Counter, Wild Beast, Magic Defense Up, Fly, Landlocked. Effect: Half Fire, Wind, Water, Dark; Weak Lightning.\",\"Porky\":\"289 HP, 12 MP, 3 Move, 4 Jump, 10 Speed, 9 PA, 44 MA, 32% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Fire, Ice, Wind, Holy; Weak Dark.\",\"Priest Female\":\"166 HP, 101 MP, 3 Move, 3 Jump, 9 Speed, 7 PA, 11 MA, 5% C-EV. Innate: White Magic. Equipment: Staves, Flails, Hats, Clothing, Robes.\",\"Priest Male\":\"177 HP, 94 MP, 3 Move, 3 Jump, 9 Speed, 9 PA, 9 MA, 5% C-EV. Innate: White Magic. Equipment: Staves, Flails, Hats, Clothing, Robes.\",\"Reaper\":\"369 HP, 29 MP, 3 Move, 4 Jump, 9 Speed, 16 PA, 43 MA, 13% C-EV. Innate: Counter, Wild Beast. Effect: Absorb Dark; Half Ice; Weak Lightning, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence.\",\"RedChocobo\":\"355 HP, 17 MP, 6 Move, 4 Jump, 10 Speed, 15 PA, 35 MA, 12% C-EV. Innate: Counter, Wild Beast, Swim, Ignore Height. Effect: Weak Wind.\",\"RedDragon\":\"470 HP, 21 MP, 5 Move, 3 Jump, 9 Speed, 16 PA, 42 MA, 9% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Lava Walking, Landlocked. Effect: Absorb Fire; Weak Ice; Immune Float.\",\"RedPanther\":\"347 HP, 11 MP, 4 Move, 6 Jump, 12 Speed, 14 PA, 36 MA, 30% C-EV. Innate: Counter, Wild Beast, Ignore Height, Retreat, Landlocked. Effect: Half Fire, Lightning; Weak Earth.\",\"Revenant\":\"268 HP, 5 MP, 5 Move, 4 Jump, 11 Speed, 12 PA, 43 MA, 29% C-EV. Innate: Counter, Wild Beast, Levitate, Teleport. Effect: Absorb Dark; Half Earth; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence.\",\"Samurai Female\":\"135 HP, 66 MP, 3 Move, 3 Jump, 8 Speed, 11 PA, 9 MA, 27% C-EV. Innate: Draw Out. Equipment: Katanas, Spears, Helmets, Armor, Robes.\",\"Samurai Male\":\"144 HP, 62 MP, 3 Move, 3 Jump, 8 Speed, 14 PA, 7 MA, 27% C-EV. Innate: Draw Out. Equipment: Katanas, Spears, Helmets, Armor, Robes.\",\"Sekhret\":\"449 HP, 1 MP, 3 Move, 5 Jump, 10 Speed, 21 PA, 44 MA, 17% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Holy, Dark; Weak Water.\",\"Serpentarius\":\"514 HP, 82 MP, 4 Move, 4 Jump, 6 Speed, 10 PA, 13 MA, 16% C-EV. Innate: Counter, Sicken, Manafont, Landlocked. Effect: Half Ice; Weak Earth; Immune Float, Transparent, Chicken, Frog.\",\"Skeleton\":\"401 HP, 11 MP, 3 Move, 4 Jump, 9 Speed, 15 PA, 44 MA, 20% C-EV. Innate: Counter, Wild Beast, Ignore Terrain. Effect: Absorb Dark; Half Ice; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence.\",\"Squidraken\":\"362 HP, 22 MP, 3 Move, 4 Jump, 7 Speed, 22 PA, 38 MA, 14% C-EV. Innate: Counter, Wild Beast, Ignore Terrain. Effect: Absorb Water; Null Fire; Weak Lightning.\",\"Squire Female\":\"171 HP, 59 MP, 4 Move, 3 Jump, 9 Speed, 7 PA, 9 MA, 8% C-EV. Innate: Basic Skill. Equipment: Swords, Axes, Flails, Crossbows, Shields, Hats, Helmets, Clothing, Armor.\",\"Squire Male\":\"183 HP, 55 MP, 4 Move, 3 Jump, 9 Speed, 9 PA, 7 MA, 8% C-EV. Innate: Basic Skill. Equipment: Swords, Axes, Flails, Crossbows, Shields, Hats, Helmets, Clothing, Armor.\",\"SteelGiant\":\"500 HP, 32 MP, 2 Move, 6 Jump, 7 Speed, 20 PA, 3 MA, 2% C-EV. Innate: Counter, Stepping Stone, Swim, Landlocked. Effect: Null Holy, Dark; Half Ice, Wind; Weak Lightning; Permanent Innocent; Immune Death, Undead, Reraise, Berserk, Frog, Poison, Regen, Faith, Sleep.\",\"Summoner Female\":\"117 HP, 119 MP, 3 Move, 3 Jump, 8 Speed, 4 PA, 12 MA, 7% C-EV. Innate: Summon Magic. Equipment: Rods, Staves, Books, Hats, Clothing, Robes.\",\"Summoner Male\":\"125 HP, 112 MP, 3 Move, 3 Jump, 8 Speed, 5 PA, 9 MA, 7% C-EV. Innate: Summon Magic. Equipment: Rods, Staves, Books, Hats, Clothing, Robes.\",\"Swine\":\"260 HP, 20 MP, 3 Move, 3 Jump, 11 Speed, 10 PA, 42 MA, 38% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Fire, Lightning, Water, Holy; Weak Dark.\",\"Taiju\":\"509 HP, 43 MP, 4 Move, 2 Jump, 7 Speed, 14 PA, 39 MA, 3% C-EV. Innate: Counter, Wild Beast, Defense Up, Non-Charge, No MP, Landlocked. Effect: Absorb Earth; Half Water; Weak Fire; Immune Float.\",\"Thief Female\":\"176 HP, 39 MP, 4 Move, 3 Jump, 10 Speed, 8 PA, 7 MA, 30% C-EV. Innate: Steal. Equipment: Knives, Ninja Blades, Swords, Hats, Clothing.\",\"Thief Male\":\"188 HP, 36 MP, 4 Move, 3 Jump, 10 Speed, 10 PA, 5 MA, 30% C-EV. Innate: Steal. Equipment: Knives, Ninja Blades, Swords, Hats, Clothing.\",\"Tiamat\":\"483 HP, 28 MP, 4 Move, 4 Jump, 9 Speed, 19 PA, 17 MA, 3% C-EV. Innate: Counter, Wild Beast, Stepping Stone, Fly, Landlocked. Effect: Half Lightning; Weak Ice, Wind; Immune Float.\",\"TimeMage Female\":\"132 HP, 110 MP, 3 Move, 3 Jump, 9 Speed, 6 PA, 13 MA, 17% C-EV. Innate: Time Magic. Equipment: Staves, Poles, Hats, Clothing, Robes.\",\"TimeMage Male\":\"141 HP, 103 MP, 3 Move, 3 Jump, 9 Speed, 8 PA, 10 MA, 17% C-EV. Innate: Time Magic. Equipment: Staves, Poles, Hats, Clothing, Robes.\",\"Treant\":\"421 HP, 38 MP, 3 Move, 2 Jump, 7 Speed, 19 PA, 40 MA, 1% C-EV. Innate: Counter, Wild Beast, Defense Up, Landlocked. Effect: Absorb Earth; Null Water; Weak Fire; Immune Float.\",\"UltimaDemon\":\"333 HP, 104 MP, 5 Move, 2 Jump, 7 Speed, 17 PA, 13 MA, 9% C-EV. Innate: Counter, Short Charge, Landlocked. Effect: Null Holy; Half Fire, Dark; Weak Water; Immune Transparent.\",\"Vampire\":\"295 HP, 6 MP, 4 Move, 4 Jump, 10 Speed, 16 PA, 33 MA, 25% C-EV. Innate: Counter, Wild Beast, Ignore Height, Retreat, Landlocked. Effect: Null Dark; Weak Earth, Holy; Immune Sleep.\",\"WildBoar\":\"277 HP, 15 MP, 3 Move, 4 Jump, 10 Speed, 19 PA, 43 MA, 36% C-EV. Innate: Counter, Wild Beast, Landlocked. Effect: Half Lightning, Ice, Earth, Holy; Weak Dark.\",\"Wizard Female\":\"128 HP, 115 MP, 3 Move, 3 Jump, 8 Speed, 5 PA, 14 MA, 10% C-EV. Innate: Black Magic. Equipment: Rods, Knives, Hats, Clothing, Robes.\",\"Wizard Male\":\"137 HP, 107 MP, 3 Move, 3 Jump, 8 Speed, 7 PA, 11 MA, 10% C-EV. Innate: Black Magic. Equipment: Rods, Knives, Hats, Clothing, Robes.\",\"Wyvern\":\"408 HP, 19 MP, 4 Move, 4 Jump, 11 Speed, 16 PA, 14 MA, 4% C-EV. Innate: Counter, Wild Beast, Sicken, Stepping Stone, Fly, Landlocked. Effect: Half Fire; Weak Ice, Wind; Immune Float, Poison.\"},\"MonsterSkills\":{\"Ahriman\":[\"Wing Attack\",\"Look of Devil\",\"Look of Fright\",\"Doom*\"],\"Apanda\":[\"Bio Tenebris\",\"Bio Venenum\",\"Bio Oleum\",\"Bio Ranae\",\"Bio Tardus\",\"Bio Silentium\",\"Bio Lapis\",\"Bio Immortuos\",\"Bio Mortem\",\"Bio Insanis\"],\"Archaic Demon\":[\"Lifebreak\",\"Dark Holy\",\"Giga Flare\",\"Empower\",\"Despair\",\"Despair 2\"],\"Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Giga Flare*\"],\"Black Chocobo\":[\"Choco Attack\",\"Choco Ball\",\"Choco Esuna\",\"Choco Meteor*\"],\"Black Goblin\":[\"Tackle\",\"Turn Punch\",\"Goblin Punch\",\"Mutilate*\"],\"Blue Dragon\":[\"Slam\",\"Ice Breath\",\"Tail Swing\",\"Fire Breath*\"],\"Bomb\":[\"Bite\",\"Self Destruct\",\"Flame Attack\",\"Spark*\"],\"Bull Demon\":[\"Shake Off\",\"Storm Around\",\"Blow Fire*\"],\"Byblos\":[\"Energize\",\"Parasite\",\"Vengeance\",\"Manaburn\",\"Chicken\"],\"Chocobo\":[\"Choco Attack\",\"Choco Cure\",\"Choco Esuna\",\"Choco Ball*\"],\"Cockatrice\":[\"Scratch Up\",\"Beak\",\"Feather Bomb\",\"Peck*\"],\"Coeurl\":[\"Scratch\",\"Cat Kick\",\"Blaster\",\"Poison Nail*\"],\"Dark Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Ulmaguest*\"],\"Dragon\":[\"Slam\",\"Thunder Breath\",\"Tail Swing\",\"Ice Breath*\"],\"Draugr\":[\"Knife Hand\",\"Aqua Soul\",\"Frost Soul\",\"Wind Soul*\"],\"Dryad\":[\"Leaf Dance\",\"Calm Spirit\",\"Protect Spirit\",\"Spirit of Life*\"],\"Explosive\":[\"Bite\",\"Self Destruct\",\"Spark\",\"Small Bomb*\"],\"Floating Eye\":[\"Wing Attack\",\"Look of Fright\",\"Beam\",\"Look of Devil*\"],\"Ghost\":[\"Throw Spirit\",\"Grease Touch\",\"Drain Touch\",\"Zombie Touch*\"],\"Ghoul\":[\"Throw Spirit\",\"Sleep Touch\",\"Knife Hand\",\"Grease Touch*\"],\"Gobbledeguck\":[\"Tackle\",\"Eye Gouge\",\"Mutilate\",\"Goblin Punch*\"],\"Goblin\":[\"Tackle\",\"Eye Gouge\",\"Goblin Punch\",\"Turn Punch*\"],\"Great Malboro\":[\"Tendrils\",\"Bad Breath\",\"Moldball Virus\",\"Goo*\"],\"Grenade\":[\"Bite\",\"Small Bomb\",\"Self Destruct\",\"Flame Attack*\"],\"Holy Dragon\":[\"Holy Breath\",\"Fire Breath\",\"Ice Breath\",\"Thunder Breath\"],\"Hydra\":[\"Triple Attack\",\"Triple Flame\",\"Triple Thunder*\"],\"Iron Hawk\":[\"Scratch Up\",\"Peck\",\"Shine Lover\",\"Feather Bomb*\"],\"Juravis\":[\"Scratch Up\",\"Feather Bomb\",\"Shine Lover\",\"Fury*\"],\"King Behemoth\":[\"Stab Up\",\"Frozen Cry\",\"Hurricane*\"],\"Malboro\":[\"Tendrils\",\"Lick\",\"Noxious Gas\",\"Bad Breath*\"],\"Mindflayer\":[\"Tentacle\",\"Mind Blast\",\"Odd Soundwave\",\"Level Blast*\"],\"Minotaur\":[\"Shake Off\",\"Blow Fire\",\"Gather Power*\"],\"Ochu\":[\"Tendrils\",\"Goo\",\"Lick\",\"Noxious Gas*\"],\"Pisco Demon\":[\"Tentacle\",\"Black Ink\",\"Level Blast\",\"Odd Soundwave*\"],\"Plague\":[\"Wing Attack\",\"Doom\",\"Look of Devil\",\"Beam*\"],\"Porky\":[\"Straight Dash\",\"Toot\",\"Bequeath Bacon\",\"Snort*\"],\"Reaper\":[\"Knife Hand\",\"Wind Soul\",\"Thunder Soul\",\"Frost Soul*\"],\"Red Chocobo\":[\"Choco Attack\",\"Choco Meteor\",\"Choco Ball\",\"Choco Cure*\"],\"Red Dragon\":[\"Slam\",\"Fire Breath\",\"Tail Swing\",\"Thunder Breath*\"],\"Red Panther\":[\"Scratch\",\"Poison Nail\",\"Cat Kick\",\"Accumulate*\"],\"Revenant\":[\"Throw Spirit\",\"Drain Touch\",\"Zombie Touch\",\"Sleep Touch*\"],\"Sekhret\":[\"Shake Off\",\"Mimic Titan\",\"Gather Power\",\"Storm Around*\"],\"Serpentarius\":[\"Snake Carrier\",\"Toxic Toad\",\"Midgar Swarm\",\"Scream\"],\"Skeleton\":[\"Knife Hand\",\"Thunder Soul\",\"Frost Soul\",\"Aqua Soul*\"],\"Squidraken\":[\"Tentacle\",\"Black Ink\",\"Odd Soundwave\",\"Mind Blast*\"],\"Steel Giant\":[\"Destroy\",\"Compress\",\"Dispose\",\"Repair\"],\"Swine\":[\"Straight Dash\",\"Oink\",\"Bequeath Bacon\",\"Toot*\"],\"Taiju\":[\"Leaf Dance\",\"Magic Spirit\",\"Spirit of Life\",\"Magic Barrier*\"],\"Tiamat\":[\"Triple Attack\",\"Triple Thunder\",\"Triple Breath\",\"Dark Whisper*\"],\"Treant\":[\"Leaf Dance\",\"Spirit of Life\",\"Protect Spirit\",\"Calm Spirit*\"],\"Ultima Demon\":[\"Nanoflare\",\"Dark Holy\",\"Ultima\",\"Hurricane\",\"Ulmaguest\",\"Empower\"],\"Vampire\":[\"Scratch\",\"Blaster\",\"Blood Suck\",\"Cat Kick*\"],\"Wild Boar\":[\"Straight Dash\",\"Snort\",\"Bequeath Bacon\",\"Oink*\"],\"Wyvern\":[\"Triple Attack\",\"Noxious Gas\",\"Triple Breath*\"]}}");

});


parcelRegister("eovON", function(module, exports) {
module.exports = Promise.all([
    import("lR9xw"),
    import("jRkIt")
]).then(()=>parcelRequire('5G0ze'));

});


parcelRegister("knZDq", function(module, exports) {

$parcel$export(module.exports, "render", () => $03d47ae74a451e87$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $03d47ae74a451e87$var$_hoisted_1 = {
    class: "mm-panel",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Your active skill modifiers"
};
const $03d47ae74a451e87$var$_hoisted_2 = {
    class: "mm-title"
};
const $03d47ae74a451e87$var$_hoisted_3 = {
    key: 0,
    class: "mm-state"
};
const $03d47ae74a451e87$var$_hoisted_4 = {
    class: "mm-mods"
};
const $03d47ae74a451e87$var$_hoisted_5 = {
    class: "mm-mod-v"
};
const $03d47ae74a451e87$var$_hoisted_6 = {
    class: "mm-bonus"
};
const $03d47ae74a451e87$var$_hoisted_7 = {
    class: "mm-amt"
};
const $03d47ae74a451e87$var$_hoisted_8 = {
    class: "mm-classes"
};
const $03d47ae74a451e87$var$_hoisted_9 = {
    key: 0,
    class: "mm-bonus"
};
const $03d47ae74a451e87$var$_hoisted_10 = {
    class: "mm-sec-sub"
};
const $03d47ae74a451e87$var$_hoisted_11 = {
    class: "mm-toggle"
};
const $03d47ae74a451e87$var$_hoisted_12 = {
    class: "mm-classpick-row"
};
const $03d47ae74a451e87$var$_hoisted_13 = {
    class: "mm-classpick"
};
const $03d47ae74a451e87$var$_hoisted_14 = [
    "title"
];
const $03d47ae74a451e87$var$_hoisted_15 = [
    "src"
];
const $03d47ae74a451e87$var$_hoisted_16 = {
    key: 1,
    class: "mm-class-btn-emoji"
};
const $03d47ae74a451e87$var$_hoisted_17 = {
    class: "mm-class-btn-name"
};
const $03d47ae74a451e87$var$_hoisted_18 = {
    key: 2,
    class: "mm-class-btn-bonus",
    title: "Earns your class bonus"
};
const $03d47ae74a451e87$var$_hoisted_19 = {
    key: 0,
    class: "mm-remembered",
    title: "Opens on this class next time"
};
const $03d47ae74a451e87$var$_hoisted_20 = {
    class: "mm-entry-head"
};
const $03d47ae74a451e87$var$_hoisted_21 = {
    class: "mm-entry-label"
};
const $03d47ae74a451e87$var$_hoisted_22 = {
    class: "mm-myentry-for"
};
const $03d47ae74a451e87$var$_hoisted_23 = {
    class: "mm-entry-meta"
};
const $03d47ae74a451e87$var$_hoisted_24 = {
    key: 0,
    class: "mm-entry-warn"
};
const $03d47ae74a451e87$var$_hoisted_25 = {
    class: "mm-cmd-row"
};
const $03d47ae74a451e87$var$_hoisted_26 = {
    class: "mm-rules"
};
const $03d47ae74a451e87$var$_hoisted_27 = {
    class: "mm-rule"
};
const $03d47ae74a451e87$var$_hoisted_28 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_29 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_30 = {
    key: 0,
    class: "mm-pool",
    role: "radiogroup",
    "aria-label": "Which skills"
};
const $03d47ae74a451e87$var$_hoisted_31 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_32 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_33 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_34 = [
    "aria-checked",
    "title"
];
const $03d47ae74a451e87$var$_hoisted_35 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_36 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_37 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_38 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_39 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_40 = [
    "aria-checked",
    "disabled",
    "title"
];
const $03d47ae74a451e87$var$_hoisted_41 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_42 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_43 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_44 = {
    key: 0,
    class: "mm-vip"
};
const $03d47ae74a451e87$var$_hoisted_45 = {
    key: 0,
    class: "mm-vip-msg"
};
const $03d47ae74a451e87$var$_hoisted_46 = {
    key: 1,
    class: "mm-vip-msg"
};
const $03d47ae74a451e87$var$_hoisted_47 = {
    key: 2,
    class: "mm-vip-msg"
};
const $03d47ae74a451e87$var$_hoisted_48 = {
    class: "mm-vip-head"
};
const $03d47ae74a451e87$var$_hoisted_49 = {
    key: 0,
    class: "mm-vip-champ"
};
const $03d47ae74a451e87$var$_hoisted_50 = {
    key: 1,
    class: "mm-vip-champ"
};
const $03d47ae74a451e87$var$_hoisted_51 = {
    key: 2,
    class: "mm-vip-list"
};
const $03d47ae74a451e87$var$_hoisted_52 = [
    "onClick"
];
const $03d47ae74a451e87$var$_hoisted_53 = {
    class: "mm-vip-name"
};
const $03d47ae74a451e87$var$_hoisted_54 = {
    key: 0,
    class: "mm-vip-tier"
};
const $03d47ae74a451e87$var$_hoisted_55 = {
    key: 1,
    class: "mm-vip-sim",
    title: "The battle sim's chance against this champion, with random teammates"
};
const $03d47ae74a451e87$var$_hoisted_56 = {
    class: "mm-vip-why"
};
const $03d47ae74a451e87$var$_hoisted_57 = {
    key: 3,
    class: "mm-vip-msg"
};
const $03d47ae74a451e87$var$_hoisted_58 = {
    key: 4,
    class: "mm-vip-note"
};
const $03d47ae74a451e87$var$_hoisted_59 = {
    key: 5,
    class: "mm-vip-note"
};
const $03d47ae74a451e87$var$_hoisted_60 = {
    key: 6,
    class: "mm-vip-note"
};
const $03d47ae74a451e87$var$_hoisted_61 = [
    "disabled"
];
const $03d47ae74a451e87$var$_hoisted_62 = {
    class: "mm-breakdown"
};
const $03d47ae74a451e87$var$_hoisted_63 = {
    key: 0
};
const $03d47ae74a451e87$var$_hoisted_64 = {
    key: 1
};
const $03d47ae74a451e87$var$_hoisted_65 = {
    key: 0
};
const $03d47ae74a451e87$var$_hoisted_66 = {
    key: 1
};
const $03d47ae74a451e87$var$_hoisted_67 = {
    key: 2
};
const $03d47ae74a451e87$var$_hoisted_68 = {
    key: 3,
    class: "mm-pool-note"
};
const $03d47ae74a451e87$var$_hoisted_69 = {
    key: 4,
    class: "mm-pool-note"
};
const $03d47ae74a451e87$var$_hoisted_70 = {
    key: 5
};
const $03d47ae74a451e87$var$_hoisted_71 = {
    key: 6
};
const $03d47ae74a451e87$var$_hoisted_72 = {
    key: 7
};
const $03d47ae74a451e87$var$_hoisted_73 = {
    key: 8
};
const $03d47ae74a451e87$var$_hoisted_74 = {
    key: 2,
    class: "mm-quest-off"
};
const $03d47ae74a451e87$var$_hoisted_75 = {
    key: 2,
    class: "mm-custom"
};
const $03d47ae74a451e87$var$_hoisted_76 = {
    class: "mm-custom-head"
};
const $03d47ae74a451e87$var$_hoisted_77 = {
    class: "mm-custom-cls"
};
const $03d47ae74a451e87$var$_hoisted_78 = {
    class: "mm-gender-toggle"
};
const $03d47ae74a451e87$var$_hoisted_79 = [
    "disabled"
];
const $03d47ae74a451e87$var$_hoisted_80 = [
    "disabled"
];
const $03d47ae74a451e87$var$_hoisted_81 = [
    "disabled"
];
const $03d47ae74a451e87$var$_hoisted_82 = {
    class: "mm-custom-sec"
};
const $03d47ae74a451e87$var$_hoisted_83 = {
    class: "mm-sec-sub"
};
const $03d47ae74a451e87$var$_hoisted_84 = {
    key: 0,
    class: "mm-pick-list"
};
const $03d47ae74a451e87$var$_hoisted_85 = [
    "onClick"
];
const $03d47ae74a451e87$var$_hoisted_86 = {
    class: "mm-pick-name"
};
const $03d47ae74a451e87$var$_hoisted_87 = {
    class: "mm-pick-meta"
};
const $03d47ae74a451e87$var$_hoisted_88 = {
    key: 1,
    class: "mm-entry-note"
};
const $03d47ae74a451e87$var$_hoisted_89 = {
    class: "mm-pick-list"
};
const $03d47ae74a451e87$var$_hoisted_90 = [
    "onClick"
];
const $03d47ae74a451e87$var$_hoisted_91 = {
    class: "mm-pick-name"
};
const $03d47ae74a451e87$var$_hoisted_92 = {
    class: "mm-pick-meta"
};
const $03d47ae74a451e87$var$_hoisted_93 = {
    class: "mm-delta neg"
};
const $03d47ae74a451e87$var$_hoisted_94 = {
    key: 0,
    class: "mm-genderedge"
};
const $03d47ae74a451e87$var$_hoisted_95 = {
    key: 1,
    class: "mm-genderedge mm-worstban"
};
const $03d47ae74a451e87$var$_hoisted_96 = {
    key: 2,
    class: "mm-monpanel"
};
const $03d47ae74a451e87$var$_hoisted_97 = {
    key: 0,
    class: "mm-entry-note"
};
const $03d47ae74a451e87$var$_hoisted_98 = {
    class: "mm-ggh-row"
};
const $03d47ae74a451e87$var$_hoisted_99 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_100 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_101 = {
    key: 0,
    class: "mm-ggh-hint"
};
const $03d47ae74a451e87$var$_hoisted_102 = {
    key: 0,
    class: "mm-entry-note mm-mon-msg"
};
const $03d47ae74a451e87$var$_hoisted_103 = {
    key: 3,
    class: "mm-ggh-row"
};
const $03d47ae74a451e87$var$_hoisted_104 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_105 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_106 = {
    class: "mm-ggh-hint"
};
const $03d47ae74a451e87$var$_hoisted_107 = {
    key: 4,
    class: "mm-ggh-row"
};
const $03d47ae74a451e87$var$_hoisted_108 = [
    "aria-checked"
];
const $03d47ae74a451e87$var$_hoisted_109 = {
    class: "mm-ggh-box"
};
const $03d47ae74a451e87$var$_hoisted_110 = {
    class: "mm-ggh-hint"
};
const $03d47ae74a451e87$var$_hoisted_111 = {
    class: "mm-entry-head"
};
const $03d47ae74a451e87$var$_hoisted_112 = {
    class: "mm-entry-label"
};
const $03d47ae74a451e87$var$_hoisted_113 = {
    class: "mm-entry-meta"
};
const $03d47ae74a451e87$var$_hoisted_114 = {
    key: 0,
    class: "mm-entry-warn"
};
const $03d47ae74a451e87$var$_hoisted_115 = {
    class: "mm-cmd-row"
};
const $03d47ae74a451e87$var$_hoisted_116 = [
    "onClick"
];
const $03d47ae74a451e87$var$_hoisted_117 = [
    "onClick"
];
const $03d47ae74a451e87$var$_hoisted_118 = {
    key: 0,
    class: "mm-entry-note"
};
const $03d47ae74a451e87$var$_hoisted_119 = {
    key: 6,
    class: "mm-note"
};
const $03d47ae74a451e87$var$_hoisted_120 = [
    "href"
];
const $03d47ae74a451e87$var$_hoisted_121 = {
    key: 2,
    class: "mm-state"
};
function $03d47ae74a451e87$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ClassPickerModal = (0, $TusQn.resolveComponent)("ClassPickerModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay z900 mm-backdrop",
        onClick: _cache[25] || (_cache[25] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "mm-close",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\xd7"),
            (0, $TusQn.createElementVNode)("h2", $03d47ae74a451e87$var$_hoisted_2, "\u26A1 " + (0, $8POXm.toDisplayString)($props.handle) + " \u2014 skill modifiers", 1),
            _cache[60] || (_cache[60] = (0, $TusQn.createElementVNode)("p", {
                class: "mm-sub"
            }, "How your owned !buyrandom skills are nudging your next character roll.", -1)),
            !$data.loaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_3, "Loading your skills\u2026")) : $options.hasData ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 1
            }, [
                $options.mods.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    _cache[27] || (_cache[27] = (0, $TusQn.createElementVNode)("div", {
                        class: "mm-sec"
                    }, [
                        (0, $TusQn.createTextVNode)("\u26A1 Active roll modifiers "),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "mm-sec-sub"
                        }, "how owned skills nudge your character roll")
                    ], -1)),
                    (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_4, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.mods, (m)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: m.token,
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-mod",
                                    {
                                        bonus: m.isBonus,
                                        cantuse: m.mod.cannotUse,
                                        hidden: m.hidden
                                    }
                                ])
                            }, [
                                (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)(m.name), 1),
                                _cache[26] || (_cache[26] = (0, $TusQn.createTextVNode)()),
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_5, (0, $8POXm.toDisplayString)(m.modText), 1)
                            ], 2);
                        }), 128))
                    ])
                ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                $options.cb ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    _cache[32] || (_cache[32] = (0, $TusQn.createElementVNode)("div", {
                        class: "mm-sec"
                    }, [
                        (0, $TusQn.createTextVNode)("\uD83D\uDCB0 EXP you can earn "),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "mm-sec-sub"
                        }, "bonuses for how you enter")
                    ], -1)),
                    (0, $TusQn.createElementVNode)("p", $03d47ae74a451e87$var$_hoisted_6, [
                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_7, "+" + (0, $8POXm.toDisplayString)($options.cb.amount) + " EXP", 1),
                        _cache[28] || (_cache[28] = (0, $TusQn.createTextVNode)(" \u2014 enter with no parameters, or as one of: ", -1)),
                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_8, (0, $8POXm.toDisplayString)($options.cb.classes.join(', ')), 1)
                    ]),
                    $data.skillBonus ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_9, [
                        _cache[29] || (_cache[29] = (0, $TusQn.createElementVNode)("span", {
                            class: "mm-amt"
                        }, "+2 EXP", -1)),
                        _cache[30] || (_cache[30] = (0, $TusQn.createTextVNode)(" \u2014 use ", -1)),
                        (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.skillBonusName), 1),
                        _cache[31] || (_cache[31] = (0, $TusQn.createTextVNode)(" in battle. ", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                $options.entries ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 2
                }, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "mm-sec mm-sec-toggle",
                        onClick: _cache[1] || (_cache[1] = ($event)=>$data.entriesExpanded = !$data.entriesExpanded)
                    }, [
                        _cache[33] || (_cache[33] = (0, $TusQn.createTextVNode)(" \uD83C\uDFAE Suggested entry ", -1)),
                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_10, "priority-aware !fight commands \xb7 " + (0, $8POXm.toDisplayString)($data.gil.toLocaleString()) + "G", 1),
                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_11, (0, $8POXm.toDisplayString)($data.entriesExpanded ? "\u25BE less" : "\u25B8 all options"), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_13, [
                            _cache[35] || (_cache[35] = (0, $TusQn.createTextVNode)("Suggest for: ", -1)),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "mm-class-btn",
                                title: 'Pick a class, or a monster' + ($options.bonusSet.size ? " (\u2726 = earns your class bonus)" : ''),
                                onClick: _cache[3] || (_cache[3] = ($event)=>$data.classPickerOpen = true)
                            }, [
                                $options.pickerCurrent.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                                    key: 0,
                                    class: "mm-class-btn-img",
                                    src: $options.pickerCurrent.icon,
                                    alt: "",
                                    onError: _cache[2] || (_cache[2] = ($event)=>$event.target.style.visibility = 'hidden')
                                }, null, 40, $03d47ae74a451e87$var$_hoisted_15)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_16, (0, $8POXm.toDisplayString)($options.pickerCurrent.emoji), 1)),
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_17, (0, $8POXm.toDisplayString)($options.pickerCurrent.label), 1),
                                $options.pickerCurrent.bonus ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_18, "\u2726 bonus")) : (0, $TusQn.createCommentVNode)("", true),
                                _cache[34] || (_cache[34] = (0, $TusQn.createElementVNode)("span", {
                                    class: "mm-class-btn-caret"
                                }, "\u25BE", -1))
                            ], 8, $03d47ae74a451e87$var$_hoisted_14),
                            $data.chosenClass ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_19, "\u2B50 remembered")) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                        $data.chosenClass !== 'MONSTER' && !$data.entrySetUp ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            class: "mm-custom-toggle",
                            onClick: _cache[4] || (_cache[4] = (...args)=>$options.setUpMyEntry && $options.setUpMyEntry(...args))
                        }, "\u2B50 Set up My entry")) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    $data.classPickerOpen ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ClassPickerModal, {
                        key: 0,
                        classes: $options.pickerTiles,
                        current: $data.chosenClass || $data.AUTO_VAL,
                        "current-gender": $options.pickedGender || '',
                        heading: "\uD83C\uDFAE Suggest an entry for",
                        onPick: $options.onPickClass,
                        onClose: _cache[5] || (_cache[5] = ($event)=>$data.classPickerOpen = false)
                    }, null, 8, [
                        "classes",
                        "current",
                        "current-gender",
                        "onPick"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $options.showMyEntry ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: 1,
                        class: (0, $8POXm.normalizeClass)([
                            "mm-entry mm-myentry",
                            {
                                poor: !$options.customEntry.affordable
                            }
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_20, [
                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_21, [
                                _cache[36] || (_cache[36] = (0, $TusQn.createTextVNode)("\u2B50 My entry ", -1)),
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_22, "\xb7 " + (0, $8POXm.toDisplayString)($options.myEntryFor), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_23, [
                                (0, $TusQn.createTextVNode)("~" + (0, $8POXm.toDisplayString)($options.customEntry.priority) + " priority \xb7 " + (0, $8POXm.toDisplayString)($options.customEntry.cost ? $options.customEntry.cost + 'G' : 'free'), 1),
                                !$options.customEntry.affordable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_24, " \xb7 need more gil")) : (0, $TusQn.createCommentVNode)("", true)
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_25, [
                            (0, $TusQn.createElementVNode)("code", {
                                class: "mm-cmd",
                                onClick: _cache[6] || (_cache[6] = ($event)=>$options.copy($options.customEntry.command)),
                                title: "Click to copy"
                            }, (0, $8POXm.toDisplayString)($options.customEntry.command), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "mm-copy",
                                onClick: _cache[7] || (_cache[7] = ($event)=>$options.copy($options.customEntry.command))
                            }, (0, $8POXm.toDisplayString)($data.copied === $options.customEntry.command ? "\u2713 copied" : "\uD83D\uDCCB"), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_26, [
                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_27, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "mm-ggh-toggle",
                                        {
                                            on: $data.rules.forceBest
                                        }
                                    ]),
                                    role: "switch",
                                    "aria-checked": $data.rules.forceBest ? 'true' : 'false',
                                    onClick: _cache[8] || (_cache[8] = ($event)=>$options.toggleRule('forceBest'))
                                }, [
                                    (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_29, (0, $8POXm.toDisplayString)($data.rules.forceBest ? "\u2713" : ''), 1),
                                    _cache[37] || (_cache[37] = (0, $TusQn.createTextVNode)(" Force my best skill ", -1))
                                ], 10, $03d47ae74a451e87$var$_hoisted_28),
                                $data.rules.forceBest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_30, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-pool-opt",
                                            {
                                                on: $data.rules.pool === 'usable'
                                            }
                                        ]),
                                        role: "radio",
                                        "aria-checked": $data.rules.pool === 'usable' ? 'true' : 'false',
                                        title: "Any skill you can still force (under 5 tildes), even if recent use costs you EXP or priority",
                                        onClick: _cache[9] || (_cache[9] = ($event)=>$options.setPool('usable'))
                                    }, "any usable", 10, $03d47ae74a451e87$var$_hoisted_31),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-pool-opt",
                                            {
                                                on: $data.rules.pool === 'offcd'
                                            }
                                        ]),
                                        role: "radio",
                                        "aria-checked": $data.rules.pool === 'offcd' ? 'true' : 'false',
                                        title: "Only skills with no reroll tildes, so you keep full EXP. An uncommon or rare one still costs priority to force: worth it when the bracket isn't crowded",
                                        onClick: _cache[10] || (_cache[10] = ($event)=>$options.setPool('offcd'))
                                    }, "off cooldown", 10, $03d47ae74a451e87$var$_hoisted_32),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-pool-opt",
                                            {
                                                on: $data.rules.pool === 'nopenalty'
                                            }
                                        ]),
                                        role: "radio",
                                        "aria-checked": $data.rules.pool === 'nopenalty' ? 'true' : 'false',
                                        title: "Only skills with no reroll tildes that also cost no priority to force: common skills (a common skill bonus counts)",
                                        onClick: _cache[11] || (_cache[11] = ($event)=>$options.setPool('nopenalty'))
                                    }, "no penalty", 10, $03d47ae74a451e87$var$_hoisted_33)
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            $options.ownedHidden.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: 0,
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.saveHidden
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.saveHidden ? 'true' : 'false',
                                title: 'Never suggest forcing ' + $options.orList($options.ownedHidden),
                                onClick: _cache[12] || (_cache[12] = (...args)=>$options.toggleHidden && $options.toggleHidden(...args))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_35, (0, $8POXm.toDisplayString)($data.saveHidden ? "\u2713" : ''), 1),
                                _cache[38] || (_cache[38] = (0, $TusQn.createTextVNode)(" Save my hidden skills ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_34)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.rules.banWorst
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.rules.banWorst ? 'true' : 'false',
                                onClick: _cache[13] || (_cache[13] = ($event)=>$options.toggleRule('banWorst'))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_37, (0, $8POXm.toDisplayString)($data.rules.banWorst ? "\u2713" : ''), 1),
                                _cache[39] || (_cache[39] = (0, $TusQn.createTextVNode)(" Ban the worst roll ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_36),
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.excludeGgh
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.excludeGgh ? 'true' : 'false',
                                onClick: _cache[14] || (_cache[14] = (...args)=>$options.toggleGgh && $options.toggleGgh(...args))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_39, (0, $8POXm.toDisplayString)($data.excludeGgh ? "\u2713" : ''), 1),
                                _cache[40] || (_cache[40] = (0, $TusQn.createTextVNode)(" Exclude GilgameHeart ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_38),
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.rules.respectQuest && !$options.questWhyNot
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.rules.respectQuest ? 'true' : 'false',
                                disabled: !!$options.questWhyNot && !$data.rules.respectQuest,
                                title: $options.questWhyNot || 'Enter as something your ' + $options.questGoal.name + ' still needs',
                                onClick: _cache[15] || (_cache[15] = ($event)=>$options.toggleRule('respectQuest'))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_41, (0, $8POXm.toDisplayString)($data.rules.respectQuest ? "\u2713" : ''), 1),
                                _cache[41] || (_cache[41] = (0, $TusQn.createTextVNode)(" Respect my quest", -1)),
                                $options.questGoal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createTextVNode)(" (" + (0, $8POXm.toDisplayString)($options.questGoal.name) + ")", 1)
                                ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 10, $03d47ae74a451e87$var$_hoisted_40),
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.rules.vip
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.rules.vip ? 'true' : 'false',
                                title: "Enter as a class you haven't champed this season, picked for its edge on the champion you'd face",
                                onClick: _cache[16] || (_cache[16] = ($event)=>$options.toggleRule('vip'))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_43, (0, $8POXm.toDisplayString)($data.rules.vip ? "\u2713" : ''), 1),
                                _cache[42] || (_cache[42] = (0, $TusQn.createTextVNode)(" \uD83C\uDF96\uFE0F Help me with VIP quest ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_42)
                        ]),
                        $data.rules.vip ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_44, [
                            $data.vipError ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_45, (0, $8POXm.toDisplayString)($data.vipError), 1)) : !$data.vipHist ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_46, "Reading this season's titles\u2026")) : !$options.vipNeeded.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_47, "\uD83C\uDF89 You've champed all " + (0, $8POXm.toDisplayString)($data.vipTotal) + " this season. Nothing left to chase!", 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 3
                            }, [
                                (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_48, [
                                    _cache[43] || (_cache[43] = (0, $TusQn.createTextVNode)(" \uD83C\uDF96\uFE0F ", -1)),
                                    (0, $TusQn.createElementVNode)("b", null, "VIP Quest, Season " + (0, $8POXm.toDisplayString)($data.seasonCount), 1),
                                    (0, $TusQn.createTextVNode)(": " + (0, $8POXm.toDisplayString)($options.vipHave) + "/" + (0, $8POXm.toDisplayString)($data.vipTotal) + " champed, " + (0, $8POXm.toDisplayString)($options.vipNeeded.length) + " to go ", 1),
                                    _cache[44] || (_cache[44] = (0, $TusQn.createElementVNode)("a", {
                                        href: "?vip",
                                        class: "mm-vip-board"
                                    }, "board \u2192", -1))
                                ]),
                                $options.vipChampText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_49, "vs " + (0, $8POXm.toDisplayString)($options.vipChampText), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_50, "No champion on this bracket to read, so the picks go by win rate alone.")),
                                $options.vipList.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ol", $03d47ae74a451e87$var$_hoisted_51, [
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.vipList, (c)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                            key: c.cls,
                                            class: (0, $8POXm.normalizeClass)({
                                                on: $options.vipPick && c.cls === $options.vipPick.cls
                                            }),
                                            onClick: ($event)=>$options.pickVip(c.cls)
                                        }, [
                                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_53, [
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(c.cls), 1),
                                                c.skill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                                    key: 0
                                                }, [
                                                    (0, $TusQn.createTextVNode)(" + " + (0, $8POXm.toDisplayString)(c.skill.name), 1)
                                                ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                            ]),
                                            c.gated ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_54, (0, $8POXm.toDisplayString)($options.vipTier(c.cls)), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            $data.vipSim[c.cls] != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_55, (0, $8POXm.toDisplayString)($data.vipSim[c.cls]) + "%", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_56, (0, $8POXm.toDisplayString)($options.vipWhy(c)), 1)
                                        ], 10, $03d47ae74a451e87$var$_hoisted_52);
                                    }), 128))
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_57, "None of the classes you still need can be entered right now: the rest are monsters you don't own, or that are on cooldown.")),
                                $options.vipGated.owned.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_58, "Strong and elite monsters share a cooldown, so the ones you still need come first.")) : (0, $TusQn.createCommentVNode)("", true),
                                $options.vipGated.cooling.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_59, [
                                    (0, $TusQn.createTextVNode)(" \u23F3 On the strong/elite cooldown for now: " + (0, $8POXm.toDisplayString)($options.vipGated.cooling.slice(0, 6).join(', ')), 1),
                                    $options.vipGated.cooling.length > 6 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, [
                                        (0, $TusQn.createTextVNode)(" and " + (0, $8POXm.toDisplayString)($options.vipGated.cooling.length - 6) + " more", 1)
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                    _cache[45] || (_cache[45] = (0, $TusQn.createTextVNode)(". ", -1))
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.vipGated.missing.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_60, [
                                    (0, $TusQn.createTextVNode)(" Strong and elite monsters you still need but don't own: " + (0, $8POXm.toDisplayString)($options.vipGated.missing.slice(0, 6).join(', ')), 1),
                                    $options.vipGated.missing.length > 6 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, [
                                        (0, $TusQn.createTextVNode)(" and " + (0, $8POXm.toDisplayString)($options.vipGated.missing.length - 6) + " more", 1)
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                    _cache[46] || (_cache[46] = (0, $TusQn.createTextVNode)(". ", -1))
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.vipList.length && $options.vipChampText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                    key: 7,
                                    class: "mm-vip-simbtn",
                                    disabled: $data.vipSimBusy,
                                    title: "Rough: each candidate fights with random teammates, on a flat grid since the map isn't known yet",
                                    onClick: _cache[17] || (_cache[17] = (...args)=>$options.runVipSim && $options.runVipSim(...args))
                                }, (0, $8POXm.toDisplayString)($data.vipSimBusy ? "Simulating\u2026" : Object.keys($data.vipSim).length ? "\uD83C\uDFB2 Run the sim again" : "\uD83C\uDFB2 Sim these against the champion"), 9, $03d47ae74a451e87$var$_hoisted_61)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 64))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("ul", $03d47ae74a451e87$var$_hoisted_62, [
                            $options.customEntry.kind === 'monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                $options.customEntry.via === 'vip' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_63, [
                                    (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.nameOfToken($options.customEntry.monster)), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 " + (0, $8POXm.toDisplayString)($options.customEntry.tier === 'elite' ? 'an' : 'a') + " " + (0, $8POXm.toDisplayString)($options.customEntry.tier) + " monster you own and haven't champed this season \xb7 " + (0, $8POXm.toDisplayString)($options.vipPickWhy) + ". A monster entry takes no other parameters.", 1)
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_64, [
                                    (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.nameOfToken($options.customEntry.monster)), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 " + (0, $8POXm.toDisplayString)($options.customEntry.tier === 'elite' ? 'an' : 'a') + " " + (0, $8POXm.toDisplayString)($options.customEntry.tier) + " monster you own that your " + (0, $8POXm.toDisplayString)($options.questGoal.name) + " still needs. A monster entry takes no other parameters.", 1)
                                ]))
                            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, [
                                (0, $TusQn.createElementVNode)("li", null, [
                                    (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)) + (0, $8POXm.toDisplayString)($data.customGender === 'Female' ? " \u2640" : $data.customGender === 'Male' ? " \u2642" : ''), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 " + (0, $8POXm.toDisplayString)($options.classBaseWRDisp) + "% base win rate", 1),
                                    $options.questActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, [
                                        (0, $TusQn.createTextVNode)(" \xb7 your " + (0, $8POXm.toDisplayString)($options.questGoal.name) + " still needs it", 1)
                                    ], 64)) : $options.vipActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, [
                                        (0, $TusQn.createTextVNode)(" \xb7 you haven't champed one this season")
                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                                ]),
                                $options.customEntry.gender ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_65, [
                                    (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.customEntry.gender === 'Female' ? "\u2640 Female" : "\u2642 Male"), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 " + (0, $8POXm.toDisplayString)($options.questGender ? 'your quest needs it' : $data.rules.gender ? 'your pick' : 'the stronger gender'), 1)
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.customEntry.forced ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_66, [
                                    (0, $TusQn.createElementVNode)("b", null, "Force " + (0, $8POXm.toDisplayString)($options.nameOfToken($options.customEntry.forced)), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 " + (0, $8POXm.toDisplayString)($options.vipSkill && $options.customEntry.forced === $options.vipSkill.token ? $options.vipSkillWhy : $options.forcePickDisp) + (0, $8POXm.toDisplayString)($options.customEntry.usesSkillBonus ? " \xb7 your skill bonus (+5 priority, +2 EXP)" : '') + (0, $8POXm.toDisplayString)($options.customEntry.stepText ? " \xb7 you've rerolled it (" + $options.customEntry.stepText + ')' : ''), 1)
                                ])) : $data.rules.forceBest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_67, "No owned skill" + (0, $8POXm.toDisplayString)($data.rules.pool === 'nopenalty' ? ' without a penalty' : $data.rules.pool === 'offcd' ? ' off cooldown' : '') + " beats " + (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)) + "'s baseline, so none is forced.", 1)) : (0, $TusQn.createCommentVNode)("", true),
                                $options.poolNote ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_68, (0, $8POXm.toDisplayString)($options.poolNote), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                $options.hiddenNote ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_69, (0, $8POXm.toDisplayString)($options.hiddenNote), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                $options.customEntry.ban ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_70, [
                                    (0, $TusQn.createElementVNode)("b", null, "Ban " + (0, $8POXm.toDisplayString)($options.customEntry.ban), 1),
                                    (0, $TusQn.createTextVNode)(" \u2014 dodges this bad roll (" + (0, $8POXm.toDisplayString)($options.banPickDisp) + ")", 1)
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.customEntry.ggh ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_71, [
                                    ..._cache[47] || (_cache[47] = [
                                        (0, $TusQn.createElementVNode)("b", null, "Exclude GilgameHeart", -1),
                                        (0, $TusQn.createTextVNode)(" \u2014 +5 priority for a 500G bribe", -1)
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $options.customEntry.bribeSkipped ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_72, "GilgameHeart bribe skipped \u2014 you're short on gil for it.")) : (0, $TusQn.createCommentVNode)("", true),
                                $options.customEntry.dropped.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_73, "Left out, since an entry takes four parameters at most: " + (0, $8POXm.toDisplayString)($options.droppedText) + ".", 1)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 64)),
                            $data.rules.respectQuest && $options.questWhyNot ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $03d47ae74a451e87$var$_hoisted_74, "\uD83C\uDFAF " + (0, $8POXm.toDisplayString)($options.questWhyNot), 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                        $options.customEntry.kind !== 'monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 1,
                            class: "mm-finetune",
                            onClick: _cache[18] || (_cache[18] = ($event)=>$data.fineTune = !$data.fineTune)
                        }, (0, $8POXm.toDisplayString)($data.fineTune ? "\u25BE hide picks" : "\u270F\uFE0F adjust picks"), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $data.fineTune && $options.customEntry.kind !== 'monster' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_75, [
                            (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_76, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_77, (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)), 1),
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_78, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-gpill",
                                            {
                                                on: $data.customGender === 'Male'
                                            }
                                        ]),
                                        disabled: !!$options.genderLock || !!$options.questGender,
                                        onClick: _cache[19] || (_cache[19] = ($event)=>$options.setGender('Male'))
                                    }, "\u2642 Male", 10, $03d47ae74a451e87$var$_hoisted_79),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-gpill",
                                            {
                                                on: $data.customGender === 'Female'
                                            }
                                        ]),
                                        disabled: !!$options.genderLock || !!$options.questGender,
                                        onClick: _cache[20] || (_cache[20] = ($event)=>$options.setGender('Female'))
                                    }, "\u2640 Female", 10, $03d47ae74a451e87$var$_hoisted_80),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-gpill",
                                            {
                                                on: !$data.customGender
                                            }
                                        ]),
                                        disabled: !!$options.genderLock || !!$options.questGender,
                                        title: "Leave the gender to the roll (saves a parameter and 100G)",
                                        onClick: _cache[21] || (_cache[21] = ($event)=>$options.setGender(''))
                                    }, "\u26A5 Any", 10, $03d47ae74a451e87$var$_hoisted_81)
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_82, [
                                _cache[48] || (_cache[48] = (0, $TusQn.createTextVNode)("\u2694\uFE0F Force a skill ", -1)),
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_83, "your best owned skills for " + (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)) + " \xb7 click to swap, click again for none", 1)
                            ]),
                            $options.customForceList.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_84, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.customForceList, (s)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                        key: s.token,
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-pick",
                                            {
                                                on: $options.forcePick === s.token
                                            }
                                        ]),
                                        onClick: ($event)=>$options.selectForce(s.token)
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_86, (0, $8POXm.toDisplayString)(s.name), 1),
                                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_87, [
                                            (0, $TusQn.createElementVNode)("span", {
                                                class: (0, $8POXm.normalizeClass)([
                                                    "mm-delta",
                                                    s.delta >= 0 ? 'pos' : 'neg'
                                                ])
                                            }, (0, $8POXm.toDisplayString)(s.delta >= 0 ? '+' : '') + (0, $8POXm.toDisplayString)(s.delta) + "%", 3),
                                            s.rarity !== 'common' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                                key: 0,
                                                class: (0, $8POXm.normalizeClass)([
                                                    "mm-rar",
                                                    s.rarity
                                                ])
                                            }, (0, $8POXm.toDisplayString)(s.rarity) + " " + (0, $8POXm.toDisplayString)(s.prio), 3)) : (0, $TusQn.createCommentVNode)("", true),
                                            s.stepText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                                key: 1,
                                                class: (0, $8POXm.normalizeClass)([
                                                    "mm-rar step",
                                                    {
                                                        neg: s.stepNeg
                                                    }
                                                ])
                                            }, "\u27F2 " + (0, $8POXm.toDisplayString)(s.stepText), 3)) : (0, $TusQn.createCommentVNode)("", true)
                                        ])
                                    ], 10, $03d47ae74a451e87$var$_hoisted_85);
                                }), 128))
                            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_88, "You don't own any forceable skills with data for this class yet \u2014 enter as the class alone, or pick a different class.")),
                            _cache[49] || (_cache[49] = (0, $TusQn.createElementVNode)("div", {
                                class: "mm-custom-sec"
                            }, [
                                (0, $TusQn.createTextVNode)("\uD83D\uDEAB Ban a skill "),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: "mm-sec-sub"
                                }, "dodge a bad roll \xb7 click to swap, click again for none")
                            ], -1)),
                            (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_89, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.customBanList, (b)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                        key: b.token,
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-pick",
                                            {
                                                on: $options.banPick === b.token
                                            }
                                        ]),
                                        onClick: ($event)=>$options.selectBan(b.token)
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_91, (0, $8POXm.toDisplayString)(b.name), 1),
                                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_92, [
                                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_93, (0, $8POXm.toDisplayString)(b.delta) + "%", 1)
                                        ])
                                    ], 10, $03d47ae74a451e87$var$_hoisted_90);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                    !$options.showMyEntry || $data.entriesExpanded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 2
                    }, [
                        $data.entriesExpanded && $options.genderEdgeInfo && $options.pickedGender == null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_94, "\uD83D\uDCA1 " + (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)) + " wins ~" + (0, $8POXm.toDisplayString)($options.genderEdgeInfo.delta) + "% more as " + (0, $8POXm.toDisplayString)($options.genderEdgeInfo.gender === 'Female' ? "\u2640 Female" : "\u2642 Male") + " \u2014 folded into the commands below (+100G, no priority cost).", 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $data.entriesExpanded && $options.worstBan ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_95, [
                            (0, $TusQn.createTextVNode)("\u26A0\uFE0F " + (0, $8POXm.toDisplayString)($options.classDisplay($options.activeClass)) + "'s worst roll: ", 1),
                            (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.worstBan.skill), 1),
                            (0, $TusQn.createTextVNode)(" as a " + (0, $8POXm.toDisplayString)($options.worstBan.slot) + " (" + (0, $8POXm.toDisplayString)($options.worstBan.delta) + "%). ", 1),
                            $data.excludeGgh ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                _cache[50] || (_cache[50] = (0, $TusQn.createTextVNode)("Swap ", -1)),
                                _cache[51] || (_cache[51] = (0, $TusQn.createElementVNode)("code", null, "-gilgameheart", -1)),
                                _cache[52] || (_cache[52] = (0, $TusQn.createTextVNode)(" \u2192 ", -1)),
                                (0, $TusQn.createElementVNode)("code", null, "-" + (0, $8POXm.toDisplayString)($options.worstBan.ban), 1),
                                _cache[53] || (_cache[53] = (0, $TusQn.createTextVNode)(" to dodge it \u2014 trades the +5 priority (but saves 500G), worth it only if you're already a lock to get in.", -1))
                            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, [
                                _cache[54] || (_cache[54] = (0, $TusQn.createTextVNode)("Add ", -1)),
                                (0, $TusQn.createElementVNode)("code", null, "-" + (0, $8POXm.toDisplayString)($options.worstBan.ban), 1),
                                _cache[55] || (_cache[55] = (0, $TusQn.createTextVNode)(" (+100G) to dodge it.", -1))
                            ], 64))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.chosenClass === 'MONSTER' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_96, [
                            !$options.rankedMonsters.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_97, "You don't own any monsters yet \u2014 acquire one via buyrandom to enter as it.")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, [
                                (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_98, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "mm-ggh-toggle",
                                            {
                                                on: $data.monsterQuest
                                            }
                                        ]),
                                        role: "switch",
                                        "aria-checked": $data.monsterQuest ? 'true' : 'false',
                                        title: "Only suggest monsters you still need for the Monster Quest",
                                        onClick: _cache[22] || (_cache[22] = (...args)=>$options.toggleMonsterQuest && $options.toggleMonsterQuest(...args))
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_100, (0, $8POXm.toDisplayString)($data.monsterQuest ? "\u2713" : ''), 1),
                                        _cache[56] || (_cache[56] = (0, $TusQn.createTextVNode)(" \uD83D\uDC09 Respect Monster Quest ", -1))
                                    ], 10, $03d47ae74a451e87$var$_hoisted_99),
                                    $data.monsterQuest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_101, (0, $8POXm.toDisplayString)($options.mqHint), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                ]),
                                $options.mqEmptyMsg ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_102, (0, $8POXm.toDisplayString)($options.mqEmptyMsg), 1)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 64))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.chosenClass !== 'MONSTER' && !$options.showMyEntry ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_103, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.excludeGgh
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.excludeGgh ? 'true' : 'false',
                                onClick: _cache[23] || (_cache[23] = (...args)=>$options.toggleGgh && $options.toggleGgh(...args))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_105, (0, $8POXm.toDisplayString)($data.excludeGgh ? "\u2713" : ''), 1),
                                _cache[57] || (_cache[57] = (0, $TusQn.createTextVNode)(" Exclude GilgameHeart ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_104),
                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_106, (0, $8POXm.toDisplayString)($data.excludeGgh ? 'buys +5 priority for a 500G bribe' : "off \u2014 commands skip the GilgameHeart bribe"), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.chosenClass !== 'MONSTER' && !$options.showMyEntry && $options.ownedHidden.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_107, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-ggh-toggle",
                                    {
                                        on: $data.saveHidden
                                    }
                                ]),
                                role: "switch",
                                "aria-checked": $data.saveHidden ? 'true' : 'false',
                                onClick: _cache[24] || (_cache[24] = (...args)=>$options.toggleHidden && $options.toggleHidden(...args))
                            }, [
                                (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_109, (0, $8POXm.toDisplayString)($data.saveHidden ? "\u2713" : ''), 1),
                                _cache[58] || (_cache[58] = (0, $TusQn.createTextVNode)(" Save my hidden skills ", -1))
                            ], 10, $03d47ae74a451e87$var$_hoisted_108),
                            (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_110, (0, $8POXm.toDisplayString)($data.saveHidden ? "commands won't force " : "off \u2014 commands may force ") + (0, $8POXm.toDisplayString)($options.orList($options.ownedHidden)), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.entriesExpanded ? $options.entries : [
                            $options.headlineEntry
                        ], (e)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: e.key,
                                class: (0, $8POXm.normalizeClass)([
                                    "mm-entry",
                                    {
                                        poor: !e.affordable
                                    }
                                ])
                            }, [
                                (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_111, [
                                    (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_112, (0, $8POXm.toDisplayString)(e.icon) + " " + (0, $8POXm.toDisplayString)(e.label), 1),
                                    (0, $TusQn.createElementVNode)("span", $03d47ae74a451e87$var$_hoisted_113, [
                                        (0, $TusQn.createTextVNode)("~" + (0, $8POXm.toDisplayString)(e.priority) + " priority \xb7 " + (0, $8POXm.toDisplayString)(e.cost ? e.cost + 'G' : 'free'), 1),
                                        !e.affordable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $03d47ae74a451e87$var$_hoisted_114, " \xb7 need more gil")) : (0, $TusQn.createCommentVNode)("", true)
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $03d47ae74a451e87$var$_hoisted_115, [
                                    (0, $TusQn.createElementVNode)("code", {
                                        class: "mm-cmd",
                                        onClick: ($event)=>$options.copy(e.command),
                                        title: "Click to copy"
                                    }, (0, $8POXm.toDisplayString)(e.command), 9, $03d47ae74a451e87$var$_hoisted_116),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: "mm-copy",
                                        onClick: ($event)=>$options.copy(e.command)
                                    }, (0, $8POXm.toDisplayString)($data.copied === e.command ? "\u2713 copied" : "\uD83D\uDCCB"), 9, $03d47ae74a451e87$var$_hoisted_117)
                                ]),
                                $data.entriesExpanded || e.mon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_118, (0, $8POXm.toDisplayString)(e.note), 1)) : (0, $TusQn.createCommentVNode)("", true)
                            ], 2);
                        }), 128)),
                        $data.chosenClass === 'MONSTER' && ($data.entriesExpanded || !$options.monsterEntries.length) ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 5
                        }, (0, $TusQn.renderList)($options.monsterBlocked, (b)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", {
                                key: b.key,
                                class: "mm-entry-note mm-mon-msg"
                            }, "\u23F3 " + (0, $8POXm.toDisplayString)(b.text), 1);
                        }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                        $data.entriesExpanded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $03d47ae74a451e87$var$_hoisted_119, "Priority shown is the base \u2014 add +20 if you're subscribed, +40 if you were snubbed last tournament; recent admissions / recently-used skills lower it.")) : (0, $TusQn.createCommentVNode)("", true)
                    ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                _cache[59] || (_cache[59] = (0, $TusQn.createElementVNode)("p", {
                    class: "mm-note"
                }, "Snub and recency adjustments aren't shown \u2014 those are computed bot-side, not in the public files.", -1)),
                (0, $TusQn.createElementVNode)("a", {
                    href: '?player=' + encodeURIComponent($props.handle) + '&tab=skills',
                    class: "mm-link"
                }, "See your full skill collection \u2192", 8, $03d47ae74a451e87$var$_hoisted_120)
            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $03d47ae74a451e87$var$_hoisted_121, " Couldn't load your live skill data \u2014 this only works on the live site (luxor's wiznaib.us). "))
        ])
    ]);
}

});

parcelRegister("cB3jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $92bb82564d5b78db$export$2e2bcd8739ae039);
let $92bb82564d5b78db$var$NOOP = ()=>{};
var $92bb82564d5b78db$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cuELn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9187e81b5d342807$export$2e2bcd8739ae039);
let $9187e81b5d342807$var$script;




let $9187e81b5d342807$var$initialize = ()=>{
    $9187e81b5d342807$var$script = (parcelRequire("ajIsn"));
    if ($9187e81b5d342807$var$script.__esModule) $9187e81b5d342807$var$script = $9187e81b5d342807$var$script.default;
    $9187e81b5d342807$var$script.render = (parcelRequire("e5sWE")).render;
    $9187e81b5d342807$var$script.__cssModules = {};
    (parcelRequire("4Oyah")).default($9187e81b5d342807$var$script);
    $9187e81b5d342807$var$script.__scopeId = 'data-v-265d11';
    $9187e81b5d342807$var$script.__file = "FightModal.vue";
};
$9187e81b5d342807$var$initialize();
var $9187e81b5d342807$export$2e2bcd8739ae039 = $9187e81b5d342807$var$script;

});
parcelRegister("ajIsn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $782e29ec3bf0ce68$export$2e2bcd8739ae039);

var $9rruk = parcelRequire("9rruk");

var $79bVW = parcelRequire("79bVW");

var $5tAvx = parcelRequire("5tAvx");

var $7cZwo = parcelRequire("7cZwo");

var $eQqwh = parcelRequire("eQqwh");

var $8Q6Uh = parcelRequire("8Q6Uh");

var $cB5a6 = parcelRequire("cB5a6");

var $ftvub = parcelRequire("ftvub");

var $4zJ4j = parcelRequire("4zJ4j");

var $dr7Eb = parcelRequire("dr7Eb");

var $by2uy = parcelRequire("by2uy");

var $8Iy0x = parcelRequire("8Iy0x");

var $c8sRz = parcelRequire("c8sRz");

var $kcejr = parcelRequire("kcejr");

var $4rZCr = parcelRequire("4rZCr");

var $56OCP = parcelRequire("56OCP");

var $hYk3h = parcelRequire("hYk3h");

var $3DHjl = parcelRequire("3DHjl");

var $kmvQC = parcelRequire("kmvQC");

var $3adGw = parcelRequire("3adGw");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $ht4ts = parcelRequire("ht4ts");

// Lazy — three.js (~600KB) only loads when the Fight View actually opens.
const $782e29ec3bf0ce68$var$MapViewer3D = (0, $TusQn.defineAsyncComponent)(()=>(parcelRequire("7z4kn")));
var $782e29ec3bf0ce68$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $8Iy0x.default)
    ],
    props: {
        map: {
            type: String,
            default: ''
        },
        leftTeam: {
            type: Object,
            required: true
        },
        rightTeam: {
            type: Object,
            required: true
        },
        itemschanged: {
            type: Object,
            required: true
        },
        charStats: {
            type: Object,
            required: true
        },
        abilitiesInfo: {
            type: Object,
            default: ()=>({})
        },
        notAbles: {
            type: Object,
            required: true
        },
        toolTips: {
            type: Object,
            required: true
        },
        // Predict-the-Bracket state for this matchup, or null. Lets the player pick the
        // winner from the Fight View. { candidates, picked, simPick, winner, weight, roundLabel }
        predict: {
            type: Object,
            default: null
        }
    },
    emits: [
        'close',
        'pick-winner'
    ],
    components: {
        BattleViewer: $3adGw.default,
        MapViewer3D: $782e29ec3bf0ce68$var$MapViewer3D
    },
    data () {
        return {
            attackerSide: 'left',
            attackerIndex: 0,
            expanded: null,
            targetStatuses: {
                protect: false,
                shell: false,
                charging: false,
                sleeping: false,
                frogChicken: false,
                oil: false
            },
            // Battle-sim (win %) state.
            simResult: null,
            simLog: [],
            simSample: null,
            simFrames: null,
            showSimLog: false,
            simRuns: (0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))).runs || 150,
            simRepro: null,
            reproCopied: false
        };
    },
    computed: {
        // The real map's terrain (height/walls/void + ENTD starts) for this round, from
        // the "NN) Name" map title — prefer a per-name override, else the number key.
        // null ⇒ the sim falls back to a flat grid.
        terrain () {
            const m = (this.map || '').match(/^\s*(\d+)\)\s*(.*)$/);
            const num = m ? +m[1] : null;
            const bare = (m ? m[2] : this.map || '').trim();
            return (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName[bare] || (num != null && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps ? (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).maps[num] : null) || null;
        },
        // The game's own tile table for this map, so the sim walks by FFT's pathfinder (null ⇒ the old BFS).
        tiles () {
            return (0, $56OCP.tilesForMap)(this.map, (0, (/*@__PURE__*/$parcel$interopDefault($4rZCr))));
        },
        // Real .glb mesh for the map view, when this isn't a displaced (byName) map.
        meshUrl () {
            const m = (this.map || '').match(/^\s*(\d+)\)\s*(.*)$/);
            if (!m) return null;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName && (0, (/*@__PURE__*/$parcel$interopDefault($kcejr))).byName[m[2].trim()]) return null; // displaced → schematic only
            return (0, $3DHjl.MESH_URLS)[+m[1]] || null;
        },
        // The map's start tiles tagged with each team's real units (in team colors),
        // for the map view — same placement the bracket-hover popup uses.
        mapStarts () {
            return (0, $kmvQC.startsWithSprites)(this.terrain && this.terrain.starts, this.leftTeam, this.rightTeam);
        },
        // Head-to-head odds: the sim's raw win rate (simCalibrationLive shows it unadjusted since
        // 2026-10-16; champSide only matters if a calibrated display is switched back on).
        simOdds () {
            if (!this.simResult) return null;
            const champSide = this.leftTeam.label === 'Champion' ? 'A' : this.rightTeam.label === 'Champion' ? 'B' : null;
            return (0, $by2uy.calibratedOdds)(this.simResult, {
                champSide: champSide
            });
        },
        attackerTeam () {
            return this.attackerSide === 'left' ? this.leftTeam : this.rightTeam;
        },
        defenderTeam () {
            return this.attackerSide === 'left' ? this.rightTeam : this.leftTeam;
        },
        attackerUnit () {
            return this.attackerTeam.roster[this.attackerIndex];
        },
        attacker () {
            const s = (0, $9rruk.unitCombatStats)(this.attackerUnit, this.charStats, this.itemschanged, this.notAbles);
            return {
                ...s,
                profile: (0, $79bVW.unitElementProfile)(s.equipped)
            };
        },
        gearList () {
            const u = this.attackerUnit;
            return [
                [
                    'Hand',
                    u.Mainhand
                ],
                [
                    'Off',
                    u.Offhand
                ],
                [
                    'Head',
                    u.Head
                ],
                [
                    'Body',
                    u.Armor
                ],
                [
                    'Acc',
                    u.Accessory
                ]
            ].filter(([, name])=>name).map(([slot, name])=>({
                    slot: slot,
                    name: name
                }));
        },
        affinityText () {
            const p = this.attacker.profile;
            const bits = [];
            if (p.strengthen.size) bits.push('Strengthen ' + [
                ...p.strengthen
            ].join('/'));
            if (p.absorb.size) bits.push('Absorb ' + [
                ...p.absorb
            ].join('/'));
            if (p.half.size) bits.push('Half ' + [
                ...p.half
            ].join('/'));
            if (p.weak.size) bits.push('Weak ' + [
                ...p.weak
            ].join('/'));
            return bits.join("  \xb7  ");
        },
        attackerMods () {
            return {
                strengthen: this.attacker.profile.strengthen,
                attackUp: this.attackerUnit.SupportSkill === 'Attack Up',
                magicAttackUp: this.attackerUnit.SupportSkill === 'Magic Attack Up',
                // Martial Arts (support, or Monk innate) → ×3/2 on Punch Art abilities.
                martialArts: this.attackerUnit.SupportSkill === 'Martial Arts' || this.attackerUnit.Class === 'Monk'
            };
        },
        // Resolved defenders with stats, elemental profile, zodiac vs attacker.
        defenders () {
            const a = this.attackerUnit;
            return this.defenderTeam.roster.map((u)=>{
                const s = (0, $9rruk.unitCombatStats)(u, this.charStats, this.itemschanged, this.notAbles);
                const profile = (0, $79bVW.unitElementProfile)(s.equipped);
                const affinityBits = [];
                if (profile.absorb.size) affinityBits.push('Abs ' + [
                    ...profile.absorb
                ].join('/'));
                if (profile.half.size) affinityBits.push("\xbd " + [
                    ...profile.half
                ].join('/'));
                return {
                    unit: u,
                    stats: s.stats,
                    profile: profile,
                    equipped: s.equipped,
                    cEv: s.classBase.cEvPercent,
                    reaction: u.ReactionSkill,
                    zodiac: (0, $5tAvx.zodiacCompat)(a.Gender, a.Sign, u.Gender, u.Sign),
                    affinity: affinityBits.join('  '),
                    mods: {
                        defenseUp: u.SupportSkill === 'Defense Up',
                        magicDefendUp: u.SupportSkill === 'Magic Defense Up',
                        protect: this.targetStatuses.protect,
                        shell: this.targetStatuses.shell,
                        charging: this.targetStatuses.charging,
                        sleeping: this.targetStatuses.sleeping,
                        frogChicken: this.targetStatuses.frogChicken,
                        zodiac: (0, $5tAvx.zodiacCompat)(a.Gender, a.Sign, u.Gender, u.Sign),
                        absorb: profile.absorb,
                        half: profile.half,
                        weak: new Set([
                            ...profile.weak,
                            ...this.targetStatuses.oil ? [
                                'Fire'
                            ] : []
                        ])
                    }
                };
            });
        },
        isMime () {
            return this.attackerUnit.Class === 'Mime';
        },
        // Estimated turn order across both teams (CT/Speed sim). Tie-break order
        // is L1, R1, L2, R2, … so we interleave the rosters.
        turnUnits () {
            const mk = (u, team, side)=>{
                const cs = (0, $9rruk.unitCombatStats)(u, this.charStats, this.itemschanged, this.notAbles);
                // Initial/permanent Haste or Slow from gear adjusts effective Speed
                // (Haste ×3/2, Slow ×1/2). In-battle Haste/Slow cast mid-fight isn't
                // modeled (we can't know it).
                const statuses = [];
                for (const item of Object.values(cs.equipped)){
                    for (const s of item.permstatus || [])statuses.push(s.name);
                    for (const s of item.initstatus || [])statuses.push(s.name);
                }
                const haste = statuses.includes('Haste');
                const slow = !haste && statuses.includes('Slow');
                let speed = cs.stats.speed;
                if (haste) speed = Math.floor(speed * 3 / 2);
                else if (slow) speed = Math.floor(speed / 2);
                return {
                    name: u.Name,
                    teamLabel: team.label,
                    side: side,
                    unit: u,
                    speed: speed,
                    haste: haste,
                    slow: slow
                };
            };
            const out = [];
            const L = this.leftTeam.roster, R = this.rightTeam.roster;
            for(let i = 0; i < Math.max(L.length, R.length); i++){
                if (L[i]) out.push(mk(L[i], this.leftTeam, 'left'));
                if (R[i]) out.push(mk(R[i], this.rightTeam, 'right'));
            }
            return out;
        },
        turnOrderList () {
            return (0, $cB5a6.turnOrder)(this.turnUnits, 12);
        },
        // Rows: basic Attack(s), Jump (if able), then damaging + status abilities.
        // A Mime mimics teammates, so its ability rows are sourced from the team.
        abilityRows () {
            const rows = [];
            const u = this.attackerUnit;
            const eq = this.attacker.equipped;
            const dual = u.SupportSkill === 'Dual Wield';
            // Basic attack(s). Dual Wield -> one row per weapon; otherwise mainhand
            // (Doublehand's ×2 is baked into weaponAttackModel), else unarmed.
            const wMain = eq.Mainhand && eq.Mainhand.wp ? (0, $eQqwh.weaponAttackModel)(eq.Mainhand, u) : null;
            const wOff = dual && eq.Offhand && eq.Offhand.wp ? (0, $eQqwh.weaponAttackModel)(eq.Offhand, u) : null;
            if (wMain) rows.push({
                label: `Attack: ${u.Mainhand}`,
                model: wMain,
                element: wMain.element,
                evadable: eq.Mainhand.type !== 'Gun'
            });
            if (wOff) rows.push({
                label: `Attack: ${u.Offhand}`,
                model: wOff,
                element: wOff.element,
                evadable: eq.Offhand.type !== 'Gun'
            });
            if (!wMain && !wOff) rows.push({
                label: 'Attack: Unarmed',
                model: (0, $eQqwh.unarmedAttackModel)(u),
                element: null,
                evadable: true
            });
            // Jump — present when the unit has a Jump-range skill.
            const skills = [
                ...u.ClassSkills || [],
                ...u.ExtraSkills || []
            ];
            if (skills.some((s)=>/^(Level|Vertical) Jump/.test(s || ''))) rows.push({
                label: 'Jump',
                model: (0, $eQqwh.jumpAttackModel)(eq.Mainhand, u),
                element: null,
                attackerMods: {},
                evadable: false
            });
            // Damaging + status abilities.
            const sourceUnits = this.isMime ? this.attackerTeam.roster : [
                u
            ];
            // Ctx for the slim legacy fallback (break skills / monster skills / Elixir).
            const legacyCtx = {
                pa: this.attacker.stats.pa,
                ma: this.attacker.stats.ma,
                brave: u.Brave,
                faith: u.Faith,
                wp: eq.Mainhand.wp,
                weaponType: eq.Mainhand.type,
                paUnarmed: this.attacker.paUnarmed
            };
            const seen = new Set();
            for (const su of sourceUnits){
                const names = [
                    ...su.ClassSkills || [],
                    ...su.ExtraSkills || [],
                    ...this.toolTips.MonsterSkills && this.toolTips.MonsterSkills[su.Class] || []
                ].map((n)=>(n || '').replace('*', ''));
                for (const name of names){
                    if (seen.has(name)) continue;
                    seen.add(name);
                    const model = (0, $7cZwo.parseAbilityInfo)(this.abilitiesInfo[name]);
                    if (!model) {
                        // Parser miss → legacy fallback so these stop vanishing from the
                        // matrix. Jump is already its own row above; songs/breaks are
                        // percents we don't show here, so only flat-damage forms are added.
                        if (/^(Level|Vertical) Jump/.test(name)) continue;
                        const legacy = (0, $7cZwo.legacyAbilityFormula)(name, legacyCtx);
                        if (legacy && legacy.kind === 'damage') rows.push({
                            label: name,
                            flat: legacy.value,
                            element: null,
                            evadable: true
                        });
                        continue;
                    }
                    if (model.kind === 'number' && model.verb === 'Damage') rows.push({
                        label: name,
                        model: model,
                        element: model.element,
                        evadable: true
                    });
                    else if (model.kind === 'percent') rows.push({
                        label: name,
                        model: model,
                        element: model.element,
                        status: true
                    });
                }
            }
            return rows;
        },
        // The grid: one row per ability/attack, one cell per defender.
        grid () {
            const ctxBase = {
                ma: this.attacker.stats.ma,
                pa: this.attacker.stats.pa,
                speed: this.attacker.stats.speed,
                brave: this.attackerUnit.Brave,
                faith: this.attackerUnit.Faith,
                wp: this.attacker.equipped.Mainhand.wp,
                maxHp: this.attacker.stats.hp,
                paUnarmed: this.attacker.paUnarmed
            };
            return this.abilityRows.map((row)=>{
                const isPercent = row.model && row.model.kind === 'percent';
                const aMods = row.attackerMods !== undefined ? row.attackerMods : this.attackerMods;
                return {
                    ability: row.label,
                    element: row.element,
                    status: !!row.status,
                    cells: this.defenders.map((d)=>{
                        // Legacy flat-damage ability: show the estimate + hit chance; no
                        // modifier pipeline (empty steps -> "base damage" in the drill-down).
                        if (row.flat != null) {
                            const hc = (dir)=>Math.round((0, $8Q6Uh.hitChance)(d, {
                                    type: 'physical',
                                    direction: dir
                                }));
                            const hitDirs = {
                                front: hc('front'),
                                side: hc('side'),
                                back: hc('back'),
                                magical: false
                            };
                            return {
                                kind: 'damage',
                                display: `${row.flat}`,
                                steps: [],
                                effect: null,
                                hit: hitDirs.front,
                                hitDirs: hitDirs
                            };
                        }
                        // targetMa + targetEquipped feed Unyielding Cut's two-branch conditional:
                        // the bare-target branch is PA*(WP+TargetMA), taken when the defender has no
                        // non-shield gear (monsters carry none). Ignored by every other ability model.
                        const ctx = {
                            ...ctxBase,
                            targetFaith: d.unit.Faith,
                            targetMa: d.stats.ma,
                            targetEquipped: !!(d.unit.Mainhand || d.unit.Head || d.unit.Armor || d.unit.Accessory || d.unit.Offhand && d.equipped.Offhand.type !== 'Shield')
                        };
                        if (isPercent) {
                            const { final: final, steps: steps } = (0, $7cZwo.computeSuccess)(row.model, ctx, {
                                ...aMods,
                                ...d.mods
                            });
                            return {
                                kind: 'percent',
                                display: `${final}%`,
                                steps: steps,
                                effect: null
                            };
                        }
                        const { final: final, steps: steps } = (0, $7cZwo.computeAbilityDamage)(row.model, ctx, {
                            ...aMods,
                            ...d.mods
                        });
                        let effect = null;
                        if (row.element) {
                            if (d.profile.absorb.has(row.element)) effect = 'absorb';
                            else if (d.mods.weak.has(row.element)) effect = 'weak';
                            else if (d.profile.half.has(row.element)) effect = 'half';
                        }
                        const display = Array.isArray(final) ? `${final[0]} - ${final[1]}` : `${final}`;
                        // Hit chance (front shown in the cell; all directions in the drill-down).
                        let hit = null, hitDirs = null;
                        if (row.evadable) {
                            const type = row.model.magical ? 'magical' : 'physical';
                            const hc = (dir)=>Math.round((0, $8Q6Uh.hitChance)(d, {
                                    type: type,
                                    direction: dir
                                }));
                            hitDirs = {
                                front: hc('front'),
                                side: hc('side'),
                                back: hc('back'),
                                magical: type === 'magical'
                            };
                            hit = hitDirs.front;
                        }
                        return {
                            kind: 'damage',
                            display: display,
                            steps: steps,
                            effect: effect,
                            hit: hit,
                            hitDirs: hitDirs
                        };
                    })
                };
            });
        },
        openCell () {
            if (!this.expanded) return null;
            return this.grid[this.expanded.r] && this.grid[this.expanded.r].cells[this.expanded.c];
        }
    },
    methods: {
        // Battle sim: prep both rosters → combatant specs, run N battles → win%.
        simulate () {
            const data = {
                charStats: this.charStats,
                itemschanged: this.itemschanged,
                notAbles: this.notAbles,
                abilitiesInfo: this.abilitiesInfo,
                monsterSkills: (/*@__PURE__*/$parcel$interopDefault($hYk3h))
            };
            const A = (0, $4zJ4j.prepTeam)(this.leftTeam.roster, data);
            const B = (0, $4zJ4j.prepTeam)(this.rightTeam.roster, data);
            const terrain = this.terrain, tiles = this.tiles; // real map geometry/height (null ⇒ flat grid)
            this.simResult = (0, $dr7Eb.runBattles)(A, B, {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                terrain: terrain,
                tiles: tiles
            });
            // The log is ONE representative battle, separate from the N-run average
            // above — capture its outcome so we can label it (else the log can show
            // the underdog winning beneath an "82%" bar). It runs on a recorded SEED so
            // the watched fight is reproducible: serializeRepro bundles seed+teams+map
            // into a capsule (📋 copy repro) you paste into replayRepro() to debug it.
            const seed = Math.floor(Math.random() * 0x7fffffff);
            const sample = (0, $dr7Eb.simulateBattle)(A, B, {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                frames: true,
                terrain: terrain,
                tiles: tiles,
                seed: seed
            });
            this.simLog = sample.log || [];
            this.simFrames = sample.frames || [];
            this.simSample = {
                winner: sample.winner,
                turns: sample.turns
            };
            this.simRepro = (0, $dr7Eb.serializeRepro)(A, B, {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($c8sRz))),
                terrain: terrain,
                tiles: tiles
            }, seed);
            this.reproCopied = false;
        },
        // Copy the sampled fight's reproducible capsule to the clipboard.
        copyRepro () {
            if (!this.simRepro || !navigator.clipboard) return;
            navigator.clipboard.writeText(this.simRepro).then(()=>{
                this.reproCopied = true;
                setTimeout(()=>{
                    this.reproCopied = false;
                }, 1500);
            }).catch(()=>{});
        },
        // Header for the sampled log battle (which side won that single run).
        sampleLabel () {
            const s = this.simSample;
            if (!s) return '';
            const who = s.winner === 'A' ? `${this.leftTeam.label} won` : s.winner === 'B' ? `${this.rightTeam.label} won` : 'draw';
            return `Sample battle \u{2014} ${who} in ${s.turns} turns \xb7 one run, not the ${this.simRuns}-run average above`;
        },
        // 95% confidence margin on the win% (± points) — Wald interval from N runs.
        winMargin () {
            if (!this.simResult) return 0;
            const { aWinPct: p, n: n } = this.simResult;
            return Math.max(1, Math.round(196 * Math.sqrt(p * (1 - p) / n)));
        },
        // Per-unit survival %, split by side, most-durable first ("who carries").
        survivalRows () {
            const us = this.simResult && this.simResult.unitStats || [];
            const sorted = [
                ...us
            ].sort((x, y)=>y.survivalPct - x.survivalPct);
            return {
                A: sorted.filter((u)=>u.team === 'A'),
                B: sorted.filter((u)=>u.team === 'B')
            };
        },
        teamColor (label) {
            return (0, $ftvub.teamBright)(label);
        },
        // Display label for a lowercase team name (one of this matchup's two teams).
        teamLabelFor (name) {
            if (name === this.leftTeam.name) return this.leftTeam.label;
            if (name === this.rightTeam.name) return this.rightTeam.label;
            return name;
        },
        teamBoxStyle (label) {
            const c = this.teamColor(label);
            return {
                border: `2px solid ${c}`,
                background: `${c}22`
            };
        },
        portrait (unit, label) {
            if (unit.Gender === 'Monster') return (0, $ht4ts.UNITS_BASE) + unit.Class + '.gif';
            const g = (unit.Gender || 'Male')[0];
            if (label === 'Champion') return (0, $ht4ts.UNITS_BASE) + unit.Class + g + '.gif';
            return (0, $ht4ts.UNITS_BASE) + unit.Class + g + '_' + label + '.gif';
        },
        pick (side, i) {
            this.attackerSide = side;
            this.attackerIndex = i;
            this.expanded = null;
        },
        isOpen (r, c) {
            return this.expanded && this.expanded.r === r && this.expanded.c === c;
        },
        toggle (r, c) {
            this.expanded = this.isOpen(r, c) ? null : {
                r: r,
                c: c
            };
        }
    }
};

});
parcelRegister("cB5a6", function(module, exports) {

$parcel$export(module.exports, "turnOrder", () => $92bcf1c840a11df0$export$532c1c0c6deff3ff);
// Predict the first N active turns from Charge Time (CT) and Speed.
//
// Each clocktick every unit gains CT equal to its Speed; a unit acts when
// CT >= 100. Higher CT acts first; ties break by unit order (the caller
// passes units already in that order: L1, R1, L2, R2, …). After acting we
// assume "move + act" (CT − 100, then capped to 60 if it would exceed 60) —
// the normal case, and what governs the following turns.
//
// This is a deterministic BASELINE: it assumes everyone starts at CT 0
// (real FFT randomizes initial CT) and ignores Haste/Slow. So it's an
// estimate of order, most accurate near the start.
//
// units: [{ speed, ... }] in tie-break order. Returns the acting units (the
// same objects, so they carry display fields) in turn order; fast units
// repeat.
function $92bcf1c840a11df0$export$532c1c0c6deff3ff(units, count = 12) {
    const state = units.map((src, i)=>({
            src: src,
            order: i,
            ct: 0
        }));
    const out = [];
    let guard = 0;
    while(out.length < count && guard < 100000){
        guard++;
        for (const u of state)u.ct += u.src.speed || 0;
        // Resolve everyone who reached 100 this tick (highest CT first, then order).
        while(out.length < count){
            const ready = state.filter((u)=>u.ct >= 100).sort((a, b)=>b.ct - a.ct || a.order - b.order);
            if (!ready.length) break;
            const u = ready[0];
            out.push(u.src);
            let nc = u.ct - 100;
            if (nc > 60) nc = 60;
            u.ct = nc;
        }
    }
    return out;
}

});

parcelRegister("3adGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $24dcebce9dc2d2fe$export$2e2bcd8739ae039);
let $24dcebce9dc2d2fe$var$script;




let $24dcebce9dc2d2fe$var$initialize = ()=>{
    $24dcebce9dc2d2fe$var$script = (parcelRequire("72W6G"));
    if ($24dcebce9dc2d2fe$var$script.__esModule) $24dcebce9dc2d2fe$var$script = $24dcebce9dc2d2fe$var$script.default;
    $24dcebce9dc2d2fe$var$script.render = (parcelRequire("fkc11")).render;
    $24dcebce9dc2d2fe$var$script.__cssModules = {};
    (parcelRequire("7I3si")).default($24dcebce9dc2d2fe$var$script);
    $24dcebce9dc2d2fe$var$script.__scopeId = 'data-v-ed259a';
    $24dcebce9dc2d2fe$var$script.__file = "BattleViewer.vue";
};
$24dcebce9dc2d2fe$var$initialize();
var $24dcebce9dc2d2fe$export$2e2bcd8739ae039 = $24dcebce9dc2d2fe$var$script;

});
parcelRegister("72W6G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5215cb1683aa485c$export$2e2bcd8739ae039);

var $ftvub = parcelRequire("ftvub");

var $ht4ts = parcelRequire("ht4ts");
var $5215cb1683aa485c$export$2e2bcd8739ae039 = {
    name: 'BattleViewer',
    props: {
        frames: {
            type: Array,
            default: ()=>[]
        },
        terrain: {
            type: Object,
            default: null
        },
        teamA: {
            type: String,
            default: ''
        },
        teamB: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            idx: 0,
            playing: false,
            speed: 700,
            timer: null
        };
    },
    computed: {
        // Grid dimensions: the real map's W×H, else a square that fits every unit.
        cols () {
            return this.terrain ? this.terrain.w : this.squareSize;
        },
        rows () {
            return this.terrain ? this.terrain.h : this.squareSize;
        },
        squareSize () {
            let m = 10;
            for (const f of this.frames)for (const u of f.board)m = Math.max(m, u.x + 1, u.y + 1);
            return m;
        },
        gridStyle () {
            return {
                gridTemplateColumns: 'repeat(' + this.cols + ', 1fr)',
                aspectRatio: this.cols + ' / ' + this.rows
            };
        },
        // Min/max walkable height — for normalizing the elevation shading.
        heightRange () {
            if (!this.terrain) return null;
            let lo = Infinity, hi = -Infinity;
            for (const row of this.terrain.heights)for (const h of row)if (h != null) {
                if (h < lo) lo = h;
                if (h > hi) hi = h;
            }
            return hi >= lo ? {
                lo: lo,
                hi: hi
            } : {
                lo: 0,
                hi: 0
            };
        },
        frame () {
            return this.frames[this.idx] || null;
        },
        prevBoard () {
            return this.idx > 0 ? this.frames[this.idx - 1].board : null;
        },
        cells () {
            const cols = this.cols, rows = this.rows, t = this.terrain, hr = this.heightRange;
            const at = {};
            for (const u of this.frame ? this.frame.board : []){
                const k = u.y * cols + u.x;
                if (!at[k] || !at[k].alive && u.alive) at[k] = u; // a living unit is never hidden by a corpse
            }
            const crys = new Set(this.frame && this.frame.crystals || []);
            const out = [];
            for(let y = 0; y < rows; y++)for(let x = 0; x < cols; x++){
                const k = y * cols + x;
                let voidT = false, wall = false, h = null, bg = null;
                if (t) {
                    h = t.heights[y] && t.heights[y][x] != null ? t.heights[y][x] : null;
                    wall = !!(t.surfaces && t.surfaces[y] && t.surfaces[y][x] === 'x');
                    voidT = h == null;
                    if (!voidT) {
                        const f = hr.hi > hr.lo ? (h - hr.lo) / (hr.hi - hr.lo) : 0;
                        bg = `hsl(205, 28%, ${Math.round(13 + 30 * f)}%)`;
                    } // higher = lighter
                }
                out.push({
                    k: k,
                    x: x,
                    y: y,
                    dark: (x + y) % 2 === 1,
                    u: at[k] || null,
                    crystal: crys.has(x + ',' + y),
                    void: voidT,
                    wall: wall,
                    h: h,
                    bg: bg
                });
            }
            return out;
        },
        actorColor () {
            const u = (this.frame.board || []).find((b)=>b.name === this.frame.actor);
            return u ? this.colorFor(u.team) : '#fff';
        }
    },
    watch: {
        frames () {
            this.pause();
            this.idx = 0;
        }
    },
    beforeUnmount () {
        this.pause();
    },
    methods: {
        colorFor (team) {
            return (0, $ftvub.teamBright)(team === 'A' ? this.teamA : this.teamB) || '#888';
        },
        spriteUrl (u) {
            const label = u.team === 'A' ? this.teamA : this.teamB;
            const g = u.gender && u.gender[0] || 'M';
            if (u.gender === 'Monster') return (0, $ht4ts.UNITS_BASE) + u.cls + '.gif';
            if (label === 'Champion') return (0, $ht4ts.UNITS_BASE) + u.cls + g + '.gif';
            return (0, $ht4ts.UNITS_BASE) + u.cls + g + '_' + label + '.gif';
        },
        hpPct (u) {
            return u.maxHp ? Math.max(0, Math.min(100, Math.round(u.hp / u.maxHp * 100))) : 0;
        },
        hpDelta (u) {
            if (!this.prevBoard) return 0;
            const p = this.prevBoard.find((b)=>b.name === u.name && b.team === u.team);
            return p ? u.hp - p.hp : 0;
        },
        faceDir (u) {
            const d = u.dir || {};
            if (d.y > 0) return 's';
            if (d.y < 0) return 'n';
            if (d.x > 0) return 'e';
            return 'w';
        },
        statusTags (s) {
            const TAG = {
                'Death Sentence': "\u2620",
                Haste: "\u23E9",
                Slow: "\u23EA",
                Protect: 'Pr',
                Shell: 'Sh',
                Regen: '+',
                Poison: 'Po',
                Sleep: 'Zz',
                Stop: 'St',
                Charm: "\u2665",
                Petrify: 'Pf',
                "Don't Act": 'DA',
                Reraise: 'RR',
                Berserk: 'Br'
            };
            const BAD = new Set([
                'Death Sentence',
                'Slow',
                'Poison',
                'Sleep',
                'Stop',
                'Charm',
                'Petrify',
                "Don't Act",
                'Frog'
            ]);
            return Object.entries(s || {}).sort((a, b)=>(b[0] === 'Death Sentence' ? 1 : 0) - (a[0] === 'Death Sentence' ? 1 : 0)).map(([k, v])=>({
                    label: (TAG[k] || k.slice(0, 2)) + (k === 'Death Sentence' ? v : ''),
                    bad: BAD.has(k)
                }));
        },
        tokenClass (u) {
            const d = this.hpDelta(u);
            return {
                actor: this.frame.actor && u.name === this.frame.actor,
                dead: !u.alive,
                hit: d < 0,
                healed: d > 0
            };
        },
        step (n) {
            this.pause();
            this.idx = Math.min(this.frames.length - 1, Math.max(0, this.idx + n));
        },
        togglePlay () {
            this.playing ? this.pause() : this.play();
        },
        play () {
            if (this.idx >= this.frames.length - 1) this.idx = 0;
            this.playing = true;
            this.tick();
        },
        tick () {
            clearTimeout(this.timer);
            if (!this.playing) return;
            this.timer = setTimeout(()=>{
                if (this.idx < this.frames.length - 1) {
                    this.idx++;
                    this.tick();
                } else this.playing = false;
            }, this.speed);
        },
        pause () {
            this.playing = false;
            clearTimeout(this.timer);
        }
    }
};

});

parcelRegister("fkc11", function(module, exports) {

$parcel$export(module.exports, "render", () => $b2820b508d53bd69$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $b2820b508d53bd69$var$_hoisted_1 = {
    key: 0,
    class: "battle-viewer"
};
const $b2820b508d53bd69$var$_hoisted_2 = {
    class: "bv-bar"
};
const $b2820b508d53bd69$var$_hoisted_3 = [
    "disabled"
];
const $b2820b508d53bd69$var$_hoisted_4 = [
    "title"
];
const $b2820b508d53bd69$var$_hoisted_5 = [
    "disabled"
];
const $b2820b508d53bd69$var$_hoisted_6 = [
    "max"
];
const $b2820b508d53bd69$var$_hoisted_7 = {
    class: "bv-count"
};
const $b2820b508d53bd69$var$_hoisted_8 = {
    key: 0,
    class: "bv-h"
};
const $b2820b508d53bd69$var$_hoisted_9 = {
    key: 1,
    class: "bv-crystal",
    title: "Crystal \u2014 a unit that steps here gets full HP/MP"
};
const $b2820b508d53bd69$var$_hoisted_10 = [
    "src",
    "alt",
    "title"
];
const $b2820b508d53bd69$var$_hoisted_11 = {
    key: 0,
    class: "bv-dead",
    title: "dead \u2014 crystallizing"
};
const $b2820b508d53bd69$var$_hoisted_12 = {
    class: "bv-hp"
};
const $b2820b508d53bd69$var$_hoisted_13 = {
    key: 2,
    class: "bv-status"
};
const $b2820b508d53bd69$var$_hoisted_14 = {
    class: "bv-caption"
};
function $b2820b508d53bd69$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $options.frame ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b2820b508d53bd69$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $b2820b508d53bd69$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("button", {
                class: "bv-btn",
                onClick: _cache[0] || (_cache[0] = ($event)=>$options.step(-1)),
                disabled: $data.idx === 0,
                title: "Previous"
            }, "\u25C0", 8, $b2820b508d53bd69$var$_hoisted_3),
            (0, $TusQn.createElementVNode)("button", {
                class: "bv-btn",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.togglePlay && $options.togglePlay(...args)),
                title: $data.playing ? 'Pause' : 'Play'
            }, (0, $8POXm.toDisplayString)($data.playing ? "\u23F8" : "\u25B6"), 9, $b2820b508d53bd69$var$_hoisted_4),
            (0, $TusQn.createElementVNode)("button", {
                class: "bv-btn",
                onClick: _cache[2] || (_cache[2] = ($event)=>$options.step(1)),
                disabled: $data.idx >= $props.frames.length - 1,
                title: "Next"
            }, "\u25B6", 8, $b2820b508d53bd69$var$_hoisted_5),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                class: "bv-scrub",
                type: "range",
                min: "0",
                max: $props.frames.length - 1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.idx = $event),
                onInput: _cache[4] || (_cache[4] = (...args)=>$options.pause && $options.pause(...args))
            }, null, 40, $b2820b508d53bd69$var$_hoisted_6), [
                [
                    (0, $eeJ70.vModelText),
                    $data.idx,
                    void 0,
                    {
                        number: true
                    }
                ]
            ]),
            (0, $TusQn.createElementVNode)("span", $b2820b508d53bd69$var$_hoisted_7, "turn " + (0, $8POXm.toDisplayString)($options.frame.turn) + " \xb7 " + (0, $8POXm.toDisplayString)($data.idx + 1) + "/" + (0, $8POXm.toDisplayString)($props.frames.length), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.speed = $event),
                class: "bv-speed",
                title: "Speed"
            }, [
                ..._cache[6] || (_cache[6] = [
                    (0, $TusQn.createElementVNode)("option", {
                        value: 1200
                    }, "0.5\xd7", -1),
                    (0, $TusQn.createElementVNode)("option", {
                        value: 700
                    }, "1\xd7", -1),
                    (0, $TusQn.createElementVNode)("option", {
                        value: 350
                    }, "2\xd7", -1)
                ])
            ], 512), [
                [
                    (0, $eeJ70.vModelSelect),
                    $data.speed,
                    void 0,
                    {
                        number: true
                    }
                ]
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)([
                "bv-grid",
                {
                    'has-terrain': !!$props.terrain
                }
            ]),
            style: (0, $8POXm.normalizeStyle)($options.gridStyle)
        }, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.cells, (cell)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: cell.k,
                    class: (0, $8POXm.normalizeClass)([
                        "bv-cell",
                        {
                            dark: !$props.terrain && cell.dark,
                            'bv-void': cell.void,
                            'bv-wall': cell.wall
                        }
                    ]),
                    style: (0, $8POXm.normalizeStyle)(cell.bg ? {
                        background: cell.bg
                    } : null)
                }, [
                    $props.terrain && cell.h != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b2820b508d53bd69$var$_hoisted_8, (0, $8POXm.toDisplayString)(Math.round(cell.h)), 1)) : (0, $TusQn.createCommentVNode)("", true),
                    cell.crystal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b2820b508d53bd69$var$_hoisted_9, "\u25C6")) : (0, $TusQn.createCommentVNode)("", true),
                    cell.u ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: 2,
                        class: (0, $8POXm.normalizeClass)([
                            "bv-token",
                            $options.tokenClass(cell.u)
                        ]),
                        style: (0, $8POXm.normalizeStyle)({
                            '--tc': $options.colorFor(cell.u.team)
                        })
                    }, [
                        (0, $TusQn.createElementVNode)("img", {
                            class: "bv-img",
                            src: $options.spriteUrl(cell.u),
                            alt: cell.u.cls,
                            title: cell.u.name + " \u2014 " + cell.u.cls
                        }, null, 8, $b2820b508d53bd69$var$_hoisted_10),
                        (0, $TusQn.createElementVNode)("span", {
                            class: (0, $8POXm.normalizeClass)([
                                "bv-face",
                                'f-' + $options.faceDir(cell.u)
                            ])
                        }, null, 2),
                        cell.u.dead != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b2820b508d53bd69$var$_hoisted_11, (0, $8POXm.toDisplayString)(cell.u.dead), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.hpDelta(cell.u) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            key: 1,
                            class: (0, $8POXm.normalizeClass)([
                                "bv-delta",
                                $options.hpDelta(cell.u) < 0 ? 'dmg' : 'heal'
                            ])
                        }, (0, $8POXm.toDisplayString)($options.hpDelta(cell.u) > 0 ? '+' : '') + (0, $8POXm.toDisplayString)($options.hpDelta(cell.u)), 3)) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("div", $b2820b508d53bd69$var$_hoisted_12, [
                            (0, $TusQn.createElementVNode)("div", {
                                class: (0, $8POXm.normalizeClass)([
                                    "bv-hp-fill",
                                    {
                                        low: $options.hpPct(cell.u) < 34
                                    }
                                ]),
                                style: (0, $8POXm.normalizeStyle)({
                                    width: $options.hpPct(cell.u) + '%'
                                })
                            }, null, 6)
                        ]),
                        $options.statusTags(cell.u.status).length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $b2820b508d53bd69$var$_hoisted_13, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.statusTags(cell.u.status), (s, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: i,
                                    class: (0, $8POXm.normalizeClass)([
                                        "bv-st",
                                        {
                                            bad: s.bad
                                        }
                                    ])
                                }, (0, $8POXm.toDisplayString)(s.label), 3);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ], 6)) : (0, $TusQn.createCommentVNode)("", true)
                ], 6);
            }), 128))
        ], 6),
        (0, $TusQn.createElementVNode)("div", $b2820b508d53bd69$var$_hoisted_14, (0, $8POXm.toDisplayString)($options.frame.caption || "\u2026"), 1)
    ])) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("7I3si", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cf52a4381df215$export$2e2bcd8739ae039);
let $59cf52a4381df215$var$NOOP = ()=>{};
var $59cf52a4381df215$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("e5sWE", function(module, exports) {

$parcel$export(module.exports, "render", () => $a417fc2ea1ff4604$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a417fc2ea1ff4604$var$_hoisted_1 = {
    class: "fight-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Fight view"
};
const $a417fc2ea1ff4604$var$_hoisted_2 = {
    class: "roster-select"
};
const $a417fc2ea1ff4604$var$_hoisted_3 = {
    class: "roster-units"
};
const $a417fc2ea1ff4604$var$_hoisted_4 = [
    "onClick"
];
const $a417fc2ea1ff4604$var$_hoisted_5 = [
    "src",
    "alt"
];
const $a417fc2ea1ff4604$var$_hoisted_6 = {
    class: "ru-name"
};
const $a417fc2ea1ff4604$var$_hoisted_7 = {
    class: "roster-units"
};
const $a417fc2ea1ff4604$var$_hoisted_8 = [
    "onClick"
];
const $a417fc2ea1ff4604$var$_hoisted_9 = [
    "src",
    "alt"
];
const $a417fc2ea1ff4604$var$_hoisted_10 = {
    class: "ru-name"
};
const $a417fc2ea1ff4604$var$_hoisted_11 = {
    key: 0,
    class: "fight-map"
};
const $a417fc2ea1ff4604$var$_hoisted_12 = {
    class: "fight-map-label"
};
const $a417fc2ea1ff4604$var$_hoisted_13 = {
    key: 0
};
const $a417fc2ea1ff4604$var$_hoisted_14 = {
    key: 0
};
const $a417fc2ea1ff4604$var$_hoisted_15 = {
    class: "fmp-meta"
};
const $a417fc2ea1ff4604$var$_hoisted_16 = {
    key: 0,
    class: "fmp-sim"
};
const $a417fc2ea1ff4604$var$_hoisted_17 = {
    class: "sim-bar"
};
const $a417fc2ea1ff4604$var$_hoisted_18 = {
    class: "sim-ci",
    title: "95% confidence margin from the number of runs"
};
const $a417fc2ea1ff4604$var$_hoisted_19 = {
    key: 0,
    class: "sim-draw"
};
const $a417fc2ea1ff4604$var$_hoisted_20 = {
    key: 2,
    class: "sim-survival"
};
const $a417fc2ea1ff4604$var$_hoisted_21 = {
    class: "ss-col"
};
const $a417fc2ea1ff4604$var$_hoisted_22 = {
    class: "ss-name"
};
const $a417fc2ea1ff4604$var$_hoisted_23 = {
    class: "ss-pct"
};
const $a417fc2ea1ff4604$var$_hoisted_24 = {
    class: "ss-col"
};
const $a417fc2ea1ff4604$var$_hoisted_25 = {
    class: "ss-name"
};
const $a417fc2ea1ff4604$var$_hoisted_26 = {
    class: "ss-pct"
};
const $a417fc2ea1ff4604$var$_hoisted_27 = {
    key: 3,
    class: "sim-replay"
};
const $a417fc2ea1ff4604$var$_hoisted_28 = {
    class: "sim-map-row"
};
const $a417fc2ea1ff4604$var$_hoisted_29 = {
    key: 0,
    class: "sim-map"
};
const $a417fc2ea1ff4604$var$_hoisted_30 = {
    key: 0,
    class: "sim-map-flat"
};
const $a417fc2ea1ff4604$var$_hoisted_31 = {
    key: 4,
    class: "sim-log"
};
const $a417fc2ea1ff4604$var$_hoisted_32 = {
    class: "sim-log-head"
};
const $a417fc2ea1ff4604$var$_hoisted_33 = {
    class: "turn-order"
};
const $a417fc2ea1ff4604$var$_hoisted_34 = {
    class: "to-strip"
};
const $a417fc2ea1ff4604$var$_hoisted_35 = {
    class: "to-num"
};
const $a417fc2ea1ff4604$var$_hoisted_36 = [
    "src",
    "alt"
];
const $a417fc2ea1ff4604$var$_hoisted_37 = {
    class: "to-name"
};
const $a417fc2ea1ff4604$var$_hoisted_38 = {
    key: 0,
    class: "to-status haste",
    title: "Haste (\xd73/2 Speed)"
};
const $a417fc2ea1ff4604$var$_hoisted_39 = {
    key: 1,
    class: "to-status slow",
    title: "Slow (\xd71/2 Speed)"
};
const $a417fc2ea1ff4604$var$_hoisted_40 = {
    class: "fight-body"
};
const $a417fc2ea1ff4604$var$_hoisted_41 = {
    class: "attacker-panel"
};
const $a417fc2ea1ff4604$var$_hoisted_42 = {
    class: "ap-identity"
};
const $a417fc2ea1ff4604$var$_hoisted_43 = [
    "src",
    "alt"
];
const $a417fc2ea1ff4604$var$_hoisted_44 = {
    class: "ap-name"
};
const $a417fc2ea1ff4604$var$_hoisted_45 = {
    class: "ap-class"
};
const $a417fc2ea1ff4604$var$_hoisted_46 = {
    class: "ap-bf"
};
const $a417fc2ea1ff4604$var$_hoisted_47 = {
    class: "ap-block ap-stats"
};
const $a417fc2ea1ff4604$var$_hoisted_48 = {
    class: "ap-block ap-skills"
};
const $a417fc2ea1ff4604$var$_hoisted_49 = {
    key: 0
};
const $a417fc2ea1ff4604$var$_hoisted_50 = {
    key: 1
};
const $a417fc2ea1ff4604$var$_hoisted_51 = {
    key: 2
};
const $a417fc2ea1ff4604$var$_hoisted_52 = {
    key: 3
};
const $a417fc2ea1ff4604$var$_hoisted_53 = {
    class: "ap-block ap-gear"
};
const $a417fc2ea1ff4604$var$_hoisted_54 = {
    key: 0,
    class: "ap-block ap-affinity"
};
const $a417fc2ea1ff4604$var$_hoisted_55 = {
    class: "matrix-wrap"
};
const $a417fc2ea1ff4604$var$_hoisted_56 = {
    key: 0,
    class: "mime-note"
};
const $a417fc2ea1ff4604$var$_hoisted_57 = {
    key: 1,
    class: "no-abilities"
};
const $a417fc2ea1ff4604$var$_hoisted_58 = {
    key: 2,
    class: "fight-matrix"
};
const $a417fc2ea1ff4604$var$_hoisted_59 = {
    class: "def-name"
};
const $a417fc2ea1ff4604$var$_hoisted_60 = {
    class: "def-class"
};
const $a417fc2ea1ff4604$var$_hoisted_61 = {
    key: 0,
    class: "def-affinity"
};
const $a417fc2ea1ff4604$var$_hoisted_62 = {
    class: "ability-col"
};
const $a417fc2ea1ff4604$var$_hoisted_63 = {
    key: 0,
    class: "el-tag"
};
const $a417fc2ea1ff4604$var$_hoisted_64 = {
    key: 1,
    class: "el-tag status-tag"
};
const $a417fc2ea1ff4604$var$_hoisted_65 = [
    "onClick"
];
const $a417fc2ea1ff4604$var$_hoisted_66 = {
    class: "cell-dmg"
};
const $a417fc2ea1ff4604$var$_hoisted_67 = {
    key: 0,
    class: "cell-hit"
};
const $a417fc2ea1ff4604$var$_hoisted_68 = {
    key: 3,
    class: "drilldown"
};
const $a417fc2ea1ff4604$var$_hoisted_69 = {
    class: "drill-head"
};
const $a417fc2ea1ff4604$var$_hoisted_70 = {
    class: "drill-steps"
};
const $a417fc2ea1ff4604$var$_hoisted_71 = {
    class: "step-label"
};
const $a417fc2ea1ff4604$var$_hoisted_72 = {
    key: 0,
    class: "step-factor"
};
const $a417fc2ea1ff4604$var$_hoisted_73 = {
    class: "step-value"
};
const $a417fc2ea1ff4604$var$_hoisted_74 = {
    key: 0,
    class: "drill-step"
};
const $a417fc2ea1ff4604$var$_hoisted_75 = {
    key: 0,
    class: "drill-hit"
};
const $a417fc2ea1ff4604$var$_hoisted_76 = {
    class: "status-row"
};
function $a417fc2ea1ff4604$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MapViewer3D = (0, $TusQn.resolveComponent)("MapViewer3D");
    const _component_BattleViewer = (0, $TusQn.resolveComponent)("BattleViewer");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay top fight-backdrop",
        onClick: _cache[16] || (_cache[16] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "close-btn",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\xd7"),
            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", {
                    class: "roster-side left-side",
                    style: (0, $8POXm.normalizeStyle)($options.teamBoxStyle($props.leftTeam.label))
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: "roster-wm",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.leftTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.leftTeam.label), 5),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_3, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.leftTeam.roster, (u, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: i,
                                class: (0, $8POXm.normalizeClass)([
                                    'roster-unit',
                                    {
                                        active: $data.attackerSide === 'left' && $data.attackerIndex === i
                                    }
                                ]),
                                onClick: ($event)=>$options.pick('left', i)
                            }, [
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "ru-icon",
                                    src: $options.portrait(u, $props.leftTeam.label),
                                    alt: u.Class,
                                    onError: _cache[1] || (_cache[1] = ($event)=>$event.target.style.visibility = 'hidden')
                                }, null, 40, $a417fc2ea1ff4604$var$_hoisted_5),
                                (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_6, (0, $8POXm.toDisplayString)(u.Name), 1)
                            ], 10, $a417fc2ea1ff4604$var$_hoisted_4);
                        }), 128))
                    ])
                ], 4),
                _cache[17] || (_cache[17] = (0, $TusQn.createElementVNode)("div", {
                    class: "roster-vs"
                }, "vs", -1)),
                (0, $TusQn.createElementVNode)("div", {
                    class: "roster-side",
                    style: (0, $8POXm.normalizeStyle)($options.teamBoxStyle($props.rightTeam.label))
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: "roster-wm",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.rightTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.rightTeam.label), 5),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_7, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.rightTeam.roster, (u, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: i,
                                class: (0, $8POXm.normalizeClass)([
                                    'roster-unit',
                                    {
                                        active: $data.attackerSide === 'right' && $data.attackerIndex === i
                                    }
                                ]),
                                onClick: ($event)=>$options.pick('right', i)
                            }, [
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "ru-icon",
                                    src: $options.portrait(u, $props.rightTeam.label),
                                    alt: u.Class,
                                    onError: _cache[2] || (_cache[2] = ($event)=>$event.target.style.visibility = 'hidden')
                                }, null, 40, $a417fc2ea1ff4604$var$_hoisted_9),
                                (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_10, (0, $8POXm.toDisplayString)(u.Name), 1)
                            ], 10, $a417fc2ea1ff4604$var$_hoisted_8);
                        }), 128))
                    ])
                ], 4)
            ]),
            _cache[31] || (_cache[31] = (0, $TusQn.createElementVNode)("p", {
                class: "pick-hint"
            }, "Click any unit to see its attacks vs the other team.", -1)),
            $options.terrain ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_12, "\uD83D\uDDFA " + (0, $8POXm.toDisplayString)($props.map) + " \u2014 starting positions", 1),
                ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_MapViewer3D, {
                    key: 'fm-' + $props.map,
                    terrain: $options.terrain,
                    starts: $options.mapStarts,
                    "mesh-url": $options.meshUrl
                }, null, 8, [
                    "terrain",
                    "starts",
                    "mesh-url"
                ]))
            ])) : (0, $TusQn.createCommentVNode)("", true),
            $props.predict ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 1,
                class: (0, $8POXm.normalizeClass)([
                    "fm-predict",
                    $props.predict.winner ? 'graded' : 'open'
                ])
            }, [
                !$props.predict.winner ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    _cache[18] || (_cache[18] = (0, $TusQn.createElementVNode)("span", {
                        class: "fmp-q"
                    }, "\uD83D\uDD2E Predict the winner:", -1)),
                    (0, $TusQn.createElementVNode)("button", {
                        class: (0, $8POXm.normalizeClass)([
                            "fmp-btn",
                            {
                                picked: $props.predict.picked === $props.leftTeam.name
                            }
                        ]),
                        style: (0, $8POXm.normalizeStyle)({
                            '--tc': $options.teamColor($props.leftTeam.label)
                        }),
                        onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit('pick-winner', $props.leftTeam.name))
                    }, [
                        $props.predict.picked === $props.leftTeam.name ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_13, "\uD83D\uDD2E ")) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.leftTeam.label), 1)
                    ], 6),
                    (0, $TusQn.createElementVNode)("button", {
                        class: (0, $8POXm.normalizeClass)([
                            "fmp-btn",
                            {
                                picked: $props.predict.picked === $props.rightTeam.name
                            }
                        ]),
                        style: (0, $8POXm.normalizeStyle)({
                            '--tc': $options.teamColor($props.rightTeam.label)
                        }),
                        onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit('pick-winner', $props.rightTeam.name))
                    }, [
                        $props.predict.picked === $props.rightTeam.name ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_14, "\uD83D\uDD2E ")) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.rightTeam.label), 1)
                    ], 6),
                    (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_15, (0, $8POXm.toDisplayString)($props.predict.roundLabel) + " \xb7 " + (0, $8POXm.toDisplayString)($props.predict.weight) + " pt" + (0, $8POXm.toDisplayString)($props.predict.weight > 1 ? 's' : ''), 1)
                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 1
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: (0, $8POXm.normalizeClass)([
                            "fmp-res",
                            !$props.predict.picked ? 'none' : $props.predict.picked === $props.predict.winner ? 'hit' : 'miss'
                        ])
                    }, [
                        !$props.predict.picked ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 0
                        }, [
                            (0, $TusQn.createTextVNode)("\u2014 you didn't pick this match")
                        ], 64)) : $props.predict.picked === $props.predict.winner ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            (0, $TusQn.createTextVNode)("\u2713 you nailed it (+" + (0, $8POXm.toDisplayString)($props.predict.weight) + ")", 1)
                        ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 2
                        }, [
                            (0, $TusQn.createTextVNode)("\u2717 you picked " + (0, $8POXm.toDisplayString)($options.teamLabelFor($props.predict.picked)), 1)
                        ], 64))
                    ], 2),
                    $props.predict.simPick ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_16, "\uD83E\uDD16 sim: " + (0, $8POXm.toDisplayString)($options.teamLabelFor($props.predict.simPick)) + " " + (0, $8POXm.toDisplayString)($props.predict.simPick === $props.predict.winner ? "\u2713" : "\u2717"), 1)) : (0, $TusQn.createCommentVNode)("", true)
                ], 64))
            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "sim-btn",
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.simulate && $options.simulate(...args))
                }, "\u2694 Simulate (" + (0, $8POXm.toDisplayString)($data.simRuns) + "\xd7)", 1),
                $data.simResult ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: "sim-pct",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.leftTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.leftTeam.label) + " " + (0, $8POXm.toDisplayString)($options.simOdds.a) + "%", 5),
                    _cache[19] || (_cache[19] = (0, $TusQn.createElementVNode)("span", {
                        class: "sim-vs"
                    }, "\u2013", -1)),
                    (0, $TusQn.createElementVNode)("span", {
                        class: "sim-pct",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.rightTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.rightTeam.label) + " " + (0, $8POXm.toDisplayString)($options.simOdds.b) + "%", 5),
                    (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_18, "\xb1" + (0, $8POXm.toDisplayString)($options.winMargin()) + "%", 1),
                    $data.simResult.draws ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_19, "(" + (0, $8POXm.toDisplayString)(Math.round($data.simResult.draws / $data.simResult.n * 100)) + "% draw)", 1)) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "sim-log-toggle",
                        onClick: _cache[6] || (_cache[6] = ($event)=>$data.showSimLog = !$data.showSimLog)
                    }, (0, $8POXm.toDisplayString)($data.showSimLog ? 'hide log' : 'log'), 1),
                    _cache[20] || (_cache[20] = (0, $TusQn.createElementVNode)("span", {
                        class: "sim-note"
                    }, "estimate \u2014 abstract grid sim (own statuses; matrix toggles don't apply)", -1))
                ], 64)) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            $data.simResult && $data.simResult.unitStats && $data.simResult.unitStats.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_21, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "ss-head",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.leftTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.leftTeam.label) + " \xb7 survives to end", 5),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.survivalRows().A, (u)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 'sa' + u.name,
                            class: "ss-row"
                        }, [
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_22, (0, $8POXm.toDisplayString)(u.name), 1),
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_23, (0, $8POXm.toDisplayString)(Math.round(u.survivalPct * 100)) + "%", 1)
                        ]);
                    }), 128))
                ]),
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_24, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "ss-head",
                        style: (0, $8POXm.normalizeStyle)({
                            color: $options.teamColor($props.rightTeam.label)
                        })
                    }, (0, $8POXm.toDisplayString)($props.rightTeam.label) + " \xb7 survives to end", 5),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.survivalRows().B, (u)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 'sb' + u.name,
                            class: "ss-row"
                        }, [
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_25, (0, $8POXm.toDisplayString)(u.name), 1),
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_26, (0, $8POXm.toDisplayString)(Math.round(u.survivalPct * 100)) + "%", 1)
                        ]);
                    }), 128))
                ])
            ])) : (0, $TusQn.createCommentVNode)("", true),
            $data.simFrames && $data.simFrames.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_27, [
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_28, [
                    $props.map ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_29, [
                        (0, $TusQn.createTextVNode)("\uD83D\uDDFA " + (0, $8POXm.toDisplayString)($props.map), 1),
                        !$options.terrain ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_30, " \xb7 flat grid (no terrain data)")) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.simRepro ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "sim-repro-btn",
                        onClick: _cache[7] || (_cache[7] = (...args)=>$options.copyRepro && $options.copyRepro(...args)),
                        title: "Copy a reproducible capsule of THIS exact fight (seed + both rosters + map). Paste it into replayRepro() to replay/debug the identical battle."
                    }, (0, $8POXm.toDisplayString)($data.reproCopied ? "\u2713 copied" : "\uD83D\uDCCB copy repro"), 1)) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                (0, $TusQn.createVNode)(_component_BattleViewer, {
                    frames: $data.simFrames,
                    terrain: $options.terrain,
                    "team-a": $props.leftTeam.label,
                    "team-b": $props.rightTeam.label
                }, null, 8, [
                    "frames",
                    "terrain",
                    "team-a",
                    "team-b"
                ])
            ])) : (0, $TusQn.createCommentVNode)("", true),
            $data.showSimLog && $data.simLog.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_31, [
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_32, (0, $8POXm.toDisplayString)($options.sampleLabel()), 1),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.simLog, (l, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: i
                    }, (0, $8POXm.toDisplayString)(l), 1);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_33, [
                _cache[21] || (_cache[21] = (0, $TusQn.createElementVNode)("span", {
                    class: "to-label",
                    title: "Estimated from Speed/CT assuming an equal start. Accounts for gear-granted Haste/Slow; not in-battle Haste/Slow."
                }, "Est. turn order \u2192", -1)),
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_34, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.turnOrderList, (t, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: i,
                            class: (0, $8POXm.normalizeClass)([
                                'to-unit',
                                'to-' + t.side
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_35, (0, $8POXm.toDisplayString)(i + 1), 1),
                            (0, $TusQn.createElementVNode)("img", {
                                class: (0, $8POXm.normalizeClass)([
                                    "to-icon",
                                    {
                                        flip: t.side === 'left'
                                    }
                                ]),
                                src: $options.portrait(t.unit, t.teamLabel),
                                alt: t.name,
                                onError: _cache[8] || (_cache[8] = ($event)=>$event.target.style.visibility = 'hidden')
                            }, null, 42, $a417fc2ea1ff4604$var$_hoisted_36),
                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_37, (0, $8POXm.toDisplayString)(t.name), 1),
                            t.haste ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_38, "\u23EB")) : t.slow ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_39, "\u23EC")) : (0, $TusQn.createCommentVNode)("", true)
                        ], 2);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_40, [
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_41, [
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_42, [
                        (0, $TusQn.createElementVNode)("img", {
                            class: "ap-portrait",
                            src: $options.portrait($options.attackerUnit, $options.attackerTeam.label),
                            alt: $options.attackerUnit.Class,
                            onError: _cache[9] || (_cache[9] = ($event)=>$event.target.style.visibility = 'hidden')
                        }, null, 40, $a417fc2ea1ff4604$var$_hoisted_43),
                        (0, $TusQn.createElementVNode)("div", null, [
                            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_44, (0, $8POXm.toDisplayString)($options.attackerUnit.Name), 1),
                            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_45, (0, $8POXm.toDisplayString)($options.attackerUnit.Class) + " \xb7 " + (0, $8POXm.toDisplayString)($options.attackerUnit.Sign), 1),
                            (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_46, "Brave " + (0, $8POXm.toDisplayString)($options.attackerUnit.Brave) + " \xb7 Faith " + (0, $8POXm.toDisplayString)($options.attackerUnit.Faith), 1)
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_47, [
                        (0, $TusQn.createElementVNode)("span", null, "HP " + (0, $8POXm.toDisplayString)($options.attacker.stats.hp), 1),
                        (0, $TusQn.createElementVNode)("span", null, "MP " + (0, $8POXm.toDisplayString)($options.attacker.stats.mp), 1),
                        (0, $TusQn.createElementVNode)("span", null, "PA " + (0, $8POXm.toDisplayString)($options.attacker.stats.pa), 1),
                        (0, $TusQn.createElementVNode)("span", null, "MA " + (0, $8POXm.toDisplayString)($options.attacker.stats.ma), 1),
                        (0, $TusQn.createElementVNode)("span", null, "SP " + (0, $8POXm.toDisplayString)($options.attacker.stats.speed), 1),
                        (0, $TusQn.createElementVNode)("span", null, "MV " + (0, $8POXm.toDisplayString)($options.attacker.stats.move), 1),
                        (0, $TusQn.createElementVNode)("span", null, "JP " + (0, $8POXm.toDisplayString)($options.attacker.stats.jump), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_48, [
                        $options.attackerUnit.ActionSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_49, "Action: " + (0, $8POXm.toDisplayString)($options.attackerUnit.ActionSkill), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.attackerUnit.ReactionSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_50, "React: " + (0, $8POXm.toDisplayString)($options.attackerUnit.ReactionSkill), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.attackerUnit.SupportSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_51, "Support: " + (0, $8POXm.toDisplayString)($options.attackerUnit.SupportSkill), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.attackerUnit.MoveSkill ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_52, "Move: " + (0, $8POXm.toDisplayString)($options.attackerUnit.MoveSkill), 1)) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_53, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.gearList, (g)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: g.slot
                            }, (0, $8POXm.toDisplayString)(g.slot) + ": " + (0, $8POXm.toDisplayString)(g.name), 1);
                        }), 128))
                    ]),
                    $options.affinityText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_54, (0, $8POXm.toDisplayString)($options.affinityText), 1)) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_55, [
                    $options.isMime ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $a417fc2ea1ff4604$var$_hoisted_56, " Mime \u2014 copies teammates' actions, so this lists the team's abilities (computed with " + (0, $8POXm.toDisplayString)($options.attackerUnit.Name) + "'s stats). Most skills are mimeable. ", 1)) : (0, $TusQn.createCommentVNode)("", true),
                    !$options.abilityRows.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $a417fc2ea1ff4604$var$_hoisted_57, (0, $8POXm.toDisplayString)($options.attackerUnit.Name) + " has no recognized damaging abilities. ", 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $a417fc2ea1ff4604$var$_hoisted_58, [
                        (0, $TusQn.createElementVNode)("thead", null, [
                            (0, $TusQn.createElementVNode)("tr", null, [
                                _cache[22] || (_cache[22] = (0, $TusQn.createElementVNode)("th", {
                                    class: "ability-col"
                                }, "Ability", -1)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.defenders, (d, c)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", {
                                        key: c,
                                        class: "def-col"
                                    }, [
                                        (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_59, (0, $8POXm.toDisplayString)(d.unit.Name), 1),
                                        (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_60, (0, $8POXm.toDisplayString)(d.unit.Class), 1),
                                        (0, $TusQn.createElementVNode)("div", {
                                            class: (0, $8POXm.normalizeClass)([
                                                "def-zodiac",
                                                'z-' + d.zodiac.toLowerCase()
                                            ])
                                        }, (0, $8POXm.toDisplayString)(d.zodiac), 3),
                                        d.affinity ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_61, (0, $8POXm.toDisplayString)(d.affinity), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                    ]);
                                }), 128))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("tbody", null, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.grid, (row, r)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                    key: r
                                }, [
                                    (0, $TusQn.createElementVNode)("td", $a417fc2ea1ff4604$var$_hoisted_62, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(row.ability) + " ", 1),
                                        row.element ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_63, (0, $8POXm.toDisplayString)(row.element), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                        row.status ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_64, "status %")) : (0, $TusQn.createCommentVNode)("", true)
                                    ]),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(row.cells, (cell, c)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", {
                                            key: c,
                                            class: (0, $8POXm.normalizeClass)([
                                                'cell',
                                                'fx-' + (cell.effect || 'none'),
                                                {
                                                    open: $options.isOpen(r, c)
                                                }
                                            ]),
                                            onClick: ($event)=>$options.toggle(r, c)
                                        }, [
                                            (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_66, (0, $8POXm.toDisplayString)(cell.display), 1),
                                            cell.hit != null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_67, (0, $8POXm.toDisplayString)(cell.hit) + "% hit", 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ], 10, $a417fc2ea1ff4604$var$_hoisted_65);
                                    }), 128))
                                ]);
                            }), 128))
                        ])
                    ])),
                    $options.openCell ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_68, [
                        (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_69, (0, $8POXm.toDisplayString)($options.grid[$data.expanded.r].ability) + " \u2192 " + (0, $8POXm.toDisplayString)($options.defenders[$data.expanded.c].unit.Name), 1),
                        (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_70, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.openCell.steps, (s, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: i,
                                    class: "drill-step"
                                }, [
                                    (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_71, (0, $8POXm.toDisplayString)(s.label), 1),
                                    s.factor ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_72, (0, $8POXm.toDisplayString)(s.factor), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                    (0, $TusQn.createElementVNode)("span", $a417fc2ea1ff4604$var$_hoisted_73, (0, $8POXm.toDisplayString)(s.value), 1)
                                ]);
                            }), 128)),
                            !$options.openCell.steps.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a417fc2ea1ff4604$var$_hoisted_74, "No modifiers \u2014 base damage.")) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                        $options.openCell.kind === 'damage' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a417fc2ea1ff4604$var$_hoisted_75, [
                            $options.openCell.hitDirs && $options.openCell.hitDirs.magical ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, [
                                (0, $TusQn.createTextVNode)(" Magic hit chance (any direction): " + (0, $8POXm.toDisplayString)($options.openCell.hitDirs.front) + "% ", 1)
                            ], 64)) : $options.openCell.hitDirs ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, [
                                (0, $TusQn.createTextVNode)(" Hit chance \u2014 Front " + (0, $8POXm.toDisplayString)($options.openCell.hitDirs.front) + "% \xb7 Side " + (0, $8POXm.toDisplayString)($options.openCell.hitDirs.side) + "% \xb7 Back " + (0, $8POXm.toDisplayString)($options.openCell.hitDirs.back) + "% ", 1)
                            ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 2
                            }, [
                                (0, $TusQn.createTextVNode)("Can't be evaded.")
                            ], 64))
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("div", $a417fc2ea1ff4604$var$_hoisted_76, [
                        _cache[29] || (_cache[29] = (0, $TusQn.createElementVNode)("span", {
                            class: "status-label"
                        }, "Pretend each target has:", -1)),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$data.targetStatuses.protect = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.protect
                                ]
                            ]),
                            _cache[23] || (_cache[23] = (0, $TusQn.createTextVNode)(" Protect", -1))
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$data.targetStatuses.shell = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.shell
                                ]
                            ]),
                            _cache[24] || (_cache[24] = (0, $TusQn.createTextVNode)(" Shell", -1))
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$data.targetStatuses.charging = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.charging
                                ]
                            ]),
                            _cache[25] || (_cache[25] = (0, $TusQn.createTextVNode)(" Charging", -1))
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$data.targetStatuses.sleeping = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.sleeping
                                ]
                            ]),
                            _cache[26] || (_cache[26] = (0, $TusQn.createTextVNode)(" Sleeping", -1))
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$data.targetStatuses.frogChicken = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.frogChicken
                                ]
                            ]),
                            _cache[27] || (_cache[27] = (0, $TusQn.createTextVNode)(" Frog/Chicken", -1))
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$data.targetStatuses.oil = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.targetStatuses.oil
                                ]
                            ]),
                            _cache[28] || (_cache[28] = (0, $TusQn.createTextVNode)(" Oil (weak Fire)", -1))
                        ])
                    ]),
                    _cache[30] || (_cache[30] = (0, $TusQn.createElementVNode)("p", {
                        class: "matrix-note"
                    }, " Numbers are estimates: attacker Strengthen/Attack-Up, the target's gear Absorb/Half, zodiac, and faith are applied. Green = absorbed (heals target), red = weak \xd72, blue = halved. Click a cell for the step breakdown. ", -1))
                ])
            ])
        ])
    ]);
}

});

parcelRegister("4Oyah", function(module, exports) {

$parcel$export(module.exports, "default", () => $3816555cbb0994ff$export$2e2bcd8739ae039);
let $3816555cbb0994ff$var$NOOP = ()=>{};
var $3816555cbb0994ff$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iAuNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88379c6f0da4485$export$2e2bcd8739ae039);
let $d88379c6f0da4485$var$script;




let $d88379c6f0da4485$var$initialize = ()=>{
    $d88379c6f0da4485$var$script = (parcelRequire("3QV8f"));
    if ($d88379c6f0da4485$var$script.__esModule) $d88379c6f0da4485$var$script = $d88379c6f0da4485$var$script.default;
    $d88379c6f0da4485$var$script.render = (parcelRequire("19ZHj")).render;
    $d88379c6f0da4485$var$script.__cssModules = {};
    (parcelRequire("cugQz")).default($d88379c6f0da4485$var$script);
    $d88379c6f0da4485$var$script.__scopeId = 'data-v-a92932';
    $d88379c6f0da4485$var$script.__file = "UnitCardModal.vue";
};
$d88379c6f0da4485$var$initialize();
var $d88379c6f0da4485$export$2e2bcd8739ae039 = $d88379c6f0da4485$var$script;

});
parcelRegister("3QV8f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ce28bab23e31b1b$export$2e2bcd8739ae039);

var $3bnHa = parcelRequire("3bnHa");

var $8Iy0x = parcelRequire("8Iy0x");

var $bTyhe = parcelRequire("bTyhe");
var $2ce28bab23e31b1b$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $8Iy0x.default)
    ],
    components: {
        InlineUnit: $3bnHa.default
    },
    props: {
        unit: {
            type: Object,
            required: true
        },
        teamColor: {
            type: String,
            default: 'Champion'
        },
        classRank: {
            type: Object,
            default: ()=>({})
        },
        toolTips: {
            type: Object,
            default: ()=>({})
        },
        notAbles: {
            type: Object,
            required: true
        },
        charStats: {
            type: Object,
            required: true
        },
        itemschanged: {
            type: Object,
            required: true
        },
        abilitiesInfo: {
            type: Object,
            default: ()=>({})
        },
        highlightColors: {
            type: Object,
            default: ()=>new Map()
        },
        // Opposing / own rosters (bracket only) — threaded through so the modal's
        // card shows the same both-teams ability breakdown as the grid card.
        enemyTeam: {
            type: Array,
            default: ()=>[]
        },
        ownTeam: {
            type: Array,
            default: ()=>[]
        },
        showWinRates: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'close'
    ],
    methods: {
        // Copy this exact unit into the Character Builder (new tab, so the bracket stays open).
        openInBuilder () {
            if (!this.unit || !this.unit.Name) return; // BuilderView ignores a nameless payload — don't open a blank tab
            const url = window.location.origin + window.location.pathname + '?build&u=' + (0, $bTyhe.encodeBuild)(this.unit, this.unit.Name);
            window.open(url, '_blank', 'noopener');
        }
    }
};

});

parcelRegister("19ZHj", function(module, exports) {

$parcel$export(module.exports, "render", () => $0d867d8cae496687$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $0d867d8cae496687$var$_hoisted_1 = {
    class: "fc-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Unit card"
};
function $0d867d8cae496687$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InlineUnit = (0, $TusQn.resolveComponent)("InlineUnit");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay top z1100 fc-overlay",
        onClick: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $0d867d8cae496687$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "fc-build",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.openInBuilder && $options.openInBuilder(...args)),
                "aria-label": "Open this unit in the Character Builder (new tab)",
                title: "Open a copy of this unit in the Character Builder (new tab)"
            }, "\u270F\uFE0F Builder"),
            (0, $TusQn.createElementVNode)("button", {
                class: "fc-close",
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\u2715"),
            (0, $TusQn.createVNode)(_component_InlineUnit, {
                unit: $props.unit,
                inModal: true,
                teamColor: $props.teamColor || 'Champion',
                classRank: $props.classRank,
                toolTips: $props.toolTips,
                notAbles: $props.notAbles,
                charStats: $props.charStats,
                itemschanged: $props.itemschanged,
                abilitiesInfo: $props.abilitiesInfo,
                highlightColors: $props.highlightColors,
                "enemy-team": $props.enemyTeam,
                "own-team": $props.ownTeam,
                "show-win-rates": $props.showWinRates
            }, null, 8, [
                "unit",
                "teamColor",
                "classRank",
                "toolTips",
                "notAbles",
                "charStats",
                "itemschanged",
                "abilitiesInfo",
                "highlightColors",
                "enemy-team",
                "own-team",
                "show-win-rates"
            ])
        ])
    ]);
}

});

parcelRegister("cugQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $91755accb222a6ef$export$2e2bcd8739ae039);
let $91755accb222a6ef$var$NOOP = ()=>{};
var $91755accb222a6ef$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iScHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd71fad14887336$export$2e2bcd8739ae039);
let $dbd71fad14887336$var$script;




let $dbd71fad14887336$var$initialize = ()=>{
    $dbd71fad14887336$var$script = (parcelRequire("jClkM"));
    if ($dbd71fad14887336$var$script.__esModule) $dbd71fad14887336$var$script = $dbd71fad14887336$var$script.default;
    $dbd71fad14887336$var$script.render = (parcelRequire("j9Lha")).render;
    $dbd71fad14887336$var$script.__cssModules = {};
    (parcelRequire("dR83w")).default($dbd71fad14887336$var$script);
    $dbd71fad14887336$var$script.__scopeId = 'data-v-e6e2c7';
    $dbd71fad14887336$var$script.__file = "SiteNav.vue";
};
$dbd71fad14887336$var$initialize();
var $dbd71fad14887336$export$2e2bcd8739ae039 = $dbd71fad14887336$var$script;

});
parcelRegister("jClkM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4821d6d81d56965$export$2e2bcd8739ae039);

var $bXoWA = parcelRequire("bXoWA");
// Shared top navigation across every page. Each view renders <SiteNav active="…"/>
// at the top; the homepage also fills the #actions slot with its bracket controls
// (settings / help / generator / prev-tournament). Self-detects the active tab from
// the URL params when `active` isn't passed. The Players tab opens a mega-menu of
// its in-page modes (deep-linked via ?players&tab=…); the other tabs get a verbose
// styled hover tooltip. On phones the whole tab row collapses behind a ☰ hamburger.
// Champions is also a mega-menu: the ToC leaderboard plus the championship-history
// pages (Line of Succession, Streaks, Champions-by-class — the last two physically
// live in PlayerView under ?players&tab=…, cross-listed here as shortcuts).
// Chat is a mega-menu too: the volume hero chart (?chat) plus the other chat-mined
// pages — Social graph, Lexicon, What Chat Forces, and the FAQ. The 🎮 Game tab is a
// MENU-ONLY parent (no page) grouping the reference pages — Maps, Stats, Mechanics,
// Sprites, Gear Lab (all nav:false, activeAs:'game') — to keep the top bar short.
const $e4821d6d81d56965$var$CHAMPION_TABS = [
    {
        label: "\uD83C\uDFC6 Tournament of Champions",
        desc: 'The reigning-champion leaderboard by title-defense streak, with a seeded bracket and sim odds',
        href: '?champions'
    },
    {
        label: "\uD83D\uDC51 Line of Succession",
        desc: "The complete crown lineage \u2014 every reign in order, who dethroned whom",
        href: '?crown'
    },
    {
        label: "\uD83C\uDFC5 Best & Worst Teams",
        desc: "The highest- and lowest-graded bracket teams ever assembled \u2014 all-time & modern",
        href: '?teams'
    },
    {
        label: "\uD83D\uDCC5 Seasons",
        desc: "Champions season by season \u2014 per-season title boards, longest reigns, rookies & records",
        href: '?seasons'
    },
    {
        label: "\uD83C\uDFB2 Season Units",
        desc: "What actually got rolled each season \u2014 every class from rarest to most common, and who rolled it most",
        href: '?units'
    },
    {
        label: "\uD83C\uDF96\uFE0F VIP Quest",
        desc: "The season race to champion the most different classes \u2014 the standings and everyone\u2019s checklist of 75",
        href: '?vip'
    },
    {
        label: "\uD83D\uDD25 Streaks",
        desc: 'Longest championship reigns & defense streaks',
        href: '?players&tab=streaks'
    },
    {
        label: "\uD83C\uDFC6 Champions by class",
        desc: 'Per-class title leaderboards + how-to-champ guide',
        href: '?players&tab=champions'
    }
];
const $e4821d6d81d56965$var$CHAT_TABS = [
    {
        label: "\uD83D\uDCAC Chat Activity",
        desc: 'Daily chat volume over six years + the most-active-chatter boards',
        href: '?chat'
    },
    {
        label: "\uD83D\uDCF0 The Daily Chocobo",
        desc: 'Yesterday in chat, as a tabloid: the big moments, the quotes, the numbers',
        href: '?chocobo'
    },
    {
        label: "\uD83D\uDD78\uFE0F Social Graph",
        desc: "Who @mentions whom \u2014 friend clusters & the biggest feuds",
        href: '?social'
    },
    {
        label: "\uD83D\uDCD6 Lexicon",
        desc: "Emote & copypasta lifecycles \u2014 born, peaked, faded",
        href: '?lexicon'
    },
    {
        label: "\uD83E\uDDFE Copypasta",
        desc: "The long-form copypasta \u2014 every repost-pasta, ranked",
        href: '?copypasta'
    },
    {
        label: "\uD83D\uDCD6 Holy Carpet Bible",
        desc: "Technominari's long verses, sorted Canon / Gospel / Apocrypha \u2014 is it all copypasta?",
        href: '?carpet'
    },
    {
        label: "\uD83C\uDFA1 Technospeak Wheel",
        desc: 'Spin the church-word wheel to build nonsense scripture (the sekhretpoop toy)',
        href: '?sekhretpoop'
    },
    {
        label: "\uD83C\uDFB2 What Chat Forces",
        desc: "Most-forced classes & skills vs win rate",
        href: '?forced'
    },
    {
        label: "\uD83C\uDF81 Gifts",
        desc: "Who has gifted the most skills \u2014 confirmed by the bot, not by who typed !gift",
        href: '?gifts'
    },
    {
        label: "\u2753 FAQ",
        desc: 'The questions chat actually asks, answered',
        href: '?faq'
    }
];
const $e4821d6d81d56965$var$PLAYER_TABS = [
    {
        label: 'Directory',
        desc: "Search 16k players \u2014 win rate, mains, championships",
        href: '?players'
    },
    {
        label: "\uD83C\uDFC6 Champions by class",
        desc: 'Per-class title leaderboards + how-to-champ guide',
        href: '?players&tab=champions'
    },
    {
        label: "\uD83C\uDFC5 Quests",
        desc: 'Monster-Quest completions, checklists & badges',
        href: '?players&tab=quests'
    },
    {
        label: "\uD83D\uDCCA Boards",
        desc: 'Career, dynasty, speedrun & monster-family boards',
        href: '?players&tab=boards'
    },
    {
        label: "\uD83C\uDFDC\uFE0F Droughts",
        desc: 'Longest streaks without champing a class',
        href: '?players&tab=droughts'
    },
    {
        label: "\uD83D\uDCB0 Betting",
        desc: "Gambler profiles \u2014 ROI, win rate, balance over time",
        href: '?players&tab=betting'
    },
    {
        label: "\uD83D\uDD25 Streaks",
        desc: 'Longest championship reigns & defense streaks',
        href: '?players&tab=streaks'
    },
    {
        label: "\uD83E\uDDED Strategy",
        desc: 'Best classes to champ + the empirical roll guide',
        href: '?players&tab=strategy'
    },
    {
        label: "\uD83C\uDFDB\uFE0F Hall of Fame",
        desc: "The 350+ Club \u2014 superlatives, records & the elite roster",
        href: '?hall'
    },
    {
        label: "\u2694\uFE0F Compare",
        desc: 'Side-by-side career comparison of any two players',
        href: '?compare'
    }
];
// The 🎮 Game tab groups the game-reference pages. Unlike the other mega-menus it's
// MENU-ONLY — there's no "Game" page, so the parent links to its first child (Maps);
// the grouped sections are nav:false (activeAs:'game') in routes.js and get injected
// here. (Keeps the top bar to ~7 tabs.)
const $e4821d6d81d56965$var$GAME_TABS = [
    {
        label: "\uD83D\uDDFA\uFE0F Maps",
        desc: "All 138 battle maps \u2014 class win-rate edges, 3D terrain & a height calculator",
        href: '?maps'
    },
    {
        label: "\uD83D\uDCCA Stats",
        desc: 'Win-rate analytics by class, skill, gear & Brave/Faith, with Meta-Tides trends',
        href: '?stats'
    },
    {
        label: "\uD83D\uDCD6 Mechanics",
        desc: "How the battle engine works \u2014 damage, evasion, zodiac, Faith and turn order",
        href: '?mechanics'
    },
    {
        label: "\uD83C\uDF9E\uFE0F Sprites",
        desc: "Every battle sprite off the disc \u2014 recolored walk cycles, with GIF export",
        href: '?gallery'
    },
    {
        label: "\uD83D\uDD0D Gear Lab",
        desc: "Item-combo lookup \u2014 roll rate, win rate, top classes, and what it pairs with",
        href: '?gear'
    },
    {
        label: "\uD83C\uDF92 Armory",
        desc: "Item glossary \u2014 every piece of gear with full stats, swing-damage calc & usage",
        href: '?armory'
    },
    {
        label: "\u2728 Abilities",
        desc: "Skill glossary \u2014 every action skill, support, reaction & move, with output & win rates",
        href: '?abilities'
    },
    {
        label: "\uD83C\uDFAD Classes",
        desc: "Every job & monster \u2014 default stats by gender with walking sprites, kit, win rates & a live ability/damage card",
        href: '?classes'
    }
];
// The mega-menus stay here (SiteNav presentation detail); the top-level tab list
// + active state are derived from the shared section registry (src/routes.js), so
// adding a page is one entry there — no edit in this file.
const $e4821d6d81d56965$var$CHILDREN = {
    champions: $e4821d6d81d56965$var$CHAMPION_TABS,
    players: $e4821d6d81d56965$var$PLAYER_TABS,
    chat: $e4821d6d81d56965$var$CHAT_TABS,
    game: $e4821d6d81d56965$var$GAME_TABS
};
const $e4821d6d81d56965$var$GAME_TAB = {
    key: 'game',
    emoji: "\uD83C\uDFAE",
    label: 'Game',
    href: '?maps',
    desc: "Game data & reference \u2014 maps, win-rate stats, battle mechanics, sprites and the gear lookup.",
    children: $e4821d6d81d56965$var$GAME_TABS
};
const $e4821d6d81d56965$var$TABS = [];
for (const s of (0, $bXoWA.SECTIONS).filter((x)=>x.nav)){
    if (s.key === 'build') $e4821d6d81d56965$var$TABS.push($e4821d6d81d56965$var$GAME_TAB); // 🎮 Game sits just before Builder
    $e4821d6d81d56965$var$TABS.push({
        key: s.key,
        emoji: s.emoji,
        label: s.label,
        href: s.href || '?' + s.param,
        desc: s.desc,
        children: $e4821d6d81d56965$var$CHILDREN[s.key]
    });
}
var $e4821d6d81d56965$export$2e2bcd8739ae039 = {
    name: 'SiteNav',
    props: {
        active: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            tabs: $e4821d6d81d56965$var$TABS,
            menuOpen: false
        };
    },
    computed: {
        activeKey () {
            if (this.active) return this.active; // App / Luxstadio pass it explicitly
            const s = (0, $bXoWA.resolveSection)();
            return s.activeAs === undefined ? s.key : s.activeAs; // null = no tab claims active (e.g. changelog)
        }
    },
    methods: {
        // Highlight the active child in any mega-menu (Players + Champions). Standalone
        // pages match by a bare param (?hall/?compare/?crown/?champions); ?players children
        // match on ?tab= (directory = default). Menu-agnostic: only one child matches a URL.
        childActive (href) {
            const cur = new URLSearchParams(window.location.search);
            const h = new URLSearchParams(href.split('?')[1] || '');
            for (const k of [
                'hall',
                'compare',
                'crown',
                'seasons',
                'units',
                'vip',
                'teams',
                'champions',
                'chat',
                'social',
                'lexicon',
                'copypasta',
                'carpet',
                'sekhretpoop',
                'forced',
                'gifts',
                'faq',
                'maps',
                'stats',
                'mechanics',
                'gallery',
                'gear'
            ])if (h.has(k)) return cur.has(k);
            if (h.has('players')) return cur.has('players') && (cur.get('tab') || 'directory') === (h.get('tab') || 'directory');
            return false;
        }
    }
};

});
parcelRegister("bXoWA", function(module, exports) {

$parcel$export(module.exports, "SECTIONS", () => $8b488dbcce1c14ef$export$5ff47a1a5df62032);
$parcel$export(module.exports, "resolveSection", () => $8b488dbcce1c14ef$export$495a9bd214bb02ef);
// Single source of truth for the site's top-level sections.
//
// The site is router-less: each section is a ?query param (parsed once at boot —
// switching sections is a full page load, which suits a static-hosted, code-split
// content site; see the TODO in App.vue). This registry is what App.vue and
// SiteNav both consume, so adding a page is ONE entry here instead of edits
// scattered across App's v-if chain, App's data flags, and SiteNav's tab list.
//
// Fields:
//   key      unique id (also the active-tab key)
//   param    the ?param that selects this section (null = the default, bracket)
//   loader   () => import(...) for App's async <component> (null = bracket/Luxstadio, static)
//   nav      true = show as a top-level tab in SiteNav
//   emoji,label,desc   nav-tab presentation (only needed when nav)
//   href     nav link (defaults to '?'+param; bracket overrides to './')
//   activeAs which tab key to highlight when this section is open (defaults to key)
//   data     generated files this section's components read SYNCHRONOUSLY (lib/preload.js).
//            main.js loads them from S3, with preload.CORE, before the page mounts.
//            Reading one a page didn't list throws, so a missing entry is found in testing.
//
// Order: nav sections first in tab order, then the non-nav ones. resolveSection()
// matches in array order, so list more-specific params before broader ones.






































const $8b488dbcce1c14ef$export$5ff47a1a5df62032 = [
    {
        key: 'bracket',
        param: null,
        loader: null,
        nav: true,
        href: './',
        emoji: "\u2694\uFE0F",
        label: 'Bracket',
        desc: "The live tournament bracket \u2014 hover any unit for its card; open a Fight View damage matrix or instant win-odds on any matchup."
    },
    {
        key: 'champions',
        param: 'champions',
        loader: ()=>(parcelRequire("9PFim")),
        nav: true,
        emoji: "\uD83C\uDFC6",
        label: 'Champions',
        desc: "The Tournament of Champions, the crown\u2019s line of succession, and championship streaks & by-class leaderboards."
    },
    {
        key: 'players',
        param: 'players',
        loader: ()=>(parcelRequire("k0TDk")),
        nav: true,
        emoji: "\uD83D\uDC65",
        label: 'Players',
        desc: 'Explore 6 years of career data'
    },
    {
        key: 'maps',
        param: 'maps',
        loader: ()=>(parcelRequire("7FRc5")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83D\uDDFA\uFE0F",
        label: 'Maps',
        data: [
            'mapStats'
        ],
        desc: "All 138 battle maps and which classes the terrain favors \u2014 empirical win-rate edges, a 3D terrain viewer, and a height-calculator tool."
    },
    {
        key: 'gear',
        param: 'gear',
        loader: ()=>(parcelRequire("2AnnC")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83D\uDD0D",
        label: 'Gear Lab',
        desc: 'Search any item (or a pair): how often it has rolled, its win rate, the top classes that carry it, and what it is most paired with.'
    },
    {
        key: 'armory',
        param: 'armory',
        loader: ()=>(parcelRequire("jmN99")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83C\uDF92",
        label: 'Armory',
        desc: "Item glossary \u2014 every weapon, shield, hat, armor & accessory with full stats, a swing-damage calculator, and real usage/win rates."
    },
    {
        key: 'abilities',
        param: 'abilities',
        loader: ()=>(parcelRequire("aunau")),
        nav: false,
        activeAs: 'game',
        emoji: "\u2728",
        label: 'Abilities',
        desc: "Ability glossary \u2014 every action skill, support, reaction & move, with what it does, an output calculator, and real win rates."
    },
    {
        key: 'classes',
        param: 'classes',
        loader: ()=>(parcelRequire("iKM0W")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83C\uDFAD",
        label: 'Classes',
        desc: "Every job and monster \u2014 default stats by gender (with a walking sprite), equippable gear, innate kit, win rates, and a live default-unit card showing its abilities & damage."
    },
    {
        key: 'build',
        param: 'build',
        loader: ()=>(parcelRequire("idFiK")),
        nav: true,
        emoji: "\uD83D\uDD27",
        label: 'Builder',
        data: [
            'blueMagicSets'
        ],
        desc: "Build a unit from scratch \u2014 set every stat, skill and gear slot, watch the full card update live, and export to stream format."
    },
    {
        key: 'memes',
        param: 'memes',
        loader: ()=>(parcelRequire("fddk4")),
        nav: true,
        emoji: "\uD83C\uDCCF",
        label: 'Memes',
        desc: "FFTBG\u2019s non-standard events \u2014 meme rulesets, Algus, and the Tournament of Champions \u2014 preserved here (and excluded from every stat)."
    },
    {
        key: 'stats',
        param: 'stats',
        loader: ()=>(parcelRequire("eAJsU")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83D\uDCCA",
        label: 'Stats',
        data: [
            'statsMonthly',
            'tournamentStats',
            'classIndexGender'
        ],
        desc: 'Deep win-rate analytics by class, skill, gear, Brave/Faith and archetype, with trends over time and a full class & monster index.'
    },
    {
        key: 'mechanics',
        param: 'mechanics',
        loader: ()=>(parcelRequire("bZxpJ")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83D\uDCD6",
        label: 'Mechanics',
        desc: "How the battle engine works \u2014 damage, evasion, zodiac, Faith, elements and turn order, with live calculators built on the same math the cards use."
    },
    {
        key: 'gallery',
        param: 'gallery',
        loader: ()=>(parcelRequire("4UxMn")),
        nav: false,
        activeAs: 'game',
        emoji: "\uD83C\uDF9E\uFE0F",
        label: 'Sprites',
        desc: "Every battle sprite ripped from the disc \u2014 front/back walk cycles recolored live through each unit\u2019s palettes (monster family tiers + team tints)."
    },
    {
        key: 'chat',
        param: 'chat',
        loader: ()=>(parcelRequire("2Ojyn")),
        nav: true,
        emoji: "\uD83D\uDCAC",
        label: 'Chat',
        data: [
            'chatVolume',
            'chatMeta',
            'chatChatters'
        ],
        desc: "Six years of the Twitch chat, mined \u2014 daily volume, the @mention social graph, the emote & copypasta lexicon, what chat forces, and an auto-FAQ."
    },
    {
        key: 'wiznaibot',
        param: 'wiznaibot',
        loader: ()=>(parcelRequire("2stJ7")),
        nav: true,
        emoji: "\uD83E\uDD16",
        label: 'Wiznaibot',
        desc: "Wiznaibot\u2019s automated betting bot \u2014 its live bankroll, every bet it makes and why, and how it\u2019s doing."
    },
    {
        key: 'wiznaibot-lab',
        param: 'wiznaibot-lab',
        loader: ()=>(parcelRequire("fjBrn")),
        nav: false,
        activeAs: 'wiznaibot'
    },
    {
        key: 'wiznaibot-silly',
        param: 'wiznaibot-silly',
        loader: ()=>(parcelRequire("3J3bL")),
        nav: false,
        activeAs: 'wiznaibot'
    },
    {
        key: 'wiznaibot-pulse',
        param: 'wiznaibot-pulse',
        loader: ()=>(parcelRequire("1vbX2")),
        nav: false,
        activeAs: 'wiznaibot'
    },
    {
        key: 'wiznaibot-help',
        param: 'wiznaibot-help',
        loader: ()=>(parcelRequire("hUlES")),
        nav: false,
        activeAs: 'wiznaibot'
    },
    {
        key: 'social',
        param: 'social',
        loader: ()=>(parcelRequire("6DM1h")),
        nav: false,
        activeAs: 'chat'
    },
    // non-nav sections (reached from mega-menus, deep links, or in-page jumps)
    {
        key: 'lexicon',
        param: 'lexicon',
        loader: ()=>(parcelRequire("dzpAn")),
        nav: false,
        activeAs: 'chat',
        data: [
            'chatLexicon',
            'chatMeta'
        ]
    },
    {
        key: 'copypasta',
        param: 'copypasta',
        loader: ()=>(parcelRequire("d6Xav")),
        nav: false,
        activeAs: 'chat',
        data: [
            'copypasta'
        ]
    },
    {
        key: 'forced',
        param: 'forced',
        loader: ()=>(parcelRequire("cJkIq")),
        nav: false,
        activeAs: 'chat',
        data: [
            'chatSubmissions'
        ]
    },
    {
        key: 'gifts',
        param: 'gifts',
        loader: ()=>(parcelRequire("6lGXr")),
        nav: false,
        activeAs: 'chat'
    },
    {
        key: 'faq',
        param: 'faq',
        loader: ()=>(parcelRequire("15yiX")),
        nav: false,
        activeAs: 'chat'
    },
    {
        key: 'carpet',
        param: 'carpet',
        loader: ()=>(parcelRequire("6vPpd")),
        nav: false,
        activeAs: 'chat',
        data: [
            'carpetBible'
        ]
    },
    {
        key: 'sekhretpoop',
        param: 'sekhretpoop',
        loader: ()=>(parcelRequire("gbUAN")),
        nav: false,
        activeAs: 'chat'
    },
    {
        key: 'chocobo',
        param: 'chocobo',
        loader: ()=>(parcelRequire("27hl4")),
        nav: false,
        activeAs: 'chat'
    },
    {
        key: 'crown',
        param: 'crown',
        loader: ()=>(parcelRequire("gzEm7")),
        nav: false,
        activeAs: 'champions'
    },
    {
        key: 'seasons',
        param: 'seasons',
        loader: ()=>(parcelRequire("DLRNL")),
        nav: false,
        activeAs: 'champions',
        emoji: "\uD83D\uDCC5",
        label: 'Seasons',
        desc: "Champions season by season \u2014 each ToC season\u2019s title leaderboard, longest reigns, rookies and records."
    },
    {
        key: 'teams',
        param: 'teams',
        loader: ()=>(parcelRequire("eok9Z")),
        nav: false,
        activeAs: 'champions',
        emoji: "\uD83C\uDFC5",
        label: 'Best Teams',
        data: [
            'teamRankings'
        ],
        desc: "The highest- and lowest-graded bracket teams ever assembled, plus the most combined HP \u2014 all-time and modern."
    },
    {
        key: 'units',
        param: 'units',
        loader: ()=>(parcelRequire("glDOh")),
        nav: false,
        activeAs: 'champions',
        emoji: "\uD83C\uDFB2",
        label: 'Season Units',
        data: [
            'seasonUnits'
        ],
        desc: "What actually got rolled each season \u2014 every class ranked from rarest to most common, and who rolled it most."
    },
    {
        key: 'vip',
        param: 'vip',
        loader: ()=>(parcelRequire("3BED8")),
        nav: false,
        activeAs: 'champions',
        emoji: "\uD83C\uDF96\uFE0F",
        label: 'VIP Quest',
        desc: "The season race to champion the most different classes: the standings, and every player\u2019s checklist of 75."
    },
    {
        key: 'player',
        param: 'player',
        loader: ()=>(parcelRequire("feuok")),
        nav: false,
        activeAs: 'players',
        data: [
            'chatMeta'
        ]
    },
    {
        key: 'hall',
        param: 'hall',
        loader: ()=>(parcelRequire("jybMt")),
        nav: false,
        activeAs: 'players'
    },
    {
        key: 'compare',
        param: 'compare',
        loader: ()=>(parcelRequire("2syr7")),
        nav: false,
        activeAs: 'players'
    },
    {
        key: 'changelog',
        param: 'changelog',
        loader: ()=>(parcelRequire("fZ9TT")),
        nav: false,
        activeAs: null
    },
    {
        key: 'overlay',
        param: 'overlay',
        loader: ()=>(parcelRequire("CwCVJ")),
        nav: false,
        activeAs: null
    },
    // Unlinked share page: the emulator turn-logger explainer (tools/emu-battle).
    {
        key: 'fightlog',
        param: 'fightlog',
        loader: ()=>(parcelRequire("7L8hB")),
        nav: false,
        activeAs: null
    }
];
const $8b488dbcce1c14ef$var$BRACKET = $8b488dbcce1c14ef$export$5ff47a1a5df62032.find((s)=>s.key === 'bracket');
function $8b488dbcce1c14ef$export$495a9bd214bb02ef(search = window.location.search) {
    const p = new URLSearchParams(search);
    return $8b488dbcce1c14ef$export$5ff47a1a5df62032.find((s)=>s.param && p.has(s.param)) || $8b488dbcce1c14ef$var$BRACKET;
}

});
parcelRegister("9PFim", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("3gwpL")),
    import("24ZKD")
]).then(()=>parcelRequire('jKmW9'));

});

parcelRegister("k0TDk", function(module, exports) {

module.exports = Promise.all([
    import("b43aL"),
    (parcelRequire("fFMZG"))(import.meta.resolve("3ZFN1")),
    import("hXxVs")
]).then(()=>parcelRequire('265jW'));

});

parcelRegister("7FRc5", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("9KQhE")),
    import("2QcHq")
]).then(()=>parcelRequire('63wk7'));

});

parcelRegister("2AnnC", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("ckM3p")),
    import("lCDYq")
]).then(()=>parcelRequire('9Nixd'));

});

parcelRegister("jmN99", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("eBUgk")),
    import("79PjJ")
]).then(()=>parcelRequire('a8IL4'));

});

parcelRegister("aunau", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("gIde5")),
    import("i1vwm")
]).then(()=>parcelRequire('4Gqf4'));

});

parcelRegister("iKM0W", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("1XYGb")),
    import("hjRHO")
]).then(()=>parcelRequire('kGeBj'));

});

parcelRegister("idFiK", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("6Hf2Z")),
    import("lR9xw"),
    import("bdrFf")
]).then(()=>parcelRequire('1xMle'));

});

parcelRegister("fddk4", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("axNVM")),
    import("gzsQK")
]).then(()=>parcelRequire('7rvaq'));

});

parcelRegister("eAJsU", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("4QKbS")),
    import("6VY1m")
]).then(()=>parcelRequire('eaXCW'));

});

parcelRegister("bZxpJ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("3UYEz")),
    import("2fqkA")
]).then(()=>parcelRequire('9Y6Lb'));

});

parcelRegister("4UxMn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("2gmpg")),
    import("g3Uzr"),
    import("cR4KY"),
    import("fBlI1")
]).then(()=>parcelRequire('c3Lzg'));

});

parcelRegister("2Ojyn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("j4Rs6")),
    import("jcqSx")
]).then(()=>parcelRequire('6FPkd'));

});

parcelRegister("2stJ7", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("dgqiQ")),
    import("lwWii")
]).then(()=>parcelRequire('RYbCv'));

});

parcelRegister("fjBrn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("4IIEw")),
    import("bm07J")
]).then(()=>parcelRequire('kPPX4'));

});

parcelRegister("3J3bL", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("b5Yyp")),
    import("7pmn6")
]).then(()=>parcelRequire('2OCo7'));

});

parcelRegister("1vbX2", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("h5oqr")),
    import("3bwdi")
]).then(()=>parcelRequire('6xHwI'));

});

parcelRegister("hUlES", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("7urRs")),
    import("dNt1v")
]).then(()=>parcelRequire('c25LW'));

});

parcelRegister("6DM1h", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("jPLgw")),
    import("5AUyT")
]).then(()=>parcelRequire('3SA15'));

});

parcelRegister("dzpAn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("e6UiB")),
    import("18vrC")
]).then(()=>parcelRequire('au13I'));

});

parcelRegister("d6Xav", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("iggQ5")),
    import("cqdOO")
]).then(()=>parcelRequire('8yqmd'));

});

parcelRegister("cJkIq", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("3HDbo")),
    import("cG4R9")
]).then(()=>parcelRequire('i7PUb'));

});

parcelRegister("6lGXr", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("hS9Cv")),
    import("5KGRW")
]).then(()=>parcelRequire('iTTPa'));

});

parcelRegister("15yiX", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("2hLHd")),
    import("iVTYN")
]).then(()=>parcelRequire('4YCq1'));

});

parcelRegister("6vPpd", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("18YZN")),
    import("bejyd")
]).then(()=>parcelRequire('3HuE9'));

});

parcelRegister("gbUAN", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("gjW8g")),
    import("iusck")
]).then(()=>parcelRequire('hgPKF'));

});

parcelRegister("27hl4", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("iyuR2")),
    import("6XjPd")
]).then(()=>parcelRequire('4oAUr'));

});

parcelRegister("gzEm7", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("g8HrZ")),
    import("fjFOt")
]).then(()=>parcelRequire('6PCTz'));

});

parcelRegister("DLRNL", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("cfVMg")),
    import("fM5BC")
]).then(()=>parcelRequire('ioai4'));

});

parcelRegister("eok9Z", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("3yMQT")),
    import("kJaMs")
]).then(()=>parcelRequire('5UQoI'));

});

parcelRegister("glDOh", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("3qnA9")),
    import("2sSTQ")
]).then(()=>parcelRequire('2axkV'));

});

parcelRegister("3BED8", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("kQgyK")),
    import("cYGUN")
]).then(()=>parcelRequire('dVDoA'));

});

parcelRegister("feuok", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("2Im6W")),
    import("b43aL"),
    import("9HPTi")
]).then(()=>parcelRequire('gOvFY'));

});

parcelRegister("jybMt", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("LqXtR")),
    import("fqGyk")
]).then(()=>parcelRequire('c8v2l'));

});

parcelRegister("2syr7", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("dJ92B")),
    import("lALth")
]).then(()=>parcelRequire('8UNvp'));

});

parcelRegister("fZ9TT", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("bdsA7")),
    import("9lFKv")
]).then(()=>parcelRequire('jOyXf'));

});

parcelRegister("CwCVJ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("c5Z5E")),
    import("g3Uzr"),
    import("cR4KY"),
    import("1bQnR"),
    import("jTjnz")
]).then(()=>parcelRequire('7OIQF'));

});

parcelRegister("7L8hB", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("f9IW1")),
    import("deEVb")
]).then(()=>parcelRequire('9z1yz'));

});



parcelRegister("j9Lha", function(module, exports) {

$parcel$export(module.exports, "render", () => $df238791ae948f70$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $df238791ae948f70$var$_hoisted_1 = {
    class: "snav",
    "aria-label": "Site sections"
};
const $df238791ae948f70$var$_hoisted_2 = {
    class: "snav-inner"
};
const $df238791ae948f70$var$_hoisted_3 = [
    "aria-expanded"
];
const $df238791ae948f70$var$_hoisted_4 = {
    class: "snav-burger-ico"
};
const $df238791ae948f70$var$_hoisted_5 = [
    "href",
    "aria-current"
];
const $df238791ae948f70$var$_hoisted_6 = {
    class: "snav-emoji",
    "aria-hidden": "true"
};
const $df238791ae948f70$var$_hoisted_7 = {
    class: "snav-label"
};
const $df238791ae948f70$var$_hoisted_8 = {
    key: 0,
    class: "snav-caret",
    "aria-hidden": "true"
};
const $df238791ae948f70$var$_hoisted_9 = {
    key: 0,
    class: "snav-mega"
};
const $df238791ae948f70$var$_hoisted_10 = {
    class: "snav-mega-head"
};
const $df238791ae948f70$var$_hoisted_11 = {
    class: "snav-mega-title"
};
const $df238791ae948f70$var$_hoisted_12 = {
    class: "snav-mega-sub"
};
const $df238791ae948f70$var$_hoisted_13 = {
    class: "snav-mega-grid"
};
const $df238791ae948f70$var$_hoisted_14 = [
    "href"
];
const $df238791ae948f70$var$_hoisted_15 = {
    class: "snav-sub-label"
};
const $df238791ae948f70$var$_hoisted_16 = {
    class: "snav-sub-desc"
};
const $df238791ae948f70$var$_hoisted_17 = {
    key: 1,
    class: "snav-tip"
};
const $df238791ae948f70$var$_hoisted_18 = {
    class: "snav-actions"
};
function $df238791ae948f70$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("nav", $df238791ae948f70$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $df238791ae948f70$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("button", {
                class: "snav-burger",
                onClick: _cache[0] || (_cache[0] = ($event)=>$data.menuOpen = !$data.menuOpen),
                "aria-expanded": String($data.menuOpen),
                "aria-label": "Menu"
            }, [
                (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_4, (0, $8POXm.toDisplayString)($data.menuOpen ? "\u2715" : "\u2630"), 1)
            ], 8, $df238791ae948f70$var$_hoisted_3),
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)([
                    "snav-tabs",
                    {
                        open: $data.menuOpen
                    }
                ])
            }, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.tabs, (t)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: t.key,
                        class: (0, $8POXm.normalizeClass)([
                            "snav-item",
                            [
                                {
                                    'has-children': t.children
                                },
                                'snav-item-' + t.key
                            ]
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("a", {
                            href: t.href,
                            class: (0, $8POXm.normalizeClass)([
                                "snav-tab",
                                [
                                    'snav-' + t.key,
                                    {
                                        active: t.key === $options.activeKey
                                    }
                                ]
                            ]),
                            "aria-current": t.key === $options.activeKey ? 'page' : null,
                            onClick: _cache[1] || (_cache[1] = ($event)=>$data.menuOpen = false)
                        }, [
                            (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_6, (0, $8POXm.toDisplayString)(t.emoji), 1),
                            (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_7, (0, $8POXm.toDisplayString)(t.label), 1),
                            t.children ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $df238791ae948f70$var$_hoisted_8, "\u25BE")) : (0, $TusQn.createCommentVNode)("", true)
                        ], 10, $df238791ae948f70$var$_hoisted_5),
                        t.children ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $df238791ae948f70$var$_hoisted_9, [
                            (0, $TusQn.createElementVNode)("div", $df238791ae948f70$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_11, (0, $8POXm.toDisplayString)(t.emoji) + " " + (0, $8POXm.toDisplayString)(t.label), 1),
                                (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_12, (0, $8POXm.toDisplayString)(t.desc), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $df238791ae948f70$var$_hoisted_13, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(t.children, (c)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: c.href,
                                        href: c.href,
                                        class: (0, $8POXm.normalizeClass)([
                                            "snav-sub",
                                            {
                                                active: $options.childActive(c.href)
                                            }
                                        ]),
                                        onClick: _cache[2] || (_cache[2] = ($event)=>$data.menuOpen = false)
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_15, (0, $8POXm.toDisplayString)(c.label), 1),
                                        (0, $TusQn.createElementVNode)("span", $df238791ae948f70$var$_hoisted_16, (0, $8POXm.toDisplayString)(c.desc), 1)
                                    ], 10, $df238791ae948f70$var$_hoisted_14);
                                }), 128))
                            ])
                        ])) : t.desc ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $df238791ae948f70$var$_hoisted_17, (0, $8POXm.toDisplayString)(t.desc), 1)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 2);
                }), 128))
            ], 2),
            (0, $TusQn.createElementVNode)("div", $df238791ae948f70$var$_hoisted_18, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "actions")
            ])
        ])
    ]);
}

});

parcelRegister("dR83w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16679560095dd82$export$2e2bcd8739ae039);
let $a16679560095dd82$var$NOOP = ()=>{};
var $a16679560095dd82$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5dltK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbed3e63925d305$export$2e2bcd8739ae039);
let $3cbed3e63925d305$var$script;




let $3cbed3e63925d305$var$initialize = ()=>{
    $3cbed3e63925d305$var$script = (parcelRequire("2gLKy"));
    if ($3cbed3e63925d305$var$script.__esModule) $3cbed3e63925d305$var$script = $3cbed3e63925d305$var$script.default;
    $3cbed3e63925d305$var$script.render = (parcelRequire("54nmD")).render;
    $3cbed3e63925d305$var$script.__cssModules = {};
    (parcelRequire("31vSI")).default($3cbed3e63925d305$var$script);
    $3cbed3e63925d305$var$script.__scopeId = 'data-v-6ba4ec';
    $3cbed3e63925d305$var$script.__file = "BotDownBanner.vue";
};
$3cbed3e63925d305$var$initialize();
var $3cbed3e63925d305$export$2e2bcd8739ae039 = $3cbed3e63925d305$var$script;

});
parcelRegister("2gLKy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a721d86fc4bf796$export$2e2bcd8739ae039);
// The "wiznaibot is down" banner, on the bracket page and the Wiznaibot page. It asks the
// betting bot's health endpoint (through the wiznaibot-health Function) every 5 minutes,
// and lib/botHealth.js decides. The point is for viewers to see it: on 2026-09-25 the bot
// lost Twitch chat and nobody noticed for three days. Add `?botdown` to the URL to see it.

var $cSJ88 = parcelRequire("cSJ88");
const $1a721d86fc4bf796$var$POLL_MS = 300000;
const $1a721d86fc4bf796$var$RECHECK_MS = 60000; // after the first "didn't answer", in case it was a blip
const $1a721d86fc4bf796$var$DISMISS_KEY = 'wiznaibus.botDownDismissed';
var $1a721d86fc4bf796$export$2e2bcd8739ae039 = {
    name: 'BotDownBanner',
    props: {
        // The live tournament's LastMod, so it can tell whether the bot is missing matches.
        // Leave it null anywhere else.
        lastMod: {
            type: [
                String,
                Number
            ],
            default: null
        }
    },
    data () {
        return {
            status: 0,
            health: null,
            misses: 0,
            reason: null,
            test: false,
            dismissed: null,
            timer: null
        };
    },
    computed: {
        onBotPage () {
            return new URLSearchParams(location.search).has('wiznaibot');
        },
        // A new outage, or a new stage of this one, shows again after a dismissal.
        key () {
            return this.reason ? this.reason.kind + ':' + (this.reason.since || '') : '';
        },
        shown () {
            return !!this.reason && this.dismissed !== this.key;
        },
        why () {
            const r = this.reason, t = r && r.since ? this.when(r.since) : '';
            switch(r && r.kind){
                case 'unreachable':
                    return "Its server isn't answering.";
                case 'offline':
                    return t ? `It's been disconnected from Twitch chat since ${t}.` : "It can't connect to Twitch chat.";
                case 'quiet':
                    return `It hasn't heard anything from Twitch chat since ${t}.`;
                case 'missing':
                    return `Matches are being played, but it hasn't seen betting open since ${t || 'it started'}.`;
                case 'test':
                    return 'This is only a test: the URL has ?botdown in it.';
                default:
                    return '';
            }
        }
    },
    watch: {
        lastMod () {
            this.judge();
        }
    },
    created () {
        try {
            this.dismissed = sessionStorage.getItem($1a721d86fc4bf796$var$DISMISS_KEY);
        } catch  {}
        if (new URLSearchParams(location.search).has('botdown')) {
            this.test = true;
            this.reason = {
                kind: 'test',
                since: null
            };
            return;
        }
        this.timer = setTimeout(this.check, 3000); // let the page's own loads go first
    },
    beforeUnmount () {
        clearTimeout(this.timer);
    },
    methods: {
        async check () {
            let status = 0, health = null;
            try {
                const res = await fetch('/.netlify/functions/wiznaibot-health');
                status = res.status;
                health = await res.json().catch(()=>null);
            } catch  {}
            this.status = status;
            this.health = health;
            const missed = status === 502 || status === 504;
            this.misses = missed ? this.misses + 1 : 0;
            this.judge();
            this.timer = setTimeout(this.check, this.misses === 1 ? $1a721d86fc4bf796$var$RECHECK_MS : $1a721d86fc4bf796$var$POLL_MS);
        },
        judge () {
            if (this.test) return;
            const r = (0, $cSJ88.botDownReason)({
                status: this.status,
                health: this.health,
                lastMod: this.lastMod
            });
            this.reason = r && r.kind === 'unreachable' && this.misses < 2 ? null : r;
        },
        when (ms) {
            const d = new Date(ms), time = d.toLocaleTimeString([], {
                hour: 'numeric',
                minute: '2-digit'
            });
            return d.toDateString() === new Date().toDateString() ? time : d.toLocaleDateString([], {
                month: 'short',
                day: 'numeric'
            }) + ', ' + time;
        },
        dismiss () {
            this.dismissed = this.key;
            try {
                sessionStorage.setItem($1a721d86fc4bf796$var$DISMISS_KEY, this.key);
            } catch  {}
        }
    }
};

});
parcelRegister("cSJ88", function(module, exports) {

$parcel$export(module.exports, "botDownReason", () => $960d8914115230b9$export$24c6e9004832880b);
// Is wiznaibot (the Twitch betting bot) down? Decides the homepage's "wiznaibot is
// down" banner.
//
// The input is the bot's /health.json, fetched through the wiznaibot-health Function.
// The service showing "active" proves nothing: on 2026-09-25 the process kept running
// for three days after it lost Twitch chat. So this asks whether the bot is logged in to
// chat, whether anything is arriving, and, on the live bracket, whether it heard betting
// open for the matches being played. Only positive evidence counts. A missing or
// old-format answer is "unknown", so the banner can't cry wolf while the bot is fine.
// Logged out of chat this long. The bot retries within a minute, so this is a real outage.
const $960d8914115230b9$export$46fb6f9841f2f769 = 600000;
const $960d8914115230b9$export$2b7d3918e91d1f3f = 900000;
const $960d8914115230b9$export$45a27ace0aa81666 = 1800000;
function $960d8914115230b9$export$24c6e9004832880b({ status: status, health: health, lastMod: lastMod } = {}) {
    if (status === 502 || status === 504) return {
        kind: 'unreachable',
        since: null
    };
    if (status !== 200 || !health || typeof health.connected !== 'boolean' || !health.now) return null;
    const now = health.now; // the bot's own clock, so its timestamps compare cleanly
    if (!health.connected) {
        const since = health.since || health.startedAt;
        return since && now - since > $960d8914115230b9$export$46fb6f9841f2f769 ? {
            kind: 'offline',
            since: since
        } : null;
    }
    if (health.lastDataAt && now - health.lastDataAt > $960d8914115230b9$export$2b7d3918e91d1f3f) return {
        kind: 'quiet',
        since: health.lastDataAt
    };
    const mod = typeof lastMod === 'string' ? Date.parse(lastMod) : lastMod;
    if (mod) {
        // A fresh login or restart starts the clock over.
        const heard = Math.max(health.lastOpenAt || 0, health.since || 0, health.startedAt || 0);
        if (mod - heard > $960d8914115230b9$export$45a27ace0aa81666) return {
            kind: 'missing',
            since: health.lastOpenAt || null
        };
    }
    return null;
}

});


parcelRegister("54nmD", function(module, exports) {

$parcel$export(module.exports, "render", () => $3b0f731cbc7b7712$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $3b0f731cbc7b7712$var$_hoisted_1 = {
    key: 0,
    class: "bot-down",
    role: "alert"
};
const $3b0f731cbc7b7712$var$_hoisted_2 = {
    class: "bd-why"
};
const $3b0f731cbc7b7712$var$_hoisted_3 = {
    key: 0,
    class: "bd-link",
    href: "?wiznaibot"
};
function $3b0f731cbc7b7712$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $options.shown ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3b0f731cbc7b7712$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("button", {
            class: "bd-dismiss",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.dismiss && $options.dismiss(...args)),
            title: "Hide this until something changes",
            "aria-label": "Hide this until something changes"
        }, "\u2715"),
        _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("b", null, "\uD83C\uDD98 Help, wiznaibot is down! Please contact Luxor.", -1)),
        (0, $TusQn.createElementVNode)("span", $3b0f731cbc7b7712$var$_hoisted_2, (0, $8POXm.toDisplayString)($options.why), 1),
        !$options.onBotPage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", $3b0f731cbc7b7712$var$_hoisted_3, "Wiznaibot page \u2192")) : (0, $TusQn.createCommentVNode)("", true)
    ])) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("31vSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $233a3214ad561ab3$export$2e2bcd8739ae039);
let $233a3214ad561ab3$var$NOOP = ()=>{};
var $233a3214ad561ab3$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9J7hU", function(module, exports) {

$parcel$export(module.exports, "default", () => $714df83dd0ca2468$export$2e2bcd8739ae039);
let $714df83dd0ca2468$var$script;




let $714df83dd0ca2468$var$initialize = ()=>{
    $714df83dd0ca2468$var$script = (parcelRequire("1T2mx"));
    if ($714df83dd0ca2468$var$script.__esModule) $714df83dd0ca2468$var$script = $714df83dd0ca2468$var$script.default;
    $714df83dd0ca2468$var$script.render = (parcelRequire("2ULNh")).render;
    $714df83dd0ca2468$var$script.__cssModules = {};
    (parcelRequire("jL0WD")).default($714df83dd0ca2468$var$script);
    $714df83dd0ca2468$var$script.__scopeId = 'data-v-3795df';
    $714df83dd0ca2468$var$script.__file = "RecentTicker.vue";
};
$714df83dd0ca2468$var$initialize();
var $714df83dd0ca2468$export$2e2bcd8739ae039 = $714df83dd0ca2468$var$script;

});
parcelRegister("1T2mx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $15fcc2ab1d1fd121$export$2e2bcd8739ae039);
// The bracket page's "just happened" strip: the last week's title milestones, quest
// completions, long reigns and more, newest first, from recentEvents.json (built on the
// refresh box after every tournament; see tools/buildRecentEvents.mjs). It re-reads the
// newest manifest every 10 minutes, so an open tab picks up new events.
//
// It scrolls only when the lines don't fit, pauses under the mouse or keyboard focus,
// and holds still (scrollable by hand) for anyone with reduced motion turned on.
// Settings has a switch to hide it (prefs.showTicker).

var $gKfUi = parcelRequire("gKfUi");

var $cElFe = parcelRequire("cElFe");
const $15fcc2ab1d1fd121$var$REFRESH_MS = 600000;
const $15fcc2ab1d1fd121$var$SPEED = 45; // px per second
var $15fcc2ab1d1fd121$export$2e2bcd8739ae039 = {
    name: 'RecentTicker',
    data () {
        return {
            events: [],
            key: '',
            now: Date.now(),
            moving: false,
            duration: 60,
            timer: null
        };
    },
    computed: {
        lines () {
            return this.events.map((e)=>{
                const l = (0, $cElFe.eventLine)(e);
                return l && {
                    ...l,
                    ago: (0, $cElFe.ago)(e.t, this.now)
                };
            }).filter(Boolean);
        },
        // Two copies while moving: the track slides left by exactly one copy, then repeats.
        shown () {
            return this.moving ? [
                ...this.lines,
                ...this.lines
            ] : this.lines;
        }
    },
    created () {
        this.refresh();
        this.timer = setInterval(this.refresh, $15fcc2ab1d1fd121$var$REFRESH_MS);
    },
    mounted () {
        this.onResize = ()=>{
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(this.measure, 200);
        };
        window.addEventListener('resize', this.onResize);
    },
    beforeUnmount () {
        clearInterval(this.timer);
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        async refresh () {
            this.now = Date.now();
            try {
                const m = await (0, $gKfUi.latestManifest)();
                const key = m && m.files && m.files['recentEvents.json'];
                if (!key || key === this.key) return;
                const data = await (0, $gKfUi.loadFile)(key);
                this.key = key;
                this.events = data && data.events || [];
                this.measure();
            } catch  {}
        },
        // Scroll only if one copy of the lines is wider than the space for them.
        async measure () {
            this.moving = false;
            await this.$nextTick();
            const track = this.$refs.track, viewport = this.$refs.viewport;
            if (!track || !viewport) return;
            const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const width = track.scrollWidth;
            if (reduced || width <= viewport.clientWidth) return;
            this.duration = Math.round(width / $15fcc2ab1d1fd121$var$SPEED);
            this.moving = true;
        }
    }
};

});
parcelRegister("cElFe", function(module, exports) {

$parcel$export(module.exports, "eventLine", () => $935a067b962d2d0f$export$fc78b3ed5191c538);
$parcel$export(module.exports, "ago", () => $935a067b962d2d0f$export$bace04f551fc2d3a);
// Lines for the bracket page's "just happened" ticker, from recentEvents.json (built on
// the refresh box by tools/buildRecentEvents.mjs, which documents the event shapes).
// The quests an event can name: goals.js's ids plus the two with their own data files.
const $935a067b962d2d0f$export$7fa87d679ae195bc = {
    monster: [
        "\uD83D\uDC09",
        'the Monster Quest'
    ],
    carried: [
        "\uD83E\uDD1D",
        'Carried by Monsters'
    ],
    human: [
        "\uD83D\uDDE1\uFE0F",
        'the Human Quest'
    ],
    everything: [
        "\uD83C\uDF0D",
        'the Everything Quest'
    ],
    gendered: [
        "\u26A5",
        'the Human Gendered Quest'
    ],
    bagel: [
        "\uD83E\uDD6F",
        'the Everything Bagel'
    ],
    zodiac: [
        "\u2B50",
        'the Zodiac Quest'
    ],
    raidboss: [
        "\uD83D\uDC79",
        'the Raid Boss Quest'
    ],
    gift: [
        "\uD83C\uDF81",
        'the Gift Quest'
    ],
    loser1: [
        "\uD83D\uDEAA",
        'First-Round Exit (Miku Quest)'
    ],
    loser2: [
        "\uD83D\uDC94",
        'Semifinal Heartbreak (Miku Quest)'
    ],
    loser3: [
        "\uD83E\uDD48",
        'So Close (Miku Quest)'
    ],
    loser4: [
        "\uD83D\uDC90",
        'Always the Bridesmaid (Miku Quest)'
    ]
};
function $935a067b962d2d0f$export$7bb39f879164e4ac(n) {
    const t = n % 100, s = t >= 11 && t <= 13 ? 'th' : ({
        1: 'st',
        2: 'nd',
        3: 'rd'
    })[n % 10] || 'th';
    return n.toLocaleString('en-US') + s;
}
// "A, B, C and D"
const $935a067b962d2d0f$var$joinNames = (a)=>a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
const $935a067b962d2d0f$var$profile = (p, tab)=>'?player=' + encodeURIComponent(p) + (tab ? '&tab=' + tab : '');
function $935a067b962d2d0f$export$fc78b3ed5191c538(e) {
    switch(e && e.k){
        case 'title':
            return {
                emoji: "\uD83C\uDFC6",
                who: e.p,
                what: e.n === 1 ? 'won their first title!' : `won their ${$935a067b962d2d0f$export$7bb39f879164e4ac(e.n)} title`,
                href: $935a067b962d2d0f$var$profile(e.p)
            };
        case 'quest':
            {
                const [emoji, name] = $935a067b962d2d0f$export$7fa87d679ae195bc[e.q] || [
                    "\uD83C\uDFC5",
                    'a quest'
                ];
                return {
                    emoji: emoji,
                    who: e.p,
                    what: `completed ${name}` + (e.n > 1 ? ` for the ${$935a067b962d2d0f$export$7bb39f879164e4ac(e.n)} time` : '!'),
                    href: $935a067b962d2d0f$var$profile(e.p, 'achievements')
                };
            }
        case 'reign':
            return {
                emoji: "\uD83D\uDEE1\uFE0F",
                who: $935a067b962d2d0f$var$joinNames(e.p || []),
                what: `have held the belt for ${e.n} tournaments`,
                href: '?crown'
            };
        case 'raidboss':
            return {
                emoji: "\uD83D\uDC79",
                who: e.p,
                what: `won a title as a raid-boss ${e.cls}`,
                href: $935a067b962d2d0f$var$profile(e.p)
            };
        case 'gifts':
            return {
                emoji: "\uD83C\uDF81",
                who: e.p,
                what: `gave their ${$935a067b962d2d0f$export$7bb39f879164e4ac(e.n)} gift`,
                href: $935a067b962d2d0f$var$profile(e.p, 'chat')
            };
        default:
            return null;
    }
}
function $935a067b962d2d0f$export$bace04f551fc2d3a(ms, now = Date.now()) {
    const min = Math.round((now - ms) / 60000);
    if (min < 1) return 'just now';
    if (min < 60) return min + ' min ago';
    const h = Math.round(min / 60);
    return h < 48 ? h + 'h ago' : Math.round(h / 24) + 'd ago';
}

});


parcelRegister("2ULNh", function(module, exports) {

$parcel$export(module.exports, "render", () => $21f5e298ea8bbcbc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $21f5e298ea8bbcbc$var$_hoisted_1 = {
    key: 0,
    class: "rt",
    role: "region",
    "aria-label": "Recent achievements"
};
const $21f5e298ea8bbcbc$var$_hoisted_2 = [
    "href",
    "tabindex",
    "aria-hidden"
];
const $21f5e298ea8bbcbc$var$_hoisted_3 = {
    class: "rt-emoji"
};
const $21f5e298ea8bbcbc$var$_hoisted_4 = {
    class: "rt-ago"
};
function $21f5e298ea8bbcbc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $options.lines.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $21f5e298ea8bbcbc$var$_hoisted_1, [
        _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("span", {
            class: "rt-label"
        }, "\uD83C\uDF89 Just happened", -1)),
        (0, $TusQn.createElementVNode)("div", {
            ref: "viewport",
            class: (0, $8POXm.normalizeClass)([
                "rt-viewport",
                {
                    faded: $data.moving
                }
            ])
        }, [
            (0, $TusQn.createElementVNode)("div", {
                ref: "track",
                class: (0, $8POXm.normalizeClass)([
                    "rt-track",
                    {
                        moving: $data.moving
                    }
                ]),
                style: (0, $8POXm.normalizeStyle)($data.moving ? {
                    animationDuration: $data.duration + 's'
                } : null)
            }, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.shown, (l, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                        key: i,
                        class: "rt-item",
                        href: l.href,
                        tabindex: i >= $options.lines.length ? -1 : null,
                        "aria-hidden": i >= $options.lines.length ? 'true' : null
                    }, [
                        (0, $TusQn.createElementVNode)("span", $21f5e298ea8bbcbc$var$_hoisted_3, (0, $8POXm.toDisplayString)(l.emoji), 1),
                        _cache[0] || (_cache[0] = (0, $TusQn.createTextVNode)()),
                        (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)(l.who), 1),
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(l.what) + " ", 1),
                        (0, $TusQn.createElementVNode)("span", $21f5e298ea8bbcbc$var$_hoisted_4, (0, $8POXm.toDisplayString)(l.ago), 1)
                    ], 8, $21f5e298ea8bbcbc$var$_hoisted_2);
                }), 128))
            ], 6)
        ], 2)
    ])) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("jL0WD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62323b67dac7327$export$2e2bcd8739ae039);
let $e62323b67dac7327$var$NOOP = ()=>{};
var $e62323b67dac7327$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cpXsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a5f00dc9d70d31$export$2e2bcd8739ae039);
let $90a5f00dc9d70d31$var$script;




let $90a5f00dc9d70d31$var$initialize = ()=>{
    $90a5f00dc9d70d31$var$script = (parcelRequire("3hshW"));
    if ($90a5f00dc9d70d31$var$script.__esModule) $90a5f00dc9d70d31$var$script = $90a5f00dc9d70d31$var$script.default;
    $90a5f00dc9d70d31$var$script.render = (parcelRequire("dSpYr")).render;
    $90a5f00dc9d70d31$var$script.__cssModules = {};
    (parcelRequire("hiHPb")).default($90a5f00dc9d70d31$var$script);
    $90a5f00dc9d70d31$var$script.__scopeId = 'data-v-610776';
    $90a5f00dc9d70d31$var$script.__file = "ColiseumPromo.vue";
};
$90a5f00dc9d70d31$var$initialize();
var $90a5f00dc9d70d31$export$2e2bcd8739ae039 = $90a5f00dc9d70d31$var$script;

});
parcelRegister("3hshW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2638e717760864c4$export$2e2bcd8739ae039);
// The Clockwork Coliseum promo under the Champ Match cell. Live news from the game's public
// API (the reigning champion, the fight on screen, the season race…) rotates through it;
// the slide text is built in lib/coliseumPromo.js.

var $51PuF = parcelRequire("51PuF");
const $2638e717760864c4$var$SITE = 'https://clockworkcoliseum.com';
const $2638e717760864c4$var$ROTATE_MS = 7000;
const $2638e717760864c4$var$REFRESH_MS = 180000;
// Each slide opens the page it's about.
const $2638e717760864c4$var$PAGE = {
    champ: '/champions',
    race: '/seasons',
    toc: '/seasons'
};
const $2638e717760864c4$var$FONTS = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700&family=Barlow+Condensed:wght@600;700&display=swap';
async function $2638e717760864c4$var$getJson(path) {
    const r = await fetch((0, $51PuF.API) + path, {
        signal: AbortSignal.timeout(8000)
    });
    if (!r.ok) throw new Error(`${path}: HTTP ${r.status}`);
    return r.json();
}

var $2638e717760864c4$export$2e2bcd8739ae039 = {
    name: 'ColiseumPromo',
    data () {
        return {
            data: {},
            index: 0,
            hover: false,
            fetchedAt: 0,
            logo: new URL((parcelRequire("fGzSY"))).href
        };
    },
    computed: {
        slides () {
            return (0, $51PuF.withFallback)((0, $51PuF.buildSlides)(this.data));
        },
        slide () {
            return this.slides[this.index % this.slides.length];
        },
        href () {
            return $2638e717760864c4$var$SITE + ($2638e717760864c4$var$PAGE[this.slide.key] || '/');
        }
    },
    mounted () {
        // The game's own typefaces (Cinzel, Barlow Condensed), once per page.
        if (!document.querySelector('link[data-ccp-fonts]')) {
            const l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = $2638e717760864c4$var$FONTS;
            l.dataset.ccpFonts = '';
            document.head.appendChild(l);
        }
        this.refresh();
        this.rotateTimer = setInterval(()=>{
            if (!this.hover && document.visibilityState === 'visible' && this.slides.length > 1) this.index = (this.index + 1) % this.slides.length;
        }, $2638e717760864c4$var$ROTATE_MS);
        this.refreshTimer = setInterval(()=>this.refresh(), $2638e717760864c4$var$REFRESH_MS);
        this.onVisible = ()=>{
            if (document.visibilityState === 'visible' && Date.now() - this.fetchedAt > $2638e717760864c4$var$REFRESH_MS) this.refresh();
        };
        document.addEventListener('visibilitychange', this.onVisible);
    },
    beforeUnmount () {
        clearInterval(this.rotateTimer);
        clearInterval(this.refreshTimer);
        document.removeEventListener('visibilitychange', this.onVisible);
    },
    methods: {
        // Each endpoint on its own: one failing just drops its slide. A hidden tab doesn't poll.
        async refresh () {
            if (document.visibilityState !== 'visible' && this.fetchedAt) return;
            this.fetchedAt = Date.now();
            const [state, champion, pulse, season] = await Promise.allSettled([
                '/state',
                '/champion',
                '/pulse',
                '/season'
            ].map($2638e717760864c4$var$getJson));
            const val = (x)=>x.status === 'fulfilled' ? x.value : undefined;
            this.data = {
                state: val(state),
                champion: val(champion),
                pulse: val(pulse),
                season: val(season)
            };
        }
    }
};

});
parcelRegister("51PuF", function(module, exports) {

$parcel$export(module.exports, "API", () => $3a94fd4fbc885beb$export$2c4e825dc9120f87);
$parcel$export(module.exports, "buildSlides", () => $3a94fd4fbc885beb$export$8ae7afce61c150e5);
$parcel$export(module.exports, "withFallback", () => $3a94fd4fbc885beb$export$4343ef9e6fe64d4b);
// The Clockwork Coliseum promo under the Champ Match cell: rotating "slides" built from
// the game's public read API (https://api.clockworkcoliseum.com, CORS-open). Pure — the
// component fetches, this turns whatever came back into slides, skipping any it can't
// fill. Every slide is { key, kicker, title, sub }.
const $3a94fd4fbc885beb$export$2c4e825dc9120f87 = 'https://api.clockworkcoliseum.com';
const $3a94fd4fbc885beb$export$c0516ecf091c8a94 = {
    code: 'WIZNAIBUS',
    reward: '750 renown, 500 coin, the new Geomancer, Oracle and Gambler, and two boon charms'
};
function $3a94fd4fbc885beb$export$9a7159eef9e29c43(mapId) {
    const base = String(mapId || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
    return base.replace(/\b([a-z])/g, (m)=>m.toUpperCase());
}
function $3a94fd4fbc885beb$export$78a6069681ed2665(n) {
    const t = String(n);
    return t.startsWith('8') || t === '11' || t === '18' ? 'An' : 'A';
}
function $3a94fd4fbc885beb$export$7bb39f879164e4ac(n) {
    const t = n % 100, s = t >= 11 && t <= 13 ? 'th' : ({
        1: 'st',
        2: 'nd',
        3: 'rd'
    })[n % 10] || 'th';
    return n + s;
}
function $3a94fd4fbc885beb$export$3423f8ebcf2c1e73(toc) {
    if (!toc || !toc.rank) return '';
    const w = (n)=>n === 1 ? 'one win' : `${n} wins`;
    if (toc.rank === 1) return 'They lead the race to the Tournament of Champions!';
    if (toc.nextLabel) return `${$3a94fd4fbc885beb$export$7bb39f879164e4ac(toc.rank)} in the ToC race, ${w(toc.toNext)} from passing ${toc.nextLabel}.`;
    return `${w(toc.toNext)} from the ToC race's top 14.`.replace(/^./, (c)=>c.toUpperCase());
}
// 2,365,000 → "2,365,000"
const $3a94fd4fbc885beb$var$num = (n)=>Number(n).toLocaleString('en-US');
function $3a94fd4fbc885beb$export$f52e29715bba3529(ms) {
    const m = Math.max(0, Math.round(ms / 60000));
    const d = Math.floor(m / 1440), h = Math.floor(m % 1440 / 60), mm = m % 60;
    return d ? `${d}d ${h}h` : h ? `${h}h ${mm}m` : `${mm}m`;
}
function $3a94fd4fbc885beb$export$8ae7afce61c150e5(data = {}, { now: now = Date.now(), code: code = $3a94fd4fbc885beb$export$c0516ecf091c8a94 } = {}) {
    const { state: state, champion: champion, pulse: pulse, season: season } = data;
    const snap = state && state.snapshot || {};
    const koth = snap.koth || {};
    const slides = [];
    // 👑 The reigning champion and their streak, against the season record. That's the top
    // peak in the season race (/season), not koth.longestStreak: the server fills that with
    // the best reign STARTED this season, which misses a reign carried over from the last one
    // (Magnar's Mantises' 8 in Season 4, where koth said 6).
    const champLabel = koth.championLabel || champion && champion.label;
    if (champLabel) {
        const streak = koth.championStreak ?? (champion && champion.streak) ?? 0;
        const record = Math.max(koth.longestStreak || 0, ...(season && season.race || []).map((r)=>r.peak || 0));
        const classes = (champion && champion.label === champLabel && champion.units || []).map((u)=>u.cls).filter(Boolean);
        const wins = `${streak} win${streak === 1 ? '' : 's'} in a row`;
        const toc = $3a94fd4fbc885beb$export$3423f8ebcf2c1e73(koth.toc);
        let sub;
        if (!streak) sub = 'Freshly crowned. Knock them off before they settle in.';
        else if (record && streak >= record) sub = `${wins} \u{2014} a new season record!`;
        else if (record && streak === record - 1) sub = `${wins}, one from the season record (${record}).`;
        else if (toc) sub = `${wins}. ${toc}`;
        else sub = `${wins}. Can your fighter dethrone them?`;
        slides.push({
            key: 'champ',
            kicker: "\uD83D\uDC51 Reigning champions",
            title: champLabel,
            sub: sub,
            detail: classes.join(" \xb7 ")
        });
    }
    // ⚔️ The fight on screen right now, and the sim's odds.
    if (snap.teamAName && snap.teamBName) {
        const a = snap.aWinPct, b = snap.bWinPct;
        const where = snap.mapId ? ` on ${$3a94fd4fbc885beb$export$9a7159eef9e29c43(snap.mapId)}` : '';
        let sub = `Live${where}.`;
        if (a != null && b != null) {
            const dog = a < b ? snap.teamAName : snap.teamBName, pct = Math.round(Math.min(a, b) * 100);
            sub = `Live${where}. ${dog} ${pct <= 25 ? 'need a miracle' : 'are the underdog'} at ${pct}%.`;
        }
        slides.push({
            key: 'live',
            kicker: "\u2694\uFE0F Fighting right now",
            title: `${snap.teamAName} vs ${snap.teamBName}`,
            sub: sub
        });
    }
    // 🎁 The site-only code.
    if (code && code.code) slides.push({
        key: 'code',
        kicker: "\uD83C\uDF81 Only on wiznaib.us",
        title: `Code ${code.code}`,
        sub: code.reward ? `${code.reward}.` : 'A welcome gift for new fighters.',
        detail: 'Redeem it when you join.'
    });
    // 🏟️ One big number that only grows.
    const battles = pulse && pulse.totals && pulse.totals.battles;
    if (battles) slides.push({
        key: 'battles',
        kicker: "\uD83C\uDFDF\uFE0F The arena never sleeps",
        title: `${$3a94fd4fbc885beb$var$num(battles)} battles fought`,
        sub: 'AI teams fight around the clock. Queue a fighter any time, even mid-match.'
    });
    // 🏆 The season: a countdown once the Tournament of Champions is scheduled, else the race.
    // The season's top `raceSize` (14) streaks reach the ToC: the top `qualifySlots` (7) go
    // straight into the tournament proper, the rest through the gauntlet.
    const s = season && season.season;
    if (s) {
        const field = season.raceSize || 14, seeded = season.qualifySlots || 7;
        const toc = s.tocAt ? new Date(s.tocAt).getTime() : NaN;
        const race = (season.race || [])[0];
        if (toc > now) slides.push({
            key: 'toc',
            kicker: `\u{1F3C6} Season ${s.id}`,
            title: `Tournament of Champions in ${$3a94fd4fbc885beb$export$f52e29715bba3529(toc - now)}`,
            sub: `The season's top ${seeded} streaks are in, and ${seeded + 1}\u{2013}${field} fight through the gauntlet.`
        });
        else if (race && race.label) {
            const into = season.tournament && s.startTournament ? season.tournament - s.startTournament + 1 : null;
            slides.push({
                key: 'race',
                kicker: `\u{1F3C6} Season ${s.id} race leader`,
                title: race.label,
                sub: `${$3a94fd4fbc885beb$export$78a6069681ed2665(race.peak)} ${race.peak}-win streak. Any of the season's top ${field} can reach the Tournament of Champions` + (into && s.length ? ` (tournament ${$3a94fd4fbc885beb$var$num(into)} of ${$3a94fd4fbc885beb$var$num(s.length)}).` : '.')
            });
        }
    }
    return slides;
}
const $3a94fd4fbc885beb$export$1b5fa103569d71ff = {
    key: 'pitch',
    kicker: "\u2694\uFE0F A web auto-battler",
    title: 'A 24/7 arena of AI teams',
    sub: 'Field your own fighter, bet on the fights, and call the shots from the stands.'
};
function $3a94fd4fbc885beb$export$4343ef9e6fe64d4b(slides) {
    return slides.some((x)=>x.key !== 'code') ? slides : [
        $3a94fd4fbc885beb$export$1b5fa103569d71ff,
        ...slides
    ];
}

});

parcelRegister("fGzSY", function(module, exports) {
module.exports = import.meta.resolve("bF12a");

});


parcelRegister("dSpYr", function(module, exports) {

$parcel$export(module.exports, "render", () => $a1a4775e2975821c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a1a4775e2975821c$var$_hoisted_1 = [
    "href"
];
const $a1a4775e2975821c$var$_hoisted_2 = {
    class: "ccp-head"
};
const $a1a4775e2975821c$var$_hoisted_3 = [
    "src"
];
const $a1a4775e2975821c$var$_hoisted_4 = {
    class: "ccp-kicker"
};
const $a1a4775e2975821c$var$_hoisted_5 = {
    class: "ccp-big"
};
const $a1a4775e2975821c$var$_hoisted_6 = {
    class: "ccp-sub"
};
const $a1a4775e2975821c$var$_hoisted_7 = {
    key: 0,
    class: "ccp-detail"
};
const $a1a4775e2975821c$var$_hoisted_8 = {
    key: 0,
    class: "ccp-dots",
    role: "group",
    "aria-label": "Clockwork Coliseum news"
};
const $a1a4775e2975821c$var$_hoisted_9 = [
    "aria-label",
    "aria-current",
    "onClick"
];
function $a1a4775e2975821c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "ccp",
        onMouseenter: _cache[0] || (_cache[0] = ($event)=>$data.hover = true),
        onMouseleave: _cache[1] || (_cache[1] = ($event)=>$data.hover = false),
        onFocusin: _cache[2] || (_cache[2] = ($event)=>$data.hover = true),
        onFocusout: _cache[3] || (_cache[3] = ($event)=>$data.hover = false)
    }, [
        (0, $TusQn.createElementVNode)("a", {
            class: "ccp-link",
            href: $options.href,
            target: "_blank",
            rel: "noopener",
            title: "Clockwork Coliseum \u2014 a web auto-battler from the people who build this site"
        }, [
            (0, $TusQn.createElementVNode)("span", $a1a4775e2975821c$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("img", {
                    class: "ccp-logo",
                    src: $data.logo,
                    alt: "",
                    width: "46",
                    height: "46"
                }, null, 8, $a1a4775e2975821c$var$_hoisted_3),
                _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("span", {
                    class: "ccp-names"
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        class: "ccp-crew"
                    }, "From the wiznaib.us crew"),
                    (0, $TusQn.createElementVNode)("span", {
                        class: "ccp-title"
                    }, "Clockwork Coliseum")
                ], -1))
            ]),
            _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("span", {
                class: "ccp-tagline"
            }, "A 24/7 FFT-style auto-battler, right in your browser", -1)),
            _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("span", {
                class: "ccp-rule"
            }, null, -1)),
            (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                name: "ccp-fade",
                mode: "out-in"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                            class: "ccp-slide",
                            key: $options.slide.key
                        }, [
                            (0, $TusQn.createElementVNode)("span", $a1a4775e2975821c$var$_hoisted_4, (0, $8POXm.toDisplayString)($options.slide.kicker), 1),
                            (0, $TusQn.createElementVNode)("span", $a1a4775e2975821c$var$_hoisted_5, (0, $8POXm.toDisplayString)($options.slide.title), 1),
                            (0, $TusQn.createElementVNode)("span", $a1a4775e2975821c$var$_hoisted_6, (0, $8POXm.toDisplayString)($options.slide.sub), 1),
                            $options.slide.detail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a1a4775e2975821c$var$_hoisted_7, (0, $8POXm.toDisplayString)($options.slide.detail), 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ]))
                    ]),
                _: 1
            }),
            _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("span", {
                class: "ccp-cta"
            }, "Enter the arena \u2192", -1))
        ], 8, $a1a4775e2975821c$var$_hoisted_1),
        $options.slides.length > 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a1a4775e2975821c$var$_hoisted_8, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.slides, (s, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                    key: s.key,
                    type: "button",
                    class: (0, $8POXm.normalizeClass)([
                        "ccp-dot",
                        {
                            on: i === $data.index
                        }
                    ]),
                    "aria-label": s.kicker,
                    "aria-current": i === $data.index ? 'true' : null,
                    onClick: ($event)=>$data.index = i
                }, null, 10, $a1a4775e2975821c$var$_hoisted_9);
            }), 128))
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ], 32);
}

});

parcelRegister("hiHPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9861cb944aaee7f$export$2e2bcd8739ae039);
let $c9861cb944aaee7f$var$NOOP = ()=>{};
var $c9861cb944aaee7f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("kSAcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f334ee40e0eca34a$export$2e2bcd8739ae039);
let $f334ee40e0eca34a$var$script;




let $f334ee40e0eca34a$var$initialize = ()=>{
    $f334ee40e0eca34a$var$script = (parcelRequire("7I2xs"));
    if ($f334ee40e0eca34a$var$script.__esModule) $f334ee40e0eca34a$var$script = $f334ee40e0eca34a$var$script.default;
    $f334ee40e0eca34a$var$script.render = (parcelRequire("bhuaK")).render;
    $f334ee40e0eca34a$var$script.__cssModules = {};
    (parcelRequire("dfubF")).default($f334ee40e0eca34a$var$script);
    $f334ee40e0eca34a$var$script.__scopeId = 'data-v-cc60d8';
    $f334ee40e0eca34a$var$script.__file = "WhatsNewModal.vue";
};
$f334ee40e0eca34a$var$initialize();
var $f334ee40e0eca34a$export$2e2bcd8739ae039 = $f334ee40e0eca34a$var$script;

});
parcelRegister("7I2xs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $59ce9c8f81f80e60$export$2e2bcd8739ae039);

var $8Iy0x = parcelRequire("8Iy0x");
var $59ce9c8f81f80e60$export$2e2bcd8739ae039 = {
    name: 'WhatsNewModal',
    mixins: [
        (0, $8Iy0x.default)
    ],
    emits: [
        'close',
        'tour'
    ],
    data () {
        return {
            features: [
                {
                    emoji: "\u2694\uFE0F",
                    title: 'Fight View + battle sim',
                    body: "Damage matrix, Monte-Carlo win odds, and a visual battle replay \u2014 on any bracket matchup."
                },
                {
                    emoji: "\uD83D\uDC64",
                    title: 'Player profiles',
                    body: "Your stats, achievements, quest progress, and championship history \u2014 all in one page."
                },
                {
                    emoji: "\uD83C\uDFC6",
                    title: 'Tournament of Champions',
                    body: 'Live champions leaderboard with a seeded bracket and sim odds, every season.'
                },
                {
                    emoji: "\uD83D\uDC65",
                    title: 'Players',
                    body: "17k-player directory \u2014 quests, boards, achievements, career stats, and full histories."
                },
                {
                    emoji: "\uD83D\uDDFA\uFE0F",
                    title: 'Maps',
                    body: '138 battle maps with class win-rate edges, 3D terrain viewer, and a height-calculator tool.'
                },
                {
                    emoji: "\uD83D\uDD0D",
                    title: 'Gear Lab',
                    body: "Search any item or pair \u2014 how often it rolls, its win rate, and what it pairs with."
                },
                {
                    emoji: "\uD83D\uDCCA",
                    title: 'Stats',
                    body: 'Win-rate analytics by class, skill, gear, Brave/Faith, and archetype, with trends.'
                },
                {
                    emoji: "\uD83C\uDFAF",
                    title: 'Goal tracker',
                    body: "Pin a quest or achievement as your goal \u2014 see what you need on the bracket page."
                }
            ]
        };
    }
};

});

parcelRegister("bhuaK", function(module, exports) {

$parcel$export(module.exports, "render", () => $8368afd60decf729$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8368afd60decf729$var$_hoisted_1 = {
    class: "wn",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "What's new"
};
const $8368afd60decf729$var$_hoisted_2 = {
    class: "wn-grid"
};
const $8368afd60decf729$var$_hoisted_3 = {
    class: "wn-feat-emoji"
};
const $8368afd60decf729$var$_hoisted_4 = {
    class: "wn-feat-text"
};
const $8368afd60decf729$var$_hoisted_5 = {
    class: "wn-feat-title"
};
const $8368afd60decf729$var$_hoisted_6 = {
    class: "wn-feat-body"
};
const $8368afd60decf729$var$_hoisted_7 = {
    class: "wn-foot"
};
function $8368afd60decf729$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay z2500 wn-overlay",
        onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "modal-close",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\u2715"),
            _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("div", {
                class: "wn-title"
            }, "\u2728 Welcome to Wiznaib.us", -1)),
            _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("div", {
                class: "wn-sub"
            }, "Luxor's companion site for FFTBG \u2014 everything the bracket doesn't tell you:", -1)),
            (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_2, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.features, (f)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: f.title,
                        class: "wn-feat"
                    }, [
                        (0, $TusQn.createElementVNode)("span", $8368afd60decf729$var$_hoisted_3, (0, $8POXm.toDisplayString)(f.emoji), 1),
                        (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_4, [
                            (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_5, (0, $8POXm.toDisplayString)(f.title), 1),
                            (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_6, (0, $8POXm.toDisplayString)(f.body), 1)
                        ])
                    ]);
                }), 128))
            ]),
            (0, $TusQn.createElementVNode)("div", $8368afd60decf729$var$_hoisted_7, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "wn-tour",
                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('tour'))
                }, "Take the tour \u2192"),
                (0, $TusQn.createElementVNode)("button", {
                    class: "wn-got",
                    onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('close'))
                }, "Got it, let me explore")
            ])
        ])
    ]);
}

});

parcelRegister("dfubF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a54179e5d6f573a$export$2e2bcd8739ae039);
let $9a54179e5d6f573a$var$NOOP = ()=>{};
var $9a54179e5d6f573a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8Bhv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $642f5ab41f4330bb$export$2e2bcd8739ae039);
let $642f5ab41f4330bb$var$script;




let $642f5ab41f4330bb$var$initialize = ()=>{
    $642f5ab41f4330bb$var$script = (parcelRequire("2P4xh"));
    if ($642f5ab41f4330bb$var$script.__esModule) $642f5ab41f4330bb$var$script = $642f5ab41f4330bb$var$script.default;
    $642f5ab41f4330bb$var$script.render = (parcelRequire("2kDyx")).render;
    $642f5ab41f4330bb$var$script.__cssModules = {};
    (parcelRequire("kwuOJ")).default($642f5ab41f4330bb$var$script);
    $642f5ab41f4330bb$var$script.__scopeId = 'data-v-0165d1';
    $642f5ab41f4330bb$var$script.__file = "SpotlightModal.vue";
};
$642f5ab41f4330bb$var$initialize();
var $642f5ab41f4330bb$export$2e2bcd8739ae039 = $642f5ab41f4330bb$var$script;

});
parcelRegister("2P4xh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $20e3dce39c808b75$export$2e2bcd8739ae039);

var $8Iy0x = parcelRequire("8Iy0x");
var $20e3dce39c808b75$export$2e2bcd8739ae039 = {
    name: 'SpotlightModal',
    mixins: [
        (0, $8Iy0x.default)
    ],
    emits: [
        'close'
    ],
    props: {
        updates: {
            type: Array,
            default: ()=>[]
        }
    }
};

});

parcelRegister("2kDyx", function(module, exports) {

$parcel$export(module.exports, "render", () => $1b2c221075aa0859$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $1b2c221075aa0859$var$_hoisted_1 = {
    class: "sl",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "What's new"
};
const $1b2c221075aa0859$var$_hoisted_2 = {
    class: "sl-list"
};
const $1b2c221075aa0859$var$_hoisted_3 = {
    class: "sl-emoji"
};
const $1b2c221075aa0859$var$_hoisted_4 = {
    class: "sl-body"
};
const $1b2c221075aa0859$var$_hoisted_5 = {
    class: "sl-head"
};
const $1b2c221075aa0859$var$_hoisted_6 = {
    class: "sl-name"
};
const $1b2c221075aa0859$var$_hoisted_7 = {
    class: "sl-date"
};
const $1b2c221075aa0859$var$_hoisted_8 = {
    class: "sl-desc"
};
const $1b2c221075aa0859$var$_hoisted_9 = [
    "href",
    "target",
    "rel"
];
const $1b2c221075aa0859$var$_hoisted_10 = {
    class: "sl-foot"
};
function $1b2c221075aa0859$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "modal-overlay z2500 sl-overlay",
        onClick: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit('close'), [
            "self"
        ]))
    }, [
        (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("button", {
                class: "modal-close",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('close')),
                "aria-label": "Close"
            }, "\u2715"),
            _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("div", {
                class: "sl-title"
            }, "\uD83C\uDD95 What's new", -1)),
            (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_2, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.updates, (u)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: u.id,
                        class: "sl-item"
                    }, [
                        (0, $TusQn.createElementVNode)("span", $1b2c221075aa0859$var$_hoisted_3, (0, $8POXm.toDisplayString)(u.emoji), 1),
                        (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_4, [
                            (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_5, [
                                (0, $TusQn.createElementVNode)("span", $1b2c221075aa0859$var$_hoisted_6, (0, $8POXm.toDisplayString)(u.title), 1),
                                (0, $TusQn.createElementVNode)("span", $1b2c221075aa0859$var$_hoisted_7, (0, $8POXm.toDisplayString)(u.date), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_8, (0, $8POXm.toDisplayString)(u.body), 1),
                            u.link ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                key: 0,
                                href: u.link,
                                class: "sl-link",
                                target: u.external ? '_blank' : null,
                                rel: u.external ? 'noopener' : null
                            }, "Check it out \u2192", 8, $1b2c221075aa0859$var$_hoisted_9)) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128))
            ]),
            (0, $TusQn.createElementVNode)("div", $1b2c221075aa0859$var$_hoisted_10, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "sl-got",
                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('close'))
                }, "Got it")
            ])
        ])
    ]);
}

});

parcelRegister("kwuOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0eb377f577114d$export$2e2bcd8739ae039);
let $ef0eb377f577114d$var$NOOP = ()=>{};
var $ef0eb377f577114d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eiARH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68f57cc8406540e$export$2e2bcd8739ae039);
let $a68f57cc8406540e$var$script;




let $a68f57cc8406540e$var$initialize = ()=>{
    $a68f57cc8406540e$var$script = (parcelRequire("SzzQE"));
    if ($a68f57cc8406540e$var$script.__esModule) $a68f57cc8406540e$var$script = $a68f57cc8406540e$var$script.default;
    $a68f57cc8406540e$var$script.render = (parcelRequire("1mzx4")).render;
    $a68f57cc8406540e$var$script.__cssModules = {};
    (parcelRequire("jqgHJ")).default($a68f57cc8406540e$var$script);
    $a68f57cc8406540e$var$script.__scopeId = 'data-v-37baff';
    $a68f57cc8406540e$var$script.__file = "OnboardingTour.vue";
};
$a68f57cc8406540e$var$initialize();
var $a68f57cc8406540e$export$2e2bcd8739ae039 = $a68f57cc8406540e$var$script;

});
parcelRegister("SzzQE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0a40a426a97f9711$export$2e2bcd8739ae039);
// A dependency-free guided tour: spotlights a sequence of on-screen targets
// (CSS selectors) with a tooltip + Back/Skip/Next. Steps whose target isn't on
// the page are skipped. Parent drives it via a ref: this.$refs.tour.begin().
var $0a40a426a97f9711$export$2e2bcd8739ae039 = {
    name: 'OnboardingTour',
    props: {
        steps: {
            type: Array,
            default: ()=>[]
        }
    },
    data () {
        return {
            active: false,
            i: 0,
            rect: null
        };
    },
    computed: {
        live () {
            return this.steps.filter((s)=>!s.target || document.querySelector(s.target));
        },
        step () {
            return this.live[this.i] || {};
        },
        maskStyle () {
            if (!this.rect) return {
                width: '0',
                height: '0',
                top: '50%',
                left: '50%',
                opacity: '0'
            };
            const p = 6;
            return {
                top: this.rect.top - p + 'px',
                left: this.rect.left - p + 'px',
                width: this.rect.width + 2 * p + 'px',
                height: this.rect.height + 2 * p + 'px',
                opacity: '1'
            };
        },
        tipStyle () {
            const W = 300;
            if (!this.rect) return {
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: W + 'px'
            };
            const belowSpace = window.innerHeight - this.rect.bottom;
            const top = belowSpace > 170 ? this.rect.bottom + 14 : Math.max(12, this.rect.top - 174);
            const left = Math.max(12, Math.min(this.rect.left, window.innerWidth - W - 12));
            return {
                top: top + 'px',
                left: left + 'px',
                width: W + 'px'
            };
        }
    },
    methods: {
        begin () {
            if (!this.steps.length) {
                this.$emit('done');
                return;
            }
            this.i = 0;
            this.active = true;
            window.addEventListener('resize', this.reposition);
            window.addEventListener('scroll', this.reposition, true);
            this.$nextTick(()=>this.go());
        },
        go () {
            const el = this.step.target && document.querySelector(this.step.target);
            if (!el) {
                this.rect = null;
                return;
            }
            el.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            });
            setTimeout(this.reposition, 320); // settle after the smooth scroll
        },
        reposition () {
            if (!this.active) return;
            const el = this.step.target && document.querySelector(this.step.target);
            this.rect = el ? el.getBoundingClientRect() : null;
        },
        next () {
            if (this.i < this.live.length - 1) {
                this.i++;
                this.go();
            } else this.end();
        },
        prev () {
            if (this.i > 0) {
                this.i--;
                this.go();
            }
        },
        skip () {
            this.end();
        },
        end () {
            this.active = false;
            window.removeEventListener('resize', this.reposition);
            window.removeEventListener('scroll', this.reposition, true);
            this.$emit('done');
        }
    },
    beforeUnmount () {
        window.removeEventListener('resize', this.reposition);
        window.removeEventListener('scroll', this.reposition, true);
    }
};

});

parcelRegister("1mzx4", function(module, exports) {

$parcel$export(module.exports, "render", () => $0fe36888594b350a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $0fe36888594b350a$var$_hoisted_1 = {
    key: 0,
    class: "ot-root",
    role: "dialog",
    "aria-label": "Guided tour"
};
const $0fe36888594b350a$var$_hoisted_2 = {
    class: "ot-tip-title"
};
const $0fe36888594b350a$var$_hoisted_3 = {
    class: "ot-tip-body"
};
const $0fe36888594b350a$var$_hoisted_4 = {
    class: "ot-tip-foot"
};
const $0fe36888594b350a$var$_hoisted_5 = {
    class: "ot-count"
};
const $0fe36888594b350a$var$_hoisted_6 = {
    class: "ot-actions"
};
function $0fe36888594b350a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $data.active ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0fe36888594b350a$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", {
            class: "ot-block",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.skip && $options.skip(...args))
        }),
        (0, $TusQn.createElementVNode)("div", {
            class: "ot-mask",
            style: (0, $8POXm.normalizeStyle)($options.maskStyle)
        }, null, 4),
        (0, $TusQn.createElementVNode)("div", {
            class: "ot-tip",
            style: (0, $8POXm.normalizeStyle)($options.tipStyle),
            onClick: _cache[4] || (_cache[4] = (0, $eeJ70.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $TusQn.createElementVNode)("div", $0fe36888594b350a$var$_hoisted_2, (0, $8POXm.toDisplayString)($options.step.title), 1),
            (0, $TusQn.createElementVNode)("div", $0fe36888594b350a$var$_hoisted_3, (0, $8POXm.toDisplayString)($options.step.body), 1),
            (0, $TusQn.createElementVNode)("div", $0fe36888594b350a$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("span", $0fe36888594b350a$var$_hoisted_5, (0, $8POXm.toDisplayString)($data.i + 1) + " / " + (0, $8POXm.toDisplayString)($options.live.length), 1),
                (0, $TusQn.createElementVNode)("span", $0fe36888594b350a$var$_hoisted_6, [
                    $data.i > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 0,
                        class: "ot-btn",
                        onClick: _cache[1] || (_cache[1] = (...args)=>$options.prev && $options.prev(...args))
                    }, "Back")) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "ot-btn ot-skip",
                        onClick: _cache[2] || (_cache[2] = (...args)=>$options.skip && $options.skip(...args))
                    }, "Skip"),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "ot-btn ot-next",
                        onClick: _cache[3] || (_cache[3] = (...args)=>$options.next && $options.next(...args))
                    }, (0, $8POXm.toDisplayString)($data.i === $options.live.length - 1 ? 'Done' : "Next \u2192"), 1)
                ])
            ])
        ], 4)
    ])) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("jqgHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23d672a0994a028$export$2e2bcd8739ae039);
let $e23d672a0994a028$var$NOOP = ()=>{};
var $e23d672a0994a028$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("4VODn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3973c327454b0139$export$2e2bcd8739ae039);
let $3973c327454b0139$var$script;




let $3973c327454b0139$var$initialize = ()=>{
    $3973c327454b0139$var$script = (parcelRequire("a30BB"));
    if ($3973c327454b0139$var$script.__esModule) $3973c327454b0139$var$script = $3973c327454b0139$var$script.default;
    $3973c327454b0139$var$script.render = (parcelRequire("9tbCY")).render;
    $3973c327454b0139$var$script.__cssModules = {};
    (parcelRequire("2QaUM")).default($3973c327454b0139$var$script);
    $3973c327454b0139$var$script.__scopeId = 'data-v-4cd406';
    $3973c327454b0139$var$script.__file = "PredictPanel.vue";
};
$3973c327454b0139$var$initialize();
var $3973c327454b0139$export$2e2bcd8739ae039 = $3973c327454b0139$var$script;

});
parcelRegister("a30BB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $750aa76e3a4387bc$export$2e2bcd8739ae039);
// Scoreboard for the Predict-the-Bracket game: running score, the vs-sim
// head-to-head, an all-time lifetime line, and a shareable result on completion.

var $e1bFN = parcelRequire("e1bFN");

var $iU8lT = parcelRequire("iU8lT");
var $750aa76e3a4387bc$export$2e2bcd8739ae039 = {
    name: 'PredictPanel',
    mixins: [
        (0, $iU8lT.default)
    ],
    props: {
        score: {
            type: Object,
            required: true
        },
        sim: {
            type: Object,
            default: null
        },
        lifetime: {
            type: Object,
            default: null
        },
        complete: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        lifetimePct () {
            return this.lifetime && this.lifetime.total ? Math.round(this.lifetime.correct / this.lifetime.total * 100) : 0;
        },
        resultLine () {
            let s = `\u{1F3C1} Final: ${this.score.correct}/${this.score.decidedWithPick} \xb7 ${this.score.points} pts`;
            if (this.sim && this.sim.decided) s += this.sim.tied ? " \xb7 tied the sim" : this.sim.beat ? " \xb7 you beat the sim! \uD83C\uDF89" : " \xb7 the sim won this one";
            return s;
        }
    },
    methods: {
        share () {
            this.copyShareLink((0, $e1bFN.shareText)(this.score, this.sim));
        }
    }
};

});
parcelRegister("e1bFN", function(module, exports) {

$parcel$export(module.exports, "MATCH_DEFS", () => $a34a36b4139b66d8$export$7015bb8ccd11d94);
$parcel$export(module.exports, "ROUND_LABEL", () => $a34a36b4139b66d8$export$d5b5164210c4b758);
$parcel$export(module.exports, "matchCandidates", () => $a34a36b4139b66d8$export$30f26853ed229c17);
$parcel$export(module.exports, "scorePredictions", () => $a34a36b4139b66d8$export$2f04c8f6ae570657);
$parcel$export(module.exports, "simRecord", () => $a34a36b4139b66d8$export$b11b32d89c51cfcc);
$parcel$export(module.exports, "loadPredictions", () => $a34a36b4139b66d8$export$7a16cec3d83078dd);
$parcel$export(module.exports, "savePredictions", () => $a34a36b4139b66d8$export$5ce6286725a491aa);
$parcel$export(module.exports, "tournamentRecord", () => $a34a36b4139b66d8$export$9246d3b1f2c1a644);
$parcel$export(module.exports, "isActive", () => $a34a36b4139b66d8$export$39e04e72f972b885);
$parcel$export(module.exports, "finalizeTournament", () => $a34a36b4139b66d8$export$f4d238a793106038);
$parcel$export(module.exports, "shareText", () => $a34a36b4139b66d8$export$ed7ca78295c017be);
$parcel$export(module.exports, "setPick", () => $a34a36b4139b66d8$export$6bcc5df6f18bab84);
// Predict-the-Bracket — pure logic for the bracket prediction game.
//
// The FFTBG bracket is 8 sequential matches (indices 0-7, matching the `winners`
// array + map indices in Luxstadio):
//   0 red|blue   1 green|yellow   2 white|black   3 purple|brown   (quarterfinals)
//   4 SF1 = winner(0) vs winner(1)        5 SF2 = winner(2) vs winner(3)
//   6 Final = winner(4) vs winner(5)      7 Champ = winner(6) vs the reigning Champion
//
// A pick for match i is editable until the match resolves (`winners[i]` posts), then
// it locks and grades. Picks cascade: a later match's candidates come from the real
// upstream winners OR, where those aren't decided yet, the player's own upstream picks
// — so the same code serves an upfront full-bracket fill AND mid-tournament "predict
// the rest". Team names are the lowercase labels used by `winners` ('red'…'champion').
const $a34a36b4139b66d8$export$7015bb8ccd11d94 = [
    {
        i: 0,
        round: 'qf',
        weight: 1,
        teams: [
            'red',
            'blue'
        ]
    },
    {
        i: 1,
        round: 'qf',
        weight: 1,
        teams: [
            'green',
            'yellow'
        ]
    },
    {
        i: 2,
        round: 'qf',
        weight: 1,
        teams: [
            'white',
            'black'
        ]
    },
    {
        i: 3,
        round: 'qf',
        weight: 1,
        teams: [
            'purple',
            'brown'
        ]
    },
    {
        i: 4,
        round: 'sf',
        weight: 2,
        from: [
            0,
            1
        ]
    },
    {
        i: 5,
        round: 'sf',
        weight: 2,
        from: [
            2,
            3
        ]
    },
    {
        i: 6,
        round: 'final',
        weight: 3,
        from: [
            4,
            5
        ]
    },
    {
        i: 7,
        round: 'champ',
        weight: 4,
        from: [
            6,
            'champion'
        ]
    }
];
const $a34a36b4139b66d8$export$d5b5164210c4b758 = {
    qf: 'Quarterfinal',
    sf: 'Semifinal',
    final: 'Final',
    champ: 'Champ Match'
};
// The team occupying an upstream slot: the real winner if decided, else the player's
// pick for that slot. The literal 'champion' slot (champ match) is always the champion.
function $a34a36b4139b66d8$var$effective(slot, winners, picks) {
    if (slot === 'champion') return 'champion';
    return winners && winners[slot] || picks && picks[slot] || null;
}
function $a34a36b4139b66d8$export$30f26853ed229c17(i, winners, picks) {
    const def = $a34a36b4139b66d8$export$7015bb8ccd11d94[i];
    if (def.teams) return def.teams.slice();
    return def.from.map((slot)=>$a34a36b4139b66d8$var$effective(slot, winners, picks));
}
function $a34a36b4139b66d8$export$a784ea2e80697fd2(i, winners, picks) {
    if (winners && winners[i]) return false; // decided → locked
    const [a, b] = $a34a36b4139b66d8$export$30f26853ed229c17(i, winners, picks);
    return !!a && !!b;
}
function $a34a36b4139b66d8$export$1088f8601c82de66(i, picks, winners) {
    const winner = winners && winners[i];
    const pick = picks && picks[i];
    if (!winner || !pick) return null;
    const correct = pick === winner;
    return {
        correct: correct,
        points: correct ? $a34a36b4139b66d8$export$7015bb8ccd11d94[i].weight : 0
    };
}
function $a34a36b4139b66d8$export$2f04c8f6ae570657(picks, winners) {
    picks = picks || {};
    winners = winners || [];
    let correct = 0, decidedWithPick = 0, points = 0, maxPoints = 0, picksMade = 0;
    const perMatch = $a34a36b4139b66d8$export$7015bb8ccd11d94.map((def)=>{
        const pick = picks[def.i] || null;
        const winner = winners[def.i] || null;
        if (pick) picksMade += 1;
        const g = $a34a36b4139b66d8$export$1088f8601c82de66(def.i, picks, winners);
        if (g) {
            decidedWithPick += 1;
            if (g.correct) correct += 1;
            points += g.points;
            maxPoints += def.weight;
        }
        return {
            i: def.i,
            round: def.round,
            weight: def.weight,
            pick: pick,
            winner: winner,
            decided: !!winner,
            graded: !!g,
            correct: g ? g.correct : null
        };
    });
    return {
        perMatch: perMatch,
        correct: correct,
        decidedWithPick: decidedWithPick,
        points: points,
        maxPoints: maxPoints,
        picksMade: picksMade
    };
}
function $a34a36b4139b66d8$export$b11b32d89c51cfcc(picks, simPicks, winners) {
    picks = picks || {};
    simPicks = simPicks || {};
    winners = winners || [];
    let you = 0, sim = 0, decided = 0;
    for (const def of $a34a36b4139b66d8$export$7015bb8ccd11d94){
        const w = winners[def.i];
        if (!w) continue;
        const p = picks[def.i], s = simPicks[def.i];
        if (!p || !s) continue;
        decided += 1;
        if (p === w) you += 1;
        if (s === w) sim += 1;
    }
    return {
        you: you,
        sim: sim,
        decided: decided,
        beat: you > sim,
        tied: you === sim
    };
}
function $a34a36b4139b66d8$export$586f1dddaeb15056(picks, winners) {
    for (const def of $a34a36b4139b66d8$export$7015bb8ccd11d94){
        if (def.teams) continue; // QF candidates are fixed, never bust
        const pick = picks[def.i];
        if (!pick) continue;
        const [a, b] = $a34a36b4139b66d8$export$30f26853ed229c17(def.i, winners, picks);
        if (pick !== a && pick !== b) delete picks[def.i];
    }
}
const $a34a36b4139b66d8$export$86880b4b2e1a2384 = 'wiznaibus.predictions.v1';
function $a34a36b4139b66d8$var$emptyState() {
    return {
        v: 1,
        byTournament: {},
        lifetime: {
            tournaments: 0,
            correct: 0,
            total: 0,
            points: 0,
            beatSim: 0,
            lostSim: 0,
            tieSim: 0,
            streak: 0,
            bestStreak: 0
        }
    };
}
function $a34a36b4139b66d8$export$7a16cec3d83078dd() {
    try {
        const raw = localStorage.getItem($a34a36b4139b66d8$export$86880b4b2e1a2384);
        if (!raw) return $a34a36b4139b66d8$var$emptyState();
        const obj = JSON.parse(raw);
        if (!obj || obj.v !== 1) return $a34a36b4139b66d8$var$emptyState();
        const base = $a34a36b4139b66d8$var$emptyState();
        return {
            ...base,
            ...obj,
            lifetime: {
                ...base.lifetime,
                ...obj.lifetime || {}
            },
            byTournament: obj.byTournament || {}
        };
    } catch  {
        return $a34a36b4139b66d8$var$emptyState();
    }
}
function $a34a36b4139b66d8$export$5ce6286725a491aa(state) {
    try {
        localStorage.setItem($a34a36b4139b66d8$export$86880b4b2e1a2384, JSON.stringify(state));
    } catch  {}
}
function $a34a36b4139b66d8$export$9246d3b1f2c1a644(state, id) {
    if (!state.byTournament[id]) state.byTournament[id] = {
        picks: {},
        sim: {},
        active: false,
        finalized: false
    };
    const rec = state.byTournament[id];
    if (!rec.picks) rec.picks = {};
    if (!rec.sim) rec.sim = {};
    return rec;
}
function $a34a36b4139b66d8$export$39e04e72f972b885(state, id) {
    const rec = id && state.byTournament && state.byTournament[id];
    return !!(rec && rec.active);
}
function $a34a36b4139b66d8$export$f4d238a793106038(state, id, winners) {
    const rec = state.byTournament && state.byTournament[id];
    if (!rec || rec.finalized || !rec.active) return false;
    const score = $a34a36b4139b66d8$export$2f04c8f6ae570657(rec.picks, winners);
    if (!score.picksMade) return false;
    const sim = $a34a36b4139b66d8$export$b11b32d89c51cfcc(rec.picks, rec.sim, winners);
    const L = state.lifetime;
    L.tournaments += 1;
    L.correct += score.correct;
    L.total += score.decidedWithPick;
    L.points += score.points;
    if (sim.decided > 0) {
        if (sim.you > sim.sim) {
            L.beatSim += 1;
            L.streak += 1;
            L.bestStreak = Math.max(L.bestStreak, L.streak);
        } else if (sim.you < sim.sim) {
            L.lostSim += 1;
            L.streak = 0;
        } else {
            L.tieSim += 1;
            L.streak = 0;
        } // a tie doesn't continue a beat-the-sim streak
    }
    rec.finalized = true;
    return true;
}
function $a34a36b4139b66d8$export$ed7ca78295c017be(score, sim) {
    let s = `\u{1F52E} My FFTBG bracket: ${score.correct}/${score.decidedWithPick} right, ${score.points} pts`;
    if (sim && sim.decided > 0) {
        const verb = sim.you > sim.sim ? 'beat' : sim.you < sim.sim ? 'lost to' : 'tied';
        s += ` \u{2014} ${verb} the sim ${sim.you}\u{2013}${sim.sim} \u{1F916}`;
    }
    return s + '. Predict yours at wiznaib.us';
}
function $a34a36b4139b66d8$export$6bcc5df6f18bab84(rec, i, team, winners) {
    if (team == null) delete rec.picks[i];
    else rec.picks[i] = team;
    $a34a36b4139b66d8$export$586f1dddaeb15056(rec.picks, winners);
    return rec;
}
// ---- share encoding: 8 chars, one team-code per match ('-' = no pick) ----
const $a34a36b4139b66d8$var$CODE = {
    red: 'R',
    blue: 'B',
    green: 'G',
    yellow: 'Y',
    white: 'W',
    black: 'K',
    purple: 'P',
    brown: 'N',
    champion: 'C'
};
const $a34a36b4139b66d8$var$DECODE = Object.fromEntries(Object.entries($a34a36b4139b66d8$var$CODE).map(([k, v])=>[
        v,
        k
    ]));
function $a34a36b4139b66d8$export$eae366c5b435d07b(picks) {
    picks = picks || {};
    let s = '';
    for(let i = 0; i < 8; i += 1)s += picks[i] ? $a34a36b4139b66d8$var$CODE[picks[i]] || '-' : '-';
    return s;
}
function $a34a36b4139b66d8$export$5f4be08389707b6b(str) {
    const picks = {};
    if (!str) return picks;
    for(let i = 0; i < 8 && i < str.length; i += 1){
        const t = $a34a36b4139b66d8$var$DECODE[str[i]];
        if (t) picks[i] = t;
    }
    return picks;
}

});

parcelRegister("iU8lT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc33ef8706e1c139$export$2e2bcd8739ae039);
// Shared "🔗 Share" button behaviour for the pages that have one.
// Provides a `linkCopied` flag and `copyShareLink(url)` — writes the URL (defaulting
// to the current address) to the clipboard and flashes `linkCopied` for 1.5s.
// Components keep their own thin `copyLink()` when they build a custom URL.
var $dc33ef8706e1c139$export$2e2bcd8739ae039 = {
    data () {
        return {
            linkCopied: false
        };
    },
    methods: {
        copyShareLink (url) {
            const target = url || window.location.href;
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(target).then(()=>{
                this.linkCopied = true;
                setTimeout(()=>{
                    this.linkCopied = false;
                }, 1500);
            }).catch(()=>{});
        }
    }
};

});


parcelRegister("9tbCY", function(module, exports) {

$parcel$export(module.exports, "render", () => $6e4fd7811245cea4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $6e4fd7811245cea4$var$_hoisted_1 = {
    class: "pp-stat"
};
const $6e4fd7811245cea4$var$_hoisted_2 = {
    key: 0,
    class: "pp-stat"
};
const $6e4fd7811245cea4$var$_hoisted_3 = {
    class: "pp-good"
};
const $6e4fd7811245cea4$var$_hoisted_4 = {
    class: "pp-dim"
};
const $6e4fd7811245cea4$var$_hoisted_5 = {
    class: "pp-good"
};
const $6e4fd7811245cea4$var$_hoisted_6 = {
    key: 1,
    class: "pp-hint"
};
const $6e4fd7811245cea4$var$_hoisted_7 = {
    key: 3,
    class: "pp-life",
    title: "Your all-time prediction record (saved in this browser)"
};
const $6e4fd7811245cea4$var$_hoisted_8 = {
    key: 0,
    class: "pp-streak"
};
const $6e4fd7811245cea4$var$_hoisted_9 = {
    class: "pp-final"
};
function $6e4fd7811245cea4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8POXm.normalizeClass)([
            "pp-bar",
            {
                complete: $props.complete
            }
        ])
    }, [
        _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("span", {
            class: "pp-title"
        }, "\uD83D\uDD2E Your bracket", -1)),
        (0, $TusQn.createElementVNode)("span", $6e4fd7811245cea4$var$_hoisted_1, (0, $8POXm.toDisplayString)($props.score.picksMade) + "/8 picked", 1),
        $props.score.decidedWithPick ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6e4fd7811245cea4$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("b", $6e4fd7811245cea4$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.score.correct), 1),
            (0, $TusQn.createElementVNode)("span", $6e4fd7811245cea4$var$_hoisted_4, "/" + (0, $8POXm.toDisplayString)($props.score.decidedWithPick) + " right", 1),
            _cache[1] || (_cache[1] = (0, $TusQn.createTextVNode)(" \xb7 ", -1)),
            (0, $TusQn.createElementVNode)("b", $6e4fd7811245cea4$var$_hoisted_5, (0, $8POXm.toDisplayString)($props.score.points), 1),
            _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("span", {
                class: "pp-dim"
            }, " pts", -1))
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6e4fd7811245cea4$var$_hoisted_6, "Pick a winner on each cell \u2014 your pick locks when that match starts.")),
        $props.sim && $props.sim.decided ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
            key: 2,
            class: (0, $8POXm.normalizeClass)([
                "pp-vs",
                $props.sim.tied ? 'tie' : $props.sim.beat ? 'win' : 'lose'
            ]),
            title: "How you're doing against the battle sim's picks, head-to-head"
        }, [
            _cache[3] || (_cache[3] = (0, $TusQn.createTextVNode)(" \uD83E\uDD16 vs the sim: ", -1)),
            (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($props.sim.you) + "\u2013" + (0, $8POXm.toDisplayString)($props.sim.sim), 1),
            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.sim.tied ? '(dead even)' : $props.sim.beat ? "\u2014 beating the AI!" : "\u2014 AI ahead"), 1)
        ], 2)) : (0, $TusQn.createCommentVNode)("", true),
        $props.lifetime && $props.lifetime.tournaments ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6e4fd7811245cea4$var$_hoisted_7, [
            (0, $TusQn.createTextVNode)(" \uD83D\uDCCA " + (0, $8POXm.toDisplayString)($props.lifetime.tournaments) + " bracket" + (0, $8POXm.toDisplayString)($props.lifetime.tournaments > 1 ? 's' : '') + " \xb7 " + (0, $8POXm.toDisplayString)($options.lifetimePct) + "% \xb7 \uD83E\uDD16 " + (0, $8POXm.toDisplayString)($props.lifetime.beatSim) + "\u2013" + (0, $8POXm.toDisplayString)($props.lifetime.lostSim) + (0, $8POXm.toDisplayString)($props.lifetime.tieSim ? "\u2013" + $props.lifetime.tieSim : '') + " ", 1),
            $props.lifetime.streak > 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6e4fd7811245cea4$var$_hoisted_8, "\xb7 \uD83D\uDD25 " + (0, $8POXm.toDisplayString)($props.lifetime.streak) + " streak", 1)) : (0, $TusQn.createCommentVNode)("", true)
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $props.complete ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 4
        }, [
            (0, $TusQn.createElementVNode)("span", $6e4fd7811245cea4$var$_hoisted_9, (0, $8POXm.toDisplayString)($options.resultLine), 1),
            (0, $TusQn.createElementVNode)("button", {
                class: "pp-share",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.share && $options.share(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.linkCopied ? "\u2713 Copied" : "\uD83D\uDD17 Share"), 1)
        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
    ], 2);
}

});

parcelRegister("2QaUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2118e78a33eafd31$export$2e2bcd8739ae039);
let $2118e78a33eafd31$var$NOOP = ()=>{};
var $2118e78a33eafd31$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("l1zL2", function(module, exports) {

$parcel$export(module.exports, "SITE_UPDATES", () => $f4e56db09981a447$export$25bc0e5999148400);
/**
 * Combined changelog + feature spotlight. Newest entries first.
 *
 * Every entry appears on the Changelog page (?changelog). Entries with
 * `spotlight: false` are changelog-only; all others ALSO show as a one-time
 * popup for returning users (tracked in prefs via seenUpdates). New visitors
 * who see the Welcome modal skip the popup.
 *
 * id:        unique string (never reuse — it's the seen-tracking key)
 * date:      display date string
 * emoji:     visual icon
 * title:     short headline
 * body:      one-liner description (the popup + changelog both show this)
 * link:      optional URL (e.g. ?players)
 * external:  set true when `link` leaves the site — opens in a new tab instead of
 *            navigating the reader away mid-changelog.
 * spotlight: set to false for changelog-only (no popup). Default = true.
 *            Every unseen spotlight entry pops for a returning visitor, so
 *            backfilled history should be changelog-only — otherwise catching the
 *            feed up buries people in notices for things they saw weeks ago.
 */ const $f4e56db09981a447$export$25bc0e5999148400 = [
    {
        id: 'mods-monster-picker-2026-10',
        date: 'Oct 2, 2026',
        emoji: "\uD83D\uDC09",
        title: 'My Mods: a class picker, and monster picks that know your cooldown',
        body: '"Suggest for" in \u26A1 My Mods is now a grid of portraits instead of a long dropdown. \u2726 marks the classes that earn your class bonus, and each class has \u2642/\u2640 buttons, so "female Lancer" is one click. Picking \uD83D\uDC09 Monster used to just say !fight. Now it suggests the highest-win-rate monster you own, can afford, and can actually roll. Strong and elite monsters share a cooldown per tier: field one elite and every elite waits it out. My Mods reads that from your skill list, the same way the bot\'s skill modifiers show it, and lists the rest of your monsters under "all options". Turn on "Respect Monster Quest" and it suggests only the monsters your next Monster Quest set still needs. The VIP helper now skips monsters on cooldown too.'
    },
    {
        id: 'loser-quest-2026-10',
        date: 'Oct 2, 2026',
        emoji: "\uD83D\uDD4A\uFE0F",
        title: 'The Miku Quest',
        body: "Named for MikuShikhu, who volunteered. It's the Everything Quest in reverse: lose with every class, all 20 human jobs and all 55 monsters, once per round. \uD83D\uDEAA First-Round Exit is a quarterfinal loss, \uD83D\uDC94 Semifinal Heartbreak a semi, \uD83E\uDD48 So Close the final, and \uD83D\uDC90 Always the Bridesmaid means winning the final and then losing the title match. 85 people have finished First-Round Exit, and only Drunkpak has finished Always the Bridesmaid. Six more are one class short, including Q99m, who has lost the title match with every monster at least four times but never with a Thief. Find it on the Players page's Quests tab, and your own four checklists on your profile's Achievements tab. Completions show up in the \"Just happened\" ticker too.",
        link: '?players&tab=quests&quest=loser'
    },
    {
        id: 'vip-helper-2026-10',
        date: 'Oct 1, 2026',
        emoji: "\uD83C\uDF96\uFE0F",
        title: 'My Mods: "Help me with VIP quest"',
        body: "A new switch in \u2B50 My entry (\u26A1 My Mods on the bracket) aims your entry at the VIP Quest: a class you haven't champed this season, picked for its edge on the champion you'd face. Strong and elite monsters you own and still need come first, since they share a cooldown. After those it weighs each class's win rate against what the champion is weak to or shrugs off: a Bomb's Fire into their Treant, say, but no Faith magic into a Steel Giant. It can also force a skillset you own that brings the right element. Every pick says why, and a \uD83C\uDFB2 button runs the battle sim for the top few against the champion."
    },
    {
        id: 'vip-board-2026-10',
        date: 'Oct 1, 2026',
        emoji: "\uD83C\uDF96\uFE0F",
        title: 'The VIP Quest board',
        body: "Who has champed the most different classes this season? The new \uD83C\uDF96\uFE0F VIP Quest page (in the Champions menu) ranks everyone. Gender doesn't matter, monsters count, and there are 75 to collect. Click a player for their checklist of all 75, switch to humans, monsters or \u2642/\u2640 humans, or look back at any past season. Set your username in \u2699 Settings and your own row is pinned at the top. The Seasons page shows each season's top five too.",
        link: '?vip'
    },
    {
        id: 'mods-hidden-2026-10',
        date: 'Oct 1, 2026',
        emoji: "\uD83D\uDC8E",
        title: 'My Mods: "Save my hidden skills"',
        body: 'For the hoarders: if you own a hidden skill, \u26A1 My Mods on the bracket now has a "Save my hidden skills" switch. With it on, no suggestion forces Math Skill, Equip Perfume, Teleport 2 or Blade Grasp. That covers Go big, \u2B50 My entry and the picks you can adjust. It\'s off until you turn it on, and it remembers your choice.'
    },
    {
        id: 'mods-offcd-2026-09',
        date: 'Sep 29, 2026',
        emoji: "\u2B50",
        title: 'My entry: "off cooldown"',
        body: 'Another one from Taobakaa: "Force my best skill" in \u2B50 My entry (\u26A1 My Mods on the bracket) has a third choice between "any usable" and "no penalty". "Off cooldown" takes your best skill that has no reroll tildes, so a win pays full EXP, but it will take an uncommon or rare skill and its priority cost. That\'s the one for quiet hours, when priority matters less. A Ninja with Mana Shield and Retreat both off cooldown now gets Mana Shield, where "no penalty" stops at the common pick. Thanks again, Taobakaa!'
    },
    {
        id: 'ticker-2026-09',
        date: 'Sep 28, 2026',
        emoji: "\uD83C\uDF89",
        title: '"Just happened," on the bracket page',
        body: "A strip under the nav now scrolls the past week's milestones: first titles and 10th, 50th and 100th ones, quest completions, champion teams reaching 10 or more tournaments, titles won as a raid boss, and big gifting milestones. It updates after every tournament, pauses when you hover over it, and holds still if your device asks for reduced motion. Each line links to the player. If it isn't for you, switch it off in \u2699 Settings."
    },
    {
        id: 'gift-quest-2026-09',
        date: 'Sep 28, 2026',
        emoji: "\uD83C\uDF81",
        title: 'The Gift Quest',
        body: 'A new quest on the Quests page: gift every skill in the game at least once, to anyone. It counts the bot\'s own gift confirmations back to February 2020 against FFTBG\'s own list of 186 skills. Nobody has finished it yet: DarrenDinosaurs and Antipathics are tied at 167. Your checklist, grouped by skill type, is on the Achievements tab of your profile. If a skill on the list can\'t actually be gifted, tell Luxor and it comes off. Building it also turned up 370 gifts the Gifts page had been missing (skills with a hyphen in the name, like N-KaiArmlet), so a few of those counts went up.',
        link: '?players&tab=quests&quest=gift'
    },
    {
        id: 'my-entry-2026-09',
        date: 'Sep 25, 2026',
        emoji: "\u2B50",
        title: 'My Mods remembers your class, and builds your entry',
        body: 'Two ideas from Taobakaa on stream, now in \u26A1 My Mods on the bracket (it appears once your username is set in \u2699 Settings). The class you pick under "Suggest for" is remembered, so if you always force Lancer it opens on Lancer. And \u2B50 My entry builds your !fight command from rules you set once: force your best owned skill for that class (from any usable skill, or only ones with no penalty: no reroll tildes and no priority cost), ban the class\'s worst roll, bribe out GilgameHeart. It fits all of that into FFTBG\'s four-parameter limit and says what it had to leave out, so opening My Mods puts your command one click from copied. Luxor added one more: tick "Respect my quest" and it enters as something your pinned quest still needs, like a male Lancer for the Human Gendered quest, or a monster you own for the Monster Quest. Thanks, Taobakaa!'
    },
    {
        id: 'gifts-2026-09',
        date: 'Sep 16, 2026',
        emoji: "\uD83C\uDF81",
        title: 'Who has gifted the most',
        body: "A new page in the Chat menu, built off a request in Discord: every !gift the bot has ever confirmed \u2014 44,771 of them since February 2020 \u2014 ranked by giver, by recipient, by skill, and by the giver\u2192recipient pairs that keep recurring, with a live feed of the latest. Nhammen leads at 2,546. It counts only the bot's own confirmation, not who typed the command, because !gift fails when you are broke, when it fires before the raffle, or when it is mashed three times in four seconds \u2014 which meant reading the bot's own message log rather than viewer chat, which never records the bot at all. Your own given and received counts are on the Chat tab of your profile.",
        link: '?gifts'
    },
    {
        id: 'season-units-2026-08',
        date: 'Aug 11, 2026',
        emoji: "\uD83C\uDFB2",
        title: "Season Units \u2014 what actually got rolled",
        body: "A new page in the Champions menu, ranking all 75 classes by how often the generator actually rolled them in a season, rarest first. Season 28's rarest was King Behemoth at 253 rolls, against Knight's 6,098. Every row carries its share of the season, how that share moved against the season before, how many different people got one, match win rate and titles \u2014 and clicking a row opens the ten people who rolled it most, both that season and all-time. The \u26A5 toggle splits each human class into \u2642/\u2640 rows, which is where it gets interesting: the rarest human roll of Season 28 was a male Oracle. This counts rolls, not appearances \u2014 a unit that reaches the final is still one roll, which is what makes \"least rolled\" a fair question at all.",
        link: '?units'
    },
    {
        id: 'clockwork-coliseum-domain-2026-08',
        date: 'Aug 11, 2026',
        emoji: "\u2699\uFE0F",
        title: 'Clockwork Coliseum has a real address',
        body: "The web auto-battler we build alongside this site now lives at clockworkcoliseum.com, and the promo under the Champ Match cell points there. Queue any time \u2014 including mid-match \u2014 and watch your team fight it out. Same beta, same crew, still free.",
        link: 'https://clockworkcoliseum.com',
        external: true
    },
    {
        id: 'season-29-2026-08',
        date: 'Aug 9, 2026',
        emoji: "\uD83D\uDC51",
        title: 'Season 29 has begun',
        body: "ToC28 went to the eighth seed: LuckyMousey, Conker63, Arbot and Stone Achromous took the Champion of Champions crown off a team that had held it through five straight Tournaments of Champions. The whole site understands Season 29 now \u2014 season stats, betting, chat and championship history all bucket into it. Two fixes came with it. The Champions page used to go blank in the window between a ToC and the new season's first dethroning, hiding the season picker along with everything else; it now still lets you browse back through every past season. And the line naming each season's ToC winner was quietly showing that season's top seed instead \u2014 wrong about four times in five, since the top seed has won only 4 of the 22 seeded ToCs. It now names who actually won the bracket, whether they went on to take the crown, and links you to it.",
        link: '?champions'
    },
    {
        id: 'champ-history-zodiac-quest-2026-08',
        date: 'Aug 9, 2026',
        emoji: "\u264E",
        title: 'Zodiac quests in your championship history',
        body: "The loadout picker on your profile's history tab has a Zodiac group now, so \"which classes have I champed with a Libra unit?\" gets the same class checklist the secondary, support and gear filters give you. Because a unit's sign comes from the reign itself rather than the loadout files, this one works for every champion instead of only the ~400 with 50+ titles \u2014 if that picker never showed up for you before, it does now.",
        spotlight: false,
        link: '?player=LuxorDoesntFrame&tab=history'
    },
    {
        id: 'seasons-page-2026-07',
        date: 'Jul 14, 2026',
        emoji: "\uD83D\uDCC5",
        title: "Seasons \u2014 FFTBG era by era",
        body: 'A page for the shape of FFTBG over time: every season since 2019, each one ending in its Tournament of Champions. The grid view puts all of them side by side with class-meta drift sparklines; picking a season gives you its champions and win rates, its records, its biggest gambling winners, its loudest chatters, the emotes that were born in it, and that season\'s rookies. There is a per-player view too, showing a career as an arc across seasons, plus a titles-by-season strip on every profile.',
        spotlight: false,
        link: '?seasons'
    },
    {
        id: 'raid-boss-quest-2026-07',
        date: 'Jul 10, 2026',
        emoji: "\uD83D\uDC79",
        title: 'Raid Boss Quest & leaderboard',
        body: "Raid bosses \u2014 the buffed units that occasionally roll onto a challenger team \u2014 now have their own board: who has fielded the most, who has actually won titles with one, and at what rate. There is a quest attached, champing all 20 human jobs as a raid boss. Nobody has finished it; the leader sits at 11 of 20.",
        spotlight: false,
        link: '?players&tab=boards'
    },
    {
        id: 'mighty-sword-rework-2026-07',
        date: 'Jul 10, 2026',
        emoji: "\u2694\uFE0F",
        title: 'The Mighty Sword rework, modelled',
        body: "FFTBG reworked the Limit skillset, and the damage engine caught up. The four Mighty Sword skills moved from PA*WP to PA*(WP+N) with an MP cost; Unyielding Cut arrived with a two-branch conditional \u2014 it reads whether the target is armed and swings differently \u2014 which needed a formula family that keys off the defender's stats, a first for the parser. Siphon now drains a percentage of the target's MP rather than acting like a max-HP nuke. Card damage, the fight view, the Builder and the battle sim all reflect the new numbers.",
        spotlight: false
    },
    {
        id: 'grade-letters-rework-2026-07',
        date: 'Jul 8, 2026',
        emoji: "\uD83C\uDF93",
        title: 'Unit grades that actually spread out',
        body: "The letter on a unit card used to be a fraction of a theoretical ceiling, which crushed roughly 87% of human units into C+ or C \u2014 technically defensible and completely useless for telling two rolls apart. A human's letter is now its percentile among real rolls of the same class and gender, so an A genuinely means \"top ~11% roll for this class\". Monsters were re-fitted too: their grade follows a sample-weighted trend line through their Brave/Faith win curves at the unit's exact values, instead of snapping to a bucket \u2014 which had produced the odd result of an 82-Brave Tiamat grading below a 79-Brave one.",
        spotlight: false
    },
    {
        id: 'class-index-gender-2026-07',
        date: 'Jul 8, 2026',
        emoji: "\u26A5",
        title: 'Class & Monster Index, split by gender',
        body: "A \u26A5 toggle on the Stats page's Class & Monster Index breaks every human class into its own \u2642 and \u2640 rows \u2014 93 of them \u2014 with each column recomputed for that gender rather than pooled. Sorting by win rate then ranks them as separate entries, which is the only way to see the gaps that the combined view averages away.",
        spotlight: false,
        link: '?stats&cisplit=1'
    },
    {
        id: 'sprite-weapons-2026-07',
        date: 'Jul 6, 2026',
        emoji: "\uD83D\uDDE1\uFE0F",
        title: 'Units swing their actual weapons',
        body: "The sprite gallery can now play a unit's attack animation with its real equipped weapon composited on top \u2014 the long-standing hard part, since the game stores the weapon's position, rotation and scale per animation frame in a format that had to be reverse-engineered against emulator memory and GPU packets to get right. Every hand weapon in FFTBG except knives and thrown items now animates, including the ones the Arena added that have no original art and borrow from the same family.",
        spotlight: false,
        link: '?gallery'
    },
    {
        id: 'bracket-attack-anims-2026-07',
        date: 'Jul 7, 2026',
        emoji: "\uD83D\uDCA5",
        title: 'Live-match units attack on the bracket',
        body: 'Units in the current match occasionally break out of their idle animation and play a one-shot attack with the weapon they are actually holding. There is a toggle in Settings if you would rather they stood still, and it respects your system\'s reduced-motion preference.',
        spotlight: false
    },
    {
        id: 'game-data-source-2026-07',
        date: 'Jul 7, 2026',
        emoji: "\uD83D\uDCCA",
        title: 'Class, item and ability data straight from FFTBG',
        body: 'The class stats, item stats, ability text and tooltips behind every card and damage estimate now come from FFTBG\'s own published help files rather than a third-party mirror that had drifted. The parser refuses to write a snapshot it does not fully understand, so a game update that changes the format fails loudly instead of quietly poisoning the numbers. Tooltips are bundled now too, so the bracket no longer waits on a live fetch to show them.',
        spotlight: false
    },
    {
        id: 'carpet-bible-2026-07',
        date: 'Jul 4, 2026',
        emoji: "\uD83D\uDCD6",
        title: 'The Holy Carpet Bible & the Technospeak wheel',
        body: 'Two additions to the Chat menu on the sillier end. The Carpet Bible collects Technominari\'s ~13,000 long-form chat verses, sorted into Canon, Gospel and Apocrypha. The Technospeak wheel is a faithful, dependency-free port of the garish church-word spinner. Both are exactly as serious as they sound.',
        spotlight: false,
        link: '?carpet'
    },
    {
        id: 'classes-page-2026-07',
        date: 'Jul 3, 2026',
        emoji: "\uD83C\uDFAD",
        title: 'A page for every class and monster',
        body: "Default stats for every job and monster \u2014 20 human classes and 55 monsters \u2014 with animated walking sprites and a live unit card showing what a stock example of that class actually looks like. Each one carries a strategy section built from real win rates \u2014 the best and worst secondary, support, reaction, move and accessory picks for that class, and for monsters, where it sits in the rotation.",
        spotlight: false,
        link: '?classes'
    },
    {
        id: 'ability-breakdown-2026-07',
        date: 'Jul 2, 2026',
        emoji: "\uD83E\uDDEE",
        title: 'Show your work: full ability breakdowns',
        body: "Clicking an ability on a unit card now pins a breakdown showing exactly how the number was reached \u2014 the formula, then the same formula with the real values substituted in, then every modifier applied in order. It covers both teams rather than just enemies, handles drain and monster skills, and marks the riders that come along with a hit. Basic attacks got the same treatment on the weapon tooltip, and monster innate elemental affinities \u2014 including outright immunities \u2014 finally show up.",
        spotlight: false
    },
    {
        id: 'champ-history-filters-2026-07',
        date: 'Jul 26, 2026',
        emoji: "\uD83D\uDC51",
        title: 'Champion history: new filters, champion numbers, and bracket links',
        body: 'The championship history on your profile can now be sliced by the zodiac sign and gender of the unit you champed with, by team color, by ToC season, and by how long the reign lasted \u2014 on top of the class and loadout filters that were already there. You can also sort by zodiac, or by the Brave and Faith you held the belt at. Every reign now shows its place in the lineage \u2014 "#27,503", the 27,503rd champion in FFTBG history \u2014 and links straight to two brackets: the one you won the belt in, and your first defense. (Filters deep-link, so a filtered list is shareable.)',
        link: '?player=LuxorDoesntFrame&tab=history'
    },
    {
        id: 'best-worst-teams-2026-06',
        date: 'Jun 30, 2026',
        emoji: "\uD83C\uDFC5",
        title: 'Best & Worst Teams of all time',
        body: "A new leaderboard in the Champions menu: every 8-team bracket in FFTBG history \u2014 519k teams across 65k tournaments \u2014 graded by the same rating the unit cards use, ranked top and bottom 250, both all-time and for the modern era. There is also a Worst Champs board: the flukiest title-winners ever, like an F-graded squad that took the crown with a Swine and a Floating Eye on it. Each team lists its full roster and links straight to that tournament's bracket. (The grade reads through today's class/item data, so the all-time board is a present-day-lens estimate \u2014 the Modern board is the fair like-for-like cut.)",
        link: '?teams'
    },
    {
        id: 'cards-and-team-popup-2026-06',
        date: 'Jun 30, 2026',
        emoji: "\uD83C\uDFB4",
        title: 'Sharper cards & a richer team-rating popup',
        body: "The team-grade hover popup got a redesign \u2014 each unit now shows its class, a diverging win-rate bar, and the skills and stats that helped or hurt its grade, in a clean readable font. Two card fixes rode along: a stat now turns red when it is below its class average (it used to read green either way), and Attack Up / Magic Attack Up / Strengthen finally factor into the basic-attack damage shown on the card \u2014 they already did in the fight view and the sim.",
        spotlight: false
    },
    {
        id: 'carried-by-monsters-2026-06',
        date: 'Jun 28, 2026',
        emoji: "\uD83E\uDD1D",
        title: "Carried by Monsters \u2014 a new quest",
        body: 'Monster Quest, flipped on its head: a new board under Players \u25B8 \uD83C\uDFC5 Quests tracking every monster type a teammate fielded on a title team you won \u2014 the monsters that carried YOU, not the ones you piloted. It gets the full Monster-Quest treatment: completion-coin badges with "Nth-ever" ranks, an Elite/Strong checklist, and a celebration view listing every assist by date. (Zanbamon leads \u2014 carried by all 55 monster types four times over, while personally championing only 20 of them.) The same progress shows on every player profile. And the three separate gendered quests are now one Human Gendered board with \u2642 / \u2640 sub-tabs.',
        link: '?players&tab=quests&quest=carried'
    },
    {
        id: 'sim-fidelity-2-2026-06',
        date: 'Jun 27, 2026',
        emoji: "\u2694\uFE0F",
        title: 'More battle-sim fidelity',
        body: "Another round of fixes to the Monte-Carlo simulator behind every win-%. Summons and other ranged magic now respect their cast range and can't be side-stepped like a melee swing; Draw Out fills the whole field \u2014 allies, enemies and the caster alike; and Hamedo only pre-empts an attacker actually in range, never reacting to a monster's swing unless it's Berserk. Dual Wield lands its second strike for bare-fisted and innate dualists too, units now path around walls and void instead of freezing on maze maps (with Fly/Teleport gliding over gaps), and a batch of statuses, songs & dances, Fury, cleanses and Math Skill all resolve more faithfully \u2014 every change still gated against thousands of historical brackets.",
        link: '?mechanics',
        spotlight: false
    },
    {
        id: 'builder-from-bracket-2026-06',
        date: 'Jun 26, 2026',
        emoji: "\u270F\uFE0F",
        title: 'Send any bracket unit to the Builder',
        body: "Every unit on the bracket now has an \u270F\uFE0F button that drops it straight into the Character Builder, fully loaded \u2014 tweak it, regrade it, or grab its share link. The Builder's force/ban panel also got smarter: a proper class picker, a GilgameHeart toggle, and ban options that understand when two share a slot.",
        link: '?build',
        spotlight: false
    },
    {
        id: 'copypasta-page-2026-06',
        date: 'Jun 25, 2026',
        emoji: "\uD83D\uDDEF\uFE0F",
        title: 'A dedicated copypasta board',
        body: "The channel's long-form copypasta \u2014 the multi-sentence repost-pastas that the Lexicon's short list buries \u2014 now has its own page. Near-duplicate wordings of the same pasta are clustered into a single ranked entry (the festive-carpet family alone spans 18 variants), searchable and sortable, each expandable to its full text.",
        link: '?copypasta',
        spotlight: false
    },
    {
        id: 'swing-grade-2026-06',
        date: 'Jun 24, 2026',
        emoji: "\uD83D\uDCA5",
        title: 'Unit grades now weigh raw swing',
        body: "The letter grade on each unit now accounts for basic-attack burst \u2014 how hard a single normal swing actually lands \u2014 which the old grade under-counted, and it properly counts both hands on a Dual Wielder. A clean, if marginal, signal that nudges heavy-hitting bruisers up a notch.",
        spotlight: false
    },
    {
        id: 'wiznaibot-status-2026-06',
        date: 'Jun 20, 2026',
        emoji: "\uD83E\uDD16",
        title: "Wiznaibot Status \u2014 watch the bot bet",
        body: "A new page following Wiznaibot's automated betting bot in real time: its live bankroll and net winnings, every bet it places with the model's reasoning behind it, and how its picks are actually doing \u2014 the model's pick tracked separately from the bet it places, with voided bets marked instead of stuck \"pending\".",
        link: '?wiznaibot'
    },
    {
        id: 'chat-section-2026-06',
        date: 'Jun 19, 2026',
        emoji: "\uD83D\uDCAC",
        title: "Chat, mined \u2014 six years of the stream's conversation",
        body: "A whole new Chat section, built offline from ~42 million lines of the stream's Twitch chat. Chat Activity charts daily volume across six years \u2014 the 2020 viral peak settling into today's steady core \u2014 and ranks the most active chatters, by year or all-time. The Social Graph maps who @mentions whom, surfacing friend clusters and the biggest running feuds (Mushufasa_ vs NovaKnight21 leads at 1,560 exchanges). The Lexicon is a museum of the channel's emotes and copypasta \u2014 first-seen dates and rise-and-fall sparklines, so you can watch SourPls die and NODDERS take over. What Chat Forces breaks down 4.1 million !fight submissions: the classes and skills chat demands most, set against their real win rates (chat loves Knight and Calculator despite losing records). And an auto-built FAQ answers the questions chat actually asks. Every player profile also gains a \uD83D\uDCAC Chat tab \u2014 their persona, tenure, catchphrase, top emotes, go-to build, and arch-rival.",
        link: '?chat'
    },
    {
        id: 'combat-sim-overhaul-2026-06',
        date: 'Jun 18, 2026',
        emoji: "\u2694\uFE0F",
        title: 'The battle simulator, brought up to speed',
        body: "The Monte-Carlo battle sim behind every win-% \u2014 the \u2694 Simulate view, the bracket's % odds, and the Predict-the-Bracket favorite \u2014 got a deep fidelity pass against the Battle Mechanics Guide. Monsters now fight with their real intrinsic skills instead of just pecking (breath weapons, elemental souls, the Hydra triple-casts, Hurricane), and undead reanimate about half the time instead of crystallizing \u2014 while a Phoenix Down to the face kills them. Casters are interruptible: a unit mid-charge can't dodge and takes extra damage, Haste no longer shortens a cast, and Short Charge does. Whole skillsets that used to do nothing now connect \u2014 HP/MP drains (Night Sword), the Demi/Lich percent-HP nukes, Jump, Charge and Throw \u2014 alongside reactions like Dragon Spirit, HP Restore, Meatbone Slash and Arrow Guard. Critical hits, faith-gated magic (Innocent shrugs it off), and Slow / Silence / Confusion all matter now, and the AI commits to the fight like the real game instead of over-kiting. And the bracket and Predict odds now play out on each round's real battle map \u2014 its height, walls and chokepoints \u2014 instead of an abstract flat field. All gated against thousands of historical brackets so the odds stay honest.",
        link: '?mechanics'
    },
    {
        id: 'attendance-streaks-2026-06',
        date: 'Jun 17, 2026',
        emoji: "\uD83D\uDD01",
        title: "Attendance Streaks \u2014 who never misses",
        body: "New boards under Players \u25B8 \uD83D\uDCCA Boards: the longest run of consecutive tournaments a player ever took part in, counted three ways \u2014 in the bracket (any team, including holding the belt as champion), as a challenger (drafted onto a colored team, so a long title reign can't bridge a sleep gap), and \"typed !fight\" (drafted or snubbed \u2014 showed up and entered every single time). Memes are skipped, so they never break a streak, and any name links to that player's full profile.",
        link: '?players&tab=boards'
    },
    {
        id: 'sprite-gallery-2026-06',
        date: 'Jun 16, 2026',
        emoji: "\uD83C\uDF9E\uFE0F",
        title: "Sprite Gallery \u2014 every unit, animated",
        body: "A new Sprites page renders every FFT battle sprite straight off the disc \u2014 all the human jobs and monsters \u2014 animated: walk, attack, hurt and death, plus cast and dance for casters and performers, viewable from the front or the back. Each one recolors live through its 16 palettes, so you can flip a monster between its family tiers (Bomb \u2192 Grenade \u2192 Explosive) or a job between team colors, dial the zoom and box size, and export any pose as an animated GIF.",
        link: '?gallery'
    },
    {
        id: 'early-champs-2026-06',
        date: 'Jun 12, 2026',
        emoji: "\uD83D\uDCDC",
        title: 'Champion history now reaches Day One',
        body: "The first month of FFTBG championship history \u2014 389 reigns from Dec 29, 2019 to Jan 31, 2020, before full tournament records existed \u2014 has been recovered from the champion archive and merged in. The Line of Succession now traces back to the very first champion (a 13-defense blue-team run), and every early title now counts toward player championships, Monster Quest dates, droughts, and the class index.",
        link: '?crown'
    },
    {
        id: 'live-player-profile-2026-06',
        date: 'Jun 11, 2026',
        emoji: "\uD83C\uDF81",
        title: 'Live profiles: last unit + skill collection',
        body: 'Player profiles now pull live data straight from FFTBG. A "Last fielded" card shows each player\'s most recent tournament unit \u2014 with an Open in Builder button to remix it \u2014 and a new \uD83C\uDF81 Skills tab lays out their full !buyrandom collection: owned vs missing, rarity-colored, with the exact priority modifier every owned skill is applying (including the masked "Hidden Skill" and prestige unlocks). Set your handle in settings and the bracket\'s skill-drop chip will also tell you whether you already own the current drop.',
        link: '?players'
    },
    {
        id: 'meta-tides-2026-06',
        date: 'Jun 11, 2026',
        emoji: "\uD83C\uDF0A",
        title: "Meta Tides \u2014 watch the meta move",
        body: "A new Stats view charting three years of meta history: stacked tides of each class's share of tournament rolls month by month (by archetype \u2014 click one to open it up \u2014 or top classes), and a bump chart ranking the quarterly win-rate leaders, where you can watch classes like Bard swing from #18 to #3 and back. Also works for Supports, Reactions, Skillsets, and weapon types.",
        link: '?stats&view=tides'
    },
    {
        id: 'predict-bracket-2026-06',
        date: 'Jun 10, 2026',
        emoji: "\uD83D\uDD2E",
        title: "Predict-the-Bracket \u2014 can you beat the AI?",
        body: "A new game on the live bracket: hit the \uD83D\uDD2E button, predict the winner of every match, and watch your score fill in as the tournament plays out \u2014 head-to-head against the battle sim. Pick on the bracket cells or right inside the \u2694 Fight View, fill the whole bracket upfront or just predict the rest, and build a lifetime record with a beat-the-sim streak. Picks save in your browser.",
        link: './'
    },
    {
        id: 'mechanics-page-2026-06',
        date: 'Jun 9, 2026',
        emoji: "\uD83D\uDCD6",
        title: 'Battle Mechanics reference',
        body: "A new page explaining how FFTBG's battles actually work \u2014 damage formulas and the modifier pipeline, zodiac compatibility, evasion, elements, Faith & Brave, turn order, plus full status and reaction/support references. Three live calculators (damage step-through, the zodiac matrix, and an evasion demo) run on the same code the unit cards use.",
        link: '?mechanics'
    },
    // ── Jun 2026 — the revamp ships ───────────────────────────────
    {
        id: 'crown-lineage-2026-06',
        date: 'Jun 9, 2026',
        emoji: "\uD83D\uDC51",
        title: 'Line of Succession',
        body: "The complete crown lineage \u2014 every championship reign in order, newest first, with the team that dethroned each one. Filter by player, class, team color, or year. Find it under the new Champions menu, alongside the Tournament of Champions, Streaks, and Champions-by-class.",
        link: '?crown'
    },
    {
        id: 'player-compare-2026-06',
        date: 'Jun 9, 2026',
        emoji: "\u2694\uFE0F",
        title: 'Player vs Player comparison',
        body: "Pick any two players and compare their full FFTBG careers side by side \u2014 win rates, championships, titles by year, signature classes, and a full class-by-class breakdown with diverging edge bars. Deep-linkable and swappable.",
        link: '?compare'
    },
    {
        id: 'hall-of-fame-2026-06',
        date: 'Jun 9, 2026',
        emoji: "\uD83C\uDFDB\uFE0F",
        title: 'Hall of Fame',
        body: "The 350+ Championship Club gets its own page \u2014 12 superlative awards (Most Championships, Longest Reign, Ultimate Specialist, and more) plus a sortable full roster with an adjustable threshold. Find it under Players.",
        link: '?hall'
    },
    {
        id: 'builder-random-2026-06',
        date: 'Jun 9, 2026',
        emoji: "\uD83C\uDFB2",
        title: 'Random generator merged into Builder',
        body: "The random unit generator now lives inside the Builder page \u2014 generate a random unit and immediately tweak every field. The \uD83C\uDFB2 bracket button links straight to it.",
        link: '?build&random'
    },
    {
        id: 'active-droughts-2026-06',
        date: 'Jun 8, 2026',
        emoji: "\uD83C\uDFDC\uFE0F",
        title: 'Active droughts on leaderboards',
        body: 'Ongoing streaks now appear alongside completed droughts. "Drought to first" tracks players who\'ve rolled a class 10+ times without ever champing it; "drought gap" tracks 10+ rolls since their last title. Active entries show in italics with a tag so you can watch them climb.',
        link: '?players&tab=droughts',
        spotlight: false
    },
    {
        id: 'equip-shield-fix-2026-06',
        date: 'Jun 8, 2026',
        emoji: "\uD83D\uDEE1\uFE0F",
        title: 'Equip Shield + Builder fixes',
        body: "Equip Shield now correctly unlocks offhand shields in the Builder and gear editor. Mimes with Equip Shield can dual-wield shields \u2014 the evasion math handles both (FFT's multiplicative formula: two Aegis Shields = 55% magic evade, not 66%). Non-Mime classes still get the standard offhand-only rule.",
        link: '?build'
    },
    {
        id: 'player-hover-2026-06',
        date: 'Jun 8, 2026',
        emoji: "\uD83D\uDC64",
        title: 'Player hover cards',
        body: "Hover any player name on the bracket for a quick career snapshot \u2014 win rate, games played, bracket wins, championships + title defenses, and their top 4 classes by games. Click to jump straight to their full profile page.",
        spotlight: false
    },
    {
        id: 'class-droughts-2026-06',
        date: 'Jun 8, 2026',
        emoji: "\uD83C\uDFDC\uFE0F",
        title: 'Class Droughts',
        body: 'How many rolls did it take before your first title with a class? What\'s the longest gap between titles? A dedicated Droughts tab on the Players page with per-class leaderboards (drought-to-first and longest gap), duration in days, class headshot icons, and drought stats on every player\'s profile.',
        link: '?players&tab=droughts'
    },
    {
        id: 'goal-tracker-2026-06',
        date: 'Jun 6, 2026',
        emoji: "\uD83C\uDFAF",
        title: 'Goal tracker',
        body: 'Pin any quest or achievement as your active goal from your profile page. A persistent widget on the bracket page shows what you still need and checks off progress as you play. Dismissible per-session, re-settable any time.'
    },
    {
        id: 'player-profile-2026-06',
        date: 'Jun 5, 2026',
        emoji: "\uD83D\uDC64",
        title: 'Player Profile page',
        body: "A dedicated page for every player \u2014 tabbed into Overview (career stats, win rates by class), Achievements (tiered badges for milestones, quests, betting feats), History (championship timeline, monthly title chart, zodiac wheel, longest reign), and Gambling (balance, ROI, biggest swings). Set your username in Settings for a quick-access button.",
        link: '?players'
    },
    {
        id: 'win-rate-highlighting-2026-06',
        date: 'Jun 4, 2026',
        emoji: "\uD83C\uDFA8",
        title: 'Win-rate highlighting',
        body: "Skills, abilities, and stats on the unit card are colored by their empirical win rate \u2014 green for above average, red for below. Baselines are gender-aware and class-relative, so a Mediator's 400 HP reads differently than a Knight's. Covers secondary skillsets, support/reaction/move skills, individual ability names, and the six core stats.",
        spotlight: false
    },
    {
        id: 'onboarding-2026-06',
        date: 'Jun 3, 2026',
        emoji: "\uD83D\uDC4B",
        title: 'Welcome tour + feature spotlights',
        body: "First-time visitors get a step-by-step guided tour of the bracket page \u2014 teams, unit cards, the fight view, and the nav bar. Returning users see a one-time spotlight popup when new features ship. Both are tracked in localStorage so they only fire once.",
        spotlight: false
    },
    {
        id: 'strategy-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\uD83E\uDDED",
        title: 'Strategy page',
        body: "Per-class best and worst skill picks derived from 6 years of empirical win-rate data. Covers every forceable slot \u2014 secondary skillset, support, reaction, move, and accessory. A Humans tab with per-class strategy cards (click for the full breakdown) and a Monsters tab with the rotation guide. Only suggests picks that are actual stream tokens you can force.",
        link: '?players&tab=strategy',
        spotlight: false
    },
    {
        id: 'memes-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\uD83C\uDCCF",
        title: 'Meme Tournaments page',
        body: "A filterable history of ~758 non-standard events \u2014 ToC brackets (auto-detected, including preshows), Algus mode, Halloween, April Fools, and unclassified meme rulesets. Bucket filters, a meme-type guide, champion-vs-winner rosters, and link-out per tournament. These are excluded from every stat computation so normal play stays clean.",
        link: '?memes',
        spotlight: false
    },
    {
        id: 'site-nav-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\uD83D\uDDC2\uFE0F",
        title: 'Site-wide navigation bar',
        body: "A persistent tab bar across every page \u2014 Bracket, Champions, Players, Maps, Gear Lab, Builder, Memes, Stats \u2014 with active-tab highlighting and a Players mega-menu for quick access to sub-tabs. Collapses to a hamburger menu on mobile. The bracket page renders its own nav variant with action buttons (settings, help, generator, prev-tournament).",
        spotlight: false
    },
    {
        id: 'sim-calibration-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\uD83D\uDCD0",
        title: 'Sim probability calibration',
        body: "Raw sim win rates were wildly overconfident \u2014 a 60/40 matchup would show as 85%. Now Platt-calibrated against ~2,400 real matches with a train/test split, bringing the Brier score from 0.33 to 0.25. A separate UI scaling factor keeps the displayed odds readable (clear favorites still read ~65-75%) while the underlying math stays honest.",
        spotlight: false
    },
    {
        id: 'builder-2026-06',
        date: 'Jun 1, 2026',
        emoji: "\uD83D\uDD27",
        title: 'Character Builder',
        body: "Build a unit from scratch \u2014 pick class, gender, zodiac, Brave/Faith, skills, and gear \u2014 with a live unit card that updates as you go (damage formulas, evasion, elements, all of it). Export in FFTBG stream format for pasting, import from a paste, or share via a URL (?build&u=...). Gear options respect class legality and Equip-X support skills.",
        link: '?build',
        spotlight: false
    },
    {
        id: 'gear-lab-2026-06',
        date: 'Jun 1, 2026',
        emoji: "\uD83D\uDD0D",
        title: 'Gear Lab',
        body: 'Pick an item (or a pair) and explore its history across ~2.3 million units. Per-slot facets show how often it rolls, its win rate, top class, and example players. Two-item search finds co-equipped combos and how they perform together. Browse items by popularity with the fancy picker, or deep-link with ?gear&a=Slot:Item.',
        link: '?gear',
        spotlight: false
    },
    // ── Jun 2026 — Maps ───────────────────────────────────────────
    {
        id: 'maps-psx-mesh-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\uD83D\uDDFA\uFE0F",
        title: 'Real PSX map meshes',
        body: "All 121 battle maps now render their actual PlayStation geometry \u2014 meshes and textures extracted straight from the disc image, with transparency and palette fixes for the tricky ones (Death City, Chocobo Forest, etc.). Viewable in the 3D viewer on each map's detail page.",
        link: '?maps',
        spotlight: false
    },
    {
        id: 'maps-page-2026-06',
        date: 'Jun 1, 2026',
        emoji: "\uD83D\uDDFA\uFE0F",
        title: 'Maps page',
        body: 'A searchable grid of all 138 battle maps with empirical class win-rate profiles (which classes a map favors or hurts), terrain height grids, a 3D viewer, starting positions from the game\'s ENTD binary, Calculator height-targeting analysis, and start-side balance (the left/right team advantage per map). Built from ~65k tournaments of QF match data. Click any card for the full detail page with sortable class/skill tables.',
        link: '?maps',
        spotlight: false
    },
    // ── Jun 2026 — Sim ────────────────────────────────────────────
    {
        id: 'sim-terrain-2026-06',
        date: 'Jun 2, 2026',
        emoji: "\u2694\uFE0F",
        title: 'Battle sim on real terrain',
        body: "The Monte Carlo sim now runs on real map geometry \u2014 true width/height grids with walls, void tiles, elevation, and jump-aware pathfinding. Starting positions use the authoritative ENTD data. The battle replay viewer renders the actual terrain with elevation shading and height numbers so you can watch fights play out on the real battlefield.",
        spotlight: false
    },
    {
        id: 'sim-realism-2026-06',
        date: 'Jun 1, 2026',
        emoji: "\u2694\uFE0F",
        title: 'Battle simulator',
        body: 'A full Monte Carlo team-vs-team combat sim faithful to FFT mechanics. 600 runs per matchup with facing-aware evasion, charge-time spells, reactions (Counter/Hamedo/Blade Grasp/Auto-Potion), friendly-fire AoE, mimes that echo allies, linear attacks, dual wield, status effects (Charm/Berserk/Frog/Darkness/Reflect and more), zodiac compatibility, elemental affinity, and a greedy AI that flanks, kites, and prioritizes casters.',
        spotlight: false
    },
    // ── May 2026 ──────────────────────────────────────────────────
    {
        id: 'sounds-2026-05',
        date: 'May 2026',
        emoji: "\uD83D\uDD0A",
        title: 'Notification sounds',
        body: "Pure Web Audio synth alerts (no downloaded assets) when your highlighted players' units win, lose, or become champion \u2014 plus a new-tournament ding. Three sound sets (chime, retro, bell) with five per-event toggles and preview buttons in Settings. Fires on the 60-second live poll, with snapshot tracking so already-decided matches stay silent.",
        spotlight: false
    },
    {
        id: 'streaks-2026-05',
        date: 'May 2026',
        emoji: "\uD83D\uDD25",
        title: 'Streaks + Greatest Dynasties',
        body: "Longest championship reigns by class, and a Greatest Dynasties leaderboard \u2014 the longest unbroken title-defense runs in FFTBG history. Expandable rosters show the units that held the throne. Glitch-split reigns (where a meme tournament briefly interrupted a streak) are bridged so the real dynasty length is preserved.",
        link: '?players&tab=streaks',
        spotlight: false
    },
    {
        id: 'betting-2026-05',
        date: 'May 2026',
        emoji: "\uD83D\uDCB0",
        title: 'Betting leaderboards + profiles',
        body: "Gambling stats for ~17k players \u2014 current balance, all-time ROI, win rate, biggest single win/loss, and balance-over-time charts. Sortable boards (richest, best ROI, most bets, biggest single win). Player names are case-folded and merged across account renames so careers track correctly.",
        link: '?players&tab=betting',
        spotlight: false
    },
    {
        id: 'achievements-2026-05',
        date: 'May 2026',
        emoji: "\uD83C\uDFC5",
        title: 'Achievements',
        body: 'Tiered badges (bronze/silver/gold) for career milestones (games, wins, bracket wins), quest completions (Monster Quest, Human Quest, Everything Bagel, and more), betting feats, gendered championships, zodiac signs collected, and team colors won with. Shown on the player profile\'s Achievements tab.',
        spotlight: false
    },
    {
        id: 'players-2026-05',
        date: 'May 2026',
        emoji: "\uD83D\uDC65",
        title: 'Players page',
        body: 'A searchable, sortable directory of ~17k players (min 5 games) across the full ~6-year history. Games, win rate, bracket wins, championships, per-class win-rate bars, and best/worst class. Tabs for Monster Quest progress (completions leaderboard, icon checklists, speedruns, Monster Families), Champions-by-class top-50 boards, and career boards (Old Guard, Day One, Fresh Blood). Player names are merged across account renames.',
        link: '?players',
        spotlight: false
    },
    {
        id: 'champions-2026-05',
        date: 'May 2026',
        emoji: "\uD83C\uDFC6",
        title: 'Champions page',
        body: "The current season's champion roster from the live API \u2014 a top-8 seeded bracket with on-demand Monte Carlo sim odds, a sortable leaderboard (rank, streak, team grade, expandable rosters), a season picker to browse past seasons, and a pinned Champion of Champions banner. Unit cards are fully interactive with damage formulas and gear details.",
        link: '?champions',
        spotlight: false
    },
    {
        id: 'stats-v2-2026-05',
        date: 'May 2026',
        emoji: "\uD83D\uDCCA",
        title: 'Stats panel v2',
        body: "A complete rewrite of the stats panel. Windowed views (1 week / 1 month / 1 year / all), dimension picker with sortable tables, a skill-to-class drill-down (click any skill row to see its win rate broken down by class), a class filter (pick a class to see every skill's win rate for it), archetype splits (caster/melee/hybrid/monster), per-monster Brave/Faith curves, market favorite-rate by round, and the Class & Monster Index \u2014 a sortable table of all 76 types combining combat win rate with championship success. Replaced the old static stats grid entirely.",
        spotlight: false
    },
    {
        id: 'fight-view-2026-05',
        date: 'May 2026',
        emoji: "\u2694\uFE0F",
        title: 'Fight view + damage matrix',
        body: "Click any bracket cell to open the fight view. Pick an attacker from either team and see a matrix of their damaging abilities (plus basic Attack, Jump, status spells) against all four enemies \u2014 estimated damage, hit chance, and color-coded weak/half/absorb. Click a cell for the step-by-step breakdown. Target-status checkboxes (Protect/Shell/Charging/Sleeping/Frog/Oil) recompute on the fly. Estimated turn order up top. Dual Wield shows two Attack rows. Mimes list teammates' abilities recomputed with the mime's own stats.",
        spotlight: false
    },
    {
        id: 'unit-cards-2026-05',
        date: 'May 2026',
        emoji: "\uD83C\uDCCF",
        title: 'Revamped unit cards',
        body: "Three-state unit cards: compact (portrait + one-line loadout summary) \u2192 detailed (click to expand in place) \u2192 full modal. Parser-driven damage formulas from the API info strings, colored skill rarity pills with roll percentages, directional evasion (front/side/back physical + magic), zodiac compatibility blocks per team, elemental affinity chips (strengthen/absorb/half/weak/cancel), and a damage-tuning panel with Brave/Faith sliders and a disarm toggle.",
        spotlight: false
    },
    // ── The original site ─────────────────────────────────────────
    {
        id: 'original-site',
        date: "2020\u20132025",
        emoji: "\uD83C\uDFD7\uFE0F",
        title: 'The original Wiznaib.us',
        body: "The site that started it all \u2014 a live bracket viewer with team grids, per-unit stat cards, item/skill tooltips, basic damage estimates, the random character generator (with force/ban token support), highlighted users, tournament archive browsing (?tournament=ID), and the original stats table. Built while learning Vue, powered by the FFTBG and mustad.io APIs.",
        spotlight: false
    }
];

});

parcelRegister("ct3vs", function(module, exports) {

$parcel$export(module.exports, "onboardSeen", () => $913ae9c000579bf5$export$d2757eafe0bb0c56);
$parcel$export(module.exports, "markOnboardSeen", () => $913ae9c000579bf5$export$33bdb7ea89fabe72);
$parcel$export(module.exports, "resetOnboarding", () => $913ae9c000579bf5$export$dea66eba5305d71a);
$parcel$export(module.exports, "introForced", () => $913ae9c000579bf5$export$707eb1264d016e59);
// Tiny localStorage-backed "have they seen this onboarding bit?" tracker.
// Keyed by id ('intro', 'tour.main', 'tour.players', 'tour.champions') so each
// piece fires at most once. Bump SCHEMA to re-show everything after a big change.
const $913ae9c000579bf5$var$KEY = 'wiznaibOnboarding.v1';
const $913ae9c000579bf5$var$read = ()=>{
    try {
        return JSON.parse(localStorage.getItem($913ae9c000579bf5$var$KEY) || '{}');
    } catch  {
        return {};
    }
};
function $913ae9c000579bf5$export$d2757eafe0bb0c56(id) {
    return $913ae9c000579bf5$var$read()[id] === true;
}
function $913ae9c000579bf5$export$33bdb7ea89fabe72(id) {
    try {
        const o = $913ae9c000579bf5$var$read();
        o[id] = true;
        localStorage.setItem($913ae9c000579bf5$var$KEY, JSON.stringify(o));
    } catch  {}
}
function $913ae9c000579bf5$export$dea66eba5305d71a() {
    try {
        localStorage.removeItem($913ae9c000579bf5$var$KEY);
    } catch  {}
}
function $913ae9c000579bf5$export$707eb1264d016e59() {
    try {
        return new URLSearchParams(window.location.search).has('intro');
    } catch  {
        return false;
    }
}

});

parcelRegister("8nxfB", function(module, exports) {

$parcel$export(module.exports, "buildCharStats", () => $619a439be62403ca$export$2708bd72d2ba8fad);
$parcel$export(module.exports, "buildItemsChanged", () => $619a439be62403ca$export$86603ac4c68b1519);
$parcel$export(module.exports, "buildAbilitiesInfo", () => $619a439be62403ca$export$c8f5f182f342b72b);
$parcel$export(module.exports, "buildNotables", () => $619a439be62403ca$export$3ab0417983643234);
$parcel$export(module.exports, "buildGameData", () => $619a439be62403ca$export$7f9e87ce8c52fc3b);
// Normalization for the mustad.io class/item API responses, shared by the app
// (Luxstadio) and the offline tools (backtest / stats backfill) so they build
// identical `charStats` / `itemschanged` dictionaries.
//
// `safeDict` wraps a name-keyed dict so a missing key returns a frozen
// zero-filled default instead of `undefined` (which would propagate NaN through
// stat sums). It also blocks Vue's reactive-proxy probes so toRaw() doesn't
// unwrap it — harmless when used outside Vue.
const $619a439be62403ca$export$82921636ce4ea263 = Object.freeze({
    name: '',
    type: '',
    info: '',
    hp: 0,
    mp: 0,
    wp: 0,
    move: 0,
    jump: 0,
    speed: 0,
    pa: 0,
    ma: 0,
    permstatus: 0,
    initstatus: 0,
    mevade: 0,
    pevade: 0,
    wevade: 0,
    element: 0
});
const $619a439be62403ca$export$b13c6d29d4b9e0ef = Object.freeze({
    name: '',
    hp: 0,
    mp: 0,
    move: 0,
    jump: 0,
    speed: 0,
    pa: 0,
    ma: 0,
    cEvPercent: 0,
    innates: []
});
const $619a439be62403ca$export$28e586de0533d5a6 = Object.freeze({
    move: 0,
    jump: 0
});
function $619a439be62403ca$export$99c81060c02fbe03(obj, defaults) {
    return new Proxy(obj, {
        get (target, key) {
            // Block Vue's reactive-proxy probes (__v_raw, __v_isReactive, …) so a
            // toRaw() on assignment doesn't strip the missing-key fallback.
            if (typeof key === 'string' && key.startsWith('__v_')) return undefined;
            if (key in target) return target[key];
            if (typeof key === 'symbol') return target[key];
            return defaults;
        }
    });
}
function $619a439be62403ca$export$341a893b8337cbe2(apiItem) {
    const s = apiItem.stats || {};
    return {
        name: apiItem.name || '',
        type: apiItem.type || '',
        info: apiItem.info || '',
        hp: s.hp || 0,
        mp: s.mp || 0,
        wp: s.wp || s.absorbWp || 0,
        move: s.move || 0,
        jump: s.jump || 0,
        speed: s.speed || 0,
        pa: s.pa || 0,
        ma: s.ma || 0,
        element: s.element || 0,
        permstatus: s.permStatuses || 0,
        initstatus: s.initialStatuses || 0,
        mevade: s.magicEvadePercent || 0,
        pevade: s.physEvadePercent || 0,
        wevade: s.evadePercent || 0
    };
}
function $619a439be62403ca$export$4f7022d2d68e2c5a(apiClass) {
    const s = apiClass.baseStats || {};
    return {
        name: apiClass.name || '',
        hp: s.hp || 0,
        mp: s.mp || 0,
        move: s.move || 0,
        jump: s.jump || 0,
        speed: s.speed || 0,
        pa: s.pa || 0,
        ma: s.ma || 0,
        cEvPercent: s.cEvPercent || 0,
        innates: apiClass.innates || [],
        effect: apiClass.effect || ''
    };
}
const $619a439be62403ca$export$dc4802e3871361cd = [
    {
        name: 'Leather Vest',
        type: 'Armor',
        stats: {
            hp: 40,
            speed: 1,
            move: 1
        }
    },
    {
        name: 'Broad Sword',
        type: 'Sword',
        stats: {
            pa: 1
        }
    },
    {
        name: 'Long Sword',
        type: 'Knight Sword',
        stats: {
            wp: 5
        }
    },
    {
        name: 'Ice Bow',
        type: 'Bow',
        stats: {}
    }
];
function $619a439be62403ca$export$2708bd72d2ba8fad(apiClasses) {
    const classes = {};
    for (const c of apiClasses)classes[c.name + c.gender] = $619a439be62403ca$export$4f7022d2d68e2c5a(c);
    return $619a439be62403ca$export$99c81060c02fbe03(classes, $619a439be62403ca$export$b13c6d29d4b9e0ef);
}
function $619a439be62403ca$export$86603ac4c68b1519(apiItems) {
    const items = {};
    for (const it of apiItems)items[it.name] = $619a439be62403ca$export$341a893b8337cbe2(it);
    items[''] = $619a439be62403ca$export$341a893b8337cbe2({
        name: '',
        stats: {}
    });
    for (const it of $619a439be62403ca$export$dc4802e3871361cd)items[it.name] = $619a439be62403ca$export$341a893b8337cbe2(it);
    return $619a439be62403ca$export$99c81060c02fbe03(items, $619a439be62403ca$export$82921636ce4ea263);
}
function $619a439be62403ca$export$c8f5f182f342b72b(apiAbilities) {
    const info = {};
    for (const a of apiAbilities || [])info[a.name] = a.info;
    return info;
}
function $619a439be62403ca$export$3ab0417983643234(notablesJson) {
    return {
        ...notablesJson,
        movementSkills: $619a439be62403ca$export$99c81060c02fbe03({
            ...notablesJson.movementSkills
        }, $619a439be62403ca$export$28e586de0533d5a6)
    };
}
function $619a439be62403ca$export$7f9e87ce8c52fc3b(classesBackup, itemsBackup, abilitiesBackup, notablesJson, monsterSkills = {}) {
    return {
        charStats: $619a439be62403ca$export$2708bd72d2ba8fad(classesBackup.classes),
        itemschanged: $619a439be62403ca$export$86603ac4c68b1519(itemsBackup.items),
        notAbles: $619a439be62403ca$export$3ab0417983643234(notablesJson),
        abilitiesInfo: $619a439be62403ca$export$c8f5f182f342b72b(abilitiesBackup.abilities),
        monsterSkills: monsterSkills
    };
}

});

parcelRegister("pVEOf", function(module, exports) {

$parcel$export(module.exports, "freshGoalInfo", () => $04df0f6fc74ba75d$export$4c7abfc35bbcb79e);
// Keeps the bracket page's goal widget current.
//
// The widget shows prefs.goalInfo, a saved copy of the pinned goal's progress. Only the
// profile page used to write it, so after winning a title you still needed, the bracket
// page kept asking for it until you happened to open your own profile. The bracket page
// now rebuilds the copy itself whenever a newer data build is out. The copy records
// which build it came from (goalInfo.src: the manifest keys of the files it was
// computed from), so while nothing new is published, a check costs one small manifest
// read. The math is the profile's own (goals.js), so the two can't disagree.

var $gKfUi = parcelRequire("gKfUi");

var $78F4Z = parcelRequire("78F4Z");

var $7HnMz = parcelRequire("7HnMz");

var $aBXwx = parcelRequire("aBXwx");

var $ed72L = parcelRequire("ed72L");

var $htddP = parcelRequire("htddP");
async function $04df0f6fc74ba75d$export$4c7abfc35bbcb79e(prefs) {
    const goal = prefs.activeGoal;
    if (!goal || !prefs.myUsername) return undefined;
    const m = await (0, $gKfUi.latestManifest)();
    if (!m || !m.files) return undefined;
    const quest = goal.type === 'quest';
    // Only Carried by Monsters reads champHistory, and only achievements read the betting file.
    const names = [
        'playerIndex.json',
        quest && goal.id === 'carried' ? 'champHistory.json' : null,
        quest ? null : 'bettingStats.json'
    ];
    const keys = names.map((n)=>n && m.files[n]);
    if (keys.some((k, i)=>names[i] && !k)) return undefined;
    const src = keys.filter(Boolean).join(' ');
    if (prefs.goalInfo && prefs.goalInfo.src === src) return undefined;
    const [index, history, betting] = await Promise.all(keys.map((k)=>k ? (0, $gKfUi.loadFile)(k) : null));
    const { canonical: canonical, record: record } = (0, $ed72L.resolvePlayerName)(prefs.myUsername, index, (0, (/*@__PURE__*/$parcel$interopDefault($htddP))).alias);
    if (!record) return undefined;
    const player = (0, $78F4Z.playerFromRecord)(canonical, record);
    const classAgg = (0, $78F4Z.buildClassAgg)(Object.values(index)), mon = (0, $78F4Z.monsterClasses)(classAgg);
    const quests = quest ? (0, $7HnMz.playerQuests)(player, {
        monsterClasses: mon,
        humanClasses: (0, $78F4Z.humanClasses)(classAgg),
        classAgg: classAgg,
        carried: history && (0, $7HnMz.carriedByMonsters)(history, canonical, mon)
    }) : [];
    const achievements = quest ? [] : (0, $aBXwx.achievementsFull)(player, mon, betting && (0, $78F4Z.bettingFor)(betting, canonical));
    const info = (0, $7HnMz.goalSnapshot)(goal, quests, achievements);
    return info && {
        ...info,
        src: src
    };
}

});
parcelRegister("7HnMz", function(module, exports) {

$parcel$export(module.exports, "playerQuests", () => $59aeff37f77eaed6$export$97387657aa4bffda);
$parcel$export(module.exports, "carriedByMonsters", () => $59aeff37f77eaed6$export$8820b1aa44c6fff6);
$parcel$export(module.exports, "goalSnapshot", () => $59aeff37f77eaed6$export$6959bc8ded3acfa);
// Championship quests, and the goal a player can pin from their profile.
//
// The profile page shows every quest's progress. A player can also pin one quest or
// achievement as their goal (prefs.activeGoal), and the bracket page shows it in a small
// widget from prefs.goalInfo: a saved copy ({ name, remaining, status }) that spares the
// bracket page the 7 MB player index on every visit. Both pages build that copy here,
// from the same data, so they can't disagree. Pure: the caller supplies the player and
// the class lists (see playerHelpers buildClassAgg / monsterClasses / humanClasses).
const $59aeff37f77eaed6$export$3129b95e77248ecb = [
    'Aries',
    'Taurus',
    'Gemini',
    'Cancer',
    'Leo',
    'Virgo',
    'Libra',
    'Scorpio',
    'Sagittarius',
    'Capricorn',
    'Aquarius',
    'Pisces',
    'Serpentarius'
];
function $59aeff37f77eaed6$export$97387657aa4bffda(player, { monsterClasses: monsterClasses, humanClasses: humanClasses, classAgg: classAgg, carried: carried }) {
    if (!player || !player.champClasses) return [];
    const cc = player.champClasses, cs = player.champSigns || {};
    const mon = monsterClasses, hum = humanClasses, agg = classAgg;
    const canM = (c)=>agg[c] && agg[c][0] > 0, canF = (c)=>agg[c] && agg[c][1] > 0;
    // Count how many targets the player has championed, how many full sets, and what's still needed.
    // `remaining` = targets never championed (for first completion).
    // `remainingNext` = targets at the minimum count (for the next full set, once all done once).
    const calc = (targets, countFn, labelFn)=>{
        let championed = 0, minC = Infinity;
        const remaining = [], counts = [];
        for (const t of targets){
            const c = countFn(t);
            counts.push({
                t: t,
                c: c
            });
            if (c > 0) championed++;
            else remaining.push(labelFn(t));
            if (c < minC) minC = c;
        }
        const completions = championed === targets.length ? minC : 0;
        // For repeat completionists: what's needed for the next set
        const remainingNext = completions > 0 ? counts.filter((x)=>x.c === minC).map((x)=>labelFn(x.t)) : [];
        return {
            championed: championed,
            total: targets.length,
            completions: completions,
            pct: Math.round(100 * championed / (targets.length || 1)),
            remaining: remaining,
            remainingNext: remainingNext
        };
    };
    const classCount = (cls)=>cc[cls] && cc[cls][0] || 0;
    const genderCount = (cls, idx)=>cc[cls] && cc[cls][idx] || 0;
    const gendered = hum.flatMap((c)=>[
            canM(c) ? {
                cls: c,
                idx: 1
            } : null,
            canF(c) ? {
                cls: c,
                idx: 2
            } : null
        ].filter(Boolean));
    const gLabel = (t)=>t.cls + (t.idx === 1 ? " \u2642" : t.idx === 2 ? " \u2640" : '');
    // All-Male / All-Female are now sub-progress inside the Human Gendered card (mirrors the leaderboard's ♂/♀ sub-tabs).
    const maleProg = calc(hum.filter(canM), (cls)=>genderCount(cls, 1), (c)=>c);
    const femaleProg = calc(hum.filter(canF), (cls)=>genderCount(cls, 2), (c)=>c);
    const car = carried || {};
    return [
        {
            id: 'monster',
            emoji: "\uD83D\uDC09",
            name: 'Monster Quest',
            ...calc(mon, (cls)=>classCount(cls), (c)=>c)
        },
        {
            id: 'carried',
            emoji: "\uD83E\uDD1D",
            name: 'Carried by Monsters',
            ...calc(mon, (cls)=>car[cls] || 0, (c)=>c)
        },
        {
            id: 'human',
            emoji: "\uD83D\uDDE1\uFE0F",
            name: 'Human Quest',
            ...calc(hum, (cls)=>classCount(cls), (c)=>c)
        },
        {
            id: 'everything',
            emoji: "\uD83C\uDF0D",
            name: 'Everything Quest',
            ...calc([
                ...hum,
                ...mon
            ], (cls)=>classCount(cls), (c)=>c)
        },
        {
            id: 'gendered',
            emoji: "\u26A5",
            name: 'Human Gendered',
            ...calc(gendered, (t)=>genderCount(t.cls, t.idx), gLabel),
            sub: [
                {
                    label: "\u2642 Male-only",
                    ...maleProg
                },
                {
                    label: "\u2640 Female-only",
                    ...femaleProg
                }
            ]
        },
        {
            id: 'bagel',
            emoji: "\uD83E\uDD6F",
            name: 'Everything Bagel',
            ...calc([
                ...gendered,
                ...mon.map((c)=>({
                        cls: c,
                        idx: 0
                    }))
            ], (t)=>t.idx === 0 ? classCount(t.cls) : genderCount(t.cls, t.idx), gLabel)
        },
        {
            id: 'zodiac',
            emoji: "\u2B50",
            name: 'Zodiac Quest',
            ...calc($59aeff37f77eaed6$export$3129b95e77248ecb, (sign)=>cs[sign] || 0, (s)=>s)
        }
    ];
}
function $59aeff37f77eaed6$export$8820b1aa44c6fff6(champHistory, me, monsterClasses) {
    const tset = new Set(monsterClasses), out = {};
    for (const i of champHistory.p[me] || []){
        const units = champHistory.r[i][3], seen = new Set();
        for (const tm of units){
            if (tm[0] === me || tm[2] !== 'X' || !tset.has(tm[1])) continue;
            seen.add(tm[1]);
        }
        for (const m of seen)out[m] = (out[m] || 0) + 1;
    }
    return out;
}
function $59aeff37f77eaed6$export$6959bc8ded3acfa(goal, quests, achievements) {
    if (!goal) return null;
    if (goal.type === 'quest') {
        const q = quests.find((x)=>x.id === goal.id);
        return q ? {
            name: q.emoji + ' ' + q.name,
            remaining: q.remaining.length ? q.remaining : q.remainingNext,
            status: q.championed + '/' + q.total
        } : null;
    }
    const a = achievements.find((x)=>x.label === goal.id);
    return a ? {
        name: a.emoji + ' ' + a.label,
        remaining: [],
        status: a.status
    } : null;
}

});

parcelRegister("aBXwx", function(module, exports) {

$parcel$export(module.exports, "gilFmt", () => $7b9b884b9f122834$export$65ff0f1c4052bd6);
$parcel$export(module.exports, "achievementsFull", () => $7b9b884b9f122834$export$b6b243e0afd011f9);
$parcel$export(module.exports, "achievementsEarned", () => $7b9b884b9f122834$export$93b98044833d4352);
/**
 * Player achievement definitions — shared by PlayerView (directory badges)
 * and PlayerProfileView (full achievement grid).
 *
 * Each achievement is a current/goal pair; cur/goal take (player, ctx) where
 * ctx = { monsters: string[], betting: object|null }.
 * Tiered achievements carry `tiers` (ascending milestones); single achievements
 * carry `goal` (one threshold; `bin` = yes/no binary).
 */ const $7b9b884b9f122834$var$YEAR_MS = 31557600000;
const $7b9b884b9f122834$var$ZODIAC_SIGNS = [
    'Aries',
    'Taurus',
    'Gemini',
    'Cancer',
    'Leo',
    'Virgo',
    'Libra',
    'Scorpio',
    'Sagittarius',
    'Capricorn',
    'Aquarius',
    'Pisces',
    'Serpentarius'
];
const $7b9b884b9f122834$export$65ff0f1c4052bd6 = (n)=>{
    const a = Math.abs(n);
    if (a >= 1e6) return +(n / 1e6).toFixed(1) + 'M';
    if (a >= 1e3) return Math.round(n / 1e3) + 'k';
    return '' + Math.round(n);
};
const $7b9b884b9f122834$var$sumGender = (p, i)=>{
    if (!p.champClasses) return 0;
    let s = 0;
    for (const c of Object.values(p.champClasses))s += c[i] || 0;
    return s;
};
const $7b9b884b9f122834$export$832dd75819e4111d = [
    {
        emoji: "\uD83D\uDC51",
        label: 'Championships',
        short: 'champs',
        cur: (p)=>p.champ || 0,
        tiers: [
            1,
            25,
            100,
            250,
            500,
            1000
        ]
    },
    {
        emoji: "\uD83D\uDEE1\uFE0F",
        label: 'Title defenses',
        short: 'defenses',
        cur: (p)=>p.champDef || 0,
        tiers: [
            10,
            50,
            100,
            250,
            500,
            1000
        ]
    },
    {
        emoji: "\u2694\uFE0F",
        label: 'Games played',
        short: 'games',
        cur: (p)=>p.played || 0,
        tiers: [
            100,
            1000,
            5000,
            10000,
            25000,
            50000
        ]
    },
    {
        emoji: "\uD83C\uDFC6",
        label: 'Bracket wins',
        short: 'bracket wins',
        cur: (p)=>p.tw || 0,
        tiers: [
            10,
            50,
            100,
            250,
            500
        ]
    },
    {
        emoji: "\uD83C\uDFAD",
        label: 'Classes championed',
        short: 'classes',
        cur: (p)=>p.champClasses ? Object.keys(p.champClasses).length : 0,
        tiers: [
            5,
            15,
            30,
            50,
            70
        ]
    },
    {
        emoji: "\uD83D\uDC79",
        label: 'Monsters championed',
        short: 'monsters',
        cur: (p, ctx)=>ctx.monsters.filter((c)=>p.champClasses && p.champClasses[c]).length,
        tiers: [
            10,
            25,
            40,
            55
        ]
    },
    {
        emoji: "\u23F3",
        label: 'Longest reign',
        short: 'in a row',
        cur: (p)=>p.champReign || 0,
        tiers: [
            5,
            10,
            15,
            25,
            42
        ]
    },
    {
        emoji: "\uD83D\uDC09",
        label: 'Monster Quests',
        short: 'MQ runs',
        cur: (p)=>p.mqDates ? p.mqDates.length : 0,
        tiers: [
            1,
            2,
            3,
            5
        ]
    },
    {
        emoji: "\uD83D\uDCC5",
        label: 'Tenure',
        short: 'span',
        cur: (p)=>p.firstChamp ? +((p.lastChamp - p.firstChamp) / $7b9b884b9f122834$var$YEAR_MS).toFixed(1) : 0,
        tiers: [
            1,
            3,
            5,
            6
        ],
        fmt: (v)=>v + 'y'
    },
    {
        emoji: "\u2642",
        label: 'Male champion',
        short: 'male champs',
        cur: (p)=>$7b9b884b9f122834$var$sumGender(p, 1),
        tiers: [
            10,
            50,
            100,
            250,
            500
        ]
    },
    {
        emoji: "\u2640",
        label: 'Female champion',
        short: 'female champs',
        cur: (p)=>$7b9b884b9f122834$var$sumGender(p, 2),
        tiers: [
            10,
            50,
            100,
            250,
            500
        ]
    },
    {
        emoji: "\uD83C\uDFA8",
        label: 'Rainbow',
        short: 'team colors',
        cur: (p)=>p.champColors ? Object.keys(p.champColors).length : 0,
        tiers: [
            2,
            4,
            6,
            8
        ]
    },
    {
        emoji: "\uD83D\uDCC6",
        label: 'Big year',
        short: 'in a year',
        cur: (p)=>p.champYears ? Math.max(...Object.values(p.champYears)) : 0,
        tiers: [
            10,
            25,
            50,
            100,
            250
        ]
    },
    {
        emoji: "\u2B50",
        label: 'Zodiac',
        desc: 'Champion a unit of all 13 zodiac signs.',
        cur: (p)=>$7b9b884b9f122834$var$ZODIAC_SIGNS.filter((s)=>p.champSigns && p.champSigns[s]).length,
        goal: ()=>13
    },
    {
        emoji: "\u26A5",
        label: 'Versatile',
        desc: 'Champion as both a male and a female unit.',
        cur: (p)=>{
            if (!p.champClasses) return 0;
            let mc = 0, fc = 0;
            for (const c of Object.values(p.champClasses)){
                mc += c[1] || 0;
                fc += c[2] || 0;
            }
            return mc > 0 && fc > 0 ? 1 : 0;
        },
        goal: ()=>1,
        bin: true
    },
    {
        emoji: "\uD83C\uDF05",
        label: 'Day One',
        desc: 'Win your first title back in 2020.',
        cur: (p)=>p.firstChamp && new Date(p.firstChamp).getFullYear() === 2020 ? 1 : 0,
        goal: ()=>1,
        bin: true
    },
    {
        emoji: "\uD83C\uDFAF",
        label: 'Specialist',
        desc: 'Half your titles on a single class.',
        cur: (p)=>p.champClasses && p.champ ? Math.round(100 * Math.max(...Object.values(p.champClasses).map((c)=>c[0])) / p.champ) : 0,
        goal: ()=>50,
        fmt: (v)=>v + '%'
    },
    {
        emoji: "\uD83D\uDCC8",
        label: 'Sharpshooter',
        desc: 'Reach a 54% win rate over 300+ games.',
        cur: (p)=>p.played >= 300 ? p.winRate : 0,
        goal: ()=>54,
        fmt: (v)=>v + '%'
    },
    // Betting (gambling) — only shown when the profile has loaded betting data (`show`).
    {
        emoji: "\uD83D\uDCB0",
        label: 'Millionaire',
        short: 'gil',
        show: (ctx)=>!!ctx.betting,
        cur: (p, ctx)=>ctx.betting.balance,
        tiers: [
            1000000,
            3000000,
            5000000,
            10000000
        ],
        fmt: $7b9b884b9f122834$export$65ff0f1c4052bd6
    },
    {
        emoji: "\uD83D\uDC0B",
        label: 'Whale',
        short: 'wagered',
        show: (ctx)=>!!ctx.betting,
        cur: (p, ctx)=>ctx.betting.wagered,
        tiers: [
            1000000,
            10000000,
            50000000,
            100000000
        ],
        fmt: $7b9b884b9f122834$export$65ff0f1c4052bd6
    },
    {
        emoji: "\uD83D\uDCC8",
        label: 'In the black',
        short: 'ROI',
        show: (ctx)=>!!ctx.betting && ctx.betting.bets >= 500,
        cur: (p, ctx)=>ctx.betting.roi,
        tiers: [
            0,
            5,
            10
        ],
        fmt: (v)=>(v >= 0 ? '+' : '') + v + '%'
    }
];
function $7b9b884b9f122834$export$b6b243e0afd011f9(player, monsters, betting) {
    const ctx = {
        monsters: monsters || [],
        betting: betting || null
    };
    const nfmt = (v)=>typeof v === 'number' ? v.toLocaleString() : v;
    return $7b9b884b9f122834$export$832dd75819e4111d.filter((a)=>!a.show || a.show(ctx)).map((a)=>{
        const cur = a.cur(player, ctx), f = a.fmt || nfmt;
        if (a.tiers) {
            let level = 0;
            for (const t of a.tiers){
                if (cur >= t) level++;
                else break;
            }
            const reached = level > 0 ? a.tiers[level - 1] : 0, next = level < a.tiers.length ? a.tiers[level] : null;
            const pct = next != null ? Math.max(0, Math.min(100, 100 * (cur - reached) / (next - reached))) : 100;
            return {
                emoji: a.emoji,
                label: a.label,
                tiered: true,
                level: level,
                maxLevel: a.tiers.length,
                earned: level > 0,
                next: next,
                pct: pct,
                status: next != null ? f(cur) + ' / ' + f(next) : "MAX \xb7 " + f(cur),
                desc: 'Tiers: ' + a.tiers.map(f).join(" \xb7 "),
                badge: f(reached) + (a.short ? ' ' + a.short : '')
            };
        }
        const goal = a.goal(player, ctx), earned = cur >= goal;
        return {
            emoji: a.emoji,
            label: a.label,
            desc: a.desc,
            earned: earned,
            tiered: false,
            pct: goal ? Math.max(0, Math.min(100, 100 * cur / goal)) : 0,
            status: a.bin ? earned ? 'Earned' : 'Not yet' : f(cur) + ' / ' + f(goal),
            badge: a.label
        };
    }).sort((a, b)=>b.earned - a.earned || (b.level || 0) - (a.level || 0) || b.pct - a.pct);
}
function $7b9b884b9f122834$export$93b98044833d4352(player, monsters, betting) {
    return $7b9b884b9f122834$export$b6b243e0afd011f9(player, monsters, betting).filter((a)=>a.earned);
}

});

parcelRegister("ed72L", function(module, exports) {

$parcel$export(module.exports, "resolvePlayerName", () => $a587be51a61f1be1$export$abab16c6b6beb089);
/**
 * Resolve a URL-provided player name against the loaded index + alias map.
 *
 * Returns { canonical, record, redirected } where:
 *   - canonical: the display-cased name from the index
 *   - record: the player record (or null if not found)
 *   - redirected: true if the input was an alias or casing mismatch
 *
 * @param {string} raw       - the ?player= value (URL-decoded)
 * @param {Object} index     - the full playerIndex keyed by display name
 * @param {Object} aliases   - nameMigrations.alias: { canonKey oldName: canonKey newName }
 */ function $a587be51a61f1be1$export$abab16c6b6beb089(raw, index, aliases) {
    if (!raw) return {
        canonical: null,
        record: null,
        redirected: false
    };
    // 1. Check alias map (keyed in canonKey form: lowercase, underscore-collapsed)
    const aliasTarget = aliases && aliases[$a587be51a61f1be1$var$collapse(raw)];
    if (aliasTarget) {
        // The alias points to the canonical key — find it in the index
        const entry = $a587be51a61f1be1$var$findInIndex(aliasTarget, index);
        if (entry) return {
            canonical: entry[0],
            record: entry[1],
            redirected: true
        };
    }
    // 2. Exact match in the index
    if (index[raw]) return {
        canonical: raw,
        record: index[raw],
        redirected: false
    };
    // 3. Collapsed match in the index (case + space/underscore variants)
    const entry = $a587be51a61f1be1$var$findInIndex(raw, index);
    if (entry) return {
        canonical: entry[0],
        record: entry[1],
        redirected: entry[0] !== raw
    };
    return {
        canonical: raw,
        record: null,
        redirected: false
    };
}
// Same collapse rule as tools/nameKey.mjs canonKey: Twitch is case-insensitive and
// swaps underscores for spaces in display names (not always 1:1 — trailing/doubled
// underscores survive in some feeds), so every run of whitespace/underscore becomes
// one underscore and leading/trailing separators are stripped. Index keys are spaced
// display names while alias keys and real handles use underscores — collapsing both
// sides makes "Bkg Kit", "bkg_kit", and "bkg__kit_" the same key.
function $a587be51a61f1be1$var$collapse(name) {
    return (name || '').toLowerCase().replace(/[\s_]+/g, '_').replace(/^_+|_+$/g, '');
}
/** Collapsed-key lookup in the index. Returns [displayName, record] or null. */ function $a587be51a61f1be1$var$findInIndex(name, index) {
    const key = $a587be51a61f1be1$var$collapse(name);
    for(const k in index){
        if ($a587be51a61f1be1$var$collapse(k) === key) return [
            k,
            index[k]
        ];
    }
    return null;
}

});

parcelRegister("htddP", function(module, exports) {
module.exports = JSON.parse("{\"generated\":{\"source\":\"fftbattleground AccountMigrationLog\",\"renames\":128,\"identities\":103,\"aliases\":123},\"alias\":{\"cuchulame\":\"q99m\",\"corkymanprime\":\"joemanprime\",\"genkidou\":\"genmakido\",\"rentedred\":\"thazzeus\",\"saldarin\":\"breylus\",\"moonslayerrs\":\"moonderg\",\"a_perfect_blue\":\"perfect_orange\",\"dothan89\":\"big_gimpin\",\"nohurty\":\"bilzeenballball\",\"bilzeen_ballball\":\"bilzeenballball\",\"demonic_vortex_oni\":\"ffviii_zell\",\"sietaha\":\"ffviii_zell\",\"sect_cor\":\"sect_bb\",\"thedapperchangeling\":\"the_dapperdragon\",\"pyah_808\":\"violetvivianite\",\"iria_808\":\"violetvivianite\",\"thefuturefragmentsteam\":\"the_future_fragments_team\",\"sagesoftboy\":\"briarcovenstead\",\"markese\":\"lurksmokebet\",\"reggiex509\":\"lurksmokebet\",\"lurk_smoke_bet\":\"lurksmokebet\",\"virulencext\":\"anasinclaire\",\"partiick0331\":\"akaya_p\",\"joeshmoetheeskimo\":\"joeshmoethechocobro\",\"shizunelulu\":\"shizunehakamichi\",\"joey1995456\":\"joeynumbers\",\"blackacebb\":\"acldacebb\",\"nx_86\":\"stasisshell\",\"ix86\":\"stasisshell\",\"d3ft_punk\":\"hialai\",\"toronado282\":\"straightupdogwater\",\"cl0udedth0ughts\":\"aschekumo\",\"deesignal\":\"danaesignal\",\"vultuous\":\"hexenzopf\",\"ikaruex\":\"arcoflad\",\"ikarumeku\":\"arcoflad\",\"wawawasi2008\":\"wawawasi\",\"mosstako13\":\"mosstako\",\"goblinartificer\":\"mosstako\",\"mosstakowhm\":\"mosstako\",\"deedopers\":\"bkg_kit\",\"wispy_231\":\"tomatobud\",\"glennfk\":\"glennfrogknight\",\"monksound\":\"headlessgundam\",\"ntcainmarko\":\"maxdunku\",\"mirapoix\":\"mira_poix\",\"roofiepoix\":\"mira_poix\",\"woebegonebark1\":\"stanky_p\",\"calajo\":\"joscal_tem\",\"nulltristan\":\"mothmantristan\",\"algus\":\"mothmantristan\",\"sweetsga_iii\":\"sweetidealism\",\"vinsonowen\":\"vinsonown\",\"cole_amity\":\"0bsoleet\",\"shearchaos\":\"alcairseia\",\"artificialmagic\":\"feevatv\",\"pplvee1\":\"ppivee\",\"bahamut64\":\"bunhamut\",\"tkaster\":\"z_tk\",\"iiinfidel\":\"exp0ints\",\"madeinnewyork87\":\"sshinjuku87\",\"chornitumparticles\":\"chronitumparticles\",\"torinbibi\":\"basch_fon_ronsenburg\",\"basch_fon_rosenburg\":\"basch_fon_ronsenburg\",\"darius099\":\"mitula_23\",\"kisaisakurai\":\"kisai_sakurai\",\"jamaris\":\"mikikailana\",\"nosub_adblocker\":\"player_filter\",\"phenosine\":\"player_filter\",\"space_questionmark\":\"player_filter\",\"jakevon27\":\"nabuchodonozor27\",\"paperyharp\":\"papyrusharp\",\"lncestkevin\":\"investkevin\",\"anachronity\":\"springskipper\",\"shintaronayaka\":\"sundaycatchy\",\"oceanpolaris\":\"star0cean\",\"polariswaters\":\"star0cean\",\"brewerspackers9\":\"bp_9\",\"gooseyourself\":\"gooserey\",\"bonemiser\":\"gouda_nuff\",\"chatmiser\":\"gouda_nuff\",\"davestrider55\":\"goromajima55\",\"darthloopercreates\":\"darthlooper\",\"boyosif\":\"moat_carp\",\"edena_aymeris\":\"celialuparelli\",\"ceethethief\":\"celialuparelli\",\"rykio777\":\"cccalle888\",\"wichoboyx\":\"aiwicho\",\"wickedcatgaming\":\"wicked1cat\",\"venomgen\":\"strikekatana\",\"amkae1\":\"amkitoo\",\"tsundah\":\"amkitoo\",\"brosepheux\":\"amkitoo\",\"fretless_tx\":\"alleroc_yt\",\"dixtrix\":\"cutiekelvin\",\"deezaruns\":\"dzuh_ssbm\",\"dave425\":\"davemanx2\",\"zpokrew\":\"pokrew\",\"corpuscav\":\"subarulesbian\",\"mistbornruler\":\"specialistmist\",\"hv5h\":\"dredgefive\",\"username42024\":\"theatheologist\",\"usernamemanresu42024\":\"theatheologist\",\"sena_ttv\":\"senaahh\",\"fnpityy\":\"h4wkenqq\",\"srkxzephyr\":\"zephyrbear\",\"arcadeaddictaaron\":\"aaronrushranked\",\"masta_glenn\":\"kaerumg\",\"pope_piss\":\"yappconfiguration\",\"riot_jayway\":\"just_jayway\",\"musashi45\":\"dr_musashi\",\"e_ballard\":\"etriusballard\",\"misswitchmary\":\"macaronsbymary\",\"xb2b3s\":\"b2b3s\",\"keninatoriv\":\"kenthekanine\",\"whymonkop\":\"jbaggiez\",\"asmodius37\":\"rodrick_37\",\"vvonderlandstreams\":\"vvonderland\",\"fenaen\":\"nevyrknowsbest\",\"greengreenss\":\"bilpinball\",\"lord_gwarth\":\"dvs_gwarth\",\"aesontiel\":\"tengaboi3d\",\"amsans1247\":\"colgatethetogekiss\"}}");

});


parcelRegister("htXGT", function(module, exports) {
module.exports = JSON.parse("{\"abilities\":[\"Cure 4\",\"Raise\",\"Raise 2\",\"Holy\",\"Dark Holy\",\"Fire 4\",\"Bolt 4\",\"Ice 4\",\"Death\",\"Flare\",\"Demi 2\",\"Meteor\",\"Petrify\",\"Moogle\",\"Carbunkle\",\"Bahamut\",\"Zodiac\",\"Cyclops\",\"Kiyomori\",\"Kikuichimonji\",\"Chirijiraden\",\"Masamune\",\"Last Song\",\"Wiznaibus\",\"Nameless Dance\",\"Earth Slash\",\"Revive\",\"Purification\",\"Steal Heart\",\"Invitation\",\"Death Sentence\",\"Mimic Daravon\",\"Water Ball\",\"Hallowed Ground\",\"Ultima\",\"Stasis Sword\",\"Justice Sword\",\"Surging Sword\",\"Explosion Sword\",\"Night Sword\",\"Phoenix Down\",\"X-Potion\",\"Remedy\",\"Dragon Spirit\",\"Auto Potion\",\"Blade Grasp\",\"Hamedo\",\"Dual Wield\",\"Short Charge\",\"Move+3\",\"Jump+3\",\"Teleport 2\",\"Equip Shield\",\"Equip Sword\",\"Equip Knife\",\"Equip Bow\",\"Equip Polearm\",\"Equip Axe\",\"Equip Gun\",\"Doublehand\",\"Galaxy Stop\",\"Elixir\",\"Attack UP\",\"Magic Attack UP\",\"Martial Arts\",\"Lucavi Skill\",\"Limit\",\"Arm Aim\",\"Gil Taking\",\"Magic Barrier\"],\"items\":[\"Air Knife\",\"Zorlin Shape\",\"Iga Knife\",\"Koga Knife\",\"Nagrarock\",\"Materia Blade\",\"Blood Sword\",\"Rune Blade\",\"Save the Queen\",\"Excalibur\",\"Ragnarok\",\"Chaos Blade\",\"Masamune\",\"Chirijiraden\",\"Slasher\",\"Faith Rod\",\"Dragon Rod\",\"Healing Staff\",\"Mace of Zeus\",\"Scorpion Tail\",\"Stone Gun\",\"Blaze Gun\",\"Glacier Gun\",\"Blast Gun\",\"Gastrafitis\",\"Yoichi Bow\",\"Perseus Bow\",\"Bloody Strings\",\"Fairy Harp\",\"Madlemgen\",\"Holy Lance\",\"Gungnir\",\"Dragon Whisker\",\"Whale Whisker\",\"Star Bag\",\"Ryozan Silk\",\"Venetian Shield\",\"Hero Shield\",\"Genji Shield\",\"Kaiser Plate\",\"Genji Helmet\",\"Grand Helmet\",\"Cachusha\",\"Barette\",\"Ribbon\",\"Black Hood\",\"Twist Headband\",\"Flash Hat\",\"Genji Armor\",\"Reflect Mail\",\"Maximillian\",\"Wizard Outfit\",\"Power Sleeve\",\"Secret Clothes\",\"Rubber Costume\",\"Wizard Robe\",\"Robe of Lords\",\"Genji Gauntlet\",\"Magic Gauntlet\",\"Bracer\",\"Cursed Ring\",\"Angel Ring\",\"Setiemson\",\"Chantage\",\"Serpentarius\",\"Vanish Mantle\",\"Salty Rage\"],\"movementSkills\":{\"Move+1\":{\"move\":1,\"jump\":0},\"Move+2\":{\"move\":2,\"jump\":0},\"Move+3\":{\"move\":3,\"jump\":0},\"Jump+1\":{\"move\":0,\"jump\":1},\"Jump+2\":{\"move\":0,\"jump\":2},\"Jump+3\":{\"move\":0,\"jump\":3},\"Ignore Height\":{\"move\":0,\"jump\":50},\"Move-HP Up\":{\"move\":0,\"jump\":0},\"Move-MP Up\":{\"move\":0,\"jump\":0},\"Lifefont\":{\"move\":0,\"jump\":0},\"Manafont\":{\"move\":0,\"jump\":0},\"Teleport\":{\"move\":0,\"jump\":50},\"Pilgrimage\":{\"move\":0,\"jump\":0},\"Teleport 2\":{\"move\":50,\"jump\":50},\"Ignore Terrain\":{\"move\":0,\"jump\":0},\"Swim\":{\"move\":0,\"jump\":0},\"Lava Walking\":{\"move\":0,\"jump\":0},\"Waterbreathing\":{\"move\":0,\"jump\":0},\"Levitate\":{\"move\":0,\"jump\":0},\"Fly\":{\"move\":0,\"jump\":0},\"Retreat\":{\"move\":0,\"jump\":0},\"Landlocked\":{\"move\":0,\"jump\":0},\"Waterwalking\":{\"move\":0,\"jump\":0},\"Sonic Step\":{\"move\":0,\"jump\":0},\"\":{\"move\":0,\"jump\":0}}}");

});

parcelRegister("jG4oQ", function(module, exports) {
module.exports = JSON.parse("{\"Dark BehemothMonster\":{\"champRate\":\"10.71%\",\"avStreak\":2.55,\"numChamps\":269,\"numRolls\":2512,\"Sum(Streaks)\":687,\"Rank\":1},\"Ultima DemonMonster\":{\"champRate\":\"10.36%\",\"avStreak\":2.8,\"numChamps\":358,\"numRolls\":3455,\"Sum(Streaks)\":1002,\"Rank\":2},\"TiamatMonster\":{\"champRate\":\"10.29%\",\"avStreak\":2.67,\"numChamps\":264,\"numRolls\":2565,\"Sum(Streaks)\":704,\"Rank\":3},\"Holy DragonMonster\":{\"champRate\":\"9.83%\",\"avStreak\":2.61,\"numChamps\":301,\"numRolls\":3063,\"Sum(Streaks)\":786,\"Rank\":4},\"Steel GiantMonster\":{\"champRate\":\"9.69%\",\"avStreak\":2.73,\"numChamps\":359,\"numRolls\":3706,\"Sum(Streaks)\":981,\"Rank\":5},\"Red DragonMonster\":{\"champRate\":\"9.18%\",\"avStreak\":2.69,\"numChamps\":189,\"numRolls\":2059,\"Sum(Streaks)\":509,\"Rank\":6},\"Red ChocoboMonster\":{\"champRate\":\"9.05%\",\"avStreak\":2.62,\"numChamps\":310,\"numRolls\":3425,\"Sum(Streaks)\":812,\"Rank\":7},\"Archaic DemonMonster\":{\"champRate\":\"9.05%\",\"avStreak\":2.59,\"numChamps\":237,\"numRolls\":2620,\"Sum(Streaks)\":615,\"Rank\":8},\"Blue DragonMonster\":{\"champRate\":\"8.47%\",\"avStreak\":2.61,\"numChamps\":155,\"numRolls\":1831,\"Sum(Streaks)\":405,\"Rank\":9},\"King BehemothMonster\":{\"champRate\":\"7.93%\",\"avStreak\":2.36,\"numChamps\":173,\"numRolls\":2182,\"Sum(Streaks)\":408,\"Rank\":10},\"DragonMonster\":{\"champRate\":\"7.28%\",\"avStreak\":2.56,\"numChamps\":140,\"numRolls\":1922,\"Sum(Streaks)\":359,\"Rank\":11},\"SerpentariusMonster\":{\"champRate\":\"7.06%\",\"avStreak\":2.66,\"numChamps\":151,\"numRolls\":2140,\"Sum(Streaks)\":401,\"Rank\":12},\"HydraMonster\":{\"champRate\":\"6.55%\",\"avStreak\":2.6,\"numChamps\":120,\"numRolls\":1833,\"Sum(Streaks)\":312,\"Rank\":13},\"SummonerFemale\":{\"champRate\":\"6.52%\",\"avStreak\":2.62,\"numChamps\":1367,\"numRolls\":20963,\"Sum(Streaks)\":3586,\"Rank\":14},\"MonkMale\":{\"champRate\":\"6.51%\",\"avStreak\":2.59,\"numChamps\":1770,\"numRolls\":27188,\"Sum(Streaks)\":4580,\"Rank\":15},\"WyvernMonster\":{\"champRate\":\"6.38%\",\"avStreak\":2.07,\"numChamps\":122,\"numRolls\":1913,\"Sum(Streaks)\":252,\"Rank\":16},\"WizardFemale\":{\"champRate\":\"6.3%\",\"avStreak\":2.62,\"numChamps\":1645,\"numRolls\":26121,\"Sum(Streaks)\":4317,\"Rank\":17},\"ByblosMonster\":{\"champRate\":\"6.23%\",\"avStreak\":2.35,\"numChamps\":124,\"numRolls\":1989,\"Sum(Streaks)\":291,\"Rank\":18},\"LancerMale\":{\"champRate\":\"6.1%\",\"avStreak\":2.67,\"numChamps\":1826,\"numRolls\":29914,\"Sum(Streaks)\":4878,\"Rank\":19},\"ArcherMale\":{\"champRate\":\"6.08%\",\"avStreak\":2.56,\"numChamps\":1421,\"numRolls\":23362,\"Sum(Streaks)\":3637,\"Rank\":20},\"NinjaMale\":{\"champRate\":\"6.05%\",\"avStreak\":2.55,\"numChamps\":1779,\"numRolls\":29400,\"Sum(Streaks)\":4539,\"Rank\":21},\"KnightMale\":{\"champRate\":\"5.91%\",\"avStreak\":2.55,\"numChamps\":2133,\"numRolls\":36108,\"Sum(Streaks)\":5442,\"Rank\":22},\"GeomancerMale\":{\"champRate\":\"5.87%\",\"avStreak\":2.36,\"numChamps\":939,\"numRolls\":16007,\"Sum(Streaks)\":2213,\"Rank\":23},\"GeomancerFemale\":{\"champRate\":\"5.84%\",\"avStreak\":2.71,\"numChamps\":1108,\"numRolls\":18975,\"Sum(Streaks)\":2999,\"Rank\":24},\"BehemothMonster\":{\"champRate\":\"5.69%\",\"avStreak\":2.48,\"numChamps\":113,\"numRolls\":1986,\"Sum(Streaks)\":280,\"Rank\":25},\"ApandaMonster\":{\"champRate\":\"5.64%\",\"avStreak\":2.31,\"numChamps\":124,\"numRolls\":2198,\"Sum(Streaks)\":287,\"Rank\":26},\"NinjaFemale\":{\"champRate\":\"5.36%\",\"avStreak\":2.46,\"numChamps\":877,\"numRolls\":16354,\"Sum(Streaks)\":2157,\"Rank\":27},\"MimeMale\":{\"champRate\":\"5.28%\",\"avStreak\":2.56,\"numChamps\":1074,\"numRolls\":20338,\"Sum(Streaks)\":2750,\"Rank\":28},\"CockatriceMonster\":{\"champRate\":\"5.25%\",\"avStreak\":2.23,\"numChamps\":115,\"numRolls\":2190,\"Sum(Streaks)\":256,\"Rank\":29},\"SamuraiFemale\":{\"champRate\":\"5.24%\",\"avStreak\":2.39,\"numChamps\":962,\"numRolls\":18355,\"Sum(Streaks)\":2301,\"Rank\":30},\"PriestFemale\":{\"champRate\":\"5.21%\",\"avStreak\":2.51,\"numChamps\":1141,\"numRolls\":21920,\"Sum(Streaks)\":2868,\"Rank\":31},\"MediatorMale\":{\"champRate\":\"5.04%\",\"avStreak\":2.5,\"numChamps\":662,\"numRolls\":13124,\"Sum(Streaks)\":1656,\"Rank\":32},\"Time MageFemale\":{\"champRate\":\"5.04%\",\"avStreak\":2.57,\"numChamps\":930,\"numRolls\":18450,\"Sum(Streaks)\":2393,\"Rank\":33},\"SekhretMonster\":{\"champRate\":\"5.0%\",\"avStreak\":2.34,\"numChamps\":90,\"numRolls\":1801,\"Sum(Streaks)\":211,\"Rank\":34},\"MinotaurMonster\":{\"champRate\":\"4.92%\",\"avStreak\":1.96,\"numChamps\":82,\"numRolls\":1666,\"Sum(Streaks)\":161,\"Rank\":35},\"ChemistMale\":{\"champRate\":\"4.91%\",\"avStreak\":2.45,\"numChamps\":706,\"numRolls\":14367,\"Sum(Streaks)\":1728,\"Rank\":36},\"OracleFemale\":{\"champRate\":\"4.9%\",\"avStreak\":2.29,\"numChamps\":882,\"numRolls\":17990,\"Sum(Streaks)\":2017,\"Rank\":37},\"Bull DemonMonster\":{\"champRate\":\"4.78%\",\"avStreak\":1.88,\"numChamps\":88,\"numRolls\":1840,\"Sum(Streaks)\":165,\"Rank\":38},\"ThiefMale\":{\"champRate\":\"4.7%\",\"avStreak\":2.29,\"numChamps\":863,\"numRolls\":18370,\"Sum(Streaks)\":1974,\"Rank\":39},\"CoeurlMonster\":{\"champRate\":\"4.66%\",\"avStreak\":2.33,\"numChamps\":84,\"numRolls\":1804,\"Sum(Streaks)\":196,\"Rank\":40},\"Black ChocoboMonster\":{\"champRate\":\"4.62%\",\"avStreak\":2.14,\"numChamps\":107,\"numRolls\":2318,\"Sum(Streaks)\":229,\"Rank\":41},\"ChemistFemale\":{\"champRate\":\"4.57%\",\"avStreak\":2.57,\"numChamps\":741,\"numRolls\":16222,\"Sum(Streaks)\":1904,\"Rank\":42},\"ArcherFemale\":{\"champRate\":\"4.56%\",\"avStreak\":2.53,\"numChamps\":655,\"numRolls\":14365,\"Sum(Streaks)\":1657,\"Rank\":43},\"SamuraiMale\":{\"champRate\":\"4.55%\",\"avStreak\":2.45,\"numChamps\":719,\"numRolls\":15796,\"Sum(Streaks)\":1761,\"Rank\":44},\"PriestMale\":{\"champRate\":\"4.5%\",\"avStreak\":2.63,\"numChamps\":484,\"numRolls\":10757,\"Sum(Streaks)\":1275,\"Rank\":45},\"MediatorFemale\":{\"champRate\":\"4.49%\",\"avStreak\":2.6,\"numChamps\":592,\"numRolls\":13198,\"Sum(Streaks)\":1537,\"Rank\":46},\"ThiefFemale\":{\"champRate\":\"4.48%\",\"avStreak\":2.6,\"numChamps\":566,\"numRolls\":12627,\"Sum(Streaks)\":1473,\"Rank\":47},\"MonkFemale\":{\"champRate\":\"4.34%\",\"avStreak\":2.36,\"numChamps\":517,\"numRolls\":11924,\"Sum(Streaks)\":1218,\"Rank\":48},\"LancerFemale\":{\"champRate\":\"4.22%\",\"avStreak\":2.31,\"numChamps\":475,\"numRolls\":11255,\"Sum(Streaks)\":1096,\"Rank\":49},\"OracleMale\":{\"champRate\":\"4.19%\",\"avStreak\":2.3,\"numChamps\":471,\"numRolls\":11237,\"Sum(Streaks)\":1083,\"Rank\":50},\"KnightFemale\":{\"champRate\":\"4.14%\",\"avStreak\":2.14,\"numChamps\":567,\"numRolls\":13694,\"Sum(Streaks)\":1214,\"Rank\":51},\"BardMale\":{\"champRate\":\"4.14%\",\"avStreak\":2.4,\"numChamps\":756,\"numRolls\":18266,\"Sum(Streaks)\":1811,\"Rank\":52},\"VampireMonster\":{\"champRate\":\"4.07%\",\"avStreak\":2.16,\"numChamps\":100,\"numRolls\":2459,\"Sum(Streaks)\":216,\"Rank\":53},\"DancerFemale\":{\"champRate\":\"4.03%\",\"avStreak\":2.29,\"numChamps\":746,\"numRolls\":18498,\"Sum(Streaks)\":1707,\"Rank\":54},\"MindflayerMonster\":{\"champRate\":\"4.01%\",\"avStreak\":1.68,\"numChamps\":72,\"numRolls\":1796,\"Sum(Streaks)\":121,\"Rank\":55},\"CalculatorFemale\":{\"champRate\":\"4.0%\",\"avStreak\":2.24,\"numChamps\":839,\"numRolls\":20966,\"Sum(Streaks)\":1879,\"Rank\":56},\"WizardMale\":{\"champRate\":\"3.99%\",\"avStreak\":2.41,\"numChamps\":452,\"numRolls\":11335,\"Sum(Streaks)\":1089,\"Rank\":57},\"TaijuMonster\":{\"champRate\":\"3.98%\",\"avStreak\":1.86,\"numChamps\":69,\"numRolls\":1735,\"Sum(Streaks)\":128,\"Rank\":58},\"SquireMale\":{\"champRate\":\"3.85%\",\"avStreak\":2.41,\"numChamps\":635,\"numRolls\":16474,\"Sum(Streaks)\":1532,\"Rank\":59},\"ReaperMonster\":{\"champRate\":\"3.85%\",\"avStreak\":1.84,\"numChamps\":67,\"numRolls\":1739,\"Sum(Streaks)\":123,\"Rank\":60},\"SummonerMale\":{\"champRate\":\"3.84%\",\"avStreak\":2.32,\"numChamps\":378,\"numRolls\":9833,\"Sum(Streaks)\":876,\"Rank\":61},\"SquireFemale\":{\"champRate\":\"3.78%\",\"avStreak\":2.24,\"numChamps\":449,\"numRolls\":11872,\"Sum(Streaks)\":1008,\"Rank\":62},\"Time MageMale\":{\"champRate\":\"3.76%\",\"avStreak\":2.34,\"numChamps\":372,\"numRolls\":9887,\"Sum(Streaks)\":869,\"Rank\":63},\"CalculatorMale\":{\"champRate\":\"3.75%\",\"avStreak\":2.34,\"numChamps\":553,\"numRolls\":14737,\"Sum(Streaks)\":1294,\"Rank\":64},\"ExplosiveMonster\":{\"champRate\":\"3.62%\",\"avStreak\":2.45,\"numChamps\":74,\"numRolls\":2047,\"Sum(Streaks)\":181,\"Rank\":65},\"PlagueMonster\":{\"champRate\":\"3.33%\",\"avStreak\":2.03,\"numChamps\":62,\"numRolls\":1863,\"Sum(Streaks)\":126,\"Rank\":66},\"DraugrMonster\":{\"champRate\":\"3.32%\",\"avStreak\":1.89,\"numChamps\":54,\"numRolls\":1625,\"Sum(Streaks)\":102,\"Rank\":67},\"JuravisMonster\":{\"champRate\":\"3.29%\",\"avStreak\":2.53,\"numChamps\":55,\"numRolls\":1670,\"Sum(Streaks)\":139,\"Rank\":68},\"Wild BoarMonster\":{\"champRate\":\"3.1%\",\"avStreak\":2.22,\"numChamps\":67,\"numRolls\":2160,\"Sum(Streaks)\":149,\"Rank\":69},\"TreantMonster\":{\"champRate\":\"3.04%\",\"avStreak\":1.98,\"numChamps\":50,\"numRolls\":1643,\"Sum(Streaks)\":99,\"Rank\":70},\"RevenantMonster\":{\"champRate\":\"2.98%\",\"avStreak\":2.35,\"numChamps\":51,\"numRolls\":1709,\"Sum(Streaks)\":120,\"Rank\":71},\"SkeletonMonster\":{\"champRate\":\"2.96%\",\"avStreak\":1.98,\"numChamps\":51,\"numRolls\":1721,\"Sum(Streaks)\":101,\"Rank\":72},\"Red PantherMonster\":{\"champRate\":\"2.95%\",\"avStreak\":1.84,\"numChamps\":44,\"numRolls\":1490,\"Sum(Streaks)\":81,\"Rank\":73},\"GrenadeMonster\":{\"champRate\":\"2.94%\",\"avStreak\":2.16,\"numChamps\":51,\"numRolls\":1737,\"Sum(Streaks)\":110,\"Rank\":74},\"BombMonster\":{\"champRate\":\"2.92%\",\"avStreak\":1.92,\"numChamps\":50,\"numRolls\":1710,\"Sum(Streaks)\":96,\"Rank\":75},\"MimeFemale\":{\"champRate\":\"2.9%\",\"avStreak\":2.19,\"numChamps\":372,\"numRolls\":12834,\"Sum(Streaks)\":816,\"Rank\":76},\"PorkyMonster\":{\"champRate\":\"2.87%\",\"avStreak\":2.33,\"numChamps\":60,\"numRolls\":2090,\"Sum(Streaks)\":140,\"Rank\":77},\"GhostMonster\":{\"champRate\":\"2.8%\",\"avStreak\":1.95,\"numChamps\":44,\"numRolls\":1571,\"Sum(Streaks)\":86,\"Rank\":78},\"AhrimanMonster\":{\"champRate\":\"2.75%\",\"avStreak\":1.94,\"numChamps\":47,\"numRolls\":1712,\"Sum(Streaks)\":91,\"Rank\":79},\"Iron HawkMonster\":{\"champRate\":\"2.7%\",\"avStreak\":1.95,\"numChamps\":44,\"numRolls\":1631,\"Sum(Streaks)\":86,\"Rank\":80},\"GobbledeguckMonster\":{\"champRate\":\"2.69%\",\"avStreak\":2,\"numChamps\":49,\"numRolls\":1820,\"Sum(Streaks)\":98,\"Rank\":81},\"Great MalboroMonster\":{\"champRate\":\"2.62%\",\"avStreak\":1.49,\"numChamps\":57,\"numRolls\":2175,\"Sum(Streaks)\":85,\"Rank\":82},\"ChocoboMonster\":{\"champRate\":\"2.54%\",\"avStreak\":2.39,\"numChamps\":61,\"numRolls\":2402,\"Sum(Streaks)\":146,\"Rank\":83},\"Black GoblinMonster\":{\"champRate\":\"2.41%\",\"avStreak\":1.79,\"numChamps\":43,\"numRolls\":1782,\"Sum(Streaks)\":77,\"Rank\":84},\"DryadMonster\":{\"champRate\":\"2.36%\",\"avStreak\":2.41,\"numChamps\":41,\"numRolls\":1739,\"Sum(Streaks)\":99,\"Rank\":85},\"SwineMonster\":{\"champRate\":\"2.33%\",\"avStreak\":2.17,\"numChamps\":46,\"numRolls\":1974,\"Sum(Streaks)\":100,\"Rank\":86},\"GhoulMonster\":{\"champRate\":\"2.26%\",\"avStreak\":2.24,\"numChamps\":34,\"numRolls\":1503,\"Sum(Streaks)\":76,\"Rank\":87},\"OchuMonster\":{\"champRate\":\"2.14%\",\"avStreak\":1.9,\"numChamps\":40,\"numRolls\":1867,\"Sum(Streaks)\":76,\"Rank\":88},\"GoblinMonster\":{\"champRate\":\"1.97%\",\"avStreak\":2.15,\"numChamps\":39,\"numRolls\":1981,\"Sum(Streaks)\":84,\"Rank\":89},\"SquidrakenMonster\":{\"champRate\":\"1.83%\",\"avStreak\":2.19,\"numChamps\":37,\"numRolls\":2023,\"Sum(Streaks)\":81,\"Rank\":90},\"Pisco DemonMonster\":{\"champRate\":\"1.71%\",\"avStreak\":1.97,\"numChamps\":35,\"numRolls\":2044,\"Sum(Streaks)\":69,\"Rank\":91},\"MalboroMonster\":{\"champRate\":\"1.63%\",\"avStreak\":2.46,\"numChamps\":28,\"numRolls\":1714,\"Sum(Streaks)\":69,\"Rank\":92},\"Floating EyeMonster\":{\"champRate\":\"1.44%\",\"avStreak\":1.7,\"numChamps\":27,\"numRolls\":1870,\"Sum(Streaks)\":46,\"Rank\":93}}");

});

parcelRegister("5zojD", function(module, exports) {

$parcel$export(module.exports, "lastDropAgo", () => $40e3153b32918070$export$60e7ace5dc7c1598);
// "When did this skill last drop?" from the fftbg.com tournaments list endpoint
// (most-recent-first, each row carries a SkillDrop). The current drop is the first
// occurrence of the token in the list; we measure the gap to the NEXT occurrence —
// i.e. how many tournaments since it last dropped before now. Anchoring to the
// first match (not index 0) keeps it correct if a newer tournament raced in on top.
//
// Returns { ago, lastMod } or null when there's no prior occurrence in the window
// (the caller then shows a "not dropped in N+" / rare message).
function $40e3153b32918070$export$60e7ace5dc7c1598(list, token) {
    if (!token || !Array.isArray(list)) return null;
    const want = String(token).toLowerCase();
    let firstIdx = -1;
    for(let i = 0; i < list.length; i++){
        const d = list[i] && list[i].SkillDrop;
        if (d && String(d).toLowerCase() === want) {
            if (firstIdx < 0) firstIdx = i;
            else return {
                ago: i - firstIdx,
                lastMod: list[i].LastMod || null
            };
        }
    }
    return null;
}

});

parcelRegister("5fnNF", function(module, exports) {
module.exports = JSON.parse("{\"classes\":[{\"name\":\"Squire\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Basic Skill\",\"info\":\"Skillset. Squire job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":183,\"mp\":55,\"move\":4,\"jump\":3,\"speed\":9,\"pa\":9,\"ma\":7,\"cEvPercent\":8}},{\"name\":\"Squire\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Basic Skill\",\"info\":\"Skillset. Squire job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":171,\"mp\":59,\"move\":4,\"jump\":3,\"speed\":9,\"pa\":7,\"ma\":9,\"cEvPercent\":8}},{\"name\":\"Chemist\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Item\",\"info\":\"Skillset (inventory). Chemist job abilities.\",\"type\":\"active\"},{\"name\":\"Throw Item\",\"info\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":165,\"mp\":46,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":7,\"ma\":7,\"cEvPercent\":12}},{\"name\":\"Chemist\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Item\",\"info\":\"Skillset (inventory). Chemist job abilities.\",\"type\":\"active\"},{\"name\":\"Throw Item\",\"info\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":154,\"mp\":49,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":6,\"ma\":8,\"cEvPercent\":12}},{\"name\":\"Knight\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Battle Skill\",\"info\":\"Skillset. Knight job abilities.\",\"type\":\"active\"},{\"name\":\"Equip Shield\",\"info\":\"Support. Allows the unit to equip Shields (even if a Knight Sword or Bow is equipped).\",\"type\":\"support\"}],\"baseStats\":{\"hp\":202,\"mp\":42,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":12,\"ma\":6,\"cEvPercent\":14}},{\"name\":\"Knight\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Battle Skill\",\"info\":\"Skillset. Knight job abilities.\",\"type\":\"active\"},{\"name\":\"Equip Shield\",\"info\":\"Support. Allows the unit to equip Shields (even if a Knight Sword or Bow is equipped).\",\"type\":\"support\"}],\"baseStats\":{\"hp\":189,\"mp\":45,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":10,\"ma\":7,\"cEvPercent\":14}},{\"name\":\"Archer\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Charge\",\"info\":\"Skillset (snipe). Archer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":170,\"mp\":38,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":11,\"ma\":6,\"cEvPercent\":16}},{\"name\":\"Archer\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Charge\",\"info\":\"Skillset (snipe). Archer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":159,\"mp\":41,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":9,\"ma\":8,\"cEvPercent\":16}},{\"name\":\"Monk\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Punch Art\",\"info\":\"Skillset. Monk job abilities.\",\"type\":\"active\"},{\"name\":\"Martial Arts\",\"info\":\"Support. Increases the damage (or hitrate) of the unit's unarmed attacks, Punch Art abilities, and certain other physical abilities by 50%.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":206,\"mp\":52,\"move\":3,\"jump\":4,\"speed\":8,\"pa\":12,\"ma\":7,\"cEvPercent\":24}},{\"name\":\"Monk\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Punch Art\",\"info\":\"Skillset. Monk job abilities.\",\"type\":\"active\"},{\"name\":\"Martial Arts\",\"info\":\"Support. Increases the damage (or hitrate) of the unit's unarmed attacks, Punch Art abilities, and certain other physical abilities by 50%.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":193,\"mp\":56,\"move\":3,\"jump\":4,\"speed\":8,\"pa\":10,\"ma\":9,\"cEvPercent\":24}},{\"name\":\"Priest\",\"gender\":\"Male\",\"innates\":[{\"name\":\"White Magic\",\"info\":\"Skillset. Priest job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":177,\"mp\":94,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":9,\"ma\":9,\"cEvPercent\":5}},{\"name\":\"Priest\",\"gender\":\"Female\",\"innates\":[{\"name\":\"White Magic\",\"info\":\"Skillset. Priest job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":166,\"mp\":101,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":7,\"ma\":11,\"cEvPercent\":5}},{\"name\":\"Wizard\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Black Magic\",\"info\":\"Skillset. Wizard job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":137,\"mp\":107,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":7,\"ma\":11,\"cEvPercent\":10}},{\"name\":\"Wizard\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Black Magic\",\"info\":\"Skillset. Wizard job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":128,\"mp\":115,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":5,\"ma\":14,\"cEvPercent\":10}},{\"name\":\"TimeMage\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Time Magic\",\"info\":\"Skillset. Time Mage job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":141,\"mp\":103,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":8,\"ma\":10,\"cEvPercent\":17}},{\"name\":\"TimeMage\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Time Magic\",\"info\":\"Skillset. Time Mage job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":132,\"mp\":110,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":6,\"ma\":13,\"cEvPercent\":17}},{\"name\":\"Summoner\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Summon Magic\",\"info\":\"Skillset. Summoner job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":125,\"mp\":112,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":5,\"ma\":9,\"cEvPercent\":7}},{\"name\":\"Summoner\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Summon Magic\",\"info\":\"Skillset. Summoner job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":117,\"mp\":119,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":4,\"ma\":12,\"cEvPercent\":7}},{\"name\":\"Thief\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Steal\",\"info\":\"Skillset. Thief job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":188,\"mp\":36,\"move\":4,\"jump\":3,\"speed\":10,\"pa\":10,\"ma\":5,\"cEvPercent\":30}},{\"name\":\"Thief\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Steal\",\"info\":\"Skillset. Thief job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":176,\"mp\":39,\"move\":4,\"jump\":3,\"speed\":10,\"pa\":8,\"ma\":7,\"cEvPercent\":30}},{\"name\":\"Mediator\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Talk Skill\",\"info\":\"Skillset (oral). Mediator job abilities.\",\"type\":\"active\"},{\"name\":\"Monster Talk\",\"info\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":160,\"mp\":48,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":8,\"ma\":8,\"cEvPercent\":9}},{\"name\":\"Mediator\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Talk Skill\",\"info\":\"Skillset (oral). Mediator job abilities.\",\"type\":\"active\"},{\"name\":\"Monster Talk\",\"info\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":150,\"mp\":51,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":7,\"ma\":10,\"cEvPercent\":9}},{\"name\":\"Oracle\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Yin Yang Magic\",\"info\":\"Skillset. Oracle job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":149,\"mp\":86,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":6,\"ma\":10,\"cEvPercent\":22}},{\"name\":\"Oracle\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Yin Yang Magic\",\"info\":\"Skillset. Oracle job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":139,\"mp\":92,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":5,\"ma\":12,\"cEvPercent\":22}},{\"name\":\"Geomancer\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Elemental\",\"info\":\"Skillset (geomancy). Geomancer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":155,\"mp\":78,\"move\":4,\"jump\":3,\"speed\":8,\"pa\":12,\"ma\":8,\"cEvPercent\":11}},{\"name\":\"Geomancer\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Elemental\",\"info\":\"Skillset (geomancy). Geomancer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":145,\"mp\":83,\"move\":4,\"jump\":3,\"speed\":8,\"pa\":9,\"ma\":10,\"cEvPercent\":11}},{\"name\":\"Lancer\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Jump\",\"info\":\"Skillset (aerial). Lancer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":194,\"mp\":34,\"move\":3,\"jump\":4,\"speed\":8,\"pa\":13,\"ma\":4,\"cEvPercent\":18}},{\"name\":\"Lancer\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Jump\",\"info\":\"Skillset (aerial). Lancer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":181,\"mp\":37,\"move\":3,\"jump\":4,\"speed\":8,\"pa\":10,\"ma\":5,\"cEvPercent\":18}},{\"name\":\"Samurai\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Draw Out\",\"info\":\"Skillset (inventory). Samurai job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":144,\"mp\":62,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":14,\"ma\":7,\"cEvPercent\":27}},{\"name\":\"Samurai\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Draw Out\",\"info\":\"Skillset (inventory). Samurai job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":135,\"mp\":66,\"move\":3,\"jump\":3,\"speed\":8,\"pa\":11,\"ma\":9,\"cEvPercent\":27}},{\"name\":\"Ninja\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Throw\",\"info\":\"Skillset (inventory). Ninja job abilities.\",\"type\":\"active\"},{\"name\":\"Dual Wield\",\"info\":\"Support. Allows the unit to equip an additional weapon in the offhand unless equipped with a Bow, attacking once with each (or both fists if unarmed).\",\"type\":\"support\"}],\"baseStats\":{\"hp\":119,\"mp\":40,\"move\":4,\"jump\":4,\"speed\":10,\"pa\":11,\"ma\":5,\"cEvPercent\":20}},{\"name\":\"Ninja\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Throw\",\"info\":\"Skillset (inventory). Ninja job abilities.\",\"type\":\"active\"},{\"name\":\"Dual Wield\",\"info\":\"Support. Allows the unit to equip an additional weapon in the offhand unless equipped with a Bow, attacking once with each (or both fists if unarmed).\",\"type\":\"support\"}],\"baseStats\":{\"hp\":112,\"mp\":43,\"move\":4,\"jump\":4,\"speed\":10,\"pa\":9,\"ma\":6,\"cEvPercent\":20}},{\"name\":\"Calculator\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Math Skill\",\"info\":\"Skillset (arithmetic). Calculator job abilities.\",\"type\":\"active\"},{\"name\":\"Monster Talk\",\"info\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":132,\"mp\":70,\"move\":3,\"jump\":3,\"speed\":7,\"pa\":7,\"ma\":8,\"cEvPercent\":15}},{\"name\":\"Calculator\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Math Skill\",\"info\":\"Skillset (arithmetic). Calculator job abilities.\",\"type\":\"active\"},{\"name\":\"Monster Talk\",\"info\":\"Support. Enables the unit's Talk Skill abilities to hit monsters.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":123,\"mp\":75,\"move\":3,\"jump\":3,\"speed\":7,\"pa\":5,\"ma\":10,\"cEvPercent\":15}},{\"name\":\"Bard\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Sing\",\"info\":\"Skillset. Bard job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":153,\"mp\":57,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":8,\"ma\":9,\"cEvPercent\":13}},{\"name\":\"Dancer\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Dance\",\"info\":\"Skillset. Dancer job abilities.\",\"type\":\"active\"}],\"baseStats\":{\"hp\":157,\"mp\":53,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":8,\"ma\":9,\"cEvPercent\":13}},{\"name\":\"Mime\",\"gender\":\"Male\",\"innates\":[{\"name\":\"Mimic\",\"info\":\"Skillset. Allows the unit to automatically copy the actions of allies without Mimic except abilities associated with a Wild Beast family, but prevents it from equipping weapons. Mimicked abilities are instant (requiring no CT) and their targeting copies the distance and direction of the original action.\",\"type\":\"active\"},{\"name\":\"Concentrate\",\"info\":\"Support. Prevents physical attacks used by the unit from being evaded.\",\"type\":\"support\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"},{\"name\":\"Throw Item\",\"info\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"type\":\"support\"},{\"name\":\"No MP\",\"info\":\"Support. Eliminates the MP cost of abilities used by the unit.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":198,\"mp\":33,\"move\":3,\"jump\":4,\"speed\":10,\"pa\":13,\"ma\":11,\"cEvPercent\":6}},{\"name\":\"Mime\",\"gender\":\"Female\",\"innates\":[{\"name\":\"Mimic\",\"info\":\"Skillset. Allows the unit to automatically copy the actions of allies without Mimic except abilities associated with a Wild Beast family, but prevents it from equipping weapons. Mimicked abilities are instant (requiring no CT) and their targeting copies the distance and direction of the original action.\",\"type\":\"active\"},{\"name\":\"Concentrate\",\"info\":\"Support. Prevents physical attacks used by the unit from being evaded.\",\"type\":\"support\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"},{\"name\":\"Throw Item\",\"info\":\"Support. Increases the range of the unit's Item abilities to 4.\",\"type\":\"support\"},{\"name\":\"No MP\",\"info\":\"Support. Eliminates the MP cost of abilities used by the unit.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":185,\"mp\":35,\"move\":3,\"jump\":4,\"speed\":10,\"pa\":11,\"ma\":13,\"cEvPercent\":6}},{\"name\":\"Chocobo\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Swim\",\"info\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":285,\"mp\":33,\"move\":6,\"jump\":5,\"speed\":9,\"pa\":16,\"ma\":38,\"cEvPercent\":21},\"effect\":\"Half Lightning; Weak Wind\"},{\"name\":\"BlackChocobo\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Swim\",\"info\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"type\":\"move\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":250,\"mp\":25,\"move\":6,\"jump\":5,\"speed\":8,\"pa\":18,\"ma\":42,\"cEvPercent\":28},\"effect\":\"Half Earth, Dark; Weak Wind\"},{\"name\":\"RedChocobo\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Swim\",\"info\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"type\":\"move\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":355,\"mp\":17,\"move\":6,\"jump\":4,\"speed\":10,\"pa\":15,\"ma\":35,\"cEvPercent\":12},\"effect\":\"Weak Wind\"},{\"name\":\"Goblin\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":316,\"mp\":7,\"move\":4,\"jump\":4,\"speed\":8,\"pa\":13,\"ma\":35,\"cEvPercent\":22},\"effect\":\"Half Lightning, Holy; Weak Ice\"},{\"name\":\"BlackGoblin\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":271,\"mp\":10,\"move\":5,\"jump\":3,\"speed\":8,\"pa\":15,\"ma\":36,\"cEvPercent\":24},\"effect\":\"Half Lightning, Dark; Weak Ice; Immune Darkness\"},{\"name\":\"Gobbledeguck\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":304,\"mp\":4,\"move\":4,\"jump\":3,\"speed\":10,\"pa\":14,\"ma\":37,\"cEvPercent\":26},\"effect\":\"Half Lightning; Weak Ice\"},{\"name\":\"Bomb\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":246,\"mp\":3,\"move\":4,\"jump\":4,\"speed\":10,\"pa\":12,\"ma\":38,\"cEvPercent\":19},\"effect\":\"Absorb Fire; Half Ice, Earth; Weak Water; Immune Oil\"},{\"name\":\"Grenade\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":257,\"mp\":6,\"move\":4,\"jump\":4,\"speed\":11,\"pa\":11,\"ma\":42,\"cEvPercent\":13},\"effect\":\"Absorb Fire; Half Holy; Weak Water; Immune Oil\"},{\"name\":\"Explosive\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":325,\"mp\":9,\"move\":4,\"jump\":4,\"speed\":9,\"pa\":14,\"ma\":40,\"cEvPercent\":16},\"effect\":\"Absorb Fire; Half Fire, Ice; Weak Water; Immune Oil\"},{\"name\":\"RedPanther\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"},{\"name\":\"Retreat\",\"info\":\"Movement. While in Critical, increases the unit's Move by 4.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":347,\"mp\":11,\"move\":4,\"jump\":6,\"speed\":12,\"pa\":14,\"ma\":36,\"cEvPercent\":30},\"effect\":\"Half Fire, Lightning; Weak Earth\"},{\"name\":\"Coeurl\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"},{\"name\":\"Retreat\",\"info\":\"Movement. While in Critical, increases the unit's Move by 4.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":274,\"mp\":16,\"move\":4,\"jump\":5,\"speed\":11,\"pa\":13,\"ma\":41,\"cEvPercent\":27},\"effect\":\"Half Ice; Weak Earth\"},{\"name\":\"Vampire\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"},{\"name\":\"Retreat\",\"info\":\"Movement. While in Critical, increases the unit's Move by 4.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":295,\"mp\":6,\"move\":4,\"jump\":4,\"speed\":10,\"pa\":16,\"ma\":33,\"cEvPercent\":25},\"effect\":\"Null Dark; Weak Earth, Holy; Immune Sleep\"},{\"name\":\"PiscoDemon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":340,\"mp\":31,\"move\":3,\"jump\":3,\"speed\":9,\"pa\":11,\"ma\":40,\"cEvPercent\":11},\"effect\":\"Absorb Water; Half Fire, Earth; Weak Lightning\"},{\"name\":\"Squidraken\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":362,\"mp\":22,\"move\":3,\"jump\":4,\"speed\":7,\"pa\":22,\"ma\":38,\"cEvPercent\":14},\"effect\":\"Absorb Water; Null Fire; Weak Lightning\"},{\"name\":\"Mindflayer\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":299,\"mp\":54,\"move\":4,\"jump\":3,\"speed\":8,\"pa\":17,\"ma\":36,\"cEvPercent\":5},\"effect\":\"Absorb Water; Half Fire; Weak Lightning\"},{\"name\":\"Skeleton\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":401,\"mp\":11,\"move\":3,\"jump\":4,\"speed\":9,\"pa\":15,\"ma\":44,\"cEvPercent\":20},\"effect\":\"Absorb Dark; Half Ice; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence\"},{\"name\":\"Draugr\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":393,\"mp\":47,\"move\":3,\"jump\":4,\"speed\":9,\"pa\":17,\"ma\":45,\"cEvPercent\":15},\"effect\":\"Absorb Dark; Null Ice; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence\"},{\"name\":\"Reaper\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"}],\"baseStats\":{\"hp\":369,\"mp\":29,\"move\":3,\"jump\":4,\"speed\":9,\"pa\":16,\"ma\":43,\"cEvPercent\":13},\"effect\":\"Absorb Dark; Half Ice; Weak Lightning, Holy; Permanent Undead; Immune Reraise, Poison, Death Sentence\"},{\"name\":\"Ghoul\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"},{\"name\":\"Teleport\",\"info\":\"Movement. Allows the unit to teleport directly to a tile within its move range.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":254,\"mp\":23,\"move\":6,\"jump\":4,\"speed\":10,\"pa\":13,\"ma\":42,\"cEvPercent\":35},\"effect\":\"Absorb Dark; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence\"},{\"name\":\"Ghost\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"},{\"name\":\"Teleport\",\"info\":\"Movement. Allows the unit to teleport directly to a tile within its move range.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":239,\"mp\":14,\"move\":5,\"jump\":5,\"speed\":10,\"pa\":14,\"ma\":41,\"cEvPercent\":40},\"effect\":\"Absorb Dark; Null Earth; Weak Wind, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence\"},{\"name\":\"Revenant\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Levitate\",\"info\":\"Movement. Grants the unit permanent Float and allows it to stand on lava.\",\"type\":\"move\"},{\"name\":\"Teleport\",\"info\":\"Movement. Allows the unit to teleport directly to a tile within its move range.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":268,\"mp\":5,\"move\":5,\"jump\":4,\"speed\":11,\"pa\":12,\"ma\":43,\"cEvPercent\":29},\"effect\":\"Absorb Dark; Half Earth; Weak Fire, Holy; Permanent Undead; Immune Reraise, Poison, Regen, Death Sentence\"},{\"name\":\"FloatingEye\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Magic Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from magical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":310,\"mp\":18,\"move\":5,\"jump\":5,\"speed\":8,\"pa\":13,\"ma\":37,\"cEvPercent\":31},\"effect\":\"Half Ice, Wind, Earth, Dark; Weak Lightning\"},{\"name\":\"Ahriman\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Magic Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from magical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":281,\"mp\":50,\"move\":5,\"jump\":6,\"speed\":8,\"pa\":16,\"ma\":39,\"cEvPercent\":23},\"effect\":\"Half Earth, Water, Holy, Dark; Weak Lightning\"},{\"name\":\"Plague\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Magic Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from magical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":292,\"mp\":34,\"move\":5,\"jump\":4,\"speed\":8,\"pa\":15,\"ma\":46,\"cEvPercent\":17},\"effect\":\"Half Fire, Wind, Water, Dark; Weak Lightning\"},{\"name\":\"Juravis\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":242,\"mp\":9,\"move\":6,\"jump\":6,\"speed\":10,\"pa\":12,\"ma\":45,\"cEvPercent\":39},\"effect\":\"Absorb Wind; Weak Earth\"},{\"name\":\"IronHawk\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":388,\"mp\":7,\"move\":6,\"jump\":4,\"speed\":9,\"pa\":15,\"ma\":34,\"cEvPercent\":37},\"effect\":\"Absorb Wind; Null Lightning; Weak Earth\"},{\"name\":\"Cockatrice\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":264,\"mp\":13,\"move\":6,\"jump\":5,\"speed\":10,\"pa\":18,\"ma\":39,\"cEvPercent\":34},\"effect\":\"Absorb Wind; Weak Earth\"},{\"name\":\"Swine\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":260,\"mp\":20,\"move\":3,\"jump\":3,\"speed\":11,\"pa\":10,\"ma\":42,\"cEvPercent\":38},\"effect\":\"Half Fire, Lightning, Water, Holy; Weak Dark\"},{\"name\":\"Porky\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":289,\"mp\":12,\"move\":3,\"jump\":4,\"speed\":10,\"pa\":9,\"ma\":44,\"cEvPercent\":32},\"effect\":\"Half Fire, Ice, Wind, Holy; Weak Dark\"},{\"name\":\"WildBoar\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":277,\"mp\":15,\"move\":3,\"jump\":4,\"speed\":10,\"pa\":19,\"ma\":43,\"cEvPercent\":36},\"effect\":\"Half Lightning, Ice, Earth, Holy; Weak Dark\"},{\"name\":\"Dryad\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from physical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":465,\"mp\":35,\"move\":3,\"jump\":3,\"speed\":7,\"pa\":11,\"ma\":41,\"cEvPercent\":4},\"effect\":\"Absorb Earth; Half Water; Weak Fire; Immune Float\"},{\"name\":\"Treant\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from physical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":421,\"mp\":38,\"move\":3,\"jump\":2,\"speed\":7,\"pa\":19,\"ma\":40,\"cEvPercent\":1},\"effect\":\"Absorb Earth; Null Water; Weak Fire; Immune Float\"},{\"name\":\"Taiju\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Defense Up\",\"info\":\"Support. Decreases the damage (or hitrate) that the unit takes from physical attacks by a third.\",\"type\":\"support\"},{\"name\":\"Non-Charge\",\"info\":\"Support. Eliminates the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"No MP\",\"info\":\"Support. Eliminates the MP cost of abilities used by the unit.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":509,\"mp\":43,\"move\":4,\"jump\":2,\"speed\":7,\"pa\":14,\"ma\":39,\"cEvPercent\":3},\"effect\":\"Absorb Earth; Half Water; Weak Fire; Immune Float\"},{\"name\":\"BullDemon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":428,\"mp\":8,\"move\":5,\"jump\":3,\"speed\":8,\"pa\":18,\"ma\":37,\"cEvPercent\":14},\"effect\":\"Half Wind; Weak Water; Immune Float\"},{\"name\":\"Minotaur\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":487,\"mp\":4,\"move\":4,\"jump\":4,\"speed\":9,\"pa\":15,\"ma\":41,\"cEvPercent\":10},\"effect\":\"Half Fire; Weak Water; Immune Float\"},{\"name\":\"Sekhret\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":449,\"mp\":1,\"move\":3,\"jump\":5,\"speed\":10,\"pa\":21,\"ma\":44,\"cEvPercent\":17},\"effect\":\"Half Holy, Dark; Weak Water\"},{\"name\":\"Malboro\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Waterwalking\",\"info\":\"Movement. Allows the unit to move and stand on the surface of water.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":443,\"mp\":2,\"move\":3,\"jump\":5,\"speed\":7,\"pa\":14,\"ma\":16,\"cEvPercent\":5},\"effect\":\"Half Wind, Water; Weak Ice; Immune Float\"},{\"name\":\"Ochu\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Waterwalking\",\"info\":\"Movement. Allows the unit to move and stand on the surface of water.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":375,\"mp\":5,\"move\":4,\"jump\":4,\"speed\":8,\"pa\":13,\"ma\":19,\"cEvPercent\":8},\"effect\":\"Half Lightning, Water; Weak Ice; Immune Float\"},{\"name\":\"GreatMalboro\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Waterwalking\",\"info\":\"Movement. Allows the unit to move and stand on the surface of water.\",\"type\":\"move\"}],\"baseStats\":{\"hp\":461,\"mp\":8,\"move\":4,\"jump\":5,\"speed\":7,\"pa\":12,\"ma\":18,\"cEvPercent\":7},\"effect\":\"Null Wind; Half Water; Weak Ice; Immune Float\"},{\"name\":\"Behemoth\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Secret Hunt\",\"info\":\"Support. After killing or resurrecting a unit, the unit gains +1 PA and +1 MA.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":476,\"mp\":26,\"move\":4,\"jump\":5,\"speed\":9,\"pa\":17,\"ma\":41,\"cEvPercent\":12},\"effect\":\"Half Wind, Earth; Weak Dark; Immune Float\"},{\"name\":\"KingBehemoth\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":505,\"mp\":30,\"move\":4,\"jump\":4,\"speed\":9,\"pa\":20,\"ma\":39,\"cEvPercent\":15},\"effect\":\"Half Wind, Holy; Weak Dark; Immune Float\"},{\"name\":\"DarkBehemoth\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":491,\"mp\":36,\"move\":4,\"jump\":3,\"speed\":9,\"pa\":23,\"ma\":40,\"cEvPercent\":18},\"effect\":\"Half Wind, Dark; Weak Holy; Immune Float\"},{\"name\":\"Dragon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Sonic Step\",\"info\":\"Movement. After moving, the unit gains +5 CT.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":455,\"mp\":27,\"move\":5,\"jump\":3,\"speed\":9,\"pa\":17,\"ma\":38,\"cEvPercent\":10},\"effect\":\"Absorb Lightning; Weak Fire; Immune Float\"},{\"name\":\"BlueDragon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Ignore Terrain\",\"info\":\"Movement. Eliminates the unit's movement penalty for moving through water (even while submerged), and allows it to move (but not stand) on lava with a movement penalty.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":480,\"mp\":24,\"move\":5,\"jump\":3,\"speed\":8,\"pa\":18,\"ma\":40,\"cEvPercent\":8},\"effect\":\"Absorb Ice; Weak Lightning; Immune Float\"},{\"name\":\"RedDragon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Lava Walking\",\"info\":\"Movement. Allows the unit to move and stand on lava.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":470,\"mp\":21,\"move\":5,\"jump\":3,\"speed\":9,\"pa\":16,\"ma\":42,\"cEvPercent\":9},\"effect\":\"Absorb Fire; Weak Ice; Immune Float\"},{\"name\":\"Wyvern\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Sicken\",\"info\":\"Support. Allows physical attacks used by the unit to add Poison (except a basic Attack with a Gun).\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":408,\"mp\":19,\"move\":4,\"jump\":4,\"speed\":11,\"pa\":16,\"ma\":14,\"cEvPercent\":4},\"effect\":\"Half Fire; Weak Ice, Wind; Immune Float, Poison\"},{\"name\":\"Hydra\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":496,\"mp\":10,\"move\":4,\"jump\":4,\"speed\":9,\"pa\":18,\"ma\":12,\"cEvPercent\":6},\"effect\":\"Half Water; Weak Ice, Wind; Immune Float\"},{\"name\":\"Tiamat\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Wild Beast\",\"info\":\"Support. Grants the unit a locked ability (denoted by an asterisk) that can be used if adjacent to an allied Beastmaster, but prevents it from using the basic Attack action.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Fly\",\"info\":\"Movement. Allows the unit to fly over impassable terrain and units to tiles of any height, and nullifies fall damage that it would take.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":483,\"mp\":28,\"move\":4,\"jump\":4,\"speed\":9,\"pa\":19,\"ma\":17,\"cEvPercent\":3},\"effect\":\"Half Lightning; Weak Ice, Wind; Immune Float\"},{\"name\":\"ArchaicDemon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Short Charge\",\"info\":\"Support. Halves the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":320,\"mp\":109,\"move\":4,\"jump\":3,\"speed\":8,\"pa\":13,\"ma\":15,\"cEvPercent\":6},\"effect\":\"Null Holy; Half Dark; Weak Lightning\"},{\"name\":\"UltimaDemon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Short Charge\",\"info\":\"Support. Halves the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":333,\"mp\":104,\"move\":5,\"jump\":2,\"speed\":7,\"pa\":17,\"ma\":13,\"cEvPercent\":9},\"effect\":\"Null Holy; Half Fire, Dark; Weak Water; Immune Transparent\"},{\"name\":\"Apanda\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Short Charge\",\"info\":\"Support. Halves the CT of abilities used by the unit (except recurring, jumping, and aiming abilities).\",\"type\":\"support\"},{\"name\":\"Pilgrimage\",\"info\":\"Movement. After moving, the unit gains +1 Brave and +1 Faith.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":415,\"mp\":91,\"move\":4,\"jump\":6,\"speed\":8,\"pa\":14,\"ma\":14,\"cEvPercent\":11},\"effect\":\"Half Wind, Earth, Water; Weak Fire, Dark; Immune Float\"},{\"name\":\"SteelGiant\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Swim\",\"info\":\"Movement. Prevents the unit from becoming submerged in water of any depth and eliminates its movement penalty for moving through water.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":500,\"mp\":32,\"move\":2,\"jump\":6,\"speed\":7,\"pa\":20,\"ma\":3,\"cEvPercent\":2},\"effect\":\"Null Holy, Dark; Half Ice, Wind; Weak Lightning; Permanent Innocent; Immune Death, Undead, Reraise, Berserk, Frog, Poison, Regen, Faith, Sleep\"},{\"name\":\"Byblos\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Ignore Height\",\"info\":\"Movement. Allows the unit to jump vertically to tiles of any height.\",\"type\":\"move\"},{\"name\":\"Lifefont\",\"info\":\"Movement. After moving, the unit heals its HP by 10%.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":382,\"mp\":63,\"move\":3,\"jump\":6,\"speed\":9,\"pa\":12,\"ma\":20,\"cEvPercent\":33},\"effect\":\"Half Earth, Holy; Weak Fire\"},{\"name\":\"HolyDragon\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Beastmaster\",\"info\":\"Support. Enables an allied Wild Beast to use its locked ability while adjacent to the unit.\",\"type\":\"support\"},{\"name\":\"Stepping Stone\",\"info\":\"Support. Temporarily increases the Jump of allied units without this ability by 3 while they are moving through the unit's tile.\",\"type\":\"support\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":435,\"mp\":40,\"move\":4,\"jump\":3,\"speed\":10,\"pa\":15,\"ma\":43,\"cEvPercent\":7},\"effect\":\"Absorb Holy; Weak Dark; Immune Evil\"},{\"name\":\"Serpentarius\",\"gender\":\"Monster\",\"innates\":[{\"name\":\"Counter\",\"info\":\"Reaction. After the unit was targeted by a counterable attack from a unit within weapon range, it retaliates with a basic Attack.\",\"type\":\"react\"},{\"name\":\"Sicken\",\"info\":\"Support. Allows physical attacks used by the unit to add Poison (except a basic Attack with a Gun).\",\"type\":\"support\"},{\"name\":\"Manafont\",\"info\":\"Movement. After moving, the unit heals its MP by 10%.\",\"type\":\"move\"},{\"name\":\"Landlocked\",\"info\":\"Movement. Prevents the unit from entering water of any depth (but not shallow water).\",\"type\":\"move\"}],\"baseStats\":{\"hp\":514,\"mp\":82,\"move\":4,\"jump\":4,\"speed\":6,\"pa\":10,\"ma\":13,\"cEvPercent\":16},\"effect\":\"Half Ice; Weak Earth; Immune Float, Transparent, Chicken, Frog\"}]}");

});

parcelRegister("4mfej", function(module, exports) {

$parcel$export(module.exports, "buildTestTeams", () => $32c507d688a8c49e$export$a55a97e787d39725);
// Synthetic tournament data activated via ?test=1. The intent is a fixed
// visual reference for refactors — every weapon type rendered once, the
// known render-edge-cases (unarmed, Martial Arts, Doublehand, Monster,
// missing item), and a few ability-rich units that exercise abilityFormula's
// damage-by-skill switch (Lancer Charges, Wizard elemental magic, Chemist
// potions). The bracket renders with empty winners/maps so the QF cells
// just show the synthetic teams.
//
// buildTestTeams discovers weapon types from the live itemschanged dict
// rather than hardcoding item names, so the page survives item-DB changes
// upstream.
// Which class to assign each weapon type so the unit can actually equip the
// thing (FFT class-weapon affinity). Falls back to Squire for anything not
// listed.
const $32c507d688a8c49e$var$WEAPON_CLASS_MAP = {
    'Sword': {
        class: 'Knight',
        gender: 'Male'
    },
    'Knight Sword': {
        class: 'Knight',
        gender: 'Male'
    },
    'Katana': {
        class: 'Samurai',
        gender: 'Male'
    },
    'Rod': {
        class: 'Wizard',
        gender: 'Female'
    },
    'Spear': {
        class: 'Lancer',
        gender: 'Male'
    },
    'Pole': {
        class: 'Oracle',
        gender: 'Male'
    },
    'Staff': {
        class: 'Priest',
        gender: 'Female'
    },
    'Crossbow': {
        class: 'Archer',
        gender: 'Male'
    },
    'Bow': {
        class: 'Archer',
        gender: 'Male'
    },
    'Knife': {
        class: 'Thief',
        gender: 'Female'
    },
    'Ninja Blade': {
        class: 'Ninja',
        gender: 'Male'
    },
    'Harp': {
        class: 'Bard',
        gender: 'Male'
    },
    'Book': {
        class: 'Mediator',
        gender: 'Male'
    },
    'Fabric': {
        class: 'Dancer',
        gender: 'Female'
    },
    'Axe': {
        class: 'Squire',
        gender: 'Male'
    },
    'Bag': {
        class: 'Chemist',
        gender: 'Female'
    },
    'Flail': {
        class: 'Priest',
        gender: 'Male'
    },
    'Gun': {
        class: 'Chemist',
        gender: 'Male'
    }
};
function $32c507d688a8c49e$var$makeUnit(overrides) {
    return {
        Name: 'Test',
        Class: 'Squire',
        Gender: 'Male',
        Sign: 'Aries',
        Brave: 70,
        Faith: 60,
        RaidBoss: false,
        Mainhand: '',
        Offhand: '',
        Head: '',
        Armor: '',
        Accessory: '',
        ClassSkills: [],
        ExtraSkills: [],
        ActionSkill: 'Basic Skill',
        ReactionSkill: 'Counter',
        SupportSkill: '',
        MoveSkill: 'Move+1',
        ...overrides
    };
}
function $32c507d688a8c49e$export$a55a97e787d39725(itemschanged) {
    // First weapon-of-type we encounter wins — keeps the same item across reloads
    // since itemschanged iteration order is insertion order.
    const sampleByType = new Map();
    let elementalGun = '';
    let nonElementalGun = '';
    for (const item of Object.values(itemschanged)){
        if (!item.type || !item.wp) continue;
        if (!sampleByType.has(item.type)) sampleByType.set(item.type, item.name);
        if (item.type === 'Gun') {
            if (item.element && !elementalGun) elementalGun = item.name;
            if (!item.element && !nonElementalGun) nonElementalGun = item.name;
        }
    }
    const weaponUnits = [];
    for (const [type, itemName] of sampleByType){
        if (type === 'Gun') continue; // handled separately so we get both flavors
        const cls = $32c507d688a8c49e$var$WEAPON_CLASS_MAP[type] || {
            class: 'Squire',
            gender: 'Male'
        };
        weaponUnits.push($32c507d688a8c49e$var$makeUnit({
            Name: 'Test_' + type.replace(/\s+/g, ''),
            Class: cls.class,
            Gender: cls.gender,
            Mainhand: itemName
        }));
    }
    if (nonElementalGun) weaponUnits.push($32c507d688a8c49e$var$makeUnit({
        Name: 'Test_Gun',
        Class: 'Chemist',
        Gender: 'Male',
        Mainhand: nonElementalGun
    }));
    if (elementalGun) weaponUnits.push($32c507d688a8c49e$var$makeUnit({
        Name: 'Test_GunElement',
        Class: 'Chemist',
        Gender: 'Male',
        Mainhand: elementalGun
    }));
    const swordItem = sampleByType.get('Sword') || '';
    const spearItem = sampleByType.get('Spear') || '';
    const rodItem = sampleByType.get('Rod') || '';
    const edgeUnits = [
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_Unarmed',
            Class: 'Monk',
            Gender: 'Male'
        }),
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_MartialArts',
            Class: 'Monk',
            Gender: 'Female',
            SupportSkill: 'Martial Arts'
        }),
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_Doublehand',
            Class: 'Knight',
            Gender: 'Male',
            Mainhand: swordItem,
            SupportSkill: 'Doublehand'
        }),
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_Monster',
            Class: 'Red Chocobo',
            Gender: 'Monster'
        }),
        // Deliberate item-not-in-API name — exercises the safeDict fallback. The
        // unit should still render with zeroed item bonuses, not crash.
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_MissingItem',
            Class: 'Knight',
            Gender: 'Male',
            Mainhand: 'TotallyMadeUpItem'
        })
    ];
    const abilityUnits = [
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_LancerCharges',
            Class: 'Lancer',
            Gender: 'Male',
            Mainhand: spearItem,
            ClassSkills: [
                'Charge+1',
                'Charge+2',
                'Charge+3',
                'Charge+4',
                'Charge+5',
                'Charge+7',
                'Charge+10',
                'Charge+20'
            ]
        }),
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_WizardMagic',
            Class: 'Wizard',
            Gender: 'Female',
            Mainhand: rodItem,
            ClassSkills: [
                'Fire',
                'Fire 2',
                'Fire 3',
                'Fire 4',
                'Bolt',
                'Bolt 2',
                'Bolt 3',
                'Bolt 4',
                'Ice',
                'Ice 2',
                'Ice 3',
                'Ice 4',
                'Flare'
            ]
        }),
        $32c507d688a8c49e$var$makeUnit({
            Name: 'Test_ChemistItems',
            Class: 'Chemist',
            Gender: 'Male',
            ClassSkills: [
                'Potion',
                'Hi-Potion',
                'X-Potion',
                'Elixir',
                'Phoenix Down'
            ]
        })
    ];
    // Distribute units across the team slots. The bracket section will show
    // these as the QF matchups (with empty winners), and the team-grid section
    // below will show them as scrollable rosters.
    const mid = Math.ceil(weaponUnits.length / 2);
    return {
        ID: 'TEST',
        Teams: {
            red: {
                Units: weaponUnits.slice(0, mid)
            },
            blue: {
                Units: weaponUnits.slice(mid)
            },
            green: {
                Units: edgeUnits
            },
            yellow: {
                Units: abilityUnits
            },
            white: {
                Units: []
            },
            black: {
                Units: []
            },
            purple: {
                Units: []
            },
            brown: {
                Units: []
            },
            champion: {
                Units: []
            }
        },
        Maps: [
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ''
        ],
        Winners: [],
        Entrants: [],
        Snubs: []
    };
}

});

parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $c319b2c832c2914a$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $c319b2c832c2914a$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $c319b2c832c2914a$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $c319b2c832c2914a$var$getPrototypeOf(obj);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $c319b2c832c2914a$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $c319b2c832c2914a$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $c319b2c832c2914a$var$getPrototypeOf(current);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) continue;
            if (!$c319b2c832c2914a$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
const $c319b2c832c2914a$var$isSet = $c319b2c832c2914a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($c319b2c832c2914a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                    $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    toSafeFlatObject: $c319b2c832c2914a$var$toSafeFlatObject,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $475Ki = parcelRequire("475Ki");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $gKvUL.default).getSafeProp(config, 'method') || (0, $gKvUL.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach((0, $475Ki.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $gKvUL.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $dlZEJ.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $gKvUL.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $gKvUL.default).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $gKvUL.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", () => $e6cbd383b18c9625$export$659081b45d03227d);
$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $5vpyF = parcelRequire("5vpyF");
'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $gKvUL.default).getSafeProp(options, name);
        return (0, $gKvUL.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $e6cbd383b18c9625$export$659081b45d03227d);
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $5vpyF.default) && (0, $5vpyF.default).isBufferAvailable()) return (0, $5vpyF.default).from(value);
            throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.', (0, $6HVMZ.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $6HVMZ.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $gKvUL.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "REDACTED", () => $4e2395edb77acf3a$export$6acd2efa8ac62a1b);
$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $4e2395edb77acf3a$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $gKvUL.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $gKvUL.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $gKvUL.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $bxxyx.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $gKvUL.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $gKvUL.default).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $4e2395edb77acf3a$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $4e2395edb77acf3a$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $4e2395edb77acf3a$var$stringifySafely(entry.message) : $4e2395edb77acf3a$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $gKvUL.default).isArray(error.errors) && error.errors.length) message = $4e2395edb77acf3a$var$aggregateErrorMessage(error);
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $gKvUL.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $gKvUL.default).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $gKvUL.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});
parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");

var $lnc0M = parcelRequire("lnc0M");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $lnc0M.sanitizeHeaderValue)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $866cce54f6bdfb0c$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $866cce54f6bdfb0c$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $866cce54f6bdfb0c$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $866cce54f6bdfb0c$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $866cce54f6bdfb0c$var$trimOWS(part.slice(0, equals));
        if (!$866cce54f6bdfb0c$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $866cce54f6bdfb0c$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $866cce54f6bdfb0c$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $gKvUL.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $gKvUL.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $gKvUL.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $866cce54f6bdfb0c$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $gKvUL.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $gKvUL.default).hasOwnProp($fc026bbf9ee156f1$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("lnc0M", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", () => $f8f5102fdfcbfec9$export$9e344cffce061a22);
$parcel$export(module.exports, "toByteStringHeaderObject", () => $f8f5102fdfcbfec9$export$c30c72bb7e677d54);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $gKvUL.default).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $gKvUL.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});




parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
const $5de878cd737ef277$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $5de878cd737ef277$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $5de878cd737ef277$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $5de878cd737ef277$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $5de878cd737ef277$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$5de878cd737ef277$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$5de878cd737ef277$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $5de878cd737ef277$var$syncHandlerEntries(this, this[$5de878cd737ef277$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $5de878cd737ef277$var$syncHandlerEntries(this, internals);
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = $5de878cd737ef277$var$countHandlers(this.handlers);
            }
        }
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $gKvUL.default).toSafeFlatObject(_config);
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from((0, $gKvUL.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");

var $475Ki = parcelRequire("475Ki");
'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $gKvUL.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach((0, $475Ki.default), (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $jOwpo = parcelRequire("jOwpo");
'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $jOwpo.DEFAULT_FORM_DATA_MAX_DEPTH);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $6HVMZ.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = (0, $gKvUL.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $gKvUL.default).hasOwnProp(target, name) || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});

parcelRegister("475Ki", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fec45dc063f0c4b$export$2e2bcd8739ae039);
'use strict';
const $2fec45dc063f0c4b$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $2fec45dc063f0c4b$export$2e2bcd8739ae039 = $2fec45dc063f0c4b$var$methodList;

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $6HVMZ.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $6T0Ji = parcelRequire("6T0Ji");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $lnc0M = parcelRequire("lnc0M");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $32jg5.default)((0, $6T0Ji.default)(_config.url)) || (0, $32jg5.default)((0, $g65xr.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach((0, $lnc0M.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && !(0, $g65xr.default).protocols.includes(protocol)) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $6HVMZ.default).ERR_BAD_REQUEST : (0, $6HVMZ.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("6T0Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $503871fd6eafbe9c$export$2e2bcd8739ae039);
'use strict';
const $503871fd6eafbe9c$var$urlParserControlCharacters = /[\t\n\r]/g;
function $503871fd6eafbe9c$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($503871fd6eafbe9c$var$urlParserControlCharacters, '');
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        if (!e || !(0, $gKvUL.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn, scheduler = (0, $gKvUL.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $lW6v2 = parcelRequire("lW6v2");

var $cbIsf = parcelRequire("cbIsf");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $lk5EI.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $gKvUL.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $gKvUL.default).getSafeProp(auth, 'username') || '';
        const password = (0, $gKvUL.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $gKvUL.default).isFormData(data)) {
        const getHeaders = (0, $gKvUL.default).getSafeProp(data, 'getHeaders');
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv || (0, $gKvUL.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $gKvUL.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $lW6v2.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        if ((0, $gKvUL.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $889er.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");

var $6T0Ji = parcelRequire("6T0Ji");
'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $598acbfafd2c63c5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $6HVMZ.REDACTED}`;
    });
}
function $598acbfafd2c63c5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $6HVMZ.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $6HVMZ.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$598acbfafd2c63c5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $6T0Ji.default)(url);
        if ($598acbfafd2c63c5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $6HVMZ.default)(`Invalid URL ${JSON.stringify($598acbfafd2c63c5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $6HVMZ.default).ERR_INVALID_URL, config);
    }
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $fE4ul.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
const $f85fda54cd977b19$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $gKvUL.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $gKvUL.default).isUndefined(transitional2)) {
            if ((0, $gKvUL.default).isPlainObject(transitional2)) {
                if ((0, $gKvUL.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $gKvUL.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $gKvUL.default).isPlainObject(transitional1) && (0, $gKvUL.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $gKvUL.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $gKvUL.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach($f85fda54cd977b19$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $gKvUL.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $gKvUL.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $gKvUL.default).hasOwnProp(config2, 'validateStatus') && (0, $gKvUL.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $gKvUL.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("lW6v2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff840e6c220d182f$export$2e2bcd8739ae039);
'use strict';
const $ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ff840e6c220d182f$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");

var $iKBwL = parcelRequire("iKBwL");

var $35BUy = parcelRequire("35BUy");

var $lnc0M = parcelRequire("lnc0M");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $gKvUL.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $gKvUL.default).global !== undefined && (0, $gKvUL.default).global !== null ? (0, $gKvUL.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $g65xr.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $eHGD2.default)(config);
        const hasMaxContentLength = (0, $gKvUL.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $gKvUL.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $gKvUL.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $6HVMZ.default)('Request body larger than maxBodyLength limit', (0, $6HVMZ.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $gKvUL.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $gKvUL.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $g65xr.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $iKBwL.default)(url);
                if (estimated > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $gKvUL.default).isReadableStream(data) || (0, $gKvUL.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $hhnAb.trackStream)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $6HVMZ.default)('Stream request bodies are not supported by the current fetch implementation', (0, $6HVMZ.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $gKvUL.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $35BUy.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $lnc0M.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $gKvUL.default).forEach($e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $bxxyx.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $6HVMZ.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $6HVMZ.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("iKBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $da69a2069c6136ea$export$2e2bcd8739ae039);
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
const $da69a2069c6136ea$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $da69a2069c6136ea$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $da69a2069c6136ea$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $da69a2069c6136ea$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $da69a2069c6136ea$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            code = $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 1)) * 16 + $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($da69a2069c6136ea$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$da69a2069c6136ea$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $da69a2069c6136ea$var$estimateBase64BufferAllocation(body);
    return $da69a2069c6136ea$var$base64Bytes(significant);
};
const $da69a2069c6136ea$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $da69a2069c6136ea$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes);
}
function $da69a2069c6136ea$export$1f39e64b554a246f(url) {
    return $da69a2069c6136ea$var$estimateDataURLBytes(url, $da69a2069c6136ea$var$estimateBase64BufferAllocation);
}

});

parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});


parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    if ($f919374d785e9fb8$var$HttpStatusCode[value] === undefined) $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});




parcelRegister("eudrX", function(module, exports) {

$parcel$export(module.exports, "render", () => $a8be4ce26977e52e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a8be4ce26977e52e$var$_hoisted_1 = {
    key: 0,
    class: "overall-page"
};
const $a8be4ce26977e52e$var$_hoisted_2 = {
    class: "snav-act"
};
const $a8be4ce26977e52e$var$_hoisted_3 = {
    key: 0,
    class: "snav-act"
};
const $a8be4ce26977e52e$var$_hoisted_4 = [
    "href"
];
const $a8be4ce26977e52e$var$_hoisted_5 = {
    class: "snav-act"
};
const $a8be4ce26977e52e$var$_hoisted_6 = {
    key: 1,
    class: "snav-act"
};
const $a8be4ce26977e52e$var$_hoisted_7 = {
    key: 2,
    class: "snav-act"
};
const $a8be4ce26977e52e$var$_hoisted_8 = [
    "href"
];
const $a8be4ce26977e52e$var$_hoisted_9 = {
    class: "container"
};
const $a8be4ce26977e52e$var$_hoisted_10 = {
    id: "app"
};
const $a8be4ce26977e52e$var$_hoisted_11 = {
    key: 0,
    class: "test-mode-banner"
};
const $a8be4ce26977e52e$var$_hoisted_12 = {
    key: 1,
    class: "archive-strip"
};
const $a8be4ce26977e52e$var$_hoisted_13 = [
    "href"
];
const $a8be4ce26977e52e$var$_hoisted_14 = [
    "href"
];
const $a8be4ce26977e52e$var$_hoisted_15 = {
    key: 3,
    class: "goal-widget"
};
const $a8be4ce26977e52e$var$_hoisted_16 = {
    class: "goal-head"
};
const $a8be4ce26977e52e$var$_hoisted_17 = {
    class: "goal-label"
};
const $a8be4ce26977e52e$var$_hoisted_18 = {
    class: "goal-status"
};
const $a8be4ce26977e52e$var$_hoisted_19 = [
    "href"
];
const $a8be4ce26977e52e$var$_hoisted_20 = {
    key: 0,
    class: "goal-rolling"
};
const $a8be4ce26977e52e$var$_hoisted_21 = {
    key: 1,
    class: "goal-remaining"
};
const $a8be4ce26977e52e$var$_hoisted_22 = {
    key: 0,
    class: "goal-remain-more"
};
const $a8be4ce26977e52e$var$_hoisted_23 = {
    key: 2,
    class: "goal-hint"
};
const $a8be4ce26977e52e$var$_hoisted_24 = {
    key: 4,
    class: "bracket-holder"
};
const $a8be4ce26977e52e$var$_hoisted_25 = {
    class: "tournament-bracket__round tournament-bracket__round--quarterfinals"
};
const $a8be4ce26977e52e$var$_hoisted_26 = {
    class: "tournament-bracket__list"
};
const $a8be4ce26977e52e$var$_hoisted_27 = {
    class: "tournament-bracket__round tournament-bracket__round--semifinals"
};
const $a8be4ce26977e52e$var$_hoisted_28 = {
    class: "tournament-bracket__list"
};
const $a8be4ce26977e52e$var$_hoisted_29 = {
    class: "tournament-bracket__round tournament-bracket__round--bronze"
};
const $a8be4ce26977e52e$var$_hoisted_30 = {
    class: "tournament-bracket__list"
};
const $a8be4ce26977e52e$var$_hoisted_31 = {
    class: "tournament-bracket__round tournament-bracket__round--gold"
};
const $a8be4ce26977e52e$var$_hoisted_32 = {
    class: "tournament-bracket__list"
};
const $a8be4ce26977e52e$var$_hoisted_33 = {
    class: "champ-cell-host"
};
const $a8be4ce26977e52e$var$_hoisted_34 = [
    "title"
];
const $a8be4ce26977e52e$var$_hoisted_35 = {
    class: "sd-name"
};
const $a8be4ce26977e52e$var$_hoisted_36 = {
    class: "sd-rarity"
};
const $a8be4ce26977e52e$var$_hoisted_37 = [
    "title"
];
const $a8be4ce26977e52e$var$_hoisted_38 = {
    class: "top-bar"
};
const $a8be4ce26977e52e$var$_hoisted_39 = {
    class: "buttons"
};
const $a8be4ce26977e52e$var$_hoisted_40 = [
    "onClick"
];
const $a8be4ce26977e52e$var$_hoisted_41 = {
    class: "snubs-entries"
};
const $a8be4ce26977e52e$var$_hoisted_42 = {
    key: 0,
    class: "entries"
};
const $a8be4ce26977e52e$var$_hoisted_43 = [
    "onClick"
];
const $a8be4ce26977e52e$var$_hoisted_44 = {
    key: 1,
    class: "snubs"
};
const $a8be4ce26977e52e$var$_hoisted_45 = {
    class: "toolTip tr-host"
};
const $a8be4ce26977e52e$var$_hoisted_46 = {
    class: "holder"
};
const $a8be4ce26977e52e$var$_hoisted_47 = {
    key: 1,
    class: "loading-screen"
};
const $a8be4ce26977e52e$var$_hoisted_48 = {
    key: 0
};
const $a8be4ce26977e52e$var$_hoisted_49 = {
    key: 1
};
const $a8be4ce26977e52e$var$_hoisted_50 = {
    class: "source-list"
};
const $a8be4ce26977e52e$var$_hoisted_51 = {
    class: "label"
};
const $a8be4ce26977e52e$var$_hoisted_52 = {
    class: "status"
};
function $a8be4ce26977e52e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BotDownBanner = (0, $TusQn.resolveComponent)("BotDownBanner");
    const _component_SiteNav = (0, $TusQn.resolveComponent)("SiteNav");
    const _component_WhatsNewModal = (0, $TusQn.resolveComponent)("WhatsNewModal");
    const _component_SpotlightModal = (0, $TusQn.resolveComponent)("SpotlightModal");
    const _component_OnboardingTour = (0, $TusQn.resolveComponent)("OnboardingTour");
    const _component_HelpModal = (0, $TusQn.resolveComponent)("HelpModal");
    const _component_UnitCardModal = (0, $TusQn.resolveComponent)("UnitCardModal");
    const _component_SettingsModal = (0, $TusQn.resolveComponent)("SettingsModal");
    const _component_AnnouncementModal = (0, $TusQn.resolveComponent)("AnnouncementModal");
    const _component_MyModifiersModal = (0, $TusQn.resolveComponent)("MyModifiersModal");
    const _component_FightModal = (0, $TusQn.resolveComponent)("FightModal");
    const _component_RecentTicker = (0, $TusQn.resolveComponent)("RecentTicker");
    const _component_PredictPanel = (0, $TusQn.resolveComponent)("PredictPanel");
    const _component_BracketMatch = (0, $TusQn.resolveComponent)("BracketMatch");
    const _component_ColiseumPromo = (0, $TusQn.resolveComponent)("ColiseumPromo");
    const _component_ChampStreakBadge = (0, $TusQn.resolveComponent)("ChampStreakBadge");
    const _component_TeamRatingTip = (0, $TusQn.resolveComponent)("TeamRatingTip");
    const _component_InlineUnit = (0, $TusQn.resolveComponent)("InlineUnit");
    return $data.renderMain ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_1, [
        $data.headsUp ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: "headsup-banner",
            onClick: _cache[0] || (_cache[0] = ($event)=>$data.headsUp = false)
        }, [
            ..._cache[22] || (_cache[22] = [
                (0, $TusQn.createTextVNode)(" \uD83D\uDD14 A new tournament is starting soon \u2014 head to chat and ", -1),
                (0, $TusQn.createElementVNode)("b", null, "!fight", -1),
                (0, $TusQn.createTextVNode)(" to enter! ", -1),
                (0, $TusQn.createElementVNode)("span", {
                    class: "hu-dismiss"
                }, "(click to dismiss)", -1)
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createVNode)(_component_BotDownBanner, {
            "last-mod": $data.isLiveTournament ? $data.tournamentLastMod : null
        }, null, 8, [
            "last-mod"
        ]),
        (0, $TusQn.createVNode)(_component_SiteNav, {
            active: "bracket"
        }, {
            actions: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "settings-gear",
                            onClick: _cache[1] || (_cache[1] = ($event)=>$data.showSettings = true),
                            "aria-label": "Settings"
                        }, "\u2699"),
                        _cache[23] || (_cache[23] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Highlight favorite players with colors, notification sounds, display toggles \u2014 and replay the intro tour.", -1))
                    ]),
                    $data.prefs.myUsername ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a8be4ce26977e52e$var$_hoisted_3, [
                        (0, $TusQn.createElementVNode)("a", {
                            class: "profile-button",
                            href: '?player=' + encodeURIComponent($data.prefs.myUsername),
                            "aria-label": "My profile"
                        }, "\uD83D\uDC64", 8, $a8be4ce26977e52e$var$_hoisted_4),
                        _cache[24] || (_cache[24] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Your full player profile \u2014 stats, achievements, championship history.", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_5, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "help-button",
                            onClick: _cache[2] || (_cache[2] = ($event)=>$data.showHelp = true),
                            "aria-label": "Help"
                        }, "?"),
                        _cache[25] || (_cache[25] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "A searchable FFTBG guide \u2014 every chat command and the game mechanics behind the numbers.", -1))
                    ]),
                    $options.canPredict ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a8be4ce26977e52e$var$_hoisted_6, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: (0, $8POXm.normalizeClass)([
                                "predict-toggle",
                                {
                                    on: $data.predictMode
                                }
                            ]),
                            onClick: _cache[3] || (_cache[3] = (...args)=>$options.togglePredict && $options.togglePredict(...args)),
                            "aria-label": "Predict the bracket"
                        }, "\uD83D\uDD2E", 2),
                        _cache[26] || (_cache[26] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Predict-the-Bracket: pick the winner of every match and see how you score \u2014 against the results and the battle sim.", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    _cache[28] || (_cache[28] = (0, $TusQn.createElementVNode)("span", {
                        class: "snav-act"
                    }, [
                        (0, $TusQn.createElementVNode)("a", {
                            class: "generator-button",
                            href: "?build&random",
                            "aria-label": "Random unit generator"
                        }, "\uD83C\uDFB2"),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Roll a random FFTBG unit in the Builder \u2014 force or ban classes and skills, then tweak anything.")
                    ], -1)),
                    $data.previous_tournament_id && !$options.isArchivedTournament ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a8be4ce26977e52e$var$_hoisted_7, [
                        (0, $TusQn.createElementVNode)("a", {
                            class: "prev-tourney-button",
                            href: '/?tournament=' + $data.previous_tournament_id,
                            "aria-label": "Previous tournament"
                        }, "\u23EE", 8, $a8be4ce26977e52e$var$_hoisted_8),
                        _cache[27] || (_cache[27] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Jump back to the previous tournament's final bracket.", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        $data.showWhatsNew ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_WhatsNewModal, {
            key: 1,
            onClose: $options.closeWhatsNew,
            onTour: $options.startMainTour
        }, null, 8, [
            "onClose",
            "onTour"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showSpotlight ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SpotlightModal, {
            key: 2,
            updates: $options.spotlightUpdates,
            onClose: $options.closeSpotlight
        }, null, 8, [
            "updates",
            "onClose"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createVNode)(_component_OnboardingTour, {
            ref: "tour",
            steps: $data.tourSteps,
            onDone: $options.onTourDone
        }, null, 8, [
            "steps",
            "onDone"
        ]),
        $data.showHelp ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_HelpModal, {
            key: 3,
            onClose: _cache[4] || (_cache[4] = ($event)=>$data.showHelp = false)
        })) : (0, $TusQn.createCommentVNode)("", true),
        $data.fullCard ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_UnitCardModal, {
            key: 4,
            unit: $data.fullCard.unit,
            "team-color": $data.fullCard.teamColor,
            "enemy-team": $data.fullCard.enemyTeam,
            "own-team": $data.fullCard.ownTeam,
            "class-rank": $data.classRank,
            "tool-tips": $data.toolTips,
            "not-ables": $data.notAbles,
            "char-stats": $data.charStats,
            itemschanged: $data.itemschanged,
            "abilities-info": $data.abilitiesInfo,
            "highlight-colors": $options.highlightColors,
            "show-win-rates": $data.prefs.showWinRates,
            onClose: _cache[5] || (_cache[5] = ($event)=>$data.fullCard = null)
        }, null, 8, [
            "unit",
            "team-color",
            "enemy-team",
            "own-team",
            "class-rank",
            "tool-tips",
            "not-ables",
            "char-stats",
            "itemschanged",
            "abilities-info",
            "highlight-colors",
            "show-win-rates"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showSettings ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SettingsModal, {
            key: 5,
            prefs: $data.prefs,
            "onUpdate:prefs": $options.onPrefsUpdate,
            onClose: _cache[6] || (_cache[6] = ($event)=>$data.showSettings = false)
        }, null, 8, [
            "prefs",
            "onUpdate:prefs"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showAnnouncement ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_AnnouncementModal, {
            key: 6,
            matches: $options.announcementMatches,
            "skill-drop": $options.skillDropInfo,
            "settings-hint": $options.announceSettingsHint,
            "settings-link": true,
            onDismiss: $options.dismissAnnouncement,
            onOpenSettings: $options.openSettingsFromAnnouncement,
            onScrollToPlayer: $options.gotoPlayer
        }, null, 8, [
            "matches",
            "skill-drop",
            "settings-hint",
            "onDismiss",
            "onOpenSettings",
            "onScrollToPlayer"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.prefs.myUsername ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
            key: 7,
            class: "my-mods-fab",
            onClick: _cache[7] || (_cache[7] = ($event)=>$data.showMyMods = true),
            title: "Your active skill modifiers \u2014 how your owned skills nudge your character roll"
        }, "\u26A1 My Mods")) : (0, $TusQn.createCommentVNode)("", true),
        $data.showMyMods ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_MyModifiersModal, {
            key: 8,
            handle: $data.prefs.myUsername,
            champion: $options.nextChampion,
            onClose: _cache[8] || (_cache[8] = ($event)=>$data.showMyMods = false)
        }, null, 8, [
            "handle",
            "champion"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.fightTeams ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_FightModal, {
            key: 9,
            map: $data.fightTeams.map,
            "left-team": $options.teamByName[$data.fightTeams.left],
            "right-team": $options.teamByName[$data.fightTeams.right],
            itemschanged: $data.itemschanged,
            "char-stats": $data.charStats,
            "abilities-info": $data.abilitiesInfo,
            "not-ables": $data.notAbles,
            "tool-tips": $data.toolTips,
            predict: $options.fightPredict,
            onPickWinner: _cache[9] || (_cache[9] = ($event)=>$options.onPick($data.fightTeams.matchIndex, $event)),
            onClose: _cache[10] || (_cache[10] = ($event)=>$data.fightTeams = null)
        }, null, 8, [
            "map",
            "left-team",
            "right-team",
            "itemschanged",
            "char-stats",
            "abilities-info",
            "not-ables",
            "tool-tips",
            "predict"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_9, [
            (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_10, [
                $data.testMode ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_11, "TEST MODE \u2014 synthetic units. Visit / to return.")) : (0, $TusQn.createCommentVNode)("", true),
                $options.isArchivedTournament ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_12, [
                    _cache[29] || (_cache[29] = (0, $TusQn.createElementVNode)("span", {
                        class: "archive-label"
                    }, "\u23EA Viewing an archived tournament", -1)),
                    $data.previous_tournament_id ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                        key: 0,
                        class: "archive-btn",
                        href: '/?tournament=' + $data.previous_tournament_id
                    }, "\u23EE Prev", 8, $a8be4ce26977e52e$var$_hoisted_13)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.next_tournament_id ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                        key: 1,
                        class: "archive-btn",
                        href: '/?tournament=' + $data.next_tournament_id
                    }, "Next \u23ED", 8, $a8be4ce26977e52e$var$_hoisted_14)) : (0, $TusQn.createCommentVNode)("", true),
                    _cache[30] || (_cache[30] = (0, $TusQn.createElementVNode)("a", {
                        class: "archive-btn archive-live",
                        href: "/"
                    }, "\u25CF Back to Live", -1))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                !$data.testMode && $data.prefs.showTicker !== false ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RecentTicker, {
                    key: 2
                })) : (0, $TusQn.createCommentVNode)("", true),
                $options.goalWidget ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_15, [
                    (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_16, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "goal-dismiss",
                            onClick: _cache[11] || (_cache[11] = (...args)=>$options.dismissGoal && $options.dismissGoal(...args)),
                            title: "Hide this widget \u2014 visit your profile to show it again"
                        }, "\u2715"),
                        (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_17, "\uD83C\uDFAF " + (0, $8POXm.toDisplayString)($options.goalWidget.name), 1),
                        (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_18, (0, $8POXm.toDisplayString)($options.goalWidget.status), 1),
                        (0, $TusQn.createElementVNode)("a", {
                            class: "goal-profile",
                            href: '?player=' + encodeURIComponent($data.prefs.myUsername) + '&tab=achievements'
                        }, "profile \u2192", 8, $a8be4ce26977e52e$var$_hoisted_19)
                    ]),
                    $options.goalWidget.rolling ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_20, [
                        _cache[31] || (_cache[31] = (0, $TusQn.createTextVNode)("\u2728 You're rolling a ", -1)),
                        (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)($options.goalWidget.rolling), 1),
                        _cache[32] || (_cache[32] = (0, $TusQn.createTextVNode)(" right now \u2014 that's one you need!", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $options.goalWidget.remaining.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_21, [
                        _cache[33] || (_cache[33] = (0, $TusQn.createElementVNode)("span", {
                            class: "goal-remain-label"
                        }, "Still need:", -1)),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.goalWidget.remaining.slice(0, 12), (r)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: r,
                                class: (0, $8POXm.normalizeClass)([
                                    "goal-remain-item",
                                    {
                                        hit: r === $options.goalWidget.rolling
                                    }
                                ])
                            }, (0, $8POXm.toDisplayString)(r), 3);
                        }), 128)),
                        $options.goalWidget.remaining.length > 12 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a8be4ce26977e52e$var$_hoisted_22, "+" + (0, $8POXm.toDisplayString)($options.goalWidget.remaining.length - 12) + " more", 1)) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : !$options.goalWidget.rolling ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_23, "Keep playing \u2014 " + (0, $8POXm.toDisplayString)($options.goalWidget.status), 1)) : (0, $TusQn.createCommentVNode)("", true)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                !$data.prefs.hideBracket ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_24, [
                    $data.predictMode ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_PredictPanel, {
                        key: 0,
                        score: $options.predictScore,
                        sim: $options.predictSimRecord,
                        lifetime: $data.predictState.lifetime,
                        complete: $options.currentMatchIndex === -1 && $options.predictScore.picksMade > 0
                    }, null, 8, [
                        "score",
                        "sim",
                        "lifetime",
                        "complete"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("div", {
                        class: (0, $8POXm.normalizeClass)([
                            "tournament-bracket tournament-bracket--rounded",
                            $options.activeRound ? 'active-' + $options.activeRound : ''
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_25, [
                            _cache[34] || (_cache[34] = (0, $TusQn.createElementVNode)("h3", {
                                class: "tournament-bracket__round-title"
                            }, "Quarterfinals", -1)),
                            (0, $TusQn.createElementVNode)("ul", $a8be4ce26977e52e$var$_hoisted_26, [
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    map: $data.maps[0],
                                    "is-current": $options.currentMatchIndex === 0,
                                    "match-index": 0,
                                    predict: $data.predictMode ? $options.predictCells[0] : null,
                                    onPick: _cache[12] || (_cache[12] = ($event)=>$options.onPick(0, $event)),
                                    "vs-title": "Red vs. Blue",
                                    "left-teams": [
                                        {
                                            name: 'red',
                                            show: true,
                                            enemyColor: $options.teamByName.blue.label
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'blue',
                                            show: true,
                                            enemyColor: $options.teamByName.red.label
                                        }
                                    ],
                                    "left-won": $options.bracketState.redBracketR1WIN,
                                    "right-won": $options.bracketState.blueBracketR1WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ]),
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    map: $data.maps[1],
                                    "is-current": $options.currentMatchIndex === 1,
                                    "match-index": 1,
                                    predict: $data.predictMode ? $options.predictCells[1] : null,
                                    onPick: _cache[13] || (_cache[13] = ($event)=>$options.onPick(1, $event)),
                                    "vs-title": "Green vs. Yellow",
                                    "left-teams": [
                                        {
                                            name: 'green',
                                            show: true,
                                            enemyColor: $options.teamByName.yellow.label
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'yellow',
                                            show: true,
                                            enemyColor: $options.teamByName.green.label
                                        }
                                    ],
                                    "left-won": $options.bracketState.greenBracketR1WIN,
                                    "right-won": $options.bracketState.yellowBracketR1WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ]),
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    map: $data.maps[2],
                                    "is-current": $options.currentMatchIndex === 2,
                                    "match-index": 2,
                                    predict: $data.predictMode ? $options.predictCells[2] : null,
                                    onPick: _cache[14] || (_cache[14] = ($event)=>$options.onPick(2, $event)),
                                    "vs-title": "White vs. Black",
                                    "left-teams": [
                                        {
                                            name: 'white',
                                            show: true,
                                            enemyColor: $options.teamByName.black.label
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'black',
                                            show: true,
                                            enemyColor: $options.teamByName.white.label
                                        }
                                    ],
                                    "left-won": $options.bracketState.whiteBracketR1WIN,
                                    "right-won": $options.bracketState.blackBracketR1WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ]),
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    map: $data.maps[3],
                                    "is-current": $options.currentMatchIndex === 3,
                                    "match-index": 3,
                                    predict: $data.predictMode ? $options.predictCells[3] : null,
                                    onPick: _cache[15] || (_cache[15] = ($event)=>$options.onPick(3, $event)),
                                    "vs-title": "Purple vs. Brown",
                                    "left-teams": [
                                        {
                                            name: 'purple',
                                            show: true,
                                            enemyColor: $options.teamByName.brown.label
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'brown',
                                            show: true,
                                            enemyColor: $options.teamByName.purple.label
                                        }
                                    ],
                                    "left-won": $options.bracketState.purpleBracketR1WIN,
                                    "right-won": $options.bracketState.brownBracketR1WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ])
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_27, [
                            _cache[35] || (_cache[35] = (0, $TusQn.createElementVNode)("h3", {
                                class: "tournament-bracket__round-title"
                            }, "Semifinals", -1)),
                            (0, $TusQn.createElementVNode)("ul", $a8be4ce26977e52e$var$_hoisted_28, [
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    "match-class": "semi",
                                    map: $data.maps[4],
                                    "is-current": $options.currentMatchIndex === 4,
                                    "match-index": 4,
                                    predict: $data.predictMode ? $options.predictCells[4] : null,
                                    onPick: _cache[16] || (_cache[16] = ($event)=>$options.onPick(4, $event)),
                                    "vs-title": $options.semiOneLeft + ' vs. ' + $options.semiOneRight,
                                    "left-teams": [
                                        {
                                            name: 'red',
                                            show: $options.bracketState.redBracketR1WIN,
                                            enemyColor: $options.semiOneRight
                                        },
                                        {
                                            name: 'blue',
                                            show: $options.bracketState.blueBracketR1WIN,
                                            enemyColor: $options.semiOneRight
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'green',
                                            show: $options.bracketState.greenBracketR1WIN,
                                            enemyColor: $options.semiOneLeft
                                        },
                                        {
                                            name: 'yellow',
                                            show: $options.bracketState.yellowBracketR1WIN,
                                            enemyColor: $options.semiOneLeft
                                        }
                                    ],
                                    "left-won": $options.bracketState.topleftBracketR2WIN,
                                    "right-won": $options.bracketState.toprightBracketR2WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "vs-title",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ]),
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    "match-class": "semi",
                                    map: $data.maps[5],
                                    "is-current": $options.currentMatchIndex === 5,
                                    "match-index": 5,
                                    predict: $data.predictMode ? $options.predictCells[5] : null,
                                    onPick: _cache[17] || (_cache[17] = ($event)=>$options.onPick(5, $event)),
                                    "vs-title": $options.semiTwoLeft + ' vs. ' + $options.semiTwoRight,
                                    "left-teams": [
                                        {
                                            name: 'white',
                                            show: $options.bracketState.whiteBracketR1WIN,
                                            enemyColor: $options.semiTwoRight
                                        },
                                        {
                                            name: 'black',
                                            show: $options.bracketState.blackBracketR1WIN,
                                            enemyColor: $options.semiTwoRight
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'purple',
                                            show: $options.bracketState.purpleBracketR1WIN,
                                            enemyColor: $options.semiTwoLeft
                                        },
                                        {
                                            name: 'brown',
                                            show: $options.bracketState.brownBracketR1WIN,
                                            enemyColor: $options.semiTwoLeft
                                        }
                                    ],
                                    "left-won": $options.bracketState.bottomleftBracketR2WIN,
                                    "right-won": $options.bracketState.bottomrightBracketR2WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "vs-title",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ])
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_29, [
                            _cache[36] || (_cache[36] = (0, $TusQn.createElementVNode)("h3", {
                                class: "tournament-bracket__round-title"
                            }, "Finals", -1)),
                            (0, $TusQn.createElementVNode)("ul", $a8be4ce26977e52e$var$_hoisted_30, [
                                (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                    "match-class": "final",
                                    map: $data.maps[6],
                                    "is-current": $options.currentMatchIndex === 6,
                                    "match-index": 6,
                                    predict: $data.predictMode ? $options.predictCells[6] : null,
                                    onPick: _cache[18] || (_cache[18] = ($event)=>$options.onPick(6, $event)),
                                    "vs-title": $options.finalLeft + ' vs. ' + $options.finalRight,
                                    "left-teams": [
                                        {
                                            name: 'red',
                                            show: $options.bracketState.redBracketR1WIN && $options.bracketState.topleftBracketR2WIN,
                                            enemyColor: $options.finalRight
                                        },
                                        {
                                            name: 'blue',
                                            show: $options.bracketState.blueBracketR1WIN && $options.bracketState.topleftBracketR2WIN,
                                            enemyColor: $options.finalRight
                                        },
                                        {
                                            name: 'green',
                                            show: $options.bracketState.greenBracketR1WIN && $options.bracketState.toprightBracketR2WIN,
                                            enemyColor: $options.finalRight
                                        },
                                        {
                                            name: 'yellow',
                                            show: $options.bracketState.yellowBracketR1WIN && $options.bracketState.toprightBracketR2WIN,
                                            enemyColor: $options.finalRight
                                        }
                                    ],
                                    "right-teams": [
                                        {
                                            name: 'white',
                                            show: $options.bracketState.whiteBracketR1WIN && $options.bracketState.bottomleftBracketR2WIN,
                                            enemyColor: $options.finalLeft
                                        },
                                        {
                                            name: 'black',
                                            show: $options.bracketState.blackBracketR1WIN && $options.bracketState.bottomleftBracketR2WIN,
                                            enemyColor: $options.finalLeft
                                        },
                                        {
                                            name: 'purple',
                                            show: $options.bracketState.purpleBracketR1WIN && $options.bracketState.bottomrightBracketR2WIN,
                                            enemyColor: $options.finalLeft
                                        },
                                        {
                                            name: 'brown',
                                            show: $options.bracketState.brownBracketR1WIN && $options.bracketState.bottomrightBracketR2WIN,
                                            enemyColor: $options.finalLeft
                                        }
                                    ],
                                    "left-won": $options.bracketState.topleftBracketR3WIN,
                                    "right-won": $options.bracketState.toprightBracketR3WIN
                                }), null, 16, [
                                    "map",
                                    "is-current",
                                    "predict",
                                    "vs-title",
                                    "left-teams",
                                    "right-teams",
                                    "left-won",
                                    "right-won"
                                ])
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_31, [
                            _cache[38] || (_cache[38] = (0, $TusQn.createElementVNode)("h3", {
                                class: "tournament-bracket__round-title"
                            }, "Champ Match", -1)),
                            (0, $TusQn.createElementVNode)("ul", $a8be4ce26977e52e$var$_hoisted_32, [
                                (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_33, [
                                    (0, $TusQn.createVNode)(_component_ColiseumPromo, {
                                        class: "cc-promo"
                                    }),
                                    (0, $TusQn.createVNode)(_component_BracketMatch, (0, $TusQn.mergeProps)($options.bracketSharedProps, {
                                        "match-class": "champ",
                                        "champ-streak": $data.champStreak,
                                        map: $data.maps[7],
                                        "is-current": $options.currentMatchIndex === 7,
                                        "match-index": 7,
                                        predict: $data.predictMode ? $options.predictCells[7] : null,
                                        onPick: _cache[19] || (_cache[19] = ($event)=>$options.onPick(7, $event)),
                                        "vs-title": $options.champLeft + ' vs. Champions',
                                        "left-teams": $options.champLeftCandidates,
                                        "right-teams": [
                                            {
                                                name: 'champion',
                                                show: true,
                                                enemyColor: $options.champLeft
                                            }
                                        ],
                                        challengers: $options.champChallengers,
                                        "left-won": $options.bracketState.topleftBracketR4WIN,
                                        "right-won": $options.bracketState.toprightBracketR4WIN
                                    }), null, 16, [
                                        "champ-streak",
                                        "map",
                                        "is-current",
                                        "predict",
                                        "vs-title",
                                        "left-teams",
                                        "right-teams",
                                        "challengers",
                                        "left-won",
                                        "right-won"
                                    ]),
                                    $options.skillDropInfo ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                        key: 0,
                                        class: (0, $8POXm.normalizeClass)([
                                            "skill-drop-chip",
                                            'rarity-' + $options.skillDropInfo.rarity
                                        ]),
                                        title: "!buyrandom skill drop for this tournament \u2014 " + $options.skillDropInfo.rarity + ($options.skillDropInfo.category ? ' ' + $options.skillDropInfo.category : '')
                                    }, [
                                        _cache[37] || (_cache[37] = (0, $TusQn.createElementVNode)("span", {
                                            class: "sd-label"
                                        }, "\uD83C\uDF81 Skill Drop", -1)),
                                        (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_35, (0, $8POXm.toDisplayString)($options.skillDropInfo.name), 1),
                                        (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_36, (0, $8POXm.toDisplayString)($options.skillDropInfo.rarity), 1),
                                        $data.dropOwned !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                            key: 0,
                                            class: (0, $8POXm.normalizeClass)([
                                                "sd-own",
                                                $data.dropOwned ? 'owned' : 'missing'
                                            ])
                                        }, (0, $8POXm.toDisplayString)($data.dropOwned ? "\u2713 you own this" : "you're missing this!"), 3)) : (0, $TusQn.createCommentVNode)("", true),
                                        $options.dropLastText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                            key: 1,
                                            class: (0, $8POXm.normalizeClass)([
                                                "sd-last",
                                                {
                                                    rare: $options.dropLastText.rare
                                                }
                                            ]),
                                            title: $options.dropLastText.title || null
                                        }, (0, $8POXm.toDisplayString)($options.dropLastText.rare && !$options.dropLastText.text.startsWith('not') ? "\uD83E\uDEE8 " : '') + (0, $8POXm.toDisplayString)($options.dropLastText.text), 11, $a8be4ce26977e52e$var$_hoisted_37)) : (0, $TusQn.createCommentVNode)("", true)
                                    ], 10, $a8be4ce26977e52e$var$_hoisted_34)) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ])
                        ])
                    ], 2)
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_38, [
                    (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_39, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.teams, (team)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                key: team.name,
                                onClick: ($event)=>team.hidden = !team.hidden,
                                class: (0, $8POXm.normalizeClass)({
                                    hiding: team.hidden
                                })
                            }, (0, $8POXm.toDisplayString)(team.name === 'champion' ? 'Champ' : team.label), 11, $a8be4ce26977e52e$var$_hoisted_40);
                        }), 128))
                    ]),
                    (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_41, [
                        $options.highlightedEntrants.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_42, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.highlightedEntrants, (u)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                    key: 'in-' + u.name,
                                    style: (0, $8POXm.normalizeStyle)(u.color ? {
                                        color: u.color
                                    } : null)
                                }, [
                                    (0, $TusQn.createElementVNode)("a", {
                                        href: "#",
                                        class: "entrant-link",
                                        onClick: (0, $eeJ70.withModifiers)(($event)=>$options.gotoPlayer(u.name), [
                                            "prevent"
                                        ]),
                                        style: (0, $8POXm.normalizeStyle)(u.color ? {
                                            color: u.color
                                        } : null)
                                    }, (0, $8POXm.toDisplayString)(u.name), 13, $a8be4ce26977e52e$var$_hoisted_43),
                                    _cache[39] || (_cache[39] = (0, $TusQn.createTextVNode)(" is in! ", -1))
                                ], 4);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $options.highlightedSnubs.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_44, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.highlightedSnubs, (u)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                    key: 'snub-' + u.name,
                                    style: (0, $8POXm.normalizeStyle)(u.color ? {
                                        color: u.color
                                    } : null)
                                }, (0, $8POXm.toDisplayString)(u.name) + " was Snubbed.", 5);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    class: (0, $8POXm.normalizeClass)([
                        "teams",
                        $options.hideClasses
                    ])
                }, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.teams, (team)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: team.name,
                            ref_for: true,
                            ref: team.name,
                            class: (0, $8POXm.normalizeClass)([
                                'team',
                                team.name
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("h3", null, [
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(team.name === 'champion' ? 'Champ' : team.label) + " Team ", 1),
                                team.name === 'champion' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ChampStreakBadge, {
                                    key: 0,
                                    streak: $data.champStreak
                                }, null, 8, [
                                    "streak"
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                _cache[40] || (_cache[40] = (0, $TusQn.createTextVNode)()),
                                $options.teamGrades[team.name] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 1,
                                    class: (0, $8POXm.normalizeClass)([
                                        "grade-badge hasToolTip",
                                        'tier-' + $options.teamGrades[team.name].color
                                    ])
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($options.teamGrades[team.name].grade), 1),
                                    (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_45, [
                                        (0, $TusQn.createVNode)(_component_TeamRatingTip, {
                                            grade: $options.teamGrades[team.name],
                                            label: team.label
                                        }, null, 8, [
                                            "grade",
                                            "label"
                                        ])
                                    ])
                                ], 2)) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $a8be4ce26977e52e$var$_hoisted_46, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(team.roster, (unit)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_InlineUnit, {
                                        key: unit.Name + '|' + unit.Class,
                                        teamColor: team.label,
                                        classRank: $data.classRank,
                                        toolTips: $data.toolTips,
                                        notAbles: $data.notAbles,
                                        charStats: $data.charStats,
                                        unit: unit,
                                        itemschanged: $data.itemschanged,
                                        abilitiesInfo: $data.abilitiesInfo,
                                        highlightColors: $options.highlightColors,
                                        "default-expanded": $data.prefs.expandedCards,
                                        "show-win-rates": $data.prefs.showWinRates,
                                        "enemy-team": $options.opponentRoster(team.name),
                                        "own-team": team.roster,
                                        onFull: _cache[20] || (_cache[20] = ($event)=>$data.fullCard = $event)
                                    }, null, 8, [
                                        "teamColor",
                                        "classRank",
                                        "toolTips",
                                        "notAbles",
                                        "charStats",
                                        "unit",
                                        "itemschanged",
                                        "abilitiesInfo",
                                        "highlightColors",
                                        "default-expanded",
                                        "show-win-rates",
                                        "enemy-team",
                                        "own-team"
                                    ]);
                                }), 128))
                            ])
                        ], 2);
                    }), 128))
                ], 2)
            ])
        ])
    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a8be4ce26977e52e$var$_hoisted_47, [
        _cache[42] || (_cache[42] = (0, $TusQn.createElementVNode)("h1", null, "Luxor's Wiznaib.us", -1)),
        $options.appState === 'failed' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h2", $a8be4ce26977e52e$var$_hoisted_48, "Couldn't load required data.")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h2", $a8be4ce26977e52e$var$_hoisted_49, "Currently Awaiting Data\u2026")),
        (0, $TusQn.createElementVNode)("ul", $a8be4ce26977e52e$var$_hoisted_50, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.sourceList, (src)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                    key: src.key,
                    class: (0, $8POXm.normalizeClass)([
                        "source-row",
                        $data.sources[src.key]
                    ])
                }, [
                    _cache[41] || (_cache[41] = (0, $TusQn.createElementVNode)("span", {
                        class: "dot"
                    }, null, -1)),
                    (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_51, (0, $8POXm.toDisplayString)(src.label), 1),
                    (0, $TusQn.createElementVNode)("span", $a8be4ce26977e52e$var$_hoisted_52, (0, $8POXm.toDisplayString)($options.sourceStatus(src.key)), 1)
                ], 2);
            }), 128))
        ]),
        $options.appState === 'failed' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
            key: 2,
            onClick: _cache[21] || (_cache[21] = (...args)=>$options.reload && $options.reload(...args)),
            class: "reload-btn"
        }, "Reload")) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("dyc38", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd7cc26a16832fb$export$2e2bcd8739ae039);
let $9dd7cc26a16832fb$var$NOOP = ()=>{};
var $9dd7cc26a16832fb$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aGoGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c70fb031b937c59$export$2e2bcd8739ae039);
let $7c70fb031b937c59$var$script;




let $7c70fb031b937c59$var$initialize = ()=>{
    $7c70fb031b937c59$var$script = (parcelRequire("eemF1"));
    if ($7c70fb031b937c59$var$script.__esModule) $7c70fb031b937c59$var$script = $7c70fb031b937c59$var$script.default;
    $7c70fb031b937c59$var$script.render = (parcelRequire("ayOi9")).render;
    $7c70fb031b937c59$var$script.__cssModules = {};
    (parcelRequire("iKS8b")).default($7c70fb031b937c59$var$script);
    $7c70fb031b937c59$var$script.__scopeId = 'data-v-7513fc';
    $7c70fb031b937c59$var$script.__file = "DataStamp.vue";
};
$7c70fb031b937c59$var$initialize();
var $7c70fb031b937c59$export$2e2bcd8739ae039 = $7c70fb031b937c59$var$script;

});
parcelRegister("eemF1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a5c3f369e3852cfc$export$2e2bcd8739ae039);
// The "Stats updated …" line at the foot of every page. The stats come from the
// refresh box's newest build (see lib/dataStore.js), which lands a few minutes after
// each tournament finishes, so this says when that build was made and links the newest
// tournament it covers. That answers "is this up to date?", e.g. why a title won in
// the last tournament isn't in a history yet. It reads the page's own manifest, so it
// describes exactly the data the page is showing.
// Chat pages (`chat`) add a second line: chat is rebuilt once a day, not per
// tournament, so the stats time would overstate how fresh their data is.

var $gKfUi = parcelRequire("gKfUi");
var $a5c3f369e3852cfc$export$2e2bcd8739ae039 = {
    name: 'DataStamp',
    props: {
        chat: Boolean
    },
    data () {
        return {
            built: null,
            latestId: null,
            chatBuilt: null,
            chatLastDay: '',
            now: Date.now(),
            timer: null
        };
    },
    async created () {
        const info = await (0, $gKfUi.dataInfo)().catch(()=>null);
        const built = info && Date.parse(info.built);
        if (!built) return;
        this.built = built;
        this.latestId = info.latestId;
        this.timer = setInterval(()=>{
            this.now = Date.now();
        }, 60000); // keep "N min ago" honest in an open tab
        if (this.chat) {
            const meta = await (0, $gKfUi.loadData)('chatMeta.json').catch(()=>null);
            if (meta && Date.parse(meta.builtAt)) {
                this.chatBuilt = Date.parse(meta.builtAt);
                this.chatLastDay = meta.lastDay || '';
            }
        }
    },
    beforeUnmount () {
        clearInterval(this.timer);
    },
    methods: {
        // Local date + time ("9/23/2026 at 2:07 PM"); just the time when it's the same day as `sameDayAs`.
        fmt (ms, sameDayAs) {
            const d = new Date(ms), time = d.toLocaleTimeString([], {
                hour: 'numeric',
                minute: '2-digit'
            });
            return sameDayAs && d.toDateString() === new Date(sameDayAs).toDateString() ? time : d.toLocaleDateString() + ' at ' + time;
        },
        // A log day ("2026-09-23") in the local date format, read as a calendar date (no UTC shift).
        day (ymd) {
            const [y, m, d] = String(ymd).split('-').map(Number);
            return y && m && d ? new Date(y, m - 1, d).toLocaleDateString() : ymd;
        },
        ago (ms) {
            const min = Math.round((this.now - ms) / 60000);
            if (min < 1) return 'just now';
            if (min < 60) return min + ' min ago';
            const h = Math.round(min / 60);
            return h < 48 ? h + (h === 1 ? ' hour ago' : ' hours ago') : Math.round(h / 24) + ' days ago';
        }
    }
};

});

parcelRegister("ayOi9", function(module, exports) {

$parcel$export(module.exports, "render", () => $7b041743e05c291f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $7b041743e05c291f$var$_hoisted_1 = {
    key: 0,
    class: "data-stamp"
};
const $7b041743e05c291f$var$_hoisted_2 = {
    class: "ds-ago"
};
const $7b041743e05c291f$var$_hoisted_3 = [
    "href"
];
const $7b041743e05c291f$var$_hoisted_4 = {
    title: "Chat is rebuilt once a day, from the chat logs up to the day before"
};
const $7b041743e05c291f$var$_hoisted_5 = {
    class: "ds-ago"
};
function $7b041743e05c291f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $data.built ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", $7b041743e05c291f$var$_hoisted_1, [
        (0, $TusQn.createTextVNode)(" Stats updated " + (0, $8POXm.toDisplayString)($options.fmt($data.built)), 1),
        (0, $TusQn.createElementVNode)("span", $7b041743e05c291f$var$_hoisted_2, " (" + (0, $8POXm.toDisplayString)($options.ago($data.built)) + ")", 1),
        $data.latestId ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 0
        }, [
            _cache[0] || (_cache[0] = (0, $TusQn.createTextVNode)(" \xb7 ", -1)),
            (0, $TusQn.createElementVNode)("a", {
                href: '?tournament=' + $data.latestId,
                title: "The newest finished tournament these stats include (it opens that bracket)"
            }, "latest tournament included: " + (0, $8POXm.toDisplayString)($options.fmt($data.latestId, $data.built)), 9, $7b041743e05c291f$var$_hoisted_3)
        ], 64)) : (0, $TusQn.createCommentVNode)("", true),
        $data.chatBuilt ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
            key: 1
        }, [
            _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
            (0, $TusQn.createElementVNode)("span", $7b041743e05c291f$var$_hoisted_4, [
                (0, $TusQn.createTextVNode)("Chat updated " + (0, $8POXm.toDisplayString)($options.fmt($data.chatBuilt)), 1),
                (0, $TusQn.createElementVNode)("span", $7b041743e05c291f$var$_hoisted_5, " (" + (0, $8POXm.toDisplayString)($options.ago($data.chatBuilt)) + ")", 1),
                (0, $TusQn.createTextVNode)(" \xb7 logs through " + (0, $8POXm.toDisplayString)($options.day($data.chatLastDay)), 1)
            ])
        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
    ])) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRegister("iKS8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $da768328738eb120$export$2e2bcd8739ae039);
let $da768328738eb120$var$NOOP = ()=>{};
var $da768328738eb120$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $2c4cb1eb429dee56$var$_hoisted_1 = {
    id: "app"
};
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    key: 0,
    class: "snav-act"
};
const $2c4cb1eb429dee56$var$_hoisted_3 = [
    "href"
];
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SiteNav = (0, $TusQn.resolveComponent)("SiteNav");
    const _component_DataStamp = (0, $TusQn.resolveComponent)("DataStamp");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_1, [
        $options.showNav ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SiteNav, {
            key: 0,
            active: $options.activeKey
        }, {
            actions: (0, $TusQn.withCtx)(()=>[
                    $data.myUsername ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("a", {
                            class: "profile-button",
                            href: '?player=' + encodeURIComponent($data.myUsername),
                            "aria-label": "My profile"
                        }, "\uD83D\uDC64", 8, $2c4cb1eb429dee56$var$_hoisted_3),
                        _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Your full player profile \u2014 stats, achievements, championship history.", -1))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("span", {
                        class: "snav-act"
                    }, [
                        (0, $TusQn.createElementVNode)("a", {
                            class: "generator-button",
                            href: "?build&random",
                            "aria-label": "Random unit generator"
                        }, "\uD83C\uDFB2"),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "act-tip"
                        }, "Roll a random FFTBG unit in the Builder \u2014 force or ban classes and skills, then tweak anything.")
                    ], -1))
                ]),
            _: 1
        }, 8, [
            "active"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)($options.view))),
        (0, $TusQn.createVNode)(_component_DataStamp, {
            chat: $options.isChat
        }, null, 8, [
            "chat"
        ])
    ]);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-6781bb';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;



var $bXoWA = parcelRequire("bXoWA");

var $koMQO = parcelRequire("koMQO");
// Some generated data is read synchronously all over the site (the unit grade on
// every card needs rosterStats), so it has to be loaded before anything renders.
// Load what this page needs from S3 first (lib/preload.js), and start fetching the
// page's own code at the same moment so the two downloads overlap.
const $2b6e161c9edcf319$var$section = (0, $bXoWA.resolveSection)();
if ($2b6e161c9edcf319$var$section.loader) $2b6e161c9edcf319$var$section.loader().catch(()=>{}); // App's async component reports its own errors
(0, $koMQO.preload)([
    ...(0, $koMQO.CORE),
    ...$2b6e161c9edcf319$var$section.data || []
]).then(()=>(0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039)).mount("#app")).catch((e)=>{
    console.error("Couldn't load the site's data", e);
    const el = document.getElementById("app");
    el.innerHTML = '<div style="max-width:28rem;margin:18vh auto;padding:1.4rem 1.6rem;background:#0a1c2e;color:#e8eef5;border:1px solid #2c4a66;border-radius:8px;font:15px/1.5 system-ui,sans-serif;text-align:center"><b>Couldn\'t load the site\'s data.</b><br>Usually a flaky connection. Try again in a moment.<br><button style="margin-top:.9rem;padding:.45rem 1.2rem;font:inherit;cursor:pointer">Retry</button></div>';
    el.querySelector("button").onclick = ()=>location.reload();
});


//# sourceMappingURL=repo.291d344e.js.map
